var _toConsumableArray = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _asyncToGenerator = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _slicedToArray = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _wrapNativeSuper = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _get2 = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _classCallCheck2 = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass2 = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _assertThisInitialized = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _inherits = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e14) { throw _e14; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e15) { didErr = true; err = _e15; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }
function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["AFRAME"] = factory();else root["AFRAME"] = factory();
})(self, function () {
  return (/******/function () {
      // webpackBootstrap
      /******/
      var __webpack_modules__ = {
        /***/"./node_modules/@ungap/custom-elements/index.js":
        /*!******************************************************!*\
          !*** ./node_modules/@ungap/custom-elements/index.js ***!
          \******************************************************/
        /***/
        function node_modulesUngapCustomElementsIndexJs() {
          /*! (c) Andrea Giammarchi @webreflection ISC */
          (function () {
            'use strict';

            var attributesObserver = function attributesObserver(whenDefined, MutationObserver) {
              var attributeChanged = function attributeChanged(records) {
                for (var i = 0, length = records.length; i < length; i++) {
                  dispatch(records[i]);
                }
              };
              var dispatch = function dispatch(_ref) {
                var target = _ref.target,
                  attributeName = _ref.attributeName,
                  oldValue = _ref.oldValue;
                target.attributeChangedCallback(attributeName, oldValue, target.getAttribute(attributeName));
              };
              return function (target, is) {
                var attributeFilter = target.constructor.observedAttributes;
                if (attributeFilter) {
                  whenDefined(is).then(function () {
                    new MutationObserver(attributeChanged).observe(target, {
                      attributes: true,
                      attributeOldValue: true,
                      attributeFilter: attributeFilter
                    });
                    for (var i = 0, length = attributeFilter.length; i < length; i++) {
                      if (target.hasAttribute(attributeFilter[i])) dispatch({
                        target: target,
                        attributeName: attributeFilter[i],
                        oldValue: null
                      });
                    }
                  });
                }
                return target;
              };
            };
            function _unsupportedIterableToArray(o, minLen) {
              if (!o) return;
              if (typeof o === "string") return _arrayLikeToArray(o, minLen);
              var n = Object.prototype.toString.call(o).slice(8, -1);
              if (n === "Object" && o.constructor) n = o.constructor.name;
              if (n === "Map" || n === "Set") return Array.from(o);
              if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
              if (len == null || len > arr.length) len = arr.length;
              for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
              return arr2;
            }
            function _createForOfIteratorHelper(o, allowArrayLike) {
              var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
              if (!it) {
                if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                  if (it) o = it;
                  var i = 0;
                  var F = function F() {};
                  return {
                    s: F,
                    n: function n() {
                      if (i >= o.length) return {
                        done: true
                      };
                      return {
                        done: false,
                        value: o[i++]
                      };
                    },
                    e: function e(_e2) {
                      throw _e2;
                    },
                    f: F
                  };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }
              var normalCompletion = true,
                didErr = false,
                err;
              return {
                s: function s() {
                  it = it.call(o);
                },
                n: function n() {
                  var step = it.next();
                  normalCompletion = step.done;
                  return step;
                },
                e: function e(_e3) {
                  didErr = true;
                  err = _e3;
                },
                f: function f() {
                  try {
                    if (!normalCompletion && it.return != null) it.return();
                  } finally {
                    if (didErr) throw err;
                  }
                }
              };
            }

            /*! (c) Andrea Giammarchi - ISC */
            var TRUE = true,
              FALSE = false,
              QSA$1 = 'querySelectorAll';

            /**
             * Start observing a generic document or root element.
             * @param {(node:Element, connected:boolean) => void} callback triggered per each dis/connected element
             * @param {Document|Element} [root=document] by default, the global document to observe
             * @param {Function} [MO=MutationObserver] by default, the global MutationObserver
             * @param {string[]} [query=['*']] the selectors to use within nodes
             * @returns {MutationObserver}
             */
            var notify = function notify(callback) {
              var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
              var MO = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MutationObserver;
              var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['*'];
              var loop = function loop(nodes, selectors, added, removed, connected, pass) {
                var _iterator = _createForOfIteratorHelper(nodes),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var node = _step.value;
                    if (pass || QSA$1 in node) {
                      if (connected) {
                        if (!added.has(node)) {
                          added.add(node);
                          removed["delete"](node);
                          callback(node, connected);
                        }
                      } else if (!removed.has(node)) {
                        removed.add(node);
                        added["delete"](node);
                        callback(node, connected);
                      }
                      if (!pass) loop(node[QSA$1](selectors), selectors, added, removed, connected, TRUE);
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              };
              var mo = new MO(function (records) {
                if (query.length) {
                  var selectors = query.join(',');
                  var added = new Set(),
                    removed = new Set();
                  var _iterator2 = _createForOfIteratorHelper(records),
                    _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var _step2$value = _step2.value,
                        addedNodes = _step2$value.addedNodes,
                        removedNodes = _step2$value.removedNodes;
                      loop(removedNodes, selectors, added, removed, FALSE, FALSE);
                      loop(addedNodes, selectors, added, removed, TRUE, FALSE);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              });
              var observe = mo.observe;
              (mo.observe = function (node) {
                return observe.call(mo, node, {
                  subtree: TRUE,
                  childList: TRUE
                });
              })(root);
              return mo;
            };
            var QSA = 'querySelectorAll';
            var _self$1 = self,
              document$2 = _self$1.document,
              Element$1 = _self$1.Element,
              MutationObserver$2 = _self$1.MutationObserver,
              Set$2 = _self$1.Set,
              WeakMap$1 = _self$1.WeakMap;
            var elements = function elements(element) {
              return QSA in element;
            };
            var filter = [].filter;
            var qsaObserver = function qsaObserver(options) {
              var live = new WeakMap$1();
              var drop = function drop(elements) {
                for (var i = 0, length = elements.length; i < length; i++) {
                  live["delete"](elements[i]);
                }
              };
              var flush = function flush() {
                var records = observer.takeRecords();
                for (var i = 0, length = records.length; i < length; i++) {
                  parse(filter.call(records[i].removedNodes, elements), false);
                  parse(filter.call(records[i].addedNodes, elements), true);
                }
              };
              var matches = function matches(element) {
                return element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
              };
              var notifier = function notifier(element, connected) {
                var selectors;
                if (connected) {
                  for (var q, m = matches(element), i = 0, length = query.length; i < length; i++) {
                    if (m.call(element, q = query[i])) {
                      if (!live.has(element)) live.set(element, new Set$2());
                      selectors = live.get(element);
                      if (!selectors.has(q)) {
                        selectors.add(q);
                        options.handle(element, connected, q);
                      }
                    }
                  }
                } else if (live.has(element)) {
                  selectors = live.get(element);
                  live["delete"](element);
                  selectors.forEach(function (q) {
                    options.handle(element, connected, q);
                  });
                }
              };
              var parse = function parse(elements) {
                var connected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                for (var i = 0, length = elements.length; i < length; i++) {
                  notifier(elements[i], connected);
                }
              };
              var query = options.query;
              var root = options.root || document$2;
              var observer = notify(notifier, root, MutationObserver$2, query);
              var attachShadow = Element$1.prototype.attachShadow;
              if (attachShadow) Element$1.prototype.attachShadow = function (init) {
                var shadowRoot = attachShadow.call(this, init);
                observer.observe(shadowRoot);
                return shadowRoot;
              };
              if (query.length) parse(root[QSA](query));
              return {
                drop: drop,
                flush: flush,
                observer: observer,
                parse: parse
              };
            };
            var _self = self,
              document$1 = _self.document,
              Map = _self.Map,
              MutationObserver$1 = _self.MutationObserver,
              Object$1 = _self.Object,
              Set$1 = _self.Set,
              WeakMap = _self.WeakMap,
              Element = _self.Element,
              HTMLElement = _self.HTMLElement,
              Node = _self.Node,
              Error = _self.Error,
              TypeError$1 = _self.TypeError,
              Reflect = _self.Reflect;
            var defineProperty = Object$1.defineProperty,
              keys = Object$1.keys,
              getOwnPropertyNames = Object$1.getOwnPropertyNames,
              setPrototypeOf = Object$1.setPrototypeOf;
            var legacy = !self.customElements;
            var expando = function expando(element) {
              var key = keys(element);
              var value = [];
              var length = key.length;
              for (var i = 0; i < length; i++) {
                value[i] = element[key[i]];
                delete element[key[i]];
              }
              return function () {
                for (var _i = 0; _i < length; _i++) {
                  element[key[_i]] = value[_i];
                }
              };
            };
            if (legacy) {
              var HTMLBuiltIn = function HTMLBuiltIn() {
                var constructor = this.constructor;
                if (!classes.has(constructor)) throw new TypeError$1('Illegal constructor');
                var is = classes.get(constructor);
                if (override) return augment(override, is);
                var element = createElement.call(document$1, is);
                return augment(setPrototypeOf(element, constructor.prototype), is);
              };
              var createElement = document$1.createElement;
              var classes = new Map();
              var defined = new Map();
              var prototypes = new Map();
              var registry = new Map();
              var query = [];
              var handle = function handle(element, connected, selector) {
                var proto = prototypes.get(selector);
                if (connected && !proto.isPrototypeOf(element)) {
                  var redefine = expando(element);
                  override = setPrototypeOf(element, proto);
                  try {
                    new proto.constructor();
                  } finally {
                    override = null;
                    redefine();
                  }
                }
                var method = "".concat(connected ? '' : 'dis', "connectedCallback");
                if (method in proto) element[method]();
              };
              var _qsaObserver = qsaObserver({
                  query: query,
                  handle: handle
                }),
                parse = _qsaObserver.parse;
              var override = null;
              var whenDefined = function whenDefined(name) {
                if (!defined.has(name)) {
                  var _,
                    $ = new Promise(function ($) {
                      _ = $;
                    });
                  defined.set(name, {
                    $: $,
                    _: _
                  });
                }
                return defined.get(name).$;
              };
              var augment = attributesObserver(whenDefined, MutationObserver$1);
              defineProperty(self, 'customElements', {
                configurable: true,
                value: {
                  define: function define(is, Class) {
                    if (registry.has(is)) throw new Error("the name \"".concat(is, "\" has already been used with this registry"));
                    classes.set(Class, is);
                    prototypes.set(is, Class.prototype);
                    registry.set(is, Class);
                    query.push(is);
                    whenDefined(is).then(function () {
                      parse(document$1.querySelectorAll(is));
                    });
                    defined.get(is)._(Class);
                  },
                  get: function get(is) {
                    return registry.get(is);
                  },
                  whenDefined: whenDefined
                }
              });
              defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, 'constructor', {
                value: HTMLBuiltIn
              });
              defineProperty(self, 'HTMLElement', {
                configurable: true,
                value: HTMLBuiltIn
              });
              defineProperty(document$1, 'createElement', {
                configurable: true,
                value: function value(name, options) {
                  var is = options && options.is;
                  var Class = is ? registry.get(is) : registry.get(name);
                  return Class ? new Class() : createElement.call(document$1, name);
                }
              });
              // in case ShadowDOM is used through a polyfill, to avoid issues
              // with builtin extends within shadow roots
              if (!('isConnected' in Node.prototype)) defineProperty(Node.prototype, 'isConnected', {
                configurable: true,
                get: function get() {
                  return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
                }
              });
            } else {
              legacy = !self.customElements.get('extends-li');
              if (legacy) {
                try {
                  var LI = function LI() {
                    return self.Reflect.construct(HTMLLIElement, [], LI);
                  };
                  LI.prototype = HTMLLIElement.prototype;
                  var is = 'extends-li';
                  self.customElements.define('extends-li', LI, {
                    'extends': 'li'
                  });
                  legacy = document$1.createElement('li', {
                    is: is
                  }).outerHTML.indexOf(is) < 0;
                  var _self$customElements = self.customElements,
                    get = _self$customElements.get,
                    _whenDefined = _self$customElements.whenDefined;
                  defineProperty(self.customElements, 'whenDefined', {
                    configurable: true,
                    value: function value(is) {
                      var _this = this;
                      return _whenDefined.call(this, is).then(function (Class) {
                        return Class || get.call(_this, is);
                      });
                    }
                  });
                } catch (o_O) {}
              }
            }
            if (legacy) {
              var parseShadow = function parseShadow(element) {
                var root = shadowRoots.get(element);
                _parse(root.querySelectorAll(this), element.isConnected);
              };
              var customElements = self.customElements;
              var _createElement = document$1.createElement;
              var define = customElements.define,
                _get = customElements.get,
                upgrade = customElements.upgrade;
              var _ref = Reflect || {
                  construct: function construct(HTMLElement) {
                    return HTMLElement.call(this);
                  }
                },
                construct = _ref.construct;
              var shadowRoots = new WeakMap();
              var shadows = new Set$1();
              var _classes = new Map();
              var _defined = new Map();
              var _prototypes = new Map();
              var _registry = new Map();
              var shadowed = [];
              var _query = [];
              var getCE = function getCE(is) {
                return _registry.get(is) || _get.call(customElements, is);
              };
              var _handle = function _handle(element, connected, selector) {
                var proto = _prototypes.get(selector);
                if (connected && !proto.isPrototypeOf(element)) {
                  var redefine = expando(element);
                  _override = setPrototypeOf(element, proto);
                  try {
                    new proto.constructor();
                  } finally {
                    _override = null;
                    redefine();
                  }
                }
                var method = "".concat(connected ? '' : 'dis', "connectedCallback");
                if (method in proto) element[method]();
              };
              var _qsaObserver2 = qsaObserver({
                  query: _query,
                  handle: _handle
                }),
                _parse = _qsaObserver2.parse;
              var _qsaObserver3 = qsaObserver({
                  query: shadowed,
                  handle: function handle(element, connected) {
                    if (shadowRoots.has(element)) {
                      if (connected) shadows.add(element);else shadows["delete"](element);
                      if (_query.length) parseShadow.call(_query, element);
                    }
                  }
                }),
                parseShadowed = _qsaObserver3.parse;
              // qsaObserver also patches attachShadow
              // be sure this runs *after* that
              var attachShadow = Element.prototype.attachShadow;
              if (attachShadow) Element.prototype.attachShadow = function (init) {
                var root = attachShadow.call(this, init);
                shadowRoots.set(this, root);
                return root;
              };
              var _whenDefined2 = function _whenDefined2(name) {
                if (!_defined.has(name)) {
                  var _,
                    $ = new Promise(function ($) {
                      _ = $;
                    });
                  _defined.set(name, {
                    $: $,
                    _: _
                  });
                }
                return _defined.get(name).$;
              };
              var _augment = attributesObserver(_whenDefined2, MutationObserver$1);
              var _override = null;
              getOwnPropertyNames(self).filter(function (k) {
                return /^HTML.*Element$/.test(k);
              }).forEach(function (k) {
                var HTMLElement = self[k];
                function HTMLBuiltIn() {
                  var constructor = this.constructor;
                  if (!_classes.has(constructor)) throw new TypeError$1('Illegal constructor');
                  var _classes$get = _classes.get(constructor),
                    is = _classes$get.is,
                    tag = _classes$get.tag;
                  if (is) {
                    if (_override) return _augment(_override, is);
                    var element = _createElement.call(document$1, tag);
                    element.setAttribute('is', is);
                    return _augment(setPrototypeOf(element, constructor.prototype), is);
                  } else return construct.call(this, HTMLElement, [], constructor);
                }
                defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, 'constructor', {
                  value: HTMLBuiltIn
                });
                defineProperty(self, k, {
                  value: HTMLBuiltIn
                });
              });
              defineProperty(document$1, 'createElement', {
                configurable: true,
                value: function value(name, options) {
                  var is = options && options.is;
                  if (is) {
                    var Class = _registry.get(is);
                    if (Class && _classes.get(Class).tag === name) return new Class();
                  }
                  var element = _createElement.call(document$1, name);
                  if (is) element.setAttribute('is', is);
                  return element;
                }
              });
              defineProperty(customElements, 'get', {
                configurable: true,
                value: getCE
              });
              defineProperty(customElements, 'whenDefined', {
                configurable: true,
                value: _whenDefined2
              });
              defineProperty(customElements, 'upgrade', {
                configurable: true,
                value: function value(element) {
                  var is = element.getAttribute('is');
                  if (is) {
                    var _constructor = _registry.get(is);
                    if (_constructor) {
                      _augment(setPrototypeOf(element, _constructor.prototype), is);
                      // apparently unnecessary because this is handled by qsa observer
                      // if (element.isConnected && element.connectedCallback)
                      //   element.connectedCallback();
                      return;
                    }
                  }
                  upgrade.call(customElements, element);
                }
              });
              defineProperty(customElements, 'define', {
                configurable: true,
                value: function value(is, Class, options) {
                  if (getCE(is)) throw new Error("'".concat(is, "' has already been defined as a custom element"));
                  var selector;
                  var tag = options && options["extends"];
                  _classes.set(Class, tag ? {
                    is: is,
                    tag: tag
                  } : {
                    is: '',
                    tag: is
                  });
                  if (tag) {
                    selector = "".concat(tag, "[is=\"").concat(is, "\"]");
                    _prototypes.set(selector, Class.prototype);
                    _registry.set(is, Class);
                    _query.push(selector);
                  } else {
                    define.apply(customElements, arguments);
                    shadowed.push(selector = is);
                  }
                  _whenDefined2(is).then(function () {
                    if (tag) {
                      _parse(document$1.querySelectorAll(selector));
                      shadows.forEach(parseShadow, [selector]);
                    } else parseShadowed(document$1.querySelectorAll(selector));
                  });
                  _defined.get(is)._(Class);
                }
              });
            }
          })();

          /***/
        },

        /***/"./node_modules/an-array/index.js":
        /*!****************************************!*\
          !*** ./node_modules/an-array/index.js ***!
          \****************************************/
        /***/
        function node_modulesAnArrayIndexJs(module) {
          var str = Object.prototype.toString;
          module.exports = anArray;
          function anArray(arr) {
            return arr.BYTES_PER_ELEMENT && str.call(arr.buffer) === '[object ArrayBuffer]' || Array.isArray(arr);
          }

          /***/
        },

        /***/"./node_modules/as-number/index.js":
        /*!*****************************************!*\
          !*** ./node_modules/as-number/index.js ***!
          \*****************************************/
        /***/
        function node_modulesAsNumberIndexJs(module) {
          module.exports = function numtype(num, def) {
            return typeof num === 'number' ? num : typeof def === 'number' ? def : 0;
          };

          /***/
        },

        /***/"./node_modules/base64-js/index.js":
        /*!*****************************************!*\
          !*** ./node_modules/base64-js/index.js ***!
          \*****************************************/
        /***/
        function node_modulesBase64JsIndexJs(__unused_webpack_module, exports) {
          "use strict";

          exports.byteLength = byteLength;
          exports.toByteArray = toByteArray;
          exports.fromByteArray = fromByteArray;
          var lookup = [];
          var revLookup = [];
          var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
          var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
          for (var i = 0, len = code.length; i < len; ++i) {
            lookup[i] = code[i];
            revLookup[code.charCodeAt(i)] = i;
          }

          // Support decoding URL-safe base64 strings, as Node.js does.
          // See: https://en.wikipedia.org/wiki/Base64#URL_applications
          revLookup['-'.charCodeAt(0)] = 62;
          revLookup['_'.charCodeAt(0)] = 63;
          function getLens(b64) {
            var len = b64.length;
            if (len % 4 > 0) {
              throw new Error('Invalid string. Length must be a multiple of 4');
            }

            // Trim off extra bytes after placeholder bytes are found
            // See: https://github.com/beatgammit/base64-js/issues/42
            var validLen = b64.indexOf('=');
            if (validLen === -1) validLen = len;
            var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
            return [validLen, placeHoldersLen];
          }

          // base64 is 4/3 + up to two characters of the original data
          function byteLength(b64) {
            var lens = getLens(b64);
            var validLen = lens[0];
            var placeHoldersLen = lens[1];
            return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
          }
          function _byteLength(b64, validLen, placeHoldersLen) {
            return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
          }
          function toByteArray(b64) {
            var tmp;
            var lens = getLens(b64);
            var validLen = lens[0];
            var placeHoldersLen = lens[1];
            var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
            var curByte = 0;

            // if there are placeholders, only get up to the last complete 4 chars
            var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
            var i;
            for (i = 0; i < len; i += 4) {
              tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
              arr[curByte++] = tmp >> 16 & 0xFF;
              arr[curByte++] = tmp >> 8 & 0xFF;
              arr[curByte++] = tmp & 0xFF;
            }
            if (placeHoldersLen === 2) {
              tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
              arr[curByte++] = tmp & 0xFF;
            }
            if (placeHoldersLen === 1) {
              tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
              arr[curByte++] = tmp >> 8 & 0xFF;
              arr[curByte++] = tmp & 0xFF;
            }
            return arr;
          }
          function tripletToBase64(num) {
            return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
          }
          function encodeChunk(uint8, start, end) {
            var tmp;
            var output = [];
            for (var i = start; i < end; i += 3) {
              tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
              output.push(tripletToBase64(tmp));
            }
            return output.join('');
          }
          function fromByteArray(uint8) {
            var tmp;
            var len = uint8.length;
            var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
            var parts = [];
            var maxChunkLength = 16383; // must be multiple of 3

            // go through the array every three bytes, we'll deal with trailing stuff later
            for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
              parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
            }

            // pad the end with zeros, but make sure to not forget the extra bytes
            if (extraBytes === 1) {
              tmp = uint8[len - 1];
              parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
            } else if (extraBytes === 2) {
              tmp = (uint8[len - 2] << 8) + uint8[len - 1];
              parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
            }
            return parts.join('');
          }

          /***/
        },

        /***/"./node_modules/buffer-equal/index.js":
        /*!********************************************!*\
          !*** ./node_modules/buffer-equal/index.js ***!
          \********************************************/
        /***/
        function node_modulesBufferEqualIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          var Buffer = __webpack_require__( /*! buffer */"./node_modules/buffer/index.js").Buffer; // for use with browserify

          module.exports = function (a, b) {
            if (!Buffer.isBuffer(a)) return undefined;
            if (!Buffer.isBuffer(b)) return undefined;
            if (typeof a.equals === 'function') return a.equals(b);
            if (a.length !== b.length) return false;
            for (var i = 0; i < a.length; i++) {
              if (a[i] !== b[i]) return false;
            }
            return true;
          };

          /***/
        },

        /***/"./node_modules/buffer/index.js":
        /*!**************************************!*\
          !*** ./node_modules/buffer/index.js ***!
          \**************************************/
        /***/
        function node_modulesBufferIndexJs(__unused_webpack_module, exports, __webpack_require__) {
          "use strict";

          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <https://feross.org>
           * @license  MIT
           */
          /* eslint-disable no-proto */
          var base64 = __webpack_require__( /*! base64-js */"./node_modules/base64-js/index.js");
          var ieee754 = __webpack_require__( /*! ieee754 */"./node_modules/ieee754/index.js");
          var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
          ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
          : null;
          exports.Buffer = Buffer;
          exports.SlowBuffer = SlowBuffer;
          exports.INSPECT_MAX_BYTES = 50;
          var K_MAX_LENGTH = 0x7fffffff;
          exports.kMaxLength = K_MAX_LENGTH;

          /**
           * If `Buffer.TYPED_ARRAY_SUPPORT`:
           *   === true    Use Uint8Array implementation (fastest)
           *   === false   Print warning and recommend using `buffer` v4.x which has an Object
           *               implementation (most compatible, even IE6)
           *
           * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
           * Opera 11.6+, iOS 4.2+.
           *
           * We report that the browser does not support typed arrays if the are not subclassable
           * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
           * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
           * for __proto__ and has a buggy typed array implementation.
           */
          Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
          if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
            console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
          }
          function typedArraySupport() {
            // Can typed array instances can be augmented?
            try {
              var arr = new Uint8Array(1);
              var proto = {
                foo: function foo() {
                  return 42;
                }
              };
              Object.setPrototypeOf(proto, Uint8Array.prototype);
              Object.setPrototypeOf(arr, proto);
              return arr.foo() === 42;
            } catch (e) {
              return false;
            }
          }
          Object.defineProperty(Buffer.prototype, 'parent', {
            enumerable: true,
            get: function get() {
              if (!Buffer.isBuffer(this)) return undefined;
              return this.buffer;
            }
          });
          Object.defineProperty(Buffer.prototype, 'offset', {
            enumerable: true,
            get: function get() {
              if (!Buffer.isBuffer(this)) return undefined;
              return this.byteOffset;
            }
          });
          function createBuffer(length) {
            if (length > K_MAX_LENGTH) {
              throw new RangeError('The value "' + length + '" is invalid for option "size"');
            }
            // Return an augmented `Uint8Array` instance
            var buf = new Uint8Array(length);
            Object.setPrototypeOf(buf, Buffer.prototype);
            return buf;
          }

          /**
           * The Buffer constructor returns instances of `Uint8Array` that have their
           * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
           * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
           * and the `Uint8Array` methods. Square bracket notation works as expected -- it
           * returns a single octet.
           *
           * The `Uint8Array` prototype remains unmodified.
           */

          function Buffer(arg, encodingOrOffset, length) {
            // Common case.
            if (typeof arg === 'number') {
              if (typeof encodingOrOffset === 'string') {
                throw new TypeError('The "string" argument must be of type string. Received type number');
              }
              return allocUnsafe(arg);
            }
            return from(arg, encodingOrOffset, length);
          }
          Buffer.poolSize = 8192; // not used by this implementation

          function from(value, encodingOrOffset, length) {
            if (typeof value === 'string') {
              return fromString(value, encodingOrOffset);
            }
            if (ArrayBuffer.isView(value)) {
              return fromArrayView(value);
            }
            if (value == null) {
              throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
            }
            if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
              return fromArrayBuffer(value, encodingOrOffset, length);
            }
            if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
              return fromArrayBuffer(value, encodingOrOffset, length);
            }
            if (typeof value === 'number') {
              throw new TypeError('The "value" argument must not be of type number. Received type number');
            }
            var valueOf = value.valueOf && value.valueOf();
            if (valueOf != null && valueOf !== value) {
              return Buffer.from(valueOf, encodingOrOffset, length);
            }
            var b = fromObject(value);
            if (b) return b;
            if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
              return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
            }
            throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
          }

          /**
           * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
           * if value is a number.
           * Buffer.from(str[, encoding])
           * Buffer.from(array)
           * Buffer.from(buffer)
           * Buffer.from(arrayBuffer[, byteOffset[, length]])
           **/
          Buffer.from = function (value, encodingOrOffset, length) {
            return from(value, encodingOrOffset, length);
          };

          // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
          // https://github.com/feross/buffer/pull/148
          Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
          Object.setPrototypeOf(Buffer, Uint8Array);
          function assertSize(size) {
            if (typeof size !== 'number') {
              throw new TypeError('"size" argument must be of type number');
            } else if (size < 0) {
              throw new RangeError('The value "' + size + '" is invalid for option "size"');
            }
          }
          function alloc(size, fill, encoding) {
            assertSize(size);
            if (size <= 0) {
              return createBuffer(size);
            }
            if (fill !== undefined) {
              // Only pay attention to encoding if it's a string. This
              // prevents accidentally sending in a number that would
              // be interpreted as a start offset.
              return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
            }
            return createBuffer(size);
          }

          /**
           * Creates a new filled Buffer instance.
           * alloc(size[, fill[, encoding]])
           **/
          Buffer.alloc = function (size, fill, encoding) {
            return alloc(size, fill, encoding);
          };
          function allocUnsafe(size) {
            assertSize(size);
            return createBuffer(size < 0 ? 0 : checked(size) | 0);
          }

          /**
           * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
           * */
          Buffer.allocUnsafe = function (size) {
            return allocUnsafe(size);
          };
          /**
           * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
           */
          Buffer.allocUnsafeSlow = function (size) {
            return allocUnsafe(size);
          };
          function fromString(string, encoding) {
            if (typeof encoding !== 'string' || encoding === '') {
              encoding = 'utf8';
            }
            if (!Buffer.isEncoding(encoding)) {
              throw new TypeError('Unknown encoding: ' + encoding);
            }
            var length = byteLength(string, encoding) | 0;
            var buf = createBuffer(length);
            var actual = buf.write(string, encoding);
            if (actual !== length) {
              // Writing a hex string, for example, that contains invalid characters will
              // cause everything after the first invalid character to be ignored. (e.g.
              // 'abxxcd' will be treated as 'ab')
              buf = buf.slice(0, actual);
            }
            return buf;
          }
          function fromArrayLike(array) {
            var length = array.length < 0 ? 0 : checked(array.length) | 0;
            var buf = createBuffer(length);
            for (var i = 0; i < length; i += 1) {
              buf[i] = array[i] & 255;
            }
            return buf;
          }
          function fromArrayView(arrayView) {
            if (isInstance(arrayView, Uint8Array)) {
              var copy = new Uint8Array(arrayView);
              return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
            }
            return fromArrayLike(arrayView);
          }
          function fromArrayBuffer(array, byteOffset, length) {
            if (byteOffset < 0 || array.byteLength < byteOffset) {
              throw new RangeError('"offset" is outside of buffer bounds');
            }
            if (array.byteLength < byteOffset + (length || 0)) {
              throw new RangeError('"length" is outside of buffer bounds');
            }
            var buf;
            if (byteOffset === undefined && length === undefined) {
              buf = new Uint8Array(array);
            } else if (length === undefined) {
              buf = new Uint8Array(array, byteOffset);
            } else {
              buf = new Uint8Array(array, byteOffset, length);
            }

            // Return an augmented `Uint8Array` instance
            Object.setPrototypeOf(buf, Buffer.prototype);
            return buf;
          }
          function fromObject(obj) {
            if (Buffer.isBuffer(obj)) {
              var len = checked(obj.length) | 0;
              var buf = createBuffer(len);
              if (buf.length === 0) {
                return buf;
              }
              obj.copy(buf, 0, 0, len);
              return buf;
            }
            if (obj.length !== undefined) {
              if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
                return createBuffer(0);
              }
              return fromArrayLike(obj);
            }
            if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
              return fromArrayLike(obj.data);
            }
          }
          function checked(length) {
            // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
            // length is NaN (which is otherwise coerced to zero.)
            if (length >= K_MAX_LENGTH) {
              throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
            }
            return length | 0;
          }
          function SlowBuffer(length) {
            if (+length != length) {
              // eslint-disable-line eqeqeq
              length = 0;
            }
            return Buffer.alloc(+length);
          }
          Buffer.isBuffer = function isBuffer(b) {
            return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
          };

          Buffer.compare = function compare(a, b) {
            if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
            if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
              throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            }
            if (a === b) return 0;
            var x = a.length;
            var y = b.length;
            for (var i = 0, len = Math.min(x, y); i < len; ++i) {
              if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
              }
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
          };
          Buffer.isEncoding = function isEncoding(encoding) {
            switch (String(encoding).toLowerCase()) {
              case 'hex':
              case 'utf8':
              case 'utf-8':
              case 'ascii':
              case 'latin1':
              case 'binary':
              case 'base64':
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return true;
              default:
                return false;
            }
          };
          Buffer.concat = function concat(list, length) {
            if (!Array.isArray(list)) {
              throw new TypeError('"list" argument must be an Array of Buffers');
            }
            if (list.length === 0) {
              return Buffer.alloc(0);
            }
            var i;
            if (length === undefined) {
              length = 0;
              for (i = 0; i < list.length; ++i) {
                length += list[i].length;
              }
            }
            var buffer = Buffer.allocUnsafe(length);
            var pos = 0;
            for (i = 0; i < list.length; ++i) {
              var buf = list[i];
              if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) {
                  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                  buf.copy(buffer, pos);
                } else {
                  Uint8Array.prototype.set.call(buffer, buf, pos);
                }
              } else if (!Buffer.isBuffer(buf)) {
                throw new TypeError('"list" argument must be an Array of Buffers');
              } else {
                buf.copy(buffer, pos);
              }
              pos += buf.length;
            }
            return buffer;
          };
          function byteLength(string, encoding) {
            if (Buffer.isBuffer(string)) {
              return string.length;
            }
            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
              return string.byteLength;
            }
            if (typeof string !== 'string') {
              throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + typeof string);
            }
            var len = string.length;
            var mustMatch = arguments.length > 2 && arguments[2] === true;
            if (!mustMatch && len === 0) return 0;

            // Use a for loop to avoid recursion
            var loweredCase = false;
            for (;;) {
              switch (encoding) {
                case 'ascii':
                case 'latin1':
                case 'binary':
                  return len;
                case 'utf8':
                case 'utf-8':
                  return utf8ToBytes(string).length;
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return len * 2;
                case 'hex':
                  return len >>> 1;
                case 'base64':
                  return base64ToBytes(string).length;
                default:
                  if (loweredCase) {
                    return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                  }

                  encoding = ('' + encoding).toLowerCase();
                  loweredCase = true;
              }
            }
          }
          Buffer.byteLength = byteLength;
          function slowToString(encoding, start, end) {
            var loweredCase = false;

            // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
            // property of a typed array.

            // This behaves neither like String nor Uint8Array in that we set start/end
            // to their upper/lower bounds if the value passed is out of range.
            // undefined is handled specially as per ECMA-262 6th Edition,
            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
            if (start === undefined || start < 0) {
              start = 0;
            }
            // Return early if start > this.length. Done here to prevent potential uint32
            // coercion fail below.
            if (start > this.length) {
              return '';
            }
            if (end === undefined || end > this.length) {
              end = this.length;
            }
            if (end <= 0) {
              return '';
            }

            // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
            end >>>= 0;
            start >>>= 0;
            if (end <= start) {
              return '';
            }
            if (!encoding) encoding = 'utf8';
            while (true) {
              switch (encoding) {
                case 'hex':
                  return hexSlice(this, start, end);
                case 'utf8':
                case 'utf-8':
                  return utf8Slice(this, start, end);
                case 'ascii':
                  return asciiSlice(this, start, end);
                case 'latin1':
                case 'binary':
                  return latin1Slice(this, start, end);
                case 'base64':
                  return base64Slice(this, start, end);
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return utf16leSlice(this, start, end);
                default:
                  if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                  encoding = (encoding + '').toLowerCase();
                  loweredCase = true;
              }
            }
          }

          // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
          // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
          // reliably in a browserify context because there could be multiple different
          // copies of the 'buffer' package in use. This method works even for Buffer
          // instances that were created from another copy of the `buffer` package.
          // See: https://github.com/feross/buffer/issues/154
          Buffer.prototype._isBuffer = true;
          function swap(b, n, m) {
            var i = b[n];
            b[n] = b[m];
            b[m] = i;
          }
          Buffer.prototype.swap16 = function swap16() {
            var len = this.length;
            if (len % 2 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 16-bits');
            }
            for (var i = 0; i < len; i += 2) {
              swap(this, i, i + 1);
            }
            return this;
          };
          Buffer.prototype.swap32 = function swap32() {
            var len = this.length;
            if (len % 4 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 32-bits');
            }
            for (var i = 0; i < len; i += 4) {
              swap(this, i, i + 3);
              swap(this, i + 1, i + 2);
            }
            return this;
          };
          Buffer.prototype.swap64 = function swap64() {
            var len = this.length;
            if (len % 8 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 64-bits');
            }
            for (var i = 0; i < len; i += 8) {
              swap(this, i, i + 7);
              swap(this, i + 1, i + 6);
              swap(this, i + 2, i + 5);
              swap(this, i + 3, i + 4);
            }
            return this;
          };
          Buffer.prototype.toString = function toString() {
            var length = this.length;
            if (length === 0) return '';
            if (arguments.length === 0) return utf8Slice(this, 0, length);
            return slowToString.apply(this, arguments);
          };
          Buffer.prototype.toLocaleString = Buffer.prototype.toString;
          Buffer.prototype.equals = function equals(b) {
            if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
            if (this === b) return true;
            return Buffer.compare(this, b) === 0;
          };
          Buffer.prototype.inspect = function inspect() {
            var str = '';
            var max = exports.INSPECT_MAX_BYTES;
            str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
            if (this.length > max) str += ' ... ';
            return '<Buffer ' + str + '>';
          };
          if (customInspectSymbol) {
            Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
          }
          Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
            if (isInstance(target, Uint8Array)) {
              target = Buffer.from(target, target.offset, target.byteLength);
            }
            if (!Buffer.isBuffer(target)) {
              throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target);
            }
            if (start === undefined) {
              start = 0;
            }
            if (end === undefined) {
              end = target ? target.length : 0;
            }
            if (thisStart === undefined) {
              thisStart = 0;
            }
            if (thisEnd === undefined) {
              thisEnd = this.length;
            }
            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
              throw new RangeError('out of range index');
            }
            if (thisStart >= thisEnd && start >= end) {
              return 0;
            }
            if (thisStart >= thisEnd) {
              return -1;
            }
            if (start >= end) {
              return 1;
            }
            start >>>= 0;
            end >>>= 0;
            thisStart >>>= 0;
            thisEnd >>>= 0;
            if (this === target) return 0;
            var x = thisEnd - thisStart;
            var y = end - start;
            var len = Math.min(x, y);
            var thisCopy = this.slice(thisStart, thisEnd);
            var targetCopy = target.slice(start, end);
            for (var i = 0; i < len; ++i) {
              if (thisCopy[i] !== targetCopy[i]) {
                x = thisCopy[i];
                y = targetCopy[i];
                break;
              }
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
          };

          // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
          // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
          //
          // Arguments:
          // - buffer - a Buffer to search
          // - val - a string, Buffer, or number
          // - byteOffset - an index into `buffer`; will be clamped to an int32
          // - encoding - an optional encoding, relevant is val is a string
          // - dir - true for indexOf, false for lastIndexOf
          function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
            // Empty buffer means no match
            if (buffer.length === 0) return -1;

            // Normalize byteOffset
            if (typeof byteOffset === 'string') {
              encoding = byteOffset;
              byteOffset = 0;
            } else if (byteOffset > 0x7fffffff) {
              byteOffset = 0x7fffffff;
            } else if (byteOffset < -0x80000000) {
              byteOffset = -0x80000000;
            }
            byteOffset = +byteOffset; // Coerce to Number.
            if (numberIsNaN(byteOffset)) {
              // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
              byteOffset = dir ? 0 : buffer.length - 1;
            }

            // Normalize byteOffset: negative offsets start from the end of the buffer
            if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
            if (byteOffset >= buffer.length) {
              if (dir) return -1;else byteOffset = buffer.length - 1;
            } else if (byteOffset < 0) {
              if (dir) byteOffset = 0;else return -1;
            }

            // Normalize val
            if (typeof val === 'string') {
              val = Buffer.from(val, encoding);
            }

            // Finally, search either indexOf (if dir is true) or lastIndexOf
            if (Buffer.isBuffer(val)) {
              // Special case: looking for empty string/buffer always fails
              if (val.length === 0) {
                return -1;
              }
              return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
            } else if (typeof val === 'number') {
              val = val & 0xFF; // Search for a byte value [0-255]
              if (typeof Uint8Array.prototype.indexOf === 'function') {
                if (dir) {
                  return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                } else {
                  return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                }
              }
              return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
            }
            throw new TypeError('val must be string, number or Buffer');
          }
          function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
            var indexSize = 1;
            var arrLength = arr.length;
            var valLength = val.length;
            if (encoding !== undefined) {
              encoding = String(encoding).toLowerCase();
              if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) {
                  return -1;
                }
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
              }
            }
            function read(buf, i) {
              if (indexSize === 1) {
                return buf[i];
              } else {
                return buf.readUInt16BE(i * indexSize);
              }
            }
            var i;
            if (dir) {
              var foundIndex = -1;
              for (i = byteOffset; i < arrLength; i++) {
                if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                  if (foundIndex === -1) foundIndex = i;
                  if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                } else {
                  if (foundIndex !== -1) i -= i - foundIndex;
                  foundIndex = -1;
                }
              }
            } else {
              if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
              for (i = byteOffset; i >= 0; i--) {
                var found = true;
                for (var j = 0; j < valLength; j++) {
                  if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                  }
                }
                if (found) return i;
              }
            }
            return -1;
          }
          Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
            return this.indexOf(val, byteOffset, encoding) !== -1;
          };
          Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
          };
          Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
          };
          function hexWrite(buf, string, offset, length) {
            offset = Number(offset) || 0;
            var remaining = buf.length - offset;
            if (!length) {
              length = remaining;
            } else {
              length = Number(length);
              if (length > remaining) {
                length = remaining;
              }
            }
            var strLen = string.length;
            if (length > strLen / 2) {
              length = strLen / 2;
            }
            var i;
            for (i = 0; i < length; ++i) {
              var parsed = parseInt(string.substr(i * 2, 2), 16);
              if (numberIsNaN(parsed)) return i;
              buf[offset + i] = parsed;
            }
            return i;
          }
          function utf8Write(buf, string, offset, length) {
            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
          }
          function asciiWrite(buf, string, offset, length) {
            return blitBuffer(asciiToBytes(string), buf, offset, length);
          }
          function base64Write(buf, string, offset, length) {
            return blitBuffer(base64ToBytes(string), buf, offset, length);
          }
          function ucs2Write(buf, string, offset, length) {
            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
          }
          Buffer.prototype.write = function write(string, offset, length, encoding) {
            // Buffer#write(string)
            if (offset === undefined) {
              encoding = 'utf8';
              length = this.length;
              offset = 0;
              // Buffer#write(string, encoding)
            } else if (length === undefined && typeof offset === 'string') {
              encoding = offset;
              length = this.length;
              offset = 0;
              // Buffer#write(string, offset[, length][, encoding])
            } else if (isFinite(offset)) {
              offset = offset >>> 0;
              if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
              } else {
                encoding = length;
                length = undefined;
              }
            } else {
              throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
            }
            var remaining = this.length - offset;
            if (length === undefined || length > remaining) length = remaining;
            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
              throw new RangeError('Attempt to write outside buffer bounds');
            }
            if (!encoding) encoding = 'utf8';
            var loweredCase = false;
            for (;;) {
              switch (encoding) {
                case 'hex':
                  return hexWrite(this, string, offset, length);
                case 'utf8':
                case 'utf-8':
                  return utf8Write(this, string, offset, length);
                case 'ascii':
                case 'latin1':
                case 'binary':
                  return asciiWrite(this, string, offset, length);
                case 'base64':
                  // Warning: maxLength not taken into account in base64Write
                  return base64Write(this, string, offset, length);
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return ucs2Write(this, string, offset, length);
                default:
                  if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                  encoding = ('' + encoding).toLowerCase();
                  loweredCase = true;
              }
            }
          };
          Buffer.prototype.toJSON = function toJSON() {
            return {
              type: 'Buffer',
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          function base64Slice(buf, start, end) {
            if (start === 0 && end === buf.length) {
              return base64.fromByteArray(buf);
            } else {
              return base64.fromByteArray(buf.slice(start, end));
            }
          }
          function utf8Slice(buf, start, end) {
            end = Math.min(buf.length, end);
            var res = [];
            var i = start;
            while (i < end) {
              var firstByte = buf[i];
              var codePoint = null;
              var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
              if (i + bytesPerSequence <= end) {
                var secondByte = void 0,
                  thirdByte = void 0,
                  fourthByte = void 0,
                  tempCodePoint = void 0;
                switch (bytesPerSequence) {
                  case 1:
                    if (firstByte < 0x80) {
                      codePoint = firstByte;
                    }
                    break;
                  case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                      if (tempCodePoint > 0x7F) {
                        codePoint = tempCodePoint;
                      }
                    }
                    break;
                  case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                      if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                        codePoint = tempCodePoint;
                      }
                    }
                    break;
                  case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                      if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                        codePoint = tempCodePoint;
                      }
                    }
                }
              }
              if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
              } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
              }
              res.push(codePoint);
              i += bytesPerSequence;
            }
            return decodeCodePointsArray(res);
          }

          // Based on http://stackoverflow.com/a/22747272/680742, the browser with
          // the lowest limit is Chrome, with 0x10000 args.
          // We go 1 magnitude less, for safety
          var MAX_ARGUMENTS_LENGTH = 0x1000;
          function decodeCodePointsArray(codePoints) {
            var len = codePoints.length;
            if (len <= MAX_ARGUMENTS_LENGTH) {
              return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
            }

            // Decode in chunks to avoid "call stack size exceeded".
            var res = '';
            var i = 0;
            while (i < len) {
              res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
            }
            return res;
          }
          function asciiSlice(buf, start, end) {
            var ret = '';
            end = Math.min(buf.length, end);
            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i] & 0x7F);
            }
            return ret;
          }
          function latin1Slice(buf, start, end) {
            var ret = '';
            end = Math.min(buf.length, end);
            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i]);
            }
            return ret;
          }
          function hexSlice(buf, start, end) {
            var len = buf.length;
            if (!start || start < 0) start = 0;
            if (!end || end < 0 || end > len) end = len;
            var out = '';
            for (var i = start; i < end; ++i) {
              out += hexSliceLookupTable[buf[i]];
            }
            return out;
          }
          function utf16leSlice(buf, start, end) {
            var bytes = buf.slice(start, end);
            var res = '';
            // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
            for (var i = 0; i < bytes.length - 1; i += 2) {
              res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
            }
            return res;
          }
          Buffer.prototype.slice = function slice(start, end) {
            var len = this.length;
            start = ~~start;
            end = end === undefined ? len : ~~end;
            if (start < 0) {
              start += len;
              if (start < 0) start = 0;
            } else if (start > len) {
              start = len;
            }
            if (end < 0) {
              end += len;
              if (end < 0) end = 0;
            } else if (end > len) {
              end = len;
            }
            if (end < start) end = start;
            var newBuf = this.subarray(start, end);
            // Return an augmented `Uint8Array` instance
            Object.setPrototypeOf(newBuf, Buffer.prototype);
            return newBuf;
          };

          /*
           * Need to make sure that buffer isn't trying to write out of bounds.
           */
          function checkOffset(offset, ext, length) {
            if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
            if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
          }
          Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul;
            }
            return val;
          };
          Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) {
              checkOffset(offset, byteLength, this.length);
            }
            var val = this[offset + --byteLength];
            var mul = 1;
            while (byteLength > 0 && (mul *= 0x100)) {
              val += this[offset + --byteLength] * mul;
            }
            return val;
          };
          Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            return this[offset];
          };
          Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] | this[offset + 1] << 8;
          };
          Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] << 8 | this[offset + 1];
          };
          Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
          };
          Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
          };
          Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
            offset = offset >>> 0;
            validateNumber(offset, 'offset');
            var first = this[offset];
            var last = this[offset + 7];
            if (first === undefined || last === undefined) {
              boundsError(offset, this.length - 8);
            }
            var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
            var hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
            return BigInt(lo) + (BigInt(hi) << BigInt(32));
          });
          Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
            offset = offset >>> 0;
            validateNumber(offset, 'offset');
            var first = this[offset];
            var last = this[offset + 7];
            if (first === undefined || last === undefined) {
              boundsError(offset, this.length - 8);
            }
            var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
            var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
            return (BigInt(hi) << BigInt(32)) + BigInt(lo);
          });
          Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul;
            }
            mul *= 0x80;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
            return val;
          };
          Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var i = byteLength;
            var mul = 1;
            var val = this[offset + --i];
            while (i > 0 && (mul *= 0x100)) {
              val += this[offset + --i] * mul;
            }
            mul *= 0x80;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
            return val;
          };
          Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            if (!(this[offset] & 0x80)) return this[offset];
            return (0xff - this[offset] + 1) * -1;
          };
          Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset] | this[offset + 1] << 8;
            return val & 0x8000 ? val | 0xFFFF0000 : val;
          };
          Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset + 1] | this[offset] << 8;
            return val & 0x8000 ? val | 0xFFFF0000 : val;
          };
          Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
          };
          Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
          };
          Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
            offset = offset >>> 0;
            validateNumber(offset, 'offset');
            var first = this[offset];
            var last = this[offset + 7];
            if (first === undefined || last === undefined) {
              boundsError(offset, this.length - 8);
            }
            var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24); // Overflow

            return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
          });
          Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
            offset = offset >>> 0;
            validateNumber(offset, 'offset');
            var first = this[offset];
            var last = this[offset + 7];
            if (first === undefined || last === undefined) {
              boundsError(offset, this.length - 8);
            }
            var val = (first << 24) +
            // Overflow
            this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
            return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
          });
          Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee754.read(this, offset, true, 23, 4);
          };
          Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee754.read(this, offset, false, 23, 4);
          };
          Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee754.read(this, offset, true, 52, 8);
          };
          Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee754.read(this, offset, false, 52, 8);
          };
          function checkInt(buf, value, offset, ext, max, min) {
            if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
            if (offset + ext > buf.length) throw new RangeError('Index out of range');
          }
          Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1;
              checkInt(this, value, offset, byteLength, maxBytes, 0);
            }
            var mul = 1;
            var i = 0;
            this[offset] = value & 0xFF;
            while (++i < byteLength && (mul *= 0x100)) {
              this[offset + i] = value / mul & 0xFF;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1;
              checkInt(this, value, offset, byteLength, maxBytes, 0);
            }
            var i = byteLength - 1;
            var mul = 1;
            this[offset + i] = value & 0xFF;
            while (--i >= 0 && (mul *= 0x100)) {
              this[offset + i] = value / mul & 0xFF;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
            this[offset] = value & 0xff;
            return offset + 1;
          };
          Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            return offset + 2;
          };
          Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
            return offset + 2;
          };
          Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
            this[offset + 3] = value >>> 24;
            this[offset + 2] = value >>> 16;
            this[offset + 1] = value >>> 8;
            this[offset] = value & 0xff;
            return offset + 4;
          };
          Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
            return offset + 4;
          };
          function wrtBigUInt64LE(buf, value, offset, min, max) {
            checkIntBI(value, min, max, buf, offset, 7);
            var lo = Number(value & BigInt(0xffffffff));
            buf[offset++] = lo;
            lo = lo >> 8;
            buf[offset++] = lo;
            lo = lo >> 8;
            buf[offset++] = lo;
            lo = lo >> 8;
            buf[offset++] = lo;
            var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
            buf[offset++] = hi;
            hi = hi >> 8;
            buf[offset++] = hi;
            hi = hi >> 8;
            buf[offset++] = hi;
            hi = hi >> 8;
            buf[offset++] = hi;
            return offset;
          }
          function wrtBigUInt64BE(buf, value, offset, min, max) {
            checkIntBI(value, min, max, buf, offset, 7);
            var lo = Number(value & BigInt(0xffffffff));
            buf[offset + 7] = lo;
            lo = lo >> 8;
            buf[offset + 6] = lo;
            lo = lo >> 8;
            buf[offset + 5] = lo;
            lo = lo >> 8;
            buf[offset + 4] = lo;
            var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
            buf[offset + 3] = hi;
            hi = hi >> 8;
            buf[offset + 2] = hi;
            hi = hi >> 8;
            buf[offset + 1] = hi;
            hi = hi >> 8;
            buf[offset] = hi;
            return offset + 8;
          }
          Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
          });
          Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
          });
          Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              var limit = Math.pow(2, 8 * byteLength - 1);
              checkInt(this, value, offset, byteLength, limit - 1, -limit);
            }
            var i = 0;
            var mul = 1;
            var sub = 0;
            this[offset] = value & 0xFF;
            while (++i < byteLength && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
                sub = 1;
              }
              this[offset + i] = (value / mul >> 0) - sub & 0xFF;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              var limit = Math.pow(2, 8 * byteLength - 1);
              checkInt(this, value, offset, byteLength, limit - 1, -limit);
            }
            var i = byteLength - 1;
            var mul = 1;
            var sub = 0;
            this[offset + i] = value & 0xFF;
            while (--i >= 0 && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
                sub = 1;
              }
              this[offset + i] = (value / mul >> 0) - sub & 0xFF;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
            if (value < 0) value = 0xff + value + 1;
            this[offset] = value & 0xff;
            return offset + 1;
          };
          Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            return offset + 2;
          };
          Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
            return offset + 2;
          };
          Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            this[offset + 2] = value >>> 16;
            this[offset + 3] = value >>> 24;
            return offset + 4;
          };
          Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
            if (value < 0) value = 0xffffffff + value + 1;
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
            return offset + 4;
          };
          Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
          });
          Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
          });
          function checkIEEE754(buf, value, offset, ext, max, min) {
            if (offset + ext > buf.length) throw new RangeError('Index out of range');
            if (offset < 0) throw new RangeError('Index out of range');
          }
          function writeFloat(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
            }
            ieee754.write(buf, value, offset, littleEndian, 23, 4);
            return offset + 4;
          }
          Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
            return writeFloat(this, value, offset, true, noAssert);
          };
          Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
            return writeFloat(this, value, offset, false, noAssert);
          };
          function writeDouble(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
            }
            ieee754.write(buf, value, offset, littleEndian, 52, 8);
            return offset + 8;
          }
          Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
            return writeDouble(this, value, offset, true, noAssert);
          };
          Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
            return writeDouble(this, value, offset, false, noAssert);
          };

          // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
          Buffer.prototype.copy = function copy(target, targetStart, start, end) {
            if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
            if (!start) start = 0;
            if (!end && end !== 0) end = this.length;
            if (targetStart >= target.length) targetStart = target.length;
            if (!targetStart) targetStart = 0;
            if (end > 0 && end < start) end = start;

            // Copy 0 bytes; we're done
            if (end === start) return 0;
            if (target.length === 0 || this.length === 0) return 0;

            // Fatal error conditions
            if (targetStart < 0) {
              throw new RangeError('targetStart out of bounds');
            }
            if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
            if (end < 0) throw new RangeError('sourceEnd out of bounds');

            // Are we oob?
            if (end > this.length) end = this.length;
            if (target.length - targetStart < end - start) {
              end = target.length - targetStart + start;
            }
            var len = end - start;
            if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
              // Use built-in when available, missing from IE11
              this.copyWithin(targetStart, start, end);
            } else {
              Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
            }
            return len;
          };

          // Usage:
          //    buffer.fill(number[, offset[, end]])
          //    buffer.fill(buffer[, offset[, end]])
          //    buffer.fill(string[, offset[, end]][, encoding])
          Buffer.prototype.fill = function fill(val, start, end, encoding) {
            // Handle string cases:
            if (typeof val === 'string') {
              if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
              } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
              }
              if (encoding !== undefined && typeof encoding !== 'string') {
                throw new TypeError('encoding must be a string');
              }
              if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
                throw new TypeError('Unknown encoding: ' + encoding);
              }
              if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
                  // Fast path: If `val` fits into a single byte, use that numeric value.
                  val = code;
                }
              }
            } else if (typeof val === 'number') {
              val = val & 255;
            } else if (typeof val === 'boolean') {
              val = Number(val);
            }

            // Invalid ranges are not set to a default, so can range check early.
            if (start < 0 || this.length < start || this.length < end) {
              throw new RangeError('Out of range index');
            }
            if (end <= start) {
              return this;
            }
            start = start >>> 0;
            end = end === undefined ? this.length : end >>> 0;
            if (!val) val = 0;
            var i;
            if (typeof val === 'number') {
              for (i = start; i < end; ++i) {
                this[i] = val;
              }
            } else {
              var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
              var len = bytes.length;
              if (len === 0) {
                throw new TypeError('The value "' + val + '" is invalid for argument "value"');
              }
              for (i = 0; i < end - start; ++i) {
                this[i + start] = bytes[i % len];
              }
            }
            return this;
          };

          // CUSTOM ERRORS
          // =============

          // Simplified versions from Node, changed for Buffer-only usage
          var errors = {};
          function E(sym, getMessage, Base) {
            errors[sym] = /*#__PURE__*/function (_Base) {
              _inherits(NodeError, _Base);
              var _super = _createSuper(NodeError);
              function NodeError() {
                var _this2;
                _classCallCheck2(this, NodeError);
                _this2 = _super.call(this);
                Object.defineProperty(_assertThisInitialized(_this2), 'message', {
                  value: getMessage.apply(_assertThisInitialized(_this2), arguments),
                  writable: true,
                  configurable: true
                });

                // Add the error code to the name to include it in the stack trace.
                _this2.name = "".concat(_this2.name, " [").concat(sym, "]");
                // Access the stack to generate the error message including the error code
                // from the name.
                _this2.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete _this2.name;
                return _this2;
              }
              _createClass2(NodeError, [{
                key: "code",
                get: function get() {
                  return sym;
                },
                set: function set(value) {
                  Object.defineProperty(this, 'code', {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                  });
                }
              }, {
                key: "toString",
                value: function toString() {
                  return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
              }]);
              return NodeError;
            }(Base);
          }
          E('ERR_BUFFER_OUT_OF_BOUNDS', function (name) {
            if (name) {
              return "".concat(name, " is outside of buffer bounds");
            }
            return 'Attempt to access memory outside buffer bounds';
          }, RangeError);
          E('ERR_INVALID_ARG_TYPE', function (name, actual) {
            return "The \"".concat(name, "\" argument must be of type number. Received type ").concat(typeof actual);
          }, TypeError);
          E('ERR_OUT_OF_RANGE', function (str, range, input) {
            var msg = "The value of \"".concat(str, "\" is out of range.");
            var received = input;
            if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
              received = addNumericalSeparator(String(input));
            } else if (typeof input === 'bigint') {
              received = String(input);
              if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) {
                received = addNumericalSeparator(received);
              }
              received += 'n';
            }
            msg += " It must be ".concat(range, ". Received ").concat(received);
            return msg;
          }, RangeError);
          function addNumericalSeparator(val) {
            var res = '';
            var i = val.length;
            var start = val[0] === '-' ? 1 : 0;
            for (; i >= start + 4; i -= 3) {
              res = "_".concat(val.slice(i - 3, i)).concat(res);
            }
            return "".concat(val.slice(0, i)).concat(res);
          }

          // CHECK FUNCTIONS
          // ===============

          function checkBounds(buf, offset, byteLength) {
            validateNumber(offset, 'offset');
            if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
              boundsError(offset, buf.length - (byteLength + 1));
            }
          }
          function checkIntBI(value, min, max, buf, offset, byteLength) {
            if (value > max || value < min) {
              var n = typeof min === 'bigint' ? 'n' : '';
              var range;
              if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) {
                  range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
                } else {
                  range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
                }
              } else {
                range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
              }
              throw new errors.ERR_OUT_OF_RANGE('value', range, value);
            }
            checkBounds(buf, offset, byteLength);
          }
          function validateNumber(value, name) {
            if (typeof value !== 'number') {
              throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
            }
          }
          function boundsError(value, length, type) {
            if (Math.floor(value) !== value) {
              validateNumber(value, type);
              throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
            }
            if (length < 0) {
              throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
            }
            throw new errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
          }

          // HELPER FUNCTIONS
          // ================

          var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
          function base64clean(str) {
            // Node takes equal signs as end of the Base64 encoding
            str = str.split('=')[0];
            // Node strips out invalid characters like \n and \t from the string, base64-js does not
            str = str.trim().replace(INVALID_BASE64_RE, '');
            // Node converts strings with length < 2 to ''
            if (str.length < 2) return '';
            // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
            while (str.length % 4 !== 0) {
              str = str + '=';
            }
            return str;
          }
          function utf8ToBytes(string, units) {
            units = units || Infinity;
            var codePoint;
            var length = string.length;
            var leadSurrogate = null;
            var bytes = [];
            for (var i = 0; i < length; ++i) {
              codePoint = string.charCodeAt(i);

              // is surrogate component
              if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                  // no lead yet
                  if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                  } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                  }

                  // valid lead
                  leadSurrogate = codePoint;
                  continue;
                }

                // 2 leads in a row
                if (codePoint < 0xDC00) {
                  if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                  leadSurrogate = codePoint;
                  continue;
                }

                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
              } else if (leadSurrogate) {
                // valid bmp char, but last char was a lead
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              }
              leadSurrogate = null;

              // encode utf8
              if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
              } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
              } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
              } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
              } else {
                throw new Error('Invalid code point');
              }
            }
            return bytes;
          }
          function asciiToBytes(str) {
            var byteArray = [];
            for (var i = 0; i < str.length; ++i) {
              // Node's code seems to be doing this and not & 0x7F..
              byteArray.push(str.charCodeAt(i) & 0xFF);
            }
            return byteArray;
          }
          function utf16leToBytes(str, units) {
            var c, hi, lo;
            var byteArray = [];
            for (var i = 0; i < str.length; ++i) {
              if ((units -= 2) < 0) break;
              c = str.charCodeAt(i);
              hi = c >> 8;
              lo = c % 256;
              byteArray.push(lo);
              byteArray.push(hi);
            }
            return byteArray;
          }
          function base64ToBytes(str) {
            return base64.toByteArray(base64clean(str));
          }
          function blitBuffer(src, dst, offset, length) {
            var i;
            for (i = 0; i < length; ++i) {
              if (i + offset >= dst.length || i >= src.length) break;
              dst[i + offset] = src[i];
            }
            return i;
          }

          // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
          // the `instanceof` check but they should be treated as of that type.
          // See: https://github.com/feross/buffer/issues/166
          function isInstance(obj, type) {
            return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
          }
          function numberIsNaN(obj) {
            // For IE11 support
            return obj !== obj; // eslint-disable-line no-self-compare
          }

          // Create lookup table for `toString('hex')`
          // See: https://github.com/feross/buffer/issues/219
          var hexSliceLookupTable = function () {
            var alphabet = '0123456789abcdef';
            var table = new Array(256);
            for (var i = 0; i < 16; ++i) {
              var i16 = i * 16;
              for (var j = 0; j < 16; ++j) {
                table[i16 + j] = alphabet[i] + alphabet[j];
              }
            }
            return table;
          }();

          // Return not function with Error if BigInt not supported
          function defineBigIntMethod(fn) {
            return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
          }
          function BufferBigIntNotDefined() {
            throw new Error('BigInt not supported');
          }

          /***/
        },

        /***/"./node_modules/css-loader/dist/runtime/api.js":
        /*!*****************************************************!*\
          !*** ./node_modules/css-loader/dist/runtime/api.js ***!
          \*****************************************************/
        /***/
        function node_modulesCssLoaderDistRuntimeApiJs(module) {
          "use strict";

          /*
            MIT License http://www.opensource.org/licenses/mit-license.php
            Author Tobias Koppers @sokra
          */
          module.exports = function (cssWithMappingToString) {
            var list = [];

            // return the list of modules as css string
            list.toString = function toString() {
              return this.map(function (item) {
                var content = "";
                var needLayer = typeof item[5] !== "undefined";
                if (item[4]) {
                  content += "@supports (".concat(item[4], ") {");
                }
                if (item[2]) {
                  content += "@media ".concat(item[2], " {");
                }
                if (needLayer) {
                  content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
                }
                content += cssWithMappingToString(item);
                if (needLayer) {
                  content += "}";
                }
                if (item[2]) {
                  content += "}";
                }
                if (item[4]) {
                  content += "}";
                }
                return content;
              }).join("");
            };

            // import a list of modules into the list
            list.i = function i(modules, media, dedupe, supports, layer) {
              if (typeof modules === "string") {
                modules = [[null, modules, undefined]];
              }
              var alreadyImportedModules = {};
              if (dedupe) {
                for (var k = 0; k < this.length; k++) {
                  var id = this[k][0];
                  if (id != null) {
                    alreadyImportedModules[id] = true;
                  }
                }
              }
              for (var _k = 0; _k < modules.length; _k++) {
                var item = [].concat(modules[_k]);
                if (dedupe && alreadyImportedModules[item[0]]) {
                  continue;
                }
                if (typeof layer !== "undefined") {
                  if (typeof item[5] === "undefined") {
                    item[5] = layer;
                  } else {
                    item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
                    item[5] = layer;
                  }
                }
                if (media) {
                  if (!item[2]) {
                    item[2] = media;
                  } else {
                    item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
                    item[2] = media;
                  }
                }
                if (supports) {
                  if (!item[4]) {
                    item[4] = "".concat(supports);
                  } else {
                    item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
                    item[4] = supports;
                  }
                }
                list.push(item);
              }
            };
            return list;
          };

          /***/
        },

        /***/"./node_modules/css-loader/dist/runtime/getUrl.js":
        /*!********************************************************!*\
          !*** ./node_modules/css-loader/dist/runtime/getUrl.js ***!
          \********************************************************/
        /***/
        function node_modulesCssLoaderDistRuntimeGetUrlJs(module) {
          "use strict";

          module.exports = function (url, options) {
            if (!options) {
              options = {};
            }
            if (!url) {
              return url;
            }
            url = String(url.__esModule ? url.default : url);

            // If url is already wrapped in quotes, remove them
            if (/^['"].*['"]$/.test(url)) {
              url = url.slice(1, -1);
            }
            if (options.hash) {
              url += options.hash;
            }

            // Should url be wrapped?
            // See https://drafts.csswg.org/css-values-3/#urls
            if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
              return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), "\"");
            }
            return url;
          };

          /***/
        },

        /***/"./node_modules/css-loader/dist/runtime/sourceMaps.js":
        /*!************************************************************!*\
          !*** ./node_modules/css-loader/dist/runtime/sourceMaps.js ***!
          \************************************************************/
        /***/
        function node_modulesCssLoaderDistRuntimeSourceMapsJs(module) {
          "use strict";

          module.exports = function (item) {
            var content = item[1];
            var cssMapping = item[3];
            if (!cssMapping) {
              return content;
            }
            if (typeof btoa === "function") {
              var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
              var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
              var sourceMapping = "/*# ".concat(data, " */");
              return [content].concat([sourceMapping]).join("\n");
            }
            return [content].join("\n");
          };

          /***/
        },

        /***/"./node_modules/custom-event-polyfill/polyfill.js":
        /*!********************************************************!*\
          !*** ./node_modules/custom-event-polyfill/polyfill.js ***!
          \********************************************************/
        /***/
        function node_modulesCustomEventPolyfillPolyfillJs() {
          // Polyfill for creating CustomEvents on IE9/10/11

          // code pulled from:
          // https://github.com/d4tocchini/customevent-polyfill
          // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

          (function () {
            if (typeof window === 'undefined') {
              return;
            }
            try {
              var ce = new window.CustomEvent('test', {
                cancelable: true
              });
              ce.preventDefault();
              if (ce.defaultPrevented !== true) {
                // IE has problems with .preventDefault() on custom events
                // http://stackoverflow.com/questions/23349191
                throw new Error('Could not prevent default');
              }
            } catch (e) {
              var CustomEvent = function CustomEvent(event, params) {
                var evt, origPrevent;
                params = params || {};
                params.bubbles = !!params.bubbles;
                params.cancelable = !!params.cancelable;
                evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                origPrevent = evt.preventDefault;
                evt.preventDefault = function () {
                  origPrevent.call(this);
                  try {
                    Object.defineProperty(this, 'defaultPrevented', {
                      get: function get() {
                        return true;
                      }
                    });
                  } catch (e) {
                    this.defaultPrevented = true;
                  }
                };
                return evt;
              };
              CustomEvent.prototype = window.Event.prototype;
              window.CustomEvent = CustomEvent; // expose definition to window
            }
          })();

          /***/
        },

        /***/"./node_modules/debug/browser.js":
        /*!***************************************!*\
          !*** ./node_modules/debug/browser.js ***!
          \***************************************/
        /***/
        function node_modulesDebugBrowserJs(module, exports, __webpack_require__) {
          /**
           * This is the web browser implementation of `debug()`.
           *
           * Expose `debug()` as the module.
           */

          exports = module.exports = __webpack_require__( /*! ./debug */"./node_modules/debug/debug.js");
          exports.log = log;
          exports.formatArgs = formatArgs;
          exports.save = save;
          exports.load = load;
          exports.useColors = useColors;
          exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

          /**
           * Colors.
           */

          exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];

          /**
           * Currently only WebKit-based Web Inspectors, Firefox >= v31,
           * and the Firebug extension (any Firefox version) are known
           * to support "%c" CSS customizations.
           *
           * TODO: add a `localStorage` variable to explicitly enable/disable colors
           */

          function useColors() {
            // is webkit? http://stackoverflow.com/a/16459606/376773
            return 'WebkitAppearance' in document.documentElement.style ||
            // is firebug? http://stackoverflow.com/a/398120/376773
            window.console && (console.firebug || console.exception && console.table) ||
            // is firefox >= v31?
            // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
            navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31;
          }

          /**
           * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
           */

          exports.formatters.j = function (v) {
            return JSON.stringify(v);
          };

          /**
           * Colorize log arguments if enabled.
           *
           * @api public
           */

          function formatArgs() {
            var args = arguments;
            var useColors = this.useColors;
            args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ');
            if (!useColors) return args;
            var c = 'color: ' + this.color;
            args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

            // the final "%c" is somewhat tricky, because there could be other
            // arguments passed either before or after the %c, so we need to
            // figure out the correct index to insert the CSS into
            var index = 0;
            var lastC = 0;
            args[0].replace(/%[a-z%]/g, function (match) {
              if ('%%' === match) return;
              index++;
              if ('%c' === match) {
                // we only are interested in the *last* %c
                // (the user may have provided their own)
                lastC = index;
              }
            });
            args.splice(lastC, 0, c);
            return args;
          }

          /**
           * Invokes `console.log()` when available.
           * No-op when `console.log` is not a "function".
           *
           * @api public
           */

          function log() {
            // this hackery is required for IE8/9, where
            // the `console.log` function doesn't have 'apply'
            return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
          }

          /**
           * Save `namespaces`.
           *
           * @param {String} namespaces
           * @api private
           */

          function save(namespaces) {
            try {
              if (null == namespaces) {
                exports.storage.removeItem('debug');
              } else {
                exports.storage.debug = namespaces;
              }
            } catch (e) {}
          }

          /**
           * Load `namespaces`.
           *
           * @return {String} returns the previously persisted debug modes
           * @api private
           */

          function load() {
            var r;
            try {
              r = exports.storage.debug;
            } catch (e) {}
            return r;
          }

          /**
           * Enable namespaces listed in `localStorage.debug` initially.
           */

          exports.enable(load());

          /**
           * Localstorage attempts to return the localstorage.
           *
           * This is necessary because safari throws
           * when a user disables cookies/localstorage
           * and you attempt to access it.
           *
           * @return {LocalStorage}
           * @api private
           */

          function localstorage() {
            try {
              return window.localStorage;
            } catch (e) {}
          }

          /***/
        },

        /***/"./node_modules/debug/debug.js":
        /*!*************************************!*\
          !*** ./node_modules/debug/debug.js ***!
          \*************************************/
        /***/
        function node_modulesDebugDebugJs(module, exports) {
          /**
           * This is the common logic for both the Node.js and web browser
           * implementations of `debug()`.
           *
           * Expose `debug()` as the module.
           */

          exports = module.exports = debug;
          exports.coerce = coerce;
          exports.disable = disable;
          exports.enable = enable;
          exports.enabled = enabled;

          /**
           * The currently active debug mode names, and names to skip.
           */

          exports.names = [];
          exports.skips = [];

          /**
           * Map of special "%n" handling functions, for the debug "format" argument.
           *
           * Valid key names are a single, lowercased letter, i.e. "n".
           */

          exports.formatters = {};

          /**
           * Previously assigned color.
           */

          var prevColor = 0;

          /**
           * Select a color.
           *
           * @return {Number}
           * @api private
           */

          function selectColor() {
            return exports.colors[prevColor++ % exports.colors.length];
          }

          /**
           * Create a debugger with the given `namespace`.
           *
           * @param {String} namespace
           * @return {Function}
           * @api public
           */

          function debug(namespace) {
            // define the `disabled` version
            function disabled() {}
            disabled.enabled = false;

            // define the `enabled` version
            function enabled() {
              var self = enabled;

              // add the `color` if not set
              if (null == self.useColors) self.useColors = exports.useColors();
              if (null == self.color && self.useColors) self.color = selectColor();
              var args = Array.prototype.slice.call(arguments);
              args[0] = exports.coerce(args[0]);
              if ('string' !== typeof args[0]) {
                // anything else let's inspect with %o
                args = ['%o'].concat(args);
              }

              // apply any `formatters` transformations
              var index = 0;
              args[0] = args[0].replace(/%([a-z%])/g, function (match, format) {
                // if we encounter an escaped % then don't increase the array index
                if (match === '%%') return match;
                index++;
                var formatter = exports.formatters[format];
                if ('function' === typeof formatter) {
                  var val = args[index];
                  match = formatter.call(self, val);

                  // now we need to remove `args[index]` since it's inlined in the `format`
                  args.splice(index, 1);
                  index--;
                }
                return match;
              });
              if ('function' === typeof exports.formatArgs) {
                args = exports.formatArgs.apply(self, args);
              }
              var logFn = enabled.log || exports.log || console.log.bind(console);
              logFn.apply(self, args);
            }
            enabled.enabled = true;
            var fn = exports.enabled(namespace) ? enabled : disabled;
            fn.namespace = namespace;
            return fn;
          }

          /**
           * Enables a debug mode by namespaces. This can include modes
           * separated by a colon and wildcards.
           *
           * @param {String} namespaces
           * @api public
           */

          function enable(namespaces) {
            exports.save(namespaces);
            var split = (namespaces || '').split(/[\s,]+/);
            var len = split.length;
            for (var i = 0; i < len; i++) {
              if (!split[i]) continue; // ignore empty strings
              namespaces = split[i].replace(/\*/g, '.*?');
              if (namespaces[0] === '-') {
                exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
              } else {
                exports.names.push(new RegExp('^' + namespaces + '$'));
              }
            }
          }

          /**
           * Disable debug output.
           *
           * @api public
           */

          function disable() {
            exports.enable('');
          }

          /**
           * Returns true if the given mode name is enabled, false otherwise.
           *
           * @param {String} name
           * @return {Boolean}
           * @api public
           */

          function enabled(name) {
            var i, len;
            for (i = 0, len = exports.skips.length; i < len; i++) {
              if (exports.skips[i].test(name)) {
                return false;
              }
            }
            for (i = 0, len = exports.names.length; i < len; i++) {
              if (exports.names[i].test(name)) {
                return true;
              }
            }
            return false;
          }

          /**
           * Coerce `val`.
           *
           * @param {Mixed} val
           * @return {Mixed}
           * @api private
           */

          function coerce(val) {
            if (val instanceof Error) return val.stack || val.message;
            return val;
          }

          /***/
        },

        /***/"./node_modules/deep-assign/index.js":
        /*!*******************************************!*\
          !*** ./node_modules/deep-assign/index.js ***!
          \*******************************************/
        /***/
        function node_modulesDeepAssignIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var isObj = __webpack_require__( /*! is-obj */"./node_modules/is-obj/index.js");
          var hasOwnProperty = Object.prototype.hasOwnProperty;
          var propIsEnumerable = Object.prototype.propertyIsEnumerable;
          function toObject(val) {
            if (val === null || val === undefined) {
              throw new TypeError('Sources cannot be null or undefined');
            }
            return Object(val);
          }
          function assignKey(to, from, key) {
            var val = from[key];
            if (val === undefined || val === null) {
              return;
            }
            if (hasOwnProperty.call(to, key)) {
              if (to[key] === undefined || to[key] === null) {
                throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
              }
            }
            if (!hasOwnProperty.call(to, key) || !isObj(val)) {
              to[key] = val;
            } else {
              to[key] = assign(Object(to[key]), from[key]);
            }
          }
          function assign(to, from) {
            if (to === from) {
              return to;
            }
            from = Object(from);
            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                assignKey(to, from, key);
              }
            }
            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(from);
              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  assignKey(to, from, symbols[i]);
                }
              }
            }
            return to;
          }
          module.exports = function deepAssign(target) {
            target = toObject(target);
            for (var s = 1; s < arguments.length; s++) {
              assign(target, arguments[s]);
            }
            return target;
          };

          /***/
        },

        /***/"./node_modules/dtype/index.js":
        /*!*************************************!*\
          !*** ./node_modules/dtype/index.js ***!
          \*************************************/
        /***/
        function node_modulesDtypeIndexJs(module) {
          module.exports = function (dtype) {
            switch (dtype) {
              case 'int8':
                return Int8Array;
              case 'int16':
                return Int16Array;
              case 'int32':
                return Int32Array;
              case 'uint8':
                return Uint8Array;
              case 'uint16':
                return Uint16Array;
              case 'uint32':
                return Uint32Array;
              case 'float32':
                return Float32Array;
              case 'float64':
                return Float64Array;
              case 'array':
                return Array;
              case 'uint8_clamped':
                return Uint8ClampedArray;
            }
          };

          /***/
        },

        /***/"./node_modules/flatten-vertex-data/index.js":
        /*!***************************************************!*\
          !*** ./node_modules/flatten-vertex-data/index.js ***!
          \***************************************************/
        /***/
        function node_modulesFlattenVertexDataIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          /*eslint new-cap:0*/
          var dtype = __webpack_require__( /*! dtype */"./node_modules/dtype/index.js");
          module.exports = flattenVertexData;
          function flattenVertexData(data, output, offset) {
            if (!data) throw new TypeError('must specify data as first parameter');
            offset = +(offset || 0) | 0;
            if (Array.isArray(data) && data[0] && typeof data[0][0] === 'number') {
              var dim = data[0].length;
              var length = data.length * dim;
              var i, j, k, l;

              // no output specified, create a new typed array
              if (!output || typeof output === 'string') {
                output = new (dtype(output || 'float32'))(length + offset);
              }
              var dstLength = output.length - offset;
              if (length !== dstLength) {
                throw new Error('source length ' + length + ' (' + dim + 'x' + data.length + ')' + ' does not match destination length ' + dstLength);
              }
              for (i = 0, k = offset; i < data.length; i++) {
                for (j = 0; j < dim; j++) {
                  output[k++] = data[i][j] === null ? NaN : data[i][j];
                }
              }
            } else {
              if (!output || typeof output === 'string') {
                // no output, create a new one
                var Ctor = dtype(output || 'float32');

                // handle arrays separately due to possible nulls
                if (Array.isArray(data) || output === 'array') {
                  output = new Ctor(data.length + offset);
                  for (i = 0, k = offset, l = output.length; k < l; k++, i++) {
                    output[k] = data[i] === null ? NaN : data[i];
                  }
                } else {
                  if (offset === 0) {
                    output = new Ctor(data);
                  } else {
                    output = new Ctor(data.length + offset);
                    output.set(data, offset);
                  }
                }
              } else {
                // store output in existing array
                output.set(data, offset);
              }
            }
            return output;
          }

          /***/
        },

        /***/"./node_modules/global/window.js":
        /*!***************************************!*\
          !*** ./node_modules/global/window.js ***!
          \***************************************/
        /***/
        function node_modulesGlobalWindowJs(module, __unused_webpack_exports, __webpack_require__) {
          var win;
          if (typeof window !== "undefined") {
            win = window;
          } else if (typeof __webpack_require__.g !== "undefined") {
            win = __webpack_require__.g;
          } else if (typeof self !== "undefined") {
            win = self;
          } else {
            win = {};
          }
          module.exports = win;

          /***/
        },

        /***/"./node_modules/ieee754/index.js":
        /*!***************************************!*\
          !*** ./node_modules/ieee754/index.js ***!
          \***************************************/
        /***/
        function node_modulesIeee754IndexJs(__unused_webpack_module, exports) {
          /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
          exports.read = function (buffer, offset, isLE, mLen, nBytes) {
            var e, m;
            var eLen = nBytes * 8 - mLen - 1;
            var eMax = (1 << eLen) - 1;
            var eBias = eMax >> 1;
            var nBits = -7;
            var i = isLE ? nBytes - 1 : 0;
            var d = isLE ? -1 : 1;
            var s = buffer[offset + i];
            i += d;
            e = s & (1 << -nBits) - 1;
            s >>= -nBits;
            nBits += eLen;
            for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
            m = e & (1 << -nBits) - 1;
            e >>= -nBits;
            nBits += mLen;
            for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
            if (e === 0) {
              e = 1 - eBias;
            } else if (e === eMax) {
              return m ? NaN : (s ? -1 : 1) * Infinity;
            } else {
              m = m + Math.pow(2, mLen);
              e = e - eBias;
            }
            return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
          };
          exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
            var e, m, c;
            var eLen = nBytes * 8 - mLen - 1;
            var eMax = (1 << eLen) - 1;
            var eBias = eMax >> 1;
            var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
            var i = isLE ? 0 : nBytes - 1;
            var d = isLE ? 1 : -1;
            var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
            value = Math.abs(value);
            if (isNaN(value) || value === Infinity) {
              m = isNaN(value) ? 1 : 0;
              e = eMax;
            } else {
              e = Math.floor(Math.log(value) / Math.LN2);
              if (value * (c = Math.pow(2, -e)) < 1) {
                e--;
                c *= 2;
              }
              if (e + eBias >= 1) {
                value += rt / c;
              } else {
                value += rt * Math.pow(2, 1 - eBias);
              }
              if (value * c >= 2) {
                e++;
                c /= 2;
              }
              if (e + eBias >= eMax) {
                m = 0;
                e = eMax;
              } else if (e + eBias >= 1) {
                m = (value * c - 1) * Math.pow(2, mLen);
                e = e + eBias;
              } else {
                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                e = 0;
              }
            }
            for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
            e = e << mLen | m;
            eLen += mLen;
            for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
            buffer[offset + i - d] |= s * 128;
          };

          /***/
        },

        /***/"./node_modules/inherits/inherits_browser.js":
        /*!***************************************************!*\
          !*** ./node_modules/inherits/inherits_browser.js ***!
          \***************************************************/
        /***/
        function node_modulesInheritsInherits_browserJs(module) {
          if (typeof Object.create === 'function') {
            // implementation from standard node.js 'util' module
            module.exports = function inherits(ctor, superCtor) {
              if (superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                  constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                  }
                });
              }
            };
          } else {
            // old school shim for old browsers
            module.exports = function inherits(ctor, superCtor) {
              if (superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function TempCtor() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
              }
            };
          }

          /***/
        },

        /***/"./node_modules/is-buffer/index.js":
        /*!*****************************************!*\
          !*** ./node_modules/is-buffer/index.js ***!
          \*****************************************/
        /***/
        function node_modulesIsBufferIndexJs(module) {
          /*!
           * Determine if an object is a Buffer
           *
           * @author   Feross Aboukhadijeh <https://feross.org>
           * @license  MIT
           */

          // The _isBuffer check is for Safari 5-7 support, because it's missing
          // Object.prototype.constructor. Remove this eventually
          module.exports = function (obj) {
            return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
          };
          function isBuffer(obj) {
            return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
          }

          // For Node v0.10 support. Remove this eventually.
          function isSlowBuffer(obj) {
            return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
          }

          /***/
        },

        /***/"./node_modules/is-function/index.js":
        /*!*******************************************!*\
          !*** ./node_modules/is-function/index.js ***!
          \*******************************************/
        /***/
        function node_modulesIsFunctionIndexJs(module) {
          module.exports = isFunction;
          var toString = Object.prototype.toString;
          function isFunction(fn) {
            if (!fn) {
              return false;
            }
            var string = toString.call(fn);
            return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (
            // IE8 and below
            fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
          }
          ;

          /***/
        },

        /***/"./node_modules/is-obj/index.js":
        /*!**************************************!*\
          !*** ./node_modules/is-obj/index.js ***!
          \**************************************/
        /***/
        function node_modulesIsObjIndexJs(module) {
          "use strict";

          module.exports = function (x) {
            var type = typeof x;
            return x !== null && (type === 'object' || type === 'function');
          };

          /***/
        },

        /***/"./node_modules/layout-bmfont-text/index.js":
        /*!**************************************************!*\
          !*** ./node_modules/layout-bmfont-text/index.js ***!
          \**************************************************/
        /***/
        function node_modulesLayoutBmfontTextIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          var wordWrap = __webpack_require__( /*! word-wrapper */"./node_modules/word-wrapper/index.js");
          var xtend = __webpack_require__( /*! xtend */"./node_modules/xtend/immutable.js");
          var number = __webpack_require__( /*! as-number */"./node_modules/as-number/index.js");
          var X_HEIGHTS = ['x', 'e', 'a', 'o', 'n', 's', 'r', 'c', 'u', 'm', 'v', 'w', 'z'];
          var M_WIDTHS = ['m', 'w'];
          var CAP_HEIGHTS = ['H', 'I', 'N', 'E', 'F', 'K', 'L', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
          var TAB_ID = '\t'.charCodeAt(0);
          var SPACE_ID = ' '.charCodeAt(0);
          var ALIGN_LEFT = 0,
            ALIGN_CENTER = 1,
            ALIGN_RIGHT = 2;
          module.exports = function createLayout(opt) {
            return new TextLayout(opt);
          };
          function TextLayout(opt) {
            this.glyphs = [];
            this._measure = this.computeMetrics.bind(this);
            this.update(opt);
          }
          TextLayout.prototype.update = function (opt) {
            opt = xtend({
              measure: this._measure
            }, opt);
            this._opt = opt;
            this._opt.tabSize = number(this._opt.tabSize, 4);
            if (!opt.font) throw new Error('must provide a valid bitmap font');
            var glyphs = this.glyphs;
            var text = opt.text || '';
            var font = opt.font;
            this._setupSpaceGlyphs(font);
            var lines = wordWrap.lines(text, opt);
            var minWidth = opt.width || 0;

            //clear glyphs
            glyphs.length = 0;

            //get max line width
            var maxLineWidth = lines.reduce(function (prev, line) {
              return Math.max(prev, line.width, minWidth);
            }, 0);

            //the pen position
            var x = 0;
            var y = 0;
            var lineHeight = number(opt.lineHeight, font.common.lineHeight);
            var baseline = font.common.base;
            var descender = lineHeight - baseline;
            var letterSpacing = opt.letterSpacing || 0;
            var height = lineHeight * lines.length - descender;
            var align = getAlignType(this._opt.align);

            //draw text along baseline
            y -= height;

            //the metrics for this text layout
            this._width = maxLineWidth;
            this._height = height;
            this._descender = lineHeight - baseline;
            this._baseline = baseline;
            this._xHeight = getXHeight(font);
            this._capHeight = getCapHeight(font);
            this._lineHeight = lineHeight;
            this._ascender = lineHeight - descender - this._xHeight;

            //layout each glyph
            var self = this;
            lines.forEach(function (line, lineIndex) {
              var start = line.start;
              var end = line.end;
              var lineWidth = line.width;
              var lastGlyph;

              //for each glyph in that line...
              for (var i = start; i < end; i++) {
                var id = text.charCodeAt(i);
                var glyph = self.getGlyph(font, id);
                if (glyph) {
                  if (lastGlyph) x += getKerning(font, lastGlyph.id, glyph.id);
                  var tx = x;
                  if (align === ALIGN_CENTER) tx += (maxLineWidth - lineWidth) / 2;else if (align === ALIGN_RIGHT) tx += maxLineWidth - lineWidth;
                  glyphs.push({
                    position: [tx, y],
                    data: glyph,
                    index: i,
                    line: lineIndex
                  });

                  //move pen forward
                  x += glyph.xadvance + letterSpacing;
                  lastGlyph = glyph;
                }
              }

              //next line down
              y += lineHeight;
              x = 0;
            });
            this._linesTotal = lines.length;
          };
          TextLayout.prototype._setupSpaceGlyphs = function (font) {
            //These are fallbacks, when the font doesn't include
            //' ' or '\t' glyphs
            this._fallbackSpaceGlyph = null;
            this._fallbackTabGlyph = null;
            if (!font.chars || font.chars.length === 0) return;

            //try to get space glyph
            //then fall back to the 'm' or 'w' glyphs
            //then fall back to the first glyph available
            var space = getGlyphById(font, SPACE_ID) || getMGlyph(font) || font.chars[0];

            //and create a fallback for tab
            var tabWidth = this._opt.tabSize * space.xadvance;
            this._fallbackSpaceGlyph = space;
            this._fallbackTabGlyph = xtend(space, {
              x: 0,
              y: 0,
              xadvance: tabWidth,
              id: TAB_ID,
              xoffset: 0,
              yoffset: 0,
              width: 0,
              height: 0
            });
          };
          TextLayout.prototype.getGlyph = function (font, id) {
            var glyph = getGlyphById(font, id);
            if (glyph) return glyph;else if (id === TAB_ID) return this._fallbackTabGlyph;else if (id === SPACE_ID) return this._fallbackSpaceGlyph;
            return null;
          };
          TextLayout.prototype.computeMetrics = function (text, start, end, width) {
            var letterSpacing = this._opt.letterSpacing || 0;
            var font = this._opt.font;
            var curPen = 0;
            var curWidth = 0;
            var count = 0;
            var glyph;
            var lastGlyph;
            if (!font.chars || font.chars.length === 0) {
              return {
                start: start,
                end: start,
                width: 0
              };
            }
            end = Math.min(text.length, end);
            for (var i = start; i < end; i++) {
              var id = text.charCodeAt(i);
              var glyph = this.getGlyph(font, id);
              if (glyph) {
                //move pen forward
                var xoff = glyph.xoffset;
                var kern = lastGlyph ? getKerning(font, lastGlyph.id, glyph.id) : 0;
                curPen += kern;
                var nextPen = curPen + glyph.xadvance + letterSpacing;
                var nextWidth = curPen + glyph.width;

                //we've hit our limit; we can't move onto the next glyph
                if (nextWidth >= width || nextPen >= width) break;

                //otherwise continue along our line
                curPen = nextPen;
                curWidth = nextWidth;
                lastGlyph = glyph;
              }
              count++;
            }

            //make sure rightmost edge lines up with rendered glyphs
            if (lastGlyph) curWidth += lastGlyph.xoffset;
            return {
              start: start,
              end: start + count,
              width: curWidth
            };
          }

          //getters for the private vars
          ;

          ['width', 'height', 'descender', 'ascender', 'xHeight', 'baseline', 'capHeight', 'lineHeight'].forEach(addGetter);
          function addGetter(name) {
            Object.defineProperty(TextLayout.prototype, name, {
              get: wrapper(name),
              configurable: true
            });
          }

          //create lookups for private vars
          function wrapper(name) {
            return new Function(['return function ' + name + '() {', '  return this._' + name, '}'].join('\n'))();
          }
          function getGlyphById(font, id) {
            if (!font.chars || font.chars.length === 0) return null;
            var glyphIdx = findChar(font.chars, id);
            if (glyphIdx >= 0) return font.chars[glyphIdx];
            return null;
          }
          function getXHeight(font) {
            for (var i = 0; i < X_HEIGHTS.length; i++) {
              var id = X_HEIGHTS[i].charCodeAt(0);
              var idx = findChar(font.chars, id);
              if (idx >= 0) return font.chars[idx].height;
            }
            return 0;
          }
          function getMGlyph(font) {
            for (var i = 0; i < M_WIDTHS.length; i++) {
              var id = M_WIDTHS[i].charCodeAt(0);
              var idx = findChar(font.chars, id);
              if (idx >= 0) return font.chars[idx];
            }
            return 0;
          }
          function getCapHeight(font) {
            for (var i = 0; i < CAP_HEIGHTS.length; i++) {
              var id = CAP_HEIGHTS[i].charCodeAt(0);
              var idx = findChar(font.chars, id);
              if (idx >= 0) return font.chars[idx].height;
            }
            return 0;
          }
          function getKerning(font, left, right) {
            if (!font.kernings || font.kernings.length === 0) return 0;
            var table = font.kernings;
            for (var i = 0; i < table.length; i++) {
              var kern = table[i];
              if (kern.first === left && kern.second === right) return kern.amount;
            }
            return 0;
          }
          function getAlignType(align) {
            if (align === 'center') return ALIGN_CENTER;else if (align === 'right') return ALIGN_RIGHT;
            return ALIGN_LEFT;
          }
          function findChar(array, value, start) {
            start = start || 0;
            for (var i = start; i < array.length; i++) {
              if (array[i].id === value) {
                return i;
              }
            }
            return -1;
          }

          /***/
        },

        /***/"./node_modules/load-bmfont/browser.js":
        /*!*********************************************!*\
          !*** ./node_modules/load-bmfont/browser.js ***!
          \*********************************************/
        /***/
        function node_modulesLoadBmfontBrowserJs(module, __unused_webpack_exports, __webpack_require__) {
          /* provided dependency */var Buffer = __webpack_require__( /*! buffer */"./node_modules/buffer/index.js")["Buffer"];
          var xhr = __webpack_require__( /*! xhr */"./node_modules/xhr/index.js");
          var noop = function noop() {};
          var parseASCII = __webpack_require__( /*! parse-bmfont-ascii */"./node_modules/parse-bmfont-ascii/index.js");
          var parseXML = __webpack_require__( /*! parse-bmfont-xml */"./node_modules/parse-bmfont-xml/lib/browser.js");
          var readBinary = __webpack_require__( /*! parse-bmfont-binary */"./node_modules/parse-bmfont-binary/index.js");
          var isBinaryFormat = __webpack_require__( /*! ./lib/is-binary */"./node_modules/load-bmfont/lib/is-binary.js");
          var xtend = __webpack_require__( /*! xtend */"./node_modules/xtend/immutable.js");
          var xml2 = function hasXML2() {
            return self.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
          }();
          module.exports = function (opt, cb) {
            cb = typeof cb === 'function' ? cb : noop;
            if (typeof opt === 'string') opt = {
              uri: opt
            };else if (!opt) opt = {};
            var expectBinary = opt.binary;
            if (expectBinary) opt = getBinaryOpts(opt);
            xhr(opt, function (err, res, body) {
              if (err) return cb(err);
              if (!/^2/.test(res.statusCode)) return cb(new Error('http status code: ' + res.statusCode));
              if (!body) return cb(new Error('no body result'));
              var binary = false;

              //if the response type is an array buffer,
              //we need to convert it into a regular Buffer object
              if (isArrayBuffer(body)) {
                var array = new Uint8Array(body);
                body = Buffer.from(array, 'binary');
              }

              //now check the string/Buffer response
              //and see if it has a binary BMF header
              if (isBinaryFormat(body)) {
                binary = true;
                //if we have a string, turn it into a Buffer
                if (typeof body === 'string') body = Buffer.from(body, 'binary');
              }

              //we are not parsing a binary format, just ASCII/XML/etc
              if (!binary) {
                //might still be a buffer if responseType is 'arraybuffer'
                if (Buffer.isBuffer(body)) body = body.toString(opt.encoding);
                body = body.trim();
              }
              var result;
              try {
                var type = res.headers['content-type'];
                if (binary) result = readBinary(body);else if (/json/.test(type) || body.charAt(0) === '{') result = JSON.parse(body);else if (/xml/.test(type) || body.charAt(0) === '<') result = parseXML(body);else result = parseASCII(body);
              } catch (e) {
                cb(new Error('error parsing font ' + e.message));
                cb = noop;
              }
              cb(null, result);
            });
          };
          function isArrayBuffer(arr) {
            var str = Object.prototype.toString;
            return str.call(arr) === '[object ArrayBuffer]';
          }
          function getBinaryOpts(opt) {
            //IE10+ and other modern browsers support array buffers
            if (xml2) return xtend(opt, {
              responseType: 'arraybuffer'
            });
            if (typeof self.XMLHttpRequest === 'undefined') throw new Error('your browser does not support XHR loading');

            //IE9 and XML1 browsers could still use an override
            var req = new self.XMLHttpRequest();
            req.overrideMimeType('text/plain; charset=x-user-defined');
            return xtend({
              xhr: req
            }, opt);
          }

          /***/
        },

        /***/"./node_modules/load-bmfont/lib/is-binary.js":
        /*!***************************************************!*\
          !*** ./node_modules/load-bmfont/lib/is-binary.js ***!
          \***************************************************/
        /***/
        function node_modulesLoadBmfontLibIsBinaryJs(module, __unused_webpack_exports, __webpack_require__) {
          /* provided dependency */var Buffer = __webpack_require__( /*! buffer */"./node_modules/buffer/index.js")["Buffer"];
          var equal = __webpack_require__( /*! buffer-equal */"./node_modules/buffer-equal/index.js");
          var HEADER = Buffer.from([66, 77, 70, 3]);
          module.exports = function (buf) {
            if (typeof buf === 'string') return buf.substring(0, 3) === 'BMF';
            return buf.length > 4 && equal(buf.slice(0, 4), HEADER);
          };

          /***/
        },

        /***/"./node_modules/object-assign/index.js":
        /*!*********************************************!*\
          !*** ./node_modules/object-assign/index.js ***!
          \*********************************************/
        /***/
        function node_modulesObjectAssignIndexJs(module) {
          "use strict";

          /*
          object-assign
          (c) Sindre Sorhus
          @license MIT
          */

          /* eslint-disable no-unused-vars */
          var getOwnPropertySymbols = Object.getOwnPropertySymbols;
          var hasOwnProperty = Object.prototype.hasOwnProperty;
          var propIsEnumerable = Object.prototype.propertyIsEnumerable;
          function toObject(val) {
            if (val === null || val === undefined) {
              throw new TypeError('Object.assign cannot be called with null or undefined');
            }
            return Object(val);
          }
          function shouldUseNative() {
            try {
              if (!Object.assign) {
                return false;
              }

              // Detect buggy property enumeration order in older V8 versions.

              // https://bugs.chromium.org/p/v8/issues/detail?id=4118
              var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
              test1[5] = 'de';
              if (Object.getOwnPropertyNames(test1)[0] === '5') {
                return false;
              }

              // https://bugs.chromium.org/p/v8/issues/detail?id=3056
              var test2 = {};
              for (var i = 0; i < 10; i++) {
                test2['_' + String.fromCharCode(i)] = i;
              }
              var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                return test2[n];
              });
              if (order2.join('') !== '0123456789') {
                return false;
              }

              // https://bugs.chromium.org/p/v8/issues/detail?id=3056
              var test3 = {};
              'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                test3[letter] = letter;
              });
              if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
                return false;
              }
              return true;
            } catch (err) {
              // We don't expect any of the above to throw, but better to be safe.
              return false;
            }
          }
          module.exports = shouldUseNative() ? Object.assign : function (target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for (var s = 1; s < arguments.length; s++) {
              from = Object(arguments[s]);
              for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                  to[key] = from[key];
                }
              }
              if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (var i = 0; i < symbols.length; i++) {
                  if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                  }
                }
              }
            }
            return to;
          };

          /***/
        },

        /***/"./node_modules/parse-bmfont-ascii/index.js":
        /*!**************************************************!*\
          !*** ./node_modules/parse-bmfont-ascii/index.js ***!
          \**************************************************/
        /***/
        function node_modulesParseBmfontAsciiIndexJs(module) {
          module.exports = function parseBMFontAscii(data) {
            if (!data) throw new Error('no data provided');
            data = data.toString().trim();
            var output = {
              pages: [],
              chars: [],
              kernings: []
            };
            var lines = data.split(/\r\n?|\n/g);
            if (lines.length === 0) throw new Error('no data in BMFont file');
            for (var i = 0; i < lines.length; i++) {
              var lineData = splitLine(lines[i], i);
              if (!lineData)
                //skip empty lines
                continue;
              if (lineData.key === 'page') {
                if (typeof lineData.data.id !== 'number') throw new Error('malformed file at line ' + i + ' -- needs page id=N');
                if (typeof lineData.data.file !== 'string') throw new Error('malformed file at line ' + i + ' -- needs page file="path"');
                output.pages[lineData.data.id] = lineData.data.file;
              } else if (lineData.key === 'chars' || lineData.key === 'kernings') {
                //... do nothing for these two ...
              } else if (lineData.key === 'char') {
                output.chars.push(lineData.data);
              } else if (lineData.key === 'kerning') {
                output.kernings.push(lineData.data);
              } else {
                output[lineData.key] = lineData.data;
              }
            }
            return output;
          };
          function splitLine(line, idx) {
            line = line.replace(/\t+/g, ' ').trim();
            if (!line) return null;
            var space = line.indexOf(' ');
            if (space === -1) throw new Error("no named row at line " + idx);
            var key = line.substring(0, space);
            line = line.substring(space + 1);
            //clear "letter" field as it is non-standard and
            //requires additional complexity to parse " / = symbols
            line = line.replace(/letter=[\'\"]\S+[\'\"]/gi, '');
            line = line.split("=");
            line = line.map(function (str) {
              return str.trim().match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);
            });
            var data = [];
            for (var i = 0; i < line.length; i++) {
              var dt = line[i];
              if (i === 0) {
                data.push({
                  key: dt[0],
                  data: ""
                });
              } else if (i === line.length - 1) {
                data[data.length - 1].data = parseData(dt[0]);
              } else {
                data[data.length - 1].data = parseData(dt[0]);
                data.push({
                  key: dt[1],
                  data: ""
                });
              }
            }
            var out = {
              key: key,
              data: {}
            };
            data.forEach(function (v) {
              out.data[v.key] = v.data;
            });
            return out;
          }
          function parseData(data) {
            if (!data || data.length === 0) return "";
            if (data.indexOf('"') === 0 || data.indexOf("'") === 0) return data.substring(1, data.length - 1);
            if (data.indexOf(',') !== -1) return parseIntList(data);
            return parseInt(data, 10);
          }
          function parseIntList(data) {
            return data.split(',').map(function (val) {
              return parseInt(val, 10);
            });
          }

          /***/
        },

        /***/"./node_modules/parse-bmfont-binary/index.js":
        /*!***************************************************!*\
          !*** ./node_modules/parse-bmfont-binary/index.js ***!
          \***************************************************/
        /***/
        function node_modulesParseBmfontBinaryIndexJs(module) {
          var HEADER = [66, 77, 70];
          module.exports = function readBMFontBinary(buf) {
            if (buf.length < 6) throw new Error('invalid buffer length for BMFont');
            var header = HEADER.every(function (byte, i) {
              return buf.readUInt8(i) === byte;
            });
            if (!header) throw new Error('BMFont missing BMF byte header');
            var i = 3;
            var vers = buf.readUInt8(i++);
            if (vers > 3) throw new Error('Only supports BMFont Binary v3 (BMFont App v1.10)');
            var target = {
              kernings: [],
              chars: []
            };
            for (var b = 0; b < 5; b++) i += readBlock(target, buf, i);
            return target;
          };
          function readBlock(target, buf, i) {
            if (i > buf.length - 1) return 0;
            var blockID = buf.readUInt8(i++);
            var blockSize = buf.readInt32LE(i);
            i += 4;
            switch (blockID) {
              case 1:
                target.info = readInfo(buf, i);
                break;
              case 2:
                target.common = readCommon(buf, i);
                break;
              case 3:
                target.pages = readPages(buf, i, blockSize);
                break;
              case 4:
                target.chars = readChars(buf, i, blockSize);
                break;
              case 5:
                target.kernings = readKernings(buf, i, blockSize);
                break;
            }
            return 5 + blockSize;
          }
          function readInfo(buf, i) {
            var info = {};
            info.size = buf.readInt16LE(i);
            var bitField = buf.readUInt8(i + 2);
            info.smooth = bitField >> 7 & 1;
            info.unicode = bitField >> 6 & 1;
            info.italic = bitField >> 5 & 1;
            info.bold = bitField >> 4 & 1;

            //fixedHeight is only mentioned in binary spec 
            if (bitField >> 3 & 1) info.fixedHeight = 1;
            info.charset = buf.readUInt8(i + 3) || '';
            info.stretchH = buf.readUInt16LE(i + 4);
            info.aa = buf.readUInt8(i + 6);
            info.padding = [buf.readInt8(i + 7), buf.readInt8(i + 8), buf.readInt8(i + 9), buf.readInt8(i + 10)];
            info.spacing = [buf.readInt8(i + 11), buf.readInt8(i + 12)];
            info.outline = buf.readUInt8(i + 13);
            info.face = readStringNT(buf, i + 14);
            return info;
          }
          function readCommon(buf, i) {
            var common = {};
            common.lineHeight = buf.readUInt16LE(i);
            common.base = buf.readUInt16LE(i + 2);
            common.scaleW = buf.readUInt16LE(i + 4);
            common.scaleH = buf.readUInt16LE(i + 6);
            common.pages = buf.readUInt16LE(i + 8);
            var bitField = buf.readUInt8(i + 10);
            common.packed = 0;
            common.alphaChnl = buf.readUInt8(i + 11);
            common.redChnl = buf.readUInt8(i + 12);
            common.greenChnl = buf.readUInt8(i + 13);
            common.blueChnl = buf.readUInt8(i + 14);
            return common;
          }
          function readPages(buf, i, size) {
            var pages = [];
            var text = readNameNT(buf, i);
            var len = text.length + 1;
            var count = size / len;
            for (var c = 0; c < count; c++) {
              pages[c] = buf.slice(i, i + text.length).toString('utf8');
              i += len;
            }
            return pages;
          }
          function readChars(buf, i, blockSize) {
            var chars = [];
            var count = blockSize / 20;
            for (var c = 0; c < count; c++) {
              var char = {};
              var off = c * 20;
              char.id = buf.readUInt32LE(i + 0 + off);
              char.x = buf.readUInt16LE(i + 4 + off);
              char.y = buf.readUInt16LE(i + 6 + off);
              char.width = buf.readUInt16LE(i + 8 + off);
              char.height = buf.readUInt16LE(i + 10 + off);
              char.xoffset = buf.readInt16LE(i + 12 + off);
              char.yoffset = buf.readInt16LE(i + 14 + off);
              char.xadvance = buf.readInt16LE(i + 16 + off);
              char.page = buf.readUInt8(i + 18 + off);
              char.chnl = buf.readUInt8(i + 19 + off);
              chars[c] = char;
            }
            return chars;
          }
          function readKernings(buf, i, blockSize) {
            var kernings = [];
            var count = blockSize / 10;
            for (var c = 0; c < count; c++) {
              var kern = {};
              var off = c * 10;
              kern.first = buf.readUInt32LE(i + 0 + off);
              kern.second = buf.readUInt32LE(i + 4 + off);
              kern.amount = buf.readInt16LE(i + 8 + off);
              kernings[c] = kern;
            }
            return kernings;
          }
          function readNameNT(buf, offset) {
            var pos = offset;
            for (; pos < buf.length; pos++) {
              if (buf[pos] === 0x00) break;
            }
            return buf.slice(offset, pos);
          }
          function readStringNT(buf, offset) {
            return readNameNT(buf, offset).toString('utf8');
          }

          /***/
        },

        /***/"./node_modules/parse-bmfont-xml/lib/browser.js":
        /*!******************************************************!*\
          !*** ./node_modules/parse-bmfont-xml/lib/browser.js ***!
          \******************************************************/
        /***/
        function node_modulesParseBmfontXmlLibBrowserJs(module, __unused_webpack_exports, __webpack_require__) {
          var parseAttributes = __webpack_require__( /*! ./parse-attribs */"./node_modules/parse-bmfont-xml/lib/parse-attribs.js");
          var parseFromString = __webpack_require__( /*! xml-parse-from-string */"./node_modules/xml-parse-from-string/index.js");

          //In some cases element.attribute.nodeName can return
          //all lowercase values.. so we need to map them to the correct 
          //case
          var NAME_MAP = {
            scaleh: 'scaleH',
            scalew: 'scaleW',
            stretchh: 'stretchH',
            lineheight: 'lineHeight',
            alphachnl: 'alphaChnl',
            redchnl: 'redChnl',
            greenchnl: 'greenChnl',
            bluechnl: 'blueChnl'
          };
          module.exports = function parse(data) {
            data = data.toString();
            var xmlRoot = parseFromString(data);
            var output = {
              pages: [],
              chars: [],
              kernings: []
            }

            //get config settings
            ;

            ['info', 'common'].forEach(function (key) {
              var element = xmlRoot.getElementsByTagName(key)[0];
              if (element) output[key] = parseAttributes(getAttribs(element));
            });

            //get page info
            var pageRoot = xmlRoot.getElementsByTagName('pages')[0];
            if (!pageRoot) throw new Error('malformed file -- no <pages> element');
            var pages = pageRoot.getElementsByTagName('page');
            for (var i = 0; i < pages.length; i++) {
              var p = pages[i];
              var id = parseInt(p.getAttribute('id'), 10);
              var file = p.getAttribute('file');
              if (isNaN(id)) throw new Error('malformed file -- page "id" attribute is NaN');
              if (!file) throw new Error('malformed file -- needs page "file" attribute');
              output.pages[parseInt(id, 10)] = file;
            }

            //get kernings / chars
            ;
            ['chars', 'kernings'].forEach(function (key) {
              var element = xmlRoot.getElementsByTagName(key)[0];
              if (!element) return;
              var childTag = key.substring(0, key.length - 1);
              var children = element.getElementsByTagName(childTag);
              for (var i = 0; i < children.length; i++) {
                var child = children[i];
                output[key].push(parseAttributes(getAttribs(child)));
              }
            });
            return output;
          };
          function getAttribs(element) {
            var attribs = getAttribList(element);
            return attribs.reduce(function (dict, attrib) {
              var key = mapName(attrib.nodeName);
              dict[key] = attrib.nodeValue;
              return dict;
            }, {});
          }
          function getAttribList(element) {
            //IE8+ and modern browsers
            var attribs = [];
            for (var i = 0; i < element.attributes.length; i++) attribs.push(element.attributes[i]);
            return attribs;
          }
          function mapName(nodeName) {
            return NAME_MAP[nodeName.toLowerCase()] || nodeName;
          }

          /***/
        },

        /***/"./node_modules/parse-bmfont-xml/lib/parse-attribs.js":
        /*!************************************************************!*\
          !*** ./node_modules/parse-bmfont-xml/lib/parse-attribs.js ***!
          \************************************************************/
        /***/
        function node_modulesParseBmfontXmlLibParseAttribsJs(module) {
          //Some versions of GlyphDesigner have a typo
          //that causes some bugs with parsing. 
          //Need to confirm with recent version of the software
          //to see whether this is still an issue or not.
          var GLYPH_DESIGNER_ERROR = 'chasrset';
          module.exports = function parseAttributes(obj) {
            if (GLYPH_DESIGNER_ERROR in obj) {
              obj['charset'] = obj[GLYPH_DESIGNER_ERROR];
              delete obj[GLYPH_DESIGNER_ERROR];
            }
            for (var k in obj) {
              if (k === 'face' || k === 'charset') continue;else if (k === 'padding' || k === 'spacing') obj[k] = parseIntList(obj[k]);else obj[k] = parseInt(obj[k], 10);
            }
            return obj;
          };
          function parseIntList(data) {
            return data.split(',').map(function (val) {
              return parseInt(val, 10);
            });
          }

          /***/
        },

        /***/"./node_modules/parse-headers/parse-headers.js":
        /*!*****************************************************!*\
          !*** ./node_modules/parse-headers/parse-headers.js ***!
          \*****************************************************/
        /***/
        function node_modulesParseHeadersParseHeadersJs(module) {
          var trim = function trim(string) {
              return string.replace(/^\s+|\s+$/g, '');
            },
            isArray = function isArray(arg) {
              return Object.prototype.toString.call(arg) === '[object Array]';
            };
          module.exports = function (headers) {
            if (!headers) return {};
            var result = {};
            var headersArr = trim(headers).split('\n');
            for (var i = 0; i < headersArr.length; i++) {
              var row = headersArr[i];
              var index = row.indexOf(':'),
                key = trim(row.slice(0, index)).toLowerCase(),
                value = trim(row.slice(index + 1));
              if (typeof result[key] === 'undefined') {
                result[key] = value;
              } else if (isArray(result[key])) {
                result[key].push(value);
              } else {
                result[key] = [result[key], value];
              }
            }
            return result;
          };

          /***/
        },

        /***/"./node_modules/present/lib/present-browser.js":
        /*!*****************************************************!*\
          !*** ./node_modules/present/lib/present-browser.js ***!
          \*****************************************************/
        /***/
        function node_modulesPresentLibPresentBrowserJs(module, __unused_webpack_exports, __webpack_require__) {
          var performance = __webpack_require__.g.performance || {};
          var present = function () {
            var names = ['now', 'webkitNow', 'msNow', 'mozNow', 'oNow'];
            while (names.length) {
              var name = names.shift();
              if (name in performance) {
                return performance[name].bind(performance);
              }
            }
            var dateNow = Date.now || function () {
              return new Date().getTime();
            };
            var navigationStart = (performance.timing || {}).navigationStart || dateNow();
            return function () {
              return dateNow() - navigationStart;
            };
          }();
          present.performanceNow = performance.now;
          present.noConflict = function () {
            performance.now = present.performanceNow;
          };
          present.conflict = function () {
            performance.now = present;
          };
          present.conflict();
          module.exports = present;

          /***/
        },

        /***/"./node_modules/process/browser.js":
        /*!*****************************************!*\
          !*** ./node_modules/process/browser.js ***!
          \*****************************************/
        /***/
        function node_modulesProcessBrowserJs(module) {
          // shim for using process in browser
          var process = module.exports = {};

          // cached from whatever global is present so that test runners that stub it
          // don't break things.  But we need to wrap it in a try catch in case it is
          // wrapped in strict mode code which doesn't define any globals.  It's inside a
          // function because try/catches deoptimize in certain engines.

          var cachedSetTimeout;
          var cachedClearTimeout;
          function defaultSetTimout() {
            throw new Error('setTimeout has not been defined');
          }
          function defaultClearTimeout() {
            throw new Error('clearTimeout has not been defined');
          }
          (function () {
            try {
              if (typeof setTimeout === 'function') {
                cachedSetTimeout = setTimeout;
              } else {
                cachedSetTimeout = defaultSetTimout;
              }
            } catch (e) {
              cachedSetTimeout = defaultSetTimout;
            }
            try {
              if (typeof clearTimeout === 'function') {
                cachedClearTimeout = clearTimeout;
              } else {
                cachedClearTimeout = defaultClearTimeout;
              }
            } catch (e) {
              cachedClearTimeout = defaultClearTimeout;
            }
          })();
          function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) {
              //normal enviroments in sane situations
              return setTimeout(fun, 0);
            }
            // if setTimeout wasn't available but was latter defined
            if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
              cachedSetTimeout = setTimeout;
              return setTimeout(fun, 0);
            }
            try {
              // when when somebody has screwed with setTimeout but no I.E. maddness
              return cachedSetTimeout(fun, 0);
            } catch (e) {
              try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
              } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
              }
            }
          }
          function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) {
              //normal enviroments in sane situations
              return clearTimeout(marker);
            }
            // if clearTimeout wasn't available but was latter defined
            if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
              cachedClearTimeout = clearTimeout;
              return clearTimeout(marker);
            }
            try {
              // when when somebody has screwed with setTimeout but no I.E. maddness
              return cachedClearTimeout(marker);
            } catch (e) {
              try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
              } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
              }
            }
          }
          var queue = [];
          var draining = false;
          var currentQueue;
          var queueIndex = -1;
          function cleanUpNextTick() {
            if (!draining || !currentQueue) {
              return;
            }
            draining = false;
            if (currentQueue.length) {
              queue = currentQueue.concat(queue);
            } else {
              queueIndex = -1;
            }
            if (queue.length) {
              drainQueue();
            }
          }
          function drainQueue() {
            if (draining) {
              return;
            }
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;
            var len = queue.length;
            while (len) {
              currentQueue = queue;
              queue = [];
              while (++queueIndex < len) {
                if (currentQueue) {
                  currentQueue[queueIndex].run();
                }
              }
              queueIndex = -1;
              len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
          }
          process.nextTick = function (fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) {
              for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
              }
            }
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) {
              runTimeout(drainQueue);
            }
          };

          // v8 likes predictible objects
          function Item(fun, array) {
            this.fun = fun;
            this.array = array;
          }
          Item.prototype.run = function () {
            this.fun.apply(null, this.array);
          };
          process.title = 'browser';
          process.browser = true;
          process.env = {};
          process.argv = [];
          process.version = ''; // empty string to avoid regexp issues
          process.versions = {};
          function noop() {}
          process.on = noop;
          process.addListener = noop;
          process.once = noop;
          process.off = noop;
          process.removeListener = noop;
          process.removeAllListeners = noop;
          process.emit = noop;
          process.prependListener = noop;
          process.prependOnceListener = noop;
          process.listeners = function (name) {
            return [];
          };
          process.binding = function (name) {
            throw new Error('process.binding is not supported');
          };
          process.cwd = function () {
            return '/';
          };
          process.chdir = function (dir) {
            throw new Error('process.chdir is not supported');
          };
          process.umask = function () {
            return 0;
          };

          /***/
        },

        /***/"./node_modules/promise-polyfill/Promise.js":
        /*!**************************************************!*\
          !*** ./node_modules/promise-polyfill/Promise.js ***!
          \**************************************************/
        /***/
        function node_modulesPromisePolyfillPromiseJs(module) {
          (function (root) {
            // Store setTimeout reference so promise-polyfill will be unaffected by
            // other code modifying setTimeout (like sinon.useFakeTimers())
            var setTimeoutFunc = setTimeout;

            // Use polyfill for setImmediate for performance gains
            var asap = typeof setImmediate === 'function' && setImmediate || function (fn) {
              setTimeoutFunc(fn, 1);
            };

            // Polyfill for Function.prototype.bind
            function bind(fn, thisArg) {
              return function () {
                fn.apply(thisArg, arguments);
              };
            }
            var isArray = Array.isArray || function (value) {
              return Object.prototype.toString.call(value) === "[object Array]";
            };
            function Promise(fn) {
              if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
              if (typeof fn !== 'function') throw new TypeError('not a function');
              this._state = null;
              this._value = null;
              this._deferreds = [];
              doResolve(fn, bind(resolve, this), bind(reject, this));
            }
            function handle(deferred) {
              var me = this;
              if (this._state === null) {
                this._deferreds.push(deferred);
                return;
              }
              asap(function () {
                var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
                if (cb === null) {
                  (me._state ? deferred.resolve : deferred.reject)(me._value);
                  return;
                }
                var ret;
                try {
                  ret = cb(me._value);
                } catch (e) {
                  deferred.reject(e);
                  return;
                }
                deferred.resolve(ret);
              });
            }
            function resolve(newValue) {
              try {
                //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
                if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
                if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
                  var then = newValue.then;
                  if (typeof then === 'function') {
                    doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
                    return;
                  }
                }
                this._state = true;
                this._value = newValue;
                finale.call(this);
              } catch (e) {
                reject.call(this, e);
              }
            }
            function reject(newValue) {
              this._state = false;
              this._value = newValue;
              finale.call(this);
            }
            function finale() {
              for (var i = 0, len = this._deferreds.length; i < len; i++) {
                handle.call(this, this._deferreds[i]);
              }
              this._deferreds = null;
            }
            function Handler(onFulfilled, onRejected, resolve, reject) {
              this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
              this.onRejected = typeof onRejected === 'function' ? onRejected : null;
              this.resolve = resolve;
              this.reject = reject;
            }

            /**
             * Take a potentially misbehaving resolver function and make sure
             * onFulfilled and onRejected are only called once.
             *
             * Makes no guarantees about asynchrony.
             */
            function doResolve(fn, onFulfilled, onRejected) {
              var done = false;
              try {
                fn(function (value) {
                  if (done) return;
                  done = true;
                  onFulfilled(value);
                }, function (reason) {
                  if (done) return;
                  done = true;
                  onRejected(reason);
                });
              } catch (ex) {
                if (done) return;
                done = true;
                onRejected(ex);
              }
            }
            Promise.prototype['catch'] = function (onRejected) {
              return this.then(null, onRejected);
            };
            Promise.prototype.then = function (onFulfilled, onRejected) {
              var me = this;
              return new Promise(function (resolve, reject) {
                handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
              });
            };
            Promise.all = function () {
              var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
              return new Promise(function (resolve, reject) {
                if (args.length === 0) return resolve([]);
                var remaining = args.length;
                function res(i, val) {
                  try {
                    if (val && (typeof val === 'object' || typeof val === 'function')) {
                      var then = val.then;
                      if (typeof then === 'function') {
                        then.call(val, function (val) {
                          res(i, val);
                        }, reject);
                        return;
                      }
                    }
                    args[i] = val;
                    if (--remaining === 0) {
                      resolve(args);
                    }
                  } catch (ex) {
                    reject(ex);
                  }
                }
                for (var i = 0; i < args.length; i++) {
                  res(i, args[i]);
                }
              });
            };
            Promise.resolve = function (value) {
              if (value && typeof value === 'object' && value.constructor === Promise) {
                return value;
              }
              return new Promise(function (resolve) {
                resolve(value);
              });
            };
            Promise.reject = function (value) {
              return new Promise(function (resolve, reject) {
                reject(value);
              });
            };
            Promise.race = function (values) {
              return new Promise(function (resolve, reject) {
                for (var i = 0, len = values.length; i < len; i++) {
                  values[i].then(resolve, reject);
                }
              });
            };

            /**
             * Set the immediate function to execute callbacks
             * @param fn {function} Function to execute
             * @private
             */
            Promise._setImmediateFn = function _setImmediateFn(fn) {
              asap = fn;
            };
            if (true && module.exports) {
              module.exports = Promise;
            } else if (!root.Promise) {
              root.Promise = Promise;
            }
          })(this);

          /***/
        },

        /***/"./node_modules/quad-indices/index.js":
        /*!********************************************!*\
          !*** ./node_modules/quad-indices/index.js ***!
          \********************************************/
        /***/
        function node_modulesQuadIndicesIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          var dtype = __webpack_require__( /*! dtype */"./node_modules/dtype/index.js");
          var anArray = __webpack_require__( /*! an-array */"./node_modules/an-array/index.js");
          var isBuffer = __webpack_require__( /*! is-buffer */"./node_modules/is-buffer/index.js");
          var CW = [0, 2, 3];
          var CCW = [2, 1, 3];
          module.exports = function createQuadElements(array, opt) {
            //if user didn't specify an output array
            if (!array || !(anArray(array) || isBuffer(array))) {
              opt = array || {};
              array = null;
            }
            if (typeof opt === 'number')
              //backwards-compatible
              opt = {
                count: opt
              };else opt = opt || {};
            var type = typeof opt.type === 'string' ? opt.type : 'uint16';
            var count = typeof opt.count === 'number' ? opt.count : 1;
            var start = opt.start || 0;
            var dir = opt.clockwise !== false ? CW : CCW,
              a = dir[0],
              b = dir[1],
              c = dir[2];
            var numIndices = count * 6;
            var indices = array || new (dtype(type))(numIndices);
            for (var i = 0, j = 0; i < numIndices; i += 6, j += 4) {
              var x = i + start;
              indices[x + 0] = j + 0;
              indices[x + 1] = j + 1;
              indices[x + 2] = j + 2;
              indices[x + 3] = j + a;
              indices[x + 4] = j + b;
              indices[x + 5] = j + c;
            }
            return indices;
          };

          /***/
        },

        /***/"./node_modules/super-animejs/lib/anime.es.js":
        /*!****************************************************!*\
          !*** ./node_modules/super-animejs/lib/anime.es.js ***!
          \****************************************************/
        /***/
        function node_modulesSuperAnimejsLibAnimeEsJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"default": function _default() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */
          });
          /*
           * anime.js v3.0.0
           * (c) 2019 Julian Garnier
           * Released under the MIT license
           * animejs.com
           */

          // Defaults

          var defaultInstanceSettings = {
            update: null,
            begin: null,
            loopBegin: null,
            changeBegin: null,
            change: null,
            changeComplete: null,
            loopComplete: null,
            complete: null,
            loop: 1,
            direction: 'normal',
            autoplay: true,
            timelineOffset: 0
          };
          var defaultTweenSettings = {
            duration: 1000,
            delay: 0,
            endDelay: 0,
            easing: 'easeOutElastic(1, .5)',
            round: 0
          };
          var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skew', 'skewX', 'skewY', 'perspective'];

          // Caching

          var cache = {
            CSS: {},
            springs: {}
          };

          // Utils

          function minMax(val, min, max) {
            return Math.min(Math.max(val, min), max);
          }
          function stringContains(str, text) {
            return str.indexOf(text) > -1;
          }
          function applyArguments(func, args) {
            return func.apply(null, args);
          }
          var hexRegex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
          var rgbPrefixRegex = /^rgb/;
          var hslRegex = /^hsl/;
          var is = {
            arr: function arr(a) {
              return Array.isArray(a);
            },
            obj: function obj(a) {
              return stringContains(Object.prototype.toString.call(a), 'Object');
            },
            pth: function pth(a) {
              return is.obj(a) && a.hasOwnProperty('totalLength');
            },
            svg: function svg(a) {
              return a instanceof SVGElement;
            },
            inp: function inp(a) {
              return a instanceof HTMLInputElement;
            },
            dom: function dom(a) {
              return a.nodeType || is.svg(a);
            },
            str: function str(a) {
              return typeof a === 'string';
            },
            fnc: function fnc(a) {
              return typeof a === 'function';
            },
            und: function und(a) {
              return typeof a === 'undefined';
            },
            hex: function hex(a) {
              return hexRegex.test(a);
            },
            rgb: function rgb(a) {
              return rgbPrefixRegex.test(a);
            },
            hsl: function hsl(a) {
              return hslRegex.test(a);
            },
            col: function col(a) {
              return is.hex(a) || is.rgb(a) || is.hsl(a);
            },
            key: function key(a) {
              return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes';
            }
          };

          // Easings

          var easingFunctionRegex = /\(([^)]+)\)/;
          function parseEasingParameters(string) {
            var match = easingFunctionRegex.exec(string);
            return match ? match[1].split(',').map(function (p) {
              return parseFloat(p);
            }) : [];
          }

          // Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js

          function spring(string, duration) {
            var params = parseEasingParameters(string);
            var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
            var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
            var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
            var velocity = minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
            var w0 = Math.sqrt(stiffness / mass);
            var zeta = damping / (2 * Math.sqrt(stiffness * mass));
            var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
            var a = 1;
            var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
            function solver(t) {
              var progress = duration ? duration * t / 1000 : t;
              if (zeta < 1) {
                progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
              } else {
                progress = (a + b * progress) * Math.exp(-progress * w0);
              }
              if (t === 0 || t === 1) {
                return t;
              }
              return 1 - progress;
            }
            function getDuration() {
              var cached = cache.springs[string];
              if (cached) {
                return cached;
              }
              var frame = 1 / 6;
              var elapsed = 0;
              var rest = 0;
              while (true) {
                elapsed += frame;
                if (solver(elapsed) === 1) {
                  rest++;
                  if (rest >= 16) {
                    break;
                  }
                } else {
                  rest = 0;
                }
              }
              var duration = elapsed * frame * 1000;
              cache.springs[string] = duration;
              return duration;
            }
            return duration ? solver : getDuration;
          }

          // Elastic easing adapted from jQueryUI http://api.jqueryui.com/easings/

          function elastic(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = minMax(amplitude, 1, 10);
            var p = minMax(period, .1, 2);
            return function (t) {
              return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
          }

          // Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function

          function steps(steps) {
            if (steps === void 0) steps = 10;
            return function (t) {
              return Math.round(t * steps) * (1 / steps);
            };
          }

          // BezierEasing https://github.com/gre/bezier-easing

          var bezier = function () {
            var kSplineTableSize = 11;
            var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
            function A(aA1, aA2) {
              return 1.0 - 3.0 * aA2 + 3.0 * aA1;
            }
            function B(aA1, aA2) {
              return 3.0 * aA2 - 6.0 * aA1;
            }
            function C(aA1) {
              return 3.0 * aA1;
            }
            function calcBezier(aT, aA1, aA2) {
              return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
            }
            function getSlope(aT, aA1, aA2) {
              return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
            }
            function binarySubdivide(aX, aA, aB, mX1, mX2) {
              var currentX,
                currentT,
                i = 0;
              do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) {
                  aB = currentT;
                } else {
                  aA = currentT;
                }
              } while (Math.abs(currentX) > 0.0000001 && ++i < 10);
              return currentT;
            }
            function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
              for (var i = 0; i < 4; ++i) {
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) {
                  return aGuessT;
                }
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
              }
              return aGuessT;
            }
            function bezier(mX1, mY1, mX2, mY2) {
              if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
                return;
              }
              var sampleValues = new Float32Array(kSplineTableSize);
              if (mX1 !== mY1 || mX2 !== mY2) {
                for (var i = 0; i < kSplineTableSize; ++i) {
                  sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
                }
              }
              function getTForX(aX) {
                var intervalStart = 0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
                  intervalStart += kSampleStepSize;
                }
                --currentSample;
                var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= 0.001) {
                  return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                } else if (initialSlope === 0.0) {
                  return guessForT;
                } else {
                  return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
                }
              }
              return function (x) {
                if (mX1 === mY1 && mX2 === mY2) {
                  return x;
                }
                if (x === 0 || x === 1) {
                  return x;
                }
                return calcBezier(getTForX(x), mY1, mY2);
              };
            }
            return bezier;
          }();
          var penner = function () {
            var names = ['Quad', 'Cubic', 'Quart', 'Quint', 'Sine', 'Expo', 'Circ', 'Back', 'Elastic'];

            // Approximated Penner equations http://matthewlein.com/ceaser/

            var curves = {
              In: [[0.550, 0.085, 0.680, 0.530], /* inQuad */
              [0.550, 0.055, 0.675, 0.190], /* inCubic */
              [0.895, 0.030, 0.685, 0.220], /* inQuart */
              [0.755, 0.050, 0.855, 0.060], /* inQuint */
              [0.470, 0.000, 0.745, 0.715], /* inSine */
              [0.950, 0.050, 0.795, 0.035], /* inExpo */
              [0.600, 0.040, 0.980, 0.335], /* inCirc */
              [0.600, -0.280, 0.735, 0.045], /* inBack */
              elastic /* inElastic */],

              Out: [[0.250, 0.460, 0.450, 0.940], /* outQuad */
              [0.215, 0.610, 0.355, 1.000], /* outCubic */
              [0.165, 0.840, 0.440, 1.000], /* outQuart */
              [0.230, 1.000, 0.320, 1.000], /* outQuint */
              [0.390, 0.575, 0.565, 1.000], /* outSine */
              [0.190, 1.000, 0.220, 1.000], /* outExpo */
              [0.075, 0.820, 0.165, 1.000], /* outCirc */
              [0.175, 0.885, 0.320, 1.275], /* outBack */
              function (a, p) {
                return function (t) {
                  return 1 - elastic(a, p)(1 - t);
                };
              } /* outElastic */],

              InOut: [[0.455, 0.030, 0.515, 0.955], /* inOutQuad */
              [0.645, 0.045, 0.355, 1.000], /* inOutCubic */
              [0.770, 0.000, 0.175, 1.000], /* inOutQuart */
              [0.860, 0.000, 0.070, 1.000], /* inOutQuint */
              [0.445, 0.050, 0.550, 0.950], /* inOutSine */
              [1.000, 0.000, 0.000, 1.000], /* inOutExpo */
              [0.785, 0.135, 0.150, 0.860], /* inOutCirc */
              [0.680, -0.550, 0.265, 1.550], /* inOutBack */
              function (a, p) {
                return function (t) {
                  return t < .5 ? elastic(a, p)(t * 2) / 2 : 1 - elastic(a, p)(t * -2 + 2) / 2;
                };
              } /* inOutElastic */]
            };

            var eases = {
              linear: [0.250, 0.250, 0.750, 0.750]
            };
            for (var coords in curves) {
              for (var i = 0, len = curves[coords].length; i < len; i++) {
                eases['ease' + coords + names[i]] = curves[coords][i];
              }
            }
            return eases;
          }();
          function parseEasings(easing, duration) {
            if (is.fnc(easing)) {
              return easing;
            }
            var name = easing.split('(')[0];
            var ease = penner[name];
            var args = parseEasingParameters(easing);
            switch (name) {
              case 'spring':
                return spring(easing, duration);
              case 'cubicBezier':
                return applyArguments(bezier, args);
              case 'steps':
                return applyArguments(steps, args);
              default:
                return is.fnc(ease) ? applyArguments(ease, args) : applyArguments(bezier, ease);
            }
          }

          // Strings

          function selectString(str) {
            try {
              var nodes = document.querySelectorAll(str);
              return nodes;
            } catch (e) {
              return;
            }
          }

          // Arrays

          var auxArrayFilter = [];
          function filterArray(arr, callback) {
            var result = auxArrayFilter;
            var len = arr.length;
            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
              if (i in arr) {
                var val = arr[i];
                if (callback.call(thisArg, val, i, arr)) {
                  result.push(val);
                }
              }
            }

            // arr turns into the auxArray and we return the previously aux array.
            auxArrayFilter = arr;
            auxArrayFilter.length = 0;
            return result;
          }
          function flattenArray(arr, result) {
            if (!result) {
              result = [];
            }
            for (var i = 0, length = arr.length; i < length; i++) {
              var value = arr[i];
              if (Array.isArray(value)) {
                flattenArray(value, result);
              } else {
                result.push(value);
              }
            }
            return result;
          }
          function toArray(o) {
            if (is.arr(o)) {
              return o;
            }
            if (is.str(o)) {
              o = selectString(o) || o;
            }
            if (o instanceof NodeList || o instanceof HTMLCollection) {
              return [].slice.call(o);
            }
            return [o];
          }
          function arrayContains(arr, val) {
            return arr.some(function (a) {
              return a === val;
            });
          }

          // Objects

          function cloneObject(o) {
            var clone = {};
            for (var p in o) {
              clone[p] = o[p];
            }
            return clone;
          }
          function replaceObjectProps(o1, o2) {
            var o = cloneObject(o1);
            for (var p in o1) {
              o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
            }
            return o;
          }
          function mergeObjects(o1, o2) {
            var o = cloneObject(o1);
            for (var p in o2) {
              o[p] = is.und(o1[p]) ? o2[p] : o1[p];
            }
            return o;
          }

          // Colors

          var rgbRegex = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g;
          function rgbToRgba(rgbValue) {
            var rgb = rgbRegex.exec(rgbValue);
            return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
          }
          var hexToRgbaHexRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          var hexToRgbaRgbRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
          function hexToRgba(hexValue) {
            var hex = hexValue.replace(hexToRgbaHexRegex, function (m, r, g, b) {
              return r + r + g + g + b + b;
            });
            var rgb = hexToRgbaRgbRegex.exec(hex);
            var r = parseInt(rgb[1], 16);
            var g = parseInt(rgb[2], 16);
            var b = parseInt(rgb[3], 16);
            return "rgba(" + r + "," + g + "," + b + ",1)";
          }
          var hslToRgbaHsl1Regex = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g;
          var hslToRgbaHsl2Regex = /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g;
          function hslToRgba(hslValue) {
            var hsl = hslToRgbaHsl1Regex.exec(hslValue) || hslToRgbaHsl2Regex.exec(hslValue);
            var h = parseInt(hsl[1], 10) / 360;
            var s = parseInt(hsl[2], 10) / 100;
            var l = parseInt(hsl[3], 10) / 100;
            var a = hsl[4] || 1;
            function hue2rgb(p, q, t) {
              if (t < 0) {
                t += 1;
              }
              if (t > 1) {
                t -= 1;
              }
              if (t < 1 / 6) {
                return p + (q - p) * 6 * t;
              }
              if (t < 1 / 2) {
                return q;
              }
              if (t < 2 / 3) {
                return p + (q - p) * (2 / 3 - t) * 6;
              }
              return p;
            }
            var r, g, b;
            if (s == 0) {
              r = g = b = l;
            } else {
              var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
              var p = 2 * l - q;
              r = hue2rgb(p, q, h + 1 / 3);
              g = hue2rgb(p, q, h);
              b = hue2rgb(p, q, h - 1 / 3);
            }
            return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
          }
          function colorToRgb(val) {
            if (is.rgb(val)) {
              return rgbToRgba(val);
            }
            if (is.hex(val)) {
              return hexToRgba(val);
            }
            if (is.hsl(val)) {
              return hslToRgba(val);
            }
          }

          // Units

          var unitRegex = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/;
          function getUnit(val) {
            var split = unitRegex.exec(val);
            if (split) {
              return split[2];
            }
          }
          function getTransformUnit(propName) {
            if (stringContains(propName, 'translate') || propName === 'perspective') {
              return 'px';
            }
            if (stringContains(propName, 'rotate') || stringContains(propName, 'skew')) {
              return 'deg';
            }
          }

          // Values

          function getFunctionValue(val, animatable) {
            if (!is.fnc(val)) {
              return val;
            }
            return val(animatable.target, animatable.id, animatable.total);
          }
          function getAttribute(el, prop) {
            return el.getAttribute(prop);
          }
          function convertPxToUnit(el, value, unit) {
            var valueUnit = getUnit(value);
            if (arrayContains([unit, 'deg', 'rad', 'turn'], valueUnit)) {
              return value;
            }
            var cached = cache.CSS[value + unit];
            if (!is.und(cached)) {
              return cached;
            }
            var baseline = 100;
            var tempEl = document.createElement(el.tagName);
            var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
            parentEl.appendChild(tempEl);
            tempEl.style.position = 'absolute';
            tempEl.style.width = baseline + unit;
            var factor = baseline / tempEl.offsetWidth;
            parentEl.removeChild(tempEl);
            var convertedUnit = factor * parseFloat(value);
            cache.CSS[value + unit] = convertedUnit;
            return convertedUnit;
          }
          function getCSSValue(el, prop, unit) {
            if (prop in el.style) {
              var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
              var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
              return unit ? convertPxToUnit(el, value, unit) : value;
            }
          }
          function getAnimationType(el, prop) {
            if (is.dom(el) && !is.inp(el) && (getAttribute(el, prop) || is.svg(el) && el[prop])) {
              return 'attribute';
            }
            if (is.dom(el) && arrayContains(validTransforms, prop)) {
              return 'transform';
            }
            if (is.dom(el) && prop !== 'transform' && getCSSValue(el, prop)) {
              return 'css';
            }
            if (el[prop] != null) {
              return 'object';
            }
          }
          var transformRegex = /(\w+)\(([^)]*)\)/g;
          function getElementTransforms(el) {
            if (!is.dom(el)) {
              return;
            }
            var str = el.style.transform || '';
            var transforms = new Map();
            var m;
            while (m = transformRegex.exec(str)) {
              transforms.set(m[1], m[2]);
            }
            return transforms;
          }
          function getTransformValue(el, propName, animatable, unit) {
            var defaultVal = stringContains(propName, 'scale') ? 1 : 0 + getTransformUnit(propName);
            var value = getElementTransforms(el).get(propName) || defaultVal;
            if (animatable) {
              animatable.transforms.list.set(propName, value);
              animatable.transforms['last'] = propName;
            }
            return unit ? convertPxToUnit(el, value, unit) : value;
          }
          function getOriginalTargetValue(target, propName, unit, animatable) {
            switch (getAnimationType(target, propName)) {
              case 'transform':
                return getTransformValue(target, propName, animatable, unit);
              case 'css':
                return getCSSValue(target, propName, unit);
              case 'attribute':
                return getAttribute(target, propName);
              default:
                return target[propName] || 0;
            }
          }
          var operatorRegex = /^(\*=|\+=|-=)/;
          function getRelativeValue(to, from) {
            var operator = operatorRegex.exec(to);
            if (!operator) {
              return to;
            }
            var u = getUnit(to) || 0;
            var x = parseFloat(from);
            var y = parseFloat(to.replace(operator[0], ''));
            switch (operator[0][0]) {
              case '+':
                return x + y + u;
              case '-':
                return x - y + u;
              case '*':
                return x * y + u;
            }
          }
          var whitespaceRegex = /\s/g;
          function validateValue(val, unit) {
            if (is.col(val)) {
              return colorToRgb(val);
            }
            var originalUnit = getUnit(val);
            var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
            return unit && !whitespaceRegex.test(val) ? unitLess + unit : unitLess;
          }

          // getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
          // adapted from https://gist.github.com/SebLambla/3e0550c496c236709744

          function getDistance(p1, p2) {
            return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
          }
          function getCircleLength(el) {
            return Math.PI * 2 * getAttribute(el, 'r');
          }
          function getRectLength(el) {
            return getAttribute(el, 'width') * 2 + getAttribute(el, 'height') * 2;
          }
          function getLineLength(el) {
            return getDistance({
              x: getAttribute(el, 'x1'),
              y: getAttribute(el, 'y1')
            }, {
              x: getAttribute(el, 'x2'),
              y: getAttribute(el, 'y2')
            });
          }
          function getPolylineLength(el) {
            var points = el.points;
            var totalLength = 0;
            var previousPos;
            for (var i = 0; i < points.numberOfItems; i++) {
              var currentPos = points.getItem(i);
              if (i > 0) {
                totalLength += getDistance(previousPos, currentPos);
              }
              previousPos = currentPos;
            }
            return totalLength;
          }
          function getPolygonLength(el) {
            var points = el.points;
            return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
          }

          // Path animation

          function getTotalLength(el) {
            if (el.getTotalLength) {
              return el.getTotalLength();
            }
            switch (el.tagName.toLowerCase()) {
              case 'circle':
                return getCircleLength(el);
              case 'rect':
                return getRectLength(el);
              case 'line':
                return getLineLength(el);
              case 'polyline':
                return getPolylineLength(el);
              case 'polygon':
                return getPolygonLength(el);
            }
          }
          function setDashoffset(el) {
            var pathLength = getTotalLength(el);
            el.setAttribute('stroke-dasharray', pathLength);
            return pathLength;
          }

          // Motion path

          function getParentSvgEl(el) {
            var parentEl = el.parentNode;
            while (is.svg(parentEl)) {
              parentEl = parentEl.parentNode;
              if (!is.svg(parentEl.parentNode)) {
                break;
              }
            }
            return parentEl;
          }
          function getParentSvg(pathEl, svgData) {
            var svg = svgData || {};
            var parentSvgEl = svg.el || getParentSvgEl(pathEl);
            var rect = parentSvgEl.getBoundingClientRect();
            var viewBoxAttr = getAttribute(parentSvgEl, 'viewBox');
            var width = rect.width;
            var height = rect.height;
            var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [0, 0, width, height]);
            return {
              el: parentSvgEl,
              viewBox: viewBox,
              x: viewBox[0] / 1,
              y: viewBox[1] / 1,
              w: width / viewBox[2],
              h: height / viewBox[3]
            };
          }
          function getPath(path, percent) {
            var pathEl = is.str(path) ? selectString(path)[0] : path;
            var p = percent || 100;
            return function (property) {
              return {
                property: property,
                el: pathEl,
                svg: getParentSvg(pathEl),
                totalLength: getTotalLength(pathEl) * (p / 100)
              };
            };
          }
          function getPathProgress(path, progress) {
            function point(offset) {
              if (offset === void 0) offset = 0;
              var l = progress + offset >= 1 ? progress + offset : 0;
              return path.el.getPointAtLength(l);
            }
            var svg = getParentSvg(path.el, path.svg);
            var p = point();
            var p0 = point(-1);
            var p1 = point(+1);
            switch (path.property) {
              case 'x':
                return (p.x - svg.x) * svg.w;
              case 'y':
                return (p.y - svg.y) * svg.h;
              case 'angle':
                return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
            }
          }

          // Decompose value

          var valueRegex = /-?\d*\.?\d+/g;
          function decomposeValue(val, unit) {
            var value = validateValue(is.pth(val) ? val.totalLength : val, unit) + '';
            return {
              original: value,
              numbers: value.match(valueRegex) ? value.match(valueRegex).map(Number) : [0],
              strings: is.str(val) || unit ? value.split(valueRegex) : []
            };
          }

          // Animatables

          function parseTargets(targets) {
            var targetsArray = targets ? flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets)) : [];
            return filterArray(targetsArray, function (item, pos, self) {
              return self.indexOf(item) === pos;
            });
          }
          function getAnimatables(targets) {
            var parsed = parseTargets(targets);
            return parsed.map(function (t, i) {
              return {
                target: t,
                id: i,
                total: parsed.length,
                transforms: {
                  list: getElementTransforms(t)
                }
              };
            });
          }

          // Properties

          var springRegex = /^spring/;
          function normalizePropertyTweens(prop, tweenSettings) {
            var settings = cloneObject(tweenSettings);
            // Override duration if easing is a spring
            if (springRegex.test(settings.easing)) {
              settings.duration = spring(settings.easing);
            }
            if (is.arr(prop)) {
              var l = prop.length;
              var isFromTo = l === 2 && !is.obj(prop[0]);
              if (!isFromTo) {
                // Duration divided by the number of tweens
                if (!is.fnc(tweenSettings.duration)) {
                  settings.duration = tweenSettings.duration / l;
                }
              } else {
                // Transform [from, to] values shorthand to a valid tween value
                prop = {
                  value: prop
                };
              }
            }
            var propArray = is.arr(prop) ? prop : [prop];
            return propArray.map(function (v, i) {
              var obj = is.obj(v) && !is.pth(v) ? v : {
                value: v
              };
              // Default delay value should only be applied to the first tween
              if (is.und(obj.delay)) {
                obj.delay = !i ? tweenSettings.delay : 0;
              }
              // Default endDelay value should only be applied to the last tween
              if (is.und(obj.endDelay)) {
                obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
              }
              return obj;
            }).map(function (k) {
              return mergeObjects(k, settings);
            });
          }
          function flattenKeyframes(keyframes) {
            var propertyNames = filterArray(flattenArray(keyframes.map(function (key) {
              return Object.keys(key);
            })), function (p) {
              return is.key(p);
            }).reduce(function (a, b) {
              if (a.indexOf(b) < 0) {
                a.push(b);
              }
              return a;
            }, []);
            var properties = {};
            var loop = function loop(i) {
              var propName = propertyNames[i];
              properties[propName] = keyframes.map(function (key) {
                var newKey = {};
                for (var p in key) {
                  if (is.key(p)) {
                    if (p == propName) {
                      newKey.value = key[p];
                    }
                  } else {
                    newKey[p] = key[p];
                  }
                }
                return newKey;
              });
            };
            for (var i = 0; i < propertyNames.length; i++) loop(i);
            return properties;
          }
          function getProperties(tweenSettings, params) {
            var properties = [];
            var keyframes = params.keyframes;
            if (keyframes) {
              params = mergeObjects(flattenKeyframes(keyframes), params);
            }
            for (var p in params) {
              if (is.key(p)) {
                properties.push({
                  name: p,
                  tweens: normalizePropertyTweens(params[p], tweenSettings)
                });
              }
            }
            return properties;
          }

          // Tweens

          function normalizeTweenValues(tween, animatable) {
            var t = {};
            for (var p in tween) {
              var value = getFunctionValue(tween[p], animatable);
              if (is.arr(value)) {
                value = value.map(function (v) {
                  return getFunctionValue(v, animatable);
                });
                if (value.length === 1) {
                  value = value[0];
                }
              }
              t[p] = value;
            }
            t.duration = parseFloat(t.duration);
            t.delay = parseFloat(t.delay);
            return t;
          }
          function normalizeTweens(prop, animatable) {
            var previousTween;
            return prop.tweens.map(function (t) {
              var tween = normalizeTweenValues(t, animatable);
              var tweenValue = tween.value;
              var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
              var toUnit = getUnit(to);
              var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
              var previousValue = previousTween ? previousTween.to.original : originalValue;
              var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
              var fromUnit = getUnit(from) || getUnit(originalValue);
              var unit = toUnit || fromUnit;
              if (is.und(to)) {
                to = previousValue;
              }
              tween.from = decomposeValue(from, unit);
              tween.to = decomposeValue(getRelativeValue(to, from), unit);
              tween.start = previousTween ? previousTween.end : 0;
              tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
              tween.easing = parseEasings(tween.easing, tween.duration);
              tween.isPath = is.pth(tweenValue);
              tween.isColor = is.col(tween.from.original);
              if (tween.isColor) {
                tween.round = 1;
              }
              previousTween = tween;
              return tween;
            });
          }

          // Tween progress

          var setProgressValue = {
            css: function css(t, p, v) {
              return t.style[p] = v;
            },
            attribute: function attribute(t, p, v) {
              return t.setAttribute(p, v);
            },
            object: function object(t, p, v) {
              return t[p] = v;
            },
            transform: function transform(t, p, v, transforms, manual) {
              transforms.list.set(p, v);
              if (p === transforms.last || manual) {
                var str = '';
                transforms.list.forEach(function (value, prop) {
                  str += prop + "(" + value + ") ";
                });
                t.style.transform = str;
              }
            }
          };

          // Set Value helper

          function setTargetsValue(targets, properties) {
            var animatables = getAnimatables(targets);
            for (var i = 0, len = animatables.length; i < len; i++) {
              var animatable = animatables[i];
              for (var property in properties) {
                var value = getFunctionValue(properties[property], animatable);
                var target = animatable.target;
                var valueUnit = getUnit(value);
                var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
                var unit = valueUnit || getUnit(originalValue);
                var to = getRelativeValue(validateValue(value, unit), originalValue);
                var animType = getAnimationType(target, property);
                setProgressValue[animType](target, property, to, animatable.transforms, true);
              }
            }
          }

          // Animations

          function createAnimation(animatable, prop) {
            var animType = getAnimationType(animatable.target, prop.name);
            if (animType) {
              var tweens = normalizeTweens(prop, animatable);
              var lastTween = tweens[tweens.length - 1];
              return {
                type: animType,
                property: prop.name,
                animatable: animatable,
                tweens: tweens,
                duration: lastTween.end,
                delay: tweens[0].delay,
                endDelay: lastTween.endDelay
              };
            }
          }
          function getAnimations(animatables, properties) {
            return filterArray(flattenArray(animatables.map(function (animatable) {
              return properties.map(function (prop) {
                return createAnimation(animatable, prop);
              });
            })), function (a) {
              return !is.und(a);
            });
          }

          // Create Instance

          function getInstanceTimings(animations, tweenSettings) {
            var animLength = animations.length;
            var getTlOffset = function getTlOffset(anim) {
              return anim.timelineOffset ? anim.timelineOffset : 0;
            };
            var timings = {};
            timings.duration = animLength ? Math.max.apply(Math, animations.map(function (anim) {
              return getTlOffset(anim) + anim.duration;
            })) : tweenSettings.duration;
            timings.delay = animLength ? Math.min.apply(Math, animations.map(function (anim) {
              return getTlOffset(anim) + anim.delay;
            })) : tweenSettings.delay;
            timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function (anim) {
              return getTlOffset(anim) + anim.duration - anim.endDelay;
            })) : tweenSettings.endDelay;
            return timings;
          }
          var instanceID = 0;
          function createNewInstance(params) {
            var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
            var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
            var properties = getProperties(tweenSettings, params);
            var animatables = getAnimatables(params.targets);
            var animations = getAnimations(animatables, properties);
            var timings = getInstanceTimings(animations, tweenSettings);
            var id = instanceID;
            instanceID++;
            return mergeObjects(instanceSettings, {
              id: id,
              children: [],
              animatables: animatables,
              animations: animations,
              duration: timings.duration,
              delay: timings.delay,
              endDelay: timings.endDelay
            });
          }

          // Core

          var activeInstances = [];
          var pausedInstances = [];
          var raf;
          var engine = function () {
            function play() {
              raf = requestAnimationFrame(step);
            }
            function step(t) {
              var activeInstancesLength = activeInstances.length;
              if (activeInstancesLength) {
                var i = 0;
                while (i < activeInstancesLength) {
                  var activeInstance = activeInstances[i];
                  if (!activeInstance.paused) {
                    activeInstance.tick(t);
                  } else {
                    var instanceIndex = activeInstances.indexOf(activeInstance);
                    if (instanceIndex > -1) {
                      activeInstances.splice(instanceIndex, 1);
                      activeInstancesLength = activeInstances.length;
                    }
                  }
                  i++;
                }
                play();
              } else {
                raf = cancelAnimationFrame(raf);
              }
            }
            return play;
          }();
          function handleVisibilityChange() {
            if (document.hidden) {
              for (var i = 0, len = activeInstances.length; i < len; i++) {
                activeInstance[i].pause();
              }
              pausedInstances = activeInstances.slice(0);
              activeInstances = [];
            } else {
              for (var i$1 = 0, len$1 = pausedInstances.length; i$1 < len$1; i$1++) {
                pausedInstances[i$1].play();
              }
            }
          }
          document.addEventListener('visibilitychange', handleVisibilityChange);

          // Public Instance

          function anime(params) {
            if (params === void 0) params = {};
            var startTime = 0,
              lastTime = 0,
              now = 0;
            var children,
              childrenLength = 0;
            var resolve = null;
            function makePromise() {
              return window.Promise && new Promise(function (_resolve) {
                return resolve = _resolve;
              });
            }
            var promise = makePromise();
            var instance = createNewInstance(params);
            function toggleInstanceDirection() {
              instance.reversed = !instance.reversed;
              for (var i = 0, len = children.length; i < len; i++) {
                children[i].reversed = instance.reversed;
              }
            }
            function adjustTime(time) {
              return instance.reversed ? instance.duration - time : time;
            }
            function resetTime() {
              startTime = 0;
              lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
            }
            function seekCild(time, child) {
              if (child) {
                child.seek(time - child.timelineOffset);
              }
            }
            function syncInstanceChildren(time) {
              if (!instance.reversePlayback) {
                for (var i = 0; i < childrenLength; i++) {
                  seekCild(time, children[i]);
                }
              } else {
                for (var i$1 = childrenLength; i$1--;) {
                  seekCild(time, children[i$1]);
                }
              }
            }
            function setAnimationsProgress(insTime) {
              var i = 0;
              var animations = instance.animations;
              var animationsLength = animations.length;
              while (i < animationsLength) {
                var anim = animations[i];
                var animatable = anim.animatable;
                var tweens = anim.tweens;
                var tweenLength = tweens.length - 1;
                var tween = tweens[tweenLength];
                // Only check for keyframes if there is more than one tween
                if (tweenLength) {
                  tween = filterArray(tweens, function (t) {
                    return insTime < t.end;
                  })[0] || tween;
                }
                var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
                var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
                var strings = tween.to.strings;
                var round = tween.round;
                var numbers = [];
                var toNumbersLength = tween.to.numbers.length;
                var progress = void 0;
                for (var n = 0; n < toNumbersLength; n++) {
                  var value = void 0;
                  var toNumber = tween.to.numbers[n];
                  var fromNumber = tween.from.numbers[n] || 0;
                  if (!tween.isPath) {
                    value = fromNumber + eased * (toNumber - fromNumber);
                  } else {
                    value = getPathProgress(tween.value, eased * toNumber);
                  }
                  if (round) {
                    if (!(tween.isColor && n > 2)) {
                      value = Math.round(value * round) / round;
                    }
                  }
                  numbers.push(value);
                }
                // Manual Array.reduce for better performances
                var stringsLength = strings.length;
                if (!stringsLength) {
                  progress = numbers[0];
                } else {
                  progress = strings[0];
                  for (var s = 0; s < stringsLength; s++) {
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                      if (!b) {
                        progress += n$1 + ' ';
                      } else {
                        progress += n$1 + b;
                      }
                    }
                  }
                }
                setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
                anim.currentValue = progress;
                i++;
              }
            }
            function setCallback(cb) {
              if (instance[cb] && !instance.passThrough) {
                instance[cb](instance);
              }
            }
            function countIteration() {
              if (instance.remaining && instance.remaining !== true) {
                instance.remaining--;
              }
            }
            function setInstanceProgress(engineTime) {
              var insDuration = instance.duration;
              var insDelay = instance.delay;
              var insEndDelay = insDuration - instance.endDelay;
              var insTime = adjustTime(engineTime);
              instance.progress = minMax(insTime / insDuration * 100, 0, 100);
              instance.reversePlayback = insTime < instance.currentTime;
              if (children) {
                syncInstanceChildren(insTime);
              }
              if (!instance.began && instance.currentTime > 0) {
                instance.began = true;
                setCallback('begin');
                setCallback('loopBegin');
              }
              if (insTime <= insDelay && instance.currentTime !== 0) {
                setAnimationsProgress(0);
              }
              if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) {
                setAnimationsProgress(insDuration);
              }
              if (insTime > insDelay && insTime < insEndDelay) {
                if (!instance.changeBegan) {
                  instance.changeBegan = true;
                  instance.changeCompleted = false;
                  setCallback('changeBegin');
                }
                setCallback('change');
                setAnimationsProgress(insTime);
              } else {
                if (instance.changeBegan) {
                  instance.changeCompleted = true;
                  instance.changeBegan = false;
                  setCallback('changeComplete');
                }
              }
              instance.currentTime = minMax(insTime, 0, insDuration);
              if (instance.began) {
                setCallback('update');
              }
              if (engineTime >= insDuration) {
                lastTime = 0;
                countIteration();
                if (instance.remaining) {
                  startTime = now;
                  setCallback('loopComplete');
                  setCallback('loopBegin');
                  if (instance.direction === 'alternate') {
                    toggleInstanceDirection();
                  }
                } else {
                  instance.paused = true;
                  if (!instance.completed) {
                    instance.completed = true;
                    setCallback('loopComplete');
                    setCallback('complete');
                    if ('Promise' in window) {
                      resolve();
                      promise = makePromise();
                    }
                  }
                }
              }
            }
            instance.reset = function () {
              var direction = instance.direction;
              instance.passThrough = false;
              instance.currentTime = 0;
              instance.progress = 0;
              instance.paused = true;
              instance.began = false;
              instance.changeBegan = false;
              instance.completed = false;
              instance.changeCompleted = false;
              instance.reversePlayback = false;
              instance.reversed = direction === 'reverse';
              instance.remaining = instance.loop;
              children = instance.children;
              childrenLength = children.length;
              for (var i = childrenLength; i--;) {
                instance.children[i].reset();
              }
              if (instance.reversed && instance.loop !== true || direction === 'alternate' && instance.loop === 1) {
                instance.remaining++;
              }
              setAnimationsProgress(0);
            };

            // Set Value helper

            instance.set = function (targets, properties) {
              setTargetsValue(targets, properties);
              return instance;
            };
            instance.tick = function (t) {
              now = t;
              if (!startTime) {
                startTime = now;
              }
              setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
            };
            instance.seek = function (time) {
              setInstanceProgress(adjustTime(time));
            };
            instance.pause = function () {
              instance.paused = true;
              resetTime();
            };
            instance.play = function () {
              if (!instance.paused) {
                return;
              }
              instance.paused = false;
              activeInstances.push(instance);
              resetTime();
              if (!raf) {
                engine();
              }
            };
            instance.reverse = function () {
              toggleInstanceDirection();
              resetTime();
            };
            instance.restart = function () {
              instance.reset();
              instance.play();
            };
            instance.finished = promise;
            instance.reset();
            if (instance.autoplay) {
              instance.play();
            }
            return instance;
          }

          // Remove targets from animation

          function removeTargetsFromAnimations(targetsArray, animations) {
            for (var a = animations.length; a--;) {
              if (arrayContains(targetsArray, animations[a].animatable.target)) {
                animations.splice(a, 1);
              }
            }
          }
          function removeTargets(targets) {
            var targetsArray = parseTargets(targets);
            for (var i = activeInstances.length; i--;) {
              var instance = activeInstances[i];
              var animations = instance.animations;
              var children = instance.children;
              removeTargetsFromAnimations(targetsArray, animations);
              for (var c = children.length; c--;) {
                var child = children[c];
                var childAnimations = child.animations;
                removeTargetsFromAnimations(targetsArray, childAnimations);
                if (!childAnimations.length && !child.children.length) {
                  children.splice(c, 1);
                }
              }
              if (!animations.length && !children.length) {
                instance.pause();
              }
            }
          }

          // Stagger helpers

          function stagger(val, params) {
            if (params === void 0) params = {};
            var direction = params.direction || 'normal';
            var easing = params.easing ? parseEasings(params.easing) : null;
            var grid = params.grid;
            var axis = params.axis;
            var fromIndex = params.from || 0;
            var fromFirst = fromIndex === 'first';
            var fromCenter = fromIndex === 'center';
            var fromLast = fromIndex === 'last';
            var isRange = is.arr(val);
            var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
            var val2 = isRange ? parseFloat(val[1]) : 0;
            var unit = getUnit(isRange ? val[1] : val) || 0;
            var start = params.start || 0 + (isRange ? val1 : 0);
            var values = [];
            var maxValue = 0;
            return function (el, i, t) {
              if (fromFirst) {
                fromIndex = 0;
              }
              if (fromCenter) {
                fromIndex = (t - 1) / 2;
              }
              if (fromLast) {
                fromIndex = t - 1;
              }
              if (!values.length) {
                for (var index = 0; index < t; index++) {
                  if (!grid) {
                    values.push(Math.abs(fromIndex - index));
                  } else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === 'x') {
                      value = -distanceX;
                    }
                    if (axis === 'y') {
                      value = -distanceY;
                    }
                    values.push(value);
                  }
                  maxValue = Math.max.apply(Math, values);
                }
                if (easing) {
                  values = values.map(function (val) {
                    return easing(val / maxValue) * maxValue;
                  });
                }
                if (direction === 'reverse') {
                  values = values.map(function (val) {
                    return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
                  });
                }
              }
              var spacing = isRange ? (val2 - val1) / maxValue : val1;
              return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
            };
          }

          // Timeline

          function timeline(params) {
            if (params === void 0) params = {};
            var tl = anime(params);
            tl.duration = 0;
            tl.add = function (instanceParams, timelineOffset) {
              var tlIndex = activeInstances.indexOf(tl);
              var children = tl.children;
              if (tlIndex > -1) {
                activeInstances.splice(tlIndex, 1);
              }
              function passThrough(ins) {
                ins.passThrough = true;
              }
              for (var i = 0; i < children.length; i++) {
                passThrough(children[i]);
              }
              var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
              insParams.targets = insParams.targets || params.targets;
              var tlDuration = tl.duration;
              insParams.autoplay = false;
              insParams.direction = tl.direction;
              insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
              passThrough(tl);
              tl.seek(insParams.timelineOffset);
              var ins = anime(insParams);
              passThrough(ins);
              children.push(ins);
              var timings = getInstanceTimings(children, params);
              tl.delay = timings.delay;
              tl.endDelay = timings.endDelay;
              tl.duration = timings.duration;
              tl.seek(0);
              tl.reset();
              if (tl.autoplay) {
                tl.play();
              }
              return tl;
            };
            return tl;
          }
          anime.version = '3.0.0';
          anime.speed = 1;
          anime.running = activeInstances;
          anime.remove = removeTargets;
          anime.get = getOriginalTargetValue;
          anime.set = setTargetsValue;
          anime.convertPx = convertPxToUnit;
          anime.path = getPath;
          anime.setDashoffset = setDashoffset;
          anime.stagger = stagger;
          anime.timeline = timeline;
          anime.easing = parseEasings;
          anime.penner = penner;
          anime.random = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
          };
          /* harmony default export */
          var __WEBPACK_DEFAULT_EXPORT__ = anime;

          /***/
        },

        /***/"./node_modules/three-bmfont-text/index.js":
        /*!*************************************************!*\
          !*** ./node_modules/three-bmfont-text/index.js ***!
          \*************************************************/
        /***/
        function node_modulesThreeBmfontTextIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          var createLayout = __webpack_require__( /*! layout-bmfont-text */"./node_modules/layout-bmfont-text/index.js");
          var inherits = __webpack_require__( /*! inherits */"./node_modules/inherits/inherits_browser.js");
          var createIndices = __webpack_require__( /*! quad-indices */"./node_modules/quad-indices/index.js");
          var buffer = __webpack_require__( /*! three-buffer-vertex-data */"./node_modules/three-buffer-vertex-data/index.js");
          var assign = __webpack_require__( /*! object-assign */"./node_modules/object-assign/index.js");
          var vertices = __webpack_require__( /*! ./lib/vertices */"./node_modules/three-bmfont-text/lib/vertices.js");
          var utils = __webpack_require__( /*! ./lib/utils */"./node_modules/three-bmfont-text/lib/utils.js");
          module.exports = function createTextGeometry(opt) {
            return new TextGeometry(opt);
          };
          var TextGeometry = /*#__PURE__*/function (_THREE$BufferGeometry) {
            "use strict";

            _inherits(TextGeometry, _THREE$BufferGeometry);
            var _super2 = _createSuper(TextGeometry);
            function TextGeometry(opt) {
              var _this3;
              _classCallCheck2(this, TextGeometry);
              _this3 = _super2.call(this);
              if (typeof opt === 'string') {
                opt = {
                  text: opt
                };
              }

              // use these as default values for any subsequent
              // calls to update()
              _this3._opt = assign({}, opt);

              // also do an initial setup...
              if (opt) _this3.update(opt);
              return _this3;
            }
            _createClass2(TextGeometry, [{
              key: "update",
              value: function update(opt) {
                if (typeof opt === 'string') {
                  opt = {
                    text: opt
                  };
                }

                // use constructor defaults
                opt = assign({}, this._opt, opt);
                if (!opt.font) {
                  throw new TypeError('must specify a { font } in options');
                }
                this.layout = createLayout(opt);

                // get vec2 texcoords
                var flipY = opt.flipY !== false;

                // the desired BMFont data
                var font = opt.font;

                // determine texture size from font file
                var texWidth = font.common.scaleW;
                var texHeight = font.common.scaleH;

                // get visible glyphs
                var glyphs = this.layout.glyphs.filter(function (glyph) {
                  var bitmap = glyph.data;
                  return bitmap.width * bitmap.height > 0;
                });

                // provide visible glyphs for convenience
                this.visibleGlyphs = glyphs;

                // get common vertex data
                var positions = vertices.positions(glyphs);
                var uvs = vertices.uvs(glyphs, texWidth, texHeight, flipY);
                var indices = createIndices({
                  clockwise: true,
                  type: 'uint16',
                  count: glyphs.length
                });

                // update vertex data
                buffer.index(this, indices, 1, 'uint16');
                buffer.attr(this, 'position', positions, 2);
                buffer.attr(this, 'uv', uvs, 2);

                // update multipage data
                if (!opt.multipage && 'page' in this.attributes) {
                  // disable multipage rendering
                  this.removeAttribute('page');
                } else if (opt.multipage) {
                  var pages = vertices.pages(glyphs);
                  // enable multipage rendering
                  buffer.attr(this, 'page', pages, 1);
                }
              }
            }, {
              key: "computeBoundingSphere",
              value: function computeBoundingSphere() {
                if (this.boundingSphere === null) {
                  this.boundingSphere = new THREE.Sphere();
                }
                var positions = this.attributes.position.array;
                var itemSize = this.attributes.position.itemSize;
                if (!positions || !itemSize || positions.length < 2) {
                  this.boundingSphere.radius = 0;
                  this.boundingSphere.center.set(0, 0, 0);
                  return;
                }
                utils.computeSphere(positions, this.boundingSphere);
                if (isNaN(this.boundingSphere.radius)) {
                  console.error('THREE.BufferGeometry.computeBoundingSphere(): ' + 'Computed radius is NaN. The ' + '"position" attribute is likely to have NaN values.');
                }
              }
            }, {
              key: "computeBoundingBox",
              value: function computeBoundingBox() {
                if (this.boundingBox === null) {
                  this.boundingBox = new THREE.Box3();
                }
                var bbox = this.boundingBox;
                var positions = this.attributes.position.array;
                var itemSize = this.attributes.position.itemSize;
                if (!positions || !itemSize || positions.length < 2) {
                  bbox.makeEmpty();
                  return;
                }
                utils.computeBox(positions, bbox);
              }
            }]);
            return TextGeometry;
          }(THREE.BufferGeometry);
          /***/
        },
        /***/"./node_modules/three-bmfont-text/lib/utils.js":
        /*!*****************************************************!*\
          !*** ./node_modules/three-bmfont-text/lib/utils.js ***!
          \*****************************************************/
        /***/
        function node_modulesThreeBmfontTextLibUtilsJs(module) {
          var itemSize = 2;
          var box = {
            min: [0, 0],
            max: [0, 0]
          };
          function bounds(positions) {
            var count = positions.length / itemSize;
            box.min[0] = positions[0];
            box.min[1] = positions[1];
            box.max[0] = positions[0];
            box.max[1] = positions[1];
            for (var i = 0; i < count; i++) {
              var x = positions[i * itemSize + 0];
              var y = positions[i * itemSize + 1];
              box.min[0] = Math.min(x, box.min[0]);
              box.min[1] = Math.min(y, box.min[1]);
              box.max[0] = Math.max(x, box.max[0]);
              box.max[1] = Math.max(y, box.max[1]);
            }
          }
          module.exports.computeBox = function (positions, output) {
            bounds(positions);
            output.min.set(box.min[0], box.min[1], 0);
            output.max.set(box.max[0], box.max[1], 0);
          };
          module.exports.computeSphere = function (positions, output) {
            bounds(positions);
            var minX = box.min[0];
            var minY = box.min[1];
            var maxX = box.max[0];
            var maxY = box.max[1];
            var width = maxX - minX;
            var height = maxY - minY;
            var length = Math.sqrt(width * width + height * height);
            output.center.set(minX + width / 2, minY + height / 2, 0);
            output.radius = length / 2;
          };

          /***/
        },

        /***/"./node_modules/three-bmfont-text/lib/vertices.js":
        /*!********************************************************!*\
          !*** ./node_modules/three-bmfont-text/lib/vertices.js ***!
          \********************************************************/
        /***/
        function node_modulesThreeBmfontTextLibVerticesJs(module) {
          module.exports.pages = function pages(glyphs) {
            var pages = new Float32Array(glyphs.length * 4 * 1);
            var i = 0;
            glyphs.forEach(function (glyph) {
              var id = glyph.data.page || 0;
              pages[i++] = id;
              pages[i++] = id;
              pages[i++] = id;
              pages[i++] = id;
            });
            return pages;
          };
          module.exports.uvs = function uvs(glyphs, texWidth, texHeight, flipY) {
            var uvs = new Float32Array(glyphs.length * 4 * 2);
            var i = 0;
            glyphs.forEach(function (glyph) {
              var bitmap = glyph.data;
              var bw = bitmap.x + bitmap.width;
              var bh = bitmap.y + bitmap.height;

              // top left position
              var u0 = bitmap.x / texWidth;
              var v1 = bitmap.y / texHeight;
              var u1 = bw / texWidth;
              var v0 = bh / texHeight;
              if (flipY) {
                v1 = (texHeight - bitmap.y) / texHeight;
                v0 = (texHeight - bh) / texHeight;
              }

              // BL
              uvs[i++] = u0;
              uvs[i++] = v1;
              // TL
              uvs[i++] = u0;
              uvs[i++] = v0;
              // TR
              uvs[i++] = u1;
              uvs[i++] = v0;
              // BR
              uvs[i++] = u1;
              uvs[i++] = v1;
            });
            return uvs;
          };
          module.exports.positions = function positions(glyphs) {
            var positions = new Float32Array(glyphs.length * 4 * 2);
            var i = 0;
            glyphs.forEach(function (glyph) {
              var bitmap = glyph.data;

              // bottom left position
              var x = glyph.position[0] + bitmap.xoffset;
              var y = glyph.position[1] + bitmap.yoffset;

              // quad size
              var w = bitmap.width;
              var h = bitmap.height;

              // BL
              positions[i++] = x;
              positions[i++] = y;
              // TL
              positions[i++] = x;
              positions[i++] = y + h;
              // TR
              positions[i++] = x + w;
              positions[i++] = y + h;
              // BR
              positions[i++] = x + w;
              positions[i++] = y;
            });
            return positions;
          };

          /***/
        },

        /***/"./node_modules/three-buffer-vertex-data/index.js":
        /*!********************************************************!*\
          !*** ./node_modules/three-buffer-vertex-data/index.js ***!
          \********************************************************/
        /***/
        function node_modulesThreeBufferVertexDataIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          var flatten = __webpack_require__( /*! flatten-vertex-data */"./node_modules/flatten-vertex-data/index.js");
          var warned = false;
          module.exports.attr = setAttribute;
          module.exports.index = setIndex;
          function setIndex(geometry, data, itemSize, dtype) {
            if (typeof itemSize !== 'number') itemSize = 1;
            if (typeof dtype !== 'string') dtype = 'uint16';
            var isR69 = !geometry.index && typeof geometry.setIndex !== 'function';
            var attrib = isR69 ? geometry.getAttribute('index') : geometry.index;
            var newAttrib = updateAttribute(attrib, data, itemSize, dtype);
            if (newAttrib) {
              if (isR69) geometry.addAttribute('index', newAttrib);else geometry.index = newAttrib;
            }
          }
          function setAttribute(geometry, key, data, itemSize, dtype) {
            if (typeof itemSize !== 'number') itemSize = 3;
            if (typeof dtype !== 'string') dtype = 'float32';
            if (Array.isArray(data) && Array.isArray(data[0]) && data[0].length !== itemSize) {
              throw new Error('Nested vertex array has unexpected size; expected ' + itemSize + ' but found ' + data[0].length);
            }
            var attrib = geometry.getAttribute(key);
            var newAttrib = updateAttribute(attrib, data, itemSize, dtype);
            geometry.setAttribute(key, newAttrib);
          }
          function updateAttribute(attrib, data, itemSize, dtype) {
            data = data || [];

            // create a new array with desired type
            data = flatten(data, dtype);
            attrib = new THREE.BufferAttribute(data, itemSize);
            attrib.itemSize = itemSize;
            attrib.needsUpdate = true;
            return attrib;
          }

          // Test whether the attribute needs to be re-created,
          // returns false if we can re-use it as-is.
          function rebuildAttribute(attrib, data, itemSize) {
            if (attrib.itemSize !== itemSize) return true;
            if (!attrib.array) return true;
            var attribLength = attrib.array.length;
            if (Array.isArray(data) && Array.isArray(data[0])) {
              // [ [ x, y, z ] ]
              return attribLength !== data.length * itemSize;
            } else {
              // [ x, y, z ]
              return attribLength !== data.length;
            }
            return false;
          }

          /***/
        },

        /***/"./node_modules/webvr-polyfill/build/webvr-polyfill.js":
        /*!*************************************************************!*\
          !*** ./node_modules/webvr-polyfill/build/webvr-polyfill.js ***!
          \*************************************************************/
        /***/
        function node_modulesWebvrPolyfillBuildWebvrPolyfillJs(module, __unused_webpack_exports, __webpack_require__) {
          /**
           * @license
           * webvr-polyfill
           * Copyright (c) 2015-2017 Google
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */

          /**
           * @license
           * cardboard-vr-display
           * Copyright (c) 2015-2017 Google
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */

          /**
           * @license
           * webvr-polyfill-dpdb 
           * Copyright (c) 2017 Google
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */

          /**
           * @license
           * wglu-preserve-state
           * Copyright (c) 2016, Brandon Jones.
           *
           * Permission is hereby granted, free of charge, to any person obtaining a copy
           * of this software and associated documentation files (the "Software"), to deal
           * in the Software without restriction, including without limitation the rights
           * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
           * copies of the Software, and to permit persons to whom the Software is
           * furnished to do so, subject to the following conditions:
           *
           * The above copyright notice and this permission notice shall be included in
           * all copies or substantial portions of the Software.
           *
           * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
           * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
           * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
           * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
           * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
           * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
           * THE SOFTWARE.
           */

          /**
           * @license
           * nosleep.js
           * Copyright (c) 2017, Rich Tibbett
           *
           * Permission is hereby granted, free of charge, to any person obtaining a copy
           * of this software and associated documentation files (the "Software"), to deal
           * in the Software without restriction, including without limitation the rights
           * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
           * copies of the Software, and to permit persons to whom the Software is
           * furnished to do so, subject to the following conditions:
           *
           * The above copyright notice and this permission notice shall be included in
           * all copies or substantial portions of the Software.
           *
           * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
           * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
           * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
           * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
           * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
           * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
           * THE SOFTWARE.
           */

          (function (global, factory) {
            true ? module.exports = factory() : 0;
          })(this, function () {
            'use strict';

            var commonjsGlobal = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};
            function unwrapExports(x) {
              return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
            }
            function createCommonjsModule(fn, module) {
              return module = {
                exports: {}
              }, fn(module, module.exports), module.exports;
            }
            var isMobile = function isMobile() {
              return /Android/i.test(navigator.userAgent) || /iPhone|iPad|iPod/i.test(navigator.userAgent);
            };
            var copyArray = function copyArray(source, dest) {
              for (var i = 0, n = source.length; i < n; i++) {
                dest[i] = source[i];
              }
            };
            var extend = function extend(dest, src) {
              for (var key in src) {
                if (src.hasOwnProperty(key)) {
                  dest[key] = src[key];
                }
              }
              return dest;
            };
            var cardboardVrDisplay = createCommonjsModule(function (module, exports) {
              /**
               * @license
               * cardboard-vr-display
               * Copyright (c) 2015-2017 Google
               * Licensed under the Apache License, Version 2.0 (the "License");
               * you may not use this file except in compliance with the License.
               * You may obtain a copy of the License at
               *
               * http://www.apache.org/licenses/LICENSE-2.0
               *
               * Unless required by applicable law or agreed to in writing, software
               * distributed under the License is distributed on an "AS IS" BASIS,
               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
               * See the License for the specific language governing permissions and
               * limitations under the License.
               */
              /**
               * @license
               * gl-preserve-state
               * Copyright (c) 2016, Brandon Jones.
               *
               * Permission is hereby granted, free of charge, to any person obtaining a copy
               * of this software and associated documentation files (the "Software"), to deal
               * in the Software without restriction, including without limitation the rights
               * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
               * copies of the Software, and to permit persons to whom the Software is
               * furnished to do so, subject to the following conditions:
               *
               * The above copyright notice and this permission notice shall be included in
               * all copies or substantial portions of the Software.
               *
               * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
               * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
               * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
               * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
               * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
               * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
               * THE SOFTWARE.
               */
              /**
               * @license
               * webvr-polyfill-dpdb
               * Copyright (c) 2015-2017 Google
               * Licensed under the Apache License, Version 2.0 (the "License");
               * you may not use this file except in compliance with the License.
               * You may obtain a copy of the License at
               *
               * http://www.apache.org/licenses/LICENSE-2.0
               *
               * Unless required by applicable law or agreed to in writing, software
               * distributed under the License is distributed on an "AS IS" BASIS,
               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
               * See the License for the specific language governing permissions and
               * limitations under the License.
               */
              /**
               * @license
               * nosleep.js
               * Copyright (c) 2017, Rich Tibbett
               *
               * Permission is hereby granted, free of charge, to any person obtaining a copy
               * of this software and associated documentation files (the "Software"), to deal
               * in the Software without restriction, including without limitation the rights
               * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
               * copies of the Software, and to permit persons to whom the Software is
               * furnished to do so, subject to the following conditions:
               *
               * The above copyright notice and this permission notice shall be included in
               * all copies or substantial portions of the Software.
               *
               * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
               * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
               * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
               * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
               * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
               * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
               * THE SOFTWARE.
               */
              (function (global, factory) {
                module.exports = factory();
              })(commonjsGlobal, function () {
                var classCallCheck = function classCallCheck(instance, Constructor) {
                  if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                  }
                };
                var createClass = function () {
                  function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                      var descriptor = props[i];
                      descriptor.enumerable = descriptor.enumerable || false;
                      descriptor.configurable = true;
                      if ("value" in descriptor) descriptor.writable = true;
                      Object.defineProperty(target, descriptor.key, descriptor);
                    }
                  }
                  return function (Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                  };
                }();
                var slicedToArray = function () {
                  function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                        _arr.push(_s.value);
                        if (i && _arr.length === i) break;
                      }
                    } catch (err) {
                      _d = true;
                      _e = err;
                    } finally {
                      try {
                        if (!_n && _i["return"]) _i["return"]();
                      } finally {
                        if (_d) throw _e;
                      }
                    }
                    return _arr;
                  }
                  return function (arr, i) {
                    if (Array.isArray(arr)) {
                      return arr;
                    } else if (Symbol.iterator in Object(arr)) {
                      return sliceIterator(arr, i);
                    } else {
                      throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }
                  };
                }();
                var MIN_TIMESTEP = 0.001;
                var MAX_TIMESTEP = 1;
                var dataUri = function dataUri(mimeType, svg) {
                  return 'data:' + mimeType + ',' + encodeURIComponent(svg);
                };
                var lerp = function lerp(a, b, t) {
                  return a + (b - a) * t;
                };
                var isIOS = function () {
                  var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);
                  return function () {
                    return isIOS;
                  };
                }();
                var isWebViewAndroid = function () {
                  var isWebViewAndroid = navigator.userAgent.indexOf('Version') !== -1 && navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Chrome') !== -1;
                  return function () {
                    return isWebViewAndroid;
                  };
                }();
                var isSafari = function () {
                  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                  return function () {
                    return isSafari;
                  };
                }();
                var isFirefoxAndroid = function () {
                  var isFirefoxAndroid = navigator.userAgent.indexOf('Firefox') !== -1 && navigator.userAgent.indexOf('Android') !== -1;
                  return function () {
                    return isFirefoxAndroid;
                  };
                }();
                var getChromeVersion = function () {
                  var match = navigator.userAgent.match(/.*Chrome\/([0-9]+)/);
                  var value = match ? parseInt(match[1], 10) : null;
                  return function () {
                    return value;
                  };
                }();
                var isSafariWithoutDeviceMotion = function () {
                  var value = false;
                  value = isIOS() && isSafari() && navigator.userAgent.indexOf('13_4') !== -1;
                  return function () {
                    return value;
                  };
                }();
                var isChromeWithoutDeviceMotion = function () {
                  var value = false;
                  if (getChromeVersion() === 65) {
                    var match = navigator.userAgent.match(/.*Chrome\/([0-9\.]*)/);
                    if (match) {
                      var _match$1$split = match[1].split('.'),
                        _match$1$split2 = slicedToArray(_match$1$split, 4),
                        major = _match$1$split2[0],
                        minor = _match$1$split2[1],
                        branch = _match$1$split2[2],
                        build = _match$1$split2[3];
                      value = parseInt(branch, 10) === 3325 && parseInt(build, 10) < 148;
                    }
                  }
                  return function () {
                    return value;
                  };
                }();
                var isR7 = function () {
                  var isR7 = navigator.userAgent.indexOf('R7 Build') !== -1;
                  return function () {
                    return isR7;
                  };
                }();
                var isLandscapeMode = function isLandscapeMode() {
                  var rtn = window.orientation == 90 || window.orientation == -90;
                  return isR7() ? !rtn : rtn;
                };
                var isTimestampDeltaValid = function isTimestampDeltaValid(timestampDeltaS) {
                  if (isNaN(timestampDeltaS)) {
                    return false;
                  }
                  if (timestampDeltaS <= MIN_TIMESTEP) {
                    return false;
                  }
                  if (timestampDeltaS > MAX_TIMESTEP) {
                    return false;
                  }
                  return true;
                };
                var getScreenWidth = function getScreenWidth() {
                  return Math.max(window.screen.width, window.screen.height) * window.devicePixelRatio;
                };
                var getScreenHeight = function getScreenHeight() {
                  return Math.min(window.screen.width, window.screen.height) * window.devicePixelRatio;
                };
                var requestFullscreen = function requestFullscreen(element) {
                  if (isWebViewAndroid()) {
                    return false;
                  }
                  if (element.requestFullscreen) {
                    element.requestFullscreen();
                  } else if (element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen();
                  } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                  } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                  } else {
                    return false;
                  }
                  return true;
                };
                var exitFullscreen = function exitFullscreen() {
                  if (document.exitFullscreen) {
                    document.exitFullscreen();
                  } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                  } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                  } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                  } else {
                    return false;
                  }
                  return true;
                };
                var getFullscreenElement = function getFullscreenElement() {
                  return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                };
                var linkProgram = function linkProgram(gl, vertexSource, fragmentSource, attribLocationMap) {
                  var vertexShader = gl.createShader(gl.VERTEX_SHADER);
                  gl.shaderSource(vertexShader, vertexSource);
                  gl.compileShader(vertexShader);
                  var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
                  gl.shaderSource(fragmentShader, fragmentSource);
                  gl.compileShader(fragmentShader);
                  var program = gl.createProgram();
                  gl.attachShader(program, vertexShader);
                  gl.attachShader(program, fragmentShader);
                  for (var attribName in attribLocationMap) {
                    gl.bindAttribLocation(program, attribLocationMap[attribName], attribName);
                  }
                  gl.linkProgram(program);
                  gl.deleteShader(vertexShader);
                  gl.deleteShader(fragmentShader);
                  return program;
                };
                var getProgramUniforms = function getProgramUniforms(gl, program) {
                  var uniforms = {};
                  var uniformCount = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
                  var uniformName = '';
                  for (var i = 0; i < uniformCount; i++) {
                    var uniformInfo = gl.getActiveUniform(program, i);
                    uniformName = uniformInfo.name.replace('[0]', '');
                    uniforms[uniformName] = gl.getUniformLocation(program, uniformName);
                  }
                  return uniforms;
                };
                var orthoMatrix = function orthoMatrix(out, left, right, bottom, top, near, far) {
                  var lr = 1 / (left - right),
                    bt = 1 / (bottom - top),
                    nf = 1 / (near - far);
                  out[0] = -2 * lr;
                  out[1] = 0;
                  out[2] = 0;
                  out[3] = 0;
                  out[4] = 0;
                  out[5] = -2 * bt;
                  out[6] = 0;
                  out[7] = 0;
                  out[8] = 0;
                  out[9] = 0;
                  out[10] = 2 * nf;
                  out[11] = 0;
                  out[12] = (left + right) * lr;
                  out[13] = (top + bottom) * bt;
                  out[14] = (far + near) * nf;
                  out[15] = 1;
                  return out;
                };
                var isMobile = function isMobile() {
                  var check = false;
                  (function (a) {
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
                  })(navigator.userAgent || navigator.vendor || window.opera);
                  return check;
                };
                var extend = function extend(dest, src) {
                  for (var key in src) {
                    if (src.hasOwnProperty(key)) {
                      dest[key] = src[key];
                    }
                  }
                  return dest;
                };
                var safariCssSizeWorkaround = function safariCssSizeWorkaround(canvas) {
                  if (isIOS()) {
                    var width = canvas.style.width;
                    var height = canvas.style.height;
                    canvas.style.width = parseInt(width) + 1 + 'px';
                    canvas.style.height = parseInt(height) + 'px';
                    setTimeout(function () {
                      canvas.style.width = width;
                      canvas.style.height = height;
                    }, 100);
                  }
                  window.canvas = canvas;
                };
                var frameDataFromPose = function () {
                  var piOver180 = Math.PI / 180.0;
                  var rad45 = Math.PI * 0.25;
                  function mat4_perspectiveFromFieldOfView(out, fov, near, far) {
                    var upTan = Math.tan(fov ? fov.upDegrees * piOver180 : rad45),
                      downTan = Math.tan(fov ? fov.downDegrees * piOver180 : rad45),
                      leftTan = Math.tan(fov ? fov.leftDegrees * piOver180 : rad45),
                      rightTan = Math.tan(fov ? fov.rightDegrees * piOver180 : rad45),
                      xScale = 2.0 / (leftTan + rightTan),
                      yScale = 2.0 / (upTan + downTan);
                    out[0] = xScale;
                    out[1] = 0.0;
                    out[2] = 0.0;
                    out[3] = 0.0;
                    out[4] = 0.0;
                    out[5] = yScale;
                    out[6] = 0.0;
                    out[7] = 0.0;
                    out[8] = -((leftTan - rightTan) * xScale * 0.5);
                    out[9] = (upTan - downTan) * yScale * 0.5;
                    out[10] = far / (near - far);
                    out[11] = -1.0;
                    out[12] = 0.0;
                    out[13] = 0.0;
                    out[14] = far * near / (near - far);
                    out[15] = 0.0;
                    return out;
                  }
                  function mat4_fromRotationTranslation(out, q, v) {
                    var x = q[0],
                      y = q[1],
                      z = q[2],
                      w = q[3],
                      x2 = x + x,
                      y2 = y + y,
                      z2 = z + z,
                      xx = x * x2,
                      xy = x * y2,
                      xz = x * z2,
                      yy = y * y2,
                      yz = y * z2,
                      zz = z * z2,
                      wx = w * x2,
                      wy = w * y2,
                      wz = w * z2;
                    out[0] = 1 - (yy + zz);
                    out[1] = xy + wz;
                    out[2] = xz - wy;
                    out[3] = 0;
                    out[4] = xy - wz;
                    out[5] = 1 - (xx + zz);
                    out[6] = yz + wx;
                    out[7] = 0;
                    out[8] = xz + wy;
                    out[9] = yz - wx;
                    out[10] = 1 - (xx + yy);
                    out[11] = 0;
                    out[12] = v[0];
                    out[13] = v[1];
                    out[14] = v[2];
                    out[15] = 1;
                    return out;
                  }
                  function mat4_translate(out, a, v) {
                    var x = v[0],
                      y = v[1],
                      z = v[2],
                      a00,
                      a01,
                      a02,
                      a03,
                      a10,
                      a11,
                      a12,
                      a13,
                      a20,
                      a21,
                      a22,
                      a23;
                    if (a === out) {
                      out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
                      out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
                      out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
                      out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
                    } else {
                      a00 = a[0];
                      a01 = a[1];
                      a02 = a[2];
                      a03 = a[3];
                      a10 = a[4];
                      a11 = a[5];
                      a12 = a[6];
                      a13 = a[7];
                      a20 = a[8];
                      a21 = a[9];
                      a22 = a[10];
                      a23 = a[11];
                      out[0] = a00;
                      out[1] = a01;
                      out[2] = a02;
                      out[3] = a03;
                      out[4] = a10;
                      out[5] = a11;
                      out[6] = a12;
                      out[7] = a13;
                      out[8] = a20;
                      out[9] = a21;
                      out[10] = a22;
                      out[11] = a23;
                      out[12] = a00 * x + a10 * y + a20 * z + a[12];
                      out[13] = a01 * x + a11 * y + a21 * z + a[13];
                      out[14] = a02 * x + a12 * y + a22 * z + a[14];
                      out[15] = a03 * x + a13 * y + a23 * z + a[15];
                    }
                    return out;
                  }
                  function mat4_invert(out, a) {
                    var a00 = a[0],
                      a01 = a[1],
                      a02 = a[2],
                      a03 = a[3],
                      a10 = a[4],
                      a11 = a[5],
                      a12 = a[6],
                      a13 = a[7],
                      a20 = a[8],
                      a21 = a[9],
                      a22 = a[10],
                      a23 = a[11],
                      a30 = a[12],
                      a31 = a[13],
                      a32 = a[14],
                      a33 = a[15],
                      b00 = a00 * a11 - a01 * a10,
                      b01 = a00 * a12 - a02 * a10,
                      b02 = a00 * a13 - a03 * a10,
                      b03 = a01 * a12 - a02 * a11,
                      b04 = a01 * a13 - a03 * a11,
                      b05 = a02 * a13 - a03 * a12,
                      b06 = a20 * a31 - a21 * a30,
                      b07 = a20 * a32 - a22 * a30,
                      b08 = a20 * a33 - a23 * a30,
                      b09 = a21 * a32 - a22 * a31,
                      b10 = a21 * a33 - a23 * a31,
                      b11 = a22 * a33 - a23 * a32,
                      det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                    if (!det) {
                      return null;
                    }
                    det = 1.0 / det;
                    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
                    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
                    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
                    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
                    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
                    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
                    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
                    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
                    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
                    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
                    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
                    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
                    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
                    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
                    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
                    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
                    return out;
                  }
                  var defaultOrientation = new Float32Array([0, 0, 0, 1]);
                  var defaultPosition = new Float32Array([0, 0, 0]);
                  function updateEyeMatrices(projection, view, pose, fov, offset, vrDisplay) {
                    mat4_perspectiveFromFieldOfView(projection, fov || null, vrDisplay.depthNear, vrDisplay.depthFar);
                    var orientation = pose.orientation || defaultOrientation;
                    var position = pose.position || defaultPosition;
                    mat4_fromRotationTranslation(view, orientation, position);
                    if (offset) mat4_translate(view, view, offset);
                    mat4_invert(view, view);
                  }
                  return function (frameData, pose, vrDisplay) {
                    if (!frameData || !pose) return false;
                    frameData.pose = pose;
                    frameData.timestamp = pose.timestamp;
                    updateEyeMatrices(frameData.leftProjectionMatrix, frameData.leftViewMatrix, pose, vrDisplay._getFieldOfView("left"), vrDisplay._getEyeOffset("left"), vrDisplay);
                    updateEyeMatrices(frameData.rightProjectionMatrix, frameData.rightViewMatrix, pose, vrDisplay._getFieldOfView("right"), vrDisplay._getEyeOffset("right"), vrDisplay);
                    return true;
                  };
                }();
                var isInsideCrossOriginIFrame = function isInsideCrossOriginIFrame() {
                  var isFramed = window.self !== window.top;
                  var refOrigin = getOriginFromUrl(document.referrer);
                  var thisOrigin = getOriginFromUrl(window.location.href);
                  return isFramed && refOrigin !== thisOrigin;
                };
                var getOriginFromUrl = function getOriginFromUrl(url) {
                  var domainIdx;
                  var protoSepIdx = url.indexOf("://");
                  if (protoSepIdx !== -1) {
                    domainIdx = protoSepIdx + 3;
                  } else {
                    domainIdx = 0;
                  }
                  var domainEndIdx = url.indexOf('/', domainIdx);
                  if (domainEndIdx === -1) {
                    domainEndIdx = url.length;
                  }
                  return url.substring(0, domainEndIdx);
                };
                var getQuaternionAngle = function getQuaternionAngle(quat) {
                  if (quat.w > 1) {
                    console.warn('getQuaternionAngle: w > 1');
                    return 0;
                  }
                  var angle = 2 * Math.acos(quat.w);
                  return angle;
                };
                var warnOnce = function () {
                  var observedWarnings = {};
                  return function (key, message) {
                    if (observedWarnings[key] === undefined) {
                      console.warn('webvr-polyfill: ' + message);
                      observedWarnings[key] = true;
                    }
                  };
                }();
                var deprecateWarning = function deprecateWarning(deprecated, suggested) {
                  var alternative = suggested ? 'Please use ' + suggested + ' instead.' : '';
                  warnOnce(deprecated, deprecated + ' has been deprecated. ' + 'This may not work on native WebVR displays. ' + alternative);
                };
                function WGLUPreserveGLState(gl, bindings, callback) {
                  if (!bindings) {
                    callback(gl);
                    return;
                  }
                  var boundValues = [];
                  var activeTexture = null;
                  for (var i = 0; i < bindings.length; ++i) {
                    var binding = bindings[i];
                    switch (binding) {
                      case gl.TEXTURE_BINDING_2D:
                      case gl.TEXTURE_BINDING_CUBE_MAP:
                        var textureUnit = bindings[++i];
                        if (textureUnit < gl.TEXTURE0 || textureUnit > gl.TEXTURE31) {
                          console.error("TEXTURE_BINDING_2D or TEXTURE_BINDING_CUBE_MAP must be followed by a valid texture unit");
                          boundValues.push(null, null);
                          break;
                        }
                        if (!activeTexture) {
                          activeTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
                        }
                        gl.activeTexture(textureUnit);
                        boundValues.push(gl.getParameter(binding), null);
                        break;
                      case gl.ACTIVE_TEXTURE:
                        activeTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
                        boundValues.push(null);
                        break;
                      default:
                        boundValues.push(gl.getParameter(binding));
                        break;
                    }
                  }
                  callback(gl);
                  for (var i = 0; i < bindings.length; ++i) {
                    var binding = bindings[i];
                    var boundValue = boundValues[i];
                    switch (binding) {
                      case gl.ACTIVE_TEXTURE:
                        break;
                      case gl.ARRAY_BUFFER_BINDING:
                        gl.bindBuffer(gl.ARRAY_BUFFER, boundValue);
                        break;
                      case gl.COLOR_CLEAR_VALUE:
                        gl.clearColor(boundValue[0], boundValue[1], boundValue[2], boundValue[3]);
                        break;
                      case gl.COLOR_WRITEMASK:
                        gl.colorMask(boundValue[0], boundValue[1], boundValue[2], boundValue[3]);
                        break;
                      case gl.CURRENT_PROGRAM:
                        gl.useProgram(boundValue);
                        break;
                      case gl.ELEMENT_ARRAY_BUFFER_BINDING:
                        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, boundValue);
                        break;
                      case gl.FRAMEBUFFER_BINDING:
                        gl.bindFramebuffer(gl.FRAMEBUFFER, boundValue);
                        break;
                      case gl.RENDERBUFFER_BINDING:
                        gl.bindRenderbuffer(gl.RENDERBUFFER, boundValue);
                        break;
                      case gl.TEXTURE_BINDING_2D:
                        var textureUnit = bindings[++i];
                        if (textureUnit < gl.TEXTURE0 || textureUnit > gl.TEXTURE31) break;
                        gl.activeTexture(textureUnit);
                        gl.bindTexture(gl.TEXTURE_2D, boundValue);
                        break;
                      case gl.TEXTURE_BINDING_CUBE_MAP:
                        var textureUnit = bindings[++i];
                        if (textureUnit < gl.TEXTURE0 || textureUnit > gl.TEXTURE31) break;
                        gl.activeTexture(textureUnit);
                        gl.bindTexture(gl.TEXTURE_CUBE_MAP, boundValue);
                        break;
                      case gl.VIEWPORT:
                        gl.viewport(boundValue[0], boundValue[1], boundValue[2], boundValue[3]);
                        break;
                      case gl.BLEND:
                      case gl.CULL_FACE:
                      case gl.DEPTH_TEST:
                      case gl.SCISSOR_TEST:
                      case gl.STENCIL_TEST:
                        if (boundValue) {
                          gl.enable(binding);
                        } else {
                          gl.disable(binding);
                        }
                        break;
                      default:
                        console.log("No GL restore behavior for 0x" + binding.toString(16));
                        break;
                    }
                    if (activeTexture) {
                      gl.activeTexture(activeTexture);
                    }
                  }
                }
                var glPreserveState = WGLUPreserveGLState;
                var distortionVS = ['attribute vec2 position;', 'attribute vec3 texCoord;', 'varying vec2 vTexCoord;', 'uniform vec4 viewportOffsetScale[2];', 'void main() {', '  vec4 viewport = viewportOffsetScale[int(texCoord.z)];', '  vTexCoord = (texCoord.xy * viewport.zw) + viewport.xy;', '  gl_Position = vec4( position, 1.0, 1.0 );', '}'].join('\n');
                var distortionFS = ['precision mediump float;', 'uniform sampler2D diffuse;', 'varying vec2 vTexCoord;', 'void main() {', '  gl_FragColor = texture2D(diffuse, vTexCoord);', '}'].join('\n');
                function CardboardDistorter(gl, cardboardUI, bufferScale, dirtySubmitFrameBindings) {
                  this.gl = gl;
                  this.cardboardUI = cardboardUI;
                  this.bufferScale = bufferScale;
                  this.dirtySubmitFrameBindings = dirtySubmitFrameBindings;
                  this.ctxAttribs = gl.getContextAttributes();
                  this.instanceExt = gl.getExtension('ANGLE_instanced_arrays');
                  this.meshWidth = 20;
                  this.meshHeight = 20;
                  this.bufferWidth = gl.drawingBufferWidth;
                  this.bufferHeight = gl.drawingBufferHeight;
                  this.realBindFramebuffer = gl.bindFramebuffer;
                  this.realEnable = gl.enable;
                  this.realDisable = gl.disable;
                  this.realColorMask = gl.colorMask;
                  this.realClearColor = gl.clearColor;
                  this.realViewport = gl.viewport;
                  if (!isIOS()) {
                    this.realCanvasWidth = Object.getOwnPropertyDescriptor(gl.canvas.__proto__, 'width');
                    this.realCanvasHeight = Object.getOwnPropertyDescriptor(gl.canvas.__proto__, 'height');
                  }
                  this.isPatched = false;
                  this.lastBoundFramebuffer = null;
                  this.cullFace = false;
                  this.depthTest = false;
                  this.blend = false;
                  this.scissorTest = false;
                  this.stencilTest = false;
                  this.viewport = [0, 0, 0, 0];
                  this.colorMask = [true, true, true, true];
                  this.clearColor = [0, 0, 0, 0];
                  this.attribs = {
                    position: 0,
                    texCoord: 1
                  };
                  this.program = linkProgram(gl, distortionVS, distortionFS, this.attribs);
                  this.uniforms = getProgramUniforms(gl, this.program);
                  this.viewportOffsetScale = new Float32Array(8);
                  this.setTextureBounds();
                  this.vertexBuffer = gl.createBuffer();
                  this.indexBuffer = gl.createBuffer();
                  this.indexCount = 0;
                  this.renderTarget = gl.createTexture();
                  this.framebuffer = gl.createFramebuffer();
                  this.depthStencilBuffer = null;
                  this.depthBuffer = null;
                  this.stencilBuffer = null;
                  if (this.ctxAttribs.depth && this.ctxAttribs.stencil) {
                    this.depthStencilBuffer = gl.createRenderbuffer();
                  } else if (this.ctxAttribs.depth) {
                    this.depthBuffer = gl.createRenderbuffer();
                  } else if (this.ctxAttribs.stencil) {
                    this.stencilBuffer = gl.createRenderbuffer();
                  }
                  this.patch();
                  this.onResize();
                }
                CardboardDistorter.prototype.destroy = function () {
                  var gl = this.gl;
                  this.unpatch();
                  gl.deleteProgram(this.program);
                  gl.deleteBuffer(this.vertexBuffer);
                  gl.deleteBuffer(this.indexBuffer);
                  gl.deleteTexture(this.renderTarget);
                  gl.deleteFramebuffer(this.framebuffer);
                  if (this.depthStencilBuffer) {
                    gl.deleteRenderbuffer(this.depthStencilBuffer);
                  }
                  if (this.depthBuffer) {
                    gl.deleteRenderbuffer(this.depthBuffer);
                  }
                  if (this.stencilBuffer) {
                    gl.deleteRenderbuffer(this.stencilBuffer);
                  }
                  if (this.cardboardUI) {
                    this.cardboardUI.destroy();
                  }
                };
                CardboardDistorter.prototype.onResize = function () {
                  var gl = this.gl;
                  var self = this;
                  var glState = [gl.RENDERBUFFER_BINDING, gl.TEXTURE_BINDING_2D, gl.TEXTURE0];
                  glPreserveState(gl, glState, function (gl) {
                    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, null);
                    if (self.scissorTest) {
                      self.realDisable.call(gl, gl.SCISSOR_TEST);
                    }
                    self.realColorMask.call(gl, true, true, true, true);
                    self.realViewport.call(gl, 0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
                    self.realClearColor.call(gl, 0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, self.framebuffer);
                    gl.bindTexture(gl.TEXTURE_2D, self.renderTarget);
                    gl.texImage2D(gl.TEXTURE_2D, 0, self.ctxAttribs.alpha ? gl.RGBA : gl.RGB, self.bufferWidth, self.bufferHeight, 0, self.ctxAttribs.alpha ? gl.RGBA : gl.RGB, gl.UNSIGNED_BYTE, null);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, self.renderTarget, 0);
                    if (self.ctxAttribs.depth && self.ctxAttribs.stencil) {
                      gl.bindRenderbuffer(gl.RENDERBUFFER, self.depthStencilBuffer);
                      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, self.bufferWidth, self.bufferHeight);
                      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, self.depthStencilBuffer);
                    } else if (self.ctxAttribs.depth) {
                      gl.bindRenderbuffer(gl.RENDERBUFFER, self.depthBuffer);
                      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, self.bufferWidth, self.bufferHeight);
                      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, self.depthBuffer);
                    } else if (self.ctxAttribs.stencil) {
                      gl.bindRenderbuffer(gl.RENDERBUFFER, self.stencilBuffer);
                      gl.renderbufferStorage(gl.RENDERBUFFER, gl.STENCIL_INDEX8, self.bufferWidth, self.bufferHeight);
                      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.STENCIL_ATTACHMENT, gl.RENDERBUFFER, self.stencilBuffer);
                    }
                    if (!gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE) {
                      console.error('Framebuffer incomplete!');
                    }
                    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, self.lastBoundFramebuffer);
                    if (self.scissorTest) {
                      self.realEnable.call(gl, gl.SCISSOR_TEST);
                    }
                    self.realColorMask.apply(gl, self.colorMask);
                    self.realViewport.apply(gl, self.viewport);
                    self.realClearColor.apply(gl, self.clearColor);
                  });
                  if (this.cardboardUI) {
                    this.cardboardUI.onResize();
                  }
                };
                CardboardDistorter.prototype.patch = function () {
                  if (this.isPatched) {
                    return;
                  }
                  var self = this;
                  var canvas = this.gl.canvas;
                  var gl = this.gl;
                  if (!isIOS()) {
                    canvas.width = getScreenWidth() * this.bufferScale;
                    canvas.height = getScreenHeight() * this.bufferScale;
                    Object.defineProperty(canvas, 'width', {
                      configurable: true,
                      enumerable: true,
                      get: function get() {
                        return self.bufferWidth;
                      },
                      set: function set(value) {
                        self.bufferWidth = value;
                        self.realCanvasWidth.set.call(canvas, value);
                        self.onResize();
                      }
                    });
                    Object.defineProperty(canvas, 'height', {
                      configurable: true,
                      enumerable: true,
                      get: function get() {
                        return self.bufferHeight;
                      },
                      set: function set(value) {
                        self.bufferHeight = value;
                        self.realCanvasHeight.set.call(canvas, value);
                        self.onResize();
                      }
                    });
                  }
                  this.lastBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
                  if (this.lastBoundFramebuffer == null) {
                    this.lastBoundFramebuffer = this.framebuffer;
                    this.gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
                  }
                  this.gl.bindFramebuffer = function (target, framebuffer) {
                    self.lastBoundFramebuffer = framebuffer ? framebuffer : self.framebuffer;
                    self.realBindFramebuffer.call(gl, target, self.lastBoundFramebuffer);
                  };
                  this.cullFace = gl.getParameter(gl.CULL_FACE);
                  this.depthTest = gl.getParameter(gl.DEPTH_TEST);
                  this.blend = gl.getParameter(gl.BLEND);
                  this.scissorTest = gl.getParameter(gl.SCISSOR_TEST);
                  this.stencilTest = gl.getParameter(gl.STENCIL_TEST);
                  gl.enable = function (pname) {
                    switch (pname) {
                      case gl.CULL_FACE:
                        self.cullFace = true;
                        break;
                      case gl.DEPTH_TEST:
                        self.depthTest = true;
                        break;
                      case gl.BLEND:
                        self.blend = true;
                        break;
                      case gl.SCISSOR_TEST:
                        self.scissorTest = true;
                        break;
                      case gl.STENCIL_TEST:
                        self.stencilTest = true;
                        break;
                    }
                    self.realEnable.call(gl, pname);
                  };
                  gl.disable = function (pname) {
                    switch (pname) {
                      case gl.CULL_FACE:
                        self.cullFace = false;
                        break;
                      case gl.DEPTH_TEST:
                        self.depthTest = false;
                        break;
                      case gl.BLEND:
                        self.blend = false;
                        break;
                      case gl.SCISSOR_TEST:
                        self.scissorTest = false;
                        break;
                      case gl.STENCIL_TEST:
                        self.stencilTest = false;
                        break;
                    }
                    self.realDisable.call(gl, pname);
                  };
                  this.colorMask = gl.getParameter(gl.COLOR_WRITEMASK);
                  gl.colorMask = function (r, g, b, a) {
                    self.colorMask[0] = r;
                    self.colorMask[1] = g;
                    self.colorMask[2] = b;
                    self.colorMask[3] = a;
                    self.realColorMask.call(gl, r, g, b, a);
                  };
                  this.clearColor = gl.getParameter(gl.COLOR_CLEAR_VALUE);
                  gl.clearColor = function (r, g, b, a) {
                    self.clearColor[0] = r;
                    self.clearColor[1] = g;
                    self.clearColor[2] = b;
                    self.clearColor[3] = a;
                    self.realClearColor.call(gl, r, g, b, a);
                  };
                  this.viewport = gl.getParameter(gl.VIEWPORT);
                  gl.viewport = function (x, y, w, h) {
                    self.viewport[0] = x;
                    self.viewport[1] = y;
                    self.viewport[2] = w;
                    self.viewport[3] = h;
                    self.realViewport.call(gl, x, y, w, h);
                  };
                  this.isPatched = true;
                  safariCssSizeWorkaround(canvas);
                };
                CardboardDistorter.prototype.unpatch = function () {
                  if (!this.isPatched) {
                    return;
                  }
                  var gl = this.gl;
                  var canvas = this.gl.canvas;
                  if (!isIOS()) {
                    Object.defineProperty(canvas, 'width', this.realCanvasWidth);
                    Object.defineProperty(canvas, 'height', this.realCanvasHeight);
                  }
                  canvas.width = this.bufferWidth;
                  canvas.height = this.bufferHeight;
                  gl.bindFramebuffer = this.realBindFramebuffer;
                  gl.enable = this.realEnable;
                  gl.disable = this.realDisable;
                  gl.colorMask = this.realColorMask;
                  gl.clearColor = this.realClearColor;
                  gl.viewport = this.realViewport;
                  if (this.lastBoundFramebuffer == this.framebuffer) {
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                  }
                  this.isPatched = false;
                  setTimeout(function () {
                    safariCssSizeWorkaround(canvas);
                  }, 1);
                };
                CardboardDistorter.prototype.setTextureBounds = function (leftBounds, rightBounds) {
                  if (!leftBounds) {
                    leftBounds = [0, 0, 0.5, 1];
                  }
                  if (!rightBounds) {
                    rightBounds = [0.5, 0, 0.5, 1];
                  }
                  this.viewportOffsetScale[0] = leftBounds[0];
                  this.viewportOffsetScale[1] = leftBounds[1];
                  this.viewportOffsetScale[2] = leftBounds[2];
                  this.viewportOffsetScale[3] = leftBounds[3];
                  this.viewportOffsetScale[4] = rightBounds[0];
                  this.viewportOffsetScale[5] = rightBounds[1];
                  this.viewportOffsetScale[6] = rightBounds[2];
                  this.viewportOffsetScale[7] = rightBounds[3];
                };
                CardboardDistorter.prototype.submitFrame = function () {
                  var gl = this.gl;
                  var self = this;
                  var glState = [];
                  if (!this.dirtySubmitFrameBindings) {
                    glState.push(gl.CURRENT_PROGRAM, gl.ARRAY_BUFFER_BINDING, gl.ELEMENT_ARRAY_BUFFER_BINDING, gl.TEXTURE_BINDING_2D, gl.TEXTURE0);
                  }
                  glPreserveState(gl, glState, function (gl) {
                    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, null);
                    var positionDivisor = 0;
                    var texCoordDivisor = 0;
                    if (self.instanceExt) {
                      positionDivisor = gl.getVertexAttrib(self.attribs.position, self.instanceExt.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
                      texCoordDivisor = gl.getVertexAttrib(self.attribs.texCoord, self.instanceExt.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
                    }
                    if (self.cullFace) {
                      self.realDisable.call(gl, gl.CULL_FACE);
                    }
                    if (self.depthTest) {
                      self.realDisable.call(gl, gl.DEPTH_TEST);
                    }
                    if (self.blend) {
                      self.realDisable.call(gl, gl.BLEND);
                    }
                    if (self.scissorTest) {
                      self.realDisable.call(gl, gl.SCISSOR_TEST);
                    }
                    if (self.stencilTest) {
                      self.realDisable.call(gl, gl.STENCIL_TEST);
                    }
                    self.realColorMask.call(gl, true, true, true, true);
                    self.realViewport.call(gl, 0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
                    if (self.ctxAttribs.alpha || isIOS()) {
                      self.realClearColor.call(gl, 0, 0, 0, 1);
                      gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.useProgram(self.program);
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, self.indexBuffer);
                    gl.bindBuffer(gl.ARRAY_BUFFER, self.vertexBuffer);
                    gl.enableVertexAttribArray(self.attribs.position);
                    gl.enableVertexAttribArray(self.attribs.texCoord);
                    gl.vertexAttribPointer(self.attribs.position, 2, gl.FLOAT, false, 20, 0);
                    gl.vertexAttribPointer(self.attribs.texCoord, 3, gl.FLOAT, false, 20, 8);
                    if (self.instanceExt) {
                      if (positionDivisor != 0) {
                        self.instanceExt.vertexAttribDivisorANGLE(self.attribs.position, 0);
                      }
                      if (texCoordDivisor != 0) {
                        self.instanceExt.vertexAttribDivisorANGLE(self.attribs.texCoord, 0);
                      }
                    }
                    gl.activeTexture(gl.TEXTURE0);
                    gl.uniform1i(self.uniforms.diffuse, 0);
                    gl.bindTexture(gl.TEXTURE_2D, self.renderTarget);
                    gl.uniform4fv(self.uniforms.viewportOffsetScale, self.viewportOffsetScale);
                    gl.drawElements(gl.TRIANGLES, self.indexCount, gl.UNSIGNED_SHORT, 0);
                    if (self.cardboardUI) {
                      self.cardboardUI.renderNoState();
                    }
                    self.realBindFramebuffer.call(self.gl, gl.FRAMEBUFFER, self.framebuffer);
                    if (!self.ctxAttribs.preserveDrawingBuffer) {
                      self.realClearColor.call(gl, 0, 0, 0, 0);
                      gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    if (!self.dirtySubmitFrameBindings) {
                      self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, self.lastBoundFramebuffer);
                    }
                    if (self.cullFace) {
                      self.realEnable.call(gl, gl.CULL_FACE);
                    }
                    if (self.depthTest) {
                      self.realEnable.call(gl, gl.DEPTH_TEST);
                    }
                    if (self.blend) {
                      self.realEnable.call(gl, gl.BLEND);
                    }
                    if (self.scissorTest) {
                      self.realEnable.call(gl, gl.SCISSOR_TEST);
                    }
                    if (self.stencilTest) {
                      self.realEnable.call(gl, gl.STENCIL_TEST);
                    }
                    self.realColorMask.apply(gl, self.colorMask);
                    self.realViewport.apply(gl, self.viewport);
                    if (self.ctxAttribs.alpha || !self.ctxAttribs.preserveDrawingBuffer) {
                      self.realClearColor.apply(gl, self.clearColor);
                    }
                    if (self.instanceExt) {
                      if (positionDivisor != 0) {
                        self.instanceExt.vertexAttribDivisorANGLE(self.attribs.position, positionDivisor);
                      }
                      if (texCoordDivisor != 0) {
                        self.instanceExt.vertexAttribDivisorANGLE(self.attribs.texCoord, texCoordDivisor);
                      }
                    }
                  });
                  if (isIOS()) {
                    var canvas = gl.canvas;
                    if (canvas.width != self.bufferWidth || canvas.height != self.bufferHeight) {
                      self.bufferWidth = canvas.width;
                      self.bufferHeight = canvas.height;
                      self.onResize();
                    }
                  }
                };
                CardboardDistorter.prototype.updateDeviceInfo = function (deviceInfo) {
                  var gl = this.gl;
                  var self = this;
                  var glState = [gl.ARRAY_BUFFER_BINDING, gl.ELEMENT_ARRAY_BUFFER_BINDING];
                  glPreserveState(gl, glState, function (gl) {
                    var vertices = self.computeMeshVertices_(self.meshWidth, self.meshHeight, deviceInfo);
                    gl.bindBuffer(gl.ARRAY_BUFFER, self.vertexBuffer);
                    gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
                    if (!self.indexCount) {
                      var indices = self.computeMeshIndices_(self.meshWidth, self.meshHeight);
                      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, self.indexBuffer);
                      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
                      self.indexCount = indices.length;
                    }
                  });
                };
                CardboardDistorter.prototype.computeMeshVertices_ = function (width, height, deviceInfo) {
                  var vertices = new Float32Array(2 * width * height * 5);
                  var lensFrustum = deviceInfo.getLeftEyeVisibleTanAngles();
                  var noLensFrustum = deviceInfo.getLeftEyeNoLensTanAngles();
                  var viewport = deviceInfo.getLeftEyeVisibleScreenRect(noLensFrustum);
                  var vidx = 0;
                  for (var e = 0; e < 2; e++) {
                    for (var j = 0; j < height; j++) {
                      for (var i = 0; i < width; i++, vidx++) {
                        var u = i / (width - 1);
                        var v = j / (height - 1);
                        var s = u;
                        var t = v;
                        var x = lerp(lensFrustum[0], lensFrustum[2], u);
                        var y = lerp(lensFrustum[3], lensFrustum[1], v);
                        var d = Math.sqrt(x * x + y * y);
                        var r = deviceInfo.distortion.distortInverse(d);
                        var p = x * r / d;
                        var q = y * r / d;
                        u = (p - noLensFrustum[0]) / (noLensFrustum[2] - noLensFrustum[0]);
                        v = (q - noLensFrustum[3]) / (noLensFrustum[1] - noLensFrustum[3]);
                        u = (viewport.x + u * viewport.width - 0.5) * 2.0;
                        v = (viewport.y + v * viewport.height - 0.5) * 2.0;
                        vertices[vidx * 5 + 0] = u;
                        vertices[vidx * 5 + 1] = v;
                        vertices[vidx * 5 + 2] = s;
                        vertices[vidx * 5 + 3] = t;
                        vertices[vidx * 5 + 4] = e;
                      }
                    }
                    var w = lensFrustum[2] - lensFrustum[0];
                    lensFrustum[0] = -(w + lensFrustum[0]);
                    lensFrustum[2] = w - lensFrustum[2];
                    w = noLensFrustum[2] - noLensFrustum[0];
                    noLensFrustum[0] = -(w + noLensFrustum[0]);
                    noLensFrustum[2] = w - noLensFrustum[2];
                    viewport.x = 1 - (viewport.x + viewport.width);
                  }
                  return vertices;
                };
                CardboardDistorter.prototype.computeMeshIndices_ = function (width, height) {
                  var indices = new Uint16Array(2 * (width - 1) * (height - 1) * 6);
                  var halfwidth = width / 2;
                  var halfheight = height / 2;
                  var vidx = 0;
                  var iidx = 0;
                  for (var e = 0; e < 2; e++) {
                    for (var j = 0; j < height; j++) {
                      for (var i = 0; i < width; i++, vidx++) {
                        if (i == 0 || j == 0) continue;
                        if (i <= halfwidth == j <= halfheight) {
                          indices[iidx++] = vidx;
                          indices[iidx++] = vidx - width - 1;
                          indices[iidx++] = vidx - width;
                          indices[iidx++] = vidx - width - 1;
                          indices[iidx++] = vidx;
                          indices[iidx++] = vidx - 1;
                        } else {
                          indices[iidx++] = vidx - 1;
                          indices[iidx++] = vidx - width;
                          indices[iidx++] = vidx;
                          indices[iidx++] = vidx - width;
                          indices[iidx++] = vidx - 1;
                          indices[iidx++] = vidx - width - 1;
                        }
                      }
                    }
                  }
                  return indices;
                };
                CardboardDistorter.prototype.getOwnPropertyDescriptor_ = function (proto, attrName) {
                  var descriptor = Object.getOwnPropertyDescriptor(proto, attrName);
                  if (descriptor.get === undefined || descriptor.set === undefined) {
                    descriptor.configurable = true;
                    descriptor.enumerable = true;
                    descriptor.get = function () {
                      return this.getAttribute(attrName);
                    };
                    descriptor.set = function (val) {
                      this.setAttribute(attrName, val);
                    };
                  }
                  return descriptor;
                };
                var uiVS = ['attribute vec2 position;', 'uniform mat4 projectionMat;', 'void main() {', '  gl_Position = projectionMat * vec4( position, -1.0, 1.0 );', '}'].join('\n');
                var uiFS = ['precision mediump float;', 'uniform vec4 color;', 'void main() {', '  gl_FragColor = color;', '}'].join('\n');
                var DEG2RAD = Math.PI / 180.0;
                var kAnglePerGearSection = 60;
                var kOuterRimEndAngle = 12;
                var kInnerRimBeginAngle = 20;
                var kOuterRadius = 1;
                var kMiddleRadius = 0.75;
                var kInnerRadius = 0.3125;
                var kCenterLineThicknessDp = 4;
                var kButtonWidthDp = 28;
                var kTouchSlopFactor = 1.5;
                function CardboardUI(gl) {
                  this.gl = gl;
                  this.attribs = {
                    position: 0
                  };
                  this.program = linkProgram(gl, uiVS, uiFS, this.attribs);
                  this.uniforms = getProgramUniforms(gl, this.program);
                  this.vertexBuffer = gl.createBuffer();
                  this.gearOffset = 0;
                  this.gearVertexCount = 0;
                  this.arrowOffset = 0;
                  this.arrowVertexCount = 0;
                  this.projMat = new Float32Array(16);
                  this.listener = null;
                  this.onResize();
                }
                CardboardUI.prototype.destroy = function () {
                  var gl = this.gl;
                  if (this.listener) {
                    gl.canvas.removeEventListener('click', this.listener, false);
                  }
                  gl.deleteProgram(this.program);
                  gl.deleteBuffer(this.vertexBuffer);
                };
                CardboardUI.prototype.listen = function (optionsCallback, backCallback) {
                  var canvas = this.gl.canvas;
                  this.listener = function (event) {
                    var midline = canvas.clientWidth / 2;
                    var buttonSize = kButtonWidthDp * kTouchSlopFactor;
                    if (event.clientX > midline - buttonSize && event.clientX < midline + buttonSize && event.clientY > canvas.clientHeight - buttonSize) {
                      optionsCallback(event);
                    } else if (event.clientX < buttonSize && event.clientY < buttonSize) {
                      backCallback(event);
                    }
                  };
                  canvas.addEventListener('click', this.listener, false);
                };
                CardboardUI.prototype.onResize = function () {
                  var gl = this.gl;
                  var self = this;
                  var glState = [gl.ARRAY_BUFFER_BINDING];
                  glPreserveState(gl, glState, function (gl) {
                    var vertices = [];
                    var midline = gl.drawingBufferWidth / 2;
                    var physicalPixels = Math.max(screen.width, screen.height) * window.devicePixelRatio;
                    var scalingRatio = gl.drawingBufferWidth / physicalPixels;
                    var dps = scalingRatio * window.devicePixelRatio;
                    var lineWidth = kCenterLineThicknessDp * dps / 2;
                    var buttonSize = kButtonWidthDp * kTouchSlopFactor * dps;
                    var buttonScale = kButtonWidthDp * dps / 2;
                    var buttonBorder = (kButtonWidthDp * kTouchSlopFactor - kButtonWidthDp) * dps;
                    vertices.push(midline - lineWidth, buttonSize);
                    vertices.push(midline - lineWidth, gl.drawingBufferHeight);
                    vertices.push(midline + lineWidth, buttonSize);
                    vertices.push(midline + lineWidth, gl.drawingBufferHeight);
                    self.gearOffset = vertices.length / 2;
                    function addGearSegment(theta, r) {
                      var angle = (90 - theta) * DEG2RAD;
                      var x = Math.cos(angle);
                      var y = Math.sin(angle);
                      vertices.push(kInnerRadius * x * buttonScale + midline, kInnerRadius * y * buttonScale + buttonScale);
                      vertices.push(r * x * buttonScale + midline, r * y * buttonScale + buttonScale);
                    }
                    for (var i = 0; i <= 6; i++) {
                      var segmentTheta = i * kAnglePerGearSection;
                      addGearSegment(segmentTheta, kOuterRadius);
                      addGearSegment(segmentTheta + kOuterRimEndAngle, kOuterRadius);
                      addGearSegment(segmentTheta + kInnerRimBeginAngle, kMiddleRadius);
                      addGearSegment(segmentTheta + (kAnglePerGearSection - kInnerRimBeginAngle), kMiddleRadius);
                      addGearSegment(segmentTheta + (kAnglePerGearSection - kOuterRimEndAngle), kOuterRadius);
                    }
                    self.gearVertexCount = vertices.length / 2 - self.gearOffset;
                    self.arrowOffset = vertices.length / 2;
                    function addArrowVertex(x, y) {
                      vertices.push(buttonBorder + x, gl.drawingBufferHeight - buttonBorder - y);
                    }
                    var angledLineWidth = lineWidth / Math.sin(45 * DEG2RAD);
                    addArrowVertex(0, buttonScale);
                    addArrowVertex(buttonScale, 0);
                    addArrowVertex(buttonScale + angledLineWidth, angledLineWidth);
                    addArrowVertex(angledLineWidth, buttonScale + angledLineWidth);
                    addArrowVertex(angledLineWidth, buttonScale - angledLineWidth);
                    addArrowVertex(0, buttonScale);
                    addArrowVertex(buttonScale, buttonScale * 2);
                    addArrowVertex(buttonScale + angledLineWidth, buttonScale * 2 - angledLineWidth);
                    addArrowVertex(angledLineWidth, buttonScale - angledLineWidth);
                    addArrowVertex(0, buttonScale);
                    addArrowVertex(angledLineWidth, buttonScale - lineWidth);
                    addArrowVertex(kButtonWidthDp * dps, buttonScale - lineWidth);
                    addArrowVertex(angledLineWidth, buttonScale + lineWidth);
                    addArrowVertex(kButtonWidthDp * dps, buttonScale + lineWidth);
                    self.arrowVertexCount = vertices.length / 2 - self.arrowOffset;
                    gl.bindBuffer(gl.ARRAY_BUFFER, self.vertexBuffer);
                    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
                  });
                };
                CardboardUI.prototype.render = function () {
                  var gl = this.gl;
                  var self = this;
                  var glState = [gl.CULL_FACE, gl.DEPTH_TEST, gl.BLEND, gl.SCISSOR_TEST, gl.STENCIL_TEST, gl.COLOR_WRITEMASK, gl.VIEWPORT, gl.CURRENT_PROGRAM, gl.ARRAY_BUFFER_BINDING];
                  glPreserveState(gl, glState, function (gl) {
                    gl.disable(gl.CULL_FACE);
                    gl.disable(gl.DEPTH_TEST);
                    gl.disable(gl.BLEND);
                    gl.disable(gl.SCISSOR_TEST);
                    gl.disable(gl.STENCIL_TEST);
                    gl.colorMask(true, true, true, true);
                    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
                    self.renderNoState();
                  });
                };
                CardboardUI.prototype.renderNoState = function () {
                  var gl = this.gl;
                  gl.useProgram(this.program);
                  gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
                  gl.enableVertexAttribArray(this.attribs.position);
                  gl.vertexAttribPointer(this.attribs.position, 2, gl.FLOAT, false, 8, 0);
                  gl.uniform4f(this.uniforms.color, 1.0, 1.0, 1.0, 1.0);
                  orthoMatrix(this.projMat, 0, gl.drawingBufferWidth, 0, gl.drawingBufferHeight, 0.1, 1024.0);
                  gl.uniformMatrix4fv(this.uniforms.projectionMat, false, this.projMat);
                  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
                  gl.drawArrays(gl.TRIANGLE_STRIP, this.gearOffset, this.gearVertexCount);
                  gl.drawArrays(gl.TRIANGLE_STRIP, this.arrowOffset, this.arrowVertexCount);
                };
                function Distortion(coefficients) {
                  this.coefficients = coefficients;
                }
                Distortion.prototype.distortInverse = function (radius) {
                  var r0 = 0;
                  var r1 = 1;
                  var dr0 = radius - this.distort(r0);
                  while (Math.abs(r1 - r0) > 0.0001) {
                    var dr1 = radius - this.distort(r1);
                    var r2 = r1 - dr1 * ((r1 - r0) / (dr1 - dr0));
                    r0 = r1;
                    r1 = r2;
                    dr0 = dr1;
                  }
                  return r1;
                };
                Distortion.prototype.distort = function (radius) {
                  var r2 = radius * radius;
                  var ret = 0;
                  for (var i = 0; i < this.coefficients.length; i++) {
                    ret = r2 * (ret + this.coefficients[i]);
                  }
                  return (ret + 1) * radius;
                };
                var degToRad = Math.PI / 180;
                var radToDeg = 180 / Math.PI;
                var Vector3 = function Vector3(x, y, z) {
                  this.x = x || 0;
                  this.y = y || 0;
                  this.z = z || 0;
                };
                Vector3.prototype = {
                  constructor: Vector3,
                  set: function set(x, y, z) {
                    this.x = x;
                    this.y = y;
                    this.z = z;
                    return this;
                  },
                  copy: function copy(v) {
                    this.x = v.x;
                    this.y = v.y;
                    this.z = v.z;
                    return this;
                  },
                  length: function length() {
                    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
                  },
                  normalize: function normalize() {
                    var scalar = this.length();
                    if (scalar !== 0) {
                      var invScalar = 1 / scalar;
                      this.multiplyScalar(invScalar);
                    } else {
                      this.x = 0;
                      this.y = 0;
                      this.z = 0;
                    }
                    return this;
                  },
                  multiplyScalar: function multiplyScalar(scalar) {
                    this.x *= scalar;
                    this.y *= scalar;
                    this.z *= scalar;
                  },
                  applyQuaternion: function applyQuaternion(q) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var qx = q.x;
                    var qy = q.y;
                    var qz = q.z;
                    var qw = q.w;
                    var ix = qw * x + qy * z - qz * y;
                    var iy = qw * y + qz * x - qx * z;
                    var iz = qw * z + qx * y - qy * x;
                    var iw = -qx * x - qy * y - qz * z;
                    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                    return this;
                  },
                  dot: function dot(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z;
                  },
                  crossVectors: function crossVectors(a, b) {
                    var ax = a.x,
                      ay = a.y,
                      az = a.z;
                    var bx = b.x,
                      by = b.y,
                      bz = b.z;
                    this.x = ay * bz - az * by;
                    this.y = az * bx - ax * bz;
                    this.z = ax * by - ay * bx;
                    return this;
                  }
                };
                var Quaternion = function Quaternion(x, y, z, w) {
                  this.x = x || 0;
                  this.y = y || 0;
                  this.z = z || 0;
                  this.w = w !== undefined ? w : 1;
                };
                Quaternion.prototype = {
                  constructor: Quaternion,
                  set: function set(x, y, z, w) {
                    this.x = x;
                    this.y = y;
                    this.z = z;
                    this.w = w;
                    return this;
                  },
                  copy: function copy(quaternion) {
                    this.x = quaternion.x;
                    this.y = quaternion.y;
                    this.z = quaternion.z;
                    this.w = quaternion.w;
                    return this;
                  },
                  setFromEulerXYZ: function setFromEulerXYZ(x, y, z) {
                    var c1 = Math.cos(x / 2);
                    var c2 = Math.cos(y / 2);
                    var c3 = Math.cos(z / 2);
                    var s1 = Math.sin(x / 2);
                    var s2 = Math.sin(y / 2);
                    var s3 = Math.sin(z / 2);
                    this.x = s1 * c2 * c3 + c1 * s2 * s3;
                    this.y = c1 * s2 * c3 - s1 * c2 * s3;
                    this.z = c1 * c2 * s3 + s1 * s2 * c3;
                    this.w = c1 * c2 * c3 - s1 * s2 * s3;
                    return this;
                  },
                  setFromEulerYXZ: function setFromEulerYXZ(x, y, z) {
                    var c1 = Math.cos(x / 2);
                    var c2 = Math.cos(y / 2);
                    var c3 = Math.cos(z / 2);
                    var s1 = Math.sin(x / 2);
                    var s2 = Math.sin(y / 2);
                    var s3 = Math.sin(z / 2);
                    this.x = s1 * c2 * c3 + c1 * s2 * s3;
                    this.y = c1 * s2 * c3 - s1 * c2 * s3;
                    this.z = c1 * c2 * s3 - s1 * s2 * c3;
                    this.w = c1 * c2 * c3 + s1 * s2 * s3;
                    return this;
                  },
                  setFromAxisAngle: function setFromAxisAngle(axis, angle) {
                    var halfAngle = angle / 2,
                      s = Math.sin(halfAngle);
                    this.x = axis.x * s;
                    this.y = axis.y * s;
                    this.z = axis.z * s;
                    this.w = Math.cos(halfAngle);
                    return this;
                  },
                  multiply: function multiply(q) {
                    return this.multiplyQuaternions(this, q);
                  },
                  multiplyQuaternions: function multiplyQuaternions(a, b) {
                    var qax = a.x,
                      qay = a.y,
                      qaz = a.z,
                      qaw = a.w;
                    var qbx = b.x,
                      qby = b.y,
                      qbz = b.z,
                      qbw = b.w;
                    this.x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
                    this.y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
                    this.z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
                    this.w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
                    return this;
                  },
                  inverse: function inverse() {
                    this.x *= -1;
                    this.y *= -1;
                    this.z *= -1;
                    this.normalize();
                    return this;
                  },
                  normalize: function normalize() {
                    var l = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
                    if (l === 0) {
                      this.x = 0;
                      this.y = 0;
                      this.z = 0;
                      this.w = 1;
                    } else {
                      l = 1 / l;
                      this.x = this.x * l;
                      this.y = this.y * l;
                      this.z = this.z * l;
                      this.w = this.w * l;
                    }
                    return this;
                  },
                  slerp: function slerp(qb, t) {
                    if (t === 0) return this;
                    if (t === 1) return this.copy(qb);
                    var x = this.x,
                      y = this.y,
                      z = this.z,
                      w = this.w;
                    var cosHalfTheta = w * qb.w + x * qb.x + y * qb.y + z * qb.z;
                    if (cosHalfTheta < 0) {
                      this.w = -qb.w;
                      this.x = -qb.x;
                      this.y = -qb.y;
                      this.z = -qb.z;
                      cosHalfTheta = -cosHalfTheta;
                    } else {
                      this.copy(qb);
                    }
                    if (cosHalfTheta >= 1.0) {
                      this.w = w;
                      this.x = x;
                      this.y = y;
                      this.z = z;
                      return this;
                    }
                    var halfTheta = Math.acos(cosHalfTheta);
                    var sinHalfTheta = Math.sqrt(1.0 - cosHalfTheta * cosHalfTheta);
                    if (Math.abs(sinHalfTheta) < 0.001) {
                      this.w = 0.5 * (w + this.w);
                      this.x = 0.5 * (x + this.x);
                      this.y = 0.5 * (y + this.y);
                      this.z = 0.5 * (z + this.z);
                      return this;
                    }
                    var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta,
                      ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
                    this.w = w * ratioA + this.w * ratioB;
                    this.x = x * ratioA + this.x * ratioB;
                    this.y = y * ratioA + this.y * ratioB;
                    this.z = z * ratioA + this.z * ratioB;
                    return this;
                  },
                  setFromUnitVectors: function () {
                    var v1, r;
                    var EPS = 0.000001;
                    return function (vFrom, vTo) {
                      if (v1 === undefined) v1 = new Vector3();
                      r = vFrom.dot(vTo) + 1;
                      if (r < EPS) {
                        r = 0;
                        if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                          v1.set(-vFrom.y, vFrom.x, 0);
                        } else {
                          v1.set(0, -vFrom.z, vFrom.y);
                        }
                      } else {
                        v1.crossVectors(vFrom, vTo);
                      }
                      this.x = v1.x;
                      this.y = v1.y;
                      this.z = v1.z;
                      this.w = r;
                      this.normalize();
                      return this;
                    };
                  }()
                };
                function Device(params) {
                  this.width = params.width || getScreenWidth();
                  this.height = params.height || getScreenHeight();
                  this.widthMeters = params.widthMeters;
                  this.heightMeters = params.heightMeters;
                  this.bevelMeters = params.bevelMeters;
                }
                var DEFAULT_ANDROID = new Device({
                  widthMeters: 0.110,
                  heightMeters: 0.062,
                  bevelMeters: 0.004
                });
                var DEFAULT_IOS = new Device({
                  widthMeters: 0.1038,
                  heightMeters: 0.0584,
                  bevelMeters: 0.004
                });
                var Viewers = {
                  CardboardV1: new CardboardViewer({
                    id: 'CardboardV1',
                    label: 'Cardboard I/O 2014',
                    fov: 40,
                    interLensDistance: 0.060,
                    baselineLensDistance: 0.035,
                    screenLensDistance: 0.042,
                    distortionCoefficients: [0.441, 0.156],
                    inverseCoefficients: [-0.4410035, 0.42756155, -0.4804439, 0.5460139, -0.58821183, 0.5733938, -0.48303202, 0.33299083, -0.17573841, 0.0651772, -0.01488963, 0.001559834]
                  }),
                  CardboardV2: new CardboardViewer({
                    id: 'CardboardV2',
                    label: 'Cardboard I/O 2015',
                    fov: 60,
                    interLensDistance: 0.064,
                    baselineLensDistance: 0.035,
                    screenLensDistance: 0.039,
                    distortionCoefficients: [0.34, 0.55],
                    inverseCoefficients: [-0.33836704, -0.18162185, 0.862655, -1.2462051, 1.0560602, -0.58208317, 0.21609078, -0.05444823, 0.009177956, -9.904169E-4, 6.183535E-5, -1.6981803E-6]
                  })
                };
                function DeviceInfo(deviceParams, additionalViewers) {
                  this.viewer = Viewers.CardboardV2;
                  this.updateDeviceParams(deviceParams);
                  this.distortion = new Distortion(this.viewer.distortionCoefficients);
                  for (var i = 0; i < additionalViewers.length; i++) {
                    var viewer = additionalViewers[i];
                    Viewers[viewer.id] = new CardboardViewer(viewer);
                  }
                }
                DeviceInfo.prototype.updateDeviceParams = function (deviceParams) {
                  this.device = this.determineDevice_(deviceParams) || this.device;
                };
                DeviceInfo.prototype.getDevice = function () {
                  return this.device;
                };
                DeviceInfo.prototype.setViewer = function (viewer) {
                  this.viewer = viewer;
                  this.distortion = new Distortion(this.viewer.distortionCoefficients);
                };
                DeviceInfo.prototype.determineDevice_ = function (deviceParams) {
                  if (!deviceParams) {
                    if (isIOS()) {
                      console.warn('Using fallback iOS device measurements.');
                      return DEFAULT_IOS;
                    } else {
                      console.warn('Using fallback Android device measurements.');
                      return DEFAULT_ANDROID;
                    }
                  }
                  var METERS_PER_INCH = 0.0254;
                  var metersPerPixelX = METERS_PER_INCH / deviceParams.xdpi;
                  var metersPerPixelY = METERS_PER_INCH / deviceParams.ydpi;
                  var width = getScreenWidth();
                  var height = getScreenHeight();
                  return new Device({
                    widthMeters: metersPerPixelX * width,
                    heightMeters: metersPerPixelY * height,
                    bevelMeters: deviceParams.bevelMm * 0.001
                  });
                };
                DeviceInfo.prototype.getDistortedFieldOfViewLeftEye = function () {
                  var viewer = this.viewer;
                  var device = this.device;
                  var distortion = this.distortion;
                  var eyeToScreenDistance = viewer.screenLensDistance;
                  var outerDist = (device.widthMeters - viewer.interLensDistance) / 2;
                  var innerDist = viewer.interLensDistance / 2;
                  var bottomDist = viewer.baselineLensDistance - device.bevelMeters;
                  var topDist = device.heightMeters - bottomDist;
                  var outerAngle = radToDeg * Math.atan(distortion.distort(outerDist / eyeToScreenDistance));
                  var innerAngle = radToDeg * Math.atan(distortion.distort(innerDist / eyeToScreenDistance));
                  var bottomAngle = radToDeg * Math.atan(distortion.distort(bottomDist / eyeToScreenDistance));
                  var topAngle = radToDeg * Math.atan(distortion.distort(topDist / eyeToScreenDistance));
                  return {
                    leftDegrees: Math.min(outerAngle, viewer.fov),
                    rightDegrees: Math.min(innerAngle, viewer.fov),
                    downDegrees: Math.min(bottomAngle, viewer.fov),
                    upDegrees: Math.min(topAngle, viewer.fov)
                  };
                };
                DeviceInfo.prototype.getLeftEyeVisibleTanAngles = function () {
                  var viewer = this.viewer;
                  var device = this.device;
                  var distortion = this.distortion;
                  var fovLeft = Math.tan(-degToRad * viewer.fov);
                  var fovTop = Math.tan(degToRad * viewer.fov);
                  var fovRight = Math.tan(degToRad * viewer.fov);
                  var fovBottom = Math.tan(-degToRad * viewer.fov);
                  var halfWidth = device.widthMeters / 4;
                  var halfHeight = device.heightMeters / 2;
                  var verticalLensOffset = viewer.baselineLensDistance - device.bevelMeters - halfHeight;
                  var centerX = viewer.interLensDistance / 2 - halfWidth;
                  var centerY = -verticalLensOffset;
                  var centerZ = viewer.screenLensDistance;
                  var screenLeft = distortion.distort((centerX - halfWidth) / centerZ);
                  var screenTop = distortion.distort((centerY + halfHeight) / centerZ);
                  var screenRight = distortion.distort((centerX + halfWidth) / centerZ);
                  var screenBottom = distortion.distort((centerY - halfHeight) / centerZ);
                  var result = new Float32Array(4);
                  result[0] = Math.max(fovLeft, screenLeft);
                  result[1] = Math.min(fovTop, screenTop);
                  result[2] = Math.min(fovRight, screenRight);
                  result[3] = Math.max(fovBottom, screenBottom);
                  return result;
                };
                DeviceInfo.prototype.getLeftEyeNoLensTanAngles = function () {
                  var viewer = this.viewer;
                  var device = this.device;
                  var distortion = this.distortion;
                  var result = new Float32Array(4);
                  var fovLeft = distortion.distortInverse(Math.tan(-degToRad * viewer.fov));
                  var fovTop = distortion.distortInverse(Math.tan(degToRad * viewer.fov));
                  var fovRight = distortion.distortInverse(Math.tan(degToRad * viewer.fov));
                  var fovBottom = distortion.distortInverse(Math.tan(-degToRad * viewer.fov));
                  var halfWidth = device.widthMeters / 4;
                  var halfHeight = device.heightMeters / 2;
                  var verticalLensOffset = viewer.baselineLensDistance - device.bevelMeters - halfHeight;
                  var centerX = viewer.interLensDistance / 2 - halfWidth;
                  var centerY = -verticalLensOffset;
                  var centerZ = viewer.screenLensDistance;
                  var screenLeft = (centerX - halfWidth) / centerZ;
                  var screenTop = (centerY + halfHeight) / centerZ;
                  var screenRight = (centerX + halfWidth) / centerZ;
                  var screenBottom = (centerY - halfHeight) / centerZ;
                  result[0] = Math.max(fovLeft, screenLeft);
                  result[1] = Math.min(fovTop, screenTop);
                  result[2] = Math.min(fovRight, screenRight);
                  result[3] = Math.max(fovBottom, screenBottom);
                  return result;
                };
                DeviceInfo.prototype.getLeftEyeVisibleScreenRect = function (undistortedFrustum) {
                  var viewer = this.viewer;
                  var device = this.device;
                  var dist = viewer.screenLensDistance;
                  var eyeX = (device.widthMeters - viewer.interLensDistance) / 2;
                  var eyeY = viewer.baselineLensDistance - device.bevelMeters;
                  var left = (undistortedFrustum[0] * dist + eyeX) / device.widthMeters;
                  var top = (undistortedFrustum[1] * dist + eyeY) / device.heightMeters;
                  var right = (undistortedFrustum[2] * dist + eyeX) / device.widthMeters;
                  var bottom = (undistortedFrustum[3] * dist + eyeY) / device.heightMeters;
                  return {
                    x: left,
                    y: bottom,
                    width: right - left,
                    height: top - bottom
                  };
                };
                DeviceInfo.prototype.getFieldOfViewLeftEye = function (opt_isUndistorted) {
                  return opt_isUndistorted ? this.getUndistortedFieldOfViewLeftEye() : this.getDistortedFieldOfViewLeftEye();
                };
                DeviceInfo.prototype.getFieldOfViewRightEye = function (opt_isUndistorted) {
                  var fov = this.getFieldOfViewLeftEye(opt_isUndistorted);
                  return {
                    leftDegrees: fov.rightDegrees,
                    rightDegrees: fov.leftDegrees,
                    upDegrees: fov.upDegrees,
                    downDegrees: fov.downDegrees
                  };
                };
                DeviceInfo.prototype.getUndistortedFieldOfViewLeftEye = function () {
                  var p = this.getUndistortedParams_();
                  return {
                    leftDegrees: radToDeg * Math.atan(p.outerDist),
                    rightDegrees: radToDeg * Math.atan(p.innerDist),
                    downDegrees: radToDeg * Math.atan(p.bottomDist),
                    upDegrees: radToDeg * Math.atan(p.topDist)
                  };
                };
                DeviceInfo.prototype.getUndistortedViewportLeftEye = function () {
                  var p = this.getUndistortedParams_();
                  var viewer = this.viewer;
                  var device = this.device;
                  var eyeToScreenDistance = viewer.screenLensDistance;
                  var screenWidth = device.widthMeters / eyeToScreenDistance;
                  var screenHeight = device.heightMeters / eyeToScreenDistance;
                  var xPxPerTanAngle = device.width / screenWidth;
                  var yPxPerTanAngle = device.height / screenHeight;
                  var x = Math.round((p.eyePosX - p.outerDist) * xPxPerTanAngle);
                  var y = Math.round((p.eyePosY - p.bottomDist) * yPxPerTanAngle);
                  return {
                    x: x,
                    y: y,
                    width: Math.round((p.eyePosX + p.innerDist) * xPxPerTanAngle) - x,
                    height: Math.round((p.eyePosY + p.topDist) * yPxPerTanAngle) - y
                  };
                };
                DeviceInfo.prototype.getUndistortedParams_ = function () {
                  var viewer = this.viewer;
                  var device = this.device;
                  var distortion = this.distortion;
                  var eyeToScreenDistance = viewer.screenLensDistance;
                  var halfLensDistance = viewer.interLensDistance / 2 / eyeToScreenDistance;
                  var screenWidth = device.widthMeters / eyeToScreenDistance;
                  var screenHeight = device.heightMeters / eyeToScreenDistance;
                  var eyePosX = screenWidth / 2 - halfLensDistance;
                  var eyePosY = (viewer.baselineLensDistance - device.bevelMeters) / eyeToScreenDistance;
                  var maxFov = viewer.fov;
                  var viewerMax = distortion.distortInverse(Math.tan(degToRad * maxFov));
                  var outerDist = Math.min(eyePosX, viewerMax);
                  var innerDist = Math.min(halfLensDistance, viewerMax);
                  var bottomDist = Math.min(eyePosY, viewerMax);
                  var topDist = Math.min(screenHeight - eyePosY, viewerMax);
                  return {
                    outerDist: outerDist,
                    innerDist: innerDist,
                    topDist: topDist,
                    bottomDist: bottomDist,
                    eyePosX: eyePosX,
                    eyePosY: eyePosY
                  };
                };
                function CardboardViewer(params) {
                  this.id = params.id;
                  this.label = params.label;
                  this.fov = params.fov;
                  this.interLensDistance = params.interLensDistance;
                  this.baselineLensDistance = params.baselineLensDistance;
                  this.screenLensDistance = params.screenLensDistance;
                  this.distortionCoefficients = params.distortionCoefficients;
                  this.inverseCoefficients = params.inverseCoefficients;
                }
                DeviceInfo.Viewers = Viewers;
                var format = 1;
                var last_updated = "2019-11-09T17:36:14Z";
                var devices = [{
                  "type": "android",
                  "rules": [{
                    "mdmh": "asus/*/Nexus 7/*"
                  }, {
                    "ua": "Nexus 7"
                  }],
                  "dpi": [320.8, 323],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "asus/*/ASUS_X00PD/*"
                  }, {
                    "ua": "ASUS_X00PD"
                  }],
                  "dpi": 245,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "asus/*/ASUS_X008D/*"
                  }, {
                    "ua": "ASUS_X008D"
                  }],
                  "dpi": 282,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "asus/*/ASUS_Z00AD/*"
                  }, {
                    "ua": "ASUS_Z00AD"
                  }],
                  "dpi": [403, 404.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Google/*/Pixel 2 XL/*"
                  }, {
                    "ua": "Pixel 2 XL"
                  }],
                  "dpi": 537.9,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Google/*/Pixel 3 XL/*"
                  }, {
                    "ua": "Pixel 3 XL"
                  }],
                  "dpi": [558.5, 553.8],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Google/*/Pixel XL/*"
                  }, {
                    "ua": "Pixel XL"
                  }],
                  "dpi": [537.9, 533],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Google/*/Pixel 3/*"
                  }, {
                    "ua": "Pixel 3"
                  }],
                  "dpi": 442.4,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Google/*/Pixel 2/*"
                  }, {
                    "ua": "Pixel 2"
                  }],
                  "dpi": 441,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Google/*/Pixel/*"
                  }, {
                    "ua": "Pixel"
                  }],
                  "dpi": [432.6, 436.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "HTC/*/HTC6435LVW/*"
                  }, {
                    "ua": "HTC6435LVW"
                  }],
                  "dpi": [449.7, 443.3],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "HTC/*/HTC One XL/*"
                  }, {
                    "ua": "HTC One XL"
                  }],
                  "dpi": [315.3, 314.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "htc/*/Nexus 9/*"
                  }, {
                    "ua": "Nexus 9"
                  }],
                  "dpi": 289,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "HTC/*/HTC One M9/*"
                  }, {
                    "ua": "HTC One M9"
                  }],
                  "dpi": [442.5, 443.3],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "HTC/*/HTC One_M8/*"
                  }, {
                    "ua": "HTC One_M8"
                  }],
                  "dpi": [449.7, 447.4],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "HTC/*/HTC One/*"
                  }, {
                    "ua": "HTC One"
                  }],
                  "dpi": 472.8,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Huawei/*/Nexus 6P/*"
                  }, {
                    "ua": "Nexus 6P"
                  }],
                  "dpi": [515.1, 518],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Huawei/*/BLN-L24/*"
                  }, {
                    "ua": "HONORBLN-L24"
                  }],
                  "dpi": 480,
                  "bw": 4,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Huawei/*/BKL-L09/*"
                  }, {
                    "ua": "BKL-L09"
                  }],
                  "dpi": 403,
                  "bw": 3.47,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LENOVO/*/Lenovo PB2-690Y/*"
                  }, {
                    "ua": "Lenovo PB2-690Y"
                  }],
                  "dpi": [457.2, 454.713],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/Nexus 5X/*"
                  }, {
                    "ua": "Nexus 5X"
                  }],
                  "dpi": [422, 419.9],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/LGMS345/*"
                  }, {
                    "ua": "LGMS345"
                  }],
                  "dpi": [221.7, 219.1],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/LG-D800/*"
                  }, {
                    "ua": "LG-D800"
                  }],
                  "dpi": [422, 424.1],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/LG-D850/*"
                  }, {
                    "ua": "LG-D850"
                  }],
                  "dpi": [537.9, 541.9],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/VS985 4G/*"
                  }, {
                    "ua": "VS985 4G"
                  }],
                  "dpi": [537.9, 535.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/Nexus 5/*"
                  }, {
                    "ua": "Nexus 5 B"
                  }],
                  "dpi": [442.4, 444.8],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/Nexus 4/*"
                  }, {
                    "ua": "Nexus 4"
                  }],
                  "dpi": [319.8, 318.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/LG-P769/*"
                  }, {
                    "ua": "LG-P769"
                  }],
                  "dpi": [240.6, 247.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/LGMS323/*"
                  }, {
                    "ua": "LGMS323"
                  }],
                  "dpi": [206.6, 204.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "LGE/*/LGLS996/*"
                  }, {
                    "ua": "LGLS996"
                  }],
                  "dpi": [403.4, 401.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Micromax/*/4560MMX/*"
                  }, {
                    "ua": "4560MMX"
                  }],
                  "dpi": [240, 219.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Micromax/*/A250/*"
                  }, {
                    "ua": "Micromax A250"
                  }],
                  "dpi": [480, 446.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Micromax/*/Micromax AQ4501/*"
                  }, {
                    "ua": "Micromax AQ4501"
                  }],
                  "dpi": 240,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/G5/*"
                  }, {
                    "ua": "Moto G (5) Plus"
                  }],
                  "dpi": [403.4, 403],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/DROID RAZR/*"
                  }, {
                    "ua": "DROID RAZR"
                  }],
                  "dpi": [368.1, 256.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT830C/*"
                  }, {
                    "ua": "XT830C"
                  }],
                  "dpi": [254, 255.9],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1021/*"
                  }, {
                    "ua": "XT1021"
                  }],
                  "dpi": [254, 256.7],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1023/*"
                  }, {
                    "ua": "XT1023"
                  }],
                  "dpi": [254, 256.7],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1028/*"
                  }, {
                    "ua": "XT1028"
                  }],
                  "dpi": [326.6, 327.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1034/*"
                  }, {
                    "ua": "XT1034"
                  }],
                  "dpi": [326.6, 328.4],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1053/*"
                  }, {
                    "ua": "XT1053"
                  }],
                  "dpi": [315.3, 316.1],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1562/*"
                  }, {
                    "ua": "XT1562"
                  }],
                  "dpi": [403.4, 402.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/Nexus 6/*"
                  }, {
                    "ua": "Nexus 6 B"
                  }],
                  "dpi": [494.3, 489.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1063/*"
                  }, {
                    "ua": "XT1063"
                  }],
                  "dpi": [295, 296.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1064/*"
                  }, {
                    "ua": "XT1064"
                  }],
                  "dpi": [295, 295.6],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1092/*"
                  }, {
                    "ua": "XT1092"
                  }],
                  "dpi": [422, 424.1],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/XT1095/*"
                  }, {
                    "ua": "XT1095"
                  }],
                  "dpi": [422, 423.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "motorola/*/G4/*"
                  }, {
                    "ua": "Moto G (4)"
                  }],
                  "dpi": 401,
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/A0001/*"
                  }, {
                    "ua": "A0001"
                  }],
                  "dpi": [403.4, 401],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE E1001/*"
                  }, {
                    "ua": "ONE E1001"
                  }],
                  "dpi": [442.4, 441.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE E1003/*"
                  }, {
                    "ua": "ONE E1003"
                  }],
                  "dpi": [442.4, 441.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE E1005/*"
                  }, {
                    "ua": "ONE E1005"
                  }],
                  "dpi": [442.4, 441.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE A2001/*"
                  }, {
                    "ua": "ONE A2001"
                  }],
                  "dpi": [391.9, 405.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE A2003/*"
                  }, {
                    "ua": "ONE A2003"
                  }],
                  "dpi": [391.9, 405.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE A2005/*"
                  }, {
                    "ua": "ONE A2005"
                  }],
                  "dpi": [391.9, 405.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A3000/*"
                  }, {
                    "ua": "ONEPLUS A3000"
                  }],
                  "dpi": 401,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A3003/*"
                  }, {
                    "ua": "ONEPLUS A3003"
                  }],
                  "dpi": 401,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A3010/*"
                  }, {
                    "ua": "ONEPLUS A3010"
                  }],
                  "dpi": 401,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A5000/*"
                  }, {
                    "ua": "ONEPLUS A5000 "
                  }],
                  "dpi": [403.411, 399.737],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONE A5010/*"
                  }, {
                    "ua": "ONEPLUS A5010"
                  }],
                  "dpi": [403, 400],
                  "bw": 2,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A6000/*"
                  }, {
                    "ua": "ONEPLUS A6000"
                  }],
                  "dpi": 401,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A6003/*"
                  }, {
                    "ua": "ONEPLUS A6003"
                  }],
                  "dpi": 401,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A6010/*"
                  }, {
                    "ua": "ONEPLUS A6010"
                  }],
                  "dpi": 401,
                  "bw": 2,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OnePlus/*/ONEPLUS A6013/*"
                  }, {
                    "ua": "ONEPLUS A6013"
                  }],
                  "dpi": 401,
                  "bw": 2,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "OPPO/*/X909/*"
                  }, {
                    "ua": "X909"
                  }],
                  "dpi": [442.4, 444.1],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9082/*"
                  }, {
                    "ua": "GT-I9082"
                  }],
                  "dpi": [184.7, 185.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G360P/*"
                  }, {
                    "ua": "SM-G360P"
                  }],
                  "dpi": [196.7, 205.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/Nexus S/*"
                  }, {
                    "ua": "Nexus S"
                  }],
                  "dpi": [234.5, 229.8],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9300/*"
                  }, {
                    "ua": "GT-I9300"
                  }],
                  "dpi": [304.8, 303.9],
                  "bw": 5,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-T230NU/*"
                  }, {
                    "ua": "SM-T230NU"
                  }],
                  "dpi": 216,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SGH-T399/*"
                  }, {
                    "ua": "SGH-T399"
                  }],
                  "dpi": [217.7, 231.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SGH-M919/*"
                  }, {
                    "ua": "SGH-M919"
                  }],
                  "dpi": [440.8, 437.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-N9005/*"
                  }, {
                    "ua": "SM-N9005"
                  }],
                  "dpi": [386.4, 387],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SAMSUNG-SM-N900A/*"
                  }, {
                    "ua": "SAMSUNG-SM-N900A"
                  }],
                  "dpi": [386.4, 387.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9500/*"
                  }, {
                    "ua": "GT-I9500"
                  }],
                  "dpi": [442.5, 443.3],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9505/*"
                  }, {
                    "ua": "GT-I9505"
                  }],
                  "dpi": 439.4,
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G900F/*"
                  }, {
                    "ua": "SM-G900F"
                  }],
                  "dpi": [415.6, 431.6],
                  "bw": 5,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G900M/*"
                  }, {
                    "ua": "SM-G900M"
                  }],
                  "dpi": [415.6, 431.6],
                  "bw": 5,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G800F/*"
                  }, {
                    "ua": "SM-G800F"
                  }],
                  "dpi": 326.8,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G906S/*"
                  }, {
                    "ua": "SM-G906S"
                  }],
                  "dpi": [562.7, 572.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9300/*"
                  }, {
                    "ua": "GT-I9300"
                  }],
                  "dpi": [306.7, 304.8],
                  "bw": 5,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-T535/*"
                  }, {
                    "ua": "SM-T535"
                  }],
                  "dpi": [142.6, 136.4],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-N920C/*"
                  }, {
                    "ua": "SM-N920C"
                  }],
                  "dpi": [515.1, 518.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-N920P/*"
                  }, {
                    "ua": "SM-N920P"
                  }],
                  "dpi": [386.3655, 390.144],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-N920W8/*"
                  }, {
                    "ua": "SM-N920W8"
                  }],
                  "dpi": [515.1, 518.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9300I/*"
                  }, {
                    "ua": "GT-I9300I"
                  }],
                  "dpi": [304.8, 305.8],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-I9195/*"
                  }, {
                    "ua": "GT-I9195"
                  }],
                  "dpi": [249.4, 256.7],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SPH-L520/*"
                  }, {
                    "ua": "SPH-L520"
                  }],
                  "dpi": [249.4, 255.9],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SAMSUNG-SGH-I717/*"
                  }, {
                    "ua": "SAMSUNG-SGH-I717"
                  }],
                  "dpi": 285.8,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SPH-D710/*"
                  }, {
                    "ua": "SPH-D710"
                  }],
                  "dpi": [217.7, 204.2],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/GT-N7100/*"
                  }, {
                    "ua": "GT-N7100"
                  }],
                  "dpi": 265.1,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SCH-I605/*"
                  }, {
                    "ua": "SCH-I605"
                  }],
                  "dpi": 265.1,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/Galaxy Nexus/*"
                  }, {
                    "ua": "Galaxy Nexus"
                  }],
                  "dpi": [315.3, 314.2],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-N910H/*"
                  }, {
                    "ua": "SM-N910H"
                  }],
                  "dpi": [515.1, 518],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-N910C/*"
                  }, {
                    "ua": "SM-N910C"
                  }],
                  "dpi": [515.2, 520.2],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G130M/*"
                  }, {
                    "ua": "SM-G130M"
                  }],
                  "dpi": [165.9, 164.8],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G928I/*"
                  }, {
                    "ua": "SM-G928I"
                  }],
                  "dpi": [515.1, 518.4],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G920F/*"
                  }, {
                    "ua": "SM-G920F"
                  }],
                  "dpi": 580.6,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G920P/*"
                  }, {
                    "ua": "SM-G920P"
                  }],
                  "dpi": [522.5, 577],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G925F/*"
                  }, {
                    "ua": "SM-G925F"
                  }],
                  "dpi": 580.6,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G925V/*"
                  }, {
                    "ua": "SM-G925V"
                  }],
                  "dpi": [522.5, 576.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G930F/*"
                  }, {
                    "ua": "SM-G930F"
                  }],
                  "dpi": 576.6,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G935F/*"
                  }, {
                    "ua": "SM-G935F"
                  }],
                  "dpi": 533,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G950F/*"
                  }, {
                    "ua": "SM-G950F"
                  }],
                  "dpi": [562.707, 565.293],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G955U/*"
                  }, {
                    "ua": "SM-G955U"
                  }],
                  "dpi": [522.514, 525.762],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G955F/*"
                  }, {
                    "ua": "SM-G955F"
                  }],
                  "dpi": [522.514, 525.762],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G960F/*"
                  }, {
                    "ua": "SM-G960F"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G9600/*"
                  }, {
                    "ua": "SM-G9600"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G960T/*"
                  }, {
                    "ua": "SM-G960T"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G960N/*"
                  }, {
                    "ua": "SM-G960N"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G960U/*"
                  }, {
                    "ua": "SM-G960U"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G9608/*"
                  }, {
                    "ua": "SM-G9608"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G960FD/*"
                  }, {
                    "ua": "SM-G960FD"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G960W/*"
                  }, {
                    "ua": "SM-G960W"
                  }],
                  "dpi": [569.575, 571.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G965F/*"
                  }, {
                    "ua": "SM-G965F"
                  }],
                  "dpi": 529,
                  "bw": 2,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Sony/*/C6903/*"
                  }, {
                    "ua": "C6903"
                  }],
                  "dpi": [442.5, 443.3],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Sony/*/D6653/*"
                  }, {
                    "ua": "D6653"
                  }],
                  "dpi": [428.6, 427.6],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Sony/*/E6653/*"
                  }, {
                    "ua": "E6653"
                  }],
                  "dpi": [428.6, 425.7],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Sony/*/E6853/*"
                  }, {
                    "ua": "E6853"
                  }],
                  "dpi": [403.4, 401.9],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Sony/*/SGP321/*"
                  }, {
                    "ua": "SGP321"
                  }],
                  "dpi": [224.7, 224.1],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "TCT/*/ALCATEL ONE TOUCH Fierce/*"
                  }, {
                    "ua": "ALCATEL ONE TOUCH Fierce"
                  }],
                  "dpi": [240, 247.5],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "THL/*/thl 5000/*"
                  }, {
                    "ua": "thl 5000"
                  }],
                  "dpi": [480, 443.3],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Fly/*/IQ4412/*"
                  }, {
                    "ua": "IQ4412"
                  }],
                  "dpi": 307.9,
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "ZTE/*/ZTE Blade L2/*"
                  }, {
                    "ua": "ZTE Blade L2"
                  }],
                  "dpi": 240,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "BENEVE/*/VR518/*"
                  }, {
                    "ua": "VR518"
                  }],
                  "dpi": 480,
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [640, 960]
                  }],
                  "dpi": [325.1, 328.4],
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [640, 1136]
                  }],
                  "dpi": [317.1, 320.2],
                  "bw": 3,
                  "ac": 1000
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [750, 1334]
                  }],
                  "dpi": 326.4,
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [1242, 2208]
                  }],
                  "dpi": [453.6, 458.4],
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [1125, 2001]
                  }],
                  "dpi": [410.9, 415.4],
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [1125, 2436]
                  }],
                  "dpi": 458,
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Huawei/*/EML-L29/*"
                  }, {
                    "ua": "EML-L29"
                  }],
                  "dpi": 428,
                  "bw": 3.45,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "Nokia/*/Nokia 7.1/*"
                  }, {
                    "ua": "Nokia 7.1"
                  }],
                  "dpi": [432, 431.9],
                  "bw": 3,
                  "ac": 500
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [1242, 2688]
                  }],
                  "dpi": 458,
                  "bw": 4,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G570M/*"
                  }, {
                    "ua": "SM-G570M"
                  }],
                  "dpi": 320,
                  "bw": 3.684,
                  "ac": 1000
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G970F/*"
                  }, {
                    "ua": "SM-G970F"
                  }],
                  "dpi": 438,
                  "bw": 2.281,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G973F/*"
                  }, {
                    "ua": "SM-G973F"
                  }],
                  "dpi": 550,
                  "bw": 2.002,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G975F/*"
                  }, {
                    "ua": "SM-G975F"
                  }],
                  "dpi": 522,
                  "bw": 2.054,
                  "ac": 500
                }, {
                  "type": "android",
                  "rules": [{
                    "mdmh": "samsung/*/SM-G977F/*"
                  }, {
                    "ua": "SM-G977F"
                  }],
                  "dpi": 505,
                  "bw": 2.334,
                  "ac": 500
                }, {
                  "type": "ios",
                  "rules": [{
                    "res": [828, 1792]
                  }],
                  "dpi": 326,
                  "bw": 5,
                  "ac": 500
                }];
                var DPDB_CACHE = {
                  format: format,
                  last_updated: last_updated,
                  devices: devices
                };
                function Dpdb(url, onDeviceParamsUpdated) {
                  this.dpdb = DPDB_CACHE;
                  this.recalculateDeviceParams_();
                  if (url) {
                    this.onDeviceParamsUpdated = onDeviceParamsUpdated;
                    var xhr = new XMLHttpRequest();
                    var obj = this;
                    xhr.open('GET', url, true);
                    xhr.addEventListener('load', function () {
                      obj.loading = false;
                      if (xhr.status >= 200 && xhr.status <= 299) {
                        obj.dpdb = JSON.parse(xhr.response);
                        obj.recalculateDeviceParams_();
                      } else {
                        console.error('Error loading online DPDB!');
                      }
                    });
                    xhr.send();
                  }
                }
                Dpdb.prototype.getDeviceParams = function () {
                  return this.deviceParams;
                };
                Dpdb.prototype.recalculateDeviceParams_ = function () {
                  var newDeviceParams = this.calcDeviceParams_();
                  if (newDeviceParams) {
                    this.deviceParams = newDeviceParams;
                    if (this.onDeviceParamsUpdated) {
                      this.onDeviceParamsUpdated(this.deviceParams);
                    }
                  } else {
                    console.error('Failed to recalculate device parameters.');
                  }
                };
                Dpdb.prototype.calcDeviceParams_ = function () {
                  var db = this.dpdb;
                  if (!db) {
                    console.error('DPDB not available.');
                    return null;
                  }
                  if (db.format != 1) {
                    console.error('DPDB has unexpected format version.');
                    return null;
                  }
                  if (!db.devices || !db.devices.length) {
                    console.error('DPDB does not have a devices section.');
                    return null;
                  }
                  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                  var width = getScreenWidth();
                  var height = getScreenHeight();
                  if (!db.devices) {
                    console.error('DPDB has no devices section.');
                    return null;
                  }
                  for (var i = 0; i < db.devices.length; i++) {
                    var device = db.devices[i];
                    if (!device.rules) {
                      console.warn('Device[' + i + '] has no rules section.');
                      continue;
                    }
                    if (device.type != 'ios' && device.type != 'android') {
                      console.warn('Device[' + i + '] has invalid type.');
                      continue;
                    }
                    if (isIOS() != (device.type == 'ios')) continue;
                    var matched = false;
                    for (var j = 0; j < device.rules.length; j++) {
                      var rule = device.rules[j];
                      if (this.ruleMatches_(rule, userAgent, width, height)) {
                        matched = true;
                        break;
                      }
                    }
                    if (!matched) continue;
                    var xdpi = device.dpi[0] || device.dpi;
                    var ydpi = device.dpi[1] || device.dpi;
                    return new DeviceParams({
                      xdpi: xdpi,
                      ydpi: ydpi,
                      bevelMm: device.bw
                    });
                  }
                  console.warn('No DPDB device match.');
                  return null;
                };
                Dpdb.prototype.ruleMatches_ = function (rule, ua, screenWidth, screenHeight) {
                  if (!rule.ua && !rule.res) return false;
                  if (rule.ua && rule.ua.substring(0, 2) === 'SM') rule.ua = rule.ua.substring(0, 7);
                  if (rule.ua && ua.indexOf(rule.ua) < 0) return false;
                  if (rule.res) {
                    if (!rule.res[0] || !rule.res[1]) return false;
                    var resX = rule.res[0];
                    var resY = rule.res[1];
                    if (Math.min(screenWidth, screenHeight) != Math.min(resX, resY) || Math.max(screenWidth, screenHeight) != Math.max(resX, resY)) {
                      return false;
                    }
                  }
                  return true;
                };
                function DeviceParams(params) {
                  this.xdpi = params.xdpi;
                  this.ydpi = params.ydpi;
                  this.bevelMm = params.bevelMm;
                }
                function SensorSample(sample, timestampS) {
                  this.set(sample, timestampS);
                }
                SensorSample.prototype.set = function (sample, timestampS) {
                  this.sample = sample;
                  this.timestampS = timestampS;
                };
                SensorSample.prototype.copy = function (sensorSample) {
                  this.set(sensorSample.sample, sensorSample.timestampS);
                };
                function ComplementaryFilter(kFilter, isDebug) {
                  this.kFilter = kFilter;
                  this.isDebug = isDebug;
                  this.currentAccelMeasurement = new SensorSample();
                  this.currentGyroMeasurement = new SensorSample();
                  this.previousGyroMeasurement = new SensorSample();
                  if (isIOS()) {
                    this.filterQ = new Quaternion(-1, 0, 0, 1);
                  } else {
                    this.filterQ = new Quaternion(1, 0, 0, 1);
                  }
                  this.previousFilterQ = new Quaternion();
                  this.previousFilterQ.copy(this.filterQ);
                  this.accelQ = new Quaternion();
                  this.isOrientationInitialized = false;
                  this.estimatedGravity = new Vector3();
                  this.measuredGravity = new Vector3();
                  this.gyroIntegralQ = new Quaternion();
                }
                ComplementaryFilter.prototype.addAccelMeasurement = function (vector, timestampS) {
                  this.currentAccelMeasurement.set(vector, timestampS);
                };
                ComplementaryFilter.prototype.addGyroMeasurement = function (vector, timestampS) {
                  this.currentGyroMeasurement.set(vector, timestampS);
                  var deltaT = timestampS - this.previousGyroMeasurement.timestampS;
                  if (isTimestampDeltaValid(deltaT)) {
                    this.run_();
                  }
                  this.previousGyroMeasurement.copy(this.currentGyroMeasurement);
                };
                ComplementaryFilter.prototype.run_ = function () {
                  if (!this.isOrientationInitialized) {
                    this.accelQ = this.accelToQuaternion_(this.currentAccelMeasurement.sample);
                    this.previousFilterQ.copy(this.accelQ);
                    this.isOrientationInitialized = true;
                    return;
                  }
                  var deltaT = this.currentGyroMeasurement.timestampS - this.previousGyroMeasurement.timestampS;
                  var gyroDeltaQ = this.gyroToQuaternionDelta_(this.currentGyroMeasurement.sample, deltaT);
                  this.gyroIntegralQ.multiply(gyroDeltaQ);
                  this.filterQ.copy(this.previousFilterQ);
                  this.filterQ.multiply(gyroDeltaQ);
                  var invFilterQ = new Quaternion();
                  invFilterQ.copy(this.filterQ);
                  invFilterQ.inverse();
                  this.estimatedGravity.set(0, 0, -1);
                  this.estimatedGravity.applyQuaternion(invFilterQ);
                  this.estimatedGravity.normalize();
                  this.measuredGravity.copy(this.currentAccelMeasurement.sample);
                  this.measuredGravity.normalize();
                  var deltaQ = new Quaternion();
                  deltaQ.setFromUnitVectors(this.estimatedGravity, this.measuredGravity);
                  deltaQ.inverse();
                  if (this.isDebug) {
                    console.log('Delta: %d deg, G_est: (%s, %s, %s), G_meas: (%s, %s, %s)', radToDeg * getQuaternionAngle(deltaQ), this.estimatedGravity.x.toFixed(1), this.estimatedGravity.y.toFixed(1), this.estimatedGravity.z.toFixed(1), this.measuredGravity.x.toFixed(1), this.measuredGravity.y.toFixed(1), this.measuredGravity.z.toFixed(1));
                  }
                  var targetQ = new Quaternion();
                  targetQ.copy(this.filterQ);
                  targetQ.multiply(deltaQ);
                  this.filterQ.slerp(targetQ, 1 - this.kFilter);
                  this.previousFilterQ.copy(this.filterQ);
                };
                ComplementaryFilter.prototype.getOrientation = function () {
                  return this.filterQ;
                };
                ComplementaryFilter.prototype.accelToQuaternion_ = function (accel) {
                  var normAccel = new Vector3();
                  normAccel.copy(accel);
                  normAccel.normalize();
                  var quat = new Quaternion();
                  quat.setFromUnitVectors(new Vector3(0, 0, -1), normAccel);
                  quat.inverse();
                  return quat;
                };
                ComplementaryFilter.prototype.gyroToQuaternionDelta_ = function (gyro, dt) {
                  var quat = new Quaternion();
                  var axis = new Vector3();
                  axis.copy(gyro);
                  axis.normalize();
                  quat.setFromAxisAngle(axis, gyro.length() * dt);
                  return quat;
                };
                function PosePredictor(predictionTimeS, isDebug) {
                  this.predictionTimeS = predictionTimeS;
                  this.isDebug = isDebug;
                  this.previousQ = new Quaternion();
                  this.previousTimestampS = null;
                  this.deltaQ = new Quaternion();
                  this.outQ = new Quaternion();
                }
                PosePredictor.prototype.getPrediction = function (currentQ, gyro, timestampS) {
                  if (!this.previousTimestampS) {
                    this.previousQ.copy(currentQ);
                    this.previousTimestampS = timestampS;
                    return currentQ;
                  }
                  var axis = new Vector3();
                  axis.copy(gyro);
                  axis.normalize();
                  var angularSpeed = gyro.length();
                  if (angularSpeed < degToRad * 20) {
                    if (this.isDebug) {
                      console.log('Moving slowly, at %s deg/s: no prediction', (radToDeg * angularSpeed).toFixed(1));
                    }
                    this.outQ.copy(currentQ);
                    this.previousQ.copy(currentQ);
                    return this.outQ;
                  }
                  var predictAngle = angularSpeed * this.predictionTimeS;
                  this.deltaQ.setFromAxisAngle(axis, predictAngle);
                  this.outQ.copy(this.previousQ);
                  this.outQ.multiply(this.deltaQ);
                  this.previousQ.copy(currentQ);
                  this.previousTimestampS = timestampS;
                  return this.outQ;
                };
                function FusionPoseSensor(kFilter, predictionTime, yawOnly, isDebug) {
                  this.yawOnly = yawOnly;
                  this.accelerometer = new Vector3();
                  this.gyroscope = new Vector3();
                  this.filter = new ComplementaryFilter(kFilter, isDebug);
                  this.posePredictor = new PosePredictor(predictionTime, isDebug);
                  this.isFirefoxAndroid = isFirefoxAndroid();
                  this.isIOS = isIOS();
                  var chromeVersion = getChromeVersion();
                  this.isDeviceMotionInRadians = !this.isIOS && chromeVersion && chromeVersion < 66;
                  this.isWithoutDeviceMotion = isChromeWithoutDeviceMotion() || isSafariWithoutDeviceMotion();
                  this.filterToWorldQ = new Quaternion();
                  if (isIOS()) {
                    this.filterToWorldQ.setFromAxisAngle(new Vector3(1, 0, 0), Math.PI / 2);
                  } else {
                    this.filterToWorldQ.setFromAxisAngle(new Vector3(1, 0, 0), -Math.PI / 2);
                  }
                  this.inverseWorldToScreenQ = new Quaternion();
                  this.worldToScreenQ = new Quaternion();
                  this.originalPoseAdjustQ = new Quaternion();
                  this.originalPoseAdjustQ.setFromAxisAngle(new Vector3(0, 0, 1), -window.orientation * Math.PI / 180);
                  this.setScreenTransform_();
                  if (isLandscapeMode()) {
                    this.filterToWorldQ.multiply(this.inverseWorldToScreenQ);
                  }
                  this.resetQ = new Quaternion();
                  this.orientationOut_ = new Float32Array(4);
                  this.start();
                }
                FusionPoseSensor.prototype.getPosition = function () {
                  return null;
                };
                FusionPoseSensor.prototype.getOrientation = function () {
                  var orientation = void 0;
                  if (this.isWithoutDeviceMotion && this._deviceOrientationQ) {
                    this.deviceOrientationFixQ = this.deviceOrientationFixQ || function () {
                      var z = new Quaternion().setFromAxisAngle(new Vector3(0, 0, -1), 0);
                      var y = new Quaternion();
                      if (window.orientation === -90) {
                        y.setFromAxisAngle(new Vector3(0, 1, 0), Math.PI / -2);
                      } else {
                        y.setFromAxisAngle(new Vector3(0, 1, 0), Math.PI / 2);
                      }
                      return z.multiply(y);
                    }();
                    this.deviceOrientationFilterToWorldQ = this.deviceOrientationFilterToWorldQ || function () {
                      var q = new Quaternion();
                      q.setFromAxisAngle(new Vector3(1, 0, 0), -Math.PI / 2);
                      return q;
                    }();
                    orientation = this._deviceOrientationQ;
                    var out = new Quaternion();
                    out.copy(orientation);
                    out.multiply(this.deviceOrientationFilterToWorldQ);
                    out.multiply(this.resetQ);
                    out.multiply(this.worldToScreenQ);
                    out.multiplyQuaternions(this.deviceOrientationFixQ, out);
                    if (this.yawOnly) {
                      out.x = 0;
                      out.z = 0;
                      out.normalize();
                    }
                    this.orientationOut_[0] = out.x;
                    this.orientationOut_[1] = out.y;
                    this.orientationOut_[2] = out.z;
                    this.orientationOut_[3] = out.w;
                    return this.orientationOut_;
                  } else {
                    var filterOrientation = this.filter.getOrientation();
                    orientation = this.posePredictor.getPrediction(filterOrientation, this.gyroscope, this.previousTimestampS);
                  }
                  var out = new Quaternion();
                  out.copy(this.filterToWorldQ);
                  out.multiply(this.resetQ);
                  out.multiply(orientation);
                  out.multiply(this.worldToScreenQ);
                  if (this.yawOnly) {
                    out.x = 0;
                    out.z = 0;
                    out.normalize();
                  }
                  this.orientationOut_[0] = out.x;
                  this.orientationOut_[1] = out.y;
                  this.orientationOut_[2] = out.z;
                  this.orientationOut_[3] = out.w;
                  return this.orientationOut_;
                };
                FusionPoseSensor.prototype.resetPose = function () {
                  this.resetQ.copy(this.filter.getOrientation());
                  this.resetQ.x = 0;
                  this.resetQ.y = 0;
                  this.resetQ.z *= -1;
                  this.resetQ.normalize();
                  if (isLandscapeMode()) {
                    this.resetQ.multiply(this.inverseWorldToScreenQ);
                  }
                  this.resetQ.multiply(this.originalPoseAdjustQ);
                };
                FusionPoseSensor.prototype.onDeviceOrientation_ = function (e) {
                  this._deviceOrientationQ = this._deviceOrientationQ || new Quaternion();
                  var alpha = e.alpha,
                    beta = e.beta,
                    gamma = e.gamma;
                  alpha = (alpha || 0) * Math.PI / 180;
                  beta = (beta || 0) * Math.PI / 180;
                  gamma = (gamma || 0) * Math.PI / 180;
                  this._deviceOrientationQ.setFromEulerYXZ(beta, alpha, -gamma);
                };
                FusionPoseSensor.prototype.onDeviceMotion_ = function (deviceMotion) {
                  this.updateDeviceMotion_(deviceMotion);
                };
                FusionPoseSensor.prototype.updateDeviceMotion_ = function (deviceMotion) {
                  var accGravity = deviceMotion.accelerationIncludingGravity;
                  var rotRate = deviceMotion.rotationRate;
                  var timestampS = deviceMotion.timeStamp / 1000;
                  var deltaS = timestampS - this.previousTimestampS;
                  if (deltaS < 0) {
                    warnOnce('fusion-pose-sensor:invalid:non-monotonic', 'Invalid timestamps detected: non-monotonic timestamp from devicemotion');
                    this.previousTimestampS = timestampS;
                    return;
                  } else if (deltaS <= MIN_TIMESTEP || deltaS > MAX_TIMESTEP) {
                    warnOnce('fusion-pose-sensor:invalid:outside-threshold', 'Invalid timestamps detected: Timestamp from devicemotion outside expected range.');
                    this.previousTimestampS = timestampS;
                    return;
                  }
                  this.accelerometer.set(-accGravity.x, -accGravity.y, -accGravity.z);
                  if (rotRate) {
                    if (isR7()) {
                      this.gyroscope.set(-rotRate.beta, rotRate.alpha, rotRate.gamma);
                    } else {
                      this.gyroscope.set(rotRate.alpha, rotRate.beta, rotRate.gamma);
                    }
                    if (!this.isDeviceMotionInRadians) {
                      this.gyroscope.multiplyScalar(Math.PI / 180);
                    }
                    this.filter.addGyroMeasurement(this.gyroscope, timestampS);
                  }
                  this.filter.addAccelMeasurement(this.accelerometer, timestampS);
                  this.previousTimestampS = timestampS;
                };
                FusionPoseSensor.prototype.onOrientationChange_ = function (screenOrientation) {
                  this.setScreenTransform_();
                };
                FusionPoseSensor.prototype.onMessage_ = function (event) {
                  var message = event.data;
                  if (!message || !message.type) {
                    return;
                  }
                  var type = message.type.toLowerCase();
                  if (type !== 'devicemotion') {
                    return;
                  }
                  this.updateDeviceMotion_(message.deviceMotionEvent);
                };
                FusionPoseSensor.prototype.setScreenTransform_ = function () {
                  this.worldToScreenQ.set(0, 0, 0, 1);
                  switch (window.orientation) {
                    case 0:
                      break;
                    case 90:
                      this.worldToScreenQ.setFromAxisAngle(new Vector3(0, 0, 1), -Math.PI / 2);
                      break;
                    case -90:
                      this.worldToScreenQ.setFromAxisAngle(new Vector3(0, 0, 1), Math.PI / 2);
                      break;
                    case 180:
                      break;
                  }
                  this.inverseWorldToScreenQ.copy(this.worldToScreenQ);
                  this.inverseWorldToScreenQ.inverse();
                };
                FusionPoseSensor.prototype.start = function () {
                  this.onDeviceMotionCallback_ = this.onDeviceMotion_.bind(this);
                  this.onOrientationChangeCallback_ = this.onOrientationChange_.bind(this);
                  this.onMessageCallback_ = this.onMessage_.bind(this);
                  this.onDeviceOrientationCallback_ = this.onDeviceOrientation_.bind(this);
                  if (isIOS() && isInsideCrossOriginIFrame()) {
                    window.addEventListener('message', this.onMessageCallback_);
                  }
                  window.addEventListener('orientationchange', this.onOrientationChangeCallback_);
                  if (this.isWithoutDeviceMotion) {
                    window.addEventListener('deviceorientation', this.onDeviceOrientationCallback_);
                  } else {
                    window.addEventListener('devicemotion', this.onDeviceMotionCallback_);
                  }
                };
                FusionPoseSensor.prototype.stop = function () {
                  window.removeEventListener('devicemotion', this.onDeviceMotionCallback_);
                  window.removeEventListener('deviceorientation', this.onDeviceOrientationCallback_);
                  window.removeEventListener('orientationchange', this.onOrientationChangeCallback_);
                  window.removeEventListener('message', this.onMessageCallback_);
                };
                var SENSOR_FREQUENCY = 60;
                var X_AXIS = new Vector3(1, 0, 0);
                var Z_AXIS = new Vector3(0, 0, 1);
                var SENSOR_TO_VR = new Quaternion();
                SENSOR_TO_VR.setFromAxisAngle(X_AXIS, -Math.PI / 2);
                SENSOR_TO_VR.multiply(new Quaternion().setFromAxisAngle(Z_AXIS, Math.PI / 2));
                var PoseSensor = function () {
                  function PoseSensor(config) {
                    classCallCheck(this, PoseSensor);
                    this.config = config;
                    this.sensor = null;
                    this.fusionSensor = null;
                    this._out = new Float32Array(4);
                    this.api = null;
                    this.errors = [];
                    this._sensorQ = new Quaternion();
                    this._outQ = new Quaternion();
                    this._onSensorRead = this._onSensorRead.bind(this);
                    this._onSensorError = this._onSensorError.bind(this);
                    this.init();
                  }
                  createClass(PoseSensor, [{
                    key: 'init',
                    value: function init() {
                      var sensor = null;
                      try {
                        sensor = new RelativeOrientationSensor({
                          frequency: SENSOR_FREQUENCY,
                          referenceFrame: 'screen'
                        });
                        sensor.addEventListener('error', this._onSensorError);
                      } catch (error) {
                        this.errors.push(error);
                        if (error.name === 'SecurityError') {
                          console.error('Cannot construct sensors due to the Feature Policy');
                          console.warn('Attempting to fall back using "devicemotion"; however this will ' + 'fail in the future without correct permissions.');
                          this.useDeviceMotion();
                        } else if (error.name === 'ReferenceError') {
                          this.useDeviceMotion();
                        } else {
                          console.error(error);
                        }
                      }
                      if (sensor) {
                        this.api = 'sensor';
                        this.sensor = sensor;
                        this.sensor.addEventListener('reading', this._onSensorRead);
                        this.sensor.start();
                      }
                    }
                  }, {
                    key: 'useDeviceMotion',
                    value: function useDeviceMotion() {
                      this.api = 'devicemotion';
                      this.fusionSensor = new FusionPoseSensor(this.config.K_FILTER, this.config.PREDICTION_TIME_S, this.config.YAW_ONLY, this.config.DEBUG);
                      if (this.sensor) {
                        this.sensor.removeEventListener('reading', this._onSensorRead);
                        this.sensor.removeEventListener('error', this._onSensorError);
                        this.sensor = null;
                      }
                    }
                  }, {
                    key: 'getOrientation',
                    value: function getOrientation() {
                      if (this.fusionSensor) {
                        return this.fusionSensor.getOrientation();
                      }
                      if (!this.sensor || !this.sensor.quaternion) {
                        this._out[0] = this._out[1] = this._out[2] = 0;
                        this._out[3] = 1;
                        return this._out;
                      }
                      var q = this.sensor.quaternion;
                      this._sensorQ.set(q[0], q[1], q[2], q[3]);
                      var out = this._outQ;
                      out.copy(SENSOR_TO_VR);
                      out.multiply(this._sensorQ);
                      if (this.config.YAW_ONLY) {
                        out.x = out.z = 0;
                        out.normalize();
                      }
                      this._out[0] = out.x;
                      this._out[1] = out.y;
                      this._out[2] = out.z;
                      this._out[3] = out.w;
                      return this._out;
                    }
                  }, {
                    key: '_onSensorError',
                    value: function _onSensorError(event) {
                      this.errors.push(event.error);
                      if (event.error.name === 'NotAllowedError') {
                        console.error('Permission to access sensor was denied');
                      } else if (event.error.name === 'NotReadableError') {
                        console.error('Sensor could not be read');
                      } else {
                        console.error(event.error);
                      }
                      this.useDeviceMotion();
                    }
                  }, {
                    key: '_onSensorRead',
                    value: function _onSensorRead() {}
                  }]);
                  return PoseSensor;
                }();
                var rotateInstructionsAsset = "<svg width='198' height='240' viewBox='0 0 198 240' xmlns='http://www.w3.org/2000/svg'><g fill='none' fill-rule='evenodd'><path d='M149.625 109.527l6.737 3.891v.886c0 .177.013.36.038.549.01.081.02.162.027.242.14 1.415.974 2.998 2.105 3.999l5.72 5.062.081-.09s4.382-2.53 5.235-3.024l25.97 14.993v54.001c0 .771-.386 1.217-.948 1.217-.233 0-.495-.076-.772-.236l-23.967-13.838-.014.024-27.322 15.775-.85-1.323c-4.731-1.529-9.748-2.74-14.951-3.61a.27.27 0 0 0-.007.024l-5.067 16.961-7.891 4.556-.037-.063v27.59c0 .772-.386 1.217-.948 1.217-.232 0-.495-.076-.772-.236l-42.473-24.522c-.95-.549-1.72-1.877-1.72-2.967v-1.035l-.021.047a5.111 5.111 0 0 0-1.816-.399 5.682 5.682 0 0 0-.546.001 13.724 13.724 0 0 1-1.918-.041c-1.655-.153-3.2-.6-4.404-1.296l-46.576-26.89.005.012-10.278-18.75c-1.001-1.827-.241-4.216 1.698-5.336l56.011-32.345a4.194 4.194 0 0 1 2.099-.572c1.326 0 2.572.659 3.227 1.853l.005-.003.227.413-.006.004a9.63 9.63 0 0 0 1.477 2.018l.277.27c1.914 1.85 4.468 2.801 7.113 2.801 1.949 0 3.948-.517 5.775-1.572.013 0 7.319-4.219 7.319-4.219a4.194 4.194 0 0 1 2.099-.572c1.326 0 2.572.658 3.226 1.853l3.25 5.928.022-.018 6.785 3.917-.105-.182 46.881-26.965m0-1.635c-.282 0-.563.073-.815.218l-46.169 26.556-5.41-3.124-3.005-5.481c-.913-1.667-2.699-2.702-4.66-2.703-1.011 0-2.02.274-2.917.792a3825 3825 0 0 1-7.275 4.195l-.044.024a9.937 9.937 0 0 1-4.957 1.353c-2.292 0-4.414-.832-5.976-2.342l-.252-.245a7.992 7.992 0 0 1-1.139-1.534 1.379 1.379 0 0 0-.06-.122l-.227-.414a1.718 1.718 0 0 0-.095-.154c-.938-1.574-2.673-2.545-4.571-2.545-1.011 0-2.02.274-2.917.792L3.125 155.502c-2.699 1.559-3.738 4.94-2.314 7.538l10.278 18.75c.177.323.448.563.761.704l46.426 26.804c1.403.81 3.157 1.332 5.072 1.508a15.661 15.661 0 0 0 2.146.046 4.766 4.766 0 0 1 .396 0c.096.004.19.011.283.022.109 1.593 1.159 3.323 2.529 4.114l42.472 24.522c.524.302 1.058.455 1.59.455 1.497 0 2.583-1.2 2.583-2.852v-26.562l7.111-4.105a1.64 1.64 0 0 0 .749-.948l4.658-15.593c4.414.797 8.692 1.848 12.742 3.128l.533.829a1.634 1.634 0 0 0 2.193.531l26.532-15.317L193 192.433c.523.302 1.058.455 1.59.455 1.497 0 2.583-1.199 2.583-2.852v-54.001c0-.584-.312-1.124-.818-1.416l-25.97-14.993a1.633 1.633 0 0 0-1.636.001c-.606.351-2.993 1.73-4.325 2.498l-4.809-4.255c-.819-.725-1.461-1.933-1.561-2.936a7.776 7.776 0 0 0-.033-.294 2.487 2.487 0 0 1-.023-.336v-.886c0-.584-.312-1.123-.817-1.416l-6.739-3.891a1.633 1.633 0 0 0-.817-.219' fill='#455A64'/><path d='M96.027 132.636l46.576 26.891c1.204.695 1.979 1.587 2.242 2.541l-.01.007-81.374 46.982h-.001c-1.654-.152-3.199-.6-4.403-1.295l-46.576-26.891 83.546-48.235' fill='#FAFAFA'/><path d='M63.461 209.174c-.008 0-.015 0-.022-.002-1.693-.156-3.228-.609-4.441-1.309l-46.576-26.89a.118.118 0 0 1 0-.203l83.546-48.235a.117.117 0 0 1 .117 0l46.576 26.891c1.227.708 2.021 1.612 2.296 2.611a.116.116 0 0 1-.042.124l-.021.016-81.375 46.981a.11.11 0 0 1-.058.016zm-50.747-28.303l46.401 26.79c1.178.68 2.671 1.121 4.32 1.276l81.272-46.922c-.279-.907-1.025-1.73-2.163-2.387l-46.517-26.857-83.313 48.1z' fill='#607D8B'/><path d='M148.327 165.471a5.85 5.85 0 0 1-.546.001c-1.894-.083-3.302-1.038-3.145-2.132a2.693 2.693 0 0 0-.072-1.105l-81.103 46.822c.628.058 1.272.073 1.918.042.182-.009.364-.009.546-.001 1.894.083 3.302 1.038 3.145 2.132l79.257-45.759' fill='#FFF'/><path d='M69.07 211.347a.118.118 0 0 1-.115-.134c.045-.317-.057-.637-.297-.925-.505-.61-1.555-1.022-2.738-1.074a5.966 5.966 0 0 0-.535.001 14.03 14.03 0 0 1-1.935-.041.117.117 0 0 1-.103-.092.116.116 0 0 1 .055-.126l81.104-46.822a.117.117 0 0 1 .171.07c.104.381.129.768.074 1.153-.045.316.057.637.296.925.506.61 1.555 1.021 2.739 1.073.178.008.357.008.535-.001a.117.117 0 0 1 .064.218l-79.256 45.759a.114.114 0 0 1-.059.016zm-3.405-2.372c.089 0 .177.002.265.006 1.266.056 2.353.488 2.908 1.158.227.274.35.575.36.882l78.685-45.429c-.036 0-.072-.001-.107-.003-1.267-.056-2.354-.489-2.909-1.158-.282-.34-.402-.724-.347-1.107a2.604 2.604 0 0 0-.032-.91L63.846 208.97a13.91 13.91 0 0 0 1.528.012c.097-.005.194-.007.291-.007z' fill='#607D8B'/><path d='M2.208 162.134c-1.001-1.827-.241-4.217 1.698-5.337l56.011-32.344c1.939-1.12 4.324-.546 5.326 1.281l.232.41a9.344 9.344 0 0 0 1.47 2.021l.278.27c3.325 3.214 8.583 3.716 12.888 1.23l7.319-4.22c1.94-1.119 4.324-.546 5.325 1.282l3.25 5.928-83.519 48.229-10.278-18.75z' fill='#FAFAFA'/><path d='M12.486 181.001a.112.112 0 0 1-.031-.005.114.114 0 0 1-.071-.056L2.106 162.19c-1.031-1.88-.249-4.345 1.742-5.494l56.01-32.344a4.328 4.328 0 0 1 2.158-.588c1.415 0 2.65.702 3.311 1.882.01.008.018.017.024.028l.227.414a.122.122 0 0 1 .013.038 9.508 9.508 0 0 0 1.439 1.959l.275.266c1.846 1.786 4.344 2.769 7.031 2.769 1.977 0 3.954-.538 5.717-1.557a.148.148 0 0 1 .035-.013l7.284-4.206a4.321 4.321 0 0 1 2.157-.588c1.427 0 2.672.716 3.329 1.914l3.249 5.929a.116.116 0 0 1-.044.157l-83.518 48.229a.116.116 0 0 1-.059.016zm49.53-57.004c-.704 0-1.41.193-2.041.557l-56.01 32.345c-1.882 1.086-2.624 3.409-1.655 5.179l10.221 18.645 83.317-48.112-3.195-5.829c-.615-1.122-1.783-1.792-3.124-1.792a4.08 4.08 0 0 0-2.04.557l-7.317 4.225a.148.148 0 0 1-.035.013 11.7 11.7 0 0 1-5.801 1.569c-2.748 0-5.303-1.007-7.194-2.835l-.278-.27a9.716 9.716 0 0 1-1.497-2.046.096.096 0 0 1-.013-.037l-.191-.347a.11.11 0 0 1-.023-.029c-.615-1.123-1.783-1.793-3.124-1.793z' fill='#607D8B'/><path d='M42.434 155.808c-2.51-.001-4.697-1.258-5.852-3.365-1.811-3.304-.438-7.634 3.059-9.654l12.291-7.098a7.599 7.599 0 0 1 3.789-1.033c2.51 0 4.697 1.258 5.852 3.365 1.811 3.304.439 7.634-3.059 9.654l-12.291 7.098a7.606 7.606 0 0 1-3.789 1.033zm13.287-20.683a7.128 7.128 0 0 0-3.555.971l-12.291 7.098c-3.279 1.893-4.573 5.942-2.883 9.024 1.071 1.955 3.106 3.122 5.442 3.122a7.13 7.13 0 0 0 3.556-.97l12.291-7.098c3.279-1.893 4.572-5.942 2.883-9.024-1.072-1.955-3.106-3.123-5.443-3.123z' fill='#607D8B'/><path d='M149.588 109.407l6.737 3.89v.887c0 .176.013.36.037.549.011.081.02.161.028.242.14 1.415.973 2.998 2.105 3.999l7.396 6.545c.177.156.358.295.541.415 1.579 1.04 2.95.466 3.062-1.282.049-.784.057-1.595.023-2.429l-.003-.16v-1.151l25.987 15.003v54c0 1.09-.77 1.53-1.72.982l-42.473-24.523c-.95-.548-1.72-1.877-1.72-2.966v-34.033' fill='#FAFAFA'/><path d='M194.553 191.25c-.257 0-.54-.085-.831-.253l-42.472-24.521c-.981-.567-1.779-1.943-1.779-3.068v-34.033h.234v34.033c0 1.051.745 2.336 1.661 2.866l42.473 24.521c.424.245.816.288 1.103.122.285-.164.442-.52.442-1.002v-53.933l-25.753-14.868.003 1.106c.034.832.026 1.654-.024 2.439-.054.844-.396 1.464-.963 1.746-.619.309-1.45.173-2.28-.373a5.023 5.023 0 0 1-.553-.426l-7.397-6.544c-1.158-1.026-1.999-2.625-2.143-4.076a9.624 9.624 0 0 0-.027-.238 4.241 4.241 0 0 1-.038-.564v-.82l-6.68-3.856.117-.202 6.738 3.89.058.034v.954c0 .171.012.351.036.533.011.083.021.165.029.246.138 1.395.948 2.935 2.065 3.923l7.397 6.545c.173.153.35.289.527.406.758.499 1.504.63 2.047.359.49-.243.786-.795.834-1.551.05-.778.057-1.591.024-2.417l-.004-.163v-1.355l.175.1 25.987 15.004.059.033v54.068c0 .569-.198.996-.559 1.204a1.002 1.002 0 0 1-.506.131' fill='#607D8B'/><path d='M145.685 163.161l24.115 13.922-25.978 14.998-1.462-.307c-6.534-2.17-13.628-3.728-21.019-4.616-4.365-.524-8.663 1.096-9.598 3.62a2.746 2.746 0 0 0-.011 1.928c1.538 4.267 4.236 8.363 7.995 12.135l.532.845-25.977 14.997-24.115-13.922 75.518-43.6' fill='#FFF'/><path d='M94.282 220.818l-.059-.033-24.29-14.024.175-.101 75.577-43.634.058.033 24.29 14.024-26.191 15.122-.045-.01-1.461-.307c-6.549-2.174-13.613-3.725-21.009-4.614a13.744 13.744 0 0 0-1.638-.097c-3.758 0-7.054 1.531-7.837 3.642a2.62 2.62 0 0 0-.01 1.848c1.535 4.258 4.216 8.326 7.968 12.091l.016.021.526.835.006.01.064.102-.105.061-25.977 14.998-.058.033zm-23.881-14.057l23.881 13.788 24.802-14.32c.546-.315.846-.489 1.017-.575l-.466-.74c-3.771-3.787-6.467-7.881-8.013-12.168a2.851 2.851 0 0 1 .011-2.008c.815-2.199 4.203-3.795 8.056-3.795.557 0 1.117.033 1.666.099 7.412.891 14.491 2.445 21.041 4.621.836.175 1.215.254 1.39.304l25.78-14.884-23.881-13.788-75.284 43.466z' fill='#607D8B'/><path d='M167.23 125.979v50.871l-27.321 15.773-6.461-14.167c-.91-1.996-3.428-1.738-5.624.574a10.238 10.238 0 0 0-2.33 4.018l-6.46 21.628-27.322 15.774v-50.871l75.518-43.6' fill='#FFF'/><path d='M91.712 220.567a.127.127 0 0 1-.059-.016.118.118 0 0 1-.058-.101v-50.871c0-.042.023-.08.058-.101l75.519-43.6a.117.117 0 0 1 .175.101v50.871c0 .041-.023.08-.059.1l-27.321 15.775a.118.118 0 0 1-.094.01.12.12 0 0 1-.071-.063l-6.46-14.168c-.375-.822-1.062-1.275-1.934-1.275-1.089 0-2.364.686-3.5 1.881a10.206 10.206 0 0 0-2.302 3.972l-6.46 21.627a.118.118 0 0 1-.054.068L91.77 220.551a.12.12 0 0 1-.058.016zm.117-50.92v50.601l27.106-15.65 6.447-21.583a10.286 10.286 0 0 1 2.357-4.065c1.18-1.242 2.517-1.954 3.669-1.954.969 0 1.731.501 2.146 1.411l6.407 14.051 27.152-15.676v-50.601l-75.284 43.466z' fill='#607D8B'/><path d='M168.543 126.213v50.87l-27.322 15.774-6.46-14.168c-.91-1.995-3.428-1.738-5.624.574a10.248 10.248 0 0 0-2.33 4.019l-6.461 21.627-27.321 15.774v-50.87l75.518-43.6' fill='#FFF'/><path d='M93.025 220.8a.123.123 0 0 1-.059-.015.12.12 0 0 1-.058-.101v-50.871c0-.042.023-.08.058-.101l75.518-43.6a.112.112 0 0 1 .117 0c.036.02.059.059.059.1v50.871a.116.116 0 0 1-.059.101l-27.321 15.774a.111.111 0 0 1-.094.01.115.115 0 0 1-.071-.062l-6.46-14.168c-.375-.823-1.062-1.275-1.935-1.275-1.088 0-2.363.685-3.499 1.881a10.19 10.19 0 0 0-2.302 3.971l-6.461 21.628a.108.108 0 0 1-.053.067l-27.322 15.775a.12.12 0 0 1-.058.015zm.117-50.919v50.6l27.106-15.649 6.447-21.584a10.293 10.293 0 0 1 2.357-4.065c1.179-1.241 2.516-1.954 3.668-1.954.969 0 1.732.502 2.147 1.412l6.407 14.051 27.152-15.676v-50.601l-75.284 43.466z' fill='#607D8B'/><path d='M169.8 177.083l-27.322 15.774-6.46-14.168c-.91-1.995-3.428-1.738-5.625.574a10.246 10.246 0 0 0-2.329 4.019l-6.461 21.627-27.321 15.774v-50.87l75.518-43.6v50.87z' fill='#FAFAFA'/><path d='M94.282 220.917a.234.234 0 0 1-.234-.233v-50.871c0-.083.045-.161.117-.202l75.518-43.601a.234.234 0 1 1 .35.202v50.871a.233.233 0 0 1-.116.202l-27.322 15.775a.232.232 0 0 1-.329-.106l-6.461-14.168c-.36-.789-.992-1.206-1.828-1.206-1.056 0-2.301.672-3.415 1.844a10.099 10.099 0 0 0-2.275 3.924l-6.46 21.628a.235.235 0 0 1-.107.136l-27.322 15.774a.23.23 0 0 1-.116.031zm.233-50.969v50.331l26.891-15.525 6.434-21.539a10.41 10.41 0 0 1 2.384-4.112c1.201-1.265 2.569-1.991 3.753-1.991 1.018 0 1.818.526 2.253 1.48l6.354 13.934 26.982-15.578v-50.331l-75.051 43.331z' fill='#607D8B'/><path d='M109.894 199.943c-1.774 0-3.241-.725-4.244-2.12a.224.224 0 0 1 .023-.294.233.233 0 0 1 .301-.023c.78.547 1.705.827 2.75.827 1.323 0 2.754-.439 4.256-1.306 5.311-3.067 9.631-10.518 9.631-16.611 0-1.927-.442-3.56-1.278-4.724a.232.232 0 0 1 .323-.327c1.671 1.172 2.591 3.381 2.591 6.219 0 6.242-4.426 13.863-9.865 17.003-1.574.908-3.084 1.356-4.488 1.356zm-2.969-1.542c.813.651 1.82.877 2.968.877h.001c1.321 0 2.753-.327 4.254-1.194 5.311-3.067 9.632-10.463 9.632-16.556 0-1.979-.463-3.599-1.326-4.761.411 1.035.625 2.275.625 3.635 0 6.243-4.426 13.883-9.865 17.023-1.574.909-3.084 1.317-4.49 1.317-.641 0-1.243-.149-1.799-.341z' fill='#607D8B'/><path d='M113.097 197.23c5.384-3.108 9.748-10.636 9.748-16.814 0-2.051-.483-3.692-1.323-4.86-1.784-1.252-4.374-1.194-7.257.47-5.384 3.108-9.748 10.636-9.748 16.814 0 2.051.483 3.692 1.323 4.86 1.784 1.252 4.374 1.194 7.257-.47' fill='#FAFAFA'/><path d='M108.724 198.614c-1.142 0-2.158-.213-3.019-.817-.021-.014-.04.014-.055-.007-.894-1.244-1.367-2.948-1.367-4.973 0-6.242 4.426-13.864 9.865-17.005 1.574-.908 3.084-1.363 4.49-1.363 1.142 0 2.158.309 3.018.913a.23.23 0 0 1 .056.056c.894 1.244 1.367 2.972 1.367 4.997 0 6.243-4.426 13.783-9.865 16.923-1.574.909-3.084 1.276-4.49 1.276zm-2.718-1.109c.774.532 1.688.776 2.718.776 1.323 0 2.754-.413 4.256-1.28 5.311-3.066 9.631-10.505 9.631-16.598 0-1.909-.434-3.523-1.255-4.685-.774-.533-1.688-.799-2.718-.799-1.323 0-2.755.441-4.256 1.308-5.311 3.066-9.631 10.506-9.631 16.599 0 1.909.434 3.517 1.255 4.679z' fill='#607D8B'/><path d='M149.318 114.262l-9.984 8.878 15.893 11.031 5.589-6.112-11.498-13.797' fill='#FAFAFA'/><path d='M169.676 120.84l-9.748 5.627c-3.642 2.103-9.528 2.113-13.147.024-3.62-2.089-3.601-5.488.041-7.591l9.495-5.608-6.729-3.885-81.836 47.071 45.923 26.514 3.081-1.779c.631-.365.869-.898.618-1.39-2.357-4.632-2.593-9.546-.683-14.262 5.638-13.92 24.509-24.815 48.618-28.07 8.169-1.103 16.68-.967 24.704.394.852.145 1.776.008 2.407-.357l3.081-1.778-25.825-14.91' fill='#FAFAFA'/><path d='M113.675 183.459a.47.47 0 0 1-.233-.062l-45.924-26.515a.468.468 0 0 1 .001-.809l81.836-47.071a.467.467 0 0 1 .466 0l6.729 3.885a.467.467 0 0 1-.467.809l-6.496-3.75-80.9 46.533 44.988 25.973 2.848-1.644c.192-.111.62-.409.435-.773-2.416-4.748-2.658-9.814-.7-14.65 2.806-6.927 8.885-13.242 17.582-18.263 8.657-4.998 19.518-8.489 31.407-10.094 8.198-1.107 16.79-.97 24.844.397.739.125 1.561.007 2.095-.301l2.381-1.374-25.125-14.506a.467.467 0 0 1 .467-.809l25.825 14.91a.467.467 0 0 1 0 .809l-3.081 1.779c-.721.417-1.763.575-2.718.413-7.963-1.351-16.457-1.486-24.563-.392-11.77 1.589-22.512 5.039-31.065 9.977-8.514 4.916-14.456 11.073-17.183 17.805-1.854 4.578-1.623 9.376.666 13.875.37.725.055 1.513-.8 2.006l-3.081 1.78a.476.476 0 0 1-.234.062' fill='#455A64'/><path d='M153.316 128.279c-2.413 0-4.821-.528-6.652-1.586-1.818-1.049-2.82-2.461-2.82-3.975 0-1.527 1.016-2.955 2.861-4.02l9.493-5.607a.233.233 0 1 1 .238.402l-9.496 5.609c-1.696.979-2.628 2.263-2.628 3.616 0 1.34.918 2.608 2.585 3.571 3.549 2.049 9.343 2.038 12.914-.024l9.748-5.628a.234.234 0 0 1 .234.405l-9.748 5.628c-1.858 1.072-4.296 1.609-6.729 1.609' fill='#607D8B'/><path d='M113.675 182.992l-45.913-26.508M113.675 183.342a.346.346 0 0 1-.175-.047l-45.913-26.508a.35.35 0 1 1 .35-.607l45.913 26.508a.35.35 0 0 1-.175.654' fill='#455A64'/><path d='M67.762 156.484v54.001c0 1.09.77 2.418 1.72 2.967l42.473 24.521c.95.549 1.72.11 1.72-.98v-54.001' fill='#FAFAFA'/><path d='M112.727 238.561c-.297 0-.62-.095-.947-.285l-42.473-24.521c-1.063-.613-1.895-2.05-1.895-3.27v-54.001a.35.35 0 1 1 .701 0v54.001c0 .96.707 2.18 1.544 2.663l42.473 24.522c.344.198.661.243.87.122.206-.119.325-.411.325-.799v-54.001a.35.35 0 1 1 .7 0v54.001c0 .655-.239 1.154-.675 1.406a1.235 1.235 0 0 1-.623.162' fill='#455A64'/><path d='M112.86 147.512h-.001c-2.318 0-4.499-.522-6.142-1.471-1.705-.984-2.643-2.315-2.643-3.749 0-1.445.952-2.791 2.68-3.788l12.041-6.953c1.668-.962 3.874-1.493 6.212-1.493 2.318 0 4.499.523 6.143 1.472 1.704.984 2.643 2.315 2.643 3.748 0 1.446-.952 2.791-2.68 3.789l-12.042 6.952c-1.668.963-3.874 1.493-6.211 1.493zm12.147-16.753c-2.217 0-4.298.497-5.861 1.399l-12.042 6.952c-1.502.868-2.33 1.998-2.33 3.182 0 1.173.815 2.289 2.293 3.142 1.538.889 3.596 1.378 5.792 1.378h.001c2.216 0 4.298-.497 5.861-1.399l12.041-6.953c1.502-.867 2.33-1.997 2.33-3.182 0-1.172-.814-2.288-2.292-3.142-1.539-.888-3.596-1.377-5.793-1.377z' fill='#607D8B'/><path d='M165.63 123.219l-5.734 3.311c-3.167 1.828-8.286 1.837-11.433.02-3.147-1.817-3.131-4.772.036-6.601l5.734-3.31 11.397 6.58' fill='#FAFAFA'/><path d='M154.233 117.448l9.995 5.771-4.682 2.704c-1.434.827-3.352 1.283-5.399 1.283-2.029 0-3.923-.449-5.333-1.263-1.29-.744-2-1.694-2-2.674 0-.991.723-1.955 2.036-2.713l5.383-3.108m0-.809l-5.734 3.31c-3.167 1.829-3.183 4.784-.036 6.601 1.568.905 3.623 1.357 5.684 1.357 2.077 0 4.159-.46 5.749-1.377l5.734-3.311-11.397-6.58M145.445 179.667c-1.773 0-3.241-.85-4.243-2.245-.067-.092-.057-.275.023-.356.08-.081.207-.12.3-.055.781.548 1.706.812 2.751.811 1.322 0 2.754-.446 4.256-1.313 5.31-3.066 9.631-10.522 9.631-16.615 0-1.927-.442-3.562-1.279-4.726a.235.235 0 0 1 .024-.301.232.232 0 0 1 .3-.027c1.67 1.172 2.59 3.38 2.59 6.219 0 6.242-4.425 13.987-9.865 17.127-1.573.908-3.083 1.481-4.488 1.481zM142.476 178c.814.651 1.82 1.002 2.969 1.002 1.322 0 2.753-.452 4.255-1.32 5.31-3.065 9.631-10.523 9.631-16.617 0-1.98-.463-3.63-1.325-4.793.411 1.035.624 2.26.624 3.62 0 6.242-4.425 13.875-9.865 17.015-1.573.909-3.084 1.376-4.489 1.376a5.49 5.49 0 0 1-1.8-.283z' fill='#607D8B'/><path d='M148.648 176.704c5.384-3.108 9.748-10.636 9.748-16.813 0-2.052-.483-3.693-1.322-4.861-1.785-1.252-4.375-1.194-7.258.471-5.383 3.108-9.748 10.636-9.748 16.813 0 2.051.484 3.692 1.323 4.86 1.785 1.253 4.374 1.195 7.257-.47' fill='#FAFAFA'/><path d='M144.276 178.276c-1.143 0-2.158-.307-3.019-.911a.217.217 0 0 1-.055-.054c-.895-1.244-1.367-2.972-1.367-4.997 0-6.241 4.425-13.875 9.865-17.016 1.573-.908 3.084-1.369 4.489-1.369 1.143 0 2.158.307 3.019.91a.24.24 0 0 1 .055.055c.894 1.244 1.367 2.971 1.367 4.997 0 6.241-4.425 13.875-9.865 17.016-1.573.908-3.084 1.369-4.489 1.369zm-2.718-1.172c.773.533 1.687.901 2.718.901 1.322 0 2.754-.538 4.256-1.405 5.31-3.066 9.631-10.567 9.631-16.661 0-1.908-.434-3.554-1.256-4.716-.774-.532-1.688-.814-2.718-.814-1.322 0-2.754.433-4.256 1.3-5.31 3.066-9.631 10.564-9.631 16.657 0 1.91.434 3.576 1.256 4.738z' fill='#607D8B'/><path d='M150.72 172.361l-.363-.295a24.105 24.105 0 0 0 2.148-3.128 24.05 24.05 0 0 0 1.977-4.375l.443.149a24.54 24.54 0 0 1-2.015 4.46 24.61 24.61 0 0 1-2.19 3.189M115.917 191.514l-.363-.294a24.174 24.174 0 0 0 2.148-3.128 24.038 24.038 0 0 0 1.976-4.375l.443.148a24.48 24.48 0 0 1-2.015 4.461 24.662 24.662 0 0 1-2.189 3.188M114 237.476V182.584 237.476' fill='#607D8B'/><g><path d='M81.822 37.474c.017-.135-.075-.28-.267-.392-.327-.188-.826-.21-1.109-.045l-6.012 3.471c-.131.076-.194.178-.191.285.002.132.002.461.002.578v.043l-.007.128-6.591 3.779c-.001 0-2.077 1.046-2.787 5.192 0 0-.912 6.961-.898 19.745.015 12.57.606 17.07 1.167 21.351.22 1.684 3.001 2.125 3.001 2.125.331.04.698-.027 1.08-.248l75.273-43.551c1.808-1.069 2.667-3.719 3.056-6.284 1.213-7.99 1.675-32.978-.275-39.878-.196-.693-.51-1.083-.868-1.282l-2.086-.79c-.727.028-1.416.467-1.534.535L82.032 37.072l-.21.402' fill='#FFF'/><path d='M144.311 1.701l2.085.79c.358.199.672.589.868 1.282 1.949 6.9 1.487 31.887.275 39.878-.39 2.565-1.249 5.215-3.056 6.284L69.21 93.486a1.78 1.78 0 0 1-.896.258l-.183-.011c0 .001-2.782-.44-3.003-2.124-.56-4.282-1.151-8.781-1.165-21.351-.015-12.784.897-19.745.897-19.745.71-4.146 2.787-5.192 2.787-5.192l6.591-3.779.007-.128v-.043c0-.117 0-.446-.002-.578-.003-.107.059-.21.191-.285l6.012-3.472a.98.98 0 0 1 .481-.11c.218 0 .449.053.627.156.193.112.285.258.268.392l.211-.402 60.744-34.836c.117-.068.806-.507 1.534-.535m0-.997l-.039.001c-.618.023-1.283.244-1.974.656l-.021.012-60.519 34.706a2.358 2.358 0 0 0-.831-.15c-.365 0-.704.084-.98.244l-6.012 3.471c-.442.255-.699.69-.689 1.166l.001.15-6.08 3.487c-.373.199-2.542 1.531-3.29 5.898l-.006.039c-.009.07-.92 7.173-.906 19.875.014 12.62.603 17.116 1.172 21.465l.002.015c.308 2.355 3.475 2.923 3.836 2.98l.034.004c.101.013.204.019.305.019a2.77 2.77 0 0 0 1.396-.392l75.273-43.552c1.811-1.071 2.999-3.423 3.542-6.997 1.186-7.814 1.734-33.096-.301-40.299-.253-.893-.704-1.527-1.343-1.882l-.132-.062-2.085-.789a.973.973 0 0 0-.353-.065' fill='#455A64'/><path d='M128.267 11.565l1.495.434-56.339 32.326' fill='#FFF'/><path d='M74.202 90.545a.5.5 0 0 1-.25-.931l18.437-10.645a.499.499 0 1 1 .499.864L74.451 90.478l-.249.067M75.764 42.654l-.108-.062.046-.171 5.135-2.964.17.045-.045.171-5.135 2.964-.063.017M70.52 90.375V46.421l.063-.036L137.84 7.554v43.954l-.062.036L70.52 90.375zm.25-43.811v43.38l66.821-38.579V7.985L70.77 46.564z' fill='#607D8B'/><path d='M86.986 83.182c-.23.149-.612.384-.849.523l-11.505 6.701c-.237.139-.206.252.068.252h.565c.275 0 .693-.113.93-.252L87.7 83.705c.237-.139.428-.253.425-.256a11.29 11.29 0 0 1-.006-.503c0-.274-.188-.377-.418-.227l-.715.463' fill='#607D8B'/><path d='M75.266 90.782H74.7c-.2 0-.316-.056-.346-.166-.03-.11.043-.217.215-.317l11.505-6.702c.236-.138.615-.371.844-.519l.715-.464a.488.488 0 0 1 .266-.089c.172 0 .345.13.345.421 0 .214.001.363.003.437l.006.004-.004.069c-.003.075-.003.075-.486.356l-11.505 6.702a2.282 2.282 0 0 1-.992.268zm-.6-.25l.034.001h.566c.252 0 .649-.108.866-.234l11.505-6.702c.168-.098.294-.173.361-.214-.004-.084-.004-.218-.004-.437l-.095-.171-.131.049-.714.463c-.232.15-.616.386-.854.525l-11.505 6.702-.029.018z' fill='#607D8B'/><path d='M75.266 89.871H74.7c-.2 0-.316-.056-.346-.166-.03-.11.043-.217.215-.317l11.505-6.702c.258-.151.694-.268.993-.268h.565c.2 0 .316.056.346.166.03.11-.043.217-.215.317l-11.505 6.702a2.282 2.282 0 0 1-.992.268zm-.6-.25l.034.001h.566c.252 0 .649-.107.866-.234l11.505-6.702.03-.018-.035-.001h-.565c-.252 0-.649.108-.867.234l-11.505 6.702-.029.018zM74.37 90.801v-1.247 1.247' fill='#607D8B'/><path d='M68.13 93.901c-.751-.093-1.314-.737-1.439-1.376-.831-4.238-1.151-8.782-1.165-21.352-.015-12.784.897-19.745.897-19.745.711-4.146 2.787-5.192 2.787-5.192l74.859-43.219c.223-.129 2.487-1.584 3.195.923 1.95 6.9 1.488 31.887.275 39.878-.389 2.565-1.248 5.215-3.056 6.283L69.21 93.653c-.382.221-.749.288-1.08.248 0 0-2.781-.441-3.001-2.125-.561-4.281-1.152-8.781-1.167-21.351-.014-12.784.898-19.745.898-19.745.71-4.146 2.787-5.191 2.787-5.191l6.598-3.81.871-.119 6.599-3.83.046-.461L68.13 93.901' fill='#FAFAFA'/><path d='M68.317 94.161l-.215-.013h-.001l-.244-.047c-.719-.156-2.772-.736-2.976-2.292-.568-4.34-1.154-8.813-1.168-21.384-.014-12.654.891-19.707.9-19.777.725-4.231 2.832-5.338 2.922-5.382l6.628-3.827.87-.119 6.446-3.742.034-.334a.248.248 0 0 1 .273-.223.248.248 0 0 1 .223.272l-.059.589-6.752 3.919-.87.118-6.556 3.785c-.031.016-1.99 1.068-2.666 5.018-.007.06-.908 7.086-.894 19.702.014 12.539.597 16.996 1.161 21.305.091.691.689 1.154 1.309 1.452a1.95 1.95 0 0 1-.236-.609c-.781-3.984-1.155-8.202-1.17-21.399-.014-12.653.891-19.707.9-19.777.725-4.231 2.832-5.337 2.922-5.382-.004.001 74.444-42.98 74.846-43.212l.028-.017c.904-.538 1.72-.688 2.36-.433.555.221.949.733 1.172 1.52 2.014 7.128 1.46 32.219.281 39.983-.507 3.341-1.575 5.515-3.175 6.462L69.335 93.869a2.023 2.023 0 0 1-1.018.292zm-.147-.507c.293.036.604-.037.915-.217l75.273-43.551c1.823-1.078 2.602-3.915 2.934-6.106 1.174-7.731 1.731-32.695-.268-39.772-.178-.631-.473-1.032-.876-1.192-.484-.193-1.166-.052-1.921.397l-.034.021-74.858 43.218c-.031.017-1.989 1.069-2.666 5.019-.007.059-.908 7.085-.894 19.702.015 13.155.386 17.351 1.161 21.303.09.461.476.983 1.037 1.139.114.025.185.037.196.039h.001z' fill='#455A64'/><path d='M69.317 68.982c.489-.281.885-.056.885.505 0 .56-.396 1.243-.885 1.525-.488.282-.884.057-.884-.504 0-.56.396-1.243.884-1.526' fill='#FFF'/><path d='M68.92 71.133c-.289 0-.487-.228-.487-.625 0-.56.396-1.243.884-1.526a.812.812 0 0 1 .397-.121c.289 0 .488.229.488.626 0 .56-.396 1.243-.885 1.525a.812.812 0 0 1-.397.121m.794-2.459a.976.976 0 0 0-.49.147c-.548.317-.978 1.058-.978 1.687 0 .486.271.812.674.812a.985.985 0 0 0 .491-.146c.548-.317.978-1.057.978-1.687 0-.486-.272-.813-.675-.813' fill='#8097A2'/><path d='M68.92 70.947c-.271 0-.299-.307-.299-.439 0-.491.361-1.116.79-1.363a.632.632 0 0 1 .303-.096c.272 0 .301.306.301.438 0 .491-.363 1.116-.791 1.364a.629.629 0 0 1-.304.096m.794-2.086a.812.812 0 0 0-.397.121c-.488.283-.884.966-.884 1.526 0 .397.198.625.487.625a.812.812 0 0 0 .397-.121c.489-.282.885-.965.885-1.525 0-.397-.199-.626-.488-.626' fill='#8097A2'/><path d='M69.444 85.35c.264-.152.477-.031.477.272 0 .303-.213.67-.477.822-.263.153-.477.031-.477-.271 0-.302.214-.671.477-.823' fill='#FFF'/><path d='M69.23 86.51c-.156 0-.263-.123-.263-.337 0-.302.214-.671.477-.823a.431.431 0 0 1 .214-.066c.156 0 .263.124.263.338 0 .303-.213.67-.477.822a.431.431 0 0 1-.214.066m.428-1.412c-.1 0-.203.029-.307.09-.32.185-.57.618-.57.985 0 .309.185.524.449.524a.63.63 0 0 0 .308-.09c.32-.185.57-.618.57-.985 0-.309-.185-.524-.45-.524' fill='#8097A2'/><path d='M69.23 86.322l-.076-.149c0-.235.179-.544.384-.661l.12-.041.076.151c0 .234-.179.542-.383.66l-.121.04m.428-1.038a.431.431 0 0 0-.214.066c-.263.152-.477.521-.477.823 0 .214.107.337.263.337a.431.431 0 0 0 .214-.066c.264-.152.477-.519.477-.822 0-.214-.107-.338-.263-.338' fill='#8097A2'/><path d='M139.278 7.769v43.667L72.208 90.16V46.493l67.07-38.724' fill='#455A64'/><path d='M72.083 90.375V46.421l.063-.036 67.257-38.831v43.954l-.062.036-67.258 38.831zm.25-43.811v43.38l66.821-38.579V7.985L72.333 46.564z' fill='#607D8B'/></g><path d='M125.737 88.647l-7.639 3.334V84l-11.459 4.713v8.269L99 100.315l13.369 3.646 13.368-15.314' fill='#455A64'/></g></svg>";
                function RotateInstructions() {
                  this.loadIcon_();
                  var overlay = document.createElement('div');
                  var s = overlay.style;
                  s.position = 'fixed';
                  s.top = 0;
                  s.right = 0;
                  s.bottom = 0;
                  s.left = 0;
                  s.backgroundColor = 'gray';
                  s.fontFamily = 'sans-serif';
                  s.zIndex = 1000000;
                  var img = document.createElement('img');
                  img.src = this.icon;
                  var s = img.style;
                  s.marginLeft = '25%';
                  s.marginTop = '25%';
                  s.width = '50%';
                  overlay.appendChild(img);
                  var text = document.createElement('div');
                  var s = text.style;
                  s.textAlign = 'center';
                  s.fontSize = '16px';
                  s.lineHeight = '24px';
                  s.margin = '24px 25%';
                  s.width = '50%';
                  text.innerHTML = 'Place your phone into your Cardboard viewer.';
                  overlay.appendChild(text);
                  var snackbar = document.createElement('div');
                  var s = snackbar.style;
                  s.backgroundColor = '#CFD8DC';
                  s.position = 'fixed';
                  s.bottom = 0;
                  s.width = '100%';
                  s.height = '48px';
                  s.padding = '14px 24px';
                  s.boxSizing = 'border-box';
                  s.color = '#656A6B';
                  overlay.appendChild(snackbar);
                  var snackbarText = document.createElement('div');
                  snackbarText.style.float = 'left';
                  snackbarText.innerHTML = 'No Cardboard viewer?';
                  var snackbarButton = document.createElement('a');
                  snackbarButton.href = 'https://www.google.com/get/cardboard/get-cardboard/';
                  snackbarButton.innerHTML = 'get one';
                  snackbarButton.target = '_blank';
                  var s = snackbarButton.style;
                  s.float = 'right';
                  s.fontWeight = 600;
                  s.textTransform = 'uppercase';
                  s.borderLeft = '1px solid gray';
                  s.paddingLeft = '24px';
                  s.textDecoration = 'none';
                  s.color = '#656A6B';
                  snackbar.appendChild(snackbarText);
                  snackbar.appendChild(snackbarButton);
                  this.overlay = overlay;
                  this.text = text;
                  this.hide();
                }
                RotateInstructions.prototype.show = function (parent) {
                  if (!parent && !this.overlay.parentElement) {
                    document.body.appendChild(this.overlay);
                  } else if (parent) {
                    if (this.overlay.parentElement && this.overlay.parentElement != parent) this.overlay.parentElement.removeChild(this.overlay);
                    parent.appendChild(this.overlay);
                  }
                  this.overlay.style.display = 'block';
                  var img = this.overlay.querySelector('img');
                  var s = img.style;
                  if (isLandscapeMode()) {
                    s.width = '20%';
                    s.marginLeft = '40%';
                    s.marginTop = '3%';
                  } else {
                    s.width = '50%';
                    s.marginLeft = '25%';
                    s.marginTop = '25%';
                  }
                };
                RotateInstructions.prototype.hide = function () {
                  this.overlay.style.display = 'none';
                };
                RotateInstructions.prototype.showTemporarily = function (ms, parent) {
                  this.show(parent);
                  this.timer = setTimeout(this.hide.bind(this), ms);
                };
                RotateInstructions.prototype.disableShowTemporarily = function () {
                  clearTimeout(this.timer);
                };
                RotateInstructions.prototype.update = function () {
                  this.disableShowTemporarily();
                  if (!isLandscapeMode() && isMobile()) {
                    this.show();
                  } else {
                    this.hide();
                  }
                };
                RotateInstructions.prototype.loadIcon_ = function () {
                  this.icon = dataUri('image/svg+xml', rotateInstructionsAsset);
                };
                var DEFAULT_VIEWER = 'CardboardV1';
                var VIEWER_KEY = 'WEBVR_CARDBOARD_VIEWER';
                var CLASS_NAME = 'webvr-polyfill-viewer-selector';
                function ViewerSelector(defaultViewer) {
                  try {
                    this.selectedKey = localStorage.getItem(VIEWER_KEY);
                  } catch (error) {
                    console.error('Failed to load viewer profile: %s', error);
                  }
                  if (!this.selectedKey) {
                    this.selectedKey = defaultViewer || DEFAULT_VIEWER;
                  }
                  this.dialog = this.createDialog_(DeviceInfo.Viewers);
                  this.root = null;
                  this.onChangeCallbacks_ = [];
                }
                ViewerSelector.prototype.show = function (root) {
                  this.root = root;
                  root.appendChild(this.dialog);
                  var selected = this.dialog.querySelector('#' + this.selectedKey);
                  selected.checked = true;
                  this.dialog.style.display = 'block';
                };
                ViewerSelector.prototype.hide = function () {
                  if (this.root && this.root.contains(this.dialog)) {
                    this.root.removeChild(this.dialog);
                  }
                  this.dialog.style.display = 'none';
                };
                ViewerSelector.prototype.getCurrentViewer = function () {
                  return DeviceInfo.Viewers[this.selectedKey];
                };
                ViewerSelector.prototype.getSelectedKey_ = function () {
                  var input = this.dialog.querySelector('input[name=field]:checked');
                  if (input) {
                    return input.id;
                  }
                  return null;
                };
                ViewerSelector.prototype.onChange = function (cb) {
                  this.onChangeCallbacks_.push(cb);
                };
                ViewerSelector.prototype.fireOnChange_ = function (viewer) {
                  for (var i = 0; i < this.onChangeCallbacks_.length; i++) {
                    this.onChangeCallbacks_[i](viewer);
                  }
                };
                ViewerSelector.prototype.onSave_ = function () {
                  this.selectedKey = this.getSelectedKey_();
                  if (!this.selectedKey || !DeviceInfo.Viewers[this.selectedKey]) {
                    console.error('ViewerSelector.onSave_: this should never happen!');
                    return;
                  }
                  this.fireOnChange_(DeviceInfo.Viewers[this.selectedKey]);
                  try {
                    localStorage.setItem(VIEWER_KEY, this.selectedKey);
                  } catch (error) {
                    console.error('Failed to save viewer profile: %s', error);
                  }
                  this.hide();
                };
                ViewerSelector.prototype.createDialog_ = function (options) {
                  var container = document.createElement('div');
                  container.classList.add(CLASS_NAME);
                  container.style.display = 'none';
                  var overlay = document.createElement('div');
                  var s = overlay.style;
                  s.position = 'fixed';
                  s.left = 0;
                  s.top = 0;
                  s.width = '100%';
                  s.height = '100%';
                  s.background = 'rgba(0, 0, 0, 0.3)';
                  overlay.addEventListener('click', this.hide.bind(this));
                  var width = 280;
                  var dialog = document.createElement('div');
                  var s = dialog.style;
                  s.boxSizing = 'border-box';
                  s.position = 'fixed';
                  s.top = '24px';
                  s.left = '50%';
                  s.marginLeft = -width / 2 + 'px';
                  s.width = width + 'px';
                  s.padding = '24px';
                  s.overflow = 'hidden';
                  s.background = '#fafafa';
                  s.fontFamily = "'Roboto', sans-serif";
                  s.boxShadow = '0px 5px 20px #666';
                  dialog.appendChild(this.createH1_('Select your viewer'));
                  for (var id in options) {
                    dialog.appendChild(this.createChoice_(id, options[id].label));
                  }
                  dialog.appendChild(this.createButton_('Save', this.onSave_.bind(this)));
                  container.appendChild(overlay);
                  container.appendChild(dialog);
                  return container;
                };
                ViewerSelector.prototype.createH1_ = function (name) {
                  var h1 = document.createElement('h1');
                  var s = h1.style;
                  s.color = 'black';
                  s.fontSize = '20px';
                  s.fontWeight = 'bold';
                  s.marginTop = 0;
                  s.marginBottom = '24px';
                  h1.innerHTML = name;
                  return h1;
                };
                ViewerSelector.prototype.createChoice_ = function (id, name) {
                  var div = document.createElement('div');
                  div.style.marginTop = '8px';
                  div.style.color = 'black';
                  var input = document.createElement('input');
                  input.style.fontSize = '30px';
                  input.setAttribute('id', id);
                  input.setAttribute('type', 'radio');
                  input.setAttribute('value', id);
                  input.setAttribute('name', 'field');
                  var label = document.createElement('label');
                  label.style.marginLeft = '4px';
                  label.setAttribute('for', id);
                  label.innerHTML = name;
                  div.appendChild(input);
                  div.appendChild(label);
                  return div;
                };
                ViewerSelector.prototype.createButton_ = function (label, onclick) {
                  var button = document.createElement('button');
                  button.innerHTML = label;
                  var s = button.style;
                  s.float = 'right';
                  s.textTransform = 'uppercase';
                  s.color = '#1094f7';
                  s.fontSize = '14px';
                  s.letterSpacing = 0;
                  s.border = 0;
                  s.background = 'none';
                  s.marginTop = '16px';
                  button.addEventListener('click', onclick);
                  return button;
                };
                var commonjsGlobal$$1 = typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};
                function unwrapExports$$1(x) {
                  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
                }
                function createCommonjsModule$$1(fn, module) {
                  return module = {
                    exports: {}
                  }, fn(module, module.exports), module.exports;
                }
                var NoSleep = createCommonjsModule$$1(function (module, exports) {
                  (function webpackUniversalModuleDefinition(root, factory) {
                    module.exports = factory();
                  })(commonjsGlobal$$1, function () {
                    return function (modules) {
                      var installedModules = {};
                      function __nested_webpack_require_167216__(moduleId) {
                        if (installedModules[moduleId]) {
                          return installedModules[moduleId].exports;
                        }
                        var module = installedModules[moduleId] = {
                          i: moduleId,
                          l: false,
                          exports: {}
                        };
                        modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_167216__);
                        module.l = true;
                        return module.exports;
                      }
                      __nested_webpack_require_167216__.m = modules;
                      __nested_webpack_require_167216__.c = installedModules;
                      __nested_webpack_require_167216__.d = function (exports, name, getter) {
                        if (!__nested_webpack_require_167216__.o(exports, name)) {
                          Object.defineProperty(exports, name, {
                            configurable: false,
                            enumerable: true,
                            get: getter
                          });
                        }
                      };
                      __nested_webpack_require_167216__.n = function (module) {
                        var getter = module && module.__esModule ? function getDefault() {
                          return module['default'];
                        } : function getModuleExports() {
                          return module;
                        };
                        __nested_webpack_require_167216__.d(getter, 'a', getter);
                        return getter;
                      };
                      __nested_webpack_require_167216__.o = function (object, property) {
                        return Object.prototype.hasOwnProperty.call(object, property);
                      };
                      __nested_webpack_require_167216__.p = "";
                      return __nested_webpack_require_167216__(__nested_webpack_require_167216__.s = 0);
                    }([function (module, exports, __nested_webpack_require_168841__) {
                      var _createClass = function () {
                        function defineProperties(target, props) {
                          for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                          }
                        }
                        return function (Constructor, protoProps, staticProps) {
                          if (protoProps) defineProperties(Constructor.prototype, protoProps);
                          if (staticProps) defineProperties(Constructor, staticProps);
                          return Constructor;
                        };
                      }();
                      function _classCallCheck(instance, Constructor) {
                        if (!(instance instanceof Constructor)) {
                          throw new TypeError("Cannot call a class as a function");
                        }
                      }
                      var mediaFile = __nested_webpack_require_168841__(1);
                      var oldIOS = typeof navigator !== 'undefined' && parseFloat(('' + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) < 10 && !window.MSStream;
                      var NoSleep = function () {
                        function NoSleep() {
                          _classCallCheck(this, NoSleep);
                          if (oldIOS) {
                            this.noSleepTimer = null;
                          } else {
                            this.noSleepVideo = document.createElement('video');
                            this.noSleepVideo.setAttribute('playsinline', '');
                            this.noSleepVideo.setAttribute('src', mediaFile);
                            this.noSleepVideo.addEventListener('timeupdate', function (e) {
                              if (this.noSleepVideo.currentTime > 0.5) {
                                this.noSleepVideo.currentTime = Math.random();
                              }
                            }.bind(this));
                          }
                        }
                        _createClass(NoSleep, [{
                          key: 'enable',
                          value: function enable() {
                            if (oldIOS) {
                              this.disable();
                              this.noSleepTimer = window.setInterval(function () {
                                window.location.href = '/';
                                window.setTimeout(window.stop, 0);
                              }, 15000);
                            } else {
                              this.noSleepVideo.play();
                            }
                          }
                        }, {
                          key: 'disable',
                          value: function disable() {
                            if (oldIOS) {
                              if (this.noSleepTimer) {
                                window.clearInterval(this.noSleepTimer);
                                this.noSleepTimer = null;
                              }
                            } else {
                              this.noSleepVideo.pause();
                            }
                          }
                        }]);
                        return NoSleep;
                      }();
                      module.exports = NoSleep;
                    }, function (module, exports, __webpack_require__) {
                      module.exports = 'data:video/mp4;base64,AAAAIGZ0eXBtcDQyAAACAGlzb21pc28yYXZjMW1wNDEAAAAIZnJlZQAACKBtZGF0AAAC8wYF///v3EXpvebZSLeWLNgg2SPu73gyNjQgLSBjb3JlIDE0MiByMjQ3OSBkZDc5YTYxIC0gSC4yNjQvTVBFRy00IEFWQyBjb2RlYyAtIENvcHlsZWZ0IDIwMDMtMjAxNCAtIGh0dHA6Ly93d3cudmlkZW9sYW4ub3JnL3gyNjQuaHRtbCAtIG9wdGlvbnM6IGNhYmFjPTEgcmVmPTEgZGVibG9jaz0xOjA6MCBhbmFseXNlPTB4MToweDExMSBtZT1oZXggc3VibWU9MiBwc3k9MSBwc3lfcmQ9MS4wMDowLjAwIG1peGVkX3JlZj0wIG1lX3JhbmdlPTE2IGNocm9tYV9tZT0xIHRyZWxsaXM9MCA4eDhkY3Q9MCBjcW09MCBkZWFkem9uZT0yMSwxMSBmYXN0X3Bza2lwPTEgY2hyb21hX3FwX29mZnNldD0wIHRocmVhZHM9NiBsb29rYWhlYWRfdGhyZWFkcz0xIHNsaWNlZF90aHJlYWRzPTAgbnI9MCBkZWNpbWF0ZT0xIGludGVybGFjZWQ9MCBibHVyYXlfY29tcGF0PTAgY29uc3RyYWluZWRfaW50cmE9MCBiZnJhbWVzPTMgYl9weXJhbWlkPTIgYl9hZGFwdD0xIGJfYmlhcz0wIGRpcmVjdD0xIHdlaWdodGI9MSBvcGVuX2dvcD0wIHdlaWdodHA9MSBrZXlpbnQ9MzAwIGtleWludF9taW49MzAgc2NlbmVjdXQ9NDAgaW50cmFfcmVmcmVzaD0wIHJjX2xvb2thaGVhZD0xMCByYz1jcmYgbWJ0cmVlPTEgY3JmPTIwLjAgcWNvbXA9MC42MCBxcG1pbj0wIHFwbWF4PTY5IHFwc3RlcD00IHZidl9tYXhyYXRlPTIwMDAwIHZidl9idWZzaXplPTI1MDAwIGNyZl9tYXg9MC4wIG5hbF9ocmQ9bm9uZSBmaWxsZXI9MCBpcF9yYXRpbz0xLjQwIGFxPTE6MS4wMACAAAAAOWWIhAA3//p+C7v8tDDSTjf97w55i3SbRPO4ZY+hkjD5hbkAkL3zpJ6h/LR1CAABzgB1kqqzUorlhQAAAAxBmiQYhn/+qZYADLgAAAAJQZ5CQhX/AAj5IQADQGgcIQADQGgcAAAACQGeYUQn/wALKCEAA0BoHAAAAAkBnmNEJ/8ACykhAANAaBwhAANAaBwAAAANQZpoNExDP/6plgAMuSEAA0BoHAAAAAtBnoZFESwr/wAI+SEAA0BoHCEAA0BoHAAAAAkBnqVEJ/8ACykhAANAaBwAAAAJAZ6nRCf/AAsoIQADQGgcIQADQGgcAAAADUGarDRMQz/+qZYADLghAANAaBwAAAALQZ7KRRUsK/8ACPkhAANAaBwAAAAJAZ7pRCf/AAsoIQADQGgcIQADQGgcAAAACQGe60Qn/wALKCEAA0BoHAAAAA1BmvA0TEM//qmWAAy5IQADQGgcIQADQGgcAAAAC0GfDkUVLCv/AAj5IQADQGgcAAAACQGfLUQn/wALKSEAA0BoHCEAA0BoHAAAAAkBny9EJ/8ACyghAANAaBwAAAANQZs0NExDP/6plgAMuCEAA0BoHAAAAAtBn1JFFSwr/wAI+SEAA0BoHCEAA0BoHAAAAAkBn3FEJ/8ACyghAANAaBwAAAAJAZ9zRCf/AAsoIQADQGgcIQADQGgcAAAADUGbeDRMQz/+qZYADLkhAANAaBwAAAALQZ+WRRUsK/8ACPghAANAaBwhAANAaBwAAAAJAZ+1RCf/AAspIQADQGgcAAAACQGft0Qn/wALKSEAA0BoHCEAA0BoHAAAAA1Bm7w0TEM//qmWAAy4IQADQGgcAAAAC0Gf2kUVLCv/AAj5IQADQGgcAAAACQGf+UQn/wALKCEAA0BoHCEAA0BoHAAAAAkBn/tEJ/8ACykhAANAaBwAAAANQZvgNExDP/6plgAMuSEAA0BoHCEAA0BoHAAAAAtBnh5FFSwr/wAI+CEAA0BoHAAAAAkBnj1EJ/8ACyghAANAaBwhAANAaBwAAAAJAZ4/RCf/AAspIQADQGgcAAAADUGaJDRMQz/+qZYADLghAANAaBwAAAALQZ5CRRUsK/8ACPkhAANAaBwhAANAaBwAAAAJAZ5hRCf/AAsoIQADQGgcAAAACQGeY0Qn/wALKSEAA0BoHCEAA0BoHAAAAA1Bmmg0TEM//qmWAAy5IQADQGgcAAAAC0GehkUVLCv/AAj5IQADQGgcIQADQGgcAAAACQGepUQn/wALKSEAA0BoHAAAAAkBnqdEJ/8ACyghAANAaBwAAAANQZqsNExDP/6plgAMuCEAA0BoHCEAA0BoHAAAAAtBnspFFSwr/wAI+SEAA0BoHAAAAAkBnulEJ/8ACyghAANAaBwhAANAaBwAAAAJAZ7rRCf/AAsoIQADQGgcAAAADUGa8DRMQz/+qZYADLkhAANAaBwhAANAaBwAAAALQZ8ORRUsK/8ACPkhAANAaBwAAAAJAZ8tRCf/AAspIQADQGgcIQADQGgcAAAACQGfL0Qn/wALKCEAA0BoHAAAAA1BmzQ0TEM//qmWAAy4IQADQGgcAAAAC0GfUkUVLCv/AAj5IQADQGgcIQADQGgcAAAACQGfcUQn/wALKCEAA0BoHAAAAAkBn3NEJ/8ACyghAANAaBwhAANAaBwAAAANQZt4NExC//6plgAMuSEAA0BoHAAAAAtBn5ZFFSwr/wAI+CEAA0BoHCEAA0BoHAAAAAkBn7VEJ/8ACykhAANAaBwAAAAJAZ+3RCf/AAspIQADQGgcAAAADUGbuzRMQn/+nhAAYsAhAANAaBwhAANAaBwAAAAJQZ/aQhP/AAspIQADQGgcAAAACQGf+UQn/wALKCEAA0BoHCEAA0BoHCEAA0BoHCEAA0BoHCEAA0BoHCEAA0BoHAAACiFtb292AAAAbG12aGQAAAAA1YCCX9WAgl8AAAPoAAAH/AABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAAGGlvZHMAAAAAEICAgAcAT////v7/AAAF+XRyYWsAAABcdGtoZAAAAAPVgIJf1YCCXwAAAAEAAAAAAAAH0AAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAygAAAMoAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAB9AAABdwAAEAAAAABXFtZGlhAAAAIG1kaGQAAAAA1YCCX9WAgl8AAV+QAAK/IFXEAAAAAAAtaGRscgAAAAAAAAAAdmlkZQAAAAAAAAAAAAAAAFZpZGVvSGFuZGxlcgAAAAUcbWluZgAAABR2bWhkAAAAAQAAAAAAAAAAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAAE3HN0YmwAAACYc3RzZAAAAAAAAAABAAAAiGF2YzEAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAygDKAEgAAABIAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY//8AAAAyYXZjQwFNQCj/4QAbZ01AKOyho3ySTUBAQFAAAAMAEAAr8gDxgxlgAQAEaO+G8gAAABhzdHRzAAAAAAAAAAEAAAA8AAALuAAAABRzdHNzAAAAAAAAAAEAAAABAAAB8GN0dHMAAAAAAAAAPAAAAAEAABdwAAAAAQAAOpgAAAABAAAXcAAAAAEAAAAAAAAAAQAAC7gAAAABAAA6mAAAAAEAABdwAAAAAQAAAAAAAAABAAALuAAAAAEAADqYAAAAAQAAF3AAAAABAAAAAAAAAAEAAAu4AAAAAQAAOpgAAAABAAAXcAAAAAEAAAAAAAAAAQAAC7gAAAABAAA6mAAAAAEAABdwAAAAAQAAAAAAAAABAAALuAAAAAEAADqYAAAAAQAAF3AAAAABAAAAAAAAAAEAAAu4AAAAAQAAOpgAAAABAAAXcAAAAAEAAAAAAAAAAQAAC7gAAAABAAA6mAAAAAEAABdwAAAAAQAAAAAAAAABAAALuAAAAAEAADqYAAAAAQAAF3AAAAABAAAAAAAAAAEAAAu4AAAAAQAAOpgAAAABAAAXcAAAAAEAAAAAAAAAAQAAC7gAAAABAAA6mAAAAAEAABdwAAAAAQAAAAAAAAABAAALuAAAAAEAADqYAAAAAQAAF3AAAAABAAAAAAAAAAEAAAu4AAAAAQAAOpgAAAABAAAXcAAAAAEAAAAAAAAAAQAAC7gAAAABAAA6mAAAAAEAABdwAAAAAQAAAAAAAAABAAALuAAAAAEAAC7gAAAAAQAAF3AAAAABAAAAAAAAABxzdHNjAAAAAAAAAAEAAAABAAAAAQAAAAEAAAEEc3RzegAAAAAAAAAAAAAAPAAAAzQAAAAQAAAADQAAAA0AAAANAAAAEQAAAA8AAAANAAAADQAAABEAAAAPAAAADQAAAA0AAAARAAAADwAAAA0AAAANAAAAEQAAAA8AAAANAAAADQAAABEAAAAPAAAADQAAAA0AAAARAAAADwAAAA0AAAANAAAAEQAAAA8AAAANAAAADQAAABEAAAAPAAAADQAAAA0AAAARAAAADwAAAA0AAAANAAAAEQAAAA8AAAANAAAADQAAABEAAAAPAAAADQAAAA0AAAARAAAADwAAAA0AAAANAAAAEQAAAA8AAAANAAAADQAAABEAAAANAAAADQAAAQBzdGNvAAAAAAAAADwAAAAwAAADZAAAA3QAAAONAAADoAAAA7kAAAPQAAAD6wAAA/4AAAQXAAAELgAABEMAAARcAAAEbwAABIwAAAShAAAEugAABM0AAATkAAAE/wAABRIAAAUrAAAFQgAABV0AAAVwAAAFiQAABaAAAAW1AAAFzgAABeEAAAX+AAAGEwAABiwAAAY/AAAGVgAABnEAAAaEAAAGnQAABrQAAAbPAAAG4gAABvUAAAcSAAAHJwAAB0AAAAdTAAAHcAAAB4UAAAeeAAAHsQAAB8gAAAfjAAAH9gAACA8AAAgmAAAIQQAACFQAAAhnAAAIhAAACJcAAAMsdHJhawAAAFx0a2hkAAAAA9WAgl/VgIJfAAAAAgAAAAAAAAf8AAAAAAAAAAAAAAABAQAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAACsm1kaWEAAAAgbWRoZAAAAADVgIJf1YCCXwAArEQAAWAAVcQAAAAAACdoZGxyAAAAAAAAAABzb3VuAAAAAAAAAAAAAAAAU3RlcmVvAAAAAmNtaW5mAAAAEHNtaGQAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAidzdGJsAAAAZ3N0c2QAAAAAAAAAAQAAAFdtcDRhAAAAAAAAAAEAAAAAAAAAAAACABAAAAAArEQAAAAAADNlc2RzAAAAAAOAgIAiAAIABICAgBRAFQAAAAADDUAAAAAABYCAgAISEAaAgIABAgAAABhzdHRzAAAAAAAAAAEAAABYAAAEAAAAABxzdHNjAAAAAAAAAAEAAAABAAAAAQAAAAEAAAAUc3RzegAAAAAAAAAGAAAAWAAAAXBzdGNvAAAAAAAAAFgAAAOBAAADhwAAA5oAAAOtAAADswAAA8oAAAPfAAAD5QAAA/gAAAQLAAAEEQAABCgAAAQ9AAAEUAAABFYAAARpAAAEgAAABIYAAASbAAAErgAABLQAAATHAAAE3gAABPMAAAT5AAAFDAAABR8AAAUlAAAFPAAABVEAAAVXAAAFagAABX0AAAWDAAAFmgAABa8AAAXCAAAFyAAABdsAAAXyAAAF+AAABg0AAAYgAAAGJgAABjkAAAZQAAAGZQAABmsAAAZ+AAAGkQAABpcAAAauAAAGwwAABskAAAbcAAAG7wAABwYAAAcMAAAHIQAABzQAAAc6AAAHTQAAB2QAAAdqAAAHfwAAB5IAAAeYAAAHqwAAB8IAAAfXAAAH3QAAB/AAAAgDAAAICQAACCAAAAg1AAAIOwAACE4AAAhhAAAIeAAACH4AAAiRAAAIpAAACKoAAAiwAAAItgAACLwAAAjCAAAAFnVkdGEAAAAObmFtZVN0ZXJlbwAAAHB1ZHRhAAAAaG1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAAO2lsc3QAAAAzqXRvbwAAACtkYXRhAAAAAQAAAABIYW5kQnJha2UgMC4xMC4yIDIwMTUwNjExMDA=';
                    }]);
                  });
                });
                var NoSleep$1 = unwrapExports$$1(NoSleep);
                var nextDisplayId = 1000;
                var defaultLeftBounds = [0, 0, 0.5, 1];
                var defaultRightBounds = [0.5, 0, 0.5, 1];
                var raf = window.requestAnimationFrame;
                var caf = window.cancelAnimationFrame;
                function VRFrameData() {
                  this.leftProjectionMatrix = new Float32Array(16);
                  this.leftViewMatrix = new Float32Array(16);
                  this.rightProjectionMatrix = new Float32Array(16);
                  this.rightViewMatrix = new Float32Array(16);
                  this.pose = null;
                }
                function VRDisplayCapabilities(config) {
                  Object.defineProperties(this, {
                    hasPosition: {
                      writable: false,
                      enumerable: true,
                      value: config.hasPosition
                    },
                    hasExternalDisplay: {
                      writable: false,
                      enumerable: true,
                      value: config.hasExternalDisplay
                    },
                    canPresent: {
                      writable: false,
                      enumerable: true,
                      value: config.canPresent
                    },
                    maxLayers: {
                      writable: false,
                      enumerable: true,
                      value: config.maxLayers
                    },
                    hasOrientation: {
                      enumerable: true,
                      get: function get() {
                        deprecateWarning('VRDisplayCapabilities.prototype.hasOrientation', 'VRDisplay.prototype.getFrameData');
                        return config.hasOrientation;
                      }
                    }
                  });
                }
                function VRDisplay(config) {
                  config = config || {};
                  var USE_WAKELOCK = 'wakelock' in config ? config.wakelock : true;
                  this.isPolyfilled = true;
                  this.displayId = nextDisplayId++;
                  this.displayName = '';
                  this.depthNear = 0.01;
                  this.depthFar = 10000.0;
                  this.isPresenting = false;
                  Object.defineProperty(this, 'isConnected', {
                    get: function get() {
                      deprecateWarning('VRDisplay.prototype.isConnected', 'VRDisplayCapabilities.prototype.hasExternalDisplay');
                      return false;
                    }
                  });
                  this.capabilities = new VRDisplayCapabilities({
                    hasPosition: false,
                    hasOrientation: false,
                    hasExternalDisplay: false,
                    canPresent: false,
                    maxLayers: 1
                  });
                  this.stageParameters = null;
                  this.waitingForPresent_ = false;
                  this.layer_ = null;
                  this.originalParent_ = null;
                  this.fullscreenElement_ = null;
                  this.fullscreenWrapper_ = null;
                  this.fullscreenElementCachedStyle_ = null;
                  this.fullscreenEventTarget_ = null;
                  this.fullscreenChangeHandler_ = null;
                  this.fullscreenErrorHandler_ = null;
                  if (USE_WAKELOCK && isMobile()) {
                    this.wakelock_ = new NoSleep$1();
                  }
                }
                VRDisplay.prototype.getFrameData = function (frameData) {
                  return frameDataFromPose(frameData, this._getPose(), this);
                };
                VRDisplay.prototype.getPose = function () {
                  deprecateWarning('VRDisplay.prototype.getPose', 'VRDisplay.prototype.getFrameData');
                  return this._getPose();
                };
                VRDisplay.prototype.resetPose = function () {
                  deprecateWarning('VRDisplay.prototype.resetPose');
                  return this._resetPose();
                };
                VRDisplay.prototype.getImmediatePose = function () {
                  deprecateWarning('VRDisplay.prototype.getImmediatePose', 'VRDisplay.prototype.getFrameData');
                  return this._getPose();
                };
                VRDisplay.prototype.requestAnimationFrame = function (callback) {
                  return raf(callback);
                };
                VRDisplay.prototype.cancelAnimationFrame = function (id) {
                  return caf(id);
                };
                VRDisplay.prototype.wrapForFullscreen = function (element) {
                  if (isIOS()) {
                    return element;
                  }
                  if (!this.fullscreenWrapper_) {
                    this.fullscreenWrapper_ = document.createElement('div');
                    var cssProperties = ['height: ' + Math.min(screen.height, screen.width) + 'px !important', 'top: 0 !important', 'left: 0 !important', 'right: 0 !important', 'border: 0', 'margin: 0', 'padding: 0', 'z-index: 999999 !important', 'position: fixed'];
                    this.fullscreenWrapper_.setAttribute('style', cssProperties.join('; ') + ';');
                    this.fullscreenWrapper_.classList.add('webvr-polyfill-fullscreen-wrapper');
                  }
                  if (this.fullscreenElement_ == element) {
                    return this.fullscreenWrapper_;
                  }
                  if (this.fullscreenElement_) {
                    if (this.originalParent_) {
                      this.originalParent_.appendChild(this.fullscreenElement_);
                    } else {
                      this.fullscreenElement_.parentElement.removeChild(this.fullscreenElement_);
                    }
                  }
                  this.fullscreenElement_ = element;
                  this.originalParent_ = element.parentElement;
                  if (!this.originalParent_) {
                    document.body.appendChild(element);
                  }
                  if (!this.fullscreenWrapper_.parentElement) {
                    var parent = this.fullscreenElement_.parentElement;
                    parent.insertBefore(this.fullscreenWrapper_, this.fullscreenElement_);
                    parent.removeChild(this.fullscreenElement_);
                  }
                  this.fullscreenWrapper_.insertBefore(this.fullscreenElement_, this.fullscreenWrapper_.firstChild);
                  this.fullscreenElementCachedStyle_ = this.fullscreenElement_.getAttribute('style');
                  var self = this;
                  function applyFullscreenElementStyle() {
                    if (!self.fullscreenElement_) {
                      return;
                    }
                    var cssProperties = ['position: absolute', 'top: 0', 'left: 0', 'width: ' + Math.max(screen.width, screen.height) + 'px', 'height: ' + Math.min(screen.height, screen.width) + 'px', 'border: 0', 'margin: 0', 'padding: 0'];
                    self.fullscreenElement_.setAttribute('style', cssProperties.join('; ') + ';');
                  }
                  applyFullscreenElementStyle();
                  return this.fullscreenWrapper_;
                };
                VRDisplay.prototype.removeFullscreenWrapper = function () {
                  if (!this.fullscreenElement_) {
                    return;
                  }
                  var element = this.fullscreenElement_;
                  if (this.fullscreenElementCachedStyle_) {
                    element.setAttribute('style', this.fullscreenElementCachedStyle_);
                  } else {
                    element.removeAttribute('style');
                  }
                  this.fullscreenElement_ = null;
                  this.fullscreenElementCachedStyle_ = null;
                  var parent = this.fullscreenWrapper_.parentElement;
                  this.fullscreenWrapper_.removeChild(element);
                  if (this.originalParent_ === parent) {
                    parent.insertBefore(element, this.fullscreenWrapper_);
                  } else if (this.originalParent_) {
                    this.originalParent_.appendChild(element);
                  }
                  parent.removeChild(this.fullscreenWrapper_);
                  return element;
                };
                VRDisplay.prototype.requestPresent = function (layers) {
                  var wasPresenting = this.isPresenting;
                  var self = this;
                  if (!(layers instanceof Array)) {
                    deprecateWarning('VRDisplay.prototype.requestPresent with non-array argument', 'an array of VRLayers as the first argument');
                    layers = [layers];
                  }
                  return new Promise(function (resolve, reject) {
                    if (!self.capabilities.canPresent) {
                      reject(new Error('VRDisplay is not capable of presenting.'));
                      return;
                    }
                    if (layers.length == 0 || layers.length > self.capabilities.maxLayers) {
                      reject(new Error('Invalid number of layers.'));
                      return;
                    }
                    var incomingLayer = layers[0];
                    if (!incomingLayer.source) {
                      resolve();
                      return;
                    }
                    var leftBounds = incomingLayer.leftBounds || defaultLeftBounds;
                    var rightBounds = incomingLayer.rightBounds || defaultRightBounds;
                    if (wasPresenting) {
                      var layer = self.layer_;
                      if (layer.source !== incomingLayer.source) {
                        layer.source = incomingLayer.source;
                      }
                      for (var i = 0; i < 4; i++) {
                        layer.leftBounds[i] = leftBounds[i];
                        layer.rightBounds[i] = rightBounds[i];
                      }
                      self.wrapForFullscreen(self.layer_.source);
                      self.updatePresent_();
                      resolve();
                      return;
                    }
                    self.layer_ = {
                      predistorted: incomingLayer.predistorted,
                      source: incomingLayer.source,
                      leftBounds: leftBounds.slice(0),
                      rightBounds: rightBounds.slice(0)
                    };
                    self.waitingForPresent_ = false;
                    if (self.layer_ && self.layer_.source) {
                      var fullscreenElement = self.wrapForFullscreen(self.layer_.source);
                      var onFullscreenChange = function onFullscreenChange() {
                        var actualFullscreenElement = getFullscreenElement();
                        self.isPresenting = fullscreenElement === actualFullscreenElement;
                        if (self.isPresenting) {
                          if (screen.orientation && screen.orientation.lock) {
                            screen.orientation.lock('landscape-primary').catch(function (error) {
                              console.error('screen.orientation.lock() failed due to', error.message);
                            });
                          }
                          self.waitingForPresent_ = false;
                          self.beginPresent_();
                          resolve();
                        } else {
                          if (screen.orientation && screen.orientation.unlock) {
                            screen.orientation.unlock();
                          }
                          self.removeFullscreenWrapper();
                          self.disableWakeLock();
                          self.endPresent_();
                          self.removeFullscreenListeners_();
                        }
                        self.fireVRDisplayPresentChange_();
                      };
                      var onFullscreenError = function onFullscreenError() {
                        if (!self.waitingForPresent_) {
                          return;
                        }
                        self.removeFullscreenWrapper();
                        self.removeFullscreenListeners_();
                        self.disableWakeLock();
                        self.waitingForPresent_ = false;
                        self.isPresenting = false;
                        reject(new Error('Unable to present.'));
                      };
                      self.addFullscreenListeners_(fullscreenElement, onFullscreenChange, onFullscreenError);
                      if (requestFullscreen(fullscreenElement)) {
                        self.enableWakeLock();
                        self.waitingForPresent_ = true;
                      } else if (isIOS() || isWebViewAndroid()) {
                        self.enableWakeLock();
                        self.isPresenting = true;
                        self.beginPresent_();
                        self.fireVRDisplayPresentChange_();
                        resolve();
                      }
                    }
                    if (!self.waitingForPresent_ && !isIOS()) {
                      exitFullscreen();
                      reject(new Error('Unable to present.'));
                    }
                  });
                };
                VRDisplay.prototype.exitPresent = function () {
                  var wasPresenting = this.isPresenting;
                  var self = this;
                  this.isPresenting = false;
                  this.layer_ = null;
                  this.disableWakeLock();
                  return new Promise(function (resolve, reject) {
                    if (wasPresenting) {
                      if (!exitFullscreen() && isIOS()) {
                        self.endPresent_();
                        self.fireVRDisplayPresentChange_();
                      }
                      if (isWebViewAndroid()) {
                        self.removeFullscreenWrapper();
                        self.removeFullscreenListeners_();
                        self.endPresent_();
                        self.fireVRDisplayPresentChange_();
                      }
                      resolve();
                    } else {
                      reject(new Error('Was not presenting to VRDisplay.'));
                    }
                  });
                };
                VRDisplay.prototype.getLayers = function () {
                  if (this.layer_) {
                    return [this.layer_];
                  }
                  return [];
                };
                VRDisplay.prototype.fireVRDisplayPresentChange_ = function () {
                  var event = new CustomEvent('vrdisplaypresentchange', {
                    detail: {
                      display: this
                    }
                  });
                  window.dispatchEvent(event);
                };
                VRDisplay.prototype.fireVRDisplayConnect_ = function () {
                  var event = new CustomEvent('vrdisplayconnect', {
                    detail: {
                      display: this
                    }
                  });
                  window.dispatchEvent(event);
                };
                VRDisplay.prototype.addFullscreenListeners_ = function (element, changeHandler, errorHandler) {
                  this.removeFullscreenListeners_();
                  this.fullscreenEventTarget_ = element;
                  this.fullscreenChangeHandler_ = changeHandler;
                  this.fullscreenErrorHandler_ = errorHandler;
                  if (changeHandler) {
                    if (document.fullscreenEnabled) {
                      element.addEventListener('fullscreenchange', changeHandler, false);
                    } else if (document.webkitFullscreenEnabled) {
                      element.addEventListener('webkitfullscreenchange', changeHandler, false);
                    } else if (document.mozFullScreenEnabled) {
                      document.addEventListener('mozfullscreenchange', changeHandler, false);
                    } else if (document.msFullscreenEnabled) {
                      element.addEventListener('msfullscreenchange', changeHandler, false);
                    }
                  }
                  if (errorHandler) {
                    if (document.fullscreenEnabled) {
                      element.addEventListener('fullscreenerror', errorHandler, false);
                    } else if (document.webkitFullscreenEnabled) {
                      element.addEventListener('webkitfullscreenerror', errorHandler, false);
                    } else if (document.mozFullScreenEnabled) {
                      document.addEventListener('mozfullscreenerror', errorHandler, false);
                    } else if (document.msFullscreenEnabled) {
                      element.addEventListener('msfullscreenerror', errorHandler, false);
                    }
                  }
                };
                VRDisplay.prototype.removeFullscreenListeners_ = function () {
                  if (!this.fullscreenEventTarget_) return;
                  var element = this.fullscreenEventTarget_;
                  if (this.fullscreenChangeHandler_) {
                    var changeHandler = this.fullscreenChangeHandler_;
                    element.removeEventListener('fullscreenchange', changeHandler, false);
                    element.removeEventListener('webkitfullscreenchange', changeHandler, false);
                    document.removeEventListener('mozfullscreenchange', changeHandler, false);
                    element.removeEventListener('msfullscreenchange', changeHandler, false);
                  }
                  if (this.fullscreenErrorHandler_) {
                    var errorHandler = this.fullscreenErrorHandler_;
                    element.removeEventListener('fullscreenerror', errorHandler, false);
                    element.removeEventListener('webkitfullscreenerror', errorHandler, false);
                    document.removeEventListener('mozfullscreenerror', errorHandler, false);
                    element.removeEventListener('msfullscreenerror', errorHandler, false);
                  }
                  this.fullscreenEventTarget_ = null;
                  this.fullscreenChangeHandler_ = null;
                  this.fullscreenErrorHandler_ = null;
                };
                VRDisplay.prototype.enableWakeLock = function () {
                  if (this.wakelock_) {
                    this.wakelock_.enable();
                  }
                };
                VRDisplay.prototype.disableWakeLock = function () {
                  if (this.wakelock_) {
                    this.wakelock_.disable();
                  }
                };
                VRDisplay.prototype.beginPresent_ = function () {};
                VRDisplay.prototype.endPresent_ = function () {};
                VRDisplay.prototype.submitFrame = function (pose) {};
                VRDisplay.prototype.getEyeParameters = function (whichEye) {
                  return null;
                };
                var config = {
                  ADDITIONAL_VIEWERS: [],
                  DEFAULT_VIEWER: '',
                  MOBILE_WAKE_LOCK: true,
                  DEBUG: false,
                  DPDB_URL: 'https://dpdb.webvr.rocks/dpdb.json',
                  K_FILTER: 0.98,
                  PREDICTION_TIME_S: 0.040,
                  CARDBOARD_UI_DISABLED: false,
                  ROTATE_INSTRUCTIONS_DISABLED: false,
                  YAW_ONLY: false,
                  BUFFER_SCALE: 0.5,
                  DIRTY_SUBMIT_FRAME_BINDINGS: false
                };
                var Eye = {
                  LEFT: 'left',
                  RIGHT: 'right'
                };
                function CardboardVRDisplay(config$$1) {
                  var defaults = extend({}, config);
                  config$$1 = extend(defaults, config$$1 || {});
                  VRDisplay.call(this, {
                    wakelock: config$$1.MOBILE_WAKE_LOCK
                  });
                  this.config = config$$1;
                  this.displayName = 'Cardboard VRDisplay';
                  this.capabilities = new VRDisplayCapabilities({
                    hasPosition: false,
                    hasOrientation: true,
                    hasExternalDisplay: false,
                    canPresent: true,
                    maxLayers: 1
                  });
                  this.stageParameters = null;
                  this.bufferScale_ = this.config.BUFFER_SCALE;
                  this.poseSensor_ = new PoseSensor(this.config);
                  this.distorter_ = null;
                  this.cardboardUI_ = null;
                  this.dpdb_ = new Dpdb(this.config.DPDB_URL, this.onDeviceParamsUpdated_.bind(this));
                  this.deviceInfo_ = new DeviceInfo(this.dpdb_.getDeviceParams(), config$$1.ADDITIONAL_VIEWERS);
                  this.viewerSelector_ = new ViewerSelector(config$$1.DEFAULT_VIEWER);
                  this.viewerSelector_.onChange(this.onViewerChanged_.bind(this));
                  this.deviceInfo_.setViewer(this.viewerSelector_.getCurrentViewer());
                  if (!this.config.ROTATE_INSTRUCTIONS_DISABLED) {
                    this.rotateInstructions_ = new RotateInstructions();
                  }
                  if (isIOS()) {
                    window.addEventListener('resize', this.onResize_.bind(this));
                  }
                }
                CardboardVRDisplay.prototype = Object.create(VRDisplay.prototype);
                CardboardVRDisplay.prototype._getPose = function () {
                  return {
                    position: null,
                    orientation: this.poseSensor_.getOrientation(),
                    linearVelocity: null,
                    linearAcceleration: null,
                    angularVelocity: null,
                    angularAcceleration: null
                  };
                };
                CardboardVRDisplay.prototype._resetPose = function () {
                  if (this.poseSensor_.resetPose) {
                    this.poseSensor_.resetPose();
                  }
                };
                CardboardVRDisplay.prototype._getFieldOfView = function (whichEye) {
                  var fieldOfView;
                  if (whichEye == Eye.LEFT) {
                    fieldOfView = this.deviceInfo_.getFieldOfViewLeftEye();
                  } else if (whichEye == Eye.RIGHT) {
                    fieldOfView = this.deviceInfo_.getFieldOfViewRightEye();
                  } else {
                    console.error('Invalid eye provided: %s', whichEye);
                    return null;
                  }
                  return fieldOfView;
                };
                CardboardVRDisplay.prototype._getEyeOffset = function (whichEye) {
                  var offset;
                  if (whichEye == Eye.LEFT) {
                    offset = [-this.deviceInfo_.viewer.interLensDistance * 0.5, 0.0, 0.0];
                  } else if (whichEye == Eye.RIGHT) {
                    offset = [this.deviceInfo_.viewer.interLensDistance * 0.5, 0.0, 0.0];
                  } else {
                    console.error('Invalid eye provided: %s', whichEye);
                    return null;
                  }
                  return offset;
                };
                CardboardVRDisplay.prototype.getEyeParameters = function (whichEye) {
                  var offset = this._getEyeOffset(whichEye);
                  var fieldOfView = this._getFieldOfView(whichEye);
                  var eyeParams = {
                    offset: offset,
                    renderWidth: this.deviceInfo_.device.width * 0.5 * this.bufferScale_,
                    renderHeight: this.deviceInfo_.device.height * this.bufferScale_
                  };
                  Object.defineProperty(eyeParams, 'fieldOfView', {
                    enumerable: true,
                    get: function get() {
                      deprecateWarning('VRFieldOfView', 'VRFrameData\'s projection matrices');
                      return fieldOfView;
                    }
                  });
                  return eyeParams;
                };
                CardboardVRDisplay.prototype.onDeviceParamsUpdated_ = function (newParams) {
                  if (this.config.DEBUG) {
                    console.log('DPDB reported that device params were updated.');
                  }
                  this.deviceInfo_.updateDeviceParams(newParams);
                  if (this.distorter_) {
                    this.distorter_.updateDeviceInfo(this.deviceInfo_);
                  }
                };
                CardboardVRDisplay.prototype.updateBounds_ = function () {
                  if (this.layer_ && this.distorter_ && (this.layer_.leftBounds || this.layer_.rightBounds)) {
                    this.distorter_.setTextureBounds(this.layer_.leftBounds, this.layer_.rightBounds);
                  }
                };
                CardboardVRDisplay.prototype.beginPresent_ = function () {
                  var gl = this.layer_.source.getContext('webgl');
                  if (!gl) gl = this.layer_.source.getContext('experimental-webgl');
                  if (!gl) gl = this.layer_.source.getContext('webgl2');
                  if (!gl) return;
                  if (this.layer_.predistorted) {
                    if (!this.config.CARDBOARD_UI_DISABLED) {
                      gl.canvas.width = getScreenWidth() * this.bufferScale_;
                      gl.canvas.height = getScreenHeight() * this.bufferScale_;
                      this.cardboardUI_ = new CardboardUI(gl);
                    }
                  } else {
                    if (!this.config.CARDBOARD_UI_DISABLED) {
                      this.cardboardUI_ = new CardboardUI(gl);
                    }
                    this.distorter_ = new CardboardDistorter(gl, this.cardboardUI_, this.config.BUFFER_SCALE, this.config.DIRTY_SUBMIT_FRAME_BINDINGS);
                    this.distorter_.updateDeviceInfo(this.deviceInfo_);
                  }
                  if (this.cardboardUI_) {
                    this.cardboardUI_.listen(function (e) {
                      this.viewerSelector_.show(this.layer_.source.parentElement);
                      e.stopPropagation();
                      e.preventDefault();
                    }.bind(this), function (e) {
                      this.exitPresent();
                      e.stopPropagation();
                      e.preventDefault();
                    }.bind(this));
                  }
                  if (this.rotateInstructions_) {
                    if (isLandscapeMode() && isMobile()) {
                      this.rotateInstructions_.showTemporarily(3000, this.layer_.source.parentElement);
                    } else {
                      this.rotateInstructions_.update();
                    }
                  }
                  this.orientationHandler = this.onOrientationChange_.bind(this);
                  window.addEventListener('orientationchange', this.orientationHandler);
                  this.vrdisplaypresentchangeHandler = this.updateBounds_.bind(this);
                  window.addEventListener('vrdisplaypresentchange', this.vrdisplaypresentchangeHandler);
                  this.fireVRDisplayDeviceParamsChange_();
                };
                CardboardVRDisplay.prototype.endPresent_ = function () {
                  if (this.distorter_) {
                    this.distorter_.destroy();
                    this.distorter_ = null;
                  }
                  if (this.cardboardUI_) {
                    this.cardboardUI_.destroy();
                    this.cardboardUI_ = null;
                  }
                  if (this.rotateInstructions_) {
                    this.rotateInstructions_.hide();
                  }
                  this.viewerSelector_.hide();
                  window.removeEventListener('orientationchange', this.orientationHandler);
                  window.removeEventListener('vrdisplaypresentchange', this.vrdisplaypresentchangeHandler);
                };
                CardboardVRDisplay.prototype.updatePresent_ = function () {
                  this.endPresent_();
                  this.beginPresent_();
                };
                CardboardVRDisplay.prototype.submitFrame = function (pose) {
                  if (this.distorter_) {
                    this.updateBounds_();
                    this.distorter_.submitFrame();
                  } else if (this.cardboardUI_ && this.layer_) {
                    var gl = this.layer_.source.getContext('webgl');
                    if (!gl) gl = this.layer_.source.getContext('experimental-webgl');
                    if (!gl) gl = this.layer_.source.getContext('webgl2');
                    var canvas = gl.canvas;
                    if (canvas.width != this.lastWidth || canvas.height != this.lastHeight) {
                      this.cardboardUI_.onResize();
                    }
                    this.lastWidth = canvas.width;
                    this.lastHeight = canvas.height;
                    this.cardboardUI_.render();
                  }
                };
                CardboardVRDisplay.prototype.onOrientationChange_ = function (e) {
                  this.viewerSelector_.hide();
                  if (this.rotateInstructions_) {
                    this.rotateInstructions_.update();
                  }
                  this.onResize_();
                };
                CardboardVRDisplay.prototype.onResize_ = function (e) {
                  if (this.layer_) {
                    var gl = this.layer_.source.getContext('webgl');
                    if (!gl) gl = this.layer_.source.getContext('experimental-webgl');
                    if (!gl) gl = this.layer_.source.getContext('webgl2');
                    var cssProperties = ['position: absolute', 'top: 0', 'left: 0', 'width: 100vw', 'height: 100vh', 'border: 0', 'margin: 0', 'padding: 0px', 'box-sizing: content-box'];
                    gl.canvas.setAttribute('style', cssProperties.join('; ') + ';');
                    safariCssSizeWorkaround(gl.canvas);
                  }
                };
                CardboardVRDisplay.prototype.onViewerChanged_ = function (viewer) {
                  this.deviceInfo_.setViewer(viewer);
                  if (this.distorter_) {
                    this.distorter_.updateDeviceInfo(this.deviceInfo_);
                  }
                  this.fireVRDisplayDeviceParamsChange_();
                };
                CardboardVRDisplay.prototype.fireVRDisplayDeviceParamsChange_ = function () {
                  var event = new CustomEvent('vrdisplaydeviceparamschange', {
                    detail: {
                      vrdisplay: this,
                      deviceInfo: this.deviceInfo_
                    }
                  });
                  window.dispatchEvent(event);
                };
                CardboardVRDisplay.VRFrameData = VRFrameData;
                CardboardVRDisplay.VRDisplay = VRDisplay;
                return CardboardVRDisplay;
              });
            });
            var CardboardVRDisplay = unwrapExports(cardboardVrDisplay);
            var version = "0.10.12";
            var DefaultConfig = {
              ADDITIONAL_VIEWERS: [],
              DEFAULT_VIEWER: '',
              PROVIDE_MOBILE_VRDISPLAY: true,
              MOBILE_WAKE_LOCK: true,
              DEBUG: false,
              DPDB_URL: 'https://dpdb.webvr.rocks/dpdb.json',
              K_FILTER: 0.98,
              PREDICTION_TIME_S: 0.040,
              CARDBOARD_UI_DISABLED: false,
              ROTATE_INSTRUCTIONS_DISABLED: false,
              YAW_ONLY: false,
              BUFFER_SCALE: 0.5,
              DIRTY_SUBMIT_FRAME_BINDINGS: false
            };
            function WebVRPolyfill(config) {
              this.config = extend(extend({}, DefaultConfig), config);
              this.polyfillDisplays = [];
              this.enabled = false;
              this.hasNative = 'getVRDisplays' in navigator;
              this.native = {};
              this.native.getVRDisplays = navigator.getVRDisplays;
              this.native.VRFrameData = window.VRFrameData;
              this.native.VRDisplay = window.VRDisplay;
              if (!this.hasNative || this.config.PROVIDE_MOBILE_VRDISPLAY && isMobile()) {
                this.enable();
                this.getVRDisplays().then(function (displays) {
                  if (displays && displays[0] && displays[0].fireVRDisplayConnect_) {
                    displays[0].fireVRDisplayConnect_();
                  }
                });
              }
            }
            WebVRPolyfill.prototype.getPolyfillDisplays = function () {
              if (this._polyfillDisplaysPopulated) {
                return this.polyfillDisplays;
              }
              if (isMobile()) {
                var vrDisplay = new CardboardVRDisplay({
                  ADDITIONAL_VIEWERS: this.config.ADDITIONAL_VIEWERS,
                  DEFAULT_VIEWER: this.config.DEFAULT_VIEWER,
                  MOBILE_WAKE_LOCK: this.config.MOBILE_WAKE_LOCK,
                  DEBUG: this.config.DEBUG,
                  DPDB_URL: this.config.DPDB_URL,
                  CARDBOARD_UI_DISABLED: this.config.CARDBOARD_UI_DISABLED,
                  K_FILTER: this.config.K_FILTER,
                  PREDICTION_TIME_S: this.config.PREDICTION_TIME_S,
                  ROTATE_INSTRUCTIONS_DISABLED: this.config.ROTATE_INSTRUCTIONS_DISABLED,
                  YAW_ONLY: this.config.YAW_ONLY,
                  BUFFER_SCALE: this.config.BUFFER_SCALE,
                  DIRTY_SUBMIT_FRAME_BINDINGS: this.config.DIRTY_SUBMIT_FRAME_BINDINGS
                });
                this.polyfillDisplays.push(vrDisplay);
              }
              this._polyfillDisplaysPopulated = true;
              return this.polyfillDisplays;
            };
            WebVRPolyfill.prototype.enable = function () {
              this.enabled = true;
              if (this.hasNative && this.native.VRFrameData) {
                var NativeVRFrameData = this.native.VRFrameData;
                var nativeFrameData = new this.native.VRFrameData();
                var nativeGetFrameData = this.native.VRDisplay.prototype.getFrameData;
                window.VRDisplay.prototype.getFrameData = function (frameData) {
                  if (frameData instanceof NativeVRFrameData) {
                    nativeGetFrameData.call(this, frameData);
                    return;
                  }
                  nativeGetFrameData.call(this, nativeFrameData);
                  frameData.pose = nativeFrameData.pose;
                  copyArray(nativeFrameData.leftProjectionMatrix, frameData.leftProjectionMatrix);
                  copyArray(nativeFrameData.rightProjectionMatrix, frameData.rightProjectionMatrix);
                  copyArray(nativeFrameData.leftViewMatrix, frameData.leftViewMatrix);
                  copyArray(nativeFrameData.rightViewMatrix, frameData.rightViewMatrix);
                };
              }
              navigator.getVRDisplays = this.getVRDisplays.bind(this);
              window.VRDisplay = CardboardVRDisplay.VRDisplay;
              window.VRFrameData = CardboardVRDisplay.VRFrameData;
            };
            WebVRPolyfill.prototype.getVRDisplays = function () {
              var _this = this;
              var config = this.config;
              if (!this.hasNative) {
                return Promise.resolve(this.getPolyfillDisplays());
              }
              return this.native.getVRDisplays.call(navigator).then(function (nativeDisplays) {
                return nativeDisplays.length > 0 ? nativeDisplays : _this.getPolyfillDisplays();
              });
            };
            WebVRPolyfill.version = version;
            WebVRPolyfill.VRFrameData = CardboardVRDisplay.VRFrameData;
            WebVRPolyfill.VRDisplay = CardboardVRDisplay.VRDisplay;
            var webvrPolyfill = Object.freeze({
              default: WebVRPolyfill
            });
            var require$$0 = webvrPolyfill && WebVRPolyfill || webvrPolyfill;
            if (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.window) {
              if (!commonjsGlobal.document) {
                commonjsGlobal.document = commonjsGlobal.window.document;
              }
              if (!commonjsGlobal.navigator) {
                commonjsGlobal.navigator = commonjsGlobal.window.navigator;
              }
            }
            var src = require$$0;
            return src;
          });

          /***/
        },

        /***/"./node_modules/word-wrapper/index.js":
        /*!********************************************!*\
          !*** ./node_modules/word-wrapper/index.js ***!
          \********************************************/
        /***/
        function node_modulesWordWrapperIndexJs(module) {
          var newline = /\n/;
          var newlineChar = '\n';
          var whitespace = /\s/;
          module.exports = function (text, opt) {
            var lines = module.exports.lines(text, opt);
            return lines.map(function (line) {
              return text.substring(line.start, line.end);
            }).join('\n');
          };
          module.exports.lines = function wordwrap(text, opt) {
            opt = opt || {};

            //zero width results in nothing visible
            if (opt.width === 0 && opt.mode !== 'nowrap') return [];
            text = text || '';
            var width = typeof opt.width === 'number' ? opt.width : Number.MAX_VALUE;
            var start = Math.max(0, opt.start || 0);
            var end = typeof opt.end === 'number' ? opt.end : text.length;
            var mode = opt.mode;
            var measure = opt.measure || monospace;
            if (mode === 'pre') return pre(measure, text, start, end, width);else return greedy(measure, text, start, end, width, mode);
          };
          function idxOf(text, chr, start, end) {
            var idx = text.indexOf(chr, start);
            if (idx === -1 || idx > end) return end;
            return idx;
          }
          function isWhitespace(chr) {
            return whitespace.test(chr);
          }
          function pre(measure, text, start, end, width) {
            var lines = [];
            var lineStart = start;
            for (var i = start; i < end && i < text.length; i++) {
              var chr = text.charAt(i);
              var isNewline = newline.test(chr);

              //If we've reached a newline, then step down a line
              //Or if we've reached the EOF
              if (isNewline || i === end - 1) {
                var lineEnd = isNewline ? i : i + 1;
                var measured = measure(text, lineStart, lineEnd, width);
                lines.push(measured);
                lineStart = i + 1;
              }
            }
            return lines;
          }
          function greedy(measure, text, start, end, width, mode) {
            //A greedy word wrapper based on LibGDX algorithm
            //https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/BitmapFontCache.java
            var lines = [];
            var testWidth = width;
            //if 'nowrap' is specified, we only wrap on newline chars
            if (mode === 'nowrap') testWidth = Number.MAX_VALUE;
            while (start < end && start < text.length) {
              //get next newline position
              var newLine = idxOf(text, newlineChar, start, end);

              //eat whitespace at start of line
              while (start < newLine) {
                if (!isWhitespace(text.charAt(start))) break;
                start++;
              }

              //determine visible # of glyphs for the available width
              var measured = measure(text, start, newLine, testWidth);
              var lineEnd = start + (measured.end - measured.start);
              var nextStart = lineEnd + newlineChar.length;

              //if we had to cut the line before the next newline...
              if (lineEnd < newLine) {
                //find char to break on
                while (lineEnd > start) {
                  if (isWhitespace(text.charAt(lineEnd))) break;
                  lineEnd--;
                }
                if (lineEnd === start) {
                  if (nextStart > start + newlineChar.length) nextStart--;
                  lineEnd = nextStart; // If no characters to break, show all.
                } else {
                  nextStart = lineEnd;
                  //eat whitespace at end of line
                  while (lineEnd > start) {
                    if (!isWhitespace(text.charAt(lineEnd - newlineChar.length))) break;
                    lineEnd--;
                  }
                }
              }
              if (lineEnd >= start) {
                var result = measure(text, start, lineEnd, testWidth);
                lines.push(result);
              }
              start = nextStart;
            }
            return lines;
          }

          //determines the visible number of glyphs within a given width
          function monospace(text, start, end, width) {
            var glyphs = Math.min(width, end - start);
            return {
              start: start,
              end: start + glyphs
            };
          }

          /***/
        },

        /***/"./node_modules/xhr/index.js":
        /*!***********************************!*\
          !*** ./node_modules/xhr/index.js ***!
          \***********************************/
        /***/
        function node_modulesXhrIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          var window = __webpack_require__( /*! global/window */"./node_modules/global/window.js");
          var isFunction = __webpack_require__( /*! is-function */"./node_modules/is-function/index.js");
          var parseHeaders = __webpack_require__( /*! parse-headers */"./node_modules/parse-headers/parse-headers.js");
          var xtend = __webpack_require__( /*! xtend */"./node_modules/xtend/immutable.js");
          module.exports = createXHR;
          // Allow use of default import syntax in TypeScript
          module.exports["default"] = createXHR;
          createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
          createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
          forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
            createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
              options = initParams(uri, options, callback);
              options.method = method.toUpperCase();
              return _createXHR(options);
            };
          });
          function forEachArray(array, iterator) {
            for (var i = 0; i < array.length; i++) {
              iterator(array[i]);
            }
          }
          function isEmpty(obj) {
            for (var i in obj) {
              if (obj.hasOwnProperty(i)) return false;
            }
            return true;
          }
          function initParams(uri, options, callback) {
            var params = uri;
            if (isFunction(options)) {
              callback = options;
              if (typeof uri === "string") {
                params = {
                  uri: uri
                };
              }
            } else {
              params = xtend(options, {
                uri: uri
              });
            }
            params.callback = callback;
            return params;
          }
          function createXHR(uri, options, callback) {
            options = initParams(uri, options, callback);
            return _createXHR(options);
          }
          function _createXHR(options) {
            if (typeof options.callback === "undefined") {
              throw new Error("callback argument missing");
            }
            var called = false;
            var callback = function cbOnce(err, response, body) {
              if (!called) {
                called = true;
                options.callback(err, response, body);
              }
            };
            function readystatechange() {
              if (xhr.readyState === 4) {
                setTimeout(loadFunc, 0);
              }
            }
            function getBody() {
              // Chrome with requestType=blob throws errors arround when even testing access to responseText
              var body = undefined;
              if (xhr.response) {
                body = xhr.response;
              } else {
                body = xhr.responseText || getXml(xhr);
              }
              if (isJson) {
                try {
                  body = JSON.parse(body);
                } catch (e) {}
              }
              return body;
            }
            function errorFunc(evt) {
              clearTimeout(timeoutTimer);
              if (!(evt instanceof Error)) {
                evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
              }
              evt.statusCode = 0;
              return callback(evt, failureResponse);
            }

            // will load the data & process the response in a special response object
            function loadFunc() {
              if (aborted) return;
              var status;
              clearTimeout(timeoutTimer);
              if (options.useXDR && xhr.status === undefined) {
                //IE8 CORS GET successful response doesn't have a status field, but body is fine
                status = 200;
              } else {
                status = xhr.status === 1223 ? 204 : xhr.status;
              }
              var response = failureResponse;
              var err = null;
              if (status !== 0) {
                response = {
                  body: getBody(),
                  statusCode: status,
                  method: method,
                  headers: {},
                  url: uri,
                  rawRequest: xhr
                };
                if (xhr.getAllResponseHeaders) {
                  //remember xhr can in fact be XDR for CORS in IE
                  response.headers = parseHeaders(xhr.getAllResponseHeaders());
                }
              } else {
                err = new Error("Internal XMLHttpRequest Error");
              }
              return callback(err, response, response.body);
            }
            var xhr = options.xhr || null;
            if (!xhr) {
              if (options.cors || options.useXDR) {
                xhr = new createXHR.XDomainRequest();
              } else {
                xhr = new createXHR.XMLHttpRequest();
              }
            }
            var key;
            var aborted;
            var uri = xhr.url = options.uri || options.url;
            var method = xhr.method = options.method || "GET";
            var body = options.body || options.data;
            var headers = xhr.headers = options.headers || {};
            var sync = !!options.sync;
            var isJson = false;
            var timeoutTimer;
            var failureResponse = {
              body: undefined,
              headers: {},
              statusCode: 0,
              method: method,
              url: uri,
              rawRequest: xhr
            };
            if ("json" in options && options.json !== false) {
              isJson = true;
              headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
              if (method !== "GET" && method !== "HEAD") {
                headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
                body = JSON.stringify(options.json === true ? body : options.json);
              }
            }
            xhr.onreadystatechange = readystatechange;
            xhr.onload = loadFunc;
            xhr.onerror = errorFunc;
            // IE9 must have onprogress be set to a unique function.
            xhr.onprogress = function () {
              // IE must die
            };
            xhr.onabort = function () {
              aborted = true;
            };
            xhr.ontimeout = errorFunc;
            xhr.open(method, uri, !sync, options.username, options.password);
            //has to be after open
            if (!sync) {
              xhr.withCredentials = !!options.withCredentials;
            }
            // Cannot set timeout with sync request
            // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
            // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
            if (!sync && options.timeout > 0) {
              timeoutTimer = setTimeout(function () {
                if (aborted) return;
                aborted = true; //IE9 may still call readystatechange
                xhr.abort("timeout");
                var e = new Error("XMLHttpRequest timeout");
                e.code = "ETIMEDOUT";
                errorFunc(e);
              }, options.timeout);
            }
            if (xhr.setRequestHeader) {
              for (key in headers) {
                if (headers.hasOwnProperty(key)) {
                  xhr.setRequestHeader(key, headers[key]);
                }
              }
            } else if (options.headers && !isEmpty(options.headers)) {
              throw new Error("Headers cannot be set on an XDomainRequest object");
            }
            if ("responseType" in options) {
              xhr.responseType = options.responseType;
            }
            if ("beforeSend" in options && typeof options.beforeSend === "function") {
              options.beforeSend(xhr);
            }

            // Microsoft Edge browser sends "undefined" when send is called with undefined value.
            // XMLHttpRequest spec says to pass null as body to indicate no body
            // See https://github.com/naugtur/xhr/issues/100.
            xhr.send(body || null);
            return xhr;
          }
          function getXml(xhr) {
            // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
            // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
            try {
              if (xhr.responseType === "document") {
                return xhr.responseXML;
              }
              var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
              if (xhr.responseType === "" && !firefoxBugTakenEffect) {
                return xhr.responseXML;
              }
            } catch (e) {}
            return null;
          }
          function noop() {}

          /***/
        },

        /***/"./node_modules/xml-parse-from-string/index.js":
        /*!*****************************************************!*\
          !*** ./node_modules/xml-parse-from-string/index.js ***!
          \*****************************************************/
        /***/
        function node_modulesXmlParseFromStringIndexJs(module) {
          module.exports = function xmlparser() {
            //common browsers
            if (typeof self.DOMParser !== 'undefined') {
              return function (str) {
                var parser = new self.DOMParser();
                return parser.parseFromString(str, 'application/xml');
              };
            }

            //IE8 fallback
            if (typeof self.ActiveXObject !== 'undefined' && new self.ActiveXObject('Microsoft.XMLDOM')) {
              return function (str) {
                var xmlDoc = new self.ActiveXObject("Microsoft.XMLDOM");
                xmlDoc.async = "false";
                xmlDoc.loadXML(str);
                return xmlDoc;
              };
            }

            //last resort fallback
            return function (str) {
              var div = document.createElement('div');
              div.innerHTML = str;
              return div;
            };
          }();

          /***/
        },

        /***/"./node_modules/xtend/immutable.js":
        /*!*****************************************!*\
          !*** ./node_modules/xtend/immutable.js ***!
          \*****************************************/
        /***/
        function node_modulesXtendImmutableJs(module) {
          module.exports = extend;
          var hasOwnProperty = Object.prototype.hasOwnProperty;
          function extend() {
            var target = {};
            for (var i = 0; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          }

          /***/
        },

        /***/"./src/components/animation.js":
        /*!*************************************!*\
          !*** ./src/components/animation.js ***!
          \*************************************/
        /***/
        function srcComponentsAnimationJs(module, __unused_webpack_exports, __webpack_require__) {
          var anime = __webpack_require__( /*! super-animejs */"./node_modules/super-animejs/lib/anime.es.js")["default"];
          var components = __webpack_require__( /*! ../core/component */"./src/core/component.js").components;
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils */"./src/utils/index.js");
          var colorHelperFrom = new THREE.Color();
          var colorHelperTo = new THREE.Color();
          var getComponentProperty = utils.entity.getComponentProperty;
          var setComponentProperty = utils.entity.setComponentProperty;
          var splitCache = {};
          var TYPE_COLOR = 'color';
          var PROP_POSITION = 'position';
          var PROP_ROTATION = 'rotation';
          var PROP_SCALE = 'scale';
          var STRING_COMPONENTS = 'components';
          var STRING_OBJECT3D = 'object3D';

          /**
           * Animation component for A-Frame using anime.js.
           *
           * The component manually controls the tick by setting `autoplay: false` on anime.js and
           * manually * calling `animation.tick()` in the tick handler. To pause or resume, we toggle a
           * boolean * flag * `isAnimationPlaying`.
           *
           * anime.js animation config for tweenining Javascript objects and values works as:
           *
           *  config = {
           *    targets: {foo: 0.0, bar: '#000'},
           *    foo: 1.0,
           *    bar: '#FFF'
           *  }
           *
           * The above will tween each property in `targets`. The `to` values are set in the root of
           * the config.
           *
           * @member {object} animation - anime.js instance.
           * @member {boolean} animationIsPlaying - Control if animation is playing.
           */
          module.exports.Component = registerComponent('animation', {
            schema: {
              autoplay: {
                default: true
              },
              delay: {
                default: 0
              },
              dir: {
                default: ''
              },
              dur: {
                default: 1000
              },
              easing: {
                default: 'easeInQuad'
              },
              elasticity: {
                default: 400
              },
              enabled: {
                default: true
              },
              from: {
                default: ''
              },
              loop: {
                default: 0,
                parse: function parse(value) {
                  // Boolean or integer.
                  if (value === true || value === 'true') {
                    return true;
                  }
                  if (value === false || value === 'false') {
                    return false;
                  }
                  return parseInt(value, 10);
                }
              },
              property: {
                default: ''
              },
              startEvents: {
                type: 'array'
              },
              pauseEvents: {
                type: 'array'
              },
              resumeEvents: {
                type: 'array'
              },
              round: {
                default: false
              },
              to: {
                default: ''
              },
              type: {
                default: ''
              },
              isRawProperty: {
                default: false
              }
            },
            multiple: true,
            init: function init() {
              var self = this;
              this.eventDetail = {
                name: this.attrName
              };
              this.time = 0;
              this.animation = null;
              this.animationIsPlaying = false;
              this.onStartEvent = this.onStartEvent.bind(this);
              this.beginAnimation = this.beginAnimation.bind(this);
              this.pauseAnimation = this.pauseAnimation.bind(this);
              this.resumeAnimation = this.resumeAnimation.bind(this);
              this.fromColor = {};
              this.toColor = {};
              this.targets = {};
              this.targetsArray = [];
              this.updateConfigForDefault = this.updateConfigForDefault.bind(this);
              this.updateConfigForRawColor = this.updateConfigForRawColor.bind(this);
              this.config = {
                complete: function complete() {
                  self.animationIsPlaying = false;
                  self.el.emit('animationcomplete', self.eventDetail, false);
                  if (self.id) {
                    self.el.emit('animationcomplete__' + self.id, self.eventDetail, false);
                  }
                }
              };
            },
            update: function update(oldData) {
              var config = this.config;
              var data = this.data;
              this.animationIsPlaying = false;
              if (!this.data.enabled) {
                return;
              }
              if (!data.property) {
                return;
              }

              // Base config.
              config.autoplay = false;
              config.direction = data.dir;
              config.duration = data.dur;
              config.easing = data.easing;
              config.elasticity = data.elasticity;
              config.loop = data.loop;
              config.round = data.round;

              // Start new animation.
              this.createAndStartAnimation();
            },
            tick: function tick(t, dt) {
              if (!this.animationIsPlaying) {
                return;
              }
              this.time += dt;
              this.animation.tick(this.time);
            },
            remove: function remove() {
              this.pauseAnimation();
              this.removeEventListeners();
            },
            pause: function pause() {
              this.paused = true;
              this.pausedWasPlaying = this.animationIsPlaying;
              this.pauseAnimation();
              this.removeEventListeners();
            },
            /**
             * `play` handler only for resuming scene.
             */
            play: function play() {
              if (!this.paused) {
                return;
              }
              this.paused = false;
              this.addEventListeners();
              if (this.pausedWasPlaying) {
                this.resumeAnimation();
                this.pausedWasPlaying = false;
              }
            },
            /**
             * Start animation from scratch.
             */
            createAndStartAnimation: function createAndStartAnimation() {
              var data = this.data;
              this.updateConfig();
              this.animationIsPlaying = false;
              this.animation = anime(this.config);
              this.animation.began = true;
              this.removeEventListeners();
              this.addEventListeners();

              // Wait for start events for animation.
              if (!data.autoplay || data.startEvents && data.startEvents.length) {
                return;
              }

              // Delay animation.
              if (data.delay) {
                setTimeout(this.beginAnimation, data.delay);
                return;
              }

              // Play animation.
              this.beginAnimation();
            },
            /**
             * This is before animation start (including from startEvents).
             * Set to initial state (config.from, time = 0, seekTime = 0).
             */
            beginAnimation: function beginAnimation() {
              this.updateConfig();
              this.animation.began = true;
              this.time = 0;
              this.animationIsPlaying = true;
              this.stopRelatedAnimations();
              this.el.emit('animationbegin', this.eventDetail, false);
            },
            pauseAnimation: function pauseAnimation() {
              this.animationIsPlaying = false;
            },
            resumeAnimation: function resumeAnimation() {
              this.animationIsPlaying = true;
            },
            /**
             * startEvents callback.
             */
            onStartEvent: function onStartEvent() {
              if (!this.data.enabled) {
                return;
              }
              this.updateConfig();
              if (this.animation) {
                this.animation.pause();
              }
              this.animation = anime(this.config);

              // Include the delay before each start event.
              if (this.data.delay) {
                setTimeout(this.beginAnimation, this.data.delay);
                return;
              }
              this.beginAnimation();
            },
            /**
             * rawProperty: true and type: color;
             */
            updateConfigForRawColor: function updateConfigForRawColor() {
              var config = this.config;
              var data = this.data;
              var el = this.el;
              var from;
              var key;
              var to;
              if (this.waitComponentInitRawProperty(this.updateConfigForRawColor)) {
                return;
              }
              from = data.from === '' ? getRawProperty(el, data.property) : data.from;
              to = data.to;

              // Use r/g/b vector for color type.
              this.setColorConfig(from, to);
              from = this.fromColor;
              to = this.toColor;
              this.targetsArray.length = 0;
              this.targetsArray.push(from);
              config.targets = this.targetsArray;
              for (key in to) {
                config[key] = to[key];
              }
              config.update = function () {
                var lastValue = {};
                return function (anim) {
                  var value;
                  value = anim.animatables[0].target;
                  // For animation timeline.
                  if (value.r === lastValue.r && value.g === lastValue.g && value.b === lastValue.b) {
                    return;
                  }
                  setRawProperty(el, data.property, value, data.type);
                };
              }();
            },
            /**
             * Stuff property into generic `property` key.
             */
            updateConfigForDefault: function updateConfigForDefault() {
              var config = this.config;
              var data = this.data;
              var el = this.el;
              var from;
              var isBoolean;
              var isNumber;
              var to;
              if (this.waitComponentInitRawProperty(this.updateConfigForDefault)) {
                return;
              }
              if (data.from === '') {
                // Infer from.
                from = isRawProperty(data) ? getRawProperty(el, data.property) : getComponentProperty(el, data.property);
              } else {
                // Explicit from.
                from = data.from;
              }
              to = data.to;
              isNumber = !isNaN(from || to);
              if (isNumber) {
                from = parseFloat(from);
                to = parseFloat(to);
              } else {
                from = from ? from.toString() : from;
                to = to ? to.toString() : to;
              }

              // Convert booleans to integer to allow boolean flipping.
              isBoolean = data.to === 'true' || data.to === 'false' || data.to === true || data.to === false;
              if (isBoolean) {
                from = data.from === 'true' || data.from === true ? 1 : 0;
                to = data.to === 'true' || data.to === true ? 1 : 0;
              }
              this.targets.aframeProperty = from;
              config.targets = this.targets;
              config.aframeProperty = to;
              config.update = function () {
                var lastValue;
                return function (anim) {
                  var value;
                  value = anim.animatables[0].target.aframeProperty;

                  // Need to do a last value check for animation timeline since all the tweening
                  // begins simultaenously even if the value has not changed. Also better for perf
                  // anyways.
                  if (value === lastValue) {
                    return;
                  }
                  lastValue = value;
                  if (isBoolean) {
                    value = value >= 1;
                  }
                  if (isRawProperty(data)) {
                    setRawProperty(el, data.property, value, data.type);
                  } else {
                    setComponentProperty(el, data.property, value);
                  }
                };
              }();
            },
            /**
             * Extend x/y/z/w onto the config.
             * Update vector by modifying object3D.
             */
            updateConfigForVector: function updateConfigForVector() {
              var config = this.config;
              var data = this.data;
              var el = this.el;
              var key;
              var from;
              var to;

              // Parse coordinates.
              from = data.from !== '' ? utils.coordinates.parse(data.from) // If data.from defined, use that.
              : getComponentProperty(el, data.property); // If data.from not defined, get on the fly.
              to = utils.coordinates.parse(data.to);
              if (data.property === PROP_ROTATION) {
                toRadians(from);
                toRadians(to);
              }

              // Set to and from.
              this.targetsArray.length = 0;
              this.targetsArray.push(from);
              config.targets = this.targetsArray;
              for (key in to) {
                config[key] = to[key];
              }

              // If animating object3D transformation, run more optimized updater.
              if (data.property === PROP_POSITION || data.property === PROP_ROTATION || data.property === PROP_SCALE) {
                config.update = function () {
                  var lastValue = {};
                  return function (anim) {
                    var value = anim.animatables[0].target;
                    if (data.property === PROP_SCALE) {
                      value.x = Math.max(0.0001, value.x);
                      value.y = Math.max(0.0001, value.y);
                      value.z = Math.max(0.0001, value.z);
                    }

                    // For animation timeline.
                    if (value.x === lastValue.x && value.y === lastValue.y && value.z === lastValue.z) {
                      return;
                    }
                    lastValue.x = value.x;
                    lastValue.y = value.y;
                    lastValue.z = value.z;
                    el.object3D[data.property].set(value.x, value.y, value.z);
                  };
                }();
                return;
              }

              // Animating some vector.
              config.update = function () {
                var lastValue = {};
                return function (anim) {
                  var value = anim.animatables[0].target;

                  // Animate rotation through radians.
                  // For animation timeline.
                  if (value.x === lastValue.x && value.y === lastValue.y && value.z === lastValue.z) {
                    return;
                  }
                  lastValue.x = value.x;
                  lastValue.y = value.y;
                  lastValue.z = value.z;
                  setComponentProperty(el, data.property, value);
                };
              }();
            },
            /**
             * Update the config before each run.
             */
            updateConfig: function updateConfig() {
              var propType;

              // Route config type.
              propType = getPropertyType(this.el, this.data.property);
              if (isRawProperty(this.data) && this.data.type === TYPE_COLOR) {
                this.updateConfigForRawColor();
              } else if (propType === 'vec2' || propType === 'vec3' || propType === 'vec4') {
                this.updateConfigForVector();
              } else {
                this.updateConfigForDefault();
              }
            },
            /**
             * Wait for component to initialize.
             */
            waitComponentInitRawProperty: function waitComponentInitRawProperty(cb) {
              var componentName;
              var data = this.data;
              var el = this.el;
              var self = this;
              if (data.from !== '') {
                return false;
              }
              if (!data.property.startsWith(STRING_COMPONENTS)) {
                return false;
              }
              componentName = splitDot(data.property)[1];
              if (el.components[componentName]) {
                return false;
              }
              el.addEventListener('componentinitialized', function wait(evt) {
                if (evt.detail.name !== componentName) {
                  return;
                }
                cb();
                // Since the config was created async, create the animation now since we missed it
                // earlier.
                self.animation = anime(self.config);
                el.removeEventListener('componentinitialized', wait);
              });
              return true;
            },
            /**
             * Make sure two animations on the same property don't fight each other.
             * e.g., animation__mouseenter="property: material.opacity"
             *       animation__mouseleave="property: material.opacity"
             */
            stopRelatedAnimations: function stopRelatedAnimations() {
              var component;
              var componentName;
              for (componentName in this.el.components) {
                component = this.el.components[componentName];
                if (componentName === this.attrName) {
                  continue;
                }
                if (component.name !== 'animation') {
                  continue;
                }
                if (!component.animationIsPlaying) {
                  continue;
                }
                if (component.data.property !== this.data.property) {
                  continue;
                }
                component.animationIsPlaying = false;
              }
            },
            addEventListeners: function addEventListeners() {
              var data = this.data;
              var el = this.el;
              _addEventListeners(el, data.startEvents, this.onStartEvent);
              _addEventListeners(el, data.pauseEvents, this.pauseAnimation);
              _addEventListeners(el, data.resumeEvents, this.resumeAnimation);
            },
            removeEventListeners: function removeEventListeners() {
              var data = this.data;
              var el = this.el;
              _removeEventListeners(el, data.startEvents, this.onStartEvent);
              _removeEventListeners(el, data.pauseEvents, this.pauseAnimation);
              _removeEventListeners(el, data.resumeEvents, this.resumeAnimation);
            },
            setColorConfig: function setColorConfig(from, to) {
              colorHelperFrom.set(from);
              colorHelperTo.set(to);
              from = this.fromColor;
              to = this.toColor;
              from.r = colorHelperFrom.r;
              from.g = colorHelperFrom.g;
              from.b = colorHelperFrom.b;
              to.r = colorHelperTo.r;
              to.g = colorHelperTo.g;
              to.b = colorHelperTo.b;
            }
          });

          /**
           * Given property name, check schema to see what type we are animating.
           * We just care whether the property is a vector.
           */
          function getPropertyType(el, property) {
            var component;
            var componentName;
            var split;
            var propertyName;
            split = property.split('.');
            componentName = split[0];
            propertyName = split[1];
            component = el.components[componentName] || components[componentName];

            // Primitives.
            if (!component) {
              return null;
            }

            // Dynamic schema. We only care about vectors anyways.
            if (propertyName && !component.schema[propertyName]) {
              return null;
            }

            // Multi-prop.
            if (propertyName) {
              return component.schema[propertyName].type;
            }

            // Single-prop.
            return component.schema.type;
          }

          /**
           * Convert object to radians.
           */
          function toRadians(obj) {
            obj.x = THREE.MathUtils.degToRad(obj.x);
            obj.y = THREE.MathUtils.degToRad(obj.y);
            obj.z = THREE.MathUtils.degToRad(obj.z);
          }
          function _addEventListeners(el, eventNames, handler) {
            var i;
            for (i = 0; i < eventNames.length; i++) {
              el.addEventListener(eventNames[i], handler);
            }
          }
          function _removeEventListeners(el, eventNames, handler) {
            var i;
            for (i = 0; i < eventNames.length; i++) {
              el.removeEventListener(eventNames[i], handler);
            }
          }
          function getRawProperty(el, path) {
            var i;
            var split;
            var value;
            split = splitDot(path);
            value = el;
            for (i = 0; i < split.length; i++) {
              value = value[split[i]];
            }
            if (value === undefined) {
              console.log(el);
              throw new Error('[animation] property (' + path + ') could not be found');
            }
            return value;
          }
          function setRawProperty(el, path, value, type) {
            var i;
            var split;
            var propertyName;
            var targetValue;
            if (path.startsWith('object3D.rotation')) {
              value = THREE.MathUtils.degToRad(value);
            }

            // Walk.
            split = splitDot(path);
            targetValue = el;
            for (i = 0; i < split.length - 1; i++) {
              targetValue = targetValue[split[i]];
            }
            propertyName = split[split.length - 1];

            // Raw color.
            if (type === TYPE_COLOR) {
              if ('r' in targetValue[propertyName]) {
                targetValue[propertyName].r = value.r;
                targetValue[propertyName].g = value.g;
                targetValue[propertyName].b = value.b;
              } else {
                targetValue[propertyName].x = value.r;
                targetValue[propertyName].y = value.g;
                targetValue[propertyName].z = value.b;
              }
              return;
            }
            targetValue[propertyName] = value;
          }
          function splitDot(path) {
            if (path in splitCache) {
              return splitCache[path];
            }
            splitCache[path] = path.split('.');
            return splitCache[path];
          }
          function isRawProperty(data) {
            return data.isRawProperty || data.property.startsWith(STRING_COMPONENTS) || data.property.startsWith(STRING_OBJECT3D);
          }

          /***/
        },

        /***/"./src/components/camera.js":
        /*!**********************************!*\
          !*** ./src/components/camera.js ***!
          \**********************************/
        /***/
        function srcComponentsCameraJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");

          /**
           * Camera component.
           * Pairs along with camera system to handle tracking the active camera.
           */
          module.exports.Component = registerComponent('camera', {
            schema: {
              active: {
                default: true
              },
              far: {
                default: 10000
              },
              fov: {
                default: 80,
                min: 0
              },
              near: {
                default: 0.005,
                min: 0
              },
              spectator: {
                default: false
              },
              zoom: {
                default: 1,
                min: 0
              }
            },
            /**
             * Initialize three.js camera and add it to the entity.
             * Add reference from scene to this entity as the camera.
             */
            init: function init() {
              var camera;
              var el = this.el;

              // Create camera.
              camera = this.camera = new THREE.PerspectiveCamera();
              el.setObject3D('camera', camera);
            },
            /**
             * Update three.js camera.
             */
            update: function update(oldData) {
              var data = this.data;
              var camera = this.camera;

              // Update properties.
              camera.aspect = data.aspect || window.innerWidth / window.innerHeight;
              camera.far = data.far;
              camera.fov = data.fov;
              camera.near = data.near;
              camera.zoom = data.zoom;
              camera.updateProjectionMatrix();
              this.updateActiveCamera(oldData);
              this.updateSpectatorCamera(oldData);
            },
            updateActiveCamera: function updateActiveCamera(oldData) {
              var data = this.data;
              var el = this.el;
              var system = this.system;
              // Active property did not change.
              if (oldData && oldData.active === data.active || data.spectator) {
                return;
              }

              // If `active` property changes, or first update, handle active camera with system.
              if (data.active && system.activeCameraEl !== el) {
                // Camera enabled. Set camera to this camera.
                system.setActiveCamera(el);
              } else if (!data.active && system.activeCameraEl === el) {
                // Camera disabled. Set camera to another camera.
                system.disableActiveCamera();
              }
            },
            updateSpectatorCamera: function updateSpectatorCamera(oldData) {
              var data = this.data;
              var el = this.el;
              var system = this.system;
              // spectator property did not change.
              if (oldData && oldData.spectator === data.spectator) {
                return;
              }

              // If `spectator` property changes, or first update, handle spectator camera with system.
              if (data.spectator && system.spectatorCameraEl !== el) {
                // Camera enabled. Set camera to this camera.
                system.setSpectatorCamera(el);
              } else if (!data.spectator && system.spectatorCameraEl === el) {
                // Camera disabled. Set camera to another camera.
                system.disableSpectatorCamera();
              }
            },
            /**
             * Remove camera on remove (callback).
             */
            remove: function remove() {
              this.el.removeObject3D('camera');
            }
          });

          /***/
        },

        /***/"./src/components/cursor.js":
        /*!**********************************!*\
          !*** ./src/components/cursor.js ***!
          \**********************************/
        /***/
        function srcComponentsCursorJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE, MouseEvent, TouchEvent */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var bind = utils.bind;
          var EVENTS = {
            CLICK: 'click',
            FUSING: 'fusing',
            MOUSEENTER: 'mouseenter',
            MOUSEDOWN: 'mousedown',
            MOUSELEAVE: 'mouseleave',
            MOUSEUP: 'mouseup'
          };
          var STATES = {
            FUSING: 'cursor-fusing',
            HOVERING: 'cursor-hovering',
            HOVERED: 'cursor-hovered'
          };
          var CANVAS_EVENTS = {
            DOWN: ['mousedown', 'touchstart'],
            UP: ['mouseup', 'touchend']
          };
          var WEBXR_EVENTS = {
            DOWN: ['selectstart'],
            UP: ['selectend']
          };
          var CANVAS_HOVER_CLASS = 'a-mouse-cursor-hover';

          /**
           * Cursor component. Applies the raycaster component specifically for starting the raycaster
           * from the camera and pointing from camera's facing direction, and then only returning the
           * closest intersection. Cursor can be fine-tuned by setting raycaster properties.
           *
           * @member {object} fuseTimeout - Timeout to trigger fuse-click.
           * @member {Element} cursorDownEl - Entity that was last mousedowned during current click.
           * @member {object} intersection - Attributes of the current intersection event, including
           *         3D- and 2D-space coordinates. See: http://threejs.org/docs/api/core/Raycaster.html
           * @member {Element} intersectedEl - Currently-intersected entity. Used to keep track to
           *         emit events when unintersecting.
           */
          module.exports.Component = registerComponent('cursor', {
            dependencies: ['raycaster'],
            schema: {
              downEvents: {
                default: []
              },
              fuse: {
                default: utils.device.isMobile()
              },
              fuseTimeout: {
                default: 1500,
                min: 0
              },
              mouseCursorStylesEnabled: {
                default: true
              },
              upEvents: {
                default: []
              },
              rayOrigin: {
                default: 'entity',
                oneOf: ['mouse', 'entity', 'xrselect']
              }
            },
            multiple: true,
            init: function init() {
              var self = this;
              this.fuseTimeout = undefined;
              this.cursorDownEl = null;
              this.intersectedEl = null;
              this.canvasBounds = document.body.getBoundingClientRect();
              this.isCursorDown = false;
              this.activeXRInput = null;

              // Debounce.
              this.updateCanvasBounds = utils.debounce(function updateCanvasBounds() {
                self.canvasBounds = self.el.sceneEl.canvas.getBoundingClientRect();
              }, 500);
              this.eventDetail = {};
              this.intersectedEventDetail = {
                cursorEl: this.el
              };

              // Bind methods.
              this.onCursorDown = bind(this.onCursorDown, this);
              this.onCursorUp = bind(this.onCursorUp, this);
              this.onIntersection = bind(this.onIntersection, this);
              this.onIntersectionCleared = bind(this.onIntersectionCleared, this);
              this.onMouseMove = bind(this.onMouseMove, this);
              this.onEnterVR = bind(this.onEnterVR, this);
            },
            update: function update(oldData) {
              if (this.data.rayOrigin === oldData.rayOrigin) {
                return;
              }
              this.updateMouseEventListeners();
            },
            tick: function tick() {
              // Update on frame to allow someone to select and mousemove
              var frame = this.el.sceneEl.frame;
              var inputSource = this.activeXRInput;
              if (this.data.rayOrigin === 'xrselect' && frame && inputSource) {
                this.onMouseMove({
                  frame: frame,
                  inputSource: inputSource,
                  type: 'fakeselectevent'
                });
              }
            },
            play: function play() {
              this.addEventListeners();
            },
            pause: function pause() {
              this.removeEventListeners();
            },
            remove: function remove() {
              var el = this.el;
              el.removeState(STATES.HOVERING);
              el.removeState(STATES.FUSING);
              clearTimeout(this.fuseTimeout);
              if (this.intersectedEl) {
                this.intersectedEl.removeState(STATES.HOVERED);
              }
              this.removeEventListeners();
            },
            addEventListeners: function addEventListeners() {
              var canvas;
              var data = this.data;
              var el = this.el;
              var self = this;
              function addCanvasListeners() {
                canvas = el.sceneEl.canvas;
                if (data.downEvents.length || data.upEvents.length) {
                  return;
                }
                CANVAS_EVENTS.DOWN.forEach(function (downEvent) {
                  canvas.addEventListener(downEvent, self.onCursorDown);
                });
                CANVAS_EVENTS.UP.forEach(function (upEvent) {
                  canvas.addEventListener(upEvent, self.onCursorUp);
                });
              }
              canvas = el.sceneEl.canvas;
              if (canvas) {
                addCanvasListeners();
              } else {
                el.sceneEl.addEventListener('render-target-loaded', addCanvasListeners);
              }
              data.downEvents.forEach(function (downEvent) {
                el.addEventListener(downEvent, self.onCursorDown);
              });
              data.upEvents.forEach(function (upEvent) {
                el.addEventListener(upEvent, self.onCursorUp);
              });
              el.addEventListener('raycaster-intersection', this.onIntersection);
              el.addEventListener('raycaster-closest-entity-changed', this.onIntersection);
              el.addEventListener('raycaster-intersection-cleared', this.onIntersectionCleared);
              el.sceneEl.addEventListener('rendererresize', this.updateCanvasBounds);
              el.sceneEl.addEventListener('enter-vr', this.onEnterVR);
              window.addEventListener('resize', this.updateCanvasBounds);
              window.addEventListener('scroll', this.updateCanvasBounds);
              this.updateMouseEventListeners();
            },
            removeEventListeners: function removeEventListeners() {
              var canvas;
              var data = this.data;
              var el = this.el;
              var self = this;
              canvas = el.sceneEl.canvas;
              if (canvas && !data.downEvents.length && !data.upEvents.length) {
                CANVAS_EVENTS.DOWN.forEach(function (downEvent) {
                  canvas.removeEventListener(downEvent, self.onCursorDown);
                });
                CANVAS_EVENTS.UP.forEach(function (upEvent) {
                  canvas.removeEventListener(upEvent, self.onCursorUp);
                });
              }
              data.downEvents.forEach(function (downEvent) {
                el.removeEventListener(downEvent, self.onCursorDown);
              });
              data.upEvents.forEach(function (upEvent) {
                el.removeEventListener(upEvent, self.onCursorUp);
              });
              el.removeEventListener('raycaster-intersection', this.onIntersection);
              el.removeEventListener('raycaster-intersection-cleared', this.onIntersectionCleared);
              canvas.removeEventListener('mousemove', this.onMouseMove);
              canvas.removeEventListener('touchstart', this.onMouseMove);
              canvas.removeEventListener('touchmove', this.onMouseMove);
              el.sceneEl.removeEventListener('rendererresize', this.updateCanvasBounds);
              el.sceneEl.removeEventListener('enter-vr', this.onEnterVR);
              window.removeEventListener('resize', this.updateCanvasBounds);
              window.removeEventListener('scroll', this.updateCanvasBounds);
            },
            updateMouseEventListeners: function updateMouseEventListeners() {
              var canvas;
              var el = this.el;
              canvas = el.sceneEl.canvas;
              canvas.removeEventListener('mousemove', this.onMouseMove);
              canvas.removeEventListener('touchmove', this.onMouseMove);
              el.setAttribute('raycaster', 'useWorldCoordinates', false);
              if (this.data.rayOrigin !== 'mouse') {
                return;
              }
              canvas.addEventListener('mousemove', this.onMouseMove, false);
              canvas.addEventListener('touchmove', this.onMouseMove, false);
              el.setAttribute('raycaster', 'useWorldCoordinates', true);
              this.updateCanvasBounds();
            },
            onMouseMove: function () {
              var direction = new THREE.Vector3();
              var mouse = new THREE.Vector2();
              var origin = new THREE.Vector3();
              var rayCasterConfig = {
                origin: origin,
                direction: direction
              };
              return function (evt) {
                var bounds = this.canvasBounds;
                var camera = this.el.sceneEl.camera;
                var left;
                var point;
                var top;
                var frame;
                var inputSource;
                var referenceSpace;
                var pose;
                var transform;
                camera.parent.updateMatrixWorld();

                // Calculate mouse position based on the canvas element
                if (evt.type === 'touchmove' || evt.type === 'touchstart') {
                  // Track the first touch for simplicity.
                  point = evt.touches.item(0);
                } else {
                  point = evt;
                }
                left = point.clientX - bounds.left;
                top = point.clientY - bounds.top;
                mouse.x = left / bounds.width * 2 - 1;
                mouse.y = -(top / bounds.height) * 2 + 1;
                if (this.data.rayOrigin === 'xrselect' && (evt.type === 'selectstart' || evt.type === 'fakeselectevent')) {
                  frame = evt.frame;
                  inputSource = evt.inputSource;
                  referenceSpace = this.el.renderer.xr.getReferenceSpace();
                  pose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                  transform = pose.transform;
                  direction.set(0, 0, -1);
                  direction.applyQuaternion(transform.orientation);
                  origin.copy(transform.position);
                } else if (evt.type === 'fakeselectout') {
                  direction.set(0, 1, 0);
                  origin.set(0, 9999, 0);
                } else if (camera && camera.isPerspectiveCamera) {
                  origin.setFromMatrixPosition(camera.matrixWorld);
                  direction.set(mouse.x, mouse.y, 0.5).unproject(camera).sub(origin).normalize();
                } else if (camera && camera.isOrthographicCamera) {
                  origin.set(mouse.x, mouse.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
                  direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
                } else {
                  console.error('AFRAME.Raycaster: Unsupported camera type: ' + camera.type);
                }
                this.el.setAttribute('raycaster', rayCasterConfig);
                if (evt.type === 'touchmove') {
                  evt.preventDefault();
                }
              };
            }(),
            /**
             * Trigger mousedown and keep track of the mousedowned entity.
             */
            onCursorDown: function onCursorDown(evt) {
              this.isCursorDown = true;
              // Raycast again for touch.
              if (this.data.rayOrigin === 'mouse' && evt.type === 'touchstart') {
                this.onMouseMove(evt);
                this.el.components.raycaster.checkIntersections();
                evt.preventDefault();
              }
              if (this.data.rayOrigin === 'xrselect' && evt.type === 'selectstart') {
                this.activeXRInput = evt.inputSource;
                this.onMouseMove(evt);
                this.el.components.raycaster.checkIntersections();

                // if something was tapped on don't do ar-hit-test things
                if (this.el.components.raycaster.intersectedEls.length && this.el.sceneEl.components['ar-hit-test'] !== undefined && this.el.sceneEl.getAttribute('ar-hit-test').enabled) {
                  // Cancel the ar-hit-test behaviours and disable the ar-hit-test
                  this.el.sceneEl.setAttribute('ar-hit-test', 'enabled', false);
                  this.reenableARHitTest = true;
                }
              }
              this.twoWayEmit(EVENTS.MOUSEDOWN, evt);
              this.cursorDownEl = this.intersectedEl;
            },
            /**
             * Trigger mouseup if:
             * - Not fusing (mobile has no mouse).
             * - Currently intersecting an entity.
             * - Currently-intersected entity is the same as the one when mousedown was triggered,
             *   in case user mousedowned one entity, dragged to another, and mouseupped.
             */
            onCursorUp: function onCursorUp(evt) {
              if (!this.isCursorDown) {
                return;
              }
              this.isCursorDown = false;
              var data = this.data;
              this.twoWayEmit(EVENTS.MOUSEUP, evt);
              if (this.reenableARHitTest === true) {
                this.el.sceneEl.setAttribute('ar-hit-test', 'enabled', true);
                this.reenableARHitTest = undefined;
              }

              // If intersected entity has changed since the cursorDown, still emit mouseUp on the
              // previously cursorUp entity.
              if (this.cursorDownEl && this.cursorDownEl !== this.intersectedEl) {
                this.intersectedEventDetail.intersection = null;
                this.cursorDownEl.emit(EVENTS.MOUSEUP, this.intersectedEventDetail);
              }
              if ((!data.fuse || data.rayOrigin === 'mouse' || data.rayOrigin === 'xrselect') && this.intersectedEl && this.cursorDownEl === this.intersectedEl) {
                this.twoWayEmit(EVENTS.CLICK, evt);
              }

              // if the current xr input stops selecting then make the ray caster point somewhere else
              if (data.rayOrigin === 'xrselect' && this.activeXRInput === evt.inputSource) {
                this.onMouseMove({
                  type: 'fakeselectout'
                });
              }
              this.activeXRInput = null;
              this.cursorDownEl = null;
              if (evt.type === 'touchend') {
                evt.preventDefault();
              }
            },
            /**
             * Handle intersection.
             */
            onIntersection: function onIntersection(evt) {
              var currentIntersection;
              var cursorEl = this.el;
              var index;
              var intersectedEl;
              var intersection;

              // Select closest object, excluding the cursor.
              index = evt.detail.els[0] === cursorEl ? 1 : 0;
              intersection = evt.detail.intersections[index];
              intersectedEl = evt.detail.els[index];

              // If cursor is the only intersected object, ignore the event.
              if (!intersectedEl) {
                return;
              }

              // Already intersecting this entity.
              if (this.intersectedEl === intersectedEl) {
                return;
              }

              // Ignore events further away than active intersection.
              if (this.intersectedEl) {
                currentIntersection = this.el.components.raycaster.getIntersection(this.intersectedEl);
                if (currentIntersection && currentIntersection.distance <= intersection.distance) {
                  return;
                }
              }

              // Unset current intersection.
              this.clearCurrentIntersection(true);
              this.setIntersection(intersectedEl, intersection);
            },
            /**
             * Handle intersection cleared.
             */
            onIntersectionCleared: function onIntersectionCleared(evt) {
              var clearedEls = evt.detail.clearedEls;
              // Check if the current intersection has ended
              if (clearedEls.indexOf(this.intersectedEl) === -1) {
                return;
              }
              this.clearCurrentIntersection();
            },
            onEnterVR: function onEnterVR() {
              this.clearCurrentIntersection(true);
              var xrSession = this.el.sceneEl.xrSession;
              var self = this;
              if (!xrSession) {
                return;
              }
              if (this.data.rayOrigin === 'mouse') {
                return;
              }
              WEBXR_EVENTS.DOWN.forEach(function (downEvent) {
                xrSession.addEventListener(downEvent, self.onCursorDown);
              });
              WEBXR_EVENTS.UP.forEach(function (upEvent) {
                xrSession.addEventListener(upEvent, self.onCursorUp);
              });
            },
            setIntersection: function setIntersection(intersectedEl, intersection) {
              var cursorEl = this.el;
              var data = this.data;
              var self = this;

              // Already intersecting.
              if (this.intersectedEl === intersectedEl) {
                return;
              }

              // Set new intersection.
              this.intersectedEl = intersectedEl;

              // Hovering.
              cursorEl.addState(STATES.HOVERING);
              intersectedEl.addState(STATES.HOVERED);
              this.twoWayEmit(EVENTS.MOUSEENTER);
              if (this.data.mouseCursorStylesEnabled && this.data.rayOrigin === 'mouse') {
                this.el.sceneEl.canvas.classList.add(CANVAS_HOVER_CLASS);
              }

              // Begin fuse if necessary.
              if (data.fuseTimeout === 0 || !data.fuse || data.rayOrigin === 'xrselect' || data.rayOrigin === 'mouse') {
                return;
              }
              cursorEl.addState(STATES.FUSING);
              this.twoWayEmit(EVENTS.FUSING);
              this.fuseTimeout = setTimeout(function fuse() {
                cursorEl.removeState(STATES.FUSING);
                self.twoWayEmit(EVENTS.CLICK);
              }, data.fuseTimeout);
            },
            clearCurrentIntersection: function clearCurrentIntersection(ignoreRemaining) {
              var index;
              var intersection;
              var intersections;
              var cursorEl = this.el;

              // Nothing to be cleared.
              if (!this.intersectedEl) {
                return;
              }

              // No longer hovering (or fusing).
              this.intersectedEl.removeState(STATES.HOVERED);
              cursorEl.removeState(STATES.HOVERING);
              cursorEl.removeState(STATES.FUSING);
              this.twoWayEmit(EVENTS.MOUSELEAVE);
              if (this.data.mouseCursorStylesEnabled && this.data.rayOrigin === 'mouse') {
                this.el.sceneEl.canvas.classList.remove(CANVAS_HOVER_CLASS);
              }

              // Unset intersected entity (after emitting the event).
              this.intersectedEl = null;

              // Clear fuseTimeout.
              clearTimeout(this.fuseTimeout);

              // Set intersection to another raycasted element if any.
              if (ignoreRemaining === true) {
                return;
              }
              intersections = this.el.components.raycaster.intersections;
              if (intersections.length === 0) {
                return;
              }
              // Exclude the cursor.
              index = intersections[0].object.el === cursorEl ? 1 : 0;
              intersection = intersections[index];
              if (!intersection) {
                return;
              }
              this.setIntersection(intersection.object.el, intersection);
            },
            /**
             * Helper to emit on both the cursor and the intersected entity (if exists).
             */
            twoWayEmit: function twoWayEmit(evtName, originalEvent) {
              var el = this.el;
              var intersectedEl = this.intersectedEl;
              var intersection;
              function addOriginalEvent(detail, evt) {
                if (originalEvent instanceof MouseEvent) {
                  detail.mouseEvent = originalEvent;
                } else if (typeof TouchEvent !== 'undefined' && originalEvent instanceof TouchEvent) {
                  detail.touchEvent = originalEvent;
                }
              }
              intersection = this.el.components.raycaster.getIntersection(intersectedEl);
              this.eventDetail.intersectedEl = intersectedEl;
              this.eventDetail.intersection = intersection;
              addOriginalEvent(this.eventDetail, originalEvent);
              el.emit(evtName, this.eventDetail);
              if (!intersectedEl) {
                return;
              }
              this.intersectedEventDetail.intersection = intersection;
              addOriginalEvent(this.intersectedEventDetail, originalEvent);
              intersectedEl.emit(evtName, this.intersectedEventDetail);
            }
          });

          /***/
        },

        /***/"./src/components/daydream-controls.js":
        /*!*********************************************!*\
          !*** ./src/components/daydream-controls.js ***!
          \*********************************************/
        /***/
        function srcComponentsDaydreamControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var DAYDREAM_CONTROLLER_MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/google/';
          var DAYDREAM_CONTROLLER_MODEL_OBJ_URL = DAYDREAM_CONTROLLER_MODEL_BASE_URL + 'vr_controller_daydream.obj';
          var DAYDREAM_CONTROLLER_MODEL_OBJ_MTL = DAYDREAM_CONTROLLER_MODEL_BASE_URL + 'vr_controller_daydream.mtl';
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var GAMEPAD_ID_WEBXR = 'google-daydream';
          var GAMEPAD_ID_WEBVR = 'Daydream Controller';
          var GAMEPAD_ID_PREFIX = isWebXRAvailable ? GAMEPAD_ID_WEBXR : GAMEPAD_ID_WEBVR;

          /**
           * Button indices:
           * 0 - trackpad
           * 1 - menu (never dispatched on this layer)
           * 2 - system (never dispatched on this layer)
           *
           * Axis:
           * 0 - trackpad x
           * 1 - trackpad y
           */
          var INPUT_MAPPING_WEBVR = {
            axes: {
              trackpad: [0, 1]
            },
            buttons: ['trackpad', 'menu', 'system']
          };

          /**
           * Button indices:
           * 0 - none
           * 1 - none
           * 2 - touchpad
           *
           * Axis:
           * 0 - touchpad x
           * 1 - touchpad y
           * Reference: https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/google/google-daydream.json
           */
          var INPUT_MAPPING_WEBXR = {
            axes: {
              touchpad: [0, 1]
            },
            buttons: ['none', 'none', 'touchpad', 'menu', 'system']
          };
          var INPUT_MAPPING = isWebXRAvailable ? INPUT_MAPPING_WEBXR : INPUT_MAPPING_WEBVR;

          /**
           * Daydream controls.
           * Interface with Daydream controller and map Gamepad events to
           * controller buttons: trackpad, menu, system
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('daydream-controls', {
            schema: {
              hand: {
                default: ''
              },
              // This informs the degenerate arm model.
              buttonColor: {
                type: 'color',
                default: '#000000'
              },
              buttonTouchedColor: {
                type: 'color',
                default: '#777777'
              },
              buttonHighlightColor: {
                type: 'color',
                default: '#FFFFFF'
              },
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              },
              armModel: {
                default: true
              }
            },
            mapping: INPUT_MAPPING,
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.bindMethods();
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, this.data.hand ? {
                hand: this.data.hand
              } : {});
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                armModel: data.armModel,
                hand: data.hand,
                idPrefix: GAMEPAD_ID_PREFIX,
                id: GAMEPAD_ID_PREFIX,
                orientationOffset: data.orientationOffset
              });
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('obj-model', {
                obj: DAYDREAM_CONTROLLER_MODEL_OBJ_URL,
                mtl: DAYDREAM_CONTROLLER_MODEL_OBJ_MTL
              });
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            onModelLoaded: function onModelLoaded(evt) {
              var controllerObject3D = evt.detail.model;
              var buttonMeshes;
              if (!this.data.model) {
                return;
              }
              buttonMeshes = this.buttonMeshes = {};
              buttonMeshes.menu = controllerObject3D.getObjectByName('AppButton_AppButton_Cylinder.004');
              buttonMeshes.system = controllerObject3D.getObjectByName('HomeButton_HomeButton_Cylinder.005');
              buttonMeshes.trackpad = controllerObject3D.getObjectByName('TouchPad_TouchPad_Cylinder.003');
              buttonMeshes.touchpad = controllerObject3D.getObjectByName('TouchPad_TouchPad_Cylinder.003');
              // Offset pivot point.
              controllerObject3D.position.set(0, 0, -0.04);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              if (!button) return;
              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            updateModel: function updateModel(buttonName, evtName) {
              if (!this.data.model) {
                return;
              }
              this.updateButtonModel(buttonName, evtName);
            },
            updateButtonModel: function updateButtonModel(buttonName, state) {
              var buttonMeshes = this.buttonMeshes;
              if (!buttonMeshes || !buttonMeshes[buttonName]) {
                return;
              }
              var color;
              switch (state) {
                case 'down':
                  color = this.data.buttonHighlightColor;
                  break;
                case 'touchstart':
                  color = this.data.buttonTouchedColor;
                  break;
                default:
                  color = this.data.buttonColor;
              }
              buttonMeshes[buttonName].material.color.set(color);
            }
          });

          /***/
        },

        /***/"./src/components/gearvr-controls.js":
        /*!*******************************************!*\
          !*** ./src/components/gearvr-controls.js ***!
          \*******************************************/
        /***/
        function srcComponentsGearvrControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var GEARVR_CONTROLLER_MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/samsung/';
          var GEARVR_CONTROLLER_MODEL_OBJ_URL = GEARVR_CONTROLLER_MODEL_BASE_URL + 'gear_vr_controller.obj';
          var GEARVR_CONTROLLER_MODEL_OBJ_MTL = GEARVR_CONTROLLER_MODEL_BASE_URL + 'gear_vr_controller.mtl';
          var GAMEPAD_ID_WEBXR = 'samsung-gearvr';
          var GAMEPAD_ID_WEBVR = 'Gear VR';

          // Prefix for Gen1 and Gen2 Oculus Touch Controllers.
          var GAMEPAD_ID_PREFIX = isWebXRAvailable ? GAMEPAD_ID_WEBXR : GAMEPAD_ID_WEBVR;

          /**
           * Button indices:
           * 0 - trackpad
           * 1 - trigger
           *
           * Axis:
           * 0 - trackpad x
           * 1 - trackpad y
           */
          var INPUT_MAPPING_WEBVR = {
            axes: {
              trackpad: [0, 1]
            },
            buttons: ['trackpad', 'trigger']
          };

          /**
           * Button indices:
           * 0 - trigger
           * 1 - none
           * 2 - touchpad
           * 3 - menu
           *
           * Axis:
           * 0 - touchpad x
           * 1 - touchpad y
           * Reference: https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/samsung/samsung-gearvr.json
           */
          var INPUT_MAPPING_WEBXR = {
            axes: {
              touchpad: [0, 1]
            },
            buttons: ['trigger', 'none', 'touchpad', 'none', 'menu']
          };
          var INPUT_MAPPING = isWebXRAvailable ? INPUT_MAPPING_WEBXR : INPUT_MAPPING_WEBVR;

          /**
           * Gear VR controls.
           * Interface with Gear VR controller and map Gamepad events to
           * controller buttons: trackpad, trigger
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('gearvr-controls', {
            schema: {
              hand: {
                default: ''
              },
              // This informs the degenerate arm model.
              buttonColor: {
                type: 'color',
                default: '#000000'
              },
              buttonTouchedColor: {
                type: 'color',
                default: '#777777'
              },
              buttonHighlightColor: {
                type: 'color',
                default: '#FFFFFF'
              },
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              },
              armModel: {
                default: true
              }
            },
            mapping: INPUT_MAPPING,
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.bindMethods();
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, this.data.hand ? {
                hand: this.data.hand
              } : {});
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                armModel: data.armModel,
                hand: data.hand,
                idPrefix: GAMEPAD_ID_PREFIX,
                id: GAMEPAD_ID_PREFIX,
                orientationOffset: data.orientationOffset
              });
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('obj-model', {
                obj: GEARVR_CONTROLLER_MODEL_OBJ_URL,
                mtl: GEARVR_CONTROLLER_MODEL_OBJ_MTL
              });
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            // No need for onButtonChanged, since Gear VR controller has no analog buttons.

            onModelLoaded: function onModelLoaded(evt) {
              var controllerObject3D = evt.detail.model;
              var buttonMeshes;
              if (!this.data.model) {
                return;
              }
              buttonMeshes = this.buttonMeshes = {};
              buttonMeshes.trigger = controllerObject3D.children[2];
              buttonMeshes.trackpad = controllerObject3D.children[1];
              buttonMeshes.touchpad = controllerObject3D.children[1];
            },
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              if (!button) return;
              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            updateModel: function updateModel(buttonName, evtName) {
              if (!this.data.model) {
                return;
              }
              this.updateButtonModel(buttonName, evtName);
            },
            updateButtonModel: function updateButtonModel(buttonName, state) {
              var buttonMeshes = this.buttonMeshes;
              if (!buttonMeshes || !buttonMeshes[buttonName]) {
                return;
              }
              var color;
              switch (state) {
                case 'down':
                  color = this.data.buttonHighlightColor;
                  break;
                case 'touchstart':
                  color = this.data.buttonTouchedColor;
                  break;
                default:
                  color = this.data.buttonColor;
              }
              buttonMeshes[buttonName].material.color.set(color);
            }
          });

          /***/
        },

        /***/"./src/components/generic-tracked-controller-controls.js":
        /*!***************************************************************!*\
          !*** ./src/components/generic-tracked-controller-controls.js ***!
          \***************************************************************/
        /***/
        function srcComponentsGenericTrackedControllerControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var GAMEPAD_ID_PREFIX = 'generic';

          /**
           * Button indices:
           * 0 - trigger
           * 1 - squeeze
           * 2 - touchpad
           * 3 - thumbstick
           *
           * Axis:
           * 0 - touchpad
           * 1 - thumbstick
           *
           */
          var INPUT_MAPPING = {
            axes: {
              touchpad: [0, 1],
              thumbstick: [2, 3]
            },
            buttons: ['trigger', 'squeeze', 'touchpad', 'thumbstick']
          };

          /**
           * Oculus Go controls.
           * Interface with Oculus Go controller and map Gamepad events to
           * controller buttons: trackpad, trigger
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('generic-tracked-controller-controls', {
            schema: {
              hand: {
                default: ''
              },
              // This informs the degenerate arm model.
              defaultModel: {
                default: true
              },
              defaultModelColor: {
                default: 'gray'
              },
              orientationOffset: {
                type: 'vec3'
              },
              disabled: {
                default: false
              }
            },
            /**
             * Button IDs:
             * 0 - trackpad
             * 1 - trigger
             */
            mapping: INPUT_MAPPING,
            bindMethods: function bindMethods() {
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.controllerPresent = false;
              this.wasControllerConnected = false;
              this.lastControllerCheck = 0;
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();

              // generic-tracked-controller-controls has the lowest precedence.
              // We must diable this component if there are more specialized controls components.
              this.el.addEventListener('controllerconnected', function (evt) {
                if (evt.detail.name === self.name) {
                  return;
                }
                self.wasControllerConnected = true;
                self.removeEventListeners();
                self.removeControllersUpdateListener();
              });
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              var data = this.data;
              var hand = data.hand ? data.hand : undefined;
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, {
                hand: hand,
                iterateControllerProfiles: true
              });
            },
            play: function play() {
              if (this.wasControllerConnected) {
                return;
              }
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;

              // Do nothing if tracked-controls already set.
              // Generic controls have the lowest precedence.
              if (this.el.components['tracked-controls']) {
                this.removeEventListeners();
                return;
              }
              el.setAttribute('tracked-controls', {
                hand: data.hand,
                idPrefix: GAMEPAD_ID_PREFIX,
                orientationOffset: data.orientationOffset,
                iterateControllerProfiles: true
              });
              if (!this.data.defaultModel) {
                return;
              }
              this.initDefaultModel();
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              if (!button) return;
              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            initDefaultModel: function initDefaultModel() {
              var modelEl = this.modelEl = document.createElement('a-entity');
              modelEl.setAttribute('geometry', {
                primitive: 'sphere',
                radius: 0.03
              });
              modelEl.setAttribute('material', {
                color: this.data.color
              });
              this.el.appendChild(modelEl);
            }
          });

          /***/
        },

        /***/"./src/components/geometry.js":
        /*!************************************!*\
          !*** ./src/components/geometry.js ***!
          \************************************/
        /***/
        function srcComponentsGeometryJs(module, __unused_webpack_exports, __webpack_require__) {
          var geometries = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").geometries;
          var geometryNames = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").geometryNames;
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var dummyGeometry = new THREE.BufferGeometry();

          /**
           * Geometry component. Combined with material component to make a mesh in 3D object.
           * Extended with registered geometries.
           */
          module.exports.Component = registerComponent('geometry', {
            schema: {
              buffer: {
                default: true
              },
              primitive: {
                default: 'box',
                oneOf: geometryNames,
                schemaChange: true
              },
              skipCache: {
                default: false
              }
            },
            init: function init() {
              this.geometry = null;
            },
            /**
             * Talk to geometry system to get or create geometry.
             */
            update: function update(previousData) {
              var data = this.data;
              var el = this.el;
              var mesh;
              var system = this.system;

              // Dispose old geometry if we created one.
              if (this.geometry) {
                system.unuseGeometry(previousData);
                this.geometry = null;
              }

              // Create new geometry.
              this.geometry = system.getOrCreateGeometry(data);

              // Set on mesh. If mesh does not exist, create it.
              mesh = el.getObject3D('mesh');
              if (mesh) {
                mesh.geometry = this.geometry;
              } else {
                mesh = new THREE.Mesh();
                mesh.geometry = this.geometry;
                // Default material if not defined on the entity.
                if (!this.el.getAttribute('material')) {
                  mesh.material = new THREE.MeshStandardMaterial({
                    color: Math.random() * 0xFFFFFF,
                    metalness: 0,
                    roughness: 0.5
                  });
                }
                el.setObject3D('mesh', mesh);
              }
            },
            /**
             * Tell geometry system that entity is no longer using the geometry.
             * Unset the geometry on the mesh
             */
            remove: function remove() {
              this.system.unuseGeometry(this.data);
              this.el.getObject3D('mesh').geometry = dummyGeometry;
              this.geometry = null;
            },
            /**
             * Update geometry component schema based on geometry type.
             */
            updateSchema: function updateSchema(data) {
              var currentGeometryType = this.oldData && this.oldData.primitive;
              var newGeometryType = data.primitive;
              var schema = geometries[newGeometryType] && geometries[newGeometryType].schema;

              // Geometry has no schema.
              if (!schema) {
                throw new Error('Unknown geometry schema `' + newGeometryType + '`');
              }
              // Nothing has changed.
              if (currentGeometryType && currentGeometryType === newGeometryType) {
                return;
              }
              this.extendSchema(schema);
            }
          });

          /***/
        },

        /***/"./src/components/gltf-model.js":
        /*!**************************************!*\
          !*** ./src/components/gltf-model.js ***!
          \**************************************/
        /***/
        function srcComponentsGltfModelJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var warn = utils.debug('components:gltf-model:warn');

          /**
           * glTF model loader.
           */
          module.exports.Component = registerComponent('gltf-model', {
            schema: {
              type: 'model'
            },
            init: function init() {
              var self = this;
              var dracoLoader = this.system.getDRACOLoader();
              var meshoptDecoder = this.system.getMeshoptDecoder();
              var ktxLoader = this.system.getKTX2Loader();
              this.model = null;
              this.loader = new THREE.GLTFLoader();
              if (dracoLoader) {
                this.loader.setDRACOLoader(dracoLoader);
              }
              if (meshoptDecoder) {
                this.ready = meshoptDecoder.then(function (meshoptDecoder) {
                  self.loader.setMeshoptDecoder(meshoptDecoder);
                });
              } else {
                this.ready = Promise.resolve();
              }
              if (ktxLoader) {
                this.loader.setKTX2Loader(ktxLoader);
              }
            },
            update: function update() {
              var self = this;
              var el = this.el;
              var src = this.data;
              if (!src) {
                return;
              }
              this.remove();
              this.ready.then(function () {
                self.loader.load(src, function gltfLoaded(gltfModel) {
                  self.model = gltfModel.scene || gltfModel.scenes[0];
                  self.model.animations = gltfModel.animations;
                  el.setObject3D('mesh', self.model);
                  el.emit('model-loaded', {
                    format: 'gltf',
                    model: self.model
                  });
                }, undefined /* onProgress */, function gltfFailed(error) {
                  var message = error && error.message ? error.message : 'Failed to load glTF model';
                  warn(message);
                  el.emit('model-error', {
                    format: 'gltf',
                    src: src
                  });
                });
              });
            },
            remove: function remove() {
              if (!this.model) {
                return;
              }
              this.el.removeObject3D('mesh');
            }
          });

          /***/
        },

        /***/"./src/components/hand-controls.js":
        /*!*****************************************!*\
          !*** ./src/components/hand-controls.js ***!
          \*****************************************/
        /***/
        function srcComponentsHandControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;

          // Found at https://github.com/aframevr/assets.
          var MODEL_URLS = {
            toonLeft: 'https://cdn.aframe.io/controllers/hands/leftHand.glb',
            toonRight: 'https://cdn.aframe.io/controllers/hands/rightHand.glb',
            lowPolyLeft: 'https://cdn.aframe.io/controllers/hands/leftHandLow.glb',
            lowPolyRight: 'https://cdn.aframe.io/controllers/hands/rightHandLow.glb',
            highPolyLeft: 'https://cdn.aframe.io/controllers/hands/leftHandHigh.glb',
            highPolyRight: 'https://cdn.aframe.io/controllers/hands/rightHandHigh.glb'
          };

          // Poses.
          var ANIMATIONS = {
            open: 'Open',
            // point: grip active, trackpad surface active, trigger inactive.
            point: 'Point',
            // pointThumb: grip active, trigger inactive, trackpad surface inactive.
            pointThumb: 'Point + Thumb',
            // fist: grip active, trigger active, trackpad surface active.
            fist: 'Fist',
            // hold: trigger active, grip inactive.
            hold: 'Hold',
            // thumbUp: grip active, trigger active, trackpad surface inactive.
            thumbUp: 'Thumb Up'
          };

          // Map animation to public events for the API.
          var EVENTS = {};
          EVENTS[ANIMATIONS.fist] = 'grip';
          EVENTS[ANIMATIONS.thumbUp] = 'pistol';
          EVENTS[ANIMATIONS.point] = 'pointing';

          /**
           * Hand controls component that abstracts 6DoF controls:
           *   oculus-touch-controls, vive-controls, windows-motion-controls.
           *
           * Originally meant to be a sample implementation of applications-specific controls that
           * abstracts multiple types of controllers.
           *
           * Auto-detect appropriate controller.
           * Handle common events coming from the detected vendor-specific controls.
           * Translate button events to semantic hand-related event names:
           *   (gripclose, gripopen, thumbup, thumbdown, pointup, pointdown)
           * Load hand model with gestures that are applied based on the button pressed.
           *
           * @property {string} Hand mapping (`left`, `right`).
           */
          module.exports.Component = registerComponent('hand-controls', {
            schema: {
              color: {
                default: 'white',
                type: 'color'
              },
              hand: {
                default: 'left'
              },
              handModelStyle: {
                default: 'lowPoly',
                oneOf: ['lowPoly', 'highPoly', 'toon']
              }
            },
            init: function init() {
              var self = this;
              var el = this.el;
              // Current pose.
              this.gesture = ANIMATIONS.open;
              // Active buttons populated by events provided by the attached controls.
              this.pressedButtons = {};
              this.touchedButtons = {};
              this.loader = new THREE.GLTFLoader();
              this.loader.setCrossOrigin('anonymous');
              this.onGripDown = function () {
                self.handleButton('grip', 'down');
              };
              this.onGripUp = function () {
                self.handleButton('grip', 'up');
              };
              this.onTrackpadDown = function () {
                self.handleButton('trackpad', 'down');
              };
              this.onTrackpadUp = function () {
                self.handleButton('trackpad', 'up');
              };
              this.onTrackpadTouchStart = function () {
                self.handleButton('trackpad', 'touchstart');
              };
              this.onTrackpadTouchEnd = function () {
                self.handleButton('trackpad', 'touchend');
              };
              this.onTriggerDown = function () {
                self.handleButton('trigger', 'down');
              };
              this.onTriggerUp = function () {
                self.handleButton('trigger', 'up');
              };
              this.onTriggerTouchStart = function () {
                self.handleButton('trigger', 'touchstart');
              };
              this.onTriggerTouchEnd = function () {
                self.handleButton('trigger', 'touchend');
              };
              this.onGripTouchStart = function () {
                self.handleButton('grip', 'touchstart');
              };
              this.onGripTouchEnd = function () {
                self.handleButton('grip', 'touchend');
              };
              this.onThumbstickDown = function () {
                self.handleButton('thumbstick', 'down');
              };
              this.onThumbstickUp = function () {
                self.handleButton('thumbstick', 'up');
              };
              this.onAorXTouchStart = function () {
                self.handleButton('AorX', 'touchstart');
              };
              this.onAorXTouchEnd = function () {
                self.handleButton('AorX', 'touchend');
              };
              this.onBorYTouchStart = function () {
                self.handleButton('BorY', 'touchstart');
              };
              this.onBorYTouchEnd = function () {
                self.handleButton('BorY', 'touchend');
              };
              this.onSurfaceTouchStart = function () {
                self.handleButton('surface', 'touchstart');
              };
              this.onSurfaceTouchEnd = function () {
                self.handleButton('surface', 'touchend');
              };
              this.onControllerConnected = this.onControllerConnected.bind(this);
              this.onControllerDisconnected = this.onControllerDisconnected.bind(this);
              el.addEventListener('controllerconnected', this.onControllerConnected);
              el.addEventListener('controllerdisconnected', this.onControllerDisconnected);

              // Hidden by default.
              el.object3D.visible = false;
            },
            play: function play() {
              this.addEventListeners();
            },
            pause: function pause() {
              this.removeEventListeners();
            },
            tick: function tick(time, delta) {
              var mesh = this.el.getObject3D('mesh');
              if (!mesh || !mesh.mixer) {
                return;
              }
              mesh.mixer.update(delta / 1000);
            },
            onControllerConnected: function onControllerConnected() {
              this.el.object3D.visible = true;
            },
            onControllerDisconnected: function onControllerDisconnected() {
              this.el.object3D.visible = false;
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('gripdown', this.onGripDown);
              el.addEventListener('gripup', this.onGripUp);
              el.addEventListener('trackpaddown', this.onTrackpadDown);
              el.addEventListener('trackpadup', this.onTrackpadUp);
              el.addEventListener('trackpadtouchstart', this.onTrackpadTouchStart);
              el.addEventListener('trackpadtouchend', this.onTrackpadTouchEnd);
              el.addEventListener('triggerdown', this.onTriggerDown);
              el.addEventListener('triggerup', this.onTriggerUp);
              el.addEventListener('triggertouchstart', this.onTriggerTouchStart);
              el.addEventListener('triggertouchend', this.onTriggerTouchEnd);
              el.addEventListener('griptouchstart', this.onGripTouchStart);
              el.addEventListener('griptouchend', this.onGripTouchEnd);
              el.addEventListener('thumbstickdown', this.onThumbstickDown);
              el.addEventListener('thumbstickup', this.onThumbstickUp);
              el.addEventListener('abuttontouchstart', this.onAorXTouchStart);
              el.addEventListener('abuttontouchend', this.onAorXTouchEnd);
              el.addEventListener('bbuttontouchstart', this.onBorYTouchStart);
              el.addEventListener('bbuttontouchend', this.onBorYTouchEnd);
              el.addEventListener('xbuttontouchstart', this.onAorXTouchStart);
              el.addEventListener('xbuttontouchend', this.onAorXTouchEnd);
              el.addEventListener('ybuttontouchstart', this.onBorYTouchStart);
              el.addEventListener('ybuttontouchend', this.onBorYTouchEnd);
              el.addEventListener('surfacetouchstart', this.onSurfaceTouchStart);
              el.addEventListener('surfacetouchend', this.onSurfaceTouchEnd);
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('gripdown', this.onGripDown);
              el.removeEventListener('gripup', this.onGripUp);
              el.removeEventListener('trackpaddown', this.onTrackpadDown);
              el.removeEventListener('trackpadup', this.onTrackpadUp);
              el.removeEventListener('trackpadtouchstart', this.onTrackpadTouchStart);
              el.removeEventListener('trackpadtouchend', this.onTrackpadTouchEnd);
              el.removeEventListener('triggerdown', this.onTriggerDown);
              el.removeEventListener('triggerup', this.onTriggerUp);
              el.removeEventListener('triggertouchstart', this.onTriggerTouchStart);
              el.removeEventListener('triggertouchend', this.onTriggerTouchEnd);
              el.removeEventListener('griptouchstart', this.onGripTouchStart);
              el.removeEventListener('griptouchend', this.onGripTouchEnd);
              el.removeEventListener('thumbstickdown', this.onThumbstickDown);
              el.removeEventListener('thumbstickup', this.onThumbstickUp);
              el.removeEventListener('abuttontouchstart', this.onAorXTouchStart);
              el.removeEventListener('abuttontouchend', this.onAorXTouchEnd);
              el.removeEventListener('bbuttontouchstart', this.onBorYTouchStart);
              el.removeEventListener('bbuttontouchend', this.onBorYTouchEnd);
              el.removeEventListener('xbuttontouchstart', this.onAorXTouchStart);
              el.removeEventListener('xbuttontouchend', this.onAorXTouchEnd);
              el.removeEventListener('ybuttontouchstart', this.onBorYTouchStart);
              el.removeEventListener('ybuttontouchend', this.onBorYTouchEnd);
              el.removeEventListener('surfacetouchstart', this.onSurfaceTouchStart);
              el.removeEventListener('surfacetouchend', this.onSurfaceTouchEnd);
            },
            /**
             * Update handler. More like the `init` handler since the only property is the hand, and
             * that won't be changing much.
             */
            update: function update(previousHand) {
              var controlConfiguration;
              var el = this.el;
              var hand = this.data.hand;
              var handModelStyle = this.data.handModelStyle;
              var handColor = this.data.color;
              var self = this;

              // Get common configuration to abstract different vendor controls.
              controlConfiguration = {
                hand: hand,
                model: false
              };

              // Set model.
              if (hand !== previousHand) {
                var handmodelUrl = MODEL_URLS[handModelStyle + hand.charAt(0).toUpperCase() + hand.slice(1)];
                this.loader.load(handmodelUrl, function (gltf) {
                  var mesh = gltf.scene.children[0];
                  var handModelOrientation = hand === 'left' ? Math.PI / 2 : -Math.PI / 2;
                  mesh.mixer = new THREE.AnimationMixer(mesh);
                  self.clips = gltf.animations;
                  el.setObject3D('mesh', mesh);
                  var handMaterial = mesh.children[1].material;
                  handMaterial.color = new THREE.Color(handColor);
                  mesh.position.set(0, 0, 0);
                  mesh.rotation.set(0, 0, handModelOrientation);
                  el.setAttribute('magicleap-controls', controlConfiguration);
                  el.setAttribute('vive-controls', controlConfiguration);
                  el.setAttribute('oculus-touch-controls', controlConfiguration);
                  el.setAttribute('windows-motion-controls', controlConfiguration);
                  el.setAttribute('hp-mixed-reality-controls', controlConfiguration);
                });
              }
            },
            remove: function remove() {
              this.el.removeObject3D('mesh');
            },
            /**
             * Play model animation, based on which button was pressed and which kind of event.
             *
             * 1. Process buttons.
             * 2. Determine gesture (this.determineGesture()).
             * 3. Animation gesture (this.animationGesture()).
             * 4. Emit gesture events (this.emitGestureEvents()).
             *
             * @param {string} button - Name of the button.
             * @param {string} evt - Type of event for the button (i.e., down/up/touchstart/touchend).
             */
            handleButton: function handleButton(button, evt) {
              var lastGesture;
              var isPressed = evt === 'down';
              var isTouched = evt === 'touchstart';

              // Update objects.
              if (evt.indexOf('touch') === 0) {
                // Update touch object.
                if (isTouched === this.touchedButtons[button]) {
                  return;
                }
                this.touchedButtons[button] = isTouched;
              } else {
                // Update button object.
                if (isPressed === this.pressedButtons[button]) {
                  return;
                }
                this.pressedButtons[button] = isPressed;
              }

              // Determine the gesture.
              lastGesture = this.gesture;
              this.gesture = this.determineGesture();

              // Same gesture.
              if (this.gesture === lastGesture) {
                return;
              }
              // Animate gesture.
              this.animateGesture(this.gesture, lastGesture);

              // Emit events.
              this.emitGestureEvents(this.gesture, lastGesture);
            },
            /**
             * Determine which pose hand should be in considering active and touched buttons.
             */
            determineGesture: function determineGesture() {
              var gesture;
              var isGripActive = this.pressedButtons.grip;
              var isSurfaceActive = this.pressedButtons.surface || this.touchedButtons.surface;
              var isTrackpadActive = this.pressedButtons.trackpad || this.touchedButtons.trackpad;
              var isTriggerActive = this.pressedButtons.trigger || this.touchedButtons.trigger;
              var isABXYActive = this.touchedButtons.AorX || this.touchedButtons.BorY;
              var isVive = isViveController(this.el.components['tracked-controls']);

              // Works well with Oculus Touch and Windows Motion Controls, but Vive needs tweaks.
              if (isVive) {
                if (isGripActive || isTriggerActive) {
                  gesture = ANIMATIONS.fist;
                } else if (isTrackpadActive) {
                  gesture = ANIMATIONS.point;
                }
              } else {
                if (isGripActive) {
                  if (isSurfaceActive || isABXYActive || isTrackpadActive) {
                    gesture = isTriggerActive ? ANIMATIONS.fist : ANIMATIONS.point;
                  } else {
                    gesture = isTriggerActive ? ANIMATIONS.thumbUp : ANIMATIONS.pointThumb;
                  }
                } else if (isTriggerActive) {
                  gesture = ANIMATIONS.hold;
                }
              }
              return gesture;
            },
            /**
             * Play corresponding clip to a gesture
             */
            getClip: function getClip(gesture) {
              var clip;
              var i;
              for (i = 0; i < this.clips.length; i++) {
                clip = this.clips[i];
                if (clip.name !== gesture) {
                  continue;
                }
                return clip;
              }
            },
            /**
             * Play gesture animation.
             *
             * @param {string} gesture - Which pose to animate to. If absent, then animate to open.
             * @param {string} lastGesture - Previous gesture, to reverse back to open if needed.
             */
            animateGesture: function animateGesture(gesture, lastGesture) {
              if (gesture) {
                this.playAnimation(gesture || ANIMATIONS.open, lastGesture, false);
                return;
              }

              // If no gesture, then reverse the current gesture back to open pose.
              this.playAnimation(lastGesture, lastGesture, true);
            },
            /**
             * Emit `hand-controls`-specific events.
             */
            emitGestureEvents: function emitGestureEvents(gesture, lastGesture) {
              var el = this.el;
              var eventName;
              if (lastGesture === gesture) {
                return;
              }

              // Emit event for lastGesture not inactive.
              eventName = getGestureEventName(lastGesture, false);
              if (eventName) {
                el.emit(eventName);
              }

              // Emit event for current gesture now active.
              eventName = getGestureEventName(gesture, true);
              if (eventName) {
                el.emit(eventName);
              }
            },
            /**
            * Play hand animation based on button state.
            *
            * @param {string} gesture - Name of the animation as specified by the model.
            * @param {string} lastGesture - Previous pose.
            * @param {boolean} reverse - Whether animation should play in reverse.
            */
            playAnimation: function playAnimation(gesture, lastGesture, reverse) {
              var clip;
              var fromAction;
              var mesh = this.el.getObject3D('mesh');
              var toAction;
              if (!mesh) {
                return;
              }

              // Stop all current animations.
              mesh.mixer.stopAllAction();

              // Grab clip action.
              clip = this.getClip(gesture);
              toAction = mesh.mixer.clipAction(clip);
              toAction.clampWhenFinished = true;
              toAction.loop = THREE.LoopRepeat;
              toAction.repetitions = 0;
              toAction.timeScale = reverse ? -1 : 1;
              toAction.time = reverse ? clip.duration : 0;
              toAction.weight = 1;

              // No gesture to gesture or gesture to no gesture.
              if (!lastGesture || gesture === lastGesture) {
                // Stop all current animations.
                mesh.mixer.stopAllAction();
                // Play animation.
                toAction.play();
                return;
              }

              // Animate or crossfade from gesture to gesture.
              clip = this.getClip(lastGesture);
              fromAction = mesh.mixer.clipAction(clip);
              fromAction.weight = 0.15;
              fromAction.play();
              toAction.play();
              fromAction.crossFadeTo(toAction, 0.15, true);
            }
          });

          /**
           * Suffix gestures based on toggle state (e.g., open/close, up/down, start/end).
           *
           * @param {string} gesture
           * @param {boolean} active
           */
          function getGestureEventName(gesture, active) {
            var eventName;
            if (!gesture) {
              return;
            }
            eventName = EVENTS[gesture];
            if (eventName === 'grip') {
              return eventName + (active ? 'close' : 'open');
            }
            if (eventName === 'point') {
              return eventName + (active ? 'up' : 'down');
            }
            if (eventName === 'pointing' || eventName === 'pistol') {
              return eventName + (active ? 'start' : 'end');
            }
          }
          function isViveController(trackedControls) {
            var controller = trackedControls && trackedControls.controller;
            var isVive = controller && (controller.id && controller.id.indexOf('OpenVR ') === 0 || controller.profiles && controller.profiles[0] && controller.profiles[0] === 'htc-vive');
            return isVive;
          }

          /***/
        },

        /***/"./src/components/hand-tracking-controls.js":
        /*!**************************************************!*\
          !*** ./src/components/hand-tracking-controls.js ***!
          \**************************************************/
        /***/
        function srcComponentsHandTrackingControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE, XRRigidTransform */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var LEFT_HAND_MODEL_URL = 'https://cdn.aframe.io/controllers/oculus-hands/v4/left.glb';
          var RIGHT_HAND_MODEL_URL = 'https://cdn.aframe.io/controllers/oculus-hands/v4/right.glb';
          var JOINTS = ['wrist', 'thumb-metacarpal', 'thumb-phalanx-proximal', 'thumb-phalanx-distal', 'thumb-tip', 'index-finger-metacarpal', 'index-finger-phalanx-proximal', 'index-finger-phalanx-intermediate', 'index-finger-phalanx-distal', 'index-finger-tip', 'middle-finger-metacarpal', 'middle-finger-phalanx-proximal', 'middle-finger-phalanx-intermediate', 'middle-finger-phalanx-distal', 'middle-finger-tip', 'ring-finger-metacarpal', 'ring-finger-phalanx-proximal', 'ring-finger-phalanx-intermediate', 'ring-finger-phalanx-distal', 'ring-finger-tip', 'pinky-finger-metacarpal', 'pinky-finger-phalanx-proximal', 'pinky-finger-phalanx-intermediate', 'pinky-finger-phalanx-distal', 'pinky-finger-tip'];
          var PINCH_START_DISTANCE = 0.015;
          var PINCH_END_DISTANCE = 0.03;
          var PINCH_POSITION_INTERPOLATION = 0.5;

          /**
           * Controls for hand tracking
           */
          module.exports.Component = registerComponent('hand-tracking-controls', {
            schema: {
              hand: {
                default: 'right',
                oneOf: ['left', 'right']
              },
              modelStyle: {
                default: 'mesh',
                oneOf: ['dots', 'mesh']
              },
              modelColor: {
                default: 'white'
              }
            },
            bindMethods: function bindMethods() {
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
            },
            addEventListeners: function addEventListeners() {
              this.el.addEventListener('model-loaded', this.onModelLoaded);
              for (var i = 0; i < this.jointEls.length; ++i) {
                this.jointEls[i].object3D.visible = true;
              }
            },
            removeEventListeners: function removeEventListeners() {
              this.el.removeEventListener('model-loaded', this.onModelLoaded);
              for (var i = 0; i < this.jointEls.length; ++i) {
                this.jointEls[i].object3D.visible = false;
              }
            },
            init: function init() {
              var sceneEl = this.el.sceneEl;
              var webXROptionalAttributes = sceneEl.getAttribute('webxr').optionalFeatures;
              webXROptionalAttributes.push('hand-tracking');
              sceneEl.setAttribute('webxr', {
                optionalFeatures: webXROptionalAttributes
              });
              this.onModelLoaded = this.onModelLoaded.bind(this);
              this.jointEls = [];
              this.controllerPresent = false;
              this.isPinched = false;
              this.pinchEventDetail = {
                position: new THREE.Vector3()
              };
              this.indexTipPosition = new THREE.Vector3();
              this.bindMethods();
              this.updateReferenceSpace = this.updateReferenceSpace.bind(this);
              this.el.sceneEl.addEventListener('enter-vr', this.updateReferenceSpace);
              this.el.sceneEl.addEventListener('exit-vr', this.updateReferenceSpace);
            },
            updateReferenceSpace: function updateReferenceSpace() {
              var self = this;
              var xrSession = this.el.sceneEl.xrSession;
              this.referenceSpace = undefined;
              if (!xrSession) {
                return;
              }
              var referenceSpaceType = self.el.sceneEl.systems.webxr.sessionReferenceSpaceType;
              xrSession.requestReferenceSpace(referenceSpaceType).then(function (referenceSpace) {
                self.referenceSpace = referenceSpace.getOffsetReferenceSpace(new XRRigidTransform({
                  x: 0,
                  y: 1.5,
                  z: 0
                }));
              }).catch(function (error) {
                self.el.sceneEl.systems.webxr.warnIfFeatureNotRequested(referenceSpaceType, 'tracked-controls-webxr uses reference space ' + referenceSpaceType);
                throw error;
              });
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              var data = this.data;
              var hand = data.hand ? data.hand : undefined;
              checkControllerPresentAndSetup(this, '', {
                hand: hand,
                iterateControllerProfiles: true,
                handTracking: true
              });
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            tick: function tick() {
              var sceneEl = this.el.sceneEl;
              var controller = this.el.components['tracked-controls'] && this.el.components['tracked-controls'].controller;
              var frame = sceneEl.frame;
              var trackedControlsWebXR = this.el.components['tracked-controls-webxr'];
              if (!controller || !frame || !trackedControlsWebXR) {
                return;
              }
              if (controller.hand) {
                this.el.object3D.position.set(0, 0, 0);
                this.el.object3D.rotation.set(0, 0, 0);
                if (frame.getJointPose) {
                  this.updateHandModel();
                }
                this.detectGesture();
              }
            },
            updateHandModel: function updateHandModel() {
              if (this.data.modelStyle === 'dots') {
                this.updateHandDotsModel();
              }
              if (this.data.modelStyle === 'mesh') {
                this.updateHandMeshModel();
              }
            },
            getBone: function getBone(name) {
              var bones = this.bones;
              for (var i = 0; i < bones.length; i++) {
                if (bones[i].name === name) {
                  return bones[i];
                }
              }
              return null;
            },
            updateHandMeshModel: function updateHandMeshModel() {
              var frame = this.el.sceneEl.frame;
              var controller = this.el.components['tracked-controls'] && this.el.components['tracked-controls'].controller;
              var referenceSpace = this.referenceSpace;
              if (!controller || !this.mesh || !referenceSpace) {
                return;
              }
              this.mesh.visible = false;
              var _iterator3 = _createForOfIteratorHelper2(controller.hand.values()),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var inputjoint = _step3.value;
                  var bone;
                  var jointPose;
                  var jointTransform;
                  jointPose = frame.getJointPose(inputjoint, referenceSpace);
                  bone = this.getBone(inputjoint.jointName);
                  if (bone != null && jointPose) {
                    jointTransform = jointPose.transform;
                    this.mesh.visible = true;
                    bone.position.copy(jointTransform.position);
                    bone.quaternion.copy(jointTransform.orientation);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            },
            updateHandDotsModel: function updateHandDotsModel() {
              var frame = this.el.sceneEl.frame;
              var controller = this.el.components['tracked-controls'] && this.el.components['tracked-controls'].controller;
              var trackedControlsWebXR = this.el.components['tracked-controls-webxr'];
              var referenceSpace = trackedControlsWebXR.system.referenceSpace;
              var jointEl;
              var object3D;
              var jointPose;
              var i = 0;
              var _iterator4 = _createForOfIteratorHelper2(controller.hand.values()),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var inputjoint = _step4.value;
                  jointEl = this.jointEls[i++];
                  object3D = jointEl.object3D;
                  jointPose = frame.getJointPose(inputjoint, referenceSpace);
                  jointEl.object3D.visible = !!jointPose;
                  if (!jointPose) {
                    continue;
                  }
                  object3D.matrix.elements = jointPose.transform.matrix;
                  object3D.matrix.decompose(object3D.position, object3D.rotation, object3D.scale);
                  jointEl.setAttribute('scale', {
                    x: jointPose.radius,
                    y: jointPose.radius,
                    z: jointPose.radius
                  });
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            },
            detectGesture: function detectGesture() {
              this.detectPinch();
            },
            detectPinch: function () {
              var thumbTipPosition = new THREE.Vector3();
              return function () {
                var frame = this.el.sceneEl.frame;
                var indexTipPosition = this.indexTipPosition;
                var controller = this.el.components['tracked-controls'] && this.el.components['tracked-controls'].controller;
                var trackedControlsWebXR = this.el.components['tracked-controls-webxr'];
                var referenceSpace = this.referenceSpace || trackedControlsWebXR.system.referenceSpace;
                var indexTip = controller.hand.get('index-finger-tip');
                var thumbTip = controller.hand.get('thumb-tip');
                if (!indexTip || !thumbTip) {
                  return;
                }
                var indexTipPose = frame.getJointPose(indexTip, referenceSpace);
                var thumbTipPose = frame.getJointPose(thumbTip, referenceSpace);
                if (!indexTipPose || !thumbTipPose) {
                  return;
                }
                thumbTipPosition.copy(thumbTipPose.transform.position);
                indexTipPosition.copy(indexTipPose.transform.position);
                var distance = indexTipPosition.distanceTo(thumbTipPosition);
                if (distance < PINCH_START_DISTANCE && this.isPinched === false) {
                  this.isPinched = true;
                  this.pinchEventDetail.position.copy(indexTipPosition).lerp(thumbTipPosition, PINCH_POSITION_INTERPOLATION);
                  this.pinchEventDetail.position.y += 1.5;
                  this.el.emit('pinchstarted', this.pinchEventDetail);
                }
                if (distance > PINCH_END_DISTANCE && this.isPinched === true) {
                  this.isPinched = false;
                  this.pinchEventDetail.position.copy(indexTipPosition).lerp(thumbTipPosition, PINCH_POSITION_INTERPOLATION);
                  this.pinchEventDetail.position.y += 1.5;
                  this.el.emit('pinchended', this.pinchEventDetail);
                }
                if (this.isPinched) {
                  this.pinchEventDetail.position.copy(indexTipPosition).lerp(thumbTipPosition, PINCH_POSITION_INTERPOLATION);
                  this.pinchEventDetail.position.y += 1.5;
                  this.el.emit('pinchmoved', this.pinchEventDetail);
                }
                indexTipPosition.y += 1.5;
              };
            }(),
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                hand: data.hand,
                iterateControllerProfiles: true,
                handTrackingEnabled: true
              });
              this.initDefaultModel();
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              var controller;
              this.checkIfControllerPresent();
              controller = this.el.components['tracked-controls'] && this.el.components['tracked-controls'].controller;
              if (!this.el.getObject3D('mesh')) {
                return;
              }
              if (!controller || !controller.hand || !controller.hand[0]) {
                this.el.getObject3D('mesh').visible = false;
              }
            },
            initDefaultModel: function initDefaultModel() {
              if (this.el.getObject3D('mesh')) {
                return;
              }
              if (this.data.modelStyle === 'dots') {
                this.initDotsModel();
              }
              if (this.data.modelStyle === 'mesh') {
                this.initMeshHandModel();
              }
            },
            initDotsModel: function initDotsModel() {
              // Add models just once.
              if (this.jointEls.length !== 0) {
                return;
              }
              for (var i = 0; i < JOINTS.length; ++i) {
                var jointEl = this.jointEl = document.createElement('a-entity');
                jointEl.setAttribute('geometry', {
                  primitive: 'sphere',
                  radius: 1.0
                });
                jointEl.setAttribute('material', {
                  color: this.data.modelColor
                });
                jointEl.object3D.visible = false;
                this.el.appendChild(jointEl);
                this.jointEls.push(jointEl);
              }
            },
            initMeshHandModel: function initMeshHandModel() {
              var modelURL = this.data.hand === 'left' ? LEFT_HAND_MODEL_URL : RIGHT_HAND_MODEL_URL;
              this.el.setAttribute('gltf-model', modelURL);
            },
            onModelLoaded: function onModelLoaded() {
              var mesh = this.mesh = this.el.getObject3D('mesh').children[0];
              var skinnedMesh = this.skinnedMesh = mesh.getObjectByProperty('type', 'SkinnedMesh');
              if (!this.skinnedMesh) {
                return;
              }
              this.bones = skinnedMesh.skeleton.bones;
              this.el.removeObject3D('mesh');
              mesh.position.set(0, 1.5, 0);
              mesh.rotation.set(0, 0, 0);
              skinnedMesh.frustumCulled = false;
              skinnedMesh.material = new THREE.MeshStandardMaterial({
                skinning: true,
                color: this.data.modelColor
              });
              this.el.setObject3D('mesh', mesh);
            }
          });

          /***/
        },

        /***/"./src/components/hide-on-enter-ar.js":
        /*!********************************************!*\
          !*** ./src/components/hide-on-enter-ar.js ***!
          \********************************************/
        /***/
        function srcComponentsHideOnEnterArJs(module, __unused_webpack_exports, __webpack_require__) {
          var register = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          module.exports.Component = register('hide-on-enter-ar', {
            init: function init() {
              var self = this;
              this.el.sceneEl.addEventListener('enter-vr', function () {
                if (self.el.sceneEl.is('ar-mode')) {
                  self.el.object3D.visible = false;
                }
              });
              this.el.sceneEl.addEventListener('exit-vr', function () {
                self.el.object3D.visible = true;
              });
            }
          });

          /***/
        },

        /***/"./src/components/hp-mixed-reality-controls.js":
        /*!*****************************************************!*\
          !*** ./src/components/hp-mixed-reality-controls.js ***!
          \*****************************************************/
        /***/
        function srcComponentsHpMixedRealityControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;

          // See Profiles Registry:
          // https://github.com/immersive-web/webxr-input-profiles/tree/master/packages/registry
          // TODO: Add a more robust system for deriving gamepad name.
          var GAMEPAD_ID = 'hp-mixed-reality';
          var HP_MIXEDL_REALITY_MODEL_GLB_BASE_URL = 'https://cdn.aframe.io/controllers/hp/mixed-reality/';
          var HP_MIXED_REALITY_POSITION_OFFSET = {
            x: 0,
            y: 0,
            z: 0.06
          };
          var HP_MIXED_REALITY_ROTATION_OFFSET = {
            _x: Math.PI / 4,
            _y: 0,
            _z: 0,
            _order: 'XYZ'
          };

          /**
           * Button IDs:
           * 0 - trigger
           * 1 - grip
           * 3 - X / A
           * 4 - Y / B
           *
           * Axis:
           * 2 - joystick x axis
           * 3 - joystick y axis
           */
          var INPUT_MAPPING_WEBXR = {
            left: {
              axes: {
                touchpad: [2, 3]
              },
              buttons: ['trigger', 'grip', 'none', 'thumbstick', 'xbutton', 'ybutton']
            },
            right: {
              axes: {
                touchpad: [2, 3]
              },
              buttons: ['trigger', 'grip', 'none', 'thumbstick', 'abutton', 'bbutton']
            }
          };

          /**
           * HP Mixed Reality Controls
           */
          module.exports.Component = registerComponent('hp-mixed-reality-controls', {
            schema: {
              hand: {
                default: 'none'
              },
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              }
            },
            mapping: INPUT_MAPPING_WEBXR,
            init: function init() {
              var self = this;
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self, self.data.hand);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self, self.data.hand);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self, self.data.hand);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self, self.data.hand);
              };
              this.previousButtonValues = {};
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();
            },
            update: function update() {
              var data = this.data;
              this.controllerIndex = data.hand === 'right' ? 0 : data.hand === 'left' ? 1 : 2;
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('axismove', this.onAxisMoved);
              el.addEventListener('model-loaded', this.onModelLoaded);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('axismove', this.onAxisMoved);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              var data = this.data;
              checkControllerPresentAndSetup(this, GAMEPAD_ID, {
                index: this.controllerIndex,
                hand: data.hand
              });
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                // TODO: verify expected behavior between reserved prefixes.
                idPrefix: GAMEPAD_ID,
                hand: data.hand,
                controller: this.controllerIndex,
                orientationOffset: data.orientationOffset
              });

              // Load model.
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('gltf-model', HP_MIXEDL_REALITY_MODEL_GLB_BASE_URL + this.data.hand + '.glb');
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              // Note that due to gamepadconnected event propagation issues, we don't rely on events.
              this.checkIfControllerPresent();
            },
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping[this.data.hand].buttons[evt.detail.id];
              var analogValue;
              if (!button) {
                return;
              }
              if (button === 'trigger') {
                analogValue = evt.detail.state.value;
                console.log('analog value of trigger press: ' + analogValue);
              }

              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onModelLoaded: function onModelLoaded(evt) {
              var controllerObject3D = evt.detail.model;
              if (!this.data.model) {
                return;
              }
              controllerObject3D.position.copy(HP_MIXED_REALITY_POSITION_OFFSET);
              controllerObject3D.rotation.copy(HP_MIXED_REALITY_ROTATION_OFFSET);
              this.el.emit('controllermodelready', {
                name: 'hp-mixed-reality-controls',
                model: this.data.model,
                rayOrigin: new THREE.Vector3(0, 0, 0)
              });
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            }
          });

          /***/
        },

        /***/"./src/components/index.js":
        /*!*********************************!*\
          !*** ./src/components/index.js ***!
          \*********************************/
        /***/
        function srcComponentsIndexJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          __webpack_require__( /*! ./animation */"./src/components/animation.js");
          __webpack_require__( /*! ./camera */"./src/components/camera.js");
          __webpack_require__( /*! ./cursor */"./src/components/cursor.js");
          __webpack_require__( /*! ./daydream-controls */"./src/components/daydream-controls.js");
          __webpack_require__( /*! ./gearvr-controls */"./src/components/gearvr-controls.js");
          __webpack_require__( /*! ./geometry */"./src/components/geometry.js");
          __webpack_require__( /*! ./generic-tracked-controller-controls */"./src/components/generic-tracked-controller-controls.js");
          __webpack_require__( /*! ./gltf-model */"./src/components/gltf-model.js");
          __webpack_require__( /*! ./hand-tracking-controls */"./src/components/hand-tracking-controls.js");
          __webpack_require__( /*! ./hand-controls */"./src/components/hand-controls.js");
          __webpack_require__( /*! ./hide-on-enter-ar */"./src/components/hide-on-enter-ar.js");
          __webpack_require__( /*! ./hp-mixed-reality-controls */"./src/components/hp-mixed-reality-controls.js");
          __webpack_require__( /*! ./layer */"./src/components/layer.js");
          __webpack_require__( /*! ./laser-controls */"./src/components/laser-controls.js");
          __webpack_require__( /*! ./light */"./src/components/light.js");
          __webpack_require__( /*! ./line */"./src/components/line.js");
          __webpack_require__( /*! ./link */"./src/components/link.js");
          __webpack_require__( /*! ./look-controls */"./src/components/look-controls.js");
          __webpack_require__( /*! ./magicleap-controls */"./src/components/magicleap-controls.js");
          __webpack_require__( /*! ./material */"./src/components/material.js");
          __webpack_require__( /*! ./obj-model */"./src/components/obj-model.js");
          __webpack_require__( /*! ./oculus-go-controls */"./src/components/oculus-go-controls.js");
          __webpack_require__( /*! ./oculus-touch-controls */"./src/components/oculus-touch-controls.js");
          __webpack_require__( /*! ./position */"./src/components/position.js");
          __webpack_require__( /*! ./raycaster */"./src/components/raycaster.js");
          __webpack_require__( /*! ./rotation */"./src/components/rotation.js");
          __webpack_require__( /*! ./scale */"./src/components/scale.js");
          __webpack_require__( /*! ./shadow */"./src/components/shadow.js");
          __webpack_require__( /*! ./sound */"./src/components/sound.js");
          __webpack_require__( /*! ./text */"./src/components/text.js");
          __webpack_require__( /*! ./tracked-controls */"./src/components/tracked-controls.js");
          __webpack_require__( /*! ./tracked-controls-webvr */"./src/components/tracked-controls-webvr.js");
          __webpack_require__( /*! ./tracked-controls-webxr */"./src/components/tracked-controls-webxr.js");
          __webpack_require__( /*! ./visible */"./src/components/visible.js");
          __webpack_require__( /*! ./valve-index-controls */"./src/components/valve-index-controls.js");
          __webpack_require__( /*! ./vive-controls */"./src/components/vive-controls.js");
          __webpack_require__( /*! ./vive-focus-controls */"./src/components/vive-focus-controls.js");
          __webpack_require__( /*! ./wasd-controls */"./src/components/wasd-controls.js");
          __webpack_require__( /*! ./windows-motion-controls */"./src/components/windows-motion-controls.js");
          __webpack_require__( /*! ./scene/ar-hit-test */"./src/components/scene/ar-hit-test.js");
          __webpack_require__( /*! ./scene/background */"./src/components/scene/background.js");
          __webpack_require__( /*! ./scene/debug */"./src/components/scene/debug.js");
          __webpack_require__( /*! ./scene/device-orientation-permission-ui */"./src/components/scene/device-orientation-permission-ui.js");
          __webpack_require__( /*! ./scene/embedded */"./src/components/scene/embedded.js");
          __webpack_require__( /*! ./scene/inspector */"./src/components/scene/inspector.js");
          __webpack_require__( /*! ./scene/fog */"./src/components/scene/fog.js");
          __webpack_require__( /*! ./scene/keyboard-shortcuts */"./src/components/scene/keyboard-shortcuts.js");
          __webpack_require__( /*! ./scene/pool */"./src/components/scene/pool.js");
          __webpack_require__( /*! ./scene/reflection */"./src/components/scene/reflection.js");
          __webpack_require__( /*! ./scene/screenshot */"./src/components/scene/screenshot.js");
          __webpack_require__( /*! ./scene/stats */"./src/components/scene/stats.js");
          __webpack_require__( /*! ./scene/vr-mode-ui */"./src/components/scene/vr-mode-ui.js");

          /***/
        },

        /***/"./src/components/laser-controls.js":
        /*!******************************************!*\
          !*** ./src/components/laser-controls.js ***!
          \******************************************/
        /***/
        function srcComponentsLaserControlsJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          registerComponent('laser-controls', {
            schema: {
              hand: {
                default: 'right'
              },
              model: {
                default: true
              },
              defaultModelColor: {
                type: 'color',
                default: 'grey'
              }
            },
            init: function init() {
              var config = this.config;
              var data = this.data;
              var el = this.el;
              var self = this;
              var controlsConfiguration = {
                hand: data.hand,
                model: data.model
              };

              // Set all controller models.
              el.setAttribute('daydream-controls', controlsConfiguration);
              el.setAttribute('gearvr-controls', controlsConfiguration);
              el.setAttribute('hp-mixed-reality-controls', controlsConfiguration);
              el.setAttribute('magicleap-controls', controlsConfiguration);
              el.setAttribute('oculus-go-controls', controlsConfiguration);
              el.setAttribute('oculus-touch-controls', controlsConfiguration);
              el.setAttribute('valve-index-controls', controlsConfiguration);
              el.setAttribute('vive-controls', controlsConfiguration);
              el.setAttribute('vive-focus-controls', controlsConfiguration);
              el.setAttribute('windows-motion-controls', controlsConfiguration);
              el.setAttribute('generic-tracked-controller-controls', {
                hand: controlsConfiguration.hand
              });

              // Wait for controller to connect, or have a valid pointing pose, before creating ray
              el.addEventListener('controllerconnected', createRay);
              el.addEventListener('controllerdisconnected', hideRay);
              el.addEventListener('controllermodelready', function (evt) {
                createRay(evt);
                self.modelReady = true;
              });
              function createRay(evt) {
                var controllerConfig = config[evt.detail.name];
                if (!controllerConfig) {
                  return;
                }

                // Show the line unless a particular config opts to hide it, until a controllermodelready
                // event comes through.
                var raycasterConfig = utils.extend({
                  showLine: true
                }, controllerConfig.raycaster || {});

                // The controllermodelready event contains a rayOrigin that takes into account
                // offsets specific to the loaded model.
                if (evt.detail.rayOrigin) {
                  raycasterConfig.origin = evt.detail.rayOrigin.origin;
                  raycasterConfig.direction = evt.detail.rayOrigin.direction;
                  raycasterConfig.showLine = true;
                }

                // Only apply a default raycaster if it does not yet exist. This prevents it overwriting
                // config applied from a controllermodelready event.
                if (evt.detail.rayOrigin || !self.modelReady) {
                  el.setAttribute('raycaster', raycasterConfig);
                } else {
                  el.setAttribute('raycaster', 'showLine', true);
                }
                el.setAttribute('cursor', utils.extend({
                  fuse: false
                }, controllerConfig.cursor));
              }
              function hideRay() {
                el.setAttribute('raycaster', 'showLine', false);
              }
            },
            config: {
              'daydream-controls': {
                cursor: {
                  downEvents: ['trackpaddown', 'triggerdown'],
                  upEvents: ['trackpadup', 'triggerup']
                }
              },
              'gearvr-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                },
                raycaster: {
                  origin: {
                    x: 0,
                    y: 0.0010,
                    z: 0
                  }
                }
              },
              'generic-tracked-controller-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                }
              },
              'hp-mixed-reality-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                },
                raycaster: {
                  origin: {
                    x: 0,
                    y: 0,
                    z: 0
                  }
                }
              },
              'magicleap-controls': {
                cursor: {
                  downEvents: ['trackpaddown', 'triggerdown'],
                  upEvents: ['trackpadup', 'triggerup']
                }
              },
              'oculus-go-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                },
                raycaster: {
                  origin: {
                    x: 0,
                    y: 0.0005,
                    z: 0
                  }
                }
              },
              'oculus-touch-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                },
                raycaster: {
                  origin: {
                    x: 0,
                    y: 0,
                    z: 0
                  }
                }
              },
              'valve-index-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                }
              },
              'vive-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                }
              },
              'vive-focus-controls': {
                cursor: {
                  downEvents: ['trackpaddown', 'triggerdown'],
                  upEvents: ['trackpadup', 'triggerup']
                }
              },
              'windows-motion-controls': {
                cursor: {
                  downEvents: ['triggerdown'],
                  upEvents: ['triggerup']
                },
                raycaster: {
                  showLine: false
                }
              }
            }
          });

          /***/
        },

        /***/"./src/components/layer.js":
        /*!*********************************!*\
          !*** ./src/components/layer.js ***!
          \*********************************/
        /***/
        function srcComponentsLayerJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE, XRRigidTransform, XRWebGLBinding */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var warn = utils.debug('components:layer:warn');
          module.exports.Component = registerComponent('layer', {
            schema: {
              type: {
                default: 'quad',
                oneOf: ['quad', 'monocubemap', 'stereocubemap']
              },
              src: {
                type: 'map'
              },
              rotateCubemap: {
                default: false
              },
              width: {
                default: 0
              },
              height: {
                default: 0
              }
            },
            init: function init() {
              var gl = this.el.sceneEl.renderer.getContext();
              this.quaternion = new THREE.Quaternion();
              this.position = new THREE.Vector3();
              this.bindMethods();
              this.needsRedraw = false;
              this.frameBuffer = gl.createFramebuffer();
              var requiredFeatures = this.el.sceneEl.getAttribute('webxr').requiredFeatures;
              requiredFeatures.push('layers');
              this.el.sceneEl.getAttribute('webxr', 'requiredFeatures', requiredFeatures);
              this.el.sceneEl.addEventListener('enter-vr', this.onEnterVR);
              this.el.sceneEl.addEventListener('exit-vr', this.onExitVR);
            },
            bindMethods: function bindMethods() {
              this.onRequestedReferenceSpace = this.onRequestedReferenceSpace.bind(this);
              this.onEnterVR = this.onEnterVR.bind(this);
              this.onExitVR = this.onExitVR.bind(this);
            },
            update: function update(oldData) {
              if (this.data.src !== oldData.src) {
                this.updateSrc();
              }
            },
            updateSrc: function updateSrc() {
              var type = this.data.type;
              this.texture = undefined;
              if (type === 'quad') {
                this.loadQuadImage();
                return;
              }
              if (type === 'monocubemap' || type === 'stereocubemap') {
                this.loadCubeMapImages();
                return;
              }
            },
            loadCubeMapImages: function loadCubeMapImages() {
              var glayer;
              var xrGLFactory = this.xrGLFactory;
              var frame = this.el.sceneEl.frame;
              var src = this.data.src;
              var type = this.data.type;
              this.visibilityChanged = false;
              if (!this.layer) {
                return;
              }
              if (type !== 'monocubemap' && type !== 'stereocubemap') {
                return;
              }
              if (!src.complete) {
                this.pendingCubeMapUpdate = true;
              } else {
                this.pendingCubeMapUpdate = false;
              }
              if (!this.loadingScreen) {
                this.loadingScreen = true;
              } else {
                this.loadingScreen = false;
              }
              if (type === 'monocubemap') {
                glayer = xrGLFactory.getSubImage(this.layer, frame);
                this.loadCubeMapImage(glayer.colorTexture, src, 0);
              } else {
                glayer = xrGLFactory.getSubImage(this.layer, frame, 'left');
                this.loadCubeMapImage(glayer.colorTexture, src, 0);
                glayer = xrGLFactory.getSubImage(this.layer, frame, 'right');
                this.loadCubeMapImage(glayer.colorTexture, src, 6);
              }
            },
            loadQuadImage: function loadQuadImage() {
              var src = this.data.src;
              var self = this;
              this.el.sceneEl.systems.material.loadTexture(src, {
                src: src
              }, function textureLoaded(texture) {
                self.el.sceneEl.renderer.initTexture(texture);
                self.texture = texture;
                if (src.tagName === 'VIDEO') {
                  setTimeout(function () {
                    self.textureIsVideo = true;
                  }, 1000);
                }
                if (self.layer) {
                  self.layer.height = self.data.height / 2 || self.texture.image.height / 1000;
                  self.layer.width = self.data.width / 2 || self.texture.image.width / 1000;
                  self.needsRedraw = true;
                }
                self.updateQuadPanel();
              });
            },
            preGenerateCubeMapTextures: function preGenerateCubeMapTextures(src, callback) {
              if (this.data.type === 'monocubemap') {
                this.generateCubeMapTextures(src, 0, callback);
              } else {
                this.generateCubeMapTextures(src, 0, callback);
                this.generateCubeMapTextures(src, 6, callback);
              }
            },
            generateCubeMapTextures: function generateCubeMapTextures(src, faceOffset, callback) {
              var data = this.data;
              var cubeFaceSize = this.cubeFaceSize;
              var textureSourceCubeFaceSize = Math.min(src.width, src.height);
              var cubefaceTextures = [];
              var imgTmp0;
              var imgTmp2;
              for (var i = 0; i < 6; i++) {
                var tempCanvas = document.createElement('CANVAS');
                tempCanvas.width = tempCanvas.height = cubeFaceSize;
                var tempCanvasContext = tempCanvas.getContext('2d');
                if (data.rotateCubemap) {
                  if (i === 2 || i === 3) {
                    tempCanvasContext.save();
                    tempCanvasContext.translate(cubeFaceSize, cubeFaceSize);
                    tempCanvasContext.rotate(Math.PI);
                  }
                }

                // Note that this call to drawImage will not only copy the bytes to the
                // canvas but also could resized the image if our cube face size is
                // smaller than the source image due to GL max texture size.
                tempCanvasContext.drawImage(src, (i + faceOffset) * textureSourceCubeFaceSize,
                // top left x coord in source
                0,
                // top left y coord in source
                textureSourceCubeFaceSize,
                // x pixel count from source
                textureSourceCubeFaceSize,
                // y pixel count from source
                0,
                // dest x offset in the canvas
                0,
                // dest y offset in the canvas
                cubeFaceSize,
                // x pixel count in dest
                cubeFaceSize // y pixel count in dest
                );

                tempCanvasContext.restore();
                if (callback) {
                  callback();
                }
                cubefaceTextures.push(tempCanvas);
              }
              if (data.rotateCubemap) {
                imgTmp0 = cubefaceTextures[0];
                imgTmp2 = cubefaceTextures[1];
                cubefaceTextures[0] = imgTmp2;
                cubefaceTextures[1] = imgTmp0;
                imgTmp0 = cubefaceTextures[4];
                imgTmp2 = cubefaceTextures[5];
                cubefaceTextures[4] = imgTmp2;
                cubefaceTextures[5] = imgTmp0;
              }
              if (callback) {
                callback();
              }
              return cubefaceTextures;
            },
            loadCubeMapImage: function loadCubeMapImage(layerColorTexture, src, faceOffset) {
              var gl = this.el.sceneEl.renderer.getContext();
              var cubefaceTextures;

              // dont flip the pixels as we load them into the texture buffer.
              // TEXTURE_CUBE_MAP expects the Y to be flipped for the faces and it already
              // is flipped in our texture image.
              gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
              gl.bindTexture(gl.TEXTURE_CUBE_MAP, layerColorTexture);
              if (!src.complete || this.loadingScreen) {
                cubefaceTextures = this.loadingScreenImages;
              } else {
                cubefaceTextures = this.generateCubeMapTextures(src, faceOffset);
              }
              var errorCode = 0;
              cubefaceTextures.forEach(function (canvas, i) {
                gl.texSubImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
                errorCode = gl.getError();
              });
              if (errorCode !== 0) {
                console.log('renderingError, WebGL Error Code: ' + errorCode);
              }
              gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
            },
            tick: function tick() {
              if (!this.el.sceneEl.xrSession) {
                return;
              }
              if (!this.layer && this.el.sceneEl.is('vr-mode')) {
                this.initLayer();
              }
              this.updateTransform();
              if (this.data.src.complete && (this.pendingCubeMapUpdate || this.loadingScreen || this.visibilityChanged)) {
                this.loadCubeMapImages();
              }
              if (!this.needsRedraw && !this.layer.needsRedraw && !this.textureIsVideo) {
                return;
              }
              if (this.data.type === 'quad') {
                this.draw();
              }
              this.needsRedraw = false;
            },
            initLayer: function initLayer() {
              var self = this;
              var type = this.data.type;
              this.el.sceneEl.xrSession.onvisibilitychange = function (evt) {
                self.visibilityChanged = evt.session.visibilityState !== 'hidden';
              };
              if (type === 'quad') {
                this.initQuadLayer();
                return;
              }
              if (type === 'monocubemap' || type === 'stereocubemap') {
                this.initCubeMapLayer();
                return;
              }
            },
            initQuadLayer: function initQuadLayer() {
              var sceneEl = this.el.sceneEl;
              var gl = sceneEl.renderer.getContext();
              var xrGLFactory = this.xrGLFactory = new XRWebGLBinding(sceneEl.xrSession, gl);
              if (!this.texture) {
                return;
              }
              this.layer = xrGLFactory.createQuadLayer({
                space: this.referenceSpace,
                viewPixelHeight: 2048,
                viewPixelWidth: 2048,
                height: this.data.height / 2 || this.texture.image.height / 1000,
                width: this.data.width / 2 || this.texture.image.width / 1000
              });
              this.initLoadingScreenImages();
              sceneEl.renderer.xr.addLayer(this.layer);
            },
            initCubeMapLayer: function initCubeMapLayer() {
              var src = this.data.src;
              var sceneEl = this.el.sceneEl;
              var gl = sceneEl.renderer.getContext();
              var glSizeLimit = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
              var cubeFaceSize = this.cubeFaceSize = Math.min(glSizeLimit, Math.min(src.width, src.height));
              var xrGLFactory = this.xrGLFactory = new XRWebGLBinding(sceneEl.xrSession, gl);
              this.layer = xrGLFactory.createCubeLayer({
                space: this.referenceSpace,
                viewPixelWidth: cubeFaceSize,
                viewPixelHeight: cubeFaceSize,
                layout: this.data.type === 'monocubemap' ? 'mono' : 'stereo',
                isStatic: false
              });
              this.initLoadingScreenImages();
              this.loadCubeMapImages();
              sceneEl.renderer.xr.addLayer(this.layer);
            },
            initLoadingScreenImages: function initLoadingScreenImages() {
              var cubeFaceSize = this.cubeFaceSize;
              var loadingScreenImages = this.loadingScreenImages = [];
              for (var i = 0; i < 6; i++) {
                var tempCanvas = document.createElement('CANVAS');
                tempCanvas.width = tempCanvas.height = cubeFaceSize;
                var tempCanvasContext = tempCanvas.getContext('2d');
                tempCanvas.width = tempCanvas.height = cubeFaceSize;
                tempCanvasContext.fillStyle = 'black';
                tempCanvasContext.fillRect(0, 0, cubeFaceSize, cubeFaceSize);
                if (i !== 2 && i !== 3) {
                  tempCanvasContext.translate(cubeFaceSize, 0);
                  tempCanvasContext.scale(-1, 1);
                  tempCanvasContext.fillStyle = 'white';
                  tempCanvasContext.font = '30px Arial';
                  tempCanvasContext.fillText('Loading', cubeFaceSize / 2, cubeFaceSize / 2);
                }
                loadingScreenImages.push(tempCanvas);
              }
            },
            destroyLayer: function destroyLayer() {
              if (!this.layer) {
                return;
              }
              this.el.sceneEl.renderer.xr.removeLayer(this.layer);
              this.layer.destroy();
              this.layer = undefined;
            },
            toggleCompositorLayer: function toggleCompositorLayer() {
              this.enableCompositorLayer(!this.layerEnabled);
            },
            enableCompositorLayer: function enableCompositorLayer(enable) {
              this.layerEnabled = enable;
              this.quadPanelEl.object3D.visible = !this.layerEnabled;
            },
            updateQuadPanel: function updateQuadPanel() {
              var quadPanelEl = this.quadPanelEl;
              if (!this.quadPanelEl) {
                quadPanelEl = this.quadPanelEl = document.createElement('a-entity');
                this.el.appendChild(quadPanelEl);
              }
              quadPanelEl.setAttribute('material', {
                shader: 'flat',
                src: this.data.src,
                transparent: true
              });
              quadPanelEl.setAttribute('geometry', {
                primitive: 'plane',
                height: this.data.height || this.texture.image.height / 1000,
                width: this.data.width || this.texture.image.height / 1000
              });
            },
            draw: function draw() {
              var sceneEl = this.el.sceneEl;
              var gl = this.el.sceneEl.renderer.getContext();
              var glayer = this.xrGLFactory.getSubImage(this.layer, sceneEl.frame);
              var texture = sceneEl.renderer.properties.get(this.texture).__webglTexture;
              var previousFrameBuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
              gl.viewport(glayer.viewport.x, glayer.viewport.y, glayer.viewport.width, glayer.viewport.height);
              gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer);
              gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, glayer.colorTexture, 0);
              blitTexture(gl, texture, glayer, this.data.src);
              gl.bindFramebuffer(gl.FRAMEBUFFER, previousFrameBuffer);
            },
            updateTransform: function updateTransform() {
              var el = this.el;
              var position = this.position;
              var quaternion = this.quaternion;
              el.object3D.updateMatrixWorld();
              position.setFromMatrixPosition(el.object3D.matrixWorld);
              quaternion.setFromRotationMatrix(el.object3D.matrixWorld);
              if (!this.layerEnabled) {
                position.set(0, 0, 100000000);
              }
              this.layer.transform = new XRRigidTransform(position, quaternion);
            },
            onEnterVR: function onEnterVR() {
              var sceneEl = this.el.sceneEl;
              var xrSession = sceneEl.xrSession;
              if (!sceneEl.hasWebXR || !XRWebGLBinding || !xrSession) {
                warn('The layer component requires WebXR and the layers API enabled');
                return;
              }
              xrSession.requestReferenceSpace('local-floor').then(this.onRequestedReferenceSpace);
              this.needsRedraw = true;
              this.layerEnabled = true;
              if (this.quadPanelEl) {
                this.quadPanelEl.object3D.visible = false;
              }
              if (this.data.src.play) {
                this.data.src.play();
              }
            },
            onExitVR: function onExitVR() {
              if (this.quadPanelEl) {
                this.quadPanelEl.object3D.visible = true;
              }
              this.destroyLayer();
            },
            onRequestedReferenceSpace: function onRequestedReferenceSpace(referenceSpace) {
              this.referenceSpace = referenceSpace;
            }
          });
          function blitTexture(gl, texture, subImage, textureEl) {
            var xrReadFramebuffer = gl.createFramebuffer();
            var x1offset = subImage.viewport.x;
            var y1offset = subImage.viewport.y;
            var x2offset = subImage.viewport.x + subImage.viewport.width;
            var y2offset = subImage.viewport.y + subImage.viewport.height;

            // Update video texture.
            if (textureEl.tagName === 'VIDEO') {
              gl.bindTexture(gl.TEXTURE_2D, texture);
              gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, textureEl.width, textureEl.height, gl.RGB, gl.UNSIGNED_BYTE, textureEl);
            }

            // Bind texture to read framebuffer.
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, xrReadFramebuffer);
            gl.framebufferTexture2D(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);

            // Blit into layer buffer.
            gl.readBuffer(gl.COLOR_ATTACHMENT0);
            gl.blitFramebuffer(0, 0, textureEl.width, textureEl.height, x1offset, y1offset, x2offset, y2offset, gl.COLOR_BUFFER_BIT, gl.NEAREST);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
            gl.deleteFramebuffer(xrReadFramebuffer);
          }

          /***/
        },

        /***/"./src/components/light.js":
        /*!*********************************!*\
          !*** ./src/components/light.js ***!
          \*********************************/
        /***/
        function srcComponentsLightJs(module, __unused_webpack_exports, __webpack_require__) {
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var utils = __webpack_require__( /*! ../utils */"./src/utils/index.js");
          var diff = utils.diff;
          var debug = __webpack_require__( /*! ../utils/debug */"./src/utils/debug.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var mathUtils = __webpack_require__( /*! ../utils/math */"./src/utils/math.js");
          var degToRad = THREE.MathUtils.degToRad;
          var warn = debug('components:light:warn');
          var CubeLoader = new THREE.CubeTextureLoader();
          var probeCache = {};

          /**
           * Light component.
           */
          module.exports.Component = registerComponent('light', {
            schema: {
              angle: {
                default: 60,
                if: {
                  type: ['spot']
                }
              },
              color: {
                type: 'color',
                if: {
                  type: ['ambient', 'directional', 'hemisphere', 'point', 'spot']
                }
              },
              envMap: {
                default: '',
                if: {
                  type: ['probe']
                }
              },
              groundColor: {
                type: 'color',
                if: {
                  type: ['hemisphere']
                }
              },
              decay: {
                default: 1,
                if: {
                  type: ['point', 'spot']
                }
              },
              distance: {
                default: 0.0,
                min: 0,
                if: {
                  type: ['point', 'spot']
                }
              },
              intensity: {
                default: 1.0,
                min: 0,
                if: {
                  type: ['ambient', 'directional', 'hemisphere', 'point', 'spot', 'probe']
                }
              },
              penumbra: {
                default: 0,
                min: 0,
                max: 1,
                if: {
                  type: ['spot']
                }
              },
              type: {
                default: 'directional',
                oneOf: ['ambient', 'directional', 'hemisphere', 'point', 'spot', 'probe'],
                schemaChange: true
              },
              target: {
                type: 'selector',
                if: {
                  type: ['spot', 'directional']
                }
              },
              // Shadows.
              castShadow: {
                default: false,
                if: {
                  type: ['point', 'spot', 'directional']
                }
              },
              shadowBias: {
                default: 0,
                if: {
                  castShadow: true
                }
              },
              shadowCameraFar: {
                default: 500,
                if: {
                  castShadow: true
                }
              },
              shadowCameraFov: {
                default: 90,
                if: {
                  castShadow: true
                }
              },
              shadowCameraNear: {
                default: 0.5,
                if: {
                  castShadow: true
                }
              },
              shadowCameraTop: {
                default: 5,
                if: {
                  castShadow: true
                }
              },
              shadowCameraRight: {
                default: 5,
                if: {
                  castShadow: true
                }
              },
              shadowCameraBottom: {
                default: -5,
                if: {
                  castShadow: true
                }
              },
              shadowCameraLeft: {
                default: -5,
                if: {
                  castShadow: true
                }
              },
              shadowCameraVisible: {
                default: false,
                if: {
                  castShadow: true
                }
              },
              shadowCameraAutomatic: {
                default: '',
                if: {
                  type: ['directional']
                }
              },
              shadowMapHeight: {
                default: 512,
                if: {
                  castShadow: true
                }
              },
              shadowMapWidth: {
                default: 512,
                if: {
                  castShadow: true
                }
              },
              shadowRadius: {
                default: 1,
                if: {
                  castShadow: true
                }
              }
            },
            /**
             * Notifies scene a light has been added to remove default lighting.
             */
            init: function init() {
              var el = this.el;
              this.light = null;
              this.defaultTarget = null;
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.system.registerLight(el);
            },
            /**
             * (Re)create or update light.
             */
            update: function update(oldData) {
              var data = this.data;
              var diffData = diff(data, oldData);
              var light = this.light;
              var rendererSystem = this.rendererSystem;
              var self = this;

              // Existing light.
              if (light && !('type' in diffData)) {
                var shadowsLoaded = false;
                // Light type has not changed. Update light.
                Object.keys(diffData).forEach(function (key) {
                  var value = data[key];
                  switch (key) {
                    case 'color':
                      {
                        light.color.set(value);
                        rendererSystem.applyColorCorrection(light.color);
                        break;
                      }
                    case 'groundColor':
                      {
                        light.groundColor.set(value);
                        rendererSystem.applyColorCorrection(light.groundColor);
                        break;
                      }
                    case 'angle':
                      {
                        light.angle = degToRad(value);
                        break;
                      }
                    case 'target':
                      {
                        // Reset target if selector is null.
                        if (value === null) {
                          if (data.type === 'spot' || data.type === 'directional') {
                            light.target = self.defaultTarget;
                          }
                        } else {
                          // Target specified, set target to entity's `object3D` when it is loaded.
                          if (value.hasLoaded) {
                            self.onSetTarget(value, light);
                          } else {
                            value.addEventListener('loaded', bind(self.onSetTarget, self, value, light));
                          }
                        }
                        break;
                      }
                    case 'envMap':
                      self.updateProbeMap(data, light);
                      break;
                    case 'castShadow':
                    case 'shadowBias':
                    case 'shadowCameraFar':
                    case 'shadowCameraFov':
                    case 'shadowCameraNear':
                    case 'shadowCameraTop':
                    case 'shadowCameraRight':
                    case 'shadowCameraBottom':
                    case 'shadowCameraLeft':
                    case 'shadowCameraVisible':
                    case 'shadowMapHeight':
                    case 'shadowMapWidth':
                    case 'shadowRadius':
                      if (!shadowsLoaded) {
                        self.updateShadow();
                        shadowsLoaded = true;
                      }
                      break;
                    case 'shadowCameraAutomatic':
                      if (data.shadowCameraAutomatic) {
                        self.shadowCameraAutomaticEls = Array.from(document.querySelectorAll(data.shadowCameraAutomatic));
                      } else {
                        self.shadowCameraAutomaticEls = [];
                      }
                      break;
                    default:
                      {
                        light[key] = value;
                      }
                  }
                });
                return;
              }

              // No light yet or light type has changed. Create and add light.
              this.setLight(this.data);
              this.updateShadow();
            },
            tick: function () {
              var bbox = new THREE.Box3();
              var normal = new THREE.Vector3();
              var cameraWorldPosition = new THREE.Vector3();
              var tempMat = new THREE.Matrix4();
              var sphere = new THREE.Sphere();
              var tempVector = new THREE.Vector3();
              return function () {
                if (!(this.data.type === 'directional' && this.light.shadow && this.light.shadow.camera instanceof THREE.OrthographicCamera && this.shadowCameraAutomaticEls.length)) return;
                var camera = this.light.shadow.camera;
                camera.getWorldDirection(normal);
                camera.getWorldPosition(cameraWorldPosition);
                tempMat.copy(camera.matrixWorld);
                tempMat.invert();
                camera.near = 1;
                camera.left = 100000;
                camera.right = -100000;
                camera.top = -100000;
                camera.bottom = 100000;
                this.shadowCameraAutomaticEls.forEach(function (el) {
                  bbox.setFromObject(el.object3D);
                  bbox.getBoundingSphere(sphere);
                  var distanceToPlane = mathUtils.distanceOfPointFromPlane(cameraWorldPosition, normal, sphere.center);
                  var pointOnCameraPlane = mathUtils.nearestPointInPlane(cameraWorldPosition, normal, sphere.center, tempVector);
                  var pointInXYPlane = pointOnCameraPlane.applyMatrix4(tempMat);
                  camera.near = Math.min(-distanceToPlane - sphere.radius - 1, camera.near);
                  camera.left = Math.min(-sphere.radius + pointInXYPlane.x, camera.left);
                  camera.right = Math.max(sphere.radius + pointInXYPlane.x, camera.right);
                  camera.top = Math.max(sphere.radius + pointInXYPlane.y, camera.top);
                  camera.bottom = Math.min(-sphere.radius + pointInXYPlane.y, camera.bottom);
                });
                camera.updateProjectionMatrix();
              };
            }(),
            setLight: function setLight(data) {
              var el = this.el;
              var newLight = this.getLight(data);
              if (newLight) {
                if (this.light) {
                  el.removeObject3D('light');
                }
                this.light = newLight;
                this.light.el = el;
                el.setObject3D('light', this.light);

                // HACK solution for issue #1624
                if (data.type === 'spot' || data.type === 'directional' || data.type === 'hemisphere') {
                  el.getObject3D('light').translateY(-1);
                }

                // set and position default lighttarget as a child to enable spotlight orientation
                if (data.type === 'spot') {
                  el.setObject3D('light-target', this.defaultTarget);
                  el.getObject3D('light-target').position.set(0, 0, -1);
                }
                if (data.shadowCameraAutomatic) {
                  this.shadowCameraAutomaticEls = Array.from(document.querySelectorAll(data.shadowCameraAutomatic));
                } else {
                  this.shadowCameraAutomaticEls = [];
                }
              }
            },
            /**
             * Updates shadow-related properties on the current light.
             */
            updateShadow: function updateShadow() {
              var el = this.el;
              var data = this.data;
              var light = this.light;
              light.castShadow = data.castShadow;

              // Shadow camera helper.
              var cameraHelper = el.getObject3D('cameraHelper');
              if (data.shadowCameraVisible && !cameraHelper) {
                el.setObject3D('cameraHelper', new THREE.CameraHelper(light.shadow.camera));
              } else if (!data.shadowCameraVisible && cameraHelper) {
                el.removeObject3D('cameraHelper');
              }
              if (!data.castShadow) {
                return light;
              }

              // Shadow appearance.
              light.shadow.bias = data.shadowBias;
              light.shadow.radius = data.shadowRadius;
              light.shadow.mapSize.height = data.shadowMapHeight;
              light.shadow.mapSize.width = data.shadowMapWidth;

              // Shadow camera.
              light.shadow.camera.near = data.shadowCameraNear;
              light.shadow.camera.far = data.shadowCameraFar;
              if (light.shadow.camera instanceof THREE.OrthographicCamera) {
                light.shadow.camera.top = data.shadowCameraTop;
                light.shadow.camera.right = data.shadowCameraRight;
                light.shadow.camera.bottom = data.shadowCameraBottom;
                light.shadow.camera.left = data.shadowCameraLeft;
              } else {
                light.shadow.camera.fov = data.shadowCameraFov;
              }
              light.shadow.camera.updateProjectionMatrix();
              if (cameraHelper) {
                cameraHelper.update();
              }
            },
            /**
             * Creates a new three.js light object given data object defining the light.
             *
             * @param {object} data
             */
            getLight: function getLight(data) {
              var angle = data.angle;
              var color = new THREE.Color(data.color);
              this.rendererSystem.applyColorCorrection(color);
              color = color.getHex();
              var decay = data.decay;
              var distance = data.distance;
              var groundColor = new THREE.Color(data.groundColor);
              this.rendererSystem.applyColorCorrection(groundColor);
              groundColor = groundColor.getHex();
              var intensity = data.intensity;
              var type = data.type;
              var target = data.target;
              var light = null;
              switch (type.toLowerCase()) {
                case 'ambient':
                  {
                    return new THREE.AmbientLight(color, intensity);
                  }
                case 'directional':
                  {
                    light = new THREE.DirectionalLight(color, intensity);
                    this.defaultTarget = light.target;
                    if (target) {
                      if (target.hasLoaded) {
                        this.onSetTarget(target, light);
                      } else {
                        target.addEventListener('loaded', bind(this.onSetTarget, this, target, light));
                      }
                    }
                    return light;
                  }
                case 'hemisphere':
                  {
                    return new THREE.HemisphereLight(color, groundColor, intensity);
                  }
                case 'point':
                  {
                    return new THREE.PointLight(color, intensity, distance, decay);
                  }
                case 'spot':
                  {
                    light = new THREE.SpotLight(color, intensity, distance, degToRad(angle), data.penumbra, decay);
                    this.defaultTarget = light.target;
                    if (target) {
                      if (target.hasLoaded) {
                        this.onSetTarget(target, light);
                      } else {
                        target.addEventListener('loaded', bind(this.onSetTarget, this, target, light));
                      }
                    }
                    return light;
                  }
                case 'probe':
                  {
                    light = new THREE.LightProbe();
                    this.updateProbeMap(data, light);
                    return light;
                  }
                default:
                  {
                    warn('%s is not a valid light type. ' + 'Choose from ambient, directional, hemisphere, point, spot.', type);
                  }
              }
            },
            /**
             * Generate the spherical harmonics for the LightProbe from a cube map
             */
            updateProbeMap: function updateProbeMap(data, light) {
              if (!data.envMap) {
                // reset parameters if no map
                light.copy(new THREE.LightProbe());
              }
              if (probeCache[data.envMap] instanceof window.Promise) {
                probeCache[data.envMap].then(function (tempLightProbe) {
                  light.copy(tempLightProbe);
                });
              }
              if (probeCache[data.envMap] instanceof THREE.LightProbe) {
                light.copy(probeCache[data.envMap]);
              }
              probeCache[data.envMap] = new window.Promise(function (resolve) {
                utils.srcLoader.validateCubemapSrc(data.envMap, function loadEnvMap(urls) {
                  CubeLoader.load(urls, function (cube) {
                    var tempLightProbe = THREE.LightProbeGenerator.fromCubeTexture(cube);
                    probeCache[data.envMap] = tempLightProbe;
                    light.copy(tempLightProbe);
                  });
                });
              });
            },
            onSetTarget: function onSetTarget(targetEl, light) {
              light.target = targetEl.object3D;
            },
            /**
             * Remove light on remove (callback).
             */
            remove: function remove() {
              var el = this.el;
              el.removeObject3D('light');
              if (el.getObject3D('cameraHelper')) {
                el.removeObject3D('cameraHelper');
              }
            }
          });

          /***/
        },

        /***/"./src/components/line.js":
        /*!********************************!*\
          !*** ./src/components/line.js ***!
          \********************************/
        /***/
        function srcComponentsLineJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          module.exports.Component = registerComponent('line', {
            schema: {
              start: {
                type: 'vec3',
                default: {
                  x: 0,
                  y: 0,
                  z: 0
                }
              },
              end: {
                type: 'vec3',
                default: {
                  x: 0,
                  y: 0,
                  z: 0
                }
              },
              color: {
                type: 'color',
                default: '#74BEC1'
              },
              opacity: {
                type: 'number',
                default: 1
              },
              visible: {
                default: true
              }
            },
            multiple: true,
            init: function init() {
              var data = this.data;
              var geometry;
              var material;
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              material = this.material = new THREE.LineBasicMaterial({
                color: data.color,
                opacity: data.opacity,
                transparent: data.opacity < 1,
                visible: data.visible
              });
              geometry = this.geometry = new THREE.BufferGeometry();
              geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(2 * 3), 3));
              this.rendererSystem.applyColorCorrection(material.color);
              this.line = new THREE.Line(geometry, material);
              this.el.setObject3D(this.attrName, this.line);
            },
            update: function update(oldData) {
              var data = this.data;
              var geometry = this.geometry;
              var geoNeedsUpdate = false;
              var material = this.material;
              var positionArray = geometry.attributes.position.array;

              // Update geometry.
              if (!isEqualVec3(data.start, oldData.start)) {
                positionArray[0] = data.start.x;
                positionArray[1] = data.start.y;
                positionArray[2] = data.start.z;
                geoNeedsUpdate = true;
              }
              if (!isEqualVec3(data.end, oldData.end)) {
                positionArray[3] = data.end.x;
                positionArray[4] = data.end.y;
                positionArray[5] = data.end.z;
                geoNeedsUpdate = true;
              }
              if (geoNeedsUpdate) {
                geometry.attributes.position.needsUpdate = true;
                geometry.computeBoundingSphere();
              }
              material.color.setStyle(data.color);
              this.rendererSystem.applyColorCorrection(material.color);
              material.opacity = data.opacity;
              material.transparent = data.opacity < 1;
              material.visible = data.visible;
            },
            remove: function remove() {
              this.el.removeObject3D(this.attrName, this.line);
            }
          });
          function isEqualVec3(a, b) {
            if (!a || !b) {
              return false;
            }
            return a.x === b.x && a.y === b.y && a.z === b.z;
          }

          /***/
        },

        /***/"./src/components/link.js":
        /*!********************************!*\
          !*** ./src/components/link.js ***!
          \********************************/
        /***/
        function srcComponentsLinkJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");

          /**
           * Link component. Connect experiences and traverse between them in VR
           *
           * @member {object} hiddenEls - Store the hidden elements during peek mode.
           */
          module.exports.Component = registerComponent('link', {
            schema: {
              backgroundColor: {
                default: 'red',
                type: 'color'
              },
              borderColor: {
                default: 'white',
                type: 'color'
              },
              highlighted: {
                default: false
              },
              highlightedColor: {
                default: '#24CAFF',
                type: 'color'
              },
              href: {
                default: ''
              },
              image: {
                type: 'asset'
              },
              on: {
                default: 'click'
              },
              peekMode: {
                default: false
              },
              title: {
                default: ''
              },
              titleColor: {
                default: 'white',
                type: 'color'
              },
              visualAspectEnabled: {
                default: false
              }
            },
            init: function init() {
              this.navigate = this.navigate.bind(this);
              this.previousQuaternion = undefined;
              this.quaternionClone = new THREE.Quaternion();
              // Store hidden elements during peek mode so we can show them again later.
              this.hiddenEls = [];
            },
            update: function update(oldData) {
              var data = this.data;
              var el = this.el;
              var backgroundColor;
              var strokeColor;
              if (!data.visualAspectEnabled) {
                return;
              }
              this.initVisualAspect();
              backgroundColor = data.highlighted ? data.highlightedColor : data.backgroundColor;
              strokeColor = data.highlighted ? data.highlightedColor : data.borderColor;
              el.setAttribute('material', 'backgroundColor', backgroundColor);
              el.setAttribute('material', 'strokeColor', strokeColor);
              if (data.on !== oldData.on) {
                this.updateEventListener();
              }
              if (oldData.peekMode !== undefined && data.peekMode !== oldData.peekMode) {
                this.updatePeekMode();
              }
              if (!data.image || oldData.image === data.image) {
                return;
              }
              el.setAttribute('material', 'pano', typeof data.image === 'string' ? data.image : data.image.src);
            },
            /*
             * Toggle all elements and full 360 preview of the linked page.
             */
            updatePeekMode: function updatePeekMode() {
              var el = this.el;
              var sphereEl = this.sphereEl;
              if (this.data.peekMode) {
                this.hideAll();
                el.getObject3D('mesh').visible = false;
                sphereEl.setAttribute('visible', true);
              } else {
                this.showAll();
                el.getObject3D('mesh').visible = true;
                sphereEl.setAttribute('visible', false);
              }
            },
            play: function play() {
              this.updateEventListener();
            },
            pause: function pause() {
              this.removeEventListener();
            },
            updateEventListener: function updateEventListener() {
              var el = this.el;
              if (!el.isPlaying) {
                return;
              }
              this.removeEventListener();
              el.addEventListener(this.data.on, this.navigate);
            },
            removeEventListener: function removeEventListener() {
              var on = this.data.on;
              if (!on) {
                return;
              }
              this.el.removeEventListener(on, this.navigate);
            },
            initVisualAspect: function initVisualAspect() {
              var el = this.el;
              var semiSphereEl;
              var sphereEl;
              var textEl;
              if (!this.data.visualAspectEnabled || this.visualAspectInitialized) {
                return;
              }
              textEl = this.textEl = this.textEl || document.createElement('a-entity');
              sphereEl = this.sphereEl = this.sphereEl || document.createElement('a-entity');
              semiSphereEl = this.semiSphereEl = this.semiSphereEl || document.createElement('a-entity');

              // Set portal.
              el.setAttribute('geometry', {
                primitive: 'circle',
                radius: 1.0,
                segments: 64
              });
              el.setAttribute('material', {
                shader: 'portal',
                pano: this.data.image,
                side: 'double'
              });

              // Set text that displays the link title and URL.
              textEl.setAttribute('text', {
                color: this.data.titleColor,
                align: 'center',
                font: 'kelsonsans',
                value: this.data.title || this.data.href,
                width: 4
              });
              textEl.setAttribute('position', '0 1.5 0');
              el.appendChild(textEl);

              // Set sphere rendered when camera is close to portal to allow user to peek inside.
              semiSphereEl.setAttribute('geometry', {
                primitive: 'sphere',
                radius: 1.0,
                phiStart: 0,
                segmentsWidth: 64,
                segmentsHeight: 64,
                phiLength: 180,
                thetaStart: 0,
                thetaLength: 360
              });
              semiSphereEl.setAttribute('material', {
                shader: 'portal',
                borderEnabled: 0.0,
                pano: this.data.image,
                side: 'back'
              });
              semiSphereEl.setAttribute('rotation', '0 180 0');
              semiSphereEl.setAttribute('position', '0 0 0');
              semiSphereEl.setAttribute('visible', false);
              el.appendChild(semiSphereEl);

              // Set sphere rendered when camera is close to portal to allow user to peek inside.
              sphereEl.setAttribute('geometry', {
                primitive: 'sphere',
                radius: 10,
                segmentsWidth: 64,
                segmentsHeight: 64
              });
              sphereEl.setAttribute('material', {
                shader: 'portal',
                borderEnabled: 0.0,
                pano: this.data.image,
                side: 'back'
              });
              sphereEl.setAttribute('visible', false);
              el.appendChild(sphereEl);
              this.visualAspectInitialized = true;
            },
            navigate: function navigate() {
              window.location = this.data.href;
            },
            /**
             * 1. Swap plane that represents portal with sphere with a hole when the camera is close
             * so user can peek inside portal. Sphere is rendered on oposite side of portal
             * from where user enters.
             * 2. Place the url/title above or inside portal depending on distance to camera.
             * 3. Face portal to camera when far away from user.
             */
            tick: function () {
              var cameraWorldPosition = new THREE.Vector3();
              var elWorldPosition = new THREE.Vector3();
              var quaternion = new THREE.Quaternion();
              var scale = new THREE.Vector3();
              return function () {
                var el = this.el;
                var object3D = el.object3D;
                var camera = el.sceneEl.camera;
                var cameraPortalOrientation;
                var distance;
                var textEl = this.textEl;
                if (!this.data.visualAspectEnabled) {
                  return;
                }

                // Update matrices
                object3D.updateMatrixWorld();
                camera.parent.updateMatrixWorld();
                camera.updateMatrixWorld();
                object3D.matrix.decompose(elWorldPosition, quaternion, scale);
                elWorldPosition.setFromMatrixPosition(object3D.matrixWorld);
                cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld);
                distance = elWorldPosition.distanceTo(cameraWorldPosition);
                if (distance > 20) {
                  // Store original orientation to be restored when the portal stops facing the camera.
                  if (!this.previousQuaternion) {
                    this.quaternionClone.copy(quaternion);
                    this.previousQuaternion = this.quaternionClone;
                  }
                  // If the portal is far away from the user, face portal to camera.
                  object3D.lookAt(cameraWorldPosition);
                } else {
                  // When portal is close to the user/camera.
                  cameraPortalOrientation = this.calculateCameraPortalOrientation();
                  // If user gets very close to portal, replace with holed sphere they can peek in.
                  if (distance < 0.5) {
                    // Configure text size and sphere orientation depending side user approaches portal.
                    if (this.semiSphereEl.getAttribute('visible') === true) {
                      return;
                    }
                    textEl.setAttribute('text', 'width', 1.5);
                    if (cameraPortalOrientation <= 0.0) {
                      textEl.setAttribute('position', '0 0 0.75');
                      textEl.setAttribute('rotation', '0 180 0');
                      this.semiSphereEl.setAttribute('rotation', '0 0 0');
                    } else {
                      textEl.setAttribute('position', '0 0 -0.75');
                      textEl.setAttribute('rotation', '0 0 0');
                      this.semiSphereEl.setAttribute('rotation', '0 180 0');
                    }
                    el.getObject3D('mesh').visible = false;
                    this.semiSphereEl.setAttribute('visible', true);
                    this.peekCameraPortalOrientation = cameraPortalOrientation;
                  } else {
                    // Calculate wich side the camera is approaching the camera (back / front).
                    // Adjust text orientation based on camera position.
                    if (cameraPortalOrientation <= 0.0) {
                      textEl.setAttribute('rotation', '0 180 0');
                    } else {
                      textEl.setAttribute('rotation', '0 0 0');
                    }
                    textEl.setAttribute('text', 'width', 5);
                    textEl.setAttribute('position', '0 1.5 0');
                    el.getObject3D('mesh').visible = true;
                    this.semiSphereEl.setAttribute('visible', false);
                    this.peekCameraPortalOrientation = undefined;
                  }
                  if (this.previousQuaternion) {
                    object3D.quaternion.copy(this.previousQuaternion);
                    this.previousQuaternion = undefined;
                  }
                }
              };
            }(),
            hideAll: function hideAll() {
              var el = this.el;
              var hiddenEls = this.hiddenEls;
              var self = this;
              if (hiddenEls.length > 0) {
                return;
              }
              el.sceneEl.object3D.traverse(function (object) {
                if (object && object.el && object.el.hasAttribute('link-controls')) {
                  return;
                }
                if (!object.el || object === el.sceneEl.object3D || object.el === el || object.el === self.sphereEl || object.el === el.sceneEl.cameraEl || object.el.getAttribute('visible') === false || object.el === self.textEl || object.el === self.semiSphereEl) {
                  return;
                }
                object.el.setAttribute('visible', false);
                hiddenEls.push(object.el);
              });
            },
            showAll: function showAll() {
              this.hiddenEls.forEach(function (el) {
                el.setAttribute('visible', true);
              });
              this.hiddenEls = [];
            },
            /**
             * Calculate whether the camera faces the front or back face of the portal.
             * @returns {number} > 0 if camera faces front of portal, < 0 if it faces back of portal.
             */
            calculateCameraPortalOrientation: function () {
              var mat4 = new THREE.Matrix4();
              var cameraPosition = new THREE.Vector3();
              var portalNormal = new THREE.Vector3(0, 0, 1);
              var portalPosition = new THREE.Vector3(0, 0, 0);
              return function () {
                var el = this.el;
                var camera = el.sceneEl.camera;

                // Reset tmp variables.
                cameraPosition.set(0, 0, 0);
                portalNormal.set(0, 0, 1);
                portalPosition.set(0, 0, 0);

                // Apply portal orientation to the normal.
                el.object3D.matrixWorld.extractRotation(mat4);
                portalNormal.applyMatrix4(mat4);

                // Calculate portal world position.
                el.object3D.updateMatrixWorld();
                el.object3D.localToWorld(portalPosition);

                // Calculate camera world position.
                camera.parent.parent.updateMatrixWorld();
                camera.parent.updateMatrixWorld();
                camera.updateMatrixWorld();
                camera.localToWorld(cameraPosition);

                // Calculate vector from portal to camera.
                // (portal) -------> (camera)
                cameraPosition.sub(portalPosition).normalize();
                portalNormal.normalize();

                // Side where camera approaches portal is given by sign of dot product of portal normal
                // and portal to camera vectors.
                return Math.sign(portalNormal.dot(cameraPosition));
              };
            }(),
            remove: function remove() {
              this.removeEventListener();
            }
          });

          /* eslint-disable */
          registerShader('portal', {
            schema: {
              borderEnabled: {
                default: 1.0,
                type: 'int',
                is: 'uniform'
              },
              backgroundColor: {
                default: 'red',
                type: 'color',
                is: 'uniform'
              },
              pano: {
                type: 'map',
                is: 'uniform'
              },
              strokeColor: {
                default: 'white',
                type: 'color',
                is: 'uniform'
              }
            },
            vertexShader: ['vec3 portalPosition;', 'varying vec3 vWorldPosition;', 'varying float vDistanceToCenter;', 'varying float vDistance;', 'void main() {', 'vDistanceToCenter = clamp(length(position - vec3(0.0, 0.0, 0.0)), 0.0, 1.0);', 'portalPosition = (modelMatrix * vec4(0.0, 0.0, 0.0, 1.0)).xyz;', 'vDistance = length(portalPosition - cameraPosition);', 'vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;', 'gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '}'].join('\n'),
            fragmentShader: ['#define RECIPROCAL_PI2 0.15915494', 'uniform sampler2D pano;', 'uniform vec3 strokeColor;', 'uniform vec3 backgroundColor;', 'uniform float borderEnabled;', 'varying float vDistanceToCenter;', 'varying float vDistance;', 'varying vec3 vWorldPosition;', 'void main() {', 'vec3 direction = normalize(vWorldPosition - cameraPosition);', 'vec2 sampleUV;', 'float borderThickness = clamp(exp(-vDistance / 50.0), 0.6, 0.95);', 'sampleUV.y = clamp(direction.y * 0.5  + 0.5, 0.0, 1.0);', 'sampleUV.x = atan(direction.z, -direction.x) * -RECIPROCAL_PI2 + 0.5;', 'if (vDistanceToCenter > borderThickness && borderEnabled == 1.0) {', 'gl_FragColor = vec4(strokeColor, 1.0);', '} else {', 'gl_FragColor = mix(texture2D(pano, sampleUV), vec4(backgroundColor, 1.0), clamp(pow((vDistance / 15.0), 2.0), 0.0, 1.0));', '}', '}'].join('\n')
          });
          /* eslint-enable */

          /***/
        },

        /***/"./src/components/look-controls.js":
        /*!*****************************************!*\
          !*** ./src/components/look-controls.js ***!
          \*****************************************/
        /***/
        function srcComponentsLookControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global DeviceOrientationEvent  */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var bind = utils.bind;

          // To avoid recalculation at every mouse movement tick
          var PI_2 = Math.PI / 2;

          /**
           * look-controls. Update entity pose, factoring mouse, touch, and WebVR API data.
           */
          module.exports.Component = registerComponent('look-controls', {
            dependencies: ['position', 'rotation'],
            schema: {
              enabled: {
                default: true
              },
              magicWindowTrackingEnabled: {
                default: true
              },
              pointerLockEnabled: {
                default: false
              },
              reverseMouseDrag: {
                default: false
              },
              reverseTouchDrag: {
                default: false
              },
              touchEnabled: {
                default: true
              },
              mouseEnabled: {
                default: true
              }
            },
            init: function init() {
              this.deltaYaw = 0;
              this.previousHMDPosition = new THREE.Vector3();
              this.hmdQuaternion = new THREE.Quaternion();
              this.magicWindowAbsoluteEuler = new THREE.Euler();
              this.magicWindowDeltaEuler = new THREE.Euler();
              this.position = new THREE.Vector3();
              this.magicWindowObject = new THREE.Object3D();
              this.rotation = {};
              this.deltaRotation = {};
              this.savedPose = null;
              this.pointerLocked = false;
              this.setupMouseControls();
              this.bindMethods();
              this.previousMouseEvent = {};
              this.setupMagicWindowControls();

              // To save / restore camera pose
              this.savedPose = {
                position: new THREE.Vector3(),
                rotation: new THREE.Euler()
              };

              // Call enter VR handler if the scene has entered VR before the event listeners attached.
              if (this.el.sceneEl.is('vr-mode') || this.el.sceneEl.is('ar-mode')) {
                this.onEnterVR();
              }
            },
            setupMagicWindowControls: function setupMagicWindowControls() {
              var magicWindowControls;
              var data = this.data;

              // Only on mobile devices and only enabled if DeviceOrientation permission has been granted.
              if (utils.device.isMobile() || utils.device.isMobileDeviceRequestingDesktopSite()) {
                magicWindowControls = this.magicWindowControls = new THREE.DeviceOrientationControls(this.magicWindowObject);
                if (typeof DeviceOrientationEvent !== 'undefined' && DeviceOrientationEvent.requestPermission) {
                  magicWindowControls.enabled = false;
                  if (this.el.sceneEl.components['device-orientation-permission-ui'].permissionGranted) {
                    magicWindowControls.enabled = data.magicWindowTrackingEnabled;
                  } else {
                    this.el.sceneEl.addEventListener('deviceorientationpermissiongranted', function () {
                      magicWindowControls.enabled = data.magicWindowTrackingEnabled;
                    });
                  }
                }
              }
            },
            update: function update(oldData) {
              var data = this.data;

              // Disable grab cursor classes if no longer enabled.
              if (data.enabled !== oldData.enabled) {
                this.updateGrabCursor(data.enabled);
              }

              // Reset magic window eulers if tracking is disabled.
              if (oldData && !data.magicWindowTrackingEnabled && oldData.magicWindowTrackingEnabled) {
                this.magicWindowAbsoluteEuler.set(0, 0, 0);
                this.magicWindowDeltaEuler.set(0, 0, 0);
              }

              // Pass on magic window tracking setting to magicWindowControls.
              if (this.magicWindowControls) {
                this.magicWindowControls.enabled = data.magicWindowTrackingEnabled;
              }
              if (oldData && !data.pointerLockEnabled !== oldData.pointerLockEnabled) {
                this.removeEventListeners();
                this.addEventListeners();
                if (this.pointerLocked) {
                  this.exitPointerLock();
                }
              }
            },
            tick: function tick(t) {
              var data = this.data;
              if (!data.enabled) {
                return;
              }
              this.updateOrientation();
            },
            play: function play() {
              this.addEventListeners();
            },
            pause: function pause() {
              this.removeEventListeners();
              if (this.pointerLocked) {
                this.exitPointerLock();
              }
            },
            remove: function remove() {
              this.removeEventListeners();
              if (this.pointerLocked) {
                this.exitPointerLock();
              }
            },
            bindMethods: function bindMethods() {
              this.onMouseDown = bind(this.onMouseDown, this);
              this.onMouseMove = bind(this.onMouseMove, this);
              this.onMouseUp = bind(this.onMouseUp, this);
              this.onTouchStart = bind(this.onTouchStart, this);
              this.onTouchMove = bind(this.onTouchMove, this);
              this.onTouchEnd = bind(this.onTouchEnd, this);
              this.onEnterVR = bind(this.onEnterVR, this);
              this.onExitVR = bind(this.onExitVR, this);
              this.onPointerLockChange = bind(this.onPointerLockChange, this);
              this.onPointerLockError = bind(this.onPointerLockError, this);
            },
            /**
             * Set up states and Object3Ds needed to store rotation data.
             */
            setupMouseControls: function setupMouseControls() {
              this.mouseDown = false;
              this.pitchObject = new THREE.Object3D();
              this.yawObject = new THREE.Object3D();
              this.yawObject.position.y = 10;
              this.yawObject.add(this.pitchObject);
            },
            /**
             * Add mouse and touch event listeners to canvas.
             */
            addEventListeners: function addEventListeners() {
              var sceneEl = this.el.sceneEl;
              var canvasEl = sceneEl.canvas;

              // Wait for canvas to load.
              if (!canvasEl) {
                sceneEl.addEventListener('render-target-loaded', bind(this.addEventListeners, this));
                return;
              }

              // Mouse events.
              canvasEl.addEventListener('mousedown', this.onMouseDown, false);
              window.addEventListener('mousemove', this.onMouseMove, false);
              window.addEventListener('mouseup', this.onMouseUp, false);

              // Touch events.
              canvasEl.addEventListener('touchstart', this.onTouchStart);
              window.addEventListener('touchmove', this.onTouchMove);
              window.addEventListener('touchend', this.onTouchEnd);

              // sceneEl events.
              sceneEl.addEventListener('enter-vr', this.onEnterVR);
              sceneEl.addEventListener('exit-vr', this.onExitVR);

              // Pointer Lock events.
              if (this.data.pointerLockEnabled) {
                document.addEventListener('pointerlockchange', this.onPointerLockChange, false);
                document.addEventListener('mozpointerlockchange', this.onPointerLockChange, false);
                document.addEventListener('pointerlockerror', this.onPointerLockError, false);
              }
            },
            /**
             * Remove mouse and touch event listeners from canvas.
             */
            removeEventListeners: function removeEventListeners() {
              var sceneEl = this.el.sceneEl;
              var canvasEl = sceneEl && sceneEl.canvas;
              if (!canvasEl) {
                return;
              }

              // Mouse events.
              canvasEl.removeEventListener('mousedown', this.onMouseDown);
              window.removeEventListener('mousemove', this.onMouseMove);
              window.removeEventListener('mouseup', this.onMouseUp);

              // Touch events.
              canvasEl.removeEventListener('touchstart', this.onTouchStart);
              window.removeEventListener('touchmove', this.onTouchMove);
              window.removeEventListener('touchend', this.onTouchEnd);

              // sceneEl events.
              sceneEl.removeEventListener('enter-vr', this.onEnterVR);
              sceneEl.removeEventListener('exit-vr', this.onExitVR);

              // Pointer Lock events.
              document.removeEventListener('pointerlockchange', this.onPointerLockChange, false);
              document.removeEventListener('mozpointerlockchange', this.onPointerLockChange, false);
              document.removeEventListener('pointerlockerror', this.onPointerLockError, false);
            },
            /**
             * Update orientation for mobile, mouse drag, and headset.
             * Mouse-drag only enabled if HMD is not active.
             */
            updateOrientation: function updateOrientation() {
              var object3D = this.el.object3D;
              var pitchObject = this.pitchObject;
              var yawObject = this.yawObject;
              var sceneEl = this.el.sceneEl;

              // In VR or AR mode, THREE is in charge of updating the camera pose.
              if ((sceneEl.is('vr-mode') || sceneEl.is('ar-mode')) && sceneEl.checkHeadsetConnected()) {
                // With WebXR THREE applies headset pose to the object3D internally.
                return;
              }
              this.updateMagicWindowOrientation();

              // On mobile, do camera rotation with touch events and sensors.
              object3D.rotation.x = this.magicWindowDeltaEuler.x + pitchObject.rotation.x;
              object3D.rotation.y = this.magicWindowDeltaEuler.y + yawObject.rotation.y;
              object3D.rotation.z = this.magicWindowDeltaEuler.z;
            },
            updateMagicWindowOrientation: function updateMagicWindowOrientation() {
              var magicWindowAbsoluteEuler = this.magicWindowAbsoluteEuler;
              var magicWindowDeltaEuler = this.magicWindowDeltaEuler;
              // Calculate magic window HMD quaternion.
              if (this.magicWindowControls && this.magicWindowControls.enabled) {
                this.magicWindowControls.update();
                magicWindowAbsoluteEuler.setFromQuaternion(this.magicWindowObject.quaternion, 'YXZ');
                if (!this.previousMagicWindowYaw && magicWindowAbsoluteEuler.y !== 0) {
                  this.previousMagicWindowYaw = magicWindowAbsoluteEuler.y;
                }
                if (this.previousMagicWindowYaw) {
                  magicWindowDeltaEuler.x = magicWindowAbsoluteEuler.x;
                  magicWindowDeltaEuler.y += magicWindowAbsoluteEuler.y - this.previousMagicWindowYaw;
                  magicWindowDeltaEuler.z = magicWindowAbsoluteEuler.z;
                  this.previousMagicWindowYaw = magicWindowAbsoluteEuler.y;
                }
              }
            },
            /**
             * Translate mouse drag into rotation.
             *
             * Dragging up and down rotates the camera around the X-axis (yaw).
             * Dragging left and right rotates the camera around the Y-axis (pitch).
             */
            onMouseMove: function onMouseMove(evt) {
              var direction;
              var movementX;
              var movementY;
              var pitchObject = this.pitchObject;
              var previousMouseEvent = this.previousMouseEvent;
              var yawObject = this.yawObject;

              // Not dragging or not enabled.
              if (!this.data.enabled || !this.mouseDown && !this.pointerLocked) {
                return;
              }

              // Calculate delta.
              if (this.pointerLocked) {
                movementX = evt.movementX || evt.mozMovementX || 0;
                movementY = evt.movementY || evt.mozMovementY || 0;
              } else {
                movementX = evt.screenX - previousMouseEvent.screenX;
                movementY = evt.screenY - previousMouseEvent.screenY;
              }
              this.previousMouseEvent.screenX = evt.screenX;
              this.previousMouseEvent.screenY = evt.screenY;

              // Calculate rotation.
              direction = this.data.reverseMouseDrag ? 1 : -1;
              yawObject.rotation.y += movementX * 0.002 * direction;
              pitchObject.rotation.x += movementY * 0.002 * direction;
              pitchObject.rotation.x = Math.max(-PI_2, Math.min(PI_2, pitchObject.rotation.x));
            },
            /**
             * Register mouse down to detect mouse drag.
             */
            onMouseDown: function onMouseDown(evt) {
              var sceneEl = this.el.sceneEl;
              if (!this.data.enabled || !this.data.mouseEnabled || (sceneEl.is('vr-mode') || sceneEl.is('ar-mode')) && sceneEl.checkHeadsetConnected()) {
                return;
              }
              // Handle only primary button.
              if (evt.button !== 0) {
                return;
              }
              var canvasEl = sceneEl && sceneEl.canvas;
              this.mouseDown = true;
              this.previousMouseEvent.screenX = evt.screenX;
              this.previousMouseEvent.screenY = evt.screenY;
              this.showGrabbingCursor();
              if (this.data.pointerLockEnabled && !this.pointerLocked) {
                if (canvasEl.requestPointerLock) {
                  canvasEl.requestPointerLock();
                } else if (canvasEl.mozRequestPointerLock) {
                  canvasEl.mozRequestPointerLock();
                }
              }
            },
            /**
             * Shows grabbing cursor on scene
             */
            showGrabbingCursor: function showGrabbingCursor() {
              this.el.sceneEl.canvas.style.cursor = 'grabbing';
            },
            /**
             * Hides grabbing cursor on scene
             */
            hideGrabbingCursor: function hideGrabbingCursor() {
              this.el.sceneEl.canvas.style.cursor = '';
            },
            /**
             * Register mouse up to detect release of mouse drag.
             */
            onMouseUp: function onMouseUp() {
              this.mouseDown = false;
              this.hideGrabbingCursor();
            },
            /**
             * Register touch down to detect touch drag.
             */
            onTouchStart: function onTouchStart(evt) {
              if (evt.touches.length !== 1 || !this.data.touchEnabled || this.el.sceneEl.is('vr-mode') || this.el.sceneEl.is('ar-mode')) {
                return;
              }
              this.touchStart = {
                x: evt.touches[0].pageX,
                y: evt.touches[0].pageY
              };
              this.touchStarted = true;
            },
            /**
             * Translate touch move to Y-axis rotation.
             */
            onTouchMove: function onTouchMove(evt) {
              var direction;
              var canvas = this.el.sceneEl.canvas;
              var deltaY;
              var yawObject = this.yawObject;
              if (!this.touchStarted || !this.data.touchEnabled) {
                return;
              }
              deltaY = 2 * Math.PI * (evt.touches[0].pageX - this.touchStart.x) / canvas.clientWidth;
              direction = this.data.reverseTouchDrag ? 1 : -1;
              // Limit touch orientaion to to yaw (y axis).
              yawObject.rotation.y -= deltaY * 0.5 * direction;
              this.touchStart = {
                x: evt.touches[0].pageX,
                y: evt.touches[0].pageY
              };
            },
            /**
             * Register touch end to detect release of touch drag.
             */
            onTouchEnd: function onTouchEnd() {
              this.touchStarted = false;
            },
            /**
             * Save pose.
             */
            onEnterVR: function onEnterVR() {
              var sceneEl = this.el.sceneEl;
              if (!sceneEl.checkHeadsetConnected()) {
                return;
              }
              this.saveCameraPose();
              this.el.object3D.position.set(0, 0, 0);
              this.el.object3D.rotation.set(0, 0, 0);
              if (sceneEl.hasWebXR) {
                this.el.object3D.matrixAutoUpdate = false;
                this.el.object3D.updateMatrix();
              }
            },
            /**
             * Restore the pose.
             */
            onExitVR: function onExitVR() {
              if (!this.el.sceneEl.checkHeadsetConnected()) {
                return;
              }
              this.restoreCameraPose();
              this.previousHMDPosition.set(0, 0, 0);
              this.el.object3D.matrixAutoUpdate = true;
            },
            /**
             * Update Pointer Lock state.
             */
            onPointerLockChange: function onPointerLockChange() {
              this.pointerLocked = !!(document.pointerLockElement || document.mozPointerLockElement);
            },
            /**
             * Recover from Pointer Lock error.
             */
            onPointerLockError: function onPointerLockError() {
              this.pointerLocked = false;
            },
            // Exits pointer-locked mode.
            exitPointerLock: function exitPointerLock() {
              document.exitPointerLock();
              this.pointerLocked = false;
            },
            /**
             * Toggle the feature of showing/hiding the grab cursor.
             */
            updateGrabCursor: function updateGrabCursor(enabled) {
              var sceneEl = this.el.sceneEl;
              function enableGrabCursor() {
                sceneEl.canvas.classList.add('a-grab-cursor');
              }
              function disableGrabCursor() {
                sceneEl.canvas.classList.remove('a-grab-cursor');
              }
              if (!sceneEl.canvas) {
                if (enabled) {
                  sceneEl.addEventListener('render-target-loaded', enableGrabCursor);
                } else {
                  sceneEl.addEventListener('render-target-loaded', disableGrabCursor);
                }
                return;
              }
              if (enabled) {
                enableGrabCursor();
                return;
              }
              disableGrabCursor();
            },
            /**
             * Save camera pose before entering VR to restore later if exiting.
             */
            saveCameraPose: function saveCameraPose() {
              var el = this.el;
              this.savedPose.position.copy(el.object3D.position);
              this.savedPose.rotation.copy(el.object3D.rotation);
              this.hasSavedPose = true;
            },
            /**
             * Reset camera pose to before entering VR.
             */
            restoreCameraPose: function restoreCameraPose() {
              var el = this.el;
              var savedPose = this.savedPose;
              if (!this.hasSavedPose) {
                return;
              }

              // Reset camera orientation.
              el.object3D.position.copy(savedPose.position);
              el.object3D.rotation.copy(savedPose.rotation);
              this.hasSavedPose = false;
            }
          });

          /***/
        },

        /***/"./src/components/magicleap-controls.js":
        /*!**********************************************!*\
          !*** ./src/components/magicleap-controls.js ***!
          \**********************************************/
        /***/
        function srcComponentsMagicleapControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;

          // See Profiles Registry:
          // https://github.com/immersive-web/webxr-input-profiles/tree/master/packages/registry
          // TODO: Add a more robust system for deriving gamepad name.
          var GAMEPAD_ID_PREFIX = 'magicleap';
          var GAMEPAD_ID_SUFFIX = '-one';
          var GAMEPAD_ID_COMPOSITE = GAMEPAD_ID_PREFIX + GAMEPAD_ID_SUFFIX;
          var MAGICLEAP_CONTROLLER_MODEL_GLB_URL = 'https://cdn.aframe.io/controllers/magicleap/magicleap-one-controller.glb';

          /**
           * Button IDs:
           * 0 - trigger
           * 1 - grip
           * 2 - touchpad
           * 3 - menu (never dispatched on this layer)
           *
           * Axis:
           * 0 - touchpad x axis
           * 1 - touchpad y axis
           */
          var INPUT_MAPPING_WEBXR = {
            axes: {
              touchpad: [0, 1]
            },
            buttons: ['trigger', 'grip', 'touchpad', 'menu']
          };

          /**
           * Magic Leap Controls
           * Interface with Magic Leap control and map Gamepad events to controller
           * buttons: trigger, grip, touchpad, and menu.
           * Load a controller model.
           */
          module.exports.Component = registerComponent('magicleap-controls', {
            schema: {
              hand: {
                default: 'none'
              },
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              }
            },
            mapping: INPUT_MAPPING_WEBXR,
            init: function init() {
              var self = this;
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.previousButtonValues = {};
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();
            },
            update: function update() {
              var data = this.data;
              this.controllerIndex = data.hand === 'right' ? 0 : data.hand === 'left' ? 1 : 2;
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('axismove', this.onAxisMoved);
              el.addEventListener('model-loaded', this.onModelLoaded);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('axismove', this.onAxisMoved);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              var data = this.data;
              checkControllerPresentAndSetup(this, GAMEPAD_ID_COMPOSITE, {
                index: this.controllerIndex,
                hand: data.hand
              });
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                // TODO: verify expected behavior between reserved prefixes.
                idPrefix: GAMEPAD_ID_COMPOSITE,
                hand: data.hand,
                controller: this.controllerIndex,
                orientationOffset: data.orientationOffset
              });

              // Load model.
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('gltf-model', MAGICLEAP_CONTROLLER_MODEL_GLB_URL);
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              // Note that due to gamepadconnected event propagation issues, we don't rely on events.
              this.checkIfControllerPresent();
            },
            /**
             * Rotate the trigger button based on how hard the trigger is pressed.
             */
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              var analogValue;
              if (!button) {
                return;
              }
              if (button === 'trigger') {
                analogValue = evt.detail.state.value;
                console.log('analog value of trigger press: ' + analogValue);
              }

              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onModelLoaded: function onModelLoaded(evt) {
              var controllerObject3D = evt.detail.model;
              // our glb scale is too large.
              controllerObject3D.scale.set(0.01, 0.01, 0.01);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            updateModel: function updateModel(buttonName, evtName) {},
            setButtonColor: function setButtonColor(buttonName, color) {}
          });

          /***/
        },

        /***/"./src/components/material.js":
        /*!************************************!*\
          !*** ./src/components/material.js ***!
          \************************************/
        /***/
        function srcComponentsMaterialJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global Promise */
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var component = __webpack_require__( /*! ../core/component */"./src/core/component.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var shader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js");
          var error = utils.debug('components:material:error');
          var registerComponent = component.registerComponent;
          var shaders = shader.shaders;
          var shaderNames = shader.shaderNames;

          /**
           * Material component.
           *
           * @member {object} shader - Determines how material is shaded. Defaults to `standard`,
           *         three.js's implementation of PBR. Another standard shading model is `flat` which
           *         uses MeshBasicMaterial.
           */
          module.exports.Component = registerComponent('material', {
            schema: {
              alphaTest: {
                default: 0.0,
                min: 0.0,
                max: 1.0
              },
              depthTest: {
                default: true
              },
              depthWrite: {
                default: true
              },
              flatShading: {
                default: false
              },
              npot: {
                default: false
              },
              offset: {
                type: 'vec2',
                default: {
                  x: 0,
                  y: 0
                }
              },
              opacity: {
                default: 1.0,
                min: 0.0,
                max: 1.0
              },
              repeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              shader: {
                default: 'standard',
                oneOf: shaderNames,
                schemaChange: true
              },
              side: {
                default: 'front',
                oneOf: ['front', 'back', 'double']
              },
              transparent: {
                default: false
              },
              vertexColors: {
                type: 'string',
                default: 'none',
                oneOf: ['face', 'vertex']
              },
              visible: {
                default: true
              },
              blending: {
                default: 'normal',
                oneOf: ['none', 'normal', 'additive', 'subtractive', 'multiply']
              },
              dithering: {
                default: true
              }
            },
            init: function init() {
              this.material = null;
            },
            /**
             * Update or create material.
             *
             * @param {object|null} oldData
             */
            update: function update(oldData) {
              var data = this.data;
              if (!this.shader || data.shader !== oldData.shader) {
                this.updateShader(data.shader);
              }
              this.shader.update(this.data);
              this.updateMaterial(oldData);
            },
            updateSchema: function updateSchema(data) {
              var currentShader;
              var newShader;
              var schema;
              var shader;
              newShader = data && data.shader;
              currentShader = this.oldData && this.oldData.shader;
              shader = newShader || currentShader;
              schema = shaders[shader] && shaders[shader].schema;
              if (!schema) {
                error('Unknown shader schema ' + shader);
              }
              if (currentShader && newShader === currentShader) {
                return;
              }
              this.extendSchema(schema);
              this.updateBehavior();
            },
            updateBehavior: function updateBehavior() {
              var key;
              var sceneEl = this.el.sceneEl;
              var schema = this.schema;
              var self = this;
              var tickProperties;
              function tickTime(time, delta) {
                var key;
                for (key in tickProperties) {
                  tickProperties[key] = time;
                }
                self.shader.update(tickProperties);
              }
              this.tick = undefined;
              tickProperties = {};
              for (key in schema) {
                if (schema[key].type === 'time') {
                  this.tick = tickTime;
                  tickProperties[key] = true;
                }
              }
              if (!sceneEl) {
                return;
              }
              if (this.tick) {
                sceneEl.addBehavior(this);
              } else {
                sceneEl.removeBehavior(this);
              }
            },
            updateShader: function updateShader(shaderName) {
              var data = this.data;
              var Shader = shaders[shaderName] && shaders[shaderName].Shader;
              var shaderInstance;
              if (!Shader) {
                throw new Error('Unknown shader ' + shaderName);
              }

              // Get material from A-Frame shader.
              shaderInstance = this.shader = new Shader();
              shaderInstance.el = this.el;
              shaderInstance.init(data);
              this.setMaterial(shaderInstance.material);
              this.updateSchema(data);
            },
            /**
             * Set and update base material properties.
             * Set `needsUpdate` when needed.
             */
            updateMaterial: function updateMaterial(oldData) {
              var data = this.data;
              var material = this.material;
              var oldDataHasKeys;

              // Base material properties.
              material.alphaTest = data.alphaTest;
              material.depthTest = data.depthTest !== false;
              material.depthWrite = data.depthWrite !== false;
              material.opacity = data.opacity;
              material.flatShading = data.flatShading;
              material.side = parseSide(data.side);
              material.transparent = data.transparent !== false || data.opacity < 1.0;
              material.vertexColors = parseVertexColors(data.vertexColors);
              material.visible = data.visible;
              material.blending = parseBlending(data.blending);
              material.dithering = data.dithering;

              // Check if material needs update.
              for (oldDataHasKeys in oldData) {
                break;
              }
              if (oldDataHasKeys && (oldData.alphaTest !== data.alphaTest || oldData.side !== data.side || oldData.vertexColors !== data.vertexColors)) {
                material.needsUpdate = true;
              }
            },
            /**
             * Remove material on remove (callback).
             * Dispose of it from memory and unsubscribe from scene updates.
             */
            remove: function remove() {
              var defaultMaterial = new THREE.MeshBasicMaterial();
              var material = this.material;
              var object3D = this.el.getObject3D('mesh');
              if (object3D) {
                object3D.material = defaultMaterial;
              }
              disposeMaterial(material, this.system);
            },
            /**
             * (Re)create new material. Has side-effects of setting `this.material` and updating
             * material registration in scene.
             *
             * @param {object} data - Material component data.
             * @param {object} type - Material type to create.
             * @returns {object} Material.
             */
            setMaterial: function setMaterial(material) {
              var el = this.el;
              var mesh;
              var system = this.system;
              if (this.material) {
                disposeMaterial(this.material, system);
              }
              this.material = material;
              system.registerMaterial(material);

              // Set on mesh. If mesh does not exist, wait for it.
              mesh = el.getObject3D('mesh');
              if (mesh) {
                mesh.material = material;
              } else {
                el.addEventListener('object3dset', function waitForMesh(evt) {
                  if (evt.detail.type !== 'mesh' || evt.target !== el) {
                    return;
                  }
                  el.getObject3D('mesh').material = material;
                  el.removeEventListener('object3dset', waitForMesh);
                });
              }
            }
          });

          /**
           * Return a three.js constant determining which material face sides to render
           * based on the side parameter (passed as a component property).
           *
           * @param {string} [side=front] - `front`, `back`, or `double`.
           * @returns {number} THREE.FrontSide, THREE.BackSide, or THREE.DoubleSide.
           */
          function parseSide(side) {
            switch (side) {
              case 'back':
                {
                  return THREE.BackSide;
                }
              case 'double':
                {
                  return THREE.DoubleSide;
                }
              default:
                {
                  // Including case `front`.
                  return THREE.FrontSide;
                }
            }
          }

          /**
           * Return a three.js constant determining vertex coloring.
           */
          function parseVertexColors(coloring) {
            switch (coloring) {
              case 'face':
                {
                  return THREE.FaceColors;
                }
              case 'vertex':
                {
                  return THREE.VertexColors;
                }
              default:
                {
                  return THREE.NoColors;
                }
            }
          }

          /**
           * Return a three.js constant determining blending
           *
           * @param {string} [blending=normal]
           * - `none`, additive`, `subtractive`,`multiply` or `normal`.
           * @returns {number}
           */
          function parseBlending(blending) {
            switch (blending) {
              case 'none':
                {
                  return THREE.NoBlending;
                }
              case 'additive':
                {
                  return THREE.AdditiveBlending;
                }
              case 'subtractive':
                {
                  return THREE.SubtractiveBlending;
                }
              case 'multiply':
                {
                  return THREE.MultiplyBlending;
                }
              default:
                {
                  return THREE.NormalBlending;
                }
            }
          }

          /**
           * Dispose of material from memory and unsubscribe material from scene updates like fog.
           */
          function disposeMaterial(material, system) {
            material.dispose();
            system.unregisterMaterial(material);
          }

          /***/
        },

        /***/"./src/components/obj-model.js":
        /*!*************************************!*\
          !*** ./src/components/obj-model.js ***!
          \*************************************/
        /***/
        function srcComponentsObjModelJs(module, __unused_webpack_exports, __webpack_require__) {
          var debug = __webpack_require__( /*! ../utils/debug */"./src/utils/debug.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var warn = debug('components:obj-model:warn');
          module.exports.Component = registerComponent('obj-model', {
            schema: {
              mtl: {
                type: 'model'
              },
              obj: {
                type: 'model'
              }
            },
            init: function init() {
              var self = this;
              this.model = null;
              this.objLoader = new THREE.OBJLoader();
              this.mtlLoader = new THREE.MTLLoader(this.objLoader.manager);
              // Allow cross-origin images to be loaded.
              this.mtlLoader.crossOrigin = '';
              this.el.addEventListener('componentinitialized', function (evt) {
                if (!self.model) {
                  return;
                }
                if (evt.detail.name !== 'material') {
                  return;
                }
                self.applyMaterial();
              });
            },
            update: function update() {
              var data = this.data;
              if (!data.obj) {
                return;
              }
              this.resetMesh();
              this.loadObj(data.obj, data.mtl);
            },
            remove: function remove() {
              if (!this.model) {
                return;
              }
              this.resetMesh();
            },
            resetMesh: function resetMesh() {
              this.el.removeObject3D('mesh');
            },
            loadObj: function loadObj(objUrl, mtlUrl) {
              var self = this;
              var el = this.el;
              var mtlLoader = this.mtlLoader;
              var objLoader = this.objLoader;
              var rendererSystem = this.el.sceneEl.systems.renderer;
              var BASE_PATH = mtlUrl.substr(0, mtlUrl.lastIndexOf('/') + 1);
              if (mtlUrl) {
                // .OBJ with an .MTL.
                if (el.hasAttribute('material')) {
                  warn('Material component properties are ignored when a .MTL is provided');
                }
                mtlLoader.setResourcePath(BASE_PATH);
                mtlLoader.load(mtlUrl, function (materials) {
                  materials.preload();
                  objLoader.setMaterials(materials);
                  objLoader.load(objUrl, function (objModel) {
                    self.model = objModel;
                    self.model.traverse(function (object) {
                      if (object.isMesh) {
                        var material = object.material;
                        if (material.color) rendererSystem.applyColorCorrection(material.color);
                        if (material.map) rendererSystem.applyColorCorrection(material.map);
                        if (material.emissive) rendererSystem.applyColorCorrection(material.emissive);
                        if (material.emissiveMap) rendererSystem.applyColorCorrection(material.emissiveMap);
                      }
                    });
                    el.setObject3D('mesh', objModel);
                    el.emit('model-loaded', {
                      format: 'obj',
                      model: objModel
                    });
                  });
                });
                return;
              }

              // .OBJ only.
              objLoader.load(objUrl, function loadObjOnly(objModel) {
                self.model = objModel;
                self.applyMaterial();
                el.setObject3D('mesh', objModel);
                el.emit('model-loaded', {
                  format: 'obj',
                  model: objModel
                });
              });
            },
            /**
             * Apply material from material component recursively.
             */
            applyMaterial: function applyMaterial() {
              var material = this.el.components.material;
              if (!material) {
                return;
              }
              this.model.traverse(function (child) {
                if (child instanceof THREE.Mesh) {
                  child.material = material.material;
                }
              });
            }
          });

          /***/
        },

        /***/"./src/components/oculus-go-controls.js":
        /*!**********************************************!*\
          !*** ./src/components/oculus-go-controls.js ***!
          \**********************************************/
        /***/
        function srcComponentsOculusGoControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var GAMEPAD_ID_WEBXR = 'oculus-go';
          var GAMEPAD_ID_WEBVR = 'Oculus Go';
          var OCULUS_GO_CONTROLLER_MODEL_URL = 'https://cdn.aframe.io/controllers/oculus/go/oculus-go-controller.gltf';

          // Prefix for Gen1 and Gen2 Oculus Touch Controllers.
          var GAMEPAD_ID_PREFIX = isWebXRAvailable ? GAMEPAD_ID_WEBXR : GAMEPAD_ID_WEBVR;

          /**
           * Button indices:
           * 0 - trackpad
           * 1 - trigger
           *
           * Axis:
           * 0 - trackpad x
           * 1 - trackpad y
           */
          var INPUT_MAPPING_WEBVR = {
            axes: {
              trackpad: [0, 1]
            },
            buttons: ['trackpad', 'trigger']
          };

          /**
           * Button indices:
           * 0 - trigger
           * 1 - none
           * 2 - touchpad
           *
           * Axis:
           * 0 - touchpad x
           * 1 - touchpad y
           * Reference: https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/oculus/oculus-go.json
           */
          var INPUT_MAPPING_WEBXR = {
            axes: {
              touchpad: [0, 1]
            },
            buttons: ['trigger', 'none', 'touchpad']
          };
          var INPUT_MAPPING = isWebXRAvailable ? INPUT_MAPPING_WEBXR : INPUT_MAPPING_WEBVR;

          /**
           * Oculus Go controls.
           * Interface with Oculus Go controller and map Gamepad events to
           * controller buttons: trackpad, trigger
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('oculus-go-controls', {
            schema: {
              hand: {
                default: ''
              },
              // This informs the degenerate arm model.
              buttonColor: {
                type: 'color',
                default: '#FFFFFF'
              },
              buttonTouchedColor: {
                type: 'color',
                default: '#BBBBBB'
              },
              buttonHighlightColor: {
                type: 'color',
                default: '#7A7A7A'
              },
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              },
              armModel: {
                default: true
              }
            },
            mapping: INPUT_MAPPING,
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, this.data.hand ? {
                hand: this.data.hand
              } : {});
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                armModel: data.armModel,
                hand: data.hand,
                idPrefix: GAMEPAD_ID_PREFIX,
                orientationOffset: data.orientationOffset
              });
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('gltf-model', OCULUS_GO_CONTROLLER_MODEL_URL);
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            // No need for onButtonChanged, since Oculus Go controller has no analog buttons.

            onModelLoaded: function onModelLoaded(evt) {
              var controllerObject3D = evt.detail.model;
              var buttonMeshes;
              if (!this.data.model) {
                return;
              }
              buttonMeshes = this.buttonMeshes = {};
              buttonMeshes.trigger = controllerObject3D.getObjectByName('oculus_go_button_trigger');
              buttonMeshes.trackpad = controllerObject3D.getObjectByName('oculus_go_touchpad');
              buttonMeshes.touchpad = controllerObject3D.getObjectByName('oculus_go_touchpad');
            },
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              if (!button) return;
              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            updateModel: function updateModel(buttonName, evtName) {
              if (!this.data.model) {
                return;
              }
              this.updateButtonModel(buttonName, evtName);
            },
            updateButtonModel: function updateButtonModel(buttonName, state) {
              var buttonMeshes = this.buttonMeshes;
              if (!buttonMeshes || !buttonMeshes[buttonName]) {
                return;
              }
              var color;
              var button;
              switch (state) {
                case 'down':
                  color = this.data.buttonHighlightColor;
                  break;
                case 'touchstart':
                  color = this.data.buttonTouchedColor;
                  break;
                default:
                  color = this.data.buttonColor;
              }
              button = buttonMeshes[buttonName];
              button.material.color.set(color);
              this.rendererSystem.applyColorCorrection(button.material.color);
            }
          });

          /***/
        },

        /***/"./src/components/oculus-touch-controls.js":
        /*!*************************************************!*\
          !*** ./src/components/oculus-touch-controls.js ***!
          \*************************************************/
        /***/
        function srcComponentsOculusTouchControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var GAMEPAD_ID_WEBXR = 'oculus-touch';
          var GAMEPAD_ID_WEBVR = 'Oculus Touch';

          // Prefix for Gen1 and Gen2 Oculus Touch Controllers.
          var GAMEPAD_ID_PREFIX = isWebXRAvailable ? GAMEPAD_ID_WEBXR : GAMEPAD_ID_WEBVR;

          // First generation model URL.
          var TOUCH_CONTROLLER_MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/oculus/oculus-touch-controller-';
          var META_CONTROLLER_MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/meta/';
          var OCULUS_TOUCH_WEBVR = {
            left: {
              modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'left.gltf',
              rayOrigin: {
                origin: {
                  x: 0.008,
                  y: -0.01,
                  z: 0
                },
                direction: {
                  x: 0,
                  y: -0.8,
                  z: -1
                }
              },
              modelPivotOffset: new THREE.Vector3(-0.005, 0.003, -0.055),
              modelPivotRotation: new THREE.Euler(0, 0, 0)
            },
            right: {
              modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'right.gltf',
              rayOrigin: {
                origin: {
                  x: -0.008,
                  y: -0.01,
                  z: 0
                },
                direction: {
                  x: 0,
                  y: -0.8,
                  z: -1
                }
              },
              modelPivotOffset: new THREE.Vector3(0.005, 0.003, -0.055),
              modelPivotRotation: new THREE.Euler(0, 0, 0)
            }
          };
          var OCULUS_TOUCH_WEBXR = {
            left: {
              modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'left.gltf',
              rayOrigin: {
                origin: {
                  x: 0.002,
                  y: -0.005,
                  z: -0.03
                },
                direction: {
                  x: 0,
                  y: -0.8,
                  z: -1
                }
              },
              modelPivotOffset: new THREE.Vector3(-0.005, 0.036, -0.037),
              modelPivotRotation: new THREE.Euler(Math.PI / 4.5, 0, 0)
            },
            right: {
              modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'right.gltf',
              rayOrigin: {
                origin: {
                  x: -0.002,
                  y: -0.005,
                  z: -0.03
                },
                direction: {
                  x: 0,
                  y: -0.8,
                  z: -1
                }
              },
              modelPivotOffset: new THREE.Vector3(0.005, 0.036, -0.037),
              modelPivotRotation: new THREE.Euler(Math.PI / 4.5, 0, 0)
            }
          };
          var OCULUS_TOUCH_CONFIG = isWebXRAvailable ? OCULUS_TOUCH_WEBXR : OCULUS_TOUCH_WEBVR;
          var CONTROLLER_DEFAULT = 'oculus-touch';
          var CONTROLLER_PROPERTIES = {
            'oculus-touch': OCULUS_TOUCH_CONFIG,
            'oculus-touch-v2': {
              left: {
                modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'gen2-left.gltf',
                rayOrigin: {
                  origin: {
                    x: -0.006,
                    y: -0.03,
                    z: -0.04
                  },
                  direction: {
                    x: 0,
                    y: -0.9,
                    z: -1
                  }
                },
                modelPivotOffset: new THREE.Vector3(0, -0.007, -0.021),
                modelPivotRotation: new THREE.Euler(-Math.PI / 4, 0, 0)
              },
              right: {
                modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'gen2-right.gltf',
                rayOrigin: {
                  origin: {
                    x: 0.006,
                    y: -0.03,
                    z: -0.04
                  },
                  direction: {
                    x: 0,
                    y: -0.9,
                    z: -1
                  }
                },
                modelPivotOffset: new THREE.Vector3(0, -0.007, -0.021),
                modelPivotRotation: new THREE.Euler(-Math.PI / 4, 0, 0)
              }
            },
            'oculus-touch-v3': {
              left: {
                modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'v3-left.glb',
                rayOrigin: {
                  origin: {
                    x: 0.0065,
                    y: -0.0186,
                    z: -0.05
                  },
                  direction: {
                    x: 0.12394785839500175,
                    y: -0.5944043672340157,
                    z: -0.7945567170519814
                  }
                },
                modelPivotOffset: new THREE.Vector3(0, 0, 0),
                modelPivotRotation: new THREE.Euler(0, 0, 0)
              },
              right: {
                modelUrl: TOUCH_CONTROLLER_MODEL_BASE_URL + 'v3-right.glb',
                rayOrigin: {
                  origin: {
                    x: -0.0065,
                    y: -0.0186,
                    z: -0.05
                  },
                  direction: {
                    x: -0.12394785839500175,
                    y: -0.5944043672340157,
                    z: -0.7945567170519814
                  }
                },
                modelPivotOffset: new THREE.Vector3(0, 0, 0),
                modelPivotRotation: new THREE.Euler(0, 0, 0)
              }
            },
            'meta-quest-touch-pro': {
              left: {
                modelUrl: META_CONTROLLER_MODEL_BASE_URL + 'quest-touch-pro-left.glb',
                rayOrigin: {
                  origin: {
                    x: 0.0065,
                    y: -0.0186,
                    z: -0.05
                  },
                  direction: {
                    x: 0.12394785839500175,
                    y: -0.5944043672340157,
                    z: -0.7945567170519814
                  }
                },
                modelPivotOffset: new THREE.Vector3(0, 0, 0),
                modelPivotRotation: new THREE.Euler(0, 0, 0)
              },
              right: {
                modelUrl: META_CONTROLLER_MODEL_BASE_URL + 'quest-touch-pro-right.glb',
                rayOrigin: {
                  origin: {
                    x: -0.0065,
                    y: -0.0186,
                    z: -0.05
                  },
                  direction: {
                    x: -0.12394785839500175,
                    y: -0.5944043672340157,
                    z: -0.7945567170519814
                  }
                },
                modelPivotOffset: new THREE.Vector3(0, 0, 0),
                modelPivotRotation: new THREE.Euler(0, 0, 0)
              }
            }
          };

          /**
           * Button indices:
           * 0 - thumbstick (which has separate axismove / thumbstickmoved events)
           * 1 - trigger (with analog value, which goes up to 1)
           * 2 - grip (with analog value, which goes up to 1)
           * 3 - X (left) or A (right)
           * 4 - Y (left) or B (right)
           * 5 - surface (touch only)
           */
          var INPUT_MAPPING_WEBVR = {
            left: {
              axes: {
                thumbstick: [0, 1]
              },
              buttons: ['thumbstick', 'trigger', 'grip', 'xbutton', 'ybutton', 'surface']
            },
            right: {
              axes: {
                thumbstick: [0, 1]
              },
              buttons: ['thumbstick', 'trigger', 'grip', 'abutton', 'bbutton', 'surface']
            }
          };

          /**
           * Button indices:
           * 0 - trigger
           * 1 - grip
           * 2 - none
           * 3 - thumbstick
           * 4 - X or A button
           * 5 - Y or B button
           * 6 - surface
           *
           * Axis:
           * 0 - none
           * 1 - none
           * 2 - thumbstick
           * 3 - thumbstick
           * Reference: https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/oculus/oculus-touch.json
           */
          var INPUT_MAPPING_WEBXR = {
            left: {
              axes: {
                thumbstick: [2, 3]
              },
              buttons: ['trigger', 'grip', 'none', 'thumbstick', 'xbutton', 'ybutton', 'surface']
            },
            right: {
              axes: {
                thumbstick: [2, 3]
              },
              buttons: ['trigger', 'grip', 'none', 'thumbstick', 'abutton', 'bbutton', 'surface']
            }
          };
          var INPUT_MAPPING = isWebXRAvailable ? INPUT_MAPPING_WEBXR : INPUT_MAPPING_WEBVR;

          /**
           * Oculus Touch controls.
           * Interface with Oculus Touch controllers and map Gamepad events to
           * controller buttons: thumbstick, trigger, grip, xbutton, ybutton, surface
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('oculus-touch-controls', {
            schema: {
              hand: {
                default: 'left'
              },
              buttonColor: {
                type: 'color',
                default: '#999'
              },
              // Off-white.
              buttonTouchColor: {
                type: 'color',
                default: '#8AB'
              },
              buttonHighlightColor: {
                type: 'color',
                default: '#2DF'
              },
              // Light blue.
              model: {
                default: true
              },
              controllerType: {
                default: 'auto',
                oneOf: ['auto', 'oculus-touch', 'oculus-touch-v2', 'oculus-touch-v3']
              },
              orientationOffset: {
                type: 'vec3',
                default: {
                  x: 43,
                  y: 0,
                  z: 0
                }
              }
            },
            mapping: INPUT_MAPPING,
            bindMethods: function bindMethods() {
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onThumbstickMoved = bind(this.onThumbstickMoved, this);
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self, self.data.hand);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self, self.data.hand);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self, self.data.hand);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self, self.data.hand);
              };
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.previousButtonValues = {};
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();
              this.triggerEuler = new THREE.Euler();
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('axismove', this.onAxisMoved);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('thumbstickmoved', this.onThumbstickMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('axismove', this.onAxisMoved);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('thumbstickmoved', this.onThumbstickMoved);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, {
                hand: this.data.hand,
                iterateControllerProfiles: true
              });
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            loadModel: function loadModel(controller) {
              var data = this.data;
              var controllerId;
              if (!data.model) {
                return;
              }
              // Set the controller display model based on the data passed in.
              this.displayModel = CONTROLLER_PROPERTIES[data.controllerType] || CONTROLLER_PROPERTIES[CONTROLLER_DEFAULT];
              // If the developer is asking for auto-detection, use the retrieved displayName to identify the specific unit.
              // This only works for WebVR currently.
              if (data.controllerType === 'auto') {
                var trackedControlsSystem = this.el.sceneEl.systems['tracked-controls-webvr'];
                // WebVR
                if (trackedControlsSystem && trackedControlsSystem.vrDisplay) {
                  var displayName = trackedControlsSystem.vrDisplay.displayName;
                  if (/^Oculus Quest$/.test(displayName)) {
                    this.displayModel = CONTROLLER_PROPERTIES['oculus-touch-v2'];
                  }
                } else {
                  // WebXR
                  controllerId = CONTROLLER_DEFAULT;
                  var controllersPropertiesIds = Object.keys(CONTROLLER_PROPERTIES);
                  for (var i = 0; i < controller.profiles.length; i++) {
                    if (controllersPropertiesIds.indexOf(controller.profiles[i]) !== -1) {
                      controllerId = controller.profiles[i];
                      break;
                    }
                  }
                  this.displayModel = CONTROLLER_PROPERTIES[controllerId];
                }
              }
              var modelUrl = this.displayModel[data.hand].modelUrl;
              this.isOculusTouchV3 = this.displayModel === CONTROLLER_PROPERTIES['oculus-touch-v3'];
              this.el.setAttribute('gltf-model', modelUrl);
            },
            injectTrackedControls: function injectTrackedControls(controller) {
              var data = this.data;
              var webXRId = GAMEPAD_ID_WEBXR;
              var webVRId = data.hand === 'right' ? 'Oculus Touch (Right)' : 'Oculus Touch (Left)';
              var id = isWebXRAvailable ? webXRId : webVRId;
              this.el.setAttribute('tracked-controls', {
                id: id,
                hand: data.hand,
                orientationOffset: data.orientationOffset,
                handTrackingEnabled: false,
                iterateControllerProfiles: true,
                space: 'gripSpace'
              });
              this.loadModel(controller);
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              // Note that due to gamepadconnected event propagation issues, we don't rely on events.
              this.checkIfControllerPresent();
            },
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping[this.data.hand].buttons[evt.detail.id];
              if (!button) {
                return;
              }
              // move the button meshes
              if (this.isOculusTouchV3) {
                this.onButtonChangedV3(evt);
              } else {
                var buttonMeshes = this.buttonMeshes;
                var analogValue;
                if (button === 'trigger' || button === 'grip') {
                  analogValue = evt.detail.state.value;
                }
                if (buttonMeshes) {
                  if (button === 'trigger' && buttonMeshes.trigger) {
                    buttonMeshes.trigger.rotation.x = this.originalXRotationTrigger - analogValue * (Math.PI / 26);
                  }
                  if (button === 'grip' && buttonMeshes.grip) {
                    analogValue *= this.data.hand === 'left' ? -1 : 1;
                    buttonMeshes.grip.position.x = this.originalXPositionGrip + analogValue * 0.004;
                  }
                }
              }
              // Pass along changed event with button state, using the buttom mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            clickButtons: ['xbutton', 'ybutton', 'abutton', 'bbutton', 'thumbstick'],
            onButtonChangedV3: function onButtonChangedV3(evt) {
              var button = this.mapping[this.data.hand].buttons[evt.detail.id];
              var buttonObjects = this.buttonObjects;
              var analogValue;
              analogValue = evt.detail.state.value;
              analogValue *= this.data.hand === 'left' ? -1 : 1;
              if (button === 'trigger') {
                this.triggerEuler.copy(this.buttonRanges.trigger.min.rotation);
                this.triggerEuler.x += analogValue * this.buttonRanges.trigger.diff.x;
                this.triggerEuler.y += analogValue * this.buttonRanges.trigger.diff.y;
                this.triggerEuler.z += analogValue * this.buttonRanges.trigger.diff.z;
                buttonObjects.trigger.setRotationFromEuler(this.triggerEuler);
              } else if (button === 'grip') {
                buttonObjects.grip.position.x = buttonObjects.grip.minX + analogValue * 0.004;
              } else if (this.clickButtons.includes(button)) {
                buttonObjects[button].position.y = analogValue === 0 ? this.buttonRanges[button].unpressedY : this.buttonRanges[button].pressedY;
              }
            },
            onModelLoaded: function onModelLoaded(evt) {
              if (!this.data.model) {
                return;
              }
              if (this.isOculusTouchV3) {
                this.onOculusTouchV3ModelLoaded(evt);
              } else {
                // All oculus headset controller models prior to the Quest 2 (i.e., Oculus Touch V3)
                // used a consistent format that is handled here
                var controllerObject3D = this.controllerObject3D = evt.detail.model;
                var buttonMeshes;
                buttonMeshes = this.buttonMeshes = {};
                buttonMeshes.grip = controllerObject3D.getObjectByName('buttonHand');
                this.originalXPositionGrip = buttonMeshes.grip && buttonMeshes.grip.position.x;
                buttonMeshes.trigger = controllerObject3D.getObjectByName('buttonTrigger');
                this.originalXRotationTrigger = buttonMeshes.trigger && buttonMeshes.trigger.rotation.x;
                buttonMeshes.thumbstick = controllerObject3D.getObjectByName('stick');
                buttonMeshes.xbutton = controllerObject3D.getObjectByName('buttonX');
                buttonMeshes.abutton = controllerObject3D.getObjectByName('buttonA');
                buttonMeshes.ybutton = controllerObject3D.getObjectByName('buttonY');
                buttonMeshes.bbutton = controllerObject3D.getObjectByName('buttonB');
              }
              for (var button in this.buttonMeshes) {
                if (this.buttonMeshes[button]) {
                  cloneMeshMaterial(this.buttonMeshes[button]);
                }
              }
              this.applyOffset(evt.detail.model);
              this.el.emit('controllermodelready', {
                name: 'oculus-touch-controls',
                model: this.data.model,
                rayOrigin: this.displayModel[this.data.hand].rayOrigin
              });
            },
            applyOffset: function applyOffset(model) {
              model.position.copy(this.displayModel[this.data.hand].modelPivotOffset);
              model.rotation.copy(this.displayModel[this.data.hand].modelPivotRotation);
            },
            onOculusTouchV3ModelLoaded: function onOculusTouchV3ModelLoaded(evt) {
              var controllerObject3D = this.controllerObject3D = evt.detail.model;
              var buttonObjects = this.buttonObjects = {};
              var buttonMeshes = this.buttonMeshes = {};
              var buttonRanges = this.buttonRanges = {};
              buttonMeshes.grip = controllerObject3D.getObjectByName('squeeze');
              buttonObjects.grip = controllerObject3D.getObjectByName('xr_standard_squeeze_pressed_value');
              buttonRanges.grip = {
                min: controllerObject3D.getObjectByName('xr_standard_squeeze_pressed_min'),
                max: controllerObject3D.getObjectByName('xr_standard_squeeze_pressed_max')
              };
              buttonObjects.grip.minX = buttonObjects.grip.position.x;
              buttonMeshes.thumbstick = controllerObject3D.getObjectByName('thumbstick');
              buttonObjects.thumbstick = controllerObject3D.getObjectByName('xr_standard_thumbstick_pressed_value');
              buttonRanges.thumbstick = {
                min: controllerObject3D.getObjectByName('xr_standard_thumbstick_pressed_min'),
                max: controllerObject3D.getObjectByName('xr_standard_thumbstick_pressed_max'),
                originalRotation: this.buttonObjects.thumbstick.rotation.clone()
              };
              buttonRanges.thumbstick.pressedY = buttonObjects.thumbstick.position.y;
              buttonRanges.thumbstick.unpressedY = buttonRanges.thumbstick.pressedY + Math.abs(buttonRanges.thumbstick.max.position.y) - Math.abs(buttonRanges.thumbstick.min.position.y);
              buttonMeshes.trigger = controllerObject3D.getObjectByName('trigger');
              buttonObjects.trigger = controllerObject3D.getObjectByName('xr_standard_trigger_pressed_value');
              buttonRanges.trigger = {
                min: controllerObject3D.getObjectByName('xr_standard_trigger_pressed_min'),
                max: controllerObject3D.getObjectByName('xr_standard_trigger_pressed_max')
              };
              buttonRanges.trigger.diff = {
                x: Math.abs(buttonRanges.trigger.max.rotation.x) - Math.abs(buttonRanges.trigger.min.rotation.x),
                y: Math.abs(buttonRanges.trigger.max.rotation.y) - Math.abs(buttonRanges.trigger.min.rotation.y),
                z: Math.abs(buttonRanges.trigger.max.rotation.z) - Math.abs(buttonRanges.trigger.min.rotation.z)
              };
              var button1 = this.data.hand === 'left' ? 'x' : 'a';
              var button2 = this.data.hand === 'left' ? 'y' : 'b';
              var button1id = button1 + 'button';
              var button2id = button2 + 'button';
              buttonMeshes[button1id] = controllerObject3D.getObjectByName(button1 + '_button');
              buttonObjects[button1id] = controllerObject3D.getObjectByName(button1 + '_button_pressed_value');
              buttonRanges[button1id] = {
                min: controllerObject3D.getObjectByName(button1 + '_button_pressed_min'),
                max: controllerObject3D.getObjectByName(button1 + '_button_pressed_max')
              };
              buttonMeshes[button2id] = controllerObject3D.getObjectByName(button2 + '_button');
              buttonObjects[button2id] = controllerObject3D.getObjectByName(button2 + '_button_pressed_value');
              buttonRanges[button2id] = {
                min: controllerObject3D.getObjectByName(button2 + '_button_pressed_min'),
                max: controllerObject3D.getObjectByName(button2 + '_button_pressed_max')
              };
              buttonRanges[button1id].unpressedY = buttonObjects[button1id].position.y;
              buttonRanges[button1id].pressedY = buttonRanges[button1id].unpressedY + Math.abs(buttonRanges[button1id].max.position.y) - Math.abs(buttonRanges[button1id].min.position.y);
              buttonRanges[button2id].unpressedY = buttonObjects[button2id].position.y;
              buttonRanges[button2id].pressedY = buttonRanges[button2id].unpressedY - Math.abs(buttonRanges[button2id].max.position.y) + Math.abs(buttonRanges[button2id].min.position.y);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping[this.data.hand].axes, evt);
            },
            onThumbstickMoved: function onThumbstickMoved(evt) {
              if (!this.isOculusTouchV3 || !this.buttonMeshes || !this.buttonMeshes.thumbstick) {
                return;
              }
              for (var axis in evt.detail) {
                this.buttonObjects.thumbstick.rotation[this.axisMap[axis]] = this.buttonRanges.thumbstick.originalRotation[this.axisMap[axis]] - Math.PI / 8 * evt.detail[axis] * (axis === 'y' || this.data.hand === 'right' ? -1 : 1);
              }
            },
            axisMap: {
              y: 'x',
              x: 'z'
            },
            updateModel: function updateModel(buttonName, evtName) {
              if (!this.data.model) {
                return;
              }
              this.updateButtonModel(buttonName, evtName);
            },
            updateButtonModel: function updateButtonModel(buttonName, state) {
              // update the button mesh colors
              var button;
              var color = state === 'up' || state === 'touchend' ? this.buttonMeshes[buttonName].originalColor || this.data.buttonColor : state === 'touchstart' ? this.data.buttonTouchColor : this.data.buttonHighlightColor;
              var buttonMeshes = this.buttonMeshes;
              if (buttonMeshes && buttonMeshes[buttonName]) {
                button = buttonMeshes[buttonName];
                button.material.color.set(color);
                this.rendererSystem.applyColorCorrection(button.material.color);
              }
            }
          });

          /**
           * Some of the controller models share the same material for different parts (buttons, triggers...).
           * In order to change their color independently we have to create separate materials.
           */
          function cloneMeshMaterial(object3d) {
            object3d.traverse(function (node) {
              if (node.type !== 'Mesh') return;
              var newMaterial = node.material.clone();
              object3d.originalColor = node.material.color;
              node.material.dispose();
              node.material = newMaterial;
            });
          }

          /***/
        },

        /***/"./src/components/position.js":
        /*!************************************!*\
          !*** ./src/components/position.js ***!
          \************************************/
        /***/
        function srcComponentsPositionJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          module.exports.Component = registerComponent('position', {
            schema: {
              type: 'vec3'
            },
            update: function update() {
              var object3D = this.el.object3D;
              var data = this.data;
              object3D.position.set(data.x, data.y, data.z);
            },
            remove: function remove() {
              // Pretty much for mixins.
              this.el.object3D.position.set(0, 0, 0);
            }
          });

          /***/
        },

        /***/"./src/components/raycaster.js":
        /*!*************************************!*\
          !*** ./src/components/raycaster.js ***!
          \*************************************/
        /***/
        function srcComponentsRaycasterJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global MutationObserver */

          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var warn = utils.debug('components:raycaster:warn');

          // Defines selectors that should be 'safe' for the MutationObserver used to
          // refresh the whitelist. Matches classnames, IDs, and presence of attributes.
          // Selectors for the value of an attribute, like [position=0 2 0], cannot be
          // reliably detected and are therefore disallowed.
          var OBSERVER_SELECTOR_RE = /^[\w\s-.,[\]#]*$/;

          // Configuration for the MutationObserver used to refresh the whitelist.
          // Listens for addition/removal of elements and attributes within the scene.
          var OBSERVER_CONFIG = {
            childList: true,
            attributes: true,
            subtree: true
          };
          var EVENTS = {
            INTERSECT: 'raycaster-intersected',
            INTERSECTION: 'raycaster-intersection',
            INTERSECT_CLEAR: 'raycaster-intersected-cleared',
            INTERSECTION_CLEAR: 'raycaster-intersection-cleared',
            INTERSECTION_CLOSEST_ENTITY_CHANGED: 'raycaster-closest-entity-changed'
          };

          /**
           * Raycaster component.
           *
           * Pass options to three.js Raycaster including which objects to test.
           * Poll for intersections.
           * Emit event on origin entity and on target entity on intersect.
           *
           * @member {array} intersectedEls - List of currently intersected entities.
           * @member {array} objects - Cached list of meshes to intersect.
           * @member {number} prevCheckTime - Previous time intersection was checked. To help interval.
           * @member {object} raycaster - three.js Raycaster.
           */
          module.exports.Component = registerComponent('raycaster', {
            schema: {
              autoRefresh: {
                default: true
              },
              direction: {
                type: 'vec3',
                default: {
                  x: 0,
                  y: 0,
                  z: -1
                }
              },
              enabled: {
                default: true
              },
              far: {
                default: 1000
              },
              interval: {
                default: 0
              },
              near: {
                default: 0
              },
              objects: {
                default: ''
              },
              origin: {
                type: 'vec3'
              },
              showLine: {
                default: false
              },
              lineColor: {
                default: 'white'
              },
              lineOpacity: {
                default: 1
              },
              useWorldCoordinates: {
                default: false
              }
            },
            multiple: true,
            init: function init() {
              this.clearedIntersectedEls = [];
              this.unitLineEndVec3 = new THREE.Vector3();
              this.intersectedEls = [];
              this.intersections = [];
              this.newIntersectedEls = [];
              this.newIntersections = [];
              this.objects = [];
              this.prevCheckTime = undefined;
              this.prevIntersectedEls = [];
              this.rawIntersections = [];
              this.raycaster = new THREE.Raycaster();
              this.updateOriginDirection();
              this.setDirty = this.setDirty.bind(this);
              this.updateLine = this.updateLine.bind(this);
              this.observer = new MutationObserver(this.setDirty);
              this.dirty = true;
              this.lineEndVec3 = new THREE.Vector3();
              this.otherLineEndVec3 = new THREE.Vector3();
              this.lineData = {
                end: this.lineEndVec3
              };
              this.getIntersection = this.getIntersection.bind(this);
              this.intersectedDetail = {
                el: this.el,
                getIntersection: this.getIntersection
              };
              this.intersectedClearedDetail = {
                el: this.el
              };
              this.intersectionClearedDetail = {
                clearedEls: this.clearedIntersectedEls
              };
              this.intersectionDetail = {};
            },
            /**
             * Create or update raycaster object.
             */
            update: function update(oldData) {
              var data = this.data;
              var el = this.el;
              var raycaster = this.raycaster;

              // Set raycaster properties.
              raycaster.far = data.far;
              raycaster.near = data.near;

              // Draw line.
              if (data.showLine && (data.far !== oldData.far || data.origin !== oldData.origin || data.direction !== oldData.direction || !oldData.showLine)) {
                // Calculate unit vector for line direction. Can be multiplied via scalar to performantly
                // adjust line length.
                this.unitLineEndVec3.copy(data.origin).add(data.direction).normalize();
                this.drawLine();
              }
              if (!data.showLine && oldData.showLine) {
                el.removeAttribute('line');
              }
              if (data.objects !== oldData.objects && !OBSERVER_SELECTOR_RE.test(data.objects)) {
                warn('[raycaster] Selector "' + data.objects + '" may not update automatically with DOM changes.');
              }
              if (!data.objects) {
                warn('[raycaster] For performance, please define raycaster.objects when using ' + 'raycaster or cursor components to whitelist which entities to intersect with. ' + 'e.g., raycaster="objects: [data-raycastable]".');
              }
              if (data.autoRefresh !== oldData.autoRefresh && el.isPlaying) {
                data.autoRefresh ? this.addEventListeners() : this.removeEventListeners();
              }
              if (oldData.enabled && !data.enabled) {
                this.clearAllIntersections();
              }
              this.setDirty();
            },
            play: function play() {
              this.addEventListeners();
            },
            pause: function pause() {
              this.removeEventListeners();
            },
            remove: function remove() {
              if (this.data.showLine) {
                this.el.removeAttribute('line');
              }
              this.clearAllIntersections();
            },
            addEventListeners: function addEventListeners() {
              if (!this.data.autoRefresh) {
                return;
              }
              this.observer.observe(this.el.sceneEl, OBSERVER_CONFIG);
              this.el.sceneEl.addEventListener('object3dset', this.setDirty);
              this.el.sceneEl.addEventListener('object3dremove', this.setDirty);
            },
            removeEventListeners: function removeEventListeners() {
              this.observer.disconnect();
              this.el.sceneEl.removeEventListener('object3dset', this.setDirty);
              this.el.sceneEl.removeEventListener('object3dremove', this.setDirty);
            },
            /**
             * Mark the object list as dirty, to be refreshed before next raycast.
             */
            setDirty: function setDirty() {
              this.dirty = true;
            },
            /**
             * Update list of objects to test for intersection.
             */
            refreshObjects: function refreshObjects() {
              var data = this.data;
              var els;

              // If objects not defined, intersect with everything.
              els = data.objects ? this.el.sceneEl.querySelectorAll(data.objects) : this.el.sceneEl.querySelectorAll('*');
              this.objects = this.flattenObject3DMaps(els);
              this.dirty = false;
            },
            /**
             * Check for intersections and cleared intersections on an interval.
             */
            tock: function tock(time) {
              var data = this.data;
              var prevCheckTime = this.prevCheckTime;
              if (!data.enabled) {
                return;
              }

              // Only check for intersection if interval time has passed.
              if (prevCheckTime && time - prevCheckTime < data.interval) {
                return;
              }

              // Update check time.
              this.prevCheckTime = time;
              this.checkIntersections();
            },
            /**
             * Raycast for intersections and emit events for current and cleared intersections.
             */
            checkIntersections: function checkIntersections() {
              var clearedIntersectedEls = this.clearedIntersectedEls;
              var el = this.el;
              var data = this.data;
              var i;
              var intersectedEls = this.intersectedEls;
              var intersection;
              var intersections = this.intersections;
              var newIntersectedEls = this.newIntersectedEls;
              var newIntersections = this.newIntersections;
              var prevIntersectedEls = this.prevIntersectedEls;
              var rawIntersections = this.rawIntersections;

              // Refresh the object whitelist if needed.
              if (this.dirty) {
                this.refreshObjects();
              }

              // Store old previously intersected entities.
              copyArray(this.prevIntersectedEls, this.intersectedEls);

              // Raycast.
              this.updateOriginDirection();
              rawIntersections.length = 0;
              this.raycaster.intersectObjects(this.objects, true, rawIntersections);

              // Only keep intersections against objects that have a reference to an entity.
              intersections.length = 0;
              intersectedEls.length = 0;
              for (i = 0; i < rawIntersections.length; i++) {
                intersection = rawIntersections[i];
                // Don't intersect with own line.
                if (data.showLine && intersection.object === el.getObject3D('line')) {
                  continue;
                }
                if (intersection.object.el) {
                  intersections.push(intersection);
                  intersectedEls.push(intersection.object.el);
                }
              }

              // Get newly intersected entities.
              newIntersections.length = 0;
              newIntersectedEls.length = 0;
              for (i = 0; i < intersections.length; i++) {
                if (prevIntersectedEls.indexOf(intersections[i].object.el) === -1) {
                  newIntersections.push(intersections[i]);
                  newIntersectedEls.push(intersections[i].object.el);
                }
              }

              // Emit intersection cleared on both entities per formerly intersected entity.
              clearedIntersectedEls.length = 0;
              for (i = 0; i < prevIntersectedEls.length; i++) {
                if (intersectedEls.indexOf(prevIntersectedEls[i]) !== -1) {
                  continue;
                }
                prevIntersectedEls[i].emit(EVENTS.INTERSECT_CLEAR, this.intersectedClearedDetail);
                clearedIntersectedEls.push(prevIntersectedEls[i]);
              }
              if (clearedIntersectedEls.length) {
                el.emit(EVENTS.INTERSECTION_CLEAR, this.intersectionClearedDetail);
              }

              // Emit intersected on intersected entity per intersected entity.
              for (i = 0; i < newIntersectedEls.length; i++) {
                newIntersectedEls[i].emit(EVENTS.INTERSECT, this.intersectedDetail);
              }

              // Emit all intersections at once on raycasting entity.
              if (newIntersections.length) {
                this.intersectionDetail.els = newIntersectedEls;
                this.intersectionDetail.intersections = newIntersections;
                el.emit(EVENTS.INTERSECTION, this.intersectionDetail);
              }

              // Emit event when the closest intersected entity has changed.
              if (prevIntersectedEls.length === 0 && intersections.length > 0 || prevIntersectedEls.length > 0 && intersections.length === 0 || prevIntersectedEls.length && intersections.length && prevIntersectedEls[0] !== intersections[0].object.el) {
                this.intersectionDetail.els = this.intersectedEls;
                this.intersectionDetail.intersections = intersections;
                el.emit(EVENTS.INTERSECTION_CLOSEST_ENTITY_CHANGED, this.intersectionDetail);
              }

              // Update line length.
              if (data.showLine) {
                setTimeout(this.updateLine);
              }
            },
            updateLine: function updateLine() {
              var el = this.el;
              var intersections = this.intersections;
              var lineLength;
              if (intersections.length) {
                if (intersections[0].object.el === el && intersections[1]) {
                  lineLength = intersections[1].distance;
                } else {
                  lineLength = intersections[0].distance;
                }
              }
              this.drawLine(lineLength);
            },
            /**
             * Return the most recent intersection details for a given entity, if any.
             * @param {AEntity} el
             * @return {Object}
             */
            getIntersection: function getIntersection(el) {
              var i;
              var intersection;
              for (i = 0; i < this.intersections.length; i++) {
                intersection = this.intersections[i];
                if (intersection.object.el === el) {
                  return intersection;
                }
              }
              return null;
            },
            /**
             * Update origin and direction of raycaster using entity transforms and supplied origin or
             * direction offsets.
             */
            updateOriginDirection: function () {
              var direction = new THREE.Vector3();
              var originVec3 = new THREE.Vector3();

              // Closure to make quaternion/vector3 objects private.
              return function updateOriginDirection() {
                var el = this.el;
                var data = this.data;
                if (data.useWorldCoordinates) {
                  this.raycaster.set(data.origin, data.direction);
                  return;
                }
                el.object3D.updateMatrixWorld();
                originVec3.setFromMatrixPosition(el.object3D.matrixWorld);

                // If non-zero origin, translate the origin into world space.
                if (data.origin.x !== 0 || data.origin.y !== 0 || data.origin.z !== 0) {
                  originVec3 = el.object3D.localToWorld(originVec3.copy(data.origin));
                }

                // three.js raycaster direction is relative to 0, 0, 0 NOT the origin / offset we
                // provide. Apply the offset to the direction, then rotation from the object,
                // and normalize.
                direction.copy(data.direction).transformDirection(el.object3D.matrixWorld).normalize();

                // Apply offset and direction, in world coordinates.
                this.raycaster.set(originVec3, direction);
              };
            }(),
            /**
             * Create or update line to give raycaster visual representation.
             * Customize the line through through line component.
             * We draw the line in the raycaster component to customize the line to the
             * raycaster's origin, direction, and far.
             *
             * Unlike the raycaster, we create the line as a child of the object. The line will
             * be affected by the transforms of the objects, so we don't have to calculate transforms
             * like we do with the raycaster.
             *
             * @param {number} length - Length of line. Pass in to shorten the line to the intersection
             *   point. If not provided, length will default to the max length, `raycaster.far`.
             */
            drawLine: function drawLine(length) {
              var data = this.data;
              var el = this.el;
              var endVec3;

              // Switch each time vector so line update triggered and to avoid unnecessary vector clone.
              endVec3 = this.lineData.end === this.lineEndVec3 ? this.otherLineEndVec3 : this.lineEndVec3;

              // Treat Infinity as 1000m for the line.
              if (length === undefined) {
                length = data.far === Infinity ? 1000 : data.far;
              }

              // Update the length of the line if given. `unitLineEndVec3` is the direction
              // given by data.direction, then we apply a scalar to give it a length.
              this.lineData.start = data.origin;
              this.lineData.end = endVec3.copy(this.unitLineEndVec3).multiplyScalar(length);
              this.lineData.color = data.lineColor;
              this.lineData.opacity = data.lineOpacity;
              el.setAttribute('line', this.lineData);
            },
            /**
             * Return A-Frame attachments of each element's object3D group (e.g., mesh).
             * Children are flattened by one level, removing the THREE.Group wrapper,
             * so that non-recursive raycasting remains useful.
             *
             * Only push children defined as component attachements (e.g., setObject3D),
             * NOT actual children in the scene graph hierarchy.
             *
             * @param  {Array<Element>} els
             * @return {Array<THREE.Object3D>}
             */
            flattenObject3DMaps: function flattenObject3DMaps(els) {
              var key;
              var i;
              var objects = this.objects;
              var scene = this.el.sceneEl.object3D;
              function isAttachedToScene(object) {
                if (object.parent) {
                  return isAttachedToScene(object.parent);
                } else {
                  return object === scene;
                }
              }

              // Push meshes and other attachments onto list of objects to intersect.
              objects.length = 0;
              for (i = 0; i < els.length; i++) {
                var el = els[i];
                if (el.isEntity && el.object3D && isAttachedToScene(el.object3D)) {
                  for (key in el.object3DMap) {
                    objects.push(el.getObject3D(key));
                  }
                }
              }
              return objects;
            },
            clearAllIntersections: function clearAllIntersections() {
              var i;
              for (i = 0; i < this.intersectedEls.length; i++) {
                this.intersectedEls[i].emit(EVENTS.INTERSECT_CLEAR, this.intersectedClearedDetail);
              }
              copyArray(this.clearedIntersectedEls, this.intersectedEls);
              this.intersectedEls.length = 0;
              this.intersections.length = 0;
              this.el.emit(EVENTS.INTERSECTION_CLEAR, this.intersectionClearedDetail);
            }
          });

          /**
           * Copy contents of one array to another without allocating new array.
           */
          function copyArray(a, b) {
            var i;
            a.length = b.length;
            for (i = 0; i < b.length; i++) {
              a[i] = b[i];
            }
          }

          /***/
        },

        /***/"./src/components/rotation.js":
        /*!************************************!*\
          !*** ./src/components/rotation.js ***!
          \************************************/
        /***/
        function srcComponentsRotationJs(module, __unused_webpack_exports, __webpack_require__) {
          var degToRad = __webpack_require__( /*! ../lib/three */"./src/lib/three.js").MathUtils.degToRad;
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          module.exports.Component = registerComponent('rotation', {
            schema: {
              type: 'vec3'
            },
            /**
             * Updates object3D rotation.
             */
            update: function update() {
              var data = this.data;
              var object3D = this.el.object3D;
              object3D.rotation.set(degToRad(data.x), degToRad(data.y), degToRad(data.z));
              object3D.rotation.order = 'YXZ';
            },
            remove: function remove() {
              // Pretty much for mixins.
              this.el.object3D.rotation.set(0, 0, 0);
            }
          });

          /***/
        },

        /***/"./src/components/scale.js":
        /*!*********************************!*\
          !*** ./src/components/scale.js ***!
          \*********************************/
        /***/
        function srcComponentsScaleJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;

          // Avoids triggering a zero-determinant which makes object3D matrix non-invertible.
          var zeroScale = 0.00001;
          module.exports.Component = registerComponent('scale', {
            schema: {
              type: 'vec3',
              default: {
                x: 1,
                y: 1,
                z: 1
              }
            },
            update: function update() {
              var data = this.data;
              var object3D = this.el.object3D;
              var x = data.x === 0 ? zeroScale : data.x;
              var y = data.y === 0 ? zeroScale : data.y;
              var z = data.z === 0 ? zeroScale : data.z;
              object3D.scale.set(x, y, z);
            },
            remove: function remove() {
              // Pretty much for mixins.
              this.el.object3D.scale.set(1, 1, 1);
            }
          });

          /***/
        },

        /***/"./src/components/scene/ar-hit-test.js":
        /*!*********************************************!*\
          !*** ./src/components/scene/ar-hit-test.js ***!
          \*********************************************/
        /***/
        function srcComponentsSceneArHitTestJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global ImageData, Map, Set */
          var arrowURL = 'data:image/webp;base64,UklGRkQHAABXRUJQVlA4WAoAAAAQAAAA/wEA/wEAQUxQSL0DAAARDzD/ERGCjrY9sYYFfgo6aa1kJ7K0w9Lo3AadLSVeFxevQwj5kuM8RfR/Atw/C0+ozB/oUBrloFZs6ElSW88j1KA4yExNWQaqRZquIDF0JYmlq0hAuUDTFu66tng3teW7pa3cQf1V1edvur54M/Slm6Wv3Gx9zw0MXlQLntcsBN6wkHjTQuYtC4W3LTw8mGRVG57TbAROtxHfZNhInGkjc5aNwtk2Hg6Mvki14k+NkZzCwQgCxalcAv3kddRTPI1DcUrXId1FLf1uHpzaQz4tquhZVLlKesbVpqKeTj0n0F5PpXDlFN9UqmhalL/ImuZFo6KmToWLoKlddMprqlS8cKovBvHo2kTiFV2LN4msaxKZl3QNiair8xYRdDWivIvXVXmbcMqJ51UebZuFXxZt6xd4laxtciqRtA3Cv0nU1t+kEUFbI8JvCa+tvkm3FDlO/W+OR99+kWEp/YYo+tYfTVnf/K8cE/F///3vv//993eeL+a+uvjawLcX3xjYvJotBFY3kVjTRGFtE+BU2AiMbiQyhpHMWEYeBozAH5qNBYRDB5KBCaTDBKKBAZTDBoKBDjwHAN5ABeCJBsAZcAAC0YHHxAYSMYBiYgGZWEA2MYFCbCCZGAAIANFEB+AnYgMQTDQAYSJ2AN5EBZAm4gDgTDgAeSIu4DGygTIRN1CMLOCZiACykQlg4jsAycgA8AO+BxCNdJyDkcbwRirDGXGnx8w+FDPrkM3MQ9JQZMYhiiwV/RDMtIM3U1/DmXHUo+IR2kSR2ToWkQ1NIn2qf2J8LCqJKiDUiSADHY3whirhdHgZ94HKaR97PhE+twEUJUFoAcgyTct8hfSxSkShASDKdMJ/ritKHwgyQ0sD4D/miCxU5SbhOOUDTnZpccCjYP/i0bZ/8bAgtVGEoGapWIQXyzKVKLwgNJFk2rtMIgoNRJlOZF7SNSSyUEeQmbxBFKEmtYjEe8S8zOZ1AkJVCmS88FJOtF40Ksg4oUaFiygk3C8qlTVNyl8UTevCUdAE2t14PfVqU1FPp57TopKeQZWromddTQp6QOfTOEQt/ZDuipZ11w/wOiqO8dRORcc6BQEkDQMClaHcn5wV9yLbxsNZNgpn2sicYSNxuo34Js1G4FQbnuNsOPa28PCWhcKbFjJvWEi8ZiHwqgXPcxbc5db33Cx95WboSzddX7yp+vyN0+eul7ZyN7Xlu64t3jVt4c5pc4JLV5EYupJE0xUknC4nOjVlmaYpyLit53HCQ0+ScnqceNcS5dzUkd0/CwMAVlA4IGADAAAQXwCdASoAAgACP8ne6Wy/tjCpqJ/IA/A5CWlu4XYBG/Pz8AfwD8APz//f3v8E1fuHZnxKYACtfuHZnxKYACrYTb5mOslhxu843ecbvON3nG7zjd3a0VCn7G1MABVxwH/Xd25gAK1+4dmfEpe2+PHhQaj75++riG6FuYACtfuHZnxKYACRrK3q9xO8Ss3uWKnMhs/rDF1hi6wxdYYusMXWGI5QRcCFDZog5OgqNlse1NDuz/UoFa/cOzPiUwAEsAOK4/nu5eZHK2tlXxJfNYlMABWv3Dsz4bvNJ5YA/LtxJ38SmAArX7h2Z8Sk5vdZUYv7mZPiUwAFa/cOzPh21s5OgZxf1mfEpemRyFr/rM+JS9noA/LtxJ38SmAAlUJIotzAASn6TjdhK+D3Dsz4dyvB7h2Z8O2tnJ0DOL+sz4lL2nKLT4lL/+iSLOocxq639w7M34MNZdm55uJ8v8ra2cpVZnxKTq2F3PN/cNksAfl24k7+JTAASqrD37h2Z7b1W+VtbOUqsz4lJ1bC7nm/uGyWAPy7cSd/EpgAJVVh79w7M9t6rfK2tnKVWZ8Sk6thdzzf3DZLAH5duJO/iUwAEqqw9+4dme29VvlbWzlKrM+JSdWwu55v7hslgD8u3EnfxKYACVVYe/cOzPbeq3ytrZylVme0kYJ8557FLerqFrzIbPrrf3DZLAH5duJO/iUvaVMS9BoaF4p7pSDFTP1XMyfElelrM0DOL+sz4eBJ13nV1OppBGPuKb4YzXQgq9uH19uS/0+JS9t9fr6ZUlQBelDG6GMgq97otb5QMPJwtKyBTbFp8Sl7b6/X0ykkawEOsgdiE6Fi0vb/Eve6xkwsmug0Z4nGNHQO8839bpTsjpz7SWIJxKagvd1QWMa6FYT1KEw3j4XDT6vJ9Xk+nyfT5Pq8n1eEmk5dinMM/9Fcfz4Z3Dsz3KD2dw7LxBRxKrqUUGQPH/7zxr1KIfNpLEJ0MZB2ITM/0Z2EFoh12NlXnEcpYcbvON3nG7zjd5xu84vfcNIAAP7+y8ceyzbVxkakPYY4lcr72fqOnDwipv+yxC71wAADBrjKnAAAAAAAAAAAAAAw7oNGHttqWONcoFN/2WIDc2pa6WVFtFYROlsaMaTXdcOjXHz93+YxAglKa4AAAAA=';
          var register = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../../lib/three */"./src/lib/three.js");
          var CAM_LAYER = 21;
          var applyPose = function () {
            var tempQuaternion = new THREE.Quaternion();
            var tempVec3 = new THREE.Vector3();
            function applyPose(pose, object3D, offset) {
              object3D.position.copy(pose.transform.position);
              object3D.quaternion.copy(pose.transform.orientation);
              tempVec3.copy(offset);
              tempQuaternion.copy(pose.transform.orientation);
              tempVec3.applyQuaternion(tempQuaternion);
              object3D.position.sub(tempVec3);
            }
            return applyPose;
          }();
          applyPose.tempFakePose = {
            transform: {
              orientation: new THREE.Quaternion(),
              position: new THREE.Vector3()
            }
          };

          /**
           * Class to handle hit-test from a single source
           *
           * For a normal space provide it as a space option
           * new HitTest(renderer, {
           *   space: viewerSpace
           * });
           *
           * this is also useful for the targetRaySpace of an XRInputSource
           *
           * It can also describe a transient input source like so:
           *
           * var profileToSupport = 'generic-touchscreen';
           * var transientHitTest = new HitTest(renderer, {
           *   profile: profileToSupport
           * });
           *
           * Where the profile matches an item in a type of controller, profiles matching 'generic-touchscreen'
           * will always be a transient input and as of 08/2021 all transient inputs are 'generic-touchscreen'
           *
           * @param {WebGLRenderer} renderer THREE.JS Renderer
           * @param {} hitTestSourceDetails The source information either as the information for a transient hit-test or a regular hit-test
           */
          function HitTest(renderer, hitTestSourceDetails) {
            this.renderer = renderer;
            this.xrHitTestSource = null;
            renderer.xr.addEventListener('sessionend', function () {
              this.xrHitTestSource = null;
            }.bind(this));
            renderer.xr.addEventListener('sessionstart', function () {
              this.sessionStart(hitTestSourceDetails);
            }.bind(this));
            if (this.renderer.xr.isPresenting) {
              this.sessionStart(hitTestSourceDetails);
            }
          }
          HitTest.prototype.previousFrameAnchors = new Set();
          HitTest.prototype.anchorToObject3D = new Map();
          function warnAboutHitTest(e) {
            console.warn(e.message);
            console.warn('Cannot requestHitTestSource Are you missing: webxr="optionalFeatures: hit-test;" from <a-scene>?');
          }
          HitTest.prototype.sessionStart = function sessionStart(hitTestSourceDetails) {
            this.session = this.renderer.xr.getSession();
            if (!('requestHitTestSource' in this.session)) {
              warnAboutHitTest({
                message: 'No requestHitTestSource on the session.'
              });
              return;
            }
            if (hitTestSourceDetails.space) {
              this.session.requestHitTestSource(hitTestSourceDetails).then(function (xrHitTestSource) {
                this.xrHitTestSource = xrHitTestSource;
              }.bind(this)).catch(warnAboutHitTest);
            } else if (hitTestSourceDetails.profile) {
              this.session.requestHitTestSourceForTransientInput(hitTestSourceDetails).then(function (xrHitTestSource) {
                this.xrHitTestSource = xrHitTestSource;
                this.transient = true;
              }.bind(this)).catch(warnAboutHitTest);
            }
          };

          /**
           * Turns the last hit test into an anchor, the provided Object3D will have it's
           * position update to track the anchor.
           *
           * @param {Object3D} object3D object to track
           * @param {Vector3} offset offset of the object from the origin that gets subtracted
           * @returns
           */
          HitTest.prototype.anchorFromLastHitTestResult = function (object3D, offset) {
            var hitTest = this.lastHitTest;
            if (!hitTest) {
              return;
            }
            var object3DOptions = {
              object3D: object3D,
              offset: offset
            };
            Array.from(this.anchorToObject3D.entries()).forEach(function (entry) {
              var entryObject = entry[1].object3D;
              var anchor = entry[0];
              if (entryObject === object3D) {
                this.anchorToObject3D.delete(anchor);
                anchor.delete();
              }
            }.bind(this));
            if (hitTest.createAnchor) {
              hitTest.createAnchor().then(function (anchor) {
                this.anchorToObject3D.set(anchor, object3DOptions);
              }.bind(this)).catch(function (e) {
                console.warn(e.message);
                console.warn('Cannot create anchor, are you missing: webxr="optionalFeatures: anchors;" from <a-scene>?');
              });
            }
          };
          HitTest.prototype.doHit = function doHit(frame) {
            if (!this.renderer.xr.isPresenting) {
              return;
            }
            var refSpace = this.renderer.xr.getReferenceSpace();
            var xrViewerPose = frame.getViewerPose(refSpace);
            var hitTestResults;
            var results;
            if (this.xrHitTestSource && xrViewerPose) {
              if (this.transient) {
                hitTestResults = frame.getHitTestResultsForTransientInput(this.xrHitTestSource);
                if (hitTestResults.length > 0) {
                  results = hitTestResults[0].results;
                  if (results.length > 0) {
                    this.lastHitTest = results[0];
                    return results[0].getPose(refSpace);
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              } else {
                hitTestResults = frame.getHitTestResults(this.xrHitTestSource);
                if (hitTestResults.length > 0) {
                  this.lastHitTest = hitTestResults[0];
                  return hitTestResults[0].getPose(refSpace);
                } else {
                  return false;
                }
              }
            }
          };

          // static function
          HitTest.updateAnchorPoses = function (frame, refSpace) {
            // If tracked anchors isn't defined because it's not supported then just use the empty set
            var trackedAnchors = frame.trackedAnchors || HitTest.prototype.previousFrameAnchors;
            HitTest.prototype.previousFrameAnchors.forEach(function (anchor) {
              // Handle anchor tracking loss - `anchor` was present
              // in the present frame but is no longer tracked.
              if (!trackedAnchors.has(anchor)) {
                HitTest.prototype.anchorToObject3D.delete(anchor);
              }
            });
            trackedAnchors.forEach(function (anchor) {
              var anchorPose;
              var object3DOptions;
              var offset;
              var object3D;
              try {
                // Query most recent pose of the anchor relative to some reference space:
                anchorPose = frame.getPose(anchor.anchorSpace, refSpace);
              } catch (e) {
                // This will fail if the anchor has been deleted that frame
              }
              if (anchorPose) {
                object3DOptions = HitTest.prototype.anchorToObject3D.get(anchor);
                offset = object3DOptions.offset;
                object3D = object3DOptions.object3D;
                applyPose(anchorPose, object3D, offset);
              }
            });
          };
          var hitTestCache;
          module.exports.Component = register('ar-hit-test', {
            schema: {
              target: {
                type: 'selector'
              },
              enabled: {
                default: true
              },
              src: {
                default: arrowURL,
                type: 'map'
              },
              type: {
                default: 'footprint',
                oneOf: ['footprint', 'map']
              },
              footprintDepth: {
                default: 0.1
              },
              mapSize: {
                type: 'vec2',
                default: {
                  x: 0.5,
                  y: 0.5
                }
              }
            },
            init: function init() {
              this.hitTest = null;
              this.imageDataArray = new Uint8ClampedArray(512 * 512 * 4);
              this.imageData = new ImageData(this.imageDataArray, 512, 512);
              this.textureCache = new Map();
              this.orthoCam = new THREE.OrthographicCamera();
              this.orthoCam.layers.set(CAM_LAYER);
              this.textureTarget = new THREE.WebGLRenderTarget(512, 512, {});
              this.basicMaterial = new THREE.MeshBasicMaterial({
                color: 0x000000,
                side: THREE.DoubleSide
              });
              this.canvas = document.createElement('canvas');
              this.context = this.canvas.getContext('2d');
              this.context.imageSmoothingEnabled = false;
              this.canvas.width = 512;
              this.canvas.height = 512;
              this.canvasTexture = new THREE.CanvasTexture(this.canvas, {
                alpha: true
              });
              this.canvasTexture.flipY = false;

              // Update WebXR to support hit-test and anchors
              var webxrData = this.el.getAttribute('webxr');
              var optionalFeaturesArray = webxrData.optionalFeatures;
              if (!optionalFeaturesArray.includes('hit-test') || !optionalFeaturesArray.includes('anchors')) {
                optionalFeaturesArray.push('hit-test');
                optionalFeaturesArray.push('anchors');
                this.el.setAttribute('webxr', webxrData);
              }
              this.el.sceneEl.renderer.xr.addEventListener('sessionend', function () {
                this.hitTest = null;
              }.bind(this));
              this.el.sceneEl.renderer.xr.addEventListener('sessionstart', function () {
                // Don't request Hit Test unless AR (breaks WebXR Emulator)
                if (!this.el.is('ar-mode')) {
                  return;
                }
                var renderer = this.el.sceneEl.renderer;
                var session = this.session = renderer.xr.getSession();
                this.hasPosedOnce = false;
                this.bboxMesh.visible = false;
                if (!hitTestCache) {
                  hitTestCache = new Map();
                }

                // Default to selecting through the face
                session.requestReferenceSpace('viewer').then(function (viewerSpace) {
                  this.hitTest = new HitTest(renderer, {
                    space: viewerSpace
                  });
                  hitTestCache.set(viewerSpace, this.hitTest);
                  this.el.emit('ar-hit-test-start');
                }.bind(this));

                // These are transient inputs so need to be handled seperately
                var profileToSupport = 'generic-touchscreen';
                var transientHitTest = new HitTest(renderer, {
                  profile: profileToSupport
                });
                session.addEventListener('selectstart', function (e) {
                  if (this.data.enabled !== true) {
                    return;
                  }
                  var inputSource = e.inputSource;
                  this.bboxMesh.visible = true;
                  if (this.hasPosedOnce === true) {
                    this.el.emit('ar-hit-test-select-start', {
                      inputSource: inputSource,
                      position: this.bboxMesh.position,
                      orientation: this.bboxMesh.quaternion
                    });
                    if (inputSource.profiles[0] === profileToSupport) {
                      this.hitTest = transientHitTest;
                    } else {
                      this.hitTest = hitTestCache.get(inputSource) || new HitTest(renderer, {
                        space: inputSource.targetRaySpace
                      });
                      hitTestCache.set(inputSource, this.hitTest);
                    }
                  }
                }.bind(this));
                session.addEventListener('selectend', function (e) {
                  if (!this.hitTest || this.data.enabled !== true) {
                    this.hitTest = null;
                    return;
                  }
                  var inputSource = e.inputSource;
                  var object;
                  if (this.hasPosedOnce === true) {
                    this.bboxMesh.visible = false;

                    // if we have a target with a 3D object then automatically generate an anchor for it.
                    if (this.data.target) {
                      object = this.data.target.object3D;
                      if (object) {
                        applyPose.tempFakePose.transform.position.copy(this.bboxMesh.position);
                        applyPose.tempFakePose.transform.orientation.copy(this.bboxMesh.quaternion);
                        applyPose(applyPose.tempFakePose, object, this.bboxOffset);
                        object.visible = true;

                        // create an anchor attatched to the object
                        this.hitTest.anchorFromLastHitTestResult(object, this.bboxOffset);
                      }
                    }
                    this.el.emit('ar-hit-test-select', {
                      inputSource: inputSource,
                      position: this.bboxMesh.position,
                      orientation: this.bboxMesh.quaternion
                    });
                  }
                  this.hitTest = null;
                }.bind(this));
              }.bind(this));
              this.bboxOffset = new THREE.Vector3();
              this.update = this.update.bind(this);
              this.makeBBox();
            },
            update: function update() {
              // If it is disabled it's cleaned up
              if (this.data.enabled === false) {
                this.hitTest = null;
                this.bboxMesh.visible = false;
              }
              if (this.data.target) {
                if (this.data.target.object3D) {
                  this.data.target.addEventListener('model-loaded', this.update);
                  this.data.target.object3D.layers.enable(CAM_LAYER);
                  this.data.target.object3D.traverse(function (child) {
                    child.layers.enable(CAM_LAYER);
                  });
                } else {
                  this.data.target.addEventListener('loaded', this.update, {
                    once: true
                  });
                }
              }
              this.bboxNeedsUpdate = true;
            },
            makeBBox: function makeBBox() {
              var geometry = new THREE.PlaneGeometry(1, 1);
              var material = new THREE.MeshBasicMaterial({
                transparent: true,
                color: 0xffffff
              });
              geometry.rotateX(-Math.PI / 2);
              geometry.rotateY(-Math.PI / 2);
              this.bbox = new THREE.Box3();
              this.bboxMesh = new THREE.Mesh(geometry, material);
              this.el.setObject3D('ar-hit-test', this.bboxMesh);
              this.bboxMesh.visible = false;
            },
            updateFootprint: function updateFootprint() {
              var tempImageData;
              var renderer = this.el.sceneEl.renderer;
              var oldRenderTarget, oldBackground;
              var isXREnabled = renderer.xr.enabled;
              this.bboxMesh.material.map = this.canvasTexture;
              this.bboxMesh.material.needsUpdate = true;
              this.orthoCam.rotation.set(-Math.PI / 2, 0, -Math.PI / 2);
              this.orthoCam.position.copy(this.bboxMesh.position);
              this.orthoCam.position.y -= this.bboxMesh.scale.y / 2;
              this.orthoCam.near = 0.1;
              this.orthoCam.far = this.orthoCam.near + this.data.footprintDepth * this.bboxMesh.scale.y;
              this.orthoCam.position.y += this.orthoCam.far;
              this.orthoCam.right = this.bboxMesh.scale.z / 2;
              this.orthoCam.left = -this.bboxMesh.scale.z / 2;
              this.orthoCam.top = this.bboxMesh.scale.x / 2;
              this.orthoCam.bottom = -this.bboxMesh.scale.x / 2;
              this.orthoCam.updateProjectionMatrix();
              oldRenderTarget = renderer.getRenderTarget();
              renderer.setRenderTarget(this.textureTarget);
              renderer.xr.enabled = false;
              oldBackground = this.el.object3D.background;
              this.el.object3D.overrideMaterial = this.basicMaterial;
              this.el.object3D.background = null;
              renderer.render(this.el.object3D, this.orthoCam);
              this.el.object3D.background = oldBackground;
              this.el.object3D.overrideMaterial = null;
              renderer.xr.enabled = isXREnabled;
              renderer.setRenderTarget(oldRenderTarget);
              renderer.readRenderTargetPixels(this.textureTarget, 0, 0, 512, 512, this.imageDataArray);
              this.context.putImageData(this.imageData, 0, 0);
              this.context.shadowColor = 'white';
              this.context.shadowBlur = 10;
              this.context.drawImage(this.canvas, 0, 0);
              tempImageData = this.context.getImageData(0, 0, 512, 512);
              for (var i = 0; i < 512 * 512; i++) {
                // if it's a little bit transparent but not opaque make it middle transparent
                if (tempImageData.data[i * 4 + 3] !== 0 && tempImageData.data[i * 4 + 3] !== 255) {
                  tempImageData.data[i * 4 + 3] = 128;
                }
              }
              this.context.putImageData(tempImageData, 0, 0);
              this.canvasTexture.needsUpdate = true;
            },
            tick: function tick() {
              var pose;
              var frame = this.el.sceneEl.frame;
              var renderer = this.el.sceneEl.renderer;
              if (frame) {
                // if we are in XR then update the positions of the objects attatched to anchors
                HitTest.updateAnchorPoses(frame, renderer.xr.getReferenceSpace());
              }
              if (this.bboxNeedsUpdate) {
                this.bboxNeedsUpdate = false;
                if (!this.data.target || this.data.type === 'map') {
                  var texture;
                  if (this.textureCache.has(this.data.src)) {
                    texture = this.textureCache.get(this.data.src);
                  } else {
                    texture = new THREE.TextureLoader().load(this.data.src);
                    this.textureCache.set(this.data.src, texture);
                  }
                  this.bboxMesh.material.map = texture;
                  this.bboxMesh.material.needsUpdate = true;
                }
                if (this.data.target && this.data.target.object3D) {
                  this.bbox.setFromObject(this.data.target.object3D);
                  this.bbox.getCenter(this.bboxMesh.position);
                  this.bbox.getSize(this.bboxMesh.scale);
                  if (this.data.type === 'footprint') {
                    // Add a little buffer for the footprint border
                    this.bboxMesh.scale.x *= 1.04;
                    this.bboxMesh.scale.z *= 1.04;
                    this.updateFootprint();
                  }
                  this.bboxMesh.position.y -= this.bboxMesh.scale.y / 2;
                  this.bboxOffset.copy(this.bboxMesh.position);
                  this.bboxOffset.sub(this.data.target.object3D.position);
                } else {
                  this.bboxMesh.scale.set(this.data.mapSize.x, 1, this.data.mapSize.y);
                }
              }
              if (this.hitTest) {
                pose = this.hitTest.doHit(frame);
                if (pose) {
                  if (this.hasPosedOnce !== true) {
                    this.hasPosedOnce = true;
                    this.el.emit('ar-hit-test-achieved');
                  }
                  this.bboxMesh.visible = true;
                  this.bboxMesh.position.copy(pose.transform.position);
                  this.bboxMesh.quaternion.copy(pose.transform.orientation);
                }
              }
            }
          });

          /***/
        },

        /***/"./src/components/scene/background.js":
        /*!********************************************!*\
          !*** ./src/components/scene/background.js ***!
          \********************************************/
        /***/
        function srcComponentsSceneBackgroundJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE */
          var register = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var COMPONENTS = __webpack_require__( /*! ../../core/component */"./src/core/component.js").components;
          module.exports.Component = register('background', {
            schema: {
              color: {
                type: 'color',
                default: 'black'
              },
              transparent: {
                default: false
              }
            },
            update: function update() {
              var data = this.data;
              var object3D = this.el.object3D;
              if (data.transparent) {
                object3D.background = null;
              } else {
                object3D.background = new THREE.Color(data.color);
              }
            },
            remove: function remove() {
              var data = this.data;
              var object3D = this.el.object3D;
              if (data.transparent) {
                object3D.background = null;
                return;
              }
              object3D.background = COMPONENTS[this.name].schema.color.default;
            }
          });

          /***/
        },

        /***/"./src/components/scene/debug.js":
        /*!***************************************!*\
          !*** ./src/components/scene/debug.js ***!
          \***************************************/
        /***/
        function srcComponentsSceneDebugJs(module, __unused_webpack_exports, __webpack_require__) {
          var register = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          module.exports.Component = register('debug', {
            schema: {
              default: true
            }
          });

          /***/
        },

        /***/"./src/components/scene/device-orientation-permission-ui.js":
        /*!******************************************************************!*\
          !*** ./src/components/scene/device-orientation-permission-ui.js ***!
          \******************************************************************/
        /***/
        function srcComponentsSceneDeviceOrientationPermissionUiJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global DeviceOrientationEvent, location  */
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");
          var bind = utils.bind;
          var constants = __webpack_require__( /*! ../../constants/ */"./src/constants/index.js");
          var MODAL_CLASS = 'a-modal';
          var DIALOG_CLASS = 'a-dialog';
          var DIALOG_TEXT_CLASS = 'a-dialog-text';
          var DIALOG_TEXT_CONTAINER_CLASS = 'a-dialog-text-container';
          var DIALOG_BUTTONS_CONTAINER_CLASS = 'a-dialog-buttons-container';
          var DIALOG_BUTTON_CLASS = 'a-dialog-button';
          var DIALOG_ALLOW_BUTTON_CLASS = 'a-dialog-allow-button';
          var DIALOG_DENY_BUTTON_CLASS = 'a-dialog-deny-button';
          var DIALOG_OK_BUTTON_CLASS = 'a-dialog-ok-button';

          /**
           * UI for enabling device motion permission
           */
          module.exports.Component = registerComponent('device-orientation-permission-ui', {
            schema: {
              enabled: {
                default: true
              },
              deviceMotionMessage: {
                default: 'This immersive website requires access to your device motion sensors.'
              },
              httpsMessage: {
                default: 'Access this site over HTTPS to enter VR mode and grant access to the device sensors.'
              },
              denyButtonText: {
                default: 'Deny'
              },
              allowButtonText: {
                default: 'Allow'
              },
              cancelButtonText: {
                default: 'Cancel'
              }
            },
            init: function init() {
              var self = this;
              if (!this.data.enabled) {
                return;
              }
              if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1' && location.protocol === 'http:') {
                this.showHTTPAlert();
              }

              // Browser doesn't support or doesn't require permission to DeviceOrientationEvent API.
              if (typeof DeviceOrientationEvent === 'undefined' || !DeviceOrientationEvent.requestPermission) {
                this.permissionGranted = true;
                return;
              }
              this.onDeviceMotionDialogAllowClicked = bind(this.onDeviceMotionDialogAllowClicked, this);
              this.onDeviceMotionDialogDenyClicked = bind(this.onDeviceMotionDialogDenyClicked, this);
              // Show dialog only if permission has not yet been granted.
              DeviceOrientationEvent.requestPermission().then(function () {
                self.el.emit('deviceorientationpermissiongranted');
                self.permissionGranted = true;
              }).catch(function () {
                self.devicePermissionDialogEl = createPermissionDialog(self.data.denyButtonText, self.data.allowButtonText, self.data.deviceMotionMessage, self.onDeviceMotionDialogAllowClicked, self.onDeviceMotionDialogDenyClicked);
                self.el.appendChild(self.devicePermissionDialogEl);
              });
            },
            remove: function remove() {
              // This removes the modal screen
              if (this.devicePermissionDialogEl) {
                this.el.removeChild(this.devicePermissionDialogEl);
              }
            },
            onDeviceMotionDialogDenyClicked: function onDeviceMotionDialogDenyClicked() {
              this.remove();
            },
            showHTTPAlert: function showHTTPAlert() {
              var self = this;
              var httpAlertEl = createAlertDialog(self.data.cancelButtonText, self.data.httpsMessage, function () {
                self.el.removeChild(httpAlertEl);
              });
              this.el.appendChild(httpAlertEl);
            },
            /**
             * Enable device motion permission when clicked.
             */
            onDeviceMotionDialogAllowClicked: function onDeviceMotionDialogAllowClicked() {
              var self = this;
              this.el.emit('deviceorientationpermissionrequested');
              DeviceOrientationEvent.requestPermission().then(function (response) {
                if (response === 'granted') {
                  self.el.emit('deviceorientationpermissiongranted');
                  self.permissionGranted = true;
                } else {
                  self.el.emit('deviceorientationpermissionrejected');
                }
                self.remove();
              }).catch(console.error);
            }
          });

          /**
           * Create a modal dialog that request users permission to access the Device Motion API.
           *
           * @param {function} onAllowClicked - click event handler
           * @param {function} onDenyClicked - click event handler
           *
           * @returns {Element} Wrapper <div>.
           */
          function createPermissionDialog(denyText, allowText, dialogText, onAllowClicked, onDenyClicked) {
            var buttonsContainer;
            var denyButton;
            var acceptButton;
            buttonsContainer = document.createElement('div');
            buttonsContainer.classList.add(DIALOG_BUTTONS_CONTAINER_CLASS);

            // Buttons
            denyButton = document.createElement('button');
            denyButton.classList.add(DIALOG_BUTTON_CLASS, DIALOG_DENY_BUTTON_CLASS);
            denyButton.setAttribute(constants.AFRAME_INJECTED, '');
            denyButton.innerHTML = denyText;
            buttonsContainer.appendChild(denyButton);
            acceptButton = document.createElement('button');
            acceptButton.classList.add(DIALOG_BUTTON_CLASS, DIALOG_ALLOW_BUTTON_CLASS);
            acceptButton.setAttribute(constants.AFRAME_INJECTED, '');
            acceptButton.innerHTML = allowText;
            buttonsContainer.appendChild(acceptButton);

            // Ask for sensor events to be used
            acceptButton.addEventListener('click', function (evt) {
              evt.stopPropagation();
              onAllowClicked();
            });
            denyButton.addEventListener('click', function (evt) {
              evt.stopPropagation();
              onDenyClicked();
            });
            return createDialog(dialogText, buttonsContainer);
          }
          function createAlertDialog(closeText, dialogText, onOkClicked) {
            var buttonsContainer;
            var okButton;
            buttonsContainer = document.createElement('div');
            buttonsContainer.classList.add(DIALOG_BUTTONS_CONTAINER_CLASS);

            // Buttons
            okButton = document.createElement('button');
            okButton.classList.add(DIALOG_BUTTON_CLASS, DIALOG_OK_BUTTON_CLASS);
            okButton.setAttribute(constants.AFRAME_INJECTED, '');
            okButton.innerHTML = closeText;
            buttonsContainer.appendChild(okButton);

            // Ask for sensor events to be used
            okButton.addEventListener('click', function (evt) {
              evt.stopPropagation();
              onOkClicked();
            });
            return createDialog(dialogText, buttonsContainer);
          }
          function createDialog(text, buttonsContainerEl) {
            var modalContainer;
            var dialog;
            var dialogTextContainer;
            var dialogText;
            modalContainer = document.createElement('div');
            modalContainer.classList.add(MODAL_CLASS);
            modalContainer.setAttribute(constants.AFRAME_INJECTED, '');
            dialog = document.createElement('div');
            dialog.className = DIALOG_CLASS;
            dialog.setAttribute(constants.AFRAME_INJECTED, '');
            modalContainer.appendChild(dialog);
            dialogTextContainer = document.createElement('div');
            dialogTextContainer.classList.add(DIALOG_TEXT_CONTAINER_CLASS);
            dialog.appendChild(dialogTextContainer);
            dialogText = document.createElement('div');
            dialogText.classList.add(DIALOG_TEXT_CLASS);
            dialogText.innerHTML = text;
            dialogTextContainer.appendChild(dialogText);
            dialog.appendChild(buttonsContainerEl);
            return modalContainer;
          }

          /***/
        },

        /***/"./src/components/scene/embedded.js":
        /*!******************************************!*\
          !*** ./src/components/scene/embedded.js ***!
          \******************************************/
        /***/
        function srcComponentsSceneEmbeddedJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;

          /**
           * Component to embed an a-frame scene within the layout of a 2D page.
           */
          module.exports.Component = registerComponent('embedded', {
            dependencies: ['vr-mode-ui'],
            schema: {
              default: true
            },
            update: function update() {
              var sceneEl = this.el;
              var enterVREl = sceneEl.querySelector('.a-enter-vr');
              if (this.data === true) {
                if (enterVREl) {
                  enterVREl.classList.add('embedded');
                }
                sceneEl.removeFullScreenStyles();
              } else {
                if (enterVREl) {
                  enterVREl.classList.remove('embedded');
                }
                sceneEl.addFullScreenStyles();
              }
            }
          });

          /***/
        },

        /***/"./src/components/scene/fog.js":
        /*!*************************************!*\
          !*** ./src/components/scene/fog.js ***!
          \*************************************/
        /***/
        function srcComponentsSceneFogJs(module, __unused_webpack_exports, __webpack_require__) {
          var register = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../../lib/three */"./src/lib/three.js");
          var debug = __webpack_require__( /*! ../../utils/debug */"./src/utils/debug.js");
          var warn = debug('components:fog:warn');

          /**
           * Fog component.
           * Applies only to the scene entity.
           */
          module.exports.Component = register('fog', {
            schema: {
              color: {
                type: 'color',
                default: '#000'
              },
              density: {
                default: 0.00025
              },
              far: {
                default: 1000,
                min: 0
              },
              near: {
                default: 1,
                min: 0
              },
              type: {
                default: 'linear',
                oneOf: ['linear', 'exponential']
              }
            },
            update: function update() {
              var data = this.data;
              var el = this.el;
              var fog = this.el.object3D.fog;
              if (!el.isScene) {
                warn('Fog component can only be applied to <a-scene>');
                return;
              }

              // (Re)create fog if fog doesn't exist or fog type changed.
              if (!fog || data.type !== fog.name) {
                el.object3D.fog = getFog(data);
                el.systems.material.updateMaterials();
                return;
              }

              // Fog data changed. Update fog.
              Object.keys(this.schema).forEach(function (key) {
                var value = data[key];
                if (key === 'color') {
                  value = new THREE.Color(value);
                }
                fog[key] = value;
              });
            },
            /**
             * Remove fog on remove (callback).
             */
            remove: function remove() {
              var fog = this.el.object3D.fog;
              if (!fog) {
                return;
              }
              fog.far = 0;
              fog.near = 0.1;
            }
          });

          /**
           * Creates a fog object. Sets fog.name to be able to detect fog type changes.
           *
           * @param {object} data - Fog data.
           * @returns {object} fog
           */
          function getFog(data) {
            var fog;
            if (data.type === 'exponential') {
              fog = new THREE.FogExp2(data.color, data.density);
            } else {
              fog = new THREE.Fog(data.color, data.near, data.far);
            }
            fog.name = data.type;
            return fog;
          }

          /***/
        },

        /***/"./src/components/scene/inspector.js":
        /*!*******************************************!*\
          !*** ./src/components/scene/inspector.js ***!
          \*******************************************/
        /***/
        function srcComponentsSceneInspectorJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global AFRAME */
          var AFRAME_INJECTED = __webpack_require__( /*! ../../constants */"./src/constants/index.js").AFRAME_INJECTED;
          var pkg = __webpack_require__( /*! ../../../package */"./package.json");
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");

          /**
           * 0.4.2 to 0.4.x
           * Will need to update this when A-Frame goes to 1.x.x.
           */
          function getFuzzyPatchVersion(version) {
            var split = version.split('.');
            split[2] = 'x';
            return split.join('.');
          }
          var INSPECTOR_DEV_URL = 'https://aframe.io/aframe-inspector/dist/aframe-inspector.js';
          var INSPECTOR_RELEASE_URL = 'https://unpkg.com/aframe-inspector@' + getFuzzyPatchVersion(pkg.version) + '/dist/aframe-inspector.min.js';
          var INSPECTOR_URL = false ? 0 : INSPECTOR_RELEASE_URL;
          var LOADING_MESSAGE = 'Loading Inspector';
          var LOADING_ERROR_MESSAGE = 'Error loading Inspector';
          module.exports.Component = registerComponent('inspector', {
            schema: {
              url: {
                default: INSPECTOR_URL
              }
            },
            init: function init() {
              this.firstPlay = true;
              this.onKeydown = this.onKeydown.bind(this);
              this.onMessage = this.onMessage.bind(this);
              this.initOverlay();
              window.addEventListener('keydown', this.onKeydown);
              window.addEventListener('message', this.onMessage);
            },
            play: function play() {
              var urlParam;
              if (!this.firstPlay) {
                return;
              }
              urlParam = utils.getUrlParameter('inspector');
              if (urlParam !== 'false' && !!urlParam) {
                this.openInspector();
                this.firstPlay = false;
              }
            },
            initOverlay: function initOverlay() {
              var dotsHTML = '<span class="dots"><span>.</span><span>.</span><span>.</span></span>';
              this.loadingMessageEl = document.createElement('div');
              this.loadingMessageEl.classList.add('a-inspector-loader');
              this.loadingMessageEl.innerHTML = LOADING_MESSAGE + dotsHTML;
            },
            remove: function remove() {
              this.removeEventListeners();
            },
            /**
             * <ctrl> + <alt> + i keyboard shortcut.
             */
            onKeydown: function onKeydown(evt) {
              var shortcutPressed = evt.keyCode === 73 && (evt.ctrlKey && evt.altKey || evt.getModifierState('AltGraph'));
              if (!shortcutPressed) {
                return;
              }
              this.openInspector();
            },
            showLoader: function showLoader() {
              document.body.appendChild(this.loadingMessageEl);
            },
            hideLoader: function hideLoader() {
              document.body.removeChild(this.loadingMessageEl);
            },
            /**
             * postMessage. aframe.io uses this to create a button on examples to open Inspector.
             */
            onMessage: function onMessage(evt) {
              if (evt.data === 'INJECT_AFRAME_INSPECTOR') {
                this.openInspector();
              }
            },
            openInspector: function openInspector(focusEl) {
              var self = this;
              var script;

              // Already injected. Open.
              if (AFRAME.INSPECTOR || AFRAME.inspectorInjected) {
                AFRAME.INSPECTOR.open(focusEl);
                return;
              }
              this.showLoader();

              // Inject.
              script = document.createElement('script');
              script.src = this.data.url;
              script.setAttribute('data-name', 'aframe-inspector');
              script.setAttribute(AFRAME_INJECTED, '');
              script.onload = function () {
                AFRAME.INSPECTOR.open(focusEl);
                self.hideLoader();
                self.removeEventListeners();
              };
              script.onerror = function () {
                self.loadingMessageEl.innerHTML = LOADING_ERROR_MESSAGE;
              };
              document.head.appendChild(script);
              AFRAME.inspectorInjected = true;
            },
            removeEventListeners: function removeEventListeners() {
              window.removeEventListener('keydown', this.onKeydown);
              window.removeEventListener('message', this.onMessage);
            }
          });

          /***/
        },

        /***/"./src/components/scene/keyboard-shortcuts.js":
        /*!****************************************************!*\
          !*** ./src/components/scene/keyboard-shortcuts.js ***!
          \****************************************************/
        /***/
        function srcComponentsSceneKeyboardShortcutsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var shouldCaptureKeyEvent = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js").shouldCaptureKeyEvent;
          module.exports.Component = registerComponent('keyboard-shortcuts', {
            schema: {
              enterVR: {
                default: true
              },
              exitVR: {
                default: true
              }
            },
            init: function init() {
              this.onKeyup = this.onKeyup.bind(this);
            },
            update: function update(oldData) {
              var data = this.data;
              this.enterVREnabled = data.enterVR;
            },
            play: function play() {
              window.addEventListener('keyup', this.onKeyup, false);
            },
            pause: function pause() {
              window.removeEventListener('keyup', this.onKeyup);
            },
            onKeyup: function onKeyup(evt) {
              var scene = this.el;
              if (!shouldCaptureKeyEvent(evt)) {
                return;
              }
              if (this.enterVREnabled && evt.keyCode === 70) {
                // f.
                scene.enterVR();
              }
              if (this.enterVREnabled && evt.keyCode === 27) {
                // escape.
                scene.exitVR();
              }
            }
          });

          /***/
        },

        /***/"./src/components/scene/pool.js":
        /*!**************************************!*\
          !*** ./src/components/scene/pool.js ***!
          \**************************************/
        /***/
        function srcComponentsScenePoolJs(module, __unused_webpack_exports, __webpack_require__) {
          var debug = __webpack_require__( /*! ../../utils/debug */"./src/utils/debug.js");
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var warn = debug('components:pool:warn');

          /**
           * Pool component to reuse entities.
           * Avoids creating and destroying the same kind of entities.
           * Helps reduce GC pauses. For example in a game to reuse enemies entities.
           *
           * @member {array} availableEls - Available entities in the pool.
           * @member {array} usedEls - Entities of the pool in use.
           */
          module.exports.Component = registerComponent('pool', {
            schema: {
              container: {
                default: ''
              },
              mixin: {
                default: ''
              },
              size: {
                default: 0
              },
              dynamic: {
                default: false
              }
            },
            multiple: true,
            initPool: function initPool() {
              var i;
              this.availableEls = [];
              this.usedEls = [];
              if (!this.data.mixin) {
                warn('No mixin provided for pool component.');
              }
              if (this.data.container) {
                this.container = document.querySelector(this.data.container);
                if (!this.container) {
                  warn('Container ' + this.data.container + ' not found.');
                }
              }
              this.container = this.container || this.el;
              for (i = 0; i < this.data.size; ++i) {
                this.createEntity();
              }
            },
            update: function update(oldData) {
              var data = this.data;
              if (oldData.mixin !== data.mixin || oldData.size !== data.size) {
                this.initPool();
              }
            },
            /**
             * Add a new entity to the list of available entities.
             */
            createEntity: function createEntity() {
              var el;
              el = document.createElement('a-entity');
              el.play = this.wrapPlay(el.play);
              el.setAttribute('mixin', this.data.mixin);
              el.object3D.visible = false;
              el.pause();
              this.container.appendChild(el);
              this.availableEls.push(el);
              var usedEls = this.usedEls;
              el.addEventListener('loaded', function () {
                if (usedEls.indexOf(el) !== -1) {
                  return;
                }
                el.object3DParent = el.object3D.parent;
                el.object3D.parent.remove(el.object3D);
              });
            },
            /**
             * Play wrapper for pooled entities. When pausing and playing a scene, don't want to play
             * entities that are not in use.
             */
            wrapPlay: function wrapPlay(playMethod) {
              var usedEls = this.usedEls;
              return function () {
                if (usedEls.indexOf(this) === -1) {
                  return;
                }
                playMethod.call(this);
              };
            },
            /**
             * Used to request one of the available entities of the pool.
             */
            requestEntity: function requestEntity() {
              var el;
              if (this.availableEls.length === 0) {
                if (this.data.dynamic === false) {
                  warn('Requested entity from empty pool: ' + this.attrName);
                  return;
                } else {
                  warn('Requested entity from empty pool. This pool is dynamic and will resize ' + 'automatically. You might want to increase its initial size: ' + this.attrName);
                }
                this.createEntity();
              }
              el = this.availableEls.shift();
              this.usedEls.push(el);
              if (el.object3DParent) {
                el.object3DParent.add(el.object3D);
                this.updateRaycasters();
              }
              el.object3D.visible = true;
              return el;
            },
            /**
             * Used to return a used entity to the pool.
             */
            returnEntity: function returnEntity(el) {
              var index = this.usedEls.indexOf(el);
              if (index === -1) {
                warn('The returned entity was not previously pooled from ' + this.attrName);
                return;
              }
              this.usedEls.splice(index, 1);
              this.availableEls.push(el);
              el.object3DParent = el.object3D.parent;
              el.object3D.parent.remove(el.object3D);
              this.updateRaycasters();
              el.object3D.visible = false;
              el.pause();
              return el;
            },
            updateRaycasters: function updateRaycasters() {
              var raycasterEls = document.querySelectorAll('[raycaster]');
              raycasterEls.forEach(function (el) {
                el.components['raycaster'].setDirty();
              });
            }
          });

          /***/
        },

        /***/"./src/components/scene/reflection.js":
        /*!********************************************!*\
          !*** ./src/components/scene/reflection.js ***!
          \********************************************/
        /***/
        function srcComponentsSceneReflectionJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE, XRWebGLBinding */
          var register = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;

          // source: view-source:https://storage.googleapis.com/chromium-webxr-test/r886480/proposals/lighting-estimation.html
          function updateLights(estimate, probeLight, directionalLight, directionalLightPosition) {
            var intensityScalar = Math.max(estimate.primaryLightIntensity.x, Math.max(estimate.primaryLightIntensity.y, estimate.primaryLightIntensity.z));
            probeLight.sh.fromArray(estimate.sphericalHarmonicsCoefficients);
            probeLight.intensity = 1;
            if (directionalLight) {
              directionalLight.color.setRGB(estimate.primaryLightIntensity.x / intensityScalar, estimate.primaryLightIntensity.y / intensityScalar, estimate.primaryLightIntensity.z / intensityScalar);
              directionalLight.intensity = intensityScalar;
              directionalLightPosition.copy(estimate.primaryLightDirection);
            }
          }
          module.exports.Component = register('reflection', {
            schema: {
              directionalLight: {
                type: 'selector'
              }
            },
            init: function init() {
              var self = this;
              this.cubeRenderTarget = new THREE.WebGLCubeRenderTarget(16);
              this.cubeCamera = new THREE.CubeCamera(0.1, 1000, this.cubeRenderTarget);
              this.lightingEstimationTexture = new THREE.WebGLCubeRenderTarget(16).texture;
              this.needsVREnvironmentUpdate = true;

              // Update WebXR to support light-estimation
              var webxrData = this.el.getAttribute('webxr');
              var optionalFeaturesArray = webxrData.optionalFeatures;
              if (!optionalFeaturesArray.includes('light-estimation')) {
                optionalFeaturesArray.push('light-estimation');
                this.el.setAttribute('webxr', webxrData);
              }
              this.el.addEventListener('enter-vr', function () {
                var renderer = self.el.renderer;
                var session = renderer.xr.getSession();
                if (session.requestLightProbe && self.el.is('ar-mode')) {
                  self.startLightProbe();
                }
              });
              this.el.addEventListener('exit-vr', function () {
                self.stopLightProbe();
              });
              this.el.object3D.environment = this.cubeRenderTarget.texture;
            },
            stopLightProbe: function stopLightProbe() {
              this.xrLightProbe = null;
              if (this.probeLight) {
                this.probeLight.components.light.light.intensity = 0;
              }
              this.needsVREnvironmentUpdate = true;
              this.el.object3D.environment = this.cubeRenderTarget.texture;
            },
            startLightProbe: function startLightProbe() {
              this.needsLightProbeUpdate = true;
            },
            setupLightProbe: function setupLightProbe() {
              var renderer = this.el.renderer;
              var xrSession = renderer.xr.getSession();
              var self = this;
              var gl = renderer.getContext();
              if (!this.probeLight) {
                var probeLight = document.createElement('a-light');
                probeLight.setAttribute('type', 'probe');
                probeLight.setAttribute('intensity', 0);
                this.el.appendChild(probeLight);
                this.probeLight = probeLight;
              }

              // Ensure that we have any extensions needed to use the preferred cube map format.
              switch (xrSession.preferredReflectionFormat) {
                case 'srgba8':
                  gl.getExtension('EXT_sRGB');
                  break;
                case 'rgba16f':
                  gl.getExtension('OES_texture_half_float');
                  break;
              }
              this.glBinding = new XRWebGLBinding(xrSession, gl);
              gl.getExtension('EXT_sRGB');
              gl.getExtension('OES_texture_half_float');
              xrSession.requestLightProbe().then(function (lightProbe) {
                self.xrLightProbe = lightProbe;
                lightProbe.addEventListener('reflectionchange', self.updateXRCubeMap.bind(self));
              }).catch(function (err) {
                console.warn('Lighting estimation not supported: ' + err.message);
                console.warn('Are you missing: webxr="optionalFeatures: light-estimation;" from <a-scene>?');
              });
            },
            updateXRCubeMap: function updateXRCubeMap() {
              // Update Cube Map, cubeMap maybe some unavailable on some hardware
              var renderer = this.el.renderer;
              var cubeMap = this.glBinding.getReflectionCubeMap(this.xrLightProbe);
              if (cubeMap) {
                var rendererProps = renderer.properties.get(this.lightingEstimationTexture);
                rendererProps.__webglTexture = cubeMap;
                this.lightingEstimationTexture.needsPMREMUpdate = true;
                this.el.object3D.environment = this.lightingEstimationTexture;
              }
            },
            tick: function tick() {
              var scene = this.el.object3D;
              var renderer = this.el.renderer;
              var frame = this.el.frame;
              if (frame && this.xrLightProbe) {
                // light estimate may not yet be available, it takes a few frames to start working
                var estimate = frame.getLightEstimate(this.xrLightProbe);
                if (estimate) {
                  updateLights(estimate, this.probeLight.components.light.light, this.data.directionalLight && this.data.directionalLight.components.light.light, this.data.directionalLight && this.data.directionalLight.object3D.position);
                }
              }
              if (this.needsVREnvironmentUpdate) {
                scene.environment = null;
                this.needsVREnvironmentUpdate = false;
                this.cubeCamera.position.set(0, 1.6, 0);
                this.cubeCamera.update(renderer, scene);
                scene.environment = this.cubeRenderTarget.texture;
              }
              if (this.needsLightProbeUpdate && frame) {
                // wait until the XR Session has started before trying to make
                // the light probe
                this.setupLightProbe();
                this.needsLightProbeUpdate = false;
              }
            },
            remove: function remove() {
              this.el.object3D.environment = null;
              if (this.probeLight) {
                this.el.removeChild(this.probeLight);
              }
            }
          });

          /***/
        },

        /***/"./src/components/scene/screenshot.js":
        /*!********************************************!*\
          !*** ./src/components/scene/screenshot.js ***!
          \********************************************/
        /***/
        function srcComponentsSceneScreenshotJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global ImageData, URL */
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../../lib/three */"./src/lib/three.js");
          var VERTEX_SHADER = ['attribute vec3 position;', 'attribute vec2 uv;', 'uniform mat4 projectionMatrix;', 'uniform mat4 modelViewMatrix;', 'varying vec2 vUv;', 'void main()  {', '  vUv = vec2( 1.- uv.x, uv.y );', '  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n');
          var FRAGMENT_SHADER = ['precision mediump float;', 'uniform samplerCube map;', 'varying vec2 vUv;', '#define M_PI 3.141592653589793238462643383279', 'void main() {', '  vec2 uv = vUv;', '  float longitude = uv.x * 2. * M_PI - M_PI + M_PI / 2.;', '  float latitude = uv.y * M_PI;', '  vec3 dir = vec3(', '    - sin( longitude ) * sin( latitude ),', '    cos( latitude ),', '    - cos( longitude ) * sin( latitude )', '  );', '  normalize( dir );', '  gl_FragColor = vec4( textureCube( map, dir ).rgb, 1.0 );', '}'].join('\n');

          /**
           * Component to take screenshots of the scene using a keboard shortcut (alt+s).
           * It can be configured to either take 360&deg; captures (`equirectangular`)
           * or regular screenshots (`projection`)
           *
           * This is based on https://github.com/spite/THREE.CubemapToEquirectangular
           * To capture an equirectangular projection of the scene a THREE.CubeCamera is used
           * The cube map produced by the CubeCamera is projected on a quad and then rendered to
           * WebGLRenderTarget with an ortographic camera.
           */
          module.exports.Component = registerComponent('screenshot', {
            schema: {
              width: {
                default: 4096
              },
              height: {
                default: 2048
              },
              camera: {
                type: 'selector'
              }
            },
            init: function init() {
              var el = this.el;
              var self = this;
              if (el.renderer) {
                setup();
              } else {
                el.addEventListener('render-target-loaded', setup);
              }
              function setup() {
                var gl = el.renderer.getContext();
                if (!gl) {
                  return;
                }
                self.cubeMapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
                self.material = new THREE.RawShaderMaterial({
                  uniforms: {
                    map: {
                      type: 't',
                      value: null
                    }
                  },
                  vertexShader: VERTEX_SHADER,
                  fragmentShader: FRAGMENT_SHADER,
                  side: THREE.DoubleSide
                });
                self.quad = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), self.material);
                self.quad.visible = false;
                self.camera = new THREE.OrthographicCamera(-1 / 2, 1 / 2, 1 / 2, -1 / 2, -10000, 10000);
                self.canvas = document.createElement('canvas');
                self.ctx = self.canvas.getContext('2d');
                el.object3D.add(self.quad);
                self.onKeyDown = self.onKeyDown.bind(self);
              }
            },
            getRenderTarget: function getRenderTarget(width, height) {
              return new THREE.WebGLRenderTarget(width, height, {
                encoding: this.el.sceneEl.renderer.outputEncoding,
                minFilter: THREE.LinearFilter,
                magFilter: THREE.LinearFilter,
                wrapS: THREE.ClampToEdgeWrapping,
                wrapT: THREE.ClampToEdgeWrapping,
                format: THREE.RGBAFormat,
                type: THREE.UnsignedByteType
              });
            },
            resize: function resize(width, height) {
              // Resize quad.
              this.quad.scale.set(width, height, 1);

              // Resize camera.
              this.camera.left = -1 * width / 2;
              this.camera.right = width / 2;
              this.camera.top = height / 2;
              this.camera.bottom = -1 * height / 2;
              this.camera.updateProjectionMatrix();

              // Resize canvas.
              this.canvas.width = width;
              this.canvas.height = height;
            },
            play: function play() {
              window.addEventListener('keydown', this.onKeyDown);
            },
            /**
             * <ctrl> + <alt> + s = Regular screenshot.
             * <ctrl> + <alt> + <shift> + s = Equirectangular screenshot.
            */
            onKeyDown: function onKeyDown(evt) {
              var shortcutPressed = evt.keyCode === 83 && evt.ctrlKey && evt.altKey;
              if (!this.data || !shortcutPressed) {
                return;
              }
              var projection = evt.shiftKey ? 'equirectangular' : 'perspective';
              this.capture(projection);
            },
            /**
             * Capture a screenshot of the scene.
             *
             * @param {string} projection - Screenshot projection (equirectangular or perspective).
             */
            setCapture: function setCapture(projection) {
              var el = this.el;
              var size;
              var camera;
              var cubeCamera;
              var cubeRenderTarget;
              // Configure camera.
              if (projection === 'perspective') {
                // Quad is only used in equirectangular mode. Hide it in this case.
                this.quad.visible = false;
                // Use scene camera.
                camera = this.data.camera && this.data.camera.components.camera.camera || el.camera;
                size = {
                  width: this.data.width,
                  height: this.data.height
                };
              } else {
                // Use ortho camera.
                camera = this.camera;
                cubeRenderTarget = new THREE.WebGLCubeRenderTarget(Math.min(this.cubeMapSize, 2048), {
                  format: THREE.RGBFormat,
                  generateMipmaps: true,
                  minFilter: THREE.LinearMipmapLinearFilter,
                  encoding: THREE.sRGBEncoding
                });
                // Create cube camera and copy position from scene camera.
                cubeCamera = new THREE.CubeCamera(el.camera.near, el.camera.far, cubeRenderTarget);
                // Copy camera position into cube camera;
                el.camera.getWorldPosition(cubeCamera.position);
                el.camera.getWorldQuaternion(cubeCamera.quaternion);
                // Render scene with cube camera.
                cubeCamera.update(el.renderer, el.object3D);
                this.quad.material.uniforms.map.value = cubeCamera.renderTarget.texture;
                size = {
                  width: this.data.width,
                  height: this.data.height
                };
                // Use quad to project image taken by the cube camera.
                this.quad.visible = true;
              }
              return {
                camera: camera,
                size: size,
                projection: projection
              };
            },
            /**
             * Maintained for backwards compatibility.
             */
            capture: function capture(projection) {
              var isVREnabled = this.el.renderer.xr.enabled;
              var renderer = this.el.renderer;
              var params;
              // Disable VR.
              renderer.xr.enabled = false;
              params = this.setCapture(projection);
              this.renderCapture(params.camera, params.size, params.projection);
              // Trigger file download.
              this.saveCapture();
              // Restore VR.
              renderer.xr.enabled = isVREnabled;
            },
            /**
             * Return canvas instead of triggering download (e.g., for uploading blob to server).
             */
            getCanvas: function getCanvas(projection) {
              var isVREnabled = this.el.renderer.xr.enabled;
              var renderer = this.el.renderer;
              // Disable VR.
              var params = this.setCapture(projection);
              renderer.xr.enabled = false;
              this.renderCapture(params.camera, params.size, params.projection);
              // Restore VR.
              renderer.xr.enabled = isVREnabled;
              return this.canvas;
            },
            renderCapture: function renderCapture(camera, size, projection) {
              var autoClear = this.el.renderer.autoClear;
              var el = this.el;
              var imageData;
              var output;
              var pixels;
              var renderer = el.renderer;
              // Create rendering target and buffer to store the read pixels.
              output = this.getRenderTarget(size.width, size.height);
              pixels = new Uint8Array(4 * size.width * size.height);
              // Resize quad, camera, and canvas.
              this.resize(size.width, size.height);
              // Render scene to render target.
              renderer.autoClear = true;
              renderer.clear();
              renderer.setRenderTarget(output);
              renderer.render(el.object3D, camera);
              renderer.autoClear = autoClear;
              // Read image pizels back.
              renderer.readRenderTargetPixels(output, 0, 0, size.width, size.height, pixels);
              renderer.setRenderTarget(null);
              if (projection === 'perspective') {
                pixels = this.flipPixelsVertically(pixels, size.width, size.height);
              }
              imageData = new ImageData(new Uint8ClampedArray(pixels), size.width, size.height);
              // Hide quad after projecting the image.
              this.quad.visible = false;
              // Copy pixels into canvas.
              this.ctx.putImageData(imageData, 0, 0);
            },
            flipPixelsVertically: function flipPixelsVertically(pixels, width, height) {
              var flippedPixels = pixels.slice(0);
              for (var x = 0; x < width; ++x) {
                for (var y = 0; y < height; ++y) {
                  flippedPixels[x * 4 + y * width * 4] = pixels[x * 4 + (height - y) * width * 4];
                  flippedPixels[x * 4 + 1 + y * width * 4] = pixels[x * 4 + 1 + (height - y) * width * 4];
                  flippedPixels[x * 4 + 2 + y * width * 4] = pixels[x * 4 + 2 + (height - y) * width * 4];
                  flippedPixels[x * 4 + 3 + y * width * 4] = pixels[x * 4 + 3 + (height - y) * width * 4];
                }
              }
              return flippedPixels;
            },
            /**
             * Download capture to file.
             */
            saveCapture: function saveCapture() {
              this.canvas.toBlob(function (blob) {
                var fileName = 'screenshot-' + document.title.toLowerCase() + '-' + Date.now() + '.png';
                var linkEl = document.createElement('a');
                var url = URL.createObjectURL(blob);
                linkEl.href = url;
                linkEl.setAttribute('download', fileName);
                linkEl.innerHTML = 'downloading...';
                linkEl.style.display = 'none';
                document.body.appendChild(linkEl);
                setTimeout(function () {
                  linkEl.click();
                  document.body.removeChild(linkEl);
                }, 1);
              }, 'image/png');
            }
          });

          /***/
        },

        /***/"./src/components/scene/stats.js":
        /*!***************************************!*\
          !*** ./src/components/scene/stats.js ***!
          \***************************************/
        /***/
        function srcComponentsSceneStatsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var RStats = __webpack_require__( /*! ../../../vendor/rStats */"./vendor/rStats.js");
          var utils = __webpack_require__( /*! ../../utils */"./src/utils/index.js");
          __webpack_require__( /*! ../../../vendor/rStats.extras */"./vendor/rStats.extras.js");
          __webpack_require__( /*! ../../lib/rStatsAframe */"./src/lib/rStatsAframe.js");
          var AFrameStats = window.aframeStats;
          var bind = utils.bind;
          var HIDDEN_CLASS = 'a-hidden';
          var ThreeStats = window.threeStats;

          /**
           * Stats appended to document.body by RStats.
           */
          module.exports.Component = registerComponent('stats', {
            schema: {
              default: true
            },
            init: function init() {
              var scene = this.el;
              if (utils.getUrlParameter('stats') === 'false') {
                return;
              }
              this.stats = createStats(scene);
              this.statsEl = document.querySelector('.rs-base');
              this.hideBound = bind(this.hide, this);
              this.showBound = bind(this.show, this);
              scene.addEventListener('enter-vr', this.hideBound);
              scene.addEventListener('exit-vr', this.showBound);
            },
            update: function update() {
              if (!this.stats) {
                return;
              }
              return !this.data ? this.hide() : this.show();
            },
            remove: function remove() {
              this.el.removeEventListener('enter-vr', this.hideBound);
              this.el.removeEventListener('exit-vr', this.showBound);
              if (!this.statsEl) {
                return;
              } // Scene detached.
              this.statsEl.parentNode.removeChild(this.statsEl);
            },
            tick: function tick() {
              var stats = this.stats;
              if (!stats) {
                return;
              }
              stats('rAF').tick();
              stats('FPS').frame();
              stats().update();
            },
            hide: function hide() {
              this.statsEl.classList.add(HIDDEN_CLASS);
            },
            show: function show() {
              this.statsEl.classList.remove(HIDDEN_CLASS);
            }
          });
          function createStats(scene) {
            var threeStats = new ThreeStats(scene.renderer);
            var aframeStats = new AFrameStats(scene);
            var plugins = scene.isMobile ? [] : [threeStats, aframeStats];
            return new RStats({
              css: [],
              // Our stylesheet is injected from `src/index.js`.
              values: {
                fps: {
                  caption: 'fps',
                  below: 30
                }
              },
              groups: [{
                caption: 'Framerate',
                values: ['fps', 'raf']
              }],
              plugins: plugins
            });
          }

          /***/
        },

        /***/"./src/components/scene/vr-mode-ui.js":
        /*!********************************************!*\
          !*** ./src/components/scene/vr-mode-ui.js ***!
          \********************************************/
        /***/
        function srcComponentsSceneVrModeUiJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var constants = __webpack_require__( /*! ../../constants/ */"./src/constants/index.js");
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");
          var bind = utils.bind;
          var ENTER_VR_CLASS = 'a-enter-vr';
          var ENTER_AR_CLASS = 'a-enter-ar';
          var ENTER_VR_BTN_CLASS = 'a-enter-vr-button';
          var ENTER_AR_BTN_CLASS = 'a-enter-ar-button';
          var HIDDEN_CLASS = 'a-hidden';
          var ORIENTATION_MODAL_CLASS = 'a-orientation-modal';

          /**
           * UI for entering VR mode.
           */
          module.exports.Component = registerComponent('vr-mode-ui', {
            dependencies: ['canvas'],
            schema: {
              enabled: {
                default: true
              },
              cardboardModeEnabled: {
                default: false
              },
              enterVRButton: {
                default: ''
              },
              enterARButton: {
                default: ''
              }
            },
            init: function init() {
              var self = this;
              var sceneEl = this.el;
              if (utils.getUrlParameter('ui') === 'false') {
                return;
              }
              this.insideLoader = false;
              this.enterVREl = null;
              this.enterAREl = null;
              this.orientationModalEl = null;
              this.bindMethods();

              // Hide/show VR UI when entering/exiting VR mode.
              sceneEl.addEventListener('enter-vr', this.updateEnterInterfaces);
              sceneEl.addEventListener('exit-vr', this.updateEnterInterfaces);
              sceneEl.addEventListener('update-vr-devices', this.updateEnterInterfaces);
              window.addEventListener('message', function (event) {
                if (event.data.type === 'loaderReady') {
                  self.insideLoader = true;
                  self.remove();
                }
              });

              // Modal that tells the user to change orientation if in portrait.
              window.addEventListener('orientationchange', this.toggleOrientationModalIfNeeded);
            },
            bindMethods: function bindMethods() {
              this.onEnterVRButtonClick = bind(this.onEnterVRButtonClick, this);
              this.onEnterARButtonClick = bind(this.onEnterARButtonClick, this);
              this.onModalClick = bind(this.onModalClick, this);
              this.toggleOrientationModalIfNeeded = bind(this.toggleOrientationModalIfNeeded, this);
              this.updateEnterInterfaces = bind(this.updateEnterInterfaces, this);
            },
            /**
             * Exit VR when modal clicked.
             */
            onModalClick: function onModalClick() {
              this.el.exitVR();
            },
            /**
             * Enter VR when clicked.
             */
            onEnterVRButtonClick: function onEnterVRButtonClick() {
              this.el.enterVR();
            },
            /**
             * Enter AR when clicked.
             */
            onEnterARButtonClick: function onEnterARButtonClick() {
              this.el.enterAR();
            },
            update: function update() {
              var data = this.data;
              var sceneEl = this.el;
              if (!data.enabled || this.insideLoader || utils.getUrlParameter('ui') === 'false') {
                return this.remove();
              }
              if (this.enterVREl || this.enterAREl || this.orientationModalEl) {
                return;
              }

              // Add UI if enabled and not already present.
              if (data.enterVRButton) {
                // Custom button.
                this.enterVREl = document.querySelector(data.enterVRButton);
                this.enterVREl.addEventListener('click', this.onEnterVRButtonClick);
              } else {
                this.enterVREl = createEnterVRButton(this.onEnterVRButtonClick);
                sceneEl.appendChild(this.enterVREl);
              }
              if (data.enterARButton) {
                // Custom button.
                this.enterAREl = document.querySelector(data.enterARButton);
                this.enterAREl.addEventListener('click', this.onEnterARButtonClick);
              } else {
                this.enterAREl = createEnterARButton(this.onEnterARButtonClick);
                sceneEl.appendChild(this.enterAREl);
              }
              this.orientationModalEl = createOrientationModal(this.onModalClick);
              sceneEl.appendChild(this.orientationModalEl);
              this.updateEnterInterfaces();
            },
            remove: function remove() {
              [this.enterVREl, this.enterAREl, this.orientationModalEl].forEach(function (uiElement) {
                if (uiElement && uiElement.parentNode) {
                  uiElement.parentNode.removeChild(uiElement);
                }
              });
              this.enterVREl = undefined;
              this.enterAREl = undefined;
              this.orientationModalEl = undefined;
            },
            updateEnterInterfaces: function updateEnterInterfaces() {
              this.toggleEnterVRButtonIfNeeded();
              this.toggleEnterARButtonIfNeeded();
              this.toggleOrientationModalIfNeeded();
            },
            toggleEnterVRButtonIfNeeded: function toggleEnterVRButtonIfNeeded() {
              var sceneEl = this.el;
              if (!this.enterVREl) {
                return;
              }
              if (sceneEl.is('vr-mode') || (sceneEl.isMobile || utils.device.isMobileDeviceRequestingDesktopSite()) && !this.data.cardboardModeEnabled && !utils.device.checkVRSupport()) {
                this.enterVREl.classList.add(HIDDEN_CLASS);
              } else {
                if (!utils.device.checkVRSupport()) {
                  this.enterVREl.classList.add('fullscreen');
                }
                this.enterVREl.classList.remove(HIDDEN_CLASS);
              }
            },
            toggleEnterARButtonIfNeeded: function toggleEnterARButtonIfNeeded() {
              var sceneEl = this.el;
              if (!this.enterAREl) {
                return;
              }
              // Hide the button while in a session, or if AR is not supported.
              if (sceneEl.is('vr-mode') || !utils.device.checkARSupport()) {
                this.enterAREl.classList.add(HIDDEN_CLASS);
              } else {
                this.enterAREl.classList.remove(HIDDEN_CLASS);
              }
            },
            toggleOrientationModalIfNeeded: function toggleOrientationModalIfNeeded() {
              var sceneEl = this.el;
              var orientationModalEl = this.orientationModalEl;
              if (!orientationModalEl || !sceneEl.isMobile) {
                return;
              }
              if (!utils.device.isLandscape() && sceneEl.is('vr-mode')) {
                // Show if in VR mode on portrait.
                orientationModalEl.classList.remove(HIDDEN_CLASS);
              } else {
                orientationModalEl.classList.add(HIDDEN_CLASS);
              }
            }
          });

          /**
           * Create a button that when clicked will enter into stereo-rendering mode for VR.
           *
           * Structure: <div><button></div>
           *
           * @param {function} onClick - click event handler
           * @returns {Element} Wrapper <div>.
           */
          function createEnterVRButton(onClick) {
            var vrButton;
            var wrapper;

            // Create elements.
            wrapper = document.createElement('div');
            wrapper.classList.add(ENTER_VR_CLASS);
            wrapper.setAttribute(constants.AFRAME_INJECTED, '');
            vrButton = document.createElement('button');
            vrButton.className = ENTER_VR_BTN_CLASS;
            vrButton.setAttribute('title', 'Enter VR mode with a headset or fullscreen without');
            vrButton.setAttribute(constants.AFRAME_INJECTED, '');
            if (utils.device.isMobile()) {
              applyStickyHoverFix(vrButton);
            }
            // Insert elements.
            wrapper.appendChild(vrButton);
            vrButton.addEventListener('click', function (evt) {
              onClick();
              evt.stopPropagation();
            });
            return wrapper;
          }

          /**
           * Create a button that when clicked will enter into AR mode
           *
           * Structure: <div><button></div>
           *
           * @param {function} onClick - click event handler
           * @returns {Element} Wrapper <div>.
           */
          function createEnterARButton(onClick) {
            var arButton;
            var wrapper;

            // Create elements.
            wrapper = document.createElement('div');
            wrapper.classList.add(ENTER_AR_CLASS);
            wrapper.setAttribute(constants.AFRAME_INJECTED, '');
            arButton = document.createElement('button');
            arButton.className = ENTER_AR_BTN_CLASS;
            arButton.setAttribute('title', 'Enter AR mode with a headset or handheld device.');
            arButton.setAttribute(constants.AFRAME_INJECTED, '');
            if (utils.device.isMobile()) {
              applyStickyHoverFix(arButton);
            }
            // Insert elements.
            wrapper.appendChild(arButton);
            arButton.addEventListener('click', function (evt) {
              onClick();
              evt.stopPropagation();
            });
            return wrapper;
          }

          /**
           * Creates a modal dialog to request the user to switch to landscape orientation.
           *
           * @param {function} onClick - click event handler
           * @returns {Element} Wrapper <div>.
           */
          function createOrientationModal(onClick) {
            var modal = document.createElement('div');
            modal.className = ORIENTATION_MODAL_CLASS;
            modal.classList.add(HIDDEN_CLASS);
            modal.setAttribute(constants.AFRAME_INJECTED, '');
            var exit = document.createElement('button');
            exit.setAttribute(constants.AFRAME_INJECTED, '');
            exit.innerHTML = 'Exit VR';

            // Exit VR on close.
            exit.addEventListener('click', onClick);
            modal.appendChild(exit);
            return modal;
          }

          /**
           * CSS hover state is sticky in iOS (as in 12/18/2019)
           * They are not removed on mouseleave and this function applies a class
           * to resets the style.
           *
           * @param {function} buttonEl - Button element
           */
          function applyStickyHoverFix(buttonEl) {
            buttonEl.addEventListener('touchstart', function () {
              buttonEl.classList.remove('resethover');
            });
            buttonEl.addEventListener('touchend', function () {
              buttonEl.classList.add('resethover');
            });
          }

          /***/
        },

        /***/"./src/components/shadow.js":
        /*!**********************************!*\
          !*** ./src/components/shadow.js ***!
          \**********************************/
        /***/
        function srcComponentsShadowJs(module, __unused_webpack_exports, __webpack_require__) {
          var component = __webpack_require__( /*! ../core/component */"./src/core/component.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var registerComponent = component.registerComponent;

          /**
           * Shadow component.
           *
           * When applied to an entity, that entity's geometry and any descendants will cast or receive
           * shadows as specified by the `cast` and `receive` properties.
           */
          module.exports.Component = registerComponent('shadow', {
            schema: {
              cast: {
                default: true
              },
              receive: {
                default: true
              }
            },
            init: function init() {
              this.onMeshChanged = bind(this.update, this);
              this.el.addEventListener('object3dset', this.onMeshChanged);
              this.system.setShadowMapEnabled(true);
            },
            update: function update() {
              var data = this.data;
              this.updateDescendants(data.cast, data.receive);
            },
            remove: function remove() {
              var el = this.el;
              el.removeEventListener('object3dset', this.onMeshChanged);
              this.updateDescendants(false, false);
            },
            updateDescendants: function updateDescendants(cast, receive) {
              var sceneEl = this.el.sceneEl;
              this.el.object3D.traverse(function (node) {
                if (!(node instanceof THREE.Mesh)) {
                  return;
                }
                node.castShadow = cast;
                node.receiveShadow = receive;

                // If scene has already rendered, materials must be updated.
                if (sceneEl.hasLoaded && node.material) {
                  var materials = Array.isArray(node.material) ? node.material : [node.material];
                  for (var i = 0; i < materials.length; i++) {
                    materials[i].needsUpdate = true;
                  }
                }
              });
            }
          });

          /***/
        },

        /***/"./src/components/sound.js":
        /*!*********************************!*\
          !*** ./src/components/sound.js ***!
          \*********************************/
        /***/
        function srcComponentsSoundJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var debug = __webpack_require__( /*! ../utils/debug */"./src/utils/debug.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var warn = debug('components:sound:warn');

          /**
           * Sound component.
           */
          module.exports.Component = registerComponent('sound', {
            schema: {
              autoplay: {
                default: false
              },
              distanceModel: {
                default: 'inverse',
                oneOf: ['linear', 'inverse', 'exponential']
              },
              loop: {
                default: false
              },
              maxDistance: {
                default: 10000
              },
              on: {
                default: ''
              },
              poolSize: {
                default: 1
              },
              positional: {
                default: true
              },
              refDistance: {
                default: 1
              },
              rolloffFactor: {
                default: 1
              },
              src: {
                type: 'audio'
              },
              volume: {
                default: 1
              }
            },
            multiple: true,
            init: function init() {
              var self = this;
              this.listener = null;
              this.audioLoader = new THREE.AudioLoader();
              this.pool = new THREE.Group();
              this.loaded = false;
              this.mustPlay = false;

              // Don't pass evt because playSound takes a function as parameter.
              this.playSoundBound = function () {
                self.playSound();
              };
            },
            update: function update(oldData) {
              var data = this.data;
              var i;
              var sound;
              var srcChanged = data.src !== oldData.src;

              // Create new sound if not yet created or changing `src`.
              if (srcChanged) {
                if (!data.src) {
                  return;
                }
                this.setupSound();
              }
              for (i = 0; i < this.pool.children.length; i++) {
                sound = this.pool.children[i];
                if (data.positional) {
                  sound.setDistanceModel(data.distanceModel);
                  sound.setMaxDistance(data.maxDistance);
                  sound.setRefDistance(data.refDistance);
                  sound.setRolloffFactor(data.rolloffFactor);
                }
                sound.setLoop(data.loop);
                sound.setVolume(data.volume);
                sound.isPaused = false;
              }
              if (data.on !== oldData.on) {
                this.updateEventListener(oldData.on);
              }

              // All sound values set. Load in `src`.
              if (srcChanged) {
                var self = this;
                this.loaded = false;
                this.audioLoader.load(data.src, function (buffer) {
                  for (i = 0; i < self.pool.children.length; i++) {
                    sound = self.pool.children[i];
                    sound.setBuffer(buffer);
                  }
                  self.loaded = true;

                  // Remove this key from cache, otherwise we can't play it again
                  THREE.Cache.remove(data.src);
                  if (self.data.autoplay || self.mustPlay) {
                    self.playSound();
                  }
                  self.el.emit('sound-loaded', self.evtDetail, false);
                });
              }
            },
            pause: function pause() {
              this.stopSound();
              this.removeEventListener();
            },
            play: function play() {
              if (this.data.autoplay) {
                this.playSound();
              }
              this.updateEventListener();
            },
            remove: function remove() {
              var i;
              var sound;
              this.removeEventListener();
              if (this.el.getObject3D(this.attrName)) {
                this.el.removeObject3D(this.attrName);
              }
              try {
                for (i = 0; i < this.pool.children.length; i++) {
                  sound = this.pool.children[i];
                  sound.disconnect();
                }
              } catch (e) {
                // disconnect() will throw if it was never connected initially.
                warn('Audio source not properly disconnected');
              }
            },
            /**
            *  Update listener attached to the user defined on event.
            */
            updateEventListener: function updateEventListener(oldEvt) {
              var el = this.el;
              if (oldEvt) {
                el.removeEventListener(oldEvt, this.playSoundBound);
              }
              el.addEventListener(this.data.on, this.playSoundBound);
            },
            removeEventListener: function removeEventListener() {
              this.el.removeEventListener(this.data.on, this.playSoundBound);
            },
            /**
             * Removes current sound object, creates new sound object, adds to entity.
             *
             * @returns {object} sound
             */
            setupSound: function setupSound() {
              var el = this.el;
              var i;
              var sceneEl = el.sceneEl;
              var self = this;
              var sound;
              if (this.pool.children.length > 0) {
                this.stopSound();
                el.removeObject3D('sound');
              }

              // Only want one AudioListener. Cache it on the scene.
              var listener = this.listener = sceneEl.audioListener || new THREE.AudioListener();
              sceneEl.audioListener = listener;
              if (sceneEl.camera) {
                sceneEl.camera.add(listener);
              }

              // Wait for camera if necessary.
              sceneEl.addEventListener('camera-set-active', function (evt) {
                evt.detail.cameraEl.getObject3D('camera').add(listener);
              });

              // Create [poolSize] audio instances and attach them to pool
              this.pool = new THREE.Group();
              for (i = 0; i < this.data.poolSize; i++) {
                sound = this.data.positional ? new THREE.PositionalAudio(listener) : new THREE.Audio(listener);
                this.pool.add(sound);
              }
              el.setObject3D(this.attrName, this.pool);
              for (i = 0; i < this.pool.children.length; i++) {
                sound = this.pool.children[i];
                sound.onEnded = function () {
                  this.isPlaying = false;
                  self.el.emit('sound-ended', self.evtDetail, false);
                };
              }
            },
            /**
             * Pause all the sounds in the pool.
             */
            pauseSound: function pauseSound() {
              var i;
              var sound;
              this.isPlaying = false;
              for (i = 0; i < this.pool.children.length; i++) {
                sound = this.pool.children[i];
                if (!sound.source || !sound.source.buffer || !sound.isPlaying || sound.isPaused) {
                  continue;
                }
                sound.isPaused = true;
                sound.pause();
              }
            },
            /**
             * Look for an unused sound in the pool and play it if found.
             */
            playSound: function playSound(processSound) {
              var found;
              var i;
              var sound;
              if (!this.loaded) {
                warn('Sound not loaded yet. It will be played once it finished loading');
                this.mustPlay = true;
                return;
              }
              found = false;
              this.isPlaying = true;
              for (i = 0; i < this.pool.children.length; i++) {
                sound = this.pool.children[i];
                if (!sound.isPlaying && sound.buffer && !found) {
                  if (processSound) {
                    processSound(sound);
                  }
                  sound.play();
                  sound.isPaused = false;
                  found = true;
                  continue;
                }
              }
              if (!found) {
                warn('All the sounds are playing. If you need to play more sounds simultaneously ' + 'consider increasing the size of pool with the `poolSize` attribute.', this.el);
                return;
              }
              this.mustPlay = false;
            },
            /**
             * Stop all the sounds in the pool.
             */
            stopSound: function stopSound() {
              var i;
              var sound;
              this.isPlaying = false;
              for (i = 0; i < this.pool.children.length; i++) {
                sound = this.pool.children[i];
                if (!sound.source || !sound.source.buffer) {
                  return;
                }
                sound.stop();
              }
            }
          });

          /***/
        },

        /***/"./src/components/text.js":
        /*!********************************!*\
          !*** ./src/components/text.js ***!
          \********************************/
        /***/
        function srcComponentsTextJs(module, __unused_webpack_exports, __webpack_require__) {
          var createTextGeometry = __webpack_require__( /*! three-bmfont-text */"./node_modules/three-bmfont-text/index.js");
          var loadBMFont = __webpack_require__( /*! load-bmfont */"./node_modules/load-bmfont/browser.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var coreShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var error = utils.debug('components:text:error');
          var shaders = coreShader.shaders;
          var warn = utils.debug('components:text:warn');

          // 1 to match other A-Frame default widths.
          var DEFAULT_WIDTH = 1;

          // @bryik set anisotropy to 16. Improves look of large amounts of text when viewed from angle.
          var MAX_ANISOTROPY = 16;
          var FONT_BASE_URL = 'https://cdn.aframe.io/fonts/';
          var FONTS = {
            aileronsemibold: FONT_BASE_URL + 'Aileron-Semibold.fnt',
            dejavu: FONT_BASE_URL + 'DejaVu-sdf.fnt',
            exo2bold: FONT_BASE_URL + 'Exo2Bold.fnt',
            exo2semibold: FONT_BASE_URL + 'Exo2SemiBold.fnt',
            kelsonsans: FONT_BASE_URL + 'KelsonSans.fnt',
            monoid: FONT_BASE_URL + 'Monoid.fnt',
            mozillavr: FONT_BASE_URL + 'mozillavr.fnt',
            roboto: FONT_BASE_URL + 'Roboto-msdf.json',
            sourcecodepro: FONT_BASE_URL + 'SourceCodePro.fnt'
          };
          var MSDF_FONTS = ['roboto'];
          var DEFAULT_FONT = 'roboto';
          module.exports.FONTS = FONTS;
          var cache = new PromiseCache();
          var fontWidthFactors = {};
          var textures = {};

          // Regular expression for detecting a URLs with a protocol prefix.
          var protocolRe = /^\w+:/;

          /**
           * SDF-based text component.
           * Based on https://github.com/Jam3/three-bmfont-text.
           *
           * All the stock fonts are for the `sdf` registered shader, an improved version of jam3's
           * original `sdf` shader.
           */
          module.exports.Component = registerComponent('text', {
            multiple: true,
            schema: {
              align: {
                type: 'string',
                default: 'left',
                oneOf: ['left', 'right', 'center']
              },
              alphaTest: {
                default: 0.5
              },
              // `anchor` defaults to center to match geometries.
              anchor: {
                default: 'center',
                oneOf: ['left', 'right', 'center', 'align']
              },
              baseline: {
                default: 'center',
                oneOf: ['top', 'center', 'bottom']
              },
              color: {
                type: 'color',
                default: '#FFF'
              },
              font: {
                type: 'string',
                default: DEFAULT_FONT
              },
              // `fontImage` defaults to the font name as a .png (e.g., mozillavr.fnt -> mozillavr.png).
              fontImage: {
                type: 'string'
              },
              // `height` has no default, will be populated at layout.
              height: {
                type: 'number'
              },
              letterSpacing: {
                type: 'number',
                default: 0
              },
              // `lineHeight` defaults to font's `lineHeight` value.
              lineHeight: {
                type: 'number'
              },
              // `negate` must be true for fonts generated with older versions of msdfgen (white background).
              negate: {
                type: 'boolean',
                default: true
              },
              opacity: {
                type: 'number',
                default: 1.0
              },
              shader: {
                default: 'sdf',
                oneOf: shaders
              },
              side: {
                default: 'front',
                oneOf: ['front', 'back', 'double']
              },
              tabSize: {
                default: 4
              },
              transparent: {
                default: true
              },
              value: {
                type: 'string'
              },
              whiteSpace: {
                default: 'normal',
                oneOf: ['normal', 'pre', 'nowrap']
              },
              // `width` defaults to geometry width if present, else `DEFAULT_WIDTH`.
              width: {
                type: 'number'
              },
              // `wrapCount` units are about one default font character. Wrap roughly at this number.
              wrapCount: {
                type: 'number',
                default: 40
              },
              // `wrapPixels` will wrap using bmfont pixel units (e.g., dejavu's is 32 pixels).
              wrapPixels: {
                type: 'number'
              },
              // `xOffset` to add padding.
              xOffset: {
                type: 'number',
                default: 0
              },
              // `yOffset` to adjust generated fonts from tools that may have incorrect metrics.
              yOffset: {
                type: 'number',
                default: 0
              },
              // `zOffset` will provide a small z offset to avoid z-fighting.
              zOffset: {
                type: 'number',
                default: 0.001
              }
            },
            init: function init() {
              this.shaderData = {};
              this.geometry = createTextGeometry();
              this.createOrUpdateMaterial();
            },
            update: function update(oldData) {
              var data = this.data;
              var font = this.currentFont;
              if (textures[data.font]) {
                this.texture = textures[data.font];
              } else {
                // Create texture per font.
                this.texture = textures[data.font] = new THREE.Texture();
                this.texture.anisotropy = MAX_ANISOTROPY;
              }

              // Update material.
              this.createOrUpdateMaterial();

              // New font. `updateFont` will later change data and layout.
              if (oldData.font !== data.font) {
                this.updateFont();
                return;
              }

              // Update geometry and layout.
              if (font) {
                this.updateGeometry(this.geometry, font);
                this.updateLayout();
              }
            },
            /**
             * Clean up geometry, material, texture, mesh, objects.
             */
            remove: function remove() {
              this.geometry.dispose();
              this.geometry = null;
              this.el.removeObject3D(this.attrName);
              this.material.dispose();
              this.material = null;
              this.texture.dispose();
              this.texture = null;
              if (this.shaderObject) {
                delete this.shaderObject;
              }
            },
            /**
             * Update the shader of the material.
             */
            createOrUpdateMaterial: function createOrUpdateMaterial() {
              var data = this.data;
              var hasChangedShader;
              var material = this.material;
              var NewShader;
              var shaderData = this.shaderData;
              var shaderName;

              // Infer shader if using a stock font (or from `-msdf` filename convention).
              shaderName = data.shader;
              if (MSDF_FONTS.indexOf(data.font) !== -1 || data.font.indexOf('-msdf.') >= 0) {
                shaderName = 'msdf';
              } else if (data.font in FONTS && MSDF_FONTS.indexOf(data.font) === -1) {
                shaderName = 'sdf';
              }
              hasChangedShader = (this.shaderObject && this.shaderObject.name) !== shaderName;
              shaderData.alphaTest = data.alphaTest;
              shaderData.color = data.color;
              shaderData.map = this.texture;
              shaderData.opacity = data.opacity;
              shaderData.side = parseSide(data.side);
              shaderData.transparent = data.transparent;
              shaderData.negate = data.negate;

              // Shader has not changed, do an update.
              if (!hasChangedShader) {
                // Update shader material.
                this.shaderObject.update(shaderData);
                // Apparently, was not set on `init` nor `update`.
                material.transparent = shaderData.transparent;
                material.side = shaderData.side;
                return;
              }

              // Shader has changed. Create a shader material.
              NewShader = createShader(this.el, shaderName, shaderData);
              this.material = NewShader.material;
              this.shaderObject = NewShader.shader;

              // Set new shader material.
              this.material.side = shaderData.side;
              if (this.mesh) {
                this.mesh.material = this.material;
              }
            },
            /**
             * Load font for geometry, load font image for material, and apply.
             */
            updateFont: function updateFont() {
              var data = this.data;
              var el = this.el;
              var fontSrc;
              var geometry = this.geometry;
              var self = this;
              if (!data.font) {
                warn('No font specified. Using the default font.');
              }

              // Make invisible during font swap.
              if (this.mesh) {
                this.mesh.visible = false;
              }

              // Look up font URL to use, and perform cached load.
              fontSrc = this.lookupFont(data.font || DEFAULT_FONT) || data.font;
              cache.get(fontSrc, function doLoadFont() {
                return loadFont(fontSrc, data.yOffset);
              }).then(function setFont(font) {
                var fontImgSrc;
                if (font.pages.length !== 1) {
                  throw new Error('Currently only single-page bitmap fonts are supported.');
                }
                if (!fontWidthFactors[fontSrc]) {
                  font.widthFactor = fontWidthFactors[font] = computeFontWidthFactor(font);
                }
                self.currentFont = font;
                // Look up font image URL to use, and perform cached load.
                fontImgSrc = self.getFontImageSrc();
                cache.get(fontImgSrc, function () {
                  return loadTexture(fontImgSrc);
                }).then(function (image) {
                  // Make mesh visible and apply font image as texture.
                  var texture = self.texture;
                  // The component may have been removed at this point and texture will
                  // be null. This happens mainly while executing the tests,
                  // in this case we just return.
                  if (!texture) return;
                  texture.image = image;
                  texture.needsUpdate = true;
                  textures[data.font] = texture;
                  self.texture = texture;
                  self.initMesh();
                  self.currentFont = font;
                  // Update geometry given font metrics.
                  self.updateGeometry(geometry, font);
                  self.updateLayout();
                  self.mesh.visible = true;
                  el.emit('textfontset', {
                    font: data.font,
                    fontObj: font
                  });
                }).catch(function (err) {
                  error(err.message);
                  error(err.stack);
                });
              }).catch(function (err) {
                error(err.message);
                error(err.stack);
              });
            },
            initMesh: function initMesh() {
              if (this.mesh) {
                return;
              }
              this.mesh = new THREE.Mesh(this.geometry, this.material);
              this.el.setObject3D(this.attrName, this.mesh);
            },
            getFontImageSrc: function getFontImageSrc() {
              if (this.data.fontImage) {
                return this.data.fontImage;
              }
              var fontSrc = this.lookupFont(this.data.font || DEFAULT_FONT) || this.data.font;
              var imageSrc = this.currentFont.pages[0];
              // If the image URL contains a non-HTTP(S) protocol, assume it's an absolute
              // path on disk and try to infer the path from the font source instead.
              if (imageSrc.match(protocolRe) && imageSrc.indexOf('http') !== 0) {
                return fontSrc.replace(/(\.fnt)|(\.json)/, '.png');
              }
              return THREE.LoaderUtils.extractUrlBase(fontSrc) + imageSrc;
            },
            /**
             * Update layout with anchor, alignment, baseline, and considering any meshes.
             */
            updateLayout: function updateLayout() {
              var anchor;
              var baseline;
              var el = this.el;
              var data = this.data;
              var geometry = this.geometry;
              var geometryComponent;
              var height;
              var layout;
              var mesh = this.mesh;
              var textRenderWidth;
              var textScale;
              var width;
              var x;
              var y;
              if (!mesh || !geometry.layout) {
                return;
              }

              // Determine width to use (defined width, geometry's width, or default width).
              geometryComponent = el.getAttribute('geometry');
              width = data.width || geometryComponent && geometryComponent.width || DEFAULT_WIDTH;

              // Determine wrap pixel count. Either specified or by experimental fudge factor.
              // Note that experimental factor will never be correct for variable width fonts.
              textRenderWidth = computeWidth(data.wrapPixels, data.wrapCount, this.currentFont.widthFactor);
              textScale = width / textRenderWidth;

              // Determine height to use.
              layout = geometry.layout;
              height = textScale * (layout.height + layout.descender);

              // Update geometry dimensions to match text layout if width and height are set to 0.
              // For example, scales a plane to fit text.
              if (geometryComponent && geometryComponent.primitive === 'plane') {
                if (!geometryComponent.width) {
                  el.setAttribute('geometry', 'width', width);
                }
                if (!geometryComponent.height) {
                  el.setAttribute('geometry', 'height', height);
                }
              }

              // Calculate X position to anchor text left, center, or right.
              anchor = data.anchor === 'align' ? data.align : data.anchor;
              if (anchor === 'left') {
                x = 0;
              } else if (anchor === 'right') {
                x = -1 * layout.width;
              } else if (anchor === 'center') {
                x = -1 * layout.width / 2;
              } else {
                throw new TypeError('Invalid text.anchor property value', anchor);
              }

              // Calculate Y position to anchor text top, center, or bottom.
              baseline = data.baseline;
              if (baseline === 'bottom') {
                y = 0;
              } else if (baseline === 'top') {
                y = -1 * layout.height + layout.ascender;
              } else if (baseline === 'center') {
                y = -1 * layout.height / 2;
              } else {
                throw new TypeError('Invalid text.baseline property value', baseline);
              }

              // Position and scale mesh to apply layout.
              mesh.position.x = x * textScale + data.xOffset;
              mesh.position.y = y * textScale;
              // Place text slightly in front to avoid Z-fighting.
              mesh.position.z = data.zOffset;
              mesh.scale.set(textScale, -1 * textScale, textScale);
            },
            /**
             * Grab font from the constant.
             * Set as a method for test stubbing purposes.
             */
            lookupFont: function lookupFont(key) {
              return FONTS[key];
            },
            /**
             * Update the text geometry using `three-bmfont-text.update`.
             */
            updateGeometry: function () {
              var geometryUpdateBase = {};
              var geometryUpdateData = {};
              var newLineRegex = /\\n/g;
              var tabRegex = /\\t/g;
              return function (geometry, font) {
                var data = this.data;
                geometryUpdateData.font = font;
                geometryUpdateData.lineHeight = data.lineHeight && isFinite(data.lineHeight) ? data.lineHeight : font.common.lineHeight;
                geometryUpdateData.text = data.value.toString().replace(newLineRegex, '\n').replace(tabRegex, '\t');
                geometryUpdateData.width = computeWidth(data.wrapPixels, data.wrapCount, font.widthFactor);
                geometry.update(utils.extend(geometryUpdateBase, data, geometryUpdateData));
              };
            }()
          });

          /**
           * Due to using negative scale, we return the opposite side specified.
           * https://github.com/mrdoob/three.js/pull/12787/
           */
          function parseSide(side) {
            switch (side) {
              case 'back':
                {
                  return THREE.FrontSide;
                }
              case 'double':
                {
                  return THREE.DoubleSide;
                }
              default:
                {
                  return THREE.BackSide;
                }
            }
          }

          /**
           * @returns {Promise}
           */
          function loadFont(src, yOffset) {
            return new Promise(function (resolve, reject) {
              loadBMFont(src, function (err, font) {
                if (err) {
                  error('Error loading font', src);
                  reject(err);
                  return;
                }

                // Fix negative Y offsets for Roboto MSDF font from tool. Experimentally determined.
                if (src.indexOf('/Roboto-msdf.json') >= 0) {
                  yOffset = 30;
                }
                if (yOffset) {
                  font.chars.map(function doOffset(ch) {
                    ch.yoffset += yOffset;
                  });
                }
                resolve(font);
              });
            });
          }

          /**
           * @returns {Promise}
           */
          function loadTexture(src) {
            return new Promise(function (resolve, reject) {
              new THREE.ImageLoader().load(src, function (image) {
                resolve(image);
              }, undefined, function () {
                error('Error loading font image', src);
                reject(null);
              });
            });
          }
          function createShader(el, shaderName, data) {
            var shader;
            var shaderObject;

            // Set up Shader.
            shaderObject = new shaders[shaderName].Shader();
            shaderObject.el = el;
            shaderObject.init(data);
            shaderObject.update(data);

            // Get material.
            shader = shaderObject.material;
            // Apparently, was not set on `init` nor `update`.
            shader.transparent = data.transparent;
            return {
              material: shader,
              shader: shaderObject
            };
          }

          /**
           * Determine wrap pixel count. Either specified or by experimental fudge factor.
           * Note that experimental factor will never be correct for variable width fonts.
           */
          function computeWidth(wrapPixels, wrapCount, widthFactor) {
            return wrapPixels || (0.5 + wrapCount) * widthFactor;
          }

          /**
           * Compute default font width factor to use.
           */
          function computeFontWidthFactor(font) {
            var sum = 0;
            var digitsum = 0;
            var digits = 0;
            font.chars.map(function (ch) {
              sum += ch.xadvance;
              if (ch.id >= 48 && ch.id <= 57) {
                digits++;
                digitsum += ch.xadvance;
              }
            });
            return digits ? digitsum / digits : sum / font.chars.length;
          }

          /**
           * Get or create a promise given a key and promise generator.
           * @todo Move to a utility and use in other parts of A-Frame.
           */
          function PromiseCache() {
            var cache = this.cache = {};
            this.get = function (key, promiseGenerator) {
              if (key in cache) {
                return cache[key];
              }
              cache[key] = promiseGenerator();
              return cache[key];
            };
          }

          /***/
        },

        /***/"./src/components/tracked-controls-webvr.js":
        /*!**************************************************!*\
          !*** ./src/components/tracked-controls-webvr.js ***!
          \**************************************************/
        /***/
        function srcComponentsTrackedControlsWebvrJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var controllerUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var DEFAULT_CAMERA_HEIGHT = __webpack_require__( /*! ../constants */"./src/constants/index.js").DEFAULT_CAMERA_HEIGHT;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var DEFAULT_HANDEDNESS = __webpack_require__( /*! ../constants */"./src/constants/index.js").DEFAULT_HANDEDNESS;
          // Vector from eyes to elbow (divided by user height).
          var EYES_TO_ELBOW = {
            x: 0.175,
            y: -0.3,
            z: -0.03
          };
          // Vector from eyes to elbow (divided by user height).
          var FOREARM = {
            x: 0,
            y: 0,
            z: -0.175
          };

          // Due to unfortunate name collision, add empty touches array to avoid Daydream error.
          var EMPTY_DAYDREAM_TOUCHES = {
            touches: []
          };
          var EVENTS = {
            AXISMOVE: 'axismove',
            BUTTONCHANGED: 'buttonchanged',
            BUTTONDOWN: 'buttondown',
            BUTTONUP: 'buttonup',
            TOUCHSTART: 'touchstart',
            TOUCHEND: 'touchend'
          };

          /**
           * Tracked controls component.
           * Wrap the gamepad API for pose and button states.
           * Select the appropriate controller and apply pose to the entity.
           * Observe button states and emit appropriate events.
           *
           * @property {number} controller - Index of controller in array returned by Gamepad API.
           *  Only used if hand property is not set.
           * @property {string} id - Selected controller among those returned by Gamepad API.
           * @property {number} hand - If multiple controllers found with id, choose the one with the
           *  given value for hand. If set, we ignore 'controller' property
           */
          module.exports.Component = registerComponent('tracked-controls-webvr', {
            schema: {
              autoHide: {
                default: true
              },
              controller: {
                default: 0
              },
              id: {
                type: 'string',
                default: ''
              },
              hand: {
                type: 'string',
                default: ''
              },
              idPrefix: {
                type: 'string',
                default: ''
              },
              orientationOffset: {
                type: 'vec3'
              },
              // Arm model parameters when not 6DoF.
              armModel: {
                default: false
              },
              headElement: {
                type: 'selector'
              }
            },
            init: function init() {
              // Copy variables back to tracked-controls for backwards compatibility.
              // Some 3rd components rely on them.
              this.axis = this.el.components['tracked-controls'].axis = [0, 0, 0];
              this.buttonStates = this.el.components['tracked-controls'].buttonStates = {};
              this.changedAxes = [];
              this.targetControllerNumber = this.data.controller;
              this.axisMoveEventDetail = {
                axis: this.axis,
                changed: this.changedAxes
              };
              this.deltaControllerPosition = new THREE.Vector3();
              this.controllerQuaternion = new THREE.Quaternion();
              this.controllerEuler = new THREE.Euler();
              this.updateGamepad();
              this.buttonEventDetails = {};
            },
            tick: function tick(time, delta) {
              var mesh = this.el.getObject3D('mesh');
              // Update mesh animations.
              if (mesh && mesh.update) {
                mesh.update(delta / 1000);
              }
              this.updateGamepad();
              this.updatePose();
              this.updateButtons();
            },
            /**
             * Return default user height to use for non-6DOF arm model.
             */
            defaultUserHeight: function defaultUserHeight() {
              return DEFAULT_CAMERA_HEIGHT;
            },
            /**
             * Return head element to use for non-6DOF arm model.
             */
            getHeadElement: function getHeadElement() {
              return this.data.headElement || this.el.sceneEl.camera.el;
            },
            /**
             * Handle update controller match criteria (such as `id`, `idPrefix`, `hand`, `controller`)
             */
            updateGamepad: function updateGamepad() {
              var data = this.data;
              var controller = controllerUtils.findMatchingControllerWebVR(this.system.controllers, data.id, data.idPrefix, data.hand, data.controller);
              this.controller = controller;
              // Legacy handle to the controller for old components.
              this.el.components['tracked-controls'].controller = controller;
              if (this.data.autoHide) {
                this.el.object3D.visible = !!this.controller;
              }
            },
            /**
             * Applies an artificial arm model to simulate elbow to wrist positioning
             * based on the orientation of the controller.
             *
             * @param {object} controllerPosition - Existing vector to update with controller position.
             */
            applyArmModel: function applyArmModel(controllerPosition) {
              // Use controllerPosition and deltaControllerPosition to avoid creating variables.
              var controller = this.controller;
              var controllerEuler = this.controllerEuler;
              var controllerQuaternion = this.controllerQuaternion;
              var deltaControllerPosition = this.deltaControllerPosition;
              var hand;
              var headEl;
              var headObject3D;
              var pose;
              var userHeight;
              headEl = this.getHeadElement();
              headObject3D = headEl.object3D;
              userHeight = this.defaultUserHeight();
              pose = controller.pose;
              hand = (controller ? controller.hand : undefined) || DEFAULT_HANDEDNESS;

              // Use camera position as head position.
              controllerPosition.copy(headObject3D.position);
              // Set offset for degenerate "arm model" to elbow.
              deltaControllerPosition.set(EYES_TO_ELBOW.x * (hand === 'left' ? -1 : hand === 'right' ? 1 : 0), EYES_TO_ELBOW.y,
              // Lower than our eyes.
              EYES_TO_ELBOW.z); // Slightly out in front.
              // Scale offset by user height.
              deltaControllerPosition.multiplyScalar(userHeight);
              // Apply camera Y rotation (not X or Z, so you can look down at your hand).
              deltaControllerPosition.applyAxisAngle(headObject3D.up, headObject3D.rotation.y);
              // Apply rotated offset to position.
              controllerPosition.add(deltaControllerPosition);

              // Set offset for degenerate "arm model" forearm. Forearm sticking out from elbow.
              deltaControllerPosition.set(FOREARM.x, FOREARM.y, FOREARM.z);
              // Scale offset by user height.
              deltaControllerPosition.multiplyScalar(userHeight);
              // Apply controller X/Y rotation (tilting up/down/left/right is usually moving the arm).
              if (pose.orientation) {
                controllerQuaternion.fromArray(pose.orientation);
              } else {
                controllerQuaternion.copy(headObject3D.quaternion);
              }
              controllerEuler.setFromQuaternion(controllerQuaternion);
              controllerEuler.set(controllerEuler.x, controllerEuler.y, 0);
              deltaControllerPosition.applyEuler(controllerEuler);
              // Apply rotated offset to position.
              controllerPosition.add(deltaControllerPosition);
            },
            /**
             * Read pose from controller (from Gamepad API), apply transforms, apply to entity.
             */
            updatePose: function updatePose() {
              var controller = this.controller;
              var data = this.data;
              var object3D = this.el.object3D;
              var pose;
              var vrDisplay = this.system.vrDisplay;
              var standingMatrix;
              if (!controller) {
                return;
              }

              // Compose pose from Gamepad.
              pose = controller.pose;
              if (pose.position) {
                object3D.position.fromArray(pose.position);
              } else {
                // Controller not 6DOF, apply arm model.
                if (data.armModel) {
                  this.applyArmModel(object3D.position);
                }
              }
              if (pose.orientation) {
                object3D.quaternion.fromArray(pose.orientation);
              }

              // Apply transforms, if 6DOF and in VR.
              if (vrDisplay && pose.position) {
                standingMatrix = this.el.sceneEl.renderer.xr.getStandingMatrix();
                object3D.matrix.compose(object3D.position, object3D.quaternion, object3D.scale);
                object3D.matrix.multiplyMatrices(standingMatrix, object3D.matrix);
                object3D.matrix.decompose(object3D.position, object3D.quaternion, object3D.scale);
              }
              object3D.rotateX(this.data.orientationOffset.x * THREE.MathUtils.DEG2RAD);
              object3D.rotateY(this.data.orientationOffset.y * THREE.MathUtils.DEG2RAD);
              object3D.rotateZ(this.data.orientationOffset.z * THREE.MathUtils.DEG2RAD);
            },
            /**
             * Handle button changes including axes, presses, touches, values.
             */
            updateButtons: function updateButtons() {
              var buttonState;
              var controller = this.controller;
              var id;
              if (!controller) {
                return;
              }

              // Check every button.
              for (id = 0; id < controller.buttons.length; ++id) {
                // Initialize button state.
                if (!this.buttonStates[id]) {
                  this.buttonStates[id] = {
                    pressed: false,
                    touched: false,
                    value: 0
                  };
                }
                if (!this.buttonEventDetails[id]) {
                  this.buttonEventDetails[id] = {
                    id: id,
                    state: this.buttonStates[id]
                  };
                }
                buttonState = controller.buttons[id];
                this.handleButton(id, buttonState);
              }
              // Check axes.
              this.handleAxes();
            },
            /**
             * Handle presses and touches for a single button.
             *
             * @param {number} id - Index of button in Gamepad button array.
             * @param {number} buttonState - Value of button state from 0 to 1.
             * @returns {boolean} Whether button has changed in any way.
             */
            handleButton: function handleButton(id, buttonState) {
              var changed;
              changed = this.handlePress(id, buttonState) | this.handleTouch(id, buttonState) | this.handleValue(id, buttonState);
              if (!changed) {
                return false;
              }
              this.el.emit(EVENTS.BUTTONCHANGED, this.buttonEventDetails[id], false);
              return true;
            },
            /**
             * An axis is an array of values from -1 (up, left) to 1 (down, right).
             * Compare each component of the axis to the previous value to determine change.
             *
             * @returns {boolean} Whether axes changed.
             */
            handleAxes: function handleAxes() {
              var changed = false;
              var controllerAxes = this.controller.axes;
              var i;
              var previousAxis = this.axis;
              var changedAxes = this.changedAxes;

              // Check if axis changed.
              this.changedAxes.splice(0, this.changedAxes.length);
              for (i = 0; i < controllerAxes.length; ++i) {
                changedAxes.push(previousAxis[i] !== controllerAxes[i]);
                if (changedAxes[i]) {
                  changed = true;
                }
              }
              if (!changed) {
                return false;
              }
              this.axis.splice(0, this.axis.length);
              for (i = 0; i < controllerAxes.length; i++) {
                this.axis.push(controllerAxes[i]);
              }
              this.el.emit(EVENTS.AXISMOVE, this.axisMoveEventDetail, false);
              return true;
            },
            /**
             * Determine whether a button press has occured and emit events as appropriate.
             *
             * @param {string} id - ID of the button to check.
             * @param {object} buttonState - State of the button to check.
             * @returns {boolean} Whether button press state changed.
             */
            handlePress: function handlePress(id, buttonState) {
              var evtName;
              var previousButtonState = this.buttonStates[id];

              // Not changed.
              if (buttonState.pressed === previousButtonState.pressed) {
                return false;
              }
              evtName = buttonState.pressed ? EVENTS.BUTTONDOWN : EVENTS.BUTTONUP;
              this.el.emit(evtName, this.buttonEventDetails[id], false);
              previousButtonState.pressed = buttonState.pressed;
              return true;
            },
            /**
             * Determine whether a button touch has occured and emit events as appropriate.
             *
             * @param {string} id - ID of the button to check.
             * @param {object} buttonState - State of the button to check.
             * @returns {boolean} Whether button touch state changed.
             */
            handleTouch: function handleTouch(id, buttonState) {
              var evtName;
              var previousButtonState = this.buttonStates[id];

              // Not changed.
              if (buttonState.touched === previousButtonState.touched) {
                return false;
              }
              evtName = buttonState.touched ? EVENTS.TOUCHSTART : EVENTS.TOUCHEND;
              this.el.emit(evtName, this.buttonEventDetails[id], false, EMPTY_DAYDREAM_TOUCHES);
              previousButtonState.touched = buttonState.touched;
              return true;
            },
            /**
             * Determine whether a button value has changed.
             *
             * @param {string} id - Id of the button to check.
             * @param {object} buttonState - State of the button to check.
             * @returns {boolean} Whether button value changed.
             */
            handleValue: function handleValue(id, buttonState) {
              var previousButtonState = this.buttonStates[id];

              // Not changed.
              if (buttonState.value === previousButtonState.value) {
                return false;
              }
              previousButtonState.value = buttonState.value;
              return true;
            }
          });

          /***/
        },

        /***/"./src/components/tracked-controls-webxr.js":
        /*!**************************************************!*\
          !*** ./src/components/tracked-controls-webxr.js ***!
          \**************************************************/
        /***/
        function srcComponentsTrackedControlsWebxrJs(module, __unused_webpack_exports, __webpack_require__) {
          var controllerUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var EVENTS = {
            AXISMOVE: 'axismove',
            BUTTONCHANGED: 'buttonchanged',
            BUTTONDOWN: 'buttondown',
            BUTTONUP: 'buttonup',
            TOUCHSTART: 'touchstart',
            TOUCHEND: 'touchend'
          };
          module.exports.Component = registerComponent('tracked-controls-webxr', {
            schema: {
              id: {
                type: 'string',
                default: ''
              },
              hand: {
                type: 'string',
                default: ''
              },
              handTrackingEnabled: {
                default: false
              },
              index: {
                type: 'int',
                default: -1
              },
              iterateControllerProfiles: {
                default: false
              },
              space: {
                type: 'string',
                oneOf: ['targetRaySpace', 'gripSpace'],
                default: 'gripSpace'
              }
            },
            init: function init() {
              this.updateController = this.updateController.bind(this);
              this.buttonEventDetails = {};
              this.buttonStates = this.el.components['tracked-controls'].buttonStates = {};
              this.axis = this.el.components['tracked-controls'].axis = [0, 0, 0];
              this.changedAxes = [];
              this.axisMoveEventDetail = {
                axis: this.axis,
                changed: this.changedAxes
              };
            },
            update: function update() {
              this.updateController();
            },
            play: function play() {
              var sceneEl = this.el.sceneEl;
              this.updateController();
              sceneEl.addEventListener('controllersupdated', this.updateController);
            },
            pause: function pause() {
              var sceneEl = this.el.sceneEl;
              sceneEl.removeEventListener('controllersupdated', this.updateController);
            },
            isControllerPresent: function isControllerPresent(evt) {
              if (!this.controller || this.controller.gamepad) {
                return false;
              }
              if (evt.inputSource.handedness !== 'none' && evt.inputSource.handedness !== this.data.hand) {
                return false;
              }
              return true;
            },
            /**
             * Handle update controller match criteria (such as `id`, `idPrefix`, `hand`, `controller`)
             */
            updateController: function updateController() {
              this.controller = controllerUtils.findMatchingControllerWebXR(this.system.controllers, this.data.id, this.data.hand, this.data.index, this.data.iterateControllerProfiles, this.data.handTrackingEnabled);
              // Legacy handle to the controller for old components.
              this.el.components['tracked-controls'].controller = this.controller;
              if (this.data.autoHide) {
                this.el.object3D.visible = !!this.controller;
              }
            },
            tick: function tick() {
              var sceneEl = this.el.sceneEl;
              var controller = this.controller;
              var frame = sceneEl.frame;
              if (!controller || !sceneEl.frame || !this.system.referenceSpace) {
                return;
              }
              if (!controller.hand) {
                this.pose = frame.getPose(controller[this.data.space], this.system.referenceSpace);
                this.updatePose();
                this.updateButtons();
              }
            },
            updatePose: function updatePose() {
              var object3D = this.el.object3D;
              var pose = this.pose;
              if (!pose) {
                return;
              }
              object3D.matrix.elements = pose.transform.matrix;
              object3D.matrix.decompose(object3D.position, object3D.rotation, object3D.scale);
            },
            /**
             * Handle button changes including axes, presses, touches, values.
             */
            updateButtons: function updateButtons() {
              var buttonState;
              var id;
              var controller = this.controller;
              var gamepad;
              if (!controller || !controller.gamepad) {
                return;
              }
              gamepad = controller.gamepad;
              // Check every button.
              for (id = 0; id < gamepad.buttons.length; ++id) {
                // Initialize button state.
                if (!this.buttonStates[id]) {
                  this.buttonStates[id] = {
                    pressed: false,
                    touched: false,
                    value: 0
                  };
                }
                if (!this.buttonEventDetails[id]) {
                  this.buttonEventDetails[id] = {
                    id: id,
                    state: this.buttonStates[id]
                  };
                }
                buttonState = gamepad.buttons[id];
                this.handleButton(id, buttonState);
              }
              // Check axes.
              this.handleAxes();
            },
            /**
             * Handle presses and touches for a single button.
             *
             * @param {number} id - Index of button in Gamepad button array.
             * @param {number} buttonState - Value of button state from 0 to 1.
             * @returns {boolean} Whether button has changed in any way.
             */
            handleButton: function handleButton(id, buttonState) {
              var changed;
              changed = this.handlePress(id, buttonState) | this.handleTouch(id, buttonState) | this.handleValue(id, buttonState);
              if (!changed) {
                return false;
              }
              this.el.emit(EVENTS.BUTTONCHANGED, this.buttonEventDetails[id], false);
              return true;
            },
            /**
             * An axis is an array of values from -1 (up, left) to 1 (down, right).
             * Compare each component of the axis to the previous value to determine change.
             *
             * @returns {boolean} Whether axes changed.
             */
            handleAxes: function handleAxes() {
              var changed = false;
              var controllerAxes = this.controller.gamepad.axes;
              var i;
              var previousAxis = this.axis;
              var changedAxes = this.changedAxes;

              // Check if axis changed.
              this.changedAxes.splice(0, this.changedAxes.length);
              for (i = 0; i < controllerAxes.length; ++i) {
                changedAxes.push(previousAxis[i] !== controllerAxes[i]);
                if (changedAxes[i]) {
                  changed = true;
                }
              }
              if (!changed) {
                return false;
              }
              this.axis.splice(0, this.axis.length);
              for (i = 0; i < controllerAxes.length; i++) {
                this.axis.push(controllerAxes[i]);
              }
              this.el.emit(EVENTS.AXISMOVE, this.axisMoveEventDetail, false);
              return true;
            },
            /**
             * Determine whether a button press has occured and emit events as appropriate.
             *
             * @param {string} id - ID of the button to check.
             * @param {object} buttonState - State of the button to check.
             * @returns {boolean} Whether button press state changed.
             */
            handlePress: function handlePress(id, buttonState) {
              var evtName;
              var previousButtonState = this.buttonStates[id];

              // Not changed.
              if (buttonState.pressed === previousButtonState.pressed) {
                return false;
              }
              evtName = buttonState.pressed ? EVENTS.BUTTONDOWN : EVENTS.BUTTONUP;
              this.el.emit(evtName, this.buttonEventDetails[id], false);
              previousButtonState.pressed = buttonState.pressed;
              return true;
            },
            /**
             * Determine whether a button touch has occured and emit events as appropriate.
             *
             * @param {string} id - ID of the button to check.
             * @param {object} buttonState - State of the button to check.
             * @returns {boolean} Whether button touch state changed.
             */
            handleTouch: function handleTouch(id, buttonState) {
              var evtName;
              var previousButtonState = this.buttonStates[id];

              // Not changed.
              if (buttonState.touched === previousButtonState.touched) {
                return false;
              }
              evtName = buttonState.touched ? EVENTS.TOUCHSTART : EVENTS.TOUCHEND;
              this.el.emit(evtName, this.buttonEventDetails[id], false);
              previousButtonState.touched = buttonState.touched;
              return true;
            },
            /**
             * Determine whether a button value has changed.
             *
             * @param {string} id - Id of the button to check.
             * @param {object} buttonState - State of the button to check.
             * @returns {boolean} Whether button value changed.
             */
            handleValue: function handleValue(id, buttonState) {
              var previousButtonState = this.buttonStates[id];

              // Not changed.
              if (buttonState.value === previousButtonState.value) {
                return false;
              }
              previousButtonState.value = buttonState.value;
              return true;
            }
          });

          /***/
        },

        /***/"./src/components/tracked-controls.js":
        /*!********************************************!*\
          !*** ./src/components/tracked-controls.js ***!
          \********************************************/
        /***/
        function srcComponentsTrackedControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;

          /**
           * Tracked controls.
           * Abstract controls that decide if the WebVR or WebXR version is going to be applied.
           *
           * @property {number} controller - Index of controller in array returned by Gamepad API.
           *  Only used if hand property is not set.
           * @property {string} id - Selected controller among those returned by Gamepad API.
           * @property {number} hand - If multiple controllers found with id, choose the one with the
           *  given value for hand. If set, we ignore 'controller' property
           */
          module.exports.Component = registerComponent('tracked-controls', {
            schema: {
              autoHide: {
                default: true
              },
              controller: {
                default: -1
              },
              id: {
                type: 'string',
                default: ''
              },
              hand: {
                type: 'string',
                default: ''
              },
              idPrefix: {
                type: 'string',
                default: ''
              },
              handTrackingEnabled: {
                default: false
              },
              orientationOffset: {
                type: 'vec3'
              },
              // Arm model parameters when not 6DoF.
              armModel: {
                default: false
              },
              headElement: {
                type: 'selector'
              },
              iterateControllerProfiles: {
                default: false
              },
              space: {
                type: 'string',
                oneOf: ['targetRaySpace', 'gripSpace'],
                default: 'targetRaySpace'
              }
            },
            update: function update() {
              var data = this.data;
              var el = this.el;
              if (el.sceneEl.hasWebXR) {
                el.setAttribute('tracked-controls-webxr', {
                  id: data.id,
                  hand: data.hand,
                  index: data.controller,
                  iterateControllerProfiles: data.iterateControllerProfiles,
                  handTrackingEnabled: data.handTrackingEnabled,
                  space: data.space
                });
              } else {
                el.setAttribute('tracked-controls-webvr', data);
              }
            }
          });

          /***/
        },

        /***/"./src/components/valve-index-controls.js":
        /*!************************************************!*\
          !*** ./src/components/valve-index-controls.js ***!
          \************************************************/
        /***/
        function srcComponentsValveIndexControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var INDEX_CONTROLLER_MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/valve/index/valve-index-';
          var INDEX_CONTROLLER_MODEL_URL = {
            left: INDEX_CONTROLLER_MODEL_BASE_URL + 'left.glb',
            right: INDEX_CONTROLLER_MODEL_BASE_URL + 'right.glb'
          };
          var GAMEPAD_ID_PREFIX = 'valve';
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var INDEX_CONTROLLER_POSITION_OFFSET_WEBVR = {
            left: {
              x: -0.00023692678902063457,
              y: 0.04724540367838371,
              z: -0.061959880395271096
            },
            right: {
              x: 0.002471558599671131,
              y: 0.055765208987076195,
              z: -0.061068168708348844
            }
          };
          var INDEX_CONTROLLER_POSITION_OFFSET_WEBXR = {
            left: {
              x: 0,
              y: -0.05,
              z: 0.06
            },
            right: {
              x: 0,
              y: -0.05,
              z: 0.06
            }
          };
          var INDEX_CONTROLLER_ROTATION_OFFSET_WEBVR = {
            left: {
              _x: 0.692295102620542,
              _y: -0.0627618864318427,
              _z: -0.06265893149611756,
              _order: 'XYZ'
            },
            right: {
              _x: 0.6484021229942998,
              _y: -0.032563619881892894,
              _z: -0.1327973171917482,
              _order: 'XYZ'
            }
          };
          var INDEX_CONTROLLER_ROTATION_OFFSET_WEBXR = {
            left: {
              _x: Math.PI / 3,
              _y: 0,
              _z: 0,
              _order: 'XYZ'
            },
            right: {
              _x: Math.PI / 3,
              _y: 0,
              _z: 0,
              _order: 'XYZ'
            }
          };
          var INDEX_CONTROLLER_ROTATION_OFFSET = isWebXRAvailable ? INDEX_CONTROLLER_ROTATION_OFFSET_WEBXR : INDEX_CONTROLLER_ROTATION_OFFSET_WEBVR;
          var INDEX_CONTROLLER_POSITION_OFFSET = isWebXRAvailable ? INDEX_CONTROLLER_POSITION_OFFSET_WEBXR : INDEX_CONTROLLER_POSITION_OFFSET_WEBVR;
          /**
           * Vive controls.
           * Interface with Vive controllers and map Gamepad events to controller buttons:
           * trackpad, trigger, grip, menu, system
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('valve-index-controls', {
            schema: {
              hand: {
                default: 'left'
              },
              buttonColor: {
                type: 'color',
                default: '#FAFAFA'
              },
              // Off-white.
              buttonHighlightColor: {
                type: 'color',
                default: '#22D1EE'
              },
              // Light blue.
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              }
            },
            mapping: {
              axes: {
                trackpad: [0, 1],
                thumbstick: [2, 3]
              },
              buttons: ['trigger', 'grip', 'trackpad', 'thumbstick', 'abutton']
            },
            init: function init() {
              var self = this;
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.previousButtonValues = {};
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
            },
            /**
             * Once OpenVR returns correct hand data in supporting browsers, we can use hand property.
             * var isPresent = checkControllerPresentAndSetup(this.el.sceneEl, GAMEPAD_ID_PREFIX,
                                                                  { hand: data.hand });
             * Until then, use hardcoded index.
             */
            checkIfControllerPresent: function checkIfControllerPresent() {
              var data = this.data;
              var controllerIndex = data.hand === 'right' ? 0 : data.hand === 'left' ? 1 : 2;
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, {
                index: controllerIndex,
                iterateControllerProfiles: true,
                hand: data.hand
              });
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;

              // If we have an OpenVR Gamepad, use the fixed mapping.
              el.setAttribute('tracked-controls', {
                idPrefix: GAMEPAD_ID_PREFIX,
                // Hand IDs: 1 = right, 0 = left, 2 = anything else.
                controller: data.hand === 'right' ? 1 : data.hand === 'left' ? 0 : 2,
                hand: data.hand,
                orientationOffset: data.orientationOffset
              });
              this.loadModel();
            },
            loadModel: function loadModel() {
              var data = this.data;
              if (!data.model) {
                return;
              }
              this.el.setAttribute('gltf-model', '' + INDEX_CONTROLLER_MODEL_URL[data.hand] + '');
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            /**
             * Rotate the trigger button based on how hard the trigger is pressed.
             */
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              var buttonMeshes = this.buttonMeshes;
              var analogValue;
              if (!button) {
                return;
              }
              if (button === 'trigger') {
                analogValue = evt.detail.state.value;
                // Update trigger rotation depending on button value.
                if (buttonMeshes && buttonMeshes.trigger) {
                  buttonMeshes.trigger.rotation.x = this.triggerOriginalRotationX - analogValue * (Math.PI / 40);
                }
              }

              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onModelLoaded: function onModelLoaded(evt) {
              var buttonMeshes;
              var controllerObject3D = evt.detail.model;
              var self = this;
              if (!this.data.model) {
                return;
              }

              // Store button meshes object to be able to change their colors.
              buttonMeshes = this.buttonMeshes = {};
              buttonMeshes.grip = {
                left: controllerObject3D.getObjectByName('leftgrip'),
                right: controllerObject3D.getObjectByName('rightgrip')
              };
              buttonMeshes.menu = controllerObject3D.getObjectByName('menubutton');
              buttonMeshes.system = controllerObject3D.getObjectByName('systembutton');
              buttonMeshes.trackpad = controllerObject3D.getObjectByName('touchpad');
              buttonMeshes.trigger = controllerObject3D.getObjectByName('trigger');
              this.triggerOriginalRotationX = buttonMeshes.trigger.rotation.x;

              // Set default colors.
              Object.keys(buttonMeshes).forEach(function (buttonName) {
                self.setButtonColor(buttonName, self.data.buttonColor);
              });

              // Offset pivot point.
              controllerObject3D.position.copy(INDEX_CONTROLLER_POSITION_OFFSET[this.data.hand]);
              controllerObject3D.rotation.copy(INDEX_CONTROLLER_ROTATION_OFFSET[this.data.hand]);
              this.el.emit('controllermodelready', {
                name: 'valve-index-controlls',
                model: this.data.model,
                rayOrigin: new THREE.Vector3(0, 0, 0)
              });
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            updateModel: function updateModel(buttonName, evtName) {
              var color;
              var isTouch;
              if (!this.data.model) {
                return;
              }
              isTouch = evtName.indexOf('touch') !== -1;
              // Don't change color for trackpad touch.
              if (isTouch) {
                return;
              }

              // Update colors.
              color = evtName === 'up' ? this.data.buttonColor : this.data.buttonHighlightColor;
              this.setButtonColor(buttonName, color);
            },
            setButtonColor: function setButtonColor(buttonName, color) {
              // TODO: The meshes aren't set up correctly now, skipping for the moment
              return;
            }
          });

          /***/
        },

        /***/"./src/components/visible.js":
        /*!***********************************!*\
          !*** ./src/components/visible.js ***!
          \***********************************/
        /***/
        function srcComponentsVisibleJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;

          /**
           * Visibility component.
           */
          module.exports.Component = registerComponent('visible', {
            schema: {
              default: true
            },
            update: function update() {
              this.el.object3D.visible = this.data;
            }
          });

          /***/
        },

        /***/"./src/components/vive-controls.js":
        /*!*****************************************!*\
          !*** ./src/components/vive-controls.js ***!
          \*****************************************/
        /***/
        function srcComponentsViveControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var VIVE_CONTROLLER_MODEL_OBJ_URL = 'https://cdn.aframe.io/controllers/vive/vr_controller_vive.obj';
          var VIVE_CONTROLLER_MODEL_OBJ_MTL = 'https://cdn.aframe.io/controllers/vive/vr_controller_vive.mtl';
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var GAMEPAD_ID_WEBXR = 'htc-vive';
          var GAMEPAD_ID_WEBVR = 'OpenVR ';

          // Prefix for Gen1 and Gen2 Oculus Touch Controllers.
          var GAMEPAD_ID_PREFIX = isWebXRAvailable ? GAMEPAD_ID_WEBXR : GAMEPAD_ID_WEBVR;

          /**
           * Button IDs:
           * 0 - trackpad
           * 1 - trigger (intensity value from 0.5 to 1)
           * 2 - grip
           * 3 - menu (dispatch but better for menu options)
           * 4 - system (never dispatched on this layer)
           */
          var INPUT_MAPPING_WEBVR = {
            axes: {
              trackpad: [0, 1]
            },
            buttons: ['trackpad', 'trigger', 'grip', 'menu', 'system']
          };

          /**
           * Button IDs:
           * 0 - trigger
           * 1 - squeeze
           * 2 - touchpad
           * 3 - none (dispatch but better for menu options)
           * 4 - menu (never dispatched on this layer)
           *
           * Axis:
           * 0 - touchpad x axis
           * 1 - touchpad y axis
           * Reference: https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/htc/htc-vive.json
           */
          var INPUT_MAPPING_WEBXR = {
            axes: {
              thumbstick: [0, 1]
            },
            buttons: ['trigger', 'grip', 'trackpad', 'none', 'menu']
          };
          var INPUT_MAPPING = isWebXRAvailable ? INPUT_MAPPING_WEBXR : INPUT_MAPPING_WEBVR;

          /**
           * Vive controls.
           * Interface with Vive controllers and map Gamepad events to controller buttons:
           * trackpad, trigger, grip, menu, system
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('vive-controls', {
            schema: {
              hand: {
                default: 'left'
              },
              buttonColor: {
                type: 'color',
                default: '#FAFAFA'
              },
              // Off-white.
              buttonHighlightColor: {
                type: 'color',
                default: '#22D1EE'
              },
              // Light blue.
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              }
            },
            mapping: INPUT_MAPPING,
            init: function init() {
              var self = this;
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.previousButtonValues = {};
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.bindMethods();
            },
            update: function update() {
              var data = this.data;
              this.controllerIndex = data.hand === 'right' ? 0 : data.hand === 'left' ? 1 : 2;
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
            },
            /**
             * Once OpenVR returns correct hand data in supporting browsers, we can use hand property.
             * var isPresent = checkControllerPresentAndSetup(this.el.sceneEl, GAMEPAD_ID_PREFIX,
                                                                  { hand: data.hand });
             * Until then, use hardcoded index.
             */
            checkIfControllerPresent: function checkIfControllerPresent() {
              var data = this.data;
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, {
                index: this.controllerIndex,
                hand: data.hand
              });
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;

              // If we have an OpenVR Gamepad, use the fixed mapping.
              el.setAttribute('tracked-controls', {
                idPrefix: GAMEPAD_ID_PREFIX,
                hand: data.hand,
                controller: this.controllerIndex,
                orientationOffset: data.orientationOffset
              });

              // Load model.
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('obj-model', {
                obj: VIVE_CONTROLLER_MODEL_OBJ_URL,
                mtl: VIVE_CONTROLLER_MODEL_OBJ_MTL
              });
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            /**
             * Rotate the trigger button based on how hard the trigger is pressed.
             */
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              var buttonMeshes = this.buttonMeshes;
              var analogValue;
              if (!button) {
                return;
              }
              if (button === 'trigger') {
                analogValue = evt.detail.state.value;
                // Update trigger rotation depending on button value.
                if (buttonMeshes && buttonMeshes.trigger) {
                  buttonMeshes.trigger.rotation.x = -analogValue * (Math.PI / 12);
                }
              }

              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onModelLoaded: function onModelLoaded(evt) {
              var buttonMeshes;
              var controllerObject3D = evt.detail.model;
              var self = this;
              if (!this.data.model) {
                return;
              }

              // Store button meshes object to be able to change their colors.
              buttonMeshes = this.buttonMeshes = {};
              buttonMeshes.grip = {
                left: controllerObject3D.getObjectByName('leftgrip'),
                right: controllerObject3D.getObjectByName('rightgrip')
              };
              buttonMeshes.menu = controllerObject3D.getObjectByName('menubutton');
              buttonMeshes.system = controllerObject3D.getObjectByName('systembutton');
              buttonMeshes.trackpad = controllerObject3D.getObjectByName('touchpad');
              buttonMeshes.trigger = controllerObject3D.getObjectByName('trigger');

              // Set default colors.
              Object.keys(buttonMeshes).forEach(function (buttonName) {
                self.setButtonColor(buttonName, self.data.buttonColor);
              });

              // Offset pivot point.
              controllerObject3D.position.set(0, -0.015, 0.04);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            updateModel: function updateModel(buttonName, evtName) {
              var color;
              var isTouch;
              if (!this.data.model) {
                return;
              }
              isTouch = evtName.indexOf('touch') !== -1;
              // Don't change color for trackpad touch.
              if (isTouch) {
                return;
              }

              // Update colors.
              color = evtName === 'up' ? this.data.buttonColor : this.data.buttonHighlightColor;
              this.setButtonColor(buttonName, color);
            },
            setButtonColor: function setButtonColor(buttonName, color) {
              var buttonMeshes = this.buttonMeshes;
              var rendererSystem = this.rendererSystem;
              if (!buttonMeshes) {
                return;
              }

              // Need to do both left and right sides for grip.
              if (buttonName === 'grip') {
                buttonMeshes.grip.left.material.color.set(color);
                buttonMeshes.grip.right.material.color.set(color);
                rendererSystem.applyColorCorrection(buttonMeshes.grip.left.material.color);
                rendererSystem.applyColorCorrection(buttonMeshes.grip.right.material.color);
                return;
              }
              buttonMeshes[buttonName].material.color.set(color);
              rendererSystem.applyColorCorrection(buttonMeshes[buttonName].material.color);
            }
          });

          /***/
        },

        /***/"./src/components/vive-focus-controls.js":
        /*!***********************************************!*\
          !*** ./src/components/vive-focus-controls.js ***!
          \***********************************************/
        /***/
        function srcComponentsViveFocusControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var GAMEPAD_ID_PREFIX = 'HTC Vive Focus';
          var VIVE_FOCUS_CONTROLLER_MODEL_URL = 'https://cdn.aframe.io/controllers/vive/focus-controller/focus-controller.gltf';

          /**
           * Vive Focus controls.
           * Interface with Vive Focus controller and map Gamepad events to
           * controller buttons: trackpad, trigger
           * Load a controller model and highlight the pressed buttons.
           */
          module.exports.Component = registerComponent('vive-focus-controls', {
            schema: {
              hand: {
                default: ''
              },
              // This informs the degenerate arm model.
              buttonTouchedColor: {
                type: 'color',
                default: '#BBBBBB'
              },
              buttonHighlightColor: {
                type: 'color',
                default: '#7A7A7A'
              },
              model: {
                default: true
              },
              orientationOffset: {
                type: 'vec3'
              },
              armModel: {
                default: true
              }
            },
            /**
             * Button IDs:
             * 0 - trackpad
             * 1 - trigger
             */
            mapping: {
              axes: {
                trackpad: [0, 1]
              },
              buttons: ['trackpad', 'trigger']
            },
            bindMethods: function bindMethods() {
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.bindMethods();
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('model-loaded', this.onModelLoaded);
              el.addEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = true;
              this.addControllersUpdateListener();
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              el.removeEventListener('axismove', this.onAxisMoved);
              this.controllerEventsActive = false;
              this.removeControllersUpdateListener();
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, this.data.hand ? {
                hand: this.data.hand
              } : {});
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            injectTrackedControls: function injectTrackedControls() {
              var el = this.el;
              var data = this.data;
              el.setAttribute('tracked-controls', {
                armModel: data.armModel,
                idPrefix: GAMEPAD_ID_PREFIX,
                orientationOffset: data.orientationOffset
              });
              if (!this.data.model) {
                return;
              }
              this.el.setAttribute('gltf-model', VIVE_FOCUS_CONTROLLER_MODEL_URL);
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            onModelLoaded: function onModelLoaded(evt) {
              var controllerObject3D = evt.detail.model;
              var buttonMeshes;
              if (!this.data.model) {
                return;
              }
              buttonMeshes = this.buttonMeshes = {};
              buttonMeshes.trigger = controllerObject3D.getObjectByName('BumperKey');
              buttonMeshes.triggerPressed = controllerObject3D.getObjectByName('BumperKey_Press');
              if (buttonMeshes.triggerPressed) {
                buttonMeshes.triggerPressed.visible = false;
              }
              buttonMeshes.trackpad = controllerObject3D.getObjectByName('TouchPad');
              buttonMeshes.trackpadPressed = controllerObject3D.getObjectByName('TouchPad_Press');
              if (buttonMeshes.trackpadPressed) {
                buttonMeshes.trackpadPressed.visible = false;
              }
            },
            // No analog buttons, only emits 0/1 values
            onButtonChanged: function onButtonChanged(evt) {
              var button = this.mapping.buttons[evt.detail.id];
              if (!button) return;
              // Pass along changed event with button state, using button mapping for convenience.
              this.el.emit(button + 'changed', evt.detail.state);
            },
            onAxisMoved: function onAxisMoved(evt) {
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            updateModel: function updateModel(buttonName, evtName) {
              if (!this.data.model) {
                return;
              }
              this.updateButtonModel(buttonName, evtName);
            },
            updateButtonModel: function updateButtonModel(buttonName, state) {
              var buttonMeshes = this.buttonMeshes;
              var pressedName = buttonName + 'Pressed';
              if (!buttonMeshes || !buttonMeshes[buttonName] || !buttonMeshes[pressedName]) {
                return;
              }
              var color;
              switch (state) {
                case 'down':
                  color = this.data.buttonHighlightColor;
                  break;
                case 'touchstart':
                  color = this.data.buttonTouchedColor;
                  break;
              }
              if (color) {
                buttonMeshes[pressedName].material.color.set(color);
              }
              buttonMeshes[pressedName].visible = !!color;
              buttonMeshes[buttonName].visible = !color;
            }
          });

          /***/
        },

        /***/"./src/components/wasd-controls.js":
        /*!*****************************************!*\
          !*** ./src/components/wasd-controls.js ***!
          \*****************************************/
        /***/
        function srcComponentsWasdControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var KEYCODE_TO_CODE = __webpack_require__( /*! ../constants */"./src/constants/index.js").keyboardevent.KEYCODE_TO_CODE;
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var bind = utils.bind;
          var shouldCaptureKeyEvent = utils.shouldCaptureKeyEvent;
          var CLAMP_VELOCITY = 0.00001;
          var MAX_DELTA = 0.2;
          var KEYS = ['KeyW', 'KeyA', 'KeyS', 'KeyD', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown'];

          /**
           * WASD component to control entities using WASD keys.
           */
          module.exports.Component = registerComponent('wasd-controls', {
            schema: {
              acceleration: {
                default: 65
              },
              adAxis: {
                default: 'x',
                oneOf: ['x', 'y', 'z']
              },
              adEnabled: {
                default: true
              },
              adInverted: {
                default: false
              },
              enabled: {
                default: true
              },
              fly: {
                default: false
              },
              wsAxis: {
                default: 'z',
                oneOf: ['x', 'y', 'z']
              },
              wsEnabled: {
                default: true
              },
              wsInverted: {
                default: false
              }
            },
            init: function init() {
              // To keep track of the pressed keys.
              this.keys = {};
              this.easing = 1.1;
              this.velocity = new THREE.Vector3();

              // Bind methods and add event listeners.
              this.onBlur = bind(this.onBlur, this);
              this.onContextMenu = bind(this.onContextMenu, this);
              this.onFocus = bind(this.onFocus, this);
              this.onKeyDown = bind(this.onKeyDown, this);
              this.onKeyUp = bind(this.onKeyUp, this);
              this.onVisibilityChange = bind(this.onVisibilityChange, this);
              this.attachVisibilityEventListeners();
            },
            tick: function tick(time, delta) {
              var data = this.data;
              var el = this.el;
              var velocity = this.velocity;
              if (!velocity[data.adAxis] && !velocity[data.wsAxis] && isEmptyObject(this.keys)) {
                return;
              }

              // Update velocity.
              delta = delta / 1000;
              this.updateVelocity(delta);
              if (!velocity[data.adAxis] && !velocity[data.wsAxis]) {
                return;
              }

              // Get movement vector and translate position.
              el.object3D.position.add(this.getMovementVector(delta));
            },
            update: function update(oldData) {
              // Reset velocity if axis have changed.
              if (oldData.adAxis !== this.data.adAxis) {
                this.velocity[oldData.adAxis] = 0;
              }
              if (oldData.wsAxis !== this.data.wsAxis) {
                this.velocity[oldData.wsAxis] = 0;
              }
            },
            remove: function remove() {
              this.removeKeyEventListeners();
              this.removeVisibilityEventListeners();
            },
            play: function play() {
              this.attachKeyEventListeners();
            },
            pause: function pause() {
              this.keys = {};
              this.removeKeyEventListeners();
            },
            updateVelocity: function updateVelocity(delta) {
              var acceleration;
              var adAxis;
              var adSign;
              var data = this.data;
              var keys = this.keys;
              var velocity = this.velocity;
              var wsAxis;
              var wsSign;
              adAxis = data.adAxis;
              wsAxis = data.wsAxis;

              // If FPS too low, reset velocity.
              if (delta > MAX_DELTA) {
                velocity[adAxis] = 0;
                velocity[wsAxis] = 0;
                return;
              }

              // https://gamedev.stackexchange.com/questions/151383/frame-rate-independant-movement-with-acceleration
              var scaledEasing = Math.pow(1 / this.easing, delta * 60);
              // Velocity Easing.
              if (velocity[adAxis] !== 0) {
                velocity[adAxis] = velocity[adAxis] * scaledEasing;
              }
              if (velocity[wsAxis] !== 0) {
                velocity[wsAxis] = velocity[wsAxis] * scaledEasing;
              }

              // Clamp velocity easing.
              if (Math.abs(velocity[adAxis]) < CLAMP_VELOCITY) {
                velocity[adAxis] = 0;
              }
              if (Math.abs(velocity[wsAxis]) < CLAMP_VELOCITY) {
                velocity[wsAxis] = 0;
              }
              if (!data.enabled) {
                return;
              }

              // Update velocity using keys pressed.
              acceleration = data.acceleration;
              if (data.adEnabled) {
                adSign = data.adInverted ? -1 : 1;
                if (keys.KeyA || keys.ArrowLeft) {
                  velocity[adAxis] -= adSign * acceleration * delta;
                }
                if (keys.KeyD || keys.ArrowRight) {
                  velocity[adAxis] += adSign * acceleration * delta;
                }
              }
              if (data.wsEnabled) {
                wsSign = data.wsInverted ? -1 : 1;
                if (keys.KeyW || keys.ArrowUp) {
                  velocity[wsAxis] -= wsSign * acceleration * delta;
                }
                if (keys.KeyS || keys.ArrowDown) {
                  velocity[wsAxis] += wsSign * acceleration * delta;
                }
              }
            },
            getMovementVector: function () {
              var directionVector = new THREE.Vector3(0, 0, 0);
              var rotationEuler = new THREE.Euler(0, 0, 0, 'YXZ');
              return function (delta) {
                var rotation = this.el.getAttribute('rotation');
                var velocity = this.velocity;
                var xRotation;
                directionVector.copy(velocity);
                directionVector.multiplyScalar(delta);

                // Absolute.
                if (!rotation) {
                  return directionVector;
                }
                xRotation = this.data.fly ? rotation.x : 0;

                // Transform direction relative to heading.
                rotationEuler.set(THREE.MathUtils.degToRad(xRotation), THREE.MathUtils.degToRad(rotation.y), 0);
                directionVector.applyEuler(rotationEuler);
                return directionVector;
              };
            }(),
            attachVisibilityEventListeners: function attachVisibilityEventListeners() {
              window.oncontextmenu = this.onContextMenu;
              window.addEventListener('blur', this.onBlur);
              window.addEventListener('focus', this.onFocus);
              document.addEventListener('visibilitychange', this.onVisibilityChange);
            },
            removeVisibilityEventListeners: function removeVisibilityEventListeners() {
              window.removeEventListener('blur', this.onBlur);
              window.removeEventListener('focus', this.onFocus);
              document.removeEventListener('visibilitychange', this.onVisibilityChange);
            },
            attachKeyEventListeners: function attachKeyEventListeners() {
              window.addEventListener('keydown', this.onKeyDown);
              window.addEventListener('keyup', this.onKeyUp);
            },
            removeKeyEventListeners: function removeKeyEventListeners() {
              window.removeEventListener('keydown', this.onKeyDown);
              window.removeEventListener('keyup', this.onKeyUp);
            },
            onContextMenu: function onContextMenu() {
              var keys = Object.keys(this.keys);
              for (var i = 0; i < keys.length; i++) {
                delete this.keys[keys[i]];
              }
            },
            onBlur: function onBlur() {
              this.pause();
            },
            onFocus: function onFocus() {
              this.play();
            },
            onVisibilityChange: function onVisibilityChange() {
              if (document.hidden) {
                this.onBlur();
              } else {
                this.onFocus();
              }
            },
            onKeyDown: function onKeyDown(event) {
              var code;
              if (!shouldCaptureKeyEvent(event)) {
                return;
              }
              code = event.code || KEYCODE_TO_CODE[event.keyCode];
              if (KEYS.indexOf(code) !== -1) {
                this.keys[code] = true;
              }
            },
            onKeyUp: function onKeyUp(event) {
              var code;
              code = event.code || KEYCODE_TO_CODE[event.keyCode];
              delete this.keys[code];
            }
          });
          function isEmptyObject(keys) {
            var key;
            for (key in keys) {
              return false;
            }
            return true;
          }

          /***/
        },

        /***/"./src/components/windows-motion-controls.js":
        /*!***************************************************!*\
          !*** ./src/components/windows-motion-controls.js ***!
          \***************************************************/
        /***/
        function srcComponentsWindowsMotionControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE */
          var registerComponent = __webpack_require__( /*! ../core/component */"./src/core/component.js").registerComponent;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var trackedControlsUtils = __webpack_require__( /*! ../utils/tracked-controls */"./src/utils/tracked-controls.js");
          var checkControllerPresentAndSetup = trackedControlsUtils.checkControllerPresentAndSetup;
          var emitIfAxesChanged = trackedControlsUtils.emitIfAxesChanged;
          var onButtonEvent = trackedControlsUtils.onButtonEvent;
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var debug = utils.debug('components:windows-motion-controls:debug');
          var warn = utils.debug('components:windows-motion-controls:warn');
          var DEFAULT_HANDEDNESS = __webpack_require__( /*! ../constants */"./src/constants/index.js").DEFAULT_HANDEDNESS;
          var MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/microsoft/';
          var MODEL_FILENAMES = {
            left: 'left.glb',
            right: 'right.glb',
            default: 'universal.glb'
          };
          var isWebXRAvailable = __webpack_require__( /*! ../utils/ */"./src/utils/index.js").device.isWebXRAvailable;
          var GAMEPAD_ID_WEBXR = 'windows-mixed-reality';
          var GAMEPAD_ID_WEBVR = 'Spatial Controller (Spatial Interaction Source) ';
          var GAMEPAD_ID_PATTERN = /([0-9a-zA-Z]+-[0-9a-zA-Z]+)$/;
          var GAMEPAD_ID_PREFIX = isWebXRAvailable ? GAMEPAD_ID_WEBXR : GAMEPAD_ID_WEBVR;
          var INPUT_MAPPING_WEBVR = {
            // A-Frame specific semantic axis names
            axes: {
              'thumbstick': [0, 1],
              'trackpad': [2, 3]
            },
            // A-Frame specific semantic button names
            buttons: ['thumbstick', 'trigger', 'grip', 'menu', 'trackpad'],
            // A mapping of the semantic name to node name in the glTF model file,
            // that should be transformed by axis value.
            // This array mirrors the browser Gamepad.axes array, such that
            // the mesh corresponding to axis 0 is in this array index 0.
            axisMeshNames: ['THUMBSTICK_X', 'THUMBSTICK_Y', 'TOUCHPAD_TOUCH_X', 'TOUCHPAD_TOUCH_Y'],
            // A mapping of the semantic name to button node name in the glTF model file,
            // that should be transformed by button value.
            buttonMeshNames: {
              'trigger': 'SELECT',
              'menu': 'MENU',
              'grip': 'GRASP',
              'thumbstick': 'THUMBSTICK_PRESS',
              'trackpad': 'TOUCHPAD_PRESS'
            },
            pointingPoseMeshName: 'POINTING_POSE'
          };
          var INPUT_MAPPING_WEBXR = {
            // A-Frame specific semantic axis names
            axes: {
              'touchpad': [0, 1],
              'thumbstick': [2, 3]
            },
            // A-Frame specific semantic button names
            buttons: ['trigger', 'squeeze', 'touchpad', 'thumbstick', 'menu'],
            // A mapping of the semantic name to node name in the glTF model file,
            // that should be transformed by axis value.
            // This array mirrors the browser Gamepad.axes array, such that
            // the mesh corresponding to axis 0 is in this array index 0.
            axisMeshNames: ['TOUCHPAD_TOUCH_X', 'TOUCHPAD_TOUCH_X', 'THUMBSTICK_X', 'THUMBSTICK_Y'],
            // A mapping of the semantic name to button node name in the glTF model file,
            // that should be transformed by button value.
            buttonMeshNames: {
              'trigger': 'SELECT',
              'menu': 'MENU',
              'squeeze': 'GRASP',
              'thumbstick': 'THUMBSTICK_PRESS',
              'touchpad': 'TOUCHPAD_PRESS'
            },
            pointingPoseMeshName: 'POINTING_POSE'
          };
          var INPUT_MAPPING = isWebXRAvailable ? INPUT_MAPPING_WEBXR : INPUT_MAPPING_WEBVR;

          /**
           * Windows Motion Controller controls.
           * Interface with Windows Motion Controller controllers and map Gamepad events to
           * controller buttons: trackpad, trigger, grip, menu, thumbstick
           * Load a controller model and transform the pressed buttons.
           */
          module.exports.Component = registerComponent('windows-motion-controls', {
            schema: {
              hand: {
                default: DEFAULT_HANDEDNESS
              },
              // It is possible to have multiple pairs of controllers attached (a pair has both left and right).
              // Set this to 1 to use a controller from the second pair, 2 from the third pair, etc.
              pair: {
                default: 0
              },
              // If true, loads the controller glTF asset.
              model: {
                default: true
              },
              // If true, will hide the model from the scene if no matching gamepad (based on ID & hand) is connected.
              hideDisconnected: {
                default: true
              }
            },
            mapping: INPUT_MAPPING,
            bindMethods: function bindMethods() {
              this.onModelError = bind(this.onModelError, this);
              this.onModelLoaded = bind(this.onModelLoaded, this);
              this.onControllersUpdate = bind(this.onControllersUpdate, this);
              this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
              this.onAxisMoved = bind(this.onAxisMoved, this);
            },
            init: function init() {
              var self = this;
              var el = this.el;
              this.onButtonChanged = bind(this.onButtonChanged, this);
              this.onButtonDown = function (evt) {
                onButtonEvent(evt.detail.id, 'down', self);
              };
              this.onButtonUp = function (evt) {
                onButtonEvent(evt.detail.id, 'up', self);
              };
              this.onButtonTouchStart = function (evt) {
                onButtonEvent(evt.detail.id, 'touchstart', self);
              };
              this.onButtonTouchEnd = function (evt) {
                onButtonEvent(evt.detail.id, 'touchend', self);
              };
              this.onControllerConnected = function () {
                self.setModelVisibility(true);
              };
              this.onControllerDisconnected = function () {
                self.setModelVisibility(false);
              };
              this.controllerPresent = false;
              this.lastControllerCheck = 0;
              this.previousButtonValues = {};
              this.bindMethods();

              // Cache for submeshes that we have looked up by name.
              this.loadedMeshInfo = {
                buttonMeshes: null,
                axisMeshes: null
              };

              // Pointing poses
              this.rayOrigin = {
                origin: new THREE.Vector3(),
                direction: new THREE.Vector3(0, 0, -1),
                createdFromMesh: false
              };
              el.addEventListener('controllerconnected', this.onControllerConnected);
              el.addEventListener('controllerdisconnected', this.onControllerDisconnected);
            },
            addEventListeners: function addEventListeners() {
              var el = this.el;
              el.addEventListener('buttonchanged', this.onButtonChanged);
              el.addEventListener('buttondown', this.onButtonDown);
              el.addEventListener('buttonup', this.onButtonUp);
              el.addEventListener('touchstart', this.onButtonTouchStart);
              el.addEventListener('touchend', this.onButtonTouchEnd);
              el.addEventListener('axismove', this.onAxisMoved);
              el.addEventListener('model-error', this.onModelError);
              el.addEventListener('model-loaded', this.onModelLoaded);
              this.controllerEventsActive = true;
            },
            removeEventListeners: function removeEventListeners() {
              var el = this.el;
              el.removeEventListener('buttonchanged', this.onButtonChanged);
              el.removeEventListener('buttondown', this.onButtonDown);
              el.removeEventListener('buttonup', this.onButtonUp);
              el.removeEventListener('touchstart', this.onButtonTouchStart);
              el.removeEventListener('touchend', this.onButtonTouchEnd);
              el.removeEventListener('axismove', this.onAxisMoved);
              el.removeEventListener('model-error', this.onModelError);
              el.removeEventListener('model-loaded', this.onModelLoaded);
              this.controllerEventsActive = false;
            },
            checkIfControllerPresent: function checkIfControllerPresent() {
              checkControllerPresentAndSetup(this, GAMEPAD_ID_PREFIX, {
                hand: this.data.hand,
                index: this.data.pair,
                iterateControllerProfiles: true
              });
            },
            play: function play() {
              this.checkIfControllerPresent();
              this.addControllersUpdateListener();
            },
            pause: function pause() {
              this.removeEventListeners();
              this.removeControllersUpdateListener();
            },
            updateControllerModel: function updateControllerModel() {
              // If we do not want to load a model, or, have already loaded the model, emit the controllermodelready event.
              if (!this.data.model || this.rayOrigin.createdFromMesh) {
                this.modelReady();
                return;
              }
              var sourceUrl = this.createControllerModelUrl();
              this.loadModel(sourceUrl);
            },
            /**
             * Helper function that constructs a URL from the controller ID suffix, for future proofed
             * art assets.
             */
            createControllerModelUrl: function createControllerModelUrl(forceDefault) {
              // Determine the device specific folder based on the ID suffix
              var trackedControlsComponent = this.el.components['tracked-controls'];
              var controller = trackedControlsComponent ? trackedControlsComponent.controller : null;
              var device = 'default';
              var hand = this.data.hand;
              var filename;
              if (controller && !window.hasNativeWebXRImplementation) {
                // Read hand directly from the controller, rather than this.data, as in the case that the controller
                // is unhanded this.data will still have 'left' or 'right' (depending on what the user inserted in to the scene).
                // In this case, we want to load the universal model, so need to get the '' from the controller.
                hand = controller.hand;
                if (!forceDefault) {
                  var match = controller.id.match(GAMEPAD_ID_PATTERN);
                  device = match && match[0] || device;
                }
              }

              // Hand
              filename = MODEL_FILENAMES[hand] || MODEL_FILENAMES.default;

              // Final url
              return MODEL_BASE_URL + device + '/' + filename;
            },
            injectTrackedControls: function injectTrackedControls() {
              var data = this.data;
              this.el.setAttribute('tracked-controls', {
                idPrefix: GAMEPAD_ID_PREFIX,
                controller: data.pair,
                hand: data.hand,
                armModel: false
              });
              this.updateControllerModel();
            },
            addControllersUpdateListener: function addControllersUpdateListener() {
              this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            removeControllersUpdateListener: function removeControllersUpdateListener() {
              this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
            },
            onControllersUpdate: function onControllersUpdate() {
              this.checkIfControllerPresent();
            },
            onModelError: function onModelError(evt) {
              var defaultUrl = this.createControllerModelUrl(true);
              if (evt.detail.src !== defaultUrl) {
                warn('Failed to load controller model for device, attempting to load default.');
                this.loadModel(defaultUrl);
              } else {
                warn('Failed to load default controller model.');
              }
            },
            loadModel: function loadModel(url) {
              // The model is loaded by the gltf-model compoent when this attribute is initially set,
              // removed and re-loaded if the given url changes.
              this.el.setAttribute('gltf-model', 'url(' + url + ')');
            },
            onModelLoaded: function onModelLoaded(evt) {
              var rootNode = this.controllerModel = evt.detail.model;
              var loadedMeshInfo = this.loadedMeshInfo;
              var i;
              var meshName;
              var mesh;
              var meshInfo;
              debug('Processing model');

              // Reset the caches
              loadedMeshInfo.buttonMeshes = {};
              loadedMeshInfo.axisMeshes = {};

              // Cache our meshes so we aren't traversing the hierarchy per frame
              if (rootNode) {
                // Button Meshes
                for (i = 0; i < this.mapping.buttons.length; i++) {
                  meshName = this.mapping.buttonMeshNames[this.mapping.buttons[i]];
                  if (!meshName) {
                    debug('Skipping unknown button at index: ' + i + ' with mapped name: ' + this.mapping.buttons[i]);
                    continue;
                  }
                  mesh = rootNode.getObjectByName(meshName);
                  if (!mesh) {
                    warn('Missing button mesh with name: ' + meshName);
                    continue;
                  }
                  meshInfo = {
                    index: i,
                    value: getImmediateChildByName(mesh, 'VALUE'),
                    pressed: getImmediateChildByName(mesh, 'PRESSED'),
                    unpressed: getImmediateChildByName(mesh, 'UNPRESSED')
                  };
                  if (meshInfo.value && meshInfo.pressed && meshInfo.unpressed) {
                    loadedMeshInfo.buttonMeshes[this.mapping.buttons[i]] = meshInfo;
                  } else {
                    // If we didn't find the mesh, it simply means this button won't have transforms applied as mapped button value changes.
                    warn('Missing button submesh under mesh with name: ' + meshName + '(VALUE: ' + !!meshInfo.value + ', PRESSED: ' + !!meshInfo.pressed + ', UNPRESSED:' + !!meshInfo.unpressed + ')');
                  }
                }

                // Axis Meshes
                for (i = 0; i < this.mapping.axisMeshNames.length; i++) {
                  meshName = this.mapping.axisMeshNames[i];
                  if (!meshName) {
                    debug('Skipping unknown axis at index: ' + i);
                    continue;
                  }
                  mesh = rootNode.getObjectByName(meshName);
                  if (!mesh) {
                    warn('Missing axis mesh with name: ' + meshName);
                    continue;
                  }
                  meshInfo = {
                    index: i,
                    value: getImmediateChildByName(mesh, 'VALUE'),
                    min: getImmediateChildByName(mesh, 'MIN'),
                    max: getImmediateChildByName(mesh, 'MAX')
                  };
                  if (meshInfo.value && meshInfo.min && meshInfo.max) {
                    loadedMeshInfo.axisMeshes[i] = meshInfo;
                  } else {
                    // If we didn't find the mesh, it simply means this axis won't have transforms applied as mapped axis values change.
                    warn('Missing axis submesh under mesh with name: ' + meshName + '(VALUE: ' + !!meshInfo.value + ', MIN: ' + !!meshInfo.min + ', MAX:' + !!meshInfo.max + ')');
                  }
                }
                this.calculateRayOriginFromMesh(rootNode);
                // Determine if the model has to be visible or not.
                this.setModelVisibility();
              }
              debug('Model load complete.');

              // Look through only immediate children. This will return null if no mesh exists with the given name.
              function getImmediateChildByName(object3d, value) {
                for (var i = 0, l = object3d.children.length; i < l; i++) {
                  var obj = object3d.children[i];
                  if (obj && obj['name'] === value) {
                    return obj;
                  }
                }
                return undefined;
              }
            },
            calculateRayOriginFromMesh: function () {
              var quaternion = new THREE.Quaternion();
              return function (rootNode) {
                var mesh;

                // Calculate the pointer pose (used for rays), by applying the world transform of th POINTER_POSE node
                // in the glTF (assumes that root node is at world origin)
                this.rayOrigin.origin.set(0, 0, 0);
                this.rayOrigin.direction.set(0, 0, -1);
                this.rayOrigin.createdFromMesh = true;

                // Try to read Pointing pose from the source model
                mesh = rootNode.getObjectByName(this.mapping.pointingPoseMeshName);
                if (mesh) {
                  var parent = rootNode.parent;

                  // We need to read pose transforms accumulated from the root of the glTF, not the scene.
                  if (parent) {
                    rootNode.parent = null;
                    rootNode.updateMatrixWorld(true);
                    rootNode.parent = parent;
                  }
                  mesh.getWorldPosition(this.rayOrigin.origin);
                  mesh.getWorldQuaternion(quaternion);
                  this.rayOrigin.direction.applyQuaternion(quaternion);

                  // Recalculate the world matrices now that the rootNode is re-attached to the parent.
                  if (parent) {
                    rootNode.updateMatrixWorld(true);
                  }
                } else {
                  debug('Mesh does not contain pointing origin data, defaulting to none.');
                }

                // Emit event stating that our pointing ray is now accurate.
                this.modelReady();
              };
            }(),
            lerpAxisTransform: function () {
              var quaternion = new THREE.Quaternion();
              return function (axis, axisValue) {
                var axisMeshInfo = this.loadedMeshInfo.axisMeshes[axis];
                if (!axisMeshInfo) return;
                var min = axisMeshInfo.min;
                var max = axisMeshInfo.max;
                var target = axisMeshInfo.value;

                // Convert from gamepad value range (-1 to +1) to lerp range (0 to 1)
                var lerpValue = axisValue * 0.5 + 0.5;
                target.setRotationFromQuaternion(quaternion.copy(min.quaternion).slerp(max.quaternion, lerpValue));
                target.position.lerpVectors(min.position, max.position, lerpValue);
              };
            }(),
            lerpButtonTransform: function () {
              var quaternion = new THREE.Quaternion();
              return function (buttonName, buttonValue) {
                var buttonMeshInfo = this.loadedMeshInfo.buttonMeshes[buttonName];
                if (!buttonMeshInfo) return;
                var min = buttonMeshInfo.unpressed;
                var max = buttonMeshInfo.pressed;
                var target = buttonMeshInfo.value;
                target.setRotationFromQuaternion(quaternion.copy(min.quaternion).slerp(max.quaternion, buttonValue));
                target.position.lerpVectors(min.position, max.position, buttonValue);
              };
            }(),
            modelReady: function modelReady() {
              this.el.emit('controllermodelready', {
                name: 'windows-motion-controls',
                model: this.data.model,
                rayOrigin: this.rayOrigin
              });
            },
            onButtonChanged: function onButtonChanged(evt) {
              var buttonName = this.mapping.buttons[evt.detail.id];
              if (buttonName) {
                // Update the button mesh transform
                if (this.loadedMeshInfo && this.loadedMeshInfo.buttonMeshes) {
                  this.lerpButtonTransform(buttonName, evt.detail.state.value);
                }

                // Only emit events for buttons that we know how to map from index to name
                this.el.emit(buttonName + 'changed', evt.detail.state);
              }
            },
            onAxisMoved: function onAxisMoved(evt) {
              var numAxes = this.mapping.axisMeshNames.length;

              // Only attempt to update meshes if we have valid data.
              if (this.loadedMeshInfo && this.loadedMeshInfo.axisMeshes) {
                for (var axis = 0; axis < numAxes; axis++) {
                  // Update the button mesh transform
                  this.lerpAxisTransform(axis, evt.detail.axis[axis] || 0.0);
                }
              }
              emitIfAxesChanged(this, this.mapping.axes, evt);
            },
            setModelVisibility: function setModelVisibility(visible) {
              var model = this.el.getObject3D('mesh');
              visible = visible !== undefined ? visible : this.modelVisible;
              this.modelVisible = visible;
              if (!model) {
                return;
              }
              model.visible = visible;
            }
          });

          /***/
        },

        /***/"./src/constants/index.js":
        /*!********************************!*\
          !*** ./src/constants/index.js ***!
          \********************************/
        /***/
        function srcConstantsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          module.exports = {
            AFRAME_INJECTED: 'aframe-injected',
            DEFAULT_CAMERA_HEIGHT: 1.6,
            DEFAULT_HANDEDNESS: 'right',
            keyboardevent: __webpack_require__( /*! ./keyboardevent */"./src/constants/keyboardevent.js")
          };

          /***/
        },

        /***/"./src/constants/keyboardevent.js":
        /*!****************************************!*\
          !*** ./src/constants/keyboardevent.js ***!
          \****************************************/
        /***/
        function srcConstantsKeyboardeventJs(module) {
          module.exports = {
            // Tiny KeyboardEvent.code polyfill.
            KEYCODE_TO_CODE: {
              '38': 'ArrowUp',
              '37': 'ArrowLeft',
              '40': 'ArrowDown',
              '39': 'ArrowRight',
              '87': 'KeyW',
              '65': 'KeyA',
              '83': 'KeyS',
              '68': 'KeyD'
            }
          };

          /***/
        },

        /***/"./src/core/a-assets.js":
        /*!******************************!*\
          !*** ./src/core/a-assets.js ***!
          \******************************/
        /***/
        function srcCoreAAssetsJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global customElements */
          var ANode = __webpack_require__( /*! ./a-node */"./src/core/a-node.js").ANode;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var debug = __webpack_require__( /*! ../utils/debug */"./src/utils/debug.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var fileLoader = new THREE.FileLoader();
          var warn = debug('core:a-assets:warn');

          /**
           * Asset management system. Handles blocking on asset loading.
           */
          var AAssets = /*#__PURE__*/function (_ANode) {
            "use strict";

            _inherits(AAssets, _ANode);
            var _super3 = _createSuper(AAssets);
            function AAssets() {
              var _this4;
              _classCallCheck2(this, AAssets);
              _this4 = _super3.call(this);
              _this4.isAssets = true;
              _this4.fileLoader = fileLoader;
              _this4.timeout = null;
              return _this4;
            }
            _createClass2(AAssets, [{
              key: "connectedCallback",
              value: function connectedCallback() {
                // Defer if DOM is not ready.
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this));
                  return;
                }
                this.doConnectedCallback();
              }
            }, {
              key: "doConnectedCallback",
              value: function doConnectedCallback() {
                var self = this;
                var i;
                var loaded = [];
                var mediaEl;
                var mediaEls;
                var imgEl;
                var imgEls;
                var timeout;
                _get2(_getPrototypeOf(AAssets.prototype), "connectedCallback", this).call(this);
                if (!this.parentNode.isScene) {
                  throw new Error('<a-assets> must be a child of a <a-scene>.');
                }

                // Wait for <img>s.
                imgEls = this.querySelectorAll('img');
                for (i = 0; i < imgEls.length; i++) {
                  imgEl = fixUpMediaElement(imgEls[i]);
                  loaded.push(new Promise(function (resolve, reject) {
                    // Set in cache because we won't be needing to call three.js loader if we have.
                    // a loaded media element.
                    THREE.Cache.add(imgEls[i].getAttribute('src'), imgEl);
                    imgEl.onload = resolve;
                    imgEl.onerror = reject;
                  }));
                }

                // Wait for <audio>s and <video>s.
                mediaEls = this.querySelectorAll('audio, video');
                for (i = 0; i < mediaEls.length; i++) {
                  mediaEl = fixUpMediaElement(mediaEls[i]);
                  if (!mediaEl.src && !mediaEl.srcObject) {
                    warn('Audio/video asset has neither `src` nor `srcObject` attributes.');
                  }
                  loaded.push(mediaElementLoaded(mediaEl));
                }

                // Trigger loaded for scene to start rendering.
                Promise.allSettled(loaded).then(bind(this.load, this));

                // Timeout to start loading anyways.
                timeout = parseInt(this.getAttribute('timeout'), 10) || 3000;
                this.timeout = setTimeout(function () {
                  if (self.hasLoaded) {
                    return;
                  }
                  warn('Asset loading timed out in ', timeout, 'ms');
                  self.emit('timeout');
                  self.load();
                }, timeout);
              }
            }, {
              key: "disconnectedCallback",
              value: function disconnectedCallback() {
                _get2(_getPrototypeOf(AAssets.prototype), "disconnectedCallback", this).call(this);
                if (this.timeout) {
                  clearTimeout(this.timeout);
                }
              }
            }, {
              key: "load",
              value: function load() {
                _get2(_getPrototypeOf(AAssets.prototype), "load", this).call(this, null, function waitOnFilter(el) {
                  return el.isAssetItem && el.hasAttribute('src');
                });
              }
            }]);
            return AAssets;
          }(ANode);
          customElements.define('a-assets', AAssets);

          /**
           * Preload using XHRLoader for any type of asset.
           */
          var AAssetItem = /*#__PURE__*/function (_ANode2) {
            "use strict";

            _inherits(AAssetItem, _ANode2);
            var _super4 = _createSuper(AAssetItem);
            function AAssetItem() {
              var _this5;
              _classCallCheck2(this, AAssetItem);
              _this5 = _super4.call(this);
              _this5.data = null;
              _this5.isAssetItem = true;
              return _this5;
            }
            _createClass2(AAssetItem, [{
              key: "connectedCallback",
              value: function connectedCallback() {
                var self = this;
                var src = this.getAttribute('src');
                fileLoader.setResponseType(this.getAttribute('response-type') || inferResponseType(src));
                fileLoader.load(src, function handleOnLoad(response) {
                  self.data = response;
                  /*
                    Workaround for a Chrome bug. If another XHR is sent to the same url before the
                    previous one closes, the second request never finishes.
                    setTimeout finishes the first request and lets the logic triggered by load open
                    subsequent requests.
                    setTimeout can be removed once the fix for the bug below ships:
                    https://bugs.chromium.org/p/chromium/issues/detail?id=633696&q=component%3ABlink%3ENetwork%3EXHR%20&colspec=ID%20Pri%20M%20Stars%20ReleaseBlock%20Component%20Status%20Owner%20Summary%20OS%20Modified
                  */
                  setTimeout(function load() {
                    ANode.prototype.load.call(self);
                  });
                }, function handleOnProgress(xhr) {
                  self.emit('progress', {
                    loadedBytes: xhr.loaded,
                    totalBytes: xhr.total,
                    xhr: xhr
                  });
                }, function handleOnError(xhr) {
                  self.emit('error', {
                    xhr: xhr
                  });
                });
              }
            }]);
            return AAssetItem;
          }(ANode);
          customElements.define('a-asset-item', AAssetItem);

          /**
           * Create a Promise that resolves once the media element has finished buffering.
           *
           * @param {Element} el - HTMLMediaElement.
           * @returns {Promise}
           */
          function mediaElementLoaded(el) {
            if (!el.hasAttribute('autoplay') && el.getAttribute('preload') !== 'auto') {
              return;
            }

            // If media specifies autoplay or preload, wait until media is completely buffered.
            return new Promise(function (resolve, reject) {
              if (el.readyState === 4) {
                return resolve();
              } // Already loaded.
              if (el.error) {
                return reject();
              } // Error.

              el.addEventListener('loadeddata', checkProgress, false);
              el.addEventListener('progress', checkProgress, false);
              el.addEventListener('error', reject, false);
              function checkProgress() {
                // Add up the seconds buffered.
                var secondsBuffered = 0;
                for (var i = 0; i < el.buffered.length; i++) {
                  secondsBuffered += el.buffered.end(i) - el.buffered.start(i);
                }

                // Compare seconds buffered to media duration.
                if (secondsBuffered >= el.duration) {
                  // Set in cache because we won't be needing to call three.js loader if we have.
                  // a loaded media element.
                  // Store video elements only. three.js loader is used for audio elements.
                  // See assetParse too.
                  if (el.tagName === 'VIDEO') {
                    THREE.Cache.add(el.getAttribute('src'), el);
                  }
                  resolve();
                }
              }
            });
          }

          /**
           * Automatically add attributes to media elements where convenient.
           * crossorigin, playsinline.
           */
          function fixUpMediaElement(mediaEl) {
            // Cross-origin.
            var newMediaEl = setCrossOrigin(mediaEl);

            // Plays inline for mobile.
            if (newMediaEl.tagName && newMediaEl.tagName.toLowerCase() === 'video') {
              newMediaEl.setAttribute('playsinline', '');
              newMediaEl.setAttribute('webkit-playsinline', '');
            }
            if (newMediaEl !== mediaEl) {
              mediaEl.parentNode.appendChild(newMediaEl);
              mediaEl.parentNode.removeChild(mediaEl);
            }
            return newMediaEl;
          }

          /**
           * Automatically set `crossorigin` if not defined on the media element.
           * If it is not defined, we must create and re-append a new media element <img> and
           * have the browser re-request it with `crossorigin` set.
           *
           * @param {Element} Media element (e.g., <img>, <audio>, <video>).
           * @returns {Element} Media element to be used to listen to for loaded events.
           */
          function setCrossOrigin(mediaEl) {
            var newMediaEl;
            var src;

            // Already has crossorigin set.
            if (mediaEl.hasAttribute('crossorigin')) {
              return mediaEl;
            }
            src = mediaEl.getAttribute('src');
            if (src !== null) {
              // Does not have protocol.
              if (src.indexOf('://') === -1) {
                return mediaEl;
              }

              // Determine if cross origin is actually needed.
              if (extractDomain(src) === window.location.host) {
                return mediaEl;
              }
            }
            warn('Cross-origin element (e.g., <img>) was requested without `crossorigin` set. ' + 'A-Frame will re-request the asset with `crossorigin` attribute set. ' + 'Please set `crossorigin` on the element (e.g., <img crossorigin="anonymous">)', src);
            mediaEl.crossOrigin = 'anonymous';
            newMediaEl = mediaEl.cloneNode(true);
            return newMediaEl;
          }

          /**
           * Extract domain out of URL.
           *
           * @param {string} url
           * @returns {string}
           */
          function extractDomain(url) {
            // Find and remove protocol (e.g., http, ftp, etc.) to get domain.
            var domain = url.indexOf('://') > -1 ? url.split('/')[2] : url.split('/')[0];

            // Find and remove port number.
            return domain.substring(0, domain.indexOf(':'));
          }

          /**
           * Infer response-type attribute from src.
           * Default is text (default XMLHttpRequest.responseType)
           * and arraybuffer for .glb files.
           *
           * @param {string} src
           * @returns {string}
           */
          function inferResponseType(src) {
            var fileName = getFileNameFromURL(src);
            var dotLastIndex = fileName.lastIndexOf('.');
            if (dotLastIndex >= 0) {
              var extension = fileName.slice(dotLastIndex, src.search(/\?|#|$/));
              if (extension === '.glb') {
                return 'arraybuffer';
              }
            }
            return 'text';
          }
          module.exports.inferResponseType = inferResponseType;

          /**
           * Extract filename from URL
           *
           * @param {string} url
           * @returns {string}
           */
          function getFileNameFromURL(url) {
            var parser = document.createElement('a');
            parser.href = url;
            var query = parser.search.replace(/^\?/, '');
            var filePath = url.replace(query, '').replace('?', '');
            return filePath.substring(filePath.lastIndexOf('/') + 1);
          }
          module.exports.getFileNameFromURL = getFileNameFromURL;

          /***/
        },

        /***/"./src/core/a-cubemap.js":
        /*!*******************************!*\
          !*** ./src/core/a-cubemap.js ***!
          \*******************************/
        /***/
        function srcCoreACubemapJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          /* global customElements, HTMLElement */
          var debug = __webpack_require__( /*! ../utils/debug */"./src/utils/debug.js");
          var warn = debug('core:cubemap:warn');

          /**
           * Cubemap element that handles validation and exposes list of URLs.
           * Does not listen to updates.
           */
          var ACubeMap = /*#__PURE__*/function (_HTMLElement) {
            "use strict";

            _inherits(ACubeMap, _HTMLElement);
            var _super5 = _createSuper(ACubeMap);
            /**
             * Calculates this.srcs.
             */
            function ACubeMap(self) {
              var _this6;
              _classCallCheck2(this, ACubeMap);
              self = _this6 = _super5.call(this, self);
              self.srcs = self.validate();
              return _possibleConstructorReturn(_this6, self);
            }

            /**
             * Checks for exactly six elements with [src].
             * Does not check explicitly for <img>s in case user does not want
             * prefetching.
             *
             * @returns {Array|null} - six URLs if valid, else null.
             */
            _createClass2(ACubeMap, [{
              key: "validate",
              value: function validate() {
                var elements = this.querySelectorAll('[src]');
                var i;
                var srcs = [];
                if (elements.length === 6) {
                  for (i = 0; i < elements.length; i++) {
                    srcs.push(elements[i].getAttribute('src'));
                  }
                  return srcs;
                }
                // Else if there are not six elements, throw a warning.
                warn('<a-cubemap> did not contain exactly six elements each with a ' + '`src` attribute.');
              }
            }]);
            return ACubeMap;
          }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
          customElements.define('a-cubemap', ACubeMap);

          /***/
        },

        /***/"./src/core/a-entity.js":
        /*!******************************!*\
          !*** ./src/core/a-entity.js ***!
          \******************************/
        /***/
        function srcCoreAEntityJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global customElements */
          var ANode = __webpack_require__( /*! ./a-node */"./src/core/a-node.js").ANode;
          var COMPONENTS = __webpack_require__( /*! ./component */"./src/core/component.js").components;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var debug = utils.debug('core:a-entity:debug');
          var warn = utils.debug('core:a-entity:warn');
          var MULTIPLE_COMPONENT_DELIMITER = '__';
          var OBJECT3D_COMPONENTS = ['position', 'rotation', 'scale', 'visible'];
          var ONCE = {
            once: true
          };

          /**
           * Entity is a container object that components are plugged into to comprise everything in
           * the scene. In A-Frame, they inherently have position, rotation, and scale.
           *
           * To be able to take components, the scene element inherits from the entity definition.
           *
           * @member {object} components - entity's currently initialized components.
           * @member {object} object3D - three.js object.
           * @member {array} states
           * @member {boolean} isPlaying - false if dynamic behavior of the entity is paused.
           */
          var AEntity = /*#__PURE__*/function (_ANode3) {
            "use strict";

            _inherits(AEntity, _ANode3);
            var _super6 = _createSuper(AEntity);
            function AEntity() {
              var _this7;
              _classCallCheck2(this, AEntity);
              _this7 = _super6.call(this);
              _this7.components = {};
              // To avoid double initializations and infinite loops.
              _this7.initializingComponents = {};
              _this7.componentsToUpdate = {};
              _this7.isEntity = true;
              _this7.isPlaying = false;
              _this7.object3D = new THREE.Group();
              _this7.object3D.el = _assertThisInitialized(_this7);
              _this7.object3DMap = {};
              _this7.parentEl = null;
              _this7.rotationObj = {};
              _this7.states = [];
              return _this7;
            }

            /**
             * Handle changes coming from the browser DOM inspector.
             */
            _createClass2(AEntity, [{
              key: "attributeChangedCallback",
              value: function attributeChangedCallback(attr, oldVal, newVal) {
                var component = this.components[attr];
                _get2(_getPrototypeOf(AEntity.prototype), "attributeChangedCallback", this).call(this);
                // If the empty string is passed by the component initialization
                // logic we ignore the component update.
                if (component && component.justInitialized && newVal === '') {
                  delete component.justInitialized;
                  return;
                }
                // When a component is removed after calling el.removeAttribute('material')
                if (!component && newVal === null) {
                  return;
                }
                this.setEntityAttribute(attr, oldVal, newVal);
              }

              /**
              * Add to parent, load, play.
              */
            }, {
              key: "connectedCallback",
              value: function connectedCallback() {
                // Defer if DOM is not ready.
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this));
                  return;
                }
                AEntity.prototype.doConnectedCallback.call(this);
              }
            }, {
              key: "doConnectedCallback",
              value: function doConnectedCallback() {
                var self = this; // Component.
                var assetsEl; // Asset management system element.
                var sceneEl;

                // ANode method.
                _get2(_getPrototypeOf(AEntity.prototype), "connectedCallback", this).call(this);
                sceneEl = this.sceneEl;
                this.addToParent();

                // Don't .load() scene on attachedCallback.
                if (this.isScene) {
                  return;
                }

                // Gracefully not error when outside of <a-scene> (e.g., tests).
                if (!sceneEl) {
                  this.load();
                  return;
                }

                // Wait for asset management system to finish before loading.
                assetsEl = sceneEl.querySelector('a-assets');
                if (assetsEl && !assetsEl.hasLoaded) {
                  assetsEl.addEventListener('loaded', function () {
                    self.load();
                  });
                  return;
                }
                this.load();
              }

              /**
               * Tell parent to remove this element's object3D from its object3D.
               * Do not call on scene element because that will cause a call to document.body.remove().
               */
            }, {
              key: "disconnectedCallback",
              value: function disconnectedCallback() {
                var componentName;
                if (!this.parentEl) {
                  return;
                }

                // Remove components.
                for (componentName in this.components) {
                  this.removeComponent(componentName, false);
                }
                if (this.isScene) {
                  return;
                }
                this.removeFromParent();
                _get2(_getPrototypeOf(AEntity.prototype), "disconnectedCallback", this).call(this);

                // Remove cyclic reference.
                this.object3D.el = null;
              }
            }, {
              key: "getObject3D",
              value: function getObject3D(type) {
                return this.object3DMap[type];
              }

              /**
               * Set a THREE.Object3D into the map.
               *
               * @param {string} type - Developer-set name of the type of object, will be unique per type.
               * @param {object} obj - A THREE.Object3D.
               */
            }, {
              key: "setObject3D",
              value: function setObject3D(type, obj) {
                var oldObj;
                var self = this;
                if (!(obj instanceof THREE.Object3D)) {
                  throw new Error('`Entity.setObject3D` was called with an object that was not an instance of ' + 'THREE.Object3D.');
                }

                // Remove existing object of the type.
                oldObj = this.getObject3D(type);
                if (oldObj) {
                  this.object3D.remove(oldObj);
                }

                // Set references to A-Frame entity.
                obj.el = this;
                if (obj.children.length) {
                  obj.traverse(function bindEl(child) {
                    child.el = self;
                  });
                }

                // Add.
                this.object3D.add(obj);
                this.object3DMap[type] = obj;
                this.emit('object3dset', {
                  object: obj,
                  type: type
                });
              }

              /**
               * Remove object from scene and entity object3D map.
               */
            }, {
              key: "removeObject3D",
              value: function removeObject3D(type) {
                var obj = this.getObject3D(type);
                if (!obj) {
                  warn('Tried to remove `Object3D` of type:', type, 'which was not defined.');
                  return;
                }
                this.object3D.remove(obj);
                delete this.object3DMap[type];
                this.emit('object3dremove', {
                  type: type
                });
              }

              /**
               * Gets or creates an object3D of a given type.
               *
               * @param {string} type - Type of the object3D.
               * @param {string} Constructor - Constructor to use to create the object3D if needed.
               * @returns {object}
               */
            }, {
              key: "getOrCreateObject3D",
              value: function getOrCreateObject3D(type, Constructor) {
                var object3D = this.getObject3D(type);
                if (!object3D && Constructor) {
                  object3D = new Constructor();
                  this.setObject3D(type, object3D);
                }
                warn('`getOrCreateObject3D` has been deprecated. Use `setObject3D()` ' + 'and `object3dset` event instead.');
                return object3D;
              }

              /**
               * Add child entity.
               *
               * @param {Element} el - Child entity.
               */
            }, {
              key: "add",
              value: function add(el) {
                if (!el.object3D) {
                  throw new Error("Trying to add an element that doesn't have an `object3D`");
                }
                this.object3D.add(el.object3D);
                this.emit('child-attached', {
                  el: el
                });
              }

              /**
               * Tell parentNode to add this entity to itself.
               */
            }, {
              key: "addToParent",
              value: function addToParent() {
                var parentNode = this.parentEl = this.parentNode;

                // `!parentNode` check primarily for unit tests.
                if (!parentNode || !parentNode.add || this.attachedToParent) {
                  return;
                }
                parentNode.add(this);
                this.attachedToParent = true; // To prevent multiple attachments to same parent.
              }

              /**
               * Tell parentNode to remove this entity from itself.
               */
            }, {
              key: "removeFromParent",
              value: function removeFromParent() {
                var parentEl = this.parentEl;
                this.parentEl.remove(this);
                this.attachedToParent = false;
                this.parentEl = null;
                parentEl.emit('child-detached', {
                  el: this
                });
              }
            }, {
              key: "load",
              value: function load() {
                var self = this;
                if (this.hasLoaded || !this.parentEl) {
                  return;
                }
                _get2(_getPrototypeOf(AEntity.prototype), "load", this).call(this, function entityLoadCallback() {
                  // Check if entity was detached while it was waiting to load.
                  if (!self.parentEl) {
                    return;
                  }
                  self.updateComponents();
                  if (self.isScene || self.parentEl.isPlaying) {
                    self.play();
                  }
                });
              }

              /**
               * Remove child entity.
               *
               * @param {Element} el - Child entity.
               */
            }, {
              key: "remove",
              value: function remove(el) {
                if (el) {
                  this.object3D.remove(el.object3D);
                } else {
                  this.parentNode.removeChild(this);
                }
              }

              /**
               * @returns {array} Direct children that are entities.
               */
            }, {
              key: "getChildEntities",
              value: function getChildEntities() {
                var children = this.children;
                var childEntities = [];
                for (var i = 0; i < children.length; i++) {
                  var child = children[i];
                  if (child instanceof AEntity) {
                    childEntities.push(child);
                  }
                }
                return childEntities;
              }

              /**
               * Initialize component.
               *
               * @param {string} attrName - Attribute name asociated to the component.
               * @param {object} data - Component data
               * @param {boolean} isDependency - True if the component is a dependency.
               */
            }, {
              key: "initComponent",
              value: function initComponent(attrName, data, isDependency) {
                var component;
                var componentId;
                var componentInfo;
                var componentName;
                var isComponentDefined;
                componentInfo = utils.split(attrName, MULTIPLE_COMPONENT_DELIMITER);
                componentName = componentInfo[0];
                componentId = componentInfo.length > 2 ? componentInfo.slice(1).join('__') : componentInfo[1];

                // Not a registered component.
                if (!COMPONENTS[componentName]) {
                  return;
                }

                // Component is not a dependency and is undefined.
                // If a component is a dependency, then it is okay to have no data.
                isComponentDefined = checkComponentDefined(this, attrName) || data !== undefined;
                if (!isComponentDefined && !isDependency) {
                  return;
                }

                // Component already initialized.
                if (attrName in this.components) {
                  return;
                }

                // Initialize dependencies first
                this.initComponentDependencies(componentName);

                // If component name has an id we check component type multiplic
                if (componentId && !COMPONENTS[componentName].multiple) {
                  throw new Error('Trying to initialize multiple ' + 'components of type `' + componentName + '`. There can only be one component of this type per entity.');
                }
                component = new COMPONENTS[componentName].Component(this, data, componentId);
                if (this.isPlaying) {
                  component.play();
                }

                // Components are reflected in the DOM as attributes but the state is not shown
                // hence we set the attribute to empty string.
                // The flag justInitialized is for attributeChangedCallback to not overwrite
                // the component with the empty string.
                if (!this.hasAttribute(attrName)) {
                  component.justInitialized = true;
                  window.HTMLElement.prototype.setAttribute.call(this, attrName, '');
                }
                debug('Component initialized: %s', attrName);
              }

              /**
               * Initialize dependencies of a component.
               *
               * @param {string} name - Root component name.
               */
            }, {
              key: "initComponentDependencies",
              value: function initComponentDependencies(name) {
                var self = this;
                var component = COMPONENTS[name];
                var dependencies;
                var i;

                // Not a component.
                if (!component) {
                  return;
                }

                // No dependencies.
                dependencies = COMPONENTS[name].dependencies;
                if (!dependencies) {
                  return;
                }

                // Initialize dependencies.
                for (i = 0; i < dependencies.length; i++) {
                  // Call getAttribute to initialize the data from the DOM.
                  self.initComponent(dependencies[i], window.HTMLElement.prototype.getAttribute.call(self, dependencies[i]) || undefined, true);
                }
              }
            }, {
              key: "removeComponent",
              value: function removeComponent(name, destroy) {
                var component;
                component = this.components[name];
                if (!component) {
                  return;
                }

                // Wait for component to initialize.
                if (!component.initialized) {
                  this.addEventListener('componentinitialized', function tryRemoveLater(evt) {
                    if (evt.detail.name !== name) {
                      return;
                    }
                    this.removeComponent(name, destroy);
                    this.removeEventListener('componentinitialized', tryRemoveLater);
                  });
                  return;
                }
                component.pause();
                component.remove();

                // Keep component attached to entity in case of just full entity detach.
                if (destroy) {
                  component.destroy();
                  delete this.components[name];
                }
                this.emit('componentremoved', component.evtDetail, false);
              }

              /**
               * Initialize or update all components.
               * Build data using initial components, defined attributes, mixins, and defaults.
               * Update default components before the rest.
               *
               * @member {function} getExtraComponents - Can be implemented to include component data
               *   from other sources (e.g., implemented by primitives).
               */
            }, {
              key: "updateComponents",
              value: function updateComponents() {
                var data;
                var extraComponents;
                var i;
                var name;
                var componentsToUpdate = this.componentsToUpdate;
                if (!this.hasLoaded) {
                  return;
                }

                // Gather mixin-defined components.
                for (i = 0; i < this.mixinEls.length; i++) {
                  for (name in this.mixinEls[i].componentCache) {
                    if (isComponent(name)) {
                      componentsToUpdate[name] = true;
                    }
                  }
                }

                // Gather from extra initial component data if defined (e.g., primitives).
                if (this.getExtraComponents) {
                  extraComponents = this.getExtraComponents();
                  for (name in extraComponents) {
                    if (isComponent(name)) {
                      componentsToUpdate[name] = true;
                    }
                  }
                }

                // Gather entity-defined components.
                for (i = 0; i < this.attributes.length; ++i) {
                  name = this.attributes[i].name;
                  if (OBJECT3D_COMPONENTS.indexOf(name) !== -1) {
                    continue;
                  }
                  if (isComponent(name)) {
                    componentsToUpdate[name] = true;
                  }
                }

                // object3D components first (position, rotation, scale, visible).
                for (i = 0; i < OBJECT3D_COMPONENTS.length; i++) {
                  name = OBJECT3D_COMPONENTS[i];
                  if (!this.hasAttribute(name)) {
                    continue;
                  }
                  this.updateComponent(name, this.getDOMAttribute(name));
                }

                // Initialize or update rest of components.
                for (name in componentsToUpdate) {
                  data = mergeComponentData(this.getDOMAttribute(name), extraComponents && extraComponents[name]);
                  this.updateComponent(name, data);
                  delete componentsToUpdate[name];
                }
              }

              /**
               * Initialize, update, or remove a single component.
               *
               * When initializing, we set the component on `this.components`.
               *
               * @param {string} attr - Component name.
               * @param {object} attrValue - Value of the DOM attribute.
               * @param {boolean} clobber - If new attrValue completely replaces previous properties.
               */
            }, {
              key: "updateComponent",
              value: function updateComponent(attr, attrValue, clobber) {
                var component = this.components[attr];
                if (component) {
                  // Remove component.
                  if (attrValue === null && !checkComponentDefined(this, attr)) {
                    this.removeComponent(attr, true);
                    return;
                  }
                  // Component already initialized. Update component.
                  component.updateProperties(attrValue, clobber);
                  return;
                }

                // Component not yet initialized. Initialize component.
                this.initComponent(attr, attrValue, false);
              }

              /**
               * If `attr` is a component name, detach the component from the entity.
               *
               * If `propertyName` is given, reset the component property value to its default.
               *
               * @param {string} attr - Attribute name, which could also be a component name.
               * @param {string} propertyName - Component prop name, if resetting an individual prop.
               */
            }, {
              key: "removeAttribute",
              value: function removeAttribute(attr, propertyName) {
                var component = this.components[attr];

                // Remove component.
                if (component && propertyName === undefined) {
                  this.removeComponent(attr, true);
                }

                // Reset component property value.
                if (component && propertyName !== undefined) {
                  component.resetProperty(propertyName);
                  return;
                }

                // Remove mixins.
                if (attr === 'mixin') {
                  this.mixinUpdate('');
                }
                window.HTMLElement.prototype.removeAttribute.call(this, attr);
              }

              /**
               * Start dynamic behavior associated with entity such as dynamic components and animations.
               * Tell all children entities to also play.
               */
            }, {
              key: "play",
              value: function play() {
                var entities;
                var i;
                var key;

                // Already playing.
                if (this.isPlaying || !this.hasLoaded) {
                  return;
                }
                this.isPlaying = true;

                // Wake up all components.
                for (key in this.components) {
                  this.components[key].play();
                }

                // Tell all child entities to play.
                entities = this.getChildEntities();
                for (i = 0; i < entities.length; i++) {
                  entities[i].play();
                }
                this.emit('play');
              }

              /**
               * Pause dynamic behavior associated with entity such as dynamic components and animations.
               * Tell all children entities to also pause.
               */
            }, {
              key: "pause",
              value: function pause() {
                var entities;
                var i;
                var key;
                if (!this.isPlaying) {
                  return;
                }
                this.isPlaying = false;

                // Sleep all components.
                for (key in this.components) {
                  this.components[key].pause();
                }

                // Tell all child entities to pause.
                entities = this.getChildEntities();
                for (i = 0; i < entities.length; i++) {
                  entities[i].pause();
                }
                this.emit('pause');
              }

              /**
               * Deals with updates on entity-specific attributes (i.e., components and mixins).
               *
               * @param {string} attr
               * @param {string} oldVal
               * @param {string|object} newVal
               */
            }, {
              key: "setEntityAttribute",
              value: function setEntityAttribute(attr, oldVal, newVal) {
                if (COMPONENTS[attr] || this.components[attr]) {
                  this.updateComponent(attr, newVal);
                  return;
                }
                if (attr === 'mixin') {
                  // Ignore if `<a-node>` code is just updating computed mixin in the DOM.
                  if (newVal === this.computedMixinStr) {
                    return;
                  }
                  this.mixinUpdate(newVal, oldVal);
                }
              }

              /**
               * When mixins updated, trigger init or optimized-update of relevant components.
               */
            }, {
              key: "mixinUpdate",
              value: function mixinUpdate(newMixins, oldMixins) {
                var componentsUpdated = AEntity.componentsUpdated;
                var component;
                var mixinEl;
                var mixinIds;
                var i;
                var self = this;
                if (!this.hasLoaded) {
                  this.addEventListener('loaded', function () {
                    self.mixinUpdate(newMixins, oldMixins);
                  }, ONCE);
                  return;
                }
                oldMixins = oldMixins || this.getAttribute('mixin');
                mixinIds = this.updateMixins(newMixins, oldMixins);

                // Loop over current mixins.
                componentsUpdated.length = 0;
                for (i = 0; i < this.mixinEls.length; i++) {
                  for (component in this.mixinEls[i].componentCache) {
                    if (componentsUpdated.indexOf(component) === -1) {
                      if (this.components[component]) {
                        // Update. Just rebuild data.
                        this.components[component].handleMixinUpdate();
                      } else {
                        // Init. buildData will gather mixin values.
                        this.initComponent(component, null);
                      }
                      componentsUpdated.push(component);
                    }
                  }
                }

                // Loop over old mixins to call for data rebuild.
                for (i = 0; i < mixinIds.oldMixinIds.length; i++) {
                  mixinEl = document.getElementById(mixinIds.oldMixinIds[i]);
                  if (!mixinEl) {
                    continue;
                  }
                  for (component in mixinEl.componentCache) {
                    if (componentsUpdated.indexOf(component) === -1) {
                      if (this.components[component]) {
                        if (this.getDOMAttribute(component)) {
                          // Update component if explicitly defined.
                          this.components[component].handleMixinUpdate();
                        } else {
                          // Remove component if not explicitly defined.
                          this.removeComponent(component, true);
                        }
                      }
                    }
                  }
                }
              }

              /**
               * setAttribute can:
               *
               * 1. Set a single property of a multi-property component.
               * 2. Set multiple properties of a multi-property component.
               * 3. Replace properties of a multi-property component.
               * 4. Set a value for a single-property component, mixin, or normal HTML attribute.
               *
               * @param {string} attrName - Component or attribute name.
               * @param {*} arg1 - Can be a value, property name, CSS-style property string, or
               *   object of properties.
               * @param {*|bool} arg2 - If arg1 is a property name, this should be a value. Otherwise,
               *   it is a boolean indicating whether to clobber previous values (defaults to false).
               */
            }, {
              key: "setAttribute",
              value: function setAttribute(attrName, arg1, arg2) {
                var singlePropUpdate = AEntity.singlePropUpdate;
                var newAttrValue;
                var clobber;
                var componentName;
                var delimiterIndex;
                var isDebugMode;
                var key;
                delimiterIndex = attrName.indexOf(MULTIPLE_COMPONENT_DELIMITER);
                componentName = delimiterIndex > 0 ? attrName.substring(0, delimiterIndex) : attrName;

                // Not a component. Normal set attribute.
                if (!COMPONENTS[componentName]) {
                  if (attrName === 'mixin') {
                    this.mixinUpdate(arg1);
                  }
                  _get2(_getPrototypeOf(AEntity.prototype), "setAttribute", this).call(this, attrName, arg1);
                  return;
                }

                // Initialize component first if not yet initialized.
                if (!this.components[attrName] && this.hasAttribute(attrName)) {
                  this.updateComponent(attrName, window.HTMLElement.prototype.getAttribute.call(this, attrName));
                }

                // Determine new attributes from the arguments
                if (typeof arg2 !== 'undefined' && typeof arg1 === 'string' && arg1.length > 0 && typeof utils.styleParser.parse(arg1) === 'string') {
                  // Update a single property of a multi-property component
                  for (key in singlePropUpdate) {
                    delete singlePropUpdate[key];
                  }
                  newAttrValue = singlePropUpdate;
                  newAttrValue[arg1] = arg2;
                  clobber = false;
                } else {
                  // Update with a value, object, or CSS-style property string, with the possiblity
                  // of clobbering previous values.
                  newAttrValue = arg1;
                  clobber = arg2 === true;
                }

                // Update component
                this.updateComponent(attrName, newAttrValue, clobber);

                // In debug mode, write component data up to the DOM.
                isDebugMode = this.sceneEl && this.sceneEl.getAttribute('debug');
                if (isDebugMode) {
                  this.components[attrName].flushToDOM();
                }
              }

              /**
               * Reflect component data in the DOM (as seen from the browser DOM Inspector).
               *
               * @param {bool} recursive - Also flushToDOM on the children.
               **/
            }, {
              key: "flushToDOM",
              value: function flushToDOM(recursive) {
                var components = this.components;
                var child;
                var children = this.children;
                var i;
                var key;

                // Flush entity's components to DOM.
                for (key in components) {
                  components[key].flushToDOM();
                }

                // Recurse.
                if (!recursive) {
                  return;
                }
                for (i = 0; i < children.length; ++i) {
                  child = children[i];
                  if (!child.flushToDOM) {
                    continue;
                  }
                  child.flushToDOM(recursive);
                }
              }

              /**
               * If `attr` is a component, returns ALL component data including applied mixins and
               * defaults.
               *
               * If `attr` is not a component, fall back to HTML getAttribute.
               *
               * @param {string} attr
               * @returns {object|string} Object if component, else string.
               */
            }, {
              key: "getAttribute",
              value: function getAttribute(attr) {
                // If component, return component data.
                var component;
                if (attr === 'position') {
                  return this.object3D.position;
                }
                if (attr === 'rotation') {
                  return getRotation(this);
                }
                if (attr === 'scale') {
                  return this.object3D.scale;
                }
                if (attr === 'visible') {
                  return this.object3D.visible;
                }
                component = this.components[attr];
                if (component) {
                  return component.data;
                }
                return window.HTMLElement.prototype.getAttribute.call(this, attr);
              }

              /**
               * If `attr` is a component, returns JUST the component data defined on the entity.
               * Like a partial version of `getComputedAttribute` as returned component data
               * does not include applied mixins or defaults.
               *
               * If `attr` is not a component, fall back to HTML getAttribute.
               *
               * @param {string} attr
               * @returns {object|string} Object if component, else string.
               */
            }, {
              key: "getDOMAttribute",
              value: function getDOMAttribute(attr) {
                // If cached value exists, return partial component data.
                var component = this.components[attr];
                if (component) {
                  return component.attrValue;
                }
                return window.HTMLElement.prototype.getAttribute.call(this, attr);
              }
            }, {
              key: "addState",
              value: function addState(state) {
                if (this.is(state)) {
                  return;
                }
                this.states.push(state);
                this.emit('stateadded', state);
              }
            }, {
              key: "removeState",
              value: function removeState(state) {
                var stateIndex = this.states.indexOf(state);
                if (stateIndex === -1) {
                  return;
                }
                this.states.splice(stateIndex, 1);
                this.emit('stateremoved', state);
              }

              /**
               * Checks if the element is in a given state. e.g. el.is('alive');
               * @type {string} state - Name of the state we want to check
               */
            }, {
              key: "is",
              value: function is(state) {
                return this.states.indexOf(state) !== -1;
              }

              /**
               * Open Inspector to this entity.
               */
            }, {
              key: "inspect",
              value: function inspect() {
                this.sceneEl.components.inspector.openInspector(this);
              }

              /**
               * Clean up memory and return memory to object pools.
               */
            }, {
              key: "destroy",
              value: function destroy() {
                var key;
                if (this.parentNode) {
                  warn('Entity can only be destroyed if detached from scenegraph.');
                  return;
                }
                for (key in this.components) {
                  this.components[key].destroy();
                }
              }
            }]);
            return AEntity;
          }(ANode);
          /**
           * Check if a component is *defined* for an entity, including defaults and mixins.
           * Does not check whether the component has been *initialized* for an entity.
           *
           * @param {string} el - Entity.
           * @param {string} name - Component name.
           * @returns {boolean}
           */
          function checkComponentDefined(el, name) {
            // Check if element contains the component.
            if (el.components[name] && el.components[name].attrValue) {
              return true;
            }
            return isComponentMixedIn(name, el.mixinEls);
          }

          /**
           * Check if any mixins contains a component.
           *
           * @param {string} name - Component name.
           * @param {array} mixinEls - Array of <a-mixin>s.
           */
          function isComponentMixedIn(name, mixinEls) {
            var i;
            var inMixin = false;
            for (i = 0; i < mixinEls.length; ++i) {
              inMixin = mixinEls[i].hasAttribute(name);
              if (inMixin) {
                break;
              }
            }
            return inMixin;
          }

          /**
           * Given entity defined value, merge in extra data if necessary.
           * Handle both single and multi-property components.
           *
           * @param {string} attrValue - Entity data.
           * @param extraData - Entity data from another source to merge in.
           */
          function mergeComponentData(attrValue, extraData) {
            // Extra data not defined, just return attrValue.
            if (!extraData) {
              return attrValue;
            }

            // Merge multi-property data.
            if (extraData.constructor === Object) {
              return utils.extend(extraData, utils.styleParser.parse(attrValue || {}));
            }

            // Return data, precendence to the defined value.
            return attrValue || extraData;
          }
          function isComponent(componentName) {
            if (componentName.indexOf(MULTIPLE_COMPONENT_DELIMITER) !== -1) {
              componentName = utils.split(componentName, MULTIPLE_COMPONENT_DELIMITER)[0];
            }
            if (!COMPONENTS[componentName]) {
              return false;
            }
            return true;
          }
          function getRotation(entityEl) {
            var radToDeg = THREE.MathUtils.radToDeg;
            var rotation = entityEl.object3D.rotation;
            var rotationObj = entityEl.rotationObj;
            rotationObj.x = radToDeg(rotation.x);
            rotationObj.y = radToDeg(rotation.y);
            rotationObj.z = radToDeg(rotation.z);
            return rotationObj;
          }
          AEntity.componentsUpdated = [];
          AEntity.singlePropUpdate = {};
          customElements.define('a-entity', AEntity);
          module.exports.AEntity = AEntity;

          /***/
        },

        /***/"./src/core/a-mixin.js":
        /*!*****************************!*\
          !*** ./src/core/a-mixin.js ***!
          \*****************************/
        /***/
        function srcCoreAMixinJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          /* global customElements */
          var ANode = __webpack_require__( /*! ./a-node */"./src/core/a-node.js").ANode;
          var components = __webpack_require__( /*! ./component */"./src/core/component.js").components;
          var utils = __webpack_require__( /*! ../utils */"./src/utils/index.js");
          var MULTIPLE_COMPONENT_DELIMITER = '__';

          /**
           * @member {object} componentCache - Cache of pre-parsed values. An object where the keys
           *         are component names and the values are already parsed by the component.
           */
          var AMixin = /*#__PURE__*/function (_ANode4) {
            "use strict";

            _inherits(AMixin, _ANode4);
            var _super7 = _createSuper(AMixin);
            function AMixin() {
              var _this8;
              _classCallCheck2(this, AMixin);
              _this8 = _super7.call(this);
              _this8.componentCache = {};
              _this8.isMixin = true;
              return _this8;
            }
            _createClass2(AMixin, [{
              key: "connectedCallback",
              value: function connectedCallback() {
                // Defer if DOM is not ready.
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this));
                  return;
                }
                this.doConnectedCallback();
              }
            }, {
              key: "doConnectedCallback",
              value: function doConnectedCallback() {
                _get2(_getPrototypeOf(AMixin.prototype), "connectedCallback", this).call(this);
                this.sceneEl = this.closestScene();
                this.id = this.getAttribute('id');
                this.cacheAttributes();
                this.updateEntities();
                this.load();
              }
            }, {
              key: "attributeChangedCallback",
              value: function attributeChangedCallback(attr, oldVal, newVal) {
                _get2(_getPrototypeOf(AMixin.prototype), "attributeChangedCallback", this).call(this);
                this.cacheAttribute(attr, newVal);
                this.updateEntities();
              }

              /**
               * setAttribute that parses and caches component values.
               */
            }, {
              key: "setAttribute",
              value: function setAttribute(attr, value) {
                window.HTMLElement.prototype.setAttribute.call(this, attr, value);
                this.cacheAttribute(attr, value);
              }

              /**
               * If `attr` is a component, then parse the value using the schema and store it.
               */
            }, {
              key: "cacheAttribute",
              value: function cacheAttribute(attr, value) {
                var component;
                var componentName;

                // Get component data.
                componentName = utils.split(attr, MULTIPLE_COMPONENT_DELIMITER)[0];
                component = components[componentName];
                if (!component) {
                  return;
                }
                if (value === undefined) {
                  value = window.HTMLElement.prototype.getAttribute.call(this, attr);
                }
                this.componentCache[attr] = component.parseAttrValueForCache(value);
              }

              /**
               * If `attr` is a component, then grab pre-parsed value from the cache.
               * Else do a normal getAttribute.
               */
            }, {
              key: "getAttribute",
              value: function getAttribute(attr) {
                return this.componentCache[attr] || window.HTMLElement.prototype.getAttribute.call(this, attr);
              }

              /**
               * Parse and cache every component defined on the mixin.
               */
            }, {
              key: "cacheAttributes",
              value: function cacheAttributes() {
                var attributes = this.attributes;
                var attrName;
                var i;
                for (i = 0; i < attributes.length; i++) {
                  attrName = attributes[i].name;
                  this.cacheAttribute(attrName);
                }
              }

              /**
               * For entities that already have been loaded by the time the mixin was attached, tell
               * those entities to register the mixin and refresh their component data.
               */
            }, {
              key: "updateEntities",
              value: function updateEntities() {
                var entity;
                var entities;
                var i;
                if (!this.sceneEl) {
                  return;
                }
                entities = this.sceneEl.querySelectorAll('[mixin~=' + this.id + ']');
                for (i = 0; i < entities.length; i++) {
                  entity = entities[i];
                  if (!entity.hasLoaded || entity.isMixin) {
                    continue;
                  }
                  entity.mixinUpdate(this.id);
                }
              }
            }]);
            return AMixin;
          }(ANode);
          customElements.define('a-mixin', AMixin);

          /***/
        },

        /***/"./src/core/a-node.js":
        /*!****************************!*\
          !*** ./src/core/a-node.js ***!
          \****************************/
        /***/
        function srcCoreANodeJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global customElements, CustomEvent, HTMLElement, MutationObserver */
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var warn = utils.debug('core:a-node:warn');
          var knownTags = {
            'a-scene': true,
            'a-assets': true,
            'a-assets-items': true,
            'a-cubemap': true,
            'a-mixin': true,
            'a-node': true,
            'a-entity': true
          };
          function isNode(node) {
            return node.tagName.toLowerCase() in knownTags || node.isNode;
          }

          /**
           * Base class for A-Frame that manages loading of objects.
           *
           * Nodes can be modified using mixins.
           * Nodes emit a `loaded` event when they and their children have initialized.
           */
          var ANode = /*#__PURE__*/function (_HTMLElement2) {
            "use strict";

            _inherits(ANode, _HTMLElement2);
            var _super8 = _createSuper(ANode);
            function ANode() {
              var _this9;
              _classCallCheck2(this, ANode);
              _this9 = _super8.call(this);
              _this9.computedMixinStr = '';
              _this9.hasLoaded = false;
              _this9.isNode = true;
              _this9.mixinEls = [];
              return _this9;
            }
            _createClass2(ANode, [{
              key: "connectedCallback",
              value: function connectedCallback() {
                // Defer if DOM is not ready.
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this));
                  return;
                }
                ANode.prototype.doConnectedCallback.call(this);
              }
            }, {
              key: "doConnectedCallback",
              value: function doConnectedCallback() {
                var mixins;
                this.sceneEl = this.closestScene();
                if (!this.sceneEl) {
                  warn('You are attempting to attach <' + this.tagName + '> outside of an A-Frame ' + 'scene. Append this element to `<a-scene>` instead.');
                }
                this.hasLoaded = false;
                this.emit('nodeready', undefined, false);
                if (!this.isMixin) {
                  mixins = this.getAttribute('mixin');
                  if (mixins) {
                    this.updateMixins(mixins);
                  }
                }
              }

              /**
               * Handle mixin.
               */
            }, {
              key: "attributeChangedCallback",
              value: function attributeChangedCallback(attr, oldVal, newVal) {
                // Ignore if `<a-node>` code is just updating computed mixin in the DOM.
                if (newVal === this.computedMixinStr) {
                  return;
                }
                if (attr === 'mixin' && !this.isMixin) {
                  this.updateMixins(newVal, oldVal);
                }
              }

              /**
               * Returns the first scene by traversing up the tree starting from and
               * including receiver element.
               */
            }, {
              key: "closestScene",
              value: function closestScene() {
                var element = this;
                while (element) {
                  if (element.isScene) {
                    break;
                  }
                  element = element.parentElement;
                }
                return element;
              }

              /**
               * Returns first element matching a selector by traversing up the tree starting
               * from and including receiver element.
               *
               * @param {string} selector - Selector of element to find.
               */
            }, {
              key: "closest",
              value: function closest(selector) {
                var matches = this.matches || this.mozMatchesSelector || this.msMatchesSelector || this.oMatchesSelector || this.webkitMatchesSelector;
                var element = this;
                while (element) {
                  if (matches.call(element, selector)) {
                    break;
                  }
                  element = element.parentElement;
                }
                return element;
              }
            }, {
              key: "disconnectedCallback",
              value: function disconnectedCallback() {
                this.hasLoaded = false;
              }

              /**
               * Wait for children to load, if any.
               * Then emit `loaded` event and set `hasLoaded`.
               */
            }, {
              key: "load",
              value: function load(cb, childFilter) {
                var children;
                var childrenLoaded;
                var self = this;
                if (this.hasLoaded) {
                  return;
                }

                // Default to waiting for all nodes.
                childFilter = childFilter || isNode;
                // Wait for children to load (if any), then load.
                children = this.getChildren();
                childrenLoaded = children.filter(childFilter).map(function (child) {
                  return new Promise(function waitForLoaded(resolve, reject) {
                    if (child.hasLoaded) {
                      return resolve();
                    }
                    child.addEventListener('loaded', resolve);
                    child.addEventListener('error', reject);
                  });
                });
                Promise.allSettled(childrenLoaded).then(function emitLoaded(results) {
                  results.forEach(function checkResultForError(result) {
                    if (result.status === 'rejected') {
                      // An "error" event has already been fired by THREE.js loader,
                      // so we don't need to fire another one.
                      // A warning explaining the consequences of the error is sufficient.
                      warn('Rendering scene with errors on node: ', result.reason.target);
                    }
                  });
                  self.hasLoaded = true;
                  if (cb) {
                    cb();
                  }
                  self.setupMutationObserver();
                  self.emit('loaded', undefined, false);
                });
              }

              /**
               * With custom elements V1 attributeChangedCallback only fires
               * for attributes defined statically via observedAttributes.
               * One can assign any arbitrary components to an A-Frame entity
               * hence we can't know the list of attributes beforehand.
               * This function setup a mutation observer to keep track of the entiy attribute changes
               * in the DOM and update components accordingly.
               */
            }, {
              key: "setupMutationObserver",
              value: function setupMutationObserver() {
                var self = this;
                var observerConfig = {
                  attributes: true,
                  attributeOldValue: true
                };
                var observer = new MutationObserver(function callAttributeChangedCallback(mutationList) {
                  var i;
                  for (i = 0; i < mutationList.length; i++) {
                    if (mutationList[i].type === 'attributes') {
                      var attributeName = mutationList[i].attributeName;
                      var newValue = window.HTMLElement.prototype.getAttribute.call(self, attributeName);
                      var oldValue = mutationList[i].oldValue;
                      self.attributeChangedCallback(attributeName, oldValue, newValue);
                    }
                  }
                });
                observer.observe(this, observerConfig);
              }
            }, {
              key: "getChildren",
              value: function getChildren() {
                return Array.prototype.slice.call(this.children, 0);
              }

              /**
               * Unregister old mixins and listeners.
               * Register new mixins and listeners.
               * Registering means to update `this.mixinEls` with listeners.
               */
            }, {
              key: "updateMixins",
              value: function updateMixins(newMixins, oldMixins) {
                var newMixinIdArray = ANode.newMixinIdArray;
                var oldMixinIdArray = ANode.oldMixinIdArray;
                var mixinIds = ANode.mixinIds;
                var i;
                var newMixinIds;
                var oldMixinIds;
                newMixinIdArray.length = 0;
                oldMixinIdArray.length = 0;
                newMixinIds = newMixins ? utils.split(newMixins.trim(), /\s+/) : newMixinIdArray;
                oldMixinIds = oldMixins ? utils.split(oldMixins.trim(), /\s+/) : oldMixinIdArray;
                mixinIds.newMixinIds = newMixinIds;
                mixinIds.oldMixinIds = oldMixinIds;

                // Unregister old mixins.
                for (i = 0; i < oldMixinIds.length; i++) {
                  if (newMixinIds.indexOf(oldMixinIds[i]) === -1) {
                    this.unregisterMixin(oldMixinIds[i]);
                  }
                }

                // Register new mixins.
                this.computedMixinStr = '';
                this.mixinEls.length = 0;
                for (i = 0; i < newMixinIds.length; i++) {
                  this.registerMixin(document.getElementById(newMixinIds[i]));
                }

                // Update DOM. Keep track of `computedMixinStr` to not recurse back here after
                // update.
                if (this.computedMixinStr) {
                  this.computedMixinStr = this.computedMixinStr.trim();
                  window.HTMLElement.prototype.setAttribute.call(this, 'mixin', this.computedMixinStr);
                }
                return mixinIds;
              }

              /**
               * From mixin ID, add mixin element to `mixinEls`.
               *
               * @param {Element} mixinEl
               */
            }, {
              key: "registerMixin",
              value: function registerMixin(mixinEl) {
                var compositedMixinIds;
                var i;
                var mixin;
                if (!mixinEl) {
                  return;
                }

                // Register composited mixins (if mixin has mixins).
                mixin = mixinEl.getAttribute('mixin');
                if (mixin) {
                  compositedMixinIds = utils.split(mixin.trim(), /\s+/);
                  for (i = 0; i < compositedMixinIds.length; i++) {
                    this.registerMixin(document.getElementById(compositedMixinIds[i]));
                  }
                }

                // Register mixin.
                this.computedMixinStr = this.computedMixinStr + ' ' + mixinEl.id;
                this.mixinEls.push(mixinEl);
              }
            }, {
              key: "setAttribute",
              value: function setAttribute(attr, newValue) {
                if (attr === 'mixin') {
                  this.updateMixins(newValue);
                }
                window.HTMLElement.prototype.setAttribute.call(this, attr, newValue);
              }
            }, {
              key: "unregisterMixin",
              value: function unregisterMixin(mixinId) {
                var i;
                var mixinEls = this.mixinEls;
                var mixinEl;
                for (i = 0; i < mixinEls.length; ++i) {
                  mixinEl = mixinEls[i];
                  if (mixinId === mixinEl.id) {
                    mixinEls.splice(i, 1);
                    break;
                  }
                }
              }

              /**
               * Emit a DOM event.
               *
               * @param {string} name - Name of event.
               * @param {object} [detail={}] - Custom data to pass as `detail` to the event.
               * @param {boolean} [bubbles=true] - Whether the event should bubble.
               * @param {object} [extraData] - Extra data to pass to the event, if any.
               */
            }, {
              key: "emit",
              value: function emit(name, detail, bubbles, extraData) {
                var data = ANode.evtData;
                if (bubbles === undefined) {
                  bubbles = true;
                }
                data.bubbles = !!bubbles;
                data.detail = detail;

                // If extra data is present, we need to create a new object.
                if (extraData) {
                  data = utils.extend({}, extraData, data);
                }
                this.dispatchEvent(new CustomEvent(name, data));
              }
            }]);
            return ANode;
          }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
          ANode.evtData = {};
          ANode.newMixinIdArray = [];
          ANode.oldMixinIdArray = [];
          ANode.mixinIds = {};
          customElements.define('a-node', ANode);
          module.exports.ANode = ANode;
          module.exports.knownTags = knownTags;

          /***/
        },

        /***/"./src/core/component.js":
        /*!*******************************!*\
          !*** ./src/core/component.js ***!
          \*******************************/
        /***/
        function srcCoreComponentJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global Node */
          var schema = __webpack_require__( /*! ./schema */"./src/core/schema.js");
          var scenes = __webpack_require__( /*! ./scene/scenes */"./src/core/scene/scenes.js");
          var systems = __webpack_require__( /*! ./system */"./src/core/system.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var components = module.exports.components = {}; // Keep track of registered components.
          var parseProperties = schema.parseProperties;
          var parseProperty = schema.parseProperty;
          var processSchema = schema.process;
          var isSingleProp = schema.isSingleProperty;
          var stringifyProperties = schema.stringifyProperties;
          var stringifyProperty = schema.stringifyProperty;
          var styleParser = utils.styleParser;
          var warn = utils.debug('core:component:warn');
          var aframeScript = document.currentScript;
          var upperCaseRegExp = new RegExp('[A-Z]+');

          // Object pools by component, created upon registration.
          var objectPools = {};

          /**
           * Component class definition.
           *
           * Components configure appearance, modify behavior, or add functionality to
           * entities. The behavior and appearance of an entity can be changed at runtime
           * by adding, removing, or updating components. Entities do not share instances
           * of components.
           *
           * @member {object} el - Reference to the entity element.
           * @member {string} attrValue - Value of the corresponding HTML attribute.
           * @member {object} data - Component data populated by parsing the
           *         mapped attribute of the component plus applying defaults and mixins.
           */
          var Component = module.exports.Component = function (el, attrValue, id) {
            var self = this;
            this.el = el;
            this.id = id;
            this.attrName = this.name + (id ? '__' + id : '');
            this.evtDetail = {
              id: this.id,
              name: this.name
            };
            this.initialized = false;
            this.isSingleProperty = isSingleProp(this.schema);
            this.isSinglePropertyObject = this.isSingleProperty && isObject(parseProperty(undefined, this.schema)) && !(this.schema.default instanceof window.HTMLElement);
            this.isObjectBased = !this.isSingleProperty || this.isSinglePropertyObject;
            this.el.components[this.attrName] = this;
            this.objectPool = objectPools[this.name];
            var events = this.events;
            this.events = {};
            eventsBind(this, events);

            // Store component data from previous update call.
            this.attrValue = undefined;
            if (this.isObjectBased) {
              this.nextData = this.objectPool.use();
              // Drop any properties added by dynamic schemas in previous use
              utils.objectPool.removeUnusedKeys(this.nextData, this.schema);
              this.oldData = this.objectPool.use();
              utils.objectPool.removeUnusedKeys(this.oldData, this.schema);
              this.previousOldData = this.objectPool.use();
              utils.objectPool.removeUnusedKeys(this.previousOldData, this.schema);
              this.parsingAttrValue = this.objectPool.use();
              utils.objectPool.removeUnusedKeys(this.parsingAttrValue, this.schema);
            } else {
              this.nextData = undefined;
              this.oldData = undefined;
              this.previousOldData = undefined;
              this.parsingAttrValue = undefined;
            }

            // Last value passed to updateProperties.
            // This type of throttle ensures that when a burst of changes occurs, the final change to the
            // component always triggers an event (so a consumer of this event will end up reading the correct
            // final state, following a burst of changes).
            this.throttledEmitComponentChanged = utils.throttleLeadingAndTrailing(function emitChange() {
              el.emit('componentchanged', self.evtDetail, false);
            }, 200);
            this.updateProperties(attrValue);
          };
          Component.prototype = {
            /**
             * Contains the type schema and defaults for the data values.
             * Data is coerced into the types of the values of the defaults.
             */
            schema: {},
            /**
             * Init handler. Similar to attachedCallback.
             * Called during component initialization and is only run once.
             * Components can use this to set initial state.
             */
            init: function init() {/* no-op */},
            /**
             * Map of event names to binded event handlers that will be lifecycle-handled.
             * Will be detached on pause / remove.
             * Will be attached on play.
             */
            events: {},
            /**
             * Update handler. Similar to attributeChangedCallback.
             * Called whenever component's data changes.
             * Also called on component initialization when the component receives initial data.
             *
             * @param {object} prevData - Previous attributes of the component.
             */
            update: function update(prevData) {/* no-op */},
            updateSchema: undefined,
            /**
             * Tick handler.
             * Called on each tick of the scene render loop.
             * Affected by play and pause.
             *
             * @param {number} time - Scene tick time.
             * @param {number} timeDelta - Difference in current render time and previous render time.
             */
            tick: undefined,
            /**
             * Tock handler.
             * Called on each tock of the scene render loop.
             * Affected by play and pause.
             *
             * @param {number} time - Scene tick time.
             * @param {number} timeDelta - Difference in current render time and previous render time.
             * @param {object} camera - Camera used to render the last frame.
             */
            tock: undefined,
            /**
             * Called to start any dynamic behavior (e.g., animation, AI, events, physics).
             */
            play: function play() {/* no-op */},
            /**
             * Called to stop any dynamic behavior (e.g., animation, AI, events, physics).
             */
            pause: function pause() {/* no-op */},
            /**
             * Remove handler. Similar to detachedCallback.
             * Called whenever component is removed from the entity (i.e., removeAttribute).
             * Components can use this to reset behavior on the entity.
             */
            remove: function remove() {/* no-op */},
            /**
             * Parses each property based on property type.
             * If component is single-property, then parses the single property value.
             *
             * @param {string} value - HTML attribute value.
             * @param {boolean} silent - Suppress warning messages.
             * @returns {object} Component data.
             */
            parse: function parse(value, silent) {
              var schema = this.schema;
              if (this.isSingleProperty) {
                return parseProperty(value, schema);
              }
              return parseProperties(styleParser.parse(value), schema, true, this.name, silent);
            },
            /**
             * Stringify properties if necessary.
             *
             * Only called from `Entity.setAttribute` for properties whose parsers accept a non-string
             * value (e.g., selector, vec3 property types).
             *
             * @param {object} data - Complete component data.
             * @returns {string}
             */
            stringify: function stringify(data) {
              var schema = this.schema;
              if (typeof data === 'string') {
                return data;
              }
              if (this.isSingleProperty) {
                return stringifyProperty(data, schema);
              }
              data = stringifyProperties(data, schema);
              return styleParser.stringify(data);
            },
            /**
             * Update the cache of the pre-parsed attribute value.
             *
             * @param {string} value - New data.
             * @param {boolean } clobber - Whether to wipe out and replace previous data.
             */
            updateCachedAttrValue: function updateCachedAttrValue(value, clobber) {
              var newAttrValue;
              var tempObject;
              var property;
              if (value === undefined) {
                return;
              }

              // If null value is the new attribute value, make the attribute value falsy.
              if (value === null) {
                if (this.isObjectBased && this.attrValue) {
                  this.objectPool.recycle(this.attrValue);
                }
                this.attrValue = undefined;
                return;
              }
              if (value instanceof Object && !(value instanceof window.HTMLElement)) {
                // If value is an object, copy it to our pooled newAttrValue object to use to update
                // the attrValue.
                tempObject = this.objectPool.use();
                newAttrValue = utils.extend(tempObject, value);
              } else {
                newAttrValue = this.parseAttrValueForCache(value);
              }

              // Merge new data with previous `attrValue` if updating and not clobbering.
              if (this.isObjectBased && !clobber && this.attrValue) {
                for (property in this.attrValue) {
                  if (newAttrValue[property] === undefined) {
                    newAttrValue[property] = this.attrValue[property];
                  }
                }
              }

              // Update attrValue.
              if (this.isObjectBased && !this.attrValue) {
                this.attrValue = this.objectPool.use();
              }
              utils.objectPool.clearObject(this.attrValue);
              this.attrValue = extendProperties(this.attrValue, newAttrValue, this.isObjectBased);
              utils.objectPool.clearObject(tempObject);
            },
            /**
             * Given an HTML attribute value parses the string based on the component schema.
             * To avoid double parsings of strings into strings we store the original instead
             * of the parsed one
             *
             * @param {string} value - HTML attribute value
             */
            parseAttrValueForCache: function parseAttrValueForCache(value) {
              var parsedValue;
              if (typeof value !== 'string') {
                return value;
              }
              if (this.isSingleProperty) {
                parsedValue = this.schema.parse(value);
                /**
                 * To avoid bogus double parsings. Cached values will be parsed when building
                 * component data. For instance when parsing a src id to its url, we want to cache
                 * original string and not the parsed one (#monster -> models/monster.dae)
                 * so when building data we parse the expected value.
                 */
                if (typeof parsedValue === 'string') {
                  parsedValue = value;
                }
              } else {
                // Parse using the style parser to avoid double parsing of individual properties.
                utils.objectPool.clearObject(this.parsingAttrValue);
                parsedValue = styleParser.parse(value, this.parsingAttrValue);
              }
              return parsedValue;
            },
            /**
             * Write cached attribute data to the entity DOM element.
             *
             * @param {boolean} isDefault - Whether component is a default component. Always flush for
             *   default components.
             */
            flushToDOM: function flushToDOM(isDefault) {
              var attrValue = isDefault ? this.data : this.attrValue;
              if (attrValue === null || attrValue === undefined) {
                return;
              }
              window.HTMLElement.prototype.setAttribute.call(this.el, this.attrName, this.stringify(attrValue));
            },
            /**
             * Apply new component data if data has changed (from setAttribute).
             *
             * @param {string} attrValue - HTML attribute value.
             *        If undefined, use the cached attribute value and continue updating properties.
             * @param {boolean} clobber - The previous component data is overwritten by the atrrValue
             */
            updateProperties: function updateProperties(attrValue, clobber) {
              var el = this.el;

              // Just cache the attribute if the entity has not loaded
              // Components are not initialized until the entity has loaded
              if (!el.hasLoaded) {
                this.updateCachedAttrValue(attrValue);
                return;
              }

              // Parse the attribute value.
              // Cache current attrValue for future updates. Updates `this.attrValue`.
              // `null` means no value on purpose, do not set a default value, let mixins take over.
              if (attrValue !== null) {
                attrValue = this.parseAttrValueForCache(attrValue);
              }

              // Cache current attrValue for future updates.
              this.updateCachedAttrValue(attrValue, clobber);
              if (this.initialized) {
                this.updateComponent(attrValue, clobber);
                this.callUpdateHandler();
              } else {
                this.initComponent();
              }
            },
            initComponent: function initComponent() {
              var el = this.el;
              var initialOldData;

              // Build data.
              if (this.updateSchema) {
                this.updateSchema(this.buildData(this.attrValue, false, true));
              }
              this.data = this.buildData(this.attrValue);

              // Component is being already initialized.
              if (el.initializingComponents[this.name]) {
                return;
              }

              // Prevent infinite loop in case of init method setting same component on the entity.
              el.initializingComponents[this.name] = true;
              // Initialize component.
              this.init();
              this.initialized = true;
              delete el.initializingComponents[this.name];

              // Store current data as previous data for future updates.
              this.oldData = extendProperties(this.oldData, this.data, this.isObjectBased);

              // For oldData, pass empty object to multiple-prop schemas or object single-prop schema.
              // Pass undefined to rest of types.
              initialOldData = this.isObjectBased ? this.objectPool.use() : undefined;
              this.update(initialOldData);
              if (this.isObjectBased) {
                this.objectPool.recycle(initialOldData);
              }

              // Play the component if the entity is playing.
              if (el.isPlaying) {
                this.play();
              }
              el.emit('componentinitialized', this.evtDetail, false);
            },
            /**
             * @param attrValue - Passed argument from setAttribute.
             */
            updateComponent: function updateComponent(attrValue, clobber) {
              var key;
              var mayNeedSchemaUpdate;
              if (clobber) {
                // Clobber. Rebuild.
                if (this.updateSchema) {
                  this.updateSchema(this.buildData(this.attrValue, true, true));
                }
                this.data = this.buildData(this.attrValue, true, false);
                return;
              }

              // Apply new value to this.data in place since direct update.
              if (this.isSingleProperty) {
                if (this.isObjectBased) {
                  parseProperty(attrValue, this.schema);
                }
                // Single-property (already parsed).
                this.data = attrValue;
                return;
              }
              parseProperties(attrValue, this.schema, true, this.name);

              // Check if we need to update schema.
              if (this.schemaChangeKeys.length) {
                for (key in attrValue) {
                  if (this.schema[key].schemaChange) {
                    mayNeedSchemaUpdate = true;
                    break;
                  }
                }
              }
              if (mayNeedSchemaUpdate) {
                // Rebuild data if need schema update.
                if (this.updateSchema) {
                  this.updateSchema(this.buildData(this.attrValue, true, true));
                }
                this.data = this.buildData(this.attrValue, true, false);
                return;
              }

              // Normal update.
              for (key in attrValue) {
                if (attrValue[key] === undefined) {
                  continue;
                }
                this.data[key] = attrValue[key];
              }
            },
            /**
             * Check if component should fire update and fire update lifecycle handler.
             */
            callUpdateHandler: function callUpdateHandler() {
              var hasComponentChanged;

              // Store the previous old data before we calculate the new oldData.
              if (this.previousOldData instanceof Object) {
                utils.objectPool.clearObject(this.previousOldData);
              }
              if (this.isObjectBased) {
                copyData(this.previousOldData, this.oldData);
              } else {
                this.previousOldData = this.oldData;
              }
              hasComponentChanged = !utils.deepEqual(this.oldData, this.data);

              // Don't update if properties haven't changed.
              // Always update rotation, position, scale.
              if (!this.isPositionRotationScale && !hasComponentChanged) {
                return;
              }

              // Store current data as previous data for future updates.
              // Reuse `this.oldData` object to try not to allocate another one.
              if (this.oldData instanceof Object) {
                utils.objectPool.clearObject(this.oldData);
              }
              this.oldData = extendProperties(this.oldData, this.data, this.isObjectBased);

              // Update component with the previous old data.
              this.update(this.previousOldData);
              this.throttledEmitComponentChanged();
            },
            handleMixinUpdate: function handleMixinUpdate() {
              this.data = this.buildData(this.attrValue);
              this.callUpdateHandler();
            },
            /**
             * Reset value of a property to the property's default value.
             * If single-prop component, reset value to component's default value.
             *
             * @param {string} propertyName - Name of property to reset.
             */
            resetProperty: function resetProperty(propertyName) {
              if (this.isObjectBased) {
                if (!(propertyName in this.attrValue)) {
                  return;
                }
                delete this.attrValue[propertyName];
                this.data[propertyName] = this.schema[propertyName].default;
              } else {
                this.attrValue = this.schema.default;
                this.data = this.schema.default;
              }
              this.updateProperties(this.attrValue);
            },
            /**
             * Extend schema of component given a partial schema.
             *
             * Some components might want to mutate their schema based on certain properties.
             * e.g., Material component changes its schema based on `shader` to account for different
             * uniforms
             *
             * @param {object} schemaAddon - Schema chunk that extend base schema.
             */
            extendSchema: function extendSchema(schemaAddon) {
              var extendedSchema;
              // Clone base schema.
              extendedSchema = utils.extend({}, components[this.name].schema);
              // Extend base schema with new schema chunk.
              utils.extend(extendedSchema, schemaAddon);
              this.schema = processSchema(extendedSchema);
              this.el.emit('schemachanged', this.evtDetail);
            },
            /**
             * Build component data from the current state of the entity.data.
             *
             * Precedence:
             * 1. Defaults data
             * 2. Mixin data.
             * 3. Attribute data.
             *
             * Finally coerce the data to the types of the defaults.
             *
             * @param {object} newData - Element new data.
             * @param {boolean} clobber - The previous data is completely replaced by the new one.
             * @param {boolean} silent - Suppress warning messages.
             * @return {object} The component data
             */
            buildData: function buildData(newData, clobber, silent) {
              var componentDefined;
              var data;
              var defaultValue;
              var key;
              var mixinData;
              var nextData = this.nextData;
              var schema = this.schema;
              var i;
              var mixinEls = this.el.mixinEls;
              var previousData;

              // Whether component has a defined value. For arrays, treat empty as not defined.
              componentDefined = newData && newData.constructor === Array ? newData.length : newData !== undefined && newData !== null;
              if (this.isObjectBased) {
                utils.objectPool.clearObject(nextData);
              }

              // 1. Gather default values (lowest precendence).
              if (this.isSingleProperty) {
                if (this.isObjectBased) {
                  // If object-based single-prop, then copy over the data to our pooled object.
                  data = copyData(nextData, schema.default);
                } else {
                  // If is plain single-prop, copy by value the default.
                  data = isObjectOrArray(schema.default) ? utils.clone(schema.default) : schema.default;
                }
              } else {
                // Preserve previously set properties if clobber not enabled.
                previousData = !clobber && this.attrValue;

                // Clone default value if object so components don't share object
                data = previousData instanceof Object ? copyData(nextData, previousData) : nextData;

                // Apply defaults.
                for (key in schema) {
                  defaultValue = schema[key].default;
                  if (data[key] !== undefined) {
                    continue;
                  }
                  // Clone default value if object so components don't share object
                  data[key] = isObjectOrArray(defaultValue) ? utils.clone(defaultValue) : defaultValue;
                }
              }

              // 2. Gather mixin values.
              for (i = 0; i < mixinEls.length; i++) {
                mixinData = mixinEls[i].getAttribute(this.attrName);
                if (!mixinData) {
                  continue;
                }
                data = extendProperties(data, mixinData, this.isObjectBased);
              }

              // 3. Gather attribute values (highest precendence).
              if (componentDefined) {
                if (this.isSingleProperty) {
                  // If object-based, copy the value to not modify the original.
                  if (isObject(newData)) {
                    copyData(this.parsingAttrValue, newData);
                    return parseProperty(this.parsingAttrValue, schema);
                  }
                  return parseProperty(newData, schema);
                }
                data = extendProperties(data, newData, this.isObjectBased);
              } else {
                // Parse and coerce using the schema.
                if (this.isSingleProperty) {
                  return parseProperty(data, schema);
                }
              }
              return parseProperties(data, schema, undefined, this.name, silent);
            },
            /**
             * Attach events from component-defined events map.
             */
            eventsAttach: function eventsAttach() {
              var eventName;
              // Safety detach to prevent double-registration.
              this.eventsDetach();
              for (eventName in this.events) {
                this.el.addEventListener(eventName, this.events[eventName]);
              }
            },
            /**
             * Detach events from component-defined events map.
             */
            eventsDetach: function eventsDetach() {
              var eventName;
              for (eventName in this.events) {
                this.el.removeEventListener(eventName, this.events[eventName]);
              }
            },
            /**
             * Release and free memory.
             */
            destroy: function destroy() {
              this.objectPool.recycle(this.attrValue);
              this.objectPool.recycle(this.oldData);
              this.objectPool.recycle(this.parsingAttrValue);
              this.attrValue = this.oldData = this.parsingAttrValue = undefined;
            }
          };
          function eventsBind(component, events) {
            var eventName;
            for (eventName in events) {
              component.events[eventName] = events[eventName].bind(component);
            }
          }

          // For testing.
          if (window.debug) {
            var registrationOrderWarnings = module.exports.registrationOrderWarnings = {};
          }

          /**
           * Register a component to A-Frame.
           *
           * @param {string} name - Component name.
           * @param {object} definition - Component schema and lifecycle method handlers.
           * @returns {object} Component.
           */
          module.exports.registerComponent = function (name, definition) {
            var NewComponent;
            var propertyName;
            var proto = {};
            var schema;
            var schemaIsSingleProp;

            // Warning if component is statically registered after the scene.
            if (document.currentScript && document.currentScript !== aframeScript) {
              scenes.forEach(function checkPosition(sceneEl) {
                // Okay to register component after the scene at runtime.
                if (sceneEl.hasLoaded) {
                  return;
                }

                // Check that component is declared before the scene.
                if (document.currentScript.compareDocumentPosition(sceneEl) === Node.DOCUMENT_POSITION_FOLLOWING) {
                  return;
                }
                warn('The component `' + name + '` was registered in a <script> tag after the scene. ' + 'Component <script> tags in an HTML file should be declared *before* the scene ' + 'such that the component is available to entities during scene initialization.');

                // For testing.
                if (window.debug) {
                  registrationOrderWarnings[name] = true;
                }
              });
            }
            if (upperCaseRegExp.test(name) === true) {
              warn('The component name `' + name + '` contains uppercase characters, but ' + 'HTML will ignore the capitalization of attribute names. ' + 'Change the name to be lowercase: `' + name.toLowerCase() + '`');
            }
            if (name.indexOf('__') !== -1) {
              throw new Error('The component name `' + name + '` is not allowed. ' + 'The sequence __ (double underscore) is reserved to specify an id' + ' for multiple components of the same type');
            }

            // Format definition object to prototype object.
            Object.keys(definition).forEach(function (key) {
              proto[key] = {
                value: definition[key],
                writable: true
              };
            });
            if (components[name]) {
              throw new Error('The component `' + name + '` has been already registered. ' + 'Check that you are not loading two versions of the same component ' + 'or two different components of the same name.');
            }
            NewComponent = function NewComponent(el, attr, id) {
              Component.call(this, el, attr, id);
            };
            NewComponent.prototype = Object.create(Component.prototype, proto);
            NewComponent.prototype.name = name;
            NewComponent.prototype.isPositionRotationScale = name === 'position' || name === 'rotation' || name === 'scale';
            NewComponent.prototype.constructor = NewComponent;
            NewComponent.prototype.system = systems && systems.systems[name];
            NewComponent.prototype.play = wrapPlay(NewComponent.prototype.play);
            NewComponent.prototype.pause = wrapPause(NewComponent.prototype.pause);
            schema = utils.extend(processSchema(NewComponent.prototype.schema, NewComponent.prototype.name));
            schemaIsSingleProp = isSingleProp(NewComponent.prototype.schema);

            // Keep track of keys that may potentially change the schema.
            if (!schemaIsSingleProp) {
              NewComponent.prototype.schemaChangeKeys = [];
              for (propertyName in schema) {
                if (schema[propertyName].schemaChange) {
                  NewComponent.prototype.schemaChangeKeys.push(propertyName);
                }
              }
            }

            // Create object pool for class of components.
            objectPools[name] = utils.objectPool.createPool();
            components[name] = {
              Component: NewComponent,
              dependencies: NewComponent.prototype.dependencies,
              isSingleProp: schemaIsSingleProp,
              multiple: NewComponent.prototype.multiple,
              name: name,
              parse: NewComponent.prototype.parse,
              parseAttrValueForCache: NewComponent.prototype.parseAttrValueForCache,
              schema: schema,
              stringify: NewComponent.prototype.stringify,
              type: NewComponent.prototype.type
            };
            return NewComponent;
          };

          /**
          * Clone component data.
          * Clone only the properties that are plain objects while keeping a reference for the rest.
          *
          * @param data - Component data to clone.
          * @returns Cloned data.
          */
          function copyData(dest, sourceData) {
            var parsedProperty;
            var key;
            for (key in sourceData) {
              if (sourceData[key] === undefined) {
                continue;
              }
              parsedProperty = sourceData[key];
              dest[key] = isObjectOrArray(parsedProperty) ? utils.clone(parsedProperty) : parsedProperty;
            }
            return dest;
          }

          /**
          * Object extending with checking for single-property schema.
          *
          * @param dest - Destination object or value.
          * @param source - Source object or value
          * @param {boolean} isObjectBased - Whether values are objects.
          * @returns Overridden object or value.
          */
          function extendProperties(dest, source, isObjectBased) {
            var key;
            if (isObjectBased && source.constructor === Object) {
              for (key in source) {
                if (source[key] === undefined) {
                  continue;
                }
                if (source[key] && source[key].constructor === Object) {
                  dest[key] = utils.clone(source[key]);
                } else {
                  dest[key] = source[key];
                }
              }
              return dest;
            }
            return source;
          }

          /**
           * Checks if a component has defined a method that needs to run every frame.
           */
          function hasBehavior(component) {
            return component.tick || component.tock;
          }

          /**
           * Wrapper for defined pause method.
           * Pause component by removing tick behavior and calling user's pause method.
           *
           * @param pauseMethod {function}
           */
          function wrapPause(pauseMethod) {
            return function pause() {
              var sceneEl = this.el.sceneEl;
              if (!this.isPlaying) {
                return;
              }
              pauseMethod.call(this);
              this.isPlaying = false;
              this.eventsDetach();
              // Remove tick behavior.
              if (!hasBehavior(this)) {
                return;
              }
              sceneEl.removeBehavior(this);
            };
          }

          /**
           * Wrapper for defined play method.
           * Play component by adding tick behavior and calling user's play method.
           *
           * @param playMethod {function}
           */
          function wrapPlay(playMethod) {
            return function play() {
              var sceneEl = this.el.sceneEl;
              var shouldPlay = this.el.isPlaying && !this.isPlaying;
              if (!this.initialized || !shouldPlay) {
                return;
              }
              playMethod.call(this);
              this.isPlaying = true;
              this.eventsAttach();
              // Add tick behavior.
              if (!hasBehavior(this)) {
                return;
              }
              sceneEl.addBehavior(this);
            };
          }
          function isObject(value) {
            return value && value.constructor === Object && !(value instanceof window.HTMLElement);
          }
          function isObjectOrArray(value) {
            return value && (value.constructor === Object || value.constructor === Array) && !(value instanceof window.HTMLElement);
          }

          /***/
        },

        /***/"./src/core/geometry.js":
        /*!******************************!*\
          !*** ./src/core/geometry.js ***!
          \******************************/
        /***/
        function srcCoreGeometryJs(module, __unused_webpack_exports, __webpack_require__) {
          var schema = __webpack_require__( /*! ./schema */"./src/core/schema.js");
          var processSchema = schema.process;
          var geometries = module.exports.geometries = {}; // Registered geometries.
          var geometryNames = module.exports.geometryNames = []; // Names of registered geometries.
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");

          /**
           * Geometry class definition.
           *
           * Geometries extend the geometry component API to create and register geometry types.
           */
          var Geometry = module.exports.Geometry = function () {};
          Geometry.prototype = {
            /**
             * Contains the type schema and defaults for the data values.
             * Data is coerced into the types of the values of the defaults.
             */
            schema: {},
            /**
             * Init handler. Similar to attachedCallback.
             * Called during shader initialization and is only run once.
             */
            init: function init(data) {
              this.geometry = new THREE.BufferGeometry();
              return this.geometry;
            },
            /**
             * Update handler. Similar to attributeChangedCallback.
             * Called whenever the associated geometry data changes.
             *
             * @param {object} data - New geometry data.
             */
            update: function update(data) {/* no-op */}
          };

          /**
           * Registers a geometry to A-Frame.
           *
           * @param {string} name - Geometry name.
           * @param {object} definition - Geometry property and methods.
           * @returns {object} Geometry.
           */
          module.exports.registerGeometry = function (name, definition) {
            var NewGeometry;
            var proto = {};

            // Format definition object to prototype object.
            Object.keys(definition).forEach(function expandDefinition(key) {
              proto[key] = {
                value: definition[key],
                writable: true
              };
            });
            if (geometries[name]) {
              throw new Error('The geometry `' + name + '` has been already registered');
            }
            NewGeometry = function NewGeometry() {
              Geometry.call(this);
            };
            NewGeometry.prototype = Object.create(Geometry.prototype, proto);
            NewGeometry.prototype.name = name;
            NewGeometry.prototype.constructor = NewGeometry;
            geometries[name] = {
              Geometry: NewGeometry,
              schema: processSchema(NewGeometry.prototype.schema)
            };
            geometryNames.push(name);
            return NewGeometry;
          };

          /***/
        },

        /***/"./src/core/propertyTypes.js":
        /*!***********************************!*\
          !*** ./src/core/propertyTypes.js ***!
          \***********************************/
        /***/
        function srcCorePropertyTypesJs(module, __unused_webpack_exports, __webpack_require__) {
          var coordinates = __webpack_require__( /*! ../utils/coordinates */"./src/utils/coordinates.js");
          var debug = __webpack_require__( /*! debug */"./node_modules/debug/browser.js");
          var error = debug('core:propertyTypes:warn');
          var warn = debug('core:propertyTypes:warn');
          var propertyTypes = module.exports.propertyTypes = {};
          var nonCharRegex = /[,> .[\]:]/;
          var urlRegex = /\url\((.+)\)/;

          // Built-in property types.
          registerPropertyType('audio', '', assetParse);
          registerPropertyType('array', [], arrayParse, arrayStringify);
          registerPropertyType('asset', '', assetParse);
          registerPropertyType('boolean', false, boolParse);
          registerPropertyType('color', '#FFF', defaultParse, defaultStringify);
          registerPropertyType('int', 0, intParse);
          registerPropertyType('number', 0, numberParse);
          registerPropertyType('map', '', assetParse);
          registerPropertyType('model', '', assetParse);
          registerPropertyType('selector', null, selectorParse, selectorStringify);
          registerPropertyType('selectorAll', null, selectorAllParse, selectorAllStringify);
          registerPropertyType('src', '', srcParse);
          registerPropertyType('string', '', defaultParse, defaultStringify);
          registerPropertyType('time', 0, intParse);
          registerPropertyType('vec2', {
            x: 0,
            y: 0
          }, vecParse, coordinates.stringify);
          registerPropertyType('vec3', {
            x: 0,
            y: 0,
            z: 0
          }, vecParse, coordinates.stringify);
          registerPropertyType('vec4', {
            x: 0,
            y: 0,
            z: 0,
            w: 1
          }, vecParse, coordinates.stringify);

          /**
           * Register a parser for re-use such that when someone uses `type` in the schema,
           * `schema.process` will set the property `parse` and `stringify`.
           *
           * @param {string} type - Type name.
           * @param [defaultValue=null] -
           *   Default value to use if component does not define default value.
           * @param {function} [parse=defaultParse] - Parse string function.
           * @param {function} [stringify=defaultStringify] - Stringify to DOM function.
           */
          function registerPropertyType(type, defaultValue, parse, stringify) {
            if ('type' in propertyTypes) {
              error('Property type ' + type + ' is already registered.');
              return;
            }
            propertyTypes[type] = {
              default: defaultValue,
              parse: parse || defaultParse,
              stringify: stringify || defaultStringify
            };
          }
          module.exports.registerPropertyType = registerPropertyType;
          function arrayParse(value) {
            if (Array.isArray(value)) {
              return value;
            }
            if (!value || typeof value !== 'string') {
              return [];
            }
            return value.split(',').map(trim);
            function trim(str) {
              return str.trim();
            }
          }
          function arrayStringify(value) {
            return value.join(', ');
          }

          /**
           * For general assets.
           *
           * @param {string} value - Can either be `url(<value>)`, an ID selector to an asset, or
           *   just string.
           * @returns {string} Parsed value from `url(<value>)`, src from `<someasset src>`, or
           *   just string.
           */
          function assetParse(value) {
            var el;
            var parsedUrl;

            // If an element was provided (e.g. canvas or video), just return it.
            if (typeof value !== 'string') {
              return value;
            }

            // Wrapped `url()` in case of data URI.
            parsedUrl = value.match(urlRegex);
            if (parsedUrl) {
              return parsedUrl[1];
            }

            // ID.
            if (value.charAt(0) === '#') {
              el = document.getElementById(value.substring(1));
              if (el) {
                // Pass through media elements. If we have the elements, we don't have to call
                // three.js loaders which would re-request the assets.
                if (el.tagName === 'CANVAS' || el.tagName === 'VIDEO' || el.tagName === 'IMG') {
                  return el;
                }
                return el.getAttribute('src');
              }
              warn('"' + value + '" asset not found.');
              return;
            }

            // Non-wrapped url().
            return value;
          }
          function defaultParse(value) {
            return value;
          }
          function defaultStringify(value) {
            if (value === null) {
              return 'null';
            }
            return value.toString();
          }
          function boolParse(value) {
            return value !== 'false' && value !== false;
          }
          function intParse(value) {
            return parseInt(value, 10);
          }
          function numberParse(value) {
            return parseFloat(value, 10);
          }
          function selectorParse(value) {
            if (!value) {
              return null;
            }
            if (typeof value !== 'string') {
              return value;
            }
            if (value[0] === '#' && !nonCharRegex.test(value)) {
              // When selecting element by ID only, use getElementById for better performance.
              // Don't match like #myId .child.
              return document.getElementById(value.substring(1));
            }
            return document.querySelector(value);
          }
          function selectorAllParse(value) {
            if (!value) {
              return null;
            }
            if (typeof value !== 'string') {
              return value;
            }
            return Array.prototype.slice.call(document.querySelectorAll(value), 0);
          }
          function selectorStringify(value) {
            if (value.getAttribute) {
              return '#' + value.getAttribute('id');
            }
            return defaultStringify(value);
          }
          function selectorAllStringify(value) {
            if (value instanceof Array) {
              return value.map(function (element) {
                return '#' + element.getAttribute('id');
              }).join(', ');
            }
            return defaultStringify(value);
          }
          function srcParse(value) {
            warn('`src` property type is deprecated. Use `asset` instead.');
            return assetParse(value);
          }
          function vecParse(value) {
            return coordinates.parse(value, this.default);
          }

          /**
           * Validate the default values in a schema to match their type.
           *
           * @param {string} type - Property type name.
           * @param defaultVal - Property type default value.
           * @returns {boolean} Whether default value is accurate given the type.
           */
          function isValidDefaultValue(type, defaultVal) {
            if (type === 'audio' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'array' && !Array.isArray(defaultVal)) {
              return false;
            }
            if (type === 'asset' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'boolean' && typeof defaultVal !== 'boolean') {
              return false;
            }
            if (type === 'color' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'int' && typeof defaultVal !== 'number') {
              return false;
            }
            if (type === 'number' && typeof defaultVal !== 'number') {
              return false;
            }
            if (type === 'map' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'model' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'selector' && typeof defaultVal !== 'string' && defaultVal !== null) {
              return false;
            }
            if (type === 'selectorAll' && typeof defaultVal !== 'string' && defaultVal !== null) {
              return false;
            }
            if (type === 'src' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'string' && typeof defaultVal !== 'string') {
              return false;
            }
            if (type === 'time' && typeof defaultVal !== 'number') {
              return false;
            }
            if (type === 'vec2') {
              return isValidDefaultCoordinate(defaultVal, 2);
            }
            if (type === 'vec3') {
              return isValidDefaultCoordinate(defaultVal, 3);
            }
            if (type === 'vec4') {
              return isValidDefaultCoordinate(defaultVal, 4);
            }
            return true;
          }
          module.exports.isValidDefaultValue = isValidDefaultValue;

          /**
           * Checks if default coordinates are valid.
           *
           * @param possibleCoordinates
           * @param {number} dimensions - 2 for 2D Vector, 3 for 3D vector.
           * @returns {boolean} Whether coordinates are parsed correctly.
           */
          function isValidDefaultCoordinate(possibleCoordinates, dimensions) {
            if (possibleCoordinates === null) {
              return true;
            }
            if (typeof possibleCoordinates !== 'object') {
              return false;
            }
            if (Object.keys(possibleCoordinates).length !== dimensions) {
              return false;
            } else {
              var x = possibleCoordinates.x;
              var y = possibleCoordinates.y;
              var z = possibleCoordinates.z;
              var w = possibleCoordinates.w;
              if (typeof x !== 'number' || typeof y !== 'number') {
                return false;
              }
              if (dimensions > 2 && typeof z !== 'number') {
                return false;
              }
              if (dimensions > 3 && typeof w !== 'number') {
                return false;
              }
            }
            return true;
          }
          module.exports.isValidDefaultCoordinate = isValidDefaultCoordinate;

          /***/
        },

        /***/"./src/core/scene/a-scene.js":
        /*!***********************************!*\
          !*** ./src/core/scene/a-scene.js ***!
          \***********************************/
        /***/
        function srcCoreSceneASceneJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global Promise, screen, CustomEvent */
          var initMetaTags = __webpack_require__( /*! ./metaTags */"./src/core/scene/metaTags.js").inject;
          var initWakelock = __webpack_require__( /*! ./wakelock */"./src/core/scene/wakelock.js");
          var loadingScreen = __webpack_require__( /*! ./loadingScreen */"./src/core/scene/loadingScreen.js");
          var scenes = __webpack_require__( /*! ./scenes */"./src/core/scene/scenes.js");
          var systems = __webpack_require__( /*! ../system */"./src/core/system.js").systems;
          var THREE = __webpack_require__( /*! ../../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");
          // Require after.
          var AEntity = __webpack_require__( /*! ../a-entity */"./src/core/a-entity.js").AEntity;
          var ANode = __webpack_require__( /*! ../a-node */"./src/core/a-node.js").ANode;
          var initPostMessageAPI = __webpack_require__( /*! ./postMessage */"./src/core/scene/postMessage.js");
          var bind = utils.bind;
          var isIOS = utils.device.isIOS();
          var isMobile = utils.device.isMobile();
          var isWebXRAvailable = utils.device.isWebXRAvailable;
          var warn = utils.debug('core:a-scene:warn');
          if (isIOS) {
            __webpack_require__( /*! ../../utils/ios-orientationchange-blank-bug */"./src/utils/ios-orientationchange-blank-bug.js");
          }

          /**
           * Scene element, holds all entities.
           *
           * @member {array} behaviors - Component instances that have registered themselves to be
                     updated on every tick.
           * @member {object} camera - three.js Camera object.
           * @member {object} canvas
           * @member {bool} isScene - Differentiates as scene entity as opposed to other entites.
           * @member {bool} isMobile - Whether browser is mobile (via UA detection).
           * @member {object} object3D - Root three.js Scene object.
           * @member {object} renderer
           * @member {bool} renderStarted
           * @member {object} systems - Registered instantiated systems.
           * @member {number} time
           */
          var AScene = /*#__PURE__*/function (_AEntity) {
            "use strict";

            _inherits(AScene, _AEntity);
            var _super9 = _createSuper(AScene);
            function AScene() {
              var _this10;
              _classCallCheck2(this, AScene);
              var self;
              _this10 = _super9.call(this);
              self = _assertThisInitialized(_this10);
              self.clock = new THREE.Clock();
              self.isIOS = isIOS;
              self.isMobile = isMobile;
              self.hasWebXR = isWebXRAvailable;
              self.isAR = false;
              self.isScene = true;
              self.object3D = new THREE.Scene();
              self.object3D.onAfterRender = function (renderer, scene, camera) {
                // THREE may swap the camera used for the rendering if in VR, so we pass it to tock
                if (self.isPlaying) {
                  self.tock(self.time, self.delta, camera);
                }
              };
              self.resize = bind(self.resize, self);
              self.render = bind(self.render, self);
              self.systems = {};
              self.systemNames = [];
              self.time = self.delta = 0;
              self.behaviors = {
                tick: [],
                tock: []
              };
              self.hasLoaded = false;
              self.isPlaying = false;
              self.originalHTML = self.innerHTML;
              return _this10;
            }
            _createClass2(AScene, [{
              key: "addFullScreenStyles",
              value: function addFullScreenStyles() {
                document.documentElement.classList.add('a-fullscreen');
              }
            }, {
              key: "removeFullScreenStyles",
              value: function removeFullScreenStyles() {
                document.documentElement.classList.remove('a-fullscreen');
              }
            }, {
              key: "connectedCallback",
              value: function connectedCallback() {
                // Defer if DOM is not ready.
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this));
                  return;
                }
                this.doConnectedCallback();
              }
            }, {
              key: "doConnectedCallback",
              value: function doConnectedCallback() {
                var self = this;
                var embedded = this.hasAttribute('embedded');

                // Default components.
                this.setAttribute('inspector', '');
                this.setAttribute('keyboard-shortcuts', '');
                this.setAttribute('screenshot', '');
                this.setAttribute('vr-mode-ui', '');
                this.setAttribute('device-orientation-permission-ui', '');
                _get2(_getPrototypeOf(AScene.prototype), "connectedCallback", this).call(this);

                // Renderer initialization
                setupCanvas(this);
                this.setupRenderer();
                loadingScreen.setup(this, getCanvasSize);
                this.resize();
                if (!embedded) {
                  this.addFullScreenStyles();
                }
                initPostMessageAPI(this);
                initMetaTags(this);
                initWakelock(this);

                // Handler to exit VR (e.g., Oculus Browser back button).
                this.onVRPresentChangeBound = bind(this.onVRPresentChange, this);
                window.addEventListener('vrdisplaypresentchange', this.onVRPresentChangeBound);

                // Bind functions.
                this.enterVRBound = function () {
                  self.enterVR();
                };
                this.exitVRBound = function () {
                  self.exitVR();
                };
                this.exitVRTrueBound = function () {
                  self.exitVR(true);
                };
                this.pointerRestrictedBound = function () {
                  self.pointerRestricted();
                };
                this.pointerUnrestrictedBound = function () {
                  self.pointerUnrestricted();
                };
                if (!isWebXRAvailable) {
                  // Exit VR on `vrdisplaydeactivate` (e.g. taking off Rift headset).
                  window.addEventListener('vrdisplaydeactivate', this.exitVRBound);

                  // Exit VR on `vrdisplaydisconnect` (e.g. unplugging Rift headset).
                  window.addEventListener('vrdisplaydisconnect', this.exitVRTrueBound);

                  // Register for mouse restricted events while in VR
                  // (e.g. mouse no longer available on desktop 2D view)
                  window.addEventListener('vrdisplaypointerrestricted', this.pointerRestrictedBound);

                  // Register for mouse unrestricted events while in VR
                  // (e.g. mouse once again available on desktop 2D view)
                  window.addEventListener('vrdisplaypointerunrestricted', this.pointerUnrestrictedBound);
                }
                window.addEventListener('sessionend', this.resize);
                // Camera set up by camera system.
                this.addEventListener('cameraready', function () {
                  self.attachedCallbackPostCamera();
                });
                this.initSystems();

                // WebXR Immersive navigation handler.
                if (this.hasWebXR && navigator.xr && navigator.xr.addEventListener) {
                  navigator.xr.addEventListener('sessiongranted', function () {
                    self.enterVR();
                  });
                }
              }
            }, {
              key: "attachedCallbackPostCamera",
              value: function attachedCallbackPostCamera() {
                var resize;
                var self = this;
                window.addEventListener('load', resize);
                window.addEventListener('resize', function () {
                  // Workaround for a Webkit bug (https://bugs.webkit.org/show_bug.cgi?id=170595)
                  // where the window does not contain the correct viewport size
                  // after an orientation change. The window size is correct if the operation
                  // is postponed a few milliseconds.
                  // self.resize can be called directly once the bug above is fixed.
                  if (self.isIOS) {
                    setTimeout(self.resize, 100);
                  } else {
                    self.resize();
                  }
                });
                this.play();

                // Add to scene index.
                scenes.push(this);
              }

              /**
               * Initialize all systems.
               */
            }, {
              key: "initSystems",
              value: function initSystems() {
                var name;

                // Initialize camera system first.
                this.initSystem('camera');
                for (name in systems) {
                  if (name === 'camera') {
                    continue;
                  }
                  this.initSystem(name);
                }
              }

              /**
               * Initialize a system.
               */
            }, {
              key: "initSystem",
              value: function initSystem(name) {
                if (this.systems[name]) {
                  return;
                }
                this.systems[name] = new systems[name](this);
                this.systemNames.push(name);
              }

              /**
               * Shut down scene on detach.
               */
            }, {
              key: "disconnectedCallback",
              value: function disconnectedCallback() {
                // Remove from scene index.
                var sceneIndex = scenes.indexOf(this);
                _get2(_getPrototypeOf(AScene.prototype), "disconnectedCallback", this).call(this);
                scenes.splice(sceneIndex, 1);
                window.removeEventListener('vrdisplaypresentchange', this.onVRPresentChangeBound);
                window.removeEventListener('vrdisplayactivate', this.enterVRBound);
                window.removeEventListener('vrdisplaydeactivate', this.exitVRBound);
                window.removeEventListener('vrdisplayconnect', this.enterVRBound);
                window.removeEventListener('vrdisplaydisconnect', this.exitVRTrueBound);
                window.removeEventListener('vrdisplaypointerrestricted', this.pointerRestrictedBound);
                window.removeEventListener('vrdisplaypointerunrestricted', this.pointerUnrestrictedBound);
                window.removeEventListener('sessionend', this.resize);
                this.renderer.dispose();
              }

              /**
               * Add ticks and tocks.
               *
               * @param {object} behavior - A component.
               */
            }, {
              key: "addBehavior",
              value: function addBehavior(behavior) {
                var behaviorArr;
                var behaviors = this.behaviors;
                var behaviorType;

                // Check if behavior has tick and/or tock and add the behavior to the appropriate list.
                for (behaviorType in behaviors) {
                  if (!behavior[behaviorType]) {
                    continue;
                  }
                  behaviorArr = this.behaviors[behaviorType];
                  if (behaviorArr.indexOf(behavior) === -1) {
                    behaviorArr.push(behavior);
                  }
                }
              }

              /**
               * For tests.
               */
            }, {
              key: "getPointerLockElement",
              value: function getPointerLockElement() {
                return document.pointerLockElement;
              }

              /**
               * For tests.
               */
            }, {
              key: "checkHeadsetConnected",
              value: function checkHeadsetConnected() {
                return utils.device.checkHeadsetConnected();
              }
            }, {
              key: "enterAR",
              value: function enterAR() {
                var errorMessage;
                if (!this.hasWebXR) {
                  errorMessage = 'Failed to enter AR mode, WebXR not supported.';
                  throw new Error(errorMessage);
                }
                if (!utils.device.checkARSupport()) {
                  errorMessage = 'Failed to enter AR, WebXR immersive-ar mode not supported in your browser or device.';
                  throw new Error(errorMessage);
                }
                return this.enterVR(true);
              }

              /**
               * Call `requestPresent` if WebVR or WebVR polyfill.
               * Call `requestFullscreen` on desktop.
               * Handle events, states, fullscreen styles.
               *
               * @param {bool?} useAR - if true, try immersive-ar mode
               * @returns {Promise}
               */
            }, {
              key: "enterVR",
              value: function enterVR(useAR) {
                var self = this;
                var vrDisplay;
                var vrManager = self.renderer.xr;
                var xrInit;

                // Don't enter VR if already in VR.
                if (this.is('vr-mode')) {
                  return Promise.resolve('Already in VR.');
                }

                // Has VR.
                if (this.checkHeadsetConnected() || this.isMobile) {
                  var rendererSystem = self.getAttribute('renderer');
                  vrManager.enabled = true;
                  if (this.hasWebXR) {
                    // XR API.
                    if (this.xrSession) {
                      this.xrSession.removeEventListener('end', this.exitVRBound);
                    }
                    var refspace = this.sceneEl.systems.webxr.sessionReferenceSpaceType;
                    vrManager.setReferenceSpaceType(refspace);
                    var xrMode = useAR ? 'immersive-ar' : 'immersive-vr';
                    xrInit = this.sceneEl.systems.webxr.sessionConfiguration;
                    return new Promise(function (resolve, reject) {
                      navigator.xr.requestSession(xrMode, xrInit).then(function requestSuccess(xrSession) {
                        self.xrSession = xrSession;
                        vrManager.layersEnabled = xrInit.requiredFeatures.indexOf('layers') !== -1;
                        vrManager.setSession(xrSession).then(function () {
                          vrManager.setFoveation(rendererSystem.foveationLevel);
                        });
                        xrSession.addEventListener('end', self.exitVRBound);
                        enterVRSuccess(resolve);
                      }, function requestFail(error) {
                        var useAR = xrMode === 'immersive-ar';
                        var mode = useAR ? 'AR' : 'VR';
                        throw new Error('Failed to enter ' + mode + ' mode (`requestSession`) ' + error);
                      });
                    });
                  } else {
                    vrDisplay = utils.device.getVRDisplay();
                    vrManager.setDevice(vrDisplay);
                    if (vrDisplay.isPresenting && !window.hasNativeWebVRImplementation) {
                      enterVRSuccess();
                      return Promise.resolve();
                    }
                    var presentationAttributes = {
                      highRefreshRate: rendererSystem.highRefreshRate
                    };
                    return vrDisplay.requestPresent([{
                      source: this.canvas,
                      attributes: presentationAttributes
                    }]).then(enterVRSuccess, enterVRFailure);
                  }
                }

                // No VR.
                enterVRSuccess();
                return Promise.resolve();

                // Callback that happens on enter VR success or enter fullscreen (any API).
                function enterVRSuccess(resolve) {
                  // vrdisplaypresentchange fires only once when the first requestPresent is completed;
                  // the first requestPresent could be called from ondisplayactivate and there is no way
                  // to setup everything from there. Thus, we need to emulate another vrdisplaypresentchange
                  // for the actual requestPresent. Need to make sure there are no issues with firing the
                  // vrdisplaypresentchange multiple times.
                  var event;
                  if (window.hasNativeWebVRImplementation && !window.hasNativeWebXRImplementation) {
                    event = new CustomEvent('vrdisplaypresentchange', {
                      detail: {
                        display: utils.device.getVRDisplay()
                      }
                    });
                    window.dispatchEvent(event);
                  }
                  if (useAR) {
                    self.addState('ar-mode');
                  } else {
                    self.addState('vr-mode');
                  }
                  self.emit('enter-vr', {
                    target: self
                  });
                  // Lock to landscape orientation on mobile.
                  if (!isWebXRAvailable && self.isMobile && screen.orientation && screen.orientation.lock) {
                    screen.orientation.lock('landscape');
                  }
                  self.addFullScreenStyles();

                  // On mobile, the polyfill handles fullscreen.
                  // TODO: 07/16 Chromium builds break when `requestFullscreen`ing on a canvas
                  // that we are also `requestPresent`ing. Until then, don't fullscreen if headset
                  // connected.
                  if (!self.isMobile && !self.checkHeadsetConnected()) {
                    requestFullscreen(self.canvas);
                  }
                  self.resize();
                  if (resolve) {
                    resolve();
                  }
                }
                function enterVRFailure(err) {
                  self.removeState('vr-mode');
                  if (err && err.message) {
                    throw new Error('Failed to enter VR mode (`requestPresent`): ' + err.message);
                  } else {
                    throw new Error('Failed to enter VR mode (`requestPresent`).');
                  }
                }
              }

              /**
              * Call `exitPresent` if WebVR / WebXR or WebVR polyfill.
              * Handle events, states, fullscreen styles.
              *
              * @returns {Promise}
              */
            }, {
              key: "exitVR",
              value: function exitVR() {
                var self = this;
                var vrDisplay;
                var vrManager = this.renderer.xr;

                // Don't exit VR if not in VR.
                if (!this.is('vr-mode') && !this.is('ar-mode')) {
                  return Promise.resolve('Not in immersive mode.');
                }

                // Handle exiting VR if not yet already and in a headset or polyfill.
                if (this.checkHeadsetConnected() || this.isMobile) {
                  vrManager.enabled = false;
                  vrDisplay = utils.device.getVRDisplay();
                  if (this.hasWebXR) {
                    this.xrSession.removeEventListener('end', this.exitVRBound);
                    // Capture promise to avoid errors.
                    this.xrSession.end().then(function () {}, function () {});
                    this.xrSession = undefined;
                  } else {
                    if (vrDisplay.isPresenting) {
                      return vrDisplay.exitPresent().then(exitVRSuccess, exitVRFailure);
                    }
                  }
                } else {
                  exitFullscreen();
                }

                // Handle exiting VR in all other cases (2D fullscreen, external exit VR event).
                exitVRSuccess();
                return Promise.resolve();
                function exitVRSuccess() {
                  self.removeState('vr-mode');
                  self.removeState('ar-mode');
                  // Lock to landscape orientation on mobile.
                  if (self.isMobile && screen.orientation && screen.orientation.unlock) {
                    screen.orientation.unlock();
                  }
                  // Exiting VR in embedded mode, no longer need fullscreen styles.
                  if (self.hasAttribute('embedded')) {
                    self.removeFullScreenStyles();
                  }
                  self.resize();
                  if (self.isIOS) {
                    utils.forceCanvasResizeSafariMobile(self.canvas);
                  }
                  self.renderer.setPixelRatio(window.devicePixelRatio);
                  self.emit('exit-vr', {
                    target: self
                  });
                }
                function exitVRFailure(err) {
                  if (err && err.message) {
                    throw new Error('Failed to exit VR mode (`exitPresent`): ' + err.message);
                  } else {
                    throw new Error('Failed to exit VR mode (`exitPresent`).');
                  }
                }
              }
            }, {
              key: "pointerRestricted",
              value: function pointerRestricted() {
                if (this.canvas) {
                  var pointerLockElement = this.getPointerLockElement();
                  if (pointerLockElement && pointerLockElement !== this.canvas && document.exitPointerLock) {
                    // Recreate pointer lock on the canvas, if taken on another element.
                    document.exitPointerLock();
                  }
                  if (this.canvas.requestPointerLock) {
                    this.canvas.requestPointerLock();
                  }
                }
              }
            }, {
              key: "pointerUnrestricted",
              value: function pointerUnrestricted() {
                var pointerLockElement = this.getPointerLockElement();
                if (pointerLockElement && pointerLockElement === this.canvas && document.exitPointerLock) {
                  document.exitPointerLock();
                }
              }

              /**
               * Handle `vrdisplaypresentchange` event for exiting VR through other means than
               * `<ESC>` key. For example, GearVR back button on Oculus Browser.
               */
            }, {
              key: "onVRPresentChange",
              value: function onVRPresentChange(evt) {
                // Polyfill places display inside the detail property
                var display = evt.display || evt.detail.display;
                // Entering VR.
                if (display && display.isPresenting) {
                  this.enterVR();
                  return;
                }
                // Exiting VR.
                this.exitVR();
              }

              /**
               * Wraps Entity.getAttribute to take into account for systems.
               * If system exists, then return system data rather than possible component data.
               */
            }, {
              key: "getAttribute",
              value: function getAttribute(attr) {
                var system = this.systems[attr];
                if (system) {
                  return system.data;
                }
                return AEntity.prototype.getAttribute.call(this, attr);
              }

              /**
               * `getAttribute` used to be `getDOMAttribute` and `getComputedAttribute` used to be
               * what `getAttribute` is now. Now legacy code.
               */
            }, {
              key: "getComputedAttribut",
              value: function getComputedAttribut(attr) {
                warn('`getComputedAttribute` is deprecated. Use `getAttribute` instead.');
                this.getAttribute(attr);
              }

              /**
               * Wraps Entity.getDOMAttribute to take into account for systems.
               * If system exists, then return system data rather than possible component data.
               */
            }, {
              key: "getDOMAttribute",
              value: function getDOMAttribute(attr) {
                var system = this.systems[attr];
                if (system) {
                  return system.data;
                }
                return AEntity.prototype.getDOMAttribute.call(this, attr);
              }

              /**
               * Wrap Entity.setAttribute to take into account for systems.
               * If system exists, then skip component initialization checks and do a normal
               * setAttribute.
               */
            }, {
              key: "setAttribute",
              value: function setAttribute(attr, value, componentPropValue) {
                var system = this.systems[attr];
                if (system) {
                  ANode.prototype.setAttribute.call(this, attr, value);
                  system.updateProperties(value);
                  return;
                }
                AEntity.prototype.setAttribute.call(this, attr, value, componentPropValue);
              }

              /**
               * @param {object} behavior - A component.
               */
            }, {
              key: "removeBehavior",
              value: function removeBehavior(behavior) {
                var behaviorArr;
                var behaviorType;
                var behaviors = this.behaviors;
                var index;

                // Check if behavior has tick and/or tock and remove the behavior from the appropriate
                // array.
                for (behaviorType in behaviors) {
                  if (!behavior[behaviorType]) {
                    continue;
                  }
                  behaviorArr = this.behaviors[behaviorType];
                  index = behaviorArr.indexOf(behavior);
                  if (index !== -1) {
                    behaviorArr.splice(index, 1);
                  }
                }
              }
            }, {
              key: "resize",
              value: function resize() {
                var camera = this.camera;
                var canvas = this.canvas;
                var embedded;
                var isVRPresenting;
                var size;
                var isPresenting = this.renderer.xr.isPresenting;
                isVRPresenting = this.renderer.xr.enabled && isPresenting;

                // Do not update renderer, if a camera or a canvas have not been injected.
                // In VR mode, three handles canvas resize based on the dimensions returned by
                // the getEyeParameters function of the WebVR API. These dimensions are independent of
                // the window size, therefore should not be overwritten with the window's width and
                // height, // except when in fullscreen mode.
                if (!camera || !canvas || this.is('vr-mode') && (this.isMobile || isVRPresenting)) {
                  return;
                }

                // Update camera.
                embedded = this.getAttribute('embedded') && !this.is('vr-mode');
                size = getCanvasSize(canvas, embedded, this.maxCanvasSize, this.is('vr-mode'));
                camera.aspect = size.width / size.height;
                camera.updateProjectionMatrix();

                // Notify renderer of size change.
                this.renderer.setSize(size.width, size.height, false);
                this.emit('rendererresize', null, false);
              }
            }, {
              key: "setupRenderer",
              value: function setupRenderer() {
                var self = this;
                var renderer;
                var rendererAttr;
                var rendererAttrString;
                var rendererConfig;
                rendererConfig = {
                  alpha: true,
                  antialias: !isMobile,
                  canvas: this.canvas,
                  logarithmicDepthBuffer: false,
                  powerPreference: 'high-performance'
                };
                this.maxCanvasSize = {
                  height: 1920,
                  width: 1920
                };
                if (this.hasAttribute('renderer')) {
                  rendererAttrString = this.getAttribute('renderer');
                  rendererAttr = utils.styleParser.parse(rendererAttrString);
                  if (rendererAttr.precision) {
                    rendererConfig.precision = rendererAttr.precision + 'p';
                  }
                  if (rendererAttr.antialias && rendererAttr.antialias !== 'auto') {
                    rendererConfig.antialias = rendererAttr.antialias === 'true';
                  }
                  if (rendererAttr.logarithmicDepthBuffer && rendererAttr.logarithmicDepthBuffer !== 'auto') {
                    rendererConfig.logarithmicDepthBuffer = rendererAttr.logarithmicDepthBuffer === 'true';
                  }
                  if (rendererAttr.alpha) {
                    rendererConfig.alpha = rendererAttr.alpha === 'true';
                  }
                  this.maxCanvasSize = {
                    width: rendererAttr.maxCanvasWidth ? parseInt(rendererAttr.maxCanvasWidth) : this.maxCanvasSize.width,
                    height: rendererAttr.maxCanvasHeight ? parseInt(rendererAttr.maxCanvasHeight) : this.maxCanvasSize.height
                  };
                }
                renderer = this.renderer = new THREE.WebGLRenderer(rendererConfig);
                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.sortObjects = false;
                if (this.camera) {
                  renderer.xr.setPoseTarget(this.camera.el.object3D);
                }
                this.addEventListener('camera-set-active', function () {
                  renderer.xr.setPoseTarget(self.camera.el.object3D);
                });
              }

              /**
               * Handler attached to elements to help scene know when to kick off.
               * Scene waits for all entities to load.
               */
            }, {
              key: "play",
              value: function play() {
                var self = this;
                var sceneEl = this;
                if (this.renderStarted) {
                  AEntity.prototype.play.call(this);
                  return;
                }
                this.addEventListener('loaded', function () {
                  var renderer = this.renderer;
                  var vrDisplay;
                  var vrManager = this.renderer.xr;
                  AEntity.prototype.play.call(this); // .play() *before* render.

                  if (sceneEl.renderStarted) {
                    return;
                  }
                  sceneEl.resize();

                  // Kick off render loop.
                  if (sceneEl.renderer) {
                    if (window.performance) {
                      window.performance.mark('render-started');
                    }
                    loadingScreen.remove();
                    vrDisplay = utils.device.getVRDisplay();
                    if (vrDisplay && vrDisplay.isPresenting) {
                      vrManager.setDevice(vrDisplay);
                      vrManager.enabled = true;
                      sceneEl.enterVR();
                    }
                    renderer.setAnimationLoop(this.render);
                    sceneEl.renderStarted = true;
                    sceneEl.emit('renderstart');
                  }
                });

                // setTimeout to wait for all nodes to attach and run their callbacks.
                setTimeout(function () {
                  AEntity.prototype.load.call(self);
                });
              }

              /**
               * Wrap `updateComponent` to not initialize the component if the component has a system
               * (aframevr/aframe#2365).
               */
            }, {
              key: "updateComponent",
              value: function updateComponent(componentName) {
                if (componentName in systems) {
                  return;
                }
                AEntity.prototype.updateComponent.apply(this, arguments);
              }

              /**
               * Behavior-updater meant to be called from scene render.
               * Abstracted to a different function to facilitate unit testing (`scene.tick()`) without
               * needing to render.
               */
            }, {
              key: "tick",
              value: function tick(time, timeDelta) {
                var i;
                var systems = this.systems;

                // Components.
                for (i = 0; i < this.behaviors.tick.length; i++) {
                  if (!this.behaviors.tick[i].el.isPlaying) {
                    continue;
                  }
                  this.behaviors.tick[i].tick(time, timeDelta);
                }

                // Systems.
                for (i = 0; i < this.systemNames.length; i++) {
                  if (!systems[this.systemNames[i]].tick) {
                    continue;
                  }
                  systems[this.systemNames[i]].tick(time, timeDelta);
                }
              }

              /**
               * Behavior-updater meant to be called after scene render for post processing purposes.
               * Abstracted to a different function to facilitate unit testing (`scene.tock()`) without
               * needing to render.
               */
            }, {
              key: "tock",
              value: function tock(time, timeDelta, camera) {
                var i;
                var systems = this.systems;

                // Components.
                for (i = 0; i < this.behaviors.tock.length; i++) {
                  if (!this.behaviors.tock[i].el.isPlaying) {
                    continue;
                  }
                  this.behaviors.tock[i].tock(time, timeDelta, camera);
                }

                // Systems.
                for (i = 0; i < this.systemNames.length; i++) {
                  if (!systems[this.systemNames[i]].tock) {
                    continue;
                  }
                  systems[this.systemNames[i]].tock(time, timeDelta, camera);
                }
              }

              /**
               * The render loop.
               *
               * Updates animations.
               * Updates behaviors.
               * Renders with request animation frame.
               */
            }, {
              key: "render",
              value: function render(time, frame) {
                var renderer = this.renderer;
                this.frame = frame;
                this.delta = this.clock.getDelta() * 1000;
                this.time = this.clock.elapsedTime * 1000;
                if (this.isPlaying) {
                  this.tick(this.time, this.delta);
                }
                var savedBackground = null;
                if (this.is('ar-mode')) {
                  // In AR mode, don't render the default background. Hide it, then
                  // restore it again after rendering.
                  savedBackground = this.object3D.background;
                  this.object3D.background = null;
                }
                renderer.render(this.object3D, this.camera);
                if (savedBackground) {
                  this.object3D.background = savedBackground;
                }
              }
            }]);
            return AScene;
          }(AEntity);
          /**
           * Return size constrained to maxSize - maintaining aspect ratio.
           *
           * @param {object} size - size parameters (width and height).
           * @param {object} maxSize - Max size parameters (width and height).
           * @returns {object} Width and height.
           */
          function constrainSizeTo(size, maxSize) {
            var aspectRatio;
            var pixelRatio = window.devicePixelRatio;
            if (!maxSize || maxSize.width === -1 && maxSize.height === -1) {
              return size;
            }
            if (size.width * pixelRatio < maxSize.width && size.height * pixelRatio < maxSize.height) {
              return size;
            }
            aspectRatio = size.width / size.height;
            if (size.width * pixelRatio > maxSize.width && maxSize.width !== -1) {
              size.width = Math.round(maxSize.width / pixelRatio);
              size.height = Math.round(maxSize.width / aspectRatio / pixelRatio);
            }
            if (size.height * pixelRatio > maxSize.height && maxSize.height !== -1) {
              size.height = Math.round(maxSize.height / pixelRatio);
              size.width = Math.round(maxSize.height * aspectRatio / pixelRatio);
            }
            return size;
          }
          window.customElements.define('a-scene', AScene);

          /**
           * Return the canvas size where the scene will be rendered.
           * Will be always the window size except when the scene is embedded.
           * The parent size will be returned in that case.
           * the returned size will be constrained to the maxSize maintaining aspect ratio.
           *
           * @param {object} canvasEl - the canvas element
           * @param {boolean} embedded - Is the scene embedded?
           * @param {object} max - Max size parameters
           * @param {boolean} isVR - If in VR
           */
          function getCanvasSize(canvasEl, embedded, maxSize, isVR) {
            if (!canvasEl.parentElement) {
              return {
                height: 0,
                width: 0
              };
            }
            if (embedded) {
              var size;
              size = {
                height: canvasEl.parentElement.offsetHeight,
                width: canvasEl.parentElement.offsetWidth
              };
              return constrainSizeTo(size, maxSize);
            }
            return getMaxSize(maxSize, isVR);
          }

          /**
           * Return the canvas size. Will be the window size unless that size is greater than the
           * maximum size (1920x1920 by default).  The constrained size will be returned in that case,
           * maintaining aspect ratio
           *
           * @param {object} maxSize - Max size parameters (width and height).
           * @param {boolean} isVR - If in VR.
           * @returns {object} Width and height.
           */
          function getMaxSize(maxSize, isVR) {
            var size;
            size = {
              height: document.body.offsetHeight,
              width: document.body.offsetWidth
            };
            if (isVR) {
              return size;
            } else {
              return constrainSizeTo(size, maxSize);
            }
          }
          function requestFullscreen(canvas) {
            var requestFullscreen = canvas.requestFullscreen || canvas.webkitRequestFullscreen || canvas.mozRequestFullScreen ||
            // The capitalized `S` is not a typo.
            canvas.msRequestFullscreen;
            // Hide navigation buttons on Android.
            requestFullscreen.apply(canvas, [{
              navigationUI: 'hide'
            }]);
          }
          function exitFullscreen() {
            var fullscreenEl = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;
            if (!fullscreenEl) {
              return;
            }
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            }
          }
          function setupCanvas(sceneEl) {
            var canvasEl;
            canvasEl = document.createElement('canvas');
            canvasEl.classList.add('a-canvas');
            // Mark canvas as provided/injected by A-Frame.
            canvasEl.dataset.aframeCanvas = true;
            sceneEl.appendChild(canvasEl);
            document.addEventListener('fullscreenchange', onFullScreenChange);
            document.addEventListener('mozfullscreenchange', onFullScreenChange);
            document.addEventListener('webkitfullscreenchange', onFullScreenChange);
            document.addEventListener('MSFullscreenChange', onFullScreenChange);

            // Prevent overscroll on mobile.
            canvasEl.addEventListener('touchmove', function (event) {
              event.preventDefault();
            });

            // Set canvas on scene.
            sceneEl.canvas = canvasEl;
            sceneEl.emit('render-target-loaded', {
              target: canvasEl
            });
            // For unknown reasons a synchronous resize does not work on desktop when
            // entering/exiting fullscreen.
            setTimeout(bind(sceneEl.resize, sceneEl), 0);
            function onFullScreenChange() {
              var fullscreenEl = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
              // No fullscren element === exit fullscreen
              if (!fullscreenEl) {
                sceneEl.exitVR();
              }
              document.activeElement.blur();
              document.body.focus();
            }
          }
          module.exports.setupCanvas = setupCanvas;
          module.exports.AScene = AScene;

          /***/
        },

        /***/"./src/core/scene/loadingScreen.js":
        /*!*****************************************!*\
          !*** ./src/core/scene/loadingScreen.js ***!
          \*****************************************/
        /***/
        function srcCoreSceneLoadingScreenJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE */
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");
          var styleParser = utils.styleParser;
          var sceneEl;
          var titleEl;
          var getSceneCanvasSize;
          var ATTR_NAME = 'loading-screen';
          var LOADER_TITLE_CLASS = 'a-loader-title';
          module.exports.setup = function setup(el, getCanvasSize) {
            sceneEl = el;
            getSceneCanvasSize = getCanvasSize;
            var loaderAttribute = sceneEl.hasAttribute(ATTR_NAME) ? styleParser.parse(sceneEl.getAttribute(ATTR_NAME)) : undefined;
            var dotsColor = loaderAttribute && loaderAttribute.dotsColor || 'white';
            var backgroundColor = loaderAttribute && loaderAttribute.backgroundColor || '#24CAFF';
            var loaderEnabled = loaderAttribute === undefined || loaderAttribute.enabled === 'true' || loaderAttribute.enabled === undefined; // true default
            var loaderScene;
            var sphereGeometry;
            var sphereMaterial;
            var sphereMesh1;
            var sphereMesh2;
            var sphereMesh3;
            var camera;
            var clock;
            var time;
            var render;
            if (!loaderEnabled) {
              return;
            }

            // Setup Scene.
            loaderScene = new THREE.Scene();
            sphereGeometry = new THREE.SphereGeometry(0.20, 36, 18, 0, 2 * Math.PI, 0, Math.PI);
            sphereMaterial = new THREE.MeshBasicMaterial({
              color: dotsColor
            });
            sphereMesh1 = new THREE.Mesh(sphereGeometry, sphereMaterial);
            sphereMesh2 = sphereMesh1.clone();
            sphereMesh3 = sphereMesh1.clone();
            camera = new THREE.PerspectiveCamera(80, window.innerWidth / window.innerHeight, 0.0005, 10000);
            clock = new THREE.Clock();
            time = 0;
            render = function render() {
              sceneEl.renderer.render(loaderScene, camera);
              time = clock.getElapsedTime() % 4;
              sphereMesh1.visible = time >= 1;
              sphereMesh2.visible = time >= 2;
              sphereMesh3.visible = time >= 3;
            };
            loaderScene.background = new THREE.Color(backgroundColor);
            loaderScene.add(camera);
            sphereMesh1.position.set(-1, 0, -15);
            sphereMesh2.position.set(0, 0, -15);
            sphereMesh3.position.set(1, 0, -15);
            camera.add(sphereMesh1);
            camera.add(sphereMesh2);
            camera.add(sphereMesh3);
            setupTitle();

            // Delay 200ms to avoid loader flashes.
            setTimeout(function () {
              if (sceneEl.hasLoaded) {
                return;
              }
              resize(camera);
              titleEl.style.display = 'block';
              window.addEventListener('resize', function () {
                resize(camera);
              });
              sceneEl.renderer.setAnimationLoop(render);
            }, 200);
          };
          module.exports.remove = function remove() {
            window.removeEventListener('resize', resize);
            if (!titleEl) {
              return;
            }
            // Hide title.
            titleEl.style.display = 'none';
          };
          function resize(camera) {
            var embedded = sceneEl.hasAttribute('embedded');
            var size = getSceneCanvasSize(sceneEl.canvas, embedded, sceneEl.maxCanvasSize, sceneEl.is('vr-mode'));
            camera.aspect = size.width / size.height;
            camera.updateProjectionMatrix();
            // Notify renderer of size change.
            sceneEl.renderer.setSize(size.width, size.height, false);
          }
          function setupTitle() {
            titleEl = document.createElement('div');
            titleEl.className = LOADER_TITLE_CLASS;
            titleEl.innerHTML = document.title;
            titleEl.style.display = 'none';
            sceneEl.appendChild(titleEl);
          }

          /***/
        },

        /***/"./src/core/scene/metaTags.js":
        /*!************************************!*\
          !*** ./src/core/scene/metaTags.js ***!
          \************************************/
        /***/
        function srcCoreSceneMetaTagsJs(module, __unused_webpack_exports, __webpack_require__) {
          var constants = __webpack_require__( /*! ../../constants/ */"./src/constants/index.js");
          var extend = __webpack_require__( /*! ../../utils */"./src/utils/index.js").extend;
          var MOBILE_HEAD_TAGS = module.exports.MOBILE_HEAD_TAGS = [Meta({
            name: 'viewport',
            content: 'width=device-width,initial-scale=1,maximum-scale=1,shrink-to-fit=no,user-scalable=no,minimal-ui,viewport-fit=cover'
          }),
          // W3C-standardised meta tags.
          Meta({
            name: 'mobile-web-app-capable',
            content: 'yes'
          }), Meta({
            name: 'theme-color',
            content: 'black'
          })];
          var MOBILE_IOS_HEAD_TAGS = [
          // iOS-specific meta tags for fullscreen when pinning to homescreen.
          Meta({
            name: 'apple-mobile-web-app-capable',
            content: 'yes'
          }), Meta({
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          }), Link({
            rel: 'apple-touch-icon',
            href: 'https://aframe.io/images/aframe-logo-152.png'
          })];
          function Meta(attrs) {
            return {
              tagName: 'meta',
              attributes: attrs,
              exists: function exists() {
                return document.querySelector('meta[name="' + attrs.name + '"]');
              }
            };
          }
          function Link(attrs) {
            return {
              tagName: 'link',
              attributes: attrs,
              exists: function exists() {
                return document.querySelector('link[rel="' + attrs.rel + '"]');
              }
            };
          }

          /**
           * Injects the necessary metatags in the document for mobile support:
           * 1. Prevent the user to zoom in the document.
           * 2. Ensure that window.innerWidth and window.innerHeight have the correct
           *    values and the canvas is properly scaled.
           * 3. To allow fullscreen mode when pinning a web app on the home screen on
           *    iOS.
           * Adapted from https://www.reddit.com/r/web_design/comments/3la04p/
           *
           * @param {object} scene - Scene element
           * @returns {Array}
           */
          module.exports.inject = function injectHeadTags(scene) {
            var headEl = document.head;
            var headScriptEl = headEl.querySelector('script');
            var tag;
            var headTags = [];
            MOBILE_HEAD_TAGS.forEach(createAndInjectTag);
            if (scene.isIOS) {
              MOBILE_IOS_HEAD_TAGS.forEach(createAndInjectTag);
            }
            return headTags;
            function createAndInjectTag(tagObj) {
              if (!tagObj || tagObj.exists()) {
                return;
              }
              tag = createTag(tagObj);
              if (!tag) {
                return;
              }
              if (headScriptEl) {
                headScriptEl.parentNode.insertBefore(tag, headScriptEl);
              } else {
                headEl.appendChild(tag);
              }
              headTags.push(tag);
            }
          };
          function createTag(tagObj) {
            if (!tagObj || !tagObj.tagName) {
              return;
            }
            var meta = document.createElement(tagObj.tagName);
            meta.setAttribute(constants.AFRAME_INJECTED, '');
            return extend(meta, tagObj.attributes);
          }

          /***/
        },

        /***/"./src/core/scene/postMessage.js":
        /*!***************************************!*\
          !*** ./src/core/scene/postMessage.js ***!
          \***************************************/
        /***/
        function srcCoreScenePostMessageJs(module, __unused_webpack_exports, __webpack_require__) {
          var bind = __webpack_require__( /*! ../../utils/bind */"./src/utils/bind.js");
          var isIframed = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js").isIframed;

          /**
           * Provides a post message API for scenes contained
           * in an iframe.
           */
          module.exports = function initPostMessageAPI(scene) {
            // Handles fullscreen behavior when inside an iframe.
            if (!isIframed()) {
              return;
            }
            // postMessage API handler
            window.addEventListener('message', bind(postMessageAPIHandler, scene));
          };
          function postMessageAPIHandler(event) {
            var scene = this;
            if (!event.data) {
              return;
            }
            switch (event.data.type) {
              case 'vr':
                {
                  switch (event.data.data) {
                    case 'enter':
                      scene.enterVR();
                      break;
                    case 'exit':
                      scene.exitVR();
                      break;
                  }
                }
            }
          }

          /***/
        },

        /***/"./src/core/scene/scenes.js":
        /*!**********************************!*\
          !*** ./src/core/scene/scenes.js ***!
          \**********************************/
        /***/
        function srcCoreSceneScenesJs(module) {
          /*
            Scene index for keeping track of created scenes.
          */
          module.exports = [];

          /***/
        },

        /***/"./src/core/scene/wakelock.js":
        /*!************************************!*\
          !*** ./src/core/scene/wakelock.js ***!
          \************************************/
        /***/
        function srcCoreSceneWakelockJs(module, __unused_webpack_exports, __webpack_require__) {
          var Wakelock = __webpack_require__( /*! ../../../vendor/wakelock/wakelock */"./vendor/wakelock/wakelock.js");
          module.exports = function initWakelock(scene) {
            if (!scene.isMobile) {
              return;
            }
            var wakelock = scene.wakelock = new Wakelock();
            scene.addEventListener('enter-vr', function () {
              wakelock.request();
            });
            scene.addEventListener('exit-vr', function () {
              wakelock.release();
            });
          };

          /***/
        },

        /***/"./src/core/schema.js":
        /*!****************************!*\
          !*** ./src/core/schema.js ***!
          \****************************/
        /***/
        function srcCoreSchemaJs(module, __unused_webpack_exports, __webpack_require__) {
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var PropertyTypes = __webpack_require__( /*! ./propertyTypes */"./src/core/propertyTypes.js");
          var debug = utils.debug;
          var isValidDefaultValue = PropertyTypes.isValidDefaultValue;
          var propertyTypes = PropertyTypes.propertyTypes;
          var warn = debug('core:schema:warn');

          /**
           * A schema is classified as a schema for a single property if:
           * - `type` is defined on the schema as a string.
           * - OR `default` is defined on the schema, as a reserved keyword.
           * - OR schema is empty.
           */
          function isSingleProperty(schema) {
            if ('type' in schema) {
              return typeof schema.type === 'string';
            }
            return 'default' in schema;
          }
          module.exports.isSingleProperty = isSingleProperty;

          /**
           * Build step to schema to use `type` to inject default value, parser, and stringifier.
           *
           * @param {object} schema
           * @param {string} componentName
           * @returns {object} Schema.
           */
          module.exports.process = function (schema, componentName) {
            var propName;

            // For single property schema, run processPropDefinition over the whole schema.
            if (isSingleProperty(schema)) {
              return processPropertyDefinition(schema, componentName);
            }

            // For multi-property schema, run processPropDefinition over each property definition.
            for (propName in schema) {
              schema[propName] = processPropertyDefinition(schema[propName], componentName);
            }
            return schema;
          };

          /**
           * Inject default value, parser, stringifier for single property.
           *
           * @param {object} propDefinition
           * @param {string} componentName
           */
          function processPropertyDefinition(propDefinition, componentName) {
            var defaultVal = propDefinition.default;
            var isCustomType;
            var propType;
            var typeName = propDefinition.type;

            // Type inference.
            if (!propDefinition.type) {
              if (defaultVal !== undefined && (typeof defaultVal === 'boolean' || typeof defaultVal === 'number')) {
                // Type inference.
                typeName = typeof defaultVal;
              } else if (Array.isArray(defaultVal)) {
                typeName = 'array';
              } else {
                // Fall back to string.
                typeName = 'string';
              }
            } else if (propDefinition.type === 'bool') {
              typeName = 'boolean';
            } else if (propDefinition.type === 'float') {
              typeName = 'number';
            }
            propType = propertyTypes[typeName];
            if (!propType) {
              warn('Unknown property type for component `' + componentName + '`: ' + typeName);
            }

            // Fill in parse and stringify using property types.
            isCustomType = !!propDefinition.parse;
            propDefinition.parse = propDefinition.parse || propType.parse;
            propDefinition.stringify = propDefinition.stringify || propType.stringify;

            // Fill in type name.
            propDefinition.type = typeName;

            // Check that default value exists.
            if ('default' in propDefinition) {
              // Check that default values are valid.
              if (!isCustomType && !isValidDefaultValue(typeName, defaultVal)) {
                warn('Default value `' + defaultVal + '` does not match type `' + typeName + '` in component `' + componentName + '`');
              }
            } else {
              // Fill in default value.
              propDefinition.default = propType.default;
            }
            return propDefinition;
          }
          module.exports.processPropertyDefinition = processPropertyDefinition;

          /**
           * Parse propData using schema. Use default values if not existing in propData.
           *
           * @param {object} propData - Unparsed properties.
           * @param {object} schema - Property types definition.
           * @param {boolean} getPartialData - Whether to return full component data or just the data
           *        with keys in `propData`.
           * @param {string } componentName - Name of the component, used for the property warning.
           * @param {boolean} silent - Suppress warning messages.
           */
          module.exports.parseProperties = function () {
            var propNames = [];
            return function (propData, schema, getPartialData, componentName, silent) {
              var i;
              var propName;
              var propDefinition;
              var propValue;
              propNames.length = 0;
              for (propName in getPartialData ? propData : schema) {
                if (getPartialData && propData[propName] === undefined) {
                  continue;
                }
                propNames.push(propName);
              }
              if (propData === null || typeof propData !== 'object') {
                return propData;
              }

              // Validation errors.
              for (propName in propData) {
                if (propData[propName] !== undefined && !schema[propName] && !silent) {
                  warn('Unknown property `' + propName + '` for component/system `' + componentName + '`.');
                }
              }
              for (i = 0; i < propNames.length; i++) {
                propName = propNames[i];
                propDefinition = schema[propName];
                propValue = propData[propName];
                if (!schema[propName]) {
                  return;
                }
                propData[propName] = parseProperty(propValue, propDefinition);
              }
              return propData;
            };
          }();

          /**
           * Deserialize a single property.
           */
          function parseProperty(value, propDefinition) {
            // Use default value if value is falsy.
            if (value === undefined || value === null || value === '') {
              value = propDefinition.default;
              if (Array.isArray(value)) {
                value = value.slice();
              }
            }
            // Invoke property type parser.
            return propDefinition.parse(value, propDefinition.default);
          }
          module.exports.parseProperty = parseProperty;

          /**
           * Serialize a group of properties.
           */
          module.exports.stringifyProperties = function (propData, schema) {
            var propName;
            var propDefinition;
            var propValue;
            var stringifiedData = {};
            var value;
            for (propName in propData) {
              propDefinition = schema[propName];
              propValue = propData[propName];
              value = propValue;
              if (typeof value === 'object') {
                value = stringifyProperty(propValue, propDefinition);
                if (!propDefinition) {
                  warn('Unknown component property: ' + propName);
                }
              }
              stringifiedData[propName] = value;
            }
            return stringifiedData;
          };

          /**
           * Serialize a single property.
           */
          function stringifyProperty(value, propDefinition) {
            // This function stringifies but it's used in a context where
            // there's always second stringification pass. By returning the original
            // value when it's not an object we save one unnecessary call
            // to JSON.stringify.
            if (typeof value !== 'object') {
              return value;
            }
            // if there's no schema for the property we use standar JSON stringify
            if (!propDefinition || value === null) {
              return JSON.stringify(value);
            }
            return propDefinition.stringify(value);
          }
          module.exports.stringifyProperty = stringifyProperty;

          /***/
        },

        /***/"./src/core/shader.js":
        /*!****************************!*\
          !*** ./src/core/shader.js ***!
          \****************************/
        /***/
        function srcCoreShaderJs(module, __unused_webpack_exports, __webpack_require__) {
          var schema = __webpack_require__( /*! ./schema */"./src/core/schema.js");
          var processSchema = schema.process;
          var shaders = module.exports.shaders = {}; // Keep track of registered shaders.
          var shaderNames = module.exports.shaderNames = []; // Keep track of the names of registered shaders.
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils */"./src/utils/index.js");

          // A-Frame properties to three.js uniform types.
          var propertyToThreeMapping = {
            array: 'v3',
            color: 'v3',
            int: 'i',
            number: 'f',
            map: 't',
            time: 'f',
            vec2: 'v2',
            vec3: 'v3',
            vec4: 'v4'
          };

          /**
           * Shader class definition.
           *
           * Shaders extend the material component API so you can create your own library
           * of customized materials
           *
           */
          var Shader = module.exports.Shader = function () {};
          Shader.prototype = {
            /**
             * Contains the type schema and defaults for the data values.
             * Data is coerced into the types of the values of the defaults.
             */
            schema: {},
            vertexShader: 'void main() {' + 'gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);' + '}',
            fragmentShader: 'void main() {' + 'gl_FragColor = vec4(1.0, 0.0, 1.0, 1.0);' + '}',
            /**
             * Init handler. Similar to attachedCallback.
             * Called during shader initialization and is only run once.
             */
            init: function init(data) {
              this.attributes = this.initVariables(data, 'attribute');
              this.uniforms = this.initVariables(data, 'uniform');
              this.material = new (this.raw ? THREE.RawShaderMaterial : THREE.ShaderMaterial)({
                // attributes: this.attributes,
                uniforms: this.uniforms,
                vertexShader: this.vertexShader,
                fragmentShader: this.fragmentShader
              });
              return this.material;
            },
            initVariables: function initVariables(data, type) {
              var key;
              var schema = this.schema;
              var variables = {};
              var varType;
              for (key in schema) {
                if (schema[key].is !== type) {
                  continue;
                }
                varType = propertyToThreeMapping[schema[key].type];
                variables[key] = {
                  type: varType,
                  value: undefined // Let updateVariables handle setting these.
                };
              }

              return variables;
            },
            /**
             * Update handler. Similar to attributeChangedCallback.
             * Called whenever the associated material data changes.
             *
             * @param {object} data - New material data.
             */
            update: function update(data) {
              this.updateVariables(data, 'attribute');
              this.updateVariables(data, 'uniform');
            },
            updateVariables: function updateVariables(data, type) {
              var key;
              var materialKey;
              var schema = this.schema;
              var variables;
              variables = type === 'uniform' ? this.uniforms : this.attributes;
              for (key in data) {
                if (!schema[key] || schema[key].is !== type) {
                  continue;
                }
                if (schema[key].type === 'map') {
                  // If data unchanged, get out early.
                  if (!variables[key] || variables[key].value === data[key]) {
                    continue;
                  }

                  // Special handling is needed for textures.
                  materialKey = '_texture_' + key;

                  // We can't actually set the variable correctly until we've loaded the texture.
                  this.setMapOnTextureLoad(variables, key, materialKey);

                  // Kick off the texture update now that handler is added.
                  utils.material.updateMapMaterialFromData(materialKey, key, this, data);
                  continue;
                }
                variables[key].value = this.parseValue(schema[key].type, data[key]);
                variables[key].needsUpdate = true;
              }
            },
            parseValue: function parseValue(type, value) {
              var color;
              switch (type) {
                case 'vec2':
                  {
                    return new THREE.Vector2(value.x, value.y);
                  }
                case 'vec3':
                  {
                    return new THREE.Vector3(value.x, value.y, value.z);
                  }
                case 'vec4':
                  {
                    return new THREE.Vector4(value.x, value.y, value.z, value.w);
                  }
                case 'color':
                  {
                    color = new THREE.Color(value);
                    return new THREE.Vector3(color.r, color.g, color.b);
                  }
                case 'map':
                  {
                    return THREE.ImageUtils.loadTexture(value);
                  }
                default:
                  {
                    return value;
                  }
              }
            },
            setMapOnTextureLoad: function setMapOnTextureLoad(variables, key, materialKey) {
              var self = this;
              this.el.addEventListener('materialtextureloaded', function () {
                variables[key].value = self.material[materialKey];
                variables[key].needsUpdate = true;
              });
            }
          };

          /**
           * Registers a shader to A-Frame.
           *
           * @param {string} name - shader name.
           * @param {object} definition - shader property and methods.
           * @returns {object} Shader.
           */
          module.exports.registerShader = function (name, definition) {
            var NewShader;
            var proto = {};

            // Format definition object to prototype object.
            Object.keys(definition).forEach(function (key) {
              proto[key] = {
                value: definition[key],
                writable: true
              };
            });
            if (shaders[name]) {
              throw new Error('The shader ' + name + ' has been already registered');
            }
            NewShader = function NewShader() {
              Shader.call(this);
            };
            NewShader.prototype = Object.create(Shader.prototype, proto);
            NewShader.prototype.name = name;
            NewShader.prototype.constructor = NewShader;
            shaders[name] = {
              Shader: NewShader,
              schema: processSchema(NewShader.prototype.schema)
            };
            shaderNames.push(name);
            return NewShader;
          };

          /***/
        },

        /***/"./src/core/system.js":
        /*!****************************!*\
          !*** ./src/core/system.js ***!
          \****************************/
        /***/
        function srcCoreSystemJs(module, __unused_webpack_exports, __webpack_require__) {
          var components = __webpack_require__( /*! ./component */"./src/core/component.js");
          var schema = __webpack_require__( /*! ./schema */"./src/core/schema.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var parseProperties = schema.parseProperties;
          var parseProperty = schema.parseProperty;
          var processSchema = schema.process;
          var isSingleProp = schema.isSingleProperty;
          var styleParser = utils.styleParser;
          var systems = module.exports.systems = {}; // Keep track of registered systems.

          /**
           * System class definition.
           *
           * Systems provide global scope and services to a group of instantiated components of the
           * same class. They can also help abstract logic away from components such that components
           * only have to worry about data.
           *
           * For example, a physics component that creates a physics world that oversees
           * all entities with a physics or rigid body component.
           *
           * TODO: Have the System prototype reuse the Component prototype. Most code is copied
           * and some pieces are missing from the Component facilities (e.g., attribute caching,
           * setAttribute behavior).
           *
           * @member {string} name - Name that system is registered under.
           * @member {Element} sceneEl - Handle to the scene element where system applies to.
           */
          var System = module.exports.System = function (sceneEl) {
            var component = components && components.components[this.name];

            // Set reference to scene.
            this.el = sceneEl;
            this.sceneEl = sceneEl;

            // Set reference to matching component (if exists).
            if (component) {
              component.Component.prototype.system = this;
            }

            // Process system configuration.
            this.buildData();
            this.init();
            this.update({});
          };
          System.prototype = {
            /**
             * Schema to configure system.
             */
            schema: {},
            /**
             * Init handler. Called during scene initialization and is only run once.
             * Systems can use this to set initial state.
             */
            init: function init() {/* no-op */},
            /**
             * Update handler. Called during scene attribute updates.
             * Systems can use this to dynamically update their state.
             */
            update: function update(oldData) {/* no-op */},
            /**
             * Build data and call update handler.
             *
             * @private
             */
            updateProperties: function updateProperties(rawData) {
              var oldData = this.data;
              if (!Object.keys(schema).length) {
                return;
              }
              this.buildData(rawData);
              this.update(oldData);
            },
            /**
             * Parse data.
             */
            buildData: function buildData(rawData) {
              var schema = this.schema;
              if (!Object.keys(schema).length) {
                return;
              }
              rawData = rawData || window.HTMLElement.prototype.getAttribute.call(this.sceneEl, this.name);
              if (isSingleProp(schema)) {
                this.data = parseProperty(rawData, schema);
              } else {
                this.data = parseProperties(styleParser.parse(rawData) || {}, schema);
              }
            },
            /**
             * Tick handler.
             * Called on each tick of the scene render loop.
             * Affected by play and pause.
             *
             * @param {number} time - Scene tick time.
             * @param {number} timeDelta - Difference in current render time and previous render time.
             */
            tick: undefined,
            /**
             * Tock handler.
             * Called on each tock of the scene render loop.
             * Affected by play and pause.
             *
             * @param {number} time - Scene tick time.
             * @param {number} timeDelta - Difference in current render time and previous render time.
             */
            tock: undefined,
            /**
             * Called to start any dynamic behavior (e.g., animation, AI, events, physics).
             */
            play: function play() {/* no-op */},
            /**
             * Called to stop any dynamic behavior (e.g., animation, AI, events, physics).
             */
            pause: function pause() {/* no-op */}
          };

          /**
           * Registers a system to A-Frame.
           *
           * @param {string} name - Component name.
           * @param {object} definition - Component property and methods.
           * @returns {object} Component.
           */
          module.exports.registerSystem = function (name, definition) {
            var i;
            var NewSystem;
            var proto = {};
            var scenes = utils.findAllScenes(document);

            // Format definition object to prototype object.
            Object.keys(definition).forEach(function (key) {
              proto[key] = {
                value: definition[key],
                writable: true
              };
            });
            if (systems[name]) {
              throw new Error('The system `' + name + '` has been already registered. ' + 'Check that you are not loading two versions of the same system ' + 'or two different systems of the same name.');
            }
            NewSystem = function NewSystem(sceneEl) {
              System.call(this, sceneEl);
            };
            NewSystem.prototype = Object.create(System.prototype, proto);
            NewSystem.prototype.name = name;
            NewSystem.prototype.constructor = NewSystem;
            NewSystem.prototype.schema = utils.extend(processSchema(NewSystem.prototype.schema));
            systems[name] = NewSystem;

            // Initialize systems for existing scenes
            for (i = 0; i < scenes.length; i++) {
              scenes[i].initSystem(name);
            }
          };

          /***/
        },

        /***/"./src/extras/components/index.js":
        /*!****************************************!*\
          !*** ./src/extras/components/index.js ***!
          \****************************************/
        /***/
        function srcExtrasComponentsIndexJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          __webpack_require__( /*! ./pivot */"./src/extras/components/pivot.js");

          /***/
        },

        /***/"./src/extras/components/pivot.js":
        /*!****************************************!*\
          !*** ./src/extras/components/pivot.js ***!
          \****************************************/
        /***/
        function srcExtrasComponentsPivotJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerComponent = __webpack_require__( /*! ../../core/component */"./src/core/component.js").registerComponent;
          var THREE = __webpack_require__( /*! ../../lib/three */"./src/lib/three.js");
          var originalPosition = new THREE.Vector3();
          var originalRotation = new THREE.Vector3();

          /**
           * Wrap el.object3D within an outer group. Apply pivot to el.object3D as position.
           */
          registerComponent('pivot', {
            dependencies: ['position'],
            schema: {
              type: 'vec3'
            },
            init: function init() {
              var data = this.data;
              var el = this.el;
              var originalParent = el.object3D.parent;
              var originalGroup = el.object3D;
              var outerGroup = new THREE.Group();
              originalPosition.copy(originalGroup.position);
              originalRotation.copy(originalGroup.rotation);

              // Detach current group from parent.
              originalParent.remove(originalGroup);
              outerGroup.add(originalGroup);

              // Set new group as the outer group.
              originalParent.add(outerGroup);

              // Set outer group as new object3D.
              el.object3D = outerGroup;

              // Apply pivot to original group.
              originalGroup.position.set(-1 * data.x, -1 * data.y, -1 * data.z);

              // Offset the pivot so that world position not affected.
              // And restore position onto outer group.
              outerGroup.position.set(data.x + originalPosition.x, data.y + originalPosition.y, data.z + originalPosition.z);

              // Transfer rotation to outer group.
              outerGroup.rotation.copy(originalGroup.rotation);
              originalGroup.rotation.set(0, 0, 0);
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/getMeshMixin.js":
        /*!***********************************************!*\
          !*** ./src/extras/primitives/getMeshMixin.js ***!
          \***********************************************/
        /***/
        function srcExtrasPrimitivesGetMeshMixinJs(module, __unused_webpack_exports, __webpack_require__) {
          /**
           * Common mesh defaults, mappings, and transforms.
           */
          var components = __webpack_require__( /*! ../../core/component */"./src/core/component.js").components;
          var shaders = __webpack_require__( /*! ../../core/shader */"./src/core/shader.js").shaders;
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");
          var materialMappings = {};
          Object.keys(components.material.schema).forEach(addMapping);
          Object.keys(shaders.standard.schema).forEach(addMapping);
          function addMapping(prop) {
            // To hyphenated.
            var htmlAttrName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            if (prop === 'fog') {
              htmlAttrName = 'material-fog';
            }
            if (prop === 'visible') {
              htmlAttrName = 'material-visible';
            }
            materialMappings[htmlAttrName] = 'material.' + prop;
          }
          module.exports = function getMeshMixin() {
            return {
              defaultComponents: {
                material: {}
              },
              mappings: utils.extend({}, materialMappings)
            };
          };

          /***/
        },

        /***/"./src/extras/primitives/index.js":
        /*!****************************************!*\
          !*** ./src/extras/primitives/index.js ***!
          \****************************************/
        /***/
        function srcExtrasPrimitivesIndexJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          __webpack_require__( /*! ./primitives/a-camera */"./src/extras/primitives/primitives/a-camera.js");
          __webpack_require__( /*! ./primitives/a-cursor */"./src/extras/primitives/primitives/a-cursor.js");
          __webpack_require__( /*! ./primitives/a-curvedimage */"./src/extras/primitives/primitives/a-curvedimage.js");
          __webpack_require__( /*! ./primitives/a-gltf-model */"./src/extras/primitives/primitives/a-gltf-model.js");
          __webpack_require__( /*! ./primitives/a-image */"./src/extras/primitives/primitives/a-image.js");
          __webpack_require__( /*! ./primitives/a-light */"./src/extras/primitives/primitives/a-light.js");
          __webpack_require__( /*! ./primitives/a-link */"./src/extras/primitives/primitives/a-link.js");
          __webpack_require__( /*! ./primitives/a-obj-model */"./src/extras/primitives/primitives/a-obj-model.js");
          __webpack_require__( /*! ./primitives/a-sky */"./src/extras/primitives/primitives/a-sky.js");
          __webpack_require__( /*! ./primitives/a-sound */"./src/extras/primitives/primitives/a-sound.js");
          __webpack_require__( /*! ./primitives/a-text */"./src/extras/primitives/primitives/a-text.js");
          __webpack_require__( /*! ./primitives/a-video */"./src/extras/primitives/primitives/a-video.js");
          __webpack_require__( /*! ./primitives/a-videosphere */"./src/extras/primitives/primitives/a-videosphere.js");
          __webpack_require__( /*! ./primitives/meshPrimitives */"./src/extras/primitives/primitives/meshPrimitives.js");

          /***/
        },

        /***/"./src/extras/primitives/primitives.js":
        /*!*********************************************!*\
          !*** ./src/extras/primitives/primitives.js ***!
          \*********************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global customElements */
          var knownTags = __webpack_require__( /*! ../../core/a-node */"./src/core/a-node.js").knownTags;
          var AEntity = __webpack_require__( /*! ../../core/a-entity */"./src/core/a-entity.js").AEntity;
          var components = __webpack_require__( /*! ../../core/component */"./src/core/component.js").components;
          var utils = __webpack_require__( /*! ../../utils/ */"./src/utils/index.js");
          var debug = utils.debug;
          var setComponentProperty = utils.entity.setComponentProperty;
          var log = debug('extras:primitives:debug');
          var warn = debug('extras:primitives:warn');
          var error = debug('extras:primitives:error');
          var primitives = module.exports.primitives = {};
          module.exports.registerPrimitive = function registerPrimitive(name, definition) {
            name = name.toLowerCase();
            if (knownTags[name]) {
              error('Trying to register primitive ' + name + ' that has been already previously registered');
              return;
            }
            knownTags[name] = true;
            log('Registering <%s>', name);

            // Deprecation warning for defaultAttributes usage.
            if (definition.defaultAttributes) {
              warn("The 'defaultAttributes' object is deprecated. Use 'defaultComponents' instead.");
            }
            var mappings = definition.mappings || {};
            var primitiveClass = /*#__PURE__*/function (_AEntity2) {
              "use strict";

              _inherits(primitiveClass, _AEntity2);
              var _super10 = _createSuper(primitiveClass);
              function primitiveClass() {
                var _this11;
                _classCallCheck2(this, primitiveClass);
                _this11 = _super10.call(this);
                _this11.defaultComponentsFromPrimitive = definition.defaultComponents || definition.defaultAttributes || {};
                _this11.deprecated = definition.deprecated || null;
                _this11.deprecatedMappings = definition.deprecatedMappings || {};
                _this11.mappings = mappings;
                if (definition.deprecated) {
                  console.warn(definition.deprecated);
                }
                _this11.resolveMappingCollisions();
                return _this11;
              }

              /**
               * If a mapping collides with a registered component name
               * it renames the mapping to componentname-property
               */
              _createClass2(primitiveClass, [{
                key: "resolveMappingCollisions",
                value: function resolveMappingCollisions() {
                  var mappings = this.mappings;
                  var self = this;
                  Object.keys(mappings).forEach(function resolveCollision(key) {
                    var newAttribute;
                    if (key !== key.toLowerCase()) {
                      warn('Mapping keys should be specified in lower case. The mapping key ' + key + ' may not be recognized');
                    }
                    if (components[key]) {
                      newAttribute = mappings[key].replace('.', '-');
                      mappings[newAttribute] = mappings[key];
                      delete mappings[key];
                      console.warn('The primitive ' + self.tagName.toLowerCase() + ' has a mapping collision. ' + 'The attribute ' + key + ' has the same name as a registered component and' + ' has been renamed to ' + newAttribute);
                    }
                  });
                }
              }, {
                key: "getExtraComponents",
                value: function getExtraComponents() {
                  var attr;
                  var data;
                  var i;
                  var mapping;
                  var mixins;
                  var path;
                  var self = this;

                  // Gather component data from default components.
                  data = utils.clone(this.defaultComponentsFromPrimitive);

                  // Factor in mixins to overwrite default components.
                  mixins = this.getAttribute('mixin');
                  if (mixins) {
                    mixins = mixins.trim().split(' ');
                    mixins.forEach(function applyMixin(mixinId) {
                      var mixinComponents = self.sceneEl.querySelector('#' + mixinId).componentCache;
                      Object.keys(mixinComponents).forEach(function setComponent(name) {
                        data[name] = extend(data[name], mixinComponents[name]);
                      });
                    });
                  }

                  // Gather component data from mappings.
                  for (i = 0; i < this.attributes.length; i++) {
                    attr = this.attributes[i];
                    mapping = this.mappings[attr.name];
                    if (mapping) {
                      path = utils.entity.getComponentPropertyPath(mapping);
                      if (path.constructor === Array) {
                        data[path[0]] = data[path[0]] || {};
                        data[path[0]][path[1]] = attr.value.trim();
                      } else {
                        data[path] = attr.value.trim();
                      }
                      continue;
                    }
                  }
                  return data;

                  /**
                   * For the base to be extensible, both objects must be pure JavaScript objects.
                   * The function assumes that base is undefined, or null or a pure object.
                   */
                  function extend(base, extension) {
                    if (isUndefined(base)) {
                      return copy(extension);
                    }
                    if (isUndefined(extension)) {
                      return copy(base);
                    }
                    if (isPureObject(base) && isPureObject(extension)) {
                      return utils.extendDeep(base, extension);
                    }
                    return copy(extension);
                  }
                  function isUndefined(value) {
                    return typeof value === 'undefined';
                  }
                  function copy(value) {
                    if (isPureObject(value)) {
                      return utils.extendDeep({}, value);
                    }
                    return value;
                  }
                  function isPureObject(value) {
                    return value !== null && value.constructor === Object;
                  }
                }

                /**
                 * Sync to attribute to component property whenever mapped attribute changes.
                 * If attribute is mapped to a component property, set the component property using
                 * the attribute value.
                 */
              }, {
                key: "attributeChangedCallback",
                value: function attributeChangedCallback(attr, oldVal, value) {
                  var componentName = this.mappings[attr];
                  if (attr in this.deprecatedMappings) {
                    console.warn(this.deprecatedMappings[attr]);
                  }
                  if (!attr || !componentName) {
                    _get2(_getPrototypeOf(primitiveClass.prototype), "attributeChangedCallback", this).call(this, attr, oldVal, value);
                    return;
                  }

                  // Set value.
                  setComponentProperty(this, componentName, value);
                }
              }]);
              return primitiveClass;
            }(AEntity);
            customElements.define(name, primitiveClass);
            primitiveClass.mappings = mappings;

            // Store.
            primitives[name] = primitiveClass;
            return primitiveClass;
          };

          /**
           * Add component mappings using schema.
           */
          function addComponentMapping(componentName, mappings) {
            var schema = components[componentName].schema;
            Object.keys(schema).map(function (prop) {
              // Hyphenate where there is camelCase.
              var attrName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
              // If there is a mapping collision, prefix with component name and hyphen.
              if (mappings[attrName] !== undefined) {
                attrName = componentName + '-' + prop;
              }
              mappings[attrName] = componentName + '.' + prop;
            });
          }

          /**
           * Helper to define a primitive, building mappings using a component schema.
           */
          function definePrimitive(tagName, defaultComponents, mappings) {
            // If no initial mappings provided, start from empty map.
            mappings = mappings || {};

            // From the default components, add mapping automagically.
            Object.keys(defaultComponents).map(function buildMappings(componentName) {
              addComponentMapping(componentName, mappings);
            });

            // Register the primitive.
            module.exports.registerPrimitive(tagName, utils.extendDeep({}, null, {
              defaultComponents: defaultComponents,
              mappings: mappings
            }));
          }
          module.exports.definePrimitive = definePrimitive;

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-camera.js":
        /*!******************************************************!*\
          !*** ./src/extras/primitives/primitives/a-camera.js ***!
          \******************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesACameraJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          registerPrimitive('a-camera', {
            defaultComponents: {
              'camera': {},
              'look-controls': {},
              'wasd-controls': {},
              'position': {
                x: 0,
                y: 1.6,
                z: 0
              }
            },
            mappings: {
              active: 'camera.active',
              far: 'camera.far',
              fov: 'camera.fov',
              'look-controls-enabled': 'look-controls.enabled',
              near: 'camera.near',
              'pointer-lock-enabled': 'look-controls.pointerLockEnabled',
              'wasd-controls-enabled': 'wasd-controls.enabled',
              'reverse-mouse-drag': 'look-controls.reverseMouseDrag',
              zoom: 'camera.zoom'
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-cursor.js":
        /*!******************************************************!*\
          !*** ./src/extras/primitives/primitives/a-cursor.js ***!
          \******************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesACursorJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          registerPrimitive('a-cursor', utils.extendDeep({}, getMeshMixin(), {
            defaultComponents: {
              cursor: {},
              geometry: {
                primitive: 'ring',
                radiusOuter: 0.016,
                radiusInner: 0.01,
                segmentsTheta: 32
              },
              material: {
                color: '#000',
                shader: 'flat',
                opacity: 0.8
              },
              position: {
                x: 0,
                y: 0,
                z: -1
              }
            },
            mappings: {
              far: 'raycaster.far',
              fuse: 'cursor.fuse',
              'fuse-timeout': 'cursor.fuseTimeout',
              interval: 'raycaster.interval',
              objects: 'raycaster.objects'
            }
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-curvedimage.js":
        /*!***********************************************************!*\
          !*** ./src/extras/primitives/primitives/a-curvedimage.js ***!
          \***********************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesACurvedimageJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          registerPrimitive('a-curvedimage', utils.extendDeep({}, getMeshMixin(), {
            defaultComponents: {
              geometry: {
                height: 1,
                primitive: 'cylinder',
                radius: 2,
                segmentsRadial: 48,
                thetaLength: 270,
                openEnded: true,
                thetaStart: 0
              },
              material: {
                color: '#FFF',
                shader: 'flat',
                side: 'double',
                transparent: true,
                repeat: '-1 1'
              }
            },
            mappings: {
              height: 'geometry.height',
              'open-ended': 'geometry.openEnded',
              radius: 'geometry.radius',
              segments: 'geometry.segmentsRadial',
              start: 'geometry.thetaStart',
              'theta-length': 'geometry.thetaLength',
              'theta-start': 'geometry.thetaStart',
              'width': 'geometry.thetaLength'
            }
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-gltf-model.js":
        /*!**********************************************************!*\
          !*** ./src/extras/primitives/primitives/a-gltf-model.js ***!
          \**********************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesAGltfModelJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          registerPrimitive('a-gltf-model', {
            mappings: {
              src: 'gltf-model'
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-image.js":
        /*!*****************************************************!*\
          !*** ./src/extras/primitives/primitives/a-image.js ***!
          \*****************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesAImageJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          registerPrimitive('a-image', utils.extendDeep({}, getMeshMixin(), {
            defaultComponents: {
              geometry: {
                primitive: 'plane'
              },
              material: {
                color: '#FFF',
                shader: 'flat',
                side: 'double',
                transparent: true
              }
            },
            mappings: {
              height: 'geometry.height',
              width: 'geometry.width'
            }
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-light.js":
        /*!*****************************************************!*\
          !*** ./src/extras/primitives/primitives/a-light.js ***!
          \*****************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesALightJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          registerPrimitive('a-light', {
            defaultComponents: {
              light: {}
            },
            mappings: {
              angle: 'light.angle',
              color: 'light.color',
              'ground-color': 'light.groundColor',
              decay: 'light.decay',
              distance: 'light.distance',
              intensity: 'light.intensity',
              penumbra: 'light.penumbra',
              type: 'light.type',
              target: 'light.target',
              envmap: 'light.envMap',
              'shadow-camera-automatic': 'light.shadowCameraAutomatic'
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-link.js":
        /*!****************************************************!*\
          !*** ./src/extras/primitives/primitives/a-link.js ***!
          \****************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesALinkJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          registerPrimitive('a-link', {
            defaultComponents: {
              link: {
                visualAspectEnabled: true
              }
            },
            mappings: {
              href: 'link.href',
              image: 'link.image',
              title: 'link.title'
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-obj-model.js":
        /*!*********************************************************!*\
          !*** ./src/extras/primitives/primitives/a-obj-model.js ***!
          \*********************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesAObjModelJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var meshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js")();
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          registerPrimitive('a-obj-model', utils.extendDeep({}, meshMixin, {
            defaultComponents: {
              'obj-model': {}
            },
            mappings: {
              src: 'obj-model.obj',
              mtl: 'obj-model.mtl'
            }
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-sky.js":
        /*!***************************************************!*\
          !*** ./src/extras/primitives/primitives/a-sky.js ***!
          \***************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesASkyJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          var meshPrimitives = __webpack_require__( /*! ./meshPrimitives */"./src/extras/primitives/primitives/meshPrimitives.js");
          registerPrimitive('a-sky', utils.extendDeep({}, getMeshMixin(), {
            defaultComponents: {
              geometry: {
                primitive: 'sphere',
                radius: 500,
                segmentsWidth: 64,
                segmentsHeight: 32
              },
              material: {
                color: '#FFF',
                side: 'back',
                shader: 'flat',
                npot: true
              },
              scale: '-1 1 1'
            },
            mappings: utils.extendDeep({}, meshPrimitives['a-sphere'].mappings)
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-sound.js":
        /*!*****************************************************!*\
          !*** ./src/extras/primitives/primitives/a-sound.js ***!
          \*****************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesASoundJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          registerPrimitive('a-sound', {
            defaultComponents: {
              sound: {}
            },
            mappings: {
              src: 'sound.src',
              on: 'sound.on',
              autoplay: 'sound.autoplay',
              loop: 'sound.loop',
              volume: 'sound.volume'
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-text.js":
        /*!****************************************************!*\
          !*** ./src/extras/primitives/primitives/a-text.js ***!
          \****************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesATextJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          // <a-text> using `definePrimitive` helper.
          var definePrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").definePrimitive;
          definePrimitive('a-text', {
            text: {
              anchor: 'align',
              width: 5
            }
          });

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-video.js":
        /*!*****************************************************!*\
          !*** ./src/extras/primitives/primitives/a-video.js ***!
          \*****************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesAVideoJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          registerPrimitive('a-video', utils.extendDeep({}, getMeshMixin(), {
            defaultComponents: {
              geometry: {
                primitive: 'plane'
              },
              material: {
                color: '#FFF',
                shader: 'flat',
                side: 'double',
                transparent: true
              }
            },
            mappings: {
              height: 'geometry.height',
              width: 'geometry.width'
            }
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/a-videosphere.js":
        /*!***********************************************************!*\
          !*** ./src/extras/primitives/primitives/a-videosphere.js ***!
          \***********************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesAVideosphereJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");
          registerPrimitive('a-videosphere', utils.extendDeep({}, getMeshMixin(), {
            defaultComponents: {
              geometry: {
                primitive: 'sphere',
                radius: 500,
                segmentsWidth: 64,
                segmentsHeight: 32
              },
              material: {
                color: '#FFF',
                shader: 'flat',
                side: 'back',
                npot: true
              },
              scale: '-1 1 1'
            },
            mappings: {
              radius: 'geometry.radius',
              'segments-height': 'geometry.segmentsHeight',
              'segments-width': 'geometry.segmentsWidth'
            }
          }));

          /***/
        },

        /***/"./src/extras/primitives/primitives/meshPrimitives.js":
        /*!************************************************************!*\
          !*** ./src/extras/primitives/primitives/meshPrimitives.js ***!
          \************************************************************/
        /***/
        function srcExtrasPrimitivesPrimitivesMeshPrimitivesJs(module, __unused_webpack_exports, __webpack_require__) {
          /**
           * Automated mesh primitive registration.
           */
          var getMeshMixin = __webpack_require__( /*! ../getMeshMixin */"./src/extras/primitives/getMeshMixin.js");
          var geometries = __webpack_require__( /*! ../../../core/geometry */"./src/core/geometry.js").geometries;
          var geometryNames = __webpack_require__( /*! ../../../core/geometry */"./src/core/geometry.js").geometryNames;
          var registerPrimitive = __webpack_require__( /*! ../primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var utils = __webpack_require__( /*! ../../../utils/ */"./src/utils/index.js");

          // For testing.
          var meshPrimitives = module.exports = {};

          // Generate primitive for each geometry type.
          geometryNames.forEach(function registerMeshPrimitive(geometryName) {
            var geometry = geometries[geometryName];
            var geometryHyphened = unCamelCase(geometryName);

            // Generate mappings.
            var mappings = {};
            Object.keys(geometry.schema).forEach(function createMapping(property) {
              mappings[unCamelCase(property)] = 'geometry.' + property;
            });

            // Register.
            var tagName = 'a-' + geometryHyphened;
            var primitive = registerPrimitive(tagName, utils.extendDeep({}, getMeshMixin(), {
              defaultComponents: {
                geometry: {
                  primitive: geometryName
                }
              },
              mappings: mappings
            }));
            meshPrimitives[tagName] = primitive;
          });

          /**
           * camelCase to hyphened-string.
           */
          function unCamelCase(str) {
            return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
          }

          /***/
        },

        /***/"./src/geometries/box.js":
        /*!*******************************!*\
          !*** ./src/geometries/box.js ***!
          \*******************************/
        /***/
        function srcGeometriesBoxJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('box', {
            schema: {
              depth: {
                default: 1,
                min: 0
              },
              height: {
                default: 1,
                min: 0
              },
              width: {
                default: 1,
                min: 0
              },
              segmentsHeight: {
                default: 1,
                min: 1,
                max: 20,
                type: 'int'
              },
              segmentsWidth: {
                default: 1,
                min: 1,
                max: 20,
                type: 'int'
              },
              segmentsDepth: {
                default: 1,
                min: 1,
                max: 20,
                type: 'int'
              }
            },
            init: function init(data) {
              this.geometry = new THREE.BoxGeometry(data.width, data.height, data.depth, data.segmentsWidth, data.segmentsHeight, data.segmentsDepth);
            }
          });

          /***/
        },

        /***/"./src/geometries/circle.js":
        /*!**********************************!*\
          !*** ./src/geometries/circle.js ***!
          \**********************************/
        /***/
        function srcGeometriesCircleJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var degToRad = THREE.MathUtils.degToRad;
          registerGeometry('circle', {
            schema: {
              radius: {
                default: 1,
                min: 0
              },
              segments: {
                default: 32,
                min: 3,
                type: 'int'
              },
              thetaLength: {
                default: 360,
                min: 0
              },
              thetaStart: {
                default: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.CircleGeometry(data.radius, data.segments, degToRad(data.thetaStart), degToRad(data.thetaLength));
            }
          });

          /***/
        },

        /***/"./src/geometries/cone.js":
        /*!********************************!*\
          !*** ./src/geometries/cone.js ***!
          \********************************/
        /***/
        function srcGeometriesConeJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var degToRad = THREE.MathUtils.degToRad;
          registerGeometry('cone', {
            schema: {
              height: {
                default: 1,
                min: 0
              },
              openEnded: {
                default: false
              },
              radiusBottom: {
                default: 1,
                min: 0
              },
              radiusTop: {
                default: 0.01,
                min: 0
              },
              segmentsHeight: {
                default: 18,
                min: 1,
                type: 'int'
              },
              segmentsRadial: {
                default: 36,
                min: 3,
                type: 'int'
              },
              thetaLength: {
                default: 360,
                min: 0
              },
              thetaStart: {
                default: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.segmentsRadial, data.segmentsHeight, data.openEnded, degToRad(data.thetaStart), degToRad(data.thetaLength));
            }
          });

          /***/
        },

        /***/"./src/geometries/cylinder.js":
        /*!************************************!*\
          !*** ./src/geometries/cylinder.js ***!
          \************************************/
        /***/
        function srcGeometriesCylinderJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var degToRad = THREE.MathUtils.degToRad;
          registerGeometry('cylinder', {
            schema: {
              height: {
                default: 1,
                min: 0
              },
              openEnded: {
                default: false
              },
              radius: {
                default: 1,
                min: 0
              },
              segmentsHeight: {
                default: 18,
                min: 1,
                type: 'int'
              },
              segmentsRadial: {
                default: 36,
                min: 3,
                type: 'int'
              },
              thetaLength: {
                default: 360,
                min: 0
              },
              thetaStart: {
                default: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.CylinderGeometry(data.radius, data.radius, data.height, data.segmentsRadial, data.segmentsHeight, data.openEnded, degToRad(data.thetaStart), degToRad(data.thetaLength));
            }
          });

          /***/
        },

        /***/"./src/geometries/dodecahedron.js":
        /*!****************************************!*\
          !*** ./src/geometries/dodecahedron.js ***!
          \****************************************/
        /***/
        function srcGeometriesDodecahedronJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('dodecahedron', {
            schema: {
              detail: {
                default: 0,
                min: 0,
                max: 5,
                type: 'int'
              },
              radius: {
                default: 1,
                min: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.DodecahedronGeometry(data.radius, data.detail);
            }
          });

          /***/
        },

        /***/"./src/geometries/icosahedron.js":
        /*!***************************************!*\
          !*** ./src/geometries/icosahedron.js ***!
          \***************************************/
        /***/
        function srcGeometriesIcosahedronJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('icosahedron', {
            schema: {
              detail: {
                default: 0,
                min: 0,
                max: 5,
                type: 'int'
              },
              radius: {
                default: 1,
                min: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.IcosahedronGeometry(data.radius, data.detail);
            }
          });

          /***/
        },

        /***/"./src/geometries/index.js":
        /*!*********************************!*\
          !*** ./src/geometries/index.js ***!
          \*********************************/
        /***/
        function srcGeometriesIndexJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          __webpack_require__( /*! ./box.js */"./src/geometries/box.js");
          __webpack_require__( /*! ./circle.js */"./src/geometries/circle.js");
          __webpack_require__( /*! ./cone.js */"./src/geometries/cone.js");
          __webpack_require__( /*! ./cylinder.js */"./src/geometries/cylinder.js");
          __webpack_require__( /*! ./dodecahedron.js */"./src/geometries/dodecahedron.js");
          __webpack_require__( /*! ./icosahedron.js */"./src/geometries/icosahedron.js");
          __webpack_require__( /*! ./octahedron.js */"./src/geometries/octahedron.js");
          __webpack_require__( /*! ./plane.js */"./src/geometries/plane.js");
          __webpack_require__( /*! ./ring.js */"./src/geometries/ring.js");
          __webpack_require__( /*! ./sphere.js */"./src/geometries/sphere.js");
          __webpack_require__( /*! ./tetrahedron.js */"./src/geometries/tetrahedron.js");
          __webpack_require__( /*! ./torus.js */"./src/geometries/torus.js");
          __webpack_require__( /*! ./torusKnot.js */"./src/geometries/torusKnot.js");
          __webpack_require__( /*! ./triangle.js */"./src/geometries/triangle.js");

          /***/
        },

        /***/"./src/geometries/octahedron.js":
        /*!**************************************!*\
          !*** ./src/geometries/octahedron.js ***!
          \**************************************/
        /***/
        function srcGeometriesOctahedronJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('octahedron', {
            schema: {
              detail: {
                default: 0,
                min: 0,
                max: 5,
                type: 'int'
              },
              radius: {
                default: 1,
                min: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.OctahedronGeometry(data.radius, data.detail);
            }
          });

          /***/
        },

        /***/"./src/geometries/plane.js":
        /*!*********************************!*\
          !*** ./src/geometries/plane.js ***!
          \*********************************/
        /***/
        function srcGeometriesPlaneJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('plane', {
            schema: {
              height: {
                default: 1,
                min: 0
              },
              width: {
                default: 1,
                min: 0
              },
              segmentsHeight: {
                default: 1,
                min: 1,
                max: 20,
                type: 'int'
              },
              segmentsWidth: {
                default: 1,
                min: 1,
                max: 20,
                type: 'int'
              }
            },
            init: function init(data) {
              this.geometry = new THREE.PlaneGeometry(data.width, data.height, data.segmentsWidth, data.segmentsHeight);
            }
          });

          /***/
        },

        /***/"./src/geometries/ring.js":
        /*!********************************!*\
          !*** ./src/geometries/ring.js ***!
          \********************************/
        /***/
        function srcGeometriesRingJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var degToRad = THREE.MathUtils.degToRad;
          registerGeometry('ring', {
            schema: {
              radiusInner: {
                default: 0.8,
                min: 0
              },
              radiusOuter: {
                default: 1.2,
                min: 0
              },
              segmentsPhi: {
                default: 10,
                min: 1,
                type: 'int'
              },
              segmentsTheta: {
                default: 32,
                min: 3,
                type: 'int'
              },
              thetaLength: {
                default: 360,
                min: 0
              },
              thetaStart: {
                default: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.RingGeometry(data.radiusInner, data.radiusOuter, data.segmentsTheta, data.segmentsPhi, degToRad(data.thetaStart), degToRad(data.thetaLength));
            }
          });

          /***/
        },

        /***/"./src/geometries/sphere.js":
        /*!**********************************!*\
          !*** ./src/geometries/sphere.js ***!
          \**********************************/
        /***/
        function srcGeometriesSphereJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var degToRad = THREE.MathUtils.degToRad;
          registerGeometry('sphere', {
            schema: {
              radius: {
                default: 1,
                min: 0
              },
              phiLength: {
                default: 360
              },
              phiStart: {
                default: 0,
                min: 0
              },
              thetaLength: {
                default: 180,
                min: 0
              },
              thetaStart: {
                default: 0
              },
              segmentsHeight: {
                default: 18,
                min: 2,
                type: 'int'
              },
              segmentsWidth: {
                default: 36,
                min: 3,
                type: 'int'
              }
            },
            init: function init(data) {
              this.geometry = new THREE.SphereGeometry(data.radius, data.segmentsWidth, data.segmentsHeight, degToRad(data.phiStart), degToRad(data.phiLength), degToRad(data.thetaStart), degToRad(data.thetaLength));
            }
          });

          /***/
        },

        /***/"./src/geometries/tetrahedron.js":
        /*!***************************************!*\
          !*** ./src/geometries/tetrahedron.js ***!
          \***************************************/
        /***/
        function srcGeometriesTetrahedronJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('tetrahedron', {
            schema: {
              detail: {
                default: 0,
                min: 0,
                max: 5,
                type: 'int'
              },
              radius: {
                default: 1,
                min: 0
              }
            },
            init: function init(data) {
              this.geometry = new THREE.TetrahedronGeometry(data.radius, data.detail);
            }
          });

          /***/
        },

        /***/"./src/geometries/torus.js":
        /*!*********************************!*\
          !*** ./src/geometries/torus.js ***!
          \*********************************/
        /***/
        function srcGeometriesTorusJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var degToRad = THREE.MathUtils.degToRad;
          registerGeometry('torus', {
            schema: {
              arc: {
                default: 360
              },
              radius: {
                default: 1,
                min: 0
              },
              radiusTubular: {
                default: 0.2,
                min: 0
              },
              segmentsRadial: {
                default: 36,
                min: 2,
                type: 'int'
              },
              segmentsTubular: {
                default: 32,
                min: 3,
                type: 'int'
              }
            },
            init: function init(data) {
              this.geometry = new THREE.TorusGeometry(data.radius, data.radiusTubular * 2, data.segmentsRadial, data.segmentsTubular, degToRad(data.arc));
            }
          });

          /***/
        },

        /***/"./src/geometries/torusKnot.js":
        /*!*************************************!*\
          !*** ./src/geometries/torusKnot.js ***!
          \*************************************/
        /***/
        function srcGeometriesTorusKnotJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          registerGeometry('torusKnot', {
            schema: {
              p: {
                default: 2,
                min: 1
              },
              q: {
                default: 3,
                min: 1
              },
              radius: {
                default: 1,
                min: 0
              },
              radiusTubular: {
                default: 0.2,
                min: 0
              },
              segmentsRadial: {
                default: 8,
                min: 3,
                type: 'int'
              },
              segmentsTubular: {
                default: 100,
                min: 3,
                type: 'int'
              }
            },
            init: function init(data) {
              this.geometry = new THREE.TorusKnotGeometry(data.radius, data.radiusTubular * 2, data.segmentsTubular, data.segmentsRadial, data.p, data.q);
            }
          });

          /***/
        },

        /***/"./src/geometries/triangle.js":
        /*!************************************!*\
          !*** ./src/geometries/triangle.js ***!
          \************************************/
        /***/
        function srcGeometriesTriangleJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          var registerGeometry = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").registerGeometry;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var quaternion = new THREE.Quaternion();
          var rotateVector = new THREE.Vector3(0, 0, 1);
          var uvMinVector = new THREE.Vector2();
          var uvMaxVector = new THREE.Vector2();
          var uvScaleVector = new THREE.Vector2();
          registerGeometry('triangle', {
            schema: {
              vertexA: {
                type: 'vec3',
                default: {
                  x: 0,
                  y: 0.5,
                  z: 0
                }
              },
              vertexB: {
                type: 'vec3',
                default: {
                  x: -0.5,
                  y: -0.5,
                  z: 0
                }
              },
              vertexC: {
                type: 'vec3',
                default: {
                  x: 0.5,
                  y: -0.5,
                  z: 0
                }
              }
            },
            init: function init(data) {
              var geometry;
              var normal;
              var triangle;
              var uvA;
              var uvB;
              var uvC;
              var vertices;
              var normals;
              var uvs;
              triangle = new THREE.Triangle();
              triangle.a.set(data.vertexA.x, data.vertexA.y, data.vertexA.z);
              triangle.b.set(data.vertexB.x, data.vertexB.y, data.vertexB.z);
              triangle.c.set(data.vertexC.x, data.vertexC.y, data.vertexC.z);
              normal = triangle.getNormal(new THREE.Vector3());

              // Rotate the 3D triangle to be parallel to XY plane.
              quaternion.setFromUnitVectors(normal, rotateVector);
              uvA = triangle.a.clone().applyQuaternion(quaternion);
              uvB = triangle.b.clone().applyQuaternion(quaternion);
              uvC = triangle.c.clone().applyQuaternion(quaternion);

              // Compute UVs.
              // Normalize x/y values of UV so they are within 0 to 1.
              uvMinVector.set(Math.min(uvA.x, uvB.x, uvC.x), Math.min(uvA.y, uvB.y, uvC.y));
              uvMaxVector.set(Math.max(uvA.x, uvB.x, uvC.x), Math.max(uvA.y, uvB.y, uvC.y));
              uvScaleVector.set(0, 0).subVectors(uvMaxVector, uvMinVector);
              uvA = new THREE.Vector2().subVectors(uvA, uvMinVector).divide(uvScaleVector);
              uvB = new THREE.Vector2().subVectors(uvB, uvMinVector).divide(uvScaleVector);
              uvC = new THREE.Vector2().subVectors(uvC, uvMinVector).divide(uvScaleVector);
              geometry = this.geometry = new THREE.BufferGeometry();
              vertices = [triangle.a.x, triangle.a.y, triangle.a.z, triangle.b.x, triangle.b.y, triangle.b.z, triangle.c.x, triangle.c.y, triangle.c.z];
              normals = [normal.x, normal.y, normal.z, normal.x, normal.y, normal.z, normal.x, normal.y, normal.z];
              uvs = [uvA.x, uvA.y, uvB.x, uvB.y, uvC.x, uvC.y];
              geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
              geometry.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
              geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
            }
          });

          /***/
        },

        /***/"./src/index.js":
        /*!**********************!*\
          !*** ./src/index.js ***!
          \**********************/
        /***/
        function srcIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          // Polyfill `Promise`.
          window.Promise = window.Promise || __webpack_require__( /*! promise-polyfill */"./node_modules/promise-polyfill/Promise.js");
          __webpack_require__( /*! @ungap/custom-elements */"./node_modules/@ungap/custom-elements/index.js");

          // WebVR polyfill
          // Check before the polyfill runs.
          window.hasNativeWebVRImplementation = !!window.navigator.getVRDisplays || !!window.navigator.getVRDevices;
          window.hasNativeWebXRImplementation = navigator.xr !== undefined;

          // If native WebXR or WebVR are defined WebVRPolyfill does not initialize.
          if (!window.hasNativeWebXRImplementation && !window.hasNativeWebVRImplementation) {
            var isIOSOlderThan10 = __webpack_require__( /*! ./utils/isIOSOlderThan10 */"./src/utils/isIOSOlderThan10.js");
            // Workaround for iOS Safari canvas sizing issues in stereo (webvr-polyfill/issues/102).
            // Only for iOS on versions older than 10.
            var bufferScale = isIOSOlderThan10(window.navigator.userAgent) ? 1 / window.devicePixelRatio : 1;
            var WebVRPolyfill = __webpack_require__( /*! webvr-polyfill */"./node_modules/webvr-polyfill/build/webvr-polyfill.js");
            var polyfillConfig = {
              BUFFER_SCALE: bufferScale,
              CARDBOARD_UI_DISABLED: true,
              ROTATE_INSTRUCTIONS_DISABLED: true,
              MOBILE_WAKE_LOCK: !!window.cordova
            };
            window.webvrpolyfill = new WebVRPolyfill(polyfillConfig);
          }
          var utils = __webpack_require__( /*! ./utils/ */"./src/utils/index.js");
          var debug = utils.debug;
          if (utils.isIE11) {
            // Polyfill `CustomEvent`.
            __webpack_require__( /*! custom-event-polyfill */"./node_modules/custom-event-polyfill/polyfill.js");
            // Polyfill String.startsWith.
            __webpack_require__( /*! ../vendor/starts-with-polyfill */"./vendor/starts-with-polyfill.js");
          }
          var error = debug('A-Frame:error');
          var warn = debug('A-Frame:warn');
          if (window.document.currentScript && window.document.currentScript.parentNode !== window.document.head && !window.debug) {
            warn('Put the A-Frame <script> tag in the <head> of the HTML *before* the scene to ' + 'ensure everything for A-Frame is properly registered before they are used from ' + 'HTML.');
          }

          // Error if not using a server.
          if (!window.cordova && window.location.protocol === 'file:') {
            error('This HTML file is currently being served via the file:// protocol. ' + 'Assets, textures, and models WILL NOT WORK due to cross-origin policy! ' + 'Please use a local or hosted server: ' + 'https://aframe.io/docs/0.5.0/introduction/getting-started.html#using-a-local-server.');
          }
          __webpack_require__( /*! present */"./node_modules/present/lib/present-browser.js"); // Polyfill `performance.now()`.

          // CSS.
          if (utils.device.isBrowserEnvironment) {
            __webpack_require__( /*! ./style/aframe.css */"./src/style/aframe.css");
            __webpack_require__( /*! ./style/rStats.css */"./src/style/rStats.css");
          }

          // Required before `AEntity` so that all components are registered.
          var AScene = __webpack_require__( /*! ./core/scene/a-scene */"./src/core/scene/a-scene.js").AScene;
          var components = __webpack_require__( /*! ./core/component */"./src/core/component.js").components;
          var registerComponent = __webpack_require__( /*! ./core/component */"./src/core/component.js").registerComponent;
          var registerGeometry = __webpack_require__( /*! ./core/geometry */"./src/core/geometry.js").registerGeometry;
          var registerPrimitive = __webpack_require__( /*! ./extras/primitives/primitives */"./src/extras/primitives/primitives.js").registerPrimitive;
          var registerShader = __webpack_require__( /*! ./core/shader */"./src/core/shader.js").registerShader;
          var registerSystem = __webpack_require__( /*! ./core/system */"./src/core/system.js").registerSystem;
          var shaders = __webpack_require__( /*! ./core/shader */"./src/core/shader.js").shaders;
          var systems = __webpack_require__( /*! ./core/system */"./src/core/system.js").systems;
          // Exports THREE to window so three.js can be used without alteration.
          var THREE = window.THREE = __webpack_require__( /*! ./lib/three */"./src/lib/three.js");
          var pkg = __webpack_require__( /*! ../package */"./package.json");
          __webpack_require__( /*! ./components/index */"./src/components/index.js"); // Register standard components.
          __webpack_require__( /*! ./geometries/index */"./src/geometries/index.js"); // Register standard geometries.
          __webpack_require__( /*! ./shaders/index */"./src/shaders/index.js"); // Register standard shaders.
          __webpack_require__( /*! ./systems/index */"./src/systems/index.js"); // Register standard systems.
          var ANode = __webpack_require__( /*! ./core/a-node */"./src/core/a-node.js").ANode;
          var AEntity = __webpack_require__( /*! ./core/a-entity */"./src/core/a-entity.js").AEntity; // Depends on ANode and core components.

          __webpack_require__( /*! ./core/a-assets */"./src/core/a-assets.js");
          __webpack_require__( /*! ./core/a-cubemap */"./src/core/a-cubemap.js");
          __webpack_require__( /*! ./core/a-mixin */"./src/core/a-mixin.js");

          // Extras.
          __webpack_require__( /*! ./extras/components/ */"./src/extras/components/index.js");
          __webpack_require__( /*! ./extras/primitives/ */"./src/extras/primitives/index.js");
          console.log('A-Frame Version: 1.4.1 (Date 2023-01-04, Commit #5183a179)');
          console.log('THREE Version (https://github.com/supermedium/three.js):', pkg.dependencies['super-three']);
          console.log('WebVR Polyfill Version:', pkg.dependencies['webvr-polyfill']);
          module.exports = window.AFRAME = {
            AComponent: __webpack_require__( /*! ./core/component */"./src/core/component.js").Component,
            AEntity: AEntity,
            ANode: ANode,
            ANIME: __webpack_require__( /*! super-animejs */"./node_modules/super-animejs/lib/anime.es.js")["default"],
            AScene: AScene,
            components: components,
            coreComponents: Object.keys(components),
            geometries: __webpack_require__( /*! ./core/geometry */"./src/core/geometry.js").geometries,
            registerComponent: registerComponent,
            registerGeometry: registerGeometry,
            registerPrimitive: registerPrimitive,
            registerShader: registerShader,
            registerSystem: registerSystem,
            primitives: {
              getMeshMixin: __webpack_require__( /*! ./extras/primitives/getMeshMixin */"./src/extras/primitives/getMeshMixin.js"),
              primitives: __webpack_require__( /*! ./extras/primitives/primitives */"./src/extras/primitives/primitives.js").primitives
            },
            scenes: __webpack_require__( /*! ./core/scene/scenes */"./src/core/scene/scenes.js"),
            schema: __webpack_require__( /*! ./core/schema */"./src/core/schema.js"),
            shaders: shaders,
            systems: systems,
            THREE: THREE,
            utils: utils,
            version: pkg.version
          };

          /***/
        },

        /***/"./src/lib/rStatsAframe.js":
        /*!*********************************!*\
          !*** ./src/lib/rStatsAframe.js ***!
          \*********************************/
        /***/
        function srcLibRStatsAframeJs(module) {
          window.aframeStats = function (scene) {
            var _rS = null;
            var _scene = scene;
            var _values = {
              te: {
                caption: 'Entities'
              },
              lt: {
                caption: 'Load Time'
              }
            };
            var _groups = [{
              caption: 'A-Frame',
              values: ['te', 'lt']
            }];
            function _update() {
              _rS('te').set(getEntityCount());
              if (window.performance.getEntriesByName) {
                _rS('lt').set(window.performance.getEntriesByName('render-started')[0].startTime.toFixed(0));
              }
            }
            function getEntityCount() {
              var elements = _scene.querySelectorAll('*');
              Array.prototype.slice.call(elements).filter(function (el) {
                return el.isEntity;
              });
              return elements.length;
            }
            function _start() {}
            function _end() {}
            function _attach(r) {
              _rS = r;
            }
            return {
              update: _update,
              start: _start,
              end: _end,
              attach: _attach,
              values: _values,
              groups: _groups,
              fractions: []
            };
          };
          if (true) {
            module.exports = {
              aframeStats: window.aframeStats
            };
          }

          /***/
        },

        /***/"./src/lib/three.js":
        /*!**************************!*\
          !*** ./src/lib/three.js ***!
          \**************************/
        /***/
        function srcLibThreeJs(module, __unused_webpack_exports, __webpack_require__) {
          var THREE = __webpack_require__( /*! ./three.module.js */"./src/lib/three.module.js")["default"];

          // Allow cross-origin images to be loaded.

          // This should not be on `THREE.Loader` nor `THREE.ImageUtils`.
          // Must be on `THREE.TextureLoader`.
          if (THREE.TextureLoader) {
            THREE.TextureLoader.prototype.crossOrigin = 'anonymous';
          }

          // This is for images loaded from the model loaders.
          if (THREE.ImageLoader) {
            THREE.ImageLoader.prototype.crossOrigin = 'anonymous';
          }

          // In-memory caching for XHRs (for images, audio files, textures, etc.).
          if (THREE.Cache) {
            THREE.Cache.enabled = true;
          }
          THREE.DRACOLoader.prototype.crossOrigin = 'anonymous';
          THREE.GLTFLoader.prototype.crossOrigin = 'anonymous';
          THREE.KTX2Loader.prototype.crossOrigin = 'anonymous';
          THREE.MTLLoader.prototype.crossOrigin = 'anonymous';
          THREE.OBJLoader.prototype.crossOrigin = 'anonymous';
          module.exports = THREE;

          /***/
        },

        /***/"./src/lib/three.module.js":
        /*!*********************************!*\
          !*** ./src/lib/three.module.js ***!
          \*********************************/
        /***/
        function srcLibThreeModuleJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"default": function _default() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */
          });
          /* harmony import */
          var super_three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! super-three */"./node_modules/super-three/build/three.module.js");
          /* harmony import */
          var super_three_examples_jsm_loaders_DRACOLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! super-three/examples/jsm/loaders/DRACOLoader */"./node_modules/super-three/examples/jsm/loaders/DRACOLoader.js");
          /* harmony import */
          var super_three_examples_jsm_loaders_GLTFLoader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! super-three/examples/jsm/loaders/GLTFLoader */"./node_modules/super-three/examples/jsm/loaders/GLTFLoader.js");
          /* harmony import */
          var super_three_examples_jsm_loaders_KTX2Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! super-three/examples/jsm/loaders/KTX2Loader */"./node_modules/super-three/examples/jsm/loaders/KTX2Loader.js");
          /* harmony import */
          var super_three_examples_jsm_loaders_OBJLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! super-three/examples/jsm/loaders/OBJLoader */"./node_modules/super-three/examples/jsm/loaders/OBJLoader.js");
          /* harmony import */
          var super_three_examples_jsm_loaders_MTLLoader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! super-three/examples/jsm/loaders/MTLLoader */"./node_modules/super-three/examples/jsm/loaders/MTLLoader.js");
          /* harmony import */
          var super_three_examples_jsm_utils_BufferGeometryUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! super-three/examples/jsm/utils/BufferGeometryUtils */"./node_modules/super-three/examples/jsm/utils/BufferGeometryUtils.js");
          /* harmony import */
          var super_three_examples_jsm_lights_LightProbeGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! super-three/examples/jsm/lights/LightProbeGenerator */"./node_modules/super-three/examples/jsm/lights/LightProbeGenerator.js");
          var objectAssign = __webpack_require__( /*! object-assign */"./node_modules/object-assign/index.js");
          var THREE = window.THREE = objectAssign({}, super_three__WEBPACK_IMPORTED_MODULE_0__);

          // TODO: Eventually include these only if they are needed by a component.
          __webpack_require__( /*! ../../vendor/DeviceOrientationControls */"./vendor/DeviceOrientationControls.js"); // THREE.DeviceOrientationControls
          THREE.DRACOLoader = super_three_examples_jsm_loaders_DRACOLoader__WEBPACK_IMPORTED_MODULE_1__.DRACOLoader;
          THREE.GLTFLoader = super_three_examples_jsm_loaders_GLTFLoader__WEBPACK_IMPORTED_MODULE_2__.GLTFLoader;
          THREE.KTX2Loader = super_three_examples_jsm_loaders_KTX2Loader__WEBPACK_IMPORTED_MODULE_3__.KTX2Loader;
          THREE.OBJLoader = super_three_examples_jsm_loaders_OBJLoader__WEBPACK_IMPORTED_MODULE_4__.OBJLoader;
          THREE.MTLLoader = super_three_examples_jsm_loaders_MTLLoader__WEBPACK_IMPORTED_MODULE_5__.MTLLoader;
          THREE.BufferGeometryUtils = super_three_examples_jsm_utils_BufferGeometryUtils__WEBPACK_IMPORTED_MODULE_6__;
          THREE.LightProbeGenerator = super_three_examples_jsm_lights_LightProbeGenerator__WEBPACK_IMPORTED_MODULE_7__.LightProbeGenerator;
          /* harmony default export */
          var __WEBPACK_DEFAULT_EXPORT__ = THREE;

          /***/
        },

        /***/"./src/shaders/flat.js":
        /*!*****************************!*\
          !*** ./src/shaders/flat.js ***!
          \*****************************/
        /***/
        function srcShadersFlatJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");

          /**
           * Flat shader using THREE.MeshBasicMaterial.
           */
          module.exports.Shader = registerShader('flat', {
            schema: {
              color: {
                type: 'color'
              },
              fog: {
                default: true
              },
              height: {
                default: 256
              },
              offset: {
                type: 'vec2',
                default: {
                  x: 0,
                  y: 0
                }
              },
              repeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              src: {
                type: 'map'
              },
              width: {
                default: 512
              },
              wireframe: {
                default: false
              },
              wireframeLinewidth: {
                default: 2
              },
              toneMapped: {
                default: true
              }
            },
            /**
             * Initializes the shader.
             * Adds a reference from the scene to this entity as the camera.
             */
            init: function init(data) {
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.materialData = {
                color: new THREE.Color()
              };
              this.textureSrc = null;
              getMaterialData(data, this.materialData);
              this.rendererSystem.applyColorCorrection(this.materialData.color);
              this.material = new THREE.MeshBasicMaterial(this.materialData);
            },
            update: function update(data) {
              this.updateMaterial(data);
              utils.material.updateMap(this, data);
            },
            /**
             * Updating existing material.
             *
             * @param {object} data - Material component data.
             */
            updateMaterial: function updateMaterial(data) {
              var key;
              getMaterialData(data, this.materialData);
              this.rendererSystem.applyColorCorrection(this.materialData.color);
              for (key in this.materialData) {
                this.material[key] = this.materialData[key];
              }
            }
          });

          /**
           * Builds and normalize material data, normalizing stuff along the way.
           *
           * @param {object} data - Material data.
           * @param {object} materialData - Object to reuse.
           * @returns {object} Updated material data.
           */
          function getMaterialData(data, materialData) {
            materialData.color.set(data.color);
            materialData.fog = data.fog;
            materialData.wireframe = data.wireframe;
            materialData.toneMapped = data.toneMapped;
            materialData.wireframeLinewidth = data.wireframeLinewidth;
            return materialData;
          }

          /***/
        },

        /***/"./src/shaders/index.js":
        /*!******************************!*\
          !*** ./src/shaders/index.js ***!
          \******************************/
        /***/
        function srcShadersIndexJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          __webpack_require__( /*! ./flat */"./src/shaders/flat.js");
          __webpack_require__( /*! ./standard */"./src/shaders/standard.js");
          __webpack_require__( /*! ./phong */"./src/shaders/phong.js");
          __webpack_require__( /*! ./sdf */"./src/shaders/sdf.js");
          __webpack_require__( /*! ./msdf */"./src/shaders/msdf.js");
          __webpack_require__( /*! ./ios10hls */"./src/shaders/ios10hls.js");
          __webpack_require__( /*! ./shadow */"./src/shaders/shadow.js");

          /***/
        },

        /***/"./src/shaders/ios10hls.js":
        /*!*********************************!*\
          !*** ./src/shaders/ios10hls.js ***!
          \*********************************/
        /***/
        function srcShadersIos10hlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;

          /**
           * Custom shader for iOS 10 HTTP Live Streaming (HLS).
           * For more information on HLS, see https://datatracker.ietf.org/doc/draft-pantos-http-live-streaming/
           */
          module.exports.Shader = registerShader('ios10hls', {
            schema: {
              src: {
                type: 'map',
                is: 'uniform'
              },
              opacity: {
                type: 'number',
                is: 'uniform',
                default: 1
              }
            },
            vertexShader: ['varying vec2 vUV;', 'void main(void) {', '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '  vUV = uv;', '}'].join('\n'),
            fragmentShader: ['uniform sampler2D src;', 'uniform float opacity;', 'varying vec2 vUV;', 'void main() {', '  vec2 offset = vec2(0, 0);', '  vec2 repeat = vec2(1, 1);', '  vec4 color = texture2D(src, vec2(vUV.x / repeat.x + offset.x, (1.0 - vUV.y) / repeat.y + offset.y)).bgra;', '  gl_FragColor = vec4(color.rgb, opacity);', '}'].join('\n')
          });

          /***/
        },

        /***/"./src/shaders/msdf.js":
        /*!*****************************!*\
          !*** ./src/shaders/msdf.js ***!
          \*****************************/
        /***/
        function srcShadersMsdfJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var isWebGL2AVailable = !!document.createElement('canvas').getContext('webgl2');
          var VERTEX_SHADER_WEBGL1 = ['attribute vec2 uv;', 'attribute vec3 position;', 'uniform mat4 projectionMatrix;', 'uniform mat4 modelViewMatrix;', 'varying vec2 vUV;', 'void main(void) {', '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '  vUV = uv;', '}'].join('\n');
          var VERTEX_SHADER_WEBGL2 = ['#version 300 es', 'in vec2 uv;', 'in vec3 position;', 'uniform mat4 projectionMatrix;', 'uniform mat4 modelViewMatrix;', 'out vec2 vUV;', 'void main(void) {', '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '  vUV = uv;', '}'].join('\n');
          var VERTEX_SHADER = isWebGL2AVailable ? VERTEX_SHADER_WEBGL2 : VERTEX_SHADER_WEBGL1;
          var FRAGMENT_SHADER_WEBGL1 = ['#ifdef GL_OES_standard_derivatives', '#extension GL_OES_standard_derivatives: enable', '#endif', 'precision highp float;', 'uniform bool negate;', 'uniform float alphaTest;', 'uniform float opacity;', 'uniform sampler2D map;', 'uniform vec3 color;', 'varying vec2 vUV;', 'float median(float r, float g, float b) {', '  return max(min(r, g), min(max(r, g), b));', '}',
          // FIXME: Experimentally determined constants.
          '#define BIG_ENOUGH 0.001', '#define MODIFIED_ALPHATEST (0.02 * isBigEnough / BIG_ENOUGH)', 'void main() {', '  vec3 sampleColor = texture2D(map, vUV).rgb;', '  if (negate) { sampleColor = 1.0 - sampleColor; }', '  float sigDist = median(sampleColor.r, sampleColor.g, sampleColor.b) - 0.5;', '  float alpha = clamp(sigDist / fwidth(sigDist) + 0.5, 0.0, 1.0);', '  float dscale = 0.353505;', '  vec2 duv = dscale * (dFdx(vUV) + dFdy(vUV));', '  float isBigEnough = max(abs(duv.x), abs(duv.y));',
          // When texel is too small, blend raw alpha value rather than supersampling.
          // FIXME: Experimentally determined constant.
          '  // Do modified alpha test.', '  if (isBigEnough > BIG_ENOUGH) {', '    float ratio = BIG_ENOUGH / isBigEnough;', '    alpha = ratio * alpha + (1.0 - ratio) * (sigDist + 0.5);', '  }', '  // Do modified alpha test.', '  if (alpha < alphaTest * MODIFIED_ALPHATEST) { discard; return; }', '  gl_FragColor = vec4(color.xyz, alpha * opacity);', '}'].join('\n');
          var FRAGMENT_SHADER_WEBGL2 = ['#version 300 es', 'precision highp float;', 'uniform bool negate;', 'uniform float alphaTest;', 'uniform float opacity;', 'uniform sampler2D map;', 'uniform vec3 color;', 'in vec2 vUV;', 'out vec4 fragColor;', 'float median(float r, float g, float b) {', '  return max(min(r, g), min(max(r, g), b));', '}',
          // FIXME: Experimentally determined constants.
          '#define BIG_ENOUGH 0.001', '#define MODIFIED_ALPHATEST (0.02 * isBigEnough / BIG_ENOUGH)', 'void main() {', '  vec3 sampleColor = texture(map, vUV).rgb;', '  if (negate) { sampleColor = 1.0 - sampleColor; }', '  float sigDist = median(sampleColor.r, sampleColor.g, sampleColor.b) - 0.5;', '  float alpha = clamp(sigDist / fwidth(sigDist) + 0.5, 0.0, 1.0);', '  float dscale = 0.353505;', '  vec2 duv = dscale * (dFdx(vUV) + dFdy(vUV));', '  float isBigEnough = max(abs(duv.x), abs(duv.y));',
          // When texel is too small, blend raw alpha value rather than supersampling.
          // FIXME: Experimentally determined constant.
          '  // Do modified alpha test.', '  if (isBigEnough > BIG_ENOUGH) {', '    float ratio = BIG_ENOUGH / isBigEnough;', '    alpha = ratio * alpha + (1.0 - ratio) * (sigDist + 0.5);', '  }', '  // Do modified alpha test.', '  if (alpha < alphaTest * MODIFIED_ALPHATEST) { discard; return; }', '  fragColor = vec4(color.xyz, alpha * opacity);', '}'].join('\n');
          var FRAGMENT_SHADER = isWebGL2AVailable ? FRAGMENT_SHADER_WEBGL2 : FRAGMENT_SHADER_WEBGL1;

          /**
           * Multi-channel signed distance field.
           * Used by text component.
           */
          module.exports.Shader = registerShader('msdf', {
            schema: {
              alphaTest: {
                type: 'number',
                is: 'uniform',
                default: 0.5
              },
              color: {
                type: 'color',
                is: 'uniform',
                default: 'white'
              },
              map: {
                type: 'map',
                is: 'uniform'
              },
              negate: {
                type: 'boolean',
                is: 'uniform',
                default: true
              },
              opacity: {
                type: 'number',
                is: 'uniform',
                default: 1.0
              }
            },
            raw: true,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER
          });

          /***/
        },

        /***/"./src/shaders/phong.js":
        /*!******************************!*\
          !*** ./src/shaders/phong.js ***!
          \******************************/
        /***/
        function srcShadersPhongJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var CubeLoader = new THREE.CubeTextureLoader();
          var texturePromises = {};

          /**
           * Phong shader using THREE.MeshPhongMaterial.
           */
          module.exports.Shader = registerShader('phong', {
            schema: {
              color: {
                type: 'color'
              },
              emissive: {
                type: 'color',
                default: 'black'
              },
              emissiveIntensity: {
                default: 1
              },
              specular: {
                type: 'color',
                default: '#111111'
              },
              transparent: {
                default: false
              },
              fog: {
                default: true
              },
              offset: {
                type: 'vec2',
                default: {
                  x: 0,
                  y: 0
                }
              },
              repeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              src: {
                type: 'map'
              },
              envMap: {
                default: ''
              },
              sphericalEnvMap: {
                type: 'map'
              },
              shininess: {
                default: 30
              },
              flatShading: {
                default: false
              },
              wireframe: {
                default: false
              },
              wireframeLinewidth: {
                default: 2
              },
              combine: {
                oneOF: ['multiply', 'mix', 'add'],
                default: 'mix'
              },
              reflectivity: {
                default: 0.9
              },
              refractionRatio: {
                default: 0.98
              },
              refract: {
                default: false
              },
              normalMap: {
                type: 'map'
              },
              normalScale: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              normalTextureOffset: {
                type: 'vec2'
              },
              normalTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              displacementMap: {
                type: 'map'
              },
              displacementScale: {
                default: 1
              },
              displacementBias: {
                default: 0.5
              },
              displacementTextureOffset: {
                type: 'vec2'
              },
              displacementTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              bumpMap: {
                type: 'map'
              },
              bumpMapScale: {
                default: 1
              },
              bumpTextureOffset: {
                type: 'vec2'
              },
              bumpTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              }
            },
            /**
             * Initializes the shader.
             * Adds a reference from the scene to this entity as the camera.
             */
            init: function init(data) {
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.materialData = {
                color: new THREE.Color(),
                specular: new THREE.Color(),
                emissive: new THREE.Color()
              };
              this.textureSrc = null;
              getMaterialData(data, this.materialData);
              this.rendererSystem.applyColorCorrection(this.materialData.color);
              this.material = new THREE.MeshPhongMaterial(this.materialData);
              utils.material.updateMap(this, data);
            },
            update: function update(data) {
              this.updateMaterial(data);
              utils.material.updateMap(this, data);
              if (data.normalMap) {
                utils.material.updateDistortionMap('normal', this, data);
              }
              if (data.displacementMap) {
                utils.material.updateDistortionMap('displacement', this, data);
              }
              if (data.ambientOcclusionMap) {
                utils.material.updateDistortionMap('ambientOcclusion', this, data);
              }
              if (data.bump) {
                utils.material.updateDistortionMap('bump', this, data);
              }
              this.updateEnvMap(data);
            },
            /**
             * Updating existing material.
             *
             * @param {object} data - Material component data.
             */
            updateMaterial: function updateMaterial(data) {
              var key;
              getMaterialData(data, this.materialData);
              this.rendererSystem.applyColorCorrection(this.materialData.color);
              for (key in this.materialData) {
                this.material[key] = this.materialData[key];
              }
            },
            /**
             * Handle environment cubemap. Textures are cached in texturePromises.
             */
            updateEnvMap: function updateEnvMap(data) {
              var self = this;
              var material = this.material;
              var envMap = data.envMap;
              var sphericalEnvMap = data.sphericalEnvMap;
              var refract = data.refract;
              var sceneEl = this.el.sceneEl;

              // No envMap defined or already loading.
              if (!envMap && !sphericalEnvMap || this.isLoadingEnvMap) {
                Object.defineProperty(material, 'envMap', {
                  get: function get() {
                    return sceneEl.object3D.environment;
                  },
                  set: function set(value) {
                    delete this.envMap;
                    this.envMap = value;
                  }
                });
                material.needsUpdate = true;
                return;
              }
              this.isLoadingEnvMap = true;
              delete material.envMap;

              // if a spherical env map is defined then use it.
              if (sphericalEnvMap) {
                this.el.sceneEl.systems.material.loadTexture(sphericalEnvMap, {
                  src: sphericalEnvMap
                }, function textureLoaded(texture) {
                  self.isLoadingEnvMap = false;
                  texture.mapping = refract ? THREE.EquirectangularRefractionMapping : THREE.EquirectangularReflectionMapping;
                  material.envMap = texture;
                  utils.material.handleTextureEvents(self.el, texture);
                  material.needsUpdate = true;
                });
                return;
              }

              // Another material is already loading this texture. Wait on promise.
              if (texturePromises[envMap]) {
                texturePromises[envMap].then(function (cube) {
                  self.isLoadingEnvMap = false;
                  material.envMap = cube;
                  utils.material.handleTextureEvents(self.el, cube);
                  material.needsUpdate = true;
                });
                return;
              }

              // Material is first to load this texture. Load and resolve texture.
              texturePromises[envMap] = new Promise(function (resolve) {
                utils.srcLoader.validateCubemapSrc(envMap, function loadEnvMap(urls) {
                  CubeLoader.load(urls, function (cube) {
                    // Texture loaded.
                    self.isLoadingEnvMap = false;
                    material.envMap = cube;
                    cube.mapping = refract ? THREE.CubeRefractionMapping : THREE.CubeReflectionMapping;
                    utils.material.handleTextureEvents(self.el, cube);
                    resolve(cube);
                  });
                });
              });
            }
          });

          /**
           * Builds and normalize material data, normalizing stuff along the way.
           *
           * @param {object} data - Material data.
           * @param {object} materialData - Object to use.
           * @returns {object} Updated materialData.
           */
          function getMaterialData(data, materialData) {
            materialData.color.set(data.color);
            materialData.specular.set(data.emissive);
            materialData.emissive.set(data.emissive);
            materialData.emissiveIntensity = data.emissiveIntensity;
            materialData.fog = data.fog;
            materialData.transparent = data.transparent;
            materialData.wireframe = data.wireframe;
            materialData.wireframeLinewidth = data.wireframeLinewidth;
            materialData.shininess = data.shininess;
            materialData.flatShading = data.flatShading;
            materialData.wireframe = data.wireframe;
            materialData.wireframeLinewidth = data.wireframeLinewidth;
            materialData.reflectivity = data.reflectivity;
            materialData.refractionRatio = data.refractionRatio;
            switch (data.combine) {
              case 'mix':
                materialData.combine = THREE.MixOperation;
                break;
              case 'multiply':
                materialData.combine = THREE.MultiplyOperation;
                break;
              case 'add':
                materialData.combine = THREE.AddOperation;
                break;
            }
            if (data.normalMap) {
              materialData.normalScale = data.normalScale;
            }
            if (data.ambientOcclusionMap) {
              materialData.aoMapIntensity = data.ambientOcclusionMapIntensity;
            }
            if (data.bumpMap) {
              materialData.aoMapIntensity = data.bumpMapScale;
            }
            if (data.displacementMap) {
              materialData.displacementScale = data.displacementScale;
              materialData.displacementBias = data.displacementBias;
            }
            return materialData;
          }

          /***/
        },

        /***/"./src/shaders/sdf.js":
        /*!****************************!*\
          !*** ./src/shaders/sdf.js ***!
          \****************************/
        /***/
        function srcShadersSdfJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var isWebGL2AVailable = !!document.createElement('canvas').getContext('webgl2');
          var VERTEX_SHADER_WEBGL1 = ['attribute vec2 uv;', 'attribute vec3 position;', 'uniform mat4 projectionMatrix;', 'uniform mat4 modelViewMatrix;', 'varying vec2 vUV;', 'void main(void) {', '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '  vUV = uv;', '}'].join('\n');
          var VERTEX_SHADER_WEBGL2 = ['#version 300 es', 'in vec2 uv;', 'in vec3 position;', 'uniform mat4 projectionMatrix;', 'uniform mat4 modelViewMatrix;', 'out vec2 vUV;', 'void main(void) {', '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '  vUV = uv;', '}'].join('\n');
          var VERTEX_SHADER = isWebGL2AVailable ? VERTEX_SHADER_WEBGL2 : VERTEX_SHADER_WEBGL1;
          var FRAGMENT_SHADER_WEBGL1 = ['#ifdef GL_OES_standard_derivatives', '#extension GL_OES_standard_derivatives: enable', '#endif', 'precision highp float;', 'uniform float alphaTest;', 'uniform float opacity;', 'uniform sampler2D map;', 'uniform vec3 color;', 'varying vec2 vUV;', '#ifdef GL_OES_standard_derivatives', '  float contour(float width, float value) {', '    return smoothstep(0.5 - value, 0.5 + value, width);', '  }', '#else', '  float aastep(float value, float afwidth) {', '    return smoothstep(0.5 - afwidth, 0.5 + afwidth, value);', '  }', '#endif',
          // FIXME: Experimentally determined constants.
          '#define BIG_ENOUGH 0.001', '#define MODIFIED_ALPHATEST (0.02 * isBigEnough / BIG_ENOUGH)', '#define ALL_SMOOTH 0.4', '#define ALL_ROUGH 0.02', '#define DISCARD_ALPHA (alphaTest / (2.2 - 1.2 * ratio))', 'void main() {',
          // When we have derivatives and can get texel size for supersampling.
          '  #ifdef GL_OES_standard_derivatives', '    vec2 uv = vUV;', '    vec4 texColor = texture2D(map, uv);', '    float dist = texColor.a;', '    float width = fwidth(dist);', '    float alpha = contour(dist, width);', '    float dscale = 0.353505;', '    vec2 duv = dscale * (dFdx(uv) + dFdy(uv));', '    float isBigEnough = max(abs(duv.x), abs(duv.y));',
          // When texel is too small, blend raw alpha value rather than supersampling.
          // FIXME: experimentally determined constant
          '    if (isBigEnough > BIG_ENOUGH) {', '      float ratio = BIG_ENOUGH / isBigEnough;', '      alpha = ratio * alpha + (1.0 - ratio) * dist;', '    }',
          // Otherwise do weighted supersampling.
          // FIXME: why this weighting?
          '    if (isBigEnough <= BIG_ENOUGH) {', '      vec4 box = vec4 (uv - duv, uv + duv);', '      alpha = (alpha + 0.5 * (', '        contour(texture2D(map, box.xy).a, width)', '        + contour(texture2D(map, box.zw).a, width)', '        + contour(texture2D(map, box.xw).a, width)', '        + contour(texture2D(map, box.zy).a, width)', '      )) / 3.0;', '    }',
          // Do modified alpha test.
          '    if (alpha < alphaTest * MODIFIED_ALPHATEST) { discard; return; }', '  #else',
          // When we don't have derivatives, use approximations.
          '    vec4 texColor = texture2D(map, vUV);', '    float value = texColor.a;',
          // FIXME: if we understood font pixel dimensions, this could probably be improved
          '    float afwidth = (1.0 / 32.0) * (1.4142135623730951 / (2.0 * gl_FragCoord.w));', '    float alpha = aastep(value, afwidth);',
          // Use gl_FragCoord.w to guess when we should blend.
          // FIXME: If we understood font pixel dimensions, this could probably be improved.
          '    float ratio = (gl_FragCoord.w >= ALL_SMOOTH) ? 1.0 : (gl_FragCoord.w < ALL_ROUGH) ? 0.0 : (gl_FragCoord.w - ALL_ROUGH) / (ALL_SMOOTH - ALL_ROUGH);', '    if (alpha < alphaTest) { if (ratio >= 1.0) { discard; return; } alpha = 0.0; }', '    alpha = alpha * ratio + (1.0 - ratio) * value;', '    if (ratio < 1.0 && alpha <= DISCARD_ALPHA) { discard; return; }', '  #endif', '  gl_FragColor = vec4(color, opacity * alpha);', '}'].join('\n');
          var FRAGMENT_SHADER_WEBGL2 = ['#version 300 es', 'precision highp float;', 'uniform float alphaTest;', 'uniform float opacity;', 'uniform sampler2D map;', 'uniform vec3 color;', 'in vec2 vUV;', 'out vec4 fragColor;', '#ifdef GL_OES_standard_derivatives', '  float contour(float width, float value) {', '    return smoothstep(0.5 - value, 0.5 + value, width);', '  }', '#else', '  float aastep(float value, float afwidth) {', '    return smoothstep(0.5 - afwidth, 0.5 + afwidth, value);', '  }', '#endif',
          // FIXME: Experimentally determined constants.
          '#define BIG_ENOUGH 0.001', '#define MODIFIED_ALPHATEST (0.02 * isBigEnough / BIG_ENOUGH)', '#define ALL_SMOOTH 0.4', '#define ALL_ROUGH 0.02', '#define DISCARD_ALPHA (alphaTest / (2.2 - 1.2 * ratio))', 'void main() {',
          // When we have derivatives and can get texel size for supersampling.
          '  #ifdef GL_OES_standard_derivatives', '    vec2 uv = vUV;', '    vec4 texColor = texture(map, uv);', '    float dist = texColor.a;', '    float width = fwidth(dist);', '    float alpha = contour(dist, width);', '    float dscale = 0.353505;', '    vec2 duv = dscale * (dFdx(uv) + dFdy(uv));', '    float isBigEnough = max(abs(duv.x), abs(duv.y));',
          // When texel is too small, blend raw alpha value rather than supersampling.
          // FIXME: experimentally determined constant
          '    if (isBigEnough > BIG_ENOUGH) {', '      float ratio = BIG_ENOUGH / isBigEnough;', '      alpha = ratio * alpha + (1.0 - ratio) * dist;', '    }',
          // Otherwise do weighted supersampling.
          // FIXME: why this weighting?
          '    if (isBigEnough <= BIG_ENOUGH) {', '      vec4 box = vec4 (uv - duv, uv + duv);', '      alpha = (alpha + 0.5 * (', '        contour(texture(map, box.xy).a, width)', '        + contour(texture(map, box.zw).a, width)', '        + contour(texture(map, box.xw).a, width)', '        + contour(texture(map, box.zy).a, width)', '      )) / 3.0;', '    }',
          // Do modified alpha test.
          '    if (alpha < alphaTest * MODIFIED_ALPHATEST) { discard; return; }', '  #else',
          // When we don't have derivatives, use approximations.
          '    vec4 texColor = texture(map, vUV);', '    float value = texColor.a;',
          // FIXME: if we understood font pixel dimensions, this could probably be improved
          '    float afwidth = (1.0 / 32.0) * (1.4142135623730951 / (2.0 * gl_FragCoord.w));', '    float alpha = aastep(value, afwidth);',
          // Use gl_FragCoord.w to guess when we should blend.
          // FIXME: If we understood font pixel dimensions, this could probably be improved.
          '    float ratio = (gl_FragCoord.w >= ALL_SMOOTH) ? 1.0 : (gl_FragCoord.w < ALL_ROUGH) ? 0.0 : (gl_FragCoord.w - ALL_ROUGH) / (ALL_SMOOTH - ALL_ROUGH);', '    if (alpha < alphaTest) { if (ratio >= 1.0) { discard; return; } alpha = 0.0; }', '    alpha = alpha * ratio + (1.0 - ratio) * value;', '    if (ratio < 1.0 && alpha <= DISCARD_ALPHA) { discard; return; }', '  #endif', '  fragColor = vec4(color, opacity * alpha);', '}'].join('\n');
          var FRAGMENT_SHADER = isWebGL2AVailable ? FRAGMENT_SHADER_WEBGL2 : FRAGMENT_SHADER_WEBGL1;

          /**
           * Signed distance field.
           * Used by text component.
           */
          module.exports.Shader = registerShader('sdf', {
            schema: {
              alphaTest: {
                type: 'number',
                is: 'uniform',
                default: 0.5
              },
              color: {
                type: 'color',
                is: 'uniform',
                default: 'white'
              },
              map: {
                type: 'map',
                is: 'uniform'
              },
              opacity: {
                type: 'number',
                is: 'uniform',
                default: 1.0
              }
            },
            raw: true,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER
          });

          /***/
        },

        /***/"./src/shaders/shadow.js":
        /*!*******************************!*\
          !*** ./src/shaders/shadow.js ***!
          \*******************************/
        /***/
        function srcShadersShadowJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");

          /**
           * Flat shader using THREE.ShadowMaterial.
           */
          module.exports.Shader = registerShader('shadow', {
            schema: {
              opacity: {
                default: 0.5
              },
              transparent: {
                default: true
              },
              alphaToCoverage: {
                default: true
              }
            },
            /**
             * Initializes the shader.
             * Adds a reference from the scene to this entity as the camera.
             */
            init: function init(data) {
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.material = new THREE.ShadowMaterial();
            },
            update: function update(data) {
              this.material.opacity = data.opacity;
              this.material.alphaToCoverage = data.alphaToCoverage;
              this.material.transparent = data.transparent;
            }
          });

          /***/
        },

        /***/"./src/shaders/standard.js":
        /*!*********************************!*\
          !*** ./src/shaders/standard.js ***!
          \*********************************/
        /***/
        function srcShadersStandardJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerShader = __webpack_require__( /*! ../core/shader */"./src/core/shader.js").registerShader;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var CubeLoader = new THREE.CubeTextureLoader();
          var texturePromises = {};

          /**
           * Standard (physically-based) shader using THREE.MeshStandardMaterial.
           */
          module.exports.Shader = registerShader('standard', {
            schema: {
              ambientOcclusionMap: {
                type: 'map'
              },
              ambientOcclusionMapIntensity: {
                default: 1
              },
              ambientOcclusionTextureOffset: {
                type: 'vec2'
              },
              ambientOcclusionTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              color: {
                type: 'color'
              },
              displacementMap: {
                type: 'map'
              },
              displacementScale: {
                default: 1
              },
              displacementBias: {
                default: 0.5
              },
              displacementTextureOffset: {
                type: 'vec2'
              },
              displacementTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              emissive: {
                type: 'color',
                default: '#000'
              },
              emissiveIntensity: {
                default: 1
              },
              envMap: {
                default: ''
              },
              fog: {
                default: true
              },
              height: {
                default: 256
              },
              metalness: {
                default: 0.0,
                min: 0.0,
                max: 1.0
              },
              metalnessMap: {
                type: 'map'
              },
              metalnessTextureOffset: {
                type: 'vec2'
              },
              metalnessTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              normalMap: {
                type: 'map'
              },
              normalScale: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              normalTextureOffset: {
                type: 'vec2'
              },
              normalTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              offset: {
                type: 'vec2',
                default: {
                  x: 0,
                  y: 0
                }
              },
              repeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              roughness: {
                default: 0.5,
                min: 0.0,
                max: 1.0
              },
              roughnessMap: {
                type: 'map'
              },
              roughnessTextureOffset: {
                type: 'vec2'
              },
              roughnessTextureRepeat: {
                type: 'vec2',
                default: {
                  x: 1,
                  y: 1
                }
              },
              sphericalEnvMap: {
                type: 'map'
              },
              src: {
                type: 'map'
              },
              width: {
                default: 512
              },
              wireframe: {
                default: false
              },
              wireframeLinewidth: {
                default: 2
              }
            },
            /**
             * Initializes the shader.
             * Adds a reference from the scene to this entity as the camera.
             */
            init: function init(data) {
              this.rendererSystem = this.el.sceneEl.systems.renderer;
              this.materialData = {
                color: new THREE.Color(),
                emissive: new THREE.Color()
              };
              getMaterialData(data, this.materialData);
              this.rendererSystem.applyColorCorrection(this.materialData.color);
              this.rendererSystem.applyColorCorrection(this.materialData.emissive);
              this.material = new THREE.MeshStandardMaterial(this.materialData);
            },
            update: function update(data) {
              this.updateMaterial(data);
              utils.material.updateMap(this, data);
              if (data.normalMap) {
                utils.material.updateDistortionMap('normal', this, data);
              }
              if (data.displacementMap) {
                utils.material.updateDistortionMap('displacement', this, data);
              }
              if (data.ambientOcclusionMap) {
                utils.material.updateDistortionMap('ambientOcclusion', this, data);
              }
              if (data.metalnessMap) {
                utils.material.updateDistortionMap('metalness', this, data);
              }
              if (data.roughnessMap) {
                utils.material.updateDistortionMap('roughness', this, data);
              }
              this.updateEnvMap(data);
            },
            /**
             * Updating existing material.
             *
             * @param {object} data - Material component data.
             * @returns {object} Material.
             */
            updateMaterial: function updateMaterial(data) {
              var key;
              var material = this.material;
              getMaterialData(data, this.materialData);
              this.rendererSystem.applyColorCorrection(this.materialData.color);
              this.rendererSystem.applyColorCorrection(this.materialData.emissive);
              for (key in this.materialData) {
                material[key] = this.materialData[key];
              }
            },
            /**
             * Handle environment cubemap. Textures are cached in texturePromises.
             */
            updateEnvMap: function updateEnvMap(data) {
              var self = this;
              var material = this.material;
              var envMap = data.envMap;
              var sphericalEnvMap = data.sphericalEnvMap;

              // No envMap defined or already loading.
              if (!envMap && !sphericalEnvMap || this.isLoadingEnvMap) {
                material.envMap = null;
                material.needsUpdate = true;
                return;
              }
              this.isLoadingEnvMap = true;

              // if a spherical env map is defined then use it.
              if (sphericalEnvMap) {
                this.el.sceneEl.systems.material.loadTexture(sphericalEnvMap, {
                  src: sphericalEnvMap
                }, function textureLoaded(texture) {
                  self.isLoadingEnvMap = false;
                  texture.mapping = THREE.EquirectangularReflectionMapping;
                  material.envMap = texture;
                  utils.material.handleTextureEvents(self.el, texture);
                  material.needsUpdate = true;
                });
                return;
              }

              // Another material is already loading this texture. Wait on promise.
              if (texturePromises[envMap]) {
                texturePromises[envMap].then(function (cube) {
                  self.isLoadingEnvMap = false;
                  material.envMap = cube;
                  utils.material.handleTextureEvents(self.el, cube);
                  material.needsUpdate = true;
                });
                return;
              }

              // Material is first to load this texture. Load and resolve texture.
              texturePromises[envMap] = new Promise(function (resolve) {
                utils.srcLoader.validateCubemapSrc(envMap, function loadEnvMap(urls) {
                  CubeLoader.load(urls, function (cube) {
                    // Texture loaded.
                    self.isLoadingEnvMap = false;
                    material.envMap = cube;
                    utils.material.handleTextureEvents(self.el, cube);
                    resolve(cube);
                  });
                });
              });
            }
          });

          /**
           * Builds and normalize material data, normalizing stuff along the way.
           *
           * @param {object} data - Material data.
           * @param {object} materialData - Object to use.
           * @returns {object} Updated materialData.
           */
          function getMaterialData(data, materialData) {
            materialData.color.set(data.color);
            materialData.emissive.set(data.emissive);
            materialData.emissiveIntensity = data.emissiveIntensity;
            materialData.fog = data.fog;
            materialData.metalness = data.metalness;
            materialData.roughness = data.roughness;
            materialData.wireframe = data.wireframe;
            materialData.wireframeLinewidth = data.wireframeLinewidth;
            if (data.normalMap) {
              materialData.normalScale = data.normalScale;
            }
            if (data.ambientOcclusionMap) {
              materialData.aoMapIntensity = data.ambientOcclusionMapIntensity;
            }
            if (data.displacementMap) {
              materialData.displacementScale = data.displacementScale;
              materialData.displacementBias = data.displacementBias;
            }
            return materialData;
          }

          /***/
        },

        /***/"./src/systems/camera.js":
        /*!*******************************!*\
          !*** ./src/systems/camera.js ***!
          \*******************************/
        /***/
        function srcSystemsCameraJs(module, __unused_webpack_exports, __webpack_require__) {
          var constants = __webpack_require__( /*! ../constants/ */"./src/constants/index.js");
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var DEFAULT_CAMERA_ATTR = 'data-aframe-default-camera';

          /**
           * Camera system. Manages which camera is active among multiple cameras in scene.
           *
           * @member {object} activeCameraEl - Active camera entity.
           */
          module.exports.System = registerSystem('camera', {
            init: function init() {
              this.activeCameraEl = null;
              this.render = this.render.bind(this);
              this.unwrapRender = this.unwrapRender.bind(this);
              this.wrapRender = this.wrapRender.bind(this);
              this.initialCameraFound = false;
              this.numUserCameras = 0;
              this.numUserCamerasChecked = 0;
              this.setupInitialCamera();
            },
            /**
             * Setup initial camera, either searching for camera or
             * creating a default camera if user has not added one during the initial scene traversal.
             * We want sceneEl.camera to be ready, set, and initialized before the rest of the scene
             * loads.
             *
             * Default camera offset height is at average eye level (~1.6m).
             */
            setupInitialCamera: function setupInitialCamera() {
              var cameraEls;
              var i;
              var sceneEl = this.sceneEl;
              var self = this;

              // Camera already defined or the one defined it is an spectator one.
              if (sceneEl.camera && !sceneEl.camera.el.getAttribute('camera').spectator) {
                sceneEl.emit('cameraready', {
                  cameraEl: sceneEl.camera.el
                });
                return;
              }

              // Search for initial user-defined camera.
              cameraEls = sceneEl.querySelectorAll('a-camera, :not(a-mixin)[camera]');

              // No user cameras, create default one.
              if (!cameraEls.length) {
                this.createDefaultCamera();
                return;
              }
              this.numUserCameras = cameraEls.length;
              for (i = 0; i < cameraEls.length; i++) {
                cameraEls[i].addEventListener('object3dset', function (evt) {
                  if (evt.detail.type !== 'camera') {
                    return;
                  }
                  self.checkUserCamera(this);
                });

                // Load camera and wait for camera to initialize.
                if (cameraEls[i].isNode) {
                  cameraEls[i].load();
                } else {
                  cameraEls[i].addEventListener('nodeready', function () {
                    this.load();
                  });
                }
              }
            },
            /**
             * Check if a user-defined camera entity is appropriate to be initial camera.
             * (active + non-spectator).
             *
             * Keep track of the number of cameras we checked and whether we found one.
             */
            checkUserCamera: function checkUserCamera(cameraEl) {
              var cameraData;
              var sceneEl = this.el.sceneEl;
              this.numUserCamerasChecked++;

              // Already found one.
              if (this.initialCameraFound) {
                return;
              }

              // Check if camera is appropriate for being the initial camera.
              cameraData = cameraEl.getAttribute('camera');
              if (!cameraData.active || cameraData.spectator) {
                // No user cameras eligible, create default camera.
                if (this.numUserCamerasChecked === this.numUserCameras) {
                  this.createDefaultCamera();
                }
                return;
              }
              this.initialCameraFound = true;
              sceneEl.camera = cameraEl.getObject3D('camera');
              sceneEl.emit('cameraready', {
                cameraEl: cameraEl
              });
            },
            createDefaultCamera: function createDefaultCamera() {
              var defaultCameraEl;
              var sceneEl = this.sceneEl;

              // Set up default camera.
              defaultCameraEl = document.createElement('a-entity');
              defaultCameraEl.setAttribute('camera', {
                active: true
              });
              defaultCameraEl.setAttribute('position', {
                x: 0,
                y: constants.DEFAULT_CAMERA_HEIGHT,
                z: 0
              });
              defaultCameraEl.setAttribute('wasd-controls', '');
              defaultCameraEl.setAttribute('look-controls', '');
              defaultCameraEl.setAttribute(constants.AFRAME_INJECTED, '');
              defaultCameraEl.addEventListener('object3dset', function (evt) {
                if (evt.detail.type !== 'camera') {
                  return;
                }
                sceneEl.camera = evt.detail.object;
                sceneEl.emit('cameraready', {
                  cameraEl: defaultCameraEl
                });
              });
              sceneEl.appendChild(defaultCameraEl);
            },
            /**
             * Set a different active camera.
             * When we choose a (sort of) random scene camera as the replacement, set its `active` to
             * true. The camera component will call `setActiveCamera` and handle passing the torch to
             * the new camera.
             */
            disableActiveCamera: function disableActiveCamera() {
              var cameraEls;
              var newActiveCameraEl;
              cameraEls = this.sceneEl.querySelectorAll(':not(a-mixin)[camera]');
              newActiveCameraEl = cameraEls[cameraEls.length - 1];
              newActiveCameraEl.setAttribute('camera', 'active', true);
            },
            /**
             * Set active camera to be used by renderer.
             * Removes the default camera (if present).
             * Disables all other cameras in the scene.
             *
             * @param {Element} newCameraEl - Entity with camera component.
             */
            setActiveCamera: function setActiveCamera(newCameraEl) {
              var cameraEl;
              var cameraEls;
              var i;
              var newCamera;
              var previousCamera = this.activeCameraEl;
              var sceneEl = this.sceneEl;

              // Same camera.
              newCamera = newCameraEl.getObject3D('camera');
              if (!newCamera || newCameraEl === this.activeCameraEl) {
                return;
              }

              // Grab the default camera.
              var defaultCameraWrapper = sceneEl.querySelector('[' + DEFAULT_CAMERA_ATTR + ']');
              var defaultCameraEl = defaultCameraWrapper && defaultCameraWrapper.querySelector(':not(a-mixin)[camera]');

              // Remove default camera if new camera is not the default camera.
              if (newCameraEl !== defaultCameraEl) {
                removeDefaultCamera(sceneEl);
              }

              // Make new camera active.
              this.activeCameraEl = newCameraEl;
              this.activeCameraEl.play();
              sceneEl.camera = newCamera;

              // Disable current camera
              if (previousCamera) {
                previousCamera.setAttribute('camera', 'active', false);
              }

              // Disable other cameras in the scene
              cameraEls = sceneEl.querySelectorAll(':not(a-mixin)[camera]');
              for (i = 0; i < cameraEls.length; i++) {
                cameraEl = cameraEls[i];
                if (!cameraEl.isEntity || newCameraEl === cameraEl) {
                  continue;
                }
                cameraEl.setAttribute('camera', 'active', false);
                cameraEl.pause();
              }
              sceneEl.emit('camera-set-active', {
                cameraEl: newCameraEl
              });
            },
            /**
             * Set spectator camera to render the scene on a 2D display.
             *
             * @param {Element} newCameraEl - Entity with camera component.
             */
            setSpectatorCamera: function setSpectatorCamera(newCameraEl) {
              var newCamera;
              var previousCamera = this.spectatorCameraEl;
              var sceneEl = this.sceneEl;
              var spectatorCameraEl;

              // Same camera.
              newCamera = newCameraEl.getObject3D('camera');
              if (!newCamera || newCameraEl === this.spectatorCameraEl) {
                return;
              }

              // Disable current camera
              if (previousCamera) {
                previousCamera.setAttribute('camera', 'spectator', false);
              }
              spectatorCameraEl = this.spectatorCameraEl = newCameraEl;
              sceneEl.addEventListener('enter-vr', this.wrapRender);
              sceneEl.addEventListener('exit-vr', this.unwrapRender);
              spectatorCameraEl.setAttribute('camera', 'active', false);
              spectatorCameraEl.play();
              sceneEl.emit('camera-set-spectator', {
                cameraEl: newCameraEl
              });
            },
            /**
             * Disables current spectator camera.
             */
            disableSpectatorCamera: function disableSpectatorCamera() {
              this.spectatorCameraEl = undefined;
            },
            /**
             * Wrap the render method of the renderer to render
             * the spectator camera after vrDisplay.submitFrame.
             */
            wrapRender: function wrapRender() {
              if (!this.spectatorCameraEl || this.originalRender) {
                return;
              }
              this.originalRender = this.sceneEl.renderer.render;
              this.sceneEl.renderer.render = this.render;
            },
            unwrapRender: function unwrapRender() {
              if (!this.originalRender) {
                return;
              }
              this.sceneEl.renderer.render = this.originalRender;
              this.originalRender = undefined;
            },
            render: function render(scene, camera) {
              var isVREnabled;
              var sceneEl = this.sceneEl;
              var spectatorCamera;
              isVREnabled = sceneEl.renderer.xr.enabled;
              this.originalRender.call(sceneEl.renderer, scene, camera);
              if (!this.spectatorCameraEl || sceneEl.isMobile || !isVREnabled) {
                return;
              }
              spectatorCamera = this.spectatorCameraEl.components.camera.camera;
              sceneEl.renderer.xr.enabled = false;
              this.originalRender.call(sceneEl.renderer, scene, spectatorCamera);
              sceneEl.renderer.xr.enabled = isVREnabled;
            }
          });

          /**
           * Remove injected default camera from scene, if present.
           *
           * @param {Element} sceneEl
           */
          function removeDefaultCamera(sceneEl) {
            var defaultCamera;
            var camera = sceneEl.camera;
            if (!camera) {
              return;
            }

            // Remove default camera if present.
            defaultCamera = sceneEl.querySelector('[' + DEFAULT_CAMERA_ATTR + ']');
            if (!defaultCamera) {
              return;
            }
            sceneEl.removeChild(defaultCamera);
          }

          /***/
        },

        /***/"./src/systems/geometry.js":
        /*!*********************************!*\
          !*** ./src/systems/geometry.js ***!
          \*********************************/
        /***/
        function srcSystemsGeometryJs(module, __unused_webpack_exports, __webpack_require__) {
          var geometries = __webpack_require__( /*! ../core/geometry */"./src/core/geometry.js").geometries;
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;

          /**
           * System for geometry component.
           * Handle geometry caching.
           *
           * @member {object} cache - Mapping of stringified component data to THREE.BufferGeometry objects.
           * @member {object} cacheCount - Keep track of number of entities using a geometry to
           *         know whether to dispose on removal.
           */
          module.exports.System = registerSystem('geometry', {
            init: function init() {
              this.cache = {};
              this.cacheCount = {};
            },
            /**
             * Reset cache. Mainly for testing.
             */
            clearCache: function clearCache() {
              this.cache = {};
              this.cacheCount = {};
            },
            /**
             * Attempt to retrieve from cache.
             *
             * @returns {Object|null} A geometry if it exists, else null.
             */
            getOrCreateGeometry: function getOrCreateGeometry(data) {
              var cache = this.cache;
              var cachedGeometry;
              var hash;

              // Skip all caching logic.
              if (data.skipCache) {
                return createGeometry(data);
              }

              // Try to retrieve from cache first.
              hash = this.hash(data);
              cachedGeometry = cache[hash];
              incrementCacheCount(this.cacheCount, hash);
              if (cachedGeometry) {
                return cachedGeometry;
              }

              // Create geometry.
              cachedGeometry = createGeometry(data);

              // Cache and return geometry.
              cache[hash] = cachedGeometry;
              return cachedGeometry;
            },
            /**
             * Let system know that an entity is no longer using a geometry.
             */
            unuseGeometry: function unuseGeometry(data) {
              var cache = this.cache;
              var cacheCount = this.cacheCount;
              var geometry;
              var hash;
              if (data.skipCache) {
                return;
              }
              hash = this.hash(data);
              if (!cache[hash]) {
                return;
              }
              decrementCacheCount(cacheCount, hash);

              // Another entity is still using this geometry. No need to do anything.
              if (cacheCount[hash] > 0) {
                return;
              }

              // No more entities are using this geometry. Dispose.
              geometry = cache[hash];
              geometry.dispose();
              delete cache[hash];
              delete cacheCount[hash];
            },
            /**
             * Use JSON.stringify to turn component data into hash.
             * Should be deterministic within a single browser engine.
             * If not, then look into json-stable-stringify.
             */
            hash: function hash(data) {
              return JSON.stringify(data);
            }
          });

          /**
           * Create geometry using component data.
           *
           * @param {object} data - Component data.
           * @returns {object} Geometry.
           */
          function createGeometry(data) {
            var geometryType = data.primitive;
            var GeometryClass = geometries[geometryType] && geometries[geometryType].Geometry;
            var geometryInstance = new GeometryClass();
            if (!GeometryClass) {
              throw new Error('Unknown geometry `' + geometryType + '`');
            }
            geometryInstance.init(data);
            return geometryInstance.geometry;
          }

          /**
           * Decreate count of entity using a geometry.
           */
          function decrementCacheCount(cacheCount, hash) {
            cacheCount[hash]--;
          }

          /**
           * Increase count of entity using a geometry.
           */
          function incrementCacheCount(cacheCount, hash) {
            cacheCount[hash] = cacheCount[hash] === undefined ? 1 : cacheCount[hash] + 1;
          }

          /***/
        },

        /***/"./src/systems/gltf-model.js":
        /*!***********************************!*\
          !*** ./src/systems/gltf-model.js ***!
          \***********************************/
        /***/
        function srcSystemsGltfModelJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          function fetchScript(src) {
            return new Promise(function (resolve, reject) {
              var script = document.createElement('script');
              document.body.appendChild(script);
              script.onload = resolve;
              script.onerror = reject;
              script.async = true;
              script.src = src;
            });
          }

          /**
           * glTF model system.
           *
           * Configures glTF loading options. Models using glTF compression require that a Draco decoder be
           * provided externally.
           *
           * @param {string} dracoDecoderPath - Base path from which to load Draco decoder library.
           * @param {string} basisTranscoderPath - Base path from which to load Basis transcoder library.
           * @param {string} meshoptDecoderPath - Full path from which to load Meshopt decoder.
           */
          module.exports.System = registerSystem('gltf-model', {
            schema: {
              dracoDecoderPath: {
                default: 'https://www.gstatic.com/draco/versioned/decoders/1.5.5/'
              },
              basisTranscoderPath: {
                default: ''
              },
              meshoptDecoderPath: {
                default: ''
              }
            },
            init: function init() {
              this.update();
            },
            update: function update() {
              var dracoDecoderPath = this.data.dracoDecoderPath;
              var basisTranscoderPath = this.data.basisTranscoderPath;
              var meshoptDecoderPath = this.data.meshoptDecoderPath;
              if (!this.dracoLoader && dracoDecoderPath) {
                this.dracoLoader = new THREE.DRACOLoader();
                this.dracoLoader.setDecoderPath(dracoDecoderPath);
              }
              if (!this.ktx2Loader && basisTranscoderPath) {
                this.ktx2Loader = new THREE.KTX2Loader();
                this.ktx2Loader.setTranscoderPath(basisTranscoderPath).detectSupport(this.el.renderer);
              }
              if (!this.meshoptDecoder && meshoptDecoderPath) {
                this.meshoptDecoder = fetchScript(meshoptDecoderPath).then(function () {
                  return window.MeshoptDecoder.ready;
                }).then(function () {
                  return window.MeshoptDecoder;
                });
              }
            },
            getDRACOLoader: function getDRACOLoader() {
              return this.dracoLoader;
            },
            getKTX2Loader: function getKTX2Loader() {
              return this.ktx2Loader;
            },
            getMeshoptDecoder: function getMeshoptDecoder() {
              return this.meshoptDecoder;
            }
          });

          /***/
        },

        /***/"./src/systems/index.js":
        /*!******************************!*\
          !*** ./src/systems/index.js ***!
          \******************************/
        /***/
        function srcSystemsIndexJs(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
          __webpack_require__( /*! ./camera */"./src/systems/camera.js");
          __webpack_require__( /*! ./geometry */"./src/systems/geometry.js");
          __webpack_require__( /*! ./gltf-model */"./src/systems/gltf-model.js");
          __webpack_require__( /*! ./light */"./src/systems/light.js");
          __webpack_require__( /*! ./material */"./src/systems/material.js");
          __webpack_require__( /*! ./renderer */"./src/systems/renderer.js");
          __webpack_require__( /*! ./shadow */"./src/systems/shadow.js");
          __webpack_require__( /*! ./tracked-controls-webvr */"./src/systems/tracked-controls-webvr.js");
          __webpack_require__( /*! ./tracked-controls-webxr */"./src/systems/tracked-controls-webxr.js");
          __webpack_require__( /*! ./webxr */"./src/systems/webxr.js");

          /***/
        },

        /***/"./src/systems/light.js":
        /*!******************************!*\
          !*** ./src/systems/light.js ***!
          \******************************/
        /***/
        function srcSystemsLightJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var bind = __webpack_require__( /*! ../utils/bind */"./src/utils/bind.js");
          var constants = __webpack_require__( /*! ../constants/ */"./src/constants/index.js");
          var DEFAULT_LIGHT_ATTR = 'data-aframe-default-light';

          /**
           * Light system.
           *
           * Prescribes default lighting if not specified (one ambient, one directional).
           * Removes default lighting from the scene when a new light is added.
           *
           * @param {bool} defaultLights - Whether default lighting are defined.
           * @param {bool} userDefinedLights - Whether user lighting is defined.
           */
          module.exports.System = registerSystem('light', {
            schema: {
              defaultLightsEnabled: {
                default: true
              }
            },
            init: function init() {
              this.defaultLights = false;
              this.userDefinedLights = false;
              // Wait for all entities to fully load before checking for existence of lights.
              // Since entities wait for <a-assets> to load, any lights attaching to the scene
              // will do so asynchronously.
              this.sceneEl.addEventListener('loaded', bind(this.setupDefaultLights, this));
            },
            /**
             * Notify scene that light has been added and to remove the default.
             *
             * @param {object} el - element holding the light component.
             */
            registerLight: function registerLight(el) {
              if (!el.hasAttribute(DEFAULT_LIGHT_ATTR)) {
                // User added a light, remove default lights through DOM.
                this.removeDefaultLights();
                this.userDefinedLights = true;
              }
            },
            removeDefaultLights: function removeDefaultLights() {
              var defaultLights;
              var sceneEl = this.sceneEl;
              if (!this.defaultLights) {
                return;
              }
              defaultLights = document.querySelectorAll('[' + DEFAULT_LIGHT_ATTR + ']');
              for (var i = 0; i < defaultLights.length; i++) {
                sceneEl.removeChild(defaultLights[i]);
              }
              this.defaultLights = false;
            },
            /**
             * Prescibe default lights to the scene.
             * Does so by injecting markup such that this state is not invisible.
             * These lights are removed if the user adds any lights.
             */
            setupDefaultLights: function setupDefaultLights() {
              var sceneEl = this.sceneEl;
              var ambientLight;
              var directionalLight;
              if (this.userDefinedLights || this.defaultLights || !this.data.defaultLightsEnabled) {
                return;
              }
              ambientLight = document.createElement('a-entity');
              ambientLight.setAttribute('light', {
                color: '#BBB',
                type: 'ambient'
              });
              ambientLight.setAttribute(DEFAULT_LIGHT_ATTR, '');
              ambientLight.setAttribute(constants.AFRAME_INJECTED, '');
              sceneEl.appendChild(ambientLight);
              directionalLight = document.createElement('a-entity');
              directionalLight.setAttribute('light', {
                color: '#FFF',
                intensity: 0.6,
                castShadow: true
              });
              directionalLight.setAttribute('position', {
                x: -0.5,
                y: 1,
                z: 1
              });
              directionalLight.setAttribute(DEFAULT_LIGHT_ATTR, '');
              directionalLight.setAttribute(constants.AFRAME_INJECTED, '');
              sceneEl.appendChild(directionalLight);
              this.defaultLights = true;
            }
          });

          /***/
        },

        /***/"./src/systems/material.js":
        /*!*********************************!*\
          !*** ./src/systems/material.js ***!
          \*********************************/
        /***/
        function srcSystemsMaterialJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var isHLS = __webpack_require__( /*! ../utils/material */"./src/utils/material.js").isHLS;
          var setTextureProperties = __webpack_require__( /*! ../utils/material */"./src/utils/material.js").setTextureProperties;
          var bind = utils.bind;
          var debug = utils.debug;
          var error = debug('components:texture:error');
          var TextureLoader = new THREE.TextureLoader();
          var warn = debug('components:texture:warn');
          TextureLoader.setCrossOrigin('anonymous');

          /**
           * System for material component.
           * Handle material registration, updates (for fog), and texture caching.
           *
           * @member {object} materials - Registered materials.
           * @member {object} textureCounts - Number of times each texture is used. Tracked
           *         separately from textureCache, because the cache (1) is populated in
           *         multiple places, and (2) may be cleared at any time.
           * @member {object} textureCache - Texture cache for:
           *   - Images: textureCache has mapping of src -> repeat -> cached three.js texture.
           *   - Videos: textureCache has mapping of videoElement -> cached three.js texture.
           */
          module.exports.System = registerSystem('material', {
            init: function init() {
              this.materials = {};
              this.textureCounts = {};
              this.textureCache = {};
              this.sceneEl.addEventListener('materialtextureloaded', bind(this.onMaterialTextureLoaded, this));
            },
            clearTextureCache: function clearTextureCache() {
              this.textureCache = {};
            },
            /**
             * Determine whether `src` is a image or video. Then try to load the asset, then call back.
             *
             * @param {string, or element} src - Texture URL or element.
             * @param {string} data - Relevant texture data used for caching.
             * @param {function} cb - Callback to pass texture to.
             */
            loadTexture: function loadTexture(src, data, cb) {
              var self = this;

              // Canvas.
              if (src.tagName === 'CANVAS') {
                this.loadCanvas(src, data, cb);
                return;
              }

              // Video element.
              if (src.tagName === 'VIDEO') {
                if (!src.src && !src.srcObject && !src.childElementCount) {
                  warn('Video element was defined with neither `source` elements nor `src` / `srcObject` attributes.');
                }
                this.loadVideo(src, data, cb);
                return;
              }
              utils.srcLoader.validateSrc(src, loadImageCb, loadVideoCb);
              function loadImageCb(src) {
                self.loadImage(src, data, cb);
              }
              function loadVideoCb(src) {
                self.loadVideo(src, data, cb);
              }
            },
            /**
             * High-level function for loading image textures (THREE.Texture).
             *
             * @param {Element|string} src - Texture source.
             * @param {object} data - Texture data.
             * @param {function} cb - Callback to pass texture to.
             */
            loadImage: function loadImage(src, data, handleImageTextureLoaded) {
              var hash = this.hash(data);
              var textureCache = this.textureCache;

              // Texture already being loaded or already loaded. Wait on promise.
              if (textureCache[hash]) {
                textureCache[hash].then(handleImageTextureLoaded);
                return;
              }

              // Texture not yet being loaded. Start loading it.
              textureCache[hash] = loadImageTexture(src, data);
              textureCache[hash].then(handleImageTextureLoaded);
            },
            /**
             * High-level function for loading canvas textures (THREE.Texture).
             *
             * @param {Element|string} src - Texture source.
             * @param {object} data - Texture data.
             * @param {function} cb - Callback to pass texture to.
             */
            loadCanvas: function loadCanvas(src, data, cb) {
              var texture;
              texture = new THREE.CanvasTexture(src);
              setTextureProperties(texture, data);
              cb(texture);
            },
            /**
            * Load video texture (THREE.VideoTexture).
            * Which is just an image texture that RAFs + needsUpdate.
            * Note that creating a video texture is synchronous unlike loading an image texture.
            * Made asynchronous to be consistent with image textures.
            *
            * @param {Element|string} src - Texture source.
            * @param {object} data - Texture data.
            * @param {function} cb - Callback to pass texture to.
            */
            loadVideo: function loadVideo(src, data, cb) {
              var hash;
              var texture;
              var textureCache = this.textureCache;
              var videoEl;
              var videoTextureResult;
              function handleVideoTextureLoaded(result) {
                result.texture.needsUpdate = true;
                cb(result.texture, result.videoEl);
              }

              // Video element provided.
              if (typeof src !== 'string') {
                // Check cache before creating texture.
                videoEl = src;
                hash = this.hashVideo(data, videoEl);
                if (textureCache[hash]) {
                  textureCache[hash].then(handleVideoTextureLoaded);
                  return;
                }
                // If not in cache, fix up the attributes then start to create the texture.
                fixVideoAttributes(videoEl);
              }

              // Only URL provided. Use video element to create texture.
              videoEl = videoEl || createVideoEl(src, data.width, data.height);

              // Generated video element already cached. Use that.
              hash = this.hashVideo(data, videoEl);
              if (textureCache[hash]) {
                textureCache[hash].then(handleVideoTextureLoaded);
                return;
              }

              // Create new video texture.
              texture = new THREE.VideoTexture(videoEl);
              texture.minFilter = THREE.LinearFilter;
              setTextureProperties(texture, data);

              // If iOS and video is HLS, do some hacks.
              if (this.sceneEl.isIOS && isHLS(videoEl.src || videoEl.getAttribute('src'), videoEl.type || videoEl.getAttribute('type'))) {
                // Actually BGRA. Tell shader to correct later.
                texture.format = THREE.RGBAFormat;
                texture.needsCorrectionBGRA = true;
                // Apparently needed for HLS. Tell shader to correct later.
                texture.flipY = false;
                texture.needsCorrectionFlipY = true;
              }

              // Cache as promise to be consistent with image texture caching.
              videoTextureResult = {
                texture: texture,
                videoEl: videoEl
              };
              textureCache[hash] = Promise.resolve(videoTextureResult);
              handleVideoTextureLoaded(videoTextureResult);
            },
            /**
             * Create a hash of the material properties for texture cache key.
             */
            hash: function hash(data) {
              if (data.src.tagName) {
                // Since `data.src` can be an element, parse out the string if necessary for the hash.
                data = utils.extendDeep({}, data);
                data.src = data.src.src;
              }
              return JSON.stringify(data);
            },
            hashVideo: function hashVideo(data, videoEl) {
              return calculateVideoCacheHash(data, videoEl);
            },
            /**
             * Keep track of material in case an update trigger is needed (e.g., fog).
             *
             * @param {object} material
             */
            registerMaterial: function registerMaterial(material) {
              this.materials[material.uuid] = material;
            },
            /**
             * Stop tracking material, and dispose of any textures not being used by
             * another material component.
             *
             * @param {object} material
             */
            unregisterMaterial: function unregisterMaterial(material) {
              delete this.materials[material.uuid];

              // If any textures on this material are no longer in use, dispose of them.
              var textureCounts = this.textureCounts;
              Object.keys(material).filter(function (propName) {
                return material[propName] && material[propName].isTexture;
              }).forEach(function (mapName) {
                textureCounts[material[mapName].uuid]--;
                if (textureCounts[material[mapName].uuid] <= 0) {
                  material[mapName].dispose();
                }
              });
            },
            /**
             * Trigger update to all registered materials.
             */
            updateMaterials: function updateMaterials(material) {
              var materials = this.materials;
              Object.keys(materials).forEach(function (uuid) {
                materials[uuid].needsUpdate = true;
              });
            },
            /**
             * Track textures used by material components, so that they can be safely
             * disposed when no longer in use. Textures must be registered here, and not
             * through registerMaterial(), because textures may not be attached at the
             * time the material is registered.
             *
             * @param {Event} e
             */
            onMaterialTextureLoaded: function onMaterialTextureLoaded(e) {
              if (!this.textureCounts[e.detail.texture.uuid]) {
                this.textureCounts[e.detail.texture.uuid] = 0;
              }
              this.textureCounts[e.detail.texture.uuid]++;
            }
          });

          /**
           * Calculates consistent hash from a video element using its attributes.
           * If the video element has an ID, use that.
           * Else build a hash that looks like `src:myvideo.mp4;height:200;width:400;`.
           *
           * @param data {object} - Texture data such as repeat.
           * @param videoEl {Element} - Video element.
           * @returns {string}
           */
          function calculateVideoCacheHash(data, videoEl) {
            var i;
            var id = videoEl.getAttribute('id');
            var hash;
            var videoAttributes;
            if (id) {
              return id;
            }

            // Calculate hash using sorted video attributes.
            hash = '';
            videoAttributes = data || {};
            for (i = 0; i < videoEl.attributes.length; i++) {
              videoAttributes[videoEl.attributes[i].name] = videoEl.attributes[i].value;
            }
            Object.keys(videoAttributes).sort().forEach(function (name) {
              hash += name + ':' + videoAttributes[name] + ';';
            });
            return hash;
          }

          /**
           * Load image texture.
           *
           * @private
           * @param {string|object} src - An <img> element or url to an image file.
           * @param {object} data - Data to set texture properties like `repeat`.
           * @returns {Promise} Resolves once texture is loaded.
           */
          function loadImageTexture(src, data) {
            return new Promise(doLoadImageTexture);
            function doLoadImageTexture(resolve, reject) {
              var isEl = typeof src !== 'string';
              function resolveTexture(texture) {
                setTextureProperties(texture, data);
                texture.needsUpdate = true;
                resolve(texture);
              }

              // Create texture from an element.
              if (isEl) {
                resolveTexture(new THREE.Texture(src));
                return;
              }

              // Request and load texture from src string. THREE will create underlying element.
              // Use THREE.TextureLoader (src, onLoad, onProgress, onError) to load texture.
              TextureLoader.load(src, resolveTexture, function () {/* no-op */}, function (xhr) {
                error('`$s` could not be fetched (Error code: %s; Response: %s)', xhr.status, xhr.statusText);
              });
            }
          }

          /**
           * Create video element to be used as a texture.
           *
           * @param {string} src - Url to a video file.
           * @param {number} width - Width of the video.
           * @param {number} height - Height of the video.
           * @returns {Element} Video element.
           */
          function createVideoEl(src, width, height) {
            var videoEl = document.createElement('video');
            videoEl.width = width;
            videoEl.height = height;
            // Support inline videos for iOS webviews.
            videoEl.setAttribute('playsinline', '');
            videoEl.setAttribute('webkit-playsinline', '');
            videoEl.autoplay = true;
            videoEl.loop = true;
            videoEl.crossOrigin = 'anonymous';
            videoEl.addEventListener('error', function () {
              warn('`$s` is not a valid video', src);
            }, true);
            videoEl.src = src;
            return videoEl;
          }

          /**
           * Fixes a video element's attributes to prevent developers from accidentally passing the
           * wrong attribute values to commonly misused video attributes.
           *
           * <video> does not treat `autoplay`, `controls`, `crossorigin`, `loop`, and `preload` as
           * as booleans. Existence of those attributes will mean truthy.
           *
           * For example, translates <video loop="false"> to <video>.
           *
           * @see https://developer.mozilla.org/docs/Web/HTML/Element/video#Attributes
           * @param {Element} videoEl - Video element.
           * @returns {Element} Video element with the correct properties updated.
           */
          function fixVideoAttributes(videoEl) {
            videoEl.autoplay = videoEl.hasAttribute('autoplay') && videoEl.getAttribute('autoplay') !== 'false';
            videoEl.controls = videoEl.hasAttribute('controls') && videoEl.getAttribute('controls') !== 'false';
            if (videoEl.getAttribute('loop') === 'false') {
              videoEl.removeAttribute('loop');
            }
            if (videoEl.getAttribute('preload') === 'false') {
              videoEl.preload = 'none';
            }
            videoEl.crossOrigin = videoEl.crossOrigin || 'anonymous';
            // To support inline videos in iOS webviews.
            videoEl.setAttribute('playsinline', '');
            videoEl.setAttribute('webkit-playsinline', '');
            return videoEl;
          }

          /***/
        },

        /***/"./src/systems/renderer.js":
        /*!*********************************!*\
          !*** ./src/systems/renderer.js ***!
          \*********************************/
        /***/
        function srcSystemsRendererJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var debug = utils.debug;
          var warn = debug('components:renderer:warn');

          /**
           * Determines state of various renderer properties.
           */
          module.exports.System = registerSystem('renderer', {
            schema: {
              antialias: {
                default: 'auto',
                oneOf: ['true', 'false', 'auto']
              },
              highRefreshRate: {
                default: utils.device.isOculusBrowser()
              },
              logarithmicDepthBuffer: {
                default: 'auto',
                oneOf: ['true', 'false', 'auto']
              },
              maxCanvasWidth: {
                default: 1920
              },
              maxCanvasHeight: {
                default: 1920
              },
              physicallyCorrectLights: {
                default: false
              },
              exposure: {
                default: 1,
                if: {
                  toneMapping: ['ACESFilmic', 'linear', 'reinhard', 'cineon']
                }
              },
              toneMapping: {
                default: 'no',
                oneOf: ['no', 'ACESFilmic', 'linear', 'reinhard', 'cineon']
              },
              precision: {
                default: 'high',
                oneOf: ['high', 'medium', 'low']
              },
              sortObjects: {
                default: false
              },
              colorManagement: {
                default: false
              },
              gammaOutput: {
                default: false
              },
              alpha: {
                default: true
              },
              foveationLevel: {
                default: 1
              }
            },
            init: function init() {
              var data = this.data;
              var sceneEl = this.el;
              var toneMappingName = this.data.toneMapping.charAt(0).toUpperCase() + this.data.toneMapping.slice(1);
              // This is the rendering engine, such as THREE.js so copy over any persistent properties from the rendering system.
              var renderer = sceneEl.renderer;
              renderer.sortObjects = data.sortObjects;
              renderer.physicallyCorrectLights = data.physicallyCorrectLights;
              renderer.toneMapping = THREE[toneMappingName + 'ToneMapping'];
              if (data.colorManagement || data.gammaOutput) {
                renderer.outputEncoding = THREE.sRGBEncoding;
                if (data.gammaOutput) {
                  warn('Property `gammaOutput` is deprecated. Use `renderer="colorManagement: true;"` instead.');
                }
              }
              if (sceneEl.hasAttribute('antialias')) {
                warn('Component `antialias` is deprecated. Use `renderer="antialias: true"` instead.');
              }
              if (sceneEl.hasAttribute('logarithmicDepthBuffer')) {
                warn('Component `logarithmicDepthBuffer` is deprecated. Use `renderer="logarithmicDepthBuffer: true"` instead.');
              }
            },
            update: function update() {
              var data = this.data;
              var sceneEl = this.el;
              var renderer = sceneEl.renderer;
              var toneMappingName = this.data.toneMapping.charAt(0).toUpperCase() + this.data.toneMapping.slice(1);
              renderer.toneMapping = THREE[toneMappingName + 'ToneMapping'];
              renderer.toneMappingExposure = data.exposure;
              renderer.xr.setFoveation(data.foveationLevel);
            },
            applyColorCorrection: function applyColorCorrection(colorOrTexture) {
              if (!this.data.colorManagement || !colorOrTexture) {
                return;
              } else if (colorOrTexture.isColor) {
                colorOrTexture.convertSRGBToLinear();
              } else if (colorOrTexture.isTexture) {
                colorOrTexture.encoding = THREE.sRGBEncoding;
              }
            }
          });

          /***/
        },

        /***/"./src/systems/shadow.js":
        /*!*******************************!*\
          !*** ./src/systems/shadow.js ***!
          \*******************************/
        /***/
        function srcSystemsShadowJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var SHADOW_MAP_TYPE_MAP = {
            basic: THREE.BasicShadowMap,
            pcf: THREE.PCFShadowMap,
            pcfsoft: THREE.PCFSoftShadowMap
          };

          /**
           * Shadow system.
           *
           * Enabled automatically when one or more shadow components are added to the scene, the system sets
           * options on the WebGLRenderer for configuring shadow appearance.
           */
          module.exports.System = registerSystem('shadow', {
            schema: {
              enabled: {
                default: true
              },
              autoUpdate: {
                default: true
              },
              type: {
                default: 'pcf',
                oneOf: ['basic', 'pcf', 'pcfsoft']
              }
            },
            init: function init() {
              var sceneEl = this.sceneEl;
              var data = this.data;
              this.shadowMapEnabled = false;
              if (!sceneEl.renderer) {
                return;
              } // For tests.

              sceneEl.renderer.shadowMap.type = SHADOW_MAP_TYPE_MAP[data.type];
              sceneEl.renderer.shadowMap.autoUpdate = data.autoUpdate;
              this.setShadowMapEnabled(this.shadowMapEnabled);
            },
            update: function update(prevData) {
              if (prevData.enabled !== this.data.enabled) {
                this.setShadowMapEnabled(this.data.enabled);
              }
            },
            /**
             * Enables/disables the renderer shadow map.
             * @param {boolean} enabled
             */
            setShadowMapEnabled: function setShadowMapEnabled(enabled) {
              var renderer = this.sceneEl.renderer;
              this.shadowMapEnabled = this.data.enabled && enabled;
              if (renderer) {
                renderer.shadowMap.enabled = this.shadowMapEnabled;
              }
            }
          });

          /***/
        },

        /***/"./src/systems/tracked-controls-webvr.js":
        /*!***********************************************!*\
          !*** ./src/systems/tracked-controls-webvr.js ***!
          \***********************************************/
        /***/
        function srcSystemsTrackedControlsWebvrJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var utils = __webpack_require__( /*! ../utils */"./src/utils/index.js");
          var isWebXRAvailable = utils.device.isWebXRAvailable;

          /**
           * Tracked controls system.
           * Maintain list with available tracked controllers.
           */
          module.exports.System = registerSystem('tracked-controls-webvr', {
            init: function init() {
              var self = this;
              this.controllers = [];
              this.isChrome = navigator.userAgent.indexOf('Chrome') !== -1;
              this.updateControllerList();
              this.throttledUpdateControllerList = utils.throttle(this.updateControllerList, 500, this);

              // Don't use WebVR if WebXR is available?
              if (isWebXRAvailable) {
                return;
              }
              if (!navigator.getVRDisplays) {
                return;
              }
              this.sceneEl.addEventListener('enter-vr', function () {
                navigator.getVRDisplays().then(function (displays) {
                  if (displays.length) {
                    self.vrDisplay = displays[0];
                  }
                });
              });
            },
            tick: function tick() {
              if (this.isChrome) {
                // Retrieve new controller handlers with updated state (pose, buttons...)
                this.updateControllerList();
              } else {
                this.throttledUpdateControllerList();
              }
            },
            /**
             * Update controller list.
             */
            updateControllerList: function updateControllerList() {
              var controllers = this.controllers;
              var gamepad;
              var gamepads;
              var i;
              var prevCount;
              gamepads = navigator.getGamepads && navigator.getGamepads();
              if (!gamepads) {
                return;
              }
              prevCount = controllers.length;
              controllers.length = 0;
              for (i = 0; i < gamepads.length; ++i) {
                gamepad = gamepads[i];
                if (gamepad && gamepad.pose) {
                  controllers.push(gamepad);
                }
              }
              if (controllers.length !== prevCount) {
                this.el.emit('controllersupdated', undefined, false);
              }
            }
          });

          /***/
        },

        /***/"./src/systems/tracked-controls-webxr.js":
        /*!***********************************************!*\
          !*** ./src/systems/tracked-controls-webxr.js ***!
          \***********************************************/
        /***/
        function srcSystemsTrackedControlsWebxrJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var utils = __webpack_require__( /*! ../utils */"./src/utils/index.js");

          /**
           * Tracked controls system.
           * Maintain list with available tracked controllers.
           */
          module.exports.System = registerSystem('tracked-controls-webxr', {
            init: function init() {
              this.controllers = [];
              this.oldControllers = [];
              this.oldControllersLength = 0;
              this.throttledUpdateControllerList = utils.throttle(this.updateControllerList, 500, this);
              this.updateReferenceSpace = this.updateReferenceSpace.bind(this);
              this.el.addEventListener('enter-vr', this.updateReferenceSpace);
              this.el.addEventListener('exit-vr', this.updateReferenceSpace);
            },
            tick: function tick() {
              this.throttledUpdateControllerList();
            },
            updateReferenceSpace: function updateReferenceSpace() {
              var self = this;
              var xrSession = this.el.xrSession;
              if (!xrSession) {
                this.referenceSpace = undefined;
                this.controllers = [];
                if (this.oldControllersLength > 0) {
                  this.oldControllersLength = 0;
                  this.el.emit('controllersupdated', undefined, false);
                }
                return;
              }
              var refspace = self.el.sceneEl.systems.webxr.sessionReferenceSpaceType;
              xrSession.requestReferenceSpace(refspace).then(function (referenceSpace) {
                self.referenceSpace = referenceSpace;
              }).catch(function (err) {
                self.el.sceneEl.systems.webxr.warnIfFeatureNotRequested(refspace, 'tracked-controls-webxr uses reference space "' + refspace + '".');
                throw err;
              });
            },
            updateControllerList: function updateControllerList() {
              var xrSession = this.el.xrSession;
              var oldControllers = this.oldControllers;
              var i;
              if (!xrSession) {
                if (this.oldControllersLength === 0) {
                  return;
                }
                // Broadcast that we now have zero controllers connected if there is
                // no session
                this.oldControllersLength = 0;
                this.controllers = [];
                this.el.emit('controllersupdated', undefined, false);
                return;
              }
              if (!xrSession.inputSources) {
                return;
              }
              this.controllers = xrSession.inputSources;
              if (this.oldControllersLength === this.controllers.length) {
                var equal = true;
                for (i = 0; i < this.controllers.length; ++i) {
                  if (this.controllers[i] === oldControllers[i] && this.controllers[i].gamepad === oldControllers[i].gamepad) {
                    continue;
                  }
                  equal = false;
                  break;
                }
                if (equal) {
                  return;
                }
              }

              // Store reference to current controllers
              oldControllers.length = 0;
              for (i = 0; i < this.controllers.length; i++) {
                oldControllers.push(this.controllers[i]);
              }
              this.oldControllersLength = this.controllers.length;
              this.el.emit('controllersupdated', undefined, false);
            }
          });

          /***/
        },

        /***/"./src/systems/webxr.js":
        /*!******************************!*\
          !*** ./src/systems/webxr.js ***!
          \******************************/
        /***/
        function srcSystemsWebxrJs(module, __unused_webpack_exports, __webpack_require__) {
          var registerSystem = __webpack_require__( /*! ../core/system */"./src/core/system.js").registerSystem;
          var utils = __webpack_require__( /*! ../utils/ */"./src/utils/index.js");
          var warn = utils.debug('systems:webxr:warn');

          /**
           * WebXR session initialization and XR module support.
           */
          module.exports.System = registerSystem('webxr', {
            schema: {
              referenceSpaceType: {
                type: 'string',
                default: 'local-floor'
              },
              requiredFeatures: {
                type: 'array',
                default: ['local-floor']
              },
              optionalFeatures: {
                type: 'array',
                default: ['bounded-floor']
              },
              overlayElement: {
                type: 'selector'
              }
            },
            update: function update() {
              var data = this.data;
              this.sessionConfiguration = {
                requiredFeatures: data.requiredFeatures,
                optionalFeatures: data.optionalFeatures
              };
              this.sessionReferenceSpaceType = data.referenceSpaceType;
              if (data.overlayElement) {
                // Update WebXR to support light-estimation
                data.overlayElement.classList.remove('a-dom-overlay');
                if (!data.optionalFeatures.includes('dom-overlay')) {
                  data.optionalFeatures.push('dom-overlay');
                  this.el.setAttribute('webxr', data);
                }
                this.warnIfFeatureNotRequested('dom-overlay');
                this.sessionConfiguration.domOverlay = {
                  root: data.overlayElement
                };
                data.overlayElement.classList.add('a-dom-overlay');
              }
            },
            wasFeatureRequested: function wasFeatureRequested(feature) {
              // Features available by default for immersive sessions don't need to
              // be requested explicitly.
              if (feature === 'viewer' || feature === 'local') {
                return true;
              }
              if (this.sessionConfiguration.requiredFeatures.includes(feature) || this.sessionConfiguration.optionalFeatures.includes(feature)) {
                return true;
              }
              return false;
            },
            warnIfFeatureNotRequested: function warnIfFeatureNotRequested(feature, optIntro) {
              if (!this.wasFeatureRequested(feature)) {
                var msg = 'Please add the feature "' + feature + '" to a-scene\'s ' + 'webxr system options in requiredFeatures/optionalFeatures.';
                warn((optIntro ? optIntro + ' ' : '') + msg);
              }
            }
          });

          /***/
        },

        /***/"./src/utils/bind.js":
        /*!***************************!*\
          !*** ./src/utils/bind.js ***!
          \***************************/
        /***/
        function srcUtilsBindJs(module) {
          /**
           * Faster version of Function.prototype.bind
           * @param {Function} fn - Function to wrap.
           * @param {Object} ctx - What to bind as context.
           * @param {...*} arguments - Arguments to pass through.
           */
          module.exports = function bind(fn, ctx /* , arg1, arg2 */) {
            return function (prependedArgs) {
              return function bound() {
                // Concat the bound function arguments with those passed to original bind
                var args = prependedArgs.concat(Array.prototype.slice.call(arguments, 0));
                return fn.apply(ctx, args);
              };
            }(Array.prototype.slice.call(arguments, 2));
          };

          /***/
        },

        /***/"./src/utils/coordinates.js":
        /*!**********************************!*\
          !*** ./src/utils/coordinates.js ***!
          \**********************************/
        /***/
        function srcUtilsCoordinatesJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global THREE */
          var debug = __webpack_require__( /*! ./debug */"./src/utils/debug.js");
          var extend = __webpack_require__( /*! object-assign */"./node_modules/object-assign/index.js");
          var warn = debug('utils:coordinates:warn');

          // Order of coordinates parsed by coordinates.parse.
          var COORDINATE_KEYS = ['x', 'y', 'z', 'w'];

          // Coordinate string regex. Handles negative, positive, and decimals.
          var regex = /^\s*((-?\d*\.{0,1}\d+(e-?\d+)?)\s+){2,3}(-?\d*\.{0,1}\d+(e-?\d+)?)\s*$/;
          module.exports.regex = regex;
          var OBJECT = 'object';
          var whitespaceRegex = /\s+/g;

          /**
           * Parses coordinates from an "x y z" string.
           * Example: "3 10 -5" to {x: 3, y: 10, z: -5}.
           *
           * @param {string} val - An "x y z" string.
           * @param {string} defaults - fallback value.
           * @returns {object} An object with keys [x, y, z].
           */
          function parse(value, defaultVec) {
            var coordinate;
            var defaultVal;
            var key;
            var i;
            var vec;
            var x;
            var y;
            var z;
            var w;
            if (value && value instanceof Object) {
              x = value.x === undefined ? defaultVec && defaultVec.x : value.x;
              y = value.y === undefined ? defaultVec && defaultVec.y : value.y;
              z = value.z === undefined ? defaultVec && defaultVec.z : value.z;
              w = value.w === undefined ? defaultVec && defaultVec.w : value.w;
              if (x !== undefined && x !== null) {
                value.x = parseIfString(x);
              }
              if (y !== undefined && y !== null) {
                value.y = parseIfString(y);
              }
              if (z !== undefined && z !== null) {
                value.z = parseIfString(z);
              }
              if (w !== undefined && w !== null) {
                value.w = parseIfString(w);
              }
              return value;
            }
            if (value === null || value === undefined) {
              return typeof defaultVec === OBJECT ? extend({}, defaultVec) : defaultVec;
            }
            coordinate = value.trim().split(whitespaceRegex);
            vec = {};
            for (i = 0; i < COORDINATE_KEYS.length; i++) {
              key = COORDINATE_KEYS[i];
              if (coordinate[i]) {
                vec[key] = parseFloat(coordinate[i], 10);
              } else {
                defaultVal = defaultVec && defaultVec[key];
                if (defaultVal === undefined) {
                  continue;
                }
                vec[key] = parseIfString(defaultVal);
              }
            }
            return vec;
          }
          module.exports.parse = parse;

          /**
           * Stringify coordinates from an object with keys [x y z].
           * Example: {x: 3, y: 10, z: -5} to "3 10 -5".
           *
           * @param {object|string} data - An object with keys [x y z].
           * @returns {string} An "x y z" string.
           */
          function stringify(data) {
            var str;
            if (typeof data !== OBJECT) {
              return data;
            }
            str = data.x + ' ' + data.y;
            if (data.z != null) {
              str += ' ' + data.z;
            }
            if (data.w != null) {
              str += ' ' + data.w;
            }
            return str;
          }
          module.exports.stringify = stringify;

          /**
           * @returns {bool}
           */
          function isCoordinates(value) {
            return regex.test(value);
          }
          module.exports.isCoordinates = isCoordinates;
          module.exports.isCoordinate = function (value) {
            warn('`AFRAME.utils.isCoordinate` has been renamed to `AFRAME.utils.isCoordinates`');
            return isCoordinates(value);
          };
          function parseIfString(val) {
            if (val !== null && val !== undefined && val.constructor === String) {
              return parseFloat(val, 10);
            }
            return val;
          }

          /**
           * Convert {x, y, z} object to three.js Vector3.
           */
          module.exports.toVector3 = function (vec3) {
            return new THREE.Vector3(vec3.x, vec3.y, vec3.z);
          };

          /***/
        },

        /***/"./src/utils/debug.js":
        /*!****************************!*\
          !*** ./src/utils/debug.js ***!
          \****************************/
        /***/
        function srcUtilsDebugJs(module, __unused_webpack_exports, __webpack_require__) {
          /* provided dependency */var process = __webpack_require__( /*! process/browser */"./node_modules/process/browser.js");
          var debugLib = __webpack_require__( /*! debug */"./node_modules/debug/browser.js");
          var extend = __webpack_require__( /*! object-assign */"./node_modules/object-assign/index.js");
          var settings = {
            colors: {
              debug: 'gray',
              error: 'red',
              info: 'gray',
              warn: 'orange'
            }
          };

          /**
           * Monkeypatches `debug` so we can colorize error/warning messages.
           *
           * (See issue: https://github.com/visionmedia/debug/issues/137)
           */
          var debug = function debug(namespace) {
            var d = debugLib(namespace);
            d.color = getDebugNamespaceColor(namespace);
            return d;
          };
          extend(debug, debugLib);

          /**
           * Returns the type of the namespace (e.g., `error`, `warn`).
           *
           * @param {String} namespace
           *   The debug logger's namespace (e.g., `components:geometry:warn`).
           * @returns {String} The type of the namespace (e.g., `warn`).
           * @api private
           */
          function getDebugNamespaceType(namespace) {
            var chunks = namespace.split(':');
            return chunks[chunks.length - 1]; // Return the last one
          }

          /**
           * Returns the color of the namespace (e.g., `orange`).
           *
           * @param {String} namespace
           *   The debug logger's namespace (e.g., `components:geometry:warn`).
           * @returns {String} The color of the namespace (e.g., `orange`).
           * @api private
           */
          function getDebugNamespaceColor(namespace) {
            var type = getDebugNamespaceType(namespace);
            var color = settings.colors && settings.colors[type];
            return color || null;
          }

          /**
           * Returns `localStorage` if possible.
           *
           * This is necessary because Safari throws when a user disables
           * cookies or `localStorage` and you attempt to access it.
           *
           * @returns {localStorage}
           * @api private
           */
          function storage() {
            try {
              return window.localStorage;
            } catch (e) {}
          }

          /**
           * To enable console logging, type this in the Console of your Dev Tools:
           *
           *   localStorage.logs = 1
           *
           * To disable console logging:
           *
           *   localStorage.logs = 0
           *
           */
          var ls = storage();
          if (ls && (parseInt(ls.logs, 10) || ls.logs === 'true')) {
            debug.enable('*');
          } else {
            debug.enable('*:error,*:info,*:warn');
          }
          if (process.browser) {
            window.logs = debug;
          }
          module.exports = debug;

          /***/
        },

        /***/"./src/utils/device.js":
        /*!*****************************!*\
          !*** ./src/utils/device.js ***!
          \*****************************/
        /***/
        function srcUtilsDeviceJs(module, __unused_webpack_exports, __webpack_require__) {
          /* provided dependency */var process = __webpack_require__( /*! process/browser */"./node_modules/process/browser.js");
          var error = __webpack_require__( /*! debug */"./node_modules/debug/browser.js")('device:error');
          var vrDisplay;
          var supportsVRSession = false;
          var supportsARSession = false;

          /**
           * Oculus Browser 7 doesn't support the WebXR gamepads module.
           * We fallback to WebVR API and will hotfix when implementation is complete.
           */
          var isWebXRAvailable = module.exports.isWebXRAvailable = !window.debug && navigator.xr !== undefined;

          // Catch vrdisplayactivate early to ensure we can enter VR mode after the scene loads.
          window.addEventListener('vrdisplayactivate', function (evt) {
            var canvasEl;
            // WebXR takes priority if available.
            if (isWebXRAvailable) {
              return;
            }
            canvasEl = document.createElement('canvas');
            vrDisplay = evt.display;
            // We need to make sure the canvas has a WebGL context associated with it.
            // Otherwise, the requestPresent could be denied.
            canvasEl.getContext('webgl', {});
            // Request present immediately. a-scene will be allowed to enter VR without user gesture.
            vrDisplay.requestPresent([{
              source: canvasEl
            }]).then(function () {}, function () {});
          });

          // Support both WebVR and WebXR APIs.
          if (isWebXRAvailable) {
            var updateEnterInterfaces = function updateEnterInterfaces() {
              var sceneEl = document.querySelector('a-scene');
              if (!sceneEl) {
                window.addEventListener('DOMContentLoaded', updateEnterInterfaces);
                return;
              }
              if (sceneEl.hasLoaded) {
                sceneEl.components['vr-mode-ui'].updateEnterInterfaces();
              } else {
                sceneEl.addEventListener('loaded', updateEnterInterfaces);
              }
            };
            var errorHandler = function errorHandler(err) {
              error('WebXR session support error: ' + err.message);
            };
            if (navigator.xr.isSessionSupported) {
              // Current WebXR spec uses a boolean-returning isSessionSupported promise
              navigator.xr.isSessionSupported('immersive-vr').then(function (supported) {
                supportsVRSession = supported;
                updateEnterInterfaces();
              }).catch(errorHandler);
              navigator.xr.isSessionSupported('immersive-ar').then(function (supported) {
                supportsARSession = supported;
                updateEnterInterfaces();
              }).catch(function () {});
            } else if (navigator.xr.supportsSession) {
              // Fallback for implementations that haven't updated to the new spec yet,
              // the old version used supportsSession which is rejected for missing
              // support.
              navigator.xr.supportsSession('immersive-vr').then(function () {
                supportsVRSession = true;
                updateEnterInterfaces();
              }).catch(errorHandler);
              navigator.xr.supportsSession('immersive-ar').then(function () {
                supportsARSession = true;
                updateEnterInterfaces();
              }).catch(function () {});
            } else {
              error('WebXR has neither isSessionSupported or supportsSession?!');
            }
          } else {
            if (navigator.getVRDisplays) {
              navigator.getVRDisplays().then(function (displays) {
                var sceneEl = document.querySelector('a-scene');
                vrDisplay = displays.length && displays[0];
                if (sceneEl) {
                  sceneEl.emit('displayconnected', {
                    vrDisplay: vrDisplay
                  });
                }
              });
            }
          }
          function getVRDisplay() {
            return vrDisplay;
          }
          module.exports.getVRDisplay = getVRDisplay;

          /**
           * Determine if a headset is connected by checking if a vrDisplay is available.
           */
          function checkHeadsetConnected() {
            return supportsVRSession || supportsARSession || !!getVRDisplay();
          }
          module.exports.checkHeadsetConnected = checkHeadsetConnected;
          function checkARSupport() {
            return supportsARSession;
          }
          module.exports.checkARSupport = checkARSupport;
          function checkVRSupport() {
            return supportsVRSession;
          }
          module.exports.checkVRSupport = checkVRSupport;

          /**
           * Checks if browser is mobile and not stand-alone dedicated vr device.
           * @return {Boolean} True if mobile browser detected.
           */
          var isMobile = function () {
            var _isMobile = false;
            (function (a) {
              // eslint-disable-next-line no-useless-escape
              if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                _isMobile = true;
              }
              if (isIOS() || isTablet() || isR7()) {
                _isMobile = true;
              }
              if (isMobileVR()) {
                _isMobile = false;
              }
            })(window.navigator.userAgent || window.navigator.vendor || window.opera);
            return function () {
              return _isMobile;
            };
          }();
          module.exports.isMobile = isMobile;

          /**
           *  Detect tablet devices.
           *  @param {string} mockUserAgent - Allow passing a mock user agent for testing.
           */
          function isTablet(mockUserAgent) {
            var userAgent = mockUserAgent || window.navigator.userAgent;
            return /ipad|Nexus (7|9)|xoom|sch-i800|playbook|tablet|kindle/i.test(userAgent);
          }
          module.exports.isTablet = isTablet;
          function isIOS() {
            return /iPad|iPhone|iPod/.test(window.navigator.platform);
          }
          module.exports.isIOS = isIOS;
          function isMobileDeviceRequestingDesktopSite() {
            return !isMobile() && !isMobileVR() && window.orientation !== undefined;
          }
          module.exports.isMobileDeviceRequestingDesktopSite = isMobileDeviceRequestingDesktopSite;

          /**
           *  Detect Oculus Browser (standalone headset)
           */
          function isOculusBrowser() {
            return /(OculusBrowser)/i.test(window.navigator.userAgent);
          }
          module.exports.isOculusBrowser = isOculusBrowser;

          /**
           *  Detect Firefox Reality (standalone headset)
           */
          function isFirefoxReality() {
            return /(Mobile VR)/i.test(window.navigator.userAgent);
          }
          module.exports.isFirefoxReality = isFirefoxReality;

          /**
           *  Detect browsers in Stand-Alone headsets
           */
          function isMobileVR() {
            return isOculusBrowser() || isFirefoxReality();
          }
          module.exports.isMobileVR = isMobileVR;
          function isR7() {
            return /R7 Build/.test(window.navigator.userAgent);
          }
          module.exports.isR7 = isR7;

          /**
           * Checks mobile device orientation.
           * @return {Boolean} True if landscape orientation.
           */
          module.exports.isLandscape = function () {
            var orientation = window.orientation;
            if (isR7()) {
              orientation += 90;
            }
            return orientation === 90 || orientation === -90;
          };

          /**
           * Check if running in a browser or spoofed browser (bundler).
           * We need to check a node api that isn't mocked on either side.
           * `require` and `module.exports` are mocked in browser by bundlers.
           * `window` is mocked in node.
           * `process` is also mocked by browserify, but has custom properties.
           */
          module.exports.isBrowserEnvironment = !!(!process || process.browser);

          /**
           * Check if running in node on the server.
           */
          module.exports.isNodeEnvironment = !module.exports.isBrowserEnvironment;

          /***/
        },

        /***/"./src/utils/entity.js":
        /*!*****************************!*\
          !*** ./src/utils/entity.js ***!
          \*****************************/
        /***/
        function srcUtilsEntityJs(module) {
          /**
           * Split a delimited component property string (e.g., `material.color`) to an object
           * containing `component` name and `property` name. If there is no delimiter, just return the
           * string back.
           *
           * Cache arrays from splitting strings via delimiter to save on memory.
           *
           * @param {string} str - e.g., `material.opacity`.
           * @param {string} delimiter - e.g., `.`.
           * @returns {array} e.g., `['material', 'opacity']`.
           */
          var propertyPathCache = {};
          function getComponentPropertyPath(str, delimiter) {
            delimiter = delimiter || '.';
            if (!propertyPathCache[delimiter]) {
              propertyPathCache[delimiter] = {};
            }
            if (str.indexOf(delimiter) !== -1) {
              propertyPathCache[delimiter][str] = str.split(delimiter);
            } else {
              propertyPathCache[delimiter][str] = str;
            }
            return propertyPathCache[delimiter][str];
          }
          module.exports.getComponentPropertyPath = getComponentPropertyPath;
          module.exports.propertyPathCache = propertyPathCache;

          /**
           * Get component property using encoded component name + component property name with a
           * delimiter.
           */
          module.exports.getComponentProperty = function (el, name, delimiter) {
            var splitName;
            delimiter = delimiter || '.';
            if (name.indexOf(delimiter) !== -1) {
              splitName = getComponentPropertyPath(name, delimiter);
              if (splitName.constructor === String) {
                return el.getAttribute(splitName);
              }
              return el.getAttribute(splitName[0])[splitName[1]];
            }
            return el.getAttribute(name);
          };

          /**
           * Set component property using encoded component name + component property name with a
           * delimiter.
           */
          module.exports.setComponentProperty = function (el, name, value, delimiter) {
            var splitName;
            delimiter = delimiter || '.';
            if (name.indexOf(delimiter) !== -1) {
              splitName = getComponentPropertyPath(name, delimiter);
              if (splitName.constructor === String) {
                el.setAttribute(splitName, value);
              } else {
                el.setAttribute(splitName[0], splitName[1], value);
              }
              return;
            }
            el.setAttribute(name, value);
          };

          /***/
        },

        /***/"./src/utils/forceCanvasResizeSafariMobile.js":
        /*!****************************************************!*\
          !*** ./src/utils/forceCanvasResizeSafariMobile.js ***!
          \****************************************************/
        /***/
        function srcUtilsForceCanvasResizeSafariMobileJs(module) {
          module.exports = function forceCanvasResizeSafariMobile(canvasEl) {
            var width = canvasEl.style.width;
            var height = canvasEl.style.height;
            // Taken from webvr-polyfill (https://github.com/borismus/webvr-polyfill/blob/85f657cd502ec9417bf26b87c3cb2afa6a70e079/src/util.js#L200)
            // iOS only workaround for https://bugs.webkit.org/show_bug.cgi?id=152556
            // By changing the size 1 pixel and restoring the previous value
            // we trigger a size recalculation cycle.
            canvasEl.style.width = parseInt(width, 10) + 1 + 'px';
            canvasEl.style.height = parseInt(height, 10) + 1 + 'px';
            setTimeout(function () {
              canvasEl.style.width = width;
              canvasEl.style.height = height;
            }, 200);
          };

          /***/
        },

        /***/"./src/utils/index.js":
        /*!****************************!*\
          !*** ./src/utils/index.js ***!
          \****************************/
        /***/
        function srcUtilsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global location */

          /* Centralized place to reference utilities since utils is exposed to the user. */
          var debug = __webpack_require__( /*! ./debug */"./src/utils/debug.js");
          var deepAssign = __webpack_require__( /*! deep-assign */"./node_modules/deep-assign/index.js");
          var device = __webpack_require__( /*! ./device */"./src/utils/device.js");
          var objectAssign = __webpack_require__( /*! object-assign */"./node_modules/object-assign/index.js");
          var objectPool = __webpack_require__( /*! ./object-pool */"./src/utils/object-pool.js");
          var warn = debug('utils:warn');
          module.exports.bind = __webpack_require__( /*! ./bind */"./src/utils/bind.js");
          module.exports.coordinates = __webpack_require__( /*! ./coordinates */"./src/utils/coordinates.js");
          module.exports.debug = debug;
          module.exports.device = device;
          module.exports.entity = __webpack_require__( /*! ./entity */"./src/utils/entity.js");
          module.exports.forceCanvasResizeSafariMobile = __webpack_require__( /*! ./forceCanvasResizeSafariMobile */"./src/utils/forceCanvasResizeSafariMobile.js");
          module.exports.isIE11 = __webpack_require__( /*! ./is-ie11 */"./src/utils/is-ie11.js");
          module.exports.material = __webpack_require__( /*! ./material */"./src/utils/material.js");
          module.exports.objectPool = objectPool;
          module.exports.split = __webpack_require__( /*! ./split */"./src/utils/split.js").split;
          module.exports.styleParser = __webpack_require__( /*! ./styleParser */"./src/utils/styleParser.js");
          module.exports.trackedControls = __webpack_require__( /*! ./tracked-controls */"./src/utils/tracked-controls.js");
          module.exports.checkHeadsetConnected = function () {
            warn('`utils.checkHeadsetConnected` has moved to `utils.device.checkHeadsetConnected`');
            return device.checkHeadsetConnected(arguments);
          };
          module.exports.isGearVR = module.exports.device.isGearVR = function () {
            warn('`utils.isGearVR` has been deprecated, use `utils.device.isMobileVR`');
          };
          module.exports.isIOS = function () {
            warn('`utils.isIOS` has moved to `utils.device.isIOS`');
            return device.isIOS(arguments);
          };
          module.exports.isOculusGo = module.exports.device.isOculusGo = function () {
            warn('`utils.isOculusGo` has been deprecated, use `utils.device.isMobileVR`');
          };
          module.exports.isMobile = function () {
            warn('`utils.isMobile has moved to `utils.device.isMobile`');
            return device.isMobile(arguments);
          };

          /**
           * Returns throttle function that gets called at most once every interval.
           *
           * @param {function} functionToThrottle
           * @param {number} minimumInterval - Minimal interval between calls (milliseconds).
           * @param {object} optionalContext - If given, bind function to throttle to this context.
           * @returns {function} Throttled function.
           */
          module.exports.throttle = function (functionToThrottle, minimumInterval, optionalContext) {
            var lastTime;
            if (optionalContext) {
              functionToThrottle = module.exports.bind(functionToThrottle, optionalContext);
            }
            return function () {
              var time = Date.now();
              var sinceLastTime = typeof lastTime === 'undefined' ? minimumInterval : time - lastTime;
              if (typeof lastTime === 'undefined' || sinceLastTime >= minimumInterval) {
                lastTime = time;
                functionToThrottle.apply(null, arguments);
              }
            };
          };

          /**
           * Returns throttle function that gets called at most once every interval.
           * If there are multiple calls in the last interval we call the function one additional
           * time.
           * It behaves like throttle except for the very last call that gets deferred until the end of the interval.
           * This is useful when an event is used to trigger synchronization of state, and there is a need to converge
           * to the correct final state following a burst of events.
           *
           * Example use cases:
           * - synchronizing state based on the componentchanged event
           * - following a mouse pointer using the mousemove event
           * - integrating with THREE.TransformControls, via the objectChange event.
           *
           * @param {function} functionToThrottle
           * @param {number} minimumInterval - Minimal interval between calls (milliseconds).
           * @param {object} optionalContext - If given, bind function to throttle to this context.
           * @returns {function} Throttled function.
           */
          module.exports.throttleLeadingAndTrailing = function (functionToThrottle, minimumInterval, optionalContext) {
            var lastTime;
            var deferTimer;
            if (optionalContext) {
              functionToThrottle = module.exports.bind(functionToThrottle, optionalContext);
            }
            return function () {
              var time = Date.now();
              var sinceLastTime = typeof lastTime === 'undefined' ? minimumInterval : time - lastTime;
              var args = arguments;
              if (typeof lastTime === 'undefined' || sinceLastTime >= minimumInterval) {
                clearTimeout(deferTimer);
                lastTime = time;
                functionToThrottle.apply(null, args);
              } else {
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function () {
                  lastTime = Date.now();
                  functionToThrottle.apply(this, args);
                }, minimumInterval - sinceLastTime);
              }
            };
          };

          /**
           * Returns throttle function that gets called at most once every interval.
           * Uses the time/timeDelta timestamps provided by the global render loop for better perf.
           *
           * @param {function} functionToThrottle
           * @param {number} minimumInterval - Minimal interval between calls (milliseconds).
           * @param {object} optionalContext - If given, bind function to throttle to this context.
           * @returns {function} Throttled function.
           */
          module.exports.throttleTick = function (functionToThrottle, minimumInterval, optionalContext) {
            var lastTime;
            if (optionalContext) {
              functionToThrottle = module.exports.bind(functionToThrottle, optionalContext);
            }
            return function (time, delta) {
              var sinceLastTime = typeof lastTime === 'undefined' ? delta : time - lastTime;
              if (typeof lastTime === 'undefined' || sinceLastTime >= minimumInterval) {
                lastTime = time;
                functionToThrottle(time, sinceLastTime);
              }
            };
          };

          /**
           * Returns debounce function that gets called only once after a set of repeated calls.
           *
           * @param {function} functionToDebounce
           * @param {number} wait - Time to wait for repeated function calls (milliseconds).
           * @param {boolean} immediate - Calls the function immediately regardless of if it should be waiting.
           * @returns {function} Debounced function.
           */
          module.exports.debounce = function (func, wait, immediate) {
            var timeout;
            return function () {
              var context = this;
              var args = arguments;
              var later = function later() {
                timeout = null;
                if (!immediate) func.apply(context, args);
              };
              var callNow = immediate && !timeout;
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
              if (callNow) func.apply(context, args);
            };
          };

          /**
           * Mix the properties of source object(s) into a destination object.
           *
           * @param  {object} dest - The object to which properties will be copied.
           * @param  {...object} source - The object(s) from which properties will be copied.
           */
          module.exports.extend = objectAssign;
          module.exports.extendDeep = deepAssign;
          module.exports.clone = function (obj) {
            return JSON.parse(JSON.stringify(obj));
          };

          /**
           * Checks if two values are equal.
           * Includes objects and arrays and nested objects and arrays.
           * Try to keep this function performant as it will be called often to see if a component
           * should be updated.
           *
           * @param {object} a - First object.
           * @param {object} b - Second object.
           * @returns {boolean} Whether two objects are deeply equal.
           */
          var deepEqual = function () {
            var arrayPool = objectPool.createPool(function () {
              return [];
            });
            return function (a, b) {
              var key;
              var keysA;
              var keysB;
              var i;
              var valA;
              var valB;

              // If not objects or arrays, compare as values.
              if (a === undefined || b === undefined || a === null || b === null || !(a && b && a.constructor === Object && b.constructor === Object || a.constructor === Array && b.constructor === Array)) {
                return a === b;
              }

              // Different number of keys, not equal.
              keysA = arrayPool.use();
              keysB = arrayPool.use();
              keysA.length = 0;
              keysB.length = 0;
              for (key in a) {
                keysA.push(key);
              }
              for (key in b) {
                keysB.push(key);
              }
              if (keysA.length !== keysB.length) {
                arrayPool.recycle(keysA);
                arrayPool.recycle(keysB);
                return false;
              }

              // Return `false` at the first sign of inequality.
              for (i = 0; i < keysA.length; ++i) {
                valA = a[keysA[i]];
                valB = b[keysA[i]];
                // Check nested array and object.
                if (typeof valA === 'object' || typeof valB === 'object' || Array.isArray(valA) && Array.isArray(valB)) {
                  if (valA === valB) {
                    continue;
                  }
                  if (!deepEqual(valA, valB)) {
                    arrayPool.recycle(keysA);
                    arrayPool.recycle(keysB);
                    return false;
                  }
                } else if (valA !== valB) {
                  arrayPool.recycle(keysA);
                  arrayPool.recycle(keysB);
                  return false;
                }
              }
              arrayPool.recycle(keysA);
              arrayPool.recycle(keysB);
              return true;
            };
          }();
          module.exports.deepEqual = deepEqual;

          /**
           * Computes the difference between two objects.
           *
           * @param {object} a - First object to compare (e.g., oldData).
           * @param {object} b - Second object to compare (e.g., newData).
           * @returns {object}
           *   Difference object where set of keys note which values were not equal, and values are
           *   `b`'s values.
           */
          module.exports.diff = function () {
            var keys = [];
            return function (a, b, targetObject) {
              var aVal;
              var bVal;
              var bKey;
              var diff;
              var key;
              var i;
              var isComparingObjects;
              diff = targetObject || {};

              // Collect A keys.
              keys.length = 0;
              for (key in a) {
                keys.push(key);
              }
              if (!b) {
                return diff;
              }

              // Collect B keys.
              for (bKey in b) {
                if (keys.indexOf(bKey) === -1) {
                  keys.push(bKey);
                }
              }
              for (i = 0; i < keys.length; i++) {
                key = keys[i];
                aVal = a[key];
                bVal = b[key];
                isComparingObjects = aVal && bVal && aVal.constructor === Object && bVal.constructor === Object;
                if (isComparingObjects && !deepEqual(aVal, bVal) || !isComparingObjects && aVal !== bVal) {
                  diff[key] = bVal;
                }
              }
              return diff;
            };
          }();

          /**
           * Returns whether we should capture this keyboard event for keyboard shortcuts.
           * @param {Event} event Event object.
           * @returns {Boolean} Whether the key event should be captured.
           */
          module.exports.shouldCaptureKeyEvent = function (event) {
            if (event.metaKey) {
              return false;
            }
            return document.activeElement === document.body;
          };

          /**
           * Splits a string into an array based on a delimiter.
           *
           * @param   {string=} [str='']        Source string
           * @param   {string=} [delimiter=' '] Delimiter to use
           * @returns {array}                   Array of delimited strings
           */
          module.exports.splitString = function (str, delimiter) {
            if (typeof delimiter === 'undefined') {
              delimiter = ' ';
            }
            // First collapse the whitespace (or whatever the delimiter is).
            var regex = new RegExp(delimiter, 'g');
            str = (str || '').replace(regex, delimiter);
            // Then split.
            return str.split(delimiter);
          };

          /**
           * Extracts data from the element given an object that contains expected keys.
           *
           * @param {Element} Source element.
           * @param {Object} [defaults={}] Object of default key-value pairs.
           * @returns {Object}
           */
          module.exports.getElData = function (el, defaults) {
            defaults = defaults || {};
            var data = {};
            Object.keys(defaults).forEach(copyAttribute);
            function copyAttribute(key) {
              if (el.hasAttribute(key)) {
                data[key] = el.getAttribute(key);
              }
            }
            return data;
          };

          /**
           * Retrieves querystring value.
           * @param  {String} name Name of querystring key.
           * @return {String}      Value
           */
          module.exports.getUrlParameter = function (name) {
            // eslint-disable-next-line no-useless-escape
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
          };

          /**
           * Detects whether context is within iframe.
           */
          module.exports.isIframed = function () {
            return window.top !== window.self;
          };

          /**
           * Finds all elements under the element that have the isScene
           * property set to true
           */
          module.exports.findAllScenes = function (el) {
            var matchingElements = [];
            var allElements = el.getElementsByTagName('*');
            for (var i = 0, n = allElements.length; i < n; i++) {
              if (allElements[i].isScene) {
                // Element exists with isScene set.
                matchingElements.push(allElements[i]);
              }
            }
            return matchingElements;
          };

          // Must be at bottom to avoid circular dependency.
          module.exports.srcLoader = __webpack_require__( /*! ./src-loader */"./src/utils/src-loader.js");

          /***/
        },

        /***/"./src/utils/ios-orientationchange-blank-bug.js":
        /*!******************************************************!*\
          !*** ./src/utils/ios-orientationchange-blank-bug.js ***!
          \******************************************************/
        /***/
        function srcUtilsIosOrientationchangeBlankBugJs() {
          // Safari regression introduced in iOS 12 and remains in iOS 13.
          // https://stackoverflow.com/questions/62717621/white-space-at-page-bottom-after-device-rotation-in-ios-safari
          window.addEventListener('orientationchange', function () {
            document.documentElement.style.height = 'initial';
            setTimeout(function () {
              document.documentElement.style.height = '100%';
              setTimeout(function () {
                // this line prevents the content
                // from hiding behind the address bar
                window.scrollTo(0, 1);
              }, 500);
            }, 500);
          });

          /***/
        },

        /***/"./src/utils/is-ie11.js":
        /*!******************************!*\
          !*** ./src/utils/is-ie11.js ***!
          \******************************/
        /***/
        function srcUtilsIsIe11Js(module) {
          // https://stackoverflow.com/a/17907562
          function getInternetExplorerVersion() {
            var version = -1;
            var userAgent = navigator.userAgent;
            var re;
            if (navigator.appName === 'Microsoft Internet Explorer') {
              re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
              if (re.exec(userAgent) != null) {
                version = parseFloat(RegExp.$1);
              }
            } else if (navigator.appName === 'Netscape') {
              re = new RegExp('Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})');
              if (re.exec(userAgent) != null) {
                version = parseFloat(RegExp.$1);
              }
            }
            return version;
          }
          module.exports = getInternetExplorerVersion() === 11;

          /***/
        },

        /***/"./src/utils/isIOSOlderThan10.js":
        /*!***************************************!*\
          !*** ./src/utils/isIOSOlderThan10.js ***!
          \***************************************/
        /***/
        function srcUtilsIsIOSOlderThan10Js(module) {
          /**
           * Check if device is iOS and older than version 10.
           */
          module.exports = function isIOSOlderThan10(userAgent) {
            return /(iphone|ipod|ipad).*os.(7_|8_|9_)/i.test(userAgent);
          };

          /***/
        },

        /***/"./src/utils/material.js":
        /*!*******************************!*\
          !*** ./src/utils/material.js ***!
          \*******************************/
        /***/
        function srcUtilsMaterialJs(module, __unused_webpack_exports, __webpack_require__) {
          var THREE = __webpack_require__( /*! ../lib/three */"./src/lib/three.js");
          var HLS_MIMETYPES = ['application/x-mpegurl', 'application/vnd.apple.mpegurl'];
          var COLOR_MAPS = new Set(['emissiveMap', 'envMap', 'map', 'specularMap']);

          /**
           * Set texture properties such as repeat and offset.
           *
           * @param {object} data - With keys like `repeat`.
          */
          function setTextureProperties(texture, data) {
            var offset = data.offset || {
              x: 0,
              y: 0
            };
            var repeat = data.repeat || {
              x: 1,
              y: 1
            };
            var npot = data.npot || false;
            // To support NPOT textures, wrap must be ClampToEdge (not Repeat),
            // and filters must not use mipmaps (i.e. Nearest or Linear).
            if (npot) {
              texture.wrapS = THREE.ClampToEdgeWrapping;
              texture.wrapT = THREE.ClampToEdgeWrapping;
              texture.magFilter = THREE.LinearFilter;
              texture.minFilter = THREE.LinearFilter;
            }

            // Don't bother setting repeat if it is 1/1. Power-of-two is required to repeat.
            if (repeat.x !== 1 || repeat.y !== 1) {
              texture.wrapS = THREE.RepeatWrapping;
              texture.wrapT = THREE.RepeatWrapping;
              texture.repeat.set(repeat.x, repeat.y);
            }
            // Don't bother setting offset if it is 0/0.
            if (offset.x !== 0 || offset.y !== 0) {
              texture.offset.set(offset.x, offset.y);
            }
          }
          module.exports.setTextureProperties = setTextureProperties;

          /**
           * Update `material` texture property (usually but not always `map`)
           * from `data` property (usually but not always `src`).
           *
           * @param {object} shader - A-Frame shader instance.
           * @param {object} data
           */
          module.exports.updateMapMaterialFromData = function (materialName, dataName, shader, data) {
            var el = shader.el;
            var material = shader.material;
            var rendererSystem = el.sceneEl.systems.renderer;
            var src = data[dataName];

            // Because a single material / shader may have multiple textures,
            // we need to remember the source value for this data property
            // to avoid redundant operations which can be expensive otherwise
            // (e.g. video texture loads).
            if (!shader.materialSrcs) {
              shader.materialSrcs = {};
            }
            if (!src) {
              // Forget the prior material src.
              delete shader.materialSrcs[materialName];
              // Remove the texture.
              setMap(null);
              return;
            }

            // If material src hasn't changed, and we already have a texture,
            // just update properties, but don't reload the texture.
            if (src === shader.materialSrcs[materialName] && material[materialName]) {
              setTextureProperties(material[materialName], data);
              return;
            }

            // Remember the new src for this texture (there may be multiple).
            shader.materialSrcs[materialName] = src;

            // If the new material src is already a texture, just use it.
            if (src instanceof THREE.Texture) {
              setMap(src);
            } else {
              // Load texture for the new material src.
              // (And check if we should still use it once available in callback.)
              el.sceneEl.systems.material.loadTexture(src, {
                src: src,
                repeat: data.repeat,
                offset: data.offset,
                npot: data.npot
              }, checkSetMap);
            }
            function checkSetMap(texture) {
              // If the source has been changed, don't use loaded texture.
              if (shader.materialSrcs[materialName] !== src) {
                return;
              }
              setMap(texture);
            }
            function setMap(texture) {
              material[materialName] = texture;
              if (texture && COLOR_MAPS.has(materialName)) {
                rendererSystem.applyColorCorrection(texture);
              }
              material.needsUpdate = true;
              handleTextureEvents(el, texture);
            }
          };

          /**
           * Update `material.map` given `data.src`. For standard and flat shaders.
           *
           * @param {object} shader - A-Frame shader instance.
           * @param {object} data
           */
          module.exports.updateMap = function (shader, data) {
            return module.exports.updateMapMaterialFromData('map', 'src', shader, data);
          };

          /**
           * Updates the material's maps which give the illusion of extra geometry.
           *
           * @param {string} longType - The friendly name of the map from the component e.g. ambientOcclusionMap becomes aoMap in THREE.js
           * @param {object} shader - A-Frame shader instance
           * @param {object} data
           */
          module.exports.updateDistortionMap = function (longType, shader, data) {
            var shortType = longType;
            if (longType === 'ambientOcclusion') {
              shortType = 'ao';
            }
            var el = shader.el;
            var material = shader.material;
            var rendererSystem = el.sceneEl.systems.renderer;
            var src = data[longType + 'Map'];
            var info = {};
            info.src = src;

            // Pass through the repeat and offset to be handled by the material loader.
            info.offset = data[longType + 'TextureOffset'];
            info.repeat = data[longType + 'TextureRepeat'];
            info.wrap = data[longType + 'TextureWrap'];
            if (src) {
              if (src === shader[longType + 'TextureSrc']) {
                return;
              }

              // Texture added or changed.
              shader[longType + 'TextureSrc'] = src;
              el.sceneEl.systems.material.loadTexture(src, info, setMap);
              return;
            }

            // Texture removed.
            if (!material.map) {
              return;
            }
            setMap(null);
            function setMap(texture) {
              var slot = shortType + 'Map';
              material[slot] = texture;
              if (texture && COLOR_MAPS.has(slot)) {
                rendererSystem.applyColorCorrection(texture);
              }
              if (texture) {
                setTextureProperties(texture, data);
              }
              material.needsUpdate = true;
              handleTextureEvents(el, texture);
            }
          };

          /**
           * Emit event on entities on texture-related events.
           *
           * @param {Element} el - Entity.
           * @param {object} texture - three.js Texture.
           */
          function handleTextureEvents(el, texture) {
            if (!texture) {
              return;
            }
            el.emit('materialtextureloaded', {
              src: texture.image,
              texture: texture
            });

            // Video events.
            if (!texture.image || texture.image.tagName !== 'VIDEO') {
              return;
            }
            texture.image.addEventListener('loadeddata', function emitVideoTextureLoadedDataAll() {
              // Check to see if we need to use iOS 10 HLS shader.
              // Only override the shader if it is stock shader that we know doesn't correct.
              if (!el.components || !el.components.material) {
                return;
              }
              if (texture.needsCorrectionBGRA && texture.needsCorrectionFlipY && ['standard', 'flat'].indexOf(el.components.material.data.shader) !== -1) {
                el.setAttribute('material', 'shader', 'ios10hls');
              }
              el.emit('materialvideoloadeddata', {
                src: texture.image,
                texture: texture
              });
            });
            texture.image.addEventListener('ended', function emitVideoTextureEndedAll() {
              // Works for non-looping videos only.
              el.emit('materialvideoended', {
                src: texture.image,
                texture: texture
              });
            });
          }
          module.exports.handleTextureEvents = handleTextureEvents;

          /**
           * Given video element src and type, guess whether stream is HLS.
           *
           * @param {string} src - src from video element (generally URL to content).
           * @param {string} type - type from video element (generally MIME type if present).
           */
          module.exports.isHLS = function (src, type) {
            if (type && HLS_MIMETYPES.includes(type.toLowerCase())) {
              return true;
            }
            if (src && src.toLowerCase().indexOf('.m3u8') > 0) {
              return true;
            }
            return false;
          };

          /***/
        },

        /***/"./src/utils/math.js":
        /*!***************************!*\
          !*** ./src/utils/math.js ***!
          \***************************/
        /***/
        function srcUtilsMathJs(module) {
          /**
           * Find the disatance from a plane defined by a point on the plane and the normal of the plane to any point.
           * @param {THREE.Vector3} positionOnPlane any point on the plane.
           * @param {THREE.Vector3} planeNormal the normal of the plane
           * @param {THREE.Vector3} pointToTest point to test
           * @returns Number
           */
          function distanceOfPointFromPlane(positionOnPlane, planeNormal, pointToTest) {
            // the d value in the plane equation a*x + b*y + c*z=d
            var d = planeNormal.dot(positionOnPlane);

            // distance of point from plane
            return (d - planeNormal.dot(pointToTest)) / planeNormal.length();
          }

          /**
           * Find the point on a plane that lies closest to
           * @param {THREE.Vector3} positionOnPlane any point on the plane.
           * @param {THREE.Vector3} planeNormal the normal of the plane
           * @param {THREE.Vector3} pointToTest point to test
           * @param {THREE.Vector3} resultPoint where to store the result.
           * @returns
           */
          function nearestPointInPlane(positionOnPlane, planeNormal, pointToTest, resultPoint) {
            var t = distanceOfPointFromPlane(positionOnPlane, planeNormal, pointToTest);
            // closest point on the plane
            resultPoint.copy(planeNormal);
            resultPoint.multiplyScalar(t);
            resultPoint.add(pointToTest);
            return resultPoint;
          }
          module.exports.distanceOfPointFromPlane = distanceOfPointFromPlane;
          module.exports.nearestPointInPlane = nearestPointInPlane;

          /***/
        },

        /***/"./src/utils/object-pool.js":
        /*!**********************************!*\
          !*** ./src/utils/object-pool.js ***!
          \**********************************/
        /***/
        function srcUtilsObjectPoolJs(module) {
          /*
            Adapted deePool by Kyle Simpson.
            MIT License: http://getify.mit-license.org
          */
          var EMPTY_SLOT = Object.freeze(Object.create(null));

          // Default object factory.
          function defaultObjectFactory() {
            return {};
          }

          /**
           * Create a new pool.
           */
          module.exports.createPool = function createPool(objectFactory) {
            var objPool = [];
            var nextFreeSlot = null; // Pool location to look for a free object to use.

            objectFactory = objectFactory || defaultObjectFactory;
            function use() {
              var objToUse;
              if (nextFreeSlot === null || nextFreeSlot === objPool.length) {
                grow(objPool.length || 5);
              }
              objToUse = objPool[nextFreeSlot];
              objPool[nextFreeSlot++] = EMPTY_SLOT;
              clearObject(objToUse);
              return objToUse;
            }
            function recycle(obj) {
              if (!(obj instanceof Object)) {
                return;
              }
              if (nextFreeSlot === null || nextFreeSlot === -1) {
                objPool[objPool.length] = obj;
                return;
              }
              objPool[--nextFreeSlot] = obj;
            }
            function grow(count) {
              var currentLength;
              var i;
              count = count === undefined ? objPool.length : count;
              if (count > 0 && nextFreeSlot == null) {
                nextFreeSlot = 0;
              }
              if (count > 0) {
                currentLength = objPool.length;
                objPool.length += Number(count);
                for (i = currentLength; i < objPool.length; i++) {
                  // Add new obj to pool.
                  objPool[i] = objectFactory();
                }
              }
              return objPool.length;
            }
            function size() {
              return objPool.length;
            }
            return {
              grow: grow,
              pool: objPool,
              recycle: recycle,
              size: size,
              use: use
            };
          };
          function clearObject(obj) {
            var key;
            if (!obj || obj.constructor !== Object) {
              return;
            }
            for (key in obj) {
              obj[key] = undefined;
            }
          }
          module.exports.clearObject = clearObject;
          function removeUnusedKeys(obj, schema) {
            var key;
            if (!obj || obj.constructor !== Object) {
              return;
            }
            for (key in obj) {
              if (!(key in schema)) {
                delete obj[key];
              }
            }
          }
          module.exports.removeUnusedKeys = removeUnusedKeys;

          /***/
        },

        /***/"./src/utils/split.js":
        /*!****************************!*\
          !*** ./src/utils/split.js ***!
          \****************************/
        /***/
        function srcUtilsSplitJs(module) {
          /**
           * String split with cached result.
           */
          module.exports.split = function () {
            var splitCache = {};
            return function (str, delimiter) {
              if (!(delimiter in splitCache)) {
                splitCache[delimiter] = {};
              }
              if (str in splitCache[delimiter]) {
                return splitCache[delimiter][str];
              }
              splitCache[delimiter][str] = str.split(delimiter);
              return splitCache[delimiter][str];
            };
          }();

          /***/
        },

        /***/"./src/utils/src-loader.js":
        /*!*********************************!*\
          !*** ./src/utils/src-loader.js ***!
          \*********************************/
        /***/
        function srcUtilsSrcLoaderJs(module, __unused_webpack_exports, __webpack_require__) {
          /* global Image, XMLHttpRequest */
          var debug = __webpack_require__( /*! ./debug */"./src/utils/debug.js");
          var warn = debug('utils:src-loader:warn');

          /**
           * Validate a texture, either as a selector or as a URL.
           * Detects whether `src` is pointing to an image or video and invokes the appropriate
           * callback.
           *
           * `src` will be passed into the callback
           *
           * @params {string|Element} src - URL or media element.
           * @params {function} isImageCb - callback if texture is an image.
           * @params {function} isVideoCb - callback if texture is a video.
           */
          function validateSrc(src, isImageCb, isVideoCb) {
            checkIsImage(src, function isAnImageUrl(isImage) {
              if (isImage) {
                isImageCb(src);
                return;
              }
              isVideoCb(src);
            });
          }

          /**
           * Validates six images as a cubemap, either as selector or comma-separated
           * URLs.
           *
           * @param {string} src - A selector or comma-separated image URLs. Image URLs
                    must be wrapped by `url()`.
           * @param {string} src - A selector or comma-separated image URLs. Image URLs
                    must be wrapped by `url()`.
           */
          function validateCubemapSrc(src, cb) {
            var aCubemap;
            var cubemapSrcRegex = '';
            var i;
            var urls;
            var validatedUrls = [];
            for (i = 0; i < 5; i++) {
              cubemapSrcRegex += '(url\\((?:[^\\)]+)\\),\\s*)';
            }
            cubemapSrcRegex += '(url\\((?:[^\\)]+)\\)\\s*)';
            urls = src.match(new RegExp(cubemapSrcRegex));

            // `src` is a comma-separated list of URLs.
            // In this case, re-use validateSrc for each side of the cube.
            function isImageCb(url) {
              validatedUrls.push(url);
              if (validatedUrls.length === 6) {
                cb(validatedUrls);
              }
            }
            if (urls) {
              for (i = 1; i < 7; i++) {
                validateSrc(parseUrl(urls[i]), isImageCb);
              }
              return;
            }

            // `src` is a query selector to <a-cubemap> containing six $([src])s.
            aCubemap = validateAndGetQuerySelector(src);
            if (!aCubemap) {
              return;
            }
            if (aCubemap.tagName === 'A-CUBEMAP' && aCubemap.srcs) {
              return cb(aCubemap.srcs);
            }
            // Else if aCubeMap is not a <a-cubemap>.
            warn('Selector "%s" does not point to <a-cubemap>', src);
          }

          /**
           * Parses src from `url(src)`.
           * @param  {string} src - String to parse.
           * @return {string} The parsed src, if parseable.
           */
          function parseUrl(src) {
            var parsedSrc = src.match(/\url\((.+)\)/);
            if (!parsedSrc) {
              return;
            }
            return parsedSrc[1];
          }

          /**
           * Call back whether `src` is an image.
           *
           * @param {string|Element} src - URL or element that will be tested.
           * @param {function} onResult - Callback with whether `src` is an image.
           */
          function checkIsImage(src, onResult) {
            var request;
            if (src.tagName) {
              onResult(src.tagName === 'IMG');
              return;
            }
            request = new XMLHttpRequest();

            // Try to send HEAD request to check if image first.
            request.open('HEAD', src);
            request.addEventListener('load', function (event) {
              var contentType;
              if (request.status >= 200 && request.status < 300) {
                contentType = request.getResponseHeader('Content-Type');
                if (contentType == null) {
                  checkIsImageFallback(src, onResult);
                } else {
                  if (contentType.startsWith('image')) {
                    onResult(true);
                  } else {
                    onResult(false);
                  }
                }
              } else {
                checkIsImageFallback(src, onResult);
              }
              request.abort();
            });
            request.send();
          }
          function checkIsImageFallback(src, onResult) {
            var tester = new Image();
            tester.addEventListener('load', onLoad);
            function onLoad() {
              onResult(true);
            }
            tester.addEventListener('error', onError);
            function onError() {
              onResult(false);
            }
            tester.src = src;
          }

          /**
           * Query and validate a query selector,
           *
           * @param  {string} selector - DOM selector.
           * @return {object|null|undefined} Selected DOM element if exists.
                     null if query yields no results.
                     undefined if `selector` is not a valid selector.
           */
          function validateAndGetQuerySelector(selector) {
            try {
              var el = document.querySelector(selector);
              if (!el) {
                warn('No element was found matching the selector: "%s"', selector);
              }
              return el;
            } catch (e) {
              // Capture exception if it's not a valid selector.
              warn('"%s" is not a valid selector', selector);
              return undefined;
            }
          }
          module.exports = {
            parseUrl: parseUrl,
            validateSrc: validateSrc,
            validateCubemapSrc: validateCubemapSrc
          };

          /***/
        },

        /***/"./src/utils/styleParser.js":
        /*!**********************************!*\
          !*** ./src/utils/styleParser.js ***!
          \**********************************/
        /***/
        function srcUtilsStyleParserJs(module) {
          /**
           * Utils for parsing style-like strings (e.g., "primitive: box; width: 5; height: 4.5").
           * Some code adapted from `style-attr` (https://github.com/joshwnj/style-attr)
           * by Josh Johnston (MIT License).
           */
          var DASH_REGEX = /-([a-z])/g;

          /**
           * Deserialize style-like string into an object of properties.
           *
           * @param {string} value - HTML attribute value.
           * @param {object} obj - Reused object for object pooling.
           * @returns {object} Property data.
           */
          module.exports.parse = function (value, obj) {
            var parsedData;
            if (typeof value !== 'string') {
              return value;
            }
            parsedData = styleParse(value, obj);
            // The style parser returns an object { "" : "test"} when fed a string
            if (parsedData['']) {
              return value;
            }
            return transformKeysToCamelCase(parsedData);
          };

          /**
           * Serialize an object of properties into a style-like string.
           *
           * @param {object} data - Property data.
           * @returns {string}
           */
          module.exports.stringify = function (data) {
            if (typeof data === 'string') {
              return data;
            }
            return styleStringify(data);
          };

          /**
           * Converts string from hyphen to camelCase.
           *
           * @param {string} str - String to camelCase.
           * @return {string} CamelCased string.
           */
          function toCamelCase(str) {
            return str.replace(DASH_REGEX, upperCase);
          }
          module.exports.toCamelCase = toCamelCase;

          /**
           * Converts object's keys from hyphens to camelCase (e.g., `max-value` to
           * `maxValue`).
           *
           * @param {object} obj - The object to camelCase keys.
           * @return {object} The object with keys camelCased.
           */
          function transformKeysToCamelCase(obj) {
            var camelKey;
            var key;
            for (key in obj) {
              camelKey = toCamelCase(key);
              if (key === camelKey) {
                continue;
              }
              obj[camelKey] = obj[key];
              delete obj[key];
            }
            return obj;
          }
          module.exports.transformKeysToCamelCase = transformKeysToCamelCase;

          /**
           * Split a string into chunks matching `<key>: <value>`
           */
          var getKeyValueChunks = function () {
            var chunks = [];
            var hasUnclosedUrl = /url\([^)]+$/;
            return function getKeyValueChunks(raw) {
              var chunk = '';
              var nextSplit;
              var offset = 0;
              var sep = ';';
              chunks.length = 0;
              while (offset < raw.length) {
                nextSplit = raw.indexOf(sep, offset);
                if (nextSplit === -1) {
                  nextSplit = raw.length;
                }
                chunk += raw.substring(offset, nextSplit);

                // data URIs can contain semicolons, so make sure we get the whole thing
                if (hasUnclosedUrl.test(chunk)) {
                  chunk += ';';
                  offset = nextSplit + 1;
                  continue;
                }
                chunks.push(chunk.trim());
                chunk = '';
                offset = nextSplit + 1;
              }
              return chunks;
            };
          }();

          /**
           * Convert a style attribute string to an object.
           *
           * @param {object} str - Attribute string.
           * @param {object} obj - Object to reuse as a base, else a new one will be allocated.
           */
          function styleParse(str, obj) {
            var chunks;
            var i;
            var item;
            var pos;
            var key;
            var val;
            obj = obj || {};
            chunks = getKeyValueChunks(str);
            for (i = 0; i < chunks.length; i++) {
              item = chunks[i];
              if (!item) {
                continue;
              }
              // Split with `.indexOf` rather than `.split` because the value may also contain colons.
              pos = item.indexOf(':');
              key = item.substr(0, pos).trim();
              val = item.substr(pos + 1).trim();
              obj[key] = val;
            }
            return obj;
          }

          /**
           * Convert an object into an attribute string
           **/
          function styleStringify(obj) {
            var key;
            var keyCount = 0;
            var i = 0;
            var str = '';
            for (key in obj) {
              keyCount++;
            }
            for (key in obj) {
              str += key + ': ' + obj[key];
              if (i < keyCount - 1) {
                str += '; ';
              }
              i++;
            }
            return str;
          }
          function upperCase(str) {
            return str[1].toUpperCase();
          }

          /***/
        },

        /***/"./src/utils/tracked-controls.js":
        /*!***************************************!*\
          !*** ./src/utils/tracked-controls.js ***!
          \***************************************/
        /***/
        function srcUtilsTrackedControlsJs(module, __unused_webpack_exports, __webpack_require__) {
          var DEFAULT_HANDEDNESS = __webpack_require__( /*! ../constants */"./src/constants/index.js").DEFAULT_HANDEDNESS;
          var AXIS_LABELS = ['x', 'y', 'z', 'w'];
          var NUM_HANDS = 2; // Number of hands in a pair. Should always be 2.

          /**
           * Called on controller component `.play` handlers.
           * Check if controller matches parameters and inject tracked-controls component.
           * Handle event listeners.
           * Generate controllerconnected or controllerdisconnected events.
           *
           * @param {object} component - Tracked controls component.
           * @param {object} idPrefix - Prefix to match in gamepad id if any.
           * @param {object} queryObject - Map of values to match.
           */
          module.exports.checkControllerPresentAndSetup = function (component, idPrefix, queryObject) {
            var el = component.el;
            var controller;
            var hasWebXR = el.sceneEl.hasWebXR;
            var isControllerPresent = hasWebXR ? isControllerPresentWebXR : isControllerPresentWebVR;
            var isPresent;
            controller = isControllerPresent(component, idPrefix, queryObject);
            isPresent = !!controller;

            // If component was previously paused and now playing, re-add event listeners.
            // Handle the event listeners here since this helper method is control of calling
            // `.addEventListeners` and `.removeEventListeners`.
            if (component.controllerPresent && !component.controllerEventsActive && !hasWebXR) {
              component.addEventListeners();
            }

            // Nothing changed, no need to do anything.
            if (isPresent === component.controllerPresent) {
              return isPresent;
            }
            component.controllerPresent = isPresent;

            // Update controller presence.
            if (isPresent) {
              component.addEventListeners();
              component.injectTrackedControls(controller);
              el.emit('controllerconnected', {
                name: component.name,
                component: component
              });
            } else {
              component.removeEventListeners();
              el.emit('controllerdisconnected', {
                name: component.name,
                component: component
              });
            }
          };

          /**
           * Enumerate controller (that have pose) and check if they match parameters for WebVR
           *
           * @param {object} component - Tracked controls component.
           * @param {object} idPrefix - Prefix to match in gamepad id if any.
           * @param {object} queryObject - Map of values to match.
           */
          function isControllerPresentWebVR(component, idPrefix, queryObject) {
            var gamepads;
            var sceneEl = component.el.sceneEl;
            var trackedControlsSystem;
            var filterControllerIndex = queryObject.index || 0;
            if (!idPrefix) {
              return false;
            }
            trackedControlsSystem = sceneEl && sceneEl.systems['tracked-controls-webvr'];
            if (!trackedControlsSystem) {
              return false;
            }
            gamepads = trackedControlsSystem.controllers;
            if (!gamepads.length) {
              return false;
            }
            return !!findMatchingControllerWebVR(gamepads, null, idPrefix, queryObject.hand, filterControllerIndex);
          }

          /**
           *
           * @param {object} component - Tracked controls component.
           */
          function isControllerPresentWebXR(component, id, queryObject) {
            var controllers;
            var sceneEl = component.el.sceneEl;
            var trackedControlsSystem = sceneEl && sceneEl.systems['tracked-controls-webxr'];
            if (!trackedControlsSystem) {
              return false;
            }
            controllers = trackedControlsSystem.controllers;
            if (!controllers || !controllers.length) {
              return false;
            }
            return findMatchingControllerWebXR(controllers, id, queryObject.hand, queryObject.index, queryObject.iterateControllerProfiles, queryObject.handTracking);
          }
          module.exports.isControllerPresentWebVR = isControllerPresentWebVR;
          module.exports.isControllerPresentWebXR = isControllerPresentWebXR;

          /**
           * Walk through the given controllers to find any where the device ID equals
           * filterIdExact, or startsWith filterIdPrefix.
           * A controller where this considered true is considered a 'match'.
           *
           * For each matching controller:
           *   If filterHand is set, and the controller:
           *     is handed, we further verify that controller.hand equals filterHand.
           *     is unhanded (controller.hand is ''), we skip until we have found a
           *     number of matching controllers that equals filterControllerIndex
           *   If filterHand is not set, we skip until we have found the nth matching
           *   controller, where n equals filterControllerIndex
           *
           * The method should be called with one of: [filterIdExact, filterIdPrefix] AND
           * one or both of: [filterHand, filterControllerIndex]
           *
           * @param {object} controllers - Array of gamepads to search
           * @param {string} filterIdExact - If set, used to find controllers with id === this value
           * @param {string} filterIdPrefix - If set, used to find controllers with id startsWith this value
           * @param {object} filterHand - If set, further filters controllers with matching 'hand' property
           * @param {object} filterControllerIndex - Find the nth matching controller,
           * where n equals filterControllerIndex. defaults to 0.
           */
          function findMatchingControllerWebVR(controllers, filterIdExact, filterIdPrefix, filterHand, filterControllerIndex) {
            var controller;
            var i;
            var matchingControllerOccurence = 0;
            var targetControllerMatch = filterControllerIndex >= 0 ? filterControllerIndex : 0;
            for (i = 0; i < controllers.length; i++) {
              controller = controllers[i];

              // Determine if the controller ID matches our criteria.
              if (filterIdPrefix && !controller.id.startsWith(filterIdPrefix)) {
                continue;
              }
              if (!filterIdPrefix && controller.id !== filterIdExact) {
                continue;
              }

              // If the hand filter and controller handedness are defined we compare them.
              if (filterHand && controller.hand && filterHand !== controller.hand) {
                continue;
              }

              // If we have detected an unhanded controller and the component was asking
              // for a particular hand, we need to treat the controllers in the array as
              // pairs of controllers. This effectively means that we need to skip
              // NUM_HANDS matches for each controller number, instead of 1.
              if (filterHand && !controller.hand) {
                targetControllerMatch = NUM_HANDS * filterControllerIndex + (filterHand === DEFAULT_HANDEDNESS ? 0 : 1);
              } else {
                return controller;
              }

              // We are looking for the nth occurence of a matching controller
              // (n equals targetControllerMatch).
              if (matchingControllerOccurence === targetControllerMatch) {
                return controller;
              }
              ++matchingControllerOccurence;
            }
            return undefined;
          }
          function findMatchingControllerWebXR(controllers, idPrefix, handedness, index, iterateProfiles, handTracking) {
            var i;
            var j;
            var controller;
            var controllerMatch = false;
            var controllerHasHandedness;
            var profiles;
            for (i = 0; i < controllers.length; i++) {
              controller = controllers[i];
              profiles = controller.profiles;
              if (handTracking) {
                controllerMatch = controller.hand;
              } else {
                if (iterateProfiles) {
                  for (j = 0; j < profiles.length; j++) {
                    controllerMatch = profiles[j].startsWith(idPrefix);
                    if (controllerMatch) {
                      break;
                    }
                  }
                } else {
                  controllerMatch = profiles.length > 0 && profiles[0].startsWith(idPrefix);
                }
              }
              if (!controllerMatch) {
                continue;
              }
              // Vive controllers are assigned handedness at runtime and it might not be always available.
              controllerHasHandedness = controller.handedness === 'right' || controller.handedness === 'left';
              if (controllerHasHandedness) {
                if (controller.handedness === handedness) {
                  return controllers[i];
                }
              } else {
                // Fallback to index if controller has no handedness.
                if (i === index) {
                  return controllers[i];
                }
              }
            }
            return undefined;
          }
          module.exports.findMatchingControllerWebVR = findMatchingControllerWebVR;
          module.exports.findMatchingControllerWebXR = findMatchingControllerWebXR;

          /**
           * Emit specific `moved` event(s) if axes changed based on original axismoved event.
           *
           * @param {object} component - Controller component in use.
           * @param {array} axesMapping - For example `{thumbstick: [0, 1]}`.
           * @param {object} evt - Event to process.
           */
          module.exports.emitIfAxesChanged = function (component, axesMapping, evt) {
            var axes;
            var buttonType;
            var changed;
            var detail;
            var j;
            for (buttonType in axesMapping) {
              axes = axesMapping[buttonType];
              changed = false;
              for (j = 0; j < axes.length; j++) {
                if (evt.detail.changed[axes[j]]) {
                  changed = true;
                }
              }
              if (!changed) {
                continue;
              }

              // Axis has changed. Emit the specific moved event with axis values in detail.
              detail = {};
              for (j = 0; j < axes.length; j++) {
                detail[AXIS_LABELS[j]] = evt.detail.axis[axes[j]];
              }
              component.el.emit(buttonType + 'moved', detail);
            }
          };

          /**
           * Handle a button event and reemits the events.
           *
           * @param {string} id - id of the button.
           * @param {string} evtName - name of the reemitted event
           * @param {object} component - reference to the component
           * @param {string} hand - handedness of the controller: left or right.
           */
          module.exports.onButtonEvent = function (id, evtName, component, hand) {
            var mapping = hand ? component.mapping[hand] : component.mapping;
            var buttonName = mapping.buttons[id];
            component.el.emit(buttonName + evtName);
            if (component.updateModel) {
              component.updateModel(buttonName, evtName);
            }
          };

          /***/
        },

        /***/"./vendor/DeviceOrientationControls.js":
        /*!*********************************************!*\
          !*** ./vendor/DeviceOrientationControls.js ***!
          \*********************************************/
        /***/
        function vendorDeviceOrientationControlsJs() {
          /**
           * @author richt / http://richt.me
           * @author WestLangley / http://github.com/WestLangley
           *
           * W3C Device Orientation control (http://w3c.github.io/deviceorientation/spec-source-orientation.html)
           */

          THREE.DeviceOrientationControls = function (object) {
            var scope = this;
            this.object = object;
            this.object.rotation.reorder('YXZ');
            this.enabled = true;
            this.deviceOrientation = {};
            this.screenOrientation = 0;
            this.alphaOffset = 0; // radians

            var onDeviceOrientationChangeEvent = function onDeviceOrientationChangeEvent(event) {
              scope.deviceOrientation = event;
            };
            var onScreenOrientationChangeEvent = function onScreenOrientationChangeEvent() {
              scope.screenOrientation = window.orientation || 0;
            };

            // The angles alpha, beta and gamma form a set of intrinsic Tait-Bryan angles of type Z-X'-Y''

            var setObjectQuaternion = function () {
              var zee = new THREE.Vector3(0, 0, 1);
              var euler = new THREE.Euler();
              var q0 = new THREE.Quaternion();
              var q1 = new THREE.Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)); // - PI/2 around the x-axis

              return function (quaternion, alpha, beta, gamma, orient) {
                euler.set(beta, alpha, -gamma, 'YXZ'); // 'ZXY' for the device, but 'YXZ' for us

                quaternion.setFromEuler(euler); // orient the device

                quaternion.multiply(q1); // camera looks out the back of the device, not the top

                quaternion.multiply(q0.setFromAxisAngle(zee, -orient)); // adjust for screen orientation
              };
            }();

            this.connect = function () {
              onScreenOrientationChangeEvent();
              window.addEventListener('orientationchange', onScreenOrientationChangeEvent, false);
              window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);
              scope.enabled = true;
            };
            this.disconnect = function () {
              window.removeEventListener('orientationchange', onScreenOrientationChangeEvent, false);
              window.removeEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);
              scope.enabled = false;
            };
            this.update = function () {
              if (scope.enabled === false) return;
              var device = scope.deviceOrientation;
              if (device) {
                var alpha = device.alpha ? THREE.MathUtils.degToRad(device.alpha) + scope.alphaOffset : 0; // Z

                var beta = device.beta ? THREE.MathUtils.degToRad(device.beta) : 0; // X'

                var gamma = device.gamma ? THREE.MathUtils.degToRad(device.gamma) : 0; // Y''

                var orient = scope.screenOrientation ? THREE.MathUtils.degToRad(scope.screenOrientation) : 0; // O

                setObjectQuaternion(scope.object.quaternion, alpha, beta, gamma, orient);
              }
            };
            this.dispose = function () {
              scope.disconnect();
            };
            this.connect();
          };

          /***/
        },

        /***/"./vendor/rStats.extras.js":
        /*!*********************************!*\
          !*** ./vendor/rStats.extras.js ***!
          \*********************************/
        /***/
        function vendorRStatsExtrasJs(module) {
          window.glStats = function () {
            var _rS = null;
            var _totalDrawArraysCalls = 0,
              _totalDrawElementsCalls = 0,
              _totalUseProgramCalls = 0,
              _totalFaces = 0,
              _totalVertices = 0,
              _totalPoints = 0,
              _totalBindTexures = 0;
            function _h(f, c) {
              return function () {
                c.apply(this, arguments);
                f.apply(this, arguments);
              };
            }
            WebGLRenderingContext.prototype.drawArrays = _h(WebGLRenderingContext.prototype.drawArrays, function () {
              _totalDrawArraysCalls++;
              if (arguments[0] == this.POINTS) _totalPoints += arguments[2];else _totalVertices += arguments[2];
            });
            WebGLRenderingContext.prototype.drawElements = _h(WebGLRenderingContext.prototype.drawElements, function () {
              _totalDrawElementsCalls++;
              _totalFaces += arguments[1] / 3;
              _totalVertices += arguments[1];
            });
            WebGLRenderingContext.prototype.useProgram = _h(WebGLRenderingContext.prototype.useProgram, function () {
              _totalUseProgramCalls++;
            });
            WebGLRenderingContext.prototype.bindTexture = _h(WebGLRenderingContext.prototype.bindTexture, function () {
              _totalBindTexures++;
            });
            var _values = {
              allcalls: {
                over: 3000,
                caption: 'Calls (hook)'
              },
              drawelements: {
                caption: 'drawElements (hook)'
              },
              drawarrays: {
                caption: 'drawArrays (hook)'
              }
            };
            var _groups = [{
              caption: 'WebGL',
              values: ['allcalls', 'drawelements', 'drawarrays', 'useprogram', 'bindtexture', 'glfaces', 'glvertices', 'glpoints']
            }];
            var _fractions = [{
              base: 'allcalls',
              steps: ['drawelements', 'drawarrays']
            }];
            function _update() {
              _rS('allcalls').set(_totalDrawArraysCalls + _totalDrawElementsCalls);
              _rS('drawElements').set(_totalDrawElementsCalls);
              _rS('drawArrays').set(_totalDrawArraysCalls);
              _rS('bindTexture').set(_totalBindTexures);
              _rS('useProgram').set(_totalUseProgramCalls);
              _rS('glfaces').set(_totalFaces);
              _rS('glvertices').set(_totalVertices);
              _rS('glpoints').set(_totalPoints);
            }
            function _start() {
              _totalDrawArraysCalls = 0;
              _totalDrawElementsCalls = 0;
              _totalUseProgramCalls = 0;
              _totalFaces = 0;
              _totalVertices = 0;
              _totalPoints = 0;
              _totalBindTexures = 0;
            }
            function _end() {}
            function _attach(r) {
              _rS = r;
            }
            return {
              update: _update,
              start: _start,
              end: _end,
              attach: _attach,
              values: _values,
              groups: _groups,
              fractions: _fractions
            };
          };
          window.threeStats = function (renderer) {
            var _rS = null;
            var _values = {
              'renderer.info.memory.geometries': {
                caption: 'Geometries'
              },
              'renderer.info.memory.textures': {
                caption: 'Textures'
              },
              'renderer.info.programs': {
                caption: 'Programs'
              },
              'renderer.info.render.calls': {
                caption: 'Calls'
              },
              'renderer.info.render.triangles': {
                caption: 'Triangles',
                over: 1000
              },
              'renderer.info.render.points': {
                caption: 'Points'
              }
            };
            var _groups = [{
              caption: 'Three.js - Memory',
              values: ['renderer.info.memory.geometries', 'renderer.info.programs', 'renderer.info.memory.textures']
            }, {
              caption: 'Three.js - Render',
              values: ['renderer.info.render.calls', 'renderer.info.render.triangles', 'renderer.info.render.points']
            }];
            var _fractions = [];
            function _update() {
              _rS('renderer.info.memory.geometries').set(renderer.info.memory.geometries);
              _rS('renderer.info.programs').set(renderer.info.programs.length);
              _rS('renderer.info.memory.textures').set(renderer.info.memory.textures);
              _rS('renderer.info.render.calls').set(renderer.info.render.calls);
              _rS('renderer.info.render.triangles').set(renderer.info.render.triangles);
              _rS('renderer.info.render.points').set(renderer.info.render.points);
            }
            function _start() {}
            function _end() {}
            function _attach(r) {
              _rS = r;
            }
            return {
              update: _update,
              start: _start,
              end: _end,
              attach: _attach,
              values: _values,
              groups: _groups,
              fractions: _fractions
            };
          };

          /*
           *   From https://github.com/paulirish/memory-stats.js
           */

          window.BrowserStats = function () {
            var _rS = null;
            var _usedJSHeapSize = 0,
              _totalJSHeapSize = 0;
            if (window.performance && !performance.memory) {
              performance.memory = {
                usedJSHeapSize: 0,
                totalJSHeapSize: 0
              };
            }
            if (performance.memory.totalJSHeapSize === 0) {
              console.warn('totalJSHeapSize === 0... performance.memory is only available in Chrome .');
            }
            var _values = {
              memory: {
                caption: 'Used Memory',
                average: true,
                avgMs: 1000,
                over: 22
              },
              total: {
                caption: 'Total Memory'
              }
            };
            var _groups = [{
              caption: 'Browser',
              values: ['memory', 'total']
            }];
            var _fractions = [{
              base: 'total',
              steps: ['memory']
            }];
            var log1024 = Math.log(1024);
            function _size(v) {
              var precision = 100; //Math.pow(10, 2);
              var i = Math.floor(Math.log(v) / log1024);
              return Math.round(v * precision / Math.pow(1024, i)) / precision; // + ' ' + sizes[i];
            }

            function _update() {
              _usedJSHeapSize = _size(performance.memory.usedJSHeapSize);
              _totalJSHeapSize = _size(performance.memory.totalJSHeapSize);
              _rS('memory').set(_usedJSHeapSize);
              _rS('total').set(_totalJSHeapSize);
            }
            function _start() {
              _usedJSHeapSize = 0;
            }
            function _end() {}
            function _attach(r) {
              _rS = r;
            }
            return {
              update: _update,
              start: _start,
              end: _end,
              attach: _attach,
              values: _values,
              groups: _groups,
              fractions: _fractions
            };
          };
          if (true) {
            module.exports = {
              glStats: window.glStats,
              threeStats: window.threeStats,
              BrowserStats: window.BrowserStats
            };
          }

          /***/
        },

        /***/"./vendor/rStats.js":
        /*!**************************!*\
          !*** ./vendor/rStats.js ***!
          \**************************/
        /***/
        function vendorRStatsJs(module) {
          "use strict";

          // performance.now() polyfill from https://gist.github.com/paulirish/5438650
          (function () {
            if ('performance' in window == false) {
              window.performance = {};
            }
            var performance = window.performance;
            if ('now' in performance == false) {
              var nowOffset = Date.now();
              if (performance.timing && performance.timing.navigationStart) {
                nowOffset = performance.timing.navigationStart;
              }
              performance.now = function now() {
                return Date.now() - nowOffset;
              };
            }
            if (!performance.mark) {
              performance.mark = function () {};
            }
            if (!performance.measure) {
              performance.measure = function () {};
            }
          })();
          window.rStats = function rStats(settings) {
            function iterateKeys(array, callback) {
              var keys = Object.keys(array);
              for (var j = 0, l = keys.length; j < l; j++) {
                callback(keys[j]);
              }
            }
            function importCSS(url) {
              var element = document.createElement('link');
              element.href = url;
              element.rel = 'stylesheet';
              element.type = 'text/css';
              document.getElementsByTagName('head')[0].appendChild(element);
            }
            var _settings = settings || {};
            var _colours = _settings.colours || ['#850700', '#c74900', '#fcb300', '#284280', '#4c7c0c'];
            var _cssFont = 'https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700,300';
            var _cssRStats = (_settings.CSSPath ? _settings.CSSPath : '') + 'rStats.css';
            var _css = _settings.css || [_cssFont, _cssRStats];
            _css.forEach(function (uri) {
              importCSS(uri);
            });
            if (!_settings.values) _settings.values = {};
            var _base,
              _div,
              _elHeight = 10,
              _elWidth = 200;
            var _perfCounters = {};
            function Graph(_dom, _id, _defArg) {
              var _def = _defArg || {};
              var _canvas = document.createElement('canvas'),
                _ctx = _canvas.getContext('2d'),
                _max = 0,
                _current = 0;
              var c = _def.color ? _def.color : '#666666';
              var _dotCanvas = document.createElement('canvas'),
                _dotCtx = _dotCanvas.getContext('2d');
              _dotCanvas.width = 1;
              _dotCanvas.height = 2 * _elHeight;
              _dotCtx.fillStyle = '#444444';
              _dotCtx.fillRect(0, 0, 1, 2 * _elHeight);
              _dotCtx.fillStyle = c;
              _dotCtx.fillRect(0, _elHeight, 1, _elHeight);
              _dotCtx.fillStyle = '#ffffff';
              _dotCtx.globalAlpha = 0.5;
              _dotCtx.fillRect(0, _elHeight, 1, 1);
              _dotCtx.globalAlpha = 1;
              var _alarmCanvas = document.createElement('canvas'),
                _alarmCtx = _alarmCanvas.getContext('2d');
              _alarmCanvas.width = 1;
              _alarmCanvas.height = 2 * _elHeight;
              _alarmCtx.fillStyle = '#444444';
              _alarmCtx.fillRect(0, 0, 1, 2 * _elHeight);
              _alarmCtx.fillStyle = '#b70000';
              _alarmCtx.fillRect(0, _elHeight, 1, _elHeight);
              _alarmCtx.globalAlpha = 0.5;
              _alarmCtx.fillStyle = '#ffffff';
              _alarmCtx.fillRect(0, _elHeight, 1, 1);
              _alarmCtx.globalAlpha = 1;
              function _init() {
                _canvas.width = _elWidth;
                _canvas.height = _elHeight;
                _canvas.style.width = _canvas.width + 'px';
                _canvas.style.height = _canvas.height + 'px';
                _canvas.className = 'rs-canvas';
                _dom.appendChild(_canvas);
                _ctx.fillStyle = '#444444';
                _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
              }
              function _draw(v, alarm) {
                _current += (v - _current) * 0.1;
                _max *= 0.99;
                if (_current > _max) _max = _current;
                _ctx.drawImage(_canvas, 1, 0, _canvas.width - 1, _canvas.height, 0, 0, _canvas.width - 1, _canvas.height);
                if (alarm) {
                  _ctx.drawImage(_alarmCanvas, _canvas.width - 1, _canvas.height - _current * _canvas.height / _max - _elHeight);
                } else {
                  _ctx.drawImage(_dotCanvas, _canvas.width - 1, _canvas.height - _current * _canvas.height / _max - _elHeight);
                }
              }
              _init();
              return {
                draw: _draw
              };
            }
            function StackGraph(_dom, _num) {
              var _canvas = document.createElement('canvas'),
                _ctx = _canvas.getContext('2d');
              function _init() {
                _canvas.width = _elWidth;
                _canvas.height = _elHeight * _num;
                _canvas.style.width = _canvas.width + 'px';
                _canvas.style.height = _canvas.height + 'px';
                _canvas.className = 'rs-canvas';
                _dom.appendChild(_canvas);
                _ctx.fillStyle = '#444444';
                _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
              }
              function _draw(v) {
                _ctx.drawImage(_canvas, 1, 0, _canvas.width - 1, _canvas.height, 0, 0, _canvas.width - 1, _canvas.height);
                var th = 0;
                iterateKeys(v, function (j) {
                  var h = v[j] * _canvas.height;
                  _ctx.fillStyle = _colours[j];
                  _ctx.fillRect(_canvas.width - 1, th, 1, h);
                  th += h;
                });
              }
              _init();
              return {
                draw: _draw
              };
            }
            function PerfCounter(id, group) {
              var _id = id,
                _time,
                _value = 0,
                _total = 0,
                _averageValue = 0,
                _accumValue = 0,
                _accumStart = performance.now(),
                _accumSamples = 0,
                _dom = document.createElement('div'),
                _spanId = document.createElement('span'),
                _spanValue = document.createElement('div'),
                _spanValueText = document.createTextNode(''),
                _def = _settings ? _settings.values[_id.toLowerCase()] : null,
                _graph = new Graph(_dom, _id, _def),
                _started = false;
              _spanId.className = 'rs-counter-id';
              _spanId.textContent = _def && _def.caption ? _def.caption : _id;
              _spanValue.className = 'rs-counter-value';
              _spanValue.appendChild(_spanValueText);
              _dom.appendChild(_spanId);
              _dom.appendChild(_spanValue);
              if (group) group.div.appendChild(_dom);else _div.appendChild(_dom);
              _time = performance.now();
              function _average(v) {
                if (_def && _def.average) {
                  _accumValue += v;
                  _accumSamples++;
                  var t = performance.now();
                  if (t - _accumStart >= (_def.avgMs || 1000)) {
                    _averageValue = _accumValue / _accumSamples;
                    _accumValue = 0;
                    _accumStart = t;
                    _accumSamples = 0;
                  }
                }
              }
              function _start() {
                _time = performance.now();
                if (_settings.userTimingAPI) performance.mark(_id + '-start');
                _started = true;
              }
              function _end() {
                _value = performance.now() - _time;
                if (_settings.userTimingAPI) {
                  performance.mark(_id + '-end');
                  if (_started) {
                    performance.measure(_id, _id + '-start', _id + '-end');
                  }
                }
                _average(_value);
              }
              function _tick() {
                _end();
                _start();
              }
              function _draw() {
                var v = _def && _def.average ? _averageValue : _value;
                _spanValueText.nodeValue = Math.round(v * 100) / 100;
                var a = _def && (_def.below && _value < _def.below || _def.over && _value > _def.over);
                _graph.draw(_value, a);
                _dom.className = a ? 'rs-counter-base alarm' : 'rs-counter-base';
              }
              function _frame() {
                var t = performance.now();
                var e = t - _time;
                _total++;
                if (e > 1000) {
                  if (_def && _def.interpolate === false) {
                    _value = _total;
                  } else {
                    _value = _total * 1000 / e;
                  }
                  _total = 0;
                  _time = t;
                  _average(_value);
                }
              }
              function _set(v) {
                _value = v;
                _average(_value);
              }
              return {
                set: _set,
                start: _start,
                tick: _tick,
                end: _end,
                frame: _frame,
                value: function value() {
                  return _value;
                },
                draw: _draw
              };
            }
            function sample() {
              var _value = 0;
              function _set(v) {
                _value = v;
              }
              return {
                set: _set,
                value: function value() {
                  return _value;
                }
              };
            }
            function _perf(idArg) {
              var id = idArg.toLowerCase();
              if (id === undefined) id = 'default';
              if (_perfCounters[id]) return _perfCounters[id];
              var group = null;
              if (_settings && _settings.groups) {
                iterateKeys(_settings.groups, function (j) {
                  var g = _settings.groups[parseInt(j, 10)];
                  if (!group && g.values.indexOf(id.toLowerCase()) !== -1) {
                    group = g;
                  }
                });
              }
              var p = new PerfCounter(id, group);
              _perfCounters[id] = p;
              return p;
            }
            function _init() {
              if (_settings.plugins) {
                if (!_settings.values) _settings.values = {};
                if (!_settings.groups) _settings.groups = [];
                if (!_settings.fractions) _settings.fractions = [];
                for (var j = 0; j < _settings.plugins.length; j++) {
                  _settings.plugins[j].attach(_perf);
                  iterateKeys(_settings.plugins[j].values, function (k) {
                    _settings.values[k] = _settings.plugins[j].values[k];
                  });
                  _settings.groups = _settings.groups.concat(_settings.plugins[j].groups);
                  _settings.fractions = _settings.fractions.concat(_settings.plugins[j].fractions);
                }
              } else {
                _settings.plugins = {};
              }
              _base = document.createElement('div');
              _base.className = 'rs-base';
              _div = document.createElement('div');
              _div.className = 'rs-container';
              _div.style.height = 'auto';
              _base.appendChild(_div);
              document.body.appendChild(_base);
              if (!_settings) return;
              if (_settings.groups) {
                iterateKeys(_settings.groups, function (j) {
                  var g = _settings.groups[parseInt(j, 10)];
                  var div = document.createElement('div');
                  div.className = 'rs-group';
                  g.div = div;
                  var h1 = document.createElement('h1');
                  h1.textContent = g.caption;
                  h1.addEventListener('click', function (e) {
                    this.classList.toggle('hidden');
                    e.preventDefault();
                  }.bind(div));
                  _div.appendChild(h1);
                  _div.appendChild(div);
                });
              }
              if (_settings.fractions) {
                iterateKeys(_settings.fractions, function (j) {
                  var f = _settings.fractions[parseInt(j, 10)];
                  var div = document.createElement('div');
                  div.className = 'rs-fraction';
                  var legend = document.createElement('div');
                  legend.className = 'rs-legend';
                  var h = 0;
                  iterateKeys(_settings.fractions[j].steps, function (k) {
                    var p = document.createElement('p');
                    p.textContent = _settings.fractions[j].steps[k];
                    p.style.color = _colours[h];
                    legend.appendChild(p);
                    h++;
                  });
                  div.appendChild(legend);
                  div.style.height = h * _elHeight + 'px';
                  f.div = div;
                  var graph = new StackGraph(div, h);
                  f.graph = graph;
                  _div.appendChild(div);
                });
              }
            }
            function _update() {
              iterateKeys(_settings.plugins, function (j) {
                _settings.plugins[j].update();
              });
              iterateKeys(_perfCounters, function (j) {
                _perfCounters[j].draw();
              });
              if (_settings && _settings.fractions) {
                iterateKeys(_settings.fractions, function (j) {
                  var f = _settings.fractions[parseInt(j, 10)];
                  var v = [];
                  var base = _perfCounters[f.base.toLowerCase()];
                  if (base) {
                    base = base.value();
                    iterateKeys(_settings.fractions[j].steps, function (k) {
                      var s = _settings.fractions[j].steps[parseInt(k, 10)].toLowerCase();
                      var val = _perfCounters[s];
                      if (val) {
                        v.push(val.value() / base);
                      }
                    });
                  }
                  f.graph.draw(v);
                });
              }

              /*if( _height != _div.clientHeight ) {
                  _height = _div.clientHeight;
                  _base.style.height = _height + 2 * _elHeight + 'px';
              console.log( _base.clientHeight );
              }*/
            }

            _init();
            return function (id) {
              if (id) return _perf(id);
              return {
                element: _base,
                update: _update
              };
            };
          };
          if (true) {
            module.exports = window.rStats;
          }

          /***/
        },

        /***/"./vendor/starts-with-polyfill.js":
        /*!****************************************!*\
          !*** ./vendor/starts-with-polyfill.js ***!
          \****************************************/
        /***/
        function vendorStartsWithPolyfillJs() {
          // https://stackoverflow.com/a/36213464
          if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
              position = position || 0;
              return this.substr(position, searchString.length) === searchString;
            };
          }

          /***/
        },

        /***/"./vendor/wakelock/util.js":
        /*!*********************************!*\
          !*** ./vendor/wakelock/util.js ***!
          \*********************************/
        /***/
        function vendorWakelockUtilJs(module) {
          /*
           * Copyright 2015 Google Inc. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *     http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */

          var Util = {};
          Util.base64 = function (mimeType, base64) {
            return 'data:' + mimeType + ';base64,' + base64;
          };
          Util.isMobile = function () {
            var check = false;
            (function (a) {
              if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
          };
          Util.isIOS = function () {
            return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
          };
          Util.isIFrame = function () {
            try {
              return window.self !== window.top;
            } catch (e) {
              return true;
            }
          };
          Util.appendQueryParameter = function (url, key, value) {
            // Determine delimiter based on if the URL already GET parameters in it.
            var delimiter = url.indexOf('?') < 0 ? '?' : '&';
            url += delimiter + key + '=' + value;
            return url;
          };

          // From http://goo.gl/4WX3tg
          Util.getQueryParameter = function (name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
              results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
          };
          Util.isLandscapeMode = function () {
            return window.orientation == 90 || window.orientation == -90;
          };
          module.exports = Util;

          /***/
        },

        /***/"./vendor/wakelock/wakelock.js":
        /*!*************************************!*\
          !*** ./vendor/wakelock/wakelock.js ***!
          \*************************************/
        /***/
        function vendorWakelockWakelockJs(module, __unused_webpack_exports, __webpack_require__) {
          /*
           * Copyright 2015 Google Inc. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *     http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */

          var Util = __webpack_require__( /*! ./util.js */"./vendor/wakelock/util.js");

          /**
           * Android and iOS compatible wakelock implementation.
           *
           * Refactored thanks to dkovalev@.
           */
          function AndroidWakeLock() {
            var video = document.createElement('video');
            video.addEventListener('ended', function () {
              video.play();
            });
            this.request = function () {
              if (video.paused) {
                // Base64 version of videos_src/no-sleep-60s.webm.
                video.src = Util.base64('video/webm', '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');
                video.play();
              }
            };
            this.release = function () {
              video.pause();
              video.src = '';
            };
          }
          function iOSWakeLock() {
            var timer = null;
            this.request = function () {
              if (!timer) {
                timer = setInterval(function () {
                  window.location.href = '/';
                  setTimeout(window.stop, 0);
                }, 15000);
              }
            };
            this.release = function () {
              if (timer) {
                clearInterval(timer);
                timer = null;
              }
            };
          }
          function getWakeLock() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
              return iOSWakeLock;
            } else {
              return AndroidWakeLock;
            }
          }
          module.exports = getWakeLock();

          /***/
        },

        /***/"./node_modules/css-loader/dist/cjs.js!./src/style/aframe.css":
        /*!********************************************************************!*\
          !*** ./node_modules/css-loader/dist/cjs.js!./src/style/aframe.css ***!
          \********************************************************************/
        /***/
        function node_modulesCssLoaderDistCjsJsSrcStyleAframeCss(module, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"default": function _default() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */
          });
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../../node_modules/css-loader/dist/runtime/sourceMaps.js */"./node_modules/css-loader/dist/runtime/sourceMaps.js");
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../../node_modules/css-loader/dist/runtime/api.js */"./node_modules/css-loader/dist/runtime/api.js");
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../../node_modules/css-loader/dist/runtime/getUrl.js */"./node_modules/css-loader/dist/runtime/getUrl.js");
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
          // Imports

          var ___CSS_LOADER_URL_IMPORT_0___ = new URL( /* asset import */__webpack_require__( /*! data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-vrmode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M68.81,21.56H64.23v8.27h4.58a4.13,4.13,0,0,0,3.1-1.09,4.2,4.2,0,0,0,1-3,4.24,4.24,0,0,0-1-3A4.05,4.05,0,0,0,68.81,21.56Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0ZM41.9,46H34L24,16h8l6,21.84,6-21.84H52Zm39.29,0H73.44L68.15,35.39H64.23V46H57V16H68.81q5.32,0,8.34,2.37a8,8,0,0,1,3,6.69,9.68,9.68,0,0,1-1.27,5.18,8.9,8.9,0,0,1-4,3.34l6.26,12.11Z%27 fill=%27%23fff%27/%3E%3C/svg%3E */"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-vrmode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M68.81,21.56H64.23v8.27h4.58a4.13,4.13,0,0,0,3.1-1.09,4.2,4.2,0,0,0,1-3,4.24,4.24,0,0,0-1-3A4.05,4.05,0,0,0,68.81,21.56Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0ZM41.9,46H34L24,16h8l6,21.84,6-21.84H52Zm39.29,0H73.44L68.15,35.39H64.23V46H57V16H68.81q5.32,0,8.34,2.37a8,8,0,0,1,3,6.69,9.68,9.68,0,0,1-1.27,5.18,8.9,8.9,0,0,1-4,3.34l6.26,12.11Z%27 fill=%27%23fff%27/%3E%3C/svg%3E"), __webpack_require__.b);
          var ___CSS_LOADER_URL_IMPORT_1___ = new URL( /* asset import */__webpack_require__( /*! data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0Zm8,50a8,8,0,0,1-8,8H12a8,8,0,0,1-8-8V12a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M43.35,39.82H32.51L30.45,46H23.88L35,16h5.73L52,46H45.43Zm-9.17-5h7.5L37.91,23.58Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M68.11,35H63.18V46H57V16H68.15q5.31,0,8.2,2.37a8.18,8.18,0,0,1,2.88,6.7,9.22,9.22,0,0,1-1.33,5.12,9.09,9.09,0,0,1-4,3.26l6.49,12.26V46H73.73Zm-4.93-5h5a5.09,5.09,0,0,0,3.6-1.18,4.21,4.21,0,0,0,1.28-3.27,4.56,4.56,0,0,0-1.2-3.34A5,5,0,0,0,68.15,21h-5Z%27 fill=%27%23fff%27/%3E%3C/svg%3E */"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0Zm8,50a8,8,0,0,1-8,8H12a8,8,0,0,1-8-8V12a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M43.35,39.82H32.51L30.45,46H23.88L35,16h5.73L52,46H45.43Zm-9.17-5h7.5L37.91,23.58Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M68.11,35H63.18V46H57V16H68.15q5.31,0,8.2,2.37a8.18,8.18,0,0,1,2.88,6.7,9.22,9.22,0,0,1-1.33,5.12,9.09,9.09,0,0,1-4,3.26l6.49,12.26V46H73.73Zm-4.93-5h5a5.09,5.09,0,0,0,3.6-1.18,4.21,4.21,0,0,0,1.28-3.27,4.56,4.56,0,0,0-1.2-3.34A5,5,0,0,0,68.15,21h-5Z%27 fill=%27%23fff%27/%3E%3C/svg%3E"), __webpack_require__.b);
          var ___CSS_LOADER_URL_IMPORT_2___ = new URL( /* asset import */__webpack_require__( /*! data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27 standalone=%27no%27%3F%3E%3Csvg width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27 version=%271.1%27 id=%27svg320%27 sodipodi:docname=%27fullscreen-aframe.svg%27 xml:space=%27preserve%27 inkscape:version=%271.2.1 %289c6d41e  2022-07-14%29%27 xmlns:inkscape=%27http://www.inkscape.org/namespaces/inkscape%27 xmlns:sodipodi=%27http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:svg=%27http://www.w3.org/2000/svg%27 xmlns:rdf=%27http://www.w3.org/1999/02/22-rdf-syntax-ns%23%27 xmlns:cc=%27http://creativecommons.org/ns%23%27 xmlns:dc=%27http://purl.org/dc/elements/1.1/%27%3E%3Cdefs id=%27defs324%27 /%3E%3Csodipodi:namedview id=%27namedview322%27 pagecolor=%27%23ffffff%27 bordercolor=%27%23000000%27 borderopacity=%270.25%27 inkscape:showpageshadow=%272%27 inkscape:pageopacity=%270.0%27 inkscape:pagecheckerboard=%270%27 inkscape:deskcolor=%27%23d1d1d1%27 showgrid=%27false%27 inkscape:zoom=%273.8064516%27 inkscape:cx=%2791.423729%27 inkscape:cy=%27-1.4449153%27 inkscape:window-width=%271440%27 inkscape:window-height=%27847%27 inkscape:window-x=%2732%27 inkscape:window-y=%2725%27 inkscape:window-maximized=%270%27 inkscape:current-layer=%27svg320%27 /%3E%3Ctitle id=%27title312%27%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96 0H12A12 12 0 0 0 0 12V50A12 12 0 0 0 12 62H96a12 12 0 0 0 12-12V12A12 12 0 0 0 96 0Zm8 50a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8H96a8 8 0 0 1 8 8Z%27 fill=%27%23fff%27 id=%27path314%27 style=%27fill:%23ffffff%27 /%3E%3Cg id=%27g356%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g358%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g360%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g362%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g364%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g366%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g368%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g370%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g372%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g374%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g376%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g378%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g380%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g382%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g384%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cmetadata id=%27metadata561%27%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=%27%27%3E%3Cdc:title%3Eaframe-armode-noborder-reduced-tracking%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cpath d=%27m 98.168511 40.083649 c 0 -1.303681 -0.998788 -2.358041 -2.239389 -2.358041 -1.230088 0.0031 -2.240892 1.05436 -2.240892 2.358041 v 4.881296 l -9.041661 -9.041662 c -0.874129 -0.875631 -2.288954 -0.875631 -3.16308 0 -0.874129 0.874126 -0.874129 2.293459 0 3.167585 l 8.995101 8.992101 h -4.858767 c -1.323206 0.0031 -2.389583 1.004796 -2.389583 2.239386 0 1.237598 1.066377 2.237888 2.389583 2.237888 h 10.154599 c 1.323206 0 2.388082 -0.998789 2.392587 -2.237888 -0.0044 -0.03305 -0.009 -0.05858 -0.0134 -0.09161 0.0046 -0.04207 0.0134 -0.08712 0.0134 -0.13066 V 40.085172 h -1.52e-4%27 id=%27path596%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 23.091002 35.921781 -9.026643 9.041662 v -4.881296 c 0 -1.303681 -1.009302 -2.355037 -2.242393 -2.358041 -1.237598 0 -2.237888 1.05436 -2.237888 2.358041 l -0.0031 10.016421 c 0 0.04356 0.01211 0.08862 0.0015 0.130659 -0.0031 0.03153 -0.009 0.05709 -0.01211 0.09161 0.0031 1.239099 1.069379 2.237888 2.391085 2.237888 h 10.156101 c 1.320202 0 2.388079 -1.000291 2.388079 -2.237888 0 -1.234591 -1.067877 -2.236383 -2.388079 -2.239387 h -4.858767 l 8.995101 -8.9921 c 0.871126 -0.874127 0.871126 -2.293459 0 -3.167586 -0.875628 -0.877132 -2.291957 -0.877132 -3.169087 -1.52e-4%27 id=%27path598%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 84.649572 25.978033 9.041662 -9.041664 v 4.881298 c 0 1.299176 1.010806 2.350532 2.240891 2.355037 1.240601 0 2.23939 -1.055861 2.23939 -2.355037 V 11.798242 c 0 -0.04356 -0.009 -0.08862 -0.0134 -0.127671 0.0044 -0.03153 0.009 -0.06157 0.0134 -0.09313 -0.0044 -1.240598 -1.069379 -2.2393873 -2.391085 -2.2393873 h -10.1546 c -1.323205 0 -2.38958 0.9987893 -2.38958 2.2393873 0 1.233091 1.066375 2.237887 2.38958 2.240891 h 4.858768 l -8.995102 8.9921 c -0.874129 0.872625 -0.874129 2.288954 0 3.161578 0.874127 0.880137 2.288951 0.880137 3.16308 1.5e-4%27 id=%27path600%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 17.264988 13.822853 h 4.857265 c 1.320202 -0.0031 2.388079 -1.0078 2.388079 -2.240889 0 -1.240601 -1.067877 -2.2393893 -2.388079 -2.2393893 H 11.967654 c -1.321707 0 -2.388082 0.9987883 -2.391085 2.2393893 0.0031 0.03153 0.009 0.06157 0.01211 0.09313 -0.0031 0.03905 -0.0015 0.08262 -0.0015 0.127671 l 0.0031 10.020926 c 0 1.299176 1.00029 2.355038 2.237887 2.355038 1.233092 -0.0044 2.242393 -1.055862 2.242393 -2.355038 v -4.881295 l 9.026644 9.041661 c 0.877132 0.878635 2.293459 0.878635 3.169087 0 0.871125 -0.872624 0.871125 -2.288953 0 -3.161577 l -8.995282 -8.993616%27 id=%27path602%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3C/svg%3E */"data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27 standalone=%27no%27%3F%3E%3Csvg width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27 version=%271.1%27 id=%27svg320%27 sodipodi:docname=%27fullscreen-aframe.svg%27 xml:space=%27preserve%27 inkscape:version=%271.2.1 %289c6d41e  2022-07-14%29%27 xmlns:inkscape=%27http://www.inkscape.org/namespaces/inkscape%27 xmlns:sodipodi=%27http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:svg=%27http://www.w3.org/2000/svg%27 xmlns:rdf=%27http://www.w3.org/1999/02/22-rdf-syntax-ns%23%27 xmlns:cc=%27http://creativecommons.org/ns%23%27 xmlns:dc=%27http://purl.org/dc/elements/1.1/%27%3E%3Cdefs id=%27defs324%27 /%3E%3Csodipodi:namedview id=%27namedview322%27 pagecolor=%27%23ffffff%27 bordercolor=%27%23000000%27 borderopacity=%270.25%27 inkscape:showpageshadow=%272%27 inkscape:pageopacity=%270.0%27 inkscape:pagecheckerboard=%270%27 inkscape:deskcolor=%27%23d1d1d1%27 showgrid=%27false%27 inkscape:zoom=%273.8064516%27 inkscape:cx=%2791.423729%27 inkscape:cy=%27-1.4449153%27 inkscape:window-width=%271440%27 inkscape:window-height=%27847%27 inkscape:window-x=%2732%27 inkscape:window-y=%2725%27 inkscape:window-maximized=%270%27 inkscape:current-layer=%27svg320%27 /%3E%3Ctitle id=%27title312%27%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96 0H12A12 12 0 0 0 0 12V50A12 12 0 0 0 12 62H96a12 12 0 0 0 12-12V12A12 12 0 0 0 96 0Zm8 50a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8H96a8 8 0 0 1 8 8Z%27 fill=%27%23fff%27 id=%27path314%27 style=%27fill:%23ffffff%27 /%3E%3Cg id=%27g356%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g358%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g360%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g362%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g364%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g366%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g368%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g370%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g372%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g374%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g376%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g378%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g380%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g382%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g384%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cmetadata id=%27metadata561%27%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=%27%27%3E%3Cdc:title%3Eaframe-armode-noborder-reduced-tracking%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cpath d=%27m 98.168511 40.083649 c 0 -1.303681 -0.998788 -2.358041 -2.239389 -2.358041 -1.230088 0.0031 -2.240892 1.05436 -2.240892 2.358041 v 4.881296 l -9.041661 -9.041662 c -0.874129 -0.875631 -2.288954 -0.875631 -3.16308 0 -0.874129 0.874126 -0.874129 2.293459 0 3.167585 l 8.995101 8.992101 h -4.858767 c -1.323206 0.0031 -2.389583 1.004796 -2.389583 2.239386 0 1.237598 1.066377 2.237888 2.389583 2.237888 h 10.154599 c 1.323206 0 2.388082 -0.998789 2.392587 -2.237888 -0.0044 -0.03305 -0.009 -0.05858 -0.0134 -0.09161 0.0046 -0.04207 0.0134 -0.08712 0.0134 -0.13066 V 40.085172 h -1.52e-4%27 id=%27path596%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 23.091002 35.921781 -9.026643 9.041662 v -4.881296 c 0 -1.303681 -1.009302 -2.355037 -2.242393 -2.358041 -1.237598 0 -2.237888 1.05436 -2.237888 2.358041 l -0.0031 10.016421 c 0 0.04356 0.01211 0.08862 0.0015 0.130659 -0.0031 0.03153 -0.009 0.05709 -0.01211 0.09161 0.0031 1.239099 1.069379 2.237888 2.391085 2.237888 h 10.156101 c 1.320202 0 2.388079 -1.000291 2.388079 -2.237888 0 -1.234591 -1.067877 -2.236383 -2.388079 -2.239387 h -4.858767 l 8.995101 -8.9921 c 0.871126 -0.874127 0.871126 -2.293459 0 -3.167586 -0.875628 -0.877132 -2.291957 -0.877132 -3.169087 -1.52e-4%27 id=%27path598%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 84.649572 25.978033 9.041662 -9.041664 v 4.881298 c 0 1.299176 1.010806 2.350532 2.240891 2.355037 1.240601 0 2.23939 -1.055861 2.23939 -2.355037 V 11.798242 c 0 -0.04356 -0.009 -0.08862 -0.0134 -0.127671 0.0044 -0.03153 0.009 -0.06157 0.0134 -0.09313 -0.0044 -1.240598 -1.069379 -2.2393873 -2.391085 -2.2393873 h -10.1546 c -1.323205 0 -2.38958 0.9987893 -2.38958 2.2393873 0 1.233091 1.066375 2.237887 2.38958 2.240891 h 4.858768 l -8.995102 8.9921 c -0.874129 0.872625 -0.874129 2.288954 0 3.161578 0.874127 0.880137 2.288951 0.880137 3.16308 1.5e-4%27 id=%27path600%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 17.264988 13.822853 h 4.857265 c 1.320202 -0.0031 2.388079 -1.0078 2.388079 -2.240889 0 -1.240601 -1.067877 -2.2393893 -2.388079 -2.2393893 H 11.967654 c -1.321707 0 -2.388082 0.9987883 -2.391085 2.2393893 0.0031 0.03153 0.009 0.06157 0.01211 0.09313 -0.0031 0.03905 -0.0015 0.08262 -0.0015 0.127671 l 0.0031 10.020926 c 0 1.299176 1.00029 2.355038 2.237887 2.355038 1.233092 -0.0044 2.242393 -1.055862 2.242393 -2.355038 v -4.881295 l 9.026644 9.041661 c 0.877132 0.878635 2.293459 0.878635 3.169087 0 0.871125 -0.872624 0.871125 -2.288953 0 -3.161577 l -8.995282 -8.993616%27 id=%27path602%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3C/svg%3E"), __webpack_require__.b);
          var ___CSS_LOADER_URL_IMPORT_3___ = new URL( /* asset import */__webpack_require__( /*! data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E */"data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E"), __webpack_require__.b);
          var ___CSS_LOADER_URL_IMPORT_4___ = new URL( /* asset import */__webpack_require__( /*! data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E */"data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E"), __webpack_require__.b);
          var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default());
          var ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);
          var ___CSS_LOADER_URL_REPLACEMENT_1___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_1___);
          var ___CSS_LOADER_URL_REPLACEMENT_2___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_2___);
          var ___CSS_LOADER_URL_REPLACEMENT_3___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_3___);
          var ___CSS_LOADER_URL_REPLACEMENT_4___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_4___);
          // Module
          ___CSS_LOADER_EXPORT___.push([module.id, "/* .a-fullscreen means not embedded. */\nhtml.a-fullscreen {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n\nhtml.a-fullscreen body {\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n  width: 100%;\n}\n\n/* Class is removed when doing <a-scene embedded>. */\nhtml.a-fullscreen .a-canvas {\n  width: 100% !important;\n  height: 100% !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  position: fixed !important;\n}\n\nhtml:not(.a-fullscreen) .a-enter-vr,\nhtml:not(.a-fullscreen) .a-enter-ar {\n  right: 5px;\n  bottom: 5px;\n}\n\nhtml:not(.a-fullscreen) .a-enter-ar {\n  right: 60px;\n}\n\n/* In chrome mobile the user agent stylesheet set it to white  */\n:-webkit-full-screen {\n  background-color: transparent;\n}\n\n.a-hidden {\n  display: none !important;\n}\n\n.a-canvas {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.a-canvas.a-grab-cursor:hover {\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\ncanvas.a-canvas.a-mouse-cursor-hover:hover {\n  cursor: pointer;\n}\n\n.a-inspector-loader {\n  background-color: #ed3160;\n  position: fixed;\n  left: 3px;\n  top: 3px;\n  padding: 6px 10px;\n  color: #fff;\n  text-decoration: none;\n  font-size: 12px;\n  font-family: Roboto,sans-serif;\n  text-align: center;\n  z-index: 99999;\n  width: 204px;\n}\n\n/* Inspector loader animation */\n@keyframes dots-1 { from { opacity: 0; } 25% { opacity: 1; } }\n@keyframes dots-2 { from { opacity: 0; } 50% { opacity: 1; } }\n@keyframes dots-3 { from { opacity: 0; } 75% { opacity: 1; } }\n@-webkit-keyframes dots-1 { from { opacity: 0; } 25% { opacity: 1; } }\n@-webkit-keyframes dots-2 { from { opacity: 0; } 50% { opacity: 1; } }\n@-webkit-keyframes dots-3 { from { opacity: 0; } 75% { opacity: 1; } }\n\n.a-inspector-loader .dots span {\n  animation: dots-1 2s infinite steps(1);\n  -webkit-animation: dots-1 2s infinite steps(1);\n}\n\n.a-inspector-loader .dots span:first-child + span {\n  animation-name: dots-2;\n  -webkit-animation-name: dots-2;\n}\n\n.a-inspector-loader .dots span:first-child + span + span {\n  animation-name: dots-3;\n  -webkit-animation-name: dots-3;\n}\n\na-scene {\n  display: block;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\na-assets,\na-scene video,\na-scene img,\na-scene audio {\n  display: none;\n}\n\n.a-enter-vr-modal,\n.a-orientation-modal {\n  font-family: Consolas, Andale Mono, Courier New, monospace;\n}\n\n.a-enter-vr-modal a {\n  border-bottom: 1px solid #fff;\n  padding: 2px 0;\n  text-decoration: none;\n  transition: .1s color ease-in;\n}\n\n.a-enter-vr-modal a:hover {\n  background-color: #fff;\n  color: #111;\n  padding: 2px 4px;\n  position: relative;\n  left: -4px;\n}\n\n.a-enter-vr,\n.a-enter-ar {\n  font-family: sans-serif, monospace;\n  font-size: 13px;\n  width: 100%;\n  font-weight: 200;\n  line-height: 16px;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n\n.a-enter-ar {\n  right: 80px;\n}\n\n.a-enter-vr-button,\n.a-enter-vr-modal,\n.a-enter-vr-modal a {\n  color: #fff;\n  user-select: none;\n  outline: none;\n}\n\n.a-enter-vr-button {\n  background: rgba(0, 0, 0, 0.35) url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") 50% 50% no-repeat;\n}\n\n.a-enter-ar-button {\n  background: rgba(0, 0, 0, 0.20) url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") 50% 50% no-repeat;\n}\n\n.a-enter-vr.fullscreen .a-enter-vr-button {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ");\n}\n\n.a-enter-vr-button,\n.a-enter-ar-button {\n  background-size: 90% 90%;\n  border: 0;\n  bottom: 0;\n  cursor: pointer;\n  min-width: 58px;\n  min-height: 34px;\n  /* 1.74418604651 */\n  /*\n    In order to keep the aspect ratio when resizing\n    padding-top percentages are relative to the containing block's width.\n    http://stackoverflow.com/questions/12121090/responsively-change-div-size-keeping-aspect-ratio\n  */\n  padding-right: 0;\n  padding-top: 0;\n  position: absolute;\n  right: 0;\n  transition: background-color .05s ease;\n  -webkit-transition: background-color .05s ease;\n  z-index: 9999;\n  border-radius: 8px;\n  touch-action: manipulation; /* Prevent iOS double tap zoom on the button */\n}\n\n.a-enter-ar-button {\n  background-size: 100% 90%;\n  margin-right: 10px;\n  border-radius: 7px;\n}\n\n.a-enter-ar-button:active,\n.a-enter-ar-button:hover,\n.a-enter-vr-button:active,\n.a-enter-vr-button:hover {\n  background-color: #ef2d5e;\n}\n\n.a-enter-vr-button.resethover {\n  background-color: rgba(0, 0, 0, 0.35);\n}\n\n\n.a-enter-vr-modal {\n  background-color: #666;\n  border-radius: 0;\n  display: none;\n  min-height: 32px;\n  margin-right: 70px;\n  padding: 9px;\n  width: 280px;\n  right: 2%;\n  position: absolute;\n}\n\n.a-enter-vr-modal:after {\n  border-bottom: 10px solid transparent;\n  border-left: 10px solid #666;\n  border-top: 10px solid transparent;\n  display: inline-block;\n  content: '';\n  position: absolute;\n  right: -5px;\n  top: 5px;\n  width: 0;\n  height: 0;\n}\n\n.a-enter-vr-modal p,\n.a-enter-vr-modal a {\n  display: inline;\n}\n\n.a-enter-vr-modal p {\n  margin: 0;\n}\n\n.a-enter-vr-modal p:after {\n  content: ' ';\n}\n\n.a-orientation-modal {\n  background: rgba(244, 244, 244, 1) url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ") center no-repeat;\n  background-size: 50% 50%;\n  bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n  left: 0;\n  line-height: 20px;\n  right: 0;\n  position: fixed;\n  top: 0;\n  z-index: 9999999;\n}\n\n.a-orientation-modal:after {\n  color: #666;\n  content: \"Insert phone into Cardboard holder.\";\n  display: block;\n  position: absolute;\n  text-align: center;\n  top: 70%;\n  transform: translateY(-70%);\n  width: 100%;\n}\n\n.a-orientation-modal button {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ") no-repeat;\n  border: none;\n  height: 50px;\n  text-indent: -9999px;\n  width: 50px;\n}\n\n.a-loader-title {\n  background-color: rgba(0, 0, 0, 0.6);\n  font-family: sans-serif, monospace;\n  text-align: center;\n  font-size: 20px;\n  height: 50px;\n  font-weight: 300;\n  line-height: 50px;\n  position: absolute;\n  right: 0px;\n  left: 0px;\n  top: 0px;\n  color: white;\n}\n\n.a-modal {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.60);\n  background-size: 50% 50%;\n  bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n  left: 0;\n  line-height: 20px;\n  right: 0;\n  position: fixed;\n  top: 0;\n  z-index: 9999999;\n}\n\n.a-dialog {\n  position: relative;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 199995;\n  width: 300px;\n  height: 200px;\n  background-size: contain;\n  background-color: white;\n  font-family: sans-serif, monospace;\n  font-size: 20px;\n  border-radius: 3px;\n  padding: 6px;\n}\n\n.a-dialog-text-container {\n  width: 100%;\n  height: 70%;\n  align-self: flex-start;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n}\n\n.a-dialog-text {\n  display: inline-block;\n  font-weight: normal;\n  font-size: 14pt;\n  margin: 8px;\n}\n\n.a-dialog-buttons-container {\n  display: inline-flex;\n  align-self: flex-end;\n  width: 100%;\n  height: 30%;\n}\n\n.a-dialog-button {\n  cursor: pointer;\n  align-self: center;\n  opacity: 0.9;\n  height: 80%;\n  width: 50%;\n  font-size: 12pt;\n  margin: 4px;\n  border-radius: 2px;\n  text-align:center;\n  border: none;\n  display: inline-block;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.10), 0 1px 2px rgba(0, 0, 0, 0.20);\n  user-select: none;\n}\n\n.a-dialog-permission-button:hover {\n  box-shadow: 0 7px 14px rgba(0,0,0,0.20), 0 2px 2px rgba(0,0,0,0.20);\n}\n\n.a-dialog-allow-button {\n  background-color: #00ceff;\n}\n\n.a-dialog-deny-button {\n  background-color: #ff005b;\n}\n\n.a-dialog-ok-button {\n  background-color: #00ceff;\n  width: 100%;\n}\n\n.a-dom-overlay:not(.a-no-style) {\n  overflow: hidden;\n  position: absolute;\n  pointer-events: none;\n  box-sizing: border-box;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  padding: 1em;\n}\n\n.a-dom-overlay:not(.a-no-style)>* {\n  pointer-events: auto;\n}\n", "", {
            "version": 3,
            "sources": ["webpack://./src/style/aframe.css"],
            "names": [],
            "mappings": "AAAA,sCAAsC;AACtC;EACE,SAAS;EACT,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA,+BAA+B;AAC/B,oBAAoB,OAAO,UAAU,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;AAC7D,oBAAoB,OAAO,UAAU,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;AAC7D,oBAAoB,OAAO,UAAU,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;AAC7D,4BAA4B,OAAO,UAAU,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;AACrE,4BAA4B,OAAO,UAAU,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;AACrE,4BAA4B,OAAO,UAAU,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;;AAErE;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yFAA4qB;AAC9qB;;AAEA;EACE,yFAAkzB;AACpzB;;AAEA;EACE,yDAA2qK;AAC7qK;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;EACT,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB;;;;GAIC;EACD,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,sCAAsC;EACtC,8CAA8C;EAC9C,aAAa;EACb,kBAAkB;EAClB,0BAA0B,EAAE,8CAA8C;AAC5E;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;;AAGA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,kCAAkC;EAClC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2FAAivF;EACjvF,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,6DAA25B;EAC35B,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,yCAAyC;EACzC,iCAAiC;EACjC,wEAAwE;EACxE,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;EACN,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB",
            "sourcesContent": ["/* .a-fullscreen means not embedded. */\nhtml.a-fullscreen {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n\nhtml.a-fullscreen body {\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n  width: 100%;\n}\n\n/* Class is removed when doing <a-scene embedded>. */\nhtml.a-fullscreen .a-canvas {\n  width: 100% !important;\n  height: 100% !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  position: fixed !important;\n}\n\nhtml:not(.a-fullscreen) .a-enter-vr,\nhtml:not(.a-fullscreen) .a-enter-ar {\n  right: 5px;\n  bottom: 5px;\n}\n\nhtml:not(.a-fullscreen) .a-enter-ar {\n  right: 60px;\n}\n\n/* In chrome mobile the user agent stylesheet set it to white  */\n:-webkit-full-screen {\n  background-color: transparent;\n}\n\n.a-hidden {\n  display: none !important;\n}\n\n.a-canvas {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.a-canvas.a-grab-cursor:hover {\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\ncanvas.a-canvas.a-mouse-cursor-hover:hover {\n  cursor: pointer;\n}\n\n.a-inspector-loader {\n  background-color: #ed3160;\n  position: fixed;\n  left: 3px;\n  top: 3px;\n  padding: 6px 10px;\n  color: #fff;\n  text-decoration: none;\n  font-size: 12px;\n  font-family: Roboto,sans-serif;\n  text-align: center;\n  z-index: 99999;\n  width: 204px;\n}\n\n/* Inspector loader animation */\n@keyframes dots-1 { from { opacity: 0; } 25% { opacity: 1; } }\n@keyframes dots-2 { from { opacity: 0; } 50% { opacity: 1; } }\n@keyframes dots-3 { from { opacity: 0; } 75% { opacity: 1; } }\n@-webkit-keyframes dots-1 { from { opacity: 0; } 25% { opacity: 1; } }\n@-webkit-keyframes dots-2 { from { opacity: 0; } 50% { opacity: 1; } }\n@-webkit-keyframes dots-3 { from { opacity: 0; } 75% { opacity: 1; } }\n\n.a-inspector-loader .dots span {\n  animation: dots-1 2s infinite steps(1);\n  -webkit-animation: dots-1 2s infinite steps(1);\n}\n\n.a-inspector-loader .dots span:first-child + span {\n  animation-name: dots-2;\n  -webkit-animation-name: dots-2;\n}\n\n.a-inspector-loader .dots span:first-child + span + span {\n  animation-name: dots-3;\n  -webkit-animation-name: dots-3;\n}\n\na-scene {\n  display: block;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\na-assets,\na-scene video,\na-scene img,\na-scene audio {\n  display: none;\n}\n\n.a-enter-vr-modal,\n.a-orientation-modal {\n  font-family: Consolas, Andale Mono, Courier New, monospace;\n}\n\n.a-enter-vr-modal a {\n  border-bottom: 1px solid #fff;\n  padding: 2px 0;\n  text-decoration: none;\n  transition: .1s color ease-in;\n}\n\n.a-enter-vr-modal a:hover {\n  background-color: #fff;\n  color: #111;\n  padding: 2px 4px;\n  position: relative;\n  left: -4px;\n}\n\n.a-enter-vr,\n.a-enter-ar {\n  font-family: sans-serif, monospace;\n  font-size: 13px;\n  width: 100%;\n  font-weight: 200;\n  line-height: 16px;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n\n.a-enter-ar {\n  right: 80px;\n}\n\n.a-enter-vr-button,\n.a-enter-vr-modal,\n.a-enter-vr-modal a {\n  color: #fff;\n  user-select: none;\n  outline: none;\n}\n\n.a-enter-vr-button {\n  background: rgba(0, 0, 0, 0.35) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='108' height='62' viewBox='0 0 108 62'%3E%3Ctitle%3Eaframe-vrmode-noborder-reduced-tracking%3C/title%3E%3Cpath d='M68.81,21.56H64.23v8.27h4.58a4.13,4.13,0,0,0,3.1-1.09,4.2,4.2,0,0,0,1-3,4.24,4.24,0,0,0-1-3A4.05,4.05,0,0,0,68.81,21.56Z' fill='%23fff'/%3E%3Cpath d='M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0ZM41.9,46H34L24,16h8l6,21.84,6-21.84H52Zm39.29,0H73.44L68.15,35.39H64.23V46H57V16H68.81q5.32,0,8.34,2.37a8,8,0,0,1,3,6.69,9.68,9.68,0,0,1-1.27,5.18,8.9,8.9,0,0,1-4,3.34l6.26,12.11Z' fill='%23fff'/%3E%3C/svg%3E\") 50% 50% no-repeat;\n}\n\n.a-enter-ar-button {\n  background: rgba(0, 0, 0, 0.20) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='108' height='62' viewBox='0 0 108 62'%3E%3Ctitle%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d='M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0Zm8,50a8,8,0,0,1-8,8H12a8,8,0,0,1-8-8V12a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z' fill='%23fff'/%3E%3Cpath d='M43.35,39.82H32.51L30.45,46H23.88L35,16h5.73L52,46H45.43Zm-9.17-5h7.5L37.91,23.58Z' fill='%23fff'/%3E%3Cpath d='M68.11,35H63.18V46H57V16H68.15q5.31,0,8.2,2.37a8.18,8.18,0,0,1,2.88,6.7,9.22,9.22,0,0,1-1.33,5.12,9.09,9.09,0,0,1-4,3.26l6.49,12.26V46H73.73Zm-4.93-5h5a5.09,5.09,0,0,0,3.6-1.18,4.21,4.21,0,0,0,1.28-3.27,4.56,4.56,0,0,0-1.2-3.34A5,5,0,0,0,68.15,21h-5Z' fill='%23fff'/%3E%3C/svg%3E\") 50% 50% no-repeat;\n}\n\n.a-enter-vr.fullscreen .a-enter-vr-button {\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='108' height='62' viewBox='0 0 108 62' version='1.1' id='svg320' sodipodi:docname='fullscreen-aframe.svg' xml:space='preserve' inkscape:version='1.2.1 (9c6d41e  2022-07-14)' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/'%3E%3Cdefs id='defs324' /%3E%3Csodipodi:namedview id='namedview322' pagecolor='%23ffffff' bordercolor='%23000000' borderopacity='0.25' inkscape:showpageshadow='2' inkscape:pageopacity='0.0' inkscape:pagecheckerboard='0' inkscape:deskcolor='%23d1d1d1' showgrid='false' inkscape:zoom='3.8064516' inkscape:cx='91.423729' inkscape:cy='-1.4449153' inkscape:window-width='1440' inkscape:window-height='847' inkscape:window-x='32' inkscape:window-y='25' inkscape:window-maximized='0' inkscape:current-layer='svg320' /%3E%3Ctitle id='title312'%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d='M96 0H12A12 12 0 0 0 0 12V50A12 12 0 0 0 12 62H96a12 12 0 0 0 12-12V12A12 12 0 0 0 96 0Zm8 50a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8H96a8 8 0 0 1 8 8Z' fill='%23fff' id='path314' style='fill:%23ffffff' /%3E%3Cg id='g356' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g358' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g360' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g362' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g364' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g366' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g368' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g370' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g372' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g374' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g376' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g378' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g380' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g382' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cg id='g384' transform='translate(-206.61017 -232.61864)'%3E%3C/g%3E%3Cmetadata id='metadata561'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:title%3Eaframe-armode-noborder-reduced-tracking%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cpath d='m 98.168511 40.083649 c 0 -1.303681 -0.998788 -2.358041 -2.239389 -2.358041 -1.230088 0.0031 -2.240892 1.05436 -2.240892 2.358041 v 4.881296 l -9.041661 -9.041662 c -0.874129 -0.875631 -2.288954 -0.875631 -3.16308 0 -0.874129 0.874126 -0.874129 2.293459 0 3.167585 l 8.995101 8.992101 h -4.858767 c -1.323206 0.0031 -2.389583 1.004796 -2.389583 2.239386 0 1.237598 1.066377 2.237888 2.389583 2.237888 h 10.154599 c 1.323206 0 2.388082 -0.998789 2.392587 -2.237888 -0.0044 -0.03305 -0.009 -0.05858 -0.0134 -0.09161 0.0046 -0.04207 0.0134 -0.08712 0.0134 -0.13066 V 40.085172 h -1.52e-4' id='path596' style='fill:%23ffffff%3Bstroke-width:1.50194' /%3E%3Cpath d='m 23.091002 35.921781 -9.026643 9.041662 v -4.881296 c 0 -1.303681 -1.009302 -2.355037 -2.242393 -2.358041 -1.237598 0 -2.237888 1.05436 -2.237888 2.358041 l -0.0031 10.016421 c 0 0.04356 0.01211 0.08862 0.0015 0.130659 -0.0031 0.03153 -0.009 0.05709 -0.01211 0.09161 0.0031 1.239099 1.069379 2.237888 2.391085 2.237888 h 10.156101 c 1.320202 0 2.388079 -1.000291 2.388079 -2.237888 0 -1.234591 -1.067877 -2.236383 -2.388079 -2.239387 h -4.858767 l 8.995101 -8.9921 c 0.871126 -0.874127 0.871126 -2.293459 0 -3.167586 -0.875628 -0.877132 -2.291957 -0.877132 -3.169087 -1.52e-4' id='path598' style='fill:%23ffffff%3Bstroke-width:1.50194' /%3E%3Cpath d='m 84.649572 25.978033 9.041662 -9.041664 v 4.881298 c 0 1.299176 1.010806 2.350532 2.240891 2.355037 1.240601 0 2.23939 -1.055861 2.23939 -2.355037 V 11.798242 c 0 -0.04356 -0.009 -0.08862 -0.0134 -0.127671 0.0044 -0.03153 0.009 -0.06157 0.0134 -0.09313 -0.0044 -1.240598 -1.069379 -2.2393873 -2.391085 -2.2393873 h -10.1546 c -1.323205 0 -2.38958 0.9987893 -2.38958 2.2393873 0 1.233091 1.066375 2.237887 2.38958 2.240891 h 4.858768 l -8.995102 8.9921 c -0.874129 0.872625 -0.874129 2.288954 0 3.161578 0.874127 0.880137 2.288951 0.880137 3.16308 1.5e-4' id='path600' style='fill:%23ffffff%3Bstroke-width:1.50194' /%3E%3Cpath d='m 17.264988 13.822853 h 4.857265 c 1.320202 -0.0031 2.388079 -1.0078 2.388079 -2.240889 0 -1.240601 -1.067877 -2.2393893 -2.388079 -2.2393893 H 11.967654 c -1.321707 0 -2.388082 0.9987883 -2.391085 2.2393893 0.0031 0.03153 0.009 0.06157 0.01211 0.09313 -0.0031 0.03905 -0.0015 0.08262 -0.0015 0.127671 l 0.0031 10.020926 c 0 1.299176 1.00029 2.355038 2.237887 2.355038 1.233092 -0.0044 2.242393 -1.055862 2.242393 -2.355038 v -4.881295 l 9.026644 9.041661 c 0.877132 0.878635 2.293459 0.878635 3.169087 0 0.871125 -0.872624 0.871125 -2.288953 0 -3.161577 l -8.995282 -8.993616' id='path602' style='fill:%23ffffff%3Bstroke-width:1.50194' /%3E%3C/svg%3E\");\n}\n\n.a-enter-vr-button,\n.a-enter-ar-button {\n  background-size: 90% 90%;\n  border: 0;\n  bottom: 0;\n  cursor: pointer;\n  min-width: 58px;\n  min-height: 34px;\n  /* 1.74418604651 */\n  /*\n    In order to keep the aspect ratio when resizing\n    padding-top percentages are relative to the containing block's width.\n    http://stackoverflow.com/questions/12121090/responsively-change-div-size-keeping-aspect-ratio\n  */\n  padding-right: 0;\n  padding-top: 0;\n  position: absolute;\n  right: 0;\n  transition: background-color .05s ease;\n  -webkit-transition: background-color .05s ease;\n  z-index: 9999;\n  border-radius: 8px;\n  touch-action: manipulation; /* Prevent iOS double tap zoom on the button */\n}\n\n.a-enter-ar-button {\n  background-size: 100% 90%;\n  margin-right: 10px;\n  border-radius: 7px;\n}\n\n.a-enter-ar-button:active,\n.a-enter-ar-button:hover,\n.a-enter-vr-button:active,\n.a-enter-vr-button:hover {\n  background-color: #ef2d5e;\n}\n\n.a-enter-vr-button.resethover {\n  background-color: rgba(0, 0, 0, 0.35);\n}\n\n\n.a-enter-vr-modal {\n  background-color: #666;\n  border-radius: 0;\n  display: none;\n  min-height: 32px;\n  margin-right: 70px;\n  padding: 9px;\n  width: 280px;\n  right: 2%;\n  position: absolute;\n}\n\n.a-enter-vr-modal:after {\n  border-bottom: 10px solid transparent;\n  border-left: 10px solid #666;\n  border-top: 10px solid transparent;\n  display: inline-block;\n  content: '';\n  position: absolute;\n  right: -5px;\n  top: 5px;\n  width: 0;\n  height: 0;\n}\n\n.a-enter-vr-modal p,\n.a-enter-vr-modal a {\n  display: inline;\n}\n\n.a-enter-vr-modal p {\n  margin: 0;\n}\n\n.a-enter-vr-modal p:after {\n  content: ' ';\n}\n\n.a-orientation-modal {\n  background: rgba(244, 244, 244, 1) url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E) center no-repeat;\n  background-size: 50% 50%;\n  bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n  left: 0;\n  line-height: 20px;\n  right: 0;\n  position: fixed;\n  top: 0;\n  z-index: 9999999;\n}\n\n.a-orientation-modal:after {\n  color: #666;\n  content: \"Insert phone into Cardboard holder.\";\n  display: block;\n  position: absolute;\n  text-align: center;\n  top: 70%;\n  transform: translateY(-70%);\n  width: 100%;\n}\n\n.a-orientation-modal button {\n  background: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E) no-repeat;\n  border: none;\n  height: 50px;\n  text-indent: -9999px;\n  width: 50px;\n}\n\n.a-loader-title {\n  background-color: rgba(0, 0, 0, 0.6);\n  font-family: sans-serif, monospace;\n  text-align: center;\n  font-size: 20px;\n  height: 50px;\n  font-weight: 300;\n  line-height: 50px;\n  position: absolute;\n  right: 0px;\n  left: 0px;\n  top: 0px;\n  color: white;\n}\n\n.a-modal {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.60);\n  background-size: 50% 50%;\n  bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n  left: 0;\n  line-height: 20px;\n  right: 0;\n  position: fixed;\n  top: 0;\n  z-index: 9999999;\n}\n\n.a-dialog {\n  position: relative;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 199995;\n  width: 300px;\n  height: 200px;\n  background-size: contain;\n  background-color: white;\n  font-family: sans-serif, monospace;\n  font-size: 20px;\n  border-radius: 3px;\n  padding: 6px;\n}\n\n.a-dialog-text-container {\n  width: 100%;\n  height: 70%;\n  align-self: flex-start;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n}\n\n.a-dialog-text {\n  display: inline-block;\n  font-weight: normal;\n  font-size: 14pt;\n  margin: 8px;\n}\n\n.a-dialog-buttons-container {\n  display: inline-flex;\n  align-self: flex-end;\n  width: 100%;\n  height: 30%;\n}\n\n.a-dialog-button {\n  cursor: pointer;\n  align-self: center;\n  opacity: 0.9;\n  height: 80%;\n  width: 50%;\n  font-size: 12pt;\n  margin: 4px;\n  border-radius: 2px;\n  text-align:center;\n  border: none;\n  display: inline-block;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.10), 0 1px 2px rgba(0, 0, 0, 0.20);\n  user-select: none;\n}\n\n.a-dialog-permission-button:hover {\n  box-shadow: 0 7px 14px rgba(0,0,0,0.20), 0 2px 2px rgba(0,0,0,0.20);\n}\n\n.a-dialog-allow-button {\n  background-color: #00ceff;\n}\n\n.a-dialog-deny-button {\n  background-color: #ff005b;\n}\n\n.a-dialog-ok-button {\n  background-color: #00ceff;\n  width: 100%;\n}\n\n.a-dom-overlay:not(.a-no-style) {\n  overflow: hidden;\n  position: absolute;\n  pointer-events: none;\n  box-sizing: border-box;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  padding: 1em;\n}\n\n.a-dom-overlay:not(.a-no-style)>* {\n  pointer-events: auto;\n}\n"],
            "sourceRoot": ""
          }]);
          // Exports
          /* harmony default export */
          var __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;

          /***/
        },

        /***/"./node_modules/css-loader/dist/cjs.js!./src/style/rStats.css":
        /*!********************************************************************!*\
          !*** ./node_modules/css-loader/dist/cjs.js!./src/style/rStats.css ***!
          \********************************************************************/
        /***/
        function node_modulesCssLoaderDistCjsJsSrcStyleRStatsCss(module, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"default": function _default() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */
          });
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../../node_modules/css-loader/dist/runtime/sourceMaps.js */"./node_modules/css-loader/dist/runtime/sourceMaps.js");
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../../node_modules/css-loader/dist/runtime/api.js */"./node_modules/css-loader/dist/runtime/api.js");
          /* harmony import */
          var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
          // Imports

          var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default());
          // Module
          ___CSS_LOADER_EXPORT___.push([module.id, ".rs-base {\n  background-color: #333;\n  color: #fafafa;\n  border-radius: 0;\n  font: 10px monospace;\n  left: 5px;\n  line-height: 1em;\n  opacity: 0.85;\n  overflow: hidden;\n  padding: 10px;\n  position: fixed;\n  top: 5px;\n  width: 300px;\n  z-index: 10000;\n}\n\n.rs-base div.hidden {\n  display: none;\n}\n\n.rs-base h1 {\n  color: #fff;\n  cursor: pointer;\n  font-size: 1.4em;\n  font-weight: 300;\n  margin: 0 0 5px;\n  padding: 0;\n}\n\n.rs-group {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column-reverse;\n  flex-direction: column-reverse;\n  margin-bottom: 5px;\n}\n\n.rs-group:last-child {\n  margin-bottom: 0;\n}\n\n.rs-counter-base {\n  align-items: center;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  height: 10px;\n  -webkit-justify-content: space-between;\n  justify-content: space-between;\n  margin: 2px 0;\n}\n\n.rs-counter-base.alarm {\n  color: #b70000;\n  text-shadow: 0 0 0 #b70000,\n               0 0 1px #fff,\n               0 0 1px #fff,\n               0 0 2px #fff,\n               0 0 2px #fff,\n               0 0 3px #fff,\n               0 0 3px #fff,\n               0 0 4px #fff,\n               0 0 4px #fff;\n}\n\n.rs-counter-id {\n  font-weight: 300;\n  -webkit-box-ordinal-group: 0;\n  -webkit-order: 0;\n  order: 0;\n  width: 54px;\n}\n\n.rs-counter-value {\n  font-weight: 300;\n  -webkit-box-ordinal-group: 1;\n  -webkit-order: 1;\n  order: 1;\n  text-align: right;\n  width: 35px;\n}\n\n.rs-canvas {\n  -webkit-box-ordinal-group: 2;\n  -webkit-order: 2;\n  order: 2;\n}\n\n@media (min-width: 480px) {\n  .rs-base {\n    left: 20px;\n    top: 20px;\n  }\n}\n", "", {
            "version": 3,
            "sources": ["webpack://./src/style/rStats.css"],
            "names": [],
            "mappings": "AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd;;;;;;;;2BAQyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE;IACE,UAAU;IACV,SAAS;EACX;AACF",
            "sourcesContent": [".rs-base {\n  background-color: #333;\n  color: #fafafa;\n  border-radius: 0;\n  font: 10px monospace;\n  left: 5px;\n  line-height: 1em;\n  opacity: 0.85;\n  overflow: hidden;\n  padding: 10px;\n  position: fixed;\n  top: 5px;\n  width: 300px;\n  z-index: 10000;\n}\n\n.rs-base div.hidden {\n  display: none;\n}\n\n.rs-base h1 {\n  color: #fff;\n  cursor: pointer;\n  font-size: 1.4em;\n  font-weight: 300;\n  margin: 0 0 5px;\n  padding: 0;\n}\n\n.rs-group {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column-reverse;\n  flex-direction: column-reverse;\n  margin-bottom: 5px;\n}\n\n.rs-group:last-child {\n  margin-bottom: 0;\n}\n\n.rs-counter-base {\n  align-items: center;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  height: 10px;\n  -webkit-justify-content: space-between;\n  justify-content: space-between;\n  margin: 2px 0;\n}\n\n.rs-counter-base.alarm {\n  color: #b70000;\n  text-shadow: 0 0 0 #b70000,\n               0 0 1px #fff,\n               0 0 1px #fff,\n               0 0 2px #fff,\n               0 0 2px #fff,\n               0 0 3px #fff,\n               0 0 3px #fff,\n               0 0 4px #fff,\n               0 0 4px #fff;\n}\n\n.rs-counter-id {\n  font-weight: 300;\n  -webkit-box-ordinal-group: 0;\n  -webkit-order: 0;\n  order: 0;\n  width: 54px;\n}\n\n.rs-counter-value {\n  font-weight: 300;\n  -webkit-box-ordinal-group: 1;\n  -webkit-order: 1;\n  order: 1;\n  text-align: right;\n  width: 35px;\n}\n\n.rs-canvas {\n  -webkit-box-ordinal-group: 2;\n  -webkit-order: 2;\n  order: 2;\n}\n\n@media (min-width: 480px) {\n  .rs-base {\n    left: 20px;\n    top: 20px;\n  }\n}\n"],
            "sourceRoot": ""
          }]);
          // Exports
          /* harmony default export */
          var __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;

          /***/
        },

        /***/"./src/style/aframe.css":
        /*!******************************!*\
          !*** ./src/style/aframe.css ***!
          \******************************/
        /***/
        function srcStyleAframeCss(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"default": function _default() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */
          });
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */"./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/styleDomAPI.js */"./node_modules/style-loader/dist/runtime/styleDomAPI.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/insertBySelector.js */"./node_modules/style-loader/dist/runtime/insertBySelector.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js */"./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/insertStyleElement.js */"./node_modules/style-loader/dist/runtime/insertStyleElement.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/styleTagTransform.js */"./node_modules/style-loader/dist/runtime/styleTagTransform.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
          /* harmony import */
          var _node_modules_css_loader_dist_cjs_js_aframe_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! !!../../node_modules/css-loader/dist/cjs.js!./aframe.css */"./node_modules/css-loader/dist/cjs.js!./src/style/aframe.css");
          var options = {};
          options.styleTagTransform = _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default();
          options.setAttributes = _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default();
          options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
          options.domAPI = _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default();
          options.insertStyleElement = _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default();
          var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_aframe_css__WEBPACK_IMPORTED_MODULE_6__["default"], options);

          /* harmony default export */
          var __WEBPACK_DEFAULT_EXPORT__ = _node_modules_css_loader_dist_cjs_js_aframe_css__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_aframe_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_aframe_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined;

          /***/
        },

        /***/"./src/style/rStats.css":
        /*!******************************!*\
          !*** ./src/style/rStats.css ***!
          \******************************/
        /***/
        function srcStyleRStatsCss(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"default": function _default() {
              return __WEBPACK_DEFAULT_EXPORT__;
            }
            /* harmony export */
          });
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */"./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/styleDomAPI.js */"./node_modules/style-loader/dist/runtime/styleDomAPI.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/insertBySelector.js */"./node_modules/style-loader/dist/runtime/insertBySelector.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js */"./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/insertStyleElement.js */"./node_modules/style-loader/dist/runtime/insertStyleElement.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! !../../node_modules/style-loader/dist/runtime/styleTagTransform.js */"./node_modules/style-loader/dist/runtime/styleTagTransform.js");
          /* harmony import */
          var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
          /* harmony import */
          var _node_modules_css_loader_dist_cjs_js_rStats_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! !!../../node_modules/css-loader/dist/cjs.js!./rStats.css */"./node_modules/css-loader/dist/cjs.js!./src/style/rStats.css");
          var options = {};
          options.styleTagTransform = _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default();
          options.setAttributes = _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default();
          options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
          options.domAPI = _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default();
          options.insertStyleElement = _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default();
          var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_rStats_css__WEBPACK_IMPORTED_MODULE_6__["default"], options);

          /* harmony default export */
          var __WEBPACK_DEFAULT_EXPORT__ = _node_modules_css_loader_dist_cjs_js_rStats_css__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_rStats_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_rStats_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined;

          /***/
        },

        /***/"./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
        /*!****************************************************************************!*\
          !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
          \****************************************************************************/
        /***/
        function node_modulesStyleLoaderDistRuntimeInjectStylesIntoStyleTagJs(module) {
          "use strict";

          var stylesInDOM = [];
          function getIndexByIdentifier(identifier) {
            var result = -1;
            for (var i = 0; i < stylesInDOM.length; i++) {
              if (stylesInDOM[i].identifier === identifier) {
                result = i;
                break;
              }
            }
            return result;
          }
          function modulesToDom(list, options) {
            var idCountMap = {};
            var identifiers = [];
            for (var i = 0; i < list.length; i++) {
              var item = list[i];
              var id = options.base ? item[0] + options.base : item[0];
              var count = idCountMap[id] || 0;
              var identifier = "".concat(id, " ").concat(count);
              idCountMap[id] = count + 1;
              var indexByIdentifier = getIndexByIdentifier(identifier);
              var obj = {
                css: item[1],
                media: item[2],
                sourceMap: item[3],
                supports: item[4],
                layer: item[5]
              };
              if (indexByIdentifier !== -1) {
                stylesInDOM[indexByIdentifier].references++;
                stylesInDOM[indexByIdentifier].updater(obj);
              } else {
                var updater = addElementStyle(obj, options);
                options.byIndex = i;
                stylesInDOM.splice(i, 0, {
                  identifier: identifier,
                  updater: updater,
                  references: 1
                });
              }
              identifiers.push(identifier);
            }
            return identifiers;
          }
          function addElementStyle(obj, options) {
            var api = options.domAPI(options);
            api.update(obj);
            var updater = function updater(newObj) {
              if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
                  return;
                }
                api.update(obj = newObj);
              } else {
                api.remove();
              }
            };
            return updater;
          }
          module.exports = function (list, options) {
            options = options || {};
            list = list || [];
            var lastIdentifiers = modulesToDom(list, options);
            return function update(newList) {
              newList = newList || [];
              for (var i = 0; i < lastIdentifiers.length; i++) {
                var identifier = lastIdentifiers[i];
                var index = getIndexByIdentifier(identifier);
                stylesInDOM[index].references--;
              }
              var newLastIdentifiers = modulesToDom(newList, options);
              for (var _i = 0; _i < lastIdentifiers.length; _i++) {
                var _identifier = lastIdentifiers[_i];
                var _index = getIndexByIdentifier(_identifier);
                if (stylesInDOM[_index].references === 0) {
                  stylesInDOM[_index].updater();
                  stylesInDOM.splice(_index, 1);
                }
              }
              lastIdentifiers = newLastIdentifiers;
            };
          };

          /***/
        },

        /***/"./node_modules/style-loader/dist/runtime/insertBySelector.js":
        /*!********************************************************************!*\
          !*** ./node_modules/style-loader/dist/runtime/insertBySelector.js ***!
          \********************************************************************/
        /***/
        function node_modulesStyleLoaderDistRuntimeInsertBySelectorJs(module) {
          "use strict";

          var memo = {};
          /* istanbul ignore next  */

          function getTarget(target) {
            if (typeof memo[target] === "undefined") {
              var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

              if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  // istanbul ignore next
                  styleTarget = null;
                }
              }
              memo[target] = styleTarget;
            }
            return memo[target];
          }
          /* istanbul ignore next  */

          function insertBySelector(insert, style) {
            var target = getTarget(insert);
            if (!target) {
              throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            }
            target.appendChild(style);
          }
          module.exports = insertBySelector;

          /***/
        },

        /***/"./node_modules/style-loader/dist/runtime/insertStyleElement.js":
        /*!**********************************************************************!*\
          !*** ./node_modules/style-loader/dist/runtime/insertStyleElement.js ***!
          \**********************************************************************/
        /***/
        function node_modulesStyleLoaderDistRuntimeInsertStyleElementJs(module) {
          "use strict";

          /* istanbul ignore next  */
          function insertStyleElement(options) {
            var element = document.createElement("style");
            options.setAttributes(element, options.attributes);
            options.insert(element, options.options);
            return element;
          }
          module.exports = insertStyleElement;

          /***/
        },

        /***/"./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js":
        /*!**********************************************************************************!*\
          !*** ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js ***!
          \**********************************************************************************/
        /***/
        function node_modulesStyleLoaderDistRuntimeSetAttributesWithoutAttributesJs(module, __unused_webpack_exports, __webpack_require__) {
          "use strict";

          /* istanbul ignore next  */
          function setAttributesWithoutAttributes(styleElement) {
            var nonce = true ? __webpack_require__.nc : 0;
            if (nonce) {
              styleElement.setAttribute("nonce", nonce);
            }
          }
          module.exports = setAttributesWithoutAttributes;

          /***/
        },

        /***/"./node_modules/style-loader/dist/runtime/styleDomAPI.js":
        /*!***************************************************************!*\
          !*** ./node_modules/style-loader/dist/runtime/styleDomAPI.js ***!
          \***************************************************************/
        /***/
        function node_modulesStyleLoaderDistRuntimeStyleDomAPIJs(module) {
          "use strict";

          /* istanbul ignore next  */
          function apply(styleElement, options, obj) {
            var css = "";
            if (obj.supports) {
              css += "@supports (".concat(obj.supports, ") {");
            }
            if (obj.media) {
              css += "@media ".concat(obj.media, " {");
            }
            var needLayer = typeof obj.layer !== "undefined";
            if (needLayer) {
              css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
            }
            css += obj.css;
            if (needLayer) {
              css += "}";
            }
            if (obj.media) {
              css += "}";
            }
            if (obj.supports) {
              css += "}";
            }
            var sourceMap = obj.sourceMap;
            if (sourceMap && typeof btoa !== "undefined") {
              css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
            } // For old IE

            /* istanbul ignore if  */

            options.styleTagTransform(css, styleElement, options.options);
          }
          function removeStyleElement(styleElement) {
            // istanbul ignore if
            if (styleElement.parentNode === null) {
              return false;
            }
            styleElement.parentNode.removeChild(styleElement);
          }
          /* istanbul ignore next  */

          function domAPI(options) {
            var styleElement = options.insertStyleElement(options);
            return {
              update: function update(obj) {
                apply(styleElement, options, obj);
              },
              remove: function remove() {
                removeStyleElement(styleElement);
              }
            };
          }
          module.exports = domAPI;

          /***/
        },

        /***/"./node_modules/style-loader/dist/runtime/styleTagTransform.js":
        /*!*********************************************************************!*\
          !*** ./node_modules/style-loader/dist/runtime/styleTagTransform.js ***!
          \*********************************************************************/
        /***/
        function node_modulesStyleLoaderDistRuntimeStyleTagTransformJs(module) {
          "use strict";

          /* istanbul ignore next  */
          function styleTagTransform(css, styleElement) {
            if (styleElement.styleSheet) {
              styleElement.styleSheet.cssText = css;
            } else {
              while (styleElement.firstChild) {
                styleElement.removeChild(styleElement.firstChild);
              }
              styleElement.appendChild(document.createTextNode(css));
            }
          }
          module.exports = styleTagTransform;

          /***/
        },

        /***/"data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27 standalone=%27no%27%3F%3E%3Csvg width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27 version=%271.1%27 id=%27svg320%27 sodipodi:docname=%27fullscreen-aframe.svg%27 xml:space=%27preserve%27 inkscape:version=%271.2.1 %289c6d41e  2022-07-14%29%27 xmlns:inkscape=%27http://www.inkscape.org/namespaces/inkscape%27 xmlns:sodipodi=%27http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:svg=%27http://www.w3.org/2000/svg%27 xmlns:rdf=%27http://www.w3.org/1999/02/22-rdf-syntax-ns%23%27 xmlns:cc=%27http://creativecommons.org/ns%23%27 xmlns:dc=%27http://purl.org/dc/elements/1.1/%27%3E%3Cdefs id=%27defs324%27 /%3E%3Csodipodi:namedview id=%27namedview322%27 pagecolor=%27%23ffffff%27 bordercolor=%27%23000000%27 borderopacity=%270.25%27 inkscape:showpageshadow=%272%27 inkscape:pageopacity=%270.0%27 inkscape:pagecheckerboard=%270%27 inkscape:deskcolor=%27%23d1d1d1%27 showgrid=%27false%27 inkscape:zoom=%273.8064516%27 inkscape:cx=%2791.423729%27 inkscape:cy=%27-1.4449153%27 inkscape:window-width=%271440%27 inkscape:window-height=%27847%27 inkscape:window-x=%2732%27 inkscape:window-y=%2725%27 inkscape:window-maximized=%270%27 inkscape:current-layer=%27svg320%27 /%3E%3Ctitle id=%27title312%27%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96 0H12A12 12 0 0 0 0 12V50A12 12 0 0 0 12 62H96a12 12 0 0 0 12-12V12A12 12 0 0 0 96 0Zm8 50a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8H96a8 8 0 0 1 8 8Z%27 fill=%27%23fff%27 id=%27path314%27 style=%27fill:%23ffffff%27 /%3E%3Cg id=%27g356%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g358%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g360%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g362%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g364%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g366%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g368%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g370%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g372%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g374%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g376%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g378%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g380%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g382%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g384%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cmetadata id=%27metadata561%27%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=%27%27%3E%3Cdc:title%3Eaframe-armode-noborder-reduced-tracking%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cpath d=%27m 98.168511 40.083649 c 0 -1.303681 -0.998788 -2.358041 -2.239389 -2.358041 -1.230088 0.0031 -2.240892 1.05436 -2.240892 2.358041 v 4.881296 l -9.041661 -9.041662 c -0.874129 -0.875631 -2.288954 -0.875631 -3.16308 0 -0.874129 0.874126 -0.874129 2.293459 0 3.167585 l 8.995101 8.992101 h -4.858767 c -1.323206 0.0031 -2.389583 1.004796 -2.389583 2.239386 0 1.237598 1.066377 2.237888 2.389583 2.237888 h 10.154599 c 1.323206 0 2.388082 -0.998789 2.392587 -2.237888 -0.0044 -0.03305 -0.009 -0.05858 -0.0134 -0.09161 0.0046 -0.04207 0.0134 -0.08712 0.0134 -0.13066 V 40.085172 h -1.52e-4%27 id=%27path596%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 23.091002 35.921781 -9.026643 9.041662 v -4.881296 c 0 -1.303681 -1.009302 -2.355037 -2.242393 -2.358041 -1.237598 0 -2.237888 1.05436 -2.237888 2.358041 l -0.0031 10.016421 c 0 0.04356 0.01211 0.08862 0.0015 0.130659 -0.0031 0.03153 -0.009 0.05709 -0.01211 0.09161 0.0031 1.239099 1.069379 2.237888 2.391085 2.237888 h 10.156101 c 1.320202 0 2.388079 -1.000291 2.388079 -2.237888 0 -1.234591 -1.067877 -2.236383 -2.388079 -2.239387 h -4.858767 l 8.995101 -8.9921 c 0.871126 -0.874127 0.871126 -2.293459 0 -3.167586 -0.875628 -0.877132 -2.291957 -0.877132 -3.169087 -1.52e-4%27 id=%27path598%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 84.649572 25.978033 9.041662 -9.041664 v 4.881298 c 0 1.299176 1.010806 2.350532 2.240891 2.355037 1.240601 0 2.23939 -1.055861 2.23939 -2.355037 V 11.798242 c 0 -0.04356 -0.009 -0.08862 -0.0134 -0.127671 0.0044 -0.03153 0.009 -0.06157 0.0134 -0.09313 -0.0044 -1.240598 -1.069379 -2.2393873 -2.391085 -2.2393873 h -10.1546 c -1.323205 0 -2.38958 0.9987893 -2.38958 2.2393873 0 1.233091 1.066375 2.237887 2.38958 2.240891 h 4.858768 l -8.995102 8.9921 c -0.874129 0.872625 -0.874129 2.288954 0 3.161578 0.874127 0.880137 2.288951 0.880137 3.16308 1.5e-4%27 id=%27path600%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 17.264988 13.822853 h 4.857265 c 1.320202 -0.0031 2.388079 -1.0078 2.388079 -2.240889 0 -1.240601 -1.067877 -2.2393893 -2.388079 -2.2393893 H 11.967654 c -1.321707 0 -2.388082 0.9987883 -2.391085 2.2393893 0.0031 0.03153 0.009 0.06157 0.01211 0.09313 -0.0031 0.03905 -0.0015 0.08262 -0.0015 0.127671 l 0.0031 10.020926 c 0 1.299176 1.00029 2.355038 2.237887 2.355038 1.233092 -0.0044 2.242393 -1.055862 2.242393 -2.355038 v -4.881295 l 9.026644 9.041661 c 0.877132 0.878635 2.293459 0.878635 3.169087 0 0.871125 -0.872624 0.871125 -2.288953 0 -3.161577 l -8.995282 -8.993616%27 id=%27path602%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3C/svg%3E":
        /*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
          !*** data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27 standalone=%27no%27%3F%3E%3Csvg width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27 version=%271.1%27 id=%27svg320%27 sodipodi:docname=%27fullscreen-aframe.svg%27 xml:space=%27preserve%27 inkscape:version=%271.2.1 %289c6d41e  2022-07-14%29%27 xmlns:inkscape=%27http://www.inkscape.org/namespaces/inkscape%27 xmlns:sodipodi=%27http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:svg=%27http://www.w3.org/2000/svg%27 xmlns:rdf=%27http://www.w3.org/1999/02/22-rdf-syntax-ns%23%27 xmlns:cc=%27http://creativecommons.org/ns%23%27 xmlns:dc=%27http://purl.org/dc/elements/1.1/%27%3E%3Cdefs id=%27defs324%27 /%3E%3Csodipodi:namedview id=%27namedview322%27 pagecolor=%27%23ffffff%27 bordercolor=%27%23000000%27 borderopacity=%270.25%27 inkscape:showpageshadow=%272%27 inkscape:pageopacity=%270.0%27 inkscape:pagecheckerboard=%270%27 inkscape:deskcolor=%27%23d1d1d1%27 showgrid=%27false%27 inkscape:zoom=%273.8064516%27 inkscape:cx=%2791.423729%27 inkscape:cy=%27-1.4449153%27 inkscape:window-width=%271440%27 inkscape:window-height=%27847%27 inkscape:window-x=%2732%27 inkscape:window-y=%2725%27 inkscape:window-maximized=%270%27 inkscape:current-layer=%27svg320%27 /%3E%3Ctitle id=%27title312%27%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96 0H12A12 12 0 0 0 0 12V50A12 12 0 0 0 12 62H96a12 12 0 0 0 12-12V12A12 12 0 0 0 96 0Zm8 50a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8H96a8 8 0 0 1 8 8Z%27 fill=%27%23fff%27 id=%27path314%27 style=%27fill:%23ffffff%27 /%3E%3Cg id=%27g356%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g358%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g360%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g362%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g364%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g366%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g368%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g370%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g372%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g374%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g376%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g378%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g380%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g382%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g384%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cmetadata id=%27metadata561%27%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=%27%27%3E%3Cdc:title%3Eaframe-armode-noborder-reduced-tracking%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cpath d=%27m 98.168511 40.083649 c 0 -1.303681 -0.998788 -2.358041 -2.239389 -2.358041 -1.230088 0.0031 -2.240892 1.05436 -2.240892 2.358041 v 4.881296 l -9.041661 -9.041662 c -0.874129 -0.875631 -2.288954 -0.875631 -3.16308 0 -0.874129 0.874126 -0.874129 2.293459 0 3.167585 l 8.995101 8.992101 h -4.858767 c -1.323206 0.0031 -2.389583 1.004796 -2.389583 2.239386 0 1.237598 1.066377 2.237888 2.389583 2.237888 h 10.154599 c 1.323206 0 2.388082 -0.998789 2.392587 -2.237888 -0.0044 -0.03305 -0.009 -0.05858 -0.0134 -0.09161 0.0046 -0.04207 0.0134 -0.08712 0.0134 -0.13066 V 40.085172 h -1.52e-4%27 id=%27path596%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 23.091002 35.921781 -9.026643 9.041662 v -4.881296 c 0 -1.303681 -1.009302 -2.355037 -2.242393 -2.358041 -1.237598 0 -2.237888 1.05436 -2.237888 2.358041 l -0.0031 10.016421 c 0 0.04356 0.01211 0.08862 0.0015 0.130659 -0.0031 0.03153 -0.009 0.05709 -0.01211 0.09161 0.0031 1.239099 1.069379 2.237888 2.391085 2.237888 h 10.156101 c 1.320202 0 2.388079 -1.000291 2.388079 -2.237888 0 -1.234591 -1.067877 -2.236383 -2.388079 -2.239387 h -4.858767 l 8.995101 -8.9921 c 0.871126 -0.874127 0.871126 -2.293459 0 -3.167586 -0.875628 -0.877132 -2.291957 -0.877132 -3.169087 -1.52e-4%27 id=%27path598%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 84.649572 25.978033 9.041662 -9.041664 v 4.881298 c 0 1.299176 1.010806 2.350532 2.240891 2.355037 1.240601 0 2.23939 -1.055861 2.23939 -2.355037 V 11.798242 c 0 -0.04356 -0.009 -0.08862 -0.0134 -0.127671 0.0044 -0.03153 0.009 -0.06157 0.0134 -0.09313 -0.0044 -1.240598 -1.069379 -2.2393873 -2.391085 -2.2393873 h -10.1546 c -1.323205 0 -2.38958 0.9987893 -2.38958 2.2393873 0 1.233091 1.066375 2.237887 2.38958 2.240891 h 4.858768 l -8.995102 8.9921 c -0.874129 0.872625 -0.874129 2.288954 0 3.161578 0.874127 0.880137 2.288951 0.880137 3.16308 1.5e-4%27 id=%27path600%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 17.264988 13.822853 h 4.857265 c 1.320202 -0.0031 2.388079 -1.0078 2.388079 -2.240889 0 -1.240601 -1.067877 -2.2393893 -2.388079 -2.2393893 H 11.967654 c -1.321707 0 -2.388082 0.9987883 -2.391085 2.2393893 0.0031 0.03153 0.009 0.06157 0.01211 0.09313 -0.0031 0.03905 -0.0015 0.08262 -0.0015 0.127671 l 0.0031 10.020926 c 0 1.299176 1.00029 2.355038 2.237887 2.355038 1.233092 -0.0044 2.242393 -1.055862 2.242393 -2.355038 v -4.881295 l 9.026644 9.041661 c 0.877132 0.878635 2.293459 0.878635 3.169087 0 0.871125 -0.872624 0.871125 -2.288953 0 -3.161577 l -8.995282 -8.993616%27 id=%27path602%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3C/svg%3E ***!
          \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
        /***/
        function dataImageSvgXml3C3FxmlVersion271027Encoding27UTF827Standalone27no273F3E3CsvgWidth2710827Height276227ViewBox27001086227Version271127Id27svg32027SodipodiDocname27fullscreenAframeSvg27XmlSpace27preserve27InkscapeVersion27121289c6d41e202207142927XmlnsInkscape27httpWwwInkscapeOrgNamespacesInkscape27XmlnsSodipodi27httpSodipodiSourceforgeNetDTDSodipodi0Dtd27Xmlns27httpWwwW3Org2000Svg27XmlnsSvg27httpWwwW3Org2000Svg27XmlnsRdf27httpWwwW3Org19990222RdfSyntaxNs2327XmlnsCc27httpCreativecommonsOrgNs2327XmlnsDc27httpPurlOrgDcElements11273E3CdefsId27defs324273E3CsodipodiNamedviewId27namedview32227Pagecolor2723ffffff27Bordercolor272300000027Borderopacity2702527InkscapeShowpageshadow27227InkscapePageopacity270027InkscapePagecheckerboard27027InkscapeDeskcolor2723d1d1d127Showgrid27false27InkscapeZoom273806451627InkscapeCx279142372927InkscapeCy271444915327InkscapeWindowWidth27144027InkscapeWindowHeight2784727InkscapeWindowX273227InkscapeWindowY272527InkscapeWindowMaximized27027InkscapeCurrentLayer27svg320273E3CtitleId27title312273EaframeArmodeNoborderReducedTracking3CTitle3E3CpathD27M960H12A1212000012V50A12120001262H96a12120001212V12A1212000960Zm850a8800188H12a8800188V12a8800188H96a8800188Z27Fill2723fff27Id27path31427Style27fill23ffffff273E3CgId27g35627Transform27translate28206610172326186429273E3CG3E3CgId27g35827Transform27translate28206610172326186429273E3CG3E3CgId27g36027Transform27translate28206610172326186429273E3CG3E3CgId27g36227Transform27translate28206610172326186429273E3CG3E3CgId27g36427Transform27translate28206610172326186429273E3CG3E3CgId27g36627Transform27translate28206610172326186429273E3CG3E3CgId27g36827Transform27translate28206610172326186429273E3CG3E3CgId27g37027Transform27translate28206610172326186429273E3CG3E3CgId27g37227Transform27translate28206610172326186429273E3CG3E3CgId27g37427Transform27translate28206610172326186429273E3CG3E3CgId27g37627Transform27translate28206610172326186429273E3CG3E3CgId27g37827Transform27translate28206610172326186429273E3CG3E3CgId27g38027Transform27translate28206610172326186429273E3CG3E3CgId27g38227Transform27translate28206610172326186429273E3CG3E3CgId27g38427Transform27translate28206610172326186429273E3CG3E3CmetadataId27metadata561273E3CrdfRDF3E3CccWorkRdfAbout27273E3CdcTitle3EaframeArmodeNoborderReducedTracking3CDcTitle3E3CCcWork3E3CRdfRDF3E3CMetadata3E3CpathD27m9816851140083649C013036810998788235804122393892358041123008800031224089210543622408922358041V4881296L90416619041662C08741290875631228895408756313163080087412908741260874129229345903167585L89951018992101H4858767C1323206000312389583100479623895832239386012375981066377223788823895832237888H10154599C13232060238808209987892392587223788800044003305000900585800134009161000460042070013400871200134013066V40085172H152e427Id27path59627Style27fill23ffffff3BstrokeWidth150194273E3CpathD27m230910023592178190266439041662V4881296C01303681100930223550372242393235804112375980223788810543622378882358041L0003110016421C00043560012110088620001501306590003100315300090057090012110091610003112390991069379223788823910852237888H10156101C132020202388079100029123880792237888012345911067877223638323880792239387H4858767L899510189921C08711260874127087112622934590316758608756280877132229195708771323169087152e427Id27path59827Style27fill23ffffff3BstrokeWidth150194273E3CpathD27m846495722597803390416629041664V4881298C0129917610108062350532224089123550371240601022393910558612239392355037V11798242C0004356000900886200134012767100044003153000900615700134009313000441240598106937922393873239108522393873H101546C13232050238958099878932389582239387301233091106637522378872389582240891H4858768L899510289921C087412908726250874129228895403161578087412708801372288951088013731630815e427Id27path60027Style27fill23ffffff3BstrokeWidth150194273E3CpathD27m1726498813822853H4857265C1320202000312388079100782388079224088901240601106787722393893238807922393893H11967654C132170702388082099878832391085223938930003100315300090061570012110093130003100390500015008262000150127671L0003110020926C012991761000292355038223788723550381233092000442242393105586222423932355038V4881295L90266449041661C087713208786352293459087863531690870087112508726240871125228895303161577L8995282899361627Id27path60227Style27fill23ffffff3BstrokeWidth150194273E3CSvg3E(module) {
          "use strict";

          module.exports = "data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27 standalone=%27no%27%3F%3E%3Csvg width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27 version=%271.1%27 id=%27svg320%27 sodipodi:docname=%27fullscreen-aframe.svg%27 xml:space=%27preserve%27 inkscape:version=%271.2.1 %289c6d41e  2022-07-14%29%27 xmlns:inkscape=%27http://www.inkscape.org/namespaces/inkscape%27 xmlns:sodipodi=%27http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:svg=%27http://www.w3.org/2000/svg%27 xmlns:rdf=%27http://www.w3.org/1999/02/22-rdf-syntax-ns%23%27 xmlns:cc=%27http://creativecommons.org/ns%23%27 xmlns:dc=%27http://purl.org/dc/elements/1.1/%27%3E%3Cdefs id=%27defs324%27 /%3E%3Csodipodi:namedview id=%27namedview322%27 pagecolor=%27%23ffffff%27 bordercolor=%27%23000000%27 borderopacity=%270.25%27 inkscape:showpageshadow=%272%27 inkscape:pageopacity=%270.0%27 inkscape:pagecheckerboard=%270%27 inkscape:deskcolor=%27%23d1d1d1%27 showgrid=%27false%27 inkscape:zoom=%273.8064516%27 inkscape:cx=%2791.423729%27 inkscape:cy=%27-1.4449153%27 inkscape:window-width=%271440%27 inkscape:window-height=%27847%27 inkscape:window-x=%2732%27 inkscape:window-y=%2725%27 inkscape:window-maximized=%270%27 inkscape:current-layer=%27svg320%27 /%3E%3Ctitle id=%27title312%27%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96 0H12A12 12 0 0 0 0 12V50A12 12 0 0 0 12 62H96a12 12 0 0 0 12-12V12A12 12 0 0 0 96 0Zm8 50a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8H96a8 8 0 0 1 8 8Z%27 fill=%27%23fff%27 id=%27path314%27 style=%27fill:%23ffffff%27 /%3E%3Cg id=%27g356%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g358%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g360%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g362%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g364%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g366%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g368%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g370%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g372%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g374%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g376%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g378%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g380%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g382%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cg id=%27g384%27 transform=%27translate%28-206.61017 -232.61864%29%27%3E%3C/g%3E%3Cmetadata id=%27metadata561%27%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=%27%27%3E%3Cdc:title%3Eaframe-armode-noborder-reduced-tracking%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cpath d=%27m 98.168511 40.083649 c 0 -1.303681 -0.998788 -2.358041 -2.239389 -2.358041 -1.230088 0.0031 -2.240892 1.05436 -2.240892 2.358041 v 4.881296 l -9.041661 -9.041662 c -0.874129 -0.875631 -2.288954 -0.875631 -3.16308 0 -0.874129 0.874126 -0.874129 2.293459 0 3.167585 l 8.995101 8.992101 h -4.858767 c -1.323206 0.0031 -2.389583 1.004796 -2.389583 2.239386 0 1.237598 1.066377 2.237888 2.389583 2.237888 h 10.154599 c 1.323206 0 2.388082 -0.998789 2.392587 -2.237888 -0.0044 -0.03305 -0.009 -0.05858 -0.0134 -0.09161 0.0046 -0.04207 0.0134 -0.08712 0.0134 -0.13066 V 40.085172 h -1.52e-4%27 id=%27path596%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 23.091002 35.921781 -9.026643 9.041662 v -4.881296 c 0 -1.303681 -1.009302 -2.355037 -2.242393 -2.358041 -1.237598 0 -2.237888 1.05436 -2.237888 2.358041 l -0.0031 10.016421 c 0 0.04356 0.01211 0.08862 0.0015 0.130659 -0.0031 0.03153 -0.009 0.05709 -0.01211 0.09161 0.0031 1.239099 1.069379 2.237888 2.391085 2.237888 h 10.156101 c 1.320202 0 2.388079 -1.000291 2.388079 -2.237888 0 -1.234591 -1.067877 -2.236383 -2.388079 -2.239387 h -4.858767 l 8.995101 -8.9921 c 0.871126 -0.874127 0.871126 -2.293459 0 -3.167586 -0.875628 -0.877132 -2.291957 -0.877132 -3.169087 -1.52e-4%27 id=%27path598%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 84.649572 25.978033 9.041662 -9.041664 v 4.881298 c 0 1.299176 1.010806 2.350532 2.240891 2.355037 1.240601 0 2.23939 -1.055861 2.23939 -2.355037 V 11.798242 c 0 -0.04356 -0.009 -0.08862 -0.0134 -0.127671 0.0044 -0.03153 0.009 -0.06157 0.0134 -0.09313 -0.0044 -1.240598 -1.069379 -2.2393873 -2.391085 -2.2393873 h -10.1546 c -1.323205 0 -2.38958 0.9987893 -2.38958 2.2393873 0 1.233091 1.066375 2.237887 2.38958 2.240891 h 4.858768 l -8.995102 8.9921 c -0.874129 0.872625 -0.874129 2.288954 0 3.161578 0.874127 0.880137 2.288951 0.880137 3.16308 1.5e-4%27 id=%27path600%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3Cpath d=%27m 17.264988 13.822853 h 4.857265 c 1.320202 -0.0031 2.388079 -1.0078 2.388079 -2.240889 0 -1.240601 -1.067877 -2.2393893 -2.388079 -2.2393893 H 11.967654 c -1.321707 0 -2.388082 0.9987883 -2.391085 2.2393893 0.0031 0.03153 0.009 0.06157 0.01211 0.09313 -0.0031 0.03905 -0.0015 0.08262 -0.0015 0.127671 l 0.0031 10.020926 c 0 1.299176 1.00029 2.355038 2.237887 2.355038 1.233092 -0.0044 2.242393 -1.055862 2.242393 -2.355038 v -4.881295 l 9.026644 9.041661 c 0.877132 0.878635 2.293459 0.878635 3.169087 0 0.871125 -0.872624 0.871125 -2.288953 0 -3.161577 l -8.995282 -8.993616%27 id=%27path602%27 style=%27fill:%23ffffff%3Bstroke-width:1.50194%27 /%3E%3C/svg%3E";

          /***/
        },

        /***/"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0Zm8,50a8,8,0,0,1-8,8H12a8,8,0,0,1-8-8V12a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M43.35,39.82H32.51L30.45,46H23.88L35,16h5.73L52,46H45.43Zm-9.17-5h7.5L37.91,23.58Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M68.11,35H63.18V46H57V16H68.15q5.31,0,8.2,2.37a8.18,8.18,0,0,1,2.88,6.7,9.22,9.22,0,0,1-1.33,5.12,9.09,9.09,0,0,1-4,3.26l6.49,12.26V46H73.73Zm-4.93-5h5a5.09,5.09,0,0,0,3.6-1.18,4.21,4.21,0,0,0,1.28-3.27,4.56,4.56,0,0,0-1.2-3.34A5,5,0,0,0,68.15,21h-5Z%27 fill=%27%23fff%27/%3E%3C/svg%3E":
        /*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
          !*** data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0Zm8,50a8,8,0,0,1-8,8H12a8,8,0,0,1-8-8V12a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M43.35,39.82H32.51L30.45,46H23.88L35,16h5.73L52,46H45.43Zm-9.17-5h7.5L37.91,23.58Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M68.11,35H63.18V46H57V16H68.15q5.31,0,8.2,2.37a8.18,8.18,0,0,1,2.88,6.7,9.22,9.22,0,0,1-1.33,5.12,9.09,9.09,0,0,1-4,3.26l6.49,12.26V46H73.73Zm-4.93-5h5a5.09,5.09,0,0,0,3.6-1.18,4.21,4.21,0,0,0,1.28-3.27,4.56,4.56,0,0,0-1.2-3.34A5,5,0,0,0,68.15,21h-5Z%27 fill=%27%23fff%27/%3E%3C/svg%3E ***!
          \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
        /***/
        function dataImageSvgXml3CsvgXmlns27httpWwwW3Org2000Svg27Width2710827Height276227ViewBox270010862273E3Ctitle3EaframeArmodeNoborderReducedTracking3CTitle3E3CpathD27M960H12A1212000012V50A12120001262H96a12120001212V12A1212000960Zm850a8800188H12a8800188V12a8800188H96a8800188Z27Fill2723fff273E3CpathD27M43353982H3251L304546H2388L3516h573L5246H4543Zm9175h75L37912358Z27Fill2723fff273E3CpathD27M681135H6318V46H57V16H6815q531082237a818818001288679229220011335129099090014326l6491226V46H7373Zm4935h5a5095090003611842142100012832745645600012334A55000681521h5Z27Fill2723fff273E3CSvg3E(module) {
          "use strict";

          module.exports = "data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-armode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0Zm8,50a8,8,0,0,1-8,8H12a8,8,0,0,1-8-8V12a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M43.35,39.82H32.51L30.45,46H23.88L35,16h5.73L52,46H45.43Zm-9.17-5h7.5L37.91,23.58Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M68.11,35H63.18V46H57V16H68.15q5.31,0,8.2,2.37a8.18,8.18,0,0,1,2.88,6.7,9.22,9.22,0,0,1-1.33,5.12,9.09,9.09,0,0,1-4,3.26l6.49,12.26V46H73.73Zm-4.93-5h5a5.09,5.09,0,0,0,3.6-1.18,4.21,4.21,0,0,0,1.28-3.27,4.56,4.56,0,0,0-1.2-3.34A5,5,0,0,0,68.15,21h-5Z%27 fill=%27%23fff%27/%3E%3C/svg%3E";

          /***/
        },

        /***/"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-vrmode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M68.81,21.56H64.23v8.27h4.58a4.13,4.13,0,0,0,3.1-1.09,4.2,4.2,0,0,0,1-3,4.24,4.24,0,0,0-1-3A4.05,4.05,0,0,0,68.81,21.56Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0ZM41.9,46H34L24,16h8l6,21.84,6-21.84H52Zm39.29,0H73.44L68.15,35.39H64.23V46H57V16H68.81q5.32,0,8.34,2.37a8,8,0,0,1,3,6.69,9.68,9.68,0,0,1-1.27,5.18,8.9,8.9,0,0,1-4,3.34l6.26,12.11Z%27 fill=%27%23fff%27/%3E%3C/svg%3E":
        /*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
          !*** data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-vrmode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M68.81,21.56H64.23v8.27h4.58a4.13,4.13,0,0,0,3.1-1.09,4.2,4.2,0,0,0,1-3,4.24,4.24,0,0,0-1-3A4.05,4.05,0,0,0,68.81,21.56Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0ZM41.9,46H34L24,16h8l6,21.84,6-21.84H52Zm39.29,0H73.44L68.15,35.39H64.23V46H57V16H68.81q5.32,0,8.34,2.37a8,8,0,0,1,3,6.69,9.68,9.68,0,0,1-1.27,5.18,8.9,8.9,0,0,1-4,3.34l6.26,12.11Z%27 fill=%27%23fff%27/%3E%3C/svg%3E ***!
          \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
        /***/
        function dataImageSvgXml3CsvgXmlns27httpWwwW3Org2000Svg27Width2710827Height276227ViewBox270010862273E3Ctitle3EaframeVrmodeNoborderReducedTracking3CTitle3E3CpathD27M68812156H6423v827h458a4134130003110942420001342442400013A40540500068812156Z27Fill2723fff273E3CpathD27M960H12A1212000012V50A12120001262H96a12120001212V12A1212000960ZM41946H34L2416h8l6218462184H52Zm39290H7344L68153539H6423V46H57V16H6881q5320834237a88001366996896800112751889890014334l6261211Z27Fill2723fff273E3CSvg3E(module) {
          "use strict";

          module.exports = "data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27108%27 height=%2762%27 viewBox=%270 0 108 62%27%3E%3Ctitle%3Eaframe-vrmode-noborder-reduced-tracking%3C/title%3E%3Cpath d=%27M68.81,21.56H64.23v8.27h4.58a4.13,4.13,0,0,0,3.1-1.09,4.2,4.2,0,0,0,1-3,4.24,4.24,0,0,0-1-3A4.05,4.05,0,0,0,68.81,21.56Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M96,0H12A12,12,0,0,0,0,12V50A12,12,0,0,0,12,62H96a12,12,0,0,0,12-12V12A12,12,0,0,0,96,0ZM41.9,46H34L24,16h8l6,21.84,6-21.84H52Zm39.29,0H73.44L68.15,35.39H64.23V46H57V16H68.81q5.32,0,8.34,2.37a8,8,0,0,1,3,6.69,9.68,9.68,0,0,1-1.27,5.18,8.9,8.9,0,0,1-4,3.34l6.26,12.11Z%27 fill=%27%23fff%27/%3E%3C/svg%3E";

          /***/
        },

        /***/"data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E":
        /*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
          !*** data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E ***!
          \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
        /***/
        function dataImageSvgXml3Csvg20xmlns3D22http3AWwwW3Org2000Svg2220xmlns3Axlink3D22http3AWwwW3Org1999Xlink2220version3D22112220x3D220px2220y3D220px2220viewBox3D22020020100201002220enableBackground3D22new20020020100201002220xml3Aspace3D22preserve223E3Cpath20fill3D22230000002220d3D22M552092C50l1780317803c141614162C141637132C05129c141614173713141751292C0L50082C448722020L322782C27069c141614173714141751292C0c14172C141614172C37132C02C5129L449512C50L271492C678032020c14172C141614172C37132C02C5129c07082C07082C16362C10622C25642C1062c09282C02C185603542C25641062L50082C5513l178032C178022020c07082C07082C16372C10622C25642C1062s185603542C25641062c141614162C141637132C05129L552092C50z223E3CPath3E3CSvg3E(module) {
          "use strict";

          module.exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E";

          /***/
        },

        /***/"data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E":
        /*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
          !*** data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E ***!
          \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
        /***/
        function dataImageSvgXml3Csvg20xmlns3D22http3AWwwW3Org2000Svg2220xmlns3Axlink3D22http3AWwwW3Org1999Xlink2220version3D22112220x3D220px2220y3D220px2220viewBox3D220200209020902220enableBackground3D22new200200209020902220xml3Aspace3D22preserve223E3Cpolygon20points3D2202C02002C02002C020223E3CPolygon3E3Cg3E3Cpath20d3D22M715452C48145h3198V20743c026272138476547654765H18456c26282C047672C213847672C4765v42789202020c02C26282C21382C47662C47672C4766h5535v0959c02C26282C21382C47652C47662C4765h42788c26282C02C476621372C47664765V52914202020C763112C502842C741732C481452C715452C48145z20M184552C16935h16344c212C02C38082C17082C38082C3808v27401H3725V22636202020c002640215047804790478H16482c02642C004792C021404792C0478v36585c02C02642C02152C04782C04792C0478h7507v7644202020h5534c21012C03811709381381V20743C146452C186432C163542C169352C184552C16935z20M16962C23116h19331v25031h7535202020c26282C047662C213947662C4768v5828h703V23116z20M715452C73064H28757c21012C038117083813808V52914202020c021022C170938122C3813812h42788c212C02C38092C1712C38092C3812v16343C753542C713562C736452C730642C715452C73064z223E3CPath3E3Cpath20d3D22M289192C58424c14662C026592C119326592C266c02C14662C11932C26582C26592C2658c14682C02C266211922C26622658202020C315812C596172C303872C584242C289192C58424z20M289192C62786c09392C01703076417031702c009392C076417042C17031704202020c0942C02C17052C07652C17052C1704C306232C620222C298582C627862C289192C62786z223E3CPath3E3Cpath20d3D22M696542C50461H33069c02642C004792C021504792C0479v20288c02C02642C02152C04782C04792C0478h36585202020c02632C02C047702142C04770478V50939C701312C506762C699172C504612C696542C50461z20M691742C51417V7075H33548V51417H69174z223E3CPath3E3Cpath20d3D22M452012C30296c66512C02C122332C53512C125512C11977l30332638c019301650507014206752C0048202020c01742C019801532C05012C00452C0676l38832C3375c0092C00752C01982C01152C03122C0115c01412C02C027300612C03620166202020l33713877c0173022C0151050200470675c019401660508014406762C0048l25922C2979202020c01834171629660540999001c253824615877381794043817c02642C004792C021504792C0479202020C44722C300832C449362C302962C452012C30296z223E3CPath3E3CG3E3CSvg3E(module) {
          "use strict";

          module.exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E";

          /***/
        },

        /***/"./node_modules/super-three/build/three.module.js":
        /*!********************************************************!*\
          !*** ./node_modules/super-three/build/three.module.js ***!
          \********************************************************/
        /***/
        function node_modulesSuperThreeBuildThreeModuleJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          var _FN;
          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"ACESFilmicToneMapping": function ACESFilmicToneMapping() {
              return (/* binding */_ACESFilmicToneMapping
              );
            },
            /* harmony export */"AddEquation": function AddEquation() {
              return (/* binding */_AddEquation
              );
            },
            /* harmony export */"AddOperation": function AddOperation() {
              return (/* binding */_AddOperation
              );
            },
            /* harmony export */"AdditiveAnimationBlendMode": function AdditiveAnimationBlendMode() {
              return (/* binding */_AdditiveAnimationBlendMode
              );
            },
            /* harmony export */"AdditiveBlending": function AdditiveBlending() {
              return (/* binding */_AdditiveBlending
              );
            },
            /* harmony export */"AlphaFormat": function AlphaFormat() {
              return (/* binding */_AlphaFormat
              );
            },
            /* harmony export */"AlwaysDepth": function AlwaysDepth() {
              return (/* binding */_AlwaysDepth
              );
            },
            /* harmony export */"AlwaysStencilFunc": function AlwaysStencilFunc() {
              return (/* binding */_AlwaysStencilFunc
              );
            },
            /* harmony export */"AmbientLight": function AmbientLight() {
              return (/* binding */_AmbientLight
              );
            },
            /* harmony export */"AmbientLightProbe": function AmbientLightProbe() {
              return (/* binding */_AmbientLightProbe
              );
            },
            /* harmony export */"AnimationClip": function AnimationClip() {
              return (/* binding */_AnimationClip
              );
            },
            /* harmony export */"AnimationLoader": function AnimationLoader() {
              return (/* binding */_AnimationLoader
              );
            },
            /* harmony export */"AnimationMixer": function AnimationMixer() {
              return (/* binding */_AnimationMixer
              );
            },
            /* harmony export */"AnimationObjectGroup": function AnimationObjectGroup() {
              return (/* binding */_AnimationObjectGroup
              );
            },
            /* harmony export */"AnimationUtils": function AnimationUtils() {
              return (/* binding */_AnimationUtils
              );
            },
            /* harmony export */"ArcCurve": function ArcCurve() {
              return (/* binding */_ArcCurve
              );
            },
            /* harmony export */"ArrayCamera": function ArrayCamera() {
              return (/* binding */_ArrayCamera
              );
            },
            /* harmony export */"ArrowHelper": function ArrowHelper() {
              return (/* binding */_ArrowHelper
              );
            },
            /* harmony export */"Audio": function Audio() {
              return (/* binding */_Audio
              );
            },
            /* harmony export */"AudioAnalyser": function AudioAnalyser() {
              return (/* binding */_AudioAnalyser
              );
            },
            /* harmony export */"AudioContext": function AudioContext() {
              return (/* binding */_AudioContext
              );
            },
            /* harmony export */"AudioListener": function AudioListener() {
              return (/* binding */_AudioListener
              );
            },
            /* harmony export */"AudioLoader": function AudioLoader() {
              return (/* binding */_AudioLoader
              );
            },
            /* harmony export */"AxesHelper": function AxesHelper() {
              return (/* binding */_AxesHelper
              );
            },
            /* harmony export */"BackSide": function BackSide() {
              return (/* binding */_BackSide
              );
            },
            /* harmony export */"BasicDepthPacking": function BasicDepthPacking() {
              return (/* binding */_BasicDepthPacking
              );
            },
            /* harmony export */"BasicShadowMap": function BasicShadowMap() {
              return (/* binding */_BasicShadowMap
              );
            },
            /* harmony export */"Bone": function Bone() {
              return (/* binding */_Bone
              );
            },
            /* harmony export */"BooleanKeyframeTrack": function BooleanKeyframeTrack() {
              return (/* binding */_BooleanKeyframeTrack
              );
            },
            /* harmony export */"Box2": function Box2() {
              return (/* binding */_Box
              );
            },
            /* harmony export */"Box3": function Box3() {
              return (/* binding */_Box2
              );
            },
            /* harmony export */"Box3Helper": function Box3Helper() {
              return (/* binding */_Box3Helper
              );
            },
            /* harmony export */"BoxBufferGeometry": function BoxBufferGeometry() {
              return (/* binding */_BoxBufferGeometry
              );
            },
            /* harmony export */"BoxGeometry": function BoxGeometry() {
              return (/* binding */_BoxGeometry
              );
            },
            /* harmony export */"BoxHelper": function BoxHelper() {
              return (/* binding */_BoxHelper
              );
            },
            /* harmony export */"BufferAttribute": function BufferAttribute() {
              return (/* binding */_BufferAttribute
              );
            },
            /* harmony export */"BufferGeometry": function BufferGeometry() {
              return (/* binding */_BufferGeometry
              );
            },
            /* harmony export */"BufferGeometryLoader": function BufferGeometryLoader() {
              return (/* binding */_BufferGeometryLoader
              );
            },
            /* harmony export */"ByteType": function ByteType() {
              return (/* binding */_ByteType
              );
            },
            /* harmony export */"Cache": function Cache() {
              return (/* binding */_Cache
              );
            },
            /* harmony export */"Camera": function Camera() {
              return (/* binding */_Camera
              );
            },
            /* harmony export */"CameraHelper": function CameraHelper() {
              return (/* binding */_CameraHelper
              );
            },
            /* harmony export */"CanvasTexture": function CanvasTexture() {
              return (/* binding */_CanvasTexture
              );
            },
            /* harmony export */"CapsuleBufferGeometry": function CapsuleBufferGeometry() {
              return (/* binding */_CapsuleBufferGeometry
              );
            },
            /* harmony export */"CapsuleGeometry": function CapsuleGeometry() {
              return (/* binding */_CapsuleGeometry
              );
            },
            /* harmony export */"CatmullRomCurve3": function CatmullRomCurve3() {
              return (/* binding */_CatmullRomCurve
              );
            },
            /* harmony export */"CineonToneMapping": function CineonToneMapping() {
              return (/* binding */_CineonToneMapping
              );
            },
            /* harmony export */"CircleBufferGeometry": function CircleBufferGeometry() {
              return (/* binding */_CircleBufferGeometry
              );
            },
            /* harmony export */"CircleGeometry": function CircleGeometry() {
              return (/* binding */_CircleGeometry
              );
            },
            /* harmony export */"ClampToEdgeWrapping": function ClampToEdgeWrapping() {
              return (/* binding */_ClampToEdgeWrapping
              );
            },
            /* harmony export */"Clock": function Clock() {
              return (/* binding */_Clock
              );
            },
            /* harmony export */"Color": function Color() {
              return (/* binding */_Color
              );
            },
            /* harmony export */"ColorKeyframeTrack": function ColorKeyframeTrack() {
              return (/* binding */_ColorKeyframeTrack
              );
            },
            /* harmony export */"ColorManagement": function ColorManagement() {
              return (/* binding */_ColorManagement
              );
            },
            /* harmony export */"CompressedArrayTexture": function CompressedArrayTexture() {
              return (/* binding */_CompressedArrayTexture
              );
            },
            /* harmony export */"CompressedTexture": function CompressedTexture() {
              return (/* binding */_CompressedTexture
              );
            },
            /* harmony export */"CompressedTextureLoader": function CompressedTextureLoader() {
              return (/* binding */_CompressedTextureLoader
              );
            },
            /* harmony export */"ConeBufferGeometry": function ConeBufferGeometry() {
              return (/* binding */_ConeBufferGeometry
              );
            },
            /* harmony export */"ConeGeometry": function ConeGeometry() {
              return (/* binding */_ConeGeometry
              );
            },
            /* harmony export */"CubeCamera": function CubeCamera() {
              return (/* binding */_CubeCamera
              );
            },
            /* harmony export */"CubeReflectionMapping": function CubeReflectionMapping() {
              return (/* binding */_CubeReflectionMapping
              );
            },
            /* harmony export */"CubeRefractionMapping": function CubeRefractionMapping() {
              return (/* binding */_CubeRefractionMapping
              );
            },
            /* harmony export */"CubeTexture": function CubeTexture() {
              return (/* binding */_CubeTexture
              );
            },
            /* harmony export */"CubeTextureLoader": function CubeTextureLoader() {
              return (/* binding */_CubeTextureLoader
              );
            },
            /* harmony export */"CubeUVReflectionMapping": function CubeUVReflectionMapping() {
              return (/* binding */_CubeUVReflectionMapping
              );
            },
            /* harmony export */"CubicBezierCurve": function CubicBezierCurve() {
              return (/* binding */_CubicBezierCurve
              );
            },
            /* harmony export */"CubicBezierCurve3": function CubicBezierCurve3() {
              return (/* binding */_CubicBezierCurve2
              );
            },
            /* harmony export */"CubicInterpolant": function CubicInterpolant() {
              return (/* binding */_CubicInterpolant
              );
            },
            /* harmony export */"CullFaceBack": function CullFaceBack() {
              return (/* binding */_CullFaceBack
              );
            },
            /* harmony export */"CullFaceFront": function CullFaceFront() {
              return (/* binding */_CullFaceFront
              );
            },
            /* harmony export */"CullFaceFrontBack": function CullFaceFrontBack() {
              return (/* binding */_CullFaceFrontBack
              );
            },
            /* harmony export */"CullFaceNone": function CullFaceNone() {
              return (/* binding */_CullFaceNone
              );
            },
            /* harmony export */"Curve": function Curve() {
              return (/* binding */_Curve
              );
            },
            /* harmony export */"CurvePath": function CurvePath() {
              return (/* binding */_CurvePath
              );
            },
            /* harmony export */"CustomBlending": function CustomBlending() {
              return (/* binding */_CustomBlending
              );
            },
            /* harmony export */"CustomToneMapping": function CustomToneMapping() {
              return (/* binding */_CustomToneMapping
              );
            },
            /* harmony export */"CylinderBufferGeometry": function CylinderBufferGeometry() {
              return (/* binding */_CylinderBufferGeometry
              );
            },
            /* harmony export */"CylinderGeometry": function CylinderGeometry() {
              return (/* binding */_CylinderGeometry
              );
            },
            /* harmony export */"Cylindrical": function Cylindrical() {
              return (/* binding */_Cylindrical
              );
            },
            /* harmony export */"Data3DTexture": function Data3DTexture() {
              return (/* binding */_Data3DTexture
              );
            },
            /* harmony export */"DataArrayTexture": function DataArrayTexture() {
              return (/* binding */_DataArrayTexture
              );
            },
            /* harmony export */"DataTexture": function DataTexture() {
              return (/* binding */_DataTexture
              );
            },
            /* harmony export */"DataTexture2DArray": function DataTexture2DArray() {
              return (/* binding */_DataTexture2DArray
              );
            },
            /* harmony export */"DataTexture3D": function DataTexture3D() {
              return (/* binding */_DataTexture3D
              );
            },
            /* harmony export */"DataTextureLoader": function DataTextureLoader() {
              return (/* binding */_DataTextureLoader
              );
            },
            /* harmony export */"DataUtils": function DataUtils() {
              return (/* binding */_DataUtils
              );
            },
            /* harmony export */"DecrementStencilOp": function DecrementStencilOp() {
              return (/* binding */_DecrementStencilOp
              );
            },
            /* harmony export */"DecrementWrapStencilOp": function DecrementWrapStencilOp() {
              return (/* binding */_DecrementWrapStencilOp
              );
            },
            /* harmony export */"DefaultLoadingManager": function DefaultLoadingManager() {
              return (/* binding */_DefaultLoadingManager
              );
            },
            /* harmony export */"DepthFormat": function DepthFormat() {
              return (/* binding */_DepthFormat
              );
            },
            /* harmony export */"DepthStencilFormat": function DepthStencilFormat() {
              return (/* binding */_DepthStencilFormat
              );
            },
            /* harmony export */"DepthTexture": function DepthTexture() {
              return (/* binding */_DepthTexture
              );
            },
            /* harmony export */"DirectionalLight": function DirectionalLight() {
              return (/* binding */_DirectionalLight
              );
            },
            /* harmony export */"DirectionalLightHelper": function DirectionalLightHelper() {
              return (/* binding */_DirectionalLightHelper
              );
            },
            /* harmony export */"DiscreteInterpolant": function DiscreteInterpolant() {
              return (/* binding */_DiscreteInterpolant
              );
            },
            /* harmony export */"DodecahedronBufferGeometry": function DodecahedronBufferGeometry() {
              return (/* binding */_DodecahedronBufferGeometry
              );
            },
            /* harmony export */"DodecahedronGeometry": function DodecahedronGeometry() {
              return (/* binding */_DodecahedronGeometry
              );
            },
            /* harmony export */"DoubleSide": function DoubleSide() {
              return (/* binding */_DoubleSide
              );
            },
            /* harmony export */"DstAlphaFactor": function DstAlphaFactor() {
              return (/* binding */_DstAlphaFactor
              );
            },
            /* harmony export */"DstColorFactor": function DstColorFactor() {
              return (/* binding */_DstColorFactor
              );
            },
            /* harmony export */"DynamicCopyUsage": function DynamicCopyUsage() {
              return (/* binding */_DynamicCopyUsage
              );
            },
            /* harmony export */"DynamicDrawUsage": function DynamicDrawUsage() {
              return (/* binding */_DynamicDrawUsage
              );
            },
            /* harmony export */"DynamicReadUsage": function DynamicReadUsage() {
              return (/* binding */_DynamicReadUsage
              );
            },
            /* harmony export */"EdgesGeometry": function EdgesGeometry() {
              return (/* binding */_EdgesGeometry
              );
            },
            /* harmony export */"EllipseCurve": function EllipseCurve() {
              return (/* binding */_EllipseCurve
              );
            },
            /* harmony export */"EqualDepth": function EqualDepth() {
              return (/* binding */_EqualDepth
              );
            },
            /* harmony export */"EqualStencilFunc": function EqualStencilFunc() {
              return (/* binding */_EqualStencilFunc
              );
            },
            /* harmony export */"EquirectangularReflectionMapping": function EquirectangularReflectionMapping() {
              return (/* binding */_EquirectangularReflectionMapping
              );
            },
            /* harmony export */"EquirectangularRefractionMapping": function EquirectangularRefractionMapping() {
              return (/* binding */_EquirectangularRefractionMapping
              );
            },
            /* harmony export */"Euler": function Euler() {
              return (/* binding */_Euler
              );
            },
            /* harmony export */"EventDispatcher": function EventDispatcher() {
              return (/* binding */_EventDispatcher
              );
            },
            /* harmony export */"ExtrudeBufferGeometry": function ExtrudeBufferGeometry() {
              return (/* binding */_ExtrudeBufferGeometry
              );
            },
            /* harmony export */"ExtrudeGeometry": function ExtrudeGeometry() {
              return (/* binding */_ExtrudeGeometry
              );
            },
            /* harmony export */"FileLoader": function FileLoader() {
              return (/* binding */_FileLoader
              );
            },
            /* harmony export */"Float16BufferAttribute": function Float16BufferAttribute() {
              return (/* binding */_Float16BufferAttribute
              );
            },
            /* harmony export */"Float32BufferAttribute": function Float32BufferAttribute() {
              return (/* binding */_Float32BufferAttribute
              );
            },
            /* harmony export */"Float64BufferAttribute": function Float64BufferAttribute() {
              return (/* binding */_Float64BufferAttribute
              );
            },
            /* harmony export */"FloatType": function FloatType() {
              return (/* binding */_FloatType
              );
            },
            /* harmony export */"Fog": function Fog() {
              return (/* binding */_Fog
              );
            },
            /* harmony export */"FogExp2": function FogExp2() {
              return (/* binding */_FogExp
              );
            },
            /* harmony export */"FramebufferTexture": function FramebufferTexture() {
              return (/* binding */_FramebufferTexture
              );
            },
            /* harmony export */"FrontSide": function FrontSide() {
              return (/* binding */_FrontSide
              );
            },
            /* harmony export */"Frustum": function Frustum() {
              return (/* binding */_Frustum
              );
            },
            /* harmony export */"GLBufferAttribute": function GLBufferAttribute() {
              return (/* binding */_GLBufferAttribute
              );
            },
            /* harmony export */"GLSL1": function GLSL1() {
              return (/* binding */_GLSL
              );
            },
            /* harmony export */"GLSL3": function GLSL3() {
              return (/* binding */_GLSL2
              );
            },
            /* harmony export */"GreaterDepth": function GreaterDepth() {
              return (/* binding */_GreaterDepth
              );
            },
            /* harmony export */"GreaterEqualDepth": function GreaterEqualDepth() {
              return (/* binding */_GreaterEqualDepth
              );
            },
            /* harmony export */"GreaterEqualStencilFunc": function GreaterEqualStencilFunc() {
              return (/* binding */_GreaterEqualStencilFunc
              );
            },
            /* harmony export */"GreaterStencilFunc": function GreaterStencilFunc() {
              return (/* binding */_GreaterStencilFunc
              );
            },
            /* harmony export */"GridHelper": function GridHelper() {
              return (/* binding */_GridHelper
              );
            },
            /* harmony export */"Group": function Group() {
              return (/* binding */_Group
              );
            },
            /* harmony export */"HalfFloatType": function HalfFloatType() {
              return (/* binding */_HalfFloatType
              );
            },
            /* harmony export */"HemisphereLight": function HemisphereLight() {
              return (/* binding */_HemisphereLight
              );
            },
            /* harmony export */"HemisphereLightHelper": function HemisphereLightHelper() {
              return (/* binding */_HemisphereLightHelper
              );
            },
            /* harmony export */"HemisphereLightProbe": function HemisphereLightProbe() {
              return (/* binding */_HemisphereLightProbe
              );
            },
            /* harmony export */"IcosahedronBufferGeometry": function IcosahedronBufferGeometry() {
              return (/* binding */_IcosahedronBufferGeometry
              );
            },
            /* harmony export */"IcosahedronGeometry": function IcosahedronGeometry() {
              return (/* binding */_IcosahedronGeometry
              );
            },
            /* harmony export */"ImageBitmapLoader": function ImageBitmapLoader() {
              return (/* binding */_ImageBitmapLoader
              );
            },
            /* harmony export */"ImageLoader": function ImageLoader() {
              return (/* binding */_ImageLoader
              );
            },
            /* harmony export */"ImageUtils": function ImageUtils() {
              return (/* binding */_ImageUtils
              );
            },
            /* harmony export */"ImmediateRenderObject": function ImmediateRenderObject() {
              return (/* binding */_ImmediateRenderObject
              );
            },
            /* harmony export */"IncrementStencilOp": function IncrementStencilOp() {
              return (/* binding */_IncrementStencilOp
              );
            },
            /* harmony export */"IncrementWrapStencilOp": function IncrementWrapStencilOp() {
              return (/* binding */_IncrementWrapStencilOp
              );
            },
            /* harmony export */"InstancedBufferAttribute": function InstancedBufferAttribute() {
              return (/* binding */_InstancedBufferAttribute
              );
            },
            /* harmony export */"InstancedBufferGeometry": function InstancedBufferGeometry() {
              return (/* binding */_InstancedBufferGeometry
              );
            },
            /* harmony export */"InstancedInterleavedBuffer": function InstancedInterleavedBuffer() {
              return (/* binding */_InstancedInterleavedBuffer
              );
            },
            /* harmony export */"InstancedMesh": function InstancedMesh() {
              return (/* binding */_InstancedMesh
              );
            },
            /* harmony export */"Int16BufferAttribute": function Int16BufferAttribute() {
              return (/* binding */_Int16BufferAttribute
              );
            },
            /* harmony export */"Int32BufferAttribute": function Int32BufferAttribute() {
              return (/* binding */_Int32BufferAttribute
              );
            },
            /* harmony export */"Int8BufferAttribute": function Int8BufferAttribute() {
              return (/* binding */_Int8BufferAttribute
              );
            },
            /* harmony export */"IntType": function IntType() {
              return (/* binding */_IntType
              );
            },
            /* harmony export */"InterleavedBuffer": function InterleavedBuffer() {
              return (/* binding */_InterleavedBuffer
              );
            },
            /* harmony export */"InterleavedBufferAttribute": function InterleavedBufferAttribute() {
              return (/* binding */_InterleavedBufferAttribute
              );
            },
            /* harmony export */"Interpolant": function Interpolant() {
              return (/* binding */_Interpolant
              );
            },
            /* harmony export */"InterpolateDiscrete": function InterpolateDiscrete() {
              return (/* binding */_InterpolateDiscrete
              );
            },
            /* harmony export */"InterpolateLinear": function InterpolateLinear() {
              return (/* binding */_InterpolateLinear
              );
            },
            /* harmony export */"InterpolateSmooth": function InterpolateSmooth() {
              return (/* binding */_InterpolateSmooth
              );
            },
            /* harmony export */"InvertStencilOp": function InvertStencilOp() {
              return (/* binding */_InvertStencilOp
              );
            },
            /* harmony export */"KeepStencilOp": function KeepStencilOp() {
              return (/* binding */_KeepStencilOp
              );
            },
            /* harmony export */"KeyframeTrack": function KeyframeTrack() {
              return (/* binding */_KeyframeTrack
              );
            },
            /* harmony export */"LOD": function LOD() {
              return (/* binding */_LOD
              );
            },
            /* harmony export */"LatheBufferGeometry": function LatheBufferGeometry() {
              return (/* binding */_LatheBufferGeometry
              );
            },
            /* harmony export */"LatheGeometry": function LatheGeometry() {
              return (/* binding */_LatheGeometry
              );
            },
            /* harmony export */"Layers": function Layers() {
              return (/* binding */_Layers
              );
            },
            /* harmony export */"LessDepth": function LessDepth() {
              return (/* binding */_LessDepth
              );
            },
            /* harmony export */"LessEqualDepth": function LessEqualDepth() {
              return (/* binding */_LessEqualDepth
              );
            },
            /* harmony export */"LessEqualStencilFunc": function LessEqualStencilFunc() {
              return (/* binding */_LessEqualStencilFunc
              );
            },
            /* harmony export */"LessStencilFunc": function LessStencilFunc() {
              return (/* binding */_LessStencilFunc
              );
            },
            /* harmony export */"Light": function Light() {
              return (/* binding */_Light
              );
            },
            /* harmony export */"LightProbe": function LightProbe() {
              return (/* binding */_LightProbe
              );
            },
            /* harmony export */"Line": function Line() {
              return (/* binding */_Line
              );
            },
            /* harmony export */"Line3": function Line3() {
              return (/* binding */_Line2
              );
            },
            /* harmony export */"LineBasicMaterial": function LineBasicMaterial() {
              return (/* binding */_LineBasicMaterial
              );
            },
            /* harmony export */"LineCurve": function LineCurve() {
              return (/* binding */_LineCurve
              );
            },
            /* harmony export */"LineCurve3": function LineCurve3() {
              return (/* binding */_LineCurve2
              );
            },
            /* harmony export */"LineDashedMaterial": function LineDashedMaterial() {
              return (/* binding */_LineDashedMaterial
              );
            },
            /* harmony export */"LineLoop": function LineLoop() {
              return (/* binding */_LineLoop
              );
            },
            /* harmony export */"LineSegments": function LineSegments() {
              return (/* binding */_LineSegments
              );
            },
            /* harmony export */"LinearEncoding": function LinearEncoding() {
              return (/* binding */_LinearEncoding
              );
            },
            /* harmony export */"LinearFilter": function LinearFilter() {
              return (/* binding */_LinearFilter
              );
            },
            /* harmony export */"LinearInterpolant": function LinearInterpolant() {
              return (/* binding */_LinearInterpolant
              );
            },
            /* harmony export */"LinearMipMapLinearFilter": function LinearMipMapLinearFilter() {
              return (/* binding */_LinearMipMapLinearFilter
              );
            },
            /* harmony export */"LinearMipMapNearestFilter": function LinearMipMapNearestFilter() {
              return (/* binding */_LinearMipMapNearestFilter
              );
            },
            /* harmony export */"LinearMipmapLinearFilter": function LinearMipmapLinearFilter() {
              return (/* binding */_LinearMipmapLinearFilter
              );
            },
            /* harmony export */"LinearMipmapNearestFilter": function LinearMipmapNearestFilter() {
              return (/* binding */_LinearMipmapNearestFilter
              );
            },
            /* harmony export */"LinearSRGBColorSpace": function LinearSRGBColorSpace() {
              return (/* binding */_LinearSRGBColorSpace
              );
            },
            /* harmony export */"LinearToneMapping": function LinearToneMapping() {
              return (/* binding */_LinearToneMapping
              );
            },
            /* harmony export */"Loader": function Loader() {
              return (/* binding */_Loader
              );
            },
            /* harmony export */"LoaderUtils": function LoaderUtils() {
              return (/* binding */_LoaderUtils
              );
            },
            /* harmony export */"LoadingManager": function LoadingManager() {
              return (/* binding */_LoadingManager
              );
            },
            /* harmony export */"LoopOnce": function LoopOnce() {
              return (/* binding */_LoopOnce
              );
            },
            /* harmony export */"LoopPingPong": function LoopPingPong() {
              return (/* binding */_LoopPingPong
              );
            },
            /* harmony export */"LoopRepeat": function LoopRepeat() {
              return (/* binding */_LoopRepeat
              );
            },
            /* harmony export */"LuminanceAlphaFormat": function LuminanceAlphaFormat() {
              return (/* binding */_LuminanceAlphaFormat
              );
            },
            /* harmony export */"LuminanceFormat": function LuminanceFormat() {
              return (/* binding */_LuminanceFormat
              );
            },
            /* harmony export */"MOUSE": function MOUSE() {
              return (/* binding */_MOUSE
              );
            },
            /* harmony export */"Material": function Material() {
              return (/* binding */_Material
              );
            },
            /* harmony export */"MaterialLoader": function MaterialLoader() {
              return (/* binding */_MaterialLoader
              );
            },
            /* harmony export */"MathUtils": function MathUtils() {
              return (/* binding */_MathUtils
              );
            },
            /* harmony export */"Matrix3": function Matrix3() {
              return (/* binding */_Matrix
              );
            },
            /* harmony export */"Matrix4": function Matrix4() {
              return (/* binding */_Matrix2
              );
            },
            /* harmony export */"MaxEquation": function MaxEquation() {
              return (/* binding */_MaxEquation
              );
            },
            /* harmony export */"Mesh": function Mesh() {
              return (/* binding */_Mesh
              );
            },
            /* harmony export */"MeshBasicMaterial": function MeshBasicMaterial() {
              return (/* binding */_MeshBasicMaterial
              );
            },
            /* harmony export */"MeshDepthMaterial": function MeshDepthMaterial() {
              return (/* binding */_MeshDepthMaterial
              );
            },
            /* harmony export */"MeshDistanceMaterial": function MeshDistanceMaterial() {
              return (/* binding */_MeshDistanceMaterial
              );
            },
            /* harmony export */"MeshLambertMaterial": function MeshLambertMaterial() {
              return (/* binding */_MeshLambertMaterial
              );
            },
            /* harmony export */"MeshMatcapMaterial": function MeshMatcapMaterial() {
              return (/* binding */_MeshMatcapMaterial
              );
            },
            /* harmony export */"MeshNormalMaterial": function MeshNormalMaterial() {
              return (/* binding */_MeshNormalMaterial
              );
            },
            /* harmony export */"MeshPhongMaterial": function MeshPhongMaterial() {
              return (/* binding */_MeshPhongMaterial
              );
            },
            /* harmony export */"MeshPhysicalMaterial": function MeshPhysicalMaterial() {
              return (/* binding */_MeshPhysicalMaterial
              );
            },
            /* harmony export */"MeshStandardMaterial": function MeshStandardMaterial() {
              return (/* binding */_MeshStandardMaterial
              );
            },
            /* harmony export */"MeshToonMaterial": function MeshToonMaterial() {
              return (/* binding */_MeshToonMaterial
              );
            },
            /* harmony export */"MinEquation": function MinEquation() {
              return (/* binding */_MinEquation
              );
            },
            /* harmony export */"MirroredRepeatWrapping": function MirroredRepeatWrapping() {
              return (/* binding */_MirroredRepeatWrapping
              );
            },
            /* harmony export */"MixOperation": function MixOperation() {
              return (/* binding */_MixOperation
              );
            },
            /* harmony export */"MultiplyBlending": function MultiplyBlending() {
              return (/* binding */_MultiplyBlending
              );
            },
            /* harmony export */"MultiplyOperation": function MultiplyOperation() {
              return (/* binding */_MultiplyOperation
              );
            },
            /* harmony export */"NearestFilter": function NearestFilter() {
              return (/* binding */_NearestFilter
              );
            },
            /* harmony export */"NearestMipMapLinearFilter": function NearestMipMapLinearFilter() {
              return (/* binding */_NearestMipMapLinearFilter
              );
            },
            /* harmony export */"NearestMipMapNearestFilter": function NearestMipMapNearestFilter() {
              return (/* binding */_NearestMipMapNearestFilter
              );
            },
            /* harmony export */"NearestMipmapLinearFilter": function NearestMipmapLinearFilter() {
              return (/* binding */_NearestMipmapLinearFilter
              );
            },
            /* harmony export */"NearestMipmapNearestFilter": function NearestMipmapNearestFilter() {
              return (/* binding */_NearestMipmapNearestFilter
              );
            },
            /* harmony export */"NeverDepth": function NeverDepth() {
              return (/* binding */_NeverDepth
              );
            },
            /* harmony export */"NeverStencilFunc": function NeverStencilFunc() {
              return (/* binding */_NeverStencilFunc
              );
            },
            /* harmony export */"NoBlending": function NoBlending() {
              return (/* binding */_NoBlending
              );
            },
            /* harmony export */"NoColorSpace": function NoColorSpace() {
              return (/* binding */_NoColorSpace
              );
            },
            /* harmony export */"NoToneMapping": function NoToneMapping() {
              return (/* binding */_NoToneMapping
              );
            },
            /* harmony export */"NormalAnimationBlendMode": function NormalAnimationBlendMode() {
              return (/* binding */_NormalAnimationBlendMode
              );
            },
            /* harmony export */"NormalBlending": function NormalBlending() {
              return (/* binding */_NormalBlending
              );
            },
            /* harmony export */"NotEqualDepth": function NotEqualDepth() {
              return (/* binding */_NotEqualDepth
              );
            },
            /* harmony export */"NotEqualStencilFunc": function NotEqualStencilFunc() {
              return (/* binding */_NotEqualStencilFunc
              );
            },
            /* harmony export */"NumberKeyframeTrack": function NumberKeyframeTrack() {
              return (/* binding */_NumberKeyframeTrack
              );
            },
            /* harmony export */"Object3D": function Object3D() {
              return (/* binding */_Object3D
              );
            },
            /* harmony export */"ObjectLoader": function ObjectLoader() {
              return (/* binding */_ObjectLoader
              );
            },
            /* harmony export */"ObjectSpaceNormalMap": function ObjectSpaceNormalMap() {
              return (/* binding */_ObjectSpaceNormalMap
              );
            },
            /* harmony export */"OctahedronBufferGeometry": function OctahedronBufferGeometry() {
              return (/* binding */_OctahedronBufferGeometry
              );
            },
            /* harmony export */"OctahedronGeometry": function OctahedronGeometry() {
              return (/* binding */_OctahedronGeometry
              );
            },
            /* harmony export */"OneFactor": function OneFactor() {
              return (/* binding */_OneFactor
              );
            },
            /* harmony export */"OneMinusDstAlphaFactor": function OneMinusDstAlphaFactor() {
              return (/* binding */_OneMinusDstAlphaFactor
              );
            },
            /* harmony export */"OneMinusDstColorFactor": function OneMinusDstColorFactor() {
              return (/* binding */_OneMinusDstColorFactor
              );
            },
            /* harmony export */"OneMinusSrcAlphaFactor": function OneMinusSrcAlphaFactor() {
              return (/* binding */_OneMinusSrcAlphaFactor
              );
            },
            /* harmony export */"OneMinusSrcColorFactor": function OneMinusSrcColorFactor() {
              return (/* binding */_OneMinusSrcColorFactor
              );
            },
            /* harmony export */"OrthographicCamera": function OrthographicCamera() {
              return (/* binding */_OrthographicCamera
              );
            },
            /* harmony export */"PCFShadowMap": function PCFShadowMap() {
              return (/* binding */_PCFShadowMap
              );
            },
            /* harmony export */"PCFSoftShadowMap": function PCFSoftShadowMap() {
              return (/* binding */_PCFSoftShadowMap
              );
            },
            /* harmony export */"PMREMGenerator": function PMREMGenerator() {
              return (/* binding */_PMREMGenerator
              );
            },
            /* harmony export */"Path": function Path() {
              return (/* binding */_Path
              );
            },
            /* harmony export */"PerspectiveCamera": function PerspectiveCamera() {
              return (/* binding */_PerspectiveCamera
              );
            },
            /* harmony export */"Plane": function Plane() {
              return (/* binding */_Plane
              );
            },
            /* harmony export */"PlaneBufferGeometry": function PlaneBufferGeometry() {
              return (/* binding */_PlaneBufferGeometry
              );
            },
            /* harmony export */"PlaneGeometry": function PlaneGeometry() {
              return (/* binding */_PlaneGeometry
              );
            },
            /* harmony export */"PlaneHelper": function PlaneHelper() {
              return (/* binding */_PlaneHelper
              );
            },
            /* harmony export */"PointLight": function PointLight() {
              return (/* binding */_PointLight
              );
            },
            /* harmony export */"PointLightHelper": function PointLightHelper() {
              return (/* binding */_PointLightHelper
              );
            },
            /* harmony export */"Points": function Points() {
              return (/* binding */_Points
              );
            },
            /* harmony export */"PointsMaterial": function PointsMaterial() {
              return (/* binding */_PointsMaterial
              );
            },
            /* harmony export */"PolarGridHelper": function PolarGridHelper() {
              return (/* binding */_PolarGridHelper
              );
            },
            /* harmony export */"PolyhedronBufferGeometry": function PolyhedronBufferGeometry() {
              return (/* binding */_PolyhedronBufferGeometry
              );
            },
            /* harmony export */"PolyhedronGeometry": function PolyhedronGeometry() {
              return (/* binding */_PolyhedronGeometry
              );
            },
            /* harmony export */"PositionalAudio": function PositionalAudio() {
              return (/* binding */_PositionalAudio
              );
            },
            /* harmony export */"PropertyBinding": function PropertyBinding() {
              return (/* binding */_PropertyBinding
              );
            },
            /* harmony export */"PropertyMixer": function PropertyMixer() {
              return (/* binding */_PropertyMixer
              );
            },
            /* harmony export */"QuadraticBezierCurve": function QuadraticBezierCurve() {
              return (/* binding */_QuadraticBezierCurve
              );
            },
            /* harmony export */"QuadraticBezierCurve3": function QuadraticBezierCurve3() {
              return (/* binding */_QuadraticBezierCurve2
              );
            },
            /* harmony export */"Quaternion": function Quaternion() {
              return (/* binding */_Quaternion
              );
            },
            /* harmony export */"QuaternionKeyframeTrack": function QuaternionKeyframeTrack() {
              return (/* binding */_QuaternionKeyframeTrack
              );
            },
            /* harmony export */"QuaternionLinearInterpolant": function QuaternionLinearInterpolant() {
              return (/* binding */_QuaternionLinearInterpolant
              );
            },
            /* harmony export */"REVISION": function REVISION() {
              return (/* binding */_REVISION
              );
            },
            /* harmony export */"RGBADepthPacking": function RGBADepthPacking() {
              return (/* binding */_RGBADepthPacking
              );
            },
            /* harmony export */"RGBAFormat": function RGBAFormat() {
              return (/* binding */_RGBAFormat
              );
            },
            /* harmony export */"RGBAIntegerFormat": function RGBAIntegerFormat() {
              return (/* binding */_RGBAIntegerFormat
              );
            },
            /* harmony export */"RGBA_ASTC_10x10_Format": function RGBA_ASTC_10x10_Format() {
              return (/* binding */_RGBA_ASTC_10x10_Format
              );
            },
            /* harmony export */"RGBA_ASTC_10x5_Format": function RGBA_ASTC_10x5_Format() {
              return (/* binding */_RGBA_ASTC_10x5_Format
              );
            },
            /* harmony export */"RGBA_ASTC_10x6_Format": function RGBA_ASTC_10x6_Format() {
              return (/* binding */_RGBA_ASTC_10x6_Format
              );
            },
            /* harmony export */"RGBA_ASTC_10x8_Format": function RGBA_ASTC_10x8_Format() {
              return (/* binding */_RGBA_ASTC_10x8_Format
              );
            },
            /* harmony export */"RGBA_ASTC_12x10_Format": function RGBA_ASTC_12x10_Format() {
              return (/* binding */_RGBA_ASTC_12x10_Format
              );
            },
            /* harmony export */"RGBA_ASTC_12x12_Format": function RGBA_ASTC_12x12_Format() {
              return (/* binding */_RGBA_ASTC_12x12_Format
              );
            },
            /* harmony export */"RGBA_ASTC_4x4_Format": function RGBA_ASTC_4x4_Format() {
              return (/* binding */_RGBA_ASTC_4x4_Format
              );
            },
            /* harmony export */"RGBA_ASTC_5x4_Format": function RGBA_ASTC_5x4_Format() {
              return (/* binding */_RGBA_ASTC_5x4_Format
              );
            },
            /* harmony export */"RGBA_ASTC_5x5_Format": function RGBA_ASTC_5x5_Format() {
              return (/* binding */_RGBA_ASTC_5x5_Format
              );
            },
            /* harmony export */"RGBA_ASTC_6x5_Format": function RGBA_ASTC_6x5_Format() {
              return (/* binding */_RGBA_ASTC_6x5_Format
              );
            },
            /* harmony export */"RGBA_ASTC_6x6_Format": function RGBA_ASTC_6x6_Format() {
              return (/* binding */_RGBA_ASTC_6x6_Format
              );
            },
            /* harmony export */"RGBA_ASTC_8x5_Format": function RGBA_ASTC_8x5_Format() {
              return (/* binding */_RGBA_ASTC_8x5_Format
              );
            },
            /* harmony export */"RGBA_ASTC_8x6_Format": function RGBA_ASTC_8x6_Format() {
              return (/* binding */_RGBA_ASTC_8x6_Format
              );
            },
            /* harmony export */"RGBA_ASTC_8x8_Format": function RGBA_ASTC_8x8_Format() {
              return (/* binding */_RGBA_ASTC_8x8_Format
              );
            },
            /* harmony export */"RGBA_BPTC_Format": function RGBA_BPTC_Format() {
              return (/* binding */_RGBA_BPTC_Format
              );
            },
            /* harmony export */"RGBA_ETC2_EAC_Format": function RGBA_ETC2_EAC_Format() {
              return (/* binding */_RGBA_ETC2_EAC_Format
              );
            },
            /* harmony export */"RGBA_PVRTC_2BPPV1_Format": function RGBA_PVRTC_2BPPV1_Format() {
              return (/* binding */_RGBA_PVRTC_2BPPV1_Format
              );
            },
            /* harmony export */"RGBA_PVRTC_4BPPV1_Format": function RGBA_PVRTC_4BPPV1_Format() {
              return (/* binding */_RGBA_PVRTC_4BPPV1_Format
              );
            },
            /* harmony export */"RGBA_S3TC_DXT1_Format": function RGBA_S3TC_DXT1_Format() {
              return (/* binding */_RGBA_S3TC_DXT1_Format
              );
            },
            /* harmony export */"RGBA_S3TC_DXT3_Format": function RGBA_S3TC_DXT3_Format() {
              return (/* binding */_RGBA_S3TC_DXT3_Format
              );
            },
            /* harmony export */"RGBA_S3TC_DXT5_Format": function RGBA_S3TC_DXT5_Format() {
              return (/* binding */_RGBA_S3TC_DXT5_Format
              );
            },
            /* harmony export */"RGBFormat": function RGBFormat() {
              return (/* binding */_RGBFormat
              );
            },
            /* harmony export */"RGB_ETC1_Format": function RGB_ETC1_Format() {
              return (/* binding */_RGB_ETC1_Format
              );
            },
            /* harmony export */"RGB_ETC2_Format": function RGB_ETC2_Format() {
              return (/* binding */_RGB_ETC2_Format
              );
            },
            /* harmony export */"RGB_PVRTC_2BPPV1_Format": function RGB_PVRTC_2BPPV1_Format() {
              return (/* binding */_RGB_PVRTC_2BPPV1_Format
              );
            },
            /* harmony export */"RGB_PVRTC_4BPPV1_Format": function RGB_PVRTC_4BPPV1_Format() {
              return (/* binding */_RGB_PVRTC_4BPPV1_Format
              );
            },
            /* harmony export */"RGB_S3TC_DXT1_Format": function RGB_S3TC_DXT1_Format() {
              return (/* binding */_RGB_S3TC_DXT1_Format
              );
            },
            /* harmony export */"RGFormat": function RGFormat() {
              return (/* binding */_RGFormat
              );
            },
            /* harmony export */"RGIntegerFormat": function RGIntegerFormat() {
              return (/* binding */_RGIntegerFormat
              );
            },
            /* harmony export */"RawShaderMaterial": function RawShaderMaterial() {
              return (/* binding */_RawShaderMaterial
              );
            },
            /* harmony export */"Ray": function Ray() {
              return (/* binding */_Ray
              );
            },
            /* harmony export */"Raycaster": function Raycaster() {
              return (/* binding */_Raycaster
              );
            },
            /* harmony export */"RectAreaLight": function RectAreaLight() {
              return (/* binding */_RectAreaLight
              );
            },
            /* harmony export */"RedFormat": function RedFormat() {
              return (/* binding */_RedFormat
              );
            },
            /* harmony export */"RedIntegerFormat": function RedIntegerFormat() {
              return (/* binding */_RedIntegerFormat
              );
            },
            /* harmony export */"ReinhardToneMapping": function ReinhardToneMapping() {
              return (/* binding */_ReinhardToneMapping
              );
            },
            /* harmony export */"RepeatWrapping": function RepeatWrapping() {
              return (/* binding */_RepeatWrapping
              );
            },
            /* harmony export */"ReplaceStencilOp": function ReplaceStencilOp() {
              return (/* binding */_ReplaceStencilOp
              );
            },
            /* harmony export */"ReverseSubtractEquation": function ReverseSubtractEquation() {
              return (/* binding */_ReverseSubtractEquation
              );
            },
            /* harmony export */"RingBufferGeometry": function RingBufferGeometry() {
              return (/* binding */_RingBufferGeometry
              );
            },
            /* harmony export */"RingGeometry": function RingGeometry() {
              return (/* binding */_RingGeometry
              );
            },
            /* harmony export */"SRGBColorSpace": function SRGBColorSpace() {
              return (/* binding */_SRGBColorSpace
              );
            },
            /* harmony export */"Scene": function Scene() {
              return (/* binding */_Scene
              );
            },
            /* harmony export */"ShaderChunk": function ShaderChunk() {
              return (/* binding */_ShaderChunk
              );
            },
            /* harmony export */"ShaderLib": function ShaderLib() {
              return (/* binding */_ShaderLib
              );
            },
            /* harmony export */"ShaderMaterial": function ShaderMaterial() {
              return (/* binding */_ShaderMaterial
              );
            },
            /* harmony export */"ShadowMaterial": function ShadowMaterial() {
              return (/* binding */_ShadowMaterial
              );
            },
            /* harmony export */"Shape": function Shape() {
              return (/* binding */_Shape
              );
            },
            /* harmony export */"ShapeBufferGeometry": function ShapeBufferGeometry() {
              return (/* binding */_ShapeBufferGeometry
              );
            },
            /* harmony export */"ShapeGeometry": function ShapeGeometry() {
              return (/* binding */_ShapeGeometry
              );
            },
            /* harmony export */"ShapePath": function ShapePath() {
              return (/* binding */_ShapePath
              );
            },
            /* harmony export */"ShapeUtils": function ShapeUtils() {
              return (/* binding */_ShapeUtils
              );
            },
            /* harmony export */"ShortType": function ShortType() {
              return (/* binding */_ShortType
              );
            },
            /* harmony export */"Skeleton": function Skeleton() {
              return (/* binding */_Skeleton
              );
            },
            /* harmony export */"SkeletonHelper": function SkeletonHelper() {
              return (/* binding */_SkeletonHelper
              );
            },
            /* harmony export */"SkinnedMesh": function SkinnedMesh() {
              return (/* binding */_SkinnedMesh
              );
            },
            /* harmony export */"Source": function Source() {
              return (/* binding */_Source
              );
            },
            /* harmony export */"Sphere": function Sphere() {
              return (/* binding */_Sphere
              );
            },
            /* harmony export */"SphereBufferGeometry": function SphereBufferGeometry() {
              return (/* binding */_SphereBufferGeometry
              );
            },
            /* harmony export */"SphereGeometry": function SphereGeometry() {
              return (/* binding */_SphereGeometry
              );
            },
            /* harmony export */"Spherical": function Spherical() {
              return (/* binding */_Spherical
              );
            },
            /* harmony export */"SphericalHarmonics3": function SphericalHarmonics3() {
              return (/* binding */_SphericalHarmonics
              );
            },
            /* harmony export */"SplineCurve": function SplineCurve() {
              return (/* binding */_SplineCurve
              );
            },
            /* harmony export */"SpotLight": function SpotLight() {
              return (/* binding */_SpotLight
              );
            },
            /* harmony export */"SpotLightHelper": function SpotLightHelper() {
              return (/* binding */_SpotLightHelper
              );
            },
            /* harmony export */"Sprite": function Sprite() {
              return (/* binding */_Sprite
              );
            },
            /* harmony export */"SpriteMaterial": function SpriteMaterial() {
              return (/* binding */_SpriteMaterial
              );
            },
            /* harmony export */"SrcAlphaFactor": function SrcAlphaFactor() {
              return (/* binding */_SrcAlphaFactor
              );
            },
            /* harmony export */"SrcAlphaSaturateFactor": function SrcAlphaSaturateFactor() {
              return (/* binding */_SrcAlphaSaturateFactor
              );
            },
            /* harmony export */"SrcColorFactor": function SrcColorFactor() {
              return (/* binding */_SrcColorFactor
              );
            },
            /* harmony export */"StaticCopyUsage": function StaticCopyUsage() {
              return (/* binding */_StaticCopyUsage
              );
            },
            /* harmony export */"StaticDrawUsage": function StaticDrawUsage() {
              return (/* binding */_StaticDrawUsage
              );
            },
            /* harmony export */"StaticReadUsage": function StaticReadUsage() {
              return (/* binding */_StaticReadUsage
              );
            },
            /* harmony export */"StereoCamera": function StereoCamera() {
              return (/* binding */_StereoCamera
              );
            },
            /* harmony export */"StreamCopyUsage": function StreamCopyUsage() {
              return (/* binding */_StreamCopyUsage
              );
            },
            /* harmony export */"StreamDrawUsage": function StreamDrawUsage() {
              return (/* binding */_StreamDrawUsage
              );
            },
            /* harmony export */"StreamReadUsage": function StreamReadUsage() {
              return (/* binding */_StreamReadUsage
              );
            },
            /* harmony export */"StringKeyframeTrack": function StringKeyframeTrack() {
              return (/* binding */_StringKeyframeTrack
              );
            },
            /* harmony export */"SubtractEquation": function SubtractEquation() {
              return (/* binding */_SubtractEquation
              );
            },
            /* harmony export */"SubtractiveBlending": function SubtractiveBlending() {
              return (/* binding */_SubtractiveBlending
              );
            },
            /* harmony export */"TOUCH": function TOUCH() {
              return (/* binding */_TOUCH
              );
            },
            /* harmony export */"TangentSpaceNormalMap": function TangentSpaceNormalMap() {
              return (/* binding */_TangentSpaceNormalMap
              );
            },
            /* harmony export */"TetrahedronBufferGeometry": function TetrahedronBufferGeometry() {
              return (/* binding */_TetrahedronBufferGeometry
              );
            },
            /* harmony export */"TetrahedronGeometry": function TetrahedronGeometry() {
              return (/* binding */_TetrahedronGeometry
              );
            },
            /* harmony export */"Texture": function Texture() {
              return (/* binding */_Texture
              );
            },
            /* harmony export */"TextureLoader": function TextureLoader() {
              return (/* binding */_TextureLoader
              );
            },
            /* harmony export */"TorusBufferGeometry": function TorusBufferGeometry() {
              return (/* binding */_TorusBufferGeometry
              );
            },
            /* harmony export */"TorusGeometry": function TorusGeometry() {
              return (/* binding */_TorusGeometry
              );
            },
            /* harmony export */"TorusKnotBufferGeometry": function TorusKnotBufferGeometry() {
              return (/* binding */_TorusKnotBufferGeometry
              );
            },
            /* harmony export */"TorusKnotGeometry": function TorusKnotGeometry() {
              return (/* binding */_TorusKnotGeometry
              );
            },
            /* harmony export */"Triangle": function Triangle() {
              return (/* binding */_Triangle
              );
            },
            /* harmony export */"TriangleFanDrawMode": function TriangleFanDrawMode() {
              return (/* binding */_TriangleFanDrawMode
              );
            },
            /* harmony export */"TriangleStripDrawMode": function TriangleStripDrawMode() {
              return (/* binding */_TriangleStripDrawMode
              );
            },
            /* harmony export */"TrianglesDrawMode": function TrianglesDrawMode() {
              return (/* binding */_TrianglesDrawMode
              );
            },
            /* harmony export */"TubeBufferGeometry": function TubeBufferGeometry() {
              return (/* binding */_TubeBufferGeometry
              );
            },
            /* harmony export */"TubeGeometry": function TubeGeometry() {
              return (/* binding */_TubeGeometry
              );
            },
            /* harmony export */"UVMapping": function UVMapping() {
              return (/* binding */_UVMapping
              );
            },
            /* harmony export */"Uint16BufferAttribute": function Uint16BufferAttribute() {
              return (/* binding */_Uint16BufferAttribute
              );
            },
            /* harmony export */"Uint32BufferAttribute": function Uint32BufferAttribute() {
              return (/* binding */_Uint32BufferAttribute
              );
            },
            /* harmony export */"Uint8BufferAttribute": function Uint8BufferAttribute() {
              return (/* binding */_Uint8BufferAttribute
              );
            },
            /* harmony export */"Uint8ClampedBufferAttribute": function Uint8ClampedBufferAttribute() {
              return (/* binding */_Uint8ClampedBufferAttribute
              );
            },
            /* harmony export */"Uniform": function Uniform() {
              return (/* binding */_Uniform
              );
            },
            /* harmony export */"UniformsGroup": function UniformsGroup() {
              return (/* binding */_UniformsGroup
              );
            },
            /* harmony export */"UniformsLib": function UniformsLib() {
              return (/* binding */_UniformsLib
              );
            },
            /* harmony export */"UniformsUtils": function UniformsUtils() {
              return (/* binding */_UniformsUtils
              );
            },
            /* harmony export */"UnsignedByteType": function UnsignedByteType() {
              return (/* binding */_UnsignedByteType
              );
            },
            /* harmony export */"UnsignedInt248Type": function UnsignedInt248Type() {
              return (/* binding */_UnsignedInt248Type
              );
            },
            /* harmony export */"UnsignedIntType": function UnsignedIntType() {
              return (/* binding */_UnsignedIntType
              );
            },
            /* harmony export */"UnsignedShort4444Type": function UnsignedShort4444Type() {
              return (/* binding */_UnsignedShort4444Type
              );
            },
            /* harmony export */"UnsignedShort5551Type": function UnsignedShort5551Type() {
              return (/* binding */_UnsignedShort5551Type
              );
            },
            /* harmony export */"UnsignedShortType": function UnsignedShortType() {
              return (/* binding */_UnsignedShortType
              );
            },
            /* harmony export */"VSMShadowMap": function VSMShadowMap() {
              return (/* binding */_VSMShadowMap
              );
            },
            /* harmony export */"Vector2": function Vector2() {
              return (/* binding */_Vector
              );
            },
            /* harmony export */"Vector3": function Vector3() {
              return (/* binding */_Vector2
              );
            },
            /* harmony export */"Vector4": function Vector4() {
              return (/* binding */_Vector3
              );
            },
            /* harmony export */"VectorKeyframeTrack": function VectorKeyframeTrack() {
              return (/* binding */_VectorKeyframeTrack
              );
            },
            /* harmony export */"VideoTexture": function VideoTexture() {
              return (/* binding */_VideoTexture
              );
            },
            /* harmony export */"WebGL1Renderer": function WebGL1Renderer() {
              return (/* binding */_WebGL1Renderer
              );
            },
            /* harmony export */"WebGL3DRenderTarget": function WebGL3DRenderTarget() {
              return (/* binding */_WebGL3DRenderTarget
              );
            },
            /* harmony export */"WebGLArrayRenderTarget": function WebGLArrayRenderTarget() {
              return (/* binding */_WebGLArrayRenderTarget
              );
            },
            /* harmony export */"WebGLCubeRenderTarget": function WebGLCubeRenderTarget() {
              return (/* binding */_WebGLCubeRenderTarget
              );
            },
            /* harmony export */"WebGLMultipleRenderTargets": function WebGLMultipleRenderTargets() {
              return (/* binding */_WebGLMultipleRenderTargets
              );
            },
            /* harmony export */"WebGLMultisampleRenderTarget": function WebGLMultisampleRenderTarget() {
              return (/* binding */_WebGLMultisampleRenderTarget
              );
            },
            /* harmony export */"WebGLRenderTarget": function WebGLRenderTarget() {
              return (/* binding */_WebGLRenderTarget
              );
            },
            /* harmony export */"WebGLRenderer": function WebGLRenderer() {
              return (/* binding */_WebGLRenderer
              );
            },
            /* harmony export */"WebGLUtils": function WebGLUtils() {
              return (/* binding */_WebGLUtils
              );
            },
            /* harmony export */"WireframeGeometry": function WireframeGeometry() {
              return (/* binding */_WireframeGeometry
              );
            },
            /* harmony export */"WrapAroundEnding": function WrapAroundEnding() {
              return (/* binding */_WrapAroundEnding
              );
            },
            /* harmony export */"ZeroCurvatureEnding": function ZeroCurvatureEnding() {
              return (/* binding */_ZeroCurvatureEnding
              );
            },
            /* harmony export */"ZeroFactor": function ZeroFactor() {
              return (/* binding */_ZeroFactor
              );
            },
            /* harmony export */"ZeroSlopeEnding": function ZeroSlopeEnding() {
              return (/* binding */_ZeroSlopeEnding
              );
            },
            /* harmony export */"ZeroStencilOp": function ZeroStencilOp() {
              return (/* binding */_ZeroStencilOp
              );
            },
            /* harmony export */"_SRGBAFormat": function _SRGBAFormat() {
              return (/* binding */_SRGBAFormat2
              );
            },
            /* harmony export */"sRGBEncoding": function sRGBEncoding() {
              return (/* binding */_sRGBEncoding
              );
            }
            /* harmony export */
          });
          /**
           * @license
           * Copyright 2010-2022 Three.js Authors
           * SPDX-License-Identifier: MIT
           */
          var _REVISION = '147';
          var _MOUSE = {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2
          };
          var _TOUCH = {
            ROTATE: 0,
            PAN: 1,
            DOLLY_PAN: 2,
            DOLLY_ROTATE: 3
          };
          var _CullFaceNone = 0;
          var _CullFaceBack = 1;
          var _CullFaceFront = 2;
          var _CullFaceFrontBack = 3;
          var _BasicShadowMap = 0;
          var _PCFShadowMap = 1;
          var _PCFSoftShadowMap = 2;
          var _VSMShadowMap = 3;
          var _FrontSide = 0;
          var _BackSide = 1;
          var _DoubleSide = 2;
          var _NoBlending = 0;
          var _NormalBlending = 1;
          var _AdditiveBlending = 2;
          var _SubtractiveBlending = 3;
          var _MultiplyBlending = 4;
          var _CustomBlending = 5;
          var _AddEquation = 100;
          var _SubtractEquation = 101;
          var _ReverseSubtractEquation = 102;
          var _MinEquation = 103;
          var _MaxEquation = 104;
          var _ZeroFactor = 200;
          var _OneFactor = 201;
          var _SrcColorFactor = 202;
          var _OneMinusSrcColorFactor = 203;
          var _SrcAlphaFactor = 204;
          var _OneMinusSrcAlphaFactor = 205;
          var _DstAlphaFactor = 206;
          var _OneMinusDstAlphaFactor = 207;
          var _DstColorFactor = 208;
          var _OneMinusDstColorFactor = 209;
          var _SrcAlphaSaturateFactor = 210;
          var _NeverDepth = 0;
          var _AlwaysDepth = 1;
          var _LessDepth = 2;
          var _LessEqualDepth = 3;
          var _EqualDepth = 4;
          var _GreaterEqualDepth = 5;
          var _GreaterDepth = 6;
          var _NotEqualDepth = 7;
          var _MultiplyOperation = 0;
          var _MixOperation = 1;
          var _AddOperation = 2;
          var _NoToneMapping = 0;
          var _LinearToneMapping = 1;
          var _ReinhardToneMapping = 2;
          var _CineonToneMapping = 3;
          var _ACESFilmicToneMapping = 4;
          var _CustomToneMapping = 5;
          var _UVMapping = 300;
          var _CubeReflectionMapping = 301;
          var _CubeRefractionMapping = 302;
          var _EquirectangularReflectionMapping = 303;
          var _EquirectangularRefractionMapping = 304;
          var _CubeUVReflectionMapping = 306;
          var _RepeatWrapping = 1000;
          var _ClampToEdgeWrapping = 1001;
          var _MirroredRepeatWrapping = 1002;
          var _NearestFilter = 1003;
          var _NearestMipmapNearestFilter = 1004;
          var _NearestMipMapNearestFilter = 1004;
          var _NearestMipmapLinearFilter = 1005;
          var _NearestMipMapLinearFilter = 1005;
          var _LinearFilter = 1006;
          var _LinearMipmapNearestFilter = 1007;
          var _LinearMipMapNearestFilter = 1007;
          var _LinearMipmapLinearFilter = 1008;
          var _LinearMipMapLinearFilter = 1008;
          var _UnsignedByteType = 1009;
          var _ByteType = 1010;
          var _ShortType = 1011;
          var _UnsignedShortType = 1012;
          var _IntType = 1013;
          var _UnsignedIntType = 1014;
          var _FloatType = 1015;
          var _HalfFloatType = 1016;
          var _UnsignedShort4444Type = 1017;
          var _UnsignedShort5551Type = 1018;
          var _UnsignedInt248Type = 1020;
          var _AlphaFormat = 1021;
          var _RGBFormat = 1022; // @deprecated since r137
          var _RGBAFormat = 1023;
          var _LuminanceFormat = 1024;
          var _LuminanceAlphaFormat = 1025;
          var _DepthFormat = 1026;
          var _DepthStencilFormat = 1027;
          var _RedFormat = 1028;
          var _RedIntegerFormat = 1029;
          var _RGFormat = 1030;
          var _RGIntegerFormat = 1031;
          var _RGBAIntegerFormat = 1033;
          var _RGB_S3TC_DXT1_Format = 33776;
          var _RGBA_S3TC_DXT1_Format = 33777;
          var _RGBA_S3TC_DXT3_Format = 33778;
          var _RGBA_S3TC_DXT5_Format = 33779;
          var _RGB_PVRTC_4BPPV1_Format = 35840;
          var _RGB_PVRTC_2BPPV1_Format = 35841;
          var _RGBA_PVRTC_4BPPV1_Format = 35842;
          var _RGBA_PVRTC_2BPPV1_Format = 35843;
          var _RGB_ETC1_Format = 36196;
          var _RGB_ETC2_Format = 37492;
          var _RGBA_ETC2_EAC_Format = 37496;
          var _RGBA_ASTC_4x4_Format = 37808;
          var _RGBA_ASTC_5x4_Format = 37809;
          var _RGBA_ASTC_5x5_Format = 37810;
          var _RGBA_ASTC_6x5_Format = 37811;
          var _RGBA_ASTC_6x6_Format = 37812;
          var _RGBA_ASTC_8x5_Format = 37813;
          var _RGBA_ASTC_8x6_Format = 37814;
          var _RGBA_ASTC_8x8_Format = 37815;
          var _RGBA_ASTC_10x5_Format = 37816;
          var _RGBA_ASTC_10x6_Format = 37817;
          var _RGBA_ASTC_10x8_Format = 37818;
          var _RGBA_ASTC_10x10_Format = 37819;
          var _RGBA_ASTC_12x10_Format = 37820;
          var _RGBA_ASTC_12x12_Format = 37821;
          var _RGBA_BPTC_Format = 36492;
          var _LoopOnce = 2200;
          var _LoopRepeat = 2201;
          var _LoopPingPong = 2202;
          var _InterpolateDiscrete = 2300;
          var _InterpolateLinear = 2301;
          var _InterpolateSmooth = 2302;
          var _ZeroCurvatureEnding = 2400;
          var _ZeroSlopeEnding = 2401;
          var _WrapAroundEnding = 2402;
          var _NormalAnimationBlendMode = 2500;
          var _AdditiveAnimationBlendMode = 2501;
          var _TrianglesDrawMode = 0;
          var _TriangleStripDrawMode = 1;
          var _TriangleFanDrawMode = 2;
          var _LinearEncoding = 3000;
          var _sRGBEncoding = 3001;
          var _BasicDepthPacking = 3200;
          var _RGBADepthPacking = 3201;
          var _TangentSpaceNormalMap = 0;
          var _ObjectSpaceNormalMap = 1; // Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
          var _NoColorSpace = '';
          var _SRGBColorSpace = 'srgb';
          var _LinearSRGBColorSpace = 'srgb-linear';
          var _ZeroStencilOp = 0;
          var _KeepStencilOp = 7680;
          var _ReplaceStencilOp = 7681;
          var _IncrementStencilOp = 7682;
          var _DecrementStencilOp = 7683;
          var _IncrementWrapStencilOp = 34055;
          var _DecrementWrapStencilOp = 34056;
          var _InvertStencilOp = 5386;
          var _NeverStencilFunc = 512;
          var _LessStencilFunc = 513;
          var _EqualStencilFunc = 514;
          var _LessEqualStencilFunc = 515;
          var _GreaterStencilFunc = 516;
          var _NotEqualStencilFunc = 517;
          var _GreaterEqualStencilFunc = 518;
          var _AlwaysStencilFunc = 519;
          var _StaticDrawUsage = 35044;
          var _DynamicDrawUsage = 35048;
          var _StreamDrawUsage = 35040;
          var _StaticReadUsage = 35045;
          var _DynamicReadUsage = 35049;
          var _StreamReadUsage = 35041;
          var _StaticCopyUsage = 35046;
          var _DynamicCopyUsage = 35050;
          var _StreamCopyUsage = 35042;
          var _GLSL = '100';
          var _GLSL2 = '300 es';
          var _SRGBAFormat2 = 1035; // fallback for WebGL 1
          /**
           * https://github.com/mrdoob/eventdispatcher.js/
           */
          var _EventDispatcher = /*#__PURE__*/function () {
            function _EventDispatcher() {
              _classCallCheck2(this, _EventDispatcher);
            }
            _createClass2(_EventDispatcher, [{
              key: "addEventListener",
              value: function addEventListener(type, listener) {
                if (this._listeners === undefined) this._listeners = {};
                var listeners = this._listeners;
                if (listeners[type] === undefined) {
                  listeners[type] = [];
                }
                if (listeners[type].indexOf(listener) === -1) {
                  listeners[type].push(listener);
                }
              }
            }, {
              key: "hasEventListener",
              value: function hasEventListener(type, listener) {
                if (this._listeners === undefined) return false;
                var listeners = this._listeners;
                return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(type, listener) {
                if (this._listeners === undefined) return;
                var listeners = this._listeners;
                var listenerArray = listeners[type];
                if (listenerArray !== undefined) {
                  var index = listenerArray.indexOf(listener);
                  if (index !== -1) {
                    listenerArray.splice(index, 1);
                  }
                }
              }
            }, {
              key: "dispatchEvent",
              value: function dispatchEvent(event) {
                if (this._listeners === undefined) return;
                var listeners = this._listeners;
                var listenerArray = listeners[event.type];
                if (listenerArray !== undefined) {
                  event.target = this; // Make a copy, in case listeners are removed while iterating.
                  var array = listenerArray.slice(0);
                  for (var i = 0, l = array.length; i < l; i++) {
                    array[i].call(this, event);
                  }
                  event.target = null;
                }
              }
            }]);
            return _EventDispatcher;
          }();
          var _lut = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff'];
          var _seed = 1234567;
          var DEG2RAD = Math.PI / 180;
          var RAD2DEG = 180 / Math.PI; // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
          function generateUUID() {
            var d0 = Math.random() * 0xffffffff | 0;
            var d1 = Math.random() * 0xffffffff | 0;
            var d2 = Math.random() * 0xffffffff | 0;
            var d3 = Math.random() * 0xffffffff | 0;
            var uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff]; // .toLowerCase() here flattens concatenated strings to save heap memory space.
            return uuid.toLowerCase();
          }
          function clamp(value, min, max) {
            return Math.max(min, Math.min(max, value));
          } // compute euclidean modulo of m % n
          // https://en.wikipedia.org/wiki/Modulo_operation
          function euclideanModulo(n, m) {
            return (n % m + m) % m;
          } // Linear mapping from range <a1, a2> to range <b1, b2>
          function mapLinear(x, a1, a2, b1, b2) {
            return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
          } // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
          function inverseLerp(x, y, value) {
            if (x !== y) {
              return (value - x) / (y - x);
            } else {
              return 0;
            }
          } // https://en.wikipedia.org/wiki/Linear_interpolation
          function lerp(x, y, t) {
            return (1 - t) * x + t * y;
          } // http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
          function damp(x, y, lambda, dt) {
            return lerp(x, y, 1 - Math.exp(-lambda * dt));
          } // https://www.desmos.com/calculator/vcsjnyz7x4
          function pingpong(x) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            return length - Math.abs(euclideanModulo(x, length * 2) - length);
          } // http://en.wikipedia.org/wiki/Smoothstep
          function smoothstep(x, min, max) {
            if (x <= min) return 0;
            if (x >= max) return 1;
            x = (x - min) / (max - min);
            return x * x * (3 - 2 * x);
          }
          function smootherstep(x, min, max) {
            if (x <= min) return 0;
            if (x >= max) return 1;
            x = (x - min) / (max - min);
            return x * x * x * (x * (x * 6 - 15) + 10);
          } // Random integer from <low, high> interval
          function randInt(low, high) {
            return low + Math.floor(Math.random() * (high - low + 1));
          } // Random float from <low, high> interval
          function randFloat(low, high) {
            return low + Math.random() * (high - low);
          } // Random float from <-range/2, range/2> interval
          function randFloatSpread(range) {
            return range * (0.5 - Math.random());
          } // Deterministic pseudo-random float in the interval [ 0, 1 ]
          function seededRandom(s) {
            if (s !== undefined) _seed = s; // Mulberry32 generator
            var t = _seed += 0x6D2B79F5;
            t = Math.imul(t ^ t >>> 15, t | 1);
            t ^= t + Math.imul(t ^ t >>> 7, t | 61);
            return ((t ^ t >>> 14) >>> 0) / 4294967296;
          }
          function degToRad(degrees) {
            return degrees * DEG2RAD;
          }
          function radToDeg(radians) {
            return radians * RAD2DEG;
          }
          function isPowerOfTwo(value) {
            return (value & value - 1) === 0 && value !== 0;
          }
          function ceilPowerOfTwo(value) {
            return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
          }
          function floorPowerOfTwo(value) {
            return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
          }
          function setQuaternionFromProperEuler(q, a, b, c, order) {
            // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
            // rotations are applied to the axes in the order specified by 'order'
            // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
            // angles are in radians
            var cos = Math.cos;
            var sin = Math.sin;
            var c2 = cos(b / 2);
            var s2 = sin(b / 2);
            var c13 = cos((a + c) / 2);
            var s13 = sin((a + c) / 2);
            var c1_3 = cos((a - c) / 2);
            var s1_3 = sin((a - c) / 2);
            var c3_1 = cos((c - a) / 2);
            var s3_1 = sin((c - a) / 2);
            switch (order) {
              case 'XYX':
                q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
                break;
              case 'YZY':
                q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
                break;
              case 'ZXZ':
                q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
                break;
              case 'XZX':
                q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
                break;
              case 'YXY':
                q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
                break;
              case 'ZYZ':
                q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
                break;
              default:
                console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
            }
          }
          function denormalize(value, array) {
            switch (array.constructor) {
              case Float32Array:
                return value;
              case Uint16Array:
                return value / 65535.0;
              case Uint8Array:
                return value / 255.0;
              case Int16Array:
                return Math.max(value / 32767.0, -1.0);
              case Int8Array:
                return Math.max(value / 127.0, -1.0);
              default:
                throw new Error('Invalid component type.');
            }
          }
          function normalize(value, array) {
            switch (array.constructor) {
              case Float32Array:
                return value;
              case Uint16Array:
                return Math.round(value * 65535.0);
              case Uint8Array:
                return Math.round(value * 255.0);
              case Int16Array:
                return Math.round(value * 32767.0);
              case Int8Array:
                return Math.round(value * 127.0);
              default:
                throw new Error('Invalid component type.');
            }
          }
          var _MathUtils = /*#__PURE__*/Object.freeze({
            __proto__: null,
            DEG2RAD: DEG2RAD,
            RAD2DEG: RAD2DEG,
            generateUUID: generateUUID,
            clamp: clamp,
            euclideanModulo: euclideanModulo,
            mapLinear: mapLinear,
            inverseLerp: inverseLerp,
            lerp: lerp,
            damp: damp,
            pingpong: pingpong,
            smoothstep: smoothstep,
            smootherstep: smootherstep,
            randInt: randInt,
            randFloat: randFloat,
            randFloatSpread: randFloatSpread,
            seededRandom: seededRandom,
            degToRad: degToRad,
            radToDeg: radToDeg,
            isPowerOfTwo: isPowerOfTwo,
            ceilPowerOfTwo: ceilPowerOfTwo,
            floorPowerOfTwo: floorPowerOfTwo,
            setQuaternionFromProperEuler: setQuaternionFromProperEuler,
            normalize: normalize,
            denormalize: denormalize
          });
          var _Vector = /*#__PURE__*/function (_Symbol$iterator) {
            function _Vector() {
              var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck2(this, _Vector);
              _Vector.prototype.isVector2 = true;
              this.x = x;
              this.y = y;
            }
            _createClass2(_Vector, [{
              key: "width",
              get: function get() {
                return this.x;
              },
              set: function set(value) {
                this.x = value;
              }
            }, {
              key: "height",
              get: function get() {
                return this.y;
              },
              set: function set(value) {
                this.y = value;
              }
            }, {
              key: "set",
              value: function set(x, y) {
                this.x = x;
                this.y = y;
                return this;
              }
            }, {
              key: "setScalar",
              value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                return this;
              }
            }, {
              key: "setX",
              value: function setX(x) {
                this.x = x;
                return this;
              }
            }, {
              key: "setY",
              value: function setY(y) {
                this.y = y;
                return this;
              }
            }, {
              key: "setComponent",
              value: function setComponent(index, value) {
                switch (index) {
                  case 0:
                    this.x = value;
                    break;
                  case 1:
                    this.y = value;
                    break;
                  default:
                    throw new Error('index is out of range: ' + index);
                }
                return this;
              }
            }, {
              key: "getComponent",
              value: function getComponent(index) {
                switch (index) {
                  case 0:
                    return this.x;
                  case 1:
                    return this.y;
                  default:
                    throw new Error('index is out of range: ' + index);
                }
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this.x, this.y);
              }
            }, {
              key: "copy",
              value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                return this;
              }
            }, {
              key: "add",
              value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                return this;
              }
            }, {
              key: "addScalar",
              value: function addScalar(s) {
                this.x += s;
                this.y += s;
                return this;
              }
            }, {
              key: "addVectors",
              value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                return this;
              }
            }, {
              key: "addScaledVector",
              value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                return this;
              }
            }, {
              key: "sub",
              value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                return this;
              }
            }, {
              key: "subScalar",
              value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                return this;
              }
            }, {
              key: "subVectors",
              value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                return this;
              }
            }, {
              key: "multiplyScalar",
              value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                return this;
              }
            }, {
              key: "divide",
              value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                return this;
              }
            }, {
              key: "divideScalar",
              value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
              }
            }, {
              key: "applyMatrix3",
              value: function applyMatrix3(m) {
                var x = this.x,
                  y = this.y;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6];
                this.y = e[1] * x + e[4] * y + e[7];
                return this;
              }
            }, {
              key: "min",
              value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                return this;
              }
            }, {
              key: "max",
              value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                return this;
              }
            }, {
              key: "clamp",
              value: function clamp(min, max) {
                // assumes min < max, componentwise
                this.x = Math.max(min.x, Math.min(max.x, this.x));
                this.y = Math.max(min.y, Math.min(max.y, this.y));
                return this;
              }
            }, {
              key: "clampScalar",
              value: function clampScalar(minVal, maxVal) {
                this.x = Math.max(minVal, Math.min(maxVal, this.x));
                this.y = Math.max(minVal, Math.min(maxVal, this.y));
                return this;
              }
            }, {
              key: "clampLength",
              value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
              }
            }, {
              key: "floor",
              value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                return this;
              }
            }, {
              key: "ceil",
              value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                return this;
              }
            }, {
              key: "round",
              value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                return this;
              }
            }, {
              key: "roundToZero",
              value: function roundToZero() {
                this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
                this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
                return this;
              }
            }, {
              key: "negate",
              value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                return this;
              }
            }, {
              key: "dot",
              value: function dot(v) {
                return this.x * v.x + this.y * v.y;
              }
            }, {
              key: "cross",
              value: function cross(v) {
                return this.x * v.y - this.y * v.x;
              }
            }, {
              key: "lengthSq",
              value: function lengthSq() {
                return this.x * this.x + this.y * this.y;
              }
            }, {
              key: "length",
              value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
              }
            }, {
              key: "manhattanLength",
              value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
              }
            }, {
              key: "normalize",
              value: function normalize() {
                return this.divideScalar(this.length() || 1);
              }
            }, {
              key: "angle",
              value: function angle() {
                // computes the angle in radians with respect to the positive x-axis
                var angle = Math.atan2(-this.y, -this.x) + Math.PI;
                return angle;
              }
            }, {
              key: "distanceTo",
              value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
              }
            }, {
              key: "distanceToSquared",
              value: function distanceToSquared(v) {
                var dx = this.x - v.x,
                  dy = this.y - v.y;
                return dx * dx + dy * dy;
              }
            }, {
              key: "manhattanDistanceTo",
              value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
              }
            }, {
              key: "setLength",
              value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
              }
            }, {
              key: "lerp",
              value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                return this;
              }
            }, {
              key: "lerpVectors",
              value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                return this;
              }
            }, {
              key: "equals",
              value: function equals(v) {
                return v.x === this.x && v.y === this.y;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                return array;
              }
            }, {
              key: "fromBufferAttribute",
              value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                return this;
              }
            }, {
              key: "rotateAround",
              value: function rotateAround(center, angle) {
                var c = Math.cos(angle),
                  s = Math.sin(angle);
                var x = this.x - center.x;
                var y = this.y - center.y;
                this.x = x * c - y * s + center.x;
                this.y = x * s + y * c + center.y;
                return this;
              }
            }, {
              key: "random",
              value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                return this;
              }
            }, {
              key: _Symbol$iterator,
              value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
                return _regeneratorRuntime().wrap(function value$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return this.x;
                    case 2:
                      _context2.next = 4;
                      return this.y;
                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }, value, this);
              })
            }]);
            return _Vector;
          }(Symbol.iterator);
          var _Matrix = /*#__PURE__*/function () {
            function _Matrix() {
              _classCallCheck2(this, _Matrix);
              _Matrix.prototype.isMatrix3 = true;
              this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1];
            }
            _createClass2(_Matrix, [{
              key: "set",
              value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
                var te = this.elements;
                te[0] = n11;
                te[1] = n21;
                te[2] = n31;
                te[3] = n12;
                te[4] = n22;
                te[5] = n32;
                te[6] = n13;
                te[7] = n23;
                te[8] = n33;
                return this;
              }
            }, {
              key: "identity",
              value: function identity() {
                this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                return this;
              }
            }, {
              key: "extractBasis",
              value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrix3Column(this, 0);
                yAxis.setFromMatrix3Column(this, 1);
                zAxis.setFromMatrix3Column(this, 2);
                return this;
              }
            }, {
              key: "setFromMatrix4",
              value: function setFromMatrix4(m) {
                var me = m.elements;
                this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(m) {
                return this.multiplyMatrices(this, m);
              }
            }, {
              key: "premultiply",
              value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
              }
            }, {
              key: "multiplyMatrices",
              value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0],
                  a12 = ae[3],
                  a13 = ae[6];
                var a21 = ae[1],
                  a22 = ae[4],
                  a23 = ae[7];
                var a31 = ae[2],
                  a32 = ae[5],
                  a33 = ae[8];
                var b11 = be[0],
                  b12 = be[3],
                  b13 = be[6];
                var b21 = be[1],
                  b22 = be[4],
                  b23 = be[7];
                var b31 = be[2],
                  b32 = be[5],
                  b33 = be[8];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31;
                te[3] = a11 * b12 + a12 * b22 + a13 * b32;
                te[6] = a11 * b13 + a12 * b23 + a13 * b33;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31;
                te[4] = a21 * b12 + a22 * b22 + a23 * b32;
                te[7] = a21 * b13 + a22 * b23 + a23 * b33;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31;
                te[5] = a31 * b12 + a32 * b22 + a33 * b32;
                te[8] = a31 * b13 + a32 * b23 + a33 * b33;
                return this;
              }
            }, {
              key: "multiplyScalar",
              value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[3] *= s;
                te[6] *= s;
                te[1] *= s;
                te[4] *= s;
                te[7] *= s;
                te[2] *= s;
                te[5] *= s;
                te[8] *= s;
                return this;
              }
            }, {
              key: "determinant",
              value: function determinant() {
                var te = this.elements;
                var a = te[0],
                  b = te[1],
                  c = te[2],
                  d = te[3],
                  e = te[4],
                  f = te[5],
                  g = te[6],
                  h = te[7],
                  i = te[8];
                return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
              }
            }, {
              key: "invert",
              value: function invert() {
                var te = this.elements,
                  n11 = te[0],
                  n21 = te[1],
                  n31 = te[2],
                  n12 = te[3],
                  n22 = te[4],
                  n32 = te[5],
                  n13 = te[6],
                  n23 = te[7],
                  n33 = te[8],
                  t11 = n33 * n22 - n32 * n23,
                  t12 = n32 * n13 - n33 * n12,
                  t13 = n23 * n12 - n22 * n13,
                  det = n11 * t11 + n21 * t12 + n31 * t13;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n31 * n23 - n33 * n21) * detInv;
                te[2] = (n32 * n21 - n31 * n22) * detInv;
                te[3] = t12 * detInv;
                te[4] = (n33 * n11 - n31 * n13) * detInv;
                te[5] = (n31 * n12 - n32 * n11) * detInv;
                te[6] = t13 * detInv;
                te[7] = (n21 * n13 - n23 * n11) * detInv;
                te[8] = (n22 * n11 - n21 * n12) * detInv;
                return this;
              }
            }, {
              key: "transpose",
              value: function transpose() {
                var tmp;
                var m = this.elements;
                tmp = m[1];
                m[1] = m[3];
                m[3] = tmp;
                tmp = m[2];
                m[2] = m[6];
                m[6] = tmp;
                tmp = m[5];
                m[5] = m[7];
                m[7] = tmp;
                return this;
              }
            }, {
              key: "getNormalMatrix",
              value: function getNormalMatrix(matrix4) {
                return this.setFromMatrix4(matrix4).invert().transpose();
              }
            }, {
              key: "transposeIntoArray",
              value: function transposeIntoArray(r) {
                var m = this.elements;
                r[0] = m[0];
                r[1] = m[3];
                r[2] = m[6];
                r[3] = m[1];
                r[4] = m[4];
                r[5] = m[7];
                r[6] = m[2];
                r[7] = m[5];
                r[8] = m[8];
                return this;
              }
            }, {
              key: "setUvTransform",
              value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
                var c = Math.cos(rotation);
                var s = Math.sin(rotation);
                this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
                return this;
              } //
            }, {
              key: "scale",
              value: function scale(sx, sy) {
                this.premultiply(_m3.makeScale(sx, sy));
                return this;
              }
            }, {
              key: "rotate",
              value: function rotate(theta) {
                this.premultiply(_m3.makeRotation(-theta));
                return this;
              }
            }, {
              key: "translate",
              value: function translate(tx, ty) {
                this.premultiply(_m3.makeTranslation(tx, ty));
                return this;
              } // for 2D Transforms
            }, {
              key: "makeTranslation",
              value: function makeTranslation(x, y) {
                this.set(1, 0, x, 0, 1, y, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeRotation",
              value: function makeRotation(theta) {
                // counterclockwise
                var c = Math.cos(theta);
                var s = Math.sin(theta);
                this.set(c, -s, 0, s, c, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeScale",
              value: function makeScale(x, y) {
                this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
                return this;
              } //
            }, {
              key: "equals",
              value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for (var i = 0; i < 9; i++) {
                  if (te[i] !== me[i]) return false;
                }
                return true;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                for (var i = 0; i < 9; i++) {
                  this.elements[i] = array[i + offset];
                }
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                return array;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().fromArray(this.elements);
              }
            }]);
            return _Matrix;
          }();
          var _m3 = /*@__PURE__*/new _Matrix();
          function arrayNeedsUint32(array) {
            // assumes larger values usually on last
            for (var i = array.length - 1; i >= 0; --i) {
              if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
            }
            return false;
          }
          var TYPED_ARRAYS = {
            Int8Array: Int8Array,
            Uint8Array: Uint8Array,
            Uint8ClampedArray: Uint8ClampedArray,
            Int16Array: Int16Array,
            Uint16Array: Uint16Array,
            Int32Array: Int32Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array
          };
          function getTypedArray(type, buffer) {
            return new TYPED_ARRAYS[type](buffer);
          }
          function createElementNS(name) {
            return document.createElementNS('http://www.w3.org/1999/xhtml', name);
          }
          function SRGBToLinear(c) {
            return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
          }
          function LinearToSRGB(c) {
            return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
          } // JavaScript RGB-to-RGB transforms, defined as
          // FN[InputColorSpace][OutputColorSpace] callback functions.
          var FN = (_FN = {}, _defineProperty(_FN, _SRGBColorSpace, _defineProperty({}, _LinearSRGBColorSpace, SRGBToLinear)), _defineProperty(_FN, _LinearSRGBColorSpace, _defineProperty({}, _SRGBColorSpace, LinearToSRGB)), _FN);
          var _ColorManagement = {
            legacyMode: true,
            get workingColorSpace() {
              return _LinearSRGBColorSpace;
            },
            set workingColorSpace(colorSpace) {
              console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
            },
            convert: function convert(color, sourceColorSpace, targetColorSpace) {
              if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
                return color;
              }
              if (FN[sourceColorSpace] && FN[sourceColorSpace][targetColorSpace] !== undefined) {
                var fn = FN[sourceColorSpace][targetColorSpace];
                color.r = fn(color.r);
                color.g = fn(color.g);
                color.b = fn(color.b);
                return color;
              }
              throw new Error('Unsupported color space conversion.');
            },
            fromWorkingColorSpace: function fromWorkingColorSpace(color, targetColorSpace) {
              return this.convert(color, this.workingColorSpace, targetColorSpace);
            },
            toWorkingColorSpace: function toWorkingColorSpace(color, sourceColorSpace) {
              return this.convert(color, sourceColorSpace, this.workingColorSpace);
            }
          };
          var _colorKeywords = {
            'aliceblue': 0xF0F8FF,
            'antiquewhite': 0xFAEBD7,
            'aqua': 0x00FFFF,
            'aquamarine': 0x7FFFD4,
            'azure': 0xF0FFFF,
            'beige': 0xF5F5DC,
            'bisque': 0xFFE4C4,
            'black': 0x000000,
            'blanchedalmond': 0xFFEBCD,
            'blue': 0x0000FF,
            'blueviolet': 0x8A2BE2,
            'brown': 0xA52A2A,
            'burlywood': 0xDEB887,
            'cadetblue': 0x5F9EA0,
            'chartreuse': 0x7FFF00,
            'chocolate': 0xD2691E,
            'coral': 0xFF7F50,
            'cornflowerblue': 0x6495ED,
            'cornsilk': 0xFFF8DC,
            'crimson': 0xDC143C,
            'cyan': 0x00FFFF,
            'darkblue': 0x00008B,
            'darkcyan': 0x008B8B,
            'darkgoldenrod': 0xB8860B,
            'darkgray': 0xA9A9A9,
            'darkgreen': 0x006400,
            'darkgrey': 0xA9A9A9,
            'darkkhaki': 0xBDB76B,
            'darkmagenta': 0x8B008B,
            'darkolivegreen': 0x556B2F,
            'darkorange': 0xFF8C00,
            'darkorchid': 0x9932CC,
            'darkred': 0x8B0000,
            'darksalmon': 0xE9967A,
            'darkseagreen': 0x8FBC8F,
            'darkslateblue': 0x483D8B,
            'darkslategray': 0x2F4F4F,
            'darkslategrey': 0x2F4F4F,
            'darkturquoise': 0x00CED1,
            'darkviolet': 0x9400D3,
            'deeppink': 0xFF1493,
            'deepskyblue': 0x00BFFF,
            'dimgray': 0x696969,
            'dimgrey': 0x696969,
            'dodgerblue': 0x1E90FF,
            'firebrick': 0xB22222,
            'floralwhite': 0xFFFAF0,
            'forestgreen': 0x228B22,
            'fuchsia': 0xFF00FF,
            'gainsboro': 0xDCDCDC,
            'ghostwhite': 0xF8F8FF,
            'gold': 0xFFD700,
            'goldenrod': 0xDAA520,
            'gray': 0x808080,
            'green': 0x008000,
            'greenyellow': 0xADFF2F,
            'grey': 0x808080,
            'honeydew': 0xF0FFF0,
            'hotpink': 0xFF69B4,
            'indianred': 0xCD5C5C,
            'indigo': 0x4B0082,
            'ivory': 0xFFFFF0,
            'khaki': 0xF0E68C,
            'lavender': 0xE6E6FA,
            'lavenderblush': 0xFFF0F5,
            'lawngreen': 0x7CFC00,
            'lemonchiffon': 0xFFFACD,
            'lightblue': 0xADD8E6,
            'lightcoral': 0xF08080,
            'lightcyan': 0xE0FFFF,
            'lightgoldenrodyellow': 0xFAFAD2,
            'lightgray': 0xD3D3D3,
            'lightgreen': 0x90EE90,
            'lightgrey': 0xD3D3D3,
            'lightpink': 0xFFB6C1,
            'lightsalmon': 0xFFA07A,
            'lightseagreen': 0x20B2AA,
            'lightskyblue': 0x87CEFA,
            'lightslategray': 0x778899,
            'lightslategrey': 0x778899,
            'lightsteelblue': 0xB0C4DE,
            'lightyellow': 0xFFFFE0,
            'lime': 0x00FF00,
            'limegreen': 0x32CD32,
            'linen': 0xFAF0E6,
            'magenta': 0xFF00FF,
            'maroon': 0x800000,
            'mediumaquamarine': 0x66CDAA,
            'mediumblue': 0x0000CD,
            'mediumorchid': 0xBA55D3,
            'mediumpurple': 0x9370DB,
            'mediumseagreen': 0x3CB371,
            'mediumslateblue': 0x7B68EE,
            'mediumspringgreen': 0x00FA9A,
            'mediumturquoise': 0x48D1CC,
            'mediumvioletred': 0xC71585,
            'midnightblue': 0x191970,
            'mintcream': 0xF5FFFA,
            'mistyrose': 0xFFE4E1,
            'moccasin': 0xFFE4B5,
            'navajowhite': 0xFFDEAD,
            'navy': 0x000080,
            'oldlace': 0xFDF5E6,
            'olive': 0x808000,
            'olivedrab': 0x6B8E23,
            'orange': 0xFFA500,
            'orangered': 0xFF4500,
            'orchid': 0xDA70D6,
            'palegoldenrod': 0xEEE8AA,
            'palegreen': 0x98FB98,
            'paleturquoise': 0xAFEEEE,
            'palevioletred': 0xDB7093,
            'papayawhip': 0xFFEFD5,
            'peachpuff': 0xFFDAB9,
            'peru': 0xCD853F,
            'pink': 0xFFC0CB,
            'plum': 0xDDA0DD,
            'powderblue': 0xB0E0E6,
            'purple': 0x800080,
            'rebeccapurple': 0x663399,
            'red': 0xFF0000,
            'rosybrown': 0xBC8F8F,
            'royalblue': 0x4169E1,
            'saddlebrown': 0x8B4513,
            'salmon': 0xFA8072,
            'sandybrown': 0xF4A460,
            'seagreen': 0x2E8B57,
            'seashell': 0xFFF5EE,
            'sienna': 0xA0522D,
            'silver': 0xC0C0C0,
            'skyblue': 0x87CEEB,
            'slateblue': 0x6A5ACD,
            'slategray': 0x708090,
            'slategrey': 0x708090,
            'snow': 0xFFFAFA,
            'springgreen': 0x00FF7F,
            'steelblue': 0x4682B4,
            'tan': 0xD2B48C,
            'teal': 0x008080,
            'thistle': 0xD8BFD8,
            'tomato': 0xFF6347,
            'turquoise': 0x40E0D0,
            'violet': 0xEE82EE,
            'wheat': 0xF5DEB3,
            'white': 0xFFFFFF,
            'whitesmoke': 0xF5F5F5,
            'yellow': 0xFFFF00,
            'yellowgreen': 0x9ACD32
          };
          var _rgb$1 = {
            r: 0,
            g: 0,
            b: 0
          };
          var _hslA = {
            h: 0,
            s: 0,
            l: 0
          };
          var _hslB = {
            h: 0,
            s: 0,
            l: 0
          };
          function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
            return p;
          }
          function toComponents(source, target) {
            target.r = source.r;
            target.g = source.g;
            target.b = source.b;
            return target;
          }
          var _Color = /*#__PURE__*/function (_Symbol$iterator2) {
            function _Color(r, g, b) {
              _classCallCheck2(this, _Color);
              this.isColor = true;
              this.r = 1;
              this.g = 1;
              this.b = 1;
              if (g === undefined && b === undefined) {
                // r is THREE.Color, hex or string
                return this.set(r);
              }
              return this.setRGB(r, g, b);
            }
            _createClass2(_Color, [{
              key: "set",
              value: function set(value) {
                if (value && value.isColor) {
                  this.copy(value);
                } else if (typeof value === 'number') {
                  this.setHex(value);
                } else if (typeof value === 'string') {
                  this.setStyle(value);
                }
                return this;
              }
            }, {
              key: "setScalar",
              value: function setScalar(scalar) {
                this.r = scalar;
                this.g = scalar;
                this.b = scalar;
                return this;
              }
            }, {
              key: "setHex",
              value: function setHex(hex) {
                var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SRGBColorSpace;
                hex = Math.floor(hex);
                this.r = (hex >> 16 & 255) / 255;
                this.g = (hex >> 8 & 255) / 255;
                this.b = (hex & 255) / 255;
                _ColorManagement.toWorkingColorSpace(this, colorSpace);
                return this;
              }
            }, {
              key: "setRGB",
              value: function setRGB(r, g, b) {
                var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ColorManagement.workingColorSpace;
                this.r = r;
                this.g = g;
                this.b = b;
                _ColorManagement.toWorkingColorSpace(this, colorSpace);
                return this;
              }
            }, {
              key: "setHSL",
              value: function setHSL(h, s, l) {
                var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ColorManagement.workingColorSpace;
                // h,s,l ranges are in 0.0 - 1.0
                h = euclideanModulo(h, 1);
                s = clamp(s, 0, 1);
                l = clamp(l, 0, 1);
                if (s === 0) {
                  this.r = this.g = this.b = l;
                } else {
                  var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
                  var q = 2 * l - p;
                  this.r = hue2rgb(q, p, h + 1 / 3);
                  this.g = hue2rgb(q, p, h);
                  this.b = hue2rgb(q, p, h - 1 / 3);
                }
                _ColorManagement.toWorkingColorSpace(this, colorSpace);
                return this;
              }
            }, {
              key: "setStyle",
              value: function setStyle(style) {
                var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SRGBColorSpace;
                function handleAlpha(string) {
                  if (string === undefined) return;
                  if (parseFloat(string) < 1) {
                    console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
                  }
                }
                var m;
                if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
                  // rgb / hsl
                  var color;
                  var name = m[1];
                  var components = m[2];
                  switch (name) {
                    case 'rgb':
                    case 'rgba':
                      if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        _ColorManagement.toWorkingColorSpace(this, colorSpace);
                        handleAlpha(color[4]);
                        return this;
                      }
                      if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        _ColorManagement.toWorkingColorSpace(this, colorSpace);
                        handleAlpha(color[4]);
                        return this;
                      }
                      break;
                    case 'hsl':
                    case 'hsla':
                      if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        var h = parseFloat(color[1]) / 360;
                        var s = parseFloat(color[2]) / 100;
                        var l = parseFloat(color[3]) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l, colorSpace);
                      }
                      break;
                  }
                } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
                  // hex color
                  var hex = m[1];
                  var size = hex.length;
                  if (size === 3) {
                    // #ff0
                    this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                    this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                    this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                    _ColorManagement.toWorkingColorSpace(this, colorSpace);
                    return this;
                  } else if (size === 6) {
                    // #ff0000
                    this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                    this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                    this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                    _ColorManagement.toWorkingColorSpace(this, colorSpace);
                    return this;
                  }
                }
                if (style && style.length > 0) {
                  return this.setColorName(style, colorSpace);
                }
                return this;
              }
            }, {
              key: "setColorName",
              value: function setColorName(style) {
                var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SRGBColorSpace;
                // color keywords
                var hex = _colorKeywords[style.toLowerCase()];
                if (hex !== undefined) {
                  // red
                  this.setHex(hex, colorSpace);
                } else {
                  // unknown color
                  console.warn('THREE.Color: Unknown color ' + style);
                }
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this.r, this.g, this.b);
              }
            }, {
              key: "copy",
              value: function copy(color) {
                this.r = color.r;
                this.g = color.g;
                this.b = color.b;
                return this;
              }
            }, {
              key: "copySRGBToLinear",
              value: function copySRGBToLinear(color) {
                this.r = SRGBToLinear(color.r);
                this.g = SRGBToLinear(color.g);
                this.b = SRGBToLinear(color.b);
                return this;
              }
            }, {
              key: "copyLinearToSRGB",
              value: function copyLinearToSRGB(color) {
                this.r = LinearToSRGB(color.r);
                this.g = LinearToSRGB(color.g);
                this.b = LinearToSRGB(color.b);
                return this;
              }
            }, {
              key: "convertSRGBToLinear",
              value: function convertSRGBToLinear() {
                this.copySRGBToLinear(this);
                return this;
              }
            }, {
              key: "convertLinearToSRGB",
              value: function convertLinearToSRGB() {
                this.copyLinearToSRGB(this);
                return this;
              }
            }, {
              key: "getHex",
              value: function getHex() {
                var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SRGBColorSpace;
                _ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb$1), colorSpace);
                return clamp(_rgb$1.r * 255, 0, 255) << 16 ^ clamp(_rgb$1.g * 255, 0, 255) << 8 ^ clamp(_rgb$1.b * 255, 0, 255) << 0;
              }
            }, {
              key: "getHexString",
              value: function getHexString() {
                var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SRGBColorSpace;
                return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
              }
            }, {
              key: "getHSL",
              value: function getHSL(target) {
                var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ColorManagement.workingColorSpace;
                // h,s,l ranges are in 0.0 - 1.0
                _ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb$1), colorSpace);
                var r = _rgb$1.r,
                  g = _rgb$1.g,
                  b = _rgb$1.b;
                var max = Math.max(r, g, b);
                var min = Math.min(r, g, b);
                var hue, saturation;
                var lightness = (min + max) / 2.0;
                if (min === max) {
                  hue = 0;
                  saturation = 0;
                } else {
                  var delta = max - min;
                  saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
                  switch (max) {
                    case r:
                      hue = (g - b) / delta + (g < b ? 6 : 0);
                      break;
                    case g:
                      hue = (b - r) / delta + 2;
                      break;
                    case b:
                      hue = (r - g) / delta + 4;
                      break;
                  }
                  hue /= 6;
                }
                target.h = hue;
                target.s = saturation;
                target.l = lightness;
                return target;
              }
            }, {
              key: "getRGB",
              value: function getRGB(target) {
                var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ColorManagement.workingColorSpace;
                _ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb$1), colorSpace);
                target.r = _rgb$1.r;
                target.g = _rgb$1.g;
                target.b = _rgb$1.b;
                return target;
              }
            }, {
              key: "getStyle",
              value: function getStyle() {
                var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SRGBColorSpace;
                _ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb$1), colorSpace);
                if (colorSpace !== _SRGBColorSpace) {
                  // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
                  return "color(".concat(colorSpace, " ").concat(_rgb$1.r, " ").concat(_rgb$1.g, " ").concat(_rgb$1.b, ")");
                }
                return "rgb(".concat(_rgb$1.r * 255 | 0, ",").concat(_rgb$1.g * 255 | 0, ",").concat(_rgb$1.b * 255 | 0, ")");
              }
            }, {
              key: "offsetHSL",
              value: function offsetHSL(h, s, l) {
                this.getHSL(_hslA);
                _hslA.h += h;
                _hslA.s += s;
                _hslA.l += l;
                this.setHSL(_hslA.h, _hslA.s, _hslA.l);
                return this;
              }
            }, {
              key: "add",
              value: function add(color) {
                this.r += color.r;
                this.g += color.g;
                this.b += color.b;
                return this;
              }
            }, {
              key: "addColors",
              value: function addColors(color1, color2) {
                this.r = color1.r + color2.r;
                this.g = color1.g + color2.g;
                this.b = color1.b + color2.b;
                return this;
              }
            }, {
              key: "addScalar",
              value: function addScalar(s) {
                this.r += s;
                this.g += s;
                this.b += s;
                return this;
              }
            }, {
              key: "sub",
              value: function sub(color) {
                this.r = Math.max(0, this.r - color.r);
                this.g = Math.max(0, this.g - color.g);
                this.b = Math.max(0, this.b - color.b);
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(color) {
                this.r *= color.r;
                this.g *= color.g;
                this.b *= color.b;
                return this;
              }
            }, {
              key: "multiplyScalar",
              value: function multiplyScalar(s) {
                this.r *= s;
                this.g *= s;
                this.b *= s;
                return this;
              }
            }, {
              key: "lerp",
              value: function lerp(color, alpha) {
                this.r += (color.r - this.r) * alpha;
                this.g += (color.g - this.g) * alpha;
                this.b += (color.b - this.b) * alpha;
                return this;
              }
            }, {
              key: "lerpColors",
              value: function lerpColors(color1, color2, alpha) {
                this.r = color1.r + (color2.r - color1.r) * alpha;
                this.g = color1.g + (color2.g - color1.g) * alpha;
                this.b = color1.b + (color2.b - color1.b) * alpha;
                return this;
              }
            }, {
              key: "lerpHSL",
              value: function lerpHSL(color, alpha) {
                this.getHSL(_hslA);
                color.getHSL(_hslB);
                var h = lerp(_hslA.h, _hslB.h, alpha);
                var s = lerp(_hslA.s, _hslB.s, alpha);
                var l = lerp(_hslA.l, _hslB.l, alpha);
                this.setHSL(h, s, l);
                return this;
              }
            }, {
              key: "equals",
              value: function equals(c) {
                return c.r === this.r && c.g === this.g && c.b === this.b;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this.r = array[offset];
                this.g = array[offset + 1];
                this.b = array[offset + 2];
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                array[offset] = this.r;
                array[offset + 1] = this.g;
                array[offset + 2] = this.b;
                return array;
              }
            }, {
              key: "fromBufferAttribute",
              value: function fromBufferAttribute(attribute, index) {
                this.r = attribute.getX(index);
                this.g = attribute.getY(index);
                this.b = attribute.getZ(index);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                return this.getHex();
              }
            }, {
              key: _Symbol$iterator2,
              value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
                return _regeneratorRuntime().wrap(function value$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return this.r;
                    case 2:
                      _context3.next = 4;
                      return this.g;
                    case 4:
                      _context3.next = 6;
                      return this.b;
                    case 6:
                    case "end":
                      return _context3.stop();
                  }
                }, value, this);
              })
            }]);
            return _Color;
          }(Symbol.iterator);
          _Color.NAMES = _colorKeywords;
          var _canvas;
          var _ImageUtils = /*#__PURE__*/function () {
            function _ImageUtils() {
              _classCallCheck2(this, _ImageUtils);
            }
            _createClass2(_ImageUtils, null, [{
              key: "getDataURL",
              value: function getDataURL(image) {
                if (/^data:/i.test(image.src)) {
                  return image.src;
                }
                if (typeof HTMLCanvasElement == 'undefined') {
                  return image.src;
                }
                var canvas;
                if (image instanceof HTMLCanvasElement) {
                  canvas = image;
                } else {
                  if (_canvas === undefined) _canvas = createElementNS('canvas');
                  _canvas.width = image.width;
                  _canvas.height = image.height;
                  var context = _canvas.getContext('2d');
                  if (image instanceof ImageData) {
                    context.putImageData(image, 0, 0);
                  } else {
                    context.drawImage(image, 0, 0, image.width, image.height);
                  }
                  canvas = _canvas;
                }
                if (canvas.width > 2048 || canvas.height > 2048) {
                  console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
                  return canvas.toDataURL('image/jpeg', 0.6);
                } else {
                  return canvas.toDataURL('image/png');
                }
              }
            }, {
              key: "sRGBToLinear",
              value: function sRGBToLinear(image) {
                if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                  var canvas = createElementNS('canvas');
                  canvas.width = image.width;
                  canvas.height = image.height;
                  var context = canvas.getContext('2d');
                  context.drawImage(image, 0, 0, image.width, image.height);
                  var imageData = context.getImageData(0, 0, image.width, image.height);
                  var data = imageData.data;
                  for (var i = 0; i < data.length; i++) {
                    data[i] = SRGBToLinear(data[i] / 255) * 255;
                  }
                  context.putImageData(imageData, 0, 0);
                  return canvas;
                } else if (image.data) {
                  var _data = image.data.slice(0);
                  for (var _i2 = 0; _i2 < _data.length; _i2++) {
                    if (_data instanceof Uint8Array || _data instanceof Uint8ClampedArray) {
                      _data[_i2] = Math.floor(SRGBToLinear(_data[_i2] / 255) * 255);
                    } else {
                      // assuming float
                      _data[_i2] = SRGBToLinear(_data[_i2]);
                    }
                  }
                  return {
                    data: _data,
                    width: image.width,
                    height: image.height
                  };
                } else {
                  console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
                  return image;
                }
              }
            }]);
            return _ImageUtils;
          }();
          var _Source = /*#__PURE__*/function () {
            function _Source() {
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              _classCallCheck2(this, _Source);
              this.isSource = true;
              this.uuid = generateUUID();
              this.data = data;
              this.version = 0;
            }
            _createClass2(_Source, [{
              key: "needsUpdate",
              set: function set(value) {
                if (value === true) this.version++;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.images[this.uuid] !== undefined) {
                  return meta.images[this.uuid];
                }
                var output = {
                  uuid: this.uuid,
                  url: ''
                };
                var data = this.data;
                if (data !== null) {
                  var url;
                  if (Array.isArray(data)) {
                    // cube texture
                    url = [];
                    for (var i = 0, l = data.length; i < l; i++) {
                      if (data[i].isDataTexture) {
                        url.push(serializeImage(data[i].image));
                      } else {
                        url.push(serializeImage(data[i]));
                      }
                    }
                  } else {
                    // texture
                    url = serializeImage(data);
                  }
                  output.url = url;
                }
                if (!isRootObject) {
                  meta.images[this.uuid] = output;
                }
                return output;
              }
            }]);
            return _Source;
          }();
          function serializeImage(image) {
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
              // default images
              return _ImageUtils.getDataURL(image);
            } else {
              if (image.data) {
                // images of DataTexture
                return {
                  data: Array.from(image.data),
                  width: image.width,
                  height: image.height,
                  type: image.data.constructor.name
                };
              } else {
                console.warn('THREE.Texture: Unable to serialize Texture.');
                return {};
              }
            }
          }
          var textureId = 0;
          var _Texture = /*#__PURE__*/function (_EventDispatcher2) {
            _inherits(_Texture, _EventDispatcher2);
            var _super11 = _createSuper(_Texture);
            function _Texture() {
              var _this12;
              var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Texture.DEFAULT_IMAGE;
              var mapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Texture.DEFAULT_MAPPING;
              var wrapS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ClampToEdgeWrapping;
              var wrapT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ClampToEdgeWrapping;
              var magFilter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _LinearFilter;
              var minFilter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _LinearMipmapLinearFilter;
              var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : _RGBAFormat;
              var type = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : _UnsignedByteType;
              var anisotropy = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : _Texture.DEFAULT_ANISOTROPY;
              var encoding = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : _LinearEncoding;
              _classCallCheck2(this, _Texture);
              _this12 = _super11.call(this);
              _this12.isTexture = true;
              Object.defineProperty(_assertThisInitialized(_this12), 'id', {
                value: textureId++
              });
              _this12.uuid = generateUUID();
              _this12.name = '';
              _this12.source = new _Source(image);
              _this12.mipmaps = [];
              _this12.mapping = mapping;
              _this12.wrapS = wrapS;
              _this12.wrapT = wrapT;
              _this12.magFilter = magFilter;
              _this12.minFilter = minFilter;
              _this12.anisotropy = anisotropy;
              _this12.format = format;
              _this12.internalFormat = null;
              _this12.type = type;
              _this12.offset = new _Vector(0, 0);
              _this12.repeat = new _Vector(1, 1);
              _this12.center = new _Vector(0, 0);
              _this12.rotation = 0;
              _this12.matrixAutoUpdate = true;
              _this12.matrix = new _Matrix();
              _this12.generateMipmaps = true;
              _this12.premultiplyAlpha = false;
              _this12.flipY = true;
              _this12.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
              // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
              //
              // Also changing the encoding after already used by a Material will not automatically make the Material
              // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
              _this12.encoding = encoding;
              _this12.userData = {};
              _this12.version = 0;
              _this12.onUpdate = null;
              _this12.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
              _this12.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
              return _this12;
            }
            _createClass2(_Texture, [{
              key: "image",
              get: function get() {
                return this.source.data;
              },
              set: function set(value) {
                this.source.data = value;
              }
            }, {
              key: "updateMatrix",
              value: function updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.name = source.name;
                this.source = source.source;
                this.mipmaps = source.mipmaps.slice(0);
                this.mapping = source.mapping;
                this.wrapS = source.wrapS;
                this.wrapT = source.wrapT;
                this.magFilter = source.magFilter;
                this.minFilter = source.minFilter;
                this.anisotropy = source.anisotropy;
                this.format = source.format;
                this.internalFormat = source.internalFormat;
                this.type = source.type;
                this.offset.copy(source.offset);
                this.repeat.copy(source.repeat);
                this.center.copy(source.center);
                this.rotation = source.rotation;
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrix.copy(source.matrix);
                this.generateMipmaps = source.generateMipmaps;
                this.premultiplyAlpha = source.premultiplyAlpha;
                this.flipY = source.flipY;
                this.unpackAlignment = source.unpackAlignment;
                this.encoding = source.encoding;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                this.needsUpdate = true;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.textures[this.uuid] !== undefined) {
                  return meta.textures[this.uuid];
                }
                var output = {
                  metadata: {
                    version: 4.5,
                    type: 'Texture',
                    generator: 'Texture.toJSON'
                  },
                  uuid: this.uuid,
                  name: this.name,
                  image: this.source.toJSON(meta).uuid,
                  mapping: this.mapping,
                  repeat: [this.repeat.x, this.repeat.y],
                  offset: [this.offset.x, this.offset.y],
                  center: [this.center.x, this.center.y],
                  rotation: this.rotation,
                  wrap: [this.wrapS, this.wrapT],
                  format: this.format,
                  type: this.type,
                  encoding: this.encoding,
                  minFilter: this.minFilter,
                  magFilter: this.magFilter,
                  anisotropy: this.anisotropy,
                  flipY: this.flipY,
                  premultiplyAlpha: this.premultiplyAlpha,
                  unpackAlignment: this.unpackAlignment
                };
                if (JSON.stringify(this.userData) !== '{}') output.userData = this.userData;
                if (!isRootObject) {
                  meta.textures[this.uuid] = output;
                }
                return output;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.dispatchEvent({
                  type: 'dispose'
                });
              }
            }, {
              key: "transformUv",
              value: function transformUv(uv) {
                if (this.mapping !== _UVMapping) return uv;
                uv.applyMatrix3(this.matrix);
                if (uv.x < 0 || uv.x > 1) {
                  switch (this.wrapS) {
                    case _RepeatWrapping:
                      uv.x = uv.x - Math.floor(uv.x);
                      break;
                    case _ClampToEdgeWrapping:
                      uv.x = uv.x < 0 ? 0 : 1;
                      break;
                    case _MirroredRepeatWrapping:
                      if (Math.abs(Math.floor(uv.x) % 2) === 1) {
                        uv.x = Math.ceil(uv.x) - uv.x;
                      } else {
                        uv.x = uv.x - Math.floor(uv.x);
                      }
                      break;
                  }
                }
                if (uv.y < 0 || uv.y > 1) {
                  switch (this.wrapT) {
                    case _RepeatWrapping:
                      uv.y = uv.y - Math.floor(uv.y);
                      break;
                    case _ClampToEdgeWrapping:
                      uv.y = uv.y < 0 ? 0 : 1;
                      break;
                    case _MirroredRepeatWrapping:
                      if (Math.abs(Math.floor(uv.y) % 2) === 1) {
                        uv.y = Math.ceil(uv.y) - uv.y;
                      } else {
                        uv.y = uv.y - Math.floor(uv.y);
                      }
                      break;
                  }
                }
                if (this.flipY) {
                  uv.y = 1 - uv.y;
                }
                return uv;
              }
            }, {
              key: "needsUpdate",
              set: function set(value) {
                if (value === true) {
                  this.version++;
                  this.source.needsUpdate = true;
                }
              }
            }]);
            return _Texture;
          }(_EventDispatcher);
          _Texture.DEFAULT_IMAGE = null;
          _Texture.DEFAULT_MAPPING = _UVMapping;
          _Texture.DEFAULT_ANISOTROPY = 1;
          var _Vector3 = /*#__PURE__*/function (_Symbol$iterator3) {
            function _Vector3() {
              var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              _classCallCheck2(this, _Vector3);
              _Vector3.prototype.isVector4 = true;
              this.x = x;
              this.y = y;
              this.z = z;
              this.w = w;
            }
            _createClass2(_Vector3, [{
              key: "width",
              get: function get() {
                return this.z;
              },
              set: function set(value) {
                this.z = value;
              }
            }, {
              key: "height",
              get: function get() {
                return this.w;
              },
              set: function set(value) {
                this.w = value;
              }
            }, {
              key: "set",
              value: function set(x, y, z, w) {
                this.x = x;
                this.y = y;
                this.z = z;
                this.w = w;
                return this;
              }
            }, {
              key: "setScalar",
              value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                this.w = scalar;
                return this;
              }
            }, {
              key: "setX",
              value: function setX(x) {
                this.x = x;
                return this;
              }
            }, {
              key: "setY",
              value: function setY(y) {
                this.y = y;
                return this;
              }
            }, {
              key: "setZ",
              value: function setZ(z) {
                this.z = z;
                return this;
              }
            }, {
              key: "setW",
              value: function setW(w) {
                this.w = w;
                return this;
              }
            }, {
              key: "setComponent",
              value: function setComponent(index, value) {
                switch (index) {
                  case 0:
                    this.x = value;
                    break;
                  case 1:
                    this.y = value;
                    break;
                  case 2:
                    this.z = value;
                    break;
                  case 3:
                    this.w = value;
                    break;
                  default:
                    throw new Error('index is out of range: ' + index);
                }
                return this;
              }
            }, {
              key: "getComponent",
              value: function getComponent(index) {
                switch (index) {
                  case 0:
                    return this.x;
                  case 1:
                    return this.y;
                  case 2:
                    return this.z;
                  case 3:
                    return this.w;
                  default:
                    throw new Error('index is out of range: ' + index);
                }
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
              }
            }, {
              key: "copy",
              value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                this.w = v.w !== undefined ? v.w : 1;
                return this;
              }
            }, {
              key: "add",
              value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                this.w += v.w;
                return this;
              }
            }, {
              key: "addScalar",
              value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                this.w += s;
                return this;
              }
            }, {
              key: "addVectors",
              value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                this.w = a.w + b.w;
                return this;
              }
            }, {
              key: "addScaledVector",
              value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                this.w += v.w * s;
                return this;
              }
            }, {
              key: "sub",
              value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                this.w -= v.w;
                return this;
              }
            }, {
              key: "subScalar",
              value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                this.w -= s;
                return this;
              }
            }, {
              key: "subVectors",
              value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                this.w = a.w - b.w;
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                this.w *= v.w;
                return this;
              }
            }, {
              key: "multiplyScalar",
              value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                this.w *= scalar;
                return this;
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(m) {
                var x = this.x,
                  y = this.y,
                  z = this.z,
                  w = this.w;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
                this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
                this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
                this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
                return this;
              }
            }, {
              key: "divideScalar",
              value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
              }
            }, {
              key: "setAxisAngleFromQuaternion",
              value: function setAxisAngleFromQuaternion(q) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
                // q is assumed to be normalized
                this.w = 2 * Math.acos(q.w);
                var s = Math.sqrt(1 - q.w * q.w);
                if (s < 0.0001) {
                  this.x = 1;
                  this.y = 0;
                  this.z = 0;
                } else {
                  this.x = q.x / s;
                  this.y = q.y / s;
                  this.z = q.z / s;
                }
                return this;
              }
            }, {
              key: "setAxisAngleFromRotationMatrix",
              value: function setAxisAngleFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var angle, x, y, z; // variables for result
                var epsilon = 0.01,
                  // margin to allow for rounding errors
                  epsilon2 = 0.1,
                  // margin to distinguish between 0 and 180 degrees
                  te = m.elements,
                  m11 = te[0],
                  m12 = te[4],
                  m13 = te[8],
                  m21 = te[1],
                  m22 = te[5],
                  m23 = te[9],
                  m31 = te[2],
                  m32 = te[6],
                  m33 = te[10];
                if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
                  // singularity found
                  // first check for identity matrix which must have +1 for all terms
                  // in leading diagonal and zero in other terms
                  if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                    // this singularity is identity matrix so angle = 0
                    this.set(1, 0, 0, 0);
                    return this; // zero angle, arbitrary axis
                  } // otherwise this singularity is angle = 180
                  angle = Math.PI;
                  var xx = (m11 + 1) / 2;
                  var yy = (m22 + 1) / 2;
                  var zz = (m33 + 1) / 2;
                  var xy = (m12 + m21) / 4;
                  var xz = (m13 + m31) / 4;
                  var yz = (m23 + m32) / 4;
                  if (xx > yy && xx > zz) {
                    // m11 is the largest diagonal term
                    if (xx < epsilon) {
                      x = 0;
                      y = 0.707106781;
                      z = 0.707106781;
                    } else {
                      x = Math.sqrt(xx);
                      y = xy / x;
                      z = xz / x;
                    }
                  } else if (yy > zz) {
                    // m22 is the largest diagonal term
                    if (yy < epsilon) {
                      x = 0.707106781;
                      y = 0;
                      z = 0.707106781;
                    } else {
                      y = Math.sqrt(yy);
                      x = xy / y;
                      z = yz / y;
                    }
                  } else {
                    // m33 is the largest diagonal term so base result on this
                    if (zz < epsilon) {
                      x = 0.707106781;
                      y = 0.707106781;
                      z = 0;
                    } else {
                      z = Math.sqrt(zz);
                      x = xz / z;
                      y = yz / z;
                    }
                  }
                  this.set(x, y, z, angle);
                  return this; // return 180 deg rotation
                } // as we have reached here there are no singularities so we can handle normally
                var s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
                if (Math.abs(s) < 0.001) s = 1; // prevent divide by zero, should not happen if matrix is orthogonal and should be
                // caught by singularity test above, but I've left it in just in case
                this.x = (m32 - m23) / s;
                this.y = (m13 - m31) / s;
                this.z = (m21 - m12) / s;
                this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
                return this;
              }
            }, {
              key: "min",
              value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                this.w = Math.min(this.w, v.w);
                return this;
              }
            }, {
              key: "max",
              value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                this.w = Math.max(this.w, v.w);
                return this;
              }
            }, {
              key: "clamp",
              value: function clamp(min, max) {
                // assumes min < max, componentwise
                this.x = Math.max(min.x, Math.min(max.x, this.x));
                this.y = Math.max(min.y, Math.min(max.y, this.y));
                this.z = Math.max(min.z, Math.min(max.z, this.z));
                this.w = Math.max(min.w, Math.min(max.w, this.w));
                return this;
              }
            }, {
              key: "clampScalar",
              value: function clampScalar(minVal, maxVal) {
                this.x = Math.max(minVal, Math.min(maxVal, this.x));
                this.y = Math.max(minVal, Math.min(maxVal, this.y));
                this.z = Math.max(minVal, Math.min(maxVal, this.z));
                this.w = Math.max(minVal, Math.min(maxVal, this.w));
                return this;
              }
            }, {
              key: "clampLength",
              value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
              }
            }, {
              key: "floor",
              value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                this.w = Math.floor(this.w);
                return this;
              }
            }, {
              key: "ceil",
              value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                this.w = Math.ceil(this.w);
                return this;
              }
            }, {
              key: "round",
              value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                this.w = Math.round(this.w);
                return this;
              }
            }, {
              key: "roundToZero",
              value: function roundToZero() {
                this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
                this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
                this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
                this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
                return this;
              }
            }, {
              key: "negate",
              value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                this.w = -this.w;
                return this;
              }
            }, {
              key: "dot",
              value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
              }
            }, {
              key: "lengthSq",
              value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
              }
            }, {
              key: "length",
              value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
              }
            }, {
              key: "manhattanLength",
              value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
              }
            }, {
              key: "normalize",
              value: function normalize() {
                return this.divideScalar(this.length() || 1);
              }
            }, {
              key: "setLength",
              value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
              }
            }, {
              key: "lerp",
              value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                this.w += (v.w - this.w) * alpha;
                return this;
              }
            }, {
              key: "lerpVectors",
              value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                this.w = v1.w + (v2.w - v1.w) * alpha;
                return this;
              }
            }, {
              key: "equals",
              value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                this.w = array[offset + 3];
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                array[offset + 3] = this.w;
                return array;
              }
            }, {
              key: "fromBufferAttribute",
              value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                this.w = attribute.getW(index);
                return this;
              }
            }, {
              key: "random",
              value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                this.w = Math.random();
                return this;
              }
            }, {
              key: _Symbol$iterator3,
              value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
                return _regeneratorRuntime().wrap(function value$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return this.x;
                    case 2:
                      _context4.next = 4;
                      return this.y;
                    case 4:
                      _context4.next = 6;
                      return this.z;
                    case 6:
                      _context4.next = 8;
                      return this.w;
                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }, value, this);
              })
            }]);
            return _Vector3;
          }(Symbol.iterator);
          /*
          In options, we can specify:
          * Texture parameters for an auto-generated target texture
          * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
          */
          var _WebGLRenderTarget = /*#__PURE__*/function (_EventDispatcher3) {
            _inherits(_WebGLRenderTarget, _EventDispatcher3);
            var _super12 = _createSuper(_WebGLRenderTarget);
            function _WebGLRenderTarget() {
              var _this13;
              var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              _classCallCheck2(this, _WebGLRenderTarget);
              _this13 = _super12.call(this);
              _this13.isWebGLRenderTarget = true;
              _this13.width = width;
              _this13.height = height;
              _this13.depth = 1;
              _this13.scissor = new _Vector3(0, 0, width, height);
              _this13.scissorTest = false;
              _this13.viewport = new _Vector3(0, 0, width, height);
              var image = {
                width: width,
                height: height,
                depth: 1
              };
              _this13.texture = new _Texture(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
              _this13.texture.isRenderTargetTexture = true;
              _this13.texture.flipY = false;
              _this13.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
              _this13.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
              _this13.texture.minFilter = options.minFilter !== undefined ? options.minFilter : _LinearFilter;
              _this13.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
              _this13.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
              _this13.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
              _this13.samples = options.samples !== undefined ? options.samples : 0;
              return _this13;
            }
            _createClass2(_WebGLRenderTarget, [{
              key: "setSize",
              value: function setSize(width, height) {
                var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                if (this.width !== width || this.height !== height || this.depth !== depth) {
                  this.width = width;
                  this.height = height;
                  this.depth = depth;
                  this.texture.image.width = width;
                  this.texture.image.height = height;
                  this.texture.image.depth = depth;
                  this.dispose();
                }
                this.viewport.set(0, 0, width, height);
                this.scissor.set(0, 0, width, height);
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.width = source.width;
                this.height = source.height;
                this.depth = source.depth;
                this.viewport.copy(source.viewport);
                this.texture = source.texture.clone();
                this.texture.isRenderTargetTexture = true; // ensure image object is not shared, see #20328
                var image = Object.assign({}, source.texture.image);
                this.texture.source = new _Source(image);
                this.depthBuffer = source.depthBuffer;
                this.stencilBuffer = source.stencilBuffer;
                if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
                this.samples = source.samples;
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.dispatchEvent({
                  type: 'dispose'
                });
              }
            }]);
            return _WebGLRenderTarget;
          }(_EventDispatcher);
          var _DataArrayTexture = /*#__PURE__*/function (_Texture2) {
            _inherits(_DataArrayTexture, _Texture2);
            var _super13 = _createSuper(_DataArrayTexture);
            function _DataArrayTexture() {
              var _this14;
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              _classCallCheck2(this, _DataArrayTexture);
              _this14 = _super13.call(this, null);
              _this14.isDataArrayTexture = true;
              _this14.image = {
                data: data,
                width: width,
                height: height,
                depth: depth
              };
              _this14.magFilter = _NearestFilter;
              _this14.minFilter = _NearestFilter;
              _this14.wrapR = _ClampToEdgeWrapping;
              _this14.generateMipmaps = false;
              _this14.flipY = false;
              _this14.unpackAlignment = 1;
              return _this14;
            }
            return _createClass2(_DataArrayTexture);
          }(_Texture);
          var _WebGLArrayRenderTarget = /*#__PURE__*/function (_WebGLRenderTarget2) {
            _inherits(_WebGLArrayRenderTarget, _WebGLRenderTarget2);
            var _super14 = _createSuper(_WebGLArrayRenderTarget);
            function _WebGLArrayRenderTarget() {
              var _this15;
              var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              _classCallCheck2(this, _WebGLArrayRenderTarget);
              _this15 = _super14.call(this, width, height);
              _this15.isWebGLArrayRenderTarget = true;
              _this15.depth = depth;
              _this15.texture = new _DataArrayTexture(null, width, height, depth);
              _this15.texture.isRenderTargetTexture = true;
              return _this15;
            }
            return _createClass2(_WebGLArrayRenderTarget);
          }(_WebGLRenderTarget);
          var _Data3DTexture = /*#__PURE__*/function (_Texture3) {
            _inherits(_Data3DTexture, _Texture3);
            var _super15 = _createSuper(_Data3DTexture);
            function _Data3DTexture() {
              var _this16;
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              _classCallCheck2(this, _Data3DTexture);
              // We're going to add .setXXX() methods for setting properties later.
              // Users can still set in DataTexture3D directly.
              //
              //	const texture = new THREE.DataTexture3D( data, width, height, depth );
              // 	texture.anisotropy = 16;
              //
              // See #14839
              _this16 = _super15.call(this, null);
              _this16.isData3DTexture = true;
              _this16.image = {
                data: data,
                width: width,
                height: height,
                depth: depth
              };
              _this16.magFilter = _NearestFilter;
              _this16.minFilter = _NearestFilter;
              _this16.wrapR = _ClampToEdgeWrapping;
              _this16.generateMipmaps = false;
              _this16.flipY = false;
              _this16.unpackAlignment = 1;
              return _this16;
            }
            return _createClass2(_Data3DTexture);
          }(_Texture);
          var _WebGL3DRenderTarget = /*#__PURE__*/function (_WebGLRenderTarget3) {
            _inherits(_WebGL3DRenderTarget, _WebGLRenderTarget3);
            var _super16 = _createSuper(_WebGL3DRenderTarget);
            function _WebGL3DRenderTarget() {
              var _this17;
              var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              _classCallCheck2(this, _WebGL3DRenderTarget);
              _this17 = _super16.call(this, width, height);
              _this17.isWebGL3DRenderTarget = true;
              _this17.depth = depth;
              _this17.texture = new _Data3DTexture(null, width, height, depth);
              _this17.texture.isRenderTargetTexture = true;
              return _this17;
            }
            return _createClass2(_WebGL3DRenderTarget);
          }(_WebGLRenderTarget);
          var _WebGLMultipleRenderTargets = /*#__PURE__*/function (_WebGLRenderTarget4) {
            _inherits(_WebGLMultipleRenderTargets, _WebGLRenderTarget4);
            var _super17 = _createSuper(_WebGLMultipleRenderTargets);
            function _WebGLMultipleRenderTargets() {
              var _this18;
              var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              _classCallCheck2(this, _WebGLMultipleRenderTargets);
              _this18 = _super17.call(this, width, height, options);
              _this18.isWebGLMultipleRenderTargets = true;
              var texture = _this18.texture;
              _this18.texture = [];
              for (var i = 0; i < count; i++) {
                _this18.texture[i] = texture.clone();
                _this18.texture[i].isRenderTargetTexture = true;
              }
              return _this18;
            }
            _createClass2(_WebGLMultipleRenderTargets, [{
              key: "setSize",
              value: function setSize(width, height) {
                var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                if (this.width !== width || this.height !== height || this.depth !== depth) {
                  this.width = width;
                  this.height = height;
                  this.depth = depth;
                  for (var i = 0, il = this.texture.length; i < il; i++) {
                    this.texture[i].image.width = width;
                    this.texture[i].image.height = height;
                    this.texture[i].image.depth = depth;
                  }
                  this.dispose();
                }
                this.viewport.set(0, 0, width, height);
                this.scissor.set(0, 0, width, height);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.dispose();
                this.width = source.width;
                this.height = source.height;
                this.depth = source.depth;
                this.viewport.set(0, 0, this.width, this.height);
                this.scissor.set(0, 0, this.width, this.height);
                this.depthBuffer = source.depthBuffer;
                this.stencilBuffer = source.stencilBuffer;
                if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
                this.texture.length = 0;
                for (var i = 0, il = source.texture.length; i < il; i++) {
                  this.texture[i] = source.texture[i].clone();
                  this.texture[i].isRenderTargetTexture = true;
                }
                return this;
              }
            }]);
            return _WebGLMultipleRenderTargets;
          }(_WebGLRenderTarget);
          var _Quaternion = /*#__PURE__*/function (_Symbol$iterator4) {
            function _Quaternion() {
              var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              _classCallCheck2(this, _Quaternion);
              this.isQuaternion = true;
              this._x = x;
              this._y = y;
              this._z = z;
              this._w = w;
            }
            _createClass2(_Quaternion, [{
              key: "x",
              get: function get() {
                return this._x;
              },
              set: function set(value) {
                this._x = value;
                this._onChangeCallback();
              }
            }, {
              key: "y",
              get: function get() {
                return this._y;
              },
              set: function set(value) {
                this._y = value;
                this._onChangeCallback();
              }
            }, {
              key: "z",
              get: function get() {
                return this._z;
              },
              set: function set(value) {
                this._z = value;
                this._onChangeCallback();
              }
            }, {
              key: "w",
              get: function get() {
                return this._w;
              },
              set: function set(value) {
                this._w = value;
                this._onChangeCallback();
              }
            }, {
              key: "set",
              value: function set(x, y, z, w) {
                this._x = x;
                this._y = y;
                this._z = z;
                this._w = w;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
              }
            }, {
              key: "copy",
              value: function copy(quaternion) {
                this._x = quaternion.x;
                this._y = quaternion.y;
                this._z = quaternion.z;
                this._w = quaternion.w;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "setFromEuler",
              value: function setFromEuler(euler, update) {
                var x = euler._x,
                  y = euler._y,
                  z = euler._z,
                  order = euler._order; // http://www.mathworks.com/matlabcentral/fileexchange/
                // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
                //	content/SpinCalc.m
                var cos = Math.cos;
                var sin = Math.sin;
                var c1 = cos(x / 2);
                var c2 = cos(y / 2);
                var c3 = cos(z / 2);
                var s1 = sin(x / 2);
                var s2 = sin(y / 2);
                var s3 = sin(z / 2);
                switch (order) {
                  case 'XYZ':
                    this._x = s1 * c2 * c3 + c1 * s2 * s3;
                    this._y = c1 * s2 * c3 - s1 * c2 * s3;
                    this._z = c1 * c2 * s3 + s1 * s2 * c3;
                    this._w = c1 * c2 * c3 - s1 * s2 * s3;
                    break;
                  case 'YXZ':
                    this._x = s1 * c2 * c3 + c1 * s2 * s3;
                    this._y = c1 * s2 * c3 - s1 * c2 * s3;
                    this._z = c1 * c2 * s3 - s1 * s2 * c3;
                    this._w = c1 * c2 * c3 + s1 * s2 * s3;
                    break;
                  case 'ZXY':
                    this._x = s1 * c2 * c3 - c1 * s2 * s3;
                    this._y = c1 * s2 * c3 + s1 * c2 * s3;
                    this._z = c1 * c2 * s3 + s1 * s2 * c3;
                    this._w = c1 * c2 * c3 - s1 * s2 * s3;
                    break;
                  case 'ZYX':
                    this._x = s1 * c2 * c3 - c1 * s2 * s3;
                    this._y = c1 * s2 * c3 + s1 * c2 * s3;
                    this._z = c1 * c2 * s3 - s1 * s2 * c3;
                    this._w = c1 * c2 * c3 + s1 * s2 * s3;
                    break;
                  case 'YZX':
                    this._x = s1 * c2 * c3 + c1 * s2 * s3;
                    this._y = c1 * s2 * c3 + s1 * c2 * s3;
                    this._z = c1 * c2 * s3 - s1 * s2 * c3;
                    this._w = c1 * c2 * c3 - s1 * s2 * s3;
                    break;
                  case 'XZY':
                    this._x = s1 * c2 * c3 - c1 * s2 * s3;
                    this._y = c1 * s2 * c3 - s1 * c2 * s3;
                    this._z = c1 * c2 * s3 + s1 * s2 * c3;
                    this._w = c1 * c2 * c3 + s1 * s2 * s3;
                    break;
                  default:
                    console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
                }
                if (update !== false) this._onChangeCallback();
                return this;
              }
            }, {
              key: "setFromAxisAngle",
              value: function setFromAxisAngle(axis, angle) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
                // assumes axis is normalized
                var halfAngle = angle / 2,
                  s = Math.sin(halfAngle);
                this._x = axis.x * s;
                this._y = axis.y * s;
                this._z = axis.z * s;
                this._w = Math.cos(halfAngle);
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "setFromRotationMatrix",
              value: function setFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements,
                  m11 = te[0],
                  m12 = te[4],
                  m13 = te[8],
                  m21 = te[1],
                  m22 = te[5],
                  m23 = te[9],
                  m31 = te[2],
                  m32 = te[6],
                  m33 = te[10],
                  trace = m11 + m22 + m33;
                if (trace > 0) {
                  var s = 0.5 / Math.sqrt(trace + 1.0);
                  this._w = 0.25 / s;
                  this._x = (m32 - m23) * s;
                  this._y = (m13 - m31) * s;
                  this._z = (m21 - m12) * s;
                } else if (m11 > m22 && m11 > m33) {
                  var _s2 = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                  this._w = (m32 - m23) / _s2;
                  this._x = 0.25 * _s2;
                  this._y = (m12 + m21) / _s2;
                  this._z = (m13 + m31) / _s2;
                } else if (m22 > m33) {
                  var _s3 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                  this._w = (m13 - m31) / _s3;
                  this._x = (m12 + m21) / _s3;
                  this._y = 0.25 * _s3;
                  this._z = (m23 + m32) / _s3;
                } else {
                  var _s4 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                  this._w = (m21 - m12) / _s4;
                  this._x = (m13 + m31) / _s4;
                  this._y = (m23 + m32) / _s4;
                  this._z = 0.25 * _s4;
                }
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "setFromUnitVectors",
              value: function setFromUnitVectors(vFrom, vTo) {
                // assumes direction vectors vFrom and vTo are normalized
                var r = vFrom.dot(vTo) + 1;
                if (r < Number.EPSILON) {
                  // vFrom and vTo point in opposite directions
                  r = 0;
                  if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                    this._x = -vFrom.y;
                    this._y = vFrom.x;
                    this._z = 0;
                    this._w = r;
                  } else {
                    this._x = 0;
                    this._y = -vFrom.z;
                    this._z = vFrom.y;
                    this._w = r;
                  }
                } else {
                  // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
                  this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
                  this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
                  this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
                  this._w = r;
                }
                return this.normalize();
              }
            }, {
              key: "angleTo",
              value: function angleTo(q) {
                return 2 * Math.acos(Math.abs(clamp(this.dot(q), -1, 1)));
              }
            }, {
              key: "rotateTowards",
              value: function rotateTowards(q, step) {
                var angle = this.angleTo(q);
                if (angle === 0) return this;
                var t = Math.min(1, step / angle);
                this.slerp(q, t);
                return this;
              }
            }, {
              key: "identity",
              value: function identity() {
                return this.set(0, 0, 0, 1);
              }
            }, {
              key: "invert",
              value: function invert() {
                // quaternion is assumed to have unit length
                return this.conjugate();
              }
            }, {
              key: "conjugate",
              value: function conjugate() {
                this._x *= -1;
                this._y *= -1;
                this._z *= -1;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "dot",
              value: function dot(v) {
                return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
              }
            }, {
              key: "lengthSq",
              value: function lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
              }
            }, {
              key: "length",
              value: function length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
              }
            }, {
              key: "normalize",
              value: function normalize() {
                var l = this.length();
                if (l === 0) {
                  this._x = 0;
                  this._y = 0;
                  this._z = 0;
                  this._w = 1;
                } else {
                  l = 1 / l;
                  this._x = this._x * l;
                  this._y = this._y * l;
                  this._z = this._z * l;
                  this._w = this._w * l;
                }
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(q) {
                return this.multiplyQuaternions(this, q);
              }
            }, {
              key: "premultiply",
              value: function premultiply(q) {
                return this.multiplyQuaternions(q, this);
              }
            }, {
              key: "multiplyQuaternions",
              value: function multiplyQuaternions(a, b) {
                // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
                var qax = a._x,
                  qay = a._y,
                  qaz = a._z,
                  qaw = a._w;
                var qbx = b._x,
                  qby = b._y,
                  qbz = b._z,
                  qbw = b._w;
                this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
                this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
                this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
                this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "slerp",
              value: function slerp(qb, t) {
                if (t === 0) return this;
                if (t === 1) return this.copy(qb);
                var x = this._x,
                  y = this._y,
                  z = this._z,
                  w = this._w; // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
                var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
                if (cosHalfTheta < 0) {
                  this._w = -qb._w;
                  this._x = -qb._x;
                  this._y = -qb._y;
                  this._z = -qb._z;
                  cosHalfTheta = -cosHalfTheta;
                } else {
                  this.copy(qb);
                }
                if (cosHalfTheta >= 1.0) {
                  this._w = w;
                  this._x = x;
                  this._y = y;
                  this._z = z;
                  return this;
                }
                var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
                if (sqrSinHalfTheta <= Number.EPSILON) {
                  var s = 1 - t;
                  this._w = s * w + t * this._w;
                  this._x = s * x + t * this._x;
                  this._y = s * y + t * this._y;
                  this._z = s * z + t * this._z;
                  this.normalize();
                  this._onChangeCallback();
                  return this;
                }
                var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
                var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
                var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta,
                  ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
                this._w = w * ratioA + this._w * ratioB;
                this._x = x * ratioA + this._x * ratioB;
                this._y = y * ratioA + this._y * ratioB;
                this._z = z * ratioA + this._z * ratioB;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "slerpQuaternions",
              value: function slerpQuaternions(qa, qb, t) {
                return this.copy(qa).slerp(qb, t);
              }
            }, {
              key: "random",
              value: function random() {
                // Derived from http://planning.cs.uiuc.edu/node198.html
                // Note, this source uses w, x, y, z ordering,
                // so we swap the order below.
                var u1 = Math.random();
                var sqrt1u1 = Math.sqrt(1 - u1);
                var sqrtu1 = Math.sqrt(u1);
                var u2 = 2 * Math.PI * Math.random();
                var u3 = 2 * Math.PI * Math.random();
                return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
              }
            }, {
              key: "equals",
              value: function equals(quaternion) {
                return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this._x = array[offset];
                this._y = array[offset + 1];
                this._z = array[offset + 2];
                this._w = array[offset + 3];
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._w;
                return array;
              }
            }, {
              key: "fromBufferAttribute",
              value: function fromBufferAttribute(attribute, index) {
                this._x = attribute.getX(index);
                this._y = attribute.getY(index);
                this._z = attribute.getZ(index);
                this._w = attribute.getW(index);
                return this;
              }
            }, {
              key: "_onChange",
              value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
              }
            }, {
              key: "_onChangeCallback",
              value: function _onChangeCallback() {}
            }, {
              key: _Symbol$iterator4,
              value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
                return _regeneratorRuntime().wrap(function value$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return this._x;
                    case 2:
                      _context5.next = 4;
                      return this._y;
                    case 4:
                      _context5.next = 6;
                      return this._z;
                    case 6:
                      _context5.next = 8;
                      return this._w;
                    case 8:
                    case "end":
                      return _context5.stop();
                  }
                }, value, this);
              })
            }], [{
              key: "slerpFlat",
              value: function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
                // fuzz-free, array-based Quaternion SLERP operation
                var x0 = src0[srcOffset0 + 0],
                  y0 = src0[srcOffset0 + 1],
                  z0 = src0[srcOffset0 + 2],
                  w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1 + 0],
                  y1 = src1[srcOffset1 + 1],
                  z1 = src1[srcOffset1 + 2],
                  w1 = src1[srcOffset1 + 3];
                if (t === 0) {
                  dst[dstOffset + 0] = x0;
                  dst[dstOffset + 1] = y0;
                  dst[dstOffset + 2] = z0;
                  dst[dstOffset + 3] = w0;
                  return;
                }
                if (t === 1) {
                  dst[dstOffset + 0] = x1;
                  dst[dstOffset + 1] = y1;
                  dst[dstOffset + 2] = z1;
                  dst[dstOffset + 3] = w1;
                  return;
                }
                if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
                  var s = 1 - t;
                  var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
                    dir = cos >= 0 ? 1 : -1,
                    sqrSin = 1 - cos * cos; // Skip the Slerp for tiny steps to avoid numeric problems:
                  if (sqrSin > Number.EPSILON) {
                    var sin = Math.sqrt(sqrSin),
                      len = Math.atan2(sin, cos * dir);
                    s = Math.sin(s * len) / sin;
                    t = Math.sin(t * len) / sin;
                  }
                  var tDir = t * dir;
                  x0 = x0 * s + x1 * tDir;
                  y0 = y0 * s + y1 * tDir;
                  z0 = z0 * s + z1 * tDir;
                  w0 = w0 * s + w1 * tDir; // Normalize in case we just did a lerp:
                  if (s === 1 - t) {
                    var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                    x0 *= f;
                    y0 *= f;
                    z0 *= f;
                    w0 *= f;
                  }
                }
                dst[dstOffset] = x0;
                dst[dstOffset + 1] = y0;
                dst[dstOffset + 2] = z0;
                dst[dstOffset + 3] = w0;
              }
            }, {
              key: "multiplyQuaternionsFlat",
              value: function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
                var x0 = src0[srcOffset0];
                var y0 = src0[srcOffset0 + 1];
                var z0 = src0[srcOffset0 + 2];
                var w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1];
                var y1 = src1[srcOffset1 + 1];
                var z1 = src1[srcOffset1 + 2];
                var w1 = src1[srcOffset1 + 3];
                dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
                dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
                dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
                dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
                return dst;
              }
            }]);
            return _Quaternion;
          }(Symbol.iterator);
          var _Vector2 = /*#__PURE__*/function (_Symbol$iterator5) {
            function _Vector2() {
              var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              _classCallCheck2(this, _Vector2);
              _Vector2.prototype.isVector3 = true;
              this.x = x;
              this.y = y;
              this.z = z;
            }
            _createClass2(_Vector2, [{
              key: "set",
              value: function set(x, y, z) {
                if (z === undefined) z = this.z; // sprite.scale.set(x,y)
                this.x = x;
                this.y = y;
                this.z = z;
                return this;
              }
            }, {
              key: "setScalar",
              value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                return this;
              }
            }, {
              key: "setX",
              value: function setX(x) {
                this.x = x;
                return this;
              }
            }, {
              key: "setY",
              value: function setY(y) {
                this.y = y;
                return this;
              }
            }, {
              key: "setZ",
              value: function setZ(z) {
                this.z = z;
                return this;
              }
            }, {
              key: "setComponent",
              value: function setComponent(index, value) {
                switch (index) {
                  case 0:
                    this.x = value;
                    break;
                  case 1:
                    this.y = value;
                    break;
                  case 2:
                    this.z = value;
                    break;
                  default:
                    throw new Error('index is out of range: ' + index);
                }
                return this;
              }
            }, {
              key: "getComponent",
              value: function getComponent(index) {
                switch (index) {
                  case 0:
                    return this.x;
                  case 1:
                    return this.y;
                  case 2:
                    return this.z;
                  default:
                    throw new Error('index is out of range: ' + index);
                }
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this.x, this.y, this.z);
              }
            }, {
              key: "copy",
              value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                return this;
              }
            }, {
              key: "add",
              value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                return this;
              }
            }, {
              key: "addScalar",
              value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                return this;
              }
            }, {
              key: "addVectors",
              value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                return this;
              }
            }, {
              key: "addScaledVector",
              value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                return this;
              }
            }, {
              key: "sub",
              value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                return this;
              }
            }, {
              key: "subScalar",
              value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                return this;
              }
            }, {
              key: "subVectors",
              value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                return this;
              }
            }, {
              key: "multiplyScalar",
              value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                return this;
              }
            }, {
              key: "multiplyVectors",
              value: function multiplyVectors(a, b) {
                this.x = a.x * b.x;
                this.y = a.y * b.y;
                this.z = a.z * b.z;
                return this;
              }
            }, {
              key: "applyEuler",
              value: function applyEuler(euler) {
                return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
              }
            }, {
              key: "applyAxisAngle",
              value: function applyAxisAngle(axis, angle) {
                return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
              }
            }, {
              key: "applyMatrix3",
              value: function applyMatrix3(m) {
                var x = this.x,
                  y = this.y,
                  z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6] * z;
                this.y = e[1] * x + e[4] * y + e[7] * z;
                this.z = e[2] * x + e[5] * y + e[8] * z;
                return this;
              }
            }, {
              key: "applyNormalMatrix",
              value: function applyNormalMatrix(m) {
                return this.applyMatrix3(m).normalize();
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(m) {
                var x = this.x,
                  y = this.y,
                  z = this.z;
                var e = m.elements;
                var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
                this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
                this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
                this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
                return this;
              }
            }, {
              key: "applyQuaternion",
              value: function applyQuaternion(q) {
                var x = this.x,
                  y = this.y,
                  z = this.z;
                var qx = q.x,
                  qy = q.y,
                  qz = q.z,
                  qw = q.w; // calculate quat * vector
                var ix = qw * x + qy * z - qz * y;
                var iy = qw * y + qz * x - qx * z;
                var iz = qw * z + qx * y - qy * x;
                var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
                this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                return this;
              }
            }, {
              key: "project",
              value: function project(camera) {
                return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
              }
            }, {
              key: "unproject",
              value: function unproject(camera) {
                return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
              }
            }, {
              key: "transformDirection",
              value: function transformDirection(m) {
                // input: THREE.Matrix4 affine matrix
                // vector interpreted as a direction
                var x = this.x,
                  y = this.y,
                  z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z;
                this.y = e[1] * x + e[5] * y + e[9] * z;
                this.z = e[2] * x + e[6] * y + e[10] * z;
                return this.normalize();
              }
            }, {
              key: "divide",
              value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                this.z /= v.z;
                return this;
              }
            }, {
              key: "divideScalar",
              value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
              }
            }, {
              key: "min",
              value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                return this;
              }
            }, {
              key: "max",
              value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                return this;
              }
            }, {
              key: "clamp",
              value: function clamp(min, max) {
                // assumes min < max, componentwise
                this.x = Math.max(min.x, Math.min(max.x, this.x));
                this.y = Math.max(min.y, Math.min(max.y, this.y));
                this.z = Math.max(min.z, Math.min(max.z, this.z));
                return this;
              }
            }, {
              key: "clampScalar",
              value: function clampScalar(minVal, maxVal) {
                this.x = Math.max(minVal, Math.min(maxVal, this.x));
                this.y = Math.max(minVal, Math.min(maxVal, this.y));
                this.z = Math.max(minVal, Math.min(maxVal, this.z));
                return this;
              }
            }, {
              key: "clampLength",
              value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
              }
            }, {
              key: "floor",
              value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                return this;
              }
            }, {
              key: "ceil",
              value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                return this;
              }
            }, {
              key: "round",
              value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                return this;
              }
            }, {
              key: "roundToZero",
              value: function roundToZero() {
                this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
                this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
                this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
                return this;
              }
            }, {
              key: "negate",
              value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                return this;
              }
            }, {
              key: "dot",
              value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z;
              } // TODO lengthSquared?
            }, {
              key: "lengthSq",
              value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
              }
            }, {
              key: "length",
              value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
              }
            }, {
              key: "manhattanLength",
              value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
              }
            }, {
              key: "normalize",
              value: function normalize() {
                return this.divideScalar(this.length() || 1);
              }
            }, {
              key: "setLength",
              value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
              }
            }, {
              key: "lerp",
              value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                return this;
              }
            }, {
              key: "lerpVectors",
              value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                return this;
              }
            }, {
              key: "cross",
              value: function cross(v) {
                return this.crossVectors(this, v);
              }
            }, {
              key: "crossVectors",
              value: function crossVectors(a, b) {
                var ax = a.x,
                  ay = a.y,
                  az = a.z;
                var bx = b.x,
                  by = b.y,
                  bz = b.z;
                this.x = ay * bz - az * by;
                this.y = az * bx - ax * bz;
                this.z = ax * by - ay * bx;
                return this;
              }
            }, {
              key: "projectOnVector",
              value: function projectOnVector(v) {
                var denominator = v.lengthSq();
                if (denominator === 0) return this.set(0, 0, 0);
                var scalar = v.dot(this) / denominator;
                return this.copy(v).multiplyScalar(scalar);
              }
            }, {
              key: "projectOnPlane",
              value: function projectOnPlane(planeNormal) {
                _vector$c.copy(this).projectOnVector(planeNormal);
                return this.sub(_vector$c);
              }
            }, {
              key: "reflect",
              value: function reflect(normal) {
                // reflect incident vector off plane orthogonal to normal
                // normal is assumed to have unit length
                return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
              }
            }, {
              key: "angleTo",
              value: function angleTo(v) {
                var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
                if (denominator === 0) return Math.PI / 2;
                var theta = this.dot(v) / denominator; // clamp, to handle numerical problems
                return Math.acos(clamp(theta, -1, 1));
              }
            }, {
              key: "distanceTo",
              value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
              }
            }, {
              key: "distanceToSquared",
              value: function distanceToSquared(v) {
                var dx = this.x - v.x,
                  dy = this.y - v.y,
                  dz = this.z - v.z;
                return dx * dx + dy * dy + dz * dz;
              }
            }, {
              key: "manhattanDistanceTo",
              value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
              }
            }, {
              key: "setFromSpherical",
              value: function setFromSpherical(s) {
                return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
              }
            }, {
              key: "setFromSphericalCoords",
              value: function setFromSphericalCoords(radius, phi, theta) {
                var sinPhiRadius = Math.sin(phi) * radius;
                this.x = sinPhiRadius * Math.sin(theta);
                this.y = Math.cos(phi) * radius;
                this.z = sinPhiRadius * Math.cos(theta);
                return this;
              }
            }, {
              key: "setFromCylindrical",
              value: function setFromCylindrical(c) {
                return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
              }
            }, {
              key: "setFromCylindricalCoords",
              value: function setFromCylindricalCoords(radius, theta, y) {
                this.x = radius * Math.sin(theta);
                this.y = y;
                this.z = radius * Math.cos(theta);
                return this;
              }
            }, {
              key: "setFromMatrixPosition",
              value: function setFromMatrixPosition(m) {
                var e = m.elements;
                this.x = e[12];
                this.y = e[13];
                this.z = e[14];
                return this;
              }
            }, {
              key: "setFromMatrixScale",
              value: function setFromMatrixScale(m) {
                var sx = this.setFromMatrixColumn(m, 0).length();
                var sy = this.setFromMatrixColumn(m, 1).length();
                var sz = this.setFromMatrixColumn(m, 2).length();
                this.x = sx;
                this.y = sy;
                this.z = sz;
                return this;
              }
            }, {
              key: "setFromMatrixColumn",
              value: function setFromMatrixColumn(m, index) {
                return this.fromArray(m.elements, index * 4);
              }
            }, {
              key: "setFromMatrix3Column",
              value: function setFromMatrix3Column(m, index) {
                return this.fromArray(m.elements, index * 3);
              }
            }, {
              key: "setFromEuler",
              value: function setFromEuler(e) {
                this.x = e._x;
                this.y = e._y;
                this.z = e._z;
                return this;
              }
            }, {
              key: "equals",
              value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                return array;
              }
            }, {
              key: "fromBufferAttribute",
              value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                return this;
              }
            }, {
              key: "random",
              value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                return this;
              }
            }, {
              key: "randomDirection",
              value: function randomDirection() {
                // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
                var u = (Math.random() - 0.5) * 2;
                var t = Math.random() * Math.PI * 2;
                var f = Math.sqrt(1 - Math.pow(u, 2));
                this.x = f * Math.cos(t);
                this.y = f * Math.sin(t);
                this.z = u;
                return this;
              }
            }, {
              key: _Symbol$iterator5,
              value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
                return _regeneratorRuntime().wrap(function value$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return this.x;
                    case 2:
                      _context6.next = 4;
                      return this.y;
                    case 4:
                      _context6.next = 6;
                      return this.z;
                    case 6:
                    case "end":
                      return _context6.stop();
                  }
                }, value, this);
              })
            }]);
            return _Vector2;
          }(Symbol.iterator);
          var _vector$c = /*@__PURE__*/new _Vector2();
          var _quaternion$4 = /*@__PURE__*/new _Quaternion();
          var _Box2 = /*#__PURE__*/function () {
            function _Box2() {
              var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2(+Infinity, +Infinity, +Infinity);
              var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2(-Infinity, -Infinity, -Infinity);
              _classCallCheck2(this, _Box2);
              this.isBox3 = true;
              this.min = min;
              this.max = max;
            }
            _createClass2(_Box2, [{
              key: "set",
              value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
              }
            }, {
              key: "setFromArray",
              value: function setFromArray(array) {
                var minX = +Infinity;
                var minY = +Infinity;
                var minZ = +Infinity;
                var maxX = -Infinity;
                var maxY = -Infinity;
                var maxZ = -Infinity;
                for (var i = 0, l = array.length; i < l; i += 3) {
                  var x = array[i];
                  var y = array[i + 1];
                  var z = array[i + 2];
                  if (x < minX) minX = x;
                  if (y < minY) minY = y;
                  if (z < minZ) minZ = z;
                  if (x > maxX) maxX = x;
                  if (y > maxY) maxY = y;
                  if (z > maxZ) maxZ = z;
                }
                this.min.set(minX, minY, minZ);
                this.max.set(maxX, maxY, maxZ);
                return this;
              }
            }, {
              key: "setFromBufferAttribute",
              value: function setFromBufferAttribute(attribute) {
                var minX = +Infinity;
                var minY = +Infinity;
                var minZ = +Infinity;
                var maxX = -Infinity;
                var maxY = -Infinity;
                var maxZ = -Infinity;
                for (var i = 0, l = attribute.count; i < l; i++) {
                  var x = attribute.getX(i);
                  var y = attribute.getY(i);
                  var z = attribute.getZ(i);
                  if (x < minX) minX = x;
                  if (y < minY) minY = y;
                  if (z < minZ) minZ = z;
                  if (x > maxX) maxX = x;
                  if (y > maxY) maxY = y;
                  if (z > maxZ) maxZ = z;
                }
                this.min.set(minX, minY, minZ);
                this.max.set(maxX, maxY, maxZ);
                return this;
              }
            }, {
              key: "setFromPoints",
              value: function setFromPoints(points) {
                this.makeEmpty();
                for (var i = 0, il = points.length; i < il; i++) {
                  this.expandByPoint(points[i]);
                }
                return this;
              }
            }, {
              key: "setFromCenterAndSize",
              value: function setFromCenterAndSize(center, size) {
                var halfSize = _vector$b.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
              }
            }, {
              key: "setFromObject",
              value: function setFromObject(object) {
                var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                this.makeEmpty();
                return this.expandByObject(object, precise);
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
              }
            }, {
              key: "makeEmpty",
              value: function makeEmpty() {
                this.min.x = this.min.y = this.min.z = +Infinity;
                this.max.x = this.max.y = this.max.z = -Infinity;
                return this;
              }
            }, {
              key: "isEmpty",
              value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
              }
            }, {
              key: "getCenter",
              value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
              }
            }, {
              key: "getSize",
              value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
              }
            }, {
              key: "expandByPoint",
              value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
              }
            }, {
              key: "expandByVector",
              value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
              }
            }, {
              key: "expandByScalar",
              value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
              }
            }, {
              key: "expandByObject",
              value: function expandByObject(object) {
                var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                // Computes the world-axis-aligned bounding box of an object (including its children),
                // accounting for both the object's, and children's, world transforms
                object.updateWorldMatrix(false, false);
                var geometry = object.geometry;
                if (geometry !== undefined) {
                  if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
                    var position = geometry.attributes.position;
                    for (var i = 0, l = position.count; i < l; i++) {
                      _vector$b.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                      this.expandByPoint(_vector$b);
                    }
                  } else {
                    if (geometry.boundingBox === null) {
                      geometry.computeBoundingBox();
                    }
                    _box$3.copy(geometry.boundingBox);
                    _box$3.applyMatrix4(object.matrixWorld);
                    this.union(_box$3);
                  }
                }
                var children = object.children;
                for (var _i3 = 0, _l = children.length; _i3 < _l; _i3++) {
                  this.expandByObject(children[_i3], precise);
                }
                return this;
              }
            }, {
              key: "containsPoint",
              value: function containsPoint(point) {
                return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
              }
            }, {
              key: "containsBox",
              value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
              }
            }, {
              key: "getParameter",
              value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                // using 6 splitting planes to rule out intersections.
                return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
              }
            }, {
              key: "intersectsSphere",
              value: function intersectsSphere(sphere) {
                // Find the point on the AABB closest to the sphere center.
                this.clampPoint(sphere.center, _vector$b); // If that point is inside the sphere, the AABB and sphere intersect.
                return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
              }
            }, {
              key: "intersectsPlane",
              value: function intersectsPlane(plane) {
                // We compute the minimum and maximum dot product values. If those values
                // are on the same side (back or front) of the plane, then there is no intersection.
                var min, max;
                if (plane.normal.x > 0) {
                  min = plane.normal.x * this.min.x;
                  max = plane.normal.x * this.max.x;
                } else {
                  min = plane.normal.x * this.max.x;
                  max = plane.normal.x * this.min.x;
                }
                if (plane.normal.y > 0) {
                  min += plane.normal.y * this.min.y;
                  max += plane.normal.y * this.max.y;
                } else {
                  min += plane.normal.y * this.max.y;
                  max += plane.normal.y * this.min.y;
                }
                if (plane.normal.z > 0) {
                  min += plane.normal.z * this.min.z;
                  max += plane.normal.z * this.max.z;
                } else {
                  min += plane.normal.z * this.max.z;
                  max += plane.normal.z * this.min.z;
                }
                return min <= -plane.constant && max >= -plane.constant;
              }
            }, {
              key: "intersectsTriangle",
              value: function intersectsTriangle(triangle) {
                if (this.isEmpty()) {
                  return false;
                } // compute box center and extents
                this.getCenter(_center);
                _extents.subVectors(this.max, _center); // translate triangle to aabb origin
                _v0$2.subVectors(triangle.a, _center);
                _v1$7.subVectors(triangle.b, _center);
                _v2$4.subVectors(triangle.c, _center); // compute edge vectors for triangle
                _f0.subVectors(_v1$7, _v0$2);
                _f1.subVectors(_v2$4, _v1$7);
                _f2.subVectors(_v0$2, _v2$4); // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
                // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
                // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
                var axes = [0, -_f0.z, _f0.y, 0, -_f1.z, _f1.y, 0, -_f2.z, _f2.y, _f0.z, 0, -_f0.x, _f1.z, 0, -_f1.x, _f2.z, 0, -_f2.x, -_f0.y, _f0.x, 0, -_f1.y, _f1.x, 0, -_f2.y, _f2.x, 0];
                if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
                  return false;
                } // test 3 face normals from the aabb
                axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
                if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
                  return false;
                } // finally testing the face normal of the triangle
                // use already existing triangle edge vectors here
                _triangleNormal.crossVectors(_f0, _f1);
                axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
                return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
              }
            }, {
              key: "clampPoint",
              value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
              }
            }, {
              key: "distanceToPoint",
              value: function distanceToPoint(point) {
                var clampedPoint = _vector$b.copy(point).clamp(this.min, this.max);
                return clampedPoint.sub(point).length();
              }
            }, {
              key: "getBoundingSphere",
              value: function getBoundingSphere(target) {
                this.getCenter(target.center);
                target.radius = this.getSize(_vector$b).length() * 0.5;
                return target;
              }
            }, {
              key: "intersect",
              value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max); // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
                if (this.isEmpty()) this.makeEmpty();
                return this;
              }
            }, {
              key: "union",
              value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix) {
                // transform of empty box is an empty box.
                if (this.isEmpty()) return this; // NOTE: I am using a binary pattern to specify all 2^3 combinations below
                _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
                _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
                _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
                _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
                _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
                _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
                _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
                _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
                this.setFromPoints(_points);
                return this;
              }
            }, {
              key: "translate",
              value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
              }
            }, {
              key: "equals",
              value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
              }
            }]);
            return _Box2;
          }();
          var _points = [/*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2(), /*@__PURE__*/new _Vector2()];
          var _vector$b = /*@__PURE__*/new _Vector2();
          var _box$3 = /*@__PURE__*/new _Box2(); // triangle centered vertices
          var _v0$2 = /*@__PURE__*/new _Vector2();
          var _v1$7 = /*@__PURE__*/new _Vector2();
          var _v2$4 = /*@__PURE__*/new _Vector2(); // triangle edge vectors
          var _f0 = /*@__PURE__*/new _Vector2();
          var _f1 = /*@__PURE__*/new _Vector2();
          var _f2 = /*@__PURE__*/new _Vector2();
          var _center = /*@__PURE__*/new _Vector2();
          var _extents = /*@__PURE__*/new _Vector2();
          var _triangleNormal = /*@__PURE__*/new _Vector2();
          var _testAxis = /*@__PURE__*/new _Vector2();
          function satForAxes(axes, v0, v1, v2, extents) {
            for (var i = 0, j = axes.length - 3; i <= j; i += 3) {
              _testAxis.fromArray(axes, i); // project the aabb onto the separating axis
              var r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z); // project all 3 vertices of the triangle onto the separating axis
              var p0 = v0.dot(_testAxis);
              var p1 = v1.dot(_testAxis);
              var p2 = v2.dot(_testAxis); // actual test, basically see if either of the most extreme of the triangle points intersects r
              if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) {
                // points of the projected triangle are outside the projected half-length of the aabb
                // the axis is separating and we can exit
                return false;
              }
            }
            return true;
          }
          var _box$2 = /*@__PURE__*/new _Box2();
          var _v1$6 = /*@__PURE__*/new _Vector2();
          var _v2$3 = /*@__PURE__*/new _Vector2();
          var _Sphere = /*#__PURE__*/function () {
            function _Sphere() {
              var center = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
              _classCallCheck2(this, _Sphere);
              this.center = center;
              this.radius = radius;
            }
            _createClass2(_Sphere, [{
              key: "set",
              value: function set(center, radius) {
                this.center.copy(center);
                this.radius = radius;
                return this;
              }
            }, {
              key: "setFromPoints",
              value: function setFromPoints(points, optionalCenter) {
                var center = this.center;
                if (optionalCenter !== undefined) {
                  center.copy(optionalCenter);
                } else {
                  _box$2.setFromPoints(points).getCenter(center);
                }
                var maxRadiusSq = 0;
                for (var i = 0, il = points.length; i < il; i++) {
                  maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
                }
                this.radius = Math.sqrt(maxRadiusSq);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(sphere) {
                this.center.copy(sphere.center);
                this.radius = sphere.radius;
                return this;
              }
            }, {
              key: "isEmpty",
              value: function isEmpty() {
                return this.radius < 0;
              }
            }, {
              key: "makeEmpty",
              value: function makeEmpty() {
                this.center.set(0, 0, 0);
                this.radius = -1;
                return this;
              }
            }, {
              key: "containsPoint",
              value: function containsPoint(point) {
                return point.distanceToSquared(this.center) <= this.radius * this.radius;
              }
            }, {
              key: "distanceToPoint",
              value: function distanceToPoint(point) {
                return point.distanceTo(this.center) - this.radius;
              }
            }, {
              key: "intersectsSphere",
              value: function intersectsSphere(sphere) {
                var radiusSum = this.radius + sphere.radius;
                return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                return box.intersectsSphere(this);
              }
            }, {
              key: "intersectsPlane",
              value: function intersectsPlane(plane) {
                return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
              }
            }, {
              key: "clampPoint",
              value: function clampPoint(point, target) {
                var deltaLengthSq = this.center.distanceToSquared(point);
                target.copy(point);
                if (deltaLengthSq > this.radius * this.radius) {
                  target.sub(this.center).normalize();
                  target.multiplyScalar(this.radius).add(this.center);
                }
                return target;
              }
            }, {
              key: "getBoundingBox",
              value: function getBoundingBox(target) {
                if (this.isEmpty()) {
                  // Empty sphere produces empty bounding box
                  target.makeEmpty();
                  return target;
                }
                target.set(this.center, this.center);
                target.expandByScalar(this.radius);
                return target;
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix) {
                this.center.applyMatrix4(matrix);
                this.radius = this.radius * matrix.getMaxScaleOnAxis();
                return this;
              }
            }, {
              key: "translate",
              value: function translate(offset) {
                this.center.add(offset);
                return this;
              }
            }, {
              key: "expandByPoint",
              value: function expandByPoint(point) {
                if (this.isEmpty()) {
                  this.center.copy(point);
                  this.radius = 0;
                  return this;
                }
                _v1$6.subVectors(point, this.center);
                var lengthSq = _v1$6.lengthSq();
                if (lengthSq > this.radius * this.radius) {
                  // calculate the minimal sphere
                  var length = Math.sqrt(lengthSq);
                  var delta = (length - this.radius) * 0.5;
                  this.center.addScaledVector(_v1$6, delta / length);
                  this.radius += delta;
                }
                return this;
              }
            }, {
              key: "union",
              value: function union(sphere) {
                if (sphere.isEmpty()) {
                  return this;
                }
                if (this.isEmpty()) {
                  this.copy(sphere);
                  return this;
                }
                if (this.center.equals(sphere.center) === true) {
                  this.radius = Math.max(this.radius, sphere.radius);
                } else {
                  _v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
                  this.expandByPoint(_v1$6.copy(sphere.center).add(_v2$3));
                  this.expandByPoint(_v1$6.copy(sphere.center).sub(_v2$3));
                }
                return this;
              }
            }, {
              key: "equals",
              value: function equals(sphere) {
                return sphere.center.equals(this.center) && sphere.radius === this.radius;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Sphere;
          }();
          var _vector$a = /*@__PURE__*/new _Vector2();
          var _segCenter = /*@__PURE__*/new _Vector2();
          var _segDir = /*@__PURE__*/new _Vector2();
          var _diff = /*@__PURE__*/new _Vector2();
          var _edge1 = /*@__PURE__*/new _Vector2();
          var _edge2 = /*@__PURE__*/new _Vector2();
          var _normal$1 = /*@__PURE__*/new _Vector2();
          var _Ray = /*#__PURE__*/function () {
            function _Ray() {
              var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2(0, 0, -1);
              _classCallCheck2(this, _Ray);
              this.origin = origin;
              this.direction = direction;
            }
            _createClass2(_Ray, [{
              key: "set",
              value: function set(origin, direction) {
                this.origin.copy(origin);
                this.direction.copy(direction);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(ray) {
                this.origin.copy(ray.origin);
                this.direction.copy(ray.direction);
                return this;
              }
            }, {
              key: "at",
              value: function at(t, target) {
                return target.copy(this.direction).multiplyScalar(t).add(this.origin);
              }
            }, {
              key: "lookAt",
              value: function lookAt(v) {
                this.direction.copy(v).sub(this.origin).normalize();
                return this;
              }
            }, {
              key: "recast",
              value: function recast(t) {
                this.origin.copy(this.at(t, _vector$a));
                return this;
              }
            }, {
              key: "closestPointToPoint",
              value: function closestPointToPoint(point, target) {
                target.subVectors(point, this.origin);
                var directionDistance = target.dot(this.direction);
                if (directionDistance < 0) {
                  return target.copy(this.origin);
                }
                return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
              }
            }, {
              key: "distanceToPoint",
              value: function distanceToPoint(point) {
                return Math.sqrt(this.distanceSqToPoint(point));
              }
            }, {
              key: "distanceSqToPoint",
              value: function distanceSqToPoint(point) {
                var directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction); // point behind the ray
                if (directionDistance < 0) {
                  return this.origin.distanceToSquared(point);
                }
                _vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
                return _vector$a.distanceToSquared(point);
              }
            }, {
              key: "distanceSqToSegment",
              value: function distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
                // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
                // It returns the min distance between the ray and the segment
                // defined by v0 and v1
                // It can also set two optional targets :
                // - The closest point on the ray
                // - The closest point on the segment
                _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
                _segDir.copy(v1).sub(v0).normalize();
                _diff.copy(this.origin).sub(_segCenter);
                var segExtent = v0.distanceTo(v1) * 0.5;
                var a01 = -this.direction.dot(_segDir);
                var b0 = _diff.dot(this.direction);
                var b1 = -_diff.dot(_segDir);
                var c = _diff.lengthSq();
                var det = Math.abs(1 - a01 * a01);
                var s0, s1, sqrDist, extDet;
                if (det > 0) {
                  // The ray and segment are not parallel.
                  s0 = a01 * b1 - b0;
                  s1 = a01 * b0 - b1;
                  extDet = segExtent * det;
                  if (s0 >= 0) {
                    if (s1 >= -extDet) {
                      if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        var invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                      } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                      }
                    } else {
                      // region 5
                      s1 = -segExtent;
                      s0 = Math.max(0, -(a01 * s1 + b0));
                      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                  } else {
                    if (s1 <= -extDet) {
                      // region 4
                      s0 = Math.max(0, -(-a01 * segExtent + b0));
                      s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    } else if (s1 <= extDet) {
                      // region 3
                      s0 = 0;
                      s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                      sqrDist = s1 * (s1 + 2 * b1) + c;
                    } else {
                      // region 2
                      s0 = Math.max(0, -(a01 * segExtent + b0));
                      s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                  }
                } else {
                  // Ray and segment are parallel.
                  s1 = a01 > 0 ? -segExtent : segExtent;
                  s0 = Math.max(0, -(a01 * s1 + b0));
                  sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
                if (optionalPointOnRay) {
                  optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
                }
                if (optionalPointOnSegment) {
                  optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
                }
                return sqrDist;
              }
            }, {
              key: "intersectSphere",
              value: function intersectSphere(sphere, target) {
                _vector$a.subVectors(sphere.center, this.origin);
                var tca = _vector$a.dot(this.direction);
                var d2 = _vector$a.dot(_vector$a) - tca * tca;
                var radius2 = sphere.radius * sphere.radius;
                if (d2 > radius2) return null;
                var thc = Math.sqrt(radius2 - d2); // t0 = first intersect point - entrance on front of sphere
                var t0 = tca - thc; // t1 = second intersect point - exit point on back of sphere
                var t1 = tca + thc; // test to see if both t0 and t1 are behind the ray - if so, return null
                if (t0 < 0 && t1 < 0) return null; // test to see if t0 is behind the ray:
                // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
                // in order to always return an intersect point that is in front of the ray.
                if (t0 < 0) return this.at(t1, target); // else t0 is in front of the ray, so return the first collision point scaled by t0
                return this.at(t0, target);
              }
            }, {
              key: "intersectsSphere",
              value: function intersectsSphere(sphere) {
                return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
              }
            }, {
              key: "distanceToPlane",
              value: function distanceToPlane(plane) {
                var denominator = plane.normal.dot(this.direction);
                if (denominator === 0) {
                  // line is coplanar, return origin
                  if (plane.distanceToPoint(this.origin) === 0) {
                    return 0;
                  } // Null is preferable to undefined since undefined means.... it is undefined
                  return null;
                }
                var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator; // Return if the ray never intersects the plane
                return t >= 0 ? t : null;
              }
            }, {
              key: "intersectPlane",
              value: function intersectPlane(plane, target) {
                var t = this.distanceToPlane(plane);
                if (t === null) {
                  return null;
                }
                return this.at(t, target);
              }
            }, {
              key: "intersectsPlane",
              value: function intersectsPlane(plane) {
                // check if the ray lies on the plane first
                var distToPoint = plane.distanceToPoint(this.origin);
                if (distToPoint === 0) {
                  return true;
                }
                var denominator = plane.normal.dot(this.direction);
                if (denominator * distToPoint < 0) {
                  return true;
                } // ray origin is behind the plane (and is pointing behind it)
                return false;
              }
            }, {
              key: "intersectBox",
              value: function intersectBox(box, target) {
                var tmin, tmax, tymin, tymax, tzmin, tzmax;
                var invdirx = 1 / this.direction.x,
                  invdiry = 1 / this.direction.y,
                  invdirz = 1 / this.direction.z;
                var origin = this.origin;
                if (invdirx >= 0) {
                  tmin = (box.min.x - origin.x) * invdirx;
                  tmax = (box.max.x - origin.x) * invdirx;
                } else {
                  tmin = (box.max.x - origin.x) * invdirx;
                  tmax = (box.min.x - origin.x) * invdirx;
                }
                if (invdiry >= 0) {
                  tymin = (box.min.y - origin.y) * invdiry;
                  tymax = (box.max.y - origin.y) * invdiry;
                } else {
                  tymin = (box.max.y - origin.y) * invdiry;
                  tymax = (box.min.y - origin.y) * invdiry;
                }
                if (tmin > tymax || tymin > tmax) return null;
                if (tymin > tmin || isNaN(tmin)) tmin = tymin;
                if (tymax < tmax || isNaN(tmax)) tmax = tymax;
                if (invdirz >= 0) {
                  tzmin = (box.min.z - origin.z) * invdirz;
                  tzmax = (box.max.z - origin.z) * invdirz;
                } else {
                  tzmin = (box.max.z - origin.z) * invdirz;
                  tzmax = (box.min.z - origin.z) * invdirz;
                }
                if (tmin > tzmax || tzmin > tmax) return null;
                if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
                if (tzmax < tmax || tmax !== tmax) tmax = tzmax; //return point closest to the ray (positive side)
                if (tmax < 0) return null;
                return this.at(tmin >= 0 ? tmin : tmax, target);
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                return this.intersectBox(box, _vector$a) !== null;
              }
            }, {
              key: "intersectTriangle",
              value: function intersectTriangle(a, b, c, backfaceCulling, target) {
                // Compute the offset origin, edges, and normal.
                // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
                _edge1.subVectors(b, a);
                _edge2.subVectors(c, a);
                _normal$1.crossVectors(_edge1, _edge2); // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
                // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
                //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
                //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
                //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
                var DdN = this.direction.dot(_normal$1);
                var sign;
                if (DdN > 0) {
                  if (backfaceCulling) return null;
                  sign = 1;
                } else if (DdN < 0) {
                  sign = -1;
                  DdN = -DdN;
                } else {
                  return null;
                }
                _diff.subVectors(this.origin, a);
                var DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2)); // b1 < 0, no intersection
                if (DdQxE2 < 0) {
                  return null;
                }
                var DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff)); // b2 < 0, no intersection
                if (DdE1xQ < 0) {
                  return null;
                } // b1+b2 > 1, no intersection
                if (DdQxE2 + DdE1xQ > DdN) {
                  return null;
                } // Line intersects triangle, check if ray does.
                var QdN = -sign * _diff.dot(_normal$1); // t < 0, no intersection
                if (QdN < 0) {
                  return null;
                } // Ray intersects triangle.
                return this.at(QdN / DdN, target);
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix4) {
                this.origin.applyMatrix4(matrix4);
                this.direction.transformDirection(matrix4);
                return this;
              }
            }, {
              key: "equals",
              value: function equals(ray) {
                return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Ray;
          }();
          var _Matrix2 = /*#__PURE__*/function () {
            function _Matrix2() {
              _classCallCheck2(this, _Matrix2);
              _Matrix2.prototype.isMatrix4 = true;
              this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            }
            _createClass2(_Matrix2, [{
              key: "set",
              value: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
                var te = this.elements;
                te[0] = n11;
                te[4] = n12;
                te[8] = n13;
                te[12] = n14;
                te[1] = n21;
                te[5] = n22;
                te[9] = n23;
                te[13] = n24;
                te[2] = n31;
                te[6] = n32;
                te[10] = n33;
                te[14] = n34;
                te[3] = n41;
                te[7] = n42;
                te[11] = n43;
                te[15] = n44;
                return this;
              }
            }, {
              key: "identity",
              value: function identity() {
                this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new _Matrix2().fromArray(this.elements);
              }
            }, {
              key: "copy",
              value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                te[9] = me[9];
                te[10] = me[10];
                te[11] = me[11];
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                te[15] = me[15];
                return this;
              }
            }, {
              key: "copyPosition",
              value: function copyPosition(m) {
                var te = this.elements,
                  me = m.elements;
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                return this;
              }
            }, {
              key: "setFromMatrix3",
              value: function setFromMatrix3(m) {
                var me = m.elements;
                this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "extractBasis",
              value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrixColumn(this, 0);
                yAxis.setFromMatrixColumn(this, 1);
                zAxis.setFromMatrixColumn(this, 2);
                return this;
              }
            }, {
              key: "makeBasis",
              value: function makeBasis(xAxis, yAxis, zAxis) {
                this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "extractRotation",
              value: function extractRotation(m) {
                // this method does not support reflection matrices
                var te = this.elements;
                var me = m.elements;
                var scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
                var scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
                var scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
                te[0] = me[0] * scaleX;
                te[1] = me[1] * scaleX;
                te[2] = me[2] * scaleX;
                te[3] = 0;
                te[4] = me[4] * scaleY;
                te[5] = me[5] * scaleY;
                te[6] = me[6] * scaleY;
                te[7] = 0;
                te[8] = me[8] * scaleZ;
                te[9] = me[9] * scaleZ;
                te[10] = me[10] * scaleZ;
                te[11] = 0;
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
              }
            }, {
              key: "makeRotationFromEuler",
              value: function makeRotationFromEuler(euler) {
                var te = this.elements;
                var x = euler.x,
                  y = euler.y,
                  z = euler.z;
                var a = Math.cos(x),
                  b = Math.sin(x);
                var c = Math.cos(y),
                  d = Math.sin(y);
                var e = Math.cos(z),
                  f = Math.sin(z);
                if (euler.order === 'XYZ') {
                  var ae = a * e,
                    af = a * f,
                    be = b * e,
                    bf = b * f;
                  te[0] = c * e;
                  te[4] = -c * f;
                  te[8] = d;
                  te[1] = af + be * d;
                  te[5] = ae - bf * d;
                  te[9] = -b * c;
                  te[2] = bf - ae * d;
                  te[6] = be + af * d;
                  te[10] = a * c;
                } else if (euler.order === 'YXZ') {
                  var ce = c * e,
                    cf = c * f,
                    de = d * e,
                    df = d * f;
                  te[0] = ce + df * b;
                  te[4] = de * b - cf;
                  te[8] = a * d;
                  te[1] = a * f;
                  te[5] = a * e;
                  te[9] = -b;
                  te[2] = cf * b - de;
                  te[6] = df + ce * b;
                  te[10] = a * c;
                } else if (euler.order === 'ZXY') {
                  var _ce = c * e,
                    _cf = c * f,
                    _de = d * e,
                    _df = d * f;
                  te[0] = _ce - _df * b;
                  te[4] = -a * f;
                  te[8] = _de + _cf * b;
                  te[1] = _cf + _de * b;
                  te[5] = a * e;
                  te[9] = _df - _ce * b;
                  te[2] = -a * d;
                  te[6] = b;
                  te[10] = a * c;
                } else if (euler.order === 'ZYX') {
                  var _ae = a * e,
                    _af = a * f,
                    _be = b * e,
                    _bf = b * f;
                  te[0] = c * e;
                  te[4] = _be * d - _af;
                  te[8] = _ae * d + _bf;
                  te[1] = c * f;
                  te[5] = _bf * d + _ae;
                  te[9] = _af * d - _be;
                  te[2] = -d;
                  te[6] = b * c;
                  te[10] = a * c;
                } else if (euler.order === 'YZX') {
                  var ac = a * c,
                    ad = a * d,
                    bc = b * c,
                    bd = b * d;
                  te[0] = c * e;
                  te[4] = bd - ac * f;
                  te[8] = bc * f + ad;
                  te[1] = f;
                  te[5] = a * e;
                  te[9] = -b * e;
                  te[2] = -d * e;
                  te[6] = ad * f + bc;
                  te[10] = ac - bd * f;
                } else if (euler.order === 'XZY') {
                  var _ac = a * c,
                    _ad = a * d,
                    _bc = b * c,
                    _bd = b * d;
                  te[0] = c * e;
                  te[4] = -f;
                  te[8] = d * e;
                  te[1] = _ac * f + _bd;
                  te[5] = a * e;
                  te[9] = _ad * f - _bc;
                  te[2] = _bc * f - _ad;
                  te[6] = b * e;
                  te[10] = _bd * f + _ac;
                } // bottom row
                te[3] = 0;
                te[7] = 0;
                te[11] = 0; // last column
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
              }
            }, {
              key: "makeRotationFromQuaternion",
              value: function makeRotationFromQuaternion(q) {
                return this.compose(_zero, q, _one);
              }
            }, {
              key: "lookAt",
              value: function lookAt(eye, target, up) {
                var te = this.elements;
                _z.subVectors(eye, target);
                if (_z.lengthSq() === 0) {
                  // eye and target are in the same position
                  _z.z = 1;
                }
                _z.normalize();
                _x.crossVectors(up, _z);
                if (_x.lengthSq() === 0) {
                  // up and z are parallel
                  if (Math.abs(up.z) === 1) {
                    _z.x += 0.0001;
                  } else {
                    _z.z += 0.0001;
                  }
                  _z.normalize();
                  _x.crossVectors(up, _z);
                }
                _x.normalize();
                _y.crossVectors(_z, _x);
                te[0] = _x.x;
                te[4] = _y.x;
                te[8] = _z.x;
                te[1] = _x.y;
                te[5] = _y.y;
                te[9] = _z.y;
                te[2] = _x.z;
                te[6] = _y.z;
                te[10] = _z.z;
                return this;
              }
            }, {
              key: "multiply",
              value: function multiply(m) {
                return this.multiplyMatrices(this, m);
              }
            }, {
              key: "premultiply",
              value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
              }
            }, {
              key: "multiplyMatrices",
              value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0],
                  a12 = ae[4],
                  a13 = ae[8],
                  a14 = ae[12];
                var a21 = ae[1],
                  a22 = ae[5],
                  a23 = ae[9],
                  a24 = ae[13];
                var a31 = ae[2],
                  a32 = ae[6],
                  a33 = ae[10],
                  a34 = ae[14];
                var a41 = ae[3],
                  a42 = ae[7],
                  a43 = ae[11],
                  a44 = ae[15];
                var b11 = be[0],
                  b12 = be[4],
                  b13 = be[8],
                  b14 = be[12];
                var b21 = be[1],
                  b22 = be[5],
                  b23 = be[9],
                  b24 = be[13];
                var b31 = be[2],
                  b32 = be[6],
                  b33 = be[10],
                  b34 = be[14];
                var b41 = be[3],
                  b42 = be[7],
                  b43 = be[11],
                  b44 = be[15];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
                te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
                return this;
              }
            }, {
              key: "multiplyScalar",
              value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[4] *= s;
                te[8] *= s;
                te[12] *= s;
                te[1] *= s;
                te[5] *= s;
                te[9] *= s;
                te[13] *= s;
                te[2] *= s;
                te[6] *= s;
                te[10] *= s;
                te[14] *= s;
                te[3] *= s;
                te[7] *= s;
                te[11] *= s;
                te[15] *= s;
                return this;
              }
            }, {
              key: "determinant",
              value: function determinant() {
                var te = this.elements;
                var n11 = te[0],
                  n12 = te[4],
                  n13 = te[8],
                  n14 = te[12];
                var n21 = te[1],
                  n22 = te[5],
                  n23 = te[9],
                  n24 = te[13];
                var n31 = te[2],
                  n32 = te[6],
                  n33 = te[10],
                  n34 = te[14];
                var n41 = te[3],
                  n42 = te[7],
                  n43 = te[11],
                  n44 = te[15]; //TODO: make this more efficient
                //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
                return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
              }
            }, {
              key: "transpose",
              value: function transpose() {
                var te = this.elements;
                var tmp;
                tmp = te[1];
                te[1] = te[4];
                te[4] = tmp;
                tmp = te[2];
                te[2] = te[8];
                te[8] = tmp;
                tmp = te[6];
                te[6] = te[9];
                te[9] = tmp;
                tmp = te[3];
                te[3] = te[12];
                te[12] = tmp;
                tmp = te[7];
                te[7] = te[13];
                te[13] = tmp;
                tmp = te[11];
                te[11] = te[14];
                te[14] = tmp;
                return this;
              }
            }, {
              key: "setPosition",
              value: function setPosition(x, y, z) {
                var te = this.elements;
                if (x.isVector3) {
                  te[12] = x.x;
                  te[13] = x.y;
                  te[14] = x.z;
                } else {
                  te[12] = x;
                  te[13] = y;
                  te[14] = z;
                }
                return this;
              }
            }, {
              key: "invert",
              value: function invert() {
                // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
                var te = this.elements,
                  n11 = te[0],
                  n21 = te[1],
                  n31 = te[2],
                  n41 = te[3],
                  n12 = te[4],
                  n22 = te[5],
                  n32 = te[6],
                  n42 = te[7],
                  n13 = te[8],
                  n23 = te[9],
                  n33 = te[10],
                  n43 = te[11],
                  n14 = te[12],
                  n24 = te[13],
                  n34 = te[14],
                  n44 = te[15],
                  t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
                  t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
                  t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
                  t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
                var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
                te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
                te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
                te[4] = t12 * detInv;
                te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
                te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
                te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
                te[8] = t13 * detInv;
                te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
                te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
                te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
                te[12] = t14 * detInv;
                te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
                te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
                te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
                return this;
              }
            }, {
              key: "scale",
              value: function scale(v) {
                var te = this.elements;
                var x = v.x,
                  y = v.y,
                  z = v.z;
                te[0] *= x;
                te[4] *= y;
                te[8] *= z;
                te[1] *= x;
                te[5] *= y;
                te[9] *= z;
                te[2] *= x;
                te[6] *= y;
                te[10] *= z;
                te[3] *= x;
                te[7] *= y;
                te[11] *= z;
                return this;
              }
            }, {
              key: "getMaxScaleOnAxis",
              value: function getMaxScaleOnAxis() {
                var te = this.elements;
                var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
                var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
                var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
                return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
              }
            }, {
              key: "makeTranslation",
              value: function makeTranslation(x, y, z) {
                this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeRotationX",
              value: function makeRotationX(theta) {
                var c = Math.cos(theta),
                  s = Math.sin(theta);
                this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeRotationY",
              value: function makeRotationY(theta) {
                var c = Math.cos(theta),
                  s = Math.sin(theta);
                this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeRotationZ",
              value: function makeRotationZ(theta) {
                var c = Math.cos(theta),
                  s = Math.sin(theta);
                this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeRotationAxis",
              value: function makeRotationAxis(axis, angle) {
                // Based on http://www.gamedev.net/reference/articles/article1199.asp
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var t = 1 - c;
                var x = axis.x,
                  y = axis.y,
                  z = axis.z;
                var tx = t * x,
                  ty = t * y;
                this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeScale",
              value: function makeScale(x, y, z) {
                this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "makeShear",
              value: function makeShear(xy, xz, yx, yz, zx, zy) {
                this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
                return this;
              }
            }, {
              key: "compose",
              value: function compose(position, quaternion, scale) {
                var te = this.elements;
                var x = quaternion._x,
                  y = quaternion._y,
                  z = quaternion._z,
                  w = quaternion._w;
                var x2 = x + x,
                  y2 = y + y,
                  z2 = z + z;
                var xx = x * x2,
                  xy = x * y2,
                  xz = x * z2;
                var yy = y * y2,
                  yz = y * z2,
                  zz = z * z2;
                var wx = w * x2,
                  wy = w * y2,
                  wz = w * z2;
                var sx = scale.x,
                  sy = scale.y,
                  sz = scale.z;
                te[0] = (1 - (yy + zz)) * sx;
                te[1] = (xy + wz) * sx;
                te[2] = (xz - wy) * sx;
                te[3] = 0;
                te[4] = (xy - wz) * sy;
                te[5] = (1 - (xx + zz)) * sy;
                te[6] = (yz + wx) * sy;
                te[7] = 0;
                te[8] = (xz + wy) * sz;
                te[9] = (yz - wx) * sz;
                te[10] = (1 - (xx + yy)) * sz;
                te[11] = 0;
                te[12] = position.x;
                te[13] = position.y;
                te[14] = position.z;
                te[15] = 1;
                return this;
              }
            }, {
              key: "decompose",
              value: function decompose(position, quaternion, scale) {
                var te = this.elements;
                var sx = _v1$5.set(te[0], te[1], te[2]).length();
                var sy = _v1$5.set(te[4], te[5], te[6]).length();
                var sz = _v1$5.set(te[8], te[9], te[10]).length(); // if determine is negative, we need to invert one scale
                var det = this.determinant();
                if (det < 0) sx = -sx;
                position.x = te[12];
                position.y = te[13];
                position.z = te[14]; // scale the rotation part
                _m1$2.copy(this);
                var invSX = 1 / sx;
                var invSY = 1 / sy;
                var invSZ = 1 / sz;
                _m1$2.elements[0] *= invSX;
                _m1$2.elements[1] *= invSX;
                _m1$2.elements[2] *= invSX;
                _m1$2.elements[4] *= invSY;
                _m1$2.elements[5] *= invSY;
                _m1$2.elements[6] *= invSY;
                _m1$2.elements[8] *= invSZ;
                _m1$2.elements[9] *= invSZ;
                _m1$2.elements[10] *= invSZ;
                quaternion.setFromRotationMatrix(_m1$2);
                scale.x = sx;
                scale.y = sy;
                scale.z = sz;
                return this;
              }
            }, {
              key: "makePerspective",
              value: function makePerspective(left, right, top, bottom, near, far) {
                var te = this.elements;
                var x = 2 * near / (right - left);
                var y = 2 * near / (top - bottom);
                var a = (right + left) / (right - left);
                var b = (top + bottom) / (top - bottom);
                var c = -(far + near) / (far - near);
                var d = -2 * far * near / (far - near);
                te[0] = x;
                te[4] = 0;
                te[8] = a;
                te[12] = 0;
                te[1] = 0;
                te[5] = y;
                te[9] = b;
                te[13] = 0;
                te[2] = 0;
                te[6] = 0;
                te[10] = c;
                te[14] = d;
                te[3] = 0;
                te[7] = 0;
                te[11] = -1;
                te[15] = 0;
                return this;
              }
            }, {
              key: "makeOrthographic",
              value: function makeOrthographic(left, right, top, bottom, near, far) {
                var te = this.elements;
                var w = 1.0 / (right - left);
                var h = 1.0 / (top - bottom);
                var p = 1.0 / (far - near);
                var x = (right + left) * w;
                var y = (top + bottom) * h;
                var z = (far + near) * p;
                te[0] = 2 * w;
                te[4] = 0;
                te[8] = 0;
                te[12] = -x;
                te[1] = 0;
                te[5] = 2 * h;
                te[9] = 0;
                te[13] = -y;
                te[2] = 0;
                te[6] = 0;
                te[10] = -2 * p;
                te[14] = -z;
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                te[15] = 1;
                return this;
              }
            }, {
              key: "equals",
              value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for (var i = 0; i < 16; i++) {
                  if (te[i] !== me[i]) return false;
                }
                return true;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                for (var i = 0; i < 16; i++) {
                  this.elements[i] = array[i + offset];
                }
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                array[offset + 9] = te[9];
                array[offset + 10] = te[10];
                array[offset + 11] = te[11];
                array[offset + 12] = te[12];
                array[offset + 13] = te[13];
                array[offset + 14] = te[14];
                array[offset + 15] = te[15];
                return array;
              }
            }]);
            return _Matrix2;
          }();
          var _v1$5 = /*@__PURE__*/new _Vector2();
          var _m1$2 = /*@__PURE__*/new _Matrix2();
          var _zero = /*@__PURE__*/new _Vector2(0, 0, 0);
          var _one = /*@__PURE__*/new _Vector2(1, 1, 1);
          var _x = /*@__PURE__*/new _Vector2();
          var _y = /*@__PURE__*/new _Vector2();
          var _z = /*@__PURE__*/new _Vector2();
          var _matrix$1 = /*@__PURE__*/new _Matrix2();
          var _quaternion$3 = /*@__PURE__*/new _Quaternion();
          var _Euler = /*#__PURE__*/function (_Symbol$iterator6) {
            function _Euler() {
              var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Euler.DefaultOrder;
              _classCallCheck2(this, _Euler);
              this.isEuler = true;
              this._x = x;
              this._y = y;
              this._z = z;
              this._order = order;
            }
            _createClass2(_Euler, [{
              key: "x",
              get: function get() {
                return this._x;
              },
              set: function set(value) {
                this._x = value;
                this._onChangeCallback();
              }
            }, {
              key: "y",
              get: function get() {
                return this._y;
              },
              set: function set(value) {
                this._y = value;
                this._onChangeCallback();
              }
            }, {
              key: "z",
              get: function get() {
                return this._z;
              },
              set: function set(value) {
                this._z = value;
                this._onChangeCallback();
              }
            }, {
              key: "order",
              get: function get() {
                return this._order;
              },
              set: function set(value) {
                this._order = value;
                this._onChangeCallback();
              }
            }, {
              key: "set",
              value: function set(x, y, z) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._order;
                this._x = x;
                this._y = y;
                this._z = z;
                this._order = order;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
              }
            }, {
              key: "copy",
              value: function copy(euler) {
                this._x = euler._x;
                this._y = euler._y;
                this._z = euler._z;
                this._order = euler._order;
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "setFromRotationMatrix",
              value: function setFromRotationMatrix(m) {
                var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
                var update = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements;
                var m11 = te[0],
                  m12 = te[4],
                  m13 = te[8];
                var m21 = te[1],
                  m22 = te[5],
                  m23 = te[9];
                var m31 = te[2],
                  m32 = te[6],
                  m33 = te[10];
                switch (order) {
                  case 'XYZ':
                    this._y = Math.asin(clamp(m13, -1, 1));
                    if (Math.abs(m13) < 0.9999999) {
                      this._x = Math.atan2(-m23, m33);
                      this._z = Math.atan2(-m12, m11);
                    } else {
                      this._x = Math.atan2(m32, m22);
                      this._z = 0;
                    }
                    break;
                  case 'YXZ':
                    this._x = Math.asin(-clamp(m23, -1, 1));
                    if (Math.abs(m23) < 0.9999999) {
                      this._y = Math.atan2(m13, m33);
                      this._z = Math.atan2(m21, m22);
                    } else {
                      this._y = Math.atan2(-m31, m11);
                      this._z = 0;
                    }
                    break;
                  case 'ZXY':
                    this._x = Math.asin(clamp(m32, -1, 1));
                    if (Math.abs(m32) < 0.9999999) {
                      this._y = Math.atan2(-m31, m33);
                      this._z = Math.atan2(-m12, m22);
                    } else {
                      this._y = 0;
                      this._z = Math.atan2(m21, m11);
                    }
                    break;
                  case 'ZYX':
                    this._y = Math.asin(-clamp(m31, -1, 1));
                    if (Math.abs(m31) < 0.9999999) {
                      this._x = Math.atan2(m32, m33);
                      this._z = Math.atan2(m21, m11);
                    } else {
                      this._x = 0;
                      this._z = Math.atan2(-m12, m22);
                    }
                    break;
                  case 'YZX':
                    this._z = Math.asin(clamp(m21, -1, 1));
                    if (Math.abs(m21) < 0.9999999) {
                      this._x = Math.atan2(-m23, m22);
                      this._y = Math.atan2(-m31, m11);
                    } else {
                      this._x = 0;
                      this._y = Math.atan2(m13, m33);
                    }
                    break;
                  case 'XZY':
                    this._z = Math.asin(-clamp(m12, -1, 1));
                    if (Math.abs(m12) < 0.9999999) {
                      this._x = Math.atan2(m32, m22);
                      this._y = Math.atan2(m13, m11);
                    } else {
                      this._x = Math.atan2(-m23, m33);
                      this._y = 0;
                    }
                    break;
                  default:
                    console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
                }
                this._order = order;
                if (update === true) this._onChangeCallback();
                return this;
              }
            }, {
              key: "setFromQuaternion",
              value: function setFromQuaternion(q, order, update) {
                _matrix$1.makeRotationFromQuaternion(q);
                return this.setFromRotationMatrix(_matrix$1, order, update);
              }
            }, {
              key: "setFromVector3",
              value: function setFromVector3(v) {
                var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
                return this.set(v.x, v.y, v.z, order);
              }
            }, {
              key: "reorder",
              value: function reorder(newOrder) {
                // WARNING: this discards revolution information -bhouston
                _quaternion$3.setFromEuler(this);
                return this.setFromQuaternion(_quaternion$3, newOrder);
              }
            }, {
              key: "equals",
              value: function equals(euler) {
                return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                this._x = array[0];
                this._y = array[1];
                this._z = array[2];
                if (array[3] !== undefined) this._order = array[3];
                this._onChangeCallback();
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._order;
                return array;
              }
            }, {
              key: "_onChange",
              value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
              }
            }, {
              key: "_onChangeCallback",
              value: function _onChangeCallback() {}
            }, {
              key: _Symbol$iterator6,
              value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
                return _regeneratorRuntime().wrap(function value$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return this._x;
                    case 2:
                      _context7.next = 4;
                      return this._y;
                    case 4:
                      _context7.next = 6;
                      return this._z;
                    case 6:
                      _context7.next = 8;
                      return this._order;
                    case 8:
                    case "end":
                      return _context7.stop();
                  }
                }, value, this);
              }) // @deprecated since r138, 02cf0df1cb4575d5842fef9c85bb5a89fe020d53
            }, {
              key: "toVector3",
              value: function toVector3() {
                console.error('THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead');
              }
            }]);
            return _Euler;
          }(Symbol.iterator);
          _Euler.DefaultOrder = 'XYZ';
          _Euler.RotationOrders = ['XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX'];
          var _Layers = /*#__PURE__*/function () {
            function _Layers() {
              _classCallCheck2(this, _Layers);
              this.mask = 1 | 0;
            }
            _createClass2(_Layers, [{
              key: "set",
              value: function set(channel) {
                this.mask = (1 << channel | 0) >>> 0;
              }
            }, {
              key: "enable",
              value: function enable(channel) {
                this.mask |= 1 << channel | 0;
              }
            }, {
              key: "enableAll",
              value: function enableAll() {
                this.mask = 0xffffffff | 0;
              }
            }, {
              key: "toggle",
              value: function toggle(channel) {
                this.mask ^= 1 << channel | 0;
              }
            }, {
              key: "disable",
              value: function disable(channel) {
                this.mask &= ~(1 << channel | 0);
              }
            }, {
              key: "disableAll",
              value: function disableAll() {
                this.mask = 0;
              }
            }, {
              key: "test",
              value: function test(layers) {
                return (this.mask & layers.mask) !== 0;
              }
            }, {
              key: "isEnabled",
              value: function isEnabled(channel) {
                return (this.mask & (1 << channel | 0)) !== 0;
              }
            }]);
            return _Layers;
          }();
          var _object3DId = 0;
          var _v1$4 = /*@__PURE__*/new _Vector2();
          var _q1 = /*@__PURE__*/new _Quaternion();
          var _m1$1 = /*@__PURE__*/new _Matrix2();
          var _target = /*@__PURE__*/new _Vector2();
          var _position$3 = /*@__PURE__*/new _Vector2();
          var _scale$2 = /*@__PURE__*/new _Vector2();
          var _quaternion$2 = /*@__PURE__*/new _Quaternion();
          var _xAxis = /*@__PURE__*/new _Vector2(1, 0, 0);
          var _yAxis = /*@__PURE__*/new _Vector2(0, 1, 0);
          var _zAxis = /*@__PURE__*/new _Vector2(0, 0, 1);
          var _addedEvent = {
            type: 'added'
          };
          var _removedEvent = {
            type: 'removed'
          };
          var _Object3D = /*#__PURE__*/function (_EventDispatcher4) {
            _inherits(_Object3D, _EventDispatcher4);
            var _super18 = _createSuper(_Object3D);
            function _Object3D() {
              var _this19;
              _classCallCheck2(this, _Object3D);
              _this19 = _super18.call(this);
              _this19.isObject3D = true;
              Object.defineProperty(_assertThisInitialized(_this19), 'id', {
                value: _object3DId++
              });
              _this19.uuid = generateUUID();
              _this19.name = '';
              _this19.type = 'Object3D';
              _this19.parent = null;
              _this19.children = [];
              _this19.up = _Object3D.DefaultUp.clone();
              var position = new _Vector2();
              var rotation = new _Euler();
              var quaternion = new _Quaternion();
              var scale = new _Vector2(1, 1, 1);
              function onRotationChange() {
                quaternion.setFromEuler(rotation, false);
              }
              function onQuaternionChange() {
                rotation.setFromQuaternion(quaternion, undefined, false);
              }
              rotation._onChange(onRotationChange);
              quaternion._onChange(onQuaternionChange);
              Object.defineProperties(_assertThisInitialized(_this19), {
                position: {
                  configurable: true,
                  enumerable: true,
                  value: position
                },
                rotation: {
                  configurable: true,
                  enumerable: true,
                  value: rotation
                },
                quaternion: {
                  configurable: true,
                  enumerable: true,
                  value: quaternion
                },
                scale: {
                  configurable: true,
                  enumerable: true,
                  value: scale
                },
                modelViewMatrix: {
                  value: new _Matrix2()
                },
                normalMatrix: {
                  value: new _Matrix()
                }
              });
              _this19.matrix = new _Matrix2();
              _this19.matrixWorld = new _Matrix2();
              _this19.matrixAutoUpdate = _Object3D.DefaultMatrixAutoUpdate;
              _this19.matrixWorldNeedsUpdate = false;
              _this19.matrixWorldAutoUpdate = _Object3D.DefaultMatrixWorldAutoUpdate; // checked by the renderer
              _this19.layers = new _Layers();
              _this19.visible = true;
              _this19.castShadow = false;
              _this19.receiveShadow = false;
              _this19.frustumCulled = true;
              _this19.renderOrder = 0;
              _this19.animations = [];
              _this19.userData = {};
              return _this19;
            }
            _createClass2(_Object3D, [{
              key: "onBeforeRender",
              value: function onBeforeRender( /* renderer, scene, camera, geometry, material, group */) {}
            }, {
              key: "onAfterRender",
              value: function onAfterRender( /* renderer, scene, camera, geometry, material, group */) {}
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                this.matrix.premultiply(matrix);
                this.matrix.decompose(this.position, this.quaternion, this.scale);
              }
            }, {
              key: "applyQuaternion",
              value: function applyQuaternion(q) {
                this.quaternion.premultiply(q);
                return this;
              }
            }, {
              key: "setRotationFromAxisAngle",
              value: function setRotationFromAxisAngle(axis, angle) {
                // assumes axis is normalized
                this.quaternion.setFromAxisAngle(axis, angle);
              }
            }, {
              key: "setRotationFromEuler",
              value: function setRotationFromEuler(euler) {
                this.quaternion.setFromEuler(euler, true);
              }
            }, {
              key: "setRotationFromMatrix",
              value: function setRotationFromMatrix(m) {
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                this.quaternion.setFromRotationMatrix(m);
              }
            }, {
              key: "setRotationFromQuaternion",
              value: function setRotationFromQuaternion(q) {
                // assumes q is normalized
                this.quaternion.copy(q);
              }
            }, {
              key: "rotateOnAxis",
              value: function rotateOnAxis(axis, angle) {
                // rotate object on axis in object space
                // axis is assumed to be normalized
                _q1.setFromAxisAngle(axis, angle);
                this.quaternion.multiply(_q1);
                return this;
              }
            }, {
              key: "rotateOnWorldAxis",
              value: function rotateOnWorldAxis(axis, angle) {
                // rotate object on axis in world space
                // axis is assumed to be normalized
                // method assumes no rotated parent
                _q1.setFromAxisAngle(axis, angle);
                this.quaternion.premultiply(_q1);
                return this;
              }
            }, {
              key: "rotateX",
              value: function rotateX(angle) {
                return this.rotateOnAxis(_xAxis, angle);
              }
            }, {
              key: "rotateY",
              value: function rotateY(angle) {
                return this.rotateOnAxis(_yAxis, angle);
              }
            }, {
              key: "rotateZ",
              value: function rotateZ(angle) {
                return this.rotateOnAxis(_zAxis, angle);
              }
            }, {
              key: "translateOnAxis",
              value: function translateOnAxis(axis, distance) {
                // translate object by distance along axis in object space
                // axis is assumed to be normalized
                _v1$4.copy(axis).applyQuaternion(this.quaternion);
                this.position.add(_v1$4.multiplyScalar(distance));
                return this;
              }
            }, {
              key: "translateX",
              value: function translateX(distance) {
                return this.translateOnAxis(_xAxis, distance);
              }
            }, {
              key: "translateY",
              value: function translateY(distance) {
                return this.translateOnAxis(_yAxis, distance);
              }
            }, {
              key: "translateZ",
              value: function translateZ(distance) {
                return this.translateOnAxis(_zAxis, distance);
              }
            }, {
              key: "localToWorld",
              value: function localToWorld(vector) {
                return vector.applyMatrix4(this.matrixWorld);
              }
            }, {
              key: "worldToLocal",
              value: function worldToLocal(vector) {
                return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
              }
            }, {
              key: "lookAt",
              value: function lookAt(x, y, z) {
                // This method does not support objects having non-uniformly-scaled parent(s)
                if (x.isVector3) {
                  _target.copy(x);
                } else {
                  _target.set(x, y, z);
                }
                var parent = this.parent;
                this.updateWorldMatrix(true, false);
                _position$3.setFromMatrixPosition(this.matrixWorld);
                if (this.isCamera || this.isLight) {
                  _m1$1.lookAt(_position$3, _target, this.up);
                } else {
                  _m1$1.lookAt(_target, _position$3, this.up);
                }
                this.quaternion.setFromRotationMatrix(_m1$1);
                if (parent) {
                  _m1$1.extractRotation(parent.matrixWorld);
                  _q1.setFromRotationMatrix(_m1$1);
                  this.quaternion.premultiply(_q1.invert());
                }
              }
            }, {
              key: "add",
              value: function add(object) {
                if (arguments.length > 1) {
                  for (var i = 0; i < arguments.length; i++) {
                    this.add(arguments[i]);
                  }
                  return this;
                }
                if (object === this) {
                  console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
                  return this;
                }
                if (object && object.isObject3D) {
                  if (object.parent !== null) {
                    object.parent.remove(object);
                  }
                  object.parent = this;
                  this.children.push(object);
                  object.dispatchEvent(_addedEvent);
                } else {
                  console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
                }
                return this;
              }
            }, {
              key: "remove",
              value: function remove(object) {
                if (arguments.length > 1) {
                  for (var i = 0; i < arguments.length; i++) {
                    this.remove(arguments[i]);
                  }
                  return this;
                }
                var index = this.children.indexOf(object);
                if (index !== -1) {
                  object.parent = null;
                  this.children.splice(index, 1);
                  object.dispatchEvent(_removedEvent);
                }
                return this;
              }
            }, {
              key: "removeFromParent",
              value: function removeFromParent() {
                var parent = this.parent;
                if (parent !== null) {
                  parent.remove(this);
                }
                return this;
              }
            }, {
              key: "clear",
              value: function clear() {
                for (var i = 0; i < this.children.length; i++) {
                  var object = this.children[i];
                  object.parent = null;
                  object.dispatchEvent(_removedEvent);
                }
                this.children.length = 0;
                return this;
              }
            }, {
              key: "attach",
              value: function attach(object) {
                // adds object as a child of this, while maintaining the object's world transform
                // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
                this.updateWorldMatrix(true, false);
                _m1$1.copy(this.matrixWorld).invert();
                if (object.parent !== null) {
                  object.parent.updateWorldMatrix(true, false);
                  _m1$1.multiply(object.parent.matrixWorld);
                }
                object.applyMatrix4(_m1$1);
                this.add(object);
                object.updateWorldMatrix(false, true);
                return this;
              }
            }, {
              key: "getObjectById",
              value: function getObjectById(id) {
                return this.getObjectByProperty('id', id);
              }
            }, {
              key: "getObjectByName",
              value: function getObjectByName(name) {
                return this.getObjectByProperty('name', name);
              }
            }, {
              key: "getObjectByProperty",
              value: function getObjectByProperty(name, value) {
                if (this[name] === value) return this;
                for (var i = 0, l = this.children.length; i < l; i++) {
                  var child = this.children[i];
                  var object = child.getObjectByProperty(name, value);
                  if (object !== undefined) {
                    return object;
                  }
                }
                return undefined;
              }
            }, {
              key: "getWorldPosition",
              value: function getWorldPosition(target) {
                this.updateWorldMatrix(true, false);
                return target.setFromMatrixPosition(this.matrixWorld);
              }
            }, {
              key: "getWorldQuaternion",
              value: function getWorldQuaternion(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose(_position$3, target, _scale$2);
                return target;
              }
            }, {
              key: "getWorldScale",
              value: function getWorldScale(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose(_position$3, _quaternion$2, target);
                return target;
              }
            }, {
              key: "getWorldDirection",
              value: function getWorldDirection(target) {
                this.updateWorldMatrix(true, false);
                var e = this.matrixWorld.elements;
                return target.set(e[8], e[9], e[10]).normalize();
              }
            }, {
              key: "raycast",
              value: function raycast( /* raycaster, intersects */) {}
            }, {
              key: "traverse",
              value: function traverse(callback) {
                callback(this);
                var children = this.children;
                for (var i = 0, l = children.length; i < l; i++) {
                  children[i].traverse(callback);
                }
              }
            }, {
              key: "traverseVisible",
              value: function traverseVisible(callback) {
                if (this.visible === false) return;
                callback(this);
                var children = this.children;
                for (var i = 0, l = children.length; i < l; i++) {
                  children[i].traverseVisible(callback);
                }
              }
            }, {
              key: "traverseAncestors",
              value: function traverseAncestors(callback) {
                var parent = this.parent;
                if (parent !== null) {
                  callback(parent);
                  parent.traverseAncestors(callback);
                }
              }
            }, {
              key: "updateMatrix",
              value: function updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale);
                this.matrixWorldNeedsUpdate = true;
              }
            }, {
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.matrixWorldNeedsUpdate || force) {
                  if (this.parent === null) {
                    this.matrixWorld.copy(this.matrix);
                  } else {
                    this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                  }
                  this.matrixWorldNeedsUpdate = false;
                  force = true;
                } // update children
                var children = this.children;
                for (var i = 0, l = children.length; i < l; i++) {
                  var child = children[i];
                  if (child.matrixWorldAutoUpdate === true || force === true) {
                    child.updateMatrixWorld(force);
                  }
                }
              }
            }, {
              key: "updateWorldMatrix",
              value: function updateWorldMatrix(updateParents, updateChildren) {
                var parent = this.parent;
                if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) {
                  parent.updateWorldMatrix(true, false);
                }
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.parent === null) {
                  this.matrixWorld.copy(this.matrix);
                } else {
                  this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                } // update children
                if (updateChildren === true) {
                  var children = this.children;
                  for (var i = 0, l = children.length; i < l; i++) {
                    var child = children[i];
                    if (child.matrixWorldAutoUpdate === true) {
                      child.updateWorldMatrix(false, true);
                    }
                  }
                }
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                // meta is a string when called from JSON.stringify
                var isRootObject = meta === undefined || typeof meta === 'string';
                var output = {}; // meta is a hash used to collect geometries, materials.
                // not providing it implies that this is the root object
                // being serialized.
                if (isRootObject) {
                  // initialize meta obj
                  meta = {
                    geometries: {},
                    materials: {},
                    textures: {},
                    images: {},
                    shapes: {},
                    skeletons: {},
                    animations: {},
                    nodes: {}
                  };
                  output.metadata = {
                    version: 4.5,
                    type: 'Object',
                    generator: 'Object3D.toJSON'
                  };
                } // standard Object3D serialization
                var object = {};
                object.uuid = this.uuid;
                object.type = this.type;
                if (this.name !== '') object.name = this.name;
                if (this.castShadow === true) object.castShadow = true;
                if (this.receiveShadow === true) object.receiveShadow = true;
                if (this.visible === false) object.visible = false;
                if (this.frustumCulled === false) object.frustumCulled = false;
                if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
                if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
                object.layers = this.layers.mask;
                object.matrix = this.matrix.toArray();
                if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false; // object specific properties
                if (this.isInstancedMesh) {
                  object.type = 'InstancedMesh';
                  object.count = this.count;
                  object.instanceMatrix = this.instanceMatrix.toJSON();
                  if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
                } //
                function serialize(library, element) {
                  if (library[element.uuid] === undefined) {
                    library[element.uuid] = element.toJSON(meta);
                  }
                  return element.uuid;
                }
                if (this.isScene) {
                  if (this.background) {
                    if (this.background.isColor) {
                      object.background = this.background.toJSON();
                    } else if (this.background.isTexture) {
                      object.background = this.background.toJSON(meta).uuid;
                    }
                  }
                  if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
                    object.environment = this.environment.toJSON(meta).uuid;
                  }
                } else if (this.isMesh || this.isLine || this.isPoints) {
                  object.geometry = serialize(meta.geometries, this.geometry);
                  var parameters = this.geometry.parameters;
                  if (parameters !== undefined && parameters.shapes !== undefined) {
                    var shapes = parameters.shapes;
                    if (Array.isArray(shapes)) {
                      for (var i = 0, l = shapes.length; i < l; i++) {
                        var shape = shapes[i];
                        serialize(meta.shapes, shape);
                      }
                    } else {
                      serialize(meta.shapes, shapes);
                    }
                  }
                }
                if (this.isSkinnedMesh) {
                  object.bindMode = this.bindMode;
                  object.bindMatrix = this.bindMatrix.toArray();
                  if (this.skeleton !== undefined) {
                    serialize(meta.skeletons, this.skeleton);
                    object.skeleton = this.skeleton.uuid;
                  }
                }
                if (this.material !== undefined) {
                  if (Array.isArray(this.material)) {
                    var uuids = [];
                    for (var _i4 = 0, _l2 = this.material.length; _i4 < _l2; _i4++) {
                      uuids.push(serialize(meta.materials, this.material[_i4]));
                    }
                    object.material = uuids;
                  } else {
                    object.material = serialize(meta.materials, this.material);
                  }
                } //
                if (this.children.length > 0) {
                  object.children = [];
                  for (var _i5 = 0; _i5 < this.children.length; _i5++) {
                    object.children.push(this.children[_i5].toJSON(meta).object);
                  }
                } //
                if (this.animations.length > 0) {
                  object.animations = [];
                  for (var _i6 = 0; _i6 < this.animations.length; _i6++) {
                    var animation = this.animations[_i6];
                    object.animations.push(serialize(meta.animations, animation));
                  }
                }
                if (isRootObject) {
                  var geometries = extractFromCache(meta.geometries);
                  var materials = extractFromCache(meta.materials);
                  var textures = extractFromCache(meta.textures);
                  var images = extractFromCache(meta.images);
                  var _shapes = extractFromCache(meta.shapes);
                  var skeletons = extractFromCache(meta.skeletons);
                  var animations = extractFromCache(meta.animations);
                  var nodes = extractFromCache(meta.nodes);
                  if (geometries.length > 0) output.geometries = geometries;
                  if (materials.length > 0) output.materials = materials;
                  if (textures.length > 0) output.textures = textures;
                  if (images.length > 0) output.images = images;
                  if (_shapes.length > 0) output.shapes = _shapes;
                  if (skeletons.length > 0) output.skeletons = skeletons;
                  if (animations.length > 0) output.animations = animations;
                  if (nodes.length > 0) output.nodes = nodes;
                }
                output.object = object;
                return output; // extract data from the cache hash
                // remove metadata on each item
                // and return as array
                function extractFromCache(cache) {
                  var values = [];
                  for (var key in cache) {
                    var data = cache[key];
                    delete data.metadata;
                    values.push(data);
                  }
                  return values;
                }
              }
            }, {
              key: "clone",
              value: function clone(recursive) {
                return new this.constructor().copy(this, recursive);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.name = source.name;
                this.up.copy(source.up);
                this.position.copy(source.position);
                this.rotation.order = source.rotation.order;
                this.quaternion.copy(source.quaternion);
                this.scale.copy(source.scale);
                this.matrix.copy(source.matrix);
                this.matrixWorld.copy(source.matrixWorld);
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
                this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
                this.layers.mask = source.layers.mask;
                this.visible = source.visible;
                this.castShadow = source.castShadow;
                this.receiveShadow = source.receiveShadow;
                this.frustumCulled = source.frustumCulled;
                this.renderOrder = source.renderOrder;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                if (recursive === true) {
                  for (var i = 0; i < source.children.length; i++) {
                    var child = source.children[i];
                    this.add(child.clone());
                  }
                }
                return this;
              }
            }]);
            return _Object3D;
          }(_EventDispatcher);
          _Object3D.DefaultUp = /*@__PURE__*/new _Vector2(0, 1, 0);
          _Object3D.DefaultMatrixAutoUpdate = true;
          _Object3D.DefaultMatrixWorldAutoUpdate = true;
          var _v0$1 = /*@__PURE__*/new _Vector2();
          var _v1$3 = /*@__PURE__*/new _Vector2();
          var _v2$2 = /*@__PURE__*/new _Vector2();
          var _v3$1 = /*@__PURE__*/new _Vector2();
          var _vab = /*@__PURE__*/new _Vector2();
          var _vac = /*@__PURE__*/new _Vector2();
          var _vbc = /*@__PURE__*/new _Vector2();
          var _vap = /*@__PURE__*/new _Vector2();
          var _vbp = /*@__PURE__*/new _Vector2();
          var _vcp = /*@__PURE__*/new _Vector2();
          var _Triangle = /*#__PURE__*/function () {
            function _Triangle() {
              var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
              var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Vector2();
              _classCallCheck2(this, _Triangle);
              this.a = a;
              this.b = b;
              this.c = c;
            }
            _createClass2(_Triangle, [{
              key: "set",
              value: function set(a, b, c) {
                this.a.copy(a);
                this.b.copy(b);
                this.c.copy(c);
                return this;
              }
            }, {
              key: "setFromPointsAndIndices",
              value: function setFromPointsAndIndices(points, i0, i1, i2) {
                this.a.copy(points[i0]);
                this.b.copy(points[i1]);
                this.c.copy(points[i2]);
                return this;
              }
            }, {
              key: "setFromAttributeAndIndices",
              value: function setFromAttributeAndIndices(attribute, i0, i1, i2) {
                this.a.fromBufferAttribute(attribute, i0);
                this.b.fromBufferAttribute(attribute, i1);
                this.c.fromBufferAttribute(attribute, i2);
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(triangle) {
                this.a.copy(triangle.a);
                this.b.copy(triangle.b);
                this.c.copy(triangle.c);
                return this;
              }
            }, {
              key: "getArea",
              value: function getArea() {
                _v0$1.subVectors(this.c, this.b);
                _v1$3.subVectors(this.a, this.b);
                return _v0$1.cross(_v1$3).length() * 0.5;
              }
            }, {
              key: "getMidpoint",
              value: function getMidpoint(target) {
                return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
              }
            }, {
              key: "getNormal",
              value: function getNormal(target) {
                return _Triangle.getNormal(this.a, this.b, this.c, target);
              }
            }, {
              key: "getPlane",
              value: function getPlane(target) {
                return target.setFromCoplanarPoints(this.a, this.b, this.c);
              }
            }, {
              key: "getBarycoord",
              value: function getBarycoord(point, target) {
                return _Triangle.getBarycoord(point, this.a, this.b, this.c, target);
              }
            }, {
              key: "getUV",
              value: function getUV(point, uv1, uv2, uv3, target) {
                return _Triangle.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
              }
            }, {
              key: "containsPoint",
              value: function containsPoint(point) {
                return _Triangle.containsPoint(point, this.a, this.b, this.c);
              }
            }, {
              key: "isFrontFacing",
              value: function isFrontFacing(direction) {
                return _Triangle.isFrontFacing(this.a, this.b, this.c, direction);
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                return box.intersectsTriangle(this);
              }
            }, {
              key: "closestPointToPoint",
              value: function closestPointToPoint(p, target) {
                var a = this.a,
                  b = this.b,
                  c = this.c;
                var v, w; // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
                // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
                // under the accompanying license; see chapter 5.1.5 for detailed explanation.
                // basically, we're distinguishing which of the voronoi regions of the triangle
                // the point lies in with the minimum amount of redundant computation.
                _vab.subVectors(b, a);
                _vac.subVectors(c, a);
                _vap.subVectors(p, a);
                var d1 = _vab.dot(_vap);
                var d2 = _vac.dot(_vap);
                if (d1 <= 0 && d2 <= 0) {
                  // vertex region of A; barycentric coords (1, 0, 0)
                  return target.copy(a);
                }
                _vbp.subVectors(p, b);
                var d3 = _vab.dot(_vbp);
                var d4 = _vac.dot(_vbp);
                if (d3 >= 0 && d4 <= d3) {
                  // vertex region of B; barycentric coords (0, 1, 0)
                  return target.copy(b);
                }
                var vc = d1 * d4 - d3 * d2;
                if (vc <= 0 && d1 >= 0 && d3 <= 0) {
                  v = d1 / (d1 - d3); // edge region of AB; barycentric coords (1-v, v, 0)
                  return target.copy(a).addScaledVector(_vab, v);
                }
                _vcp.subVectors(p, c);
                var d5 = _vab.dot(_vcp);
                var d6 = _vac.dot(_vcp);
                if (d6 >= 0 && d5 <= d6) {
                  // vertex region of C; barycentric coords (0, 0, 1)
                  return target.copy(c);
                }
                var vb = d5 * d2 - d1 * d6;
                if (vb <= 0 && d2 >= 0 && d6 <= 0) {
                  w = d2 / (d2 - d6); // edge region of AC; barycentric coords (1-w, 0, w)
                  return target.copy(a).addScaledVector(_vac, w);
                }
                var va = d3 * d6 - d5 * d4;
                if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
                  _vbc.subVectors(c, b);
                  w = (d4 - d3) / (d4 - d3 + (d5 - d6)); // edge region of BC; barycentric coords (0, 1-w, w)
                  return target.copy(b).addScaledVector(_vbc, w); // edge region of BC
                } // face region
                var denom = 1 / (va + vb + vc); // u = va * denom
                v = vb * denom;
                w = vc * denom;
                return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
              }
            }, {
              key: "equals",
              value: function equals(triangle) {
                return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
              }
            }], [{
              key: "getNormal",
              value: function getNormal(a, b, c, target) {
                target.subVectors(c, b);
                _v0$1.subVectors(a, b);
                target.cross(_v0$1);
                var targetLengthSq = target.lengthSq();
                if (targetLengthSq > 0) {
                  return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
                }
                return target.set(0, 0, 0);
              } // static/instance method to calculate barycentric coordinates
              // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
            }, {
              key: "getBarycoord",
              value: function getBarycoord(point, a, b, c, target) {
                _v0$1.subVectors(c, a);
                _v1$3.subVectors(b, a);
                _v2$2.subVectors(point, a);
                var dot00 = _v0$1.dot(_v0$1);
                var dot01 = _v0$1.dot(_v1$3);
                var dot02 = _v0$1.dot(_v2$2);
                var dot11 = _v1$3.dot(_v1$3);
                var dot12 = _v1$3.dot(_v2$2);
                var denom = dot00 * dot11 - dot01 * dot01; // collinear or singular triangle
                if (denom === 0) {
                  // arbitrary location outside of triangle?
                  // not sure if this is the best idea, maybe should be returning undefined
                  return target.set(-2, -1, -1);
                }
                var invDenom = 1 / denom;
                var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
                var v = (dot00 * dot12 - dot01 * dot02) * invDenom; // barycentric coordinates must always sum to 1
                return target.set(1 - u - v, v, u);
              }
            }, {
              key: "containsPoint",
              value: function containsPoint(point, a, b, c) {
                this.getBarycoord(point, a, b, c, _v3$1);
                return _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
              }
            }, {
              key: "getUV",
              value: function getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
                this.getBarycoord(point, p1, p2, p3, _v3$1);
                target.set(0, 0);
                target.addScaledVector(uv1, _v3$1.x);
                target.addScaledVector(uv2, _v3$1.y);
                target.addScaledVector(uv3, _v3$1.z);
                return target;
              }
            }, {
              key: "isFrontFacing",
              value: function isFrontFacing(a, b, c, direction) {
                _v0$1.subVectors(c, b);
                _v1$3.subVectors(a, b); // strictly front facing
                return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
              }
            }]);
            return _Triangle;
          }();
          var materialId = 0;
          var _Material = /*#__PURE__*/function (_EventDispatcher5) {
            _inherits(_Material, _EventDispatcher5);
            var _super19 = _createSuper(_Material);
            function _Material() {
              var _this20;
              _classCallCheck2(this, _Material);
              _this20 = _super19.call(this);
              _this20.isMaterial = true;
              Object.defineProperty(_assertThisInitialized(_this20), 'id', {
                value: materialId++
              });
              _this20.uuid = generateUUID();
              _this20.name = '';
              _this20.type = 'Material';
              _this20.blending = _NormalBlending;
              _this20.side = _FrontSide;
              _this20.vertexColors = false;
              _this20.opacity = 1;
              _this20.transparent = false;
              _this20.blendSrc = _SrcAlphaFactor;
              _this20.blendDst = _OneMinusSrcAlphaFactor;
              _this20.blendEquation = _AddEquation;
              _this20.blendSrcAlpha = null;
              _this20.blendDstAlpha = null;
              _this20.blendEquationAlpha = null;
              _this20.depthFunc = _LessEqualDepth;
              _this20.depthTest = true;
              _this20.depthWrite = true;
              _this20.stencilWriteMask = 0xff;
              _this20.stencilFunc = _AlwaysStencilFunc;
              _this20.stencilRef = 0;
              _this20.stencilFuncMask = 0xff;
              _this20.stencilFail = _KeepStencilOp;
              _this20.stencilZFail = _KeepStencilOp;
              _this20.stencilZPass = _KeepStencilOp;
              _this20.stencilWrite = false;
              _this20.clippingPlanes = null;
              _this20.clipIntersection = false;
              _this20.clipShadows = false;
              _this20.shadowSide = null;
              _this20.colorWrite = true;
              _this20.precision = null; // override the renderer's default precision for this material
              _this20.polygonOffset = false;
              _this20.polygonOffsetFactor = 0;
              _this20.polygonOffsetUnits = 0;
              _this20.dithering = false;
              _this20.alphaToCoverage = false;
              _this20.premultipliedAlpha = false;
              _this20.visible = true;
              _this20.toneMapped = true;
              _this20.userData = {};
              _this20.version = 0;
              _this20._alphaTest = 0;
              return _this20;
            }
            _createClass2(_Material, [{
              key: "alphaTest",
              get: function get() {
                return this._alphaTest;
              },
              set: function set(value) {
                if (this._alphaTest > 0 !== value > 0) {
                  this.version++;
                }
                this._alphaTest = value;
              }
            }, {
              key: "onBuild",
              value: function onBuild( /* shaderobject, renderer */) {}
            }, {
              key: "onBeforeRender",
              value: function onBeforeRender( /* renderer, scene, camera, geometry, object, group */) {}
            }, {
              key: "onBeforeCompile",
              value: function onBeforeCompile( /* shaderobject, renderer */) {}
            }, {
              key: "customProgramCacheKey",
              value: function customProgramCacheKey() {
                return this.onBeforeCompile.toString();
              }
            }, {
              key: "setValues",
              value: function setValues(values) {
                if (values === undefined) return;
                for (var key in values) {
                  var newValue = values[key];
                  if (newValue === undefined) {
                    console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                    continue;
                  }
                  var currentValue = this[key];
                  if (currentValue === undefined) {
                    console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                    continue;
                  }
                  if (currentValue && currentValue.isColor) {
                    currentValue.set(newValue);
                  } else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) {
                    currentValue.copy(newValue);
                  } else {
                    this[key] = newValue;
                  }
                }
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (isRootObject) {
                  meta = {
                    textures: {},
                    images: {}
                  };
                }
                var data = {
                  metadata: {
                    version: 4.5,
                    type: 'Material',
                    generator: 'Material.toJSON'
                  }
                }; // standard Material serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (this.color && this.color.isColor) data.color = this.color.getHex();
                if (this.roughness !== undefined) data.roughness = this.roughness;
                if (this.metalness !== undefined) data.metalness = this.metalness;
                if (this.sheen !== undefined) data.sheen = this.sheen;
                if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
                if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
                if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
                if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
                if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
                if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
                if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
                if (this.shininess !== undefined) data.shininess = this.shininess;
                if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
                if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
                if (this.clearcoatMap && this.clearcoatMap.isTexture) {
                  data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
                }
                if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
                  data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
                }
                if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
                  data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
                  data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
                }
                if (this.iridescence !== undefined) data.iridescence = this.iridescence;
                if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
                if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
                if (this.iridescenceMap && this.iridescenceMap.isTexture) {
                  data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
                }
                if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {
                  data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
                }
                if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
                if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
                if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
                if (this.lightMap && this.lightMap.isTexture) {
                  data.lightMap = this.lightMap.toJSON(meta).uuid;
                  data.lightMapIntensity = this.lightMapIntensity;
                }
                if (this.aoMap && this.aoMap.isTexture) {
                  data.aoMap = this.aoMap.toJSON(meta).uuid;
                  data.aoMapIntensity = this.aoMapIntensity;
                }
                if (this.bumpMap && this.bumpMap.isTexture) {
                  data.bumpMap = this.bumpMap.toJSON(meta).uuid;
                  data.bumpScale = this.bumpScale;
                }
                if (this.normalMap && this.normalMap.isTexture) {
                  data.normalMap = this.normalMap.toJSON(meta).uuid;
                  data.normalMapType = this.normalMapType;
                  data.normalScale = this.normalScale.toArray();
                }
                if (this.displacementMap && this.displacementMap.isTexture) {
                  data.displacementMap = this.displacementMap.toJSON(meta).uuid;
                  data.displacementScale = this.displacementScale;
                  data.displacementBias = this.displacementBias;
                }
                if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
                if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
                if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
                if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
                if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
                if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
                if (this.envMap && this.envMap.isTexture) {
                  data.envMap = this.envMap.toJSON(meta).uuid;
                  if (this.combine !== undefined) data.combine = this.combine;
                }
                if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
                if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
                if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
                if (this.gradientMap && this.gradientMap.isTexture) {
                  data.gradientMap = this.gradientMap.toJSON(meta).uuid;
                }
                if (this.transmission !== undefined) data.transmission = this.transmission;
                if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
                if (this.thickness !== undefined) data.thickness = this.thickness;
                if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
                if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
                if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
                if (this.size !== undefined) data.size = this.size;
                if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
                if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
                if (this.blending !== _NormalBlending) data.blending = this.blending;
                if (this.side !== _FrontSide) data.side = this.side;
                if (this.vertexColors) data.vertexColors = true;
                if (this.opacity < 1) data.opacity = this.opacity;
                if (this.transparent === true) data.transparent = this.transparent;
                data.depthFunc = this.depthFunc;
                data.depthTest = this.depthTest;
                data.depthWrite = this.depthWrite;
                data.colorWrite = this.colorWrite;
                data.stencilWrite = this.stencilWrite;
                data.stencilWriteMask = this.stencilWriteMask;
                data.stencilFunc = this.stencilFunc;
                data.stencilRef = this.stencilRef;
                data.stencilFuncMask = this.stencilFuncMask;
                data.stencilFail = this.stencilFail;
                data.stencilZFail = this.stencilZFail;
                data.stencilZPass = this.stencilZPass; // rotation (SpriteMaterial)
                if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
                if (this.polygonOffset === true) data.polygonOffset = true;
                if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
                if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
                if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
                if (this.dashSize !== undefined) data.dashSize = this.dashSize;
                if (this.gapSize !== undefined) data.gapSize = this.gapSize;
                if (this.scale !== undefined) data.scale = this.scale;
                if (this.dithering === true) data.dithering = true;
                if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
                if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
                if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
                if (this.wireframe === true) data.wireframe = this.wireframe;
                if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
                if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
                if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
                if (this.flatShading === true) data.flatShading = this.flatShading;
                if (this.visible === false) data.visible = false;
                if (this.toneMapped === false) data.toneMapped = false;
                if (this.fog === false) data.fog = false;
                if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData; // TODO: Copied from Object3D.toJSON
                function extractFromCache(cache) {
                  var values = [];
                  for (var key in cache) {
                    var _data2 = cache[key];
                    delete _data2.metadata;
                    values.push(_data2);
                  }
                  return values;
                }
                if (isRootObject) {
                  var textures = extractFromCache(meta.textures);
                  var images = extractFromCache(meta.images);
                  if (textures.length > 0) data.textures = textures;
                  if (images.length > 0) data.images = images;
                }
                return data;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.name = source.name;
                this.blending = source.blending;
                this.side = source.side;
                this.vertexColors = source.vertexColors;
                this.opacity = source.opacity;
                this.transparent = source.transparent;
                this.blendSrc = source.blendSrc;
                this.blendDst = source.blendDst;
                this.blendEquation = source.blendEquation;
                this.blendSrcAlpha = source.blendSrcAlpha;
                this.blendDstAlpha = source.blendDstAlpha;
                this.blendEquationAlpha = source.blendEquationAlpha;
                this.depthFunc = source.depthFunc;
                this.depthTest = source.depthTest;
                this.depthWrite = source.depthWrite;
                this.stencilWriteMask = source.stencilWriteMask;
                this.stencilFunc = source.stencilFunc;
                this.stencilRef = source.stencilRef;
                this.stencilFuncMask = source.stencilFuncMask;
                this.stencilFail = source.stencilFail;
                this.stencilZFail = source.stencilZFail;
                this.stencilZPass = source.stencilZPass;
                this.stencilWrite = source.stencilWrite;
                var srcPlanes = source.clippingPlanes;
                var dstPlanes = null;
                if (srcPlanes !== null) {
                  var n = srcPlanes.length;
                  dstPlanes = new Array(n);
                  for (var i = 0; i !== n; ++i) {
                    dstPlanes[i] = srcPlanes[i].clone();
                  }
                }
                this.clippingPlanes = dstPlanes;
                this.clipIntersection = source.clipIntersection;
                this.clipShadows = source.clipShadows;
                this.shadowSide = source.shadowSide;
                this.colorWrite = source.colorWrite;
                this.precision = source.precision;
                this.polygonOffset = source.polygonOffset;
                this.polygonOffsetFactor = source.polygonOffsetFactor;
                this.polygonOffsetUnits = source.polygonOffsetUnits;
                this.dithering = source.dithering;
                this.alphaTest = source.alphaTest;
                this.alphaToCoverage = source.alphaToCoverage;
                this.premultipliedAlpha = source.premultipliedAlpha;
                this.visible = source.visible;
                this.toneMapped = source.toneMapped;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.dispatchEvent({
                  type: 'dispose'
                });
              }
            }, {
              key: "needsUpdate",
              set: function set(value) {
                if (value === true) this.version++;
              }
            }]);
            return _Material;
          }(_EventDispatcher);
          var _MeshBasicMaterial = /*#__PURE__*/function (_Material2) {
            _inherits(_MeshBasicMaterial, _Material2);
            var _super20 = _createSuper(_MeshBasicMaterial);
            function _MeshBasicMaterial(parameters) {
              var _this21;
              _classCallCheck2(this, _MeshBasicMaterial);
              _this21 = _super20.call(this);
              _this21.isMeshBasicMaterial = true;
              _this21.type = 'MeshBasicMaterial';
              _this21.color = new _Color(0xffffff); // emissive
              _this21.map = null;
              _this21.lightMap = null;
              _this21.lightMapIntensity = 1.0;
              _this21.aoMap = null;
              _this21.aoMapIntensity = 1.0;
              _this21.specularMap = null;
              _this21.alphaMap = null;
              _this21.envMap = null;
              _this21.combine = _MultiplyOperation;
              _this21.reflectivity = 1;
              _this21.refractionRatio = 0.98;
              _this21.wireframe = false;
              _this21.wireframeLinewidth = 1;
              _this21.wireframeLinecap = 'round';
              _this21.wireframeLinejoin = 'round';
              _this21.fog = true;
              _this21.setValues(parameters);
              return _this21;
            }
            _createClass2(_MeshBasicMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _MeshBasicMaterial;
          }(_Material);
          var _vector$9 = /*@__PURE__*/new _Vector2();
          var _vector2$1 = /*@__PURE__*/new _Vector();
          var _BufferAttribute = /*#__PURE__*/function () {
            function _BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _BufferAttribute);
              if (Array.isArray(array)) {
                throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
              }
              this.isBufferAttribute = true;
              this.name = '';
              this.array = array;
              this.itemSize = itemSize;
              this.count = array !== undefined ? array.length / itemSize : 0;
              this.normalized = normalized === true;
              this.usage = _StaticDrawUsage;
              this.updateRange = {
                offset: 0,
                count: -1
              };
              this.version = 0;
            }
            _createClass2(_BufferAttribute, [{
              key: "onUploadCallback",
              value: function onUploadCallback() {}
            }, {
              key: "needsUpdate",
              set: function set(value) {
                if (value === true) this.version++;
              }
            }, {
              key: "setUsage",
              value: function setUsage(value) {
                this.usage = value;
                return this;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.name = source.name;
                this.array = new source.array.constructor(source.array);
                this.itemSize = source.itemSize;
                this.count = source.count;
                this.normalized = source.normalized;
                this.usage = source.usage;
                return this;
              }
            }, {
              key: "copyAt",
              value: function copyAt(index1, attribute, index2) {
                index1 *= this.itemSize;
                index2 *= attribute.itemSize;
                for (var i = 0, l = this.itemSize; i < l; i++) {
                  this.array[index1 + i] = attribute.array[index2 + i];
                }
                return this;
              }
            }, {
              key: "copyArray",
              value: function copyArray(array) {
                this.array.set(array);
                return this;
              }
            }, {
              key: "applyMatrix3",
              value: function applyMatrix3(m) {
                if (this.itemSize === 2) {
                  for (var i = 0, l = this.count; i < l; i++) {
                    _vector2$1.fromBufferAttribute(this, i);
                    _vector2$1.applyMatrix3(m);
                    this.setXY(i, _vector2$1.x, _vector2$1.y);
                  }
                } else if (this.itemSize === 3) {
                  for (var _i7 = 0, _l3 = this.count; _i7 < _l3; _i7++) {
                    _vector$9.fromBufferAttribute(this, _i7);
                    _vector$9.applyMatrix3(m);
                    this.setXYZ(_i7, _vector$9.x, _vector$9.y, _vector$9.z);
                  }
                }
                return this;
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(m) {
                for (var i = 0, l = this.count; i < l; i++) {
                  _vector$9.fromBufferAttribute(this, i);
                  _vector$9.applyMatrix4(m);
                  this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
                }
                return this;
              }
            }, {
              key: "applyNormalMatrix",
              value: function applyNormalMatrix(m) {
                for (var i = 0, l = this.count; i < l; i++) {
                  _vector$9.fromBufferAttribute(this, i);
                  _vector$9.applyNormalMatrix(m);
                  this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
                }
                return this;
              }
            }, {
              key: "transformDirection",
              value: function transformDirection(m) {
                for (var i = 0, l = this.count; i < l; i++) {
                  _vector$9.fromBufferAttribute(this, i);
                  _vector$9.transformDirection(m);
                  this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
                }
                return this;
              }
            }, {
              key: "set",
              value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                // Matching BufferAttribute constructor, do not normalize the array.
                this.array.set(value, offset);
                return this;
              }
            }, {
              key: "getX",
              value: function getX(index) {
                var x = this.array[index * this.itemSize];
                if (this.normalized) x = denormalize(x, this.array);
                return x;
              }
            }, {
              key: "setX",
              value: function setX(index, x) {
                if (this.normalized) x = normalize(x, this.array);
                this.array[index * this.itemSize] = x;
                return this;
              }
            }, {
              key: "getY",
              value: function getY(index) {
                var y = this.array[index * this.itemSize + 1];
                if (this.normalized) y = denormalize(y, this.array);
                return y;
              }
            }, {
              key: "setY",
              value: function setY(index, y) {
                if (this.normalized) y = normalize(y, this.array);
                this.array[index * this.itemSize + 1] = y;
                return this;
              }
            }, {
              key: "getZ",
              value: function getZ(index) {
                var z = this.array[index * this.itemSize + 2];
                if (this.normalized) z = denormalize(z, this.array);
                return z;
              }
            }, {
              key: "setZ",
              value: function setZ(index, z) {
                if (this.normalized) z = normalize(z, this.array);
                this.array[index * this.itemSize + 2] = z;
                return this;
              }
            }, {
              key: "getW",
              value: function getW(index) {
                var w = this.array[index * this.itemSize + 3];
                if (this.normalized) w = denormalize(w, this.array);
                return w;
              }
            }, {
              key: "setW",
              value: function setW(index, w) {
                if (this.normalized) w = normalize(w, this.array);
                this.array[index * this.itemSize + 3] = w;
                return this;
              }
            }, {
              key: "setXY",
              value: function setXY(index, x, y) {
                index *= this.itemSize;
                if (this.normalized) {
                  x = normalize(x, this.array);
                  y = normalize(y, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                return this;
              }
            }, {
              key: "setXYZ",
              value: function setXYZ(index, x, y, z) {
                index *= this.itemSize;
                if (this.normalized) {
                  x = normalize(x, this.array);
                  y = normalize(y, this.array);
                  z = normalize(z, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                return this;
              }
            }, {
              key: "setXYZW",
              value: function setXYZW(index, x, y, z, w) {
                index *= this.itemSize;
                if (this.normalized) {
                  x = normalize(x, this.array);
                  y = normalize(y, this.array);
                  z = normalize(z, this.array);
                  w = normalize(w, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                this.array[index + 3] = w;
                return this;
              }
            }, {
              key: "onUpload",
              value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = {
                  itemSize: this.itemSize,
                  type: this.array.constructor.name,
                  array: Array.from(this.array),
                  normalized: this.normalized
                };
                if (this.name !== '') data.name = this.name;
                if (this.usage !== _StaticDrawUsage) data.usage = this.usage;
                if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
                return data;
              } // @deprecated
            }, {
              key: "copyColorsArray",
              value: function copyColorsArray() {
                console.error('THREE.BufferAttribute: copyColorsArray() was removed in r144.');
              }
            }, {
              key: "copyVector2sArray",
              value: function copyVector2sArray() {
                console.error('THREE.BufferAttribute: copyVector2sArray() was removed in r144.');
              }
            }, {
              key: "copyVector3sArray",
              value: function copyVector3sArray() {
                console.error('THREE.BufferAttribute: copyVector3sArray() was removed in r144.');
              }
            }, {
              key: "copyVector4sArray",
              value: function copyVector4sArray() {
                console.error('THREE.BufferAttribute: copyVector4sArray() was removed in r144.');
              }
            }]);
            return _BufferAttribute;
          }(); //
          var _Int8BufferAttribute = /*#__PURE__*/function (_BufferAttribute2) {
            _inherits(_Int8BufferAttribute, _BufferAttribute2);
            var _super21 = _createSuper(_Int8BufferAttribute);
            function _Int8BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Int8BufferAttribute);
              return _super21.call(this, new Int8Array(array), itemSize, normalized);
            }
            return _createClass2(_Int8BufferAttribute);
          }(_BufferAttribute);
          var _Uint8BufferAttribute = /*#__PURE__*/function (_BufferAttribute3) {
            _inherits(_Uint8BufferAttribute, _BufferAttribute3);
            var _super22 = _createSuper(_Uint8BufferAttribute);
            function _Uint8BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Uint8BufferAttribute);
              return _super22.call(this, new Uint8Array(array), itemSize, normalized);
            }
            return _createClass2(_Uint8BufferAttribute);
          }(_BufferAttribute);
          var _Uint8ClampedBufferAttribute = /*#__PURE__*/function (_BufferAttribute4) {
            _inherits(_Uint8ClampedBufferAttribute, _BufferAttribute4);
            var _super23 = _createSuper(_Uint8ClampedBufferAttribute);
            function _Uint8ClampedBufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Uint8ClampedBufferAttribute);
              return _super23.call(this, new Uint8ClampedArray(array), itemSize, normalized);
            }
            return _createClass2(_Uint8ClampedBufferAttribute);
          }(_BufferAttribute);
          var _Int16BufferAttribute = /*#__PURE__*/function (_BufferAttribute5) {
            _inherits(_Int16BufferAttribute, _BufferAttribute5);
            var _super24 = _createSuper(_Int16BufferAttribute);
            function _Int16BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Int16BufferAttribute);
              return _super24.call(this, new Int16Array(array), itemSize, normalized);
            }
            return _createClass2(_Int16BufferAttribute);
          }(_BufferAttribute);
          var _Uint16BufferAttribute = /*#__PURE__*/function (_BufferAttribute6) {
            _inherits(_Uint16BufferAttribute, _BufferAttribute6);
            var _super25 = _createSuper(_Uint16BufferAttribute);
            function _Uint16BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Uint16BufferAttribute);
              return _super25.call(this, new Uint16Array(array), itemSize, normalized);
            }
            return _createClass2(_Uint16BufferAttribute);
          }(_BufferAttribute);
          var _Int32BufferAttribute = /*#__PURE__*/function (_BufferAttribute7) {
            _inherits(_Int32BufferAttribute, _BufferAttribute7);
            var _super26 = _createSuper(_Int32BufferAttribute);
            function _Int32BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Int32BufferAttribute);
              return _super26.call(this, new Int32Array(array), itemSize, normalized);
            }
            return _createClass2(_Int32BufferAttribute);
          }(_BufferAttribute);
          var _Uint32BufferAttribute = /*#__PURE__*/function (_BufferAttribute8) {
            _inherits(_Uint32BufferAttribute, _BufferAttribute8);
            var _super27 = _createSuper(_Uint32BufferAttribute);
            function _Uint32BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Uint32BufferAttribute);
              return _super27.call(this, new Uint32Array(array), itemSize, normalized);
            }
            return _createClass2(_Uint32BufferAttribute);
          }(_BufferAttribute);
          var _Float16BufferAttribute = /*#__PURE__*/function (_BufferAttribute9) {
            _inherits(_Float16BufferAttribute, _BufferAttribute9);
            var _super28 = _createSuper(_Float16BufferAttribute);
            function _Float16BufferAttribute(array, itemSize, normalized) {
              var _this22;
              _classCallCheck2(this, _Float16BufferAttribute);
              _this22 = _super28.call(this, new Uint16Array(array), itemSize, normalized);
              _this22.isFloat16BufferAttribute = true;
              return _this22;
            }
            return _createClass2(_Float16BufferAttribute);
          }(_BufferAttribute);
          var _Float32BufferAttribute = /*#__PURE__*/function (_BufferAttribute10) {
            _inherits(_Float32BufferAttribute, _BufferAttribute10);
            var _super29 = _createSuper(_Float32BufferAttribute);
            function _Float32BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Float32BufferAttribute);
              return _super29.call(this, new Float32Array(array), itemSize, normalized);
            }
            return _createClass2(_Float32BufferAttribute);
          }(_BufferAttribute);
          var _Float64BufferAttribute = /*#__PURE__*/function (_BufferAttribute11) {
            _inherits(_Float64BufferAttribute, _BufferAttribute11);
            var _super30 = _createSuper(_Float64BufferAttribute);
            function _Float64BufferAttribute(array, itemSize, normalized) {
              _classCallCheck2(this, _Float64BufferAttribute);
              return _super30.call(this, new Float64Array(array), itemSize, normalized);
            }
            return _createClass2(_Float64BufferAttribute);
          }(_BufferAttribute);
          var _id$1 = 0;
          var _m1 = /*@__PURE__*/new _Matrix2();
          var _obj = /*@__PURE__*/new _Object3D();
          var _offset = /*@__PURE__*/new _Vector2();
          var _box$1 = /*@__PURE__*/new _Box2();
          var _boxMorphTargets = /*@__PURE__*/new _Box2();
          var _vector$8 = /*@__PURE__*/new _Vector2();
          var _BufferGeometry = /*#__PURE__*/function (_EventDispatcher6) {
            _inherits(_BufferGeometry, _EventDispatcher6);
            var _super31 = _createSuper(_BufferGeometry);
            function _BufferGeometry() {
              var _this23;
              _classCallCheck2(this, _BufferGeometry);
              _this23 = _super31.call(this);
              _this23.isBufferGeometry = true;
              Object.defineProperty(_assertThisInitialized(_this23), 'id', {
                value: _id$1++
              });
              _this23.uuid = generateUUID();
              _this23.name = '';
              _this23.type = 'BufferGeometry';
              _this23.index = null;
              _this23.attributes = {};
              _this23.morphAttributes = {};
              _this23.morphTargetsRelative = false;
              _this23.groups = [];
              _this23.boundingBox = null;
              _this23.boundingSphere = null;
              _this23.drawRange = {
                start: 0,
                count: Infinity
              };
              _this23.userData = {};
              return _this23;
            }
            _createClass2(_BufferGeometry, [{
              key: "getIndex",
              value: function getIndex() {
                return this.index;
              }
            }, {
              key: "setIndex",
              value: function setIndex(index) {
                if (Array.isArray(index)) {
                  this.index = new (arrayNeedsUint32(index) ? _Uint32BufferAttribute : _Uint16BufferAttribute)(index, 1);
                } else {
                  this.index = index;
                }
                return this;
              }
            }, {
              key: "getAttribute",
              value: function getAttribute(name) {
                return this.attributes[name];
              }
            }, {
              key: "setAttribute",
              value: function setAttribute(name, attribute) {
                this.attributes[name] = attribute;
                return this;
              }
            }, {
              key: "deleteAttribute",
              value: function deleteAttribute(name) {
                delete this.attributes[name];
                return this;
              }
            }, {
              key: "hasAttribute",
              value: function hasAttribute(name) {
                return this.attributes[name] !== undefined;
              }
            }, {
              key: "addGroup",
              value: function addGroup(start, count) {
                var materialIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                this.groups.push({
                  start: start,
                  count: count,
                  materialIndex: materialIndex
                });
              }
            }, {
              key: "clearGroups",
              value: function clearGroups() {
                this.groups = [];
              }
            }, {
              key: "setDrawRange",
              value: function setDrawRange(start, count) {
                this.drawRange.start = start;
                this.drawRange.count = count;
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix) {
                var position = this.attributes.position;
                if (position !== undefined) {
                  position.applyMatrix4(matrix);
                  position.needsUpdate = true;
                }
                var normal = this.attributes.normal;
                if (normal !== undefined) {
                  var normalMatrix = new _Matrix().getNormalMatrix(matrix);
                  normal.applyNormalMatrix(normalMatrix);
                  normal.needsUpdate = true;
                }
                var tangent = this.attributes.tangent;
                if (tangent !== undefined) {
                  tangent.transformDirection(matrix);
                  tangent.needsUpdate = true;
                }
                if (this.boundingBox !== null) {
                  this.computeBoundingBox();
                }
                if (this.boundingSphere !== null) {
                  this.computeBoundingSphere();
                }
                return this;
              }
            }, {
              key: "applyQuaternion",
              value: function applyQuaternion(q) {
                _m1.makeRotationFromQuaternion(q);
                this.applyMatrix4(_m1);
                return this;
              }
            }, {
              key: "rotateX",
              value: function rotateX(angle) {
                // rotate geometry around world x-axis
                _m1.makeRotationX(angle);
                this.applyMatrix4(_m1);
                return this;
              }
            }, {
              key: "rotateY",
              value: function rotateY(angle) {
                // rotate geometry around world y-axis
                _m1.makeRotationY(angle);
                this.applyMatrix4(_m1);
                return this;
              }
            }, {
              key: "rotateZ",
              value: function rotateZ(angle) {
                // rotate geometry around world z-axis
                _m1.makeRotationZ(angle);
                this.applyMatrix4(_m1);
                return this;
              }
            }, {
              key: "translate",
              value: function translate(x, y, z) {
                // translate geometry
                _m1.makeTranslation(x, y, z);
                this.applyMatrix4(_m1);
                return this;
              }
            }, {
              key: "scale",
              value: function scale(x, y, z) {
                // scale geometry
                _m1.makeScale(x, y, z);
                this.applyMatrix4(_m1);
                return this;
              }
            }, {
              key: "lookAt",
              value: function lookAt(vector) {
                _obj.lookAt(vector);
                _obj.updateMatrix();
                this.applyMatrix4(_obj.matrix);
                return this;
              }
            }, {
              key: "center",
              value: function center() {
                this.computeBoundingBox();
                this.boundingBox.getCenter(_offset).negate();
                this.translate(_offset.x, _offset.y, _offset.z);
                return this;
              }
            }, {
              key: "setFromPoints",
              value: function setFromPoints(points) {
                var position = [];
                for (var i = 0, l = points.length; i < l; i++) {
                  var point = points[i];
                  position.push(point.x, point.y, point.z || 0);
                }
                this.setAttribute('position', new _Float32BufferAttribute(position, 3));
                return this;
              }
            }, {
              key: "computeBoundingBox",
              value: function computeBoundingBox() {
                if (this.boundingBox === null) {
                  this.boundingBox = new _Box2();
                }
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                  console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
                  this.boundingBox.set(new _Vector2(-Infinity, -Infinity, -Infinity), new _Vector2(+Infinity, +Infinity, +Infinity));
                  return;
                }
                if (position !== undefined) {
                  this.boundingBox.setFromBufferAttribute(position); // process morph attributes if present
                  if (morphAttributesPosition) {
                    for (var i = 0, il = morphAttributesPosition.length; i < il; i++) {
                      var morphAttribute = morphAttributesPosition[i];
                      _box$1.setFromBufferAttribute(morphAttribute);
                      if (this.morphTargetsRelative) {
                        _vector$8.addVectors(this.boundingBox.min, _box$1.min);
                        this.boundingBox.expandByPoint(_vector$8);
                        _vector$8.addVectors(this.boundingBox.max, _box$1.max);
                        this.boundingBox.expandByPoint(_vector$8);
                      } else {
                        this.boundingBox.expandByPoint(_box$1.min);
                        this.boundingBox.expandByPoint(_box$1.max);
                      }
                    }
                  }
                } else {
                  this.boundingBox.makeEmpty();
                }
                if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
                  console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
                }
              }
            }, {
              key: "computeBoundingSphere",
              value: function computeBoundingSphere() {
                if (this.boundingSphere === null) {
                  this.boundingSphere = new _Sphere();
                }
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                  console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
                  this.boundingSphere.set(new _Vector2(), Infinity);
                  return;
                }
                if (position) {
                  // first, find the center of the bounding sphere
                  var center = this.boundingSphere.center;
                  _box$1.setFromBufferAttribute(position); // process morph attributes if present
                  if (morphAttributesPosition) {
                    for (var i = 0, il = morphAttributesPosition.length; i < il; i++) {
                      var morphAttribute = morphAttributesPosition[i];
                      _boxMorphTargets.setFromBufferAttribute(morphAttribute);
                      if (this.morphTargetsRelative) {
                        _vector$8.addVectors(_box$1.min, _boxMorphTargets.min);
                        _box$1.expandByPoint(_vector$8);
                        _vector$8.addVectors(_box$1.max, _boxMorphTargets.max);
                        _box$1.expandByPoint(_vector$8);
                      } else {
                        _box$1.expandByPoint(_boxMorphTargets.min);
                        _box$1.expandByPoint(_boxMorphTargets.max);
                      }
                    }
                  }
                  _box$1.getCenter(center); // second, try to find a boundingSphere with a radius smaller than the
                  // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
                  var maxRadiusSq = 0;
                  for (var _i8 = 0, _il = position.count; _i8 < _il; _i8++) {
                    _vector$8.fromBufferAttribute(position, _i8);
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
                  } // process morph attributes if present
                  if (morphAttributesPosition) {
                    for (var _i9 = 0, _il2 = morphAttributesPosition.length; _i9 < _il2; _i9++) {
                      var _morphAttribute = morphAttributesPosition[_i9];
                      var morphTargetsRelative = this.morphTargetsRelative;
                      for (var j = 0, jl = _morphAttribute.count; j < jl; j++) {
                        _vector$8.fromBufferAttribute(_morphAttribute, j);
                        if (morphTargetsRelative) {
                          _offset.fromBufferAttribute(position, j);
                          _vector$8.add(_offset);
                        }
                        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
                      }
                    }
                  }
                  this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
                  if (isNaN(this.boundingSphere.radius)) {
                    console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                  }
                }
              }
            }, {
              key: "computeTangents",
              value: function computeTangents() {
                var index = this.index;
                var attributes = this.attributes; // based on http://www.terathon.com/code/tangent.html
                // (per vertex tangents)
                if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
                  console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
                  return;
                }
                var indices = index.array;
                var positions = attributes.position.array;
                var normals = attributes.normal.array;
                var uvs = attributes.uv.array;
                var nVertices = positions.length / 3;
                if (this.hasAttribute('tangent') === false) {
                  this.setAttribute('tangent', new _BufferAttribute(new Float32Array(4 * nVertices), 4));
                }
                var tangents = this.getAttribute('tangent').array;
                var tan1 = [],
                  tan2 = [];
                for (var i = 0; i < nVertices; i++) {
                  tan1[i] = new _Vector2();
                  tan2[i] = new _Vector2();
                }
                var vA = new _Vector2(),
                  vB = new _Vector2(),
                  vC = new _Vector2(),
                  uvA = new _Vector(),
                  uvB = new _Vector(),
                  uvC = new _Vector(),
                  sdir = new _Vector2(),
                  tdir = new _Vector2();
                function handleTriangle(a, b, c) {
                  vA.fromArray(positions, a * 3);
                  vB.fromArray(positions, b * 3);
                  vC.fromArray(positions, c * 3);
                  uvA.fromArray(uvs, a * 2);
                  uvB.fromArray(uvs, b * 2);
                  uvC.fromArray(uvs, c * 2);
                  vB.sub(vA);
                  vC.sub(vA);
                  uvB.sub(uvA);
                  uvC.sub(uvA);
                  var r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y); // silently ignore degenerate uv triangles having coincident or colinear vertices
                  if (!isFinite(r)) return;
                  sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
                  tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
                  tan1[a].add(sdir);
                  tan1[b].add(sdir);
                  tan1[c].add(sdir);
                  tan2[a].add(tdir);
                  tan2[b].add(tdir);
                  tan2[c].add(tdir);
                }
                var groups = this.groups;
                if (groups.length === 0) {
                  groups = [{
                    start: 0,
                    count: indices.length
                  }];
                }
                for (var _i10 = 0, il = groups.length; _i10 < il; ++_i10) {
                  var group = groups[_i10];
                  var start = group.start;
                  var count = group.count;
                  for (var j = start, jl = start + count; j < jl; j += 3) {
                    handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
                  }
                }
                var tmp = new _Vector2(),
                  tmp2 = new _Vector2();
                var n = new _Vector2(),
                  n2 = new _Vector2();
                function handleVertex(v) {
                  n.fromArray(normals, v * 3);
                  n2.copy(n);
                  var t = tan1[v]; // Gram-Schmidt orthogonalize
                  tmp.copy(t);
                  tmp.sub(n.multiplyScalar(n.dot(t))).normalize(); // Calculate handedness
                  tmp2.crossVectors(n2, t);
                  var test = tmp2.dot(tan2[v]);
                  var w = test < 0.0 ? -1.0 : 1.0;
                  tangents[v * 4] = tmp.x;
                  tangents[v * 4 + 1] = tmp.y;
                  tangents[v * 4 + 2] = tmp.z;
                  tangents[v * 4 + 3] = w;
                }
                for (var _i11 = 0, _il3 = groups.length; _i11 < _il3; ++_i11) {
                  var _group = groups[_i11];
                  var _start2 = _group.start;
                  var _count = _group.count;
                  for (var _j = _start2, _jl = _start2 + _count; _j < _jl; _j += 3) {
                    handleVertex(indices[_j + 0]);
                    handleVertex(indices[_j + 1]);
                    handleVertex(indices[_j + 2]);
                  }
                }
              }
            }, {
              key: "computeVertexNormals",
              value: function computeVertexNormals() {
                var index = this.index;
                var positionAttribute = this.getAttribute('position');
                if (positionAttribute !== undefined) {
                  var normalAttribute = this.getAttribute('normal');
                  if (normalAttribute === undefined) {
                    normalAttribute = new _BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
                    this.setAttribute('normal', normalAttribute);
                  } else {
                    // reset existing normals to zero
                    for (var i = 0, il = normalAttribute.count; i < il; i++) {
                      normalAttribute.setXYZ(i, 0, 0, 0);
                    }
                  }
                  var pA = new _Vector2(),
                    pB = new _Vector2(),
                    pC = new _Vector2();
                  var nA = new _Vector2(),
                    nB = new _Vector2(),
                    nC = new _Vector2();
                  var cb = new _Vector2(),
                    ab = new _Vector2(); // indexed elements
                  if (index) {
                    for (var _i12 = 0, _il4 = index.count; _i12 < _il4; _i12 += 3) {
                      var vA = index.getX(_i12 + 0);
                      var vB = index.getX(_i12 + 1);
                      var vC = index.getX(_i12 + 2);
                      pA.fromBufferAttribute(positionAttribute, vA);
                      pB.fromBufferAttribute(positionAttribute, vB);
                      pC.fromBufferAttribute(positionAttribute, vC);
                      cb.subVectors(pC, pB);
                      ab.subVectors(pA, pB);
                      cb.cross(ab);
                      nA.fromBufferAttribute(normalAttribute, vA);
                      nB.fromBufferAttribute(normalAttribute, vB);
                      nC.fromBufferAttribute(normalAttribute, vC);
                      nA.add(cb);
                      nB.add(cb);
                      nC.add(cb);
                      normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                      normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                      normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
                    }
                  } else {
                    // non-indexed elements (unconnected triangle soup)
                    for (var _i13 = 0, _il5 = positionAttribute.count; _i13 < _il5; _i13 += 3) {
                      pA.fromBufferAttribute(positionAttribute, _i13 + 0);
                      pB.fromBufferAttribute(positionAttribute, _i13 + 1);
                      pC.fromBufferAttribute(positionAttribute, _i13 + 2);
                      cb.subVectors(pC, pB);
                      ab.subVectors(pA, pB);
                      cb.cross(ab);
                      normalAttribute.setXYZ(_i13 + 0, cb.x, cb.y, cb.z);
                      normalAttribute.setXYZ(_i13 + 1, cb.x, cb.y, cb.z);
                      normalAttribute.setXYZ(_i13 + 2, cb.x, cb.y, cb.z);
                    }
                  }
                  this.normalizeNormals();
                  normalAttribute.needsUpdate = true;
                }
              } // @deprecated since r144
            }, {
              key: "merge",
              value: function merge() {
                console.error('THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead.');
                return this;
              }
            }, {
              key: "normalizeNormals",
              value: function normalizeNormals() {
                var normals = this.attributes.normal;
                for (var i = 0, il = normals.count; i < il; i++) {
                  _vector$8.fromBufferAttribute(normals, i);
                  _vector$8.normalize();
                  normals.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
                }
              }
            }, {
              key: "toNonIndexed",
              value: function toNonIndexed() {
                function convertBufferAttribute(attribute, indices) {
                  var array = attribute.array;
                  var itemSize = attribute.itemSize;
                  var normalized = attribute.normalized;
                  var array2 = new array.constructor(indices.length * itemSize);
                  var index = 0,
                    index2 = 0;
                  for (var i = 0, l = indices.length; i < l; i++) {
                    if (attribute.isInterleavedBufferAttribute) {
                      index = indices[i] * attribute.data.stride + attribute.offset;
                    } else {
                      index = indices[i] * itemSize;
                    }
                    for (var j = 0; j < itemSize; j++) {
                      array2[index2++] = array[index++];
                    }
                  }
                  return new _BufferAttribute(array2, itemSize, normalized);
                } //
                if (this.index === null) {
                  console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
                  return this;
                }
                var geometry2 = new _BufferGeometry();
                var indices = this.index.array;
                var attributes = this.attributes; // attributes
                for (var name in attributes) {
                  var attribute = attributes[name];
                  var newAttribute = convertBufferAttribute(attribute, indices);
                  geometry2.setAttribute(name, newAttribute);
                } // morph attributes
                var morphAttributes = this.morphAttributes;
                for (var _name in morphAttributes) {
                  var morphArray = [];
                  var morphAttribute = morphAttributes[_name]; // morphAttribute: array of Float32BufferAttributes
                  for (var i = 0, il = morphAttribute.length; i < il; i++) {
                    var _attribute = morphAttribute[i];
                    var _newAttribute = convertBufferAttribute(_attribute, indices);
                    morphArray.push(_newAttribute);
                  }
                  geometry2.morphAttributes[_name] = morphArray;
                }
                geometry2.morphTargetsRelative = this.morphTargetsRelative; // groups
                var groups = this.groups;
                for (var _i14 = 0, l = groups.length; _i14 < l; _i14++) {
                  var group = groups[_i14];
                  geometry2.addGroup(group.start, group.count, group.materialIndex);
                }
                return geometry2;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = {
                  metadata: {
                    version: 4.5,
                    type: 'BufferGeometry',
                    generator: 'BufferGeometry.toJSON'
                  }
                }; // standard BufferGeometry serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (Object.keys(this.userData).length > 0) data.userData = this.userData;
                if (this.parameters !== undefined) {
                  var parameters = this.parameters;
                  for (var key in parameters) {
                    if (parameters[key] !== undefined) data[key] = parameters[key];
                  }
                  return data;
                } // for simplicity the code assumes attributes are not shared across geometries, see #15811
                data.data = {
                  attributes: {}
                };
                var index = this.index;
                if (index !== null) {
                  data.data.index = {
                    type: index.array.constructor.name,
                    array: Array.prototype.slice.call(index.array)
                  };
                }
                var attributes = this.attributes;
                for (var _key in attributes) {
                  var attribute = attributes[_key];
                  data.data.attributes[_key] = attribute.toJSON(data.data);
                }
                var morphAttributes = {};
                var hasMorphAttributes = false;
                for (var _key2 in this.morphAttributes) {
                  var attributeArray = this.morphAttributes[_key2];
                  var array = [];
                  for (var i = 0, il = attributeArray.length; i < il; i++) {
                    var _attribute2 = attributeArray[i];
                    array.push(_attribute2.toJSON(data.data));
                  }
                  if (array.length > 0) {
                    morphAttributes[_key2] = array;
                    hasMorphAttributes = true;
                  }
                }
                if (hasMorphAttributes) {
                  data.data.morphAttributes = morphAttributes;
                  data.data.morphTargetsRelative = this.morphTargetsRelative;
                }
                var groups = this.groups;
                if (groups.length > 0) {
                  data.data.groups = JSON.parse(JSON.stringify(groups));
                }
                var boundingSphere = this.boundingSphere;
                if (boundingSphere !== null) {
                  data.data.boundingSphere = {
                    center: boundingSphere.center.toArray(),
                    radius: boundingSphere.radius
                  };
                }
                return data;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                // reset
                this.index = null;
                this.attributes = {};
                this.morphAttributes = {};
                this.groups = [];
                this.boundingBox = null;
                this.boundingSphere = null; // used for storing cloned, shared data
                var data = {}; // name
                this.name = source.name; // index
                var index = source.index;
                if (index !== null) {
                  this.setIndex(index.clone(data));
                } // attributes
                var attributes = source.attributes;
                for (var name in attributes) {
                  var attribute = attributes[name];
                  this.setAttribute(name, attribute.clone(data));
                } // morph attributes
                var morphAttributes = source.morphAttributes;
                for (var _name2 in morphAttributes) {
                  var array = [];
                  var morphAttribute = morphAttributes[_name2]; // morphAttribute: array of Float32BufferAttributes
                  for (var i = 0, l = morphAttribute.length; i < l; i++) {
                    array.push(morphAttribute[i].clone(data));
                  }
                  this.morphAttributes[_name2] = array;
                }
                this.morphTargetsRelative = source.morphTargetsRelative; // groups
                var groups = source.groups;
                for (var _i15 = 0, _l4 = groups.length; _i15 < _l4; _i15++) {
                  var group = groups[_i15];
                  this.addGroup(group.start, group.count, group.materialIndex);
                } // bounding box
                var boundingBox = source.boundingBox;
                if (boundingBox !== null) {
                  this.boundingBox = boundingBox.clone();
                } // bounding sphere
                var boundingSphere = source.boundingSphere;
                if (boundingSphere !== null) {
                  this.boundingSphere = boundingSphere.clone();
                } // draw range
                this.drawRange.start = source.drawRange.start;
                this.drawRange.count = source.drawRange.count; // user data
                this.userData = source.userData; // geometry generator parameters
                if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.dispatchEvent({
                  type: 'dispose'
                });
              }
            }]);
            return _BufferGeometry;
          }(_EventDispatcher);
          var _inverseMatrix$2 = /*@__PURE__*/new _Matrix2();
          var _ray$2 = /*@__PURE__*/new _Ray();
          var _sphere$3 = /*@__PURE__*/new _Sphere();
          var _vA$1 = /*@__PURE__*/new _Vector2();
          var _vB$1 = /*@__PURE__*/new _Vector2();
          var _vC$1 = /*@__PURE__*/new _Vector2();
          var _tempA = /*@__PURE__*/new _Vector2();
          var _tempB = /*@__PURE__*/new _Vector2();
          var _tempC = /*@__PURE__*/new _Vector2();
          var _morphA = /*@__PURE__*/new _Vector2();
          var _morphB = /*@__PURE__*/new _Vector2();
          var _morphC = /*@__PURE__*/new _Vector2();
          var _uvA$1 = /*@__PURE__*/new _Vector();
          var _uvB$1 = /*@__PURE__*/new _Vector();
          var _uvC$1 = /*@__PURE__*/new _Vector();
          var _intersectionPoint = /*@__PURE__*/new _Vector2();
          var _intersectionPointWorld = /*@__PURE__*/new _Vector2();
          var _Mesh = /*#__PURE__*/function (_Object3D2) {
            _inherits(_Mesh, _Object3D2);
            var _super32 = _createSuper(_Mesh);
            function _Mesh() {
              var _this24;
              var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _BufferGeometry();
              var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _MeshBasicMaterial();
              _classCallCheck2(this, _Mesh);
              _this24 = _super32.call(this);
              _this24.isMesh = true;
              _this24.type = 'Mesh';
              _this24.geometry = geometry;
              _this24.material = material;
              _this24.updateMorphTargets();
              return _this24;
            }
            _createClass2(_Mesh, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Mesh.prototype), "copy", this).call(this, source, recursive);
                if (source.morphTargetInfluences !== undefined) {
                  this.morphTargetInfluences = source.morphTargetInfluences.slice();
                }
                if (source.morphTargetDictionary !== undefined) {
                  this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
                }
                this.material = source.material;
                this.geometry = source.geometry;
                return this;
              }
            }, {
              key: "updateMorphTargets",
              value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                  var morphAttribute = morphAttributes[keys[0]];
                  if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for (var m = 0, ml = morphAttribute.length; m < ml; m++) {
                      var name = morphAttribute[m].name || String(m);
                      this.morphTargetInfluences.push(0);
                      this.morphTargetDictionary[name] = m;
                    }
                  }
                }
              }
            }, {
              key: "raycast",
              value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var material = this.material;
                var matrixWorld = this.matrixWorld;
                if (material === undefined) return; // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                _sphere$3.copy(geometry.boundingSphere);
                _sphere$3.applyMatrix4(matrixWorld);
                if (raycaster.ray.intersectsSphere(_sphere$3) === false) return; //
                _inverseMatrix$2.copy(matrixWorld).invert();
                _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2); // Check boundingBox before continuing
                if (geometry.boundingBox !== null) {
                  if (_ray$2.intersectsBox(geometry.boundingBox) === false) return;
                }
                var intersection;
                var index = geometry.index;
                var position = geometry.attributes.position;
                var morphPosition = geometry.morphAttributes.position;
                var morphTargetsRelative = geometry.morphTargetsRelative;
                var uv = geometry.attributes.uv;
                var uv2 = geometry.attributes.uv2;
                var groups = geometry.groups;
                var drawRange = geometry.drawRange;
                if (index !== null) {
                  // indexed buffer geometry
                  if (Array.isArray(material)) {
                    for (var i = 0, il = groups.length; i < il; i++) {
                      var group = groups[i];
                      var groupMaterial = material[group.materialIndex];
                      var start = Math.max(group.start, drawRange.start);
                      var end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                      for (var j = start, jl = end; j < jl; j += 3) {
                        var a = index.getX(j);
                        var b = index.getX(j + 1);
                        var c = index.getX(j + 2);
                        intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                          intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                          intersection.face.materialIndex = group.materialIndex;
                          intersects.push(intersection);
                        }
                      }
                    }
                  } else {
                    var _start3 = Math.max(0, drawRange.start);
                    var _end2 = Math.min(index.count, drawRange.start + drawRange.count);
                    for (var _i16 = _start3, _il6 = _end2; _i16 < _il6; _i16 += 3) {
                      var _a = index.getX(_i16);
                      var _b = index.getX(_i16 + 1);
                      var _c = index.getX(_i16 + 2);
                      intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, _a, _b, _c);
                      if (intersection) {
                        intersection.faceIndex = Math.floor(_i16 / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                      }
                    }
                  }
                } else if (position !== undefined) {
                  // non-indexed buffer geometry
                  if (Array.isArray(material)) {
                    for (var _i17 = 0, _il7 = groups.length; _i17 < _il7; _i17++) {
                      var _group2 = groups[_i17];
                      var _groupMaterial = material[_group2.materialIndex];
                      var _start4 = Math.max(_group2.start, drawRange.start);
                      var _end3 = Math.min(position.count, Math.min(_group2.start + _group2.count, drawRange.start + drawRange.count));
                      for (var _j2 = _start4, _jl2 = _end3; _j2 < _jl2; _j2 += 3) {
                        var _a2 = _j2;
                        var _b2 = _j2 + 1;
                        var _c2 = _j2 + 2;
                        intersection = checkBufferGeometryIntersection(this, _groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, _a2, _b2, _c2);
                        if (intersection) {
                          intersection.faceIndex = Math.floor(_j2 / 3); // triangle number in non-indexed buffer semantics
                          intersection.face.materialIndex = _group2.materialIndex;
                          intersects.push(intersection);
                        }
                      }
                    }
                  } else {
                    var _start5 = Math.max(0, drawRange.start);
                    var _end4 = Math.min(position.count, drawRange.start + drawRange.count);
                    for (var _i18 = _start5, _il8 = _end4; _i18 < _il8; _i18 += 3) {
                      var _a3 = _i18;
                      var _b3 = _i18 + 1;
                      var _c3 = _i18 + 2;
                      intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, _a3, _b3, _c3);
                      if (intersection) {
                        intersection.faceIndex = Math.floor(_i18 / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                      }
                    }
                  }
                }
              }
            }]);
            return _Mesh;
          }(_Object3D);
          function checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
            var intersect;
            if (material.side === _BackSide) {
              intersect = ray.intersectTriangle(pC, pB, pA, true, point);
            } else {
              intersect = ray.intersectTriangle(pA, pB, pC, material.side !== _DoubleSide, point);
            }
            if (intersect === null) return null;
            _intersectionPointWorld.copy(point);
            _intersectionPointWorld.applyMatrix4(object.matrixWorld);
            var distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
            if (distance < raycaster.near || distance > raycaster.far) return null;
            return {
              distance: distance,
              point: _intersectionPointWorld.clone(),
              object: object
            };
          }
          function checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
            _vA$1.fromBufferAttribute(position, a);
            _vB$1.fromBufferAttribute(position, b);
            _vC$1.fromBufferAttribute(position, c);
            var morphInfluences = object.morphTargetInfluences;
            if (morphPosition && morphInfluences) {
              _morphA.set(0, 0, 0);
              _morphB.set(0, 0, 0);
              _morphC.set(0, 0, 0);
              for (var i = 0, il = morphPosition.length; i < il; i++) {
                var influence = morphInfluences[i];
                var morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morphAttribute, a);
                _tempB.fromBufferAttribute(morphAttribute, b);
                _tempC.fromBufferAttribute(morphAttribute, c);
                if (morphTargetsRelative) {
                  _morphA.addScaledVector(_tempA, influence);
                  _morphB.addScaledVector(_tempB, influence);
                  _morphC.addScaledVector(_tempC, influence);
                } else {
                  _morphA.addScaledVector(_tempA.sub(_vA$1), influence);
                  _morphB.addScaledVector(_tempB.sub(_vB$1), influence);
                  _morphC.addScaledVector(_tempC.sub(_vC$1), influence);
                }
              }
              _vA$1.add(_morphA);
              _vB$1.add(_morphB);
              _vC$1.add(_morphC);
            }
            if (object.isSkinnedMesh) {
              object.boneTransform(a, _vA$1);
              object.boneTransform(b, _vB$1);
              object.boneTransform(c, _vC$1);
            }
            var intersection = checkIntersection(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
            if (intersection) {
              if (uv) {
                _uvA$1.fromBufferAttribute(uv, a);
                _uvB$1.fromBufferAttribute(uv, b);
                _uvC$1.fromBufferAttribute(uv, c);
                intersection.uv = _Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new _Vector());
              }
              if (uv2) {
                _uvA$1.fromBufferAttribute(uv2, a);
                _uvB$1.fromBufferAttribute(uv2, b);
                _uvC$1.fromBufferAttribute(uv2, c);
                intersection.uv2 = _Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new _Vector());
              }
              var face = {
                a: a,
                b: b,
                c: c,
                normal: new _Vector2(),
                materialIndex: 0
              };
              _Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
              intersection.face = face;
            }
            return intersection;
          }
          var _BoxGeometry = /*#__PURE__*/function (_BufferGeometry2) {
            _inherits(_BoxGeometry, _BufferGeometry2);
            var _super33 = _createSuper(_BoxGeometry);
            function _BoxGeometry() {
              var _this25;
              var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var widthSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              var heightSegments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
              var depthSegments = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
              _classCallCheck2(this, _BoxGeometry);
              _this25 = _super33.call(this);
              _this25.type = 'BoxGeometry';
              _this25.parameters = {
                width: width,
                height: height,
                depth: depth,
                widthSegments: widthSegments,
                heightSegments: heightSegments,
                depthSegments: depthSegments
              };
              var scope = _assertThisInitialized(_this25); // segments
              widthSegments = Math.floor(widthSegments);
              heightSegments = Math.floor(heightSegments);
              depthSegments = Math.floor(depthSegments); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // helper variables
              var numberOfVertices = 0;
              var groupStart = 0; // build each side of the box geometry
              buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
              buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
              buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
              buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
              buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
              buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
              // build geometry
              _this25.setIndex(indices);
              _this25.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this25.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this25.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
                var segmentWidth = width / gridX;
                var segmentHeight = height / gridY;
                var widthHalf = width / 2;
                var heightHalf = height / 2;
                var depthHalf = depth / 2;
                var gridX1 = gridX + 1;
                var gridY1 = gridY + 1;
                var vertexCounter = 0;
                var groupCount = 0;
                var vector = new _Vector2(); // generate vertices, normals and uvs
                for (var iy = 0; iy < gridY1; iy++) {
                  var y = iy * segmentHeight - heightHalf;
                  for (var ix = 0; ix < gridX1; ix++) {
                    var x = ix * segmentWidth - widthHalf; // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf; // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z); // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1; // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z); // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY); // counters
                    vertexCounter += 1;
                  }
                } // indices
                // 1. you need three indices to draw a single face
                // 2. a single segment consists of two faces
                // 3. so we need to generate six (2*3) indices per segment
                for (var _iy = 0; _iy < gridY; _iy++) {
                  for (var _ix = 0; _ix < gridX; _ix++) {
                    var a = numberOfVertices + _ix + gridX1 * _iy;
                    var b = numberOfVertices + _ix + gridX1 * (_iy + 1);
                    var c = numberOfVertices + (_ix + 1) + gridX1 * (_iy + 1);
                    var d = numberOfVertices + (_ix + 1) + gridX1 * _iy; // faces
                    indices.push(a, b, d);
                    indices.push(b, c, d); // increase counter
                    groupCount += 6;
                  }
                } // add a group to the geometry. this will ensure multi material support
                scope.addGroup(groupStart, groupCount, materialIndex); // calculate new start value for groups
                groupStart += groupCount; // update total number of vertices
                numberOfVertices += vertexCounter;
              }
              return _this25;
            }
            _createClass2(_BoxGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
              }
            }]);
            return _BoxGeometry;
          }(_BufferGeometry);
          /**
          * Uniform Utilities
          */
          function cloneUniforms(src) {
            var dst = {};
            for (var u in src) {
              dst[u] = {};
              for (var p in src[u]) {
                var property = src[u][p];
                if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                  dst[u][p] = property.clone();
                } else if (Array.isArray(property)) {
                  dst[u][p] = property.slice();
                } else {
                  dst[u][p] = property;
                }
              }
            }
            return dst;
          }
          function mergeUniforms(uniforms) {
            var merged = {};
            for (var u = 0; u < uniforms.length; u++) {
              var _tmp = cloneUniforms(uniforms[u]);
              for (var p in _tmp) {
                merged[p] = _tmp[p];
              }
            }
            return merged;
          }
          function cloneUniformsGroups(src) {
            var dst = [];
            for (var u = 0; u < src.length; u++) {
              dst.push(src[u].clone());
            }
            return dst;
          }
          function getUnlitUniformColorSpace(renderer) {
            if (renderer.getRenderTarget() === null) {
              // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
              return renderer.outputEncoding === _sRGBEncoding ? _SRGBColorSpace : _LinearSRGBColorSpace;
            }
            return _LinearSRGBColorSpace;
          } // Legacy
          var _UniformsUtils = {
            clone: cloneUniforms,
            merge: mergeUniforms
          };
          var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
          var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
          var _ShaderMaterial = /*#__PURE__*/function (_Material3) {
            _inherits(_ShaderMaterial, _Material3);
            var _super34 = _createSuper(_ShaderMaterial);
            function _ShaderMaterial(parameters) {
              var _this26;
              _classCallCheck2(this, _ShaderMaterial);
              _this26 = _super34.call(this);
              _this26.isShaderMaterial = true;
              _this26.type = 'ShaderMaterial';
              _this26.defines = {};
              _this26.uniforms = {};
              _this26.uniformsGroups = [];
              _this26.vertexShader = default_vertex;
              _this26.fragmentShader = default_fragment;
              _this26.linewidth = 1;
              _this26.wireframe = false;
              _this26.wireframeLinewidth = 1;
              _this26.fog = false; // set to use scene fog
              _this26.lights = false; // set to use scene lights
              _this26.clipping = false; // set to use user-defined clipping planes
              _this26.extensions = {
                derivatives: false,
                // set to use derivatives
                fragDepth: false,
                // set to use fragment depth values
                drawBuffers: false,
                // set to use draw buffers
                shaderTextureLOD: false // set to use shader texture LOD
              }; // When rendered geometry doesn't include these attributes but the material does,
              // use these default values in WebGL. This avoids errors when buffer data is missing.
              _this26.defaultAttributeValues = {
                'color': [1, 1, 1],
                'uv': [0, 0],
                'uv2': [0, 0]
              };
              _this26.index0AttributeName = undefined;
              _this26.uniformsNeedUpdate = false;
              _this26.glslVersion = null;
              if (parameters !== undefined) {
                _this26.setValues(parameters);
              }
              return _this26;
            }
            _createClass2(_ShaderMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_ShaderMaterial.prototype), "copy", this).call(this, source);
                this.fragmentShader = source.fragmentShader;
                this.vertexShader = source.vertexShader;
                this.uniforms = cloneUniforms(source.uniforms);
                this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);
                this.defines = Object.assign({}, source.defines);
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.fog = source.fog;
                this.lights = source.lights;
                this.clipping = source.clipping;
                this.extensions = Object.assign({}, source.extensions);
                this.glslVersion = source.glslVersion;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_ShaderMaterial.prototype), "toJSON", this).call(this, meta);
                data.glslVersion = this.glslVersion;
                data.uniforms = {};
                for (var name in this.uniforms) {
                  var uniform = this.uniforms[name];
                  var _value2 = uniform.value;
                  if (_value2 && _value2.isTexture) {
                    data.uniforms[name] = {
                      type: 't',
                      value: _value2.toJSON(meta).uuid
                    };
                  } else if (_value2 && _value2.isColor) {
                    data.uniforms[name] = {
                      type: 'c',
                      value: _value2.getHex()
                    };
                  } else if (_value2 && _value2.isVector2) {
                    data.uniforms[name] = {
                      type: 'v2',
                      value: _value2.toArray()
                    };
                  } else if (_value2 && _value2.isVector3) {
                    data.uniforms[name] = {
                      type: 'v3',
                      value: _value2.toArray()
                    };
                  } else if (_value2 && _value2.isVector4) {
                    data.uniforms[name] = {
                      type: 'v4',
                      value: _value2.toArray()
                    };
                  } else if (_value2 && _value2.isMatrix3) {
                    data.uniforms[name] = {
                      type: 'm3',
                      value: _value2.toArray()
                    };
                  } else if (_value2 && _value2.isMatrix4) {
                    data.uniforms[name] = {
                      type: 'm4',
                      value: _value2.toArray()
                    };
                  } else {
                    data.uniforms[name] = {
                      value: _value2
                    }; // note: the array variants v2v, v3v, v4v, m4v and tv are not supported so far
                  }
                }
                if (Object.keys(this.defines).length > 0) data.defines = this.defines;
                data.vertexShader = this.vertexShader;
                data.fragmentShader = this.fragmentShader;
                var extensions = {};
                for (var key in this.extensions) {
                  if (this.extensions[key] === true) extensions[key] = true;
                }
                if (Object.keys(extensions).length > 0) data.extensions = extensions;
                return data;
              }
            }]);
            return _ShaderMaterial;
          }(_Material);
          var _Camera = /*#__PURE__*/function (_Object3D3) {
            _inherits(_Camera, _Object3D3);
            var _super35 = _createSuper(_Camera);
            function _Camera() {
              var _this27;
              _classCallCheck2(this, _Camera);
              _this27 = _super35.call(this);
              _this27.isCamera = true;
              _this27.type = 'Camera';
              _this27.matrixWorldInverse = new _Matrix2();
              _this27.projectionMatrix = new _Matrix2();
              _this27.projectionMatrixInverse = new _Matrix2();
              return _this27;
            }
            _createClass2(_Camera, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Camera.prototype), "copy", this).call(this, source, recursive);
                this.matrixWorldInverse.copy(source.matrixWorldInverse);
                this.projectionMatrix.copy(source.projectionMatrix);
                this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
                return this;
              }
            }, {
              key: "getWorldDirection",
              value: function getWorldDirection(target) {
                this.updateWorldMatrix(true, false);
                var e = this.matrixWorld.elements;
                return target.set(-e[8], -e[9], -e[10]).normalize();
              }
            }, {
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                _get2(_getPrototypeOf(_Camera.prototype), "updateMatrixWorld", this).call(this, force);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
              }
            }, {
              key: "updateWorldMatrix",
              value: function updateWorldMatrix(updateParents, updateChildren) {
                _get2(_getPrototypeOf(_Camera.prototype), "updateWorldMatrix", this).call(this, updateParents, updateChildren);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Camera;
          }(_Object3D);
          var _PerspectiveCamera = /*#__PURE__*/function (_Camera2) {
            _inherits(_PerspectiveCamera, _Camera2);
            var _super36 = _createSuper(_PerspectiveCamera);
            function _PerspectiveCamera() {
              var _this28;
              var fov = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
              var aspect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
              var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2000;
              _classCallCheck2(this, _PerspectiveCamera);
              _this28 = _super36.call(this);
              _this28.isPerspectiveCamera = true;
              _this28.type = 'PerspectiveCamera';
              _this28.fov = fov;
              _this28.zoom = 1;
              _this28.near = near;
              _this28.far = far;
              _this28.focus = 10;
              _this28.aspect = aspect;
              _this28.view = null;
              _this28.filmGauge = 35; // width of the film (default in millimeters)
              _this28.filmOffset = 0; // horizontal film offset (same unit as gauge)
              _this28.updateProjectionMatrix();
              return _this28;
            }
            _createClass2(_PerspectiveCamera, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_PerspectiveCamera.prototype), "copy", this).call(this, source, recursive);
                this.fov = source.fov;
                this.zoom = source.zoom;
                this.near = source.near;
                this.far = source.far;
                this.focus = source.focus;
                this.aspect = source.aspect;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                this.filmGauge = source.filmGauge;
                this.filmOffset = source.filmOffset;
                return this;
              } /**
                * Sets the FOV by focal length in respect to the current .filmGauge.
                *
                * The default film gauge is 35, so that the focal length can be specified for
                * a 35mm (full frame) camera.
                *
                * Values for focal length and film gauge must have the same unit.
                */
            }, {
              key: "setFocalLength",
              value: function setFocalLength(focalLength) {
                /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
                this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
                this.updateProjectionMatrix();
              } /**
                * Calculates the focal length from the current .fov and .filmGauge.
                */
            }, {
              key: "getFocalLength",
              value: function getFocalLength() {
                var vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
                return 0.5 * this.getFilmHeight() / vExtentSlope;
              }
            }, {
              key: "getEffectiveFOV",
              value: function getEffectiveFOV() {
                return RAD2DEG * 2 * Math.atan(Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom);
              }
            }, {
              key: "getFilmWidth",
              value: function getFilmWidth() {
                // film not completely covered in portrait format (aspect < 1)
                return this.filmGauge * Math.min(this.aspect, 1);
              }
            }, {
              key: "getFilmHeight",
              value: function getFilmHeight() {
                // film not completely covered in landscape format (aspect > 1)
                return this.filmGauge / Math.max(this.aspect, 1);
              } /**
                * Sets an offset in a larger frustum. This is useful for multi-window or
                * multi-monitor/multi-machine setups.
                *
                * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
                * the monitors are in grid like this
                *
                *   +---+---+---+
                *   | A | B | C |
                *   +---+---+---+
                *   | D | E | F |
                *   +---+---+---+
                *
                * then for each monitor you would call it like this
                *
                *   const w = 1920;
                *   const h = 1080;
                *   const fullWidth = w * 3;
                *   const fullHeight = h * 2;
                *
                *   --A--
                *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
                *   --B--
                *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
                *   --C--
                *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
                *   --D--
                *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
                *   --E--
                *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
                *   --F--
                *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
                *
                *   Note there is no reason monitors have to be the same size or in a grid.
                */
            }, {
              key: "setViewOffset",
              value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                this.aspect = fullWidth / fullHeight;
                if (this.view === null) {
                  this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                  };
                }
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
              }
            }, {
              key: "clearViewOffset",
              value: function clearViewOffset() {
                if (this.view !== null) {
                  this.view.enabled = false;
                }
                this.updateProjectionMatrix();
              }
            }, {
              key: "updateProjectionMatrix",
              value: function updateProjectionMatrix() {
                var near = this.near;
                var top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
                var height = 2 * top;
                var width = this.aspect * height;
                var left = -0.5 * width;
                var view = this.view;
                if (this.view !== null && this.view.enabled) {
                  var fullWidth = view.fullWidth,
                    fullHeight = view.fullHeight;
                  left += view.offsetX * width / fullWidth;
                  top -= view.offsetY * height / fullHeight;
                  width *= view.width / fullWidth;
                  height *= view.height / fullHeight;
                }
                var skew = this.filmOffset;
                if (skew !== 0) left += near * skew / this.getFilmWidth();
                this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_PerspectiveCamera.prototype), "toJSON", this).call(this, meta);
                data.object.fov = this.fov;
                data.object.zoom = this.zoom;
                data.object.near = this.near;
                data.object.far = this.far;
                data.object.focus = this.focus;
                data.object.aspect = this.aspect;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                data.object.filmGauge = this.filmGauge;
                data.object.filmOffset = this.filmOffset;
                return data;
              }
            }]);
            return _PerspectiveCamera;
          }(_Camera);
          var fov = -90; // negative fov is not an error
          var aspect = 1;
          var _CubeCamera = /*#__PURE__*/function (_Object3D4) {
            _inherits(_CubeCamera, _Object3D4);
            var _super37 = _createSuper(_CubeCamera);
            function _CubeCamera(near, far, renderTarget) {
              var _this29;
              _classCallCheck2(this, _CubeCamera);
              _this29 = _super37.call(this);
              _this29.type = 'CubeCamera';
              _this29.renderTarget = renderTarget;
              var cameraPX = new _PerspectiveCamera(fov, aspect, near, far);
              cameraPX.layers = _this29.layers;
              cameraPX.up.set(0, 1, 0);
              cameraPX.lookAt(1, 0, 0);
              _this29.add(cameraPX);
              var cameraNX = new _PerspectiveCamera(fov, aspect, near, far);
              cameraNX.layers = _this29.layers;
              cameraNX.up.set(0, 1, 0);
              cameraNX.lookAt(-1, 0, 0);
              _this29.add(cameraNX);
              var cameraPY = new _PerspectiveCamera(fov, aspect, near, far);
              cameraPY.layers = _this29.layers;
              cameraPY.up.set(0, 0, -1);
              cameraPY.lookAt(0, 1, 0);
              _this29.add(cameraPY);
              var cameraNY = new _PerspectiveCamera(fov, aspect, near, far);
              cameraNY.layers = _this29.layers;
              cameraNY.up.set(0, 0, 1);
              cameraNY.lookAt(0, -1, 0);
              _this29.add(cameraNY);
              var cameraPZ = new _PerspectiveCamera(fov, aspect, near, far);
              cameraPZ.layers = _this29.layers;
              cameraPZ.up.set(0, 1, 0);
              cameraPZ.lookAt(0, 0, 1);
              _this29.add(cameraPZ);
              var cameraNZ = new _PerspectiveCamera(fov, aspect, near, far);
              cameraNZ.layers = _this29.layers;
              cameraNZ.up.set(0, 1, 0);
              cameraNZ.lookAt(0, 0, -1);
              _this29.add(cameraNZ);
              return _this29;
            }
            _createClass2(_CubeCamera, [{
              key: "update",
              value: function update(renderer, scene) {
                if (this.parent === null) this.updateMatrixWorld();
                var renderTarget = this.renderTarget;
                var _this$children = _slicedToArray(this.children, 6),
                  cameraPX = _this$children[0],
                  cameraNX = _this$children[1],
                  cameraPY = _this$children[2],
                  cameraNY = _this$children[3],
                  cameraPZ = _this$children[4],
                  cameraNZ = _this$children[5];
                var currentRenderTarget = renderer.getRenderTarget();
                var currentToneMapping = renderer.toneMapping;
                var currentXrEnabled = renderer.xr.enabled;
                renderer.toneMapping = _NoToneMapping;
                renderer.xr.enabled = false;
                var generateMipmaps = renderTarget.texture.generateMipmaps;
                renderTarget.texture.generateMipmaps = false;
                renderer.setRenderTarget(renderTarget, 0);
                renderer.render(scene, cameraPX);
                renderer.setRenderTarget(renderTarget, 1);
                renderer.render(scene, cameraNX);
                renderer.setRenderTarget(renderTarget, 2);
                renderer.render(scene, cameraPY);
                renderer.setRenderTarget(renderTarget, 3);
                renderer.render(scene, cameraNY);
                renderer.setRenderTarget(renderTarget, 4);
                renderer.render(scene, cameraPZ);
                renderTarget.texture.generateMipmaps = generateMipmaps;
                renderer.setRenderTarget(renderTarget, 5);
                renderer.render(scene, cameraNZ);
                renderer.setRenderTarget(currentRenderTarget);
                renderer.toneMapping = currentToneMapping;
                renderer.xr.enabled = currentXrEnabled;
                renderTarget.texture.needsPMREMUpdate = true;
              }
            }]);
            return _CubeCamera;
          }(_Object3D);
          var _CubeTexture = /*#__PURE__*/function (_Texture4) {
            _inherits(_CubeTexture, _Texture4);
            var _super38 = _createSuper(_CubeTexture);
            function _CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
              var _this30;
              _classCallCheck2(this, _CubeTexture);
              images = images !== undefined ? images : [];
              mapping = mapping !== undefined ? mapping : _CubeReflectionMapping;
              _this30 = _super38.call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
              _this30.isCubeTexture = true;
              _this30.flipY = false;
              return _this30;
            }
            _createClass2(_CubeTexture, [{
              key: "images",
              get: function get() {
                return this.image;
              },
              set: function set(value) {
                this.image = value;
              }
            }]);
            return _CubeTexture;
          }(_Texture);
          var _WebGLCubeRenderTarget = /*#__PURE__*/function (_WebGLRenderTarget5) {
            _inherits(_WebGLCubeRenderTarget, _WebGLRenderTarget5);
            var _super39 = _createSuper(_WebGLCubeRenderTarget);
            function _WebGLCubeRenderTarget() {
              var _this31;
              var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck2(this, _WebGLCubeRenderTarget);
              _this31 = _super39.call(this, size, size, options);
              _this31.isWebGLCubeRenderTarget = true;
              var image = {
                width: size,
                height: size,
                depth: 1
              };
              var images = [image, image, image, image, image, image];
              _this31.texture = new _CubeTexture(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding); // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
              // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
              // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
              // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
              // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
              // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
              _this31.texture.isRenderTargetTexture = true;
              _this31.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
              _this31.texture.minFilter = options.minFilter !== undefined ? options.minFilter : _LinearFilter;
              return _this31;
            }
            _createClass2(_WebGLCubeRenderTarget, [{
              key: "fromEquirectangularTexture",
              value: function fromEquirectangularTexture(renderer, texture) {
                this.texture.type = texture.type;
                this.texture.encoding = texture.encoding;
                this.texture.generateMipmaps = texture.generateMipmaps;
                this.texture.minFilter = texture.minFilter;
                this.texture.magFilter = texture.magFilter;
                var shader = {
                  uniforms: {
                    tEquirect: {
                      value: null
                    }
                  },
                  vertexShader: /* glsl */"\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
                  fragmentShader: /* glsl */"\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
                };
                var geometry = new _BoxGeometry(5, 5, 5);
                var material = new _ShaderMaterial({
                  name: 'CubemapFromEquirect',
                  uniforms: cloneUniforms(shader.uniforms),
                  vertexShader: shader.vertexShader,
                  fragmentShader: shader.fragmentShader,
                  side: _BackSide,
                  blending: _NoBlending
                });
                material.uniforms.tEquirect.value = texture;
                var mesh = new _Mesh(geometry, material);
                var currentMinFilter = texture.minFilter; // Avoid blurred poles
                if (texture.minFilter === _LinearMipmapLinearFilter) texture.minFilter = _LinearFilter;
                var camera = new _CubeCamera(1, 10, this);
                camera.update(renderer, mesh);
                texture.minFilter = currentMinFilter;
                mesh.geometry.dispose();
                mesh.material.dispose();
                return this;
              }
            }, {
              key: "clear",
              value: function clear(renderer, color, depth, stencil) {
                var currentRenderTarget = renderer.getRenderTarget();
                for (var i = 0; i < 6; i++) {
                  renderer.setRenderTarget(this, i);
                  renderer.clear(color, depth, stencil);
                }
                renderer.setRenderTarget(currentRenderTarget);
              }
            }]);
            return _WebGLCubeRenderTarget;
          }(_WebGLRenderTarget);
          var _vector1 = /*@__PURE__*/new _Vector2();
          var _vector2 = /*@__PURE__*/new _Vector2();
          var _normalMatrix = /*@__PURE__*/new _Matrix();
          var _Plane = /*#__PURE__*/function () {
            function _Plane() {
              var normal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2(1, 0, 0);
              var constant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck2(this, _Plane);
              this.isPlane = true; // normal is assumed to be normalized
              this.normal = normal;
              this.constant = constant;
            }
            _createClass2(_Plane, [{
              key: "set",
              value: function set(normal, constant) {
                this.normal.copy(normal);
                this.constant = constant;
                return this;
              }
            }, {
              key: "setComponents",
              value: function setComponents(x, y, z, w) {
                this.normal.set(x, y, z);
                this.constant = w;
                return this;
              }
            }, {
              key: "setFromNormalAndCoplanarPoint",
              value: function setFromNormalAndCoplanarPoint(normal, point) {
                this.normal.copy(normal);
                this.constant = -point.dot(this.normal);
                return this;
              }
            }, {
              key: "setFromCoplanarPoints",
              value: function setFromCoplanarPoints(a, b, c) {
                var normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize(); // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
                this.setFromNormalAndCoplanarPoint(normal, a);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(plane) {
                this.normal.copy(plane.normal);
                this.constant = plane.constant;
                return this;
              }
            }, {
              key: "normalize",
              value: function normalize() {
                // Note: will lead to a divide by zero if the plane is invalid.
                var inverseNormalLength = 1.0 / this.normal.length();
                this.normal.multiplyScalar(inverseNormalLength);
                this.constant *= inverseNormalLength;
                return this;
              }
            }, {
              key: "negate",
              value: function negate() {
                this.constant *= -1;
                this.normal.negate();
                return this;
              }
            }, {
              key: "distanceToPoint",
              value: function distanceToPoint(point) {
                return this.normal.dot(point) + this.constant;
              }
            }, {
              key: "distanceToSphere",
              value: function distanceToSphere(sphere) {
                return this.distanceToPoint(sphere.center) - sphere.radius;
              }
            }, {
              key: "projectPoint",
              value: function projectPoint(point, target) {
                return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
              }
            }, {
              key: "intersectLine",
              value: function intersectLine(line, target) {
                var direction = line.delta(_vector1);
                var denominator = this.normal.dot(direction);
                if (denominator === 0) {
                  // line is coplanar, return origin
                  if (this.distanceToPoint(line.start) === 0) {
                    return target.copy(line.start);
                  } // Unsure if this is the correct method to handle this case.
                  return null;
                }
                var t = -(line.start.dot(this.normal) + this.constant) / denominator;
                if (t < 0 || t > 1) {
                  return null;
                }
                return target.copy(direction).multiplyScalar(t).add(line.start);
              }
            }, {
              key: "intersectsLine",
              value: function intersectsLine(line) {
                // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
                var startSign = this.distanceToPoint(line.start);
                var endSign = this.distanceToPoint(line.end);
                return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                return box.intersectsPlane(this);
              }
            }, {
              key: "intersectsSphere",
              value: function intersectsSphere(sphere) {
                return sphere.intersectsPlane(this);
              }
            }, {
              key: "coplanarPoint",
              value: function coplanarPoint(target) {
                return target.copy(this.normal).multiplyScalar(-this.constant);
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix, optionalNormalMatrix) {
                var normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
                var referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
                var normal = this.normal.applyMatrix3(normalMatrix).normalize();
                this.constant = -referencePoint.dot(normal);
                return this;
              }
            }, {
              key: "translate",
              value: function translate(offset) {
                this.constant -= offset.dot(this.normal);
                return this;
              }
            }, {
              key: "equals",
              value: function equals(plane) {
                return plane.normal.equals(this.normal) && plane.constant === this.constant;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Plane;
          }();
          var _sphere$2 = /*@__PURE__*/new _Sphere();
          var _vector$7 = /*@__PURE__*/new _Vector2();
          var _Frustum = /*#__PURE__*/function () {
            function _Frustum() {
              var p0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Plane();
              var p1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Plane();
              var p2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Plane();
              var p3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _Plane();
              var p4 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new _Plane();
              var p5 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new _Plane();
              _classCallCheck2(this, _Frustum);
              this.planes = [p0, p1, p2, p3, p4, p5];
            }
            _createClass2(_Frustum, [{
              key: "set",
              value: function set(p0, p1, p2, p3, p4, p5) {
                var planes = this.planes;
                planes[0].copy(p0);
                planes[1].copy(p1);
                planes[2].copy(p2);
                planes[3].copy(p3);
                planes[4].copy(p4);
                planes[5].copy(p5);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(frustum) {
                var planes = this.planes;
                for (var i = 0; i < 6; i++) {
                  planes[i].copy(frustum.planes[i]);
                }
                return this;
              }
            }, {
              key: "setFromProjectionMatrix",
              value: function setFromProjectionMatrix(m) {
                var planes = this.planes;
                var me = m.elements;
                var me0 = me[0],
                  me1 = me[1],
                  me2 = me[2],
                  me3 = me[3];
                var me4 = me[4],
                  me5 = me[5],
                  me6 = me[6],
                  me7 = me[7];
                var me8 = me[8],
                  me9 = me[9],
                  me10 = me[10],
                  me11 = me[11];
                var me12 = me[12],
                  me13 = me[13],
                  me14 = me[14],
                  me15 = me[15];
                planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
                planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
                planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
                planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
                planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
                planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
                return this;
              }
            }, {
              key: "intersectsObject",
              value: function intersectsObject(object) {
                var geometry = object.geometry;
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                _sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
                return this.intersectsSphere(_sphere$2);
              }
            }, {
              key: "intersectsSprite",
              value: function intersectsSprite(sprite) {
                _sphere$2.center.set(0, 0, 0);
                _sphere$2.radius = 0.7071067811865476;
                _sphere$2.applyMatrix4(sprite.matrixWorld);
                return this.intersectsSphere(_sphere$2);
              }
            }, {
              key: "intersectsSphere",
              value: function intersectsSphere(sphere) {
                var planes = this.planes;
                var center = sphere.center;
                var negRadius = -sphere.radius;
                for (var i = 0; i < 6; i++) {
                  var distance = planes[i].distanceToPoint(center);
                  if (distance < negRadius) {
                    return false;
                  }
                }
                return true;
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                var planes = this.planes;
                for (var i = 0; i < 6; i++) {
                  var plane = planes[i]; // corner at max distance
                  _vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
                  _vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
                  _vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
                  if (plane.distanceToPoint(_vector$7) < 0) {
                    return false;
                  }
                }
                return true;
              }
            }, {
              key: "containsPoint",
              value: function containsPoint(point) {
                var planes = this.planes;
                for (var i = 0; i < 6; i++) {
                  if (planes[i].distanceToPoint(point) < 0) {
                    return false;
                  }
                }
                return true;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Frustum;
          }();
          function WebGLAnimation() {
            var context = null;
            var isAnimating = false;
            var animationLoop = null;
            var requestId = null;
            function onAnimationFrame(time, frame) {
              animationLoop(time, frame);
              requestId = context.requestAnimationFrame(onAnimationFrame);
            }
            return {
              start: function start() {
                if (isAnimating === true) return;
                if (animationLoop === null) return;
                requestId = context.requestAnimationFrame(onAnimationFrame);
                isAnimating = true;
              },
              stop: function stop() {
                context.cancelAnimationFrame(requestId);
                isAnimating = false;
              },
              setAnimationLoop: function setAnimationLoop(callback) {
                animationLoop = callback;
              },
              setContext: function setContext(value) {
                context = value;
              }
            };
          }
          function WebGLAttributes(gl, capabilities) {
            var isWebGL2 = capabilities.isWebGL2;
            var buffers = new WeakMap();
            function createBuffer(attribute, bufferType) {
              var array = attribute.array;
              var usage = attribute.usage;
              var buffer = gl.createBuffer();
              gl.bindBuffer(bufferType, buffer);
              gl.bufferData(bufferType, array, usage);
              attribute.onUploadCallback();
              var type;
              if (array instanceof Float32Array) {
                type = 5126;
              } else if (array instanceof Uint16Array) {
                if (attribute.isFloat16BufferAttribute) {
                  if (isWebGL2) {
                    type = 5131;
                  } else {
                    throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
                  }
                } else {
                  type = 5123;
                }
              } else if (array instanceof Int16Array) {
                type = 5122;
              } else if (array instanceof Uint32Array) {
                type = 5125;
              } else if (array instanceof Int32Array) {
                type = 5124;
              } else if (array instanceof Int8Array) {
                type = 5120;
              } else if (array instanceof Uint8Array) {
                type = 5121;
              } else if (array instanceof Uint8ClampedArray) {
                type = 5121;
              } else {
                throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
              }
              return {
                buffer: buffer,
                type: type,
                bytesPerElement: array.BYTES_PER_ELEMENT,
                version: attribute.version
              };
            }
            function updateBuffer(buffer, attribute, bufferType) {
              var array = attribute.array;
              var updateRange = attribute.updateRange;
              gl.bindBuffer(bufferType, buffer);
              if (updateRange.count === -1) {
                // Not using update ranges
                gl.bufferSubData(bufferType, 0, array);
              } else {
                if (isWebGL2) {
                  gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
                } else {
                  gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
                }
                updateRange.count = -1; // reset range
              }
              attribute.onUploadCallback();
            } //
            function get(attribute) {
              if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
              return buffers.get(attribute);
            }
            function remove(attribute) {
              if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
              var data = buffers.get(attribute);
              if (data) {
                gl.deleteBuffer(data.buffer);
                buffers.delete(attribute);
              }
            }
            function update(attribute, bufferType) {
              if (attribute.isGLBufferAttribute) {
                var cached = buffers.get(attribute);
                if (!cached || cached.version < attribute.version) {
                  buffers.set(attribute, {
                    buffer: attribute.buffer,
                    type: attribute.type,
                    bytesPerElement: attribute.elementSize,
                    version: attribute.version
                  });
                }
                return;
              }
              if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
              var data = buffers.get(attribute);
              if (data === undefined) {
                buffers.set(attribute, createBuffer(attribute, bufferType));
              } else if (data.version < attribute.version) {
                updateBuffer(data.buffer, attribute, bufferType);
                data.version = attribute.version;
              }
            }
            return {
              get: get,
              remove: remove,
              update: update
            };
          }
          var _PlaneGeometry = /*#__PURE__*/function (_BufferGeometry3) {
            _inherits(_PlaneGeometry, _BufferGeometry3);
            var _super40 = _createSuper(_PlaneGeometry);
            function _PlaneGeometry() {
              var _this32;
              var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var widthSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var heightSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              _classCallCheck2(this, _PlaneGeometry);
              _this32 = _super40.call(this);
              _this32.type = 'PlaneGeometry';
              _this32.parameters = {
                width: width,
                height: height,
                widthSegments: widthSegments,
                heightSegments: heightSegments
              };
              var width_half = width / 2;
              var height_half = height / 2;
              var gridX = Math.floor(widthSegments);
              var gridY = Math.floor(heightSegments);
              var gridX1 = gridX + 1;
              var gridY1 = gridY + 1;
              var segment_width = width / gridX;
              var segment_height = height / gridY; //
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = [];
              for (var iy = 0; iy < gridY1; iy++) {
                var y = iy * segment_height - height_half;
                for (var ix = 0; ix < gridX1; ix++) {
                  var x = ix * segment_width - width_half;
                  vertices.push(x, -y, 0);
                  normals.push(0, 0, 1);
                  uvs.push(ix / gridX);
                  uvs.push(1 - iy / gridY);
                }
              }
              for (var _iy2 = 0; _iy2 < gridY; _iy2++) {
                for (var _ix2 = 0; _ix2 < gridX; _ix2++) {
                  var a = _ix2 + gridX1 * _iy2;
                  var b = _ix2 + gridX1 * (_iy2 + 1);
                  var c = _ix2 + 1 + gridX1 * (_iy2 + 1);
                  var d = _ix2 + 1 + gridX1 * _iy2;
                  indices.push(a, b, d);
                  indices.push(b, c, d);
                }
              }
              _this32.setIndex(indices);
              _this32.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this32.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this32.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              return _this32;
            }
            _createClass2(_PlaneGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
              }
            }]);
            return _PlaneGeometry;
          }(_BufferGeometry);
          var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
          var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
          var alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
          var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
          var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
          var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
          var begin_vertex = "vec3 transformed = vec3( position );";
          var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
          var bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\n#ifdef USE_IRIDESCENCE\n\tvec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif";
          var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\t return vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat R21 = R12;\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
          var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
          var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
          var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
          var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
          var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
          var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
          var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
          var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
          var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
          var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
          var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
          var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
          var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
          var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
          var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
          var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
          var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
          var encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
          var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
          var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
          var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
          var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
          var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
          var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
          var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
          var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
          var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
          var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
          var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
          var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
          var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
          var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
          var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
          var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif";
          var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
          var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
          var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
          var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
          var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif";
          var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );\n\t#else\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
          var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
          var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
          var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
          var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
          var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
          var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
          var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
          var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
          var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
          var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
          var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
          var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
          var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
          var morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
          var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
          var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
          var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
          var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
          var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
          var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
          var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
          var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
          var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif";
          var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
          var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif";
          var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
          var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
          var output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
          var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
          var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
          var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
          var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
          var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
          var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
          var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
          var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
          var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
          var shadowmap_vertex = "#if defined( USE_SHADOWMAP ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_COORDS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
          var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
          var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
          var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
          var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
          var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
          var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
          var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
          var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
          var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
          var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );\n#endif";
          var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif";
          var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
          var uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
          var uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
          var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
          var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
          var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
          var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
          var vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
          var fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
          var vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
          var fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
          var vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
          var fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
          var vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
          var fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
          var vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
          var fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
          var vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
          var fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
          var vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
          var vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
          var vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
          var vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
          var fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
          var vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
          var fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
          var vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
          var vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
          var fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
          var vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
          var vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
          var vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
          var vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
          var fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
          var _ShaderChunk = {
            alphamap_fragment: alphamap_fragment,
            alphamap_pars_fragment: alphamap_pars_fragment,
            alphatest_fragment: alphatest_fragment,
            alphatest_pars_fragment: alphatest_pars_fragment,
            aomap_fragment: aomap_fragment,
            aomap_pars_fragment: aomap_pars_fragment,
            begin_vertex: begin_vertex,
            beginnormal_vertex: beginnormal_vertex,
            bsdfs: bsdfs,
            iridescence_fragment: iridescence_fragment,
            bumpmap_pars_fragment: bumpmap_pars_fragment,
            clipping_planes_fragment: clipping_planes_fragment,
            clipping_planes_pars_fragment: clipping_planes_pars_fragment,
            clipping_planes_pars_vertex: clipping_planes_pars_vertex,
            clipping_planes_vertex: clipping_planes_vertex,
            color_fragment: color_fragment,
            color_pars_fragment: color_pars_fragment,
            color_pars_vertex: color_pars_vertex,
            color_vertex: color_vertex,
            common: common,
            cube_uv_reflection_fragment: cube_uv_reflection_fragment,
            defaultnormal_vertex: defaultnormal_vertex,
            displacementmap_pars_vertex: displacementmap_pars_vertex,
            displacementmap_vertex: displacementmap_vertex,
            emissivemap_fragment: emissivemap_fragment,
            emissivemap_pars_fragment: emissivemap_pars_fragment,
            encodings_fragment: encodings_fragment,
            encodings_pars_fragment: encodings_pars_fragment,
            envmap_fragment: envmap_fragment,
            envmap_common_pars_fragment: envmap_common_pars_fragment,
            envmap_pars_fragment: envmap_pars_fragment,
            envmap_pars_vertex: envmap_pars_vertex,
            envmap_physical_pars_fragment: envmap_physical_pars_fragment,
            envmap_vertex: envmap_vertex,
            fog_vertex: fog_vertex,
            fog_pars_vertex: fog_pars_vertex,
            fog_fragment: fog_fragment,
            fog_pars_fragment: fog_pars_fragment,
            gradientmap_pars_fragment: gradientmap_pars_fragment,
            lightmap_fragment: lightmap_fragment,
            lightmap_pars_fragment: lightmap_pars_fragment,
            lights_lambert_fragment: lights_lambert_fragment,
            lights_lambert_pars_fragment: lights_lambert_pars_fragment,
            lights_pars_begin: lights_pars_begin,
            lights_toon_fragment: lights_toon_fragment,
            lights_toon_pars_fragment: lights_toon_pars_fragment,
            lights_phong_fragment: lights_phong_fragment,
            lights_phong_pars_fragment: lights_phong_pars_fragment,
            lights_physical_fragment: lights_physical_fragment,
            lights_physical_pars_fragment: lights_physical_pars_fragment,
            lights_fragment_begin: lights_fragment_begin,
            lights_fragment_maps: lights_fragment_maps,
            lights_fragment_end: lights_fragment_end,
            logdepthbuf_fragment: logdepthbuf_fragment,
            logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
            logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
            logdepthbuf_vertex: logdepthbuf_vertex,
            map_fragment: map_fragment,
            map_pars_fragment: map_pars_fragment,
            map_particle_fragment: map_particle_fragment,
            map_particle_pars_fragment: map_particle_pars_fragment,
            metalnessmap_fragment: metalnessmap_fragment,
            metalnessmap_pars_fragment: metalnessmap_pars_fragment,
            morphcolor_vertex: morphcolor_vertex,
            morphnormal_vertex: morphnormal_vertex,
            morphtarget_pars_vertex: morphtarget_pars_vertex,
            morphtarget_vertex: morphtarget_vertex,
            normal_fragment_begin: normal_fragment_begin,
            normal_fragment_maps: normal_fragment_maps,
            normal_pars_fragment: normal_pars_fragment,
            normal_pars_vertex: normal_pars_vertex,
            normal_vertex: normal_vertex,
            normalmap_pars_fragment: normalmap_pars_fragment,
            clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
            clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
            clearcoat_pars_fragment: clearcoat_pars_fragment,
            iridescence_pars_fragment: iridescence_pars_fragment,
            output_fragment: output_fragment,
            packing: packing,
            premultiplied_alpha_fragment: premultiplied_alpha_fragment,
            project_vertex: project_vertex,
            dithering_fragment: dithering_fragment,
            dithering_pars_fragment: dithering_pars_fragment,
            roughnessmap_fragment: roughnessmap_fragment,
            roughnessmap_pars_fragment: roughnessmap_pars_fragment,
            shadowmap_pars_fragment: shadowmap_pars_fragment,
            shadowmap_pars_vertex: shadowmap_pars_vertex,
            shadowmap_vertex: shadowmap_vertex,
            shadowmask_pars_fragment: shadowmask_pars_fragment,
            skinbase_vertex: skinbase_vertex,
            skinning_pars_vertex: skinning_pars_vertex,
            skinning_vertex: skinning_vertex,
            skinnormal_vertex: skinnormal_vertex,
            specularmap_fragment: specularmap_fragment,
            specularmap_pars_fragment: specularmap_pars_fragment,
            tonemapping_fragment: tonemapping_fragment,
            tonemapping_pars_fragment: tonemapping_pars_fragment,
            transmission_fragment: transmission_fragment,
            transmission_pars_fragment: transmission_pars_fragment,
            uv_pars_fragment: uv_pars_fragment,
            uv_pars_vertex: uv_pars_vertex,
            uv_vertex: uv_vertex,
            uv2_pars_fragment: uv2_pars_fragment,
            uv2_pars_vertex: uv2_pars_vertex,
            uv2_vertex: uv2_vertex,
            worldpos_vertex: worldpos_vertex,
            background_vert: vertex$h,
            background_frag: fragment$h,
            backgroundCube_vert: vertex$g,
            backgroundCube_frag: fragment$g,
            cube_vert: vertex$f,
            cube_frag: fragment$f,
            depth_vert: vertex$e,
            depth_frag: fragment$e,
            distanceRGBA_vert: vertex$d,
            distanceRGBA_frag: fragment$d,
            equirect_vert: vertex$c,
            equirect_frag: fragment$c,
            linedashed_vert: vertex$b,
            linedashed_frag: fragment$b,
            meshbasic_vert: vertex$a,
            meshbasic_frag: fragment$a,
            meshlambert_vert: vertex$9,
            meshlambert_frag: fragment$9,
            meshmatcap_vert: vertex$8,
            meshmatcap_frag: fragment$8,
            meshnormal_vert: vertex$7,
            meshnormal_frag: fragment$7,
            meshphong_vert: vertex$6,
            meshphong_frag: fragment$6,
            meshphysical_vert: vertex$5,
            meshphysical_frag: fragment$5,
            meshtoon_vert: vertex$4,
            meshtoon_frag: fragment$4,
            points_vert: vertex$3,
            points_frag: fragment$3,
            shadow_vert: vertex$2,
            shadow_frag: fragment$2,
            sprite_vert: vertex$1,
            sprite_frag: fragment$1
          }; /**
             * Uniforms library for shared webgl shaders
             */
          var _UniformsLib = {
            common: {
              diffuse: {
                value: /*@__PURE__*/new _Color(0xffffff)
              },
              opacity: {
                value: 1.0
              },
              map: {
                value: null
              },
              uvTransform: {
                value: /*@__PURE__*/new _Matrix()
              },
              uv2Transform: {
                value: /*@__PURE__*/new _Matrix()
              },
              alphaMap: {
                value: null
              },
              alphaTest: {
                value: 0
              }
            },
            specularmap: {
              specularMap: {
                value: null
              }
            },
            envmap: {
              envMap: {
                value: null
              },
              flipEnvMap: {
                value: -1
              },
              reflectivity: {
                value: 1.0
              },
              // basic, lambert, phong
              ior: {
                value: 1.5
              },
              // physical
              refractionRatio: {
                value: 0.98
              } // basic, lambert, phong
            },
            aomap: {
              aoMap: {
                value: null
              },
              aoMapIntensity: {
                value: 1
              }
            },
            lightmap: {
              lightMap: {
                value: null
              },
              lightMapIntensity: {
                value: 1
              }
            },
            emissivemap: {
              emissiveMap: {
                value: null
              }
            },
            bumpmap: {
              bumpMap: {
                value: null
              },
              bumpScale: {
                value: 1
              }
            },
            normalmap: {
              normalMap: {
                value: null
              },
              normalScale: {
                value: /*@__PURE__*/new _Vector(1, 1)
              }
            },
            displacementmap: {
              displacementMap: {
                value: null
              },
              displacementScale: {
                value: 1
              },
              displacementBias: {
                value: 0
              }
            },
            roughnessmap: {
              roughnessMap: {
                value: null
              }
            },
            metalnessmap: {
              metalnessMap: {
                value: null
              }
            },
            gradientmap: {
              gradientMap: {
                value: null
              }
            },
            fog: {
              fogDensity: {
                value: 0.00025
              },
              fogNear: {
                value: 1
              },
              fogFar: {
                value: 2000
              },
              fogColor: {
                value: /*@__PURE__*/new _Color(0xffffff)
              }
            },
            lights: {
              ambientLightColor: {
                value: []
              },
              lightProbe: {
                value: []
              },
              directionalLights: {
                value: [],
                properties: {
                  direction: {},
                  color: {}
                }
              },
              directionalLightShadows: {
                value: [],
                properties: {
                  shadowBias: {},
                  shadowNormalBias: {},
                  shadowRadius: {},
                  shadowMapSize: {}
                }
              },
              directionalShadowMap: {
                value: []
              },
              directionalShadowMatrix: {
                value: []
              },
              spotLights: {
                value: [],
                properties: {
                  color: {},
                  position: {},
                  direction: {},
                  distance: {},
                  coneCos: {},
                  penumbraCos: {},
                  decay: {}
                }
              },
              spotLightShadows: {
                value: [],
                properties: {
                  shadowBias: {},
                  shadowNormalBias: {},
                  shadowRadius: {},
                  shadowMapSize: {}
                }
              },
              spotLightMap: {
                value: []
              },
              spotShadowMap: {
                value: []
              },
              spotLightMatrix: {
                value: []
              },
              pointLights: {
                value: [],
                properties: {
                  color: {},
                  position: {},
                  decay: {},
                  distance: {}
                }
              },
              pointLightShadows: {
                value: [],
                properties: {
                  shadowBias: {},
                  shadowNormalBias: {},
                  shadowRadius: {},
                  shadowMapSize: {},
                  shadowCameraNear: {},
                  shadowCameraFar: {}
                }
              },
              pointShadowMap: {
                value: []
              },
              pointShadowMatrix: {
                value: []
              },
              hemisphereLights: {
                value: [],
                properties: {
                  direction: {},
                  skyColor: {},
                  groundColor: {}
                }
              },
              // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
              rectAreaLights: {
                value: [],
                properties: {
                  color: {},
                  position: {},
                  width: {},
                  height: {}
                }
              },
              ltc_1: {
                value: null
              },
              ltc_2: {
                value: null
              }
            },
            points: {
              diffuse: {
                value: /*@__PURE__*/new _Color(0xffffff)
              },
              opacity: {
                value: 1.0
              },
              size: {
                value: 1.0
              },
              scale: {
                value: 1.0
              },
              map: {
                value: null
              },
              alphaMap: {
                value: null
              },
              alphaTest: {
                value: 0
              },
              uvTransform: {
                value: /*@__PURE__*/new _Matrix()
              }
            },
            sprite: {
              diffuse: {
                value: /*@__PURE__*/new _Color(0xffffff)
              },
              opacity: {
                value: 1.0
              },
              center: {
                value: /*@__PURE__*/new _Vector(0.5, 0.5)
              },
              rotation: {
                value: 0.0
              },
              map: {
                value: null
              },
              alphaMap: {
                value: null
              },
              alphaTest: {
                value: 0
              },
              uvTransform: {
                value: /*@__PURE__*/new _Matrix()
              }
            }
          };
          var _ShaderLib = {
            basic: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.specularmap, _UniformsLib.envmap, _UniformsLib.aomap, _UniformsLib.lightmap, _UniformsLib.fog]),
              vertexShader: _ShaderChunk.meshbasic_vert,
              fragmentShader: _ShaderChunk.meshbasic_frag
            },
            lambert: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.specularmap, _UniformsLib.envmap, _UniformsLib.aomap, _UniformsLib.lightmap, _UniformsLib.emissivemap, _UniformsLib.bumpmap, _UniformsLib.normalmap, _UniformsLib.displacementmap, _UniformsLib.fog, _UniformsLib.lights, {
                emissive: {
                  value: /*@__PURE__*/new _Color(0x000000)
                }
              }]),
              vertexShader: _ShaderChunk.meshlambert_vert,
              fragmentShader: _ShaderChunk.meshlambert_frag
            },
            phong: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.specularmap, _UniformsLib.envmap, _UniformsLib.aomap, _UniformsLib.lightmap, _UniformsLib.emissivemap, _UniformsLib.bumpmap, _UniformsLib.normalmap, _UniformsLib.displacementmap, _UniformsLib.fog, _UniformsLib.lights, {
                emissive: {
                  value: /*@__PURE__*/new _Color(0x000000)
                },
                specular: {
                  value: /*@__PURE__*/new _Color(0x111111)
                },
                shininess: {
                  value: 30
                }
              }]),
              vertexShader: _ShaderChunk.meshphong_vert,
              fragmentShader: _ShaderChunk.meshphong_frag
            },
            standard: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.envmap, _UniformsLib.aomap, _UniformsLib.lightmap, _UniformsLib.emissivemap, _UniformsLib.bumpmap, _UniformsLib.normalmap, _UniformsLib.displacementmap, _UniformsLib.roughnessmap, _UniformsLib.metalnessmap, _UniformsLib.fog, _UniformsLib.lights, {
                emissive: {
                  value: /*@__PURE__*/new _Color(0x000000)
                },
                roughness: {
                  value: 1.0
                },
                metalness: {
                  value: 0.0
                },
                envMapIntensity: {
                  value: 1
                } // temporary
              }]),
              vertexShader: _ShaderChunk.meshphysical_vert,
              fragmentShader: _ShaderChunk.meshphysical_frag
            },
            toon: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.aomap, _UniformsLib.lightmap, _UniformsLib.emissivemap, _UniformsLib.bumpmap, _UniformsLib.normalmap, _UniformsLib.displacementmap, _UniformsLib.gradientmap, _UniformsLib.fog, _UniformsLib.lights, {
                emissive: {
                  value: /*@__PURE__*/new _Color(0x000000)
                }
              }]),
              vertexShader: _ShaderChunk.meshtoon_vert,
              fragmentShader: _ShaderChunk.meshtoon_frag
            },
            matcap: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.bumpmap, _UniformsLib.normalmap, _UniformsLib.displacementmap, _UniformsLib.fog, {
                matcap: {
                  value: null
                }
              }]),
              vertexShader: _ShaderChunk.meshmatcap_vert,
              fragmentShader: _ShaderChunk.meshmatcap_frag
            },
            points: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.points, _UniformsLib.fog]),
              vertexShader: _ShaderChunk.points_vert,
              fragmentShader: _ShaderChunk.points_frag
            },
            dashed: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.fog, {
                scale: {
                  value: 1
                },
                dashSize: {
                  value: 1
                },
                totalSize: {
                  value: 2
                }
              }]),
              vertexShader: _ShaderChunk.linedashed_vert,
              fragmentShader: _ShaderChunk.linedashed_frag
            },
            depth: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.displacementmap]),
              vertexShader: _ShaderChunk.depth_vert,
              fragmentShader: _ShaderChunk.depth_frag
            },
            normal: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.bumpmap, _UniformsLib.normalmap, _UniformsLib.displacementmap, {
                opacity: {
                  value: 1.0
                }
              }]),
              vertexShader: _ShaderChunk.meshnormal_vert,
              fragmentShader: _ShaderChunk.meshnormal_frag
            },
            sprite: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.sprite, _UniformsLib.fog]),
              vertexShader: _ShaderChunk.sprite_vert,
              fragmentShader: _ShaderChunk.sprite_frag
            },
            background: {
              uniforms: {
                uvTransform: {
                  value: /*@__PURE__*/new _Matrix()
                },
                t2D: {
                  value: null
                },
                backgroundIntensity: {
                  value: 1
                }
              },
              vertexShader: _ShaderChunk.background_vert,
              fragmentShader: _ShaderChunk.background_frag
            },
            backgroundCube: {
              uniforms: {
                envMap: {
                  value: null
                },
                flipEnvMap: {
                  value: -1
                },
                backgroundBlurriness: {
                  value: 0
                },
                backgroundIntensity: {
                  value: 1
                }
              },
              vertexShader: _ShaderChunk.backgroundCube_vert,
              fragmentShader: _ShaderChunk.backgroundCube_frag
            },
            cube: {
              uniforms: {
                tCube: {
                  value: null
                },
                tFlip: {
                  value: -1
                },
                opacity: {
                  value: 1.0
                }
              },
              vertexShader: _ShaderChunk.cube_vert,
              fragmentShader: _ShaderChunk.cube_frag
            },
            equirect: {
              uniforms: {
                tEquirect: {
                  value: null
                }
              },
              vertexShader: _ShaderChunk.equirect_vert,
              fragmentShader: _ShaderChunk.equirect_frag
            },
            distanceRGBA: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.common, _UniformsLib.displacementmap, {
                referencePosition: {
                  value: /*@__PURE__*/new _Vector2()
                },
                nearDistance: {
                  value: 1
                },
                farDistance: {
                  value: 1000
                }
              }]),
              vertexShader: _ShaderChunk.distanceRGBA_vert,
              fragmentShader: _ShaderChunk.distanceRGBA_frag
            },
            shadow: {
              uniforms: /*@__PURE__*/mergeUniforms([_UniformsLib.lights, _UniformsLib.fog, {
                color: {
                  value: /*@__PURE__*/new _Color(0x00000)
                },
                opacity: {
                  value: 1.0
                }
              }]),
              vertexShader: _ShaderChunk.shadow_vert,
              fragmentShader: _ShaderChunk.shadow_frag
            }
          };
          _ShaderLib.physical = {
            uniforms: /*@__PURE__*/mergeUniforms([_ShaderLib.standard.uniforms, {
              clearcoat: {
                value: 0
              },
              clearcoatMap: {
                value: null
              },
              clearcoatRoughness: {
                value: 0
              },
              clearcoatRoughnessMap: {
                value: null
              },
              clearcoatNormalScale: {
                value: /*@__PURE__*/new _Vector(1, 1)
              },
              clearcoatNormalMap: {
                value: null
              },
              iridescence: {
                value: 0
              },
              iridescenceMap: {
                value: null
              },
              iridescenceIOR: {
                value: 1.3
              },
              iridescenceThicknessMinimum: {
                value: 100
              },
              iridescenceThicknessMaximum: {
                value: 400
              },
              iridescenceThicknessMap: {
                value: null
              },
              sheen: {
                value: 0
              },
              sheenColor: {
                value: /*@__PURE__*/new _Color(0x000000)
              },
              sheenColorMap: {
                value: null
              },
              sheenRoughness: {
                value: 1
              },
              sheenRoughnessMap: {
                value: null
              },
              transmission: {
                value: 0
              },
              transmissionMap: {
                value: null
              },
              transmissionSamplerSize: {
                value: /*@__PURE__*/new _Vector()
              },
              transmissionSamplerMap: {
                value: null
              },
              thickness: {
                value: 0
              },
              thicknessMap: {
                value: null
              },
              attenuationDistance: {
                value: 0
              },
              attenuationColor: {
                value: /*@__PURE__*/new _Color(0x000000)
              },
              specularIntensity: {
                value: 1
              },
              specularIntensityMap: {
                value: null
              },
              specularColor: {
                value: /*@__PURE__*/new _Color(1, 1, 1)
              },
              specularColorMap: {
                value: null
              }
            }]),
            vertexShader: _ShaderChunk.meshphysical_vert,
            fragmentShader: _ShaderChunk.meshphysical_frag
          };
          var _rgb = {
            r: 0,
            b: 0,
            g: 0
          };
          function WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
            var clearColor = new _Color(0x000000);
            var clearAlpha = alpha === true ? 0 : 1;
            var planeMesh;
            var boxMesh;
            var currentBackground = null;
            var currentBackgroundVersion = 0;
            var currentTonemapping = null;
            function render(renderList, scene) {
              var forceClear = false;
              var background = scene.isScene === true ? scene.background : null;
              if (background && background.isTexture) {
                var usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
                background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
              } // Ignore background in AR
              // TODO: Reconsider this.
              var xr = renderer.xr;
              var session = xr.getSession && xr.getSession();
              if (session && session.environmentBlendMode === 'additive') {
                background = null;
              }
              if (background === null) {
                setClear(clearColor, clearAlpha);
              } else if (background && background.isColor) {
                setClear(background, 1);
                forceClear = true;
              }
              if (renderer.autoClear || forceClear) {
                renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
              }
              if (background && (background.isCubeTexture || background.mapping === _CubeUVReflectionMapping)) {
                if (boxMesh === undefined) {
                  boxMesh = new _Mesh(new _BoxGeometry(1, 1, 1), new _ShaderMaterial({
                    name: 'BackgroundCubeMaterial',
                    uniforms: cloneUniforms(_ShaderLib.backgroundCube.uniforms),
                    vertexShader: _ShaderLib.backgroundCube.vertexShader,
                    fragmentShader: _ShaderLib.backgroundCube.fragmentShader,
                    side: _BackSide,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                  }));
                  boxMesh.geometry.deleteAttribute('normal');
                  boxMesh.geometry.deleteAttribute('uv');
                  boxMesh.onBeforeRender = function (renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                  }; // add "envMap" material property so the renderer can evaluate it like for built-in materials
                  Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function get() {
                      return this.uniforms.envMap.value;
                    }
                  });
                  objects.update(boxMesh);
                }
                boxMesh.material.uniforms.envMap.value = background;
                boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
                boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
                boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
                if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                  boxMesh.material.needsUpdate = true;
                  currentBackground = background;
                  currentBackgroundVersion = background.version;
                  currentTonemapping = renderer.toneMapping;
                }
                boxMesh.layers.enableAll(); // push to the pre-sorted opaque render list
                renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
              } else if (background && background.isTexture) {
                if (planeMesh === undefined) {
                  planeMesh = new _Mesh(new _PlaneGeometry(2, 2), new _ShaderMaterial({
                    name: 'BackgroundMaterial',
                    uniforms: cloneUniforms(_ShaderLib.background.uniforms),
                    vertexShader: _ShaderLib.background.vertexShader,
                    fragmentShader: _ShaderLib.background.fragmentShader,
                    side: _FrontSide,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                  }));
                  planeMesh.geometry.deleteAttribute('normal'); // add "map" material property so the renderer can evaluate it like for built-in materials
                  Object.defineProperty(planeMesh.material, 'map', {
                    get: function get() {
                      return this.uniforms.t2D.value;
                    }
                  });
                  objects.update(planeMesh);
                }
                planeMesh.material.uniforms.t2D.value = background;
                planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
                if (background.matrixAutoUpdate === true) {
                  background.updateMatrix();
                }
                planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
                if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                  planeMesh.material.needsUpdate = true;
                  currentBackground = background;
                  currentBackgroundVersion = background.version;
                  currentTonemapping = renderer.toneMapping;
                }
                planeMesh.layers.enableAll(); // push to the pre-sorted opaque render list
                renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
              }
            }
            function setClear(color, alpha) {
              color.getRGB(_rgb, getUnlitUniformColorSpace(renderer));
              state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha, premultipliedAlpha);
            }
            return {
              getClearColor: function getClearColor() {
                return clearColor;
              },
              setClearColor: function setClearColor(color) {
                var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                clearColor.set(color);
                clearAlpha = alpha;
                setClear(clearColor, clearAlpha);
              },
              getClearAlpha: function getClearAlpha() {
                return clearAlpha;
              },
              setClearAlpha: function setClearAlpha(alpha) {
                clearAlpha = alpha;
                setClear(clearColor, clearAlpha);
              },
              render: render
            };
          }
          function WebGLBindingStates(gl, extensions, attributes, capabilities) {
            var maxVertexAttributes = gl.getParameter(34921);
            var extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
            var vaoAvailable = capabilities.isWebGL2 || extension !== null;
            var bindingStates = {};
            var defaultState = createBindingState(null);
            var currentState = defaultState;
            var forceUpdate = false;
            function setup(object, material, program, geometry, index) {
              var updateBuffers = false;
              if (vaoAvailable) {
                var state = getBindingState(geometry, program, material);
                if (currentState !== state) {
                  currentState = state;
                  bindVertexArrayObject(currentState.object);
                }
                updateBuffers = needsUpdate(object, geometry, program, index);
                if (updateBuffers) saveCache(object, geometry, program, index);
              } else {
                var wireframe = material.wireframe === true;
                if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                  currentState.geometry = geometry.id;
                  currentState.program = program.id;
                  currentState.wireframe = wireframe;
                  updateBuffers = true;
                }
              }
              if (index !== null) {
                attributes.update(index, 34963);
              }
              if (updateBuffers || forceUpdate) {
                forceUpdate = false;
                setupVertexAttributes(object, material, program, geometry);
                if (index !== null) {
                  gl.bindBuffer(34963, attributes.get(index).buffer);
                }
              }
            }
            function createVertexArrayObject() {
              if (capabilities.isWebGL2) return gl.createVertexArray();
              return extension.createVertexArrayOES();
            }
            function bindVertexArrayObject(vao) {
              if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
              return extension.bindVertexArrayOES(vao);
            }
            function deleteVertexArrayObject(vao) {
              if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
              return extension.deleteVertexArrayOES(vao);
            }
            function getBindingState(geometry, program, material) {
              var wireframe = material.wireframe === true;
              var programMap = bindingStates[geometry.id];
              if (programMap === undefined) {
                programMap = {};
                bindingStates[geometry.id] = programMap;
              }
              var stateMap = programMap[program.id];
              if (stateMap === undefined) {
                stateMap = {};
                programMap[program.id] = stateMap;
              }
              var state = stateMap[wireframe];
              if (state === undefined) {
                state = createBindingState(createVertexArrayObject());
                stateMap[wireframe] = state;
              }
              return state;
            }
            function createBindingState(vao) {
              var newAttributes = [];
              var enabledAttributes = [];
              var attributeDivisors = [];
              for (var i = 0; i < maxVertexAttributes; i++) {
                newAttributes[i] = 0;
                enabledAttributes[i] = 0;
                attributeDivisors[i] = 0;
              }
              return {
                // for backward compatibility on non-VAO support browser
                geometry: null,
                program: null,
                wireframe: false,
                newAttributes: newAttributes,
                enabledAttributes: enabledAttributes,
                attributeDivisors: attributeDivisors,
                object: vao,
                attributes: {},
                index: null
              };
            }
            function needsUpdate(object, geometry, program, index) {
              var cachedAttributes = currentState.attributes;
              var geometryAttributes = geometry.attributes;
              var attributesNum = 0;
              var programAttributes = program.getAttributes();
              for (var name in programAttributes) {
                var programAttribute = programAttributes[name];
                if (programAttribute.location >= 0) {
                  var cachedAttribute = cachedAttributes[name];
                  var geometryAttribute = geometryAttributes[name];
                  if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                  }
                  if (cachedAttribute === undefined) return true;
                  if (cachedAttribute.attribute !== geometryAttribute) return true;
                  if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                  attributesNum++;
                }
              }
              if (currentState.attributesNum !== attributesNum) return true;
              if (currentState.index !== index) return true;
              return false;
            }
            function saveCache(object, geometry, program, index) {
              var cache = {};
              var attributes = geometry.attributes;
              var attributesNum = 0;
              var programAttributes = program.getAttributes();
              for (var name in programAttributes) {
                var programAttribute = programAttributes[name];
                if (programAttribute.location >= 0) {
                  var attribute = attributes[name];
                  if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                  }
                  var data = {};
                  data.attribute = attribute;
                  if (attribute && attribute.data) {
                    data.data = attribute.data;
                  }
                  cache[name] = data;
                  attributesNum++;
                }
              }
              currentState.attributes = cache;
              currentState.attributesNum = attributesNum;
              currentState.index = index;
            }
            function initAttributes() {
              var newAttributes = currentState.newAttributes;
              for (var i = 0, il = newAttributes.length; i < il; i++) {
                newAttributes[i] = 0;
              }
            }
            function enableAttribute(attribute) {
              enableAttributeAndDivisor(attribute, 0);
            }
            function enableAttributeAndDivisor(attribute, meshPerAttribute) {
              var newAttributes = currentState.newAttributes;
              var enabledAttributes = currentState.enabledAttributes;
              var attributeDivisors = currentState.attributeDivisors;
              newAttributes[attribute] = 1;
              if (enabledAttributes[attribute] === 0) {
                gl.enableVertexAttribArray(attribute);
                enabledAttributes[attribute] = 1;
              }
              if (attributeDivisors[attribute] !== meshPerAttribute) {
                var _extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
                _extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
                attributeDivisors[attribute] = meshPerAttribute;
              }
            }
            function disableUnusedAttributes() {
              var newAttributes = currentState.newAttributes;
              var enabledAttributes = currentState.enabledAttributes;
              for (var i = 0, il = enabledAttributes.length; i < il; i++) {
                if (enabledAttributes[i] !== newAttributes[i]) {
                  gl.disableVertexAttribArray(i);
                  enabledAttributes[i] = 0;
                }
              }
            }
            function vertexAttribPointer(index, size, type, normalized, stride, offset) {
              if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) {
                gl.vertexAttribIPointer(index, size, type, stride, offset);
              } else {
                gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
              }
            }
            function setupVertexAttributes(object, material, program, geometry) {
              if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
                if (extensions.get('ANGLE_instanced_arrays') === null) return;
              }
              initAttributes();
              var geometryAttributes = geometry.attributes;
              var programAttributes = program.getAttributes();
              var materialDefaultAttributeValues = material.defaultAttributeValues;
              for (var name in programAttributes) {
                var programAttribute = programAttributes[name];
                if (programAttribute.location >= 0) {
                  var geometryAttribute = geometryAttributes[name];
                  if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                  }
                  if (geometryAttribute !== undefined) {
                    var normalized = geometryAttribute.normalized;
                    var size = geometryAttribute.itemSize;
                    var attribute = attributes.get(geometryAttribute); // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    var buffer = attribute.buffer;
                    var type = attribute.type;
                    var bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                      var data = geometryAttribute.data;
                      var stride = data.stride;
                      var offset = geometryAttribute.offset;
                      if (data.isInstancedInterleavedBuffer) {
                        for (var i = 0; i < programAttribute.locationSize; i++) {
                          enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                        }
                        if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) {
                          geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        }
                      } else {
                        for (var _i19 = 0; _i19 < programAttribute.locationSize; _i19++) {
                          enableAttribute(programAttribute.location + _i19);
                        }
                      }
                      gl.bindBuffer(34962, buffer);
                      for (var _i20 = 0; _i20 < programAttribute.locationSize; _i20++) {
                        vertexAttribPointer(programAttribute.location + _i20, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * _i20) * bytesPerElement);
                      }
                    } else {
                      if (geometryAttribute.isInstancedBufferAttribute) {
                        for (var _i21 = 0; _i21 < programAttribute.locationSize; _i21++) {
                          enableAttributeAndDivisor(programAttribute.location + _i21, geometryAttribute.meshPerAttribute);
                        }
                        if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) {
                          geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        }
                      } else {
                        for (var _i22 = 0; _i22 < programAttribute.locationSize; _i22++) {
                          enableAttribute(programAttribute.location + _i22);
                        }
                      }
                      gl.bindBuffer(34962, buffer);
                      for (var _i23 = 0; _i23 < programAttribute.locationSize; _i23++) {
                        vertexAttribPointer(programAttribute.location + _i23, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * _i23 * bytesPerElement);
                      }
                    }
                  } else if (materialDefaultAttributeValues !== undefined) {
                    var _value3 = materialDefaultAttributeValues[name];
                    if (_value3 !== undefined) {
                      switch (_value3.length) {
                        case 2:
                          gl.vertexAttrib2fv(programAttribute.location, _value3);
                          break;
                        case 3:
                          gl.vertexAttrib3fv(programAttribute.location, _value3);
                          break;
                        case 4:
                          gl.vertexAttrib4fv(programAttribute.location, _value3);
                          break;
                        default:
                          gl.vertexAttrib1fv(programAttribute.location, _value3);
                      }
                    }
                  }
                }
              }
              disableUnusedAttributes();
            }
            function dispose() {
              reset();
              for (var geometryId in bindingStates) {
                var programMap = bindingStates[geometryId];
                for (var programId in programMap) {
                  var stateMap = programMap[programId];
                  for (var wireframe in stateMap) {
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                  }
                  delete programMap[programId];
                }
                delete bindingStates[geometryId];
              }
            }
            function releaseStatesOfGeometry(geometry) {
              if (bindingStates[geometry.id] === undefined) return;
              var programMap = bindingStates[geometry.id];
              for (var programId in programMap) {
                var stateMap = programMap[programId];
                for (var wireframe in stateMap) {
                  deleteVertexArrayObject(stateMap[wireframe].object);
                  delete stateMap[wireframe];
                }
                delete programMap[programId];
              }
              delete bindingStates[geometry.id];
            }
            function releaseStatesOfProgram(program) {
              for (var geometryId in bindingStates) {
                var programMap = bindingStates[geometryId];
                if (programMap[program.id] === undefined) continue;
                var stateMap = programMap[program.id];
                for (var wireframe in stateMap) {
                  deleteVertexArrayObject(stateMap[wireframe].object);
                  delete stateMap[wireframe];
                }
                delete programMap[program.id];
              }
            }
            function reset() {
              resetDefaultState();
              forceUpdate = true;
              if (currentState === defaultState) return;
              currentState = defaultState;
              bindVertexArrayObject(currentState.object);
            } // for backward-compatibility
            function resetDefaultState() {
              defaultState.geometry = null;
              defaultState.program = null;
              defaultState.wireframe = false;
            }
            return {
              setup: setup,
              reset: reset,
              resetDefaultState: resetDefaultState,
              dispose: dispose,
              releaseStatesOfGeometry: releaseStatesOfGeometry,
              releaseStatesOfProgram: releaseStatesOfProgram,
              initAttributes: initAttributes,
              enableAttribute: enableAttribute,
              disableUnusedAttributes: disableUnusedAttributes
            };
          }
          function WebGLBufferRenderer(gl, extensions, info, capabilities) {
            var isWebGL2 = capabilities.isWebGL2;
            var mode;
            function setMode(value) {
              mode = value;
            }
            function render(start, count) {
              gl.drawArrays(mode, start, count);
              info.update(count, mode, 1);
            }
            function renderInstances(start, count, primcount) {
              if (primcount === 0) return;
              var extension, methodName;
              if (isWebGL2) {
                extension = gl;
                methodName = 'drawArraysInstanced';
              } else {
                extension = extensions.get('ANGLE_instanced_arrays');
                methodName = 'drawArraysInstancedANGLE';
                if (extension === null) {
                  console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                  return;
                }
              }
              extension[methodName](mode, start, count, primcount);
              info.update(count, mode, primcount);
            } //
            this.setMode = setMode;
            this.render = render;
            this.renderInstances = renderInstances;
          }
          function WebGLCapabilities(gl, extensions, parameters) {
            var maxAnisotropy;
            function getMaxAnisotropy() {
              if (maxAnisotropy !== undefined) return maxAnisotropy;
              if (extensions.has('EXT_texture_filter_anisotropic') === true) {
                var extension = extensions.get('EXT_texture_filter_anisotropic');
                maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
              } else {
                maxAnisotropy = 0;
              }
              return maxAnisotropy;
            }
            function getMaxPrecision(precision) {
              if (precision === 'highp') {
                if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) {
                  return 'highp';
                }
                precision = 'mediump';
              }
              if (precision === 'mediump') {
                if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) {
                  return 'mediump';
                }
              }
              return 'lowp';
            }
            var isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
            var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
            var maxPrecision = getMaxPrecision(precision);
            if (maxPrecision !== precision) {
              console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
              precision = maxPrecision;
            }
            var drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
            var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
            var maxTextures = gl.getParameter(34930);
            var maxVertexTextures = gl.getParameter(35660);
            var maxTextureSize = gl.getParameter(3379);
            var maxCubemapSize = gl.getParameter(34076);
            var maxAttributes = gl.getParameter(34921);
            var maxVertexUniforms = gl.getParameter(36347);
            var maxVaryings = gl.getParameter(36348);
            var maxFragmentUniforms = gl.getParameter(36349);
            var vertexTextures = maxVertexTextures > 0;
            var floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
            var floatVertexTextures = vertexTextures && floatFragmentTextures;
            var maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
            return {
              isWebGL2: isWebGL2,
              drawBuffers: drawBuffers,
              getMaxAnisotropy: getMaxAnisotropy,
              getMaxPrecision: getMaxPrecision,
              precision: precision,
              logarithmicDepthBuffer: logarithmicDepthBuffer,
              maxTextures: maxTextures,
              maxVertexTextures: maxVertexTextures,
              maxTextureSize: maxTextureSize,
              maxCubemapSize: maxCubemapSize,
              maxAttributes: maxAttributes,
              maxVertexUniforms: maxVertexUniforms,
              maxVaryings: maxVaryings,
              maxFragmentUniforms: maxFragmentUniforms,
              vertexTextures: vertexTextures,
              floatFragmentTextures: floatFragmentTextures,
              floatVertexTextures: floatVertexTextures,
              maxSamples: maxSamples
            };
          }
          function WebGLClipping(properties) {
            var scope = this;
            var globalState = null,
              numGlobalPlanes = 0,
              localClippingEnabled = false,
              renderingShadows = false;
            var plane = new _Plane(),
              viewNormalMatrix = new _Matrix(),
              uniform = {
                value: null,
                needsUpdate: false
              };
            this.uniform = uniform;
            this.numPlanes = 0;
            this.numIntersection = 0;
            this.init = function (planes, enableLocalClipping, camera) {
              var enabled = planes.length !== 0 || enableLocalClipping ||
              // enable state of previous frame - the clipping code has to
              // run another frame in order to reset the state:
              numGlobalPlanes !== 0 || localClippingEnabled;
              localClippingEnabled = enableLocalClipping;
              globalState = projectPlanes(planes, camera, 0);
              numGlobalPlanes = planes.length;
              return enabled;
            };
            this.beginShadows = function () {
              renderingShadows = true;
              projectPlanes(null);
            };
            this.endShadows = function () {
              renderingShadows = false;
              resetGlobalState();
            };
            this.setState = function (material, camera, useCache) {
              var planes = material.clippingPlanes,
                clipIntersection = material.clipIntersection,
                clipShadows = material.clipShadows;
              var materialProperties = properties.get(material);
              if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
                // there's no local clipping
                if (renderingShadows) {
                  // there's no global clipping
                  projectPlanes(null);
                } else {
                  resetGlobalState();
                }
              } else {
                var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
                  lGlobal = nGlobal * 4;
                var dstArray = materialProperties.clippingState || null;
                uniform.value = dstArray; // ensure unique state
                dstArray = projectPlanes(planes, camera, lGlobal, useCache);
                for (var i = 0; i !== lGlobal; ++i) {
                  dstArray[i] = globalState[i];
                }
                materialProperties.clippingState = dstArray;
                this.numIntersection = clipIntersection ? this.numPlanes : 0;
                this.numPlanes += nGlobal;
              }
            };
            function resetGlobalState() {
              if (uniform.value !== globalState) {
                uniform.value = globalState;
                uniform.needsUpdate = numGlobalPlanes > 0;
              }
              scope.numPlanes = numGlobalPlanes;
              scope.numIntersection = 0;
            }
            function projectPlanes(planes, camera, dstOffset, skipTransform) {
              var nPlanes = planes !== null ? planes.length : 0;
              var dstArray = null;
              if (nPlanes !== 0) {
                dstArray = uniform.value;
                if (skipTransform !== true || dstArray === null) {
                  var flatSize = dstOffset + nPlanes * 4,
                    viewMatrix = camera.matrixWorldInverse;
                  viewNormalMatrix.getNormalMatrix(viewMatrix);
                  if (dstArray === null || dstArray.length < flatSize) {
                    dstArray = new Float32Array(flatSize);
                  }
                  for (var i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4) {
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                  }
                }
                uniform.value = dstArray;
                uniform.needsUpdate = true;
              }
              scope.numPlanes = nPlanes;
              scope.numIntersection = 0;
              return dstArray;
            }
          }
          function WebGLCubeMaps(renderer) {
            var cubemaps = new WeakMap();
            function mapTextureMapping(texture, mapping) {
              if (mapping === _EquirectangularReflectionMapping) {
                texture.mapping = _CubeReflectionMapping;
              } else if (mapping === _EquirectangularRefractionMapping) {
                texture.mapping = _CubeRefractionMapping;
              }
              return texture;
            }
            function get(texture) {
              if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
                var mapping = texture.mapping;
                if (mapping === _EquirectangularReflectionMapping || mapping === _EquirectangularRefractionMapping) {
                  if (cubemaps.has(texture)) {
                    var cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                  } else {
                    var image = texture.image;
                    if (image && image.height > 0) {
                      var renderTarget = new _WebGLCubeRenderTarget(image.height / 2);
                      renderTarget.fromEquirectangularTexture(renderer, texture);
                      cubemaps.set(texture, renderTarget);
                      texture.addEventListener('dispose', onTextureDispose);
                      return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else {
                      // image not yet ready. try the conversion next frame
                      return null;
                    }
                  }
                }
              }
              return texture;
            }
            function onTextureDispose(event) {
              var texture = event.target;
              texture.removeEventListener('dispose', onTextureDispose);
              var cubemap = cubemaps.get(texture);
              if (cubemap !== undefined) {
                cubemaps.delete(texture);
                cubemap.dispose();
              }
            }
            function dispose() {
              cubemaps = new WeakMap();
            }
            return {
              get: get,
              dispose: dispose
            };
          }
          var _OrthographicCamera = /*#__PURE__*/function (_Camera3) {
            _inherits(_OrthographicCamera, _Camera3);
            var _super41 = _createSuper(_OrthographicCamera);
            function _OrthographicCamera() {
              var _this33;
              var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
              var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var bottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
              var near = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.1;
              var far = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2000;
              _classCallCheck2(this, _OrthographicCamera);
              _this33 = _super41.call(this);
              _this33.isOrthographicCamera = true;
              _this33.type = 'OrthographicCamera';
              _this33.zoom = 1;
              _this33.view = null;
              _this33.left = left;
              _this33.right = right;
              _this33.top = top;
              _this33.bottom = bottom;
              _this33.near = near;
              _this33.far = far;
              _this33.updateProjectionMatrix();
              return _this33;
            }
            _createClass2(_OrthographicCamera, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_OrthographicCamera.prototype), "copy", this).call(this, source, recursive);
                this.left = source.left;
                this.right = source.right;
                this.top = source.top;
                this.bottom = source.bottom;
                this.near = source.near;
                this.far = source.far;
                this.zoom = source.zoom;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                return this;
              }
            }, {
              key: "setViewOffset",
              value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                if (this.view === null) {
                  this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                  };
                }
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
              }
            }, {
              key: "clearViewOffset",
              value: function clearViewOffset() {
                if (this.view !== null) {
                  this.view.enabled = false;
                }
                this.updateProjectionMatrix();
              }
            }, {
              key: "updateProjectionMatrix",
              value: function updateProjectionMatrix() {
                var dx = (this.right - this.left) / (2 * this.zoom);
                var dy = (this.top - this.bottom) / (2 * this.zoom);
                var cx = (this.right + this.left) / 2;
                var cy = (this.top + this.bottom) / 2;
                var left = cx - dx;
                var right = cx + dx;
                var top = cy + dy;
                var bottom = cy - dy;
                if (this.view !== null && this.view.enabled) {
                  var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
                  var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                  left += scaleW * this.view.offsetX;
                  right = left + scaleW * this.view.width;
                  top -= scaleH * this.view.offsetY;
                  bottom = top - scaleH * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_OrthographicCamera.prototype), "toJSON", this).call(this, meta);
                data.object.zoom = this.zoom;
                data.object.left = this.left;
                data.object.right = this.right;
                data.object.top = this.top;
                data.object.bottom = this.bottom;
                data.object.near = this.near;
                data.object.far = this.far;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                return data;
              }
            }]);
            return _OrthographicCamera;
          }(_Camera);
          var LOD_MIN = 4; // The standard deviations (radians) associated with the extra mips. These are
          // chosen to approximate a Trowbridge-Reitz distribution function times the
          // geometric shadowing function. These sigma values squared must match the
          // variance #defines in cube_uv_reflection_fragment.glsl.js.
          var EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582]; // The maximum length of the blur for loop. Smaller sigmas will use fewer
          // samples and exit early, but not recompile the shader.
          var MAX_SAMPLES = 20;
          var _flatCamera = /*@__PURE__*/new _OrthographicCamera();
          var _clearColor = /*@__PURE__*/new _Color();
          var _oldTarget = null; // Golden Ratio
          var PHI = (1 + Math.sqrt(5)) / 2;
          var INV_PHI = 1 / PHI; // Vertices of a dodecahedron (except the opposites, which represent the
          // same axis), used as axis directions evenly spread on a sphere.
          var _axisDirections = [/*@__PURE__*/new _Vector2(1, 1, 1), /*@__PURE__*/new _Vector2(-1, 1, 1), /*@__PURE__*/new _Vector2(1, 1, -1), /*@__PURE__*/new _Vector2(-1, 1, -1), /*@__PURE__*/new _Vector2(0, PHI, INV_PHI), /*@__PURE__*/new _Vector2(0, PHI, -INV_PHI), /*@__PURE__*/new _Vector2(INV_PHI, 0, PHI), /*@__PURE__*/new _Vector2(-INV_PHI, 0, PHI), /*@__PURE__*/new _Vector2(PHI, INV_PHI, 0), /*@__PURE__*/new _Vector2(-PHI, INV_PHI, 0)]; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * (PMREM) from a cubeMap environment texture. This allows different levels of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * blur to be quickly accessed based on material roughness. It is packed into a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * special CubeUV format that allows us to perform custom interpolation so that
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * higher roughness levels. In this way we maintain resolution to smoothly
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * interpolate diffuse lighting while limiting sampling computation.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * Paper: Fast, Accurate Image-Based Lighting
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */
          var _PMREMGenerator = /*#__PURE__*/function () {
            function _PMREMGenerator(renderer) {
              _classCallCheck2(this, _PMREMGenerator);
              this._renderer = renderer;
              this._pingPongRenderTarget = null;
              this._lodMax = 0;
              this._cubeSize = 0;
              this._lodPlanes = [];
              this._sizeLods = [];
              this._sigmas = [];
              this._blurMaterial = null;
              this._cubemapMaterial = null;
              this._equirectMaterial = null;
              this._compileMaterial(this._blurMaterial);
            } /**
              * Generates a PMREM from a supplied Scene, which can be faster than using an
              * image if networking bandwidth is low. Optional sigma specifies a blur radius
              * in radians to be applied to the scene before PMREM generation. Optional near
              * and far planes ensure the scene is rendered in its entirety (the cubeCamera
              * is placed at the origin).
              */
            _createClass2(_PMREMGenerator, [{
              key: "fromScene",
              value: function fromScene(scene) {
                var sigma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
                var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
                _oldTarget = this._renderer.getRenderTarget();
                this._setSize(256);
                var cubeUVRenderTarget = this._allocateTargets();
                cubeUVRenderTarget.depthBuffer = true;
                this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
                if (sigma > 0) {
                  this._blur(cubeUVRenderTarget, 0, 0, sigma);
                }
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
              } /**
                * Generates a PMREM from an equirectangular texture, which can be either LDR
                * or HDR. The ideal input image size is 1k (1024 x 512),
                * as this matches best with the 256 x 256 cubemap output.
                */
            }, {
              key: "fromEquirectangular",
              value: function fromEquirectangular(equirectangular) {
                var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                return this._fromTexture(equirectangular, renderTarget);
              } /**
                * Generates a PMREM from an cubemap texture, which can be either LDR
                * or HDR. The ideal input cube size is 256 x 256,
                * as this matches best with the 256 x 256 cubemap output.
                */
            }, {
              key: "fromCubemap",
              value: function fromCubemap(cubemap) {
                var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                return this._fromTexture(cubemap, renderTarget);
              } /**
                * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
                * your texture's network fetch for increased concurrency.
                */
            }, {
              key: "compileCubemapShader",
              value: function compileCubemapShader() {
                if (this._cubemapMaterial === null) {
                  this._cubemapMaterial = _getCubemapMaterial();
                  this._compileMaterial(this._cubemapMaterial);
                }
              } /**
                * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
                * your texture's network fetch for increased concurrency.
                */
            }, {
              key: "compileEquirectangularShader",
              value: function compileEquirectangularShader() {
                if (this._equirectMaterial === null) {
                  this._equirectMaterial = _getEquirectMaterial();
                  this._compileMaterial(this._equirectMaterial);
                }
              } /**
                * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
                * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
                * one of them will cause any others to also become unusable.
                */
            }, {
              key: "dispose",
              value: function dispose() {
                this._dispose();
                if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
                if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
              } // private interface
            }, {
              key: "_setSize",
              value: function _setSize(cubeSize) {
                this._lodMax = Math.floor(Math.log2(cubeSize));
                this._cubeSize = Math.pow(2, this._lodMax);
              }
            }, {
              key: "_dispose",
              value: function _dispose() {
                if (this._blurMaterial !== null) this._blurMaterial.dispose();
                if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
                for (var i = 0; i < this._lodPlanes.length; i++) {
                  this._lodPlanes[i].dispose();
                }
              }
            }, {
              key: "_cleanup",
              value: function _cleanup(outputTarget) {
                this._renderer.setRenderTarget(_oldTarget);
                outputTarget.scissorTest = false;
                _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
              }
            }, {
              key: "_fromTexture",
              value: function _fromTexture(texture, renderTarget) {
                if (texture.mapping === _CubeReflectionMapping || texture.mapping === _CubeRefractionMapping) {
                  this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
                } else {
                  // Equirectangular
                  this._setSize(texture.image.width / 4);
                }
                _oldTarget = this._renderer.getRenderTarget();
                var cubeUVRenderTarget = renderTarget || this._allocateTargets();
                this._textureToCubeUV(texture, cubeUVRenderTarget);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
              }
            }, {
              key: "_allocateTargets",
              value: function _allocateTargets() {
                var width = 3 * Math.max(this._cubeSize, 16 * 7);
                var height = 4 * this._cubeSize;
                var params = {
                  magFilter: _LinearFilter,
                  minFilter: _LinearFilter,
                  generateMipmaps: false,
                  type: _HalfFloatType,
                  format: _RGBAFormat,
                  encoding: _LinearEncoding,
                  depthBuffer: false
                };
                var cubeUVRenderTarget = _createRenderTarget(width, height, params);
                if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width) {
                  if (this._pingPongRenderTarget !== null) {
                    this._dispose();
                  }
                  this._pingPongRenderTarget = _createRenderTarget(width, height, params);
                  var _lodMax = this._lodMax;
                  var _createPlanes2 = _createPlanes(_lodMax);
                  this._sizeLods = _createPlanes2.sizeLods;
                  this._lodPlanes = _createPlanes2.lodPlanes;
                  this._sigmas = _createPlanes2.sigmas;
                  this._blurMaterial = _getBlurShader(_lodMax, width, height);
                }
                return cubeUVRenderTarget;
              }
            }, {
              key: "_compileMaterial",
              value: function _compileMaterial(material) {
                var tmpMesh = new _Mesh(this._lodPlanes[0], material);
                this._renderer.compile(tmpMesh, _flatCamera);
              }
            }, {
              key: "_sceneToCubeUV",
              value: function _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
                var fov = 90;
                var aspect = 1;
                var cubeCamera = new _PerspectiveCamera(fov, aspect, near, far);
                var upSign = [1, -1, 1, 1, 1, 1];
                var forwardSign = [1, 1, 1, -1, -1, -1];
                var renderer = this._renderer;
                var originalAutoClear = renderer.autoClear;
                var toneMapping = renderer.toneMapping;
                renderer.getClearColor(_clearColor);
                renderer.toneMapping = _NoToneMapping;
                renderer.autoClear = false;
                var backgroundMaterial = new _MeshBasicMaterial({
                  name: 'PMREM.Background',
                  side: _BackSide,
                  depthWrite: false,
                  depthTest: false
                });
                var backgroundBox = new _Mesh(new _BoxGeometry(), backgroundMaterial);
                var useSolidColor = false;
                var background = scene.background;
                if (background) {
                  if (background.isColor) {
                    backgroundMaterial.color.copy(background);
                    scene.background = null;
                    useSolidColor = true;
                  }
                } else {
                  backgroundMaterial.color.copy(_clearColor);
                  useSolidColor = true;
                }
                for (var i = 0; i < 6; i++) {
                  var col = i % 3;
                  if (col === 0) {
                    cubeCamera.up.set(0, upSign[i], 0);
                    cubeCamera.lookAt(forwardSign[i], 0, 0);
                  } else if (col === 1) {
                    cubeCamera.up.set(0, 0, upSign[i]);
                    cubeCamera.lookAt(0, forwardSign[i], 0);
                  } else {
                    cubeCamera.up.set(0, upSign[i], 0);
                    cubeCamera.lookAt(0, 0, forwardSign[i]);
                  }
                  var size = this._cubeSize;
                  _setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
                  renderer.setRenderTarget(cubeUVRenderTarget);
                  if (useSolidColor) {
                    renderer.render(backgroundBox, cubeCamera);
                  }
                  renderer.render(scene, cubeCamera);
                }
                backgroundBox.geometry.dispose();
                backgroundBox.material.dispose();
                renderer.toneMapping = toneMapping;
                renderer.autoClear = originalAutoClear;
                scene.background = background;
              }
            }, {
              key: "_textureToCubeUV",
              value: function _textureToCubeUV(texture, cubeUVRenderTarget) {
                var renderer = this._renderer;
                var isCubeTexture = texture.mapping === _CubeReflectionMapping || texture.mapping === _CubeRefractionMapping;
                if (isCubeTexture) {
                  if (this._cubemapMaterial === null) {
                    this._cubemapMaterial = _getCubemapMaterial();
                  }
                  this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
                } else {
                  if (this._equirectMaterial === null) {
                    this._equirectMaterial = _getEquirectMaterial();
                  }
                }
                var material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
                var mesh = new _Mesh(this._lodPlanes[0], material);
                var uniforms = material.uniforms;
                uniforms['envMap'].value = texture;
                var size = this._cubeSize;
                _setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
                renderer.setRenderTarget(cubeUVRenderTarget);
                renderer.render(mesh, _flatCamera);
              }
            }, {
              key: "_applyPMREM",
              value: function _applyPMREM(cubeUVRenderTarget) {
                var renderer = this._renderer;
                var autoClear = renderer.autoClear;
                renderer.autoClear = false;
                for (var i = 1; i < this._lodPlanes.length; i++) {
                  var sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
                  var poleAxis = _axisDirections[(i - 1) % _axisDirections.length];
                  this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
                }
                renderer.autoClear = autoClear;
              } /**
                * This is a two-pass Gaussian blur for a cubemap. Normally this is done
                * vertically and horizontally, but this breaks down on a cube. Here we apply
                * the blur latitudinally (around the poles), and then longitudinally (towards
                * the poles) to approximate the orthogonally-separable blur. It is least
                * accurate at the poles, but still does a decent job.
                */
            }, {
              key: "_blur",
              value: function _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
                var pingPongRenderTarget = this._pingPongRenderTarget;
                this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
                this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
              }
            }, {
              key: "_halfBlur",
              value: function _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
                var renderer = this._renderer;
                var blurMaterial = this._blurMaterial;
                if (direction !== 'latitudinal' && direction !== 'longitudinal') {
                  console.error('blur direction must be either latitudinal or longitudinal!');
                } // Number of standard deviations at which to cut off the discrete approximation.
                var STANDARD_DEVIATIONS = 3;
                var blurMesh = new _Mesh(this._lodPlanes[lodOut], blurMaterial);
                var blurUniforms = blurMaterial.uniforms;
                var pixels = this._sizeLods[lodIn] - 1;
                var radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
                var sigmaPixels = sigmaRadians / radiansPerPixel;
                var samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
                if (samples > MAX_SAMPLES) {
                  console.warn("sigmaRadians, ".concat(sigmaRadians, ", is too large and will clip, as it requested ").concat(samples, " samples when the maximum is set to ").concat(MAX_SAMPLES));
                }
                var weights = [];
                var sum = 0;
                for (var i = 0; i < MAX_SAMPLES; ++i) {
                  var _x2 = i / sigmaPixels;
                  var weight = Math.exp(-_x2 * _x2 / 2);
                  weights.push(weight);
                  if (i === 0) {
                    sum += weight;
                  } else if (i < samples) {
                    sum += 2 * weight;
                  }
                }
                for (var _i24 = 0; _i24 < weights.length; _i24++) {
                  weights[_i24] = weights[_i24] / sum;
                }
                blurUniforms['envMap'].value = targetIn.texture;
                blurUniforms['samples'].value = samples;
                blurUniforms['weights'].value = weights;
                blurUniforms['latitudinal'].value = direction === 'latitudinal';
                if (poleAxis) {
                  blurUniforms['poleAxis'].value = poleAxis;
                }
                var _lodMax = this._lodMax;
                blurUniforms['dTheta'].value = radiansPerPixel;
                blurUniforms['mipInt'].value = _lodMax - lodIn;
                var outputSize = this._sizeLods[lodOut];
                var x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
                var y = 4 * (this._cubeSize - outputSize);
                _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
                renderer.setRenderTarget(targetOut);
                renderer.render(blurMesh, _flatCamera);
              }
            }]);
            return _PMREMGenerator;
          }();
          function _createPlanes(lodMax) {
            var lodPlanes = [];
            var sizeLods = [];
            var sigmas = [];
            var lod = lodMax;
            var totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
            for (var i = 0; i < totalLods; i++) {
              var sizeLod = Math.pow(2, lod);
              sizeLods.push(sizeLod);
              var sigma = 1.0 / sizeLod;
              if (i > lodMax - LOD_MIN) {
                sigma = EXTRA_LOD_SIGMA[i - lodMax + LOD_MIN - 1];
              } else if (i === 0) {
                sigma = 0;
              }
              sigmas.push(sigma);
              var texelSize = 1.0 / (sizeLod - 2);
              var min = -texelSize;
              var max = 1 + texelSize;
              var uv1 = [min, min, max, min, max, max, min, min, max, max, min, max];
              var cubeFaces = 6;
              var vertices = 6;
              var positionSize = 3;
              var uvSize = 2;
              var faceIndexSize = 1;
              var position = new Float32Array(positionSize * vertices * cubeFaces);
              var uv = new Float32Array(uvSize * vertices * cubeFaces);
              var faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
              for (var face = 0; face < cubeFaces; face++) {
                var x = face % 3 * 2 / 3 - 1;
                var y = face > 2 ? 0 : -1;
                var coordinates = [x, y, 0, x + 2 / 3, y, 0, x + 2 / 3, y + 1, 0, x, y, 0, x + 2 / 3, y + 1, 0, x, y + 1, 0];
                position.set(coordinates, positionSize * vertices * face);
                uv.set(uv1, uvSize * vertices * face);
                var fill = [face, face, face, face, face, face];
                faceIndex.set(fill, faceIndexSize * vertices * face);
              }
              var planes = new _BufferGeometry();
              planes.setAttribute('position', new _BufferAttribute(position, positionSize));
              planes.setAttribute('uv', new _BufferAttribute(uv, uvSize));
              planes.setAttribute('faceIndex', new _BufferAttribute(faceIndex, faceIndexSize));
              lodPlanes.push(planes);
              if (lod > LOD_MIN) {
                lod--;
              }
            }
            return {
              lodPlanes: lodPlanes,
              sizeLods: sizeLods,
              sigmas: sigmas
            };
          }
          function _createRenderTarget(width, height, params) {
            var cubeUVRenderTarget = new _WebGLRenderTarget(width, height, params);
            cubeUVRenderTarget.texture.mapping = _CubeUVReflectionMapping;
            cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
            cubeUVRenderTarget.scissorTest = true;
            return cubeUVRenderTarget;
          }
          function _setViewport(target, x, y, width, height) {
            target.viewport.set(x, y, width, height);
            target.scissor.set(x, y, width, height);
          }
          function _getBlurShader(lodMax, width, height) {
            var weights = new Float32Array(MAX_SAMPLES);
            var poleAxis = new _Vector2(0, 1, 0);
            var shaderMaterial = new _ShaderMaterial({
              name: 'SphericalGaussianBlur',
              defines: {
                'n': MAX_SAMPLES,
                'CUBEUV_TEXEL_WIDTH': 1.0 / width,
                'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
                'CUBEUV_MAX_MIP': "".concat(lodMax, ".0")
              },
              uniforms: {
                'envMap': {
                  value: null
                },
                'samples': {
                  value: 1
                },
                'weights': {
                  value: weights
                },
                'latitudinal': {
                  value: false
                },
                'dTheta': {
                  value: 0
                },
                'mipInt': {
                  value: 0
                },
                'poleAxis': {
                  value: poleAxis
                }
              },
              vertexShader: _getCommonVertexShader(),
              fragmentShader: /* glsl */"\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
              blending: _NoBlending,
              depthTest: false,
              depthWrite: false
            });
            return shaderMaterial;
          }
          function _getEquirectMaterial() {
            return new _ShaderMaterial({
              name: 'EquirectangularToCubeUV',
              uniforms: {
                'envMap': {
                  value: null
                }
              },
              vertexShader: _getCommonVertexShader(),
              fragmentShader: /* glsl */"\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
              blending: _NoBlending,
              depthTest: false,
              depthWrite: false
            });
          }
          function _getCubemapMaterial() {
            return new _ShaderMaterial({
              name: 'CubemapToCubeUV',
              uniforms: {
                'envMap': {
                  value: null
                },
                'flipEnvMap': {
                  value: -1
                }
              },
              vertexShader: _getCommonVertexShader(),
              fragmentShader: /* glsl */"\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
              blending: _NoBlending,
              depthTest: false,
              depthWrite: false
            });
          }
          function _getCommonVertexShader() {
            return (/* glsl */"\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t"
            );
          }
          function WebGLCubeUVMaps(renderer) {
            var cubeUVmaps = new WeakMap();
            var pmremGenerator = null;
            function get(texture) {
              if (texture && texture.isTexture) {
                var mapping = texture.mapping;
                var isEquirectMap = mapping === _EquirectangularReflectionMapping || mapping === _EquirectangularRefractionMapping;
                var isCubeMap = mapping === _CubeReflectionMapping || mapping === _CubeRefractionMapping; // equirect/cube map to cubeUV conversion
                if (isEquirectMap || isCubeMap) {
                  if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    var renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new _PMREMGenerator(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                  } else {
                    if (cubeUVmaps.has(texture)) {
                      return cubeUVmaps.get(texture).texture;
                    } else {
                      var image = texture.image;
                      if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                        if (pmremGenerator === null) pmremGenerator = new _PMREMGenerator(renderer);
                        var _renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                        cubeUVmaps.set(texture, _renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return _renderTarget.texture;
                      } else {
                        // image not yet ready. try the conversion next frame
                        return null;
                      }
                    }
                  }
                }
              }
              return texture;
            }
            function isCubeTextureComplete(image) {
              var count = 0;
              var length = 6;
              for (var i = 0; i < length; i++) {
                if (image[i] !== undefined) count++;
              }
              return count === length;
            }
            function onTextureDispose(event) {
              var texture = event.target;
              texture.removeEventListener('dispose', onTextureDispose);
              var cubemapUV = cubeUVmaps.get(texture);
              if (cubemapUV !== undefined) {
                cubeUVmaps.delete(texture);
                cubemapUV.dispose();
              }
            }
            function dispose() {
              cubeUVmaps = new WeakMap();
              if (pmremGenerator !== null) {
                pmremGenerator.dispose();
                pmremGenerator = null;
              }
            }
            return {
              get: get,
              dispose: dispose
            };
          }
          function WebGLExtensions(gl) {
            var extensions = {};
            function getExtension(name) {
              if (extensions[name] !== undefined) {
                return extensions[name];
              }
              var extension;
              switch (name) {
                case 'WEBGL_depth_texture':
                  extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                  break;
                case 'EXT_texture_filter_anisotropic':
                  extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                  break;
                case 'WEBGL_compressed_texture_s3tc':
                  extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                  break;
                case 'WEBGL_compressed_texture_pvrtc':
                  extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                  break;
                default:
                  extension = gl.getExtension(name);
              }
              extensions[name] = extension;
              return extension;
            }
            return {
              has: function has(name) {
                return getExtension(name) !== null;
              },
              init: function init(capabilities) {
                if (capabilities.isWebGL2) {
                  getExtension('EXT_color_buffer_float');
                } else {
                  getExtension('WEBGL_depth_texture');
                  getExtension('OES_texture_float');
                  getExtension('OES_texture_half_float');
                  getExtension('OES_texture_half_float_linear');
                  getExtension('OES_standard_derivatives');
                  getExtension('OES_element_index_uint');
                  getExtension('OES_vertex_array_object');
                  getExtension('ANGLE_instanced_arrays');
                }
                getExtension('OES_texture_float_linear');
                getExtension('EXT_color_buffer_half_float');
                getExtension('WEBGL_multisampled_render_to_texture');
              },
              get: function get(name) {
                var extension = getExtension(name);
                if (extension === null) {
                  console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
                }
                return extension;
              }
            };
          }
          function WebGLGeometries(gl, attributes, info, bindingStates) {
            var geometries = {};
            var wireframeAttributes = new WeakMap();
            function onGeometryDispose(event) {
              var geometry = event.target;
              if (geometry.index !== null) {
                attributes.remove(geometry.index);
              }
              for (var name in geometry.attributes) {
                attributes.remove(geometry.attributes[name]);
              }
              geometry.removeEventListener('dispose', onGeometryDispose);
              delete geometries[geometry.id];
              var attribute = wireframeAttributes.get(geometry);
              if (attribute) {
                attributes.remove(attribute);
                wireframeAttributes.delete(geometry);
              }
              bindingStates.releaseStatesOfGeometry(geometry);
              if (geometry.isInstancedBufferGeometry === true) {
                delete geometry._maxInstanceCount;
              } //
              info.memory.geometries--;
            }
            function get(object, geometry) {
              if (geometries[geometry.id] === true) return geometry;
              geometry.addEventListener('dispose', onGeometryDispose);
              geometries[geometry.id] = true;
              info.memory.geometries++;
              return geometry;
            }
            function update(geometry) {
              var geometryAttributes = geometry.attributes; // Updating index buffer in VAO now. See WebGLBindingStates.
              for (var name in geometryAttributes) {
                attributes.update(geometryAttributes[name], 34962);
              } // morph targets
              var morphAttributes = geometry.morphAttributes;
              for (var _name3 in morphAttributes) {
                var array = morphAttributes[_name3];
                for (var i = 0, l = array.length; i < l; i++) {
                  attributes.update(array[i], 34962);
                }
              }
            }
            function updateWireframeAttribute(geometry) {
              var indices = [];
              var geometryIndex = geometry.index;
              var geometryPosition = geometry.attributes.position;
              var version = 0;
              if (geometryIndex !== null) {
                var array = geometryIndex.array;
                version = geometryIndex.version;
                for (var i = 0, l = array.length; i < l; i += 3) {
                  var a = array[i + 0];
                  var b = array[i + 1];
                  var c = array[i + 2];
                  indices.push(a, b, b, c, c, a);
                }
              } else {
                var _array = geometryPosition.array;
                version = geometryPosition.version;
                for (var _i25 = 0, _l5 = _array.length / 3 - 1; _i25 < _l5; _i25 += 3) {
                  var _a4 = _i25 + 0;
                  var _b4 = _i25 + 1;
                  var _c4 = _i25 + 2;
                  indices.push(_a4, _b4, _b4, _c4, _c4, _a4);
                }
              }
              var attribute = new (arrayNeedsUint32(indices) ? _Uint32BufferAttribute : _Uint16BufferAttribute)(indices, 1);
              attribute.version = version; // Updating index buffer in VAO now. See WebGLBindingStates
              //
              var previousAttribute = wireframeAttributes.get(geometry);
              if (previousAttribute) attributes.remove(previousAttribute); //
              wireframeAttributes.set(geometry, attribute);
            }
            function getWireframeAttribute(geometry) {
              var currentAttribute = wireframeAttributes.get(geometry);
              if (currentAttribute) {
                var geometryIndex = geometry.index;
                if (geometryIndex !== null) {
                  // if the attribute is obsolete, create a new one
                  if (currentAttribute.version < geometryIndex.version) {
                    updateWireframeAttribute(geometry);
                  }
                }
              } else {
                updateWireframeAttribute(geometry);
              }
              return wireframeAttributes.get(geometry);
            }
            return {
              get: get,
              update: update,
              getWireframeAttribute: getWireframeAttribute
            };
          }
          function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
            var isWebGL2 = capabilities.isWebGL2;
            var mode;
            function setMode(value) {
              mode = value;
            }
            var type, bytesPerElement;
            function setIndex(value) {
              type = value.type;
              bytesPerElement = value.bytesPerElement;
            }
            function render(start, count) {
              gl.drawElements(mode, count, type, start * bytesPerElement);
              info.update(count, mode, 1);
            }
            function renderInstances(start, count, primcount) {
              if (primcount === 0) return;
              var extension, methodName;
              if (isWebGL2) {
                extension = gl;
                methodName = 'drawElementsInstanced';
              } else {
                extension = extensions.get('ANGLE_instanced_arrays');
                methodName = 'drawElementsInstancedANGLE';
                if (extension === null) {
                  console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                  return;
                }
              }
              extension[methodName](mode, count, type, start * bytesPerElement, primcount);
              info.update(count, mode, primcount);
            } //
            this.setMode = setMode;
            this.setIndex = setIndex;
            this.render = render;
            this.renderInstances = renderInstances;
          }
          function WebGLInfo(gl) {
            var memory = {
              geometries: 0,
              textures: 0
            };
            var render = {
              frame: 0,
              calls: 0,
              triangles: 0,
              points: 0,
              lines: 0
            };
            function update(count, mode, instanceCount) {
              render.calls++;
              switch (mode) {
                case 4:
                  render.triangles += instanceCount * (count / 3);
                  break;
                case 1:
                  render.lines += instanceCount * (count / 2);
                  break;
                case 3:
                  render.lines += instanceCount * (count - 1);
                  break;
                case 2:
                  render.lines += instanceCount * count;
                  break;
                case 0:
                  render.points += instanceCount * count;
                  break;
                default:
                  console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                  break;
              }
            }
            function reset() {
              render.frame++;
              render.calls = 0;
              render.triangles = 0;
              render.points = 0;
              render.lines = 0;
            }
            return {
              memory: memory,
              render: render,
              programs: null,
              autoReset: true,
              reset: reset,
              update: update
            };
          }
          function numericalSort(a, b) {
            return a[0] - b[0];
          }
          function absNumericalSort(a, b) {
            return Math.abs(b[1]) - Math.abs(a[1]);
          }
          function WebGLMorphtargets(gl, capabilities, textures) {
            var influencesList = {};
            var morphInfluences = new Float32Array(8);
            var morphTextures = new WeakMap();
            var morph = new _Vector3();
            var workInfluences = [];
            for (var i = 0; i < 8; i++) {
              workInfluences[i] = [i, 0];
            }
            function update(object, geometry, material, program) {
              var objectInfluences = object.morphTargetInfluences;
              if (capabilities.isWebGL2 === true) {
                // instead of using attributes, the WebGL 2 code path encodes morph targets
                // into an array of data textures. Each layer represents a single morph target.
                var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
                var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
                var entry = morphTextures.get(geometry);
                if (entry === undefined || entry.count !== morphTargetsCount) {
                  var disposeTexture = function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener('dispose', disposeTexture);
                  };
                  if (entry !== undefined) entry.texture.dispose();
                  var hasMorphPosition = geometry.morphAttributes.position !== undefined;
                  var hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                  var hasMorphColors = geometry.morphAttributes.color !== undefined;
                  var morphTargets = geometry.morphAttributes.position || [];
                  var morphNormals = geometry.morphAttributes.normal || [];
                  var morphColors = geometry.morphAttributes.color || [];
                  var vertexDataCount = 0;
                  if (hasMorphPosition === true) vertexDataCount = 1;
                  if (hasMorphNormals === true) vertexDataCount = 2;
                  if (hasMorphColors === true) vertexDataCount = 3;
                  var width = geometry.attributes.position.count * vertexDataCount;
                  var height = 1;
                  if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                  }
                  var buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                  var texture = new _DataArrayTexture(buffer, width, height, morphTargetsCount);
                  texture.type = _FloatType;
                  texture.needsUpdate = true; // fill buffer
                  var vertexDataStride = vertexDataCount * 4;
                  for (var _i26 = 0; _i26 < morphTargetsCount; _i26++) {
                    var morphTarget = morphTargets[_i26];
                    var morphNormal = morphNormals[_i26];
                    var morphColor = morphColors[_i26];
                    var offset = width * height * 4 * _i26;
                    for (var j = 0; j < morphTarget.count; j++) {
                      var stride = j * vertexDataStride;
                      if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                      }
                      if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                      }
                      if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                      }
                    }
                  }
                  entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new _Vector(width, height)
                  };
                  morphTextures.set(geometry, entry);
                  geometry.addEventListener('dispose', disposeTexture);
                } //
                var morphInfluencesSum = 0;
                for (var _i27 = 0; _i27 < objectInfluences.length; _i27++) {
                  morphInfluencesSum += objectInfluences[_i27];
                }
                var morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
                program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
                program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
                program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
                program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
              } else {
                // When object doesn't have morph target influences defined, we treat it as a 0-length array
                // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
                var length = objectInfluences === undefined ? 0 : objectInfluences.length;
                var influences = influencesList[geometry.id];
                if (influences === undefined || influences.length !== length) {
                  // initialise list
                  influences = [];
                  for (var _i28 = 0; _i28 < length; _i28++) {
                    influences[_i28] = [_i28, 0];
                  }
                  influencesList[geometry.id] = influences;
                } // Collect influences
                for (var _i29 = 0; _i29 < length; _i29++) {
                  var influence = influences[_i29];
                  influence[0] = _i29;
                  influence[1] = objectInfluences[_i29];
                }
                influences.sort(absNumericalSort);
                for (var _i30 = 0; _i30 < 8; _i30++) {
                  if (_i30 < length && influences[_i30][1]) {
                    workInfluences[_i30][0] = influences[_i30][0];
                    workInfluences[_i30][1] = influences[_i30][1];
                  } else {
                    workInfluences[_i30][0] = Number.MAX_SAFE_INTEGER;
                    workInfluences[_i30][1] = 0;
                  }
                }
                workInfluences.sort(numericalSort);
                var _morphTargets = geometry.morphAttributes.position;
                var _morphNormals = geometry.morphAttributes.normal;
                var _morphInfluencesSum = 0;
                for (var _i31 = 0; _i31 < 8; _i31++) {
                  var _influence = workInfluences[_i31];
                  var index = _influence[0];
                  var _value4 = _influence[1];
                  if (index !== Number.MAX_SAFE_INTEGER && _value4) {
                    if (_morphTargets && geometry.getAttribute('morphTarget' + _i31) !== _morphTargets[index]) {
                      geometry.setAttribute('morphTarget' + _i31, _morphTargets[index]);
                    }
                    if (_morphNormals && geometry.getAttribute('morphNormal' + _i31) !== _morphNormals[index]) {
                      geometry.setAttribute('morphNormal' + _i31, _morphNormals[index]);
                    }
                    morphInfluences[_i31] = _value4;
                    _morphInfluencesSum += _value4;
                  } else {
                    if (_morphTargets && geometry.hasAttribute('morphTarget' + _i31) === true) {
                      geometry.deleteAttribute('morphTarget' + _i31);
                    }
                    if (_morphNormals && geometry.hasAttribute('morphNormal' + _i31) === true) {
                      geometry.deleteAttribute('morphNormal' + _i31);
                    }
                    morphInfluences[_i31] = 0;
                  }
                } // GLSL shader uses formula baseinfluence * base + sum(target * influence)
                // This allows us to switch between absolute morphs and relative morphs without changing shader code
                // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
                var _morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - _morphInfluencesSum;
                program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', _morphBaseInfluence);
                program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
              }
            }
            return {
              update: update
            };
          }
          function WebGLObjects(gl, geometries, attributes, info) {
            var updateMap = new WeakMap();
            function update(object) {
              var frame = info.render.frame;
              var geometry = object.geometry;
              var buffergeometry = geometries.get(object, geometry); // Update once per frame
              if (updateMap.get(buffergeometry) !== frame) {
                geometries.update(buffergeometry);
                updateMap.set(buffergeometry, frame);
              }
              if (object.isInstancedMesh) {
                if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) {
                  object.addEventListener('dispose', onInstancedMeshDispose);
                }
                attributes.update(object.instanceMatrix, 34962);
                if (object.instanceColor !== null) {
                  attributes.update(object.instanceColor, 34962);
                }
              }
              return buffergeometry;
            }
            function dispose() {
              updateMap = new WeakMap();
            }
            function onInstancedMeshDispose(event) {
              var instancedMesh = event.target;
              instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
              attributes.remove(instancedMesh.instanceMatrix);
              if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
            }
            return {
              update: update,
              dispose: dispose
            };
          } /**
            * Uniforms of a program.
            * Those form a tree structure with a special top-level container for the root,
            * which you get by calling 'new WebGLUniforms( gl, program )'.
            *
            *
            * Properties of inner nodes including the top-level container:
            *
            * .seq - array of nested uniforms
            * .map - nested uniforms by name
            *
            *
            * Methods of all nodes except the top-level container:
            *
            * .setValue( gl, value, [textures] )
            *
            * 		uploads a uniform value(s)
            *  	the 'textures' parameter is needed for sampler uniforms
            *
            *
            * Static methods of the top-level container (textures factorizations):
            *
            * .upload( gl, seq, values, textures )
            *
            * 		sets uniforms in 'seq' to 'values[id].value'
            *
            * .seqWithValue( seq, values ) : filteredSeq
            *
            * 		filters 'seq' entries with corresponding entry in values
            *
            *
            * Methods of the top-level container (textures factorizations):
            *
            * .setValue( gl, name, value, textures )
            *
            * 		sets uniform with  name 'name' to 'value'
            *
            * .setOptional( gl, obj, prop )
            *
            * 		like .set for an optional property of the object
            *
            */
          var emptyTexture = /*@__PURE__*/new _Texture();
          var emptyArrayTexture = /*@__PURE__*/new _DataArrayTexture();
          var empty3dTexture = /*@__PURE__*/new _Data3DTexture();
          var emptyCubeTexture = /*@__PURE__*/new _CubeTexture(); // --- Utilities ---
          // Array Caches (provide typed arrays for temporary by size)
          var arrayCacheF32 = [];
          var arrayCacheI32 = []; // Float32Array caches used for uploading Matrix uniforms
          var mat4array = new Float32Array(16);
          var mat3array = new Float32Array(9);
          var mat2array = new Float32Array(4); // Flattening for arrays of vectors and matrices
          function flatten(array, nBlocks, blockSize) {
            var firstElem = array[0];
            if (firstElem <= 0 || firstElem > 0) return array; // unoptimized: ! isNaN( firstElem )
            // see http://jacksondunstan.com/articles/983
            var n = nBlocks * blockSize;
            var r = arrayCacheF32[n];
            if (r === undefined) {
              r = new Float32Array(n);
              arrayCacheF32[n] = r;
            }
            if (nBlocks !== 0) {
              firstElem.toArray(r, 0);
              for (var i = 1, offset = 0; i !== nBlocks; ++i) {
                offset += blockSize;
                array[i].toArray(r, offset);
              }
            }
            return r;
          }
          function arraysEqual(a, b) {
            if (a.length !== b.length) return false;
            for (var i = 0, l = a.length; i < l; i++) {
              if (a[i] !== b[i]) return false;
            }
            return true;
          }
          function copyArray(a, b) {
            for (var i = 0, l = b.length; i < l; i++) {
              a[i] = b[i];
            }
          } // Texture unit allocation
          function allocTexUnits(textures, n) {
            var r = arrayCacheI32[n];
            if (r === undefined) {
              r = new Int32Array(n);
              arrayCacheI32[n] = r;
            }
            for (var i = 0; i !== n; ++i) {
              r[i] = textures.allocateTextureUnit();
            }
            return r;
          } // --- Setters ---
          // Note: Defining these methods externally, because they come in a bunch
          // and this way their names minify.
          // Single scalar
          function setValueV1f(gl, v) {
            var cache = this.cache;
            if (cache[0] === v) return;
            gl.uniform1f(this.addr, v);
            cache[0] = v;
          } // Single float vector (from flat array or THREE.VectorN)
          function setValueV2f(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y) {
                gl.uniform2f(this.addr, v.x, v.y);
                cache[0] = v.x;
                cache[1] = v.y;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform2fv(this.addr, v);
              copyArray(cache, v);
            }
          }
          function setValueV3f(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
                gl.uniform3f(this.addr, v.x, v.y, v.z);
                cache[0] = v.x;
                cache[1] = v.y;
                cache[2] = v.z;
              }
            } else if (v.r !== undefined) {
              if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
                gl.uniform3f(this.addr, v.r, v.g, v.b);
                cache[0] = v.r;
                cache[1] = v.g;
                cache[2] = v.b;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform3fv(this.addr, v);
              copyArray(cache, v);
            }
          }
          function setValueV4f(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
                gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
                cache[0] = v.x;
                cache[1] = v.y;
                cache[2] = v.z;
                cache[3] = v.w;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform4fv(this.addr, v);
              copyArray(cache, v);
            }
          } // Single matrix (from flat array or THREE.MatrixN)
          function setValueM2(gl, v) {
            var cache = this.cache;
            var elements = v.elements;
            if (elements === undefined) {
              if (arraysEqual(cache, v)) return;
              gl.uniformMatrix2fv(this.addr, false, v);
              copyArray(cache, v);
            } else {
              if (arraysEqual(cache, elements)) return;
              mat2array.set(elements);
              gl.uniformMatrix2fv(this.addr, false, mat2array);
              copyArray(cache, elements);
            }
          }
          function setValueM3(gl, v) {
            var cache = this.cache;
            var elements = v.elements;
            if (elements === undefined) {
              if (arraysEqual(cache, v)) return;
              gl.uniformMatrix3fv(this.addr, false, v);
              copyArray(cache, v);
            } else {
              if (arraysEqual(cache, elements)) return;
              mat3array.set(elements);
              gl.uniformMatrix3fv(this.addr, false, mat3array);
              copyArray(cache, elements);
            }
          }
          function setValueM4(gl, v) {
            var cache = this.cache;
            var elements = v.elements;
            if (elements === undefined) {
              if (arraysEqual(cache, v)) return;
              gl.uniformMatrix4fv(this.addr, false, v);
              copyArray(cache, v);
            } else {
              if (arraysEqual(cache, elements)) return;
              mat4array.set(elements);
              gl.uniformMatrix4fv(this.addr, false, mat4array);
              copyArray(cache, elements);
            }
          } // Single integer / boolean
          function setValueV1i(gl, v) {
            var cache = this.cache;
            if (cache[0] === v) return;
            gl.uniform1i(this.addr, v);
            cache[0] = v;
          } // Single integer / boolean vector (from flat array or THREE.VectorN)
          function setValueV2i(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y) {
                gl.uniform2i(this.addr, v.x, v.y);
                cache[0] = v.x;
                cache[1] = v.y;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform2iv(this.addr, v);
              copyArray(cache, v);
            }
          }
          function setValueV3i(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
                gl.uniform3i(this.addr, v.x, v.y, v.z);
                cache[0] = v.x;
                cache[1] = v.y;
                cache[2] = v.z;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform3iv(this.addr, v);
              copyArray(cache, v);
            }
          }
          function setValueV4i(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
                gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
                cache[0] = v.x;
                cache[1] = v.y;
                cache[2] = v.z;
                cache[3] = v.w;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform4iv(this.addr, v);
              copyArray(cache, v);
            }
          } // Single unsigned integer
          function setValueV1ui(gl, v) {
            var cache = this.cache;
            if (cache[0] === v) return;
            gl.uniform1ui(this.addr, v);
            cache[0] = v;
          } // Single unsigned integer vector (from flat array or THREE.VectorN)
          function setValueV2ui(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y) {
                gl.uniform2ui(this.addr, v.x, v.y);
                cache[0] = v.x;
                cache[1] = v.y;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform2uiv(this.addr, v);
              copyArray(cache, v);
            }
          }
          function setValueV3ui(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
                gl.uniform3ui(this.addr, v.x, v.y, v.z);
                cache[0] = v.x;
                cache[1] = v.y;
                cache[2] = v.z;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform3uiv(this.addr, v);
              copyArray(cache, v);
            }
          }
          function setValueV4ui(gl, v) {
            var cache = this.cache;
            if (v.x !== undefined) {
              if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
                gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
                cache[0] = v.x;
                cache[1] = v.y;
                cache[2] = v.z;
                cache[3] = v.w;
              }
            } else {
              if (arraysEqual(cache, v)) return;
              gl.uniform4uiv(this.addr, v);
              copyArray(cache, v);
            }
          } // Single texture (2D / Cube)
          function setValueT1(gl, v, textures) {
            var cache = this.cache;
            var unit = textures.allocateTextureUnit();
            if (cache[0] !== unit) {
              gl.uniform1i(this.addr, unit);
              cache[0] = unit;
            }
            textures.setTexture2D(v || emptyTexture, unit);
          }
          function setValueT3D1(gl, v, textures) {
            var cache = this.cache;
            var unit = textures.allocateTextureUnit();
            if (cache[0] !== unit) {
              gl.uniform1i(this.addr, unit);
              cache[0] = unit;
            }
            textures.setTexture3D(v || empty3dTexture, unit);
          }
          function setValueT6(gl, v, textures) {
            var cache = this.cache;
            var unit = textures.allocateTextureUnit();
            if (cache[0] !== unit) {
              gl.uniform1i(this.addr, unit);
              cache[0] = unit;
            }
            textures.setTextureCube(v || emptyCubeTexture, unit);
          }
          function setValueT2DArray1(gl, v, textures) {
            var cache = this.cache;
            var unit = textures.allocateTextureUnit();
            if (cache[0] !== unit) {
              gl.uniform1i(this.addr, unit);
              cache[0] = unit;
            }
            textures.setTexture2DArray(v || emptyArrayTexture, unit);
          } // Helper to pick the right setter for the singular case
          function getSingularSetter(type) {
            switch (type) {
              case 0x1406:
                return setValueV1f;
              // FLOAT
              case 0x8b50:
                return setValueV2f;
              // _VEC2
              case 0x8b51:
                return setValueV3f;
              // _VEC3
              case 0x8b52:
                return setValueV4f;
              // _VEC4
              case 0x8b5a:
                return setValueM2;
              // _MAT2
              case 0x8b5b:
                return setValueM3;
              // _MAT3
              case 0x8b5c:
                return setValueM4;
              // _MAT4
              case 0x1404:
              case 0x8b56:
                return setValueV1i;
              // INT, BOOL
              case 0x8b53:
              case 0x8b57:
                return setValueV2i;
              // _VEC2
              case 0x8b54:
              case 0x8b58:
                return setValueV3i;
              // _VEC3
              case 0x8b55:
              case 0x8b59:
                return setValueV4i;
              // _VEC4
              case 0x1405:
                return setValueV1ui;
              // UINT
              case 0x8dc6:
                return setValueV2ui;
              // _VEC2
              case 0x8dc7:
                return setValueV3ui;
              // _VEC3
              case 0x8dc8:
                return setValueV4ui;
              // _VEC4
              case 0x8b5e: // SAMPLER_2D
              case 0x8d66: // SAMPLER_EXTERNAL_OES
              case 0x8dca: // INT_SAMPLER_2D
              case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
              case 0x8b62:
                // SAMPLER_2D_SHADOW
                return setValueT1;
              case 0x8b5f: // SAMPLER_3D
              case 0x8dcb: // INT_SAMPLER_3D
              case 0x8dd3:
                // UNSIGNED_INT_SAMPLER_3D
                return setValueT3D1;
              case 0x8b60: // SAMPLER_CUBE
              case 0x8dcc: // INT_SAMPLER_CUBE
              case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
              case 0x8dc5:
                // SAMPLER_CUBE_SHADOW
                return setValueT6;
              case 0x8dc1: // SAMPLER_2D_ARRAY
              case 0x8dcf: // INT_SAMPLER_2D_ARRAY
              case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
              case 0x8dc4:
                // SAMPLER_2D_ARRAY_SHADOW
                return setValueT2DArray1;
            }
          } // Array of scalars
          function setValueV1fArray(gl, v) {
            gl.uniform1fv(this.addr, v);
          } // Array of vectors (from flat array or array of THREE.VectorN)
          function setValueV2fArray(gl, v) {
            var data = flatten(v, this.size, 2);
            gl.uniform2fv(this.addr, data);
          }
          function setValueV3fArray(gl, v) {
            var data = flatten(v, this.size, 3);
            gl.uniform3fv(this.addr, data);
          }
          function setValueV4fArray(gl, v) {
            var data = flatten(v, this.size, 4);
            gl.uniform4fv(this.addr, data);
          } // Array of matrices (from flat array or array of THREE.MatrixN)
          function setValueM2Array(gl, v) {
            var data = flatten(v, this.size, 4);
            gl.uniformMatrix2fv(this.addr, false, data);
          }
          function setValueM3Array(gl, v) {
            var data = flatten(v, this.size, 9);
            gl.uniformMatrix3fv(this.addr, false, data);
          }
          function setValueM4Array(gl, v) {
            var data = flatten(v, this.size, 16);
            gl.uniformMatrix4fv(this.addr, false, data);
          } // Array of integer / boolean
          function setValueV1iArray(gl, v) {
            gl.uniform1iv(this.addr, v);
          } // Array of integer / boolean vectors (from flat array)
          function setValueV2iArray(gl, v) {
            gl.uniform2iv(this.addr, v);
          }
          function setValueV3iArray(gl, v) {
            gl.uniform3iv(this.addr, v);
          }
          function setValueV4iArray(gl, v) {
            gl.uniform4iv(this.addr, v);
          } // Array of unsigned integer
          function setValueV1uiArray(gl, v) {
            gl.uniform1uiv(this.addr, v);
          } // Array of unsigned integer vectors (from flat array)
          function setValueV2uiArray(gl, v) {
            gl.uniform2uiv(this.addr, v);
          }
          function setValueV3uiArray(gl, v) {
            gl.uniform3uiv(this.addr, v);
          }
          function setValueV4uiArray(gl, v) {
            gl.uniform4uiv(this.addr, v);
          } // Array of textures (2D / 3D / Cube / 2DArray)
          function setValueT1Array(gl, v, textures) {
            var cache = this.cache;
            var n = v.length;
            var units = allocTexUnits(textures, n);
            if (!arraysEqual(cache, units)) {
              gl.uniform1iv(this.addr, units);
              copyArray(cache, units);
            }
            for (var i = 0; i !== n; ++i) {
              textures.setTexture2D(v[i] || emptyTexture, units[i]);
            }
          }
          function setValueT3DArray(gl, v, textures) {
            var cache = this.cache;
            var n = v.length;
            var units = allocTexUnits(textures, n);
            if (!arraysEqual(cache, units)) {
              gl.uniform1iv(this.addr, units);
              copyArray(cache, units);
            }
            for (var i = 0; i !== n; ++i) {
              textures.setTexture3D(v[i] || empty3dTexture, units[i]);
            }
          }
          function setValueT6Array(gl, v, textures) {
            var cache = this.cache;
            var n = v.length;
            var units = allocTexUnits(textures, n);
            if (!arraysEqual(cache, units)) {
              gl.uniform1iv(this.addr, units);
              copyArray(cache, units);
            }
            for (var i = 0; i !== n; ++i) {
              textures.setTextureCube(v[i] || emptyCubeTexture, units[i]);
            }
          }
          function setValueT2DArrayArray(gl, v, textures) {
            var cache = this.cache;
            var n = v.length;
            var units = allocTexUnits(textures, n);
            if (!arraysEqual(cache, units)) {
              gl.uniform1iv(this.addr, units);
              copyArray(cache, units);
            }
            for (var i = 0; i !== n; ++i) {
              textures.setTexture2DArray(v[i] || emptyArrayTexture, units[i]);
            }
          } // Helper to pick the right setter for a pure (bottom-level) array
          function getPureArraySetter(type) {
            switch (type) {
              case 0x1406:
                return setValueV1fArray;
              // FLOAT
              case 0x8b50:
                return setValueV2fArray;
              // _VEC2
              case 0x8b51:
                return setValueV3fArray;
              // _VEC3
              case 0x8b52:
                return setValueV4fArray;
              // _VEC4
              case 0x8b5a:
                return setValueM2Array;
              // _MAT2
              case 0x8b5b:
                return setValueM3Array;
              // _MAT3
              case 0x8b5c:
                return setValueM4Array;
              // _MAT4
              case 0x1404:
              case 0x8b56:
                return setValueV1iArray;
              // INT, BOOL
              case 0x8b53:
              case 0x8b57:
                return setValueV2iArray;
              // _VEC2
              case 0x8b54:
              case 0x8b58:
                return setValueV3iArray;
              // _VEC3
              case 0x8b55:
              case 0x8b59:
                return setValueV4iArray;
              // _VEC4
              case 0x1405:
                return setValueV1uiArray;
              // UINT
              case 0x8dc6:
                return setValueV2uiArray;
              // _VEC2
              case 0x8dc7:
                return setValueV3uiArray;
              // _VEC3
              case 0x8dc8:
                return setValueV4uiArray;
              // _VEC4
              case 0x8b5e: // SAMPLER_2D
              case 0x8d66: // SAMPLER_EXTERNAL_OES
              case 0x8dca: // INT_SAMPLER_2D
              case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
              case 0x8b62:
                // SAMPLER_2D_SHADOW
                return setValueT1Array;
              case 0x8b5f: // SAMPLER_3D
              case 0x8dcb: // INT_SAMPLER_3D
              case 0x8dd3:
                // UNSIGNED_INT_SAMPLER_3D
                return setValueT3DArray;
              case 0x8b60: // SAMPLER_CUBE
              case 0x8dcc: // INT_SAMPLER_CUBE
              case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
              case 0x8dc5:
                // SAMPLER_CUBE_SHADOW
                return setValueT6Array;
              case 0x8dc1: // SAMPLER_2D_ARRAY
              case 0x8dcf: // INT_SAMPLER_2D_ARRAY
              case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
              case 0x8dc4:
                // SAMPLER_2D_ARRAY_SHADOW
                return setValueT2DArrayArray;
            }
          } // --- Uniform Classes ---
          var SingleUniform = /*#__PURE__*/_createClass2(function SingleUniform(id, activeInfo, addr) {
            _classCallCheck2(this, SingleUniform);
            this.id = id;
            this.addr = addr;
            this.cache = [];
            this.setValue = getSingularSetter(activeInfo.type); // this.path = activeInfo.name; // DEBUG
          });
          var PureArrayUniform = /*#__PURE__*/_createClass2(function PureArrayUniform(id, activeInfo, addr) {
            _classCallCheck2(this, PureArrayUniform);
            this.id = id;
            this.addr = addr;
            this.cache = [];
            this.size = activeInfo.size;
            this.setValue = getPureArraySetter(activeInfo.type); // this.path = activeInfo.name; // DEBUG
          });
          var StructuredUniform = /*#__PURE__*/function () {
            function StructuredUniform(id) {
              _classCallCheck2(this, StructuredUniform);
              this.id = id;
              this.seq = [];
              this.map = {};
            }
            _createClass2(StructuredUniform, [{
              key: "setValue",
              value: function setValue(gl, value, textures) {
                var seq = this.seq;
                for (var i = 0, n = seq.length; i !== n; ++i) {
                  var u = seq[i];
                  u.setValue(gl, value[u.id], textures);
                }
              }
            }]);
            return StructuredUniform;
          }(); // --- Top-level ---
          // Parser - builds up the property tree from the path strings
          var RePathPart = /(\w+)(\])?(\[|\.)?/g; // extracts
          // 	- the identifier (member name or array index)
          //  - followed by an optional right bracket (found when array index)
          //  - followed by an optional left bracket or dot (type of subscript)
          //
          // Note: These portions can be read in a non-overlapping fashion and
          // allow straightforward parsing of the hierarchy that WebGL encodes
          // in the uniform names.
          function addUniform(container, uniformObject) {
            container.seq.push(uniformObject);
            container.map[uniformObject.id] = uniformObject;
          }
          function parseUniform(activeInfo, addr, container) {
            var path = activeInfo.name,
              pathLength = path.length; // reset RegExp object, because of the early exit of a previous run
            RePathPart.lastIndex = 0;
            while (true) {
              var match = RePathPart.exec(path),
                matchEnd = RePathPart.lastIndex;
              var _id2 = match[1];
              var idIsIndex = match[2] === ']',
                subscript = match[3];
              if (idIsIndex) _id2 = _id2 | 0; // convert to integer
              if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
                // bare name or "pure" bottom-level array "[0]" suffix
                addUniform(container, subscript === undefined ? new SingleUniform(_id2, activeInfo, addr) : new PureArrayUniform(_id2, activeInfo, addr));
                break;
              } else {
                // step into inner node / create it in case it doesn't exist
                var map = container.map;
                var next = map[_id2];
                if (next === undefined) {
                  next = new StructuredUniform(_id2);
                  addUniform(container, next);
                }
                container = next;
              }
            }
          } // Root Container
          var WebGLUniforms = /*#__PURE__*/function () {
            function WebGLUniforms(gl, program) {
              _classCallCheck2(this, WebGLUniforms);
              this.seq = [];
              this.map = {};
              var n = gl.getProgramParameter(program, 35718);
              for (var i = 0; i < n; ++i) {
                var info = gl.getActiveUniform(program, i),
                  addr = gl.getUniformLocation(program, info.name);
                parseUniform(info, addr, this);
              }
            }
            _createClass2(WebGLUniforms, [{
              key: "setValue",
              value: function setValue(gl, name, value, textures) {
                var u = this.map[name];
                if (u !== undefined) u.setValue(gl, value, textures);
              }
            }, {
              key: "setOptional",
              value: function setOptional(gl, object, name) {
                var v = object[name];
                if (v !== undefined) this.setValue(gl, name, v);
              }
            }], [{
              key: "upload",
              value: function upload(gl, seq, values, textures) {
                for (var i = 0, n = seq.length; i !== n; ++i) {
                  var u = seq[i],
                    v = values[u.id];
                  if (v.needsUpdate !== false) {
                    // note: always updating when .needsUpdate is undefined
                    u.setValue(gl, v.value, textures);
                  }
                }
              }
            }, {
              key: "seqWithValue",
              value: function seqWithValue(seq, values) {
                var r = [];
                for (var i = 0, n = seq.length; i !== n; ++i) {
                  var u = seq[i];
                  if (u.id in values) r.push(u);
                }
                return r;
              }
            }]);
            return WebGLUniforms;
          }();
          function WebGLShader(gl, type, string) {
            var shader = gl.createShader(type);
            gl.shaderSource(shader, string);
            gl.compileShader(shader);
            return shader;
          }
          var programIdCount = 0;
          function handleSource(string, errorLine) {
            var lines = string.split('\n');
            var lines2 = [];
            var from = Math.max(errorLine - 6, 0);
            var to = Math.min(errorLine + 6, lines.length);
            for (var i = from; i < to; i++) {
              var line = i + 1;
              lines2.push("".concat(line === errorLine ? '>' : ' ', " ").concat(line, ": ").concat(lines[i]));
            }
            return lines2.join('\n');
          }
          function getEncodingComponents(encoding) {
            switch (encoding) {
              case _LinearEncoding:
                return ['Linear', '( value )'];
              case _sRGBEncoding:
                return ['sRGB', '( value )'];
              default:
                console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
                return ['Linear', '( value )'];
            }
          }
          function getShaderErrors(gl, shader, type) {
            var status = gl.getShaderParameter(shader, 35713);
            var errors = gl.getShaderInfoLog(shader).trim();
            if (status && errors === '') return '';
            var errorMatches = /ERROR: 0:(\d+)/.exec(errors);
            if (errorMatches) {
              // --enable-privileged-webgl-extension
              // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
              var errorLine = parseInt(errorMatches[1]);
              return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource(gl.getShaderSource(shader), errorLine);
            } else {
              return errors;
            }
          }
          function getTexelEncodingFunction(functionName, encoding) {
            var components = getEncodingComponents(encoding);
            return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
          }
          function getToneMappingFunction(functionName, toneMapping) {
            var toneMappingName;
            switch (toneMapping) {
              case _LinearToneMapping:
                toneMappingName = 'Linear';
                break;
              case _ReinhardToneMapping:
                toneMappingName = 'Reinhard';
                break;
              case _CineonToneMapping:
                toneMappingName = 'OptimizedCineon';
                break;
              case _ACESFilmicToneMapping:
                toneMappingName = 'ACESFilmic';
                break;
              case _CustomToneMapping:
                toneMappingName = 'Custom';
                break;
              default:
                console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
                toneMappingName = 'Linear';
            }
            return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
          }
          function generateExtensions(parameters) {
            var chunks = [parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '', (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '', parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '', (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''];
            return chunks.filter(filterEmptyLine).join('\n');
          }
          function generateDefines(defines) {
            var chunks = [];
            for (var name in defines) {
              var _value5 = defines[name];
              if (_value5 === false) continue;
              chunks.push('#define ' + name + ' ' + _value5);
            }
            return chunks.join('\n');
          }
          function fetchAttributeLocations(gl, program) {
            var attributes = {};
            var n = gl.getProgramParameter(program, 35721);
            for (var i = 0; i < n; i++) {
              var info = gl.getActiveAttrib(program, i);
              var name = info.name;
              var locationSize = 1;
              if (info.type === 35674) locationSize = 2;
              if (info.type === 35675) locationSize = 3;
              if (info.type === 35676) locationSize = 4; // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
              attributes[name] = {
                type: info.type,
                location: gl.getAttribLocation(program, name),
                locationSize: locationSize
              };
            }
            return attributes;
          }
          function filterEmptyLine(string) {
            return string !== '';
          }
          function replaceLightNums(string, parameters) {
            var numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
            return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
          }
          function replaceClippingPlaneNums(string, parameters) {
            return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
          } // Resolve Includes
          var includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
          function resolveIncludes(string) {
            return string.replace(includePattern, includeReplacer);
          }
          function includeReplacer(match, include) {
            var string = _ShaderChunk[include];
            if (string === undefined) {
              throw new Error('Can not resolve #include <' + include + '>');
            }
            return resolveIncludes(string);
          } // Unroll Loops
          var unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
          function unrollLoops(string) {
            return string.replace(unrollLoopPattern, loopReplacer);
          }
          function loopReplacer(match, start, end, snippet) {
            var string = '';
            for (var i = parseInt(start); i < parseInt(end); i++) {
              string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
            }
            return string;
          } //
          function generatePrecision(parameters) {
            var precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
            if (parameters.precision === 'highp') {
              precisionstring += '\n#define HIGH_PRECISION';
            } else if (parameters.precision === 'mediump') {
              precisionstring += '\n#define MEDIUM_PRECISION';
            } else if (parameters.precision === 'lowp') {
              precisionstring += '\n#define LOW_PRECISION';
            }
            return precisionstring;
          }
          function generateShadowMapTypeDefine(parameters) {
            var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
            if (parameters.shadowMapType === _PCFShadowMap) {
              shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
            } else if (parameters.shadowMapType === _PCFSoftShadowMap) {
              shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
            } else if (parameters.shadowMapType === _VSMShadowMap) {
              shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
            }
            return shadowMapTypeDefine;
          }
          function generateEnvMapTypeDefine(parameters) {
            var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            if (parameters.envMap) {
              switch (parameters.envMapMode) {
                case _CubeReflectionMapping:
                case _CubeRefractionMapping:
                  envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
                  break;
                case _CubeUVReflectionMapping:
                  envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
                  break;
              }
            }
            return envMapTypeDefine;
          }
          function generateEnvMapModeDefine(parameters) {
            var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
            if (parameters.envMap) {
              switch (parameters.envMapMode) {
                case _CubeRefractionMapping:
                  envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
                  break;
              }
            }
            return envMapModeDefine;
          }
          function generateEnvMapBlendingDefine(parameters) {
            var envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
            if (parameters.envMap) {
              switch (parameters.combine) {
                case _MultiplyOperation:
                  envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
                  break;
                case _MixOperation:
                  envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
                  break;
                case _AddOperation:
                  envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
                  break;
              }
            }
            return envMapBlendingDefine;
          }
          function generateCubeUVSize(parameters) {
            var imageHeight = parameters.envMapCubeUVHeight;
            if (imageHeight === null) return null;
            var maxMip = Math.log2(imageHeight) - 2;
            var texelHeight = 1.0 / imageHeight;
            var texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
            return {
              texelWidth: texelWidth,
              texelHeight: texelHeight,
              maxMip: maxMip
            };
          }
          function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
            // TODO Send this event to Three.js DevTools
            // console.log( 'WebGLProgram', cacheKey );
            var gl = renderer.getContext();
            var defines = parameters.defines;
            var vertexShader = parameters.vertexShader;
            var fragmentShader = parameters.fragmentShader;
            var shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
            var envMapTypeDefine = generateEnvMapTypeDefine(parameters);
            var envMapModeDefine = generateEnvMapModeDefine(parameters);
            var envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
            var envMapCubeUVSize = generateCubeUVSize(parameters);
            var customExtensions = parameters.isWebGL2 ? '' : generateExtensions(parameters);
            var customDefines = generateDefines(defines);
            var program = gl.createProgram();
            var prefixVertex, prefixFragment;
            var versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
            if (parameters.isRawShaderMaterial) {
              prefixVertex = [customDefines].filter(filterEmptyLine).join('\n');
              if (prefixVertex.length > 0) {
                prefixVertex += '\n';
              }
              prefixFragment = [customExtensions, customDefines].filter(filterEmptyLine).join('\n');
              if (prefixFragment.length > 0) {
                prefixFragment += '\n';
              }
            } else {
              prefixVertex = [generatePrecision(parameters), '#define SHADER_NAME ' + parameters.shaderName, customDefines, parameters.instancing ? '#define USE_INSTANCING' : '', parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '', parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '', parameters.useFog && parameters.fog ? '#define USE_FOG' : '', parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '', parameters.map ? '#define USE_MAP' : '', parameters.envMap ? '#define USE_ENVMAP' : '', parameters.envMap ? '#define ' + envMapModeDefine : '', parameters.lightMap ? '#define USE_LIGHTMAP' : '', parameters.aoMap ? '#define USE_AOMAP' : '', parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '', parameters.bumpMap ? '#define USE_BUMPMAP' : '', parameters.normalMap ? '#define USE_NORMALMAP' : '', parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '', parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '', parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '', parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '', parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '', parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '', parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '', parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '', parameters.specularMap ? '#define USE_SPECULARMAP' : '', parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '', parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '', parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '', parameters.metalnessMap ? '#define USE_METALNESSMAP' : '', parameters.alphaMap ? '#define USE_ALPHAMAP' : '', parameters.transmission ? '#define USE_TRANSMISSION' : '', parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '', parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '', parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '', parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '', parameters.vertexTangents ? '#define USE_TANGENT' : '', parameters.vertexColors ? '#define USE_COLOR' : '', parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '', parameters.vertexUvs ? '#define USE_UV' : '', parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '', parameters.flatShading ? '#define FLAT_SHADED' : '', parameters.skinning ? '#define USE_SKINNING' : '', parameters.morphTargets ? '#define USE_MORPHTARGETS' : '', parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '', parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '', parameters.doubleSided ? '#define DOUBLE_SIDED' : '', parameters.flipSided ? '#define FLIP_SIDED' : '', parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '', parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '', parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '', parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '', parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '', 'uniform mat4 modelMatrix;', 'uniform mat4 modelViewMatrix;', 'uniform mat4 projectionMatrix;', 'uniform mat4 viewMatrix;', 'uniform mat3 normalMatrix;', 'uniform vec3 cameraPosition;', 'uniform bool isOrthographic;', '#ifdef USE_INSTANCING', '	attribute mat4 instanceMatrix;', '#endif', '#ifdef USE_INSTANCING_COLOR', '	attribute vec3 instanceColor;', '#endif', 'attribute vec3 position;', 'attribute vec3 normal;', 'attribute vec2 uv;', '#ifdef USE_TANGENT', '	attribute vec4 tangent;', '#endif', '#if defined( USE_COLOR_ALPHA )', '	attribute vec4 color;', '#elif defined( USE_COLOR )', '	attribute vec3 color;', '#endif', '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )', '	attribute vec3 morphTarget0;', '	attribute vec3 morphTarget1;', '	attribute vec3 morphTarget2;', '	attribute vec3 morphTarget3;', '	#ifdef USE_MORPHNORMALS', '		attribute vec3 morphNormal0;', '		attribute vec3 morphNormal1;', '		attribute vec3 morphNormal2;', '		attribute vec3 morphNormal3;', '	#else', '		attribute vec3 morphTarget4;', '		attribute vec3 morphTarget5;', '		attribute vec3 morphTarget6;', '		attribute vec3 morphTarget7;', '	#endif', '#endif', '#ifdef USE_SKINNING', '	attribute vec4 skinIndex;', '	attribute vec4 skinWeight;', '#endif', '\n'].filter(filterEmptyLine).join('\n');
              prefixFragment = [customExtensions, generatePrecision(parameters), '#define SHADER_NAME ' + parameters.shaderName, customDefines, parameters.useFog && parameters.fog ? '#define USE_FOG' : '', parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '', parameters.map ? '#define USE_MAP' : '', parameters.matcap ? '#define USE_MATCAP' : '', parameters.envMap ? '#define USE_ENVMAP' : '', parameters.envMap ? '#define ' + envMapTypeDefine : '', parameters.envMap ? '#define ' + envMapModeDefine : '', parameters.envMap ? '#define ' + envMapBlendingDefine : '', envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '', envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '', envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '', parameters.lightMap ? '#define USE_LIGHTMAP' : '', parameters.aoMap ? '#define USE_AOMAP' : '', parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '', parameters.bumpMap ? '#define USE_BUMPMAP' : '', parameters.normalMap ? '#define USE_NORMALMAP' : '', parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '', parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '', parameters.clearcoat ? '#define USE_CLEARCOAT' : '', parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '', parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '', parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '', parameters.iridescence ? '#define USE_IRIDESCENCE' : '', parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '', parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '', parameters.specularMap ? '#define USE_SPECULARMAP' : '', parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '', parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '', parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '', parameters.metalnessMap ? '#define USE_METALNESSMAP' : '', parameters.alphaMap ? '#define USE_ALPHAMAP' : '', parameters.alphaTest ? '#define USE_ALPHATEST' : '', parameters.sheen ? '#define USE_SHEEN' : '', parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '', parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '', parameters.transmission ? '#define USE_TRANSMISSION' : '', parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '', parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '', parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '', parameters.vertexTangents ? '#define USE_TANGENT' : '', parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '', parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '', parameters.vertexUvs ? '#define USE_UV' : '', parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '', parameters.gradientMap ? '#define USE_GRADIENTMAP' : '', parameters.flatShading ? '#define FLAT_SHADED' : '', parameters.doubleSided ? '#define DOUBLE_SIDED' : '', parameters.flipSided ? '#define FLIP_SIDED' : '', parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '', parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '', parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '', parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '', parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '', parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '', 'uniform mat4 viewMatrix;', 'uniform vec3 cameraPosition;', 'uniform bool isOrthographic;', parameters.toneMapping !== _NoToneMapping ? '#define TONE_MAPPING' : '', parameters.toneMapping !== _NoToneMapping ? _ShaderChunk['tonemapping_pars_fragment'] : '',
              // this code is required here because it is used by the toneMapping() function defined below
              parameters.toneMapping !== _NoToneMapping ? getToneMappingFunction('toneMapping', parameters.toneMapping) : '', parameters.dithering ? '#define DITHERING' : '', parameters.opaque ? '#define OPAQUE' : '', _ShaderChunk['encodings_pars_fragment'],
              // this code is required here because it is used by the various encoding/decoding function defined below
              getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding), parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '', '\n'].filter(filterEmptyLine).join('\n');
            }
            vertexShader = resolveIncludes(vertexShader);
            vertexShader = replaceLightNums(vertexShader, parameters);
            vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
            fragmentShader = resolveIncludes(fragmentShader);
            fragmentShader = replaceLightNums(fragmentShader, parameters);
            fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
            vertexShader = unrollLoops(vertexShader);
            fragmentShader = unrollLoops(fragmentShader);
            if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
              // GLSL 3.0 conversion for built-in materials and ShaderMaterial
              versionString = '#version 300 es\n';
              prefixVertex = ['precision mediump sampler2DArray;', '#define attribute in', '#define varying out', '#define texture2D texture'].join('\n') + '\n' + prefixVertex;
              prefixFragment = ['#define varying in', parameters.glslVersion === _GLSL2 ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;', parameters.glslVersion === _GLSL2 ? '' : '#define gl_FragColor pc_fragColor', '#define gl_FragDepthEXT gl_FragDepth', '#define texture2D texture', '#define textureCube texture', '#define texture2DProj textureProj', '#define texture2DLodEXT textureLod', '#define texture2DProjLodEXT textureProjLod', '#define textureCubeLodEXT textureLod', '#define texture2DGradEXT textureGrad', '#define texture2DProjGradEXT textureProjGrad', '#define textureCubeGradEXT textureGrad'].join('\n') + '\n' + prefixFragment;
            }
            var vertexGlsl = versionString + prefixVertex + vertexShader;
            var fragmentGlsl = versionString + prefixFragment + fragmentShader; // console.log( '*VERTEX*', vertexGlsl );
            // console.log( '*FRAGMENT*', fragmentGlsl );
            var glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
            var glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
            gl.attachShader(program, glVertexShader);
            gl.attachShader(program, glFragmentShader); // Force a particular attribute to index 0.
            if (parameters.index0AttributeName !== undefined) {
              gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
            } else if (parameters.morphTargets === true) {
              // programs with morphTargets displace position out of attribute 0
              gl.bindAttribLocation(program, 0, 'position');
            }
            gl.linkProgram(program); // check for link errors
            if (renderer.debug.checkShaderErrors) {
              var programLog = gl.getProgramInfoLog(program).trim();
              var vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
              var fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
              var runnable = true;
              var haveDiagnostics = true;
              if (gl.getProgramParameter(program, 35714) === false) {
                runnable = false;
                var vertexErrors = getShaderErrors(gl, glVertexShader, 'vertex');
                var fragmentErrors = getShaderErrors(gl, glFragmentShader, 'fragment');
                console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, 35715) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
              } else if (programLog !== '') {
                console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
              } else if (vertexLog === '' || fragmentLog === '') {
                haveDiagnostics = false;
              }
              if (haveDiagnostics) {
                this.diagnostics = {
                  runnable: runnable,
                  programLog: programLog,
                  vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                  },
                  fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                  }
                };
              }
            } // Clean up
            // Crashes in iOS9 and iOS10. #18402
            // gl.detachShader( program, glVertexShader );
            // gl.detachShader( program, glFragmentShader );
            gl.deleteShader(glVertexShader);
            gl.deleteShader(glFragmentShader); // set up caching for uniform locations
            var cachedUniforms;
            this.getUniforms = function () {
              if (cachedUniforms === undefined) {
                cachedUniforms = new WebGLUniforms(gl, program);
              }
              return cachedUniforms;
            }; // set up caching for attribute locations
            var cachedAttributes;
            this.getAttributes = function () {
              if (cachedAttributes === undefined) {
                cachedAttributes = fetchAttributeLocations(gl, program);
              }
              return cachedAttributes;
            }; // free resource
            this.destroy = function () {
              bindingStates.releaseStatesOfProgram(this);
              gl.deleteProgram(program);
              this.program = undefined;
            }; //
            this.name = parameters.shaderName;
            this.id = programIdCount++;
            this.cacheKey = cacheKey;
            this.usedTimes = 1;
            this.program = program;
            this.vertexShader = glVertexShader;
            this.fragmentShader = glFragmentShader;
            return this;
          }
          var _id = 0;
          var WebGLShaderCache = /*#__PURE__*/function () {
            function WebGLShaderCache() {
              _classCallCheck2(this, WebGLShaderCache);
              this.shaderCache = new Map();
              this.materialCache = new Map();
            }
            _createClass2(WebGLShaderCache, [{
              key: "update",
              value: function update(material) {
                var vertexShader = material.vertexShader;
                var fragmentShader = material.fragmentShader;
                var vertexShaderStage = this._getShaderStage(vertexShader);
                var fragmentShaderStage = this._getShaderStage(fragmentShader);
                var materialShaders = this._getShaderCacheForMaterial(material);
                if (materialShaders.has(vertexShaderStage) === false) {
                  materialShaders.add(vertexShaderStage);
                  vertexShaderStage.usedTimes++;
                }
                if (materialShaders.has(fragmentShaderStage) === false) {
                  materialShaders.add(fragmentShaderStage);
                  fragmentShaderStage.usedTimes++;
                }
                return this;
              }
            }, {
              key: "remove",
              value: function remove(material) {
                var materialShaders = this.materialCache.get(material);
                var _iterator5 = _createForOfIteratorHelper2(materialShaders),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var shaderStage = _step5.value;
                    shaderStage.usedTimes--;
                    if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                this.materialCache.delete(material);
                return this;
              }
            }, {
              key: "getVertexShaderID",
              value: function getVertexShaderID(material) {
                return this._getShaderStage(material.vertexShader).id;
              }
            }, {
              key: "getFragmentShaderID",
              value: function getFragmentShaderID(material) {
                return this._getShaderStage(material.fragmentShader).id;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.shaderCache.clear();
                this.materialCache.clear();
              }
            }, {
              key: "_getShaderCacheForMaterial",
              value: function _getShaderCacheForMaterial(material) {
                var cache = this.materialCache;
                var set = cache.get(material);
                if (set === undefined) {
                  set = new Set();
                  cache.set(material, set);
                }
                return set;
              }
            }, {
              key: "_getShaderStage",
              value: function _getShaderStage(code) {
                var cache = this.shaderCache;
                var stage = cache.get(code);
                if (stage === undefined) {
                  stage = new WebGLShaderStage(code);
                  cache.set(code, stage);
                }
                return stage;
              }
            }]);
            return WebGLShaderCache;
          }();
          var WebGLShaderStage = /*#__PURE__*/_createClass2(function WebGLShaderStage(code) {
            _classCallCheck2(this, WebGLShaderStage);
            this.id = _id++;
            this.code = code;
            this.usedTimes = 0;
          });
          function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
            var _programLayers = new _Layers();
            var _customShaders = new WebGLShaderCache();
            var programs = [];
            var isWebGL2 = capabilities.isWebGL2;
            var logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
            var vertexTextures = capabilities.vertexTextures;
            var precision = capabilities.precision;
            var shaderIDs = {
              MeshDepthMaterial: 'depth',
              MeshDistanceMaterial: 'distanceRGBA',
              MeshNormalMaterial: 'normal',
              MeshBasicMaterial: 'basic',
              MeshLambertMaterial: 'lambert',
              MeshPhongMaterial: 'phong',
              MeshToonMaterial: 'toon',
              MeshStandardMaterial: 'physical',
              MeshPhysicalMaterial: 'physical',
              MeshMatcapMaterial: 'matcap',
              LineBasicMaterial: 'basic',
              LineDashedMaterial: 'dashed',
              PointsMaterial: 'points',
              ShadowMaterial: 'shadow',
              SpriteMaterial: 'sprite'
            };
            function getParameters(material, lights, shadows, scene, object) {
              var fog = scene.fog;
              var geometry = object.geometry;
              var environment = material.isMeshStandardMaterial ? scene.environment : null;
              var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
              var envMapCubeUVHeight = !!envMap && envMap.mapping === _CubeUVReflectionMapping ? envMap.image.height : null;
              var shaderID = shaderIDs[material.type]; // heuristics to create shader parameters according to lights in the scene
              // (not to blow over maxLights budget)
              if (material.precision !== null) {
                precision = capabilities.getMaxPrecision(material.precision);
                if (precision !== material.precision) {
                  console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
                }
              } //
              var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
              var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
              var morphTextureStride = 0;
              if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
              if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
              if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3; //
              var vertexShader, fragmentShader;
              var customVertexShaderID, customFragmentShaderID;
              if (shaderID) {
                var shader = _ShaderLib[shaderID];
                vertexShader = shader.vertexShader;
                fragmentShader = shader.fragmentShader;
              } else {
                vertexShader = material.vertexShader;
                fragmentShader = material.fragmentShader;
                _customShaders.update(material);
                customVertexShaderID = _customShaders.getVertexShaderID(material);
                customFragmentShaderID = _customShaders.getFragmentShaderID(material);
              }
              var currentRenderTarget = renderer.getRenderTarget();
              var useAlphaTest = material.alphaTest > 0;
              var useClearcoat = material.clearcoat > 0;
              var useIridescence = material.iridescence > 0;
              var parameters = {
                isWebGL2: isWebGL2,
                shaderID: shaderID,
                shaderName: material.type,
                vertexShader: vertexShader,
                fragmentShader: fragmentShader,
                defines: material.defines,
                customVertexShaderID: customVertexShaderID,
                customFragmentShaderID: customFragmentShaderID,
                isRawShaderMaterial: material.isRawShaderMaterial === true,
                glslVersion: material.glslVersion,
                precision: precision,
                instancing: object.isInstancedMesh === true,
                instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
                supportsVertexTextures: vertexTextures,
                outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : _LinearEncoding,
                map: !!material.map,
                matcap: !!material.matcap,
                envMap: !!envMap,
                envMapMode: envMap && envMap.mapping,
                envMapCubeUVHeight: envMapCubeUVHeight,
                lightMap: !!material.lightMap,
                aoMap: !!material.aoMap,
                emissiveMap: !!material.emissiveMap,
                bumpMap: !!material.bumpMap,
                normalMap: !!material.normalMap,
                objectSpaceNormalMap: material.normalMapType === _ObjectSpaceNormalMap,
                tangentSpaceNormalMap: material.normalMapType === _TangentSpaceNormalMap,
                decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === _sRGBEncoding,
                clearcoat: useClearcoat,
                clearcoatMap: useClearcoat && !!material.clearcoatMap,
                clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
                clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
                iridescence: useIridescence,
                iridescenceMap: useIridescence && !!material.iridescenceMap,
                iridescenceThicknessMap: useIridescence && !!material.iridescenceThicknessMap,
                displacementMap: !!material.displacementMap,
                roughnessMap: !!material.roughnessMap,
                metalnessMap: !!material.metalnessMap,
                specularMap: !!material.specularMap,
                specularIntensityMap: !!material.specularIntensityMap,
                specularColorMap: !!material.specularColorMap,
                opaque: material.transparent === false && material.blending === _NormalBlending,
                alphaMap: !!material.alphaMap,
                alphaTest: useAlphaTest,
                gradientMap: !!material.gradientMap,
                sheen: material.sheen > 0,
                sheenColorMap: !!material.sheenColorMap,
                sheenRoughnessMap: !!material.sheenRoughnessMap,
                transmission: material.transmission > 0,
                transmissionMap: !!material.transmissionMap,
                thicknessMap: !!material.thicknessMap,
                combine: material.combine,
                vertexTangents: !!material.normalMap && !!geometry.attributes.tangent,
                vertexColors: material.vertexColors,
                vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
                vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
                uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
                fog: !!fog,
                useFog: material.fog === true,
                fogExp2: fog && fog.isFogExp2,
                flatShading: !!material.flatShading,
                sizeAttenuation: material.sizeAttenuation,
                logarithmicDepthBuffer: logarithmicDepthBuffer,
                skinning: object.isSkinnedMesh === true,
                morphTargets: geometry.morphAttributes.position !== undefined,
                morphNormals: geometry.morphAttributes.normal !== undefined,
                morphColors: geometry.morphAttributes.color !== undefined,
                morphTargetsCount: morphTargetsCount,
                morphTextureStride: morphTextureStride,
                numDirLights: lights.directional.length,
                numPointLights: lights.point.length,
                numSpotLights: lights.spot.length,
                numSpotLightMaps: lights.spotLightMap.length,
                numRectAreaLights: lights.rectArea.length,
                numHemiLights: lights.hemi.length,
                numDirLightShadows: lights.directionalShadowMap.length,
                numPointLightShadows: lights.pointShadowMap.length,
                numSpotLightShadows: lights.spotShadowMap.length,
                numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
                numClippingPlanes: clipping.numPlanes,
                numClipIntersection: clipping.numIntersection,
                dithering: material.dithering,
                shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
                shadowMapType: renderer.shadowMap.type,
                toneMapping: material.toneMapped ? renderer.toneMapping : _NoToneMapping,
                physicallyCorrectLights: renderer.physicallyCorrectLights,
                premultipliedAlpha: material.premultipliedAlpha,
                doubleSided: material.side === _DoubleSide,
                flipSided: material.side === _BackSide,
                useDepthPacking: !!material.depthPacking,
                depthPacking: material.depthPacking || 0,
                index0AttributeName: material.index0AttributeName,
                extensionDerivatives: material.extensions && material.extensions.derivatives,
                extensionFragDepth: material.extensions && material.extensions.fragDepth,
                extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
                extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
                rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
                rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
                rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
                customProgramCacheKey: material.customProgramCacheKey()
              };
              return parameters;
            }
            function getProgramCacheKey(parameters) {
              var array = [];
              if (parameters.shaderID) {
                array.push(parameters.shaderID);
              } else {
                array.push(parameters.customVertexShaderID);
                array.push(parameters.customFragmentShaderID);
              }
              if (parameters.defines !== undefined) {
                for (var name in parameters.defines) {
                  array.push(name);
                  array.push(parameters.defines[name]);
                }
              }
              if (parameters.isRawShaderMaterial === false) {
                getProgramCacheKeyParameters(array, parameters);
                getProgramCacheKeyBooleans(array, parameters);
                array.push(renderer.outputEncoding);
              }
              array.push(parameters.customProgramCacheKey);
              return array.join();
            }
            function getProgramCacheKeyParameters(array, parameters) {
              array.push(parameters.precision);
              array.push(parameters.outputEncoding);
              array.push(parameters.envMapMode);
              array.push(parameters.envMapCubeUVHeight);
              array.push(parameters.combine);
              array.push(parameters.vertexUvs);
              array.push(parameters.fogExp2);
              array.push(parameters.sizeAttenuation);
              array.push(parameters.morphTargetsCount);
              array.push(parameters.morphAttributeCount);
              array.push(parameters.numDirLights);
              array.push(parameters.numPointLights);
              array.push(parameters.numSpotLights);
              array.push(parameters.numSpotLightMaps);
              array.push(parameters.numHemiLights);
              array.push(parameters.numRectAreaLights);
              array.push(parameters.numDirLightShadows);
              array.push(parameters.numPointLightShadows);
              array.push(parameters.numSpotLightShadows);
              array.push(parameters.numSpotLightShadowsWithMaps);
              array.push(parameters.shadowMapType);
              array.push(parameters.toneMapping);
              array.push(parameters.numClippingPlanes);
              array.push(parameters.numClipIntersection);
              array.push(parameters.depthPacking);
            }
            function getProgramCacheKeyBooleans(array, parameters) {
              _programLayers.disableAll();
              if (parameters.isWebGL2) _programLayers.enable(0);
              if (parameters.supportsVertexTextures) _programLayers.enable(1);
              if (parameters.instancing) _programLayers.enable(2);
              if (parameters.instancingColor) _programLayers.enable(3);
              if (parameters.map) _programLayers.enable(4);
              if (parameters.matcap) _programLayers.enable(5);
              if (parameters.envMap) _programLayers.enable(6);
              if (parameters.lightMap) _programLayers.enable(7);
              if (parameters.aoMap) _programLayers.enable(8);
              if (parameters.emissiveMap) _programLayers.enable(9);
              if (parameters.bumpMap) _programLayers.enable(10);
              if (parameters.normalMap) _programLayers.enable(11);
              if (parameters.objectSpaceNormalMap) _programLayers.enable(12);
              if (parameters.tangentSpaceNormalMap) _programLayers.enable(13);
              if (parameters.clearcoat) _programLayers.enable(14);
              if (parameters.clearcoatMap) _programLayers.enable(15);
              if (parameters.clearcoatRoughnessMap) _programLayers.enable(16);
              if (parameters.clearcoatNormalMap) _programLayers.enable(17);
              if (parameters.iridescence) _programLayers.enable(18);
              if (parameters.iridescenceMap) _programLayers.enable(19);
              if (parameters.iridescenceThicknessMap) _programLayers.enable(20);
              if (parameters.displacementMap) _programLayers.enable(21);
              if (parameters.specularMap) _programLayers.enable(22);
              if (parameters.roughnessMap) _programLayers.enable(23);
              if (parameters.metalnessMap) _programLayers.enable(24);
              if (parameters.gradientMap) _programLayers.enable(25);
              if (parameters.alphaMap) _programLayers.enable(26);
              if (parameters.alphaTest) _programLayers.enable(27);
              if (parameters.vertexColors) _programLayers.enable(28);
              if (parameters.vertexAlphas) _programLayers.enable(29);
              if (parameters.vertexUvs) _programLayers.enable(30);
              if (parameters.vertexTangents) _programLayers.enable(31);
              if (parameters.uvsVertexOnly) _programLayers.enable(32);
              array.push(_programLayers.mask);
              _programLayers.disableAll();
              if (parameters.fog) _programLayers.enable(0);
              if (parameters.useFog) _programLayers.enable(1);
              if (parameters.flatShading) _programLayers.enable(2);
              if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
              if (parameters.skinning) _programLayers.enable(4);
              if (parameters.morphTargets) _programLayers.enable(5);
              if (parameters.morphNormals) _programLayers.enable(6);
              if (parameters.morphColors) _programLayers.enable(7);
              if (parameters.premultipliedAlpha) _programLayers.enable(8);
              if (parameters.shadowMapEnabled) _programLayers.enable(9);
              if (parameters.physicallyCorrectLights) _programLayers.enable(10);
              if (parameters.doubleSided) _programLayers.enable(11);
              if (parameters.flipSided) _programLayers.enable(12);
              if (parameters.useDepthPacking) _programLayers.enable(13);
              if (parameters.dithering) _programLayers.enable(14);
              if (parameters.specularIntensityMap) _programLayers.enable(15);
              if (parameters.specularColorMap) _programLayers.enable(16);
              if (parameters.transmission) _programLayers.enable(17);
              if (parameters.transmissionMap) _programLayers.enable(18);
              if (parameters.thicknessMap) _programLayers.enable(19);
              if (parameters.sheen) _programLayers.enable(20);
              if (parameters.sheenColorMap) _programLayers.enable(21);
              if (parameters.sheenRoughnessMap) _programLayers.enable(22);
              if (parameters.decodeVideoTexture) _programLayers.enable(23);
              if (parameters.opaque) _programLayers.enable(24);
              array.push(_programLayers.mask);
            }
            function getUniforms(material) {
              var shaderID = shaderIDs[material.type];
              var uniforms;
              if (shaderID) {
                var shader = _ShaderLib[shaderID];
                uniforms = _UniformsUtils.clone(shader.uniforms);
              } else {
                uniforms = material.uniforms;
              }
              return uniforms;
            }
            function acquireProgram(parameters, cacheKey) {
              var program; // Check if code has been already compiled
              for (var p = 0, pl = programs.length; p < pl; p++) {
                var preexistingProgram = programs[p];
                if (preexistingProgram.cacheKey === cacheKey) {
                  program = preexistingProgram;
                  ++program.usedTimes;
                  break;
                }
              }
              if (program === undefined) {
                program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
                programs.push(program);
              }
              return program;
            }
            function releaseProgram(program) {
              if (--program.usedTimes === 0) {
                // Remove from unordered set
                var i = programs.indexOf(program);
                programs[i] = programs[programs.length - 1];
                programs.pop(); // Free WebGL resources
                program.destroy();
              }
            }
            function releaseShaderCache(material) {
              _customShaders.remove(material);
            }
            function dispose() {
              _customShaders.dispose();
            }
            return {
              getParameters: getParameters,
              getProgramCacheKey: getProgramCacheKey,
              getUniforms: getUniforms,
              acquireProgram: acquireProgram,
              releaseProgram: releaseProgram,
              releaseShaderCache: releaseShaderCache,
              // Exposed for resource monitoring & error feedback via renderer.info:
              programs: programs,
              dispose: dispose
            };
          }
          function WebGLProperties() {
            var properties = new WeakMap();
            function get(object) {
              var map = properties.get(object);
              if (map === undefined) {
                map = {};
                properties.set(object, map);
              }
              return map;
            }
            function remove(object) {
              properties.delete(object);
            }
            function update(object, key, value) {
              properties.get(object)[key] = value;
            }
            function dispose() {
              properties = new WeakMap();
            }
            return {
              get: get,
              remove: remove,
              update: update,
              dispose: dispose
            };
          }
          function painterSortStable(a, b) {
            if (a.groupOrder !== b.groupOrder) {
              return a.groupOrder - b.groupOrder;
            } else if (a.renderOrder !== b.renderOrder) {
              return a.renderOrder - b.renderOrder;
            } else if (a.material.id !== b.material.id) {
              return a.material.id - b.material.id;
            } else if (a.z !== b.z) {
              return a.z - b.z;
            } else {
              return a.id - b.id;
            }
          }
          function reversePainterSortStable(a, b) {
            if (a.groupOrder !== b.groupOrder) {
              return a.groupOrder - b.groupOrder;
            } else if (a.renderOrder !== b.renderOrder) {
              return a.renderOrder - b.renderOrder;
            } else if (a.z !== b.z) {
              return b.z - a.z;
            } else {
              return a.id - b.id;
            }
          }
          function WebGLRenderList() {
            var renderItems = [];
            var renderItemsIndex = 0;
            var opaque = [];
            var transmissive = [];
            var transparent = [];
            function init() {
              renderItemsIndex = 0;
              opaque.length = 0;
              transmissive.length = 0;
              transparent.length = 0;
            }
            function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
              var renderItem = renderItems[renderItemsIndex];
              if (renderItem === undefined) {
                renderItem = {
                  id: object.id,
                  object: object,
                  geometry: geometry,
                  material: material,
                  groupOrder: groupOrder,
                  renderOrder: object.renderOrder,
                  z: z,
                  group: group
                };
                renderItems[renderItemsIndex] = renderItem;
              } else {
                renderItem.id = object.id;
                renderItem.object = object;
                renderItem.geometry = geometry;
                renderItem.material = material;
                renderItem.groupOrder = groupOrder;
                renderItem.renderOrder = object.renderOrder;
                renderItem.z = z;
                renderItem.group = group;
              }
              renderItemsIndex++;
              return renderItem;
            }
            function push(object, geometry, material, groupOrder, z, group) {
              var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
              if (material.transmission > 0.0) {
                transmissive.push(renderItem);
              } else if (material.transparent === true) {
                transparent.push(renderItem);
              } else {
                opaque.push(renderItem);
              }
            }
            function unshift(object, geometry, material, groupOrder, z, group) {
              var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
              if (material.transmission > 0.0) {
                transmissive.unshift(renderItem);
              } else if (material.transparent === true) {
                transparent.unshift(renderItem);
              } else {
                opaque.unshift(renderItem);
              }
            }
            function sort(customOpaqueSort, customTransparentSort) {
              if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
              if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
              if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
            }
            function finish() {
              // Clear references from inactive renderItems in the list
              for (var i = renderItemsIndex, il = renderItems.length; i < il; i++) {
                var renderItem = renderItems[i];
                if (renderItem.id === null) break;
                renderItem.id = null;
                renderItem.object = null;
                renderItem.geometry = null;
                renderItem.material = null;
                renderItem.group = null;
              }
            }
            return {
              opaque: opaque,
              transmissive: transmissive,
              transparent: transparent,
              init: init,
              push: push,
              unshift: unshift,
              finish: finish,
              sort: sort
            };
          }
          function WebGLRenderLists() {
            var lists = new WeakMap();
            function get(scene, renderCallDepth) {
              var listArray = lists.get(scene);
              var list;
              if (listArray === undefined) {
                list = new WebGLRenderList();
                lists.set(scene, [list]);
              } else {
                if (renderCallDepth >= listArray.length) {
                  list = new WebGLRenderList();
                  listArray.push(list);
                } else {
                  list = listArray[renderCallDepth];
                }
              }
              return list;
            }
            function dispose() {
              lists = new WeakMap();
            }
            return {
              get: get,
              dispose: dispose
            };
          }
          function UniformsCache() {
            var lights = {};
            return {
              get: function get(light) {
                if (lights[light.id] !== undefined) {
                  return lights[light.id];
                }
                var uniforms;
                switch (light.type) {
                  case 'DirectionalLight':
                    uniforms = {
                      direction: new _Vector2(),
                      color: new _Color()
                    };
                    break;
                  case 'SpotLight':
                    uniforms = {
                      position: new _Vector2(),
                      direction: new _Vector2(),
                      color: new _Color(),
                      distance: 0,
                      coneCos: 0,
                      penumbraCos: 0,
                      decay: 0
                    };
                    break;
                  case 'PointLight':
                    uniforms = {
                      position: new _Vector2(),
                      color: new _Color(),
                      distance: 0,
                      decay: 0
                    };
                    break;
                  case 'HemisphereLight':
                    uniforms = {
                      direction: new _Vector2(),
                      skyColor: new _Color(),
                      groundColor: new _Color()
                    };
                    break;
                  case 'RectAreaLight':
                    uniforms = {
                      color: new _Color(),
                      position: new _Vector2(),
                      halfWidth: new _Vector2(),
                      halfHeight: new _Vector2()
                    };
                    break;
                }
                lights[light.id] = uniforms;
                return uniforms;
              }
            };
          }
          function ShadowUniformsCache() {
            var lights = {};
            return {
              get: function get(light) {
                if (lights[light.id] !== undefined) {
                  return lights[light.id];
                }
                var uniforms;
                switch (light.type) {
                  case 'DirectionalLight':
                    uniforms = {
                      shadowBias: 0,
                      shadowNormalBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new _Vector()
                    };
                    break;
                  case 'SpotLight':
                    uniforms = {
                      shadowBias: 0,
                      shadowNormalBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new _Vector()
                    };
                    break;
                  case 'PointLight':
                    uniforms = {
                      shadowBias: 0,
                      shadowNormalBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new _Vector(),
                      shadowCameraNear: 1,
                      shadowCameraFar: 1000
                    };
                    break;
                  // TODO (abelnation): set RectAreaLight shadow uniforms
                }
                lights[light.id] = uniforms;
                return uniforms;
              }
            };
          }
          var nextVersion = 0;
          function shadowCastingAndTexturingLightsFirst(lightA, lightB) {
            return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
          }
          function WebGLLights(extensions, capabilities) {
            var cache = new UniformsCache();
            var shadowCache = ShadowUniformsCache();
            var state = {
              version: 0,
              hash: {
                directionalLength: -1,
                pointLength: -1,
                spotLength: -1,
                rectAreaLength: -1,
                hemiLength: -1,
                numDirectionalShadows: -1,
                numPointShadows: -1,
                numSpotShadows: -1,
                numSpotMaps: -1
              },
              ambient: [0, 0, 0],
              probe: [],
              directional: [],
              directionalShadow: [],
              directionalShadowMap: [],
              directionalShadowMatrix: [],
              spot: [],
              spotLightMap: [],
              spotShadow: [],
              spotShadowMap: [],
              spotLightMatrix: [],
              rectArea: [],
              rectAreaLTC1: null,
              rectAreaLTC2: null,
              point: [],
              pointShadow: [],
              pointShadowMap: [],
              pointShadowMatrix: [],
              hemi: [],
              numSpotLightShadowsWithMaps: 0
            };
            for (var i = 0; i < 9; i++) state.probe.push(new _Vector2());
            var vector3 = new _Vector2();
            var matrix4 = new _Matrix2();
            var matrix42 = new _Matrix2();
            function setup(lights, physicallyCorrectLights) {
              var r = 0,
                g = 0,
                b = 0;
              for (var _i32 = 0; _i32 < 9; _i32++) state.probe[_i32].set(0, 0, 0);
              var directionalLength = 0;
              var pointLength = 0;
              var spotLength = 0;
              var rectAreaLength = 0;
              var hemiLength = 0;
              var numDirectionalShadows = 0;
              var numPointShadows = 0;
              var numSpotShadows = 0;
              var numSpotMaps = 0;
              var numSpotShadowsWithMaps = 0; // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
              lights.sort(shadowCastingAndTexturingLightsFirst); // artist-friendly light intensity scaling factor
              var scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
              for (var _i33 = 0, l = lights.length; _i33 < l; _i33++) {
                var light = lights[_i33];
                var color = light.color;
                var intensity = light.intensity;
                var distance = light.distance;
                var shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
                if (light.isAmbientLight) {
                  r += color.r * intensity * scaleFactor;
                  g += color.g * intensity * scaleFactor;
                  b += color.b * intensity * scaleFactor;
                } else if (light.isLightProbe) {
                  for (var j = 0; j < 9; j++) {
                    state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                  }
                } else if (light.isDirectionalLight) {
                  var uniforms = cache.get(light);
                  uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                  if (light.castShadow) {
                    var shadow = light.shadow;
                    var shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                  }
                  state.directional[directionalLength] = uniforms;
                  directionalLength++;
                } else if (light.isSpotLight) {
                  var _uniforms = cache.get(light);
                  _uniforms.position.setFromMatrixPosition(light.matrixWorld);
                  _uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                  _uniforms.distance = distance;
                  _uniforms.coneCos = Math.cos(light.angle);
                  _uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                  _uniforms.decay = light.decay;
                  state.spot[spotLength] = _uniforms;
                  var _shadow = light.shadow;
                  if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++; // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    _shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                  }
                  state.spotLightMatrix[spotLength] = _shadow.matrix;
                  if (light.castShadow) {
                    var _shadowUniforms = shadowCache.get(light);
                    _shadowUniforms.shadowBias = _shadow.bias;
                    _shadowUniforms.shadowNormalBias = _shadow.normalBias;
                    _shadowUniforms.shadowRadius = _shadow.radius;
                    _shadowUniforms.shadowMapSize = _shadow.mapSize;
                    state.spotShadow[spotLength] = _shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                  }
                  spotLength++;
                } else if (light.isRectAreaLight) {
                  var _uniforms2 = cache.get(light);
                  _uniforms2.color.copy(color).multiplyScalar(intensity);
                  _uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                  _uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                  state.rectArea[rectAreaLength] = _uniforms2;
                  rectAreaLength++;
                } else if (light.isPointLight) {
                  var _uniforms3 = cache.get(light);
                  _uniforms3.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                  _uniforms3.distance = light.distance;
                  _uniforms3.decay = light.decay;
                  if (light.castShadow) {
                    var _shadow2 = light.shadow;
                    var _shadowUniforms2 = shadowCache.get(light);
                    _shadowUniforms2.shadowBias = _shadow2.bias;
                    _shadowUniforms2.shadowNormalBias = _shadow2.normalBias;
                    _shadowUniforms2.shadowRadius = _shadow2.radius;
                    _shadowUniforms2.shadowMapSize = _shadow2.mapSize;
                    _shadowUniforms2.shadowCameraNear = _shadow2.camera.near;
                    _shadowUniforms2.shadowCameraFar = _shadow2.camera.far;
                    state.pointShadow[pointLength] = _shadowUniforms2;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                  }
                  state.point[pointLength] = _uniforms3;
                  pointLength++;
                } else if (light.isHemisphereLight) {
                  var _uniforms4 = cache.get(light);
                  _uniforms4.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                  _uniforms4.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                  state.hemi[hemiLength] = _uniforms4;
                  hemiLength++;
                }
              }
              if (rectAreaLength > 0) {
                if (capabilities.isWebGL2) {
                  // WebGL 2
                  state.rectAreaLTC1 = _UniformsLib.LTC_FLOAT_1;
                  state.rectAreaLTC2 = _UniformsLib.LTC_FLOAT_2;
                } else {
                  // WebGL 1
                  if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = _UniformsLib.LTC_FLOAT_1;
                    state.rectAreaLTC2 = _UniformsLib.LTC_FLOAT_2;
                  } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = _UniformsLib.LTC_HALF_1;
                    state.rectAreaLTC2 = _UniformsLib.LTC_HALF_2;
                  } else {
                    console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
                  }
                }
              }
              state.ambient[0] = r;
              state.ambient[1] = g;
              state.ambient[2] = b;
              var hash = state.hash;
              if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
                state.directional.length = directionalLength;
                state.spot.length = spotLength;
                state.rectArea.length = rectAreaLength;
                state.point.length = pointLength;
                state.hemi.length = hemiLength;
                state.directionalShadow.length = numDirectionalShadows;
                state.directionalShadowMap.length = numDirectionalShadows;
                state.pointShadow.length = numPointShadows;
                state.pointShadowMap.length = numPointShadows;
                state.spotShadow.length = numSpotShadows;
                state.spotShadowMap.length = numSpotShadows;
                state.directionalShadowMatrix.length = numDirectionalShadows;
                state.pointShadowMatrix.length = numPointShadows;
                state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
                state.spotLightMap.length = numSpotMaps;
                state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
                hash.directionalLength = directionalLength;
                hash.pointLength = pointLength;
                hash.spotLength = spotLength;
                hash.rectAreaLength = rectAreaLength;
                hash.hemiLength = hemiLength;
                hash.numDirectionalShadows = numDirectionalShadows;
                hash.numPointShadows = numPointShadows;
                hash.numSpotShadows = numSpotShadows;
                hash.numSpotMaps = numSpotMaps;
                state.version = nextVersion++;
              }
            }
            function setupView(lights, camera) {
              var directionalLength = 0;
              var pointLength = 0;
              var spotLength = 0;
              var rectAreaLength = 0;
              var hemiLength = 0;
              var viewMatrix = camera.matrixWorldInverse;
              for (var _i34 = 0, l = lights.length; _i34 < l; _i34++) {
                var light = lights[_i34];
                if (light.isDirectionalLight) {
                  var uniforms = state.directional[directionalLength];
                  uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                  vector3.setFromMatrixPosition(light.target.matrixWorld);
                  uniforms.direction.sub(vector3);
                  uniforms.direction.transformDirection(viewMatrix);
                  directionalLength++;
                } else if (light.isSpotLight) {
                  var _uniforms5 = state.spot[spotLength];
                  _uniforms5.position.setFromMatrixPosition(light.matrixWorld);
                  _uniforms5.position.applyMatrix4(viewMatrix);
                  _uniforms5.direction.setFromMatrixPosition(light.matrixWorld);
                  vector3.setFromMatrixPosition(light.target.matrixWorld);
                  _uniforms5.direction.sub(vector3);
                  _uniforms5.direction.transformDirection(viewMatrix);
                  spotLength++;
                } else if (light.isRectAreaLight) {
                  var _uniforms6 = state.rectArea[rectAreaLength];
                  _uniforms6.position.setFromMatrixPosition(light.matrixWorld);
                  _uniforms6.position.applyMatrix4(viewMatrix); // extract local rotation of light to derive width/height half vectors
                  matrix42.identity();
                  matrix4.copy(light.matrixWorld);
                  matrix4.premultiply(viewMatrix);
                  matrix42.extractRotation(matrix4);
                  _uniforms6.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                  _uniforms6.halfHeight.set(0.0, light.height * 0.5, 0.0);
                  _uniforms6.halfWidth.applyMatrix4(matrix42);
                  _uniforms6.halfHeight.applyMatrix4(matrix42);
                  rectAreaLength++;
                } else if (light.isPointLight) {
                  var _uniforms7 = state.point[pointLength];
                  _uniforms7.position.setFromMatrixPosition(light.matrixWorld);
                  _uniforms7.position.applyMatrix4(viewMatrix);
                  pointLength++;
                } else if (light.isHemisphereLight) {
                  var _uniforms8 = state.hemi[hemiLength];
                  _uniforms8.direction.setFromMatrixPosition(light.matrixWorld);
                  _uniforms8.direction.transformDirection(viewMatrix);
                  hemiLength++;
                }
              }
            }
            return {
              setup: setup,
              setupView: setupView,
              state: state
            };
          }
          function WebGLRenderState(extensions, capabilities) {
            var lights = new WebGLLights(extensions, capabilities);
            var lightsArray = [];
            var shadowsArray = [];
            function init() {
              lightsArray.length = 0;
              shadowsArray.length = 0;
            }
            function pushLight(light) {
              lightsArray.push(light);
            }
            function pushShadow(shadowLight) {
              shadowsArray.push(shadowLight);
            }
            function setupLights(physicallyCorrectLights) {
              lights.setup(lightsArray, physicallyCorrectLights);
            }
            function setupLightsView(camera) {
              lights.setupView(lightsArray, camera);
            }
            var state = {
              lightsArray: lightsArray,
              shadowsArray: shadowsArray,
              lights: lights
            };
            return {
              init: init,
              state: state,
              setupLights: setupLights,
              setupLightsView: setupLightsView,
              pushLight: pushLight,
              pushShadow: pushShadow
            };
          }
          function WebGLRenderStates(extensions, capabilities) {
            var renderStates = new WeakMap();
            function get(scene) {
              var renderCallDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var renderStateArray = renderStates.get(scene);
              var renderState;
              if (renderStateArray === undefined) {
                renderState = new WebGLRenderState(extensions, capabilities);
                renderStates.set(scene, [renderState]);
              } else {
                if (renderCallDepth >= renderStateArray.length) {
                  renderState = new WebGLRenderState(extensions, capabilities);
                  renderStateArray.push(renderState);
                } else {
                  renderState = renderStateArray[renderCallDepth];
                }
              }
              return renderState;
            }
            function dispose() {
              renderStates = new WeakMap();
            }
            return {
              get: get,
              dispose: dispose
            };
          }
          var _MeshDepthMaterial = /*#__PURE__*/function (_Material4) {
            _inherits(_MeshDepthMaterial, _Material4);
            var _super42 = _createSuper(_MeshDepthMaterial);
            function _MeshDepthMaterial(parameters) {
              var _this34;
              _classCallCheck2(this, _MeshDepthMaterial);
              _this34 = _super42.call(this);
              _this34.isMeshDepthMaterial = true;
              _this34.type = 'MeshDepthMaterial';
              _this34.depthPacking = _BasicDepthPacking;
              _this34.map = null;
              _this34.alphaMap = null;
              _this34.displacementMap = null;
              _this34.displacementScale = 1;
              _this34.displacementBias = 0;
              _this34.wireframe = false;
              _this34.wireframeLinewidth = 1;
              _this34.setValues(parameters);
              return _this34;
            }
            _createClass2(_MeshDepthMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshDepthMaterial.prototype), "copy", this).call(this, source);
                this.depthPacking = source.depthPacking;
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                return this;
              }
            }]);
            return _MeshDepthMaterial;
          }(_Material);
          var _MeshDistanceMaterial = /*#__PURE__*/function (_Material5) {
            _inherits(_MeshDistanceMaterial, _Material5);
            var _super43 = _createSuper(_MeshDistanceMaterial);
            function _MeshDistanceMaterial(parameters) {
              var _this35;
              _classCallCheck2(this, _MeshDistanceMaterial);
              _this35 = _super43.call(this);
              _this35.isMeshDistanceMaterial = true;
              _this35.type = 'MeshDistanceMaterial';
              _this35.referencePosition = new _Vector2();
              _this35.nearDistance = 1;
              _this35.farDistance = 1000;
              _this35.map = null;
              _this35.alphaMap = null;
              _this35.displacementMap = null;
              _this35.displacementScale = 1;
              _this35.displacementBias = 0;
              _this35.setValues(parameters);
              return _this35;
            }
            _createClass2(_MeshDistanceMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshDistanceMaterial.prototype), "copy", this).call(this, source);
                this.referencePosition.copy(source.referencePosition);
                this.nearDistance = source.nearDistance;
                this.farDistance = source.farDistance;
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                return this;
              }
            }]);
            return _MeshDistanceMaterial;
          }(_Material);
          var vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
          var fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
          function WebGLShadowMap(_renderer, _objects, _capabilities) {
            var _frustum = new _Frustum();
            var _shadowMapSize = new _Vector(),
              _viewportSize = new _Vector(),
              _viewport = new _Vector3(),
              _depthMaterial = new _MeshDepthMaterial({
                depthPacking: _RGBADepthPacking
              }),
              _distanceMaterial = new _MeshDistanceMaterial(),
              _materialCache = {},
              _maxTextureSize = _capabilities.maxTextureSize;
            var shadowSide = {
              0: _BackSide,
              1: _FrontSide,
              2: _DoubleSide
            };
            var shadowMaterialVertical = new _ShaderMaterial({
              defines: {
                VSM_SAMPLES: 8
              },
              uniforms: {
                shadow_pass: {
                  value: null
                },
                resolution: {
                  value: new _Vector()
                },
                radius: {
                  value: 4.0
                }
              },
              vertexShader: vertex,
              fragmentShader: fragment
            });
            var shadowMaterialHorizontal = shadowMaterialVertical.clone();
            shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
            var fullScreenTri = new _BufferGeometry();
            fullScreenTri.setAttribute('position', new _BufferAttribute(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3));
            var fullScreenMesh = new _Mesh(fullScreenTri, shadowMaterialVertical);
            var scope = this;
            this.enabled = false;
            this.autoUpdate = true;
            this.needsUpdate = false;
            this.type = _PCFShadowMap;
            this.render = function (lights, scene, camera) {
              if (scope.enabled === false) return;
              if (scope.autoUpdate === false && scope.needsUpdate === false) return;
              if (lights.length === 0) return;
              var currentRenderTarget = _renderer.getRenderTarget();
              var activeCubeFace = _renderer.getActiveCubeFace();
              var activeMipmapLevel = _renderer.getActiveMipmapLevel();
              var _state = _renderer.state; // Set GL state for depth map.
              _state.setBlending(_NoBlending);
              _state.buffers.color.setClear(1, 1, 1, 1);
              _state.buffers.depth.setTest(true);
              _state.setScissorTest(false); // render depth map
              for (var i = 0, il = lights.length; i < il; i++) {
                var light = lights[i];
                var shadow = light.shadow;
                if (shadow === undefined) {
                  console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                  continue;
                }
                if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
                _shadowMapSize.copy(shadow.mapSize);
                var shadowFrameExtents = shadow.getFrameExtents();
                _shadowMapSize.multiply(shadowFrameExtents);
                _viewportSize.copy(shadow.mapSize);
                if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                  if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                  }
                  if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                  }
                }
                if (shadow.map === null) {
                  var pars = this.type !== _VSMShadowMap ? {
                    minFilter: _NearestFilter,
                    magFilter: _NearestFilter
                  } : {};
                  shadow.map = new _WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                  shadow.map.texture.name = light.name + '.shadowMap';
                  shadow.camera.updateProjectionMatrix();
                }
                _renderer.setRenderTarget(shadow.map);
                _renderer.clear();
                var viewportCount = shadow.getViewportCount();
                for (var vp = 0; vp < viewportCount; vp++) {
                  var viewport = shadow.getViewport(vp);
                  _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                  _state.viewport(_viewport);
                  shadow.updateMatrices(light, vp);
                  _frustum = shadow.getFrustum();
                  renderObject(scene, camera, shadow.camera, light, this.type);
                } // do blur pass for VSM
                if (shadow.isPointLightShadow !== true && this.type === _VSMShadowMap) {
                  VSMPass(shadow, camera);
                }
                shadow.needsUpdate = false;
              }
              scope.needsUpdate = false;
              _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
            };
            function VSMPass(shadow, camera) {
              var geometry = _objects.update(fullScreenMesh);
              if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
                shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
                shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
                shadowMaterialVertical.needsUpdate = true;
                shadowMaterialHorizontal.needsUpdate = true;
              }
              if (shadow.mapPass === null) {
                shadow.mapPass = new _WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
              } // vertical pass
              shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
              shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
              shadowMaterialVertical.uniforms.radius.value = shadow.radius;
              _renderer.setRenderTarget(shadow.mapPass);
              _renderer.clear();
              _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null); // horizontal pass
              shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
              shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
              shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
              _renderer.setRenderTarget(shadow.map);
              _renderer.clear();
              _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
            }
            function getDepthMaterial(object, material, light, shadowCameraNear, shadowCameraFar, type) {
              var result = null;
              var customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
              if (customMaterial !== undefined) {
                result = customMaterial;
              } else {
                result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
              }
              if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                var keyA = result.uuid,
                  keyB = material.uuid;
                var materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                  materialsForVariant = {};
                  _materialCache[keyA] = materialsForVariant;
                }
                var cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                  cachedMaterial = result.clone();
                  materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
              }
              result.visible = material.visible;
              result.wireframe = material.wireframe;
              if (type === _VSMShadowMap) {
                result.side = material.shadowSide !== null ? material.shadowSide : material.side;
              } else {
                result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
              }
              result.alphaMap = material.alphaMap;
              result.alphaTest = material.alphaTest;
              result.map = material.map;
              result.clipShadows = material.clipShadows;
              result.clippingPlanes = material.clippingPlanes;
              result.clipIntersection = material.clipIntersection;
              result.displacementMap = material.displacementMap;
              result.displacementScale = material.displacementScale;
              result.displacementBias = material.displacementBias;
              result.wireframeLinewidth = material.wireframeLinewidth;
              result.linewidth = material.linewidth;
              if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
                result.referencePosition.setFromMatrixPosition(light.matrixWorld);
                result.nearDistance = shadowCameraNear;
                result.farDistance = shadowCameraFar;
              }
              return result;
            }
            function renderObject(object, camera, shadowCamera, light, type) {
              if (object.visible === false) return;
              var visible = object.layers.test(camera.layers);
              if (visible && (object.isMesh || object.isLine || object.isPoints)) {
                if ((object.castShadow || object.receiveShadow && type === _VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                  object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                  var geometry = _objects.update(object);
                  var material = object.material;
                  if (Array.isArray(material)) {
                    var groups = geometry.groups;
                    for (var k = 0, kl = groups.length; k < kl; k++) {
                      var group = groups[k];
                      var groupMaterial = material[group.materialIndex];
                      if (groupMaterial && groupMaterial.visible) {
                        var depthMaterial = getDepthMaterial(object, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                        _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                      }
                    }
                  } else if (material.visible) {
                    var _depthMaterial2 = getDepthMaterial(object, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, _depthMaterial2, object, null);
                  }
                }
              }
              var children = object.children;
              for (var i = 0, l = children.length; i < l; i++) {
                renderObject(children[i], camera, shadowCamera, light, type);
              }
            }
          }
          function WebGLState(gl, extensions, capabilities) {
            var _equationToGL, _factorToGL;
            var isWebGL2 = capabilities.isWebGL2;
            function ColorBuffer() {
              var locked = false;
              var color = new _Vector3();
              var currentColorMask = null;
              var currentColorClear = new _Vector3(0, 0, 0, 0);
              return {
                setMask: function setMask(colorMask) {
                  if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                  }
                },
                setLocked: function setLocked(lock) {
                  locked = lock;
                },
                setClear: function setClear(r, g, b, a, premultipliedAlpha) {
                  if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                  }
                  color.set(r, g, b, a);
                  if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                  }
                },
                reset: function reset() {
                  locked = false;
                  currentColorMask = null;
                  currentColorClear.set(-1, 0, 0, 0); // set to invalid state
                }
              };
            }
            function DepthBuffer() {
              var locked = false;
              var currentDepthMask = null;
              var currentDepthFunc = null;
              var currentDepthClear = null;
              return {
                setTest: function setTest(depthTest) {
                  if (depthTest) {
                    enable(2929);
                  } else {
                    disable(2929);
                  }
                },
                setMask: function setMask(depthMask) {
                  if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                  }
                },
                setFunc: function setFunc(depthFunc) {
                  if (currentDepthFunc !== depthFunc) {
                    switch (depthFunc) {
                      case _NeverDepth:
                        gl.depthFunc(512);
                        break;
                      case _AlwaysDepth:
                        gl.depthFunc(519);
                        break;
                      case _LessDepth:
                        gl.depthFunc(513);
                        break;
                      case _LessEqualDepth:
                        gl.depthFunc(515);
                        break;
                      case _EqualDepth:
                        gl.depthFunc(514);
                        break;
                      case _GreaterEqualDepth:
                        gl.depthFunc(518);
                        break;
                      case _GreaterDepth:
                        gl.depthFunc(516);
                        break;
                      case _NotEqualDepth:
                        gl.depthFunc(517);
                        break;
                      default:
                        gl.depthFunc(515);
                    }
                    currentDepthFunc = depthFunc;
                  }
                },
                setLocked: function setLocked(lock) {
                  locked = lock;
                },
                setClear: function setClear(depth) {
                  if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                  }
                },
                reset: function reset() {
                  locked = false;
                  currentDepthMask = null;
                  currentDepthFunc = null;
                  currentDepthClear = null;
                }
              };
            }
            function StencilBuffer() {
              var locked = false;
              var currentStencilMask = null;
              var currentStencilFunc = null;
              var currentStencilRef = null;
              var currentStencilFuncMask = null;
              var currentStencilFail = null;
              var currentStencilZFail = null;
              var currentStencilZPass = null;
              var currentStencilClear = null;
              return {
                setTest: function setTest(stencilTest) {
                  if (!locked) {
                    if (stencilTest) {
                      enable(2960);
                    } else {
                      disable(2960);
                    }
                  }
                },
                setMask: function setMask(stencilMask) {
                  if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                  }
                },
                setFunc: function setFunc(stencilFunc, stencilRef, stencilMask) {
                  if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                  }
                },
                setOp: function setOp(stencilFail, stencilZFail, stencilZPass) {
                  if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                  }
                },
                setLocked: function setLocked(lock) {
                  locked = lock;
                },
                setClear: function setClear(stencil) {
                  if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                  }
                },
                reset: function reset() {
                  locked = false;
                  currentStencilMask = null;
                  currentStencilFunc = null;
                  currentStencilRef = null;
                  currentStencilFuncMask = null;
                  currentStencilFail = null;
                  currentStencilZFail = null;
                  currentStencilZPass = null;
                  currentStencilClear = null;
                }
              };
            } //
            var colorBuffer = new ColorBuffer();
            var depthBuffer = new DepthBuffer();
            var stencilBuffer = new StencilBuffer();
            var uboBindings = new WeakMap();
            var uboProgamMap = new WeakMap();
            var enabledCapabilities = {};
            var currentBoundFramebuffers = {};
            var currentDrawbuffers = new WeakMap();
            var defaultDrawbuffers = [];
            var currentProgram = null;
            var currentBlendingEnabled = false;
            var currentBlending = null;
            var currentBlendEquation = null;
            var currentBlendSrc = null;
            var currentBlendDst = null;
            var currentBlendEquationAlpha = null;
            var currentBlendSrcAlpha = null;
            var currentBlendDstAlpha = null;
            var currentPremultipledAlpha = false;
            var currentFlipSided = null;
            var currentCullFace = null;
            var currentLineWidth = null;
            var currentPolygonOffsetFactor = null;
            var currentPolygonOffsetUnits = null;
            var maxTextures = gl.getParameter(35661);
            var lineWidthAvailable = false;
            var version = 0;
            var glVersion = gl.getParameter(7938);
            if (glVersion.indexOf('WebGL') !== -1) {
              version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
              lineWidthAvailable = version >= 1.0;
            } else if (glVersion.indexOf('OpenGL ES') !== -1) {
              version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
              lineWidthAvailable = version >= 2.0;
            }
            var currentTextureSlot = null;
            var currentBoundTextures = {};
            var scissorParam = gl.getParameter(3088);
            var viewportParam = gl.getParameter(2978);
            var currentScissor = new _Vector3().fromArray(scissorParam);
            var currentViewport = new _Vector3().fromArray(viewportParam);
            function createTexture(type, target, count) {
              var data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
              var texture = gl.createTexture();
              gl.bindTexture(type, texture);
              gl.texParameteri(type, 10241, 9728);
              gl.texParameteri(type, 10240, 9728);
              for (var i = 0; i < count; i++) {
                gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
              }
              return texture;
            }
            var emptyTextures = {};
            emptyTextures[3553] = createTexture(3553, 3553, 1);
            emptyTextures[34067] = createTexture(34067, 34069, 6); // init
            colorBuffer.setClear(0, 0, 0, 1);
            depthBuffer.setClear(1);
            stencilBuffer.setClear(0);
            enable(2929);
            depthBuffer.setFunc(_LessEqualDepth);
            setFlipSided(false);
            setCullFace(_CullFaceBack);
            enable(2884);
            setBlending(_NoBlending); //
            function enable(id) {
              if (enabledCapabilities[id] !== true) {
                gl.enable(id);
                enabledCapabilities[id] = true;
              }
            }
            function disable(id) {
              if (enabledCapabilities[id] !== false) {
                gl.disable(id);
                enabledCapabilities[id] = false;
              }
            }
            function bindFramebuffer(target, framebuffer) {
              if (currentBoundFramebuffers[target] !== framebuffer) {
                gl.bindFramebuffer(target, framebuffer);
                currentBoundFramebuffers[target] = framebuffer;
                if (isWebGL2) {
                  // 36009 is equivalent to 36160
                  if (target === 36009) {
                    currentBoundFramebuffers[36160] = framebuffer;
                  }
                  if (target === 36160) {
                    currentBoundFramebuffers[36009] = framebuffer;
                  }
                }
                return true;
              }
              return false;
            }
            function drawBuffers(renderTarget, framebuffer) {
              var drawBuffers = defaultDrawbuffers;
              var needsUpdate = false;
              if (renderTarget) {
                drawBuffers = currentDrawbuffers.get(framebuffer);
                if (drawBuffers === undefined) {
                  drawBuffers = [];
                  currentDrawbuffers.set(framebuffer, drawBuffers);
                }
                if (renderTarget.isWebGLMultipleRenderTargets) {
                  var textures = renderTarget.texture;
                  if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for (var i = 0, il = textures.length; i < il; i++) {
                      drawBuffers[i] = 36064 + i;
                    }
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                  }
                } else {
                  if (drawBuffers[0] !== 36064) {
                    drawBuffers[0] = 36064;
                    needsUpdate = true;
                  }
                }
              } else {
                if (drawBuffers[0] !== 1029) {
                  drawBuffers[0] = 1029;
                  needsUpdate = true;
                }
              }
              if (needsUpdate) {
                if (capabilities.isWebGL2) {
                  gl.drawBuffers(drawBuffers);
                } else {
                  extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
                }
              }
            }
            function useProgram(program) {
              if (currentProgram !== program) {
                gl.useProgram(program);
                currentProgram = program;
                return true;
              }
              return false;
            }
            var equationToGL = (_equationToGL = {}, _defineProperty(_equationToGL, _AddEquation, 32774), _defineProperty(_equationToGL, _SubtractEquation, 32778), _defineProperty(_equationToGL, _ReverseSubtractEquation, 32779), _equationToGL);
            if (isWebGL2) {
              equationToGL[_MinEquation] = 32775;
              equationToGL[_MaxEquation] = 32776;
            } else {
              var extension = extensions.get('EXT_blend_minmax');
              if (extension !== null) {
                equationToGL[_MinEquation] = extension.MIN_EXT;
                equationToGL[_MaxEquation] = extension.MAX_EXT;
              }
            }
            var factorToGL = (_factorToGL = {}, _defineProperty(_factorToGL, _ZeroFactor, 0), _defineProperty(_factorToGL, _OneFactor, 1), _defineProperty(_factorToGL, _SrcColorFactor, 768), _defineProperty(_factorToGL, _SrcAlphaFactor, 770), _defineProperty(_factorToGL, _SrcAlphaSaturateFactor, 776), _defineProperty(_factorToGL, _DstColorFactor, 774), _defineProperty(_factorToGL, _DstAlphaFactor, 772), _defineProperty(_factorToGL, _OneMinusSrcColorFactor, 769), _defineProperty(_factorToGL, _OneMinusSrcAlphaFactor, 771), _defineProperty(_factorToGL, _OneMinusDstColorFactor, 775), _defineProperty(_factorToGL, _OneMinusDstAlphaFactor, 773), _factorToGL);
            function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
              if (blending === _NoBlending) {
                if (currentBlendingEnabled === true) {
                  disable(3042);
                  currentBlendingEnabled = false;
                }
                return;
              }
              if (currentBlendingEnabled === false) {
                enable(3042);
                currentBlendingEnabled = true;
              }
              if (blending !== _CustomBlending) {
                if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                  if (currentBlendEquation !== _AddEquation || currentBlendEquationAlpha !== _AddEquation) {
                    gl.blendEquation(32774);
                    currentBlendEquation = _AddEquation;
                    currentBlendEquationAlpha = _AddEquation;
                  }
                  if (premultipliedAlpha) {
                    switch (blending) {
                      case _NormalBlending:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                      case _AdditiveBlending:
                        gl.blendFunc(1, 1);
                        break;
                      case _SubtractiveBlending:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                      case _MultiplyBlending:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                      default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                    }
                  } else {
                    switch (blending) {
                      case _NormalBlending:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                      case _AdditiveBlending:
                        gl.blendFunc(770, 1);
                        break;
                      case _SubtractiveBlending:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                      case _MultiplyBlending:
                        gl.blendFunc(0, 768);
                        break;
                      default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                    }
                  }
                  currentBlendSrc = null;
                  currentBlendDst = null;
                  currentBlendSrcAlpha = null;
                  currentBlendDstAlpha = null;
                  currentBlending = blending;
                  currentPremultipledAlpha = premultipliedAlpha;
                }
                return;
              } // custom blending
              blendEquationAlpha = blendEquationAlpha || blendEquation;
              blendSrcAlpha = blendSrcAlpha || blendSrc;
              blendDstAlpha = blendDstAlpha || blendDst;
              if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
                gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
                currentBlendEquation = blendEquation;
                currentBlendEquationAlpha = blendEquationAlpha;
              }
              if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
                gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
                currentBlendSrc = blendSrc;
                currentBlendDst = blendDst;
                currentBlendSrcAlpha = blendSrcAlpha;
                currentBlendDstAlpha = blendDstAlpha;
              }
              currentBlending = blending;
              currentPremultipledAlpha = false;
            }
            function setMaterial(material, frontFaceCW) {
              material.side === _DoubleSide ? disable(2884) : enable(2884);
              var flipSided = material.side === _BackSide;
              if (frontFaceCW) flipSided = !flipSided;
              setFlipSided(flipSided);
              material.blending === _NormalBlending && material.transparent === false ? setBlending(_NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
              depthBuffer.setFunc(material.depthFunc);
              depthBuffer.setTest(material.depthTest);
              depthBuffer.setMask(material.depthWrite);
              colorBuffer.setMask(material.colorWrite);
              var stencilWrite = material.stencilWrite;
              stencilBuffer.setTest(stencilWrite);
              if (stencilWrite) {
                stencilBuffer.setMask(material.stencilWriteMask);
                stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
                stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
              }
              setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
              material.alphaToCoverage === true ? enable(32926) : disable(32926);
            } //
            function setFlipSided(flipSided) {
              if (currentFlipSided !== flipSided) {
                if (flipSided) {
                  gl.frontFace(2304);
                } else {
                  gl.frontFace(2305);
                }
                currentFlipSided = flipSided;
              }
            }
            function setCullFace(cullFace) {
              if (cullFace !== _CullFaceNone) {
                enable(2884);
                if (cullFace !== currentCullFace) {
                  if (cullFace === _CullFaceBack) {
                    gl.cullFace(1029);
                  } else if (cullFace === _CullFaceFront) {
                    gl.cullFace(1028);
                  } else {
                    gl.cullFace(1032);
                  }
                }
              } else {
                disable(2884);
              }
              currentCullFace = cullFace;
            }
            function setLineWidth(width) {
              if (width !== currentLineWidth) {
                if (lineWidthAvailable) gl.lineWidth(width);
                currentLineWidth = width;
              }
            }
            function setPolygonOffset(polygonOffset, factor, units) {
              if (polygonOffset) {
                enable(32823);
                if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                  gl.polygonOffset(factor, units);
                  currentPolygonOffsetFactor = factor;
                  currentPolygonOffsetUnits = units;
                }
              } else {
                disable(32823);
              }
            }
            function setScissorTest(scissorTest) {
              if (scissorTest) {
                enable(3089);
              } else {
                disable(3089);
              }
            } // texture
            function activeTexture(webglSlot) {
              if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
              if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
              }
            }
            function bindTexture(webglType, webglTexture, webglSlot) {
              if (webglSlot === undefined) {
                if (currentTextureSlot === null) {
                  webglSlot = 33984 + maxTextures - 1;
                } else {
                  webglSlot = currentTextureSlot;
                }
              }
              var boundTexture = currentBoundTextures[webglSlot];
              if (boundTexture === undefined) {
                boundTexture = {
                  type: undefined,
                  texture: undefined
                };
                currentBoundTextures[webglSlot] = boundTexture;
              }
              if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
                if (currentTextureSlot !== webglSlot) {
                  gl.activeTexture(webglSlot);
                  currentTextureSlot = webglSlot;
                }
                gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
                boundTexture.type = webglType;
                boundTexture.texture = webglTexture;
              }
            }
            function unbindTexture() {
              var boundTexture = currentBoundTextures[currentTextureSlot];
              if (boundTexture !== undefined && boundTexture.type !== undefined) {
                gl.bindTexture(boundTexture.type, null);
                boundTexture.type = undefined;
                boundTexture.texture = undefined;
              }
            }
            function compressedTexImage2D() {
              try {
                gl.compressedTexImage2D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function compressedTexImage3D() {
              try {
                gl.compressedTexImage3D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function texSubImage2D() {
              try {
                gl.texSubImage2D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function texSubImage3D() {
              try {
                gl.texSubImage3D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function compressedTexSubImage2D() {
              try {
                gl.compressedTexSubImage2D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function compressedTexSubImage3D() {
              try {
                gl.compressedTexSubImage3D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function texStorage2D() {
              try {
                gl.texStorage2D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function texStorage3D() {
              try {
                gl.texStorage3D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function texImage2D() {
              try {
                gl.texImage2D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            }
            function texImage3D() {
              try {
                gl.texImage3D.apply(gl, arguments);
              } catch (error) {
                console.error('THREE.WebGLState:', error);
              }
            } //
            function scissor(scissor) {
              if (currentScissor.equals(scissor) === false) {
                gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
                currentScissor.copy(scissor);
              }
            }
            function viewport(viewport) {
              if (currentViewport.equals(viewport) === false) {
                gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
                currentViewport.copy(viewport);
              }
            }
            function updateUBOMapping(uniformsGroup, program) {
              var mapping = uboProgamMap.get(program);
              if (mapping === undefined) {
                mapping = new WeakMap();
                uboProgamMap.set(program, mapping);
              }
              var blockIndex = mapping.get(uniformsGroup);
              if (blockIndex === undefined) {
                blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
                mapping.set(uniformsGroup, blockIndex);
              }
            }
            function uniformBlockBinding(uniformsGroup, program) {
              var mapping = uboProgamMap.get(program);
              var blockIndex = mapping.get(uniformsGroup);
              if (uboBindings.get(uniformsGroup) !== blockIndex) {
                // bind shader specific block index to global block point
                gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
                uboBindings.set(uniformsGroup, blockIndex);
              }
            } //
            function reset() {
              // reset state
              gl.disable(3042);
              gl.disable(2884);
              gl.disable(2929);
              gl.disable(32823);
              gl.disable(3089);
              gl.disable(2960);
              gl.disable(32926);
              gl.blendEquation(32774);
              gl.blendFunc(1, 0);
              gl.blendFuncSeparate(1, 0, 1, 0);
              gl.colorMask(true, true, true, true);
              gl.clearColor(0, 0, 0, 0);
              gl.depthMask(true);
              gl.depthFunc(513);
              gl.clearDepth(1);
              gl.stencilMask(0xffffffff);
              gl.stencilFunc(519, 0, 0xffffffff);
              gl.stencilOp(7680, 7680, 7680);
              gl.clearStencil(0);
              gl.cullFace(1029);
              gl.frontFace(2305);
              gl.polygonOffset(0, 0);
              gl.activeTexture(33984);
              gl.bindFramebuffer(36160, null);
              if (isWebGL2 === true) {
                gl.bindFramebuffer(36009, null);
                gl.bindFramebuffer(36008, null);
              }
              gl.useProgram(null);
              gl.lineWidth(1);
              gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
              gl.viewport(0, 0, gl.canvas.width, gl.canvas.height); // reset internals
              enabledCapabilities = {};
              currentTextureSlot = null;
              currentBoundTextures = {};
              currentBoundFramebuffers = {};
              currentDrawbuffers = new WeakMap();
              defaultDrawbuffers = [];
              currentProgram = null;
              currentBlendingEnabled = false;
              currentBlending = null;
              currentBlendEquation = null;
              currentBlendSrc = null;
              currentBlendDst = null;
              currentBlendEquationAlpha = null;
              currentBlendSrcAlpha = null;
              currentBlendDstAlpha = null;
              currentPremultipledAlpha = false;
              currentFlipSided = null;
              currentCullFace = null;
              currentLineWidth = null;
              currentPolygonOffsetFactor = null;
              currentPolygonOffsetUnits = null;
              currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
              currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
              colorBuffer.reset();
              depthBuffer.reset();
              stencilBuffer.reset();
            }
            return {
              buffers: {
                color: colorBuffer,
                depth: depthBuffer,
                stencil: stencilBuffer
              },
              enable: enable,
              disable: disable,
              bindFramebuffer: bindFramebuffer,
              drawBuffers: drawBuffers,
              useProgram: useProgram,
              setBlending: setBlending,
              setMaterial: setMaterial,
              setFlipSided: setFlipSided,
              setCullFace: setCullFace,
              setLineWidth: setLineWidth,
              setPolygonOffset: setPolygonOffset,
              setScissorTest: setScissorTest,
              activeTexture: activeTexture,
              bindTexture: bindTexture,
              unbindTexture: unbindTexture,
              compressedTexImage2D: compressedTexImage2D,
              compressedTexImage3D: compressedTexImage3D,
              texImage2D: texImage2D,
              texImage3D: texImage3D,
              updateUBOMapping: updateUBOMapping,
              uniformBlockBinding: uniformBlockBinding,
              texStorage2D: texStorage2D,
              texStorage3D: texStorage3D,
              texSubImage2D: texSubImage2D,
              texSubImage3D: texSubImage3D,
              compressedTexSubImage2D: compressedTexSubImage2D,
              compressedTexSubImage3D: compressedTexSubImage3D,
              scissor: scissor,
              viewport: viewport,
              reset: reset
            };
          }
          function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
            var _wrappingToGL, _filterToGL;
            var isWebGL2 = capabilities.isWebGL2;
            var maxTextures = capabilities.maxTextures;
            var maxCubemapSize = capabilities.maxCubemapSize;
            var maxTextureSize = capabilities.maxTextureSize;
            var maxSamples = capabilities.maxSamples;
            var multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
            var supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
            var _videoTextures = new WeakMap();
            var _canvas;
            var _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
            // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
            // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
            // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
            var useOffscreenCanvas = false;
            try {
              useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' // eslint-disable-next-line compat/compat
              && new OffscreenCanvas(1, 1).getContext('2d') !== null;
            } catch (err) {// Ignore any errors
            }
            function createCanvas(width, height) {
              // Use OffscreenCanvas when available. Specially needed in web workers
              return useOffscreenCanvas ?
              // eslint-disable-next-line compat/compat
              new OffscreenCanvas(width, height) : createElementNS('canvas');
            }
            function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
              var scale = 1; // handle case if texture exceeds max size
              if (image.width > maxSize || image.height > maxSize) {
                scale = maxSize / Math.max(image.width, image.height);
              } // only perform resize if necessary
              if (scale < 1 || needsPowerOfTwo === true) {
                // only perform resize for certain image types
                if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                  var floor = needsPowerOfTwo ? floorPowerOfTwo : Math.floor;
                  var width = floor(scale * image.width);
                  var height = floor(scale * image.height);
                  if (_canvas === undefined) _canvas = createCanvas(width, height); // cube textures can't reuse the same canvas
                  var canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                  canvas.width = width;
                  canvas.height = height;
                  var context = canvas.getContext('2d');
                  context.drawImage(image, 0, 0, width, height);
                  console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                  return canvas;
                } else {
                  if ('data' in image) {
                    console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                  }
                  return image;
                }
              }
              return image;
            }
            function isPowerOfTwo$1(image) {
              return isPowerOfTwo(image.width) && isPowerOfTwo(image.height);
            }
            function textureNeedsPowerOfTwo(texture) {
              if (isWebGL2) return false;
              return texture.wrapS !== _ClampToEdgeWrapping || texture.wrapT !== _ClampToEdgeWrapping || texture.minFilter !== _NearestFilter && texture.minFilter !== _LinearFilter;
            }
            function textureNeedsGenerateMipmaps(texture, supportsMips) {
              return texture.generateMipmaps && supportsMips && texture.minFilter !== _NearestFilter && texture.minFilter !== _LinearFilter;
            }
            function generateMipmap(target) {
              _gl.generateMipmap(target);
            }
            function getInternalFormat(internalFormatName, glFormat, glType, encoding) {
              var forceLinearEncoding = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
              if (isWebGL2 === false) return glFormat;
              if (internalFormatName !== null) {
                if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
                console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
              }
              var internalFormat = glFormat;
              if (glFormat === 6403) {
                if (glType === 5126) internalFormat = 33326;
                if (glType === 5131) internalFormat = 33325;
                if (glType === 5121) internalFormat = 33321;
              }
              if (glFormat === 33319) {
                if (glType === 5126) internalFormat = 33328;
                if (glType === 5131) internalFormat = 33327;
                if (glType === 5121) internalFormat = 33323;
              }
              if (glFormat === 6408) {
                if (glType === 5126) internalFormat = 34836;
                if (glType === 5131) internalFormat = 34842;
                if (glType === 5121) internalFormat = encoding === _sRGBEncoding && forceLinearEncoding === false ? 35907 : 32856;
                if (glType === 32819) internalFormat = 32854;
                if (glType === 32820) internalFormat = 32855;
              }
              if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) {
                extensions.get('EXT_color_buffer_float');
              }
              return internalFormat;
            }
            function getMipLevels(texture, image, supportsMips) {
              if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== _NearestFilter && texture.minFilter !== _LinearFilter) {
                return Math.log2(Math.max(image.width, image.height)) + 1;
              } else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) {
                // user-defined mipmaps
                return texture.mipmaps.length;
              } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
                return image.mipmaps.length;
              } else {
                // texture without mipmaps (only base level)
                return 1;
              }
            } // Fallback filters for non-power-of-2 textures
            function filterFallback(f) {
              if (f === _NearestFilter || f === _NearestMipmapNearestFilter || f === _NearestMipmapLinearFilter) {
                return 9728;
              }
              return 9729;
            } //
            function onTextureDispose(event) {
              var texture = event.target;
              texture.removeEventListener('dispose', onTextureDispose);
              deallocateTexture(texture);
              if (texture.isVideoTexture) {
                _videoTextures.delete(texture);
              }
            }
            function onRenderTargetDispose(event) {
              var renderTarget = event.target;
              renderTarget.removeEventListener('dispose', onRenderTargetDispose);
              deallocateRenderTarget(renderTarget);
            } //
            function deallocateTexture(texture) {
              var textureProperties = properties.get(texture);
              if (textureProperties.__webglInit === undefined) return; // check if it's necessary to remove the WebGLTexture object
              var source = texture.source;
              var webglTextures = _sources.get(source);
              if (webglTextures) {
                var webglTexture = webglTextures[textureProperties.__cacheKey];
                webglTexture.usedTimes--; // the WebGLTexture object is not used anymore, remove it
                if (webglTexture.usedTimes === 0) {
                  deleteTexture(texture);
                } // remove the weak map entry if no WebGLTexture uses the source anymore
                if (Object.keys(webglTextures).length === 0) {
                  _sources.delete(source);
                }
              }
              properties.remove(texture);
            }
            function deleteTexture(texture) {
              var textureProperties = properties.get(texture);
              _gl.deleteTexture(textureProperties.__webglTexture);
              var source = texture.source;
              var webglTextures = _sources.get(source);
              delete webglTextures[textureProperties.__cacheKey];
              info.memory.textures--;
            }
            function deallocateRenderTarget(renderTarget) {
              var texture = renderTarget.texture;
              var renderTargetProperties = properties.get(renderTarget);
              var textureProperties = properties.get(texture);
              if (textureProperties.__webglTexture !== undefined) {
                _gl.deleteTexture(textureProperties.__webglTexture);
                info.memory.textures--;
              }
              if (renderTarget.depthTexture) {
                renderTarget.depthTexture.dispose();
              }
              if (renderTarget.isWebGLCubeRenderTarget) {
                for (var i = 0; i < 6; i++) {
                  _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
                  if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
                }
              } else {
                _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
                if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
                if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
                if (renderTargetProperties.__webglColorRenderbuffer) {
                  for (var _i35 = 0; _i35 < renderTargetProperties.__webglColorRenderbuffer.length; _i35++) {
                    if (renderTargetProperties.__webglColorRenderbuffer[_i35]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[_i35]);
                  }
                }
                if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
              }
              if (renderTarget.isWebGLMultipleRenderTargets) {
                for (var _i36 = 0, il = texture.length; _i36 < il; _i36++) {
                  var attachmentProperties = properties.get(texture[_i36]);
                  if (attachmentProperties.__webglTexture) {
                    _gl.deleteTexture(attachmentProperties.__webglTexture);
                    info.memory.textures--;
                  }
                  properties.remove(texture[_i36]);
                }
              }
              properties.remove(texture);
              properties.remove(renderTarget);
            } //
            var textureUnits = 0;
            function resetTextureUnits() {
              textureUnits = 0;
            }
            function allocateTextureUnit() {
              var textureUnit = textureUnits;
              if (textureUnit >= maxTextures) {
                console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
              }
              textureUnits += 1;
              return textureUnit;
            }
            function getTextureCacheKey(texture) {
              var array = [];
              array.push(texture.wrapS);
              array.push(texture.wrapT);
              array.push(texture.wrapR || 0);
              array.push(texture.magFilter);
              array.push(texture.minFilter);
              array.push(texture.anisotropy);
              array.push(texture.internalFormat);
              array.push(texture.format);
              array.push(texture.type);
              array.push(texture.generateMipmaps);
              array.push(texture.premultiplyAlpha);
              array.push(texture.flipY);
              array.push(texture.unpackAlignment);
              array.push(texture.encoding);
              return array.join();
            } //
            function setTexture2D(texture, slot) {
              var textureProperties = properties.get(texture);
              if (texture.isVideoTexture) updateVideoTexture(texture);
              if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
                var image = texture.image;
                if (image === null) {
                  console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
                } else if (image.complete === false) {
                  console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
                } else {
                  uploadTexture(textureProperties, texture, slot);
                  return;
                }
              }
              state.bindTexture(3553, textureProperties.__webglTexture, 33984 + slot);
            }
            function setTexture2DArray(texture, slot) {
              var textureProperties = properties.get(texture);
              if (texture.version > 0 && textureProperties.__version !== texture.version) {
                uploadTexture(textureProperties, texture, slot);
                return;
              }
              state.bindTexture(35866, textureProperties.__webglTexture, 33984 + slot);
            }
            function setTexture3D(texture, slot) {
              var textureProperties = properties.get(texture);
              if (texture.version > 0 && textureProperties.__version !== texture.version) {
                uploadTexture(textureProperties, texture, slot);
                return;
              }
              state.bindTexture(32879, textureProperties.__webglTexture, 33984 + slot);
            }
            function setTextureCube(texture, slot) {
              var textureProperties = properties.get(texture);
              if (texture.version > 0 && textureProperties.__version !== texture.version) {
                uploadCubeTexture(textureProperties, texture, slot);
                return;
              }
              state.bindTexture(34067, textureProperties.__webglTexture, 33984 + slot);
            }
            var wrappingToGL = (_wrappingToGL = {}, _defineProperty(_wrappingToGL, _RepeatWrapping, 10497), _defineProperty(_wrappingToGL, _ClampToEdgeWrapping, 33071), _defineProperty(_wrappingToGL, _MirroredRepeatWrapping, 33648), _wrappingToGL);
            var filterToGL = (_filterToGL = {}, _defineProperty(_filterToGL, _NearestFilter, 9728), _defineProperty(_filterToGL, _NearestMipmapNearestFilter, 9984), _defineProperty(_filterToGL, _NearestMipmapLinearFilter, 9986), _defineProperty(_filterToGL, _LinearFilter, 9729), _defineProperty(_filterToGL, _LinearMipmapNearestFilter, 9985), _defineProperty(_filterToGL, _LinearMipmapLinearFilter, 9987), _filterToGL);
            function setTextureParameters(textureType, texture, supportsMips) {
              if (supportsMips) {
                _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
                _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
                if (textureType === 32879 || textureType === 35866) {
                  _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
                }
                _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
                _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
              } else {
                _gl.texParameteri(textureType, 10242, 33071);
                _gl.texParameteri(textureType, 10243, 33071);
                if (textureType === 32879 || textureType === 35866) {
                  _gl.texParameteri(textureType, 32882, 33071);
                }
                if (texture.wrapS !== _ClampToEdgeWrapping || texture.wrapT !== _ClampToEdgeWrapping) {
                  console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
                }
                _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
                _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
                if (texture.minFilter !== _NearestFilter && texture.minFilter !== _LinearFilter) {
                  console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
                }
              }
              if (extensions.has('EXT_texture_filter_anisotropic') === true) {
                var extension = extensions.get('EXT_texture_filter_anisotropic');
                if (texture.type === _FloatType && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
                if (isWebGL2 === false && texture.type === _HalfFloatType && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
                if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                  _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                  properties.get(texture).__currentAnisotropy = texture.anisotropy;
                }
              }
            }
            function initTexture(textureProperties, texture) {
              var forceUpload = false;
              if (textureProperties.__webglInit === undefined) {
                textureProperties.__webglInit = true;
                texture.addEventListener('dispose', onTextureDispose);
              } // create Source <-> WebGLTextures mapping if necessary
              var source = texture.source;
              var webglTextures = _sources.get(source);
              if (webglTextures === undefined) {
                webglTextures = {};
                _sources.set(source, webglTextures);
              } // check if there is already a WebGLTexture object for the given texture parameters
              var textureCacheKey = getTextureCacheKey(texture);
              if (textureCacheKey !== textureProperties.__cacheKey) {
                // if not, create a new instance of WebGLTexture
                if (webglTextures[textureCacheKey] === undefined) {
                  // create new entry
                  webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                  };
                  info.memory.textures++; // when a new instance of WebGLTexture was created, a texture upload is required
                  // even if the image contents are identical
                  forceUpload = true;
                }
                webglTextures[textureCacheKey].usedTimes++; // every time the texture cache key changes, it's necessary to check if an instance of
                // WebGLTexture can be deleted in order to avoid a memory leak.
                var webglTexture = webglTextures[textureProperties.__cacheKey];
                if (webglTexture !== undefined) {
                  webglTextures[textureProperties.__cacheKey].usedTimes--;
                  if (webglTexture.usedTimes === 0) {
                    deleteTexture(texture);
                  }
                } // store references to cache key and WebGLTexture object
                textureProperties.__cacheKey = textureCacheKey;
                textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
              }
              return forceUpload;
            }
            function uploadTexture(textureProperties, texture, slot) {
              var textureType = 3553;
              if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = 35866;
              if (texture.isData3DTexture) textureType = 32879;
              var forceUpload = initTexture(textureProperties, texture);
              var source = texture.source;
              state.bindTexture(textureType, textureProperties.__webglTexture, 33984 + slot);
              var sourceProperties = properties.get(source);
              if (source.version !== sourceProperties.__version || forceUpload === true) {
                state.activeTexture(33984 + slot);
                _gl.pixelStorei(37440, texture.flipY);
                _gl.pixelStorei(37441, texture.premultiplyAlpha);
                _gl.pixelStorei(3317, texture.unpackAlignment);
                _gl.pixelStorei(37443, 0);
                var needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
                var image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
                image = verifyColorSpace(texture, image);
                var supportsMips = isPowerOfTwo$1(image) || isWebGL2,
                  glFormat = utils.convert(texture.format, texture.encoding);
                var glType = utils.convert(texture.type),
                  glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
                setTextureParameters(textureType, texture, supportsMips);
                var mipmap;
                var mipmaps = texture.mipmaps;
                var useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
                var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
                var levels = getMipLevels(texture, image, supportsMips);
                if (texture.isDepthTexture) {
                  // populate depth texture with dummy data
                  glInternalFormat = 6402;
                  if (isWebGL2) {
                    if (texture.type === _FloatType) {
                      glInternalFormat = 36012;
                    } else if (texture.type === _UnsignedIntType) {
                      glInternalFormat = 33190;
                    } else if (texture.type === _UnsignedInt248Type) {
                      glInternalFormat = 35056;
                    } else {
                      glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
                    }
                  } else {
                    if (texture.type === _FloatType) {
                      console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
                    }
                  } // validation checks for WebGL 1
                  if (texture.format === _DepthFormat && glInternalFormat === 6402) {
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== _UnsignedShortType && texture.type !== _UnsignedIntType) {
                      console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                      texture.type = _UnsignedIntType;
                      glType = utils.convert(texture.type);
                    }
                  }
                  if (texture.format === _DepthStencilFormat && glInternalFormat === 6402) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = 34041; // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== _UnsignedInt248Type) {
                      console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                      texture.type = _UnsignedInt248Type;
                      glType = utils.convert(texture.type);
                    }
                  } //
                  if (allocateMemory) {
                    if (useTexStorage) {
                      state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
                    } else {
                      state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                    }
                  }
                } else if (texture.isDataTexture) {
                  // use manually created mipmaps if available
                  // if there are no manual mipmaps
                  // set 0 level mipmap and then use GL to generate other mipmap levels
                  if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) {
                      state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    }
                    for (var i = 0, il = mipmaps.length; i < il; i++) {
                      mipmap = mipmaps[i];
                      if (useTexStorage) {
                        state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                      } else {
                        state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                      }
                    }
                    texture.generateMipmaps = false;
                  } else {
                    if (useTexStorage) {
                      if (allocateMemory) {
                        state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                      }
                      state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                    } else {
                      state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
                    }
                  }
                } else if (texture.isCompressedTexture) {
                  if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) {
                      state.texStorage3D(35866, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    }
                    for (var _i37 = 0, _il9 = mipmaps.length; _i37 < _il9; _i37++) {
                      mipmap = mipmaps[_i37];
                      if (texture.format !== _RGBAFormat) {
                        if (glFormat !== null) {
                          if (useTexStorage) {
                            state.compressedTexSubImage3D(35866, _i37, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                          } else {
                            state.compressedTexImage3D(35866, _i37, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                          }
                        } else {
                          console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        }
                      } else {
                        if (useTexStorage) {
                          state.texSubImage3D(35866, _i37, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        } else {
                          state.texImage3D(35866, _i37, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                      }
                    }
                  } else {
                    if (useTexStorage && allocateMemory) {
                      state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    }
                    for (var _i38 = 0, _il10 = mipmaps.length; _i38 < _il10; _i38++) {
                      mipmap = mipmaps[_i38];
                      if (texture.format !== _RGBAFormat) {
                        if (glFormat !== null) {
                          if (useTexStorage) {
                            state.compressedTexSubImage2D(3553, _i38, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                          } else {
                            state.compressedTexImage2D(3553, _i38, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                          }
                        } else {
                          console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        }
                      } else {
                        if (useTexStorage) {
                          state.texSubImage2D(3553, _i38, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else {
                          state.texImage2D(3553, _i38, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                      }
                    }
                  }
                } else if (texture.isDataArrayTexture) {
                  if (useTexStorage) {
                    if (allocateMemory) {
                      state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                    }
                    state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                  } else {
                    state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
                  }
                } else if (texture.isData3DTexture) {
                  if (useTexStorage) {
                    if (allocateMemory) {
                      state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                    }
                    state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                  } else {
                    state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
                  }
                } else if (texture.isFramebufferTexture) {
                  if (allocateMemory) {
                    if (useTexStorage) {
                      state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    } else {
                      var width = image.width,
                        height = image.height;
                      for (var _i39 = 0; _i39 < levels; _i39++) {
                        state.texImage2D(3553, _i39, glInternalFormat, width, height, 0, glFormat, glType, null);
                        width >>= 1;
                        height >>= 1;
                      }
                    }
                  }
                } else {
                  // regular Texture (image, video, canvas)
                  // use manually created mipmaps if available
                  // if there are no manual mipmaps
                  // set 0 level mipmap and then use GL to generate other mipmap levels
                  if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) {
                      state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    }
                    for (var _i40 = 0, _il11 = mipmaps.length; _i40 < _il11; _i40++) {
                      mipmap = mipmaps[_i40];
                      if (useTexStorage) {
                        state.texSubImage2D(3553, _i40, 0, 0, glFormat, glType, mipmap);
                      } else {
                        state.texImage2D(3553, _i40, glInternalFormat, glFormat, glType, mipmap);
                      }
                    }
                    texture.generateMipmaps = false;
                  } else {
                    if (useTexStorage) {
                      if (allocateMemory) {
                        state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                      }
                      state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
                    } else {
                      state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
                    }
                  }
                }
                if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                  generateMipmap(textureType);
                }
                sourceProperties.__version = source.version;
                if (texture.onUpdate) texture.onUpdate(texture);
              }
              textureProperties.__version = texture.version;
            }
            function uploadCubeTexture(textureProperties, texture, slot) {
              if (texture.image.length !== 6) return;
              var forceUpload = initTexture(textureProperties, texture);
              var source = texture.source;
              state.bindTexture(34067, textureProperties.__webglTexture, 33984 + slot);
              var sourceProperties = properties.get(source);
              if (source.version !== sourceProperties.__version || forceUpload === true) {
                state.activeTexture(33984 + slot);
                _gl.pixelStorei(37440, texture.flipY);
                _gl.pixelStorei(37441, texture.premultiplyAlpha);
                _gl.pixelStorei(3317, texture.unpackAlignment);
                _gl.pixelStorei(37443, 0);
                var isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
                var isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
                var cubeImage = [];
                for (var i = 0; i < 6; i++) {
                  if (!isCompressed && !isDataTexture) {
                    cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                  } else {
                    cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                  }
                  cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
                }
                var image = cubeImage[0],
                  supportsMips = isPowerOfTwo$1(image) || isWebGL2,
                  glFormat = utils.convert(texture.format, texture.encoding),
                  glType = utils.convert(texture.type),
                  glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                var useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
                var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
                var levels = getMipLevels(texture, image, supportsMips);
                setTextureParameters(34067, texture, supportsMips);
                var mipmaps;
                if (isCompressed) {
                  if (useTexStorage && allocateMemory) {
                    state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
                  }
                  for (var _i41 = 0; _i41 < 6; _i41++) {
                    mipmaps = cubeImage[_i41].mipmaps;
                    for (var j = 0; j < mipmaps.length; j++) {
                      var mipmap = mipmaps[j];
                      if (texture.format !== _RGBAFormat) {
                        if (glFormat !== null) {
                          if (useTexStorage) {
                            state.compressedTexSubImage2D(34069 + _i41, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                          } else {
                            state.compressedTexImage2D(34069 + _i41, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                          }
                        } else {
                          console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        }
                      } else {
                        if (useTexStorage) {
                          state.texSubImage2D(34069 + _i41, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else {
                          state.texImage2D(34069 + _i41, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                      }
                    }
                  }
                } else {
                  mipmaps = texture.mipmaps;
                  if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                  }
                  for (var _i42 = 0; _i42 < 6; _i42++) {
                    if (isDataTexture) {
                      if (useTexStorage) {
                        state.texSubImage2D(34069 + _i42, 0, 0, 0, cubeImage[_i42].width, cubeImage[_i42].height, glFormat, glType, cubeImage[_i42].data);
                      } else {
                        state.texImage2D(34069 + _i42, 0, glInternalFormat, cubeImage[_i42].width, cubeImage[_i42].height, 0, glFormat, glType, cubeImage[_i42].data);
                      }
                      for (var _j3 = 0; _j3 < mipmaps.length; _j3++) {
                        var _mipmap = mipmaps[_j3];
                        var mipmapImage = _mipmap.image[_i42].image;
                        if (useTexStorage) {
                          state.texSubImage2D(34069 + _i42, _j3 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else {
                          state.texImage2D(34069 + _i42, _j3 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                        }
                      }
                    } else {
                      if (useTexStorage) {
                        state.texSubImage2D(34069 + _i42, 0, 0, 0, glFormat, glType, cubeImage[_i42]);
                      } else {
                        state.texImage2D(34069 + _i42, 0, glInternalFormat, glFormat, glType, cubeImage[_i42]);
                      }
                      for (var _j4 = 0; _j4 < mipmaps.length; _j4++) {
                        var _mipmap2 = mipmaps[_j4];
                        if (useTexStorage) {
                          state.texSubImage2D(34069 + _i42, _j4 + 1, 0, 0, glFormat, glType, _mipmap2.image[_i42]);
                        } else {
                          state.texImage2D(34069 + _i42, _j4 + 1, glInternalFormat, glFormat, glType, _mipmap2.image[_i42]);
                        }
                      }
                    }
                  }
                }
                if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                  // We assume images for cube map have the same size.
                  generateMipmap(34067);
                }
                sourceProperties.__version = source.version;
                if (texture.onUpdate) texture.onUpdate(texture);
              }
              textureProperties.__version = texture.version;
            } // Render targets
            // Setup storage for target texture and bind it to correct framebuffer
            function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
              var glFormat = utils.convert(texture.format, texture.encoding);
              var glType = utils.convert(texture.type);
              var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
              var renderTargetProperties = properties.get(renderTarget);
              if (!renderTargetProperties.__hasExternalTextures) {
                if (textureTarget === 32879 || textureTarget === 35866) {
                  state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
                } else {
                  state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
                }
              }
              state.bindFramebuffer(36160, framebuffer);
              if (useMultisampledRTT(renderTarget)) {
                multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
              } else if (textureTarget === 3553 || textureTarget >= 34069 && textureTarget <= 34074) {
                // see #24753
                _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
              }
              state.bindFramebuffer(36160, null);
            } // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
            function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
              _gl.bindRenderbuffer(36161, renderbuffer);
              if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
                var glInternalFormat = 33189;
                if (isMultisample || useMultisampledRTT(renderTarget)) {
                  var depthTexture = renderTarget.depthTexture;
                  if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === _FloatType) {
                      glInternalFormat = 36012;
                    } else if (depthTexture.type === _UnsignedIntType) {
                      glInternalFormat = 33190;
                    }
                  }
                  var samples = getRenderTargetSamples(renderTarget);
                  if (useMultisampledRTT(renderTarget)) {
                    multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                  } else {
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                  }
                } else {
                  _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
                }
                _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
              } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
                var _samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) {
                  _gl.renderbufferStorageMultisample(36161, _samples, 35056, renderTarget.width, renderTarget.height);
                } else if (useMultisampledRTT(renderTarget)) {
                  multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, _samples, 35056, renderTarget.width, renderTarget.height);
                } else {
                  _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
                }
                _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
              } else {
                var textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];
                for (var i = 0; i < textures.length; i++) {
                  var texture = textures[i];
                  var glFormat = utils.convert(texture.format, texture.encoding);
                  var glType = utils.convert(texture.type);
                  var _glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                  var _samples2 = getRenderTargetSamples(renderTarget);
                  if (isMultisample && useMultisampledRTT(renderTarget) === false) {
                    _gl.renderbufferStorageMultisample(36161, _samples2, _glInternalFormat, renderTarget.width, renderTarget.height);
                  } else if (useMultisampledRTT(renderTarget)) {
                    multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, _samples2, _glInternalFormat, renderTarget.width, renderTarget.height);
                  } else {
                    _gl.renderbufferStorage(36161, _glInternalFormat, renderTarget.width, renderTarget.height);
                  }
                }
              }
              _gl.bindRenderbuffer(36161, null);
            } // Setup resources for a Depth Texture for a FBO (needs an extension)
            function setupDepthTexture(framebuffer, renderTarget) {
              var isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
              if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
              state.bindFramebuffer(36160, framebuffer);
              if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
                throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
              } // upload an empty depth texture with framebuffer size
              if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
                renderTarget.depthTexture.image.width = renderTarget.width;
                renderTarget.depthTexture.image.height = renderTarget.height;
                renderTarget.depthTexture.needsUpdate = true;
              }
              setTexture2D(renderTarget.depthTexture, 0);
              var webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
              var samples = getRenderTargetSamples(renderTarget);
              if (renderTarget.depthTexture.format === _DepthFormat) {
                if (useMultisampledRTT(renderTarget)) {
                  multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
                } else {
                  _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
                }
              } else if (renderTarget.depthTexture.format === _DepthStencilFormat) {
                if (useMultisampledRTT(renderTarget)) {
                  multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
                } else {
                  _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
                }
              } else {
                throw new Error('Unknown depthTexture format');
              }
            } // Setup GL resources for a non-texture depth buffer
            function setupDepthRenderbuffer(renderTarget) {
              var renderTargetProperties = properties.get(renderTarget);
              var isCube = renderTarget.isWebGLCubeRenderTarget === true;
              if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
                if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
                setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
              } else {
                if (isCube) {
                  renderTargetProperties.__webglDepthbuffer = [];
                  for (var i = 0; i < 6; i++) {
                    state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                  }
                } else {
                  state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                  renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                  setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
                }
              }
              state.bindFramebuffer(36160, null);
            } // rebind framebuffer with external textures
            function rebindTextures(renderTarget, colorTexture, depthTexture) {
              var renderTargetProperties = properties.get(renderTarget);
              if (colorTexture !== undefined) {
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
              }
              if (depthTexture !== undefined) {
                setupDepthRenderbuffer(renderTarget);
              }
            } // Set up GL resources for the render target
            function setupRenderTarget(renderTarget) {
              var texture = renderTarget.texture;
              var renderTargetProperties = properties.get(renderTarget);
              var textureProperties = properties.get(texture);
              renderTarget.addEventListener('dispose', onRenderTargetDispose);
              if (renderTarget.isWebGLMultipleRenderTargets !== true) {
                if (textureProperties.__webglTexture === undefined) {
                  textureProperties.__webglTexture = _gl.createTexture();
                }
                textureProperties.__version = texture.version;
                info.memory.textures++;
              }
              var isCube = renderTarget.isWebGLCubeRenderTarget === true;
              var isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
              var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2; // Setup framebuffer
              if (isCube) {
                renderTargetProperties.__webglFramebuffer = [];
                for (var i = 0; i < 6; i++) {
                  renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
                }
              } else {
                renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
                if (isMultipleRenderTargets) {
                  if (capabilities.drawBuffers) {
                    var textures = renderTarget.texture;
                    for (var _i43 = 0, il = textures.length; _i43 < il; _i43++) {
                      var attachmentProperties = properties.get(textures[_i43]);
                      if (attachmentProperties.__webglTexture === undefined) {
                        attachmentProperties.__webglTexture = _gl.createTexture();
                        info.memory.textures++;
                      }
                    }
                  } else {
                    console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
                  }
                }
                if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                  var _textures = isMultipleRenderTargets ? texture : [texture];
                  renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                  renderTargetProperties.__webglColorRenderbuffer = [];
                  state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                  for (var _i44 = 0; _i44 < _textures.length; _i44++) {
                    var _texture = _textures[_i44];
                    renderTargetProperties.__webglColorRenderbuffer[_i44] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer[_i44]);
                    var glFormat = utils.convert(_texture.format, _texture.encoding);
                    var glType = utils.convert(_texture.type);
                    var glInternalFormat = getInternalFormat(_texture.internalFormat, glFormat, glType, _texture.encoding, renderTarget.isXRRenderTarget === true);
                    var samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(36160, 36064 + _i44, 36161, renderTargetProperties.__webglColorRenderbuffer[_i44]);
                  }
                  _gl.bindRenderbuffer(36161, null);
                  if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                  }
                  state.bindFramebuffer(36160, null);
                }
              } // Setup color buffer
              if (isCube) {
                state.bindTexture(34067, textureProperties.__webglTexture);
                setTextureParameters(34067, texture, supportsMips);
                for (var _i45 = 0; _i45 < 6; _i45++) {
                  setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[_i45], renderTarget, texture, 36064, 34069 + _i45);
                }
                if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                  generateMipmap(34067);
                }
                state.unbindTexture();
              } else if (isMultipleRenderTargets) {
                var _textures2 = renderTarget.texture;
                for (var _i46 = 0, _il12 = _textures2.length; _i46 < _il12; _i46++) {
                  var attachment = _textures2[_i46];
                  var _attachmentProperties = properties.get(attachment);
                  state.bindTexture(3553, _attachmentProperties.__webglTexture);
                  setTextureParameters(3553, attachment, supportsMips);
                  setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + _i46, 3553);
                  if (textureNeedsGenerateMipmaps(attachment, supportsMips)) {
                    generateMipmap(3553);
                  }
                }
                state.unbindTexture();
              } else {
                var glTextureType = 3553;
                if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                  if (isWebGL2) {
                    glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
                  } else {
                    console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
                  }
                }
                state.bindTexture(glTextureType, textureProperties.__webglTexture);
                setTextureParameters(glTextureType, texture, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
                if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                  generateMipmap(glTextureType);
                }
                state.unbindTexture();
              } // Setup depth and stencil buffers
              if (renderTarget.depthBuffer) {
                setupDepthRenderbuffer(renderTarget);
              }
            }
            function updateRenderTargetMipmap(renderTarget) {
              var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
              var textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];
              for (var i = 0, il = textures.length; i < il; i++) {
                var texture = textures[i];
                if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                  var target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                  var webglTexture = properties.get(texture).__webglTexture;
                  state.bindTexture(target, webglTexture);
                  generateMipmap(target);
                  state.unbindTexture();
                }
              }
            }
            function updateMultisampleRenderTarget(renderTarget) {
              if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                var textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [renderTarget.texture];
                var width = renderTarget.width;
                var height = renderTarget.height;
                var mask = 16384;
                var invalidationArray = [];
                var depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
                var renderTargetProperties = properties.get(renderTarget);
                var isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true; // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) {
                  for (var i = 0; i < textures.length; i++) {
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, null);
                    state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(36009, 36064 + i, 3553, null, 0);
                  }
                }
                state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                for (var _i47 = 0; _i47 < textures.length; _i47++) {
                  invalidationArray.push(36064 + _i47);
                  if (renderTarget.depthBuffer) {
                    invalidationArray.push(depthStyle);
                  }
                  var ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                  if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                  }
                  if (isMultipleRenderTargets) {
                    _gl.framebufferRenderbuffer(36008, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer[_i47]);
                  }
                  if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(36008, [depthStyle]);
                    _gl.invalidateFramebuffer(36009, [depthStyle]);
                  }
                  if (isMultipleRenderTargets) {
                    var webglTexture = properties.get(textures[_i47]).__webglTexture;
                    _gl.framebufferTexture2D(36009, 36064, 3553, webglTexture, 0);
                  }
                  _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                  if (supportsInvalidateFramebuffer) {
                    _gl.invalidateFramebuffer(36008, invalidationArray);
                  }
                }
                state.bindFramebuffer(36008, null);
                state.bindFramebuffer(36009, null); // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) {
                  for (var _i48 = 0; _i48 < textures.length; _i48++) {
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064 + _i48, 36161, renderTargetProperties.__webglColorRenderbuffer[_i48]);
                    var _webglTexture = properties.get(textures[_i48]).__webglTexture;
                    state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(36009, 36064 + _i48, 3553, _webglTexture, 0);
                  }
                }
                state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
              }
            }
            function getRenderTargetSamples(renderTarget) {
              return Math.min(maxSamples, renderTarget.samples);
            }
            function useMultisampledRTT(renderTarget) {
              var renderTargetProperties = properties.get(renderTarget);
              return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
            }
            function updateVideoTexture(texture) {
              var frame = info.render.frame; // Check the last frame we updated the VideoTexture
              if (_videoTextures.get(texture) !== frame) {
                _videoTextures.set(texture, frame);
                texture.update();
              }
            }
            function verifyColorSpace(texture, image) {
              var encoding = texture.encoding;
              var format = texture.format;
              var type = texture.type;
              if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === _SRGBAFormat2) return image;
              if (encoding !== _LinearEncoding) {
                // sRGB
                if (encoding === _sRGBEncoding) {
                  if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has('EXT_sRGB') === true && format === _RGBAFormat) {
                      texture.format = _SRGBAFormat2; // it's not possible to generate mips in WebGL 1 with this extension
                      texture.minFilter = _LinearFilter;
                      texture.generateMipmaps = false;
                    } else {
                      // slow fallback (CPU decode)
                      image = _ImageUtils.sRGBToLinear(image);
                    }
                  } else {
                    // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                    if (format !== _RGBAFormat || type !== _UnsignedByteType) {
                      console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
                    }
                  }
                } else {
                  console.error('THREE.WebGLTextures: Unsupported texture encoding:', encoding);
                }
              }
              return image;
            } //
            this.allocateTextureUnit = allocateTextureUnit;
            this.resetTextureUnits = resetTextureUnits;
            this.setTexture2D = setTexture2D;
            this.setTexture2DArray = setTexture2DArray;
            this.setTexture3D = setTexture3D;
            this.setTextureCube = setTextureCube;
            this.rebindTextures = rebindTextures;
            this.setupRenderTarget = setupRenderTarget;
            this.updateRenderTargetMipmap = updateRenderTargetMipmap;
            this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
            this.setupDepthRenderbuffer = setupDepthRenderbuffer;
            this.setupFrameBufferTexture = setupFrameBufferTexture;
            this.useMultisampledRTT = useMultisampledRTT;
          }
          function _WebGLUtils(gl, extensions, capabilities) {
            var isWebGL2 = capabilities.isWebGL2;
            function convert(p) {
              var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var extension;
              if (p === _UnsignedByteType) return 5121;
              if (p === _UnsignedShort4444Type) return 32819;
              if (p === _UnsignedShort5551Type) return 32820;
              if (p === _ByteType) return 5120;
              if (p === _ShortType) return 5122;
              if (p === _UnsignedShortType) return 5123;
              if (p === _IntType) return 5124;
              if (p === _UnsignedIntType) return 5125;
              if (p === _FloatType) return 5126;
              if (p === _HalfFloatType) {
                if (isWebGL2) return 5131;
                extension = extensions.get('OES_texture_half_float');
                if (extension !== null) {
                  return extension.HALF_FLOAT_OES;
                } else {
                  return null;
                }
              }
              if (p === _AlphaFormat) return 6406;
              if (p === _RGBAFormat) return 6408;
              if (p === _LuminanceFormat) return 6409;
              if (p === _LuminanceAlphaFormat) return 6410;
              if (p === _DepthFormat) return 6402;
              if (p === _DepthStencilFormat) return 34041; // @deprecated since r137
              if (p === _RGBFormat) {
                console.warn('THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228');
                return 6408;
              } // WebGL 1 sRGB fallback
              if (p === _SRGBAFormat2) {
                extension = extensions.get('EXT_sRGB');
                if (extension !== null) {
                  return extension.SRGB_ALPHA_EXT;
                } else {
                  return null;
                }
              } // WebGL2 formats.
              if (p === _RedFormat) return 6403;
              if (p === _RedIntegerFormat) return 36244;
              if (p === _RGFormat) return 33319;
              if (p === _RGIntegerFormat) return 33320;
              if (p === _RGBAIntegerFormat) return 36249; // S3TC
              if (p === _RGB_S3TC_DXT1_Format || p === _RGBA_S3TC_DXT1_Format || p === _RGBA_S3TC_DXT3_Format || p === _RGBA_S3TC_DXT5_Format) {
                if (encoding === _sRGBEncoding) {
                  extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                  if (extension !== null) {
                    if (p === _RGB_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === _RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === _RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === _RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                  } else {
                    return null;
                  }
                } else {
                  extension = extensions.get('WEBGL_compressed_texture_s3tc');
                  if (extension !== null) {
                    if (p === _RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === _RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === _RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === _RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                  } else {
                    return null;
                  }
                }
              } // PVRTC
              if (p === _RGB_PVRTC_4BPPV1_Format || p === _RGB_PVRTC_2BPPV1_Format || p === _RGBA_PVRTC_4BPPV1_Format || p === _RGBA_PVRTC_2BPPV1_Format) {
                extension = extensions.get('WEBGL_compressed_texture_pvrtc');
                if (extension !== null) {
                  if (p === _RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                  if (p === _RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                  if (p === _RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                  if (p === _RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                } else {
                  return null;
                }
              } // ETC1
              if (p === _RGB_ETC1_Format) {
                extension = extensions.get('WEBGL_compressed_texture_etc1');
                if (extension !== null) {
                  return extension.COMPRESSED_RGB_ETC1_WEBGL;
                } else {
                  return null;
                }
              } // ETC2
              if (p === _RGB_ETC2_Format || p === _RGBA_ETC2_EAC_Format) {
                extension = extensions.get('WEBGL_compressed_texture_etc');
                if (extension !== null) {
                  if (p === _RGB_ETC2_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                  if (p === _RGBA_ETC2_EAC_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                } else {
                  return null;
                }
              } // ASTC
              if (p === _RGBA_ASTC_4x4_Format || p === _RGBA_ASTC_5x4_Format || p === _RGBA_ASTC_5x5_Format || p === _RGBA_ASTC_6x5_Format || p === _RGBA_ASTC_6x6_Format || p === _RGBA_ASTC_8x5_Format || p === _RGBA_ASTC_8x6_Format || p === _RGBA_ASTC_8x8_Format || p === _RGBA_ASTC_10x5_Format || p === _RGBA_ASTC_10x6_Format || p === _RGBA_ASTC_10x8_Format || p === _RGBA_ASTC_10x10_Format || p === _RGBA_ASTC_12x10_Format || p === _RGBA_ASTC_12x12_Format) {
                extension = extensions.get('WEBGL_compressed_texture_astc');
                if (extension !== null) {
                  if (p === _RGBA_ASTC_4x4_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                  if (p === _RGBA_ASTC_5x4_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                  if (p === _RGBA_ASTC_5x5_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                  if (p === _RGBA_ASTC_6x5_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                  if (p === _RGBA_ASTC_6x6_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                  if (p === _RGBA_ASTC_8x5_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                  if (p === _RGBA_ASTC_8x6_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                  if (p === _RGBA_ASTC_8x8_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                  if (p === _RGBA_ASTC_10x5_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                  if (p === _RGBA_ASTC_10x6_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                  if (p === _RGBA_ASTC_10x8_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                  if (p === _RGBA_ASTC_10x10_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                  if (p === _RGBA_ASTC_12x10_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                  if (p === _RGBA_ASTC_12x12_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
                } else {
                  return null;
                }
              } // BPTC
              if (p === _RGBA_BPTC_Format) {
                extension = extensions.get('EXT_texture_compression_bptc');
                if (extension !== null) {
                  if (p === _RGBA_BPTC_Format) return encoding === _sRGBEncoding ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                } else {
                  return null;
                }
              } //
              if (p === _UnsignedInt248Type) {
                if (isWebGL2) return 34042;
                extension = extensions.get('WEBGL_depth_texture');
                if (extension !== null) {
                  return extension.UNSIGNED_INT_24_8_WEBGL;
                } else {
                  return null;
                }
              } // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
              return gl[p] !== undefined ? gl[p] : null;
            }
            return {
              convert: convert
            };
          }
          var _Group = /*#__PURE__*/function (_Object3D5) {
            _inherits(_Group, _Object3D5);
            var _super44 = _createSuper(_Group);
            function _Group() {
              var _this36;
              _classCallCheck2(this, _Group);
              _this36 = _super44.call(this);
              _this36.isGroup = true;
              _this36.type = 'Group';
              return _this36;
            }
            return _createClass2(_Group);
          }(_Object3D);
          var _ArrayCamera = /*#__PURE__*/function (_PerspectiveCamera2) {
            _inherits(_ArrayCamera, _PerspectiveCamera2);
            var _super45 = _createSuper(_ArrayCamera);
            function _ArrayCamera() {
              var _this37;
              var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              _classCallCheck2(this, _ArrayCamera);
              _this37 = _super45.call(this);
              _this37.isArrayCamera = true;
              _this37.cameras = array;
              return _this37;
            }
            return _createClass2(_ArrayCamera);
          }(_PerspectiveCamera);
          /**
          * @author jsantell / https://www.jsantell.com/
          * @author mrdoob / http://mrdoob.com/
          */
          var cameraLPos = new _Vector2();
          var cameraRPos = new _Vector2(); /**
                                           * Assumes 2 cameras that are parallel and share an X-axis, and that
                                           * the cameras' projection and world matrices have already been set.
                                           * And that near and far planes are identical for both cameras.
                                           * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
                                           */
          function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            var ipd = cameraLPos.distanceTo(cameraRPos);
            var projL = cameraL.projectionMatrix.elements;
            var projR = cameraR.projectionMatrix.elements; // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            var near = projL[14] / (projL[10] - 1);
            var far = projL[14] / (projL[10] + 1);
            var topFov = (projL[9] + 1) / projL[5];
            var bottomFov = (projL[9] - 1) / projL[5];
            var leftFov = (projL[8] - 1) / projL[0];
            var rightFov = (projR[8] + 1) / projR[0];
            var left = near * leftFov;
            var right = near * rightFov; // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            var zOffset = ipd / (-leftFov + rightFov);
            var xOffset = zOffset * -leftFov; // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert(); // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            var near2 = near + zOffset;
            var far2 = far + zOffset;
            var left2 = left - xOffset;
            var right2 = right + (ipd - xOffset);
            var top2 = topFov * far / far2 * near2;
            var bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
          } /**
            * @author mrdoob / http://mrdoob.com/
            */
          function WebVRManager(renderer) {
            var renderWidth, renderHeight;
            var scope = this;
            var device = null;
            var frameData = null;
            var poseTarget = null;
            var controllers = [];
            var standingMatrix = new _Matrix2();
            var standingMatrixInverse = new _Matrix2();
            var framebufferScaleFactor = 1.0;
            var referenceSpaceType = 'local-floor';
            if (typeof window !== 'undefined' && 'VRFrameData' in window) {
              frameData = new window.VRFrameData();
              window.addEventListener('vrdisplaypresentchange', onVRDisplayPresentChange, false);
            }
            var matrixWorldInverse = new _Matrix2();
            var tempQuaternion = new _Quaternion();
            var tempPosition = new _Vector2();
            var cameraL = new _PerspectiveCamera();
            cameraL.viewport = new _Vector3();
            cameraL.layers.enable(1);
            var cameraR = new _PerspectiveCamera();
            cameraR.viewport = new _Vector3();
            cameraR.layers.enable(2);
            var cameraVR = new _ArrayCamera([cameraL, cameraR]);
            cameraVR.layers.enable(1);
            cameraVR.layers.enable(2);
            var currentSize = new _Vector(),
              currentPixelRatio;
            function onVRDisplayPresentChange() {
              var isPresenting = scope.isPresenting = device !== null && device.isPresenting === true;
              if (isPresenting) {
                var eyeParameters = device.getEyeParameters('left');
                renderWidth = 2 * eyeParameters.renderWidth * framebufferScaleFactor;
                renderHeight = eyeParameters.renderHeight * framebufferScaleFactor;
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                renderer.setDrawingBufferSize(renderWidth, renderHeight, 1);
                cameraL.viewport.set(0, 0, renderWidth / 2, renderHeight);
                cameraR.viewport.set(renderWidth / 2, 0, renderWidth / 2, renderHeight);
                animation.start();
                scope.dispatchEvent({
                  type: 'sessionstart'
                });
              } else {
                if (scope.enabled) {
                  renderer.setDrawingBufferSize(currentSize.width, currentSize.height, currentPixelRatio);
                }
                animation.stop();
                scope.dispatchEvent({
                  type: 'sessionend'
                });
              }
            } //
            var triggers = [];
            var grips = [];
            function findGamepad(id) {
              var gamepads = navigator.getGamepads && navigator.getGamepads();
              for (var i = 0, l = gamepads.length; i < l; i++) {
                var gamepad = gamepads[i];
                if (gamepad && (gamepad.id === 'Daydream Controller' || gamepad.id === 'Gear VR Controller' || gamepad.id === 'Oculus Go Controller' || gamepad.id === 'OpenVR Gamepad' || gamepad.id.startsWith('Oculus Touch') || gamepad.id.startsWith('HTC Vive Focus') || gamepad.id.startsWith('Spatial Controller'))) {
                  var hand = gamepad.hand;
                  if (id === 0 && (hand === '' || hand === 'right')) return gamepad;
                  if (id === 1 && hand === 'left') return gamepad;
                }
              }
            }
            function updateControllers() {
              for (var i = 0; i < controllers.length; i++) {
                var controller = controllers[i];
                var gamepad = findGamepad(i);
                if (gamepad !== undefined && gamepad.pose !== undefined) {
                  if (gamepad.pose === null) return; // Pose
                  var pose = gamepad.pose;
                  if (pose.hasPosition === false) controller.position.set(0.2, -0.6, -0.05);
                  if (pose.position !== null) controller.position.fromArray(pose.position);
                  if (pose.orientation !== null) controller.quaternion.fromArray(pose.orientation);
                  controller.matrix.compose(controller.position, controller.quaternion, controller.scale);
                  controller.matrix.premultiply(standingMatrix);
                  controller.matrix.decompose(controller.position, controller.quaternion, controller.scale);
                  controller.matrixWorldNeedsUpdate = true;
                  controller.visible = true; // Trigger
                  var buttonId = gamepad.id === 'Daydream Controller' ? 0 : 1;
                  if (triggers[i] === undefined) triggers[i] = false;
                  if (triggers[i] !== gamepad.buttons[buttonId].pressed) {
                    triggers[i] = gamepad.buttons[buttonId].pressed;
                    if (triggers[i] === true) {
                      controller.dispatchEvent({
                        type: 'selectstart'
                      });
                    } else {
                      controller.dispatchEvent({
                        type: 'selectend'
                      });
                      controller.dispatchEvent({
                        type: 'select'
                      });
                    }
                  } // Grip
                  buttonId = 2;
                  if (grips[i] === undefined) grips[i] = false; // Skip if the grip button doesn't exist on this controller
                  if (gamepad.buttons[buttonId] !== undefined) {
                    if (grips[i] !== gamepad.buttons[buttonId].pressed) {
                      grips[i] = gamepad.buttons[buttonId].pressed;
                      if (grips[i] === true) {
                        controller.dispatchEvent({
                          type: 'squeezestart'
                        });
                      } else {
                        controller.dispatchEvent({
                          type: 'squeezeend'
                        });
                        controller.dispatchEvent({
                          type: 'squeeze'
                        });
                      }
                    }
                  }
                } else {
                  controller.visible = false;
                }
              }
            }
            function updateViewportFromBounds(viewport, bounds) {
              if (bounds !== null && bounds.length === 4) {
                viewport.set(bounds[0] * renderWidth, bounds[1] * renderHeight, bounds[2] * renderWidth, bounds[3] * renderHeight);
              }
            } //
            this.enabled = false;
            this.getController = function (id) {
              var controller = controllers[id];
              if (controller === undefined) {
                controller = new _Group();
                controller.matrixAutoUpdate = false;
                controller.visible = false;
                controllers[id] = controller;
              }
              return controller;
            };
            this.getDevice = function () {
              return device;
            };
            this.setDevice = function (value) {
              if (value !== undefined) device = value;
              animation.setContext(value);
            };
            this.setFramebufferScaleFactor = function (value) {
              framebufferScaleFactor = value;
            };
            this.setReferenceSpaceType = function (value) {
              referenceSpaceType = value;
            };
            this.setPoseTarget = function (object) {
              if (object !== undefined) poseTarget = object;
            }; //
            this.cameraAutoUpdate = true;
            this.updateCamera = function (camera) {
              var userHeight = referenceSpaceType === 'local-floor' ? 1.6 : 0;
              device.depthNear = camera.near;
              device.depthFar = camera.far;
              device.getFrameData(frameData); //
              if (referenceSpaceType === 'local-floor') {
                var stageParameters = device.stageParameters;
                if (stageParameters) {
                  standingMatrix.fromArray(stageParameters.sittingToStandingTransform);
                } else {
                  standingMatrix.makeTranslation(0, userHeight, 0);
                }
              }
              var pose = frameData.pose;
              var poseObject = poseTarget !== null ? poseTarget : camera; // We want to manipulate poseObject by its position and quaternion components since users may rely on them.
              poseObject.matrix.copy(standingMatrix);
              poseObject.matrix.decompose(poseObject.position, poseObject.quaternion, poseObject.scale);
              if (pose.orientation !== null) {
                tempQuaternion.fromArray(pose.orientation);
                poseObject.quaternion.multiply(tempQuaternion);
              }
              if (pose.position !== null) {
                tempQuaternion.setFromRotationMatrix(standingMatrix);
                tempPosition.fromArray(pose.position);
                tempPosition.applyQuaternion(tempQuaternion);
                poseObject.position.add(tempPosition);
              }
              poseObject.updateMatrixWorld();
              var children = poseObject.children;
              for (var i = 0, l = children.length; i < l; i++) {
                children[i].updateMatrixWorld(true);
              } //
              cameraL.near = camera.near;
              cameraR.near = camera.near;
              cameraL.far = camera.far;
              cameraR.far = camera.far;
              cameraL.matrixWorldInverse.fromArray(frameData.leftViewMatrix);
              cameraR.matrixWorldInverse.fromArray(frameData.rightViewMatrix); // TODO (mrdoob) Double check this code
              standingMatrixInverse.copy(standingMatrix).invert();
              if (referenceSpaceType === 'local-floor') {
                cameraL.matrixWorldInverse.multiply(standingMatrixInverse);
                cameraR.matrixWorldInverse.multiply(standingMatrixInverse);
              }
              var parent = poseObject.parent;
              if (parent !== null) {
                matrixWorldInverse.copy(parent.matrixWorld).invert();
                cameraL.matrixWorldInverse.multiply(matrixWorldInverse);
                cameraR.matrixWorldInverse.multiply(matrixWorldInverse);
              } // envMap and Mirror needs camera.matrixWorld
              cameraL.matrixWorld.copy(cameraL.matrixWorldInverse).invert();
              cameraR.matrixWorld.copy(cameraR.matrixWorldInverse).invert();
              cameraL.projectionMatrix.fromArray(frameData.leftProjectionMatrix);
              cameraR.projectionMatrix.fromArray(frameData.rightProjectionMatrix);
              setProjectionFromUnion(cameraVR, cameraL, cameraR); //
              var layers = device.getLayers();
              if (layers.length) {
                var layer = layers[0];
                updateViewportFromBounds(cameraL.viewport, layer.leftBounds);
                updateViewportFromBounds(cameraR.viewport, layer.rightBounds);
              }
              updateControllers();
              return cameraVR;
            };
            this.getCamera = function () {
              return cameraVR;
            }; // Dummy getFoveation/setFoveation to have the same API as WebXR
            this.getFoveation = function () {
              return 1;
            };
            this.setFoveation = function (foveation) {
              if (foveation !== 1) {
                console.warn('THREE.WebVRManager: setFoveation() not used in WebVR.');
              }
            }; //
            this.getStandingMatrix = function () {
              return standingMatrix;
            };
            this.isPresenting = false; // Animation Loop
            var animation = new WebGLAnimation();
            this.setAnimationLoop = function (callback) {
              animation.setAnimationLoop(callback);
              if (this.isPresenting) animation.start();
            };
            this.submitFrame = function () {
              if (this.isPresenting) device.submitFrame();
            };
            this.dispose = function () {
              if (typeof window !== 'undefined') {
                window.removeEventListener('vrdisplaypresentchange', onVRDisplayPresentChange);
              }
            }; // DEPRECATED
            this.setFrameOfReferenceType = function () {
              console.warn('THREE.WebVRManager: setFrameOfReferenceType() has been deprecated.');
            };
          }
          Object.assign(WebVRManager.prototype, {
            addEventListener: _EventDispatcher.prototype.addEventListener,
            hasEventListener: _EventDispatcher.prototype.hasEventListener,
            removeEventListener: _EventDispatcher.prototype.removeEventListener,
            dispatchEvent: _EventDispatcher.prototype.dispatchEvent
          });
          var _moveEvent = {
            type: 'move'
          };
          var WebXRController = /*#__PURE__*/function () {
            function WebXRController() {
              _classCallCheck2(this, WebXRController);
              this._targetRay = null;
              this._grip = null;
              this._hand = null;
            }
            _createClass2(WebXRController, [{
              key: "getHandSpace",
              value: function getHandSpace() {
                if (this._hand === null) {
                  this._hand = new _Group();
                  this._hand.matrixAutoUpdate = false;
                  this._hand.visible = false;
                  this._hand.joints = {};
                  this._hand.inputState = {
                    pinching: false
                  };
                }
                return this._hand;
              }
            }, {
              key: "getTargetRaySpace",
              value: function getTargetRaySpace() {
                if (this._targetRay === null) {
                  this._targetRay = new _Group();
                  this._targetRay.matrixAutoUpdate = false;
                  this._targetRay.visible = false;
                  this._targetRay.hasLinearVelocity = false;
                  this._targetRay.linearVelocity = new _Vector2();
                  this._targetRay.hasAngularVelocity = false;
                  this._targetRay.angularVelocity = new _Vector2();
                }
                return this._targetRay;
              }
            }, {
              key: "getGripSpace",
              value: function getGripSpace() {
                if (this._grip === null) {
                  this._grip = new _Group();
                  this._grip.matrixAutoUpdate = false;
                  this._grip.visible = false;
                  this._grip.hasLinearVelocity = false;
                  this._grip.linearVelocity = new _Vector2();
                  this._grip.hasAngularVelocity = false;
                  this._grip.angularVelocity = new _Vector2();
                }
                return this._grip;
              }
            }, {
              key: "dispatchEvent",
              value: function dispatchEvent(event) {
                if (this._targetRay !== null) {
                  this._targetRay.dispatchEvent(event);
                }
                if (this._grip !== null) {
                  this._grip.dispatchEvent(event);
                }
                if (this._hand !== null) {
                  this._hand.dispatchEvent(event);
                }
                return this;
              }
            }, {
              key: "connect",
              value: function connect(inputSource) {
                if (inputSource && inputSource.hand) {
                  var hand = this._hand;
                  if (hand) {
                    var _iterator6 = _createForOfIteratorHelper2(inputSource.hand.values()),
                      _step6;
                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var inputjoint = _step6.value;
                        // Initialize hand with joints when connected
                        this._getHandJoint(hand, inputjoint);
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                  }
                }
                this.dispatchEvent({
                  type: 'connected',
                  data: inputSource
                });
                return this;
              }
            }, {
              key: "disconnect",
              value: function disconnect(inputSource) {
                this.dispatchEvent({
                  type: 'disconnected',
                  data: inputSource
                });
                if (this._targetRay !== null) {
                  this._targetRay.visible = false;
                }
                if (this._grip !== null) {
                  this._grip.visible = false;
                }
                if (this._hand !== null) {
                  this._hand.visible = false;
                }
                return this;
              }
            }, {
              key: "update",
              value: function update(inputSource, frame, referenceSpace) {
                var inputPose = null;
                var gripPose = null;
                var handPose = null;
                var targetRay = this._targetRay;
                var grip = this._grip;
                var hand = this._hand;
                if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
                  if (hand && inputSource.hand) {
                    handPose = true;
                    var _iterator7 = _createForOfIteratorHelper2(inputSource.hand.values()),
                      _step7;
                    try {
                      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                        var inputjoint = _step7.value;
                        // Update the joints groups with the XRJoint poses
                        var jointPose = frame.getJointPose(inputjoint, referenceSpace); // The transform of this joint will be updated with the joint pose on each frame
                        var joint = this._getHandJoint(hand, inputjoint);
                        if (jointPose !== null) {
                          joint.matrix.fromArray(jointPose.transform.matrix);
                          joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                          joint.jointRadius = jointPose.radius;
                        }
                        joint.visible = jointPose !== null;
                      } // Custom events
                      // Check pinchz
                    } catch (err) {
                      _iterator7.e(err);
                    } finally {
                      _iterator7.f();
                    }
                    var indexTip = hand.joints['index-finger-tip'];
                    var thumbTip = hand.joints['thumb-tip'];
                    var distance = indexTip.position.distanceTo(thumbTip.position);
                    var distanceToPinch = 0.02;
                    var threshold = 0.005;
                    if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                      hand.inputState.pinching = false;
                      this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                      });
                    } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                      hand.inputState.pinching = true;
                      this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                      });
                    }
                  } else {
                    if (grip !== null && inputSource.gripSpace) {
                      gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                      if (gripPose !== null) {
                        grip.matrix.fromArray(gripPose.transform.matrix);
                        grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                        if (gripPose.linearVelocity) {
                          grip.hasLinearVelocity = true;
                          grip.linearVelocity.copy(gripPose.linearVelocity);
                        } else {
                          grip.hasLinearVelocity = false;
                        }
                        if (gripPose.angularVelocity) {
                          grip.hasAngularVelocity = true;
                          grip.angularVelocity.copy(gripPose.angularVelocity);
                        } else {
                          grip.hasAngularVelocity = false;
                        }
                      }
                    }
                  }
                  if (targetRay !== null) {
                    inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace); // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                    if (inputPose === null && gripPose !== null) {
                      inputPose = gripPose;
                    }
                    if (inputPose !== null) {
                      targetRay.matrix.fromArray(inputPose.transform.matrix);
                      targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                      if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                      } else {
                        targetRay.hasLinearVelocity = false;
                      }
                      if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                      } else {
                        targetRay.hasAngularVelocity = false;
                      }
                      this.dispatchEvent(_moveEvent);
                    }
                  }
                }
                if (targetRay !== null) {
                  targetRay.visible = inputPose !== null;
                }
                if (grip !== null) {
                  grip.visible = gripPose !== null;
                }
                if (hand !== null) {
                  hand.visible = handPose !== null;
                }
                return this;
              } // private method
            }, {
              key: "_getHandJoint",
              value: function _getHandJoint(hand, inputjoint) {
                if (hand.joints[inputjoint.jointName] === undefined) {
                  var joint = new _Group();
                  joint.matrixAutoUpdate = false;
                  joint.visible = false;
                  hand.joints[inputjoint.jointName] = joint;
                  hand.add(joint);
                }
                return hand.joints[inputjoint.jointName];
              }
            }]);
            return WebXRController;
          }();
          var _DepthTexture = /*#__PURE__*/function (_Texture5) {
            _inherits(_DepthTexture, _Texture5);
            var _super46 = _createSuper(_DepthTexture);
            function _DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
              var _this38;
              _classCallCheck2(this, _DepthTexture);
              format = format !== undefined ? format : _DepthFormat;
              if (format !== _DepthFormat && format !== _DepthStencilFormat) {
                throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
              }
              if (type === undefined && format === _DepthFormat) type = _UnsignedIntType;
              if (type === undefined && format === _DepthStencilFormat) type = _UnsignedInt248Type;
              _this38 = _super46.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
              _this38.isDepthTexture = true;
              _this38.image = {
                width: width,
                height: height
              };
              _this38.magFilter = magFilter !== undefined ? magFilter : _NearestFilter;
              _this38.minFilter = minFilter !== undefined ? minFilter : _NearestFilter;
              _this38.flipY = false;
              _this38.generateMipmaps = false;
              return _this38;
            }
            return _createClass2(_DepthTexture);
          }(_Texture);
          var WebXRManager = /*#__PURE__*/function (_EventDispatcher7) {
            _inherits(WebXRManager, _EventDispatcher7);
            var _super47 = _createSuper(WebXRManager);
            function WebXRManager(renderer, gl) {
              var _this39;
              _classCallCheck2(this, WebXRManager);
              _this39 = _super47.call(this);
              var scope = _assertThisInitialized(_this39);
              var session = null;
              var framebufferScaleFactor = 1.0;
              var poseTarget = null;
              var referenceSpace = null;
              var referenceSpaceType = 'local-floor';
              var customReferenceSpace = null;
              var pose = null;
              var layers = [];
              var glBinding = null;
              var glProjLayer = null;
              var glBaseLayer = null;
              var xrFrame = null;
              var attributes = gl.getContextAttributes();
              var initialRenderTarget = null;
              var newRenderTarget = null;
              var controllers = [];
              var controllerInputSources = [];
              var planes = new Set();
              var planesLastChangedTimes = new Map(); //
              var cameraL = new _PerspectiveCamera();
              cameraL.layers.enable(1);
              cameraL.viewport = new _Vector3();
              var cameraR = new _PerspectiveCamera();
              cameraR.layers.enable(2);
              cameraR.viewport = new _Vector3();
              var cameras = [cameraL, cameraR];
              var cameraVR = new _ArrayCamera();
              cameraVR.layers.enable(1);
              cameraVR.layers.enable(2);
              var _currentDepthNear = null;
              var _currentDepthFar = null; //
              _this39.cameraAutoUpdate = true;
              _this39.layersEnabled = false;
              _this39.enabled = false;
              _this39.isPresenting = false;
              _this39.getCameraPose = function () {
                return pose;
              };
              _this39.getController = function (index) {
                var controller = controllers[index];
                if (controller === undefined) {
                  controller = new WebXRController();
                  controllers[index] = controller;
                }
                return controller.getTargetRaySpace();
              };
              _this39.getControllerGrip = function (index) {
                var controller = controllers[index];
                if (controller === undefined) {
                  controller = new WebXRController();
                  controllers[index] = controller;
                }
                return controller.getGripSpace();
              };
              _this39.getHand = function (index) {
                var controller = controllers[index];
                if (controller === undefined) {
                  controller = new WebXRController();
                  controllers[index] = controller;
                }
                return controller.getHandSpace();
              }; //
              function onSessionEvent(event) {
                var controllerIndex = controllerInputSources.indexOf(event.inputSource);
                if (controllerIndex === -1) {
                  return;
                }
                var controller = controllers[controllerIndex];
                if (controller !== undefined) {
                  controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                  });
                }
              }
              function onSessionEnd() {
                session.removeEventListener('select', onSessionEvent);
                session.removeEventListener('selectstart', onSessionEvent);
                session.removeEventListener('selectend', onSessionEvent);
                session.removeEventListener('squeeze', onSessionEvent);
                session.removeEventListener('squeezestart', onSessionEvent);
                session.removeEventListener('squeezeend', onSessionEvent);
                session.removeEventListener('end', onSessionEnd);
                session.removeEventListener('inputsourceschange', onInputSourcesChange);
                for (var i = 0; i < controllers.length; i++) {
                  var inputSource = controllerInputSources[i];
                  if (inputSource === null) continue;
                  controllerInputSources[i] = null;
                  controllers[i].disconnect(inputSource);
                }
                _currentDepthNear = null;
                _currentDepthFar = null; // restore framebuffer/rendering state
                renderer.setRenderTarget(initialRenderTarget);
                glBaseLayer = null;
                glProjLayer = null;
                glBinding = null;
                session = null;
                newRenderTarget = null; //
                animation.stop();
                scope.isPresenting = false;
                scope.dispatchEvent({
                  type: 'sessionend'
                });
              }
              _this39.setFramebufferScaleFactor = function (value) {
                framebufferScaleFactor = value;
                if (scope.isPresenting === true) {
                  console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
                }
              };
              _this39.setReferenceSpaceType = function (value) {
                referenceSpaceType = value;
                if (scope.isPresenting === true) {
                  console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
                }
              };
              _this39.getReferenceSpace = function () {
                return customReferenceSpace || referenceSpace;
              };
              _this39.setReferenceSpace = function (space) {
                customReferenceSpace = space;
              };
              _this39.getBaseLayer = function () {
                return glProjLayer !== null ? glProjLayer : glBaseLayer;
              };
              _this39.getBinding = function () {
                return glBinding;
              };
              _this39.getFrame = function () {
                return xrFrame;
              };
              _this39.getSession = function () {
                return session;
              };
              _this39.setSession = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
                  var layerInit, depthFormat, depthType, glDepthFormat, projectionlayerInit, renderTargetProperties;
                  return _regeneratorRuntime().wrap(function _callee$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        session = value;
                        if (!(session !== null)) {
                          _context8.next = 25;
                          break;
                        }
                        initialRenderTarget = renderer.getRenderTarget();
                        session.addEventListener('select', onSessionEvent);
                        session.addEventListener('selectstart', onSessionEvent);
                        session.addEventListener('selectend', onSessionEvent);
                        session.addEventListener('squeeze', onSessionEvent);
                        session.addEventListener('squeezestart', onSessionEvent);
                        session.addEventListener('squeezeend', onSessionEvent);
                        session.addEventListener('end', onSessionEnd);
                        session.addEventListener('inputsourceschange', onInputSourcesChange);
                        if (!(attributes.xrCompatible !== true)) {
                          _context8.next = 14;
                          break;
                        }
                        _context8.next = 14;
                        return gl.makeXRCompatible();
                      case 14:
                        if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                          layerInit = {
                            antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                            alpha: attributes.alpha,
                            depth: attributes.depth,
                            stencil: attributes.stencil,
                            framebufferScaleFactor: framebufferScaleFactor
                          };
                          glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                          session.updateRenderState({
                            baseLayer: glBaseLayer
                          });
                          newRenderTarget = new _WebGLRenderTarget(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                            format: _RGBAFormat,
                            type: _UnsignedByteType,
                            encoding: renderer.outputEncoding,
                            stencilBuffer: attributes.stencil
                          });
                        } else {
                          depthFormat = null;
                          depthType = null;
                          glDepthFormat = null;
                          if (attributes.depth) {
                            glDepthFormat = attributes.stencil ? 35056 : 33190;
                            depthFormat = attributes.stencil ? _DepthStencilFormat : _DepthFormat;
                            depthType = attributes.stencil ? _UnsignedInt248Type : _UnsignedIntType;
                          }
                          projectionlayerInit = {
                            colorFormat: 32856,
                            depthFormat: glDepthFormat,
                            scaleFactor: framebufferScaleFactor
                          };
                          glBinding = new XRWebGLBinding(session, gl);
                          glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                          session.updateRenderState({
                            layers: [glProjLayer]
                          });
                          newRenderTarget = new _WebGLRenderTarget(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                            format: _RGBAFormat,
                            type: _UnsignedByteType,
                            depthTexture: new _DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                            stencilBuffer: attributes.stencil,
                            encoding: renderer.outputEncoding,
                            samples: attributes.antialias ? 4 : 0
                          });
                          renderTargetProperties = renderer.properties.get(newRenderTarget);
                          renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                        }
                        newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                        // Set foveation to maximum.
                        this.setFoveation(1.0);
                        customReferenceSpace = null;
                        _context8.next = 20;
                        return session.requestReferenceSpace(referenceSpaceType);
                      case 20:
                        referenceSpace = _context8.sent;
                        animation.setContext(session);
                        animation.start();
                        scope.isPresenting = true;
                        scope.dispatchEvent({
                          type: 'sessionstart'
                        });
                      case 25:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee, this);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }();
              _this39.addLayer = function (layer) {
                if (!window.XRWebGLBinding || !this.layersEnabled || !session) {
                  return;
                }
                layers.push(layer);
                this.updateLayers();
              };
              _this39.removeLayer = function (layer) {
                layers.splice(layers.indexOf(layer), 1);
                if (!window.XRWebGLBinding || !this.layersEnabled || !session) {
                  return;
                }
                this.updateLayers();
              };
              _this39.updateLayers = function () {
                var layersCopy = layers.map(function (x) {
                  return x;
                });
                layersCopy.unshift(session.renderState.layers[0]);
                session.updateRenderState({
                  layers: layersCopy
                });
              };
              function onInputSourcesChange(event) {
                // Notify disconnected
                for (var i = 0; i < event.removed.length; i++) {
                  var inputSource = event.removed[i];
                  var index = controllerInputSources.indexOf(inputSource);
                  if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                  }
                } // Notify connected
                for (var _i49 = 0; _i49 < event.added.length; _i49++) {
                  var _inputSource = event.added[_i49];
                  var controllerIndex = controllerInputSources.indexOf(_inputSource);
                  if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for (var _i50 = 0; _i50 < controllers.length; _i50++) {
                      if (_i50 >= controllerInputSources.length) {
                        controllerInputSources.push(_inputSource);
                        controllerIndex = _i50;
                        break;
                      } else if (controllerInputSources[_i50] === null) {
                        controllerInputSources[_i50] = _inputSource;
                        controllerIndex = _i50;
                        break;
                      }
                    } // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                  }
                  var controller = controllers[controllerIndex];
                  if (controller) {
                    controller.connect(_inputSource);
                  }
                }
              } //
              var cameraLPos = new _Vector2();
              var cameraRPos = new _Vector2(); /**
                                               * Assumes 2 cameras that are parallel and share an X-axis, and that
                                               * the cameras' projection and world matrices have already been set.
                                               * And that near and far planes are identical for both cameras.
                                               * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
                                               */
              function setProjectionFromUnion(camera, cameraL, cameraR) {
                cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
                cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
                var ipd = cameraLPos.distanceTo(cameraRPos);
                var projL = cameraL.projectionMatrix.elements;
                var projR = cameraR.projectionMatrix.elements; // VR systems will have identical far and near planes, and
                // most likely identical top and bottom frustum extents.
                // Use the left camera for these values.
                var near = projL[14] / (projL[10] - 1);
                var far = projL[14] / (projL[10] + 1);
                var topFov = (projL[9] + 1) / projL[5];
                var bottomFov = (projL[9] - 1) / projL[5];
                var leftFov = (projL[8] - 1) / projL[0];
                var rightFov = (projR[8] + 1) / projR[0];
                var left = near * leftFov;
                var right = near * rightFov; // Calculate the new camera's position offset from the
                // left camera. xOffset should be roughly half `ipd`.
                var zOffset = ipd / (-leftFov + rightFov);
                var xOffset = zOffset * -leftFov; // TODO: Better way to apply this offset?
                cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
                camera.translateX(xOffset);
                camera.translateZ(zOffset);
                camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
                camera.matrixWorldInverse.copy(camera.matrixWorld).invert(); // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                var near2 = near + zOffset;
                var far2 = far + zOffset;
                var left2 = left - xOffset;
                var right2 = right + (ipd - xOffset);
                var top2 = topFov * far / far2 * near2;
                var bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
              }
              function updateCamera(camera, parent) {
                if (parent === null) {
                  camera.matrixWorld.copy(camera.matrix);
                } else {
                  camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
                }
                camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
              }
              _this39.setPoseTarget = function (object) {
                if (object !== undefined) poseTarget = object;
              };
              _this39.updateCamera = function (camera) {
                if (session === null) return;
                cameraVR.near = cameraR.near = cameraL.near = camera.near;
                cameraVR.far = cameraR.far = cameraL.far = camera.far;
                if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                  // Note that the new renderState won't apply until the next frame. See #18320
                  session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                  });
                  _currentDepthNear = cameraVR.near;
                  _currentDepthFar = cameraVR.far;
                }
                var cameras = cameraVR.cameras;
                var object = poseTarget || camera;
                var parent = object.parent;
                updateCamera(cameraVR, parent);
                for (var i = 0; i < cameras.length; i++) {
                  updateCamera(cameras[i], parent);
                }
                cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale); // update user camera and its children
                object.matrixWorld.copy(cameraVR.matrixWorld);
                object.matrix.copy(cameraVR.matrix);
                object.matrix.decompose(object.position, object.quaternion, object.scale);
                var children = object.children;
                for (var _i51 = 0, l = children.length; _i51 < l; _i51++) {
                  children[_i51].updateMatrixWorld(true);
                } // update projection matrix for proper view frustum culling
                if (cameras.length === 2) {
                  setProjectionFromUnion(cameraVR, cameraL, cameraR);
                } else {
                  // assume single camera setup (AR)
                  cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
                }
              };
              _this39.getCamera = function () {
                return cameraVR;
              };
              _this39.getFoveation = function () {
                if (glProjLayer !== null) {
                  return glProjLayer.fixedFoveation;
                }
                if (glBaseLayer !== null) {
                  return glBaseLayer.fixedFoveation;
                }
                return undefined;
              };
              _this39.setFoveation = function (foveation) {
                // 0 = no foveation = full resolution
                // 1 = maximum foveation = the edges render at lower resolution
                if (glProjLayer !== null) {
                  glProjLayer.fixedFoveation = foveation;
                }
                if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) {
                  glBaseLayer.fixedFoveation = foveation;
                }
              };
              _this39.getPlanes = function () {
                return planes;
              }; // Animation Loop
              var onAnimationFrameCallback = null;
              function onAnimationFrame(time, frame) {
                pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
                xrFrame = frame;
                if (pose !== null) {
                  var views = pose.views;
                  if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                  }
                  var cameraVRNeedsUpdate = false; // check if it's necessary to rebuild cameraVR's camera list
                  if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                  }
                  for (var i = 0; i < views.length; i++) {
                    var view = views[i];
                    var viewport = null;
                    if (glBaseLayer !== null) {
                      viewport = glBaseLayer.getViewport(view);
                    } else {
                      var glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                      viewport = glSubImage.viewport; // For side-by-side projection, we only produce a single texture for both eyes.
                      if (i === 0) {
                        renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                        renderer.setRenderTarget(newRenderTarget);
                      }
                    }
                    var camera = cameras[i];
                    if (camera === undefined) {
                      camera = new _PerspectiveCamera();
                      camera.layers.enable(i);
                      camera.viewport = new _Vector3();
                      cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                      cameraVR.matrix.copy(camera.matrix);
                    }
                    if (cameraVRNeedsUpdate === true) {
                      cameraVR.cameras.push(camera);
                    }
                  }
                } //
                for (var _i52 = 0; _i52 < controllers.length; _i52++) {
                  var inputSource = controllerInputSources[_i52];
                  var controller = controllers[_i52];
                  if (inputSource !== null && controller !== undefined) {
                    controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
                  }
                }
                if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
                if (frame.detectedPlanes) {
                  scope.dispatchEvent({
                    type: 'planesdetected',
                    data: frame.detectedPlanes
                  });
                  var planesToRemove = null;
                  var _iterator8 = _createForOfIteratorHelper2(planes),
                    _step8;
                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                      var _plane = _step8.value;
                      if (!frame.detectedPlanes.has(_plane)) {
                        if (planesToRemove === null) {
                          planesToRemove = [];
                        }
                        planesToRemove.push(_plane);
                      }
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                  if (planesToRemove !== null) {
                    var _iterator9 = _createForOfIteratorHelper2(planesToRemove),
                      _step9;
                    try {
                      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                        var plane = _step9.value;
                        planes.delete(plane);
                        planesLastChangedTimes.delete(plane);
                        scope.dispatchEvent({
                          type: 'planeremoved',
                          data: plane
                        });
                      }
                    } catch (err) {
                      _iterator9.e(err);
                    } finally {
                      _iterator9.f();
                    }
                  }
                  var _iterator10 = _createForOfIteratorHelper2(frame.detectedPlanes),
                    _step10;
                  try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                      var _plane2 = _step10.value;
                      if (!planes.has(_plane2)) {
                        planes.add(_plane2);
                        planesLastChangedTimes.set(_plane2, frame.lastChangedTime);
                        scope.dispatchEvent({
                          type: 'planeadded',
                          data: _plane2
                        });
                      } else {
                        var lastKnownTime = planesLastChangedTimes.get(_plane2);
                        if (_plane2.lastChangedTime > lastKnownTime) {
                          planesLastChangedTimes.set(_plane2, _plane2.lastChangedTime);
                          scope.dispatchEvent({
                            type: 'planechanged',
                            data: _plane2
                          });
                        }
                      }
                    }
                  } catch (err) {
                    _iterator10.e(err);
                  } finally {
                    _iterator10.f();
                  }
                }
                xrFrame = null;
              }
              var animation = new WebGLAnimation();
              animation.setAnimationLoop(onAnimationFrame);
              _this39.setAnimationLoop = function (callback) {
                onAnimationFrameCallback = callback;
              };
              _this39.dispose = function () {};
              return _this39;
            }
            return _createClass2(WebXRManager);
          }(_EventDispatcher);
          function WebGLMaterials(renderer, properties) {
            function refreshFogUniforms(uniforms, fog) {
              fog.color.getRGB(uniforms.fogColor.value, getUnlitUniformColorSpace(renderer));
              if (fog.isFog) {
                uniforms.fogNear.value = fog.near;
                uniforms.fogFar.value = fog.far;
              } else if (fog.isFogExp2) {
                uniforms.fogDensity.value = fog.density;
              }
            }
            function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
              if (material.isMeshBasicMaterial) {
                refreshUniformsCommon(uniforms, material);
              } else if (material.isMeshLambertMaterial) {
                refreshUniformsCommon(uniforms, material);
              } else if (material.isMeshToonMaterial) {
                refreshUniformsCommon(uniforms, material);
                refreshUniformsToon(uniforms, material);
              } else if (material.isMeshPhongMaterial) {
                refreshUniformsCommon(uniforms, material);
                refreshUniformsPhong(uniforms, material);
              } else if (material.isMeshStandardMaterial) {
                refreshUniformsCommon(uniforms, material);
                refreshUniformsStandard(uniforms, material);
                if (material.isMeshPhysicalMaterial) {
                  refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
                }
              } else if (material.isMeshMatcapMaterial) {
                refreshUniformsCommon(uniforms, material);
                refreshUniformsMatcap(uniforms, material);
              } else if (material.isMeshDepthMaterial) {
                refreshUniformsCommon(uniforms, material);
              } else if (material.isMeshDistanceMaterial) {
                refreshUniformsCommon(uniforms, material);
                refreshUniformsDistance(uniforms, material);
              } else if (material.isMeshNormalMaterial) {
                refreshUniformsCommon(uniforms, material);
              } else if (material.isLineBasicMaterial) {
                refreshUniformsLine(uniforms, material);
                if (material.isLineDashedMaterial) {
                  refreshUniformsDash(uniforms, material);
                }
              } else if (material.isPointsMaterial) {
                refreshUniformsPoints(uniforms, material, pixelRatio, height);
              } else if (material.isSpriteMaterial) {
                refreshUniformsSprites(uniforms, material);
              } else if (material.isShadowMaterial) {
                uniforms.color.value.copy(material.color);
                uniforms.opacity.value = material.opacity;
              } else if (material.isShaderMaterial) {
                material.uniformsNeedUpdate = false; // #15581
              }
            }
            function refreshUniformsCommon(uniforms, material) {
              uniforms.opacity.value = material.opacity;
              if (material.color) {
                uniforms.diffuse.value.copy(material.color);
              }
              if (material.emissive) {
                uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
              }
              if (material.map) {
                uniforms.map.value = material.map;
              }
              if (material.alphaMap) {
                uniforms.alphaMap.value = material.alphaMap;
              }
              if (material.bumpMap) {
                uniforms.bumpMap.value = material.bumpMap;
                uniforms.bumpScale.value = material.bumpScale;
                if (material.side === _BackSide) uniforms.bumpScale.value *= -1;
              }
              if (material.displacementMap) {
                uniforms.displacementMap.value = material.displacementMap;
                uniforms.displacementScale.value = material.displacementScale;
                uniforms.displacementBias.value = material.displacementBias;
              }
              if (material.emissiveMap) {
                uniforms.emissiveMap.value = material.emissiveMap;
              }
              if (material.normalMap) {
                uniforms.normalMap.value = material.normalMap;
                uniforms.normalScale.value.copy(material.normalScale);
                if (material.side === _BackSide) uniforms.normalScale.value.negate();
              }
              if (material.specularMap) {
                uniforms.specularMap.value = material.specularMap;
              }
              if (material.alphaTest > 0) {
                uniforms.alphaTest.value = material.alphaTest;
              }
              var envMap = properties.get(material).envMap;
              if (envMap) {
                uniforms.envMap.value = envMap;
                uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
                uniforms.reflectivity.value = material.reflectivity;
                uniforms.ior.value = material.ior;
                uniforms.refractionRatio.value = material.refractionRatio;
              }
              if (material.lightMap) {
                uniforms.lightMap.value = material.lightMap; // artist-friendly light intensity scaling factor
                var scaleFactor = renderer.physicallyCorrectLights !== true ? Math.PI : 1;
                uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
              }
              if (material.aoMap) {
                uniforms.aoMap.value = material.aoMap;
                uniforms.aoMapIntensity.value = material.aoMapIntensity;
              } // uv repeat and offset setting priorities
              // 1. color map
              // 2. specular map
              // 3. displacementMap map
              // 4. normal map
              // 5. bump map
              // 6. roughnessMap map
              // 7. metalnessMap map
              // 8. alphaMap map
              // 9. emissiveMap map
              // 10. clearcoat map
              // 11. clearcoat normal map
              // 12. clearcoat roughnessMap map
              // 13. iridescence map
              // 14. iridescence thickness map
              // 15. specular intensity map
              // 16. specular tint map
              // 17. transmission map
              // 18. thickness map
              var uvScaleMap;
              if (material.map) {
                uvScaleMap = material.map;
              } else if (material.specularMap) {
                uvScaleMap = material.specularMap;
              } else if (material.displacementMap) {
                uvScaleMap = material.displacementMap;
              } else if (material.normalMap) {
                uvScaleMap = material.normalMap;
              } else if (material.bumpMap) {
                uvScaleMap = material.bumpMap;
              } else if (material.roughnessMap) {
                uvScaleMap = material.roughnessMap;
              } else if (material.metalnessMap) {
                uvScaleMap = material.metalnessMap;
              } else if (material.alphaMap) {
                uvScaleMap = material.alphaMap;
              } else if (material.emissiveMap) {
                uvScaleMap = material.emissiveMap;
              } else if (material.clearcoatMap) {
                uvScaleMap = material.clearcoatMap;
              } else if (material.clearcoatNormalMap) {
                uvScaleMap = material.clearcoatNormalMap;
              } else if (material.clearcoatRoughnessMap) {
                uvScaleMap = material.clearcoatRoughnessMap;
              } else if (material.iridescenceMap) {
                uvScaleMap = material.iridescenceMap;
              } else if (material.iridescenceThicknessMap) {
                uvScaleMap = material.iridescenceThicknessMap;
              } else if (material.specularIntensityMap) {
                uvScaleMap = material.specularIntensityMap;
              } else if (material.specularColorMap) {
                uvScaleMap = material.specularColorMap;
              } else if (material.transmissionMap) {
                uvScaleMap = material.transmissionMap;
              } else if (material.thicknessMap) {
                uvScaleMap = material.thicknessMap;
              } else if (material.sheenColorMap) {
                uvScaleMap = material.sheenColorMap;
              } else if (material.sheenRoughnessMap) {
                uvScaleMap = material.sheenRoughnessMap;
              }
              if (uvScaleMap !== undefined) {
                // backwards compatibility
                if (uvScaleMap.isWebGLRenderTarget) {
                  uvScaleMap = uvScaleMap.texture;
                }
                if (uvScaleMap.matrixAutoUpdate === true) {
                  uvScaleMap.updateMatrix();
                }
                uniforms.uvTransform.value.copy(uvScaleMap.matrix);
              } // uv repeat and offset setting priorities for uv2
              // 1. ao map
              // 2. light map
              var uv2ScaleMap;
              if (material.aoMap) {
                uv2ScaleMap = material.aoMap;
              } else if (material.lightMap) {
                uv2ScaleMap = material.lightMap;
              }
              if (uv2ScaleMap !== undefined) {
                // backwards compatibility
                if (uv2ScaleMap.isWebGLRenderTarget) {
                  uv2ScaleMap = uv2ScaleMap.texture;
                }
                if (uv2ScaleMap.matrixAutoUpdate === true) {
                  uv2ScaleMap.updateMatrix();
                }
                uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
              }
            }
            function refreshUniformsLine(uniforms, material) {
              uniforms.diffuse.value.copy(material.color);
              uniforms.opacity.value = material.opacity;
            }
            function refreshUniformsDash(uniforms, material) {
              uniforms.dashSize.value = material.dashSize;
              uniforms.totalSize.value = material.dashSize + material.gapSize;
              uniforms.scale.value = material.scale;
            }
            function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
              uniforms.diffuse.value.copy(material.color);
              uniforms.opacity.value = material.opacity;
              uniforms.size.value = material.size * pixelRatio;
              uniforms.scale.value = height * 0.5;
              if (material.map) {
                uniforms.map.value = material.map;
              }
              if (material.alphaMap) {
                uniforms.alphaMap.value = material.alphaMap;
              }
              if (material.alphaTest > 0) {
                uniforms.alphaTest.value = material.alphaTest;
              } // uv repeat and offset setting priorities
              // 1. color map
              // 2. alpha map
              var uvScaleMap;
              if (material.map) {
                uvScaleMap = material.map;
              } else if (material.alphaMap) {
                uvScaleMap = material.alphaMap;
              }
              if (uvScaleMap !== undefined) {
                if (uvScaleMap.matrixAutoUpdate === true) {
                  uvScaleMap.updateMatrix();
                }
                uniforms.uvTransform.value.copy(uvScaleMap.matrix);
              }
            }
            function refreshUniformsSprites(uniforms, material) {
              uniforms.diffuse.value.copy(material.color);
              uniforms.opacity.value = material.opacity;
              uniforms.rotation.value = material.rotation;
              if (material.map) {
                uniforms.map.value = material.map;
              }
              if (material.alphaMap) {
                uniforms.alphaMap.value = material.alphaMap;
              }
              if (material.alphaTest > 0) {
                uniforms.alphaTest.value = material.alphaTest;
              } // uv repeat and offset setting priorities
              // 1. color map
              // 2. alpha map
              var uvScaleMap;
              if (material.map) {
                uvScaleMap = material.map;
              } else if (material.alphaMap) {
                uvScaleMap = material.alphaMap;
              }
              if (uvScaleMap !== undefined) {
                if (uvScaleMap.matrixAutoUpdate === true) {
                  uvScaleMap.updateMatrix();
                }
                uniforms.uvTransform.value.copy(uvScaleMap.matrix);
              }
            }
            function refreshUniformsPhong(uniforms, material) {
              uniforms.specular.value.copy(material.specular);
              uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
            }
            function refreshUniformsToon(uniforms, material) {
              if (material.gradientMap) {
                uniforms.gradientMap.value = material.gradientMap;
              }
            }
            function refreshUniformsStandard(uniforms, material) {
              uniforms.roughness.value = material.roughness;
              uniforms.metalness.value = material.metalness;
              if (material.roughnessMap) {
                uniforms.roughnessMap.value = material.roughnessMap;
              }
              if (material.metalnessMap) {
                uniforms.metalnessMap.value = material.metalnessMap;
              }
              var envMap = properties.get(material).envMap;
              if (envMap) {
                //uniforms.envMap.value = material.envMap; // part of uniforms common
                uniforms.envMapIntensity.value = material.envMapIntensity;
              }
            }
            function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
              uniforms.ior.value = material.ior; // also part of uniforms common
              if (material.sheen > 0) {
                uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
                uniforms.sheenRoughness.value = material.sheenRoughness;
                if (material.sheenColorMap) {
                  uniforms.sheenColorMap.value = material.sheenColorMap;
                }
                if (material.sheenRoughnessMap) {
                  uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                }
              }
              if (material.clearcoat > 0) {
                uniforms.clearcoat.value = material.clearcoat;
                uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
                if (material.clearcoatMap) {
                  uniforms.clearcoatMap.value = material.clearcoatMap;
                }
                if (material.clearcoatRoughnessMap) {
                  uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                }
                if (material.clearcoatNormalMap) {
                  uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                  uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                  if (material.side === _BackSide) {
                    uniforms.clearcoatNormalScale.value.negate();
                  }
                }
              }
              if (material.iridescence > 0) {
                uniforms.iridescence.value = material.iridescence;
                uniforms.iridescenceIOR.value = material.iridescenceIOR;
                uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
                uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
                if (material.iridescenceMap) {
                  uniforms.iridescenceMap.value = material.iridescenceMap;
                }
                if (material.iridescenceThicknessMap) {
                  uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                }
              }
              if (material.transmission > 0) {
                uniforms.transmission.value = material.transmission;
                uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
                uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
                if (material.transmissionMap) {
                  uniforms.transmissionMap.value = material.transmissionMap;
                }
                uniforms.thickness.value = material.thickness;
                if (material.thicknessMap) {
                  uniforms.thicknessMap.value = material.thicknessMap;
                }
                uniforms.attenuationDistance.value = material.attenuationDistance;
                uniforms.attenuationColor.value.copy(material.attenuationColor);
              }
              uniforms.specularIntensity.value = material.specularIntensity;
              uniforms.specularColor.value.copy(material.specularColor);
              if (material.specularIntensityMap) {
                uniforms.specularIntensityMap.value = material.specularIntensityMap;
              }
              if (material.specularColorMap) {
                uniforms.specularColorMap.value = material.specularColorMap;
              }
            }
            function refreshUniformsMatcap(uniforms, material) {
              if (material.matcap) {
                uniforms.matcap.value = material.matcap;
              }
            }
            function refreshUniformsDistance(uniforms, material) {
              uniforms.referencePosition.value.copy(material.referencePosition);
              uniforms.nearDistance.value = material.nearDistance;
              uniforms.farDistance.value = material.farDistance;
            }
            return {
              refreshFogUniforms: refreshFogUniforms,
              refreshMaterialUniforms: refreshMaterialUniforms
            };
          }
          function WebGLUniformsGroups(gl, info, capabilities, state) {
            var buffers = {};
            var updateList = {};
            var allocatedBindingPoints = [];
            var maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(35375) : 0; // binding points are global whereas block indices are per shader program
            function bind(uniformsGroup, program) {
              var webglProgram = program.program;
              state.uniformBlockBinding(uniformsGroup, webglProgram);
            }
            function update(uniformsGroup, program) {
              var buffer = buffers[uniformsGroup.id];
              if (buffer === undefined) {
                prepareUniformsGroup(uniformsGroup);
                buffer = createBuffer(uniformsGroup);
                buffers[uniformsGroup.id] = buffer;
                uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
              } // ensure to update the binding points/block indices mapping for this program
              var webglProgram = program.program;
              state.updateUBOMapping(uniformsGroup, webglProgram); // update UBO once per frame
              var frame = info.render.frame;
              if (updateList[uniformsGroup.id] !== frame) {
                updateBufferData(uniformsGroup);
                updateList[uniformsGroup.id] = frame;
              }
            }
            function createBuffer(uniformsGroup) {
              // the setup of an UBO is independent of a particular shader program but global
              var bindingPointIndex = allocateBindingPointIndex();
              uniformsGroup.__bindingPointIndex = bindingPointIndex;
              var buffer = gl.createBuffer();
              var size = uniformsGroup.__size;
              var usage = uniformsGroup.usage;
              gl.bindBuffer(35345, buffer);
              gl.bufferData(35345, size, usage);
              gl.bindBuffer(35345, null);
              gl.bindBufferBase(35345, bindingPointIndex, buffer);
              return buffer;
            }
            function allocateBindingPointIndex() {
              for (var i = 0; i < maxBindingPoints; i++) {
                if (allocatedBindingPoints.indexOf(i) === -1) {
                  allocatedBindingPoints.push(i);
                  return i;
                }
              }
              console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
              return 0;
            }
            function updateBufferData(uniformsGroup) {
              var buffer = buffers[uniformsGroup.id];
              var uniforms = uniformsGroup.uniforms;
              var cache = uniformsGroup.__cache;
              gl.bindBuffer(35345, buffer);
              for (var i = 0, il = uniforms.length; i < il; i++) {
                var uniform = uniforms[i]; // partly update the buffer if necessary
                if (hasUniformChanged(uniform, i, cache) === true) {
                  var _value6 = uniform.value;
                  var offset = uniform.__offset;
                  if (typeof _value6 === 'number') {
                    uniform.__data[0] = _value6;
                    gl.bufferSubData(35345, offset, uniform.__data);
                  } else {
                    if (uniform.value.isMatrix3) {
                      // manually converting 3x3 to 3x4
                      uniform.__data[0] = uniform.value.elements[0];
                      uniform.__data[1] = uniform.value.elements[1];
                      uniform.__data[2] = uniform.value.elements[2];
                      uniform.__data[3] = uniform.value.elements[0];
                      uniform.__data[4] = uniform.value.elements[3];
                      uniform.__data[5] = uniform.value.elements[4];
                      uniform.__data[6] = uniform.value.elements[5];
                      uniform.__data[7] = uniform.value.elements[0];
                      uniform.__data[8] = uniform.value.elements[6];
                      uniform.__data[9] = uniform.value.elements[7];
                      uniform.__data[10] = uniform.value.elements[8];
                      uniform.__data[11] = uniform.value.elements[0];
                    } else {
                      _value6.toArray(uniform.__data);
                    }
                    gl.bufferSubData(35345, offset, uniform.__data);
                  }
                }
              }
              gl.bindBuffer(35345, null);
            }
            function hasUniformChanged(uniform, index, cache) {
              var value = uniform.value;
              if (cache[index] === undefined) {
                // cache entry does not exist so far
                if (typeof value === 'number') {
                  cache[index] = value;
                } else {
                  cache[index] = value.clone();
                }
                return true;
              } else {
                // compare current value with cached entry
                if (typeof value === 'number') {
                  if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                  }
                } else {
                  var cachedObject = cache[index];
                  if (cachedObject.equals(value) === false) {
                    cachedObject.copy(value);
                    return true;
                  }
                }
              }
              return false;
            }
            function prepareUniformsGroup(uniformsGroup) {
              // determine total buffer size according to the STD140 layout
              // Hint: STD140 is the only supported layout in WebGL 2
              var uniforms = uniformsGroup.uniforms;
              var offset = 0; // global buffer offset in bytes
              var chunkSize = 16; // size of a chunk in bytes
              var chunkOffset = 0; // offset within a single chunk in bytes
              for (var i = 0, l = uniforms.length; i < l; i++) {
                var uniform = uniforms[i];
                var _info = getUniformSize(uniform); // the following two properties will be used for partial buffer updates
                uniform.__data = new Float32Array(_info.storage / Float32Array.BYTES_PER_ELEMENT);
                uniform.__offset = offset; //
                if (i > 0) {
                  chunkOffset = offset % chunkSize;
                  var remainingSizeInChunk = chunkSize - chunkOffset; // check for chunk overflow
                  if (chunkOffset !== 0 && remainingSizeInChunk - _info.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                  }
                }
                offset += _info.storage;
              } // ensure correct final padding
              chunkOffset = offset % chunkSize;
              if (chunkOffset > 0) offset += chunkSize - chunkOffset; //
              uniformsGroup.__size = offset;
              uniformsGroup.__cache = {};
              return this;
            }
            function getUniformSize(uniform) {
              var value = uniform.value;
              var info = {
                boundary: 0,
                // bytes
                storage: 0 // bytes
              }; // determine sizes according to STD140
              if (typeof value === 'number') {
                // float/int
                info.boundary = 4;
                info.storage = 4;
              } else if (value.isVector2) {
                // vec2
                info.boundary = 8;
                info.storage = 8;
              } else if (value.isVector3 || value.isColor) {
                // vec3
                info.boundary = 16;
                info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
              } else if (value.isVector4) {
                // vec4
                info.boundary = 16;
                info.storage = 16;
              } else if (value.isMatrix3) {
                // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
                info.boundary = 48;
                info.storage = 48;
              } else if (value.isMatrix4) {
                // mat4
                info.boundary = 64;
                info.storage = 64;
              } else if (value.isTexture) {
                console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
              } else {
                console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
              }
              return info;
            }
            function onUniformsGroupsDispose(event) {
              var uniformsGroup = event.target;
              uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
              var index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
              allocatedBindingPoints.splice(index, 1);
              gl.deleteBuffer(buffers[uniformsGroup.id]);
              delete buffers[uniformsGroup.id];
              delete updateList[uniformsGroup.id];
            }
            function dispose() {
              for (var _id3 in buffers) {
                gl.deleteBuffer(buffers[_id3]);
              }
              allocatedBindingPoints = [];
              buffers = {};
              updateList = {};
            }
            return {
              bind: bind,
              update: update,
              dispose: dispose
            };
          }
          function createCanvasElement() {
            var canvas = createElementNS('canvas');
            canvas.style.display = 'block';
            return canvas;
          }
          function _WebGLRenderer() {
            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.isWebGLRenderer = true;
            var _canvas = parameters.canvas !== undefined ? parameters.canvas : createCanvasElement(),
              _context = parameters.context !== undefined ? parameters.context : null,
              _depth = parameters.depth !== undefined ? parameters.depth : true,
              _stencil = parameters.stencil !== undefined ? parameters.stencil : true,
              _antialias = parameters.antialias !== undefined ? parameters.antialias : false,
              _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
              _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false,
              _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default',
              _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
            var _alpha;
            if (_context !== null) {
              _alpha = _context.getContextAttributes().alpha;
            } else {
              _alpha = parameters.alpha !== undefined ? parameters.alpha : false;
            }
            var currentRenderList = null;
            var currentRenderState = null; // render() can be called from within a callback triggered by another render.
            // We track this so that the nested render call gets its list and state isolated from the parent render call.
            var renderListStack = [];
            var renderStateStack = []; // public properties
            this.domElement = _canvas; // Debug configuration container
            this.debug = {
              /**
              * Enables error checking and reporting when shader programs are being compiled
              * @type {boolean}
              */
              checkShaderErrors: true
            }; // clearing
            this.autoClear = true;
            this.autoClearColor = true;
            this.autoClearDepth = true;
            this.autoClearStencil = true; // scene graph
            this.sortObjects = true; // user-defined clipping
            this.clippingPlanes = [];
            this.localClippingEnabled = false; // physically based shading
            this.outputEncoding = _LinearEncoding; // physical lights
            this.physicallyCorrectLights = false; // tone mapping
            this.toneMapping = _NoToneMapping;
            this.toneMappingExposure = 1.0; // internal properties
            var _this = this;
            var _isContextLost = false; // internal state cache
            var _currentActiveCubeFace = 0;
            var _currentActiveMipmapLevel = 0;
            var _currentRenderTarget = null;
            var _currentMaterialId = -1;
            var _currentCamera = null;
            var _currentViewport = new _Vector3();
            var _currentScissor = new _Vector3();
            var _currentScissorTest = null; //
            var _width = _canvas.width;
            var _height = _canvas.height;
            var _pixelRatio = 1;
            var _opaqueSort = null;
            var _transparentSort = null;
            var _viewport = new _Vector3(0, 0, _width, _height);
            var _scissor = new _Vector3(0, 0, _width, _height);
            var _scissorTest = false; // frustum
            var _frustum = new _Frustum(); // clipping
            var _clippingEnabled = false;
            var _localClippingEnabled = false; // transmission
            var _transmissionRenderTarget = null; // camera matrices cache
            var _projScreenMatrix = new _Matrix2();
            var _vector2 = new _Vector();
            var _vector3 = new _Vector2();
            var _emptyScene = {
              background: null,
              fog: null,
              environment: null,
              overrideMaterial: null,
              isScene: true
            };
            function getTargetPixelRatio() {
              return _currentRenderTarget === null ? _pixelRatio : 1;
            } // initialize
            var _gl = _context;
            function getContext(contextNames, contextAttributes) {
              for (var i = 0; i < contextNames.length; i++) {
                var contextName = contextNames[i];
                var context = _canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
              }
              return null;
            }
            try {
              var contextAttributes = {
                alpha: true,
                depth: _depth,
                stencil: _stencil,
                antialias: _antialias,
                premultipliedAlpha: _premultipliedAlpha,
                preserveDrawingBuffer: _preserveDrawingBuffer,
                powerPreference: _powerPreference,
                failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
              }; // OffscreenCanvas does not have setAttribute, see #22811
              if ('setAttribute' in _canvas) _canvas.setAttribute('data-engine', "three.js r".concat(_REVISION)); // event listeners must be registered before WebGL context is created, see #12753
              _canvas.addEventListener('webglcontextlost', onContextLost, false);
              _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
              _canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
              if (_gl === null) {
                var contextNames = ['webgl2', 'webgl', 'experimental-webgl'];
                if (_this.isWebGL1Renderer === true) {
                  contextNames.shift();
                }
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                  if (getContext(contextNames)) {
                    throw new Error('Error creating WebGL context with your selected attributes.');
                  } else {
                    throw new Error('Error creating WebGL context.');
                  }
                }
              } // Some experimental-webgl implementations do not have getShaderPrecisionFormat
              if (_gl.getShaderPrecisionFormat === undefined) {
                _gl.getShaderPrecisionFormat = function () {
                  return {
                    'rangeMin': 1,
                    'rangeMax': 1,
                    'precision': 1
                  };
                };
              }
            } catch (error) {
              console.error('THREE.WebGLRenderer: ' + error.message);
              throw error;
            }
            var extensions, capabilities, state, info;
            var properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
            var programCache, materials, renderLists, renderStates, clipping, shadowMap;
            var background, morphtargets, bufferRenderer, indexedBufferRenderer;
            var utils, bindingStates, uniformsGroups;
            function initGLContext() {
              extensions = new WebGLExtensions(_gl);
              capabilities = new WebGLCapabilities(_gl, extensions, parameters);
              extensions.init(capabilities);
              utils = new _WebGLUtils(_gl, extensions, capabilities);
              state = new WebGLState(_gl, extensions, capabilities);
              info = new WebGLInfo(_gl);
              properties = new WebGLProperties();
              textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
              cubemaps = new WebGLCubeMaps(_this);
              cubeuvmaps = new WebGLCubeUVMaps(_this);
              attributes = new WebGLAttributes(_gl, capabilities);
              bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
              geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
              objects = new WebGLObjects(_gl, geometries, attributes, info);
              morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
              clipping = new WebGLClipping(properties);
              programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
              materials = new WebGLMaterials(_this, properties);
              renderLists = new WebGLRenderLists();
              renderStates = new WebGLRenderStates(extensions, capabilities);
              background = new WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, _premultipliedAlpha);
              shadowMap = new WebGLShadowMap(_this, objects, capabilities);
              uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);
              bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
              indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
              info.programs = programCache.programs;
              _this.capabilities = capabilities;
              _this.extensions = extensions;
              _this.properties = properties;
              _this.renderLists = renderLists;
              _this.shadowMap = shadowMap;
              _this.state = state;
              _this.info = info;
            }
            initGLContext();
            var xr = typeof navigator !== 'undefined' && 'xr' in navigator ? new WebXRManager(_this, _gl) : new WebVRManager(_this);
            this.xr = xr; // API
            this.getContext = function () {
              return _gl;
            };
            this.getContextAttributes = function () {
              return _gl.getContextAttributes();
            };
            this.forceContextLoss = function () {
              var extension = extensions.get('WEBGL_lose_context');
              if (extension) extension.loseContext();
            };
            this.forceContextRestore = function () {
              var extension = extensions.get('WEBGL_lose_context');
              if (extension) extension.restoreContext();
            };
            this.getPixelRatio = function () {
              return _pixelRatio;
            };
            this.setPixelRatio = function (value) {
              if (value === undefined) return;
              _pixelRatio = value;
              this.setSize(_width, _height, false);
            };
            this.getSize = function (target) {
              return target.set(_width, _height);
            };
            this.setSize = function (width, height, updateStyle) {
              if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
              }
              _width = width;
              _height = height;
              _canvas.width = Math.floor(width * _pixelRatio);
              _canvas.height = Math.floor(height * _pixelRatio);
              if (updateStyle !== false) {
                _canvas.style.width = width + 'px';
                _canvas.style.height = height + 'px';
              }
              this.setViewport(0, 0, width, height);
            };
            this.getDrawingBufferSize = function (target) {
              return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
            };
            this.setDrawingBufferSize = function (width, height, pixelRatio) {
              _width = width;
              _height = height;
              _pixelRatio = pixelRatio;
              _canvas.width = Math.floor(width * pixelRatio);
              _canvas.height = Math.floor(height * pixelRatio);
              this.setViewport(0, 0, width, height);
            };
            this.getCurrentViewport = function (target) {
              return target.copy(_currentViewport);
            };
            this.getViewport = function (target) {
              return target.copy(_viewport);
            };
            this.setViewport = function (x, y, width, height) {
              if (x.isVector4) {
                _viewport.set(x.x, x.y, x.z, x.w);
              } else {
                _viewport.set(x, y, width, height);
              }
              state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
            };
            this.getScissor = function (target) {
              return target.copy(_scissor);
            };
            this.setScissor = function (x, y, width, height) {
              if (x.isVector4) {
                _scissor.set(x.x, x.y, x.z, x.w);
              } else {
                _scissor.set(x, y, width, height);
              }
              state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
            };
            this.getScissorTest = function () {
              return _scissorTest;
            };
            this.setScissorTest = function (boolean) {
              state.setScissorTest(_scissorTest = boolean);
            };
            this.setOpaqueSort = function (method) {
              _opaqueSort = method;
            };
            this.setTransparentSort = function (method) {
              _transparentSort = method;
            }; // Clearing
            this.getClearColor = function (target) {
              return target.copy(background.getClearColor());
            };
            this.setClearColor = function () {
              background.setClearColor.apply(background, arguments);
            };
            this.getClearAlpha = function () {
              return background.getClearAlpha();
            };
            this.setClearAlpha = function () {
              background.setClearAlpha.apply(background, arguments);
            };
            this.clear = function () {
              var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var stencil = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
              var bits = 0;
              if (color) bits |= 16384;
              if (depth) bits |= 256;
              if (stencil) bits |= 1024;
              _gl.clear(bits);
            };
            this.clearColor = function () {
              this.clear(true, false, false);
            };
            this.clearDepth = function () {
              this.clear(false, true, false);
            };
            this.clearStencil = function () {
              this.clear(false, false, true);
            }; //
            this.dispose = function () {
              _canvas.removeEventListener('webglcontextlost', onContextLost, false);
              _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
              _canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
              renderLists.dispose();
              renderStates.dispose();
              properties.dispose();
              cubemaps.dispose();
              cubeuvmaps.dispose();
              objects.dispose();
              bindingStates.dispose();
              uniformsGroups.dispose();
              programCache.dispose();
              xr.dispose();
              xr.removeEventListener('sessionstart', onXRSessionStart);
              xr.removeEventListener('sessionend', onXRSessionEnd);
              if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
              }
              animation.stop();
            }; // Events
            function onContextLost(event) {
              event.preventDefault();
              console.log('THREE.WebGLRenderer: Context Lost.');
              _isContextLost = true;
            }
            function onContextRestore( /* event */) {
              console.log('THREE.WebGLRenderer: Context Restored.');
              _isContextLost = false;
              var infoAutoReset = info.autoReset;
              var shadowMapEnabled = shadowMap.enabled;
              var shadowMapAutoUpdate = shadowMap.autoUpdate;
              var shadowMapNeedsUpdate = shadowMap.needsUpdate;
              var shadowMapType = shadowMap.type;
              initGLContext();
              info.autoReset = infoAutoReset;
              shadowMap.enabled = shadowMapEnabled;
              shadowMap.autoUpdate = shadowMapAutoUpdate;
              shadowMap.needsUpdate = shadowMapNeedsUpdate;
              shadowMap.type = shadowMapType;
            }
            function onContextCreationError(event) {
              console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
            }
            function onMaterialDispose(event) {
              var material = event.target;
              material.removeEventListener('dispose', onMaterialDispose);
              deallocateMaterial(material);
            } // Buffer deallocation
            function deallocateMaterial(material) {
              releaseMaterialProgramReferences(material);
              properties.remove(material);
            }
            function releaseMaterialProgramReferences(material) {
              var programs = properties.get(material).programs;
              if (programs !== undefined) {
                programs.forEach(function (program) {
                  programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) {
                  programCache.releaseShaderCache(material);
                }
              }
            } // Buffer rendering
            this.renderBufferDirect = function (camera, scene, geometry, material, object, group) {
              if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
              var frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
              var program = setProgram(camera, scene, geometry, material, object);
              state.setMaterial(material, frontFaceCW); //
              var index = geometry.index;
              var rangeFactor = 1;
              if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                rangeFactor = 2;
              } //
              var drawRange = geometry.drawRange;
              var position = geometry.attributes.position;
              var drawStart = drawRange.start * rangeFactor;
              var drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
              if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
              }
              if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
              } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
              }
              var drawCount = drawEnd - drawStart;
              if (drawCount < 0 || drawCount === Infinity) return; //
              bindingStates.setup(object, material, program, geometry, index);
              var attribute;
              var renderer = bufferRenderer;
              if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
              } //
              if (object.isMesh) {
                if (material.wireframe === true) {
                  state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                  renderer.setMode(1);
                } else {
                  renderer.setMode(4);
                }
              } else if (object.isLine) {
                var lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) {
                  renderer.setMode(1);
                } else if (object.isLineLoop) {
                  renderer.setMode(2);
                } else {
                  renderer.setMode(3);
                }
              } else if (object.isPoints) {
                renderer.setMode(0);
              } else if (object.isSprite) {
                renderer.setMode(4);
              }
              if (object.isInstancedMesh) {
                renderer.renderInstances(drawStart, drawCount, object.count);
              } else if (geometry.isInstancedBufferGeometry) {
                var maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                var instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
              } else {
                renderer.render(drawStart, drawCount);
              }
            }; // Compile
            this.compile = function (scene, camera) {
              function prepare(material, scene, object) {
                if (material.transparent === true && material.side === _DoubleSide) {
                  material.side = _BackSide;
                  material.needsUpdate = true;
                  getProgram(material, scene, object);
                  material.side = _FrontSide;
                  material.needsUpdate = true;
                  getProgram(material, scene, object);
                  material.side = _DoubleSide;
                } else {
                  getProgram(material, scene, object);
                }
              }
              currentRenderState = renderStates.get(scene);
              currentRenderState.init();
              renderStateStack.push(currentRenderState);
              scene.traverseVisible(function (object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                  currentRenderState.pushLight(object);
                  if (object.castShadow) {
                    currentRenderState.pushShadow(object);
                  }
                }
              });
              currentRenderState.setupLights(_this.physicallyCorrectLights);
              scene.traverse(function (object) {
                var material = object.material;
                if (material) {
                  if (Array.isArray(material)) {
                    for (var i = 0; i < material.length; i++) {
                      var material2 = material[i];
                      prepare(material2, scene, object);
                    }
                  } else {
                    prepare(material, scene, object);
                  }
                }
              });
              renderStateStack.pop();
              currentRenderState = null;
            }; // Animation Loop
            var onAnimationFrameCallback = null;
            function onAnimationFrame(time) {
              if (onAnimationFrameCallback) onAnimationFrameCallback(time);
            }
            function onXRSessionStart() {
              animation.stop();
            }
            function onXRSessionEnd() {
              animation.start();
            }
            var animation = new WebGLAnimation();
            animation.setAnimationLoop(onAnimationFrame);
            if (typeof self !== 'undefined') animation.setContext(self);
            this.setAnimationLoop = function (callback) {
              onAnimationFrameCallback = callback;
              xr.setAnimationLoop(callback);
              callback === null ? animation.stop() : animation.start();
            };
            xr.addEventListener('sessionstart', onXRSessionStart);
            xr.addEventListener('sessionend', onXRSessionEnd); // Rendering
            this.render = function (scene, camera) {
              if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
              }
              if (_isContextLost === true) return; // update scene graph
              if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld(); // update camera matrices and frustum
              if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
              if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
              } //
              if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
              currentRenderState = renderStates.get(scene, renderStateStack.length);
              currentRenderState.init();
              renderStateStack.push(currentRenderState);
              _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
              _frustum.setFromProjectionMatrix(_projScreenMatrix);
              _localClippingEnabled = this.localClippingEnabled;
              _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
              currentRenderList = renderLists.get(scene, renderListStack.length);
              currentRenderList.init();
              renderListStack.push(currentRenderList);
              projectObject(scene, camera, 0, _this.sortObjects);
              currentRenderList.finish();
              if (_this.sortObjects === true) {
                currentRenderList.sort(_opaqueSort, _transparentSort);
              } //
              if (_clippingEnabled === true) clipping.beginShadows();
              var shadowsArray = currentRenderState.state.shadowsArray;
              shadowMap.render(shadowsArray, scene, camera);
              if (_clippingEnabled === true) clipping.endShadows(); //
              if (this.info.autoReset === true) this.info.reset(); //
              background.render(currentRenderList, scene); // render scene
              currentRenderState.setupLights(_this.physicallyCorrectLights);
              if (camera.isArrayCamera) {
                var cameras = camera.cameras;
                for (var i = 0, l = cameras.length; i < l; i++) {
                  var camera2 = cameras[i];
                  renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
              } else {
                renderScene(currentRenderList, scene, camera);
              } //
              if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget); // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
              } //
              if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
              if (xr.enabled && xr.submitFrame) {
                xr.submitFrame();
              } // _gl.finish();
              bindingStates.resetDefaultState();
              _currentMaterialId = -1;
              _currentCamera = null;
              renderStateStack.pop();
              if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
              } else {
                currentRenderState = null;
              }
              renderListStack.pop();
              if (renderListStack.length > 0) {
                currentRenderList = renderListStack[renderListStack.length - 1];
              } else {
                currentRenderList = null;
              }
            };
            function projectObject(object, camera, groupOrder, sortObjects) {
              if (object.visible === false) return;
              var visible = object.layers.test(camera.layers);
              if (visible) {
                if (object.isGroup) {
                  groupOrder = object.renderOrder;
                } else if (object.isLOD) {
                  if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                  currentRenderState.pushLight(object);
                  if (object.castShadow) {
                    currentRenderState.pushShadow(object);
                  }
                } else if (object.isSprite) {
                  if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) {
                      _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    }
                    var geometry = objects.update(object);
                    var material = object.material;
                    if (material.visible) {
                      currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                  }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                  if (object.isSkinnedMesh) {
                    // update skeleton only once in a frame
                    if (object.skeleton.frame !== info.render.frame) {
                      object.skeleton.update();
                      object.skeleton.frame = info.render.frame;
                    }
                  }
                  if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) {
                      _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    }
                    var _geometry2 = objects.update(object);
                    var _material = object.material;
                    if (Array.isArray(_material)) {
                      var groups = _geometry2.groups;
                      for (var i = 0, l = groups.length; i < l; i++) {
                        var group = groups[i];
                        var groupMaterial = _material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                          currentRenderList.push(object, _geometry2, groupMaterial, groupOrder, _vector3.z, group);
                        }
                      }
                    } else if (_material.visible) {
                      currentRenderList.push(object, _geometry2, _material, groupOrder, _vector3.z, null);
                    }
                  }
                }
              }
              var children = object.children;
              for (var _i53 = 0, _l6 = children.length; _i53 < _l6; _i53++) {
                projectObject(children[_i53], camera, groupOrder, sortObjects);
              }
            }
            function renderScene(currentRenderList, scene, camera, viewport) {
              var opaqueObjects = currentRenderList.opaque;
              var transmissiveObjects = currentRenderList.transmissive;
              var transparentObjects = currentRenderList.transparent;
              currentRenderState.setupLightsView(camera);
              if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
              if (viewport) state.viewport(_currentViewport.copy(viewport));
              if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
              if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
              if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera); // Ensure depth buffer writing is enabled so it can be cleared on next render
              state.buffers.depth.setTest(true);
              state.buffers.depth.setMask(true);
              state.buffers.color.setMask(true);
              state.setPolygonOffset(false);
            }
            function renderTransmissionPass(opaqueObjects, scene, camera) {
              var isWebGL2 = capabilities.isWebGL2;
              if (_transmissionRenderTarget === null) {
                _transmissionRenderTarget = new _WebGLRenderTarget(1, 1, {
                  generateMipmaps: true,
                  type: extensions.has('EXT_color_buffer_half_float') ? _HalfFloatType : _UnsignedByteType,
                  minFilter: _LinearMipmapLinearFilter,
                  samples: isWebGL2 && _antialias === true ? 4 : 0
                });
              }
              _this.getDrawingBufferSize(_vector2);
              if (isWebGL2) {
                _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
              } else {
                _transmissionRenderTarget.setSize(floorPowerOfTwo(_vector2.x), floorPowerOfTwo(_vector2.y));
              } //
              var currentRenderTarget = _this.getRenderTarget();
              _this.setRenderTarget(_transmissionRenderTarget);
              _this.clear(); // Turn off the features which can affect the frag color for opaque objects pass.
              // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
              var currentToneMapping = _this.toneMapping;
              _this.toneMapping = _NoToneMapping;
              renderObjects(opaqueObjects, scene, camera);
              _this.toneMapping = currentToneMapping;
              textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
              textures.updateRenderTargetMipmap(_transmissionRenderTarget);
              _this.setRenderTarget(currentRenderTarget);
            }
            function renderObjects(renderList, scene, camera) {
              var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
              for (var i = 0, l = renderList.length; i < l; i++) {
                var renderItem = renderList[i];
                var object = renderItem.object;
                var geometry = renderItem.geometry;
                var material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                var group = renderItem.group;
                if (object.layers.test(camera.layers)) {
                  renderObject(object, scene, camera, geometry, material, group);
                }
              }
            }
            function renderObject(object, scene, camera, geometry, material, group) {
              object.onBeforeRender(_this, scene, camera, geometry, material, group);
              object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
              object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
              material.onBeforeRender(_this, scene, camera, geometry, object, group);
              if (material.transparent === true && material.side === _DoubleSide) {
                material.side = _BackSide;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = _FrontSide;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = _DoubleSide;
              } else {
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
              }
              object.onAfterRender(_this, scene, camera, geometry, material, group);
            }
            function getProgram(material, scene, object) {
              if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
              var materialProperties = properties.get(material);
              var lights = currentRenderState.state.lights;
              var shadowsArray = currentRenderState.state.shadowsArray;
              var lightsStateVersion = lights.state.version;
              var parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
              var programCacheKey = programCache.getProgramCacheKey(parameters);
              var programs = materialProperties.programs; // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
              materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
              materialProperties.fog = scene.fog;
              materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
              if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
              }
              var program = programs.get(programCacheKey);
              if (program !== undefined) {
                // early out if program and light state is identical
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                  updateCommonMaterialProperties(material, parameters);
                  return program;
                }
              } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
              }
              var uniforms = materialProperties.uniforms;
              if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
                uniforms.clippingPlanes = clipping.uniform;
              }
              updateCommonMaterialProperties(material, parameters); // store the light setup it was created for
              materialProperties.needsLights = materialNeedsLights(material);
              materialProperties.lightsStateVersion = lightsStateVersion;
              if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix; // TODO (abelnation): add area lights shadow info to uniforms
              }
              var progUniforms = program.getUniforms();
              var uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
              materialProperties.currentProgram = program;
              materialProperties.uniformsList = uniformsList;
              return program;
            }
            function updateCommonMaterialProperties(material, parameters) {
              var materialProperties = properties.get(material);
              materialProperties.outputEncoding = parameters.outputEncoding;
              materialProperties.instancing = parameters.instancing;
              materialProperties.skinning = parameters.skinning;
              materialProperties.morphTargets = parameters.morphTargets;
              materialProperties.morphNormals = parameters.morphNormals;
              materialProperties.morphColors = parameters.morphColors;
              materialProperties.morphTargetsCount = parameters.morphTargetsCount;
              materialProperties.numClippingPlanes = parameters.numClippingPlanes;
              materialProperties.numIntersection = parameters.numClipIntersection;
              materialProperties.vertexAlphas = parameters.vertexAlphas;
              materialProperties.vertexTangents = parameters.vertexTangents;
              materialProperties.toneMapping = parameters.toneMapping;
            }
            function setProgram(camera, scene, geometry, material, object) {
              if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
              textures.resetTextureUnits();
              var fog = scene.fog;
              var environment = material.isMeshStandardMaterial ? scene.environment : null;
              var encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : _LinearEncoding;
              var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
              var vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
              var vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
              var morphTargets = !!geometry.morphAttributes.position;
              var morphNormals = !!geometry.morphAttributes.normal;
              var morphColors = !!geometry.morphAttributes.color;
              var toneMapping = material.toneMapped ? _this.toneMapping : _NoToneMapping;
              var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
              var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
              var materialProperties = properties.get(material);
              var lights = currentRenderState.state.lights;
              if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                  var useCache = camera === _currentCamera && material.id === _currentMaterialId; // we might want to call this function with some ClippingGroup
                  // object instead of the material, once it becomes feasible
                  // (#8465, #8379)
                  clipping.setState(material, camera, useCache);
                }
              } //
              var needsProgramChange = false;
              if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
                  needsProgramChange = true;
                } else if (materialProperties.outputEncoding !== encoding) {
                  needsProgramChange = true;
                } else if (object.isInstancedMesh && materialProperties.instancing === false) {
                  needsProgramChange = true;
                } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
                  needsProgramChange = true;
                } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
                  needsProgramChange = true;
                } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
                  needsProgramChange = true;
                } else if (materialProperties.envMap !== envMap) {
                  needsProgramChange = true;
                } else if (material.fog === true && materialProperties.fog !== fog) {
                  needsProgramChange = true;
                } else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
                  needsProgramChange = true;
                } else if (materialProperties.vertexAlphas !== vertexAlphas) {
                  needsProgramChange = true;
                } else if (materialProperties.vertexTangents !== vertexTangents) {
                  needsProgramChange = true;
                } else if (materialProperties.morphTargets !== morphTargets) {
                  needsProgramChange = true;
                } else if (materialProperties.morphNormals !== morphNormals) {
                  needsProgramChange = true;
                } else if (materialProperties.morphColors !== morphColors) {
                  needsProgramChange = true;
                } else if (materialProperties.toneMapping !== toneMapping) {
                  needsProgramChange = true;
                } else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) {
                  needsProgramChange = true;
                }
              } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
              } //
              var program = materialProperties.currentProgram;
              if (needsProgramChange === true) {
                program = getProgram(material, scene, object);
              }
              var refreshProgram = false;
              var refreshMaterial = false;
              var refreshLights = false;
              var p_uniforms = program.getUniforms(),
                m_uniforms = materialProperties.uniforms;
              if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
              }
              if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
              }
              if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) {
                  p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                }
                if (_currentCamera !== camera) {
                  _currentCamera = camera; // lighting uniforms depend on the camera so enforce an update
                  // now, in case this material supports lights - or later, when
                  // the next material that does gets activated:
                  refreshMaterial = true; // set to true on material change
                  refreshLights = true; // remains set until update done
                } // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                  var uCamPos = p_uniforms.map.cameraPosition;
                  if (uCamPos !== undefined) {
                    uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                  }
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
                  p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) {
                  p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                }
              } // skinning and morph target uniforms must be set even if material didn't change
              // auto-setting of texture unit for bone and morph texture must go before other textures
              // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
              if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                var skeleton = object.skeleton;
                if (skeleton) {
                  if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                  } else {
                    console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
                  }
                }
              }
              var morphAttributes = geometry.morphAttributes;
              if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) {
                morphtargets.update(object, geometry, material, program);
              }
              if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
              } // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
              if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
              }
              if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) {
                  // the current material requires lighting info
                  // note: all lighting uniforms are always set correctly
                  // they simply reference the renderer's state for their
                  // values
                  //
                  // use the current material's .needsUpdate flags to set
                  // the GL state when required
                  markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                } // refresh uniforms common to several materials
                if (fog && material.fog === true) {
                  materials.refreshFogUniforms(m_uniforms, fog);
                }
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
              }
              if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
              }
              if (material.isSpriteMaterial) {
                p_uniforms.setValue(_gl, 'center', object.center);
              } // common matrices
              p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
              p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
              p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld); // UBOs
              if (material.isShaderMaterial || material.isRawShaderMaterial) {
                var groups = material.uniformsGroups;
                for (var i = 0, l = groups.length; i < l; i++) {
                  if (capabilities.isWebGL2) {
                    var group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                  } else {
                    console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
                  }
                }
              }
              return program;
            } // If uniforms are marked as clean, they don't need to be loaded to the GPU.
            function markUniformsLightsNeedsUpdate(uniforms, value) {
              uniforms.ambientLightColor.needsUpdate = value;
              uniforms.lightProbe.needsUpdate = value;
              uniforms.directionalLights.needsUpdate = value;
              uniforms.directionalLightShadows.needsUpdate = value;
              uniforms.pointLights.needsUpdate = value;
              uniforms.pointLightShadows.needsUpdate = value;
              uniforms.spotLights.needsUpdate = value;
              uniforms.spotLightShadows.needsUpdate = value;
              uniforms.rectAreaLights.needsUpdate = value;
              uniforms.hemisphereLights.needsUpdate = value;
            }
            function materialNeedsLights(material) {
              return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
            }
            this.setTexture2D = function () {
              var warned = false; // backwards compatibility: peel texture.texture
              return function setTexture2D(texture, slot) {
                if (texture && texture.isWebGLRenderTarget) {
                  if (!warned) {
                    console.warn("THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead.");
                    warned = true;
                  }
                  texture = texture.texture;
                }
                textures.setTexture2D(texture, slot);
              };
            }();
            this.getActiveCubeFace = function () {
              return _currentActiveCubeFace;
            };
            this.getActiveMipmapLevel = function () {
              return _currentActiveMipmapLevel;
            };
            this.getRenderTarget = function () {
              return _currentRenderTarget;
            };
            this.setRenderTargetTextures = function (renderTarget, colorTexture, depthTexture) {
              properties.get(renderTarget.texture).__webglTexture = colorTexture;
              properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
              var renderTargetProperties = properties.get(renderTarget);
              renderTargetProperties.__hasExternalTextures = true;
              if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) {
                  // The multisample_render_to_texture extension doesn't work properly if there
                  // are midframe flushes and an external depth buffer. Disable use of the extension.
                  if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                  }
                }
              }
            };
            this.setRenderTargetFramebuffer = function (renderTarget, defaultFramebuffer) {
              var renderTargetProperties = properties.get(renderTarget);
              renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
              renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
            };
            this.setRenderTarget = function (renderTarget) {
              var activeCubeFace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var activeMipmapLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              _currentRenderTarget = renderTarget;
              _currentActiveCubeFace = activeCubeFace;
              _currentActiveMipmapLevel = activeMipmapLevel;
              var useDefaultFramebuffer = true;
              var framebuffer = null;
              var isCube = false;
              var isRenderTarget3D = false;
              if (renderTarget) {
                var renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                  // We need to make sure to rebind the framebuffer.
                  state.bindFramebuffer(36160, null);
                  useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) {
                  textures.setupRenderTarget(renderTarget);
                } else if (renderTargetProperties.__hasExternalTextures) {
                  // Color and depth texture must be rebound in order for the swapchain to update.
                  textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                }
                var texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
                  isRenderTarget3D = true;
                }
                var __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                  framebuffer = __webglFramebuffer[activeCubeFace];
                  isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
                  framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                } else {
                  framebuffer = __webglFramebuffer;
                }
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
              } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
              }
              var framebufferBound = state.bindFramebuffer(36160, framebuffer);
              if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) {
                state.drawBuffers(renderTarget, framebuffer);
              }
              state.viewport(_currentViewport);
              state.scissor(_currentScissor);
              state.setScissorTest(_currentScissorTest);
              if (isCube) {
                var textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
              } else if (isRenderTarget3D) {
                var _textureProperties = properties.get(renderTarget.texture);
                var layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(36160, 36064, _textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
              }
              _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
            };
            this.readRenderTargetPixels = function (renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
              if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
              }
              var framebuffer = properties.get(renderTarget).__webglFramebuffer;
              if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) {
                framebuffer = framebuffer[activeCubeFaceIndex];
              }
              if (framebuffer) {
                state.bindFramebuffer(36160, framebuffer);
                try {
                  var texture = renderTarget.texture;
                  var textureFormat = texture.format;
                  var textureType = texture.type;
                  if (textureFormat !== _RGBAFormat && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                  }
                  var halfFloatSupportedByExt = textureType === _HalfFloatType && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                  if (textureType !== _UnsignedByteType && utils.convert(textureType) !== _gl.getParameter(35738) &&
                  // Edge and Chrome Mac < 52 (#9513)
                  !(textureType === _FloatType && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) &&
                  // Chrome Mac >= 52 and Firefox
                  !halfFloatSupportedByExt) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                  } // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                  if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                  }
                } finally {
                  // restore framebuffer of current render target if necessary
                  var _framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                  state.bindFramebuffer(36160, _framebuffer);
                }
              }
            };
            this.copyFramebufferToTexture = function (position, texture) {
              var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var levelScale = Math.pow(2, -level);
              var width = Math.floor(texture.image.width * levelScale);
              var height = Math.floor(texture.image.height * levelScale);
              textures.setTexture2D(texture, 0);
              _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
              state.unbindTexture();
            };
            this.copyTextureToTexture = function (position, srcTexture, dstTexture) {
              var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
              var width = srcTexture.image.width;
              var height = srcTexture.image.height;
              var glFormat = utils.convert(dstTexture.format);
              var glType = utils.convert(dstTexture.type);
              textures.setTexture2D(dstTexture, 0); // As another texture upload may have changed pixelStorei
              // parameters, make sure they are correct for the dstTexture
              _gl.pixelStorei(37440, dstTexture.flipY);
              _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
              _gl.pixelStorei(3317, dstTexture.unpackAlignment);
              if (srcTexture.isDataTexture) {
                _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
              } else {
                if (srcTexture.isCompressedTexture) {
                  _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
                } else {
                  _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
                }
              } // Generate mipmaps only when copying level 0
              if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
              state.unbindTexture();
            };
            this.copyTextureToTexture3D = function (sourceBox, position, srcTexture, dstTexture) {
              var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
              if (_this.isWebGL1Renderer) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
                return;
              }
              var width = sourceBox.max.x - sourceBox.min.x + 1;
              var height = sourceBox.max.y - sourceBox.min.y + 1;
              var depth = sourceBox.max.z - sourceBox.min.z + 1;
              var glFormat = utils.convert(dstTexture.format);
              var glType = utils.convert(dstTexture.type);
              var glTarget;
              if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = 32879;
              } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = 35866;
              } else {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
                return;
              }
              _gl.pixelStorei(37440, dstTexture.flipY);
              _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
              _gl.pixelStorei(3317, dstTexture.unpackAlignment);
              var unpackRowLen = _gl.getParameter(3314);
              var unpackImageHeight = _gl.getParameter(32878);
              var unpackSkipPixels = _gl.getParameter(3316);
              var unpackSkipRows = _gl.getParameter(3315);
              var unpackSkipImages = _gl.getParameter(32877);
              var image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
              _gl.pixelStorei(3314, image.width);
              _gl.pixelStorei(32878, image.height);
              _gl.pixelStorei(3316, sourceBox.min.x);
              _gl.pixelStorei(3315, sourceBox.min.y);
              _gl.pixelStorei(32877, sourceBox.min.z);
              if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
                _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
              } else {
                if (srcTexture.isCompressedArrayTexture) {
                  console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
                  _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
                } else {
                  _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
                }
              }
              _gl.pixelStorei(3314, unpackRowLen);
              _gl.pixelStorei(32878, unpackImageHeight);
              _gl.pixelStorei(3316, unpackSkipPixels);
              _gl.pixelStorei(3315, unpackSkipRows);
              _gl.pixelStorei(32877, unpackSkipImages); // Generate mipmaps only when copying level 0
              if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
              state.unbindTexture();
            };
            this.initTexture = function (texture) {
              if (texture.isCubeTexture) {
                textures.setTextureCube(texture, 0);
              } else if (texture.isData3DTexture) {
                textures.setTexture3D(texture, 0);
              } else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
                textures.setTexture2DArray(texture, 0);
              } else {
                textures.setTexture2D(texture, 0);
              }
              state.unbindTexture();
            };
            this.resetState = function () {
              _currentActiveCubeFace = 0;
              _currentActiveMipmapLevel = 0;
              _currentRenderTarget = null;
              state.reset();
              bindingStates.reset();
            };
            if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
              __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
                detail: this
              }));
            }
          }
          var _WebGL1Renderer = /*#__PURE__*/function (_WebGLRenderer2) {
            _inherits(_WebGL1Renderer, _WebGLRenderer2);
            var _super48 = _createSuper(_WebGL1Renderer);
            function _WebGL1Renderer() {
              _classCallCheck2(this, _WebGL1Renderer);
              return _super48.apply(this, arguments);
            }
            return _createClass2(_WebGL1Renderer);
          }(_WebGLRenderer);
          _WebGL1Renderer.prototype.isWebGL1Renderer = true;
          var _FogExp = /*#__PURE__*/function () {
            function _FogExp(color) {
              var density = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.00025;
              _classCallCheck2(this, _FogExp);
              this.isFogExp2 = true;
              this.name = '';
              this.color = new _Color(color);
              this.density = density;
            }
            _createClass2(_FogExp, [{
              key: "clone",
              value: function clone() {
                return new _FogExp(this.color, this.density);
              }
            }, {
              key: "toJSON",
              value: function toJSON( /* meta */) {
                return {
                  type: 'FogExp2',
                  color: this.color.getHex(),
                  density: this.density
                };
              }
            }]);
            return _FogExp;
          }();
          var _Fog = /*#__PURE__*/function () {
            function _Fog(color) {
              var near = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var far = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
              _classCallCheck2(this, _Fog);
              this.isFog = true;
              this.name = '';
              this.color = new _Color(color);
              this.near = near;
              this.far = far;
            }
            _createClass2(_Fog, [{
              key: "clone",
              value: function clone() {
                return new _Fog(this.color, this.near, this.far);
              }
            }, {
              key: "toJSON",
              value: function toJSON( /* meta */) {
                return {
                  type: 'Fog',
                  color: this.color.getHex(),
                  near: this.near,
                  far: this.far
                };
              }
            }]);
            return _Fog;
          }();
          var _Scene = /*#__PURE__*/function (_Object3D6) {
            _inherits(_Scene, _Object3D6);
            var _super49 = _createSuper(_Scene);
            function _Scene() {
              var _this40;
              _classCallCheck2(this, _Scene);
              _this40 = _super49.call(this);
              _this40.isScene = true;
              _this40.type = 'Scene';
              _this40.background = null;
              _this40.environment = null;
              _this40.fog = null;
              _this40.backgroundBlurriness = 0;
              _this40.backgroundIntensity = 1;
              _this40.overrideMaterial = null;
              if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
                __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
                  detail: _assertThisInitialized(_this40)
                }));
              }
              return _this40;
            }
            _createClass2(_Scene, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Scene.prototype), "copy", this).call(this, source, recursive);
                if (source.background !== null) this.background = source.background.clone();
                if (source.environment !== null) this.environment = source.environment.clone();
                if (source.fog !== null) this.fog = source.fog.clone();
                this.backgroundBlurriness = source.backgroundBlurriness;
                this.backgroundIntensity = source.backgroundIntensity;
                if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_Scene.prototype), "toJSON", this).call(this, meta);
                if (this.fog !== null) data.object.fog = this.fog.toJSON();
                if (this.backgroundBlurriness > 0) data.backgroundBlurriness = this.backgroundBlurriness;
                if (this.backgroundIntensity !== 1) data.backgroundIntensity = this.backgroundIntensity;
                return data;
              } // @deprecated
            }, {
              key: "autoUpdate",
              get: function get() {
                console.warn('THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.');
                return this.matrixWorldAutoUpdate;
              },
              set: function set(value) {
                console.warn('THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.');
                this.matrixWorldAutoUpdate = value;
              }
            }]);
            return _Scene;
          }(_Object3D);
          var _InterleavedBuffer = /*#__PURE__*/function () {
            function _InterleavedBuffer(array, stride) {
              _classCallCheck2(this, _InterleavedBuffer);
              this.isInterleavedBuffer = true;
              this.array = array;
              this.stride = stride;
              this.count = array !== undefined ? array.length / stride : 0;
              this.usage = _StaticDrawUsage;
              this.updateRange = {
                offset: 0,
                count: -1
              };
              this.version = 0;
              this.uuid = generateUUID();
            }
            _createClass2(_InterleavedBuffer, [{
              key: "onUploadCallback",
              value: function onUploadCallback() {}
            }, {
              key: "needsUpdate",
              set: function set(value) {
                if (value === true) this.version++;
              }
            }, {
              key: "setUsage",
              value: function setUsage(value) {
                this.usage = value;
                return this;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.array = new source.array.constructor(source.array);
                this.count = source.count;
                this.stride = source.stride;
                this.usage = source.usage;
                return this;
              }
            }, {
              key: "copyAt",
              value: function copyAt(index1, attribute, index2) {
                index1 *= this.stride;
                index2 *= attribute.stride;
                for (var i = 0, l = this.stride; i < l; i++) {
                  this.array[index1 + i] = attribute.array[index2 + i];
                }
                return this;
              }
            }, {
              key: "set",
              value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this.array.set(value, offset);
                return this;
              }
            }, {
              key: "clone",
              value: function clone(data) {
                if (data.arrayBuffers === undefined) {
                  data.arrayBuffers = {};
                }
                if (this.array.buffer._uuid === undefined) {
                  this.array.buffer._uuid = generateUUID();
                }
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) {
                  data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
                }
                var array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
                var ib = new this.constructor(array, this.stride);
                ib.setUsage(this.usage);
                return ib;
              }
            }, {
              key: "onUpload",
              value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(data) {
                if (data.arrayBuffers === undefined) {
                  data.arrayBuffers = {};
                } // generate UUID for array buffer if necessary
                if (this.array.buffer._uuid === undefined) {
                  this.array.buffer._uuid = generateUUID();
                }
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) {
                  data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
                } //
                return {
                  uuid: this.uuid,
                  buffer: this.array.buffer._uuid,
                  type: this.array.constructor.name,
                  stride: this.stride
                };
              }
            }]);
            return _InterleavedBuffer;
          }();
          var _vector$6 = /*@__PURE__*/new _Vector2();
          var _InterleavedBufferAttribute = /*#__PURE__*/function () {
            function _InterleavedBufferAttribute(interleavedBuffer, itemSize, offset) {
              var normalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              _classCallCheck2(this, _InterleavedBufferAttribute);
              this.isInterleavedBufferAttribute = true;
              this.name = '';
              this.data = interleavedBuffer;
              this.itemSize = itemSize;
              this.offset = offset;
              this.normalized = normalized === true;
            }
            _createClass2(_InterleavedBufferAttribute, [{
              key: "count",
              get: function get() {
                return this.data.count;
              }
            }, {
              key: "array",
              get: function get() {
                return this.data.array;
              }
            }, {
              key: "needsUpdate",
              set: function set(value) {
                this.data.needsUpdate = value;
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(m) {
                for (var i = 0, l = this.data.count; i < l; i++) {
                  _vector$6.fromBufferAttribute(this, i);
                  _vector$6.applyMatrix4(m);
                  this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
                }
                return this;
              }
            }, {
              key: "applyNormalMatrix",
              value: function applyNormalMatrix(m) {
                for (var i = 0, l = this.count; i < l; i++) {
                  _vector$6.fromBufferAttribute(this, i);
                  _vector$6.applyNormalMatrix(m);
                  this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
                }
                return this;
              }
            }, {
              key: "transformDirection",
              value: function transformDirection(m) {
                for (var i = 0, l = this.count; i < l; i++) {
                  _vector$6.fromBufferAttribute(this, i);
                  _vector$6.transformDirection(m);
                  this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
                }
                return this;
              }
            }, {
              key: "setX",
              value: function setX(index, x) {
                if (this.normalized) x = normalize(x, this.array);
                this.data.array[index * this.data.stride + this.offset] = x;
                return this;
              }
            }, {
              key: "setY",
              value: function setY(index, y) {
                if (this.normalized) y = normalize(y, this.array);
                this.data.array[index * this.data.stride + this.offset + 1] = y;
                return this;
              }
            }, {
              key: "setZ",
              value: function setZ(index, z) {
                if (this.normalized) z = normalize(z, this.array);
                this.data.array[index * this.data.stride + this.offset + 2] = z;
                return this;
              }
            }, {
              key: "setW",
              value: function setW(index, w) {
                if (this.normalized) w = normalize(w, this.array);
                this.data.array[index * this.data.stride + this.offset + 3] = w;
                return this;
              }
            }, {
              key: "getX",
              value: function getX(index) {
                var x = this.data.array[index * this.data.stride + this.offset];
                if (this.normalized) x = denormalize(x, this.array);
                return x;
              }
            }, {
              key: "getY",
              value: function getY(index) {
                var y = this.data.array[index * this.data.stride + this.offset + 1];
                if (this.normalized) y = denormalize(y, this.array);
                return y;
              }
            }, {
              key: "getZ",
              value: function getZ(index) {
                var z = this.data.array[index * this.data.stride + this.offset + 2];
                if (this.normalized) z = denormalize(z, this.array);
                return z;
              }
            }, {
              key: "getW",
              value: function getW(index) {
                var w = this.data.array[index * this.data.stride + this.offset + 3];
                if (this.normalized) w = denormalize(w, this.array);
                return w;
              }
            }, {
              key: "setXY",
              value: function setXY(index, x, y) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                  x = normalize(x, this.array);
                  y = normalize(y, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                return this;
              }
            }, {
              key: "setXYZ",
              value: function setXYZ(index, x, y, z) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                  x = normalize(x, this.array);
                  y = normalize(y, this.array);
                  z = normalize(z, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                return this;
              }
            }, {
              key: "setXYZW",
              value: function setXYZW(index, x, y, z, w) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                  x = normalize(x, this.array);
                  y = normalize(y, this.array);
                  z = normalize(z, this.array);
                  w = normalize(w, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                this.data.array[index + 3] = w;
                return this;
              }
            }, {
              key: "clone",
              value: function clone(data) {
                if (data === undefined) {
                  console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
                  var array = [];
                  for (var i = 0; i < this.count; i++) {
                    var index = i * this.data.stride + this.offset;
                    for (var j = 0; j < this.itemSize; j++) {
                      array.push(this.data.array[index + j]);
                    }
                  }
                  return new _BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
                } else {
                  if (data.interleavedBuffers === undefined) {
                    data.interleavedBuffers = {};
                  }
                  if (data.interleavedBuffers[this.data.uuid] === undefined) {
                    data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
                  }
                  return new _InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
                }
              }
            }, {
              key: "toJSON",
              value: function toJSON(data) {
                if (data === undefined) {
                  console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
                  var array = [];
                  for (var i = 0; i < this.count; i++) {
                    var index = i * this.data.stride + this.offset;
                    for (var j = 0; j < this.itemSize; j++) {
                      array.push(this.data.array[index + j]);
                    }
                  } // de-interleave data and save it as an ordinary buffer attribute for now
                  return {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: array,
                    normalized: this.normalized
                  };
                } else {
                  // save as true interleaved attribute
                  if (data.interleavedBuffers === undefined) {
                    data.interleavedBuffers = {};
                  }
                  if (data.interleavedBuffers[this.data.uuid] === undefined) {
                    data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
                  }
                  return {
                    isInterleavedBufferAttribute: true,
                    itemSize: this.itemSize,
                    data: this.data.uuid,
                    offset: this.offset,
                    normalized: this.normalized
                  };
                }
              }
            }]);
            return _InterleavedBufferAttribute;
          }();
          var _SpriteMaterial = /*#__PURE__*/function (_Material6) {
            _inherits(_SpriteMaterial, _Material6);
            var _super50 = _createSuper(_SpriteMaterial);
            function _SpriteMaterial(parameters) {
              var _this41;
              _classCallCheck2(this, _SpriteMaterial);
              _this41 = _super50.call(this);
              _this41.isSpriteMaterial = true;
              _this41.type = 'SpriteMaterial';
              _this41.color = new _Color(0xffffff);
              _this41.map = null;
              _this41.alphaMap = null;
              _this41.rotation = 0;
              _this41.sizeAttenuation = true;
              _this41.transparent = true;
              _this41.fog = true;
              _this41.setValues(parameters);
              return _this41;
            }
            _createClass2(_SpriteMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_SpriteMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.rotation = source.rotation;
                this.sizeAttenuation = source.sizeAttenuation;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _SpriteMaterial;
          }(_Material);
          var _geometry;
          var _intersectPoint = /*@__PURE__*/new _Vector2();
          var _worldScale = /*@__PURE__*/new _Vector2();
          var _mvPosition = /*@__PURE__*/new _Vector2();
          var _alignedPosition = /*@__PURE__*/new _Vector();
          var _rotatedPosition = /*@__PURE__*/new _Vector();
          var _viewWorldMatrix = /*@__PURE__*/new _Matrix2();
          var _vA = /*@__PURE__*/new _Vector2();
          var _vB = /*@__PURE__*/new _Vector2();
          var _vC = /*@__PURE__*/new _Vector2();
          var _uvA = /*@__PURE__*/new _Vector();
          var _uvB = /*@__PURE__*/new _Vector();
          var _uvC = /*@__PURE__*/new _Vector();
          var _Sprite = /*#__PURE__*/function (_Object3D7) {
            _inherits(_Sprite, _Object3D7);
            var _super51 = _createSuper(_Sprite);
            function _Sprite(material) {
              var _this42;
              _classCallCheck2(this, _Sprite);
              _this42 = _super51.call(this);
              _this42.isSprite = true;
              _this42.type = 'Sprite';
              if (_geometry === undefined) {
                _geometry = new _BufferGeometry();
                var float32Array = new Float32Array([-0.5, -0.5, 0, 0, 0, 0.5, -0.5, 0, 1, 0, 0.5, 0.5, 0, 1, 1, -0.5, 0.5, 0, 0, 1]);
                var interleavedBuffer = new _InterleavedBuffer(float32Array, 5);
                _geometry.setIndex([0, 1, 2, 0, 2, 3]);
                _geometry.setAttribute('position', new _InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
                _geometry.setAttribute('uv', new _InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
              }
              _this42.geometry = _geometry;
              _this42.material = material !== undefined ? material : new _SpriteMaterial();
              _this42.center = new _Vector(0.5, 0.5);
              return _this42;
            }
            _createClass2(_Sprite, [{
              key: "raycast",
              value: function raycast(raycaster, intersects) {
                if (raycaster.camera === null) {
                  console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
                }
                _worldScale.setFromMatrixScale(this.matrixWorld);
                _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
                this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
                _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
                if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
                  _worldScale.multiplyScalar(-_mvPosition.z);
                }
                var rotation = this.material.rotation;
                var sin, cos;
                if (rotation !== 0) {
                  cos = Math.cos(rotation);
                  sin = Math.sin(rotation);
                }
                var center = this.center;
                transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
                transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
                transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
                _uvA.set(0, 0);
                _uvB.set(1, 0);
                _uvC.set(1, 1); // check first triangle
                var intersect = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);
                if (intersect === null) {
                  // check second triangle
                  transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
                  _uvB.set(0, 1);
                  intersect = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
                  if (intersect === null) {
                    return;
                  }
                }
                var distance = raycaster.ray.origin.distanceTo(_intersectPoint);
                if (distance < raycaster.near || distance > raycaster.far) return;
                intersects.push({
                  distance: distance,
                  point: _intersectPoint.clone(),
                  uv: _Triangle.getUV(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new _Vector()),
                  face: null,
                  object: this
                });
              }
            }, {
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Sprite.prototype), "copy", this).call(this, source, recursive);
                if (source.center !== undefined) this.center.copy(source.center);
                this.material = source.material;
                return this;
              }
            }]);
            return _Sprite;
          }(_Object3D);
          function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
            // compute position in camera space
            _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale); // to check if rotation is not zero
            if (sin !== undefined) {
              _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
              _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
            } else {
              _rotatedPosition.copy(_alignedPosition);
            }
            vertexPosition.copy(mvPosition);
            vertexPosition.x += _rotatedPosition.x;
            vertexPosition.y += _rotatedPosition.y; // transform to world space
            vertexPosition.applyMatrix4(_viewWorldMatrix);
          }
          var _v1$2 = /*@__PURE__*/new _Vector2();
          var _v2$1 = /*@__PURE__*/new _Vector2();
          var _LOD = /*#__PURE__*/function (_Object3D8) {
            _inherits(_LOD, _Object3D8);
            var _super52 = _createSuper(_LOD);
            function _LOD() {
              var _this43;
              _classCallCheck2(this, _LOD);
              _this43 = _super52.call(this);
              _this43._currentLevel = 0;
              _this43.type = 'LOD';
              Object.defineProperties(_assertThisInitialized(_this43), {
                levels: {
                  enumerable: true,
                  value: []
                },
                isLOD: {
                  value: true
                }
              });
              _this43.autoUpdate = true;
              return _this43;
            }
            _createClass2(_LOD, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_LOD.prototype), "copy", this).call(this, source, false);
                var levels = source.levels;
                for (var i = 0, l = levels.length; i < l; i++) {
                  var level = levels[i];
                  this.addLevel(level.object.clone(), level.distance, level.hysteresis);
                }
                this.autoUpdate = source.autoUpdate;
                return this;
              }
            }, {
              key: "addLevel",
              value: function addLevel(object) {
                var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var hysteresis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                distance = Math.abs(distance);
                var levels = this.levels;
                var l;
                for (l = 0; l < levels.length; l++) {
                  if (distance < levels[l].distance) {
                    break;
                  }
                }
                levels.splice(l, 0, {
                  distance: distance,
                  hysteresis: hysteresis,
                  object: object
                });
                this.add(object);
                return this;
              }
            }, {
              key: "getCurrentLevel",
              value: function getCurrentLevel() {
                return this._currentLevel;
              }
            }, {
              key: "getObjectForDistance",
              value: function getObjectForDistance(distance) {
                var levels = this.levels;
                if (levels.length > 0) {
                  var i, l;
                  for (i = 1, l = levels.length; i < l; i++) {
                    var levelDistance = levels[i].distance;
                    if (levels[i].object.visible) {
                      levelDistance -= levelDistance * levels[i].hysteresis;
                    }
                    if (distance < levelDistance) {
                      break;
                    }
                  }
                  return levels[i - 1].object;
                }
                return null;
              }
            }, {
              key: "raycast",
              value: function raycast(raycaster, intersects) {
                var levels = this.levels;
                if (levels.length > 0) {
                  _v1$2.setFromMatrixPosition(this.matrixWorld);
                  var distance = raycaster.ray.origin.distanceTo(_v1$2);
                  this.getObjectForDistance(distance).raycast(raycaster, intersects);
                }
              }
            }, {
              key: "update",
              value: function update(camera) {
                var levels = this.levels;
                if (levels.length > 1) {
                  _v1$2.setFromMatrixPosition(camera.matrixWorld);
                  _v2$1.setFromMatrixPosition(this.matrixWorld);
                  var distance = _v1$2.distanceTo(_v2$1) / camera.zoom;
                  levels[0].object.visible = true;
                  var i, l;
                  for (i = 1, l = levels.length; i < l; i++) {
                    var levelDistance = levels[i].distance;
                    if (levels[i].object.visible) {
                      levelDistance -= levelDistance * levels[i].hysteresis;
                    }
                    if (distance >= levelDistance) {
                      levels[i - 1].object.visible = false;
                      levels[i].object.visible = true;
                    } else {
                      break;
                    }
                  }
                  this._currentLevel = i - 1;
                  for (; i < l; i++) {
                    levels[i].object.visible = false;
                  }
                }
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_LOD.prototype), "toJSON", this).call(this, meta);
                if (this.autoUpdate === false) data.object.autoUpdate = false;
                data.object.levels = [];
                var levels = this.levels;
                for (var i = 0, l = levels.length; i < l; i++) {
                  var level = levels[i];
                  data.object.levels.push({
                    object: level.object.uuid,
                    distance: level.distance,
                    hysteresis: level.hysteresis
                  });
                }
                return data;
              }
            }]);
            return _LOD;
          }(_Object3D);
          var _basePosition = /*@__PURE__*/new _Vector2();
          var _skinIndex = /*@__PURE__*/new _Vector3();
          var _skinWeight = /*@__PURE__*/new _Vector3();
          var _vector$5 = /*@__PURE__*/new _Vector2();
          var _matrix = /*@__PURE__*/new _Matrix2();
          var _SkinnedMesh = /*#__PURE__*/function (_Mesh2) {
            _inherits(_SkinnedMesh, _Mesh2);
            var _super53 = _createSuper(_SkinnedMesh);
            function _SkinnedMesh(geometry, material) {
              var _this44;
              _classCallCheck2(this, _SkinnedMesh);
              _this44 = _super53.call(this, geometry, material);
              _this44.isSkinnedMesh = true;
              _this44.type = 'SkinnedMesh';
              _this44.bindMode = 'attached';
              _this44.bindMatrix = new _Matrix2();
              _this44.bindMatrixInverse = new _Matrix2();
              return _this44;
            }
            _createClass2(_SkinnedMesh, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_SkinnedMesh.prototype), "copy", this).call(this, source, recursive);
                this.bindMode = source.bindMode;
                this.bindMatrix.copy(source.bindMatrix);
                this.bindMatrixInverse.copy(source.bindMatrixInverse);
                this.skeleton = source.skeleton;
                return this;
              }
            }, {
              key: "bind",
              value: function bind(skeleton, bindMatrix) {
                this.skeleton = skeleton;
                if (bindMatrix === undefined) {
                  this.updateMatrixWorld(true);
                  this.skeleton.calculateInverses();
                  bindMatrix = this.matrixWorld;
                }
                this.bindMatrix.copy(bindMatrix);
                this.bindMatrixInverse.copy(bindMatrix).invert();
              }
            }, {
              key: "pose",
              value: function pose() {
                this.skeleton.pose();
              }
            }, {
              key: "normalizeSkinWeights",
              value: function normalizeSkinWeights() {
                var vector = new _Vector3();
                var skinWeight = this.geometry.attributes.skinWeight;
                for (var i = 0, l = skinWeight.count; i < l; i++) {
                  vector.fromBufferAttribute(skinWeight, i);
                  var scale = 1.0 / vector.manhattanLength();
                  if (scale !== Infinity) {
                    vector.multiplyScalar(scale);
                  } else {
                    vector.set(1, 0, 0, 0); // do something reasonable
                  }
                  skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
                }
              }
            }, {
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                _get2(_getPrototypeOf(_SkinnedMesh.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.bindMode === 'attached') {
                  this.bindMatrixInverse.copy(this.matrixWorld).invert();
                } else if (this.bindMode === 'detached') {
                  this.bindMatrixInverse.copy(this.bindMatrix).invert();
                } else {
                  console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
                }
              }
            }, {
              key: "boneTransform",
              value: function boneTransform(index, target) {
                var skeleton = this.skeleton;
                var geometry = this.geometry;
                _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
                _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
                _basePosition.copy(target).applyMatrix4(this.bindMatrix);
                target.set(0, 0, 0);
                for (var i = 0; i < 4; i++) {
                  var weight = _skinWeight.getComponent(i);
                  if (weight !== 0) {
                    var boneIndex = _skinIndex.getComponent(i);
                    _matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                    target.addScaledVector(_vector$5.copy(_basePosition).applyMatrix4(_matrix), weight);
                  }
                }
                return target.applyMatrix4(this.bindMatrixInverse);
              }
            }]);
            return _SkinnedMesh;
          }(_Mesh);
          var _Bone = /*#__PURE__*/function (_Object3D9) {
            _inherits(_Bone, _Object3D9);
            var _super54 = _createSuper(_Bone);
            function _Bone() {
              var _this45;
              _classCallCheck2(this, _Bone);
              _this45 = _super54.call(this);
              _this45.isBone = true;
              _this45.type = 'Bone';
              return _this45;
            }
            return _createClass2(_Bone);
          }(_Object3D);
          var _DataTexture = /*#__PURE__*/function (_Texture6) {
            _inherits(_DataTexture, _Texture6);
            var _super55 = _createSuper(_DataTexture);
            function _DataTexture() {
              var _this46;
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var format = arguments.length > 3 ? arguments[3] : undefined;
              var type = arguments.length > 4 ? arguments[4] : undefined;
              var mapping = arguments.length > 5 ? arguments[5] : undefined;
              var wrapS = arguments.length > 6 ? arguments[6] : undefined;
              var wrapT = arguments.length > 7 ? arguments[7] : undefined;
              var magFilter = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : _NearestFilter;
              var minFilter = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : _NearestFilter;
              var anisotropy = arguments.length > 10 ? arguments[10] : undefined;
              var encoding = arguments.length > 11 ? arguments[11] : undefined;
              _classCallCheck2(this, _DataTexture);
              _this46 = _super55.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
              _this46.isDataTexture = true;
              _this46.image = {
                data: data,
                width: width,
                height: height
              };
              _this46.generateMipmaps = false;
              _this46.flipY = false;
              _this46.unpackAlignment = 1;
              return _this46;
            }
            return _createClass2(_DataTexture);
          }(_Texture);
          var _offsetMatrix = /*@__PURE__*/new _Matrix2();
          var _identityMatrix = /*@__PURE__*/new _Matrix2();
          var _Skeleton = /*#__PURE__*/function () {
            function _Skeleton() {
              var bones = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var boneInverses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              _classCallCheck2(this, _Skeleton);
              this.uuid = generateUUID();
              this.bones = bones.slice(0);
              this.boneInverses = boneInverses;
              this.boneMatrices = null;
              this.boneTexture = null;
              this.boneTextureSize = 0;
              this.frame = -1;
              this.init();
            }
            _createClass2(_Skeleton, [{
              key: "init",
              value: function init() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                this.boneMatrices = new Float32Array(bones.length * 16); // calculate inverse bone matrices if necessary
                if (boneInverses.length === 0) {
                  this.calculateInverses();
                } else {
                  // handle special case
                  if (bones.length !== boneInverses.length) {
                    console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
                    this.boneInverses = [];
                    for (var i = 0, il = this.bones.length; i < il; i++) {
                      this.boneInverses.push(new _Matrix2());
                    }
                  }
                }
              }
            }, {
              key: "calculateInverses",
              value: function calculateInverses() {
                this.boneInverses.length = 0;
                for (var i = 0, il = this.bones.length; i < il; i++) {
                  var inverse = new _Matrix2();
                  if (this.bones[i]) {
                    inverse.copy(this.bones[i].matrixWorld).invert();
                  }
                  this.boneInverses.push(inverse);
                }
              }
            }, {
              key: "pose",
              value: function pose() {
                // recover the bind-time world matrices
                for (var i = 0, il = this.bones.length; i < il; i++) {
                  var bone = this.bones[i];
                  if (bone) {
                    bone.matrixWorld.copy(this.boneInverses[i]).invert();
                  }
                } // compute the local matrices, positions, rotations and scales
                for (var _i54 = 0, _il13 = this.bones.length; _i54 < _il13; _i54++) {
                  var _bone = this.bones[_i54];
                  if (_bone) {
                    if (_bone.parent && _bone.parent.isBone) {
                      _bone.matrix.copy(_bone.parent.matrixWorld).invert();
                      _bone.matrix.multiply(_bone.matrixWorld);
                    } else {
                      _bone.matrix.copy(_bone.matrixWorld);
                    }
                    _bone.matrix.decompose(_bone.position, _bone.quaternion, _bone.scale);
                  }
                }
              }
            }, {
              key: "update",
              value: function update() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                var boneMatrices = this.boneMatrices;
                var boneTexture = this.boneTexture; // flatten bone matrices to array
                for (var i = 0, il = bones.length; i < il; i++) {
                  // compute the offset between the current and the original transform
                  var matrix = bones[i] ? bones[i].matrixWorld : _identityMatrix;
                  _offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
                  _offsetMatrix.toArray(boneMatrices, i * 16);
                }
                if (boneTexture !== null) {
                  boneTexture.needsUpdate = true;
                }
              }
            }, {
              key: "clone",
              value: function clone() {
                return new _Skeleton(this.bones, this.boneInverses);
              }
            }, {
              key: "computeBoneTexture",
              value: function computeBoneTexture() {
                // layout (1 matrix = 4 pixels)
                //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
                //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
                //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
                //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
                var size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
                size = ceilPowerOfTwo(size);
                size = Math.max(size, 4);
                var boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                boneMatrices.set(this.boneMatrices); // copy current values
                var boneTexture = new _DataTexture(boneMatrices, size, size, _RGBAFormat, _FloatType);
                boneTexture.needsUpdate = true;
                this.boneMatrices = boneMatrices;
                this.boneTexture = boneTexture;
                this.boneTextureSize = size;
                return this;
              }
            }, {
              key: "getBoneByName",
              value: function getBoneByName(name) {
                for (var i = 0, il = this.bones.length; i < il; i++) {
                  var bone = this.bones[i];
                  if (bone.name === name) {
                    return bone;
                  }
                }
                return undefined;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                if (this.boneTexture !== null) {
                  this.boneTexture.dispose();
                  this.boneTexture = null;
                }
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json, bones) {
                this.uuid = json.uuid;
                for (var i = 0, l = json.bones.length; i < l; i++) {
                  var uuid = json.bones[i];
                  var bone = bones[uuid];
                  if (bone === undefined) {
                    console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                    bone = new _Bone();
                  }
                  this.bones.push(bone);
                  this.boneInverses.push(new _Matrix2().fromArray(json.boneInverses[i]));
                }
                this.init();
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = {
                  metadata: {
                    version: 4.5,
                    type: 'Skeleton',
                    generator: 'Skeleton.toJSON'
                  },
                  bones: [],
                  boneInverses: []
                };
                data.uuid = this.uuid;
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                for (var i = 0, l = bones.length; i < l; i++) {
                  var bone = bones[i];
                  data.bones.push(bone.uuid);
                  var boneInverse = boneInverses[i];
                  data.boneInverses.push(boneInverse.toArray());
                }
                return data;
              }
            }]);
            return _Skeleton;
          }();
          var _InstancedBufferAttribute = /*#__PURE__*/function (_BufferAttribute12) {
            _inherits(_InstancedBufferAttribute, _BufferAttribute12);
            var _super56 = _createSuper(_InstancedBufferAttribute);
            function _InstancedBufferAttribute(array, itemSize, normalized) {
              var _this47;
              var meshPerAttribute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              _classCallCheck2(this, _InstancedBufferAttribute);
              _this47 = _super56.call(this, array, itemSize, normalized);
              _this47.isInstancedBufferAttribute = true;
              _this47.meshPerAttribute = meshPerAttribute;
              return _this47;
            }
            _createClass2(_InstancedBufferAttribute, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_InstancedBufferAttribute.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_InstancedBufferAttribute.prototype), "toJSON", this).call(this);
                data.meshPerAttribute = this.meshPerAttribute;
                data.isInstancedBufferAttribute = true;
                return data;
              }
            }]);
            return _InstancedBufferAttribute;
          }(_BufferAttribute);
          var _instanceLocalMatrix = /*@__PURE__*/new _Matrix2();
          var _instanceWorldMatrix = /*@__PURE__*/new _Matrix2();
          var _instanceIntersects = [];
          var _identity = /*@__PURE__*/new _Matrix2();
          var _mesh = /*@__PURE__*/new _Mesh();
          var _InstancedMesh = /*#__PURE__*/function (_Mesh3) {
            _inherits(_InstancedMesh, _Mesh3);
            var _super57 = _createSuper(_InstancedMesh);
            function _InstancedMesh(geometry, material, count) {
              var _this48;
              _classCallCheck2(this, _InstancedMesh);
              _this48 = _super57.call(this, geometry, material);
              _this48.isInstancedMesh = true;
              _this48.instanceMatrix = new _InstancedBufferAttribute(new Float32Array(count * 16), 16);
              _this48.instanceColor = null;
              _this48.count = count;
              _this48.frustumCulled = false;
              for (var i = 0; i < count; i++) {
                _this48.setMatrixAt(i, _identity);
              }
              return _this48;
            }
            _createClass2(_InstancedMesh, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_InstancedMesh.prototype), "copy", this).call(this, source, recursive);
                this.instanceMatrix.copy(source.instanceMatrix);
                if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
                this.count = source.count;
                return this;
              }
            }, {
              key: "getColorAt",
              value: function getColorAt(index, color) {
                color.fromArray(this.instanceColor.array, index * 3);
              }
            }, {
              key: "getMatrixAt",
              value: function getMatrixAt(index, matrix) {
                matrix.fromArray(this.instanceMatrix.array, index * 16);
              }
            }, {
              key: "raycast",
              value: function raycast(raycaster, intersects) {
                var matrixWorld = this.matrixWorld;
                var raycastTimes = this.count;
                _mesh.geometry = this.geometry;
                _mesh.material = this.material;
                if (_mesh.material === undefined) return;
                for (var instanceId = 0; instanceId < raycastTimes; instanceId++) {
                  // calculate the world matrix for each instance
                  this.getMatrixAt(instanceId, _instanceLocalMatrix);
                  _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix); // the mesh represents this single instance
                  _mesh.matrixWorld = _instanceWorldMatrix;
                  _mesh.raycast(raycaster, _instanceIntersects); // process the result of raycast
                  for (var i = 0, l = _instanceIntersects.length; i < l; i++) {
                    var intersect = _instanceIntersects[i];
                    intersect.instanceId = instanceId;
                    intersect.object = this;
                    intersects.push(intersect);
                  }
                  _instanceIntersects.length = 0;
                }
              }
            }, {
              key: "setColorAt",
              value: function setColorAt(index, color) {
                if (this.instanceColor === null) {
                  this.instanceColor = new _InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3), 3);
                }
                color.toArray(this.instanceColor.array, index * 3);
              }
            }, {
              key: "setMatrixAt",
              value: function setMatrixAt(index, matrix) {
                matrix.toArray(this.instanceMatrix.array, index * 16);
              }
            }, {
              key: "updateMorphTargets",
              value: function updateMorphTargets() {}
            }, {
              key: "dispose",
              value: function dispose() {
                this.dispatchEvent({
                  type: 'dispose'
                });
              }
            }]);
            return _InstancedMesh;
          }(_Mesh);
          var _LineBasicMaterial = /*#__PURE__*/function (_Material7) {
            _inherits(_LineBasicMaterial, _Material7);
            var _super58 = _createSuper(_LineBasicMaterial);
            function _LineBasicMaterial(parameters) {
              var _this49;
              _classCallCheck2(this, _LineBasicMaterial);
              _this49 = _super58.call(this);
              _this49.isLineBasicMaterial = true;
              _this49.type = 'LineBasicMaterial';
              _this49.color = new _Color(0xffffff);
              _this49.linewidth = 1;
              _this49.linecap = 'round';
              _this49.linejoin = 'round';
              _this49.fog = true;
              _this49.setValues(parameters);
              return _this49;
            }
            _createClass2(_LineBasicMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_LineBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.linewidth = source.linewidth;
                this.linecap = source.linecap;
                this.linejoin = source.linejoin;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _LineBasicMaterial;
          }(_Material);
          var _start$1 = /*@__PURE__*/new _Vector2();
          var _end$1 = /*@__PURE__*/new _Vector2();
          var _inverseMatrix$1 = /*@__PURE__*/new _Matrix2();
          var _ray$1 = /*@__PURE__*/new _Ray();
          var _sphere$1 = /*@__PURE__*/new _Sphere();
          var _Line = /*#__PURE__*/function (_Object3D10) {
            _inherits(_Line, _Object3D10);
            var _super59 = _createSuper(_Line);
            function _Line() {
              var _this50;
              var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _BufferGeometry();
              var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _LineBasicMaterial();
              _classCallCheck2(this, _Line);
              _this50 = _super59.call(this);
              _this50.isLine = true;
              _this50.type = 'Line';
              _this50.geometry = geometry;
              _this50.material = material;
              _this50.updateMorphTargets();
              return _this50;
            }
            _createClass2(_Line, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Line.prototype), "copy", this).call(this, source, recursive);
                this.material = source.material;
                this.geometry = source.geometry;
                return this;
              }
            }, {
              key: "computeLineDistances",
              value: function computeLineDistances() {
                var geometry = this.geometry; // we assume non-indexed geometry
                if (geometry.index === null) {
                  var positionAttribute = geometry.attributes.position;
                  var lineDistances = [0];
                  for (var i = 1, l = positionAttribute.count; i < l; i++) {
                    _start$1.fromBufferAttribute(positionAttribute, i - 1);
                    _end$1.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += _start$1.distanceTo(_end$1);
                  }
                  geometry.setAttribute('lineDistance', new _Float32BufferAttribute(lineDistances, 1));
                } else {
                  console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                }
                return this;
              }
            }, {
              key: "raycast",
              value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Line.threshold;
                var drawRange = geometry.drawRange; // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                _sphere$1.copy(geometry.boundingSphere);
                _sphere$1.applyMatrix4(matrixWorld);
                _sphere$1.radius += threshold;
                if (raycaster.ray.intersectsSphere(_sphere$1) === false) return; //
                _inverseMatrix$1.copy(matrixWorld).invert();
                _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var vStart = new _Vector2();
                var vEnd = new _Vector2();
                var interSegment = new _Vector2();
                var interRay = new _Vector2();
                var step = this.isLineSegments ? 2 : 1;
                var index = geometry.index;
                var attributes = geometry.attributes;
                var positionAttribute = attributes.position;
                if (index !== null) {
                  var start = Math.max(0, drawRange.start);
                  var end = Math.min(index.count, drawRange.start + drawRange.count);
                  for (var i = start, l = end - 1; i < l; i += step) {
                    var a = index.getX(i);
                    var b = index.getX(i + 1);
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    var distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    var distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                      distance: distance,
                      // What do we want? intersection point on the ray or on the segment??
                      // point: raycaster.ray.at( distance ),
                      point: interSegment.clone().applyMatrix4(this.matrixWorld),
                      index: i,
                      face: null,
                      faceIndex: null,
                      object: this
                    });
                  }
                } else {
                  var _start6 = Math.max(0, drawRange.start);
                  var _end5 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                  for (var _i55 = _start6, _l7 = _end5 - 1; _i55 < _l7; _i55 += step) {
                    vStart.fromBufferAttribute(positionAttribute, _i55);
                    vEnd.fromBufferAttribute(positionAttribute, _i55 + 1);
                    var _distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (_distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    var _distance = raycaster.ray.origin.distanceTo(interRay);
                    if (_distance < raycaster.near || _distance > raycaster.far) continue;
                    intersects.push({
                      distance: _distance,
                      // What do we want? intersection point on the ray or on the segment??
                      // point: raycaster.ray.at( distance ),
                      point: interSegment.clone().applyMatrix4(this.matrixWorld),
                      index: _i55,
                      face: null,
                      faceIndex: null,
                      object: this
                    });
                  }
                }
              }
            }, {
              key: "updateMorphTargets",
              value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                  var morphAttribute = morphAttributes[keys[0]];
                  if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for (var m = 0, ml = morphAttribute.length; m < ml; m++) {
                      var name = morphAttribute[m].name || String(m);
                      this.morphTargetInfluences.push(0);
                      this.morphTargetDictionary[name] = m;
                    }
                  }
                }
              }
            }]);
            return _Line;
          }(_Object3D);
          var _start = /*@__PURE__*/new _Vector2();
          var _end = /*@__PURE__*/new _Vector2();
          var _LineSegments = /*#__PURE__*/function (_Line3) {
            _inherits(_LineSegments, _Line3);
            var _super60 = _createSuper(_LineSegments);
            function _LineSegments(geometry, material) {
              var _this51;
              _classCallCheck2(this, _LineSegments);
              _this51 = _super60.call(this, geometry, material);
              _this51.isLineSegments = true;
              _this51.type = 'LineSegments';
              return _this51;
            }
            _createClass2(_LineSegments, [{
              key: "computeLineDistances",
              value: function computeLineDistances() {
                var geometry = this.geometry; // we assume non-indexed geometry
                if (geometry.index === null) {
                  var positionAttribute = geometry.attributes.position;
                  var lineDistances = [];
                  for (var i = 0, l = positionAttribute.count; i < l; i += 2) {
                    _start.fromBufferAttribute(positionAttribute, i);
                    _end.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + _start.distanceTo(_end);
                  }
                  geometry.setAttribute('lineDistance', new _Float32BufferAttribute(lineDistances, 1));
                } else {
                  console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                }
                return this;
              }
            }]);
            return _LineSegments;
          }(_Line);
          var _LineLoop = /*#__PURE__*/function (_Line4) {
            _inherits(_LineLoop, _Line4);
            var _super61 = _createSuper(_LineLoop);
            function _LineLoop(geometry, material) {
              var _this52;
              _classCallCheck2(this, _LineLoop);
              _this52 = _super61.call(this, geometry, material);
              _this52.isLineLoop = true;
              _this52.type = 'LineLoop';
              return _this52;
            }
            return _createClass2(_LineLoop);
          }(_Line);
          var _PointsMaterial = /*#__PURE__*/function (_Material8) {
            _inherits(_PointsMaterial, _Material8);
            var _super62 = _createSuper(_PointsMaterial);
            function _PointsMaterial(parameters) {
              var _this53;
              _classCallCheck2(this, _PointsMaterial);
              _this53 = _super62.call(this);
              _this53.isPointsMaterial = true;
              _this53.type = 'PointsMaterial';
              _this53.color = new _Color(0xffffff);
              _this53.map = null;
              _this53.alphaMap = null;
              _this53.size = 1;
              _this53.sizeAttenuation = true;
              _this53.fog = true;
              _this53.setValues(parameters);
              return _this53;
            }
            _createClass2(_PointsMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_PointsMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.size = source.size;
                this.sizeAttenuation = source.sizeAttenuation;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _PointsMaterial;
          }(_Material);
          var _inverseMatrix = /*@__PURE__*/new _Matrix2();
          var _ray = /*@__PURE__*/new _Ray();
          var _sphere = /*@__PURE__*/new _Sphere();
          var _position$2 = /*@__PURE__*/new _Vector2();
          var _Points = /*#__PURE__*/function (_Object3D11) {
            _inherits(_Points, _Object3D11);
            var _super63 = _createSuper(_Points);
            function _Points() {
              var _this54;
              var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _BufferGeometry();
              var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _PointsMaterial();
              _classCallCheck2(this, _Points);
              _this54 = _super63.call(this);
              _this54.isPoints = true;
              _this54.type = 'Points';
              _this54.geometry = geometry;
              _this54.material = material;
              _this54.updateMorphTargets();
              return _this54;
            }
            _createClass2(_Points, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Points.prototype), "copy", this).call(this, source, recursive);
                this.material = source.material;
                this.geometry = source.geometry;
                return this;
              }
            }, {
              key: "raycast",
              value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Points.threshold;
                var drawRange = geometry.drawRange; // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                _sphere.copy(geometry.boundingSphere);
                _sphere.applyMatrix4(matrixWorld);
                _sphere.radius += threshold;
                if (raycaster.ray.intersectsSphere(_sphere) === false) return; //
                _inverseMatrix.copy(matrixWorld).invert();
                _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var index = geometry.index;
                var attributes = geometry.attributes;
                var positionAttribute = attributes.position;
                if (index !== null) {
                  var start = Math.max(0, drawRange.start);
                  var end = Math.min(index.count, drawRange.start + drawRange.count);
                  for (var i = start, il = end; i < il; i++) {
                    var a = index.getX(i);
                    _position$2.fromBufferAttribute(positionAttribute, a);
                    testPoint(_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                  }
                } else {
                  var _start7 = Math.max(0, drawRange.start);
                  var _end6 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                  for (var _i56 = _start7, l = _end6; _i56 < l; _i56++) {
                    _position$2.fromBufferAttribute(positionAttribute, _i56);
                    testPoint(_position$2, _i56, localThresholdSq, matrixWorld, raycaster, intersects, this);
                  }
                }
              }
            }, {
              key: "updateMorphTargets",
              value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                  var morphAttribute = morphAttributes[keys[0]];
                  if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for (var m = 0, ml = morphAttribute.length; m < ml; m++) {
                      var name = morphAttribute[m].name || String(m);
                      this.morphTargetInfluences.push(0);
                      this.morphTargetDictionary[name] = m;
                    }
                  }
                }
              }
            }]);
            return _Points;
          }(_Object3D);
          function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
            var rayPointDistanceSq = _ray.distanceSqToPoint(point);
            if (rayPointDistanceSq < localThresholdSq) {
              var intersectPoint = new _Vector2();
              _ray.closestPointToPoint(point, intersectPoint);
              intersectPoint.applyMatrix4(matrixWorld);
              var distance = raycaster.ray.origin.distanceTo(intersectPoint);
              if (distance < raycaster.near || distance > raycaster.far) return;
              intersects.push({
                distance: distance,
                distanceToRay: Math.sqrt(rayPointDistanceSq),
                point: intersectPoint,
                index: index,
                face: null,
                object: object
              });
            }
          }
          var _VideoTexture = /*#__PURE__*/function (_Texture7) {
            _inherits(_VideoTexture, _Texture7);
            var _super64 = _createSuper(_VideoTexture);
            function _VideoTexture(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
              var _this55;
              _classCallCheck2(this, _VideoTexture);
              _this55 = _super64.call(this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
              _this55.isVideoTexture = true;
              _this55.minFilter = minFilter !== undefined ? minFilter : _LinearFilter;
              _this55.magFilter = magFilter !== undefined ? magFilter : _LinearFilter;
              _this55.generateMipmaps = false;
              var scope = _assertThisInitialized(_this55);
              function updateVideo() {
                scope.needsUpdate = true;
                video.requestVideoFrameCallback(updateVideo);
              }
              if ('requestVideoFrameCallback' in video) {
                video.requestVideoFrameCallback(updateVideo);
              }
              return _this55;
            }
            _createClass2(_VideoTexture, [{
              key: "clone",
              value: function clone() {
                return new this.constructor(this.image).copy(this);
              }
            }, {
              key: "update",
              value: function update() {
                var video = this.image;
                var hasVideoFrameCallback = ('requestVideoFrameCallback' in video);
                if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
                  this.needsUpdate = true;
                }
              }
            }]);
            return _VideoTexture;
          }(_Texture);
          var _FramebufferTexture = /*#__PURE__*/function (_Texture8) {
            _inherits(_FramebufferTexture, _Texture8);
            var _super65 = _createSuper(_FramebufferTexture);
            function _FramebufferTexture(width, height, format) {
              var _this56;
              _classCallCheck2(this, _FramebufferTexture);
              _this56 = _super65.call(this, {
                width: width,
                height: height
              });
              _this56.isFramebufferTexture = true;
              _this56.format = format;
              _this56.magFilter = _NearestFilter;
              _this56.minFilter = _NearestFilter;
              _this56.generateMipmaps = false;
              _this56.needsUpdate = true;
              return _this56;
            }
            return _createClass2(_FramebufferTexture);
          }(_Texture);
          var _CompressedTexture = /*#__PURE__*/function (_Texture9) {
            _inherits(_CompressedTexture, _Texture9);
            var _super66 = _createSuper(_CompressedTexture);
            function _CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
              var _this57;
              _classCallCheck2(this, _CompressedTexture);
              _this57 = _super66.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
              _this57.isCompressedTexture = true;
              _this57.image = {
                width: width,
                height: height
              };
              _this57.mipmaps = mipmaps; // no flipping for cube textures
              // (also flipping doesn't work for compressed textures )
              _this57.flipY = false; // can't generate mipmaps for compressed textures
              // mips must be embedded in DDS files
              _this57.generateMipmaps = false;
              return _this57;
            }
            return _createClass2(_CompressedTexture);
          }(_Texture);
          var _CompressedArrayTexture = /*#__PURE__*/function (_CompressedTexture2) {
            _inherits(_CompressedArrayTexture, _CompressedTexture2);
            var _super67 = _createSuper(_CompressedArrayTexture);
            function _CompressedArrayTexture(mipmaps, width, height, depth, format, type) {
              var _this58;
              _classCallCheck2(this, _CompressedArrayTexture);
              _this58 = _super67.call(this, mipmaps, width, height, format, type);
              _this58.isCompressedArrayTexture = true;
              _this58.image.depth = depth;
              _this58.wrapR = _ClampToEdgeWrapping;
              return _this58;
            }
            return _createClass2(_CompressedArrayTexture);
          }(_CompressedTexture);
          var _CanvasTexture = /*#__PURE__*/function (_Texture10) {
            _inherits(_CanvasTexture, _Texture10);
            var _super68 = _createSuper(_CanvasTexture);
            function _CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
              var _this59;
              _classCallCheck2(this, _CanvasTexture);
              _this59 = _super68.call(this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
              _this59.isCanvasTexture = true;
              _this59.needsUpdate = true;
              return _this59;
            }
            return _createClass2(_CanvasTexture);
          }(_Texture);
          /**
          * Extensible curve object.
          *
          * Some common of curve methods:
          * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
          * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
          * .getPoints(), .getSpacedPoints()
          * .getLength()
          * .updateArcLengths()
          *
          * This following curves inherit from THREE.Curve:
          *
          * -- 2D curves --
          * THREE.ArcCurve
          * THREE.CubicBezierCurve
          * THREE.EllipseCurve
          * THREE.LineCurve
          * THREE.QuadraticBezierCurve
          * THREE.SplineCurve
          *
          * -- 3D curves --
          * THREE.CatmullRomCurve3
          * THREE.CubicBezierCurve3
          * THREE.LineCurve3
          * THREE.QuadraticBezierCurve3
          *
          * A series of curves can be represented as a THREE.CurvePath.
          *
          **/
          var _Curve = /*#__PURE__*/function () {
            function _Curve() {
              _classCallCheck2(this, _Curve);
              this.type = 'Curve';
              this.arcLengthDivisions = 200;
            } // Virtual base class method to overwrite and implement in subclasses
            //	- t [0 .. 1]
            _createClass2(_Curve, [{
              key: "getPoint",
              value: function getPoint( /* t, optionalTarget */) {
                console.warn('THREE.Curve: .getPoint() not implemented.');
                return null;
              } // Get point at relative position in curve according to arc length
              // - u [0 .. 1]
            }, {
              key: "getPointAt",
              value: function getPointAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getPoint(t, optionalTarget);
              } // Get sequence of points using getPoint( t )
            }, {
              key: "getPoints",
              value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
                var points = [];
                for (var d = 0; d <= divisions; d++) {
                  points.push(this.getPoint(d / divisions));
                }
                return points;
              } // Get sequence of points using getPointAt( u )
            }, {
              key: "getSpacedPoints",
              value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
                var points = [];
                for (var d = 0; d <= divisions; d++) {
                  points.push(this.getPointAt(d / divisions));
                }
                return points;
              } // Get total curve arc length
            }, {
              key: "getLength",
              value: function getLength() {
                var lengths = this.getLengths();
                return lengths[lengths.length - 1];
              } // Get list of cumulative segment lengths
            }, {
              key: "getLengths",
              value: function getLengths() {
                var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.arcLengthDivisions;
                if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
                  return this.cacheArcLengths;
                }
                this.needsUpdate = false;
                var cache = [];
                var current,
                  last = this.getPoint(0);
                var sum = 0;
                cache.push(0);
                for (var p = 1; p <= divisions; p++) {
                  current = this.getPoint(p / divisions);
                  sum += current.distanceTo(last);
                  cache.push(sum);
                  last = current;
                }
                this.cacheArcLengths = cache;
                return cache; // { sums: cache, sum: sum }; Sum is in the last element.
              }
            }, {
              key: "updateArcLengths",
              value: function updateArcLengths() {
                this.needsUpdate = true;
                this.getLengths();
              } // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
            }, {
              key: "getUtoTmapping",
              value: function getUtoTmapping(u, distance) {
                var arcLengths = this.getLengths();
                var i = 0;
                var il = arcLengths.length;
                var targetArcLength; // The targeted u distance value to get
                if (distance) {
                  targetArcLength = distance;
                } else {
                  targetArcLength = u * arcLengths[il - 1];
                } // binary search for the index with largest value smaller than target u distance
                var low = 0,
                  high = il - 1,
                  comparison;
                while (low <= high) {
                  i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                  comparison = arcLengths[i] - targetArcLength;
                  if (comparison < 0) {
                    low = i + 1;
                  } else if (comparison > 0) {
                    high = i - 1;
                  } else {
                    high = i;
                    break; // DONE
                  }
                }
                i = high;
                if (arcLengths[i] === targetArcLength) {
                  return i / (il - 1);
                } // we could get finer grain at lengths, or use simple interpolation between two points
                var lengthBefore = arcLengths[i];
                var lengthAfter = arcLengths[i + 1];
                var segmentLength = lengthAfter - lengthBefore; // determine where we are between the 'before' and 'after' points
                var segmentFraction = (targetArcLength - lengthBefore) / segmentLength; // add that fractional amount to t
                var t = (i + segmentFraction) / (il - 1);
                return t;
              } // Returns a unit vector tangent at t
              // In case any sub curve does not implement its tangent derivation,
              // 2 points a small delta apart will be used to find its gradient
              // which seems to give a reasonable approximation
            }, {
              key: "getTangent",
              value: function getTangent(t, optionalTarget) {
                var delta = 0.0001;
                var t1 = t - delta;
                var t2 = t + delta; // Capping in case of danger
                if (t1 < 0) t1 = 0;
                if (t2 > 1) t2 = 1;
                var pt1 = this.getPoint(t1);
                var pt2 = this.getPoint(t2);
                var tangent = optionalTarget || (pt1.isVector2 ? new _Vector() : new _Vector2());
                tangent.copy(pt2).sub(pt1).normalize();
                return tangent;
              }
            }, {
              key: "getTangentAt",
              value: function getTangentAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getTangent(t, optionalTarget);
              }
            }, {
              key: "computeFrenetFrames",
              value: function computeFrenetFrames(segments, closed) {
                // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
                var normal = new _Vector2();
                var tangents = [];
                var normals = [];
                var binormals = [];
                var vec = new _Vector2();
                var mat = new _Matrix2(); // compute the tangent vectors for each segment on the curve
                for (var i = 0; i <= segments; i++) {
                  var u = i / segments;
                  tangents[i] = this.getTangentAt(u, new _Vector2());
                } // select an initial normal vector perpendicular to the first tangent vector,
                // and in the direction of the minimum tangent xyz component
                normals[0] = new _Vector2();
                binormals[0] = new _Vector2();
                var min = Number.MAX_VALUE;
                var tx = Math.abs(tangents[0].x);
                var ty = Math.abs(tangents[0].y);
                var tz = Math.abs(tangents[0].z);
                if (tx <= min) {
                  min = tx;
                  normal.set(1, 0, 0);
                }
                if (ty <= min) {
                  min = ty;
                  normal.set(0, 1, 0);
                }
                if (tz <= min) {
                  normal.set(0, 0, 1);
                }
                vec.crossVectors(tangents[0], normal).normalize();
                normals[0].crossVectors(tangents[0], vec);
                binormals[0].crossVectors(tangents[0], normals[0]); // compute the slowly-varying normal and binormal vectors for each segment on the curve
                for (var _i57 = 1; _i57 <= segments; _i57++) {
                  normals[_i57] = normals[_i57 - 1].clone();
                  binormals[_i57] = binormals[_i57 - 1].clone();
                  vec.crossVectors(tangents[_i57 - 1], tangents[_i57]);
                  if (vec.length() > Number.EPSILON) {
                    vec.normalize();
                    var theta = Math.acos(clamp(tangents[_i57 - 1].dot(tangents[_i57]), -1, 1)); // clamp for floating pt errors
                    normals[_i57].applyMatrix4(mat.makeRotationAxis(vec, theta));
                  }
                  binormals[_i57].crossVectors(tangents[_i57], normals[_i57]);
                } // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
                if (closed === true) {
                  var _theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));
                  _theta /= segments;
                  if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
                    _theta = -_theta;
                  }
                  for (var _i58 = 1; _i58 <= segments; _i58++) {
                    // twist a little...
                    normals[_i58].applyMatrix4(mat.makeRotationAxis(tangents[_i58], _theta * _i58));
                    binormals[_i58].crossVectors(tangents[_i58], normals[_i58]);
                  }
                }
                return {
                  tangents: tangents,
                  normals: normals,
                  binormals: binormals
                };
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.arcLengthDivisions = source.arcLengthDivisions;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = {
                  metadata: {
                    version: 4.5,
                    type: 'Curve',
                    generator: 'Curve.toJSON'
                  }
                };
                data.arcLengthDivisions = this.arcLengthDivisions;
                data.type = this.type;
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                this.arcLengthDivisions = json.arcLengthDivisions;
                return this;
              }
            }]);
            return _Curve;
          }();
          var _EllipseCurve = /*#__PURE__*/function (_Curve2) {
            _inherits(_EllipseCurve, _Curve2);
            var _super69 = _createSuper(_EllipseCurve);
            function _EllipseCurve() {
              var _this60;
              var aX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var aY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var xRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var yRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              var aStartAngle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
              var aEndAngle = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.PI * 2;
              var aClockwise = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
              var aRotation = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
              _classCallCheck2(this, _EllipseCurve);
              _this60 = _super69.call(this);
              _this60.isEllipseCurve = true;
              _this60.type = 'EllipseCurve';
              _this60.aX = aX;
              _this60.aY = aY;
              _this60.xRadius = xRadius;
              _this60.yRadius = yRadius;
              _this60.aStartAngle = aStartAngle;
              _this60.aEndAngle = aEndAngle;
              _this60.aClockwise = aClockwise;
              _this60.aRotation = aRotation;
              return _this60;
            }
            _createClass2(_EllipseCurve, [{
              key: "getPoint",
              value: function getPoint(t, optionalTarget) {
                var point = optionalTarget || new _Vector();
                var twoPi = Math.PI * 2;
                var deltaAngle = this.aEndAngle - this.aStartAngle;
                var samePoints = Math.abs(deltaAngle) < Number.EPSILON; // ensures that deltaAngle is 0 .. 2 PI
                while (deltaAngle < 0) deltaAngle += twoPi;
                while (deltaAngle > twoPi) deltaAngle -= twoPi;
                if (deltaAngle < Number.EPSILON) {
                  if (samePoints) {
                    deltaAngle = 0;
                  } else {
                    deltaAngle = twoPi;
                  }
                }
                if (this.aClockwise === true && !samePoints) {
                  if (deltaAngle === twoPi) {
                    deltaAngle = -twoPi;
                  } else {
                    deltaAngle = deltaAngle - twoPi;
                  }
                }
                var angle = this.aStartAngle + t * deltaAngle;
                var x = this.aX + this.xRadius * Math.cos(angle);
                var y = this.aY + this.yRadius * Math.sin(angle);
                if (this.aRotation !== 0) {
                  var cos = Math.cos(this.aRotation);
                  var sin = Math.sin(this.aRotation);
                  var tx = x - this.aX;
                  var ty = y - this.aY; // Rotate the point about the center of the ellipse.
                  x = tx * cos - ty * sin + this.aX;
                  y = tx * sin + ty * cos + this.aY;
                }
                return point.set(x, y);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_EllipseCurve.prototype), "copy", this).call(this, source);
                this.aX = source.aX;
                this.aY = source.aY;
                this.xRadius = source.xRadius;
                this.yRadius = source.yRadius;
                this.aStartAngle = source.aStartAngle;
                this.aEndAngle = source.aEndAngle;
                this.aClockwise = source.aClockwise;
                this.aRotation = source.aRotation;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_EllipseCurve.prototype), "toJSON", this).call(this);
                data.aX = this.aX;
                data.aY = this.aY;
                data.xRadius = this.xRadius;
                data.yRadius = this.yRadius;
                data.aStartAngle = this.aStartAngle;
                data.aEndAngle = this.aEndAngle;
                data.aClockwise = this.aClockwise;
                data.aRotation = this.aRotation;
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_EllipseCurve.prototype), "fromJSON", this).call(this, json);
                this.aX = json.aX;
                this.aY = json.aY;
                this.xRadius = json.xRadius;
                this.yRadius = json.yRadius;
                this.aStartAngle = json.aStartAngle;
                this.aEndAngle = json.aEndAngle;
                this.aClockwise = json.aClockwise;
                this.aRotation = json.aRotation;
                return this;
              }
            }]);
            return _EllipseCurve;
          }(_Curve);
          var _ArcCurve = /*#__PURE__*/function (_EllipseCurve2) {
            _inherits(_ArcCurve, _EllipseCurve2);
            var _super70 = _createSuper(_ArcCurve);
            function _ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
              var _this61;
              _classCallCheck2(this, _ArcCurve);
              _this61 = _super70.call(this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
              _this61.isArcCurve = true;
              _this61.type = 'ArcCurve';
              return _this61;
            }
            return _createClass2(_ArcCurve);
          }(_EllipseCurve);
          /**
          * Centripetal CatmullRom Curve - which is useful for avoiding
          * cusps and self-intersections in non-uniform catmull rom curves.
          * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
          *
          * curve.type accepts centripetal(default), chordal and catmullrom
          * curve.tension is used for catmullrom which defaults to 0.5
          */
          /*
          Based on an optimized c++ solution in
          - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
          - http://ideone.com/NoEbVM
          This CubicPoly class could be used for reusing some variables and calculations,
          but for three.js curve use, it could be possible inlined and flatten into a single function call
          which can be placed in CurveUtils.
          */
          function CubicPoly() {
            var c0 = 0,
              c1 = 0,
              c2 = 0,
              c3 = 0; /*
                      * Compute coefficients for a cubic polynomial
                      *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
                      * such that
                      *   p(0) = x0, p(1) = x1
                      *  and
                      *   p'(0) = t0, p'(1) = t1.
                      */
            function init(x0, x1, t0, t1) {
              c0 = x0;
              c1 = t0;
              c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
              c3 = 2 * x0 - 2 * x1 + t0 + t1;
            }
            return {
              initCatmullRom: function initCatmullRom(x0, x1, x2, x3, tension) {
                init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
              },
              initNonuniformCatmullRom: function initNonuniformCatmullRom(x0, x1, x2, x3, dt0, dt1, dt2) {
                // compute tangents when parameterized in [t1,t2]
                var t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
                var t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2; // rescale tangents for parametrization in [0,1]
                t1 *= dt1;
                t2 *= dt1;
                init(x1, x2, t1, t2);
              },
              calc: function calc(t) {
                var t2 = t * t;
                var t3 = t2 * t;
                return c0 + c1 * t + c2 * t2 + c3 * t3;
              }
            };
          } //
          var tmp = /*@__PURE__*/new _Vector2();
          var px = /*@__PURE__*/new CubicPoly();
          var py = /*@__PURE__*/new CubicPoly();
          var pz = /*@__PURE__*/new CubicPoly();
          var _CatmullRomCurve = /*#__PURE__*/function (_Curve3) {
            _inherits(_CatmullRomCurve, _Curve3);
            var _super71 = _createSuper(_CatmullRomCurve);
            function _CatmullRomCurve() {
              var _this62;
              var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var curveType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'centripetal';
              var tension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
              _classCallCheck2(this, _CatmullRomCurve);
              _this62 = _super71.call(this);
              _this62.isCatmullRomCurve3 = true;
              _this62.type = 'CatmullRomCurve3';
              _this62.points = points;
              _this62.closed = closed;
              _this62.curveType = curveType;
              _this62.tension = tension;
              return _this62;
            }
            _createClass2(_CatmullRomCurve, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
                var point = optionalTarget;
                var points = this.points;
                var l = points.length;
                var p = (l - (this.closed ? 0 : 1)) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                if (this.closed) {
                  intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
                } else if (weight === 0 && intPoint === l - 1) {
                  intPoint = l - 2;
                  weight = 1;
                }
                var p0, p3; // 4 points (p1 & p2 defined below)
                if (this.closed || intPoint > 0) {
                  p0 = points[(intPoint - 1) % l];
                } else {
                  // extrapolate first point
                  tmp.subVectors(points[0], points[1]).add(points[0]);
                  p0 = tmp;
                }
                var p1 = points[intPoint % l];
                var p2 = points[(intPoint + 1) % l];
                if (this.closed || intPoint + 2 < l) {
                  p3 = points[(intPoint + 2) % l];
                } else {
                  // extrapolate last point
                  tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
                  p3 = tmp;
                }
                if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
                  // init Centripetal / Chordal Catmull-Rom
                  var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
                  var dt0 = Math.pow(p0.distanceToSquared(p1), pow);
                  var dt1 = Math.pow(p1.distanceToSquared(p2), pow);
                  var dt2 = Math.pow(p2.distanceToSquared(p3), pow); // safety check for repeated points
                  if (dt1 < 1e-4) dt1 = 1.0;
                  if (dt0 < 1e-4) dt0 = dt1;
                  if (dt2 < 1e-4) dt2 = dt1;
                  px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
                  py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
                  pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
                } else if (this.curveType === 'catmullrom') {
                  px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
                  py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
                  pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
                }
                point.set(px.calc(weight), py.calc(weight), pz.calc(weight));
                return point;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_CatmullRomCurve.prototype), "copy", this).call(this, source);
                this.points = [];
                for (var i = 0, l = source.points.length; i < l; i++) {
                  var point = source.points[i];
                  this.points.push(point.clone());
                }
                this.closed = source.closed;
                this.curveType = source.curveType;
                this.tension = source.tension;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_CatmullRomCurve.prototype), "toJSON", this).call(this);
                data.points = [];
                for (var i = 0, l = this.points.length; i < l; i++) {
                  var point = this.points[i];
                  data.points.push(point.toArray());
                }
                data.closed = this.closed;
                data.curveType = this.curveType;
                data.tension = this.tension;
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_CatmullRomCurve.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for (var i = 0, l = json.points.length; i < l; i++) {
                  var point = json.points[i];
                  this.points.push(new _Vector2().fromArray(point));
                }
                this.closed = json.closed;
                this.curveType = json.curveType;
                this.tension = json.tension;
                return this;
              }
            }]);
            return _CatmullRomCurve;
          }(_Curve);
          /**
          * Bezier Curves formulas obtained from
          * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
          */
          function CatmullRom(t, p0, p1, p2, p3) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
          } //
          function QuadraticBezierP0(t, p) {
            var k = 1 - t;
            return k * k * p;
          }
          function QuadraticBezierP1(t, p) {
            return 2 * (1 - t) * t * p;
          }
          function QuadraticBezierP2(t, p) {
            return t * t * p;
          }
          function QuadraticBezier(t, p0, p1, p2) {
            return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
          } //
          function CubicBezierP0(t, p) {
            var k = 1 - t;
            return k * k * k * p;
          }
          function CubicBezierP1(t, p) {
            var k = 1 - t;
            return 3 * k * k * t * p;
          }
          function CubicBezierP2(t, p) {
            return 3 * (1 - t) * t * t * p;
          }
          function CubicBezierP3(t, p) {
            return t * t * t * p;
          }
          function CubicBezier(t, p0, p1, p2, p3) {
            return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
          }
          var _CubicBezierCurve = /*#__PURE__*/function (_Curve4) {
            _inherits(_CubicBezierCurve, _Curve4);
            var _super72 = _createSuper(_CubicBezierCurve);
            function _CubicBezierCurve() {
              var _this63;
              var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector();
              var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
              var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Vector();
              var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _Vector();
              _classCallCheck2(this, _CubicBezierCurve);
              _this63 = _super72.call(this);
              _this63.isCubicBezierCurve = true;
              _this63.type = 'CubicBezierCurve';
              _this63.v0 = v0;
              _this63.v1 = v1;
              _this63.v2 = v2;
              _this63.v3 = v3;
              return _this63;
            }
            _createClass2(_CubicBezierCurve, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
                var point = optionalTarget;
                var v0 = this.v0,
                  v1 = this.v1,
                  v2 = this.v2,
                  v3 = this.v3;
                point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
                return point;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_CubicBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_CubicBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_CubicBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
              }
            }]);
            return _CubicBezierCurve;
          }(_Curve);
          var _CubicBezierCurve2 = /*#__PURE__*/function (_Curve5) {
            _inherits(_CubicBezierCurve2, _Curve5);
            var _super73 = _createSuper(_CubicBezierCurve2);
            function _CubicBezierCurve2() {
              var _this64;
              var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
              var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Vector2();
              var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _Vector2();
              _classCallCheck2(this, _CubicBezierCurve2);
              _this64 = _super73.call(this);
              _this64.isCubicBezierCurve3 = true;
              _this64.type = 'CubicBezierCurve3';
              _this64.v0 = v0;
              _this64.v1 = v1;
              _this64.v2 = v2;
              _this64.v3 = v3;
              return _this64;
            }
            _createClass2(_CubicBezierCurve2, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
                var point = optionalTarget;
                var v0 = this.v0,
                  v1 = this.v1,
                  v2 = this.v2,
                  v3 = this.v3;
                point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y), CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
                return point;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_CubicBezierCurve2.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_CubicBezierCurve2.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_CubicBezierCurve2.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
              }
            }]);
            return _CubicBezierCurve2;
          }(_Curve);
          var _LineCurve = /*#__PURE__*/function (_Curve6) {
            _inherits(_LineCurve, _Curve6);
            var _super74 = _createSuper(_LineCurve);
            function _LineCurve() {
              var _this65;
              var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector();
              var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
              _classCallCheck2(this, _LineCurve);
              _this65 = _super74.call(this);
              _this65.isLineCurve = true;
              _this65.type = 'LineCurve';
              _this65.v1 = v1;
              _this65.v2 = v2;
              return _this65;
            }
            _createClass2(_LineCurve, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
                var point = optionalTarget;
                if (t === 1) {
                  point.copy(this.v2);
                } else {
                  point.copy(this.v2).sub(this.v1);
                  point.multiplyScalar(t).add(this.v1);
                }
                return point;
              } // Line curve is linear, so we can overwrite default getPointAt
            }, {
              key: "getPointAt",
              value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
              }
            }, {
              key: "getTangent",
              value: function getTangent(t, optionalTarget) {
                var tangent = optionalTarget || new _Vector();
                tangent.copy(this.v2).sub(this.v1).normalize();
                return tangent;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_LineCurve.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_LineCurve.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_LineCurve.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
              }
            }]);
            return _LineCurve;
          }(_Curve);
          var _LineCurve2 = /*#__PURE__*/function (_Curve7) {
            _inherits(_LineCurve2, _Curve7);
            var _super75 = _createSuper(_LineCurve2);
            function _LineCurve2() {
              var _this66;
              var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
              _classCallCheck2(this, _LineCurve2);
              _this66 = _super75.call(this);
              _this66.isLineCurve3 = true;
              _this66.type = 'LineCurve3';
              _this66.v1 = v1;
              _this66.v2 = v2;
              return _this66;
            }
            _createClass2(_LineCurve2, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
                var point = optionalTarget;
                if (t === 1) {
                  point.copy(this.v2);
                } else {
                  point.copy(this.v2).sub(this.v1);
                  point.multiplyScalar(t).add(this.v1);
                }
                return point;
              } // Line curve is linear, so we can overwrite default getPointAt
            }, {
              key: "getPointAt",
              value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_LineCurve2.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_LineCurve2.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_LineCurve2.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
              }
            }]);
            return _LineCurve2;
          }(_Curve);
          var _QuadraticBezierCurve = /*#__PURE__*/function (_Curve8) {
            _inherits(_QuadraticBezierCurve, _Curve8);
            var _super76 = _createSuper(_QuadraticBezierCurve);
            function _QuadraticBezierCurve() {
              var _this67;
              var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector();
              var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
              var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Vector();
              _classCallCheck2(this, _QuadraticBezierCurve);
              _this67 = _super76.call(this);
              _this67.isQuadraticBezierCurve = true;
              _this67.type = 'QuadraticBezierCurve';
              _this67.v0 = v0;
              _this67.v1 = v1;
              _this67.v2 = v2;
              return _this67;
            }
            _createClass2(_QuadraticBezierCurve, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
                var point = optionalTarget;
                var v0 = this.v0,
                  v1 = this.v1,
                  v2 = this.v2;
                point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y));
                return point;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_QuadraticBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_QuadraticBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_QuadraticBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
              }
            }]);
            return _QuadraticBezierCurve;
          }(_Curve);
          var _QuadraticBezierCurve2 = /*#__PURE__*/function (_Curve9) {
            _inherits(_QuadraticBezierCurve2, _Curve9);
            var _super77 = _createSuper(_QuadraticBezierCurve2);
            function _QuadraticBezierCurve2() {
              var _this68;
              var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
              var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Vector2();
              _classCallCheck2(this, _QuadraticBezierCurve2);
              _this68 = _super77.call(this);
              _this68.isQuadraticBezierCurve3 = true;
              _this68.type = 'QuadraticBezierCurve3';
              _this68.v0 = v0;
              _this68.v1 = v1;
              _this68.v2 = v2;
              return _this68;
            }
            _createClass2(_QuadraticBezierCurve2, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
                var point = optionalTarget;
                var v0 = this.v0,
                  v1 = this.v1,
                  v2 = this.v2;
                point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y), QuadraticBezier(t, v0.z, v1.z, v2.z));
                return point;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_QuadraticBezierCurve2.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_QuadraticBezierCurve2.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_QuadraticBezierCurve2.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
              }
            }]);
            return _QuadraticBezierCurve2;
          }(_Curve);
          var _SplineCurve = /*#__PURE__*/function (_Curve10) {
            _inherits(_SplineCurve, _Curve10);
            var _super78 = _createSuper(_SplineCurve);
            function _SplineCurve() {
              var _this69;
              var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              _classCallCheck2(this, _SplineCurve);
              _this69 = _super78.call(this);
              _this69.isSplineCurve = true;
              _this69.type = 'SplineCurve';
              _this69.points = points;
              return _this69;
            }
            _createClass2(_SplineCurve, [{
              key: "getPoint",
              value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector();
                var point = optionalTarget;
                var points = this.points;
                var p = (points.length - 1) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                var p1 = points[intPoint];
                var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                point.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                return point;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_SplineCurve.prototype), "copy", this).call(this, source);
                this.points = [];
                for (var i = 0, l = source.points.length; i < l; i++) {
                  var point = source.points[i];
                  this.points.push(point.clone());
                }
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_SplineCurve.prototype), "toJSON", this).call(this);
                data.points = [];
                for (var i = 0, l = this.points.length; i < l; i++) {
                  var point = this.points[i];
                  data.points.push(point.toArray());
                }
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_SplineCurve.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for (var i = 0, l = json.points.length; i < l; i++) {
                  var point = json.points[i];
                  this.points.push(new _Vector().fromArray(point));
                }
                return this;
              }
            }]);
            return _SplineCurve;
          }(_Curve);
          var Curves = /*#__PURE__*/Object.freeze({
            __proto__: null,
            ArcCurve: _ArcCurve,
            CatmullRomCurve3: _CatmullRomCurve,
            CubicBezierCurve: _CubicBezierCurve,
            CubicBezierCurve3: _CubicBezierCurve2,
            EllipseCurve: _EllipseCurve,
            LineCurve: _LineCurve,
            LineCurve3: _LineCurve2,
            QuadraticBezierCurve: _QuadraticBezierCurve,
            QuadraticBezierCurve3: _QuadraticBezierCurve2,
            SplineCurve: _SplineCurve
          }); /**************************************************************
              *	Curved Path - a curve path is simply a array of connected
              *  curves, but retains the api of a curve
              **************************************************************/
          var _CurvePath = /*#__PURE__*/function (_Curve11) {
            _inherits(_CurvePath, _Curve11);
            var _super79 = _createSuper(_CurvePath);
            function _CurvePath() {
              var _this70;
              _classCallCheck2(this, _CurvePath);
              _this70 = _super79.call(this);
              _this70.type = 'CurvePath';
              _this70.curves = [];
              _this70.autoClose = false; // Automatically closes the path
              return _this70;
            }
            _createClass2(_CurvePath, [{
              key: "add",
              value: function add(curve) {
                this.curves.push(curve);
              }
            }, {
              key: "closePath",
              value: function closePath() {
                // Add a line curve if start and end of lines are not connected
                var startPoint = this.curves[0].getPoint(0);
                var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                if (!startPoint.equals(endPoint)) {
                  this.curves.push(new _LineCurve(endPoint, startPoint));
                }
              } // To get accurate point with reference to
              // entire path distance at time t,
              // following has to be done:
              // 1. Length of each sub path have to be known
              // 2. Locate and identify type of curve
              // 3. Get t for the curve
              // 4. Return curve.getPointAt(t')
            }, {
              key: "getPoint",
              value: function getPoint(t, optionalTarget) {
                var d = t * this.getLength();
                var curveLengths = this.getCurveLengths();
                var i = 0; // To think about boundaries points.
                while (i < curveLengths.length) {
                  if (curveLengths[i] >= d) {
                    var diff = curveLengths[i] - d;
                    var curve = this.curves[i];
                    var segmentLength = curve.getLength();
                    var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                    return curve.getPointAt(u, optionalTarget);
                  }
                  i++;
                }
                return null; // loop where sum != 0, sum > d , sum+1 <d
              } // We cannot use the default THREE.Curve getPoint() with getLength() because in
              // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
              // getPoint() depends on getLength
            }, {
              key: "getLength",
              value: function getLength() {
                var lens = this.getCurveLengths();
                return lens[lens.length - 1];
              } // cacheLengths must be recalculated.
            }, {
              key: "updateArcLengths",
              value: function updateArcLengths() {
                this.needsUpdate = true;
                this.cacheLengths = null;
                this.getCurveLengths();
              } // Compute lengths and cache them
              // We cannot overwrite getLengths() because UtoT mapping uses it.
            }, {
              key: "getCurveLengths",
              value: function getCurveLengths() {
                // We use cache values if curves and cache array are same length
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
                  return this.cacheLengths;
                } // Get length of sub-curve
                // Push sums into cached array
                var lengths = [];
                var sums = 0;
                for (var i = 0, l = this.curves.length; i < l; i++) {
                  sums += this.curves[i].getLength();
                  lengths.push(sums);
                }
                this.cacheLengths = lengths;
                return lengths;
              }
            }, {
              key: "getSpacedPoints",
              value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
                var points = [];
                for (var i = 0; i <= divisions; i++) {
                  points.push(this.getPoint(i / divisions));
                }
                if (this.autoClose) {
                  points.push(points[0]);
                }
                return points;
              }
            }, {
              key: "getPoints",
              value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
                var points = [];
                var last;
                for (var i = 0, curves = this.curves; i < curves.length; i++) {
                  var curve = curves[i];
                  var resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
                  var pts = curve.getPoints(resolution);
                  for (var j = 0; j < pts.length; j++) {
                    var point = pts[j];
                    if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                    points.push(point);
                    last = point;
                  }
                }
                if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
                  points.push(points[0]);
                }
                return points;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_CurvePath.prototype), "copy", this).call(this, source);
                this.curves = [];
                for (var i = 0, l = source.curves.length; i < l; i++) {
                  var curve = source.curves[i];
                  this.curves.push(curve.clone());
                }
                this.autoClose = source.autoClose;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_CurvePath.prototype), "toJSON", this).call(this);
                data.autoClose = this.autoClose;
                data.curves = [];
                for (var i = 0, l = this.curves.length; i < l; i++) {
                  var curve = this.curves[i];
                  data.curves.push(curve.toJSON());
                }
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_CurvePath.prototype), "fromJSON", this).call(this, json);
                this.autoClose = json.autoClose;
                this.curves = [];
                for (var i = 0, l = json.curves.length; i < l; i++) {
                  var curve = json.curves[i];
                  this.curves.push(new Curves[curve.type]().fromJSON(curve));
                }
                return this;
              }
            }]);
            return _CurvePath;
          }(_Curve);
          var _Path = /*#__PURE__*/function (_CurvePath2) {
            _inherits(_Path, _CurvePath2);
            var _super80 = _createSuper(_Path);
            function _Path(points) {
              var _this71;
              _classCallCheck2(this, _Path);
              _this71 = _super80.call(this);
              _this71.type = 'Path';
              _this71.currentPoint = new _Vector();
              if (points) {
                _this71.setFromPoints(points);
              }
              return _this71;
            }
            _createClass2(_Path, [{
              key: "setFromPoints",
              value: function setFromPoints(points) {
                this.moveTo(points[0].x, points[0].y);
                for (var i = 1, l = points.length; i < l; i++) {
                  this.lineTo(points[i].x, points[i].y);
                }
                return this;
              }
            }, {
              key: "moveTo",
              value: function moveTo(x, y) {
                this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
                return this;
              }
            }, {
              key: "lineTo",
              value: function lineTo(x, y) {
                var curve = new _LineCurve(this.currentPoint.clone(), new _Vector(x, y));
                this.curves.push(curve);
                this.currentPoint.set(x, y);
                return this;
              }
            }, {
              key: "quadraticCurveTo",
              value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                var curve = new _QuadraticBezierCurve(this.currentPoint.clone(), new _Vector(aCPx, aCPy), new _Vector(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
              }
            }, {
              key: "bezierCurveTo",
              value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                var curve = new _CubicBezierCurve(this.currentPoint.clone(), new _Vector(aCP1x, aCP1y), new _Vector(aCP2x, aCP2y), new _Vector(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
              }
            }, {
              key: "splineThru",
              value: function splineThru(pts /*Array of Vector*/) {
                var npts = [this.currentPoint.clone()].concat(pts);
                var curve = new _SplineCurve(npts);
                this.curves.push(curve);
                this.currentPoint.copy(pts[pts.length - 1]);
                return this;
              }
            }, {
              key: "arc",
              value: function arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
              }
            }, {
              key: "absarc",
              value: function absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
              }
            }, {
              key: "ellipse",
              value: function ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                return this;
              }
            }, {
              key: "absellipse",
              value: function absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var curve = new _EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                if (this.curves.length > 0) {
                  // if a previous curve is present, attempt to join
                  var firstPoint = curve.getPoint(0);
                  if (!firstPoint.equals(this.currentPoint)) {
                    this.lineTo(firstPoint.x, firstPoint.y);
                  }
                }
                this.curves.push(curve);
                var lastPoint = curve.getPoint(1);
                this.currentPoint.copy(lastPoint);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_Path.prototype), "copy", this).call(this, source);
                this.currentPoint.copy(source.currentPoint);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_Path.prototype), "toJSON", this).call(this);
                data.currentPoint = this.currentPoint.toArray();
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_Path.prototype), "fromJSON", this).call(this, json);
                this.currentPoint.fromArray(json.currentPoint);
                return this;
              }
            }]);
            return _Path;
          }(_CurvePath);
          var _LatheGeometry = /*#__PURE__*/function (_BufferGeometry4) {
            _inherits(_LatheGeometry, _BufferGeometry4);
            var _super81 = _createSuper(_LatheGeometry);
            function _LatheGeometry() {
              var _this72;
              var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [new _Vector(0, -0.5), new _Vector(0.5, 0), new _Vector(0, 0.5)];
              var segments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
              var phiStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var phiLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI * 2;
              _classCallCheck2(this, _LatheGeometry);
              _this72 = _super81.call(this);
              _this72.type = 'LatheGeometry';
              _this72.parameters = {
                points: points,
                segments: segments,
                phiStart: phiStart,
                phiLength: phiLength
              };
              segments = Math.floor(segments); // clamp phiLength so it's in range of [ 0, 2PI ]
              phiLength = clamp(phiLength, 0, Math.PI * 2); // buffers
              var indices = [];
              var vertices = [];
              var uvs = [];
              var initNormals = [];
              var normals = []; // helper variables
              var inverseSegments = 1.0 / segments;
              var vertex = new _Vector2();
              var uv = new _Vector();
              var normal = new _Vector2();
              var curNormal = new _Vector2();
              var prevNormal = new _Vector2();
              var dx = 0;
              var dy = 0; // pre-compute normals for initial "meridian"
              for (var j = 0; j <= points.length - 1; j++) {
                switch (j) {
                  case 0:
                    // special handling for 1st vertex on path
                    dx = points[j + 1].x - points[j].x;
                    dy = points[j + 1].y - points[j].y;
                    normal.x = dy * 1.0;
                    normal.y = -dx;
                    normal.z = dy * 0.0;
                    prevNormal.copy(normal);
                    normal.normalize();
                    initNormals.push(normal.x, normal.y, normal.z);
                    break;
                  case points.length - 1:
                    // special handling for last Vertex on path
                    initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                    break;
                  default:
                    // default handling for all vertices in between
                    dx = points[j + 1].x - points[j].x;
                    dy = points[j + 1].y - points[j].y;
                    normal.x = dy * 1.0;
                    normal.y = -dx;
                    normal.z = dy * 0.0;
                    curNormal.copy(normal);
                    normal.x += prevNormal.x;
                    normal.y += prevNormal.y;
                    normal.z += prevNormal.z;
                    normal.normalize();
                    initNormals.push(normal.x, normal.y, normal.z);
                    prevNormal.copy(curNormal);
                }
              } // generate vertices, uvs and normals
              for (var i = 0; i <= segments; i++) {
                var phi = phiStart + i * inverseSegments * phiLength;
                var sin = Math.sin(phi);
                var cos = Math.cos(phi);
                for (var _j5 = 0; _j5 <= points.length - 1; _j5++) {
                  // vertex
                  vertex.x = points[_j5].x * sin;
                  vertex.y = points[_j5].y;
                  vertex.z = points[_j5].x * cos;
                  vertices.push(vertex.x, vertex.y, vertex.z); // uv
                  uv.x = i / segments;
                  uv.y = _j5 / (points.length - 1);
                  uvs.push(uv.x, uv.y); // normal
                  var x = initNormals[3 * _j5 + 0] * sin;
                  var y = initNormals[3 * _j5 + 1];
                  var z = initNormals[3 * _j5 + 0] * cos;
                  normals.push(x, y, z);
                }
              } // indices
              for (var _i59 = 0; _i59 < segments; _i59++) {
                for (var _j6 = 0; _j6 < points.length - 1; _j6++) {
                  var base = _j6 + _i59 * points.length;
                  var a = base;
                  var b = base + points.length;
                  var c = base + points.length + 1;
                  var d = base + 1; // faces
                  indices.push(a, b, d);
                  indices.push(c, d, b);
                }
              } // build geometry
              _this72.setIndex(indices);
              _this72.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this72.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              _this72.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              return _this72;
            }
            _createClass2(_LatheGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
              }
            }]);
            return _LatheGeometry;
          }(_BufferGeometry);
          var _CapsuleGeometry = /*#__PURE__*/function (_LatheGeometry2) {
            _inherits(_CapsuleGeometry, _LatheGeometry2);
            var _super82 = _createSuper(_CapsuleGeometry);
            function _CapsuleGeometry() {
              var _this73;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var capSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
              var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
              _classCallCheck2(this, _CapsuleGeometry);
              var path = new _Path();
              path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
              path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
              _this73 = _super82.call(this, path.getPoints(capSegments), radialSegments);
              _this73.type = 'CapsuleGeometry';
              _this73.parameters = {
                radius: radius,
                height: length,
                capSegments: capSegments,
                radialSegments: radialSegments
              };
              return _this73;
            }
            _createClass2(_CapsuleGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _CapsuleGeometry(data.radius, data.length, data.capSegments, data.radialSegments);
              }
            }]);
            return _CapsuleGeometry;
          }(_LatheGeometry);
          var _CircleGeometry = /*#__PURE__*/function (_BufferGeometry5) {
            _inherits(_CircleGeometry, _BufferGeometry5);
            var _super83 = _createSuper(_CircleGeometry);
            function _CircleGeometry() {
              var _this74;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var segments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
              var thetaStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var thetaLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI * 2;
              _classCallCheck2(this, _CircleGeometry);
              _this74 = _super83.call(this);
              _this74.type = 'CircleGeometry';
              _this74.parameters = {
                radius: radius,
                segments: segments,
                thetaStart: thetaStart,
                thetaLength: thetaLength
              };
              segments = Math.max(3, segments); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // helper variables
              var vertex = new _Vector2();
              var uv = new _Vector(); // center point
              vertices.push(0, 0, 0);
              normals.push(0, 0, 1);
              uvs.push(0.5, 0.5);
              for (var s = 0, i = 3; s <= segments; s++, i += 3) {
                var segment = thetaStart + s / segments * thetaLength; // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z); // normal
                normals.push(0, 0, 1); // uvs
                uv.x = (vertices[i] / radius + 1) / 2;
                uv.y = (vertices[i + 1] / radius + 1) / 2;
                uvs.push(uv.x, uv.y);
              } // indices
              for (var _i60 = 1; _i60 <= segments; _i60++) {
                indices.push(_i60, _i60 + 1, 0);
              } // build geometry
              _this74.setIndex(indices);
              _this74.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this74.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this74.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              return _this74;
            }
            _createClass2(_CircleGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
              }
            }]);
            return _CircleGeometry;
          }(_BufferGeometry);
          var _CylinderGeometry = /*#__PURE__*/function (_BufferGeometry6) {
            _inherits(_CylinderGeometry, _BufferGeometry6);
            var _super84 = _createSuper(_CylinderGeometry);
            function _CylinderGeometry() {
              var _this75;
              var radiusTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var radiusBottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
              var heightSegments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
              var openEnded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
              var thetaStart = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
              var thetaLength = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : Math.PI * 2;
              _classCallCheck2(this, _CylinderGeometry);
              _this75 = _super84.call(this);
              _this75.type = 'CylinderGeometry';
              _this75.parameters = {
                radiusTop: radiusTop,
                radiusBottom: radiusBottom,
                height: height,
                radialSegments: radialSegments,
                heightSegments: heightSegments,
                openEnded: openEnded,
                thetaStart: thetaStart,
                thetaLength: thetaLength
              };
              var scope = _assertThisInitialized(_this75);
              radialSegments = Math.floor(radialSegments);
              heightSegments = Math.floor(heightSegments); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // helper variables
              var index = 0;
              var indexArray = [];
              var halfHeight = height / 2;
              var groupStart = 0; // generate geometry
              generateTorso();
              if (openEnded === false) {
                if (radiusTop > 0) generateCap(true);
                if (radiusBottom > 0) generateCap(false);
              } // build geometry
              _this75.setIndex(indices);
              _this75.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this75.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this75.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              function generateTorso() {
                var normal = new _Vector2();
                var vertex = new _Vector2();
                var groupCount = 0; // this will be used to calculate the normal
                var slope = (radiusBottom - radiusTop) / height; // generate vertices, normals and uvs
                for (var y = 0; y <= heightSegments; y++) {
                  var indexRow = [];
                  var v = y / heightSegments; // calculate the radius of the current row
                  var radius = v * (radiusBottom - radiusTop) + radiusTop;
                  for (var x = 0; x <= radialSegments; x++) {
                    var u = x / radialSegments;
                    var theta = u * thetaLength + thetaStart;
                    var sinTheta = Math.sin(theta);
                    var cosTheta = Math.cos(theta); // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z); // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z); // uv
                    uvs.push(u, 1 - v); // save index of vertex in respective row
                    indexRow.push(index++);
                  } // now save vertices of the row in our index array
                  indexArray.push(indexRow);
                } // generate indices
                for (var _x4 = 0; _x4 < radialSegments; _x4++) {
                  for (var _y2 = 0; _y2 < heightSegments; _y2++) {
                    // we use the index array to access the correct indices
                    var a = indexArray[_y2][_x4];
                    var b = indexArray[_y2 + 1][_x4];
                    var c = indexArray[_y2 + 1][_x4 + 1];
                    var d = indexArray[_y2][_x4 + 1]; // faces
                    indices.push(a, b, d);
                    indices.push(b, c, d); // update group counter
                    groupCount += 6;
                  }
                } // add a group to the geometry. this will ensure multi material support
                scope.addGroup(groupStart, groupCount, 0); // calculate new start value for groups
                groupStart += groupCount;
              }
              function generateCap(top) {
                // save the index of the first center vertex
                var centerIndexStart = index;
                var uv = new _Vector();
                var vertex = new _Vector2();
                var groupCount = 0;
                var radius = top === true ? radiusTop : radiusBottom;
                var sign = top === true ? 1 : -1; // first we generate the center vertex data of the cap.
                // because the geometry needs one set of uvs per face,
                // we must generate a center vertex per face/segment
                for (var x = 1; x <= radialSegments; x++) {
                  // vertex
                  vertices.push(0, halfHeight * sign, 0); // normal
                  normals.push(0, sign, 0); // uv
                  uvs.push(0.5, 0.5); // increase index
                  index++;
                } // save the index of the last center vertex
                var centerIndexEnd = index; // now we generate the surrounding vertices, normals and uvs
                for (var _x5 = 0; _x5 <= radialSegments; _x5++) {
                  var u = _x5 / radialSegments;
                  var theta = u * thetaLength + thetaStart;
                  var cosTheta = Math.cos(theta);
                  var sinTheta = Math.sin(theta); // vertex
                  vertex.x = radius * sinTheta;
                  vertex.y = halfHeight * sign;
                  vertex.z = radius * cosTheta;
                  vertices.push(vertex.x, vertex.y, vertex.z); // normal
                  normals.push(0, sign, 0); // uv
                  uv.x = cosTheta * 0.5 + 0.5;
                  uv.y = sinTheta * 0.5 * sign + 0.5;
                  uvs.push(uv.x, uv.y); // increase index
                  index++;
                } // generate indices
                for (var _x6 = 0; _x6 < radialSegments; _x6++) {
                  var c = centerIndexStart + _x6;
                  var i = centerIndexEnd + _x6;
                  if (top === true) {
                    // face top
                    indices.push(i, i + 1, c);
                  } else {
                    // face bottom
                    indices.push(i + 1, i, c);
                  }
                  groupCount += 3;
                } // add a group to the geometry. this will ensure multi material support
                scope.addGroup(groupStart, groupCount, top === true ? 1 : 2); // calculate new start value for groups
                groupStart += groupCount;
              }
              return _this75;
            }
            _createClass2(_CylinderGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
              }
            }]);
            return _CylinderGeometry;
          }(_BufferGeometry);
          var _ConeGeometry = /*#__PURE__*/function (_CylinderGeometry2) {
            _inherits(_ConeGeometry, _CylinderGeometry2);
            var _super85 = _createSuper(_ConeGeometry);
            function _ConeGeometry() {
              var _this76;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var radialSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
              var heightSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              var openEnded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
              var thetaStart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
              var thetaLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Math.PI * 2;
              _classCallCheck2(this, _ConeGeometry);
              _this76 = _super85.call(this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
              _this76.type = 'ConeGeometry';
              _this76.parameters = {
                radius: radius,
                height: height,
                radialSegments: radialSegments,
                heightSegments: heightSegments,
                openEnded: openEnded,
                thetaStart: thetaStart,
                thetaLength: thetaLength
              };
              return _this76;
            }
            _createClass2(_ConeGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
              }
            }]);
            return _ConeGeometry;
          }(_CylinderGeometry);
          var _PolyhedronGeometry = /*#__PURE__*/function (_BufferGeometry7) {
            _inherits(_PolyhedronGeometry, _BufferGeometry7);
            var _super86 = _createSuper(_PolyhedronGeometry);
            function _PolyhedronGeometry() {
              var _this77;
              var vertices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var indices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var detail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
              _classCallCheck2(this, _PolyhedronGeometry);
              _this77 = _super86.call(this);
              _this77.type = 'PolyhedronGeometry';
              _this77.parameters = {
                vertices: vertices,
                indices: indices,
                radius: radius,
                detail: detail
              }; // default buffer data
              var vertexBuffer = [];
              var uvBuffer = []; // the subdivision creates the vertex buffer data
              subdivide(detail); // all vertices should lie on a conceptual sphere with a given radius
              applyRadius(radius); // finally, create the uv data
              generateUVs(); // build non-indexed geometry
              _this77.setAttribute('position', new _Float32BufferAttribute(vertexBuffer, 3));
              _this77.setAttribute('normal', new _Float32BufferAttribute(vertexBuffer.slice(), 3));
              _this77.setAttribute('uv', new _Float32BufferAttribute(uvBuffer, 2));
              if (detail === 0) {
                _this77.computeVertexNormals(); // flat normals
              } else {
                _this77.normalizeNormals(); // smooth normals
              } // helper functions
              function subdivide(detail) {
                var a = new _Vector2();
                var b = new _Vector2();
                var c = new _Vector2(); // iterate over all faces and apply a subdivision with the given detail value
                for (var i = 0; i < indices.length; i += 3) {
                  // get the vertices of the face
                  getVertexByIndex(indices[i + 0], a);
                  getVertexByIndex(indices[i + 1], b);
                  getVertexByIndex(indices[i + 2], c); // perform subdivision
                  subdivideFace(a, b, c, detail);
                }
              }
              function subdivideFace(a, b, c, detail) {
                var cols = detail + 1; // we use this multidimensional array as a data structure for creating the subdivision
                var v = []; // construct all of the vertices for this subdivision
                for (var i = 0; i <= cols; i++) {
                  v[i] = [];
                  var aj = a.clone().lerp(c, i / cols);
                  var bj = b.clone().lerp(c, i / cols);
                  var rows = cols - i;
                  for (var j = 0; j <= rows; j++) {
                    if (j === 0 && i === cols) {
                      v[i][j] = aj;
                    } else {
                      v[i][j] = aj.clone().lerp(bj, j / rows);
                    }
                  }
                } // construct all of the faces
                for (var _i61 = 0; _i61 < cols; _i61++) {
                  for (var _j7 = 0; _j7 < 2 * (cols - _i61) - 1; _j7++) {
                    var k = Math.floor(_j7 / 2);
                    if (_j7 % 2 === 0) {
                      pushVertex(v[_i61][k + 1]);
                      pushVertex(v[_i61 + 1][k]);
                      pushVertex(v[_i61][k]);
                    } else {
                      pushVertex(v[_i61][k + 1]);
                      pushVertex(v[_i61 + 1][k + 1]);
                      pushVertex(v[_i61 + 1][k]);
                    }
                  }
                }
              }
              function applyRadius(radius) {
                var vertex = new _Vector2(); // iterate over the entire buffer and apply the radius to each vertex
                for (var i = 0; i < vertexBuffer.length; i += 3) {
                  vertex.x = vertexBuffer[i + 0];
                  vertex.y = vertexBuffer[i + 1];
                  vertex.z = vertexBuffer[i + 2];
                  vertex.normalize().multiplyScalar(radius);
                  vertexBuffer[i + 0] = vertex.x;
                  vertexBuffer[i + 1] = vertex.y;
                  vertexBuffer[i + 2] = vertex.z;
                }
              }
              function generateUVs() {
                var vertex = new _Vector2();
                for (var i = 0; i < vertexBuffer.length; i += 3) {
                  vertex.x = vertexBuffer[i + 0];
                  vertex.y = vertexBuffer[i + 1];
                  vertex.z = vertexBuffer[i + 2];
                  var u = azimuth(vertex) / 2 / Math.PI + 0.5;
                  var v = inclination(vertex) / Math.PI + 0.5;
                  uvBuffer.push(u, 1 - v);
                }
                correctUVs();
                correctSeam();
              }
              function correctSeam() {
                // handle case when face straddles the seam, see #3269
                for (var i = 0; i < uvBuffer.length; i += 6) {
                  // uv data of a single face
                  var x0 = uvBuffer[i + 0];
                  var x1 = uvBuffer[i + 2];
                  var x2 = uvBuffer[i + 4];
                  var max = Math.max(x0, x1, x2);
                  var min = Math.min(x0, x1, x2); // 0.9 is somewhat arbitrary
                  if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                  }
                }
              }
              function pushVertex(vertex) {
                vertexBuffer.push(vertex.x, vertex.y, vertex.z);
              }
              function getVertexByIndex(index, vertex) {
                var stride = index * 3;
                vertex.x = vertices[stride + 0];
                vertex.y = vertices[stride + 1];
                vertex.z = vertices[stride + 2];
              }
              function correctUVs() {
                var a = new _Vector2();
                var b = new _Vector2();
                var c = new _Vector2();
                var centroid = new _Vector2();
                var uvA = new _Vector();
                var uvB = new _Vector();
                var uvC = new _Vector();
                for (var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6) {
                  a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                  b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                  c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                  uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                  uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                  uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                  centroid.copy(a).add(b).add(c).divideScalar(3);
                  var azi = azimuth(centroid);
                  correctUV(uvA, j + 0, a, azi);
                  correctUV(uvB, j + 2, b, azi);
                  correctUV(uvC, j + 4, c, azi);
                }
              }
              function correctUV(uv, stride, vector, azimuth) {
                if (azimuth < 0 && uv.x === 1) {
                  uvBuffer[stride] = uv.x - 1;
                }
                if (vector.x === 0 && vector.z === 0) {
                  uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
                }
              } // Angle around the Y axis, counter-clockwise when looking from above.
              function azimuth(vector) {
                return Math.atan2(vector.z, -vector.x);
              } // Angle above the XZ plane.
              function inclination(vector) {
                return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
              }
              return _this77;
            }
            _createClass2(_PolyhedronGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
              }
            }]);
            return _PolyhedronGeometry;
          }(_BufferGeometry);
          var _DodecahedronGeometry = /*#__PURE__*/function (_PolyhedronGeometry2) {
            _inherits(_DodecahedronGeometry, _PolyhedronGeometry2);
            var _super87 = _createSuper(_DodecahedronGeometry);
            function _DodecahedronGeometry() {
              var _this78;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck2(this, _DodecahedronGeometry);
              var t = (1 + Math.sqrt(5)) / 2;
              var r = 1 / t;
              var vertices = [
              // (±1, ±1, ±1)
              -1, -1, -1, -1, -1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1,
              // (0, ±1/φ, ±φ)
              0, -r, -t, 0, -r, t, 0, r, -t, 0, r, t,
              // (±1/φ, ±φ, 0)
              -r, -t, 0, -r, t, 0, r, -t, 0, r, t, 0,
              // (±φ, 0, ±1/φ)
              -t, 0, -r, t, 0, -r, -t, 0, r, t, 0, r];
              var indices = [3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9];
              _this78 = _super87.call(this, vertices, indices, radius, detail);
              _this78.type = 'DodecahedronGeometry';
              _this78.parameters = {
                radius: radius,
                detail: detail
              };
              return _this78;
            }
            _createClass2(_DodecahedronGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _DodecahedronGeometry(data.radius, data.detail);
              }
            }]);
            return _DodecahedronGeometry;
          }(_PolyhedronGeometry);
          var _v0 = /*@__PURE__*/new _Vector2();
          var _v1$1 = /*@__PURE__*/new _Vector2();
          var _normal = /*@__PURE__*/new _Vector2();
          var _triangle = /*@__PURE__*/new _Triangle();
          var _EdgesGeometry = /*#__PURE__*/function (_BufferGeometry8) {
            _inherits(_EdgesGeometry, _BufferGeometry8);
            var _super88 = _createSuper(_EdgesGeometry);
            function _EdgesGeometry() {
              var _this79;
              var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var thresholdAngle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              _classCallCheck2(this, _EdgesGeometry);
              _this79 = _super88.call(this);
              _this79.type = 'EdgesGeometry';
              _this79.parameters = {
                geometry: geometry,
                thresholdAngle: thresholdAngle
              };
              if (geometry !== null) {
                var precisionPoints = 4;
                var precision = Math.pow(10, precisionPoints);
                var thresholdDot = Math.cos(DEG2RAD * thresholdAngle);
                var indexAttr = geometry.getIndex();
                var positionAttr = geometry.getAttribute('position');
                var indexCount = indexAttr ? indexAttr.count : positionAttr.count;
                var indexArr = [0, 0, 0];
                var vertKeys = ['a', 'b', 'c'];
                var hashes = new Array(3);
                var edgeData = {};
                var vertices = [];
                for (var i = 0; i < indexCount; i += 3) {
                  if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                  } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                  }
                  var a = _triangle.a,
                    b = _triangle.b,
                    c = _triangle.c;
                  a.fromBufferAttribute(positionAttr, indexArr[0]);
                  b.fromBufferAttribute(positionAttr, indexArr[1]);
                  c.fromBufferAttribute(positionAttr, indexArr[2]);
                  _triangle.getNormal(_normal); // create hashes for the edge from the vertices
                  hashes[0] = "".concat(Math.round(a.x * precision), ",").concat(Math.round(a.y * precision), ",").concat(Math.round(a.z * precision));
                  hashes[1] = "".concat(Math.round(b.x * precision), ",").concat(Math.round(b.y * precision), ",").concat(Math.round(b.z * precision));
                  hashes[2] = "".concat(Math.round(c.x * precision), ",").concat(Math.round(c.y * precision), ",").concat(Math.round(c.z * precision)); // skip degenerate triangles
                  if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {
                    continue;
                  } // iterate over every edge
                  for (var j = 0; j < 3; j++) {
                    // get the first and next vertex making up the edge
                    var jNext = (j + 1) % 3;
                    var vecHash0 = hashes[j];
                    var vecHash1 = hashes[jNext];
                    var v0 = _triangle[vertKeys[j]];
                    var v1 = _triangle[vertKeys[jNext]];
                    var hash = "".concat(vecHash0, "_").concat(vecHash1);
                    var reverseHash = "".concat(vecHash1, "_").concat(vecHash0);
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                      // if we found a sibling edge add it into the vertex array if
                      // it meets the angle threshold and delete the edge from the map.
                      if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                        vertices.push(v0.x, v0.y, v0.z);
                        vertices.push(v1.x, v1.y, v1.z);
                      }
                      edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) {
                      // if we've already got an edge here then skip adding a new one
                      edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: _normal.clone()
                      };
                    }
                  }
                } // iterate over all remaining, unmatched edges and add them to the vertex array
                for (var key in edgeData) {
                  if (edgeData[key]) {
                    var _edgeData$key = edgeData[key],
                      index0 = _edgeData$key.index0,
                      index1 = _edgeData$key.index1;
                    _v0.fromBufferAttribute(positionAttr, index0);
                    _v1$1.fromBufferAttribute(positionAttr, index1);
                    vertices.push(_v0.x, _v0.y, _v0.z);
                    vertices.push(_v1$1.x, _v1$1.y, _v1$1.z);
                  }
                }
                _this79.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              }
              return _this79;
            }
            return _createClass2(_EdgesGeometry);
          }(_BufferGeometry);
          var _Shape = /*#__PURE__*/function (_Path2) {
            _inherits(_Shape, _Path2);
            var _super89 = _createSuper(_Shape);
            function _Shape(points) {
              var _this80;
              _classCallCheck2(this, _Shape);
              _this80 = _super89.call(this, points);
              _this80.uuid = generateUUID();
              _this80.type = 'Shape';
              _this80.holes = [];
              return _this80;
            }
            _createClass2(_Shape, [{
              key: "getPointsHoles",
              value: function getPointsHoles(divisions) {
                var holesPts = [];
                for (var i = 0, l = this.holes.length; i < l; i++) {
                  holesPts[i] = this.holes[i].getPoints(divisions);
                }
                return holesPts;
              } // get points of shape and holes (keypoints based on segments parameter)
            }, {
              key: "extractPoints",
              value: function extractPoints(divisions) {
                return {
                  shape: this.getPoints(divisions),
                  holes: this.getPointsHoles(divisions)
                };
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_Shape.prototype), "copy", this).call(this, source);
                this.holes = [];
                for (var i = 0, l = source.holes.length; i < l; i++) {
                  var hole = source.holes[i];
                  this.holes.push(hole.clone());
                }
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_Shape.prototype), "toJSON", this).call(this);
                data.uuid = this.uuid;
                data.holes = [];
                for (var i = 0, l = this.holes.length; i < l; i++) {
                  var hole = this.holes[i];
                  data.holes.push(hole.toJSON());
                }
                return data;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                _get2(_getPrototypeOf(_Shape.prototype), "fromJSON", this).call(this, json);
                this.uuid = json.uuid;
                this.holes = [];
                for (var i = 0, l = json.holes.length; i < l; i++) {
                  var hole = json.holes[i];
                  this.holes.push(new _Path().fromJSON(hole));
                }
                return this;
              }
            }]);
            return _Shape;
          }(_Path);
          /**
          * Port from https://github.com/mapbox/earcut (v2.2.4)
          */
          var Earcut = {
            triangulate: function triangulate(data, holeIndices) {
              var dim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
              var hasHoles = holeIndices && holeIndices.length;
              var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
              var outerNode = linkedList(data, 0, outerLen, dim, true);
              var triangles = [];
              if (!outerNode || outerNode.next === outerNode.prev) return triangles;
              var minX, minY, maxX, maxY, x, y, invSize;
              if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim); // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
              if (data.length > 80 * dim) {
                minX = maxX = data[0];
                minY = maxY = data[1];
                for (var i = dim; i < outerLen; i += dim) {
                  x = data[i];
                  y = data[i + 1];
                  if (x < minX) minX = x;
                  if (y < minY) minY = y;
                  if (x > maxX) maxX = x;
                  if (y > maxY) maxY = y;
                } // minX, minY and invSize are later used to transform coords into integers for z-order calculation
                invSize = Math.max(maxX - minX, maxY - minY);
                invSize = invSize !== 0 ? 32767 / invSize : 0;
              }
              earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
              return triangles;
            }
          }; // create a circular doubly linked list from polygon points in the specified winding order
          function linkedList(data, start, end, dim, clockwise) {
            var i, last;
            if (clockwise === signedArea(data, start, end, dim) > 0) {
              for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
            } else {
              for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
            }
            if (last && equals(last, last.next)) {
              removeNode(last);
              last = last.next;
            }
            return last;
          } // eliminate colinear or duplicate points
          function filterPoints(start, end) {
            if (!start) return start;
            if (!end) end = start;
            var p = start,
              again;
            do {
              again = false;
              if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
                removeNode(p);
                p = end = p.prev;
                if (p === p.next) break;
                again = true;
              } else {
                p = p.next;
              }
            } while (again || p !== end);
            return end;
          } // main ear slicing loop which triangulates a polygon (given as a linked list)
          function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
            if (!ear) return; // interlink polygon nodes in z-order
            if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
            var stop = ear,
              prev,
              next; // iterate through ears, slicing them one by one
            while (ear.prev !== ear.next) {
              prev = ear.prev;
              next = ear.next;
              if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
                // cut off the triangle
                triangles.push(prev.i / dim | 0);
                triangles.push(ear.i / dim | 0);
                triangles.push(next.i / dim | 0);
                removeNode(ear); // skipping the next vertex leads to less sliver triangles
                ear = next.next;
                stop = next.next;
                continue;
              }
              ear = next; // if we looped through the whole remaining polygon and can't find any more ears
              if (ear === stop) {
                // try filtering points and slicing again
                if (!pass) {
                  earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1); // if this didn't work, try curing all small self-intersections locally
                } else if (pass === 1) {
                  ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                  earcutLinked(ear, triangles, dim, minX, minY, invSize, 2); // as a last resort, try splitting the remaining polygon into two
                } else if (pass === 2) {
                  splitEarcut(ear, triangles, dim, minX, minY, invSize);
                }
                break;
              }
            }
          } // check whether a polygon node forms a valid ear with adjacent nodes
          function isEar(ear) {
            var a = ear.prev,
              b = ear,
              c = ear.next;
            if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
            // now make sure we don't have other points inside the potential ear
            var ax = a.x,
              bx = b.x,
              cx = c.x,
              ay = a.y,
              by = b.y,
              cy = c.y; // triangle bbox; min & max are calculated like this for speed
            var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx,
              y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy,
              x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx,
              y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
            var p = c.next;
            while (p !== a) {
              if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
              p = p.next;
            }
            return true;
          }
          function isEarHashed(ear, minX, minY, invSize) {
            var a = ear.prev,
              b = ear,
              c = ear.next;
            if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
            var ax = a.x,
              bx = b.x,
              cx = c.x,
              ay = a.y,
              by = b.y,
              cy = c.y; // triangle bbox; min & max are calculated like this for speed
            var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx,
              y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy,
              x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx,
              y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy; // z-order range for the current triangle bbox;
            var minZ = zOrder(x0, y0, minX, minY, invSize),
              maxZ = zOrder(x1, y1, minX, minY, invSize);
            var p = ear.prevZ,
              n = ear.nextZ; // look for points inside the triangle in both directions
            while (p && p.z >= minZ && n && n.z <= maxZ) {
              if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
              p = p.prevZ;
              if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
              n = n.nextZ;
            } // look for remaining points in decreasing z-order
            while (p && p.z >= minZ) {
              if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
              p = p.prevZ;
            } // look for remaining points in increasing z-order
            while (n && n.z <= maxZ) {
              if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
              n = n.nextZ;
            }
            return true;
          } // go through all polygon nodes and cure small local self-intersections
          function cureLocalIntersections(start, triangles, dim) {
            var p = start;
            do {
              var a = p.prev,
                b = p.next.next;
              if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
                triangles.push(a.i / dim | 0);
                triangles.push(p.i / dim | 0);
                triangles.push(b.i / dim | 0); // remove two nodes involved
                removeNode(p);
                removeNode(p.next);
                p = start = b;
              }
              p = p.next;
            } while (p !== start);
            return filterPoints(p);
          } // try splitting polygon into two and triangulate them independently
          function splitEarcut(start, triangles, dim, minX, minY, invSize) {
            // look for a valid diagonal that divides the polygon into two
            var a = start;
            do {
              var b = a.next.next;
              while (b !== a.prev) {
                if (a.i !== b.i && isValidDiagonal(a, b)) {
                  // split the polygon in two by the diagonal
                  var c = splitPolygon(a, b); // filter colinear points around the cuts
                  a = filterPoints(a, a.next);
                  c = filterPoints(c, c.next); // run earcut on each half
                  earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                  earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                  return;
                }
                b = b.next;
              }
              a = a.next;
            } while (a !== start);
          } // link every hole into the outer loop, producing a single-ring polygon without holes
          function eliminateHoles(data, holeIndices, outerNode, dim) {
            var queue = [];
            var i, len, start, end, list;
            for (i = 0, len = holeIndices.length; i < len; i++) {
              start = holeIndices[i] * dim;
              end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
              list = linkedList(data, start, end, dim, false);
              if (list === list.next) list.steiner = true;
              queue.push(getLeftmost(list));
            }
            queue.sort(compareX); // process holes from left to right
            for (i = 0; i < queue.length; i++) {
              outerNode = eliminateHole(queue[i], outerNode);
            }
            return outerNode;
          }
          function compareX(a, b) {
            return a.x - b.x;
          } // find a bridge between vertices that connects hole with an outer ring and link it
          function eliminateHole(hole, outerNode) {
            var bridge = findHoleBridge(hole, outerNode);
            if (!bridge) {
              return outerNode;
            }
            var bridgeReverse = splitPolygon(bridge, hole); // filter collinear points around the cuts
            filterPoints(bridgeReverse, bridgeReverse.next);
            return filterPoints(bridge, bridge.next);
          } // David Eberly's algorithm for finding a bridge between hole and outer polygon
          function findHoleBridge(hole, outerNode) {
            var p = outerNode,
              qx = -Infinity,
              m;
            var hx = hole.x,
              hy = hole.y; // find a segment intersected by a ray from the hole's leftmost point to the left;
            // segment's endpoint with lesser x will be potential connection point
            do {
              if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
                var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
                if (x <= hx && x > qx) {
                  qx = x;
                  m = p.x < p.next.x ? p : p.next;
                  if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
                }
              }
              p = p.next;
            } while (p !== outerNode);
            if (!m) return null; // look for points inside the triangle of hole point, segment intersection and endpoint;
            // if there are no points found, we have a valid connection;
            // otherwise choose the point of the minimum angle with the ray as connection point
            var stop = m,
              mx = m.x,
              my = m.y;
            var tanMin = Infinity,
              tan;
            p = m;
            do {
              if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
                tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
                if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                  m = p;
                  tanMin = tan;
                }
              }
              p = p.next;
            } while (p !== stop);
            return m;
          } // whether sector in vertex m contains sector in vertex p in the same coordinates
          function sectorContainsSector(m, p) {
            return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
          } // interlink polygon nodes in z-order
          function indexCurve(start, minX, minY, invSize) {
            var p = start;
            do {
              if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
              p.prevZ = p.prev;
              p.nextZ = p.next;
              p = p.next;
            } while (p !== start);
            p.prevZ.nextZ = null;
            p.prevZ = null;
            sortLinked(p);
          } // Simon Tatham's linked list merge sort algorithm
          // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
          function sortLinked(list) {
            var i,
              p,
              q,
              e,
              tail,
              numMerges,
              pSize,
              qSize,
              inSize = 1;
            do {
              p = list;
              list = null;
              tail = null;
              numMerges = 0;
              while (p) {
                numMerges++;
                q = p;
                pSize = 0;
                for (i = 0; i < inSize; i++) {
                  pSize++;
                  q = q.nextZ;
                  if (!q) break;
                }
                qSize = inSize;
                while (pSize > 0 || qSize > 0 && q) {
                  if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                  } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                  }
                  if (tail) tail.nextZ = e;else list = e;
                  e.prevZ = tail;
                  tail = e;
                }
                p = q;
              }
              tail.nextZ = null;
              inSize *= 2;
            } while (numMerges > 1);
            return list;
          } // z-order of a point given coords and inverse of the longer side of data bbox
          function zOrder(x, y, minX, minY, invSize) {
            // coords are transformed into non-negative 15-bit integer range
            x = (x - minX) * invSize | 0;
            y = (y - minY) * invSize | 0;
            x = (x | x << 8) & 0x00FF00FF;
            x = (x | x << 4) & 0x0F0F0F0F;
            x = (x | x << 2) & 0x33333333;
            x = (x | x << 1) & 0x55555555;
            y = (y | y << 8) & 0x00FF00FF;
            y = (y | y << 4) & 0x0F0F0F0F;
            y = (y | y << 2) & 0x33333333;
            y = (y | y << 1) & 0x55555555;
            return x | y << 1;
          } // find the leftmost node of a polygon ring
          function getLeftmost(start) {
            var p = start,
              leftmost = start;
            do {
              if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
              p = p.next;
            } while (p !== start);
            return leftmost;
          } // check if a point lies within a convex triangle
          function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
            return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
          } // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
          function isValidDiagonal(a, b) {
            return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && (
            // dones't intersect other edges
            locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && (
            // locally visible
            area(a.prev, a, b.prev) || area(a, b.prev, b)) ||
            // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
          } // signed area of a triangle
          function area(p, q, r) {
            return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
          } // check if two points are equal
          function equals(p1, p2) {
            return p1.x === p2.x && p1.y === p2.y;
          } // check if two segments intersect
          function intersects(p1, q1, p2, q2) {
            var o1 = sign(area(p1, q1, p2));
            var o2 = sign(area(p1, q1, q2));
            var o3 = sign(area(p2, q2, p1));
            var o4 = sign(area(p2, q2, q1));
            if (o1 !== o2 && o3 !== o4) return true; // general case
            if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
            if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
            if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
            if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
            return false;
          } // for collinear points p, q, r, check if point q lies on segment pr
          function onSegment(p, q, r) {
            return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
          }
          function sign(num) {
            return num > 0 ? 1 : num < 0 ? -1 : 0;
          } // check if a polygon diagonal intersects any polygon segments
          function intersectsPolygon(a, b) {
            var p = a;
            do {
              if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
              p = p.next;
            } while (p !== a);
            return false;
          } // check if a polygon diagonal is locally inside the polygon
          function locallyInside(a, b) {
            return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
          } // check if the middle point of a polygon diagonal is inside the polygon
          function middleInside(a, b) {
            var p = a,
              inside = false;
            var px = (a.x + b.x) / 2,
              py = (a.y + b.y) / 2;
            do {
              if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
              p = p.next;
            } while (p !== a);
            return inside;
          } // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
          // if one belongs to the outer ring and another to a hole, it merges it into a single ring
          function splitPolygon(a, b) {
            var a2 = new Node(a.i, a.x, a.y),
              b2 = new Node(b.i, b.x, b.y),
              an = a.next,
              bp = b.prev;
            a.next = b;
            b.prev = a;
            a2.next = an;
            an.prev = a2;
            b2.next = a2;
            a2.prev = b2;
            bp.next = b2;
            b2.prev = bp;
            return b2;
          } // create a node and optionally link it with previous one (in a circular doubly linked list)
          function insertNode(i, x, y, last) {
            var p = new Node(i, x, y);
            if (!last) {
              p.prev = p;
              p.next = p;
            } else {
              p.next = last.next;
              p.prev = last;
              last.next.prev = p;
              last.next = p;
            }
            return p;
          }
          function removeNode(p) {
            p.next.prev = p.prev;
            p.prev.next = p.next;
            if (p.prevZ) p.prevZ.nextZ = p.nextZ;
            if (p.nextZ) p.nextZ.prevZ = p.prevZ;
          }
          function Node(i, x, y) {
            // vertex index in coordinates array
            this.i = i; // vertex coordinates
            this.x = x;
            this.y = y; // previous and next vertex nodes in a polygon ring
            this.prev = null;
            this.next = null; // z-order curve value
            this.z = 0; // previous and next nodes in z-order
            this.prevZ = null;
            this.nextZ = null; // indicates whether this is a steiner point
            this.steiner = false;
          }
          function signedArea(data, start, end, dim) {
            var sum = 0;
            for (var i = start, j = end - dim; i < end; i += dim) {
              sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
              j = i;
            }
            return sum;
          }
          var _ShapeUtils = /*#__PURE__*/function () {
            function _ShapeUtils() {
              _classCallCheck2(this, _ShapeUtils);
            }
            _createClass2(_ShapeUtils, null, [{
              key: "area",
              value:
              // calculate area of the contour polygon
              function area(contour) {
                var n = contour.length;
                var a = 0.0;
                for (var p = n - 1, q = 0; q < n; p = q++) {
                  a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
                }
                return a * 0.5;
              }
            }, {
              key: "isClockWise",
              value: function isClockWise(pts) {
                return _ShapeUtils.area(pts) < 0;
              }
            }, {
              key: "triangulateShape",
              value: function triangulateShape(contour, holes) {
                var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
                var holeIndices = []; // array of hole indices
                var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
                removeDupEndPts(contour);
                addContour(vertices, contour); //
                var holeIndex = contour.length;
                holes.forEach(removeDupEndPts);
                for (var i = 0; i < holes.length; i++) {
                  holeIndices.push(holeIndex);
                  holeIndex += holes[i].length;
                  addContour(vertices, holes[i]);
                } //
                var triangles = Earcut.triangulate(vertices, holeIndices); //
                for (var _i62 = 0; _i62 < triangles.length; _i62 += 3) {
                  faces.push(triangles.slice(_i62, _i62 + 3));
                }
                return faces;
              }
            }]);
            return _ShapeUtils;
          }();
          function removeDupEndPts(points) {
            var l = points.length;
            if (l > 2 && points[l - 1].equals(points[0])) {
              points.pop();
            }
          }
          function addContour(vertices, contour) {
            for (var i = 0; i < contour.length; i++) {
              vertices.push(contour[i].x);
              vertices.push(contour[i].y);
            }
          } /**
            * Creates extruded geometry from a path shape.
            *
            * parameters = {
            *
            *  curveSegments: <int>, // number of points on the curves
            *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
            *  depth: <float>, // Depth to extrude the shape
            *
            *  bevelEnabled: <bool>, // turn on bevel
            *  bevelThickness: <float>, // how deep into the original shape bevel goes
            *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
            *  bevelOffset: <float>, // how far from shape outline does bevel start
            *  bevelSegments: <int>, // number of bevel layers
            *
            *  extrudePath: <THREE.Curve> // curve to extrude shape along
            *
            *  UVGenerator: <Object> // object that provides UV generator functions
            *
            * }
            */
          var _ExtrudeGeometry = /*#__PURE__*/function (_BufferGeometry9) {
            _inherits(_ExtrudeGeometry, _BufferGeometry9);
            var _super90 = _createSuper(_ExtrudeGeometry);
            function _ExtrudeGeometry() {
              var _this81;
              var shapes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Shape([new _Vector(0.5, 0.5), new _Vector(-0.5, 0.5), new _Vector(-0.5, -0.5), new _Vector(0.5, -0.5)]);
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck2(this, _ExtrudeGeometry);
              _this81 = _super90.call(this);
              _this81.type = 'ExtrudeGeometry';
              _this81.parameters = {
                shapes: shapes,
                options: options
              };
              shapes = Array.isArray(shapes) ? shapes : [shapes];
              var scope = _assertThisInitialized(_this81);
              var verticesArray = [];
              var uvArray = [];
              for (var i = 0, l = shapes.length; i < l; i++) {
                var shape = shapes[i];
                addShape(shape);
              } // build geometry
              _this81.setAttribute('position', new _Float32BufferAttribute(verticesArray, 3));
              _this81.setAttribute('uv', new _Float32BufferAttribute(uvArray, 2));
              _this81.computeVertexNormals(); // functions
              function addShape(shape) {
                var placeholder = []; // options
                var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
                var steps = options.steps !== undefined ? options.steps : 1;
                var depth = options.depth !== undefined ? options.depth : 1;
                var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
                var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
                var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
                var bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
                var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
                var extrudePath = options.extrudePath;
                var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator; //
                var extrudePts,
                  extrudeByPath = false;
                var splineTube, binormal, normal, position2;
                if (extrudePath) {
                  extrudePts = extrudePath.getSpacedPoints(steps);
                  extrudeByPath = true;
                  bevelEnabled = false; // bevels not supported for path extrusion
                  // SETUP TNB variables
                  // TODO1 - have a .isClosed in spline?
                  splineTube = extrudePath.computeFrenetFrames(steps, false); // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                  binormal = new _Vector2();
                  normal = new _Vector2();
                  position2 = new _Vector2();
                } // Safeguards if bevels are not enabled
                if (!bevelEnabled) {
                  bevelSegments = 0;
                  bevelThickness = 0;
                  bevelSize = 0;
                  bevelOffset = 0;
                } // Variables initialization
                var shapePoints = shape.extractPoints(curveSegments);
                var vertices = shapePoints.shape;
                var holes = shapePoints.holes;
                var reverse = !_ShapeUtils.isClockWise(vertices);
                if (reverse) {
                  vertices = vertices.reverse(); // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                  for (var h = 0, hl = holes.length; h < hl; h++) {
                    var ahole = holes[h];
                    if (_ShapeUtils.isClockWise(ahole)) {
                      holes[h] = ahole.reverse();
                    }
                  }
                }
                var faces = _ShapeUtils.triangulateShape(vertices, holes); /* Vertices */
                var contour = vertices; // vertices has all points but contour has only points of circumference
                for (var _h2 = 0, _hl = holes.length; _h2 < _hl; _h2++) {
                  var _ahole = holes[_h2];
                  vertices = vertices.concat(_ahole);
                }
                function scalePt2(pt, vec, size) {
                  if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                  return vec.clone().multiplyScalar(size).add(pt);
                }
                var vlen = vertices.length,
                  flen = faces.length; // Find directions for point movement
                function getBevelVec(inPt, inPrev, inNext) {
                  // computes for inPt the corresponding point inPt' on a new contour
                  //   shifted by 1 unit (length of normalized vector) to the left
                  // if we walk along contour clockwise, this new contour is outside the old one
                  //
                  // inPt' is the intersection of the two lines parallel to the two
                  //  adjacent edges of inPt at a distance of 1 unit on the left side.
                  var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                  // good reading for geometry algorithms (here: line-line intersection)
                  // http://geomalgorithms.com/a05-_intersect-1.html
                  var v_prev_x = inPt.x - inPrev.x,
                    v_prev_y = inPt.y - inPrev.y;
                  var v_next_x = inNext.x - inPt.x,
                    v_next_y = inNext.y - inPt.y;
                  var v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y; // check for collinear edges
                  var collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                  if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    var v_prev_len = Math.sqrt(v_prev_lensq);
                    var v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y); // shift adjacent points by unit vectors to the left
                    var ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    var ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    var ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    var ptNextShift_y = inNext.y + v_next_x / v_next_len; // scaling factor for v_prev to intersection point
                    var sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x); // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y; // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    var v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) {
                      return new _Vector(v_trans_x, v_trans_y);
                    } else {
                      shrink_by = Math.sqrt(v_trans_lensq / 2);
                    }
                  } else {
                    // handle special case of collinear edges
                    var direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                      if (v_next_x > Number.EPSILON) {
                        direction_eq = true;
                      }
                    } else {
                      if (v_prev_x < -Number.EPSILON) {
                        if (v_next_x < -Number.EPSILON) {
                          direction_eq = true;
                        }
                      } else {
                        if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                          direction_eq = true;
                        }
                      }
                    }
                    if (direction_eq) {
                      // console.log("Warning: lines are a straight sequence");
                      v_trans_x = -v_prev_y;
                      v_trans_y = v_prev_x;
                      shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                      // console.log("Warning: lines are a straight spike");
                      v_trans_x = v_prev_x;
                      v_trans_y = v_prev_y;
                      shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                  }
                  return new _Vector(v_trans_x / shrink_by, v_trans_y / shrink_by);
                }
                var contourMovements = [];
                for (var _i63 = 0, il = contour.length, j = il - 1, k = _i63 + 1; _i63 < il; _i63++, j++, k++) {
                  if (j === il) j = 0;
                  if (k === il) k = 0; //  (j)---(i)---(k)
                  // console.log('i,j,k', i, j , k)
                  contourMovements[_i63] = getBevelVec(contour[_i63], contour[j], contour[k]);
                }
                var holesMovements = [];
                var oneHoleMovements,
                  verticesMovements = contourMovements.concat();
                for (var _h3 = 0, _hl2 = holes.length; _h3 < _hl2; _h3++) {
                  var _ahole2 = holes[_h3];
                  oneHoleMovements = [];
                  for (var _i64 = 0, _il14 = _ahole2.length, _j8 = _il14 - 1, _k2 = _i64 + 1; _i64 < _il14; _i64++, _j8++, _k2++) {
                    if (_j8 === _il14) _j8 = 0;
                    if (_k2 === _il14) _k2 = 0; //  (j)---(i)---(k)
                    oneHoleMovements[_i64] = getBevelVec(_ahole2[_i64], _ahole2[_j8], _ahole2[_k2]);
                  }
                  holesMovements.push(oneHoleMovements);
                  verticesMovements = verticesMovements.concat(oneHoleMovements);
                } // Loop bevelSegments, 1 for the front, 1 for the back
                for (var b = 0; b < bevelSegments; b++) {
                  //for ( b = bevelSegments; b > 0; b -- ) {
                  var t = b / bevelSegments;
                  var z = bevelThickness * Math.cos(t * Math.PI / 2);
                  var _bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset; // contract shape
                  for (var _i65 = 0, _il15 = contour.length; _i65 < _il15; _i65++) {
                    var vert = scalePt2(contour[_i65], contourMovements[_i65], _bs);
                    v(vert.x, vert.y, -z);
                  } // expand holes
                  for (var _h4 = 0, _hl3 = holes.length; _h4 < _hl3; _h4++) {
                    var _ahole3 = holes[_h4];
                    oneHoleMovements = holesMovements[_h4];
                    for (var _i66 = 0, _il16 = _ahole3.length; _i66 < _il16; _i66++) {
                      var _vert = scalePt2(_ahole3[_i66], oneHoleMovements[_i66], _bs);
                      v(_vert.x, _vert.y, -z);
                    }
                  }
                }
                var bs = bevelSize + bevelOffset; // Back facing vertices
                for (var _i67 = 0; _i67 < vlen; _i67++) {
                  var _vert2 = bevelEnabled ? scalePt2(vertices[_i67], verticesMovements[_i67], bs) : vertices[_i67];
                  if (!extrudeByPath) {
                    v(_vert2.x, _vert2.y, 0);
                  } else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(_vert2.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(_vert2.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                  }
                } // Add stepped vertices...
                // Including front facing vertices
                for (var s = 1; s <= steps; s++) {
                  for (var _i68 = 0; _i68 < vlen; _i68++) {
                    var _vert3 = bevelEnabled ? scalePt2(vertices[_i68], verticesMovements[_i68], bs) : vertices[_i68];
                    if (!extrudeByPath) {
                      v(_vert3.x, _vert3.y, depth / steps * s);
                    } else {
                      // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                      normal.copy(splineTube.normals[s]).multiplyScalar(_vert3.x);
                      binormal.copy(splineTube.binormals[s]).multiplyScalar(_vert3.y);
                      position2.copy(extrudePts[s]).add(normal).add(binormal);
                      v(position2.x, position2.y, position2.z);
                    }
                  }
                } // Add bevel segments planes
                //for ( b = 1; b <= bevelSegments; b ++ ) {
                for (var _b5 = bevelSegments - 1; _b5 >= 0; _b5--) {
                  var _t2 = _b5 / bevelSegments;
                  var _z2 = bevelThickness * Math.cos(_t2 * Math.PI / 2);
                  var _bs2 = bevelSize * Math.sin(_t2 * Math.PI / 2) + bevelOffset; // contract shape
                  for (var _i69 = 0, _il17 = contour.length; _i69 < _il17; _i69++) {
                    var _vert4 = scalePt2(contour[_i69], contourMovements[_i69], _bs2);
                    v(_vert4.x, _vert4.y, depth + _z2);
                  } // expand holes
                  for (var _h5 = 0, _hl4 = holes.length; _h5 < _hl4; _h5++) {
                    var _ahole4 = holes[_h5];
                    oneHoleMovements = holesMovements[_h5];
                    for (var _i70 = 0, _il18 = _ahole4.length; _i70 < _il18; _i70++) {
                      var _vert5 = scalePt2(_ahole4[_i70], oneHoleMovements[_i70], _bs2);
                      if (!extrudeByPath) {
                        v(_vert5.x, _vert5.y, depth + _z2);
                      } else {
                        v(_vert5.x, _vert5.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + _z2);
                      }
                    }
                  }
                } /* Faces */ // Top and bottom faces
                buildLidFaces(); // Sides faces
                buildSideFaces(); /////  Internal functions
                function buildLidFaces() {
                  var start = verticesArray.length / 3;
                  if (bevelEnabled) {
                    var layer = 0; // steps + 1
                    var offset = vlen * layer; // Bottom faces
                    for (var _i71 = 0; _i71 < flen; _i71++) {
                      var face = faces[_i71];
                      f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer; // Top faces
                    for (var _i72 = 0; _i72 < flen; _i72++) {
                      var _face = faces[_i72];
                      f3(_face[0] + offset, _face[1] + offset, _face[2] + offset);
                    }
                  } else {
                    // Bottom faces
                    for (var _i73 = 0; _i73 < flen; _i73++) {
                      var _face2 = faces[_i73];
                      f3(_face2[2], _face2[1], _face2[0]);
                    } // Top faces
                    for (var _i74 = 0; _i74 < flen; _i74++) {
                      var _face3 = faces[_i74];
                      f3(_face3[0] + vlen * steps, _face3[1] + vlen * steps, _face3[2] + vlen * steps);
                    }
                  }
                  scope.addGroup(start, verticesArray.length / 3 - start, 0);
                } // Create faces for the z-sides of the shape
                function buildSideFaces() {
                  var start = verticesArray.length / 3;
                  var layeroffset = 0;
                  sidewalls(contour, layeroffset);
                  layeroffset += contour.length;
                  for (var _h6 = 0, _hl5 = holes.length; _h6 < _hl5; _h6++) {
                    var _ahole5 = holes[_h6];
                    sidewalls(_ahole5, layeroffset); //, true
                    layeroffset += _ahole5.length;
                  }
                  scope.addGroup(start, verticesArray.length / 3 - start, 1);
                }
                function sidewalls(contour, layeroffset) {
                  var i = contour.length;
                  while (--i >= 0) {
                    var _j9 = i;
                    var _k3 = i - 1;
                    if (_k3 < 0) _k3 = contour.length - 1; //console.log('b', i,j, i-1, k,vertices.length);
                    for (var _s5 = 0, sl = steps + bevelSegments * 2; _s5 < sl; _s5++) {
                      var slen1 = vlen * _s5;
                      var slen2 = vlen * (_s5 + 1);
                      var a = layeroffset + _j9 + slen1,
                        _b6 = layeroffset + _k3 + slen1,
                        c = layeroffset + _k3 + slen2,
                        d = layeroffset + _j9 + slen2;
                      f4(a, _b6, c, d);
                    }
                  }
                }
                function v(x, y, z) {
                  placeholder.push(x);
                  placeholder.push(y);
                  placeholder.push(z);
                }
                function f3(a, b, c) {
                  addVertex(a);
                  addVertex(b);
                  addVertex(c);
                  var nextIndex = verticesArray.length / 3;
                  var uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                  addUV(uvs[0]);
                  addUV(uvs[1]);
                  addUV(uvs[2]);
                }
                function f4(a, b, c, d) {
                  addVertex(a);
                  addVertex(b);
                  addVertex(d);
                  addVertex(b);
                  addVertex(c);
                  addVertex(d);
                  var nextIndex = verticesArray.length / 3;
                  var uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                  addUV(uvs[0]);
                  addUV(uvs[1]);
                  addUV(uvs[3]);
                  addUV(uvs[1]);
                  addUV(uvs[2]);
                  addUV(uvs[3]);
                }
                function addVertex(index) {
                  verticesArray.push(placeholder[index * 3 + 0]);
                  verticesArray.push(placeholder[index * 3 + 1]);
                  verticesArray.push(placeholder[index * 3 + 2]);
                }
                function addUV(vector2) {
                  uvArray.push(vector2.x);
                  uvArray.push(vector2.y);
                }
              }
              return _this81;
            }
            _createClass2(_ExtrudeGeometry, [{
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_ExtrudeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                var options = this.parameters.options;
                return toJSON$1(shapes, options, data);
              }
            }], [{
              key: "fromJSON",
              value: function fromJSON(data, shapes) {
                var geometryShapes = [];
                for (var j = 0, jl = data.shapes.length; j < jl; j++) {
                  var shape = shapes[data.shapes[j]];
                  geometryShapes.push(shape);
                }
                var extrudePath = data.options.extrudePath;
                if (extrudePath !== undefined) {
                  data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
                }
                return new _ExtrudeGeometry(geometryShapes, data.options);
              }
            }]);
            return _ExtrudeGeometry;
          }(_BufferGeometry);
          var WorldUVGenerator = {
            generateTopUV: function generateTopUV(geometry, vertices, indexA, indexB, indexC) {
              var a_x = vertices[indexA * 3];
              var a_y = vertices[indexA * 3 + 1];
              var b_x = vertices[indexB * 3];
              var b_y = vertices[indexB * 3 + 1];
              var c_x = vertices[indexC * 3];
              var c_y = vertices[indexC * 3 + 1];
              return [new _Vector(a_x, a_y), new _Vector(b_x, b_y), new _Vector(c_x, c_y)];
            },
            generateSideWallUV: function generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {
              var a_x = vertices[indexA * 3];
              var a_y = vertices[indexA * 3 + 1];
              var a_z = vertices[indexA * 3 + 2];
              var b_x = vertices[indexB * 3];
              var b_y = vertices[indexB * 3 + 1];
              var b_z = vertices[indexB * 3 + 2];
              var c_x = vertices[indexC * 3];
              var c_y = vertices[indexC * 3 + 1];
              var c_z = vertices[indexC * 3 + 2];
              var d_x = vertices[indexD * 3];
              var d_y = vertices[indexD * 3 + 1];
              var d_z = vertices[indexD * 3 + 2];
              if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
                return [new _Vector(a_x, 1 - a_z), new _Vector(b_x, 1 - b_z), new _Vector(c_x, 1 - c_z), new _Vector(d_x, 1 - d_z)];
              } else {
                return [new _Vector(a_y, 1 - a_z), new _Vector(b_y, 1 - b_z), new _Vector(c_y, 1 - c_z), new _Vector(d_y, 1 - d_z)];
              }
            }
          };
          function toJSON$1(shapes, options, data) {
            data.shapes = [];
            if (Array.isArray(shapes)) {
              for (var i = 0, l = shapes.length; i < l; i++) {
                var shape = shapes[i];
                data.shapes.push(shape.uuid);
              }
            } else {
              data.shapes.push(shapes.uuid);
            }
            data.options = Object.assign({}, options);
            if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
            return data;
          }
          var _IcosahedronGeometry = /*#__PURE__*/function (_PolyhedronGeometry3) {
            _inherits(_IcosahedronGeometry, _PolyhedronGeometry3);
            var _super91 = _createSuper(_IcosahedronGeometry);
            function _IcosahedronGeometry() {
              var _this82;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck2(this, _IcosahedronGeometry);
              var t = (1 + Math.sqrt(5)) / 2;
              var vertices = [-1, t, 0, 1, t, 0, -1, -t, 0, 1, -t, 0, 0, -1, t, 0, 1, t, 0, -1, -t, 0, 1, -t, t, 0, -1, t, 0, 1, -t, 0, -1, -t, 0, 1];
              var indices = [0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1];
              _this82 = _super91.call(this, vertices, indices, radius, detail);
              _this82.type = 'IcosahedronGeometry';
              _this82.parameters = {
                radius: radius,
                detail: detail
              };
              return _this82;
            }
            _createClass2(_IcosahedronGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _IcosahedronGeometry(data.radius, data.detail);
              }
            }]);
            return _IcosahedronGeometry;
          }(_PolyhedronGeometry);
          var _OctahedronGeometry = /*#__PURE__*/function (_PolyhedronGeometry4) {
            _inherits(_OctahedronGeometry, _PolyhedronGeometry4);
            var _super92 = _createSuper(_OctahedronGeometry);
            function _OctahedronGeometry() {
              var _this83;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck2(this, _OctahedronGeometry);
              var vertices = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1];
              var indices = [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2];
              _this83 = _super92.call(this, vertices, indices, radius, detail);
              _this83.type = 'OctahedronGeometry';
              _this83.parameters = {
                radius: radius,
                detail: detail
              };
              return _this83;
            }
            _createClass2(_OctahedronGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _OctahedronGeometry(data.radius, data.detail);
              }
            }]);
            return _OctahedronGeometry;
          }(_PolyhedronGeometry);
          var _RingGeometry = /*#__PURE__*/function (_BufferGeometry10) {
            _inherits(_RingGeometry, _BufferGeometry10);
            var _super93 = _createSuper(_RingGeometry);
            function _RingGeometry() {
              var _this84;
              var innerRadius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
              var outerRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var thetaSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
              var phiSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
              var thetaStart = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
              var thetaLength = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.PI * 2;
              _classCallCheck2(this, _RingGeometry);
              _this84 = _super93.call(this);
              _this84.type = 'RingGeometry';
              _this84.parameters = {
                innerRadius: innerRadius,
                outerRadius: outerRadius,
                thetaSegments: thetaSegments,
                phiSegments: phiSegments,
                thetaStart: thetaStart,
                thetaLength: thetaLength
              };
              thetaSegments = Math.max(3, thetaSegments);
              phiSegments = Math.max(1, phiSegments); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // some helper variables
              var radius = innerRadius;
              var radiusStep = (outerRadius - innerRadius) / phiSegments;
              var vertex = new _Vector2();
              var uv = new _Vector(); // generate vertices, normals and uvs
              for (var j = 0; j <= phiSegments; j++) {
                for (var i = 0; i <= thetaSegments; i++) {
                  // values are generate from the inside of the ring to the outside
                  var segment = thetaStart + i / thetaSegments * thetaLength; // vertex
                  vertex.x = radius * Math.cos(segment);
                  vertex.y = radius * Math.sin(segment);
                  vertices.push(vertex.x, vertex.y, vertex.z); // normal
                  normals.push(0, 0, 1); // uv
                  uv.x = (vertex.x / outerRadius + 1) / 2;
                  uv.y = (vertex.y / outerRadius + 1) / 2;
                  uvs.push(uv.x, uv.y);
                } // increase the radius for next row of vertices
                radius += radiusStep;
              } // indices
              for (var _j10 = 0; _j10 < phiSegments; _j10++) {
                var thetaSegmentLevel = _j10 * (thetaSegments + 1);
                for (var _i75 = 0; _i75 < thetaSegments; _i75++) {
                  var _segment = _i75 + thetaSegmentLevel;
                  var a = _segment;
                  var b = _segment + thetaSegments + 1;
                  var c = _segment + thetaSegments + 2;
                  var d = _segment + 1; // faces
                  indices.push(a, b, d);
                  indices.push(b, c, d);
                }
              } // build geometry
              _this84.setIndex(indices);
              _this84.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this84.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this84.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              return _this84;
            }
            _createClass2(_RingGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
              }
            }]);
            return _RingGeometry;
          }(_BufferGeometry);
          var _ShapeGeometry = /*#__PURE__*/function (_BufferGeometry11) {
            _inherits(_ShapeGeometry, _BufferGeometry11);
            var _super94 = _createSuper(_ShapeGeometry);
            function _ShapeGeometry() {
              var _this85;
              var shapes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Shape([new _Vector(0, 0.5), new _Vector(-0.5, -0.5), new _Vector(0.5, -0.5)]);
              var curveSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
              _classCallCheck2(this, _ShapeGeometry);
              _this85 = _super94.call(this);
              _this85.type = 'ShapeGeometry';
              _this85.parameters = {
                shapes: shapes,
                curveSegments: curveSegments
              }; // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // helper variables
              var groupStart = 0;
              var groupCount = 0; // allow single and array values for "shapes" parameter
              if (Array.isArray(shapes) === false) {
                addShape(shapes);
              } else {
                for (var i = 0; i < shapes.length; i++) {
                  addShape(shapes[i]);
                  _this85.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
                  groupStart += groupCount;
                  groupCount = 0;
                }
              } // build geometry
              _this85.setIndex(indices);
              _this85.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this85.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this85.setAttribute('uv', new _Float32BufferAttribute(uvs, 2)); // helper functions
              function addShape(shape) {
                var indexOffset = vertices.length / 3;
                var points = shape.extractPoints(curveSegments);
                var shapeVertices = points.shape;
                var shapeHoles = points.holes; // check direction of vertices
                if (_ShapeUtils.isClockWise(shapeVertices) === false) {
                  shapeVertices = shapeVertices.reverse();
                }
                for (var _i76 = 0, l = shapeHoles.length; _i76 < l; _i76++) {
                  var shapeHole = shapeHoles[_i76];
                  if (_ShapeUtils.isClockWise(shapeHole) === true) {
                    shapeHoles[_i76] = shapeHole.reverse();
                  }
                }
                var faces = _ShapeUtils.triangulateShape(shapeVertices, shapeHoles); // join vertices of inner and outer paths to a single array
                for (var _i77 = 0, _l8 = shapeHoles.length; _i77 < _l8; _i77++) {
                  var _shapeHole = shapeHoles[_i77];
                  shapeVertices = shapeVertices.concat(_shapeHole);
                } // vertices, normals, uvs
                for (var _i78 = 0, _l9 = shapeVertices.length; _i78 < _l9; _i78++) {
                  var _vertex = shapeVertices[_i78];
                  vertices.push(_vertex.x, _vertex.y, 0);
                  normals.push(0, 0, 1);
                  uvs.push(_vertex.x, _vertex.y); // world uvs
                } // indices
                for (var _i79 = 0, _l10 = faces.length; _i79 < _l10; _i79++) {
                  var face = faces[_i79];
                  var a = face[0] + indexOffset;
                  var b = face[1] + indexOffset;
                  var c = face[2] + indexOffset;
                  indices.push(a, b, c);
                  groupCount += 3;
                }
              }
              return _this85;
            }
            _createClass2(_ShapeGeometry, [{
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_ShapeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                return _toJSON(shapes, data);
              }
            }], [{
              key: "fromJSON",
              value: function fromJSON(data, shapes) {
                var geometryShapes = [];
                for (var j = 0, jl = data.shapes.length; j < jl; j++) {
                  var shape = shapes[data.shapes[j]];
                  geometryShapes.push(shape);
                }
                return new _ShapeGeometry(geometryShapes, data.curveSegments);
              }
            }]);
            return _ShapeGeometry;
          }(_BufferGeometry);
          function _toJSON(shapes, data) {
            data.shapes = [];
            if (Array.isArray(shapes)) {
              for (var i = 0, l = shapes.length; i < l; i++) {
                var shape = shapes[i];
                data.shapes.push(shape.uuid);
              }
            } else {
              data.shapes.push(shapes.uuid);
            }
            return data;
          }
          var _SphereGeometry = /*#__PURE__*/function (_BufferGeometry12) {
            _inherits(_SphereGeometry, _BufferGeometry12);
            var _super95 = _createSuper(_SphereGeometry);
            function _SphereGeometry() {
              var _this86;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var widthSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
              var heightSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
              var phiStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
              var phiLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.PI * 2;
              var thetaStart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
              var thetaLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Math.PI;
              _classCallCheck2(this, _SphereGeometry);
              _this86 = _super95.call(this);
              _this86.type = 'SphereGeometry';
              _this86.parameters = {
                radius: radius,
                widthSegments: widthSegments,
                heightSegments: heightSegments,
                phiStart: phiStart,
                phiLength: phiLength,
                thetaStart: thetaStart,
                thetaLength: thetaLength
              };
              widthSegments = Math.max(3, Math.floor(widthSegments));
              heightSegments = Math.max(2, Math.floor(heightSegments));
              var thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
              var index = 0;
              var grid = [];
              var vertex = new _Vector2();
              var normal = new _Vector2(); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // generate vertices, normals and uvs
              for (var iy = 0; iy <= heightSegments; iy++) {
                var verticesRow = [];
                var v = iy / heightSegments; // special case for the poles
                var uOffset = 0;
                if (iy == 0 && thetaStart == 0) {
                  uOffset = 0.5 / widthSegments;
                } else if (iy == heightSegments && thetaEnd == Math.PI) {
                  uOffset = -0.5 / widthSegments;
                }
                for (var ix = 0; ix <= widthSegments; ix++) {
                  var u = ix / widthSegments; // vertex
                  vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                  vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                  vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                  vertices.push(vertex.x, vertex.y, vertex.z); // normal
                  normal.copy(vertex).normalize();
                  normals.push(normal.x, normal.y, normal.z); // uv
                  uvs.push(u + uOffset, 1 - v);
                  verticesRow.push(index++);
                }
                grid.push(verticesRow);
              } // indices
              for (var _iy3 = 0; _iy3 < heightSegments; _iy3++) {
                for (var _ix3 = 0; _ix3 < widthSegments; _ix3++) {
                  var a = grid[_iy3][_ix3 + 1];
                  var b = grid[_iy3][_ix3];
                  var c = grid[_iy3 + 1][_ix3];
                  var d = grid[_iy3 + 1][_ix3 + 1];
                  if (_iy3 !== 0 || thetaStart > 0) indices.push(a, b, d);
                  if (_iy3 !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
                }
              } // build geometry
              _this86.setIndex(indices);
              _this86.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this86.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this86.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              return _this86;
            }
            _createClass2(_SphereGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
              }
            }]);
            return _SphereGeometry;
          }(_BufferGeometry);
          var _TetrahedronGeometry = /*#__PURE__*/function (_PolyhedronGeometry5) {
            _inherits(_TetrahedronGeometry, _PolyhedronGeometry5);
            var _super96 = _createSuper(_TetrahedronGeometry);
            function _TetrahedronGeometry() {
              var _this87;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              _classCallCheck2(this, _TetrahedronGeometry);
              var vertices = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1];
              var indices = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1];
              _this87 = _super96.call(this, vertices, indices, radius, detail);
              _this87.type = 'TetrahedronGeometry';
              _this87.parameters = {
                radius: radius,
                detail: detail
              };
              return _this87;
            }
            _createClass2(_TetrahedronGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _TetrahedronGeometry(data.radius, data.detail);
              }
            }]);
            return _TetrahedronGeometry;
          }(_PolyhedronGeometry);
          var _TorusGeometry = /*#__PURE__*/function (_BufferGeometry13) {
            _inherits(_TorusGeometry, _BufferGeometry13);
            var _super97 = _createSuper(_TorusGeometry);
            function _TorusGeometry() {
              var _this88;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var tube = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
              var radialSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
              var tubularSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;
              var arc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.PI * 2;
              _classCallCheck2(this, _TorusGeometry);
              _this88 = _super97.call(this);
              _this88.type = 'TorusGeometry';
              _this88.parameters = {
                radius: radius,
                tube: tube,
                radialSegments: radialSegments,
                tubularSegments: tubularSegments,
                arc: arc
              };
              radialSegments = Math.floor(radialSegments);
              tubularSegments = Math.floor(tubularSegments); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // helper variables
              var center = new _Vector2();
              var vertex = new _Vector2();
              var normal = new _Vector2(); // generate vertices, normals and uvs
              for (var j = 0; j <= radialSegments; j++) {
                for (var i = 0; i <= tubularSegments; i++) {
                  var u = i / tubularSegments * arc;
                  var v = j / radialSegments * Math.PI * 2; // vertex
                  vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
                  vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
                  vertex.z = tube * Math.sin(v);
                  vertices.push(vertex.x, vertex.y, vertex.z); // normal
                  center.x = radius * Math.cos(u);
                  center.y = radius * Math.sin(u);
                  normal.subVectors(vertex, center).normalize();
                  normals.push(normal.x, normal.y, normal.z); // uv
                  uvs.push(i / tubularSegments);
                  uvs.push(j / radialSegments);
                }
              } // generate indices
              for (var _j11 = 1; _j11 <= radialSegments; _j11++) {
                for (var _i80 = 1; _i80 <= tubularSegments; _i80++) {
                  // indices
                  var a = (tubularSegments + 1) * _j11 + _i80 - 1;
                  var b = (tubularSegments + 1) * (_j11 - 1) + _i80 - 1;
                  var c = (tubularSegments + 1) * (_j11 - 1) + _i80;
                  var d = (tubularSegments + 1) * _j11 + _i80; // faces
                  indices.push(a, b, d);
                  indices.push(b, c, d);
                }
              } // build geometry
              _this88.setIndex(indices);
              _this88.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this88.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this88.setAttribute('uv', new _Float32BufferAttribute(uvs, 2));
              return _this88;
            }
            _createClass2(_TorusGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
              }
            }]);
            return _TorusGeometry;
          }(_BufferGeometry);
          var _TorusKnotGeometry = /*#__PURE__*/function (_BufferGeometry14) {
            _inherits(_TorusKnotGeometry, _BufferGeometry14);
            var _super98 = _createSuper(_TorusKnotGeometry);
            function _TorusKnotGeometry() {
              var _this89;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var tube = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
              var tubularSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 64;
              var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
              var p = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
              var q = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 3;
              _classCallCheck2(this, _TorusKnotGeometry);
              _this89 = _super98.call(this);
              _this89.type = 'TorusKnotGeometry';
              _this89.parameters = {
                radius: radius,
                tube: tube,
                tubularSegments: tubularSegments,
                radialSegments: radialSegments,
                p: p,
                q: q
              };
              tubularSegments = Math.floor(tubularSegments);
              radialSegments = Math.floor(radialSegments); // buffers
              var indices = [];
              var vertices = [];
              var normals = [];
              var uvs = []; // helper variables
              var vertex = new _Vector2();
              var normal = new _Vector2();
              var P1 = new _Vector2();
              var P2 = new _Vector2();
              var B = new _Vector2();
              var T = new _Vector2();
              var N = new _Vector2(); // generate vertices, normals and uvs
              for (var i = 0; i <= tubularSegments; ++i) {
                // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
                var u = i / tubularSegments * p * Math.PI * 2; // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
                // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
                calculatePositionOnCurve(u, p, q, radius, P1);
                calculatePositionOnCurve(u + 0.01, p, q, radius, P2); // calculate orthonormal basis
                T.subVectors(P2, P1);
                N.addVectors(P2, P1);
                B.crossVectors(T, N);
                N.crossVectors(B, T); // normalize B, N. T can be ignored, we don't use it
                B.normalize();
                N.normalize();
                for (var j = 0; j <= radialSegments; ++j) {
                  // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                  // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                  var v = j / radialSegments * Math.PI * 2;
                  var cx = -tube * Math.cos(v);
                  var cy = tube * Math.sin(v); // now calculate the final vertex position.
                  // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                  vertex.x = P1.x + (cx * N.x + cy * B.x);
                  vertex.y = P1.y + (cx * N.y + cy * B.y);
                  vertex.z = P1.z + (cx * N.z + cy * B.z);
                  vertices.push(vertex.x, vertex.y, vertex.z); // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                  normal.subVectors(vertex, P1).normalize();
                  normals.push(normal.x, normal.y, normal.z); // uv
                  uvs.push(i / tubularSegments);
                  uvs.push(j / radialSegments);
                }
              } // generate indices
              for (var _j12 = 1; _j12 <= tubularSegments; _j12++) {
                for (var _i81 = 1; _i81 <= radialSegments; _i81++) {
                  // indices
                  var a = (radialSegments + 1) * (_j12 - 1) + (_i81 - 1);
                  var b = (radialSegments + 1) * _j12 + (_i81 - 1);
                  var c = (radialSegments + 1) * _j12 + _i81;
                  var d = (radialSegments + 1) * (_j12 - 1) + _i81; // faces
                  indices.push(a, b, d);
                  indices.push(b, c, d);
                }
              } // build geometry
              _this89.setIndex(indices);
              _this89.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this89.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this89.setAttribute('uv', new _Float32BufferAttribute(uvs, 2)); // this function calculates the current position on the torus curve
              function calculatePositionOnCurve(u, p, q, radius, position) {
                var cu = Math.cos(u);
                var su = Math.sin(u);
                var quOverP = q / p * u;
                var cs = Math.cos(quOverP);
                position.x = radius * (2 + cs) * 0.5 * cu;
                position.y = radius * (2 + cs) * su * 0.5;
                position.z = radius * Math.sin(quOverP) * 0.5;
              }
              return _this89;
            }
            _createClass2(_TorusKnotGeometry, null, [{
              key: "fromJSON",
              value: function fromJSON(data) {
                return new _TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
              }
            }]);
            return _TorusKnotGeometry;
          }(_BufferGeometry);
          var _TubeGeometry = /*#__PURE__*/function (_BufferGeometry15) {
            _inherits(_TubeGeometry, _BufferGeometry15);
            var _super99 = _createSuper(_TubeGeometry);
            function _TubeGeometry() {
              var _this90;
              var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _QuadraticBezierCurve2(new _Vector2(-1, -1, 0), new _Vector2(-1, 1, 0), new _Vector2(1, 1, 0));
              var tubularSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
              var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
              var closed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
              _classCallCheck2(this, _TubeGeometry);
              _this90 = _super99.call(this);
              _this90.type = 'TubeGeometry';
              _this90.parameters = {
                path: path,
                tubularSegments: tubularSegments,
                radius: radius,
                radialSegments: radialSegments,
                closed: closed
              };
              var frames = path.computeFrenetFrames(tubularSegments, closed); // expose internals
              _this90.tangents = frames.tangents;
              _this90.normals = frames.normals;
              _this90.binormals = frames.binormals; // helper variables
              var vertex = new _Vector2();
              var normal = new _Vector2();
              var uv = new _Vector();
              var P = new _Vector2(); // buffer
              var vertices = [];
              var normals = [];
              var uvs = [];
              var indices = []; // create buffer data
              generateBufferData(); // build geometry
              _this90.setIndex(indices);
              _this90.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              _this90.setAttribute('normal', new _Float32BufferAttribute(normals, 3));
              _this90.setAttribute('uv', new _Float32BufferAttribute(uvs, 2)); // functions
              function generateBufferData() {
                for (var i = 0; i < tubularSegments; i++) {
                  generateSegment(i);
                } // if the geometry is not closed, generate the last row of vertices and normals
                // at the regular position on the given path
                //
                // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
                generateSegment(closed === false ? tubularSegments : 0); // uvs are generated in a separate function.
                // this makes it easy compute correct values for closed geometries
                generateUVs(); // finally create faces
                generateIndices();
              }
              function generateSegment(i) {
                // we use getPointAt to sample evenly distributed points from the given path
                P = path.getPointAt(i / tubularSegments, P); // retrieve corresponding normal and binormal
                var N = frames.normals[i];
                var B = frames.binormals[i]; // generate normals and vertices for the current segment
                for (var j = 0; j <= radialSegments; j++) {
                  var v = j / radialSegments * Math.PI * 2;
                  var sin = Math.sin(v);
                  var cos = -Math.cos(v); // normal
                  normal.x = cos * N.x + sin * B.x;
                  normal.y = cos * N.y + sin * B.y;
                  normal.z = cos * N.z + sin * B.z;
                  normal.normalize();
                  normals.push(normal.x, normal.y, normal.z); // vertex
                  vertex.x = P.x + radius * normal.x;
                  vertex.y = P.y + radius * normal.y;
                  vertex.z = P.z + radius * normal.z;
                  vertices.push(vertex.x, vertex.y, vertex.z);
                }
              }
              function generateIndices() {
                for (var j = 1; j <= tubularSegments; j++) {
                  for (var i = 1; i <= radialSegments; i++) {
                    var a = (radialSegments + 1) * (j - 1) + (i - 1);
                    var b = (radialSegments + 1) * j + (i - 1);
                    var c = (radialSegments + 1) * j + i;
                    var d = (radialSegments + 1) * (j - 1) + i; // faces
                    indices.push(a, b, d);
                    indices.push(b, c, d);
                  }
                }
              }
              function generateUVs() {
                for (var i = 0; i <= tubularSegments; i++) {
                  for (var j = 0; j <= radialSegments; j++) {
                    uv.x = i / tubularSegments;
                    uv.y = j / radialSegments;
                    uvs.push(uv.x, uv.y);
                  }
                }
              }
              return _this90;
            }
            _createClass2(_TubeGeometry, [{
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_TubeGeometry.prototype), "toJSON", this).call(this);
                data.path = this.parameters.path.toJSON();
                return data;
              }
            }], [{
              key: "fromJSON",
              value: function fromJSON(data) {
                // This only works for built-in curves (e.g. CatmullRomCurve3).
                // User defined curves or instances of CurvePath will not be deserialized.
                return new _TubeGeometry(new Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
              }
            }]);
            return _TubeGeometry;
          }(_BufferGeometry);
          var _WireframeGeometry = /*#__PURE__*/function (_BufferGeometry16) {
            _inherits(_WireframeGeometry, _BufferGeometry16);
            var _super100 = _createSuper(_WireframeGeometry);
            function _WireframeGeometry() {
              var _this91;
              var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              _classCallCheck2(this, _WireframeGeometry);
              _this91 = _super100.call(this);
              _this91.type = 'WireframeGeometry';
              _this91.parameters = {
                geometry: geometry
              };
              if (geometry !== null) {
                // buffer
                var vertices = [];
                var edges = new Set(); // helper variables
                var start = new _Vector2();
                var end = new _Vector2();
                if (geometry.index !== null) {
                  // indexed BufferGeometry
                  var position = geometry.attributes.position;
                  var indices = geometry.index;
                  var groups = geometry.groups;
                  if (groups.length === 0) {
                    groups = [{
                      start: 0,
                      count: indices.count,
                      materialIndex: 0
                    }];
                  } // create a data structure that contains all edges without duplicates
                  for (var o = 0, ol = groups.length; o < ol; ++o) {
                    var group = groups[o];
                    var groupStart = group.start;
                    var groupCount = group.count;
                    for (var i = groupStart, l = groupStart + groupCount; i < l; i += 3) {
                      for (var j = 0; j < 3; j++) {
                        var index1 = indices.getX(i + j);
                        var index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if (isUniqueEdge(start, end, edges) === true) {
                          vertices.push(start.x, start.y, start.z);
                          vertices.push(end.x, end.y, end.z);
                        }
                      }
                    }
                  }
                } else {
                  // non-indexed BufferGeometry
                  var _position2 = geometry.attributes.position;
                  for (var _i82 = 0, _l11 = _position2.count / 3; _i82 < _l11; _i82++) {
                    for (var _j13 = 0; _j13 < 3; _j13++) {
                      // three edges per triangle, an edge is represented as (index1, index2)
                      // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                      var _index2 = 3 * _i82 + _j13;
                      var _index3 = 3 * _i82 + (_j13 + 1) % 3;
                      start.fromBufferAttribute(_position2, _index2);
                      end.fromBufferAttribute(_position2, _index3);
                      if (isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                      }
                    }
                  }
                } // build geometry
                _this91.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              }
              return _this91;
            }
            return _createClass2(_WireframeGeometry);
          }(_BufferGeometry);
          function isUniqueEdge(start, end, edges) {
            var hash1 = "".concat(start.x, ",").concat(start.y, ",").concat(start.z, "-").concat(end.x, ",").concat(end.y, ",").concat(end.z);
            var hash2 = "".concat(end.x, ",").concat(end.y, ",").concat(end.z, "-").concat(start.x, ",").concat(start.y, ",").concat(start.z); // coincident edge
            if (edges.has(hash1) === true || edges.has(hash2) === true) {
              return false;
            } else {
              edges.add(hash1);
              edges.add(hash2);
              return true;
            }
          }
          var Geometries = /*#__PURE__*/Object.freeze({
            __proto__: null,
            BoxGeometry: _BoxGeometry,
            CapsuleGeometry: _CapsuleGeometry,
            CircleGeometry: _CircleGeometry,
            ConeGeometry: _ConeGeometry,
            CylinderGeometry: _CylinderGeometry,
            DodecahedronGeometry: _DodecahedronGeometry,
            EdgesGeometry: _EdgesGeometry,
            ExtrudeGeometry: _ExtrudeGeometry,
            IcosahedronGeometry: _IcosahedronGeometry,
            LatheGeometry: _LatheGeometry,
            OctahedronGeometry: _OctahedronGeometry,
            PlaneGeometry: _PlaneGeometry,
            PolyhedronGeometry: _PolyhedronGeometry,
            RingGeometry: _RingGeometry,
            ShapeGeometry: _ShapeGeometry,
            SphereGeometry: _SphereGeometry,
            TetrahedronGeometry: _TetrahedronGeometry,
            TorusGeometry: _TorusGeometry,
            TorusKnotGeometry: _TorusKnotGeometry,
            TubeGeometry: _TubeGeometry,
            WireframeGeometry: _WireframeGeometry
          });
          var _ShadowMaterial = /*#__PURE__*/function (_Material9) {
            _inherits(_ShadowMaterial, _Material9);
            var _super101 = _createSuper(_ShadowMaterial);
            function _ShadowMaterial(parameters) {
              var _this92;
              _classCallCheck2(this, _ShadowMaterial);
              _this92 = _super101.call(this);
              _this92.isShadowMaterial = true;
              _this92.type = 'ShadowMaterial';
              _this92.color = new _Color(0x000000);
              _this92.transparent = true;
              _this92.fog = true;
              _this92.setValues(parameters);
              return _this92;
            }
            _createClass2(_ShadowMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_ShadowMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.fog = source.fog;
                return this;
              }
            }]);
            return _ShadowMaterial;
          }(_Material);
          var _RawShaderMaterial = /*#__PURE__*/function (_ShaderMaterial2) {
            _inherits(_RawShaderMaterial, _ShaderMaterial2);
            var _super102 = _createSuper(_RawShaderMaterial);
            function _RawShaderMaterial(parameters) {
              var _this93;
              _classCallCheck2(this, _RawShaderMaterial);
              _this93 = _super102.call(this, parameters);
              _this93.isRawShaderMaterial = true;
              _this93.type = 'RawShaderMaterial';
              return _this93;
            }
            return _createClass2(_RawShaderMaterial);
          }(_ShaderMaterial);
          var _MeshStandardMaterial = /*#__PURE__*/function (_Material10) {
            _inherits(_MeshStandardMaterial, _Material10);
            var _super103 = _createSuper(_MeshStandardMaterial);
            function _MeshStandardMaterial(parameters) {
              var _this94;
              _classCallCheck2(this, _MeshStandardMaterial);
              _this94 = _super103.call(this);
              _this94.isMeshStandardMaterial = true;
              _this94.defines = {
                'STANDARD': ''
              };
              _this94.type = 'MeshStandardMaterial';
              _this94.color = new _Color(0xffffff); // diffuse
              _this94.roughness = 1.0;
              _this94.metalness = 0.0;
              _this94.map = null;
              _this94.lightMap = null;
              _this94.lightMapIntensity = 1.0;
              _this94.aoMap = null;
              _this94.aoMapIntensity = 1.0;
              _this94.emissive = new _Color(0x000000);
              _this94.emissiveIntensity = 1.0;
              _this94.emissiveMap = null;
              _this94.bumpMap = null;
              _this94.bumpScale = 1;
              _this94.normalMap = null;
              _this94.normalMapType = _TangentSpaceNormalMap;
              _this94.normalScale = new _Vector(1, 1);
              _this94.displacementMap = null;
              _this94.displacementScale = 1;
              _this94.displacementBias = 0;
              _this94.roughnessMap = null;
              _this94.metalnessMap = null;
              _this94.alphaMap = null;
              _this94.envMap = null;
              _this94.envMapIntensity = 1.0;
              _this94.wireframe = false;
              _this94.wireframeLinewidth = 1;
              _this94.wireframeLinecap = 'round';
              _this94.wireframeLinejoin = 'round';
              _this94.flatShading = false;
              _this94.fog = true;
              _this94.setValues(parameters);
              return _this94;
            }
            _createClass2(_MeshStandardMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshStandardMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                  'STANDARD': ''
                };
                this.color.copy(source.color);
                this.roughness = source.roughness;
                this.metalness = source.metalness;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.roughnessMap = source.roughnessMap;
                this.metalnessMap = source.metalnessMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapIntensity = source.envMapIntensity;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _MeshStandardMaterial;
          }(_Material);
          var _MeshPhysicalMaterial = /*#__PURE__*/function (_MeshStandardMaterial2) {
            _inherits(_MeshPhysicalMaterial, _MeshStandardMaterial2);
            var _super104 = _createSuper(_MeshPhysicalMaterial);
            function _MeshPhysicalMaterial(parameters) {
              var _this95;
              _classCallCheck2(this, _MeshPhysicalMaterial);
              _this95 = _super104.call(this);
              _this95.isMeshPhysicalMaterial = true;
              _this95.defines = {
                'STANDARD': '',
                'PHYSICAL': ''
              };
              _this95.type = 'MeshPhysicalMaterial';
              _this95.clearcoatMap = null;
              _this95.clearcoatRoughness = 0.0;
              _this95.clearcoatRoughnessMap = null;
              _this95.clearcoatNormalScale = new _Vector(1, 1);
              _this95.clearcoatNormalMap = null;
              _this95.ior = 1.5;
              Object.defineProperty(_assertThisInitialized(_this95), 'reflectivity', {
                get: function get() {
                  return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
                },
                set: function set(reflectivity) {
                  this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
                }
              });
              _this95.iridescenceMap = null;
              _this95.iridescenceIOR = 1.3;
              _this95.iridescenceThicknessRange = [100, 400];
              _this95.iridescenceThicknessMap = null;
              _this95.sheenColor = new _Color(0x000000);
              _this95.sheenColorMap = null;
              _this95.sheenRoughness = 1.0;
              _this95.sheenRoughnessMap = null;
              _this95.transmissionMap = null;
              _this95.thickness = 0;
              _this95.thicknessMap = null;
              _this95.attenuationDistance = Infinity;
              _this95.attenuationColor = new _Color(1, 1, 1);
              _this95.specularIntensity = 1.0;
              _this95.specularIntensityMap = null;
              _this95.specularColor = new _Color(1, 1, 1);
              _this95.specularColorMap = null;
              _this95._sheen = 0.0;
              _this95._clearcoat = 0;
              _this95._iridescence = 0;
              _this95._transmission = 0;
              _this95.setValues(parameters);
              return _this95;
            }
            _createClass2(_MeshPhysicalMaterial, [{
              key: "sheen",
              get: function get() {
                return this._sheen;
              },
              set: function set(value) {
                if (this._sheen > 0 !== value > 0) {
                  this.version++;
                }
                this._sheen = value;
              }
            }, {
              key: "clearcoat",
              get: function get() {
                return this._clearcoat;
              },
              set: function set(value) {
                if (this._clearcoat > 0 !== value > 0) {
                  this.version++;
                }
                this._clearcoat = value;
              }
            }, {
              key: "iridescence",
              get: function get() {
                return this._iridescence;
              },
              set: function set(value) {
                if (this._iridescence > 0 !== value > 0) {
                  this.version++;
                }
                this._iridescence = value;
              }
            }, {
              key: "transmission",
              get: function get() {
                return this._transmission;
              },
              set: function set(value) {
                if (this._transmission > 0 !== value > 0) {
                  this.version++;
                }
                this._transmission = value;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshPhysicalMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                  'STANDARD': '',
                  'PHYSICAL': ''
                };
                this.clearcoat = source.clearcoat;
                this.clearcoatMap = source.clearcoatMap;
                this.clearcoatRoughness = source.clearcoatRoughness;
                this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
                this.clearcoatNormalMap = source.clearcoatNormalMap;
                this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
                this.ior = source.ior;
                this.iridescence = source.iridescence;
                this.iridescenceMap = source.iridescenceMap;
                this.iridescenceIOR = source.iridescenceIOR;
                this.iridescenceThicknessRange = _toConsumableArray(source.iridescenceThicknessRange);
                this.iridescenceThicknessMap = source.iridescenceThicknessMap;
                this.sheen = source.sheen;
                this.sheenColor.copy(source.sheenColor);
                this.sheenColorMap = source.sheenColorMap;
                this.sheenRoughness = source.sheenRoughness;
                this.sheenRoughnessMap = source.sheenRoughnessMap;
                this.transmission = source.transmission;
                this.transmissionMap = source.transmissionMap;
                this.thickness = source.thickness;
                this.thicknessMap = source.thicknessMap;
                this.attenuationDistance = source.attenuationDistance;
                this.attenuationColor.copy(source.attenuationColor);
                this.specularIntensity = source.specularIntensity;
                this.specularIntensityMap = source.specularIntensityMap;
                this.specularColor.copy(source.specularColor);
                this.specularColorMap = source.specularColorMap;
                return this;
              }
            }]);
            return _MeshPhysicalMaterial;
          }(_MeshStandardMaterial);
          var _MeshPhongMaterial = /*#__PURE__*/function (_Material11) {
            _inherits(_MeshPhongMaterial, _Material11);
            var _super105 = _createSuper(_MeshPhongMaterial);
            function _MeshPhongMaterial(parameters) {
              var _this96;
              _classCallCheck2(this, _MeshPhongMaterial);
              _this96 = _super105.call(this);
              _this96.isMeshPhongMaterial = true;
              _this96.type = 'MeshPhongMaterial';
              _this96.color = new _Color(0xffffff); // diffuse
              _this96.specular = new _Color(0x111111);
              _this96.shininess = 30;
              _this96.map = null;
              _this96.lightMap = null;
              _this96.lightMapIntensity = 1.0;
              _this96.aoMap = null;
              _this96.aoMapIntensity = 1.0;
              _this96.emissive = new _Color(0x000000);
              _this96.emissiveIntensity = 1.0;
              _this96.emissiveMap = null;
              _this96.bumpMap = null;
              _this96.bumpScale = 1;
              _this96.normalMap = null;
              _this96.normalMapType = _TangentSpaceNormalMap;
              _this96.normalScale = new _Vector(1, 1);
              _this96.displacementMap = null;
              _this96.displacementScale = 1;
              _this96.displacementBias = 0;
              _this96.specularMap = null;
              _this96.alphaMap = null;
              _this96.envMap = null;
              _this96.combine = _MultiplyOperation;
              _this96.reflectivity = 1;
              _this96.refractionRatio = 0.98;
              _this96.wireframe = false;
              _this96.wireframeLinewidth = 1;
              _this96.wireframeLinecap = 'round';
              _this96.wireframeLinejoin = 'round';
              _this96.flatShading = false;
              _this96.fog = true;
              _this96.setValues(parameters);
              return _this96;
            }
            _createClass2(_MeshPhongMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshPhongMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.specular.copy(source.specular);
                this.shininess = source.shininess;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _MeshPhongMaterial;
          }(_Material);
          var _MeshToonMaterial = /*#__PURE__*/function (_Material12) {
            _inherits(_MeshToonMaterial, _Material12);
            var _super106 = _createSuper(_MeshToonMaterial);
            function _MeshToonMaterial(parameters) {
              var _this97;
              _classCallCheck2(this, _MeshToonMaterial);
              _this97 = _super106.call(this);
              _this97.isMeshToonMaterial = true;
              _this97.defines = {
                'TOON': ''
              };
              _this97.type = 'MeshToonMaterial';
              _this97.color = new _Color(0xffffff);
              _this97.map = null;
              _this97.gradientMap = null;
              _this97.lightMap = null;
              _this97.lightMapIntensity = 1.0;
              _this97.aoMap = null;
              _this97.aoMapIntensity = 1.0;
              _this97.emissive = new _Color(0x000000);
              _this97.emissiveIntensity = 1.0;
              _this97.emissiveMap = null;
              _this97.bumpMap = null;
              _this97.bumpScale = 1;
              _this97.normalMap = null;
              _this97.normalMapType = _TangentSpaceNormalMap;
              _this97.normalScale = new _Vector(1, 1);
              _this97.displacementMap = null;
              _this97.displacementScale = 1;
              _this97.displacementBias = 0;
              _this97.alphaMap = null;
              _this97.wireframe = false;
              _this97.wireframeLinewidth = 1;
              _this97.wireframeLinecap = 'round';
              _this97.wireframeLinejoin = 'round';
              _this97.fog = true;
              _this97.setValues(parameters);
              return _this97;
            }
            _createClass2(_MeshToonMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshToonMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.gradientMap = source.gradientMap;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _MeshToonMaterial;
          }(_Material);
          var _MeshNormalMaterial = /*#__PURE__*/function (_Material13) {
            _inherits(_MeshNormalMaterial, _Material13);
            var _super107 = _createSuper(_MeshNormalMaterial);
            function _MeshNormalMaterial(parameters) {
              var _this98;
              _classCallCheck2(this, _MeshNormalMaterial);
              _this98 = _super107.call(this);
              _this98.isMeshNormalMaterial = true;
              _this98.type = 'MeshNormalMaterial';
              _this98.bumpMap = null;
              _this98.bumpScale = 1;
              _this98.normalMap = null;
              _this98.normalMapType = _TangentSpaceNormalMap;
              _this98.normalScale = new _Vector(1, 1);
              _this98.displacementMap = null;
              _this98.displacementScale = 1;
              _this98.displacementBias = 0;
              _this98.wireframe = false;
              _this98.wireframeLinewidth = 1;
              _this98.flatShading = false;
              _this98.setValues(parameters);
              return _this98;
            }
            _createClass2(_MeshNormalMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshNormalMaterial.prototype), "copy", this).call(this, source);
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.flatShading = source.flatShading;
                return this;
              }
            }]);
            return _MeshNormalMaterial;
          }(_Material);
          var _MeshLambertMaterial = /*#__PURE__*/function (_Material14) {
            _inherits(_MeshLambertMaterial, _Material14);
            var _super108 = _createSuper(_MeshLambertMaterial);
            function _MeshLambertMaterial(parameters) {
              var _this99;
              _classCallCheck2(this, _MeshLambertMaterial);
              _this99 = _super108.call(this);
              _this99.isMeshLambertMaterial = true;
              _this99.type = 'MeshLambertMaterial';
              _this99.color = new _Color(0xffffff); // diffuse
              _this99.map = null;
              _this99.lightMap = null;
              _this99.lightMapIntensity = 1.0;
              _this99.aoMap = null;
              _this99.aoMapIntensity = 1.0;
              _this99.emissive = new _Color(0x000000);
              _this99.emissiveIntensity = 1.0;
              _this99.emissiveMap = null;
              _this99.bumpMap = null;
              _this99.bumpScale = 1;
              _this99.normalMap = null;
              _this99.normalMapType = _TangentSpaceNormalMap;
              _this99.normalScale = new _Vector(1, 1);
              _this99.displacementMap = null;
              _this99.displacementScale = 1;
              _this99.displacementBias = 0;
              _this99.specularMap = null;
              _this99.alphaMap = null;
              _this99.envMap = null;
              _this99.combine = _MultiplyOperation;
              _this99.reflectivity = 1;
              _this99.refractionRatio = 0.98;
              _this99.wireframe = false;
              _this99.wireframeLinewidth = 1;
              _this99.wireframeLinecap = 'round';
              _this99.wireframeLinejoin = 'round';
              _this99.flatShading = false;
              _this99.fog = true;
              _this99.setValues(parameters);
              return _this99;
            }
            _createClass2(_MeshLambertMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshLambertMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _MeshLambertMaterial;
          }(_Material);
          var _MeshMatcapMaterial = /*#__PURE__*/function (_Material15) {
            _inherits(_MeshMatcapMaterial, _Material15);
            var _super109 = _createSuper(_MeshMatcapMaterial);
            function _MeshMatcapMaterial(parameters) {
              var _this100;
              _classCallCheck2(this, _MeshMatcapMaterial);
              _this100 = _super109.call(this);
              _this100.isMeshMatcapMaterial = true;
              _this100.defines = {
                'MATCAP': ''
              };
              _this100.type = 'MeshMatcapMaterial';
              _this100.color = new _Color(0xffffff); // diffuse
              _this100.matcap = null;
              _this100.map = null;
              _this100.bumpMap = null;
              _this100.bumpScale = 1;
              _this100.normalMap = null;
              _this100.normalMapType = _TangentSpaceNormalMap;
              _this100.normalScale = new _Vector(1, 1);
              _this100.displacementMap = null;
              _this100.displacementScale = 1;
              _this100.displacementBias = 0;
              _this100.alphaMap = null;
              _this100.flatShading = false;
              _this100.fog = true;
              _this100.setValues(parameters);
              return _this100;
            }
            _createClass2(_MeshMatcapMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_MeshMatcapMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                  'MATCAP': ''
                };
                this.color.copy(source.color);
                this.matcap = source.matcap;
                this.map = source.map;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
              }
            }]);
            return _MeshMatcapMaterial;
          }(_Material);
          var _LineDashedMaterial = /*#__PURE__*/function (_LineBasicMaterial2) {
            _inherits(_LineDashedMaterial, _LineBasicMaterial2);
            var _super110 = _createSuper(_LineDashedMaterial);
            function _LineDashedMaterial(parameters) {
              var _this101;
              _classCallCheck2(this, _LineDashedMaterial);
              _this101 = _super110.call(this);
              _this101.isLineDashedMaterial = true;
              _this101.type = 'LineDashedMaterial';
              _this101.scale = 1;
              _this101.dashSize = 3;
              _this101.gapSize = 1;
              _this101.setValues(parameters);
              return _this101;
            }
            _createClass2(_LineDashedMaterial, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_LineDashedMaterial.prototype), "copy", this).call(this, source);
                this.scale = source.scale;
                this.dashSize = source.dashSize;
                this.gapSize = source.gapSize;
                return this;
              }
            }]);
            return _LineDashedMaterial;
          }(_LineBasicMaterial); // same as Array.prototype.slice, but also works on typed arrays
          function arraySlice(array, from, to) {
            if (isTypedArray(array)) {
              // in ios9 array.subarray(from, undefined) will return empty array
              // but array.subarray(from) or array.subarray(from, len) is correct
              return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
            }
            return array.slice(from, to);
          } // converts an array to a specific type
          function convertArray(array, type, forceClone) {
            if (!array ||
            // let 'undefined' and 'null' pass
            !forceClone && array.constructor === type) return array;
            if (typeof type.BYTES_PER_ELEMENT === 'number') {
              return new type(array); // create typed array
            }
            return Array.prototype.slice.call(array); // create Array
          }
          function isTypedArray(object) {
            return ArrayBuffer.isView(object) && !(object instanceof DataView);
          } // returns an array by which times and values can be sorted
          function getKeyframeOrder(times) {
            function compareTime(i, j) {
              return times[i] - times[j];
            }
            var n = times.length;
            var result = new Array(n);
            for (var i = 0; i !== n; ++i) result[i] = i;
            result.sort(compareTime);
            return result;
          } // uses the array previously returned by 'getKeyframeOrder' to sort data
          function sortedArray(values, stride, order) {
            var nValues = values.length;
            var result = new values.constructor(nValues);
            for (var i = 0, dstOffset = 0; dstOffset !== nValues; ++i) {
              var srcOffset = order[i] * stride;
              for (var j = 0; j !== stride; ++j) {
                result[dstOffset++] = values[srcOffset + j];
              }
            }
            return result;
          } // function for parsing AOS keyframe formats
          function flattenJSON(jsonKeys, times, values, valuePropertyName) {
            var i = 1,
              key = jsonKeys[0];
            while (key !== undefined && key[valuePropertyName] === undefined) {
              key = jsonKeys[i++];
            }
            if (key === undefined) return; // no data
            var value = key[valuePropertyName];
            if (value === undefined) return; // no data
            if (Array.isArray(value)) {
              do {
                value = key[valuePropertyName];
                if (value !== undefined) {
                  times.push(key.time);
                  values.push.apply(values, value); // push all elements
                }
                key = jsonKeys[i++];
              } while (key !== undefined);
            } else if (value.toArray !== undefined) {
              // ...assume THREE.Math-ish
              do {
                value = key[valuePropertyName];
                if (value !== undefined) {
                  times.push(key.time);
                  value.toArray(values, values.length);
                }
                key = jsonKeys[i++];
              } while (key !== undefined);
            } else {
              // otherwise push as-is
              do {
                value = key[valuePropertyName];
                if (value !== undefined) {
                  times.push(key.time);
                  values.push(value);
                }
                key = jsonKeys[i++];
              } while (key !== undefined);
            }
          }
          function subclip(sourceClip, name, startFrame, endFrame) {
            var fps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
            var clip = sourceClip.clone();
            clip.name = name;
            var tracks = [];
            for (var i = 0; i < clip.tracks.length; ++i) {
              var track = clip.tracks[i];
              var valueSize = track.getValueSize();
              var times = [];
              var values = [];
              for (var j = 0; j < track.times.length; ++j) {
                var frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for (var k = 0; k < valueSize; ++k) {
                  values.push(track.values[j * valueSize + k]);
                }
              }
              if (times.length === 0) continue;
              track.times = convertArray(times, track.times.constructor);
              track.values = convertArray(values, track.values.constructor);
              tracks.push(track);
            }
            clip.tracks = tracks; // find minimum .times value across all tracks in the trimmed clip
            var minStartTime = Infinity;
            for (var _i83 = 0; _i83 < clip.tracks.length; ++_i83) {
              if (minStartTime > clip.tracks[_i83].times[0]) {
                minStartTime = clip.tracks[_i83].times[0];
              }
            } // shift all tracks such that clip begins at t=0
            for (var _i84 = 0; _i84 < clip.tracks.length; ++_i84) {
              clip.tracks[_i84].shift(-1 * minStartTime);
            }
            clip.resetDuration();
            return clip;
          }
          function makeClipAdditive(targetClip) {
            var referenceFrame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var referenceClip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : targetClip;
            var fps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
            if (fps <= 0) fps = 30;
            var numTracks = referenceClip.tracks.length;
            var referenceTime = referenceFrame / fps; // Make each track's values relative to the values at the reference frame
            var _loop = function _loop() {
              var referenceTrack = referenceClip.tracks[i];
              var referenceTrackType = referenceTrack.ValueTypeName; // Skip this track if it's non-numeric
              if (referenceTrackType === 'bool' || referenceTrackType === 'string') return "continue"; // Find the track in the target clip whose name and type matches the reference track
              var targetTrack = targetClip.tracks.find(function (track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
              });
              if (targetTrack === undefined) return "continue";
              var referenceOffset = 0;
              var referenceValueSize = referenceTrack.getValueSize();
              if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
                referenceOffset = referenceValueSize / 3;
              }
              var targetOffset = 0;
              var targetValueSize = targetTrack.getValueSize();
              if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
                targetOffset = targetValueSize / 3;
              }
              var lastIndex = referenceTrack.times.length - 1;
              var referenceValue; // Find the value to subtract out of the track
              if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                var startIndex = referenceOffset;
                var endIndex = referenceValueSize - referenceOffset;
                referenceValue = arraySlice(referenceTrack.values, startIndex, endIndex);
              } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                var _startIndex = lastIndex * referenceValueSize + referenceOffset;
                var _endIndex = _startIndex + referenceValueSize - referenceOffset;
                referenceValue = arraySlice(referenceTrack.values, _startIndex, _endIndex);
              } else {
                // Interpolate to the reference value
                var interpolant = referenceTrack.createInterpolant();
                var _startIndex2 = referenceOffset;
                var _endIndex2 = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = arraySlice(interpolant.resultBuffer, _startIndex2, _endIndex2);
              } // Conjugate the quaternion
              if (referenceTrackType === 'quaternion') {
                var referenceQuat = new _Quaternion().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
              } // Subtract the reference value from all of the track values
              var numTimes = targetTrack.times.length;
              for (var j = 0; j < numTimes; ++j) {
                var valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === 'quaternion') {
                  // Multiply the conjugate for quaternion track types
                  _Quaternion.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                } else {
                  var valueEnd = targetValueSize - targetOffset * 2; // Subtract each value for all other numeric track types
                  for (var k = 0; k < valueEnd; ++k) {
                    targetTrack.values[valueStart + k] -= referenceValue[k];
                  }
                }
              }
            };
            for (var i = 0; i < numTracks; ++i) {
              var _ret = _loop();
              if (_ret === "continue") continue;
            }
            targetClip.blendMode = _AdditiveAnimationBlendMode;
            return targetClip;
          }
          var _AnimationUtils = /*#__PURE__*/Object.freeze({
            __proto__: null,
            arraySlice: arraySlice,
            convertArray: convertArray,
            isTypedArray: isTypedArray,
            getKeyframeOrder: getKeyframeOrder,
            sortedArray: sortedArray,
            flattenJSON: flattenJSON,
            subclip: subclip,
            makeClipAdditive: makeClipAdditive
          }); /**
              * Abstract base class of interpolants over parametric samples.
              *
              * The parameter domain is one dimensional, typically the time or a path
              * along a curve defined by the data.
              *
              * The sample values can have any dimensionality and derived classes may
              * apply special interpretations to the data.
              *
              * This class provides the interval seek in a Template Method, deferring
              * the actual interpolation to derived classes.
              *
              * Time complexity is O(1) for linear access crossing at most two points
              * and O(log N) for random access, where N is the number of positions.
              *
              * References:
              *
              * 		http://www.oodesign.com/template-method-pattern.html
              *
              */
          var _Interpolant = /*#__PURE__*/function () {
            function _Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
              _classCallCheck2(this, _Interpolant);
              this.parameterPositions = parameterPositions;
              this._cachedIndex = 0;
              this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
              this.sampleValues = sampleValues;
              this.valueSize = sampleSize;
              this.settings = null;
              this.DefaultSettings_ = {};
            }
            _createClass2(_Interpolant, [{
              key: "evaluate",
              value: function evaluate(t) {
                var pp = this.parameterPositions;
                var i1 = this._cachedIndex,
                  t1 = pp[i1],
                  t0 = pp[i1 - 1];
                validate_interval: {
                  seek: {
                    var right;
                    linear_scan: {
                      //- See http://jsperf.com/comparison-to-undefined/3
                      //- slower code:
                      //-
                      //- 				if ( t >= t1 || t1 === undefined ) {
                      forward_scan: if (!(t < t1)) {
                        for (var giveUpAt = i1 + 2;;) {
                          if (t1 === undefined) {
                            if (t < t0) break forward_scan; // after end
                            i1 = pp.length;
                            this._cachedIndex = i1;
                            return this.copySampleValue_(i1 - 1);
                          }
                          if (i1 === giveUpAt) break; // this loop
                          t0 = t1;
                          t1 = pp[++i1];
                          if (t < t1) {
                            // we have arrived at the sought interval
                            break seek;
                          }
                        } // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                      } //- slower code:
                      //-					if ( t < t0 || t0 === undefined ) {
                      if (!(t >= t0)) {
                        // looping?
                        var t1global = pp[1];
                        if (t < t1global) {
                          i1 = 2; // + 1, using the scan for the details
                          t0 = t1global;
                        } // linear reverse scan
                        for (var _giveUpAt = i1 - 2;;) {
                          if (t0 === undefined) {
                            // before start
                            this._cachedIndex = 0;
                            return this.copySampleValue_(0);
                          }
                          if (i1 === _giveUpAt) break; // this loop
                          t1 = t0;
                          t0 = pp[--i1 - 1];
                          if (t >= t0) {
                            // we have arrived at the sought interval
                            break seek;
                          }
                        } // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                      } // the interval is valid
                      break validate_interval;
                    } // linear scan
                    // binary search
                    while (i1 < right) {
                      var mid = i1 + right >>> 1;
                      if (t < pp[mid]) {
                        right = mid;
                      } else {
                        i1 = mid + 1;
                      }
                    }
                    t1 = pp[i1];
                    t0 = pp[i1 - 1]; // check boundary cases, again
                    if (t0 === undefined) {
                      this._cachedIndex = 0;
                      return this.copySampleValue_(0);
                    }
                    if (t1 === undefined) {
                      i1 = pp.length;
                      this._cachedIndex = i1;
                      return this.copySampleValue_(i1 - 1);
                    }
                  } // seek
                  this._cachedIndex = i1;
                  this.intervalChanged_(i1, t0, t1);
                } // validate_interval
                return this.interpolate_(i1, t0, t, t1);
              }
            }, {
              key: "getSettings_",
              value: function getSettings_() {
                return this.settings || this.DefaultSettings_;
              }
            }, {
              key: "copySampleValue_",
              value: function copySampleValue_(index) {
                // copies a sample value to the result buffer
                var result = this.resultBuffer,
                  values = this.sampleValues,
                  stride = this.valueSize,
                  offset = index * stride;
                for (var i = 0; i !== stride; ++i) {
                  result[i] = values[offset + i];
                }
                return result;
              } // Template methods for derived classes:
            }, {
              key: "interpolate_",
              value: function interpolate_( /* i1, t0, t, t1 */
              ) {
                throw new Error('call to abstract method'); // implementations shall return this.resultBuffer
              }
            }, {
              key: "intervalChanged_",
              value: function intervalChanged_( /* i1, t0, t1 */
              ) {// empty
              }
            }]);
            return _Interpolant;
          }();
          /**
          * Fast and simple cubic spline interpolant.
          *
          * It was derived from a Hermitian construction setting the first derivative
          * at each sample position to the linear slope between neighboring positions
          * over their parameter interval.
          */
          var _CubicInterpolant = /*#__PURE__*/function (_Interpolant2) {
            _inherits(_CubicInterpolant, _Interpolant2);
            var _super111 = _createSuper(_CubicInterpolant);
            function _CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
              var _this102;
              _classCallCheck2(this, _CubicInterpolant);
              _this102 = _super111.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
              _this102._weightPrev = -0;
              _this102._offsetPrev = -0;
              _this102._weightNext = -0;
              _this102._offsetNext = -0;
              _this102.DefaultSettings_ = {
                endingStart: _ZeroCurvatureEnding,
                endingEnd: _ZeroCurvatureEnding
              };
              return _this102;
            }
            _createClass2(_CubicInterpolant, [{
              key: "intervalChanged_",
              value: function intervalChanged_(i1, t0, t1) {
                var pp = this.parameterPositions;
                var iPrev = i1 - 2,
                  iNext = i1 + 1,
                  tPrev = pp[iPrev],
                  tNext = pp[iNext];
                if (tPrev === undefined) {
                  switch (this.getSettings_().endingStart) {
                    case _ZeroSlopeEnding:
                      // f'(t0) = 0
                      iPrev = i1;
                      tPrev = 2 * t0 - t1;
                      break;
                    case _WrapAroundEnding:
                      // use the other end of the curve
                      iPrev = pp.length - 2;
                      tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                      break;
                    default:
                      // ZeroCurvatureEnding
                      // f''(t0) = 0 a.k.a. Natural Spline
                      iPrev = i1;
                      tPrev = t1;
                  }
                }
                if (tNext === undefined) {
                  switch (this.getSettings_().endingEnd) {
                    case _ZeroSlopeEnding:
                      // f'(tN) = 0
                      iNext = i1;
                      tNext = 2 * t1 - t0;
                      break;
                    case _WrapAroundEnding:
                      // use the other end of the curve
                      iNext = 1;
                      tNext = t1 + pp[1] - pp[0];
                      break;
                    default:
                      // ZeroCurvatureEnding
                      // f''(tN) = 0, a.k.a. Natural Spline
                      iNext = i1 - 1;
                      tNext = t0;
                  }
                }
                var halfDt = (t1 - t0) * 0.5,
                  stride = this.valueSize;
                this._weightPrev = halfDt / (t0 - tPrev);
                this._weightNext = halfDt / (tNext - t1);
                this._offsetPrev = iPrev * stride;
                this._offsetNext = iNext * stride;
              }
            }, {
              key: "interpolate_",
              value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer,
                  values = this.sampleValues,
                  stride = this.valueSize,
                  o1 = i1 * stride,
                  o0 = o1 - stride,
                  oP = this._offsetPrev,
                  oN = this._offsetNext,
                  wP = this._weightPrev,
                  wN = this._weightNext,
                  p = (t - t0) / (t1 - t0),
                  pp = p * p,
                  ppp = pp * p; // evaluate polynomials
                var sP = -wP * ppp + 2 * wP * pp - wP * p;
                var s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
                var s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
                var sN = wN * ppp - wN * pp; // combine data linearly
                for (var i = 0; i !== stride; ++i) {
                  result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
                }
                return result;
              }
            }]);
            return _CubicInterpolant;
          }(_Interpolant);
          var _LinearInterpolant = /*#__PURE__*/function (_Interpolant3) {
            _inherits(_LinearInterpolant, _Interpolant3);
            var _super112 = _createSuper(_LinearInterpolant);
            function _LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
              _classCallCheck2(this, _LinearInterpolant);
              return _super112.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
            }
            _createClass2(_LinearInterpolant, [{
              key: "interpolate_",
              value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer,
                  values = this.sampleValues,
                  stride = this.valueSize,
                  offset1 = i1 * stride,
                  offset0 = offset1 - stride,
                  weight1 = (t - t0) / (t1 - t0),
                  weight0 = 1 - weight1;
                for (var i = 0; i !== stride; ++i) {
                  result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
                }
                return result;
              }
            }]);
            return _LinearInterpolant;
          }(_Interpolant);
          /**
          *
          * Interpolant that evaluates to the sample value at the position preceding
          * the parameter.
          */
          var _DiscreteInterpolant = /*#__PURE__*/function (_Interpolant4) {
            _inherits(_DiscreteInterpolant, _Interpolant4);
            var _super113 = _createSuper(_DiscreteInterpolant);
            function _DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
              _classCallCheck2(this, _DiscreteInterpolant);
              return _super113.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
            }
            _createClass2(_DiscreteInterpolant, [{
              key: "interpolate_",
              value: function interpolate_(i1 /*, t0, t, t1 */) {
                return this.copySampleValue_(i1 - 1);
              }
            }]);
            return _DiscreteInterpolant;
          }(_Interpolant);
          var _KeyframeTrack = /*#__PURE__*/function () {
            function _KeyframeTrack(name, times, values, interpolation) {
              _classCallCheck2(this, _KeyframeTrack);
              if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
              if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
              this.name = name;
              this.times = convertArray(times, this.TimeBufferType);
              this.values = convertArray(values, this.ValueBufferType);
              this.setInterpolation(interpolation || this.DefaultInterpolation);
            } // Serialization (in static context, because of constructor invocation
            // and automatic invocation of .toJSON):
            _createClass2(_KeyframeTrack, [{
              key: "InterpolantFactoryMethodDiscrete",
              value: function InterpolantFactoryMethodDiscrete(result) {
                return new _DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
              }
            }, {
              key: "InterpolantFactoryMethodLinear",
              value: function InterpolantFactoryMethodLinear(result) {
                return new _LinearInterpolant(this.times, this.values, this.getValueSize(), result);
              }
            }, {
              key: "InterpolantFactoryMethodSmooth",
              value: function InterpolantFactoryMethodSmooth(result) {
                return new _CubicInterpolant(this.times, this.values, this.getValueSize(), result);
              }
            }, {
              key: "setInterpolation",
              value: function setInterpolation(interpolation) {
                var factoryMethod;
                switch (interpolation) {
                  case _InterpolateDiscrete:
                    factoryMethod = this.InterpolantFactoryMethodDiscrete;
                    break;
                  case _InterpolateLinear:
                    factoryMethod = this.InterpolantFactoryMethodLinear;
                    break;
                  case _InterpolateSmooth:
                    factoryMethod = this.InterpolantFactoryMethodSmooth;
                    break;
                }
                if (factoryMethod === undefined) {
                  var message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
                  if (this.createInterpolant === undefined) {
                    // fall back to default, unless the default itself is messed up
                    if (interpolation !== this.DefaultInterpolation) {
                      this.setInterpolation(this.DefaultInterpolation);
                    } else {
                      throw new Error(message); // fatal, in this case
                    }
                  }
                  console.warn('THREE.KeyframeTrack:', message);
                  return this;
                }
                this.createInterpolant = factoryMethod;
                return this;
              }
            }, {
              key: "getInterpolation",
              value: function getInterpolation() {
                switch (this.createInterpolant) {
                  case this.InterpolantFactoryMethodDiscrete:
                    return _InterpolateDiscrete;
                  case this.InterpolantFactoryMethodLinear:
                    return _InterpolateLinear;
                  case this.InterpolantFactoryMethodSmooth:
                    return _InterpolateSmooth;
                }
              }
            }, {
              key: "getValueSize",
              value: function getValueSize() {
                return this.values.length / this.times.length;
              } // move all keyframes either forwards or backwards in time
            }, {
              key: "shift",
              value: function shift(timeOffset) {
                if (timeOffset !== 0.0) {
                  var times = this.times;
                  for (var i = 0, n = times.length; i !== n; ++i) {
                    times[i] += timeOffset;
                  }
                }
                return this;
              } // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
            }, {
              key: "scale",
              value: function scale(timeScale) {
                if (timeScale !== 1.0) {
                  var times = this.times;
                  for (var i = 0, n = times.length; i !== n; ++i) {
                    times[i] *= timeScale;
                  }
                }
                return this;
              } // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
              // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
            }, {
              key: "trim",
              value: function trim(startTime, endTime) {
                var times = this.times,
                  nKeys = times.length;
                var from = 0,
                  to = nKeys - 1;
                while (from !== nKeys && times[from] < startTime) {
                  ++from;
                }
                while (to !== -1 && times[to] > endTime) {
                  --to;
                }
                ++to; // inclusive -> exclusive bound
                if (from !== 0 || to !== nKeys) {
                  // empty tracks are forbidden, so keep at least one keyframe
                  if (from >= to) {
                    to = Math.max(to, 1);
                    from = to - 1;
                  }
                  var stride = this.getValueSize();
                  this.times = arraySlice(times, from, to);
                  this.values = arraySlice(this.values, from * stride, to * stride);
                }
                return this;
              } // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
            }, {
              key: "validate",
              value: function validate() {
                var valid = true;
                var valueSize = this.getValueSize();
                if (valueSize - Math.floor(valueSize) !== 0) {
                  console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
                  valid = false;
                }
                var times = this.times,
                  values = this.values,
                  nKeys = times.length;
                if (nKeys === 0) {
                  console.error('THREE.KeyframeTrack: Track is empty.', this);
                  valid = false;
                }
                var prevTime = null;
                for (var i = 0; i !== nKeys; i++) {
                  var currTime = times[i];
                  if (typeof currTime === 'number' && isNaN(currTime)) {
                    console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                    valid = false;
                    break;
                  }
                  if (prevTime !== null && prevTime > currTime) {
                    console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                    valid = false;
                    break;
                  }
                  prevTime = currTime;
                }
                if (values !== undefined) {
                  if (isTypedArray(values)) {
                    for (var _i85 = 0, n = values.length; _i85 !== n; ++_i85) {
                      var _value7 = values[_i85];
                      if (isNaN(_value7)) {
                        console.error('THREE.KeyframeTrack: Value is not a valid number.', this, _i85, _value7);
                        valid = false;
                        break;
                      }
                    }
                  }
                }
                return valid;
              } // removes equivalent sequential keys as common in morph target sequences
              // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
            }, {
              key: "optimize",
              value: function optimize() {
                // times or values may be shared with other tracks, so overwriting is unsafe
                var times = arraySlice(this.times),
                  values = arraySlice(this.values),
                  stride = this.getValueSize(),
                  smoothInterpolation = this.getInterpolation() === _InterpolateSmooth,
                  lastIndex = times.length - 1;
                var writeIndex = 1;
                for (var i = 1; i < lastIndex; ++i) {
                  var keep = false;
                  var time = times[i];
                  var timeNext = times[i + 1]; // remove adjacent keyframes scheduled at the same time
                  if (time !== timeNext && (i !== 1 || time !== times[0])) {
                    if (!smoothInterpolation) {
                      // remove unnecessary keyframes same as their neighbors
                      var offset = i * stride,
                        offsetP = offset - stride,
                        offsetN = offset + stride;
                      for (var j = 0; j !== stride; ++j) {
                        var _value8 = values[offset + j];
                        if (_value8 !== values[offsetP + j] || _value8 !== values[offsetN + j]) {
                          keep = true;
                          break;
                        }
                      }
                    } else {
                      keep = true;
                    }
                  } // in-place compaction
                  if (keep) {
                    if (i !== writeIndex) {
                      times[writeIndex] = times[i];
                      var readOffset = i * stride,
                        writeOffset = writeIndex * stride;
                      for (var _j14 = 0; _j14 !== stride; ++_j14) {
                        values[writeOffset + _j14] = values[readOffset + _j14];
                      }
                    }
                    ++writeIndex;
                  }
                } // flush last keyframe (compaction looks ahead)
                if (lastIndex > 0) {
                  times[writeIndex] = times[lastIndex];
                  for (var _readOffset = lastIndex * stride, _writeOffset = writeIndex * stride, _j15 = 0; _j15 !== stride; ++_j15) {
                    values[_writeOffset + _j15] = values[_readOffset + _j15];
                  }
                  ++writeIndex;
                }
                if (writeIndex !== times.length) {
                  this.times = arraySlice(times, 0, writeIndex);
                  this.values = arraySlice(values, 0, writeIndex * stride);
                } else {
                  this.times = times;
                  this.values = values;
                }
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                var times = arraySlice(this.times, 0);
                var values = arraySlice(this.values, 0);
                var TypedKeyframeTrack = this.constructor;
                var track = new TypedKeyframeTrack(this.name, times, values); // Interpolant argument to constructor is not saved, so copy the factory method directly.
                track.createInterpolant = this.createInterpolant;
                return track;
              }
            }], [{
              key: "toJSON",
              value: function toJSON(track) {
                var trackType = track.constructor;
                var json; // derived classes can define a static toJSON method
                if (trackType.toJSON !== this.toJSON) {
                  json = trackType.toJSON(track);
                } else {
                  // by default, we assume the data can be serialized as-is
                  json = {
                    'name': track.name,
                    'times': convertArray(track.times, Array),
                    'values': convertArray(track.values, Array)
                  };
                  var interpolation = track.getInterpolation();
                  if (interpolation !== track.DefaultInterpolation) {
                    json.interpolation = interpolation;
                  }
                }
                json.type = track.ValueTypeName; // mandatory
                return json;
              }
            }]);
            return _KeyframeTrack;
          }();
          _KeyframeTrack.prototype.TimeBufferType = Float32Array;
          _KeyframeTrack.prototype.ValueBufferType = Float32Array;
          _KeyframeTrack.prototype.DefaultInterpolation = _InterpolateLinear; /**
                                                                              * A Track of Boolean keyframe values.
                                                                              */
          var _BooleanKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack2) {
            _inherits(_BooleanKeyframeTrack, _KeyframeTrack2);
            var _super114 = _createSuper(_BooleanKeyframeTrack);
            function _BooleanKeyframeTrack() {
              _classCallCheck2(this, _BooleanKeyframeTrack);
              return _super114.apply(this, arguments);
            }
            return _createClass2(_BooleanKeyframeTrack);
          }(_KeyframeTrack);
          _BooleanKeyframeTrack.prototype.ValueTypeName = 'bool';
          _BooleanKeyframeTrack.prototype.ValueBufferType = Array;
          _BooleanKeyframeTrack.prototype.DefaultInterpolation = _InterpolateDiscrete;
          _BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
          _BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined; /**
                                                                                      * A Track of keyframe values that represent color.
                                                                                      */
          var _ColorKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack3) {
            _inherits(_ColorKeyframeTrack, _KeyframeTrack3);
            var _super115 = _createSuper(_ColorKeyframeTrack);
            function _ColorKeyframeTrack() {
              _classCallCheck2(this, _ColorKeyframeTrack);
              return _super115.apply(this, arguments);
            }
            return _createClass2(_ColorKeyframeTrack);
          }(_KeyframeTrack);
          _ColorKeyframeTrack.prototype.ValueTypeName = 'color'; /**
                                                                 * A Track of numeric keyframe values.
                                                                 */
          var _NumberKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack4) {
            _inherits(_NumberKeyframeTrack, _KeyframeTrack4);
            var _super116 = _createSuper(_NumberKeyframeTrack);
            function _NumberKeyframeTrack() {
              _classCallCheck2(this, _NumberKeyframeTrack);
              return _super116.apply(this, arguments);
            }
            return _createClass2(_NumberKeyframeTrack);
          }(_KeyframeTrack);
          _NumberKeyframeTrack.prototype.ValueTypeName = 'number'; /**
                                                                   * Spherical linear unit quaternion interpolant.
                                                                   */
          var _QuaternionLinearInterpolant = /*#__PURE__*/function (_Interpolant5) {
            _inherits(_QuaternionLinearInterpolant, _Interpolant5);
            var _super117 = _createSuper(_QuaternionLinearInterpolant);
            function _QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
              _classCallCheck2(this, _QuaternionLinearInterpolant);
              return _super117.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
            }
            _createClass2(_QuaternionLinearInterpolant, [{
              key: "interpolate_",
              value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer,
                  values = this.sampleValues,
                  stride = this.valueSize,
                  alpha = (t - t0) / (t1 - t0);
                var offset = i1 * stride;
                for (var end = offset + stride; offset !== end; offset += 4) {
                  _Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
                }
                return result;
              }
            }]);
            return _QuaternionLinearInterpolant;
          }(_Interpolant);
          /**
          * A Track of quaternion keyframe values.
          */
          var _QuaternionKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack5) {
            _inherits(_QuaternionKeyframeTrack, _KeyframeTrack5);
            var _super118 = _createSuper(_QuaternionKeyframeTrack);
            function _QuaternionKeyframeTrack() {
              _classCallCheck2(this, _QuaternionKeyframeTrack);
              return _super118.apply(this, arguments);
            }
            _createClass2(_QuaternionKeyframeTrack, [{
              key: "InterpolantFactoryMethodLinear",
              value: function InterpolantFactoryMethodLinear(result) {
                return new _QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
              }
            }]);
            return _QuaternionKeyframeTrack;
          }(_KeyframeTrack);
          _QuaternionKeyframeTrack.prototype.ValueTypeName = 'quaternion'; // ValueBufferType is inherited
          _QuaternionKeyframeTrack.prototype.DefaultInterpolation = _InterpolateLinear;
          _QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined; /**
                                                                                         * A Track that interpolates Strings
                                                                                         */
          var _StringKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack6) {
            _inherits(_StringKeyframeTrack, _KeyframeTrack6);
            var _super119 = _createSuper(_StringKeyframeTrack);
            function _StringKeyframeTrack() {
              _classCallCheck2(this, _StringKeyframeTrack);
              return _super119.apply(this, arguments);
            }
            return _createClass2(_StringKeyframeTrack);
          }(_KeyframeTrack);
          _StringKeyframeTrack.prototype.ValueTypeName = 'string';
          _StringKeyframeTrack.prototype.ValueBufferType = Array;
          _StringKeyframeTrack.prototype.DefaultInterpolation = _InterpolateDiscrete;
          _StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
          _StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined; /**
                                                                                     * A Track of vectored keyframe values.
                                                                                     */
          var _VectorKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack7) {
            _inherits(_VectorKeyframeTrack, _KeyframeTrack7);
            var _super120 = _createSuper(_VectorKeyframeTrack);
            function _VectorKeyframeTrack() {
              _classCallCheck2(this, _VectorKeyframeTrack);
              return _super120.apply(this, arguments);
            }
            return _createClass2(_VectorKeyframeTrack);
          }(_KeyframeTrack);
          _VectorKeyframeTrack.prototype.ValueTypeName = 'vector';
          var _AnimationClip = /*#__PURE__*/function () {
            function _AnimationClip(name) {
              var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
              var tracks = arguments.length > 2 ? arguments[2] : undefined;
              var blendMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _NormalAnimationBlendMode;
              _classCallCheck2(this, _AnimationClip);
              this.name = name;
              this.tracks = tracks;
              this.duration = duration;
              this.blendMode = blendMode;
              this.uuid = generateUUID(); // this means it should figure out its duration by scanning the tracks
              if (this.duration < 0) {
                this.resetDuration();
              }
            }
            _createClass2(_AnimationClip, [{
              key: "resetDuration",
              value: function resetDuration() {
                var tracks = this.tracks;
                var duration = 0;
                for (var i = 0, n = tracks.length; i !== n; ++i) {
                  var track = this.tracks[i];
                  duration = Math.max(duration, track.times[track.times.length - 1]);
                }
                this.duration = duration;
                return this;
              }
            }, {
              key: "trim",
              value: function trim() {
                for (var i = 0; i < this.tracks.length; i++) {
                  this.tracks[i].trim(0, this.duration);
                }
                return this;
              }
            }, {
              key: "validate",
              value: function validate() {
                var valid = true;
                for (var i = 0; i < this.tracks.length; i++) {
                  valid = valid && this.tracks[i].validate();
                }
                return valid;
              }
            }, {
              key: "optimize",
              value: function optimize() {
                for (var i = 0; i < this.tracks.length; i++) {
                  this.tracks[i].optimize();
                }
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                var tracks = [];
                for (var i = 0; i < this.tracks.length; i++) {
                  tracks.push(this.tracks[i].clone());
                }
                return new this.constructor(this.name, this.duration, tracks, this.blendMode);
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                return this.constructor.toJSON(this);
              }
            }], [{
              key: "parse",
              value: function parse(json) {
                var tracks = [],
                  jsonTracks = json.tracks,
                  frameTime = 1.0 / (json.fps || 1.0);
                for (var i = 0, n = jsonTracks.length; i !== n; ++i) {
                  tracks.push(parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
                }
                var clip = new this(json.name, json.duration, tracks, json.blendMode);
                clip.uuid = json.uuid;
                return clip;
              }
            }, {
              key: "toJSON",
              value: function toJSON(clip) {
                var tracks = [],
                  clipTracks = clip.tracks;
                var json = {
                  'name': clip.name,
                  'duration': clip.duration,
                  'tracks': tracks,
                  'uuid': clip.uuid,
                  'blendMode': clip.blendMode
                };
                for (var i = 0, n = clipTracks.length; i !== n; ++i) {
                  tracks.push(_KeyframeTrack.toJSON(clipTracks[i]));
                }
                return json;
              }
            }, {
              key: "CreateFromMorphTargetSequence",
              value: function CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
                var numMorphTargets = morphTargetSequence.length;
                var tracks = [];
                for (var i = 0; i < numMorphTargets; i++) {
                  var times = [];
                  var values = [];
                  times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
                  values.push(0, 1, 0);
                  var order = getKeyframeOrder(times);
                  times = sortedArray(times, 1, order);
                  values = sortedArray(values, 1, order); // if there is a key at the first frame, duplicate it as the
                  // last frame as well for perfect loop.
                  if (!noLoop && times[0] === 0) {
                    times.push(numMorphTargets);
                    values.push(values[0]);
                  }
                  tracks.push(new _NumberKeyframeTrack('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
                }
                return new this(name, -1, tracks);
              }
            }, {
              key: "findByName",
              value: function findByName(objectOrClipArray, name) {
                var clipArray = objectOrClipArray;
                if (!Array.isArray(objectOrClipArray)) {
                  var o = objectOrClipArray;
                  clipArray = o.geometry && o.geometry.animations || o.animations;
                }
                for (var i = 0; i < clipArray.length; i++) {
                  if (clipArray[i].name === name) {
                    return clipArray[i];
                  }
                }
                return null;
              }
            }, {
              key: "CreateClipsFromMorphTargetSequences",
              value: function CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
                var animationToMorphTargets = {}; // tested with https://regex101.com/ on trick sequences
                // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
                var pattern = /^([\w-]*?)([\d]+)$/; // sort morph target names into animation groups based
                // patterns like Walk_001, Walk_002, Run_001, Run_002
                for (var i = 0, il = morphTargets.length; i < il; i++) {
                  var morphTarget = morphTargets[i];
                  var parts = morphTarget.name.match(pattern);
                  if (parts && parts.length > 1) {
                    var name = parts[1];
                    var animationMorphTargets = animationToMorphTargets[name];
                    if (!animationMorphTargets) {
                      animationToMorphTargets[name] = animationMorphTargets = [];
                    }
                    animationMorphTargets.push(morphTarget);
                  }
                }
                var clips = [];
                for (var _name4 in animationToMorphTargets) {
                  clips.push(this.CreateFromMorphTargetSequence(_name4, animationToMorphTargets[_name4], fps, noLoop));
                }
                return clips;
              } // parse the animation.hierarchy format
            }, {
              key: "parseAnimation",
              value: function parseAnimation(animation, bones) {
                if (!animation) {
                  console.error('THREE.AnimationClip: No animation in JSONLoader data.');
                  return null;
                }
                var addNonemptyTrack = function addNonemptyTrack(trackType, trackName, animationKeys, propertyName, destTracks) {
                  // only return track if there are actually keys.
                  if (animationKeys.length !== 0) {
                    var times = [];
                    var values = [];
                    flattenJSON(animationKeys, times, values, propertyName); // empty keys are filtered out, so check again
                    if (times.length !== 0) {
                      destTracks.push(new trackType(trackName, times, values));
                    }
                  }
                };
                var tracks = [];
                var clipName = animation.name || 'default';
                var fps = animation.fps || 30;
                var blendMode = animation.blendMode; // automatic length determination in AnimationClip.
                var duration = animation.length || -1;
                var hierarchyTracks = animation.hierarchy || [];
                for (var h = 0; h < hierarchyTracks.length; h++) {
                  var animationKeys = hierarchyTracks[h].keys; // skip empty tracks
                  if (!animationKeys || animationKeys.length === 0) continue; // process morph targets
                  if (animationKeys[0].morphTargets) {
                    // figure out all morph targets used in this track
                    var morphTargetNames = {};
                    var k = void 0;
                    for (k = 0; k < animationKeys.length; k++) {
                      if (animationKeys[k].morphTargets) {
                        for (var m = 0; m < animationKeys[k].morphTargets.length; m++) {
                          morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                        }
                      }
                    } // create a track for each morph target with all zero
                    // morphTargetInfluences except for the keys in which
                    // the morphTarget is named.
                    for (var morphTargetName in morphTargetNames) {
                      var times = [];
                      var values = [];
                      for (var _m = 0; _m !== animationKeys[k].morphTargets.length; ++_m) {
                        var animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                      }
                      tracks.push(new _NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                    }
                    duration = morphTargetNames.length * fps;
                  } else {
                    // ...assume skeletal animation
                    var boneName = '.bones[' + bones[h].name + ']';
                    addNonemptyTrack(_VectorKeyframeTrack, boneName + '.position', animationKeys, 'pos', tracks);
                    addNonemptyTrack(_QuaternionKeyframeTrack, boneName + '.quaternion', animationKeys, 'rot', tracks);
                    addNonemptyTrack(_VectorKeyframeTrack, boneName + '.scale', animationKeys, 'scl', tracks);
                  }
                }
                if (tracks.length === 0) {
                  return null;
                }
                var clip = new this(clipName, duration, tracks, blendMode);
                return clip;
              }
            }]);
            return _AnimationClip;
          }();
          function getTrackTypeForValueTypeName(typeName) {
            switch (typeName.toLowerCase()) {
              case 'scalar':
              case 'double':
              case 'float':
              case 'number':
              case 'integer':
                return _NumberKeyframeTrack;
              case 'vector':
              case 'vector2':
              case 'vector3':
              case 'vector4':
                return _VectorKeyframeTrack;
              case 'color':
                return _ColorKeyframeTrack;
              case 'quaternion':
                return _QuaternionKeyframeTrack;
              case 'bool':
              case 'boolean':
                return _BooleanKeyframeTrack;
              case 'string':
                return _StringKeyframeTrack;
            }
            throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
          }
          function parseKeyframeTrack(json) {
            if (json.type === undefined) {
              throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
            }
            var trackType = getTrackTypeForValueTypeName(json.type);
            if (json.times === undefined) {
              var times = [],
                values = [];
              flattenJSON(json.keys, times, values, 'value');
              json.times = times;
              json.values = values;
            } // derived classes can define a static parse method
            if (trackType.parse !== undefined) {
              return trackType.parse(json);
            } else {
              // by default, we assume a constructor compatible with the base
              return new trackType(json.name, json.times, json.values, json.interpolation);
            }
          }
          var _Cache = {
            enabled: false,
            files: {},
            add: function add(key, file) {
              if (this.enabled === false) return; // console.log( 'THREE.Cache', 'Adding key:', key );
              this.files[key] = file;
            },
            get: function get(key) {
              if (this.enabled === false) return; // console.log( 'THREE.Cache', 'Checking key:', key );
              return this.files[key];
            },
            remove: function remove(key) {
              delete this.files[key];
            },
            clear: function clear() {
              this.files = {};
            }
          };
          var _LoadingManager = /*#__PURE__*/_createClass2(function _LoadingManager(onLoad, onProgress, onError) {
            _classCallCheck2(this, _LoadingManager);
            var scope = this;
            var isLoading = false;
            var itemsLoaded = 0;
            var itemsTotal = 0;
            var urlModifier = undefined;
            var handlers = []; // Refer to #5689 for the reason why we don't set .onStart
            // in the constructor
            this.onStart = undefined;
            this.onLoad = onLoad;
            this.onProgress = onProgress;
            this.onError = onError;
            this.itemStart = function (url) {
              itemsTotal++;
              if (isLoading === false) {
                if (scope.onStart !== undefined) {
                  scope.onStart(url, itemsLoaded, itemsTotal);
                }
              }
              isLoading = true;
            };
            this.itemEnd = function (url) {
              itemsLoaded++;
              if (scope.onProgress !== undefined) {
                scope.onProgress(url, itemsLoaded, itemsTotal);
              }
              if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) {
                  scope.onLoad();
                }
              }
            };
            this.itemError = function (url) {
              if (scope.onError !== undefined) {
                scope.onError(url);
              }
            };
            this.resolveURL = function (url) {
              if (urlModifier) {
                return urlModifier(url);
              }
              return url;
            };
            this.setURLModifier = function (transform) {
              urlModifier = transform;
              return this;
            };
            this.addHandler = function (regex, loader) {
              handlers.push(regex, loader);
              return this;
            };
            this.removeHandler = function (regex) {
              var index = handlers.indexOf(regex);
              if (index !== -1) {
                handlers.splice(index, 2);
              }
              return this;
            };
            this.getHandler = function (file) {
              for (var i = 0, l = handlers.length; i < l; i += 2) {
                var regex = handlers[i];
                var loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) {
                  return loader;
                }
              }
              return null;
            };
          });
          var _DefaultLoadingManager = /*@__PURE__*/new _LoadingManager();
          var _Loader = /*#__PURE__*/function () {
            function _Loader(manager) {
              _classCallCheck2(this, _Loader);
              this.manager = manager !== undefined ? manager : _DefaultLoadingManager;
              this.crossOrigin = 'anonymous';
              this.withCredentials = false;
              this.path = '';
              this.resourcePath = '';
              this.requestHeader = {};
            }
            _createClass2(_Loader, [{
              key: "load",
              value: function load( /* url, onLoad, onProgress, onError */) {}
            }, {
              key: "loadAsync",
              value: function loadAsync(url, onProgress) {
                var scope = this;
                return new Promise(function (resolve, reject) {
                  scope.load(url, resolve, onProgress, reject);
                });
              }
            }, {
              key: "parse",
              value: function parse( /* data */) {}
            }, {
              key: "setCrossOrigin",
              value: function setCrossOrigin(crossOrigin) {
                this.crossOrigin = crossOrigin;
                return this;
              }
            }, {
              key: "setWithCredentials",
              value: function setWithCredentials(value) {
                this.withCredentials = value;
                return this;
              }
            }, {
              key: "setPath",
              value: function setPath(path) {
                this.path = path;
                return this;
              }
            }, {
              key: "setResourcePath",
              value: function setResourcePath(resourcePath) {
                this.resourcePath = resourcePath;
                return this;
              }
            }, {
              key: "setRequestHeader",
              value: function setRequestHeader(requestHeader) {
                this.requestHeader = requestHeader;
                return this;
              }
            }]);
            return _Loader;
          }();
          var loading = {};
          var HttpError = /*#__PURE__*/function (_Error) {
            _inherits(HttpError, _Error);
            var _super121 = _createSuper(HttpError);
            function HttpError(message, response) {
              var _this103;
              _classCallCheck2(this, HttpError);
              _this103 = _super121.call(this, message);
              _this103.response = response;
              return _this103;
            }
            return _createClass2(HttpError);
          }( /*#__PURE__*/_wrapNativeSuper(Error));
          var _FileLoader = /*#__PURE__*/function (_Loader2) {
            _inherits(_FileLoader, _Loader2);
            var _super122 = _createSuper(_FileLoader);
            function _FileLoader(manager) {
              _classCallCheck2(this, _FileLoader);
              return _super122.call(this, manager);
            }
            _createClass2(_FileLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var _this104 = this;
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var cached = _Cache.get(url);
                if (cached !== undefined) {
                  this.manager.itemStart(url);
                  setTimeout(function () {
                    if (onLoad) onLoad(cached);
                    _this104.manager.itemEnd(url);
                  }, 0);
                  return cached;
                } // Check if request is duplicate
                if (loading[url] !== undefined) {
                  loading[url].push({
                    onLoad: onLoad,
                    onProgress: onProgress,
                    onError: onError
                  });
                  return;
                } // Initialise array for duplicate requests
                loading[url] = [];
                loading[url].push({
                  onLoad: onLoad,
                  onProgress: onProgress,
                  onError: onError
                }); // create request
                var req = new Request(url, {
                  headers: new Headers(this.requestHeader),
                  credentials: this.withCredentials ? 'include' : 'same-origin' // An abort controller could be added within a future PR
                }); // record states ( avoid data race )
                var mimeType = this.mimeType;
                var responseType = this.responseType; // start the fetch
                fetch(req).then(function (response) {
                  if (response.status === 200 || response.status === 0) {
                    // Some browsers return HTTP Status 0 when using non-http protocol
                    // e.g. 'file://' or 'data://'. Handle as success.
                    if (response.status === 0) {
                      console.warn('THREE.FileLoader: HTTP Status 0 received.');
                    } // Workaround: Checking if response.body === undefined for Alipay browser #23548
                    if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) {
                      return response;
                    }
                    var callbacks = loading[url];
                    var reader = response.body.getReader(); // Nginx needs X-File-Size check
                    // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                    var contentLength = response.headers.get('Content-Length') || response.headers.get('X-File-Size');
                    var total = contentLength ? parseInt(contentLength) : 0;
                    var lengthComputable = total !== 0;
                    var loaded = 0; // periodically read data into the new stream tracking while download progress
                    var stream = new ReadableStream({
                      start: function start(controller) {
                        readData();
                        function readData() {
                          reader.read().then(function (_ref3) {
                            var done = _ref3.done,
                              value = _ref3.value;
                            if (done) {
                              controller.close();
                            } else {
                              loaded += value.byteLength;
                              var event = new ProgressEvent('progress', {
                                lengthComputable: lengthComputable,
                                loaded: loaded,
                                total: total
                              });
                              for (var i = 0, il = callbacks.length; i < il; i++) {
                                var callback = callbacks[i];
                                if (callback.onProgress) callback.onProgress(event);
                              }
                              controller.enqueue(value);
                              readData();
                            }
                          });
                        }
                      }
                    });
                    return new Response(stream);
                  } else {
                    throw new HttpError("fetch for \"".concat(response.url, "\" responded with ").concat(response.status, ": ").concat(response.statusText), response);
                  }
                }).then(function (response) {
                  switch (responseType) {
                    case 'arraybuffer':
                      return response.arrayBuffer();
                    case 'blob':
                      return response.blob();
                    case 'document':
                      return response.text().then(function (text) {
                        var parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                      });
                    case 'json':
                      return response.json();
                    default:
                      if (mimeType === undefined) {
                        return response.text();
                      } else {
                        // sniff encoding
                        var re = /charset="?([^;"\s]*)"?/i;
                        var exec = re.exec(mimeType);
                        var label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        var decoder = new TextDecoder(label);
                        return response.arrayBuffer().then(function (ab) {
                          return decoder.decode(ab);
                        });
                      }
                  }
                }).then(function (data) {
                  // Add to cache only on HTTP success, so that we do not cache
                  // error response bodies as proper responses to requests.
                  _Cache.add(url, data);
                  var callbacks = loading[url];
                  delete loading[url];
                  for (var i = 0, il = callbacks.length; i < il; i++) {
                    var callback = callbacks[i];
                    if (callback.onLoad) callback.onLoad(data);
                  }
                }).catch(function (err) {
                  // Abort errors and other errors are handled the same
                  var callbacks = loading[url];
                  if (callbacks === undefined) {
                    // When onLoad was called and url was deleted in `loading`
                    _this104.manager.itemError(url);
                    throw err;
                  }
                  delete loading[url];
                  for (var i = 0, il = callbacks.length; i < il; i++) {
                    var callback = callbacks[i];
                    if (callback.onError) callback.onError(err);
                  }
                  _this104.manager.itemError(url);
                }).finally(function () {
                  _this104.manager.itemEnd(url);
                });
                this.manager.itemStart(url);
              }
            }, {
              key: "setResponseType",
              value: function setResponseType(value) {
                this.responseType = value;
                return this;
              }
            }, {
              key: "setMimeType",
              value: function setMimeType(value) {
                this.mimeType = value;
                return this;
              }
            }]);
            return _FileLoader;
          }(_Loader);
          var _AnimationLoader = /*#__PURE__*/function (_Loader3) {
            _inherits(_AnimationLoader, _Loader3);
            var _super123 = _createSuper(_AnimationLoader);
            function _AnimationLoader(manager) {
              _classCallCheck2(this, _AnimationLoader);
              return _super123.call(this, manager);
            }
            _createClass2(_AnimationLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new _FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (text) {
                  try {
                    onLoad(scope.parse(JSON.parse(text)));
                  } catch (e) {
                    if (onError) {
                      onError(e);
                    } else {
                      console.error(e);
                    }
                    scope.manager.itemError(url);
                  }
                }, onProgress, onError);
              }
            }, {
              key: "parse",
              value: function parse(json) {
                var animations = [];
                for (var i = 0; i < json.length; i++) {
                  var clip = _AnimationClip.parse(json[i]);
                  animations.push(clip);
                }
                return animations;
              }
            }]);
            return _AnimationLoader;
          }(_Loader);
          /**
          * Abstract Base class to block based textures loader (dds, pvr, ...)
          *
          * Sub classes have to implement the parse() method which will be used in load().
          */
          var _CompressedTextureLoader = /*#__PURE__*/function (_Loader4) {
            _inherits(_CompressedTextureLoader, _Loader4);
            var _super124 = _createSuper(_CompressedTextureLoader);
            function _CompressedTextureLoader(manager) {
              _classCallCheck2(this, _CompressedTextureLoader);
              return _super124.call(this, manager);
            }
            _createClass2(_CompressedTextureLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var images = [];
                var texture = new _CompressedTexture();
                var loader = new _FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                var loaded = 0;
                function loadTexture(i) {
                  loader.load(url[i], function (buffer) {
                    var texDatas = scope.parse(buffer, true);
                    images[i] = {
                      width: texDatas.width,
                      height: texDatas.height,
                      format: texDatas.format,
                      mipmaps: texDatas.mipmaps
                    };
                    loaded += 1;
                    if (loaded === 6) {
                      if (texDatas.mipmapCount === 1) texture.minFilter = _LinearFilter;
                      texture.image = images;
                      texture.format = texDatas.format;
                      texture.needsUpdate = true;
                      if (onLoad) onLoad(texture);
                    }
                  }, onProgress, onError);
                }
                if (Array.isArray(url)) {
                  for (var i = 0, il = url.length; i < il; ++i) {
                    loadTexture(i);
                  }
                } else {
                  // compressed cubemap texture stored in a single DDS file
                  loader.load(url, function (buffer) {
                    var texDatas = scope.parse(buffer, true);
                    if (texDatas.isCubemap) {
                      var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                      for (var f = 0; f < faces; f++) {
                        images[f] = {
                          mipmaps: []
                        };
                        for (var _i86 = 0; _i86 < texDatas.mipmapCount; _i86++) {
                          images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + _i86]);
                          images[f].format = texDatas.format;
                          images[f].width = texDatas.width;
                          images[f].height = texDatas.height;
                        }
                      }
                      texture.image = images;
                    } else {
                      texture.image.width = texDatas.width;
                      texture.image.height = texDatas.height;
                      texture.mipmaps = texDatas.mipmaps;
                    }
                    if (texDatas.mipmapCount === 1) {
                      texture.minFilter = _LinearFilter;
                    }
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                  }, onProgress, onError);
                }
                return texture;
              }
            }]);
            return _CompressedTextureLoader;
          }(_Loader);
          var _ImageLoader = /*#__PURE__*/function (_Loader5) {
            _inherits(_ImageLoader, _Loader5);
            var _super125 = _createSuper(_ImageLoader);
            function _ImageLoader(manager) {
              _classCallCheck2(this, _ImageLoader);
              return _super125.call(this, manager);
            }
            _createClass2(_ImageLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = _Cache.get(url);
                if (cached !== undefined) {
                  scope.manager.itemStart(url);
                  setTimeout(function () {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                  }, 0);
                  return cached;
                }
                var image = createElementNS('img');
                function onImageLoad() {
                  removeEventListeners();
                  _Cache.add(url, this);
                  if (onLoad) onLoad(this);
                  scope.manager.itemEnd(url);
                }
                function onImageError(event) {
                  removeEventListeners();
                  if (onError) onError(event);
                  scope.manager.itemError(url);
                  scope.manager.itemEnd(url);
                }
                function removeEventListeners() {
                  image.removeEventListener('load', onImageLoad, false);
                  image.removeEventListener('error', onImageError, false);
                }
                image.addEventListener('load', onImageLoad, false);
                image.addEventListener('error', onImageError, false);
                if (url.slice(0, 5) !== 'data:') {
                  if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
                }
                scope.manager.itemStart(url);
                image.src = url;
                return image;
              }
            }]);
            return _ImageLoader;
          }(_Loader);
          var _CubeTextureLoader = /*#__PURE__*/function (_Loader6) {
            _inherits(_CubeTextureLoader, _Loader6);
            var _super126 = _createSuper(_CubeTextureLoader);
            function _CubeTextureLoader(manager) {
              _classCallCheck2(this, _CubeTextureLoader);
              return _super126.call(this, manager);
            }
            _createClass2(_CubeTextureLoader, [{
              key: "load",
              value: function load(urls, onLoad, onProgress, onError) {
                var texture = new _CubeTexture();
                var loader = new _ImageLoader(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                var loaded = 0;
                function loadTexture(i) {
                  loader.load(urls[i], function (image) {
                    texture.images[i] = image;
                    loaded++;
                    if (loaded === 6) {
                      texture.needsUpdate = true;
                      if (onLoad) onLoad(texture);
                    }
                  }, undefined, onError);
                }
                for (var i = 0; i < urls.length; ++i) {
                  loadTexture(i);
                }
                return texture;
              }
            }]);
            return _CubeTextureLoader;
          }(_Loader);
          /**
          * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
          *
          * Sub classes have to implement the parse() method which will be used in load().
          */
          var _DataTextureLoader = /*#__PURE__*/function (_Loader7) {
            _inherits(_DataTextureLoader, _Loader7);
            var _super127 = _createSuper(_DataTextureLoader);
            function _DataTextureLoader(manager) {
              _classCallCheck2(this, _DataTextureLoader);
              return _super127.call(this, manager);
            }
            _createClass2(_DataTextureLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var texture = new _DataTexture();
                var loader = new _FileLoader(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setPath(this.path);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function (buffer) {
                  var texData = scope.parse(buffer);
                  if (!texData) return;
                  if (texData.image !== undefined) {
                    texture.image = texData.image;
                  } else if (texData.data !== undefined) {
                    texture.image.width = texData.width;
                    texture.image.height = texData.height;
                    texture.image.data = texData.data;
                  }
                  texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : _ClampToEdgeWrapping;
                  texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : _ClampToEdgeWrapping;
                  texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : _LinearFilter;
                  texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : _LinearFilter;
                  texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
                  if (texData.encoding !== undefined) {
                    texture.encoding = texData.encoding;
                  }
                  if (texData.flipY !== undefined) {
                    texture.flipY = texData.flipY;
                  }
                  if (texData.format !== undefined) {
                    texture.format = texData.format;
                  }
                  if (texData.type !== undefined) {
                    texture.type = texData.type;
                  }
                  if (texData.mipmaps !== undefined) {
                    texture.mipmaps = texData.mipmaps;
                    texture.minFilter = _LinearMipmapLinearFilter; // presumably...
                  }
                  if (texData.mipmapCount === 1) {
                    texture.minFilter = _LinearFilter;
                  }
                  if (texData.generateMipmaps !== undefined) {
                    texture.generateMipmaps = texData.generateMipmaps;
                  }
                  texture.needsUpdate = true;
                  if (onLoad) onLoad(texture, texData);
                }, onProgress, onError);
                return texture;
              }
            }]);
            return _DataTextureLoader;
          }(_Loader);
          var _TextureLoader = /*#__PURE__*/function (_Loader8) {
            _inherits(_TextureLoader, _Loader8);
            var _super128 = _createSuper(_TextureLoader);
            function _TextureLoader(manager) {
              _classCallCheck2(this, _TextureLoader);
              return _super128.call(this, manager);
            }
            _createClass2(_TextureLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var texture = new _Texture();
                var loader = new _ImageLoader(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                loader.load(url, function (image) {
                  texture.image = image;
                  texture.needsUpdate = true;
                  if (onLoad !== undefined) {
                    onLoad(texture);
                  }
                }, onProgress, onError);
                return texture;
              }
            }]);
            return _TextureLoader;
          }(_Loader);
          var _Light = /*#__PURE__*/function (_Object3D12) {
            _inherits(_Light, _Object3D12);
            var _super129 = _createSuper(_Light);
            function _Light(color) {
              var _this105;
              var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              _classCallCheck2(this, _Light);
              _this105 = _super129.call(this);
              _this105.isLight = true;
              _this105.type = 'Light';
              _this105.color = new _Color(color);
              _this105.intensity = intensity;
              return _this105;
            }
            _createClass2(_Light, [{
              key: "dispose",
              value: function dispose() {// Empty here in base class; some subclasses override.
              }
            }, {
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_Light.prototype), "copy", this).call(this, source, recursive);
                this.color.copy(source.color);
                this.intensity = source.intensity;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_Light.prototype), "toJSON", this).call(this, meta);
                data.object.color = this.color.getHex();
                data.object.intensity = this.intensity;
                if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
                if (this.distance !== undefined) data.object.distance = this.distance;
                if (this.angle !== undefined) data.object.angle = this.angle;
                if (this.decay !== undefined) data.object.decay = this.decay;
                if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
                if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
                return data;
              }
            }]);
            return _Light;
          }(_Object3D);
          var _HemisphereLight = /*#__PURE__*/function (_Light2) {
            _inherits(_HemisphereLight, _Light2);
            var _super130 = _createSuper(_HemisphereLight);
            function _HemisphereLight(skyColor, groundColor, intensity) {
              var _this106;
              _classCallCheck2(this, _HemisphereLight);
              _this106 = _super130.call(this, skyColor, intensity);
              _this106.isHemisphereLight = true;
              _this106.type = 'HemisphereLight';
              _this106.position.copy(_Object3D.DefaultUp);
              _this106.updateMatrix();
              _this106.groundColor = new _Color(groundColor);
              return _this106;
            }
            _createClass2(_HemisphereLight, [{
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_HemisphereLight.prototype), "copy", this).call(this, source, recursive);
                this.groundColor.copy(source.groundColor);
                return this;
              }
            }]);
            return _HemisphereLight;
          }(_Light);
          var _projScreenMatrix$1 = /*@__PURE__*/new _Matrix2();
          var _lightPositionWorld$1 = /*@__PURE__*/new _Vector2();
          var _lookTarget$1 = /*@__PURE__*/new _Vector2();
          var LightShadow = /*#__PURE__*/function () {
            function LightShadow(camera) {
              _classCallCheck2(this, LightShadow);
              this.camera = camera;
              this.bias = 0;
              this.normalBias = 0;
              this.radius = 1;
              this.blurSamples = 8;
              this.mapSize = new _Vector(512, 512);
              this.map = null;
              this.mapPass = null;
              this.matrix = new _Matrix2();
              this.autoUpdate = true;
              this.needsUpdate = false;
              this._frustum = new _Frustum();
              this._frameExtents = new _Vector(1, 1);
              this._viewportCount = 1;
              this._viewports = [new _Vector3(0, 0, 1, 1)];
            }
            _createClass2(LightShadow, [{
              key: "getViewportCount",
              value: function getViewportCount() {
                return this._viewportCount;
              }
            }, {
              key: "getFrustum",
              value: function getFrustum() {
                return this._frustum;
              }
            }, {
              key: "updateMatrices",
              value: function updateMatrices(light) {
                var shadowCamera = this.camera;
                var shadowMatrix = this.matrix;
                _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
                shadowCamera.position.copy(_lightPositionWorld$1);
                _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
                shadowCamera.lookAt(_lookTarget$1);
                shadowCamera.updateMatrixWorld();
                _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);
                shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
                shadowMatrix.multiply(_projScreenMatrix$1);
              }
            }, {
              key: "getViewport",
              value: function getViewport(viewportIndex) {
                return this._viewports[viewportIndex];
              }
            }, {
              key: "getFrameExtents",
              value: function getFrameExtents() {
                return this._frameExtents;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                if (this.map) {
                  this.map.dispose();
                }
                if (this.mapPass) {
                  this.mapPass.dispose();
                }
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.camera = source.camera.clone();
                this.bias = source.bias;
                this.radius = source.radius;
                this.mapSize.copy(source.mapSize);
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var object = {};
                if (this.bias !== 0) object.bias = this.bias;
                if (this.normalBias !== 0) object.normalBias = this.normalBias;
                if (this.radius !== 1) object.radius = this.radius;
                if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
                object.camera = this.camera.toJSON(false).object;
                delete object.camera.matrix;
                return object;
              }
            }]);
            return LightShadow;
          }();
          var SpotLightShadow = /*#__PURE__*/function (_LightShadow) {
            _inherits(SpotLightShadow, _LightShadow);
            var _super131 = _createSuper(SpotLightShadow);
            function SpotLightShadow() {
              var _this107;
              _classCallCheck2(this, SpotLightShadow);
              _this107 = _super131.call(this, new _PerspectiveCamera(50, 1, 0.5, 500));
              _this107.isSpotLightShadow = true;
              _this107.focus = 1;
              return _this107;
            }
            _createClass2(SpotLightShadow, [{
              key: "updateMatrices",
              value: function updateMatrices(light) {
                var camera = this.camera;
                var fov = RAD2DEG * 2 * light.angle * this.focus;
                var aspect = this.mapSize.width / this.mapSize.height;
                var far = light.distance || camera.far;
                if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
                  camera.fov = fov;
                  camera.aspect = aspect;
                  camera.far = far;
                  camera.updateProjectionMatrix();
                }
                _get2(_getPrototypeOf(SpotLightShadow.prototype), "updateMatrices", this).call(this, light);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(SpotLightShadow.prototype), "copy", this).call(this, source);
                this.focus = source.focus;
                return this;
              }
            }]);
            return SpotLightShadow;
          }(LightShadow);
          var _SpotLight = /*#__PURE__*/function (_Light3) {
            _inherits(_SpotLight, _Light3);
            var _super132 = _createSuper(_SpotLight);
            function _SpotLight(color, intensity) {
              var _this108;
              var distance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var angle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI / 3;
              var penumbra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
              var decay = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;
              _classCallCheck2(this, _SpotLight);
              _this108 = _super132.call(this, color, intensity);
              _this108.isSpotLight = true;
              _this108.type = 'SpotLight';
              _this108.position.copy(_Object3D.DefaultUp);
              _this108.updateMatrix();
              _this108.target = new _Object3D();
              _this108.distance = distance;
              _this108.angle = angle;
              _this108.penumbra = penumbra;
              _this108.decay = decay;
              _this108.map = null;
              _this108.shadow = new SpotLightShadow();
              return _this108;
            }
            _createClass2(_SpotLight, [{
              key: "power",
              get: function get() {
                // compute the light's luminous power (in lumens) from its intensity (in candela)
                // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
                return this.intensity * Math.PI;
              },
              set: function set(power) {
                // set the light's intensity (in candela) from the desired luminous power (in lumens)
                this.intensity = power / Math.PI;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.shadow.dispose();
              }
            }, {
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_SpotLight.prototype), "copy", this).call(this, source, recursive);
                this.distance = source.distance;
                this.angle = source.angle;
                this.penumbra = source.penumbra;
                this.decay = source.decay;
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
              }
            }]);
            return _SpotLight;
          }(_Light);
          var _projScreenMatrix = /*@__PURE__*/new _Matrix2();
          var _lightPositionWorld = /*@__PURE__*/new _Vector2();
          var _lookTarget = /*@__PURE__*/new _Vector2();
          var PointLightShadow = /*#__PURE__*/function (_LightShadow2) {
            _inherits(PointLightShadow, _LightShadow2);
            var _super133 = _createSuper(PointLightShadow);
            function PointLightShadow() {
              var _this109;
              _classCallCheck2(this, PointLightShadow);
              _this109 = _super133.call(this, new _PerspectiveCamera(90, 1, 0.5, 500));
              _this109.isPointLightShadow = true;
              _this109._frameExtents = new _Vector(4, 2);
              _this109._viewportCount = 6;
              _this109._viewports = [
              // These viewports map a cube-map onto a 2D texture with the
              // following orientation:
              //
              //  xzXZ
              //   y Y
              //
              // X - Positive x direction
              // x - Negative x direction
              // Y - Positive y direction
              // y - Negative y direction
              // Z - Positive z direction
              // z - Negative z direction
              // positive X
              new _Vector3(2, 1, 1, 1),
              // negative X
              new _Vector3(0, 1, 1, 1),
              // positive Z
              new _Vector3(3, 1, 1, 1),
              // negative Z
              new _Vector3(1, 1, 1, 1),
              // positive Y
              new _Vector3(3, 0, 1, 1),
              // negative Y
              new _Vector3(1, 0, 1, 1)];
              _this109._cubeDirections = [new _Vector2(1, 0, 0), new _Vector2(-1, 0, 0), new _Vector2(0, 0, 1), new _Vector2(0, 0, -1), new _Vector2(0, 1, 0), new _Vector2(0, -1, 0)];
              _this109._cubeUps = [new _Vector2(0, 1, 0), new _Vector2(0, 1, 0), new _Vector2(0, 1, 0), new _Vector2(0, 1, 0), new _Vector2(0, 0, 1), new _Vector2(0, 0, -1)];
              return _this109;
            }
            _createClass2(PointLightShadow, [{
              key: "updateMatrices",
              value: function updateMatrices(light) {
                var viewportIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var camera = this.camera;
                var shadowMatrix = this.matrix;
                var far = light.distance || camera.far;
                if (far !== camera.far) {
                  camera.far = far;
                  camera.updateProjectionMatrix();
                }
                _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                camera.position.copy(_lightPositionWorld);
                _lookTarget.copy(camera.position);
                _lookTarget.add(this._cubeDirections[viewportIndex]);
                camera.up.copy(this._cubeUps[viewportIndex]);
                camera.lookAt(_lookTarget);
                camera.updateMatrixWorld();
                shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
                _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix(_projScreenMatrix);
              }
            }]);
            return PointLightShadow;
          }(LightShadow);
          var _PointLight = /*#__PURE__*/function (_Light4) {
            _inherits(_PointLight, _Light4);
            var _super134 = _createSuper(_PointLight);
            function _PointLight(color, intensity) {
              var _this110;
              var distance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var decay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
              _classCallCheck2(this, _PointLight);
              _this110 = _super134.call(this, color, intensity);
              _this110.isPointLight = true;
              _this110.type = 'PointLight';
              _this110.distance = distance;
              _this110.decay = decay;
              _this110.shadow = new PointLightShadow();
              return _this110;
            }
            _createClass2(_PointLight, [{
              key: "power",
              get: function get() {
                // compute the light's luminous power (in lumens) from its intensity (in candela)
                // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
                return this.intensity * 4 * Math.PI;
              },
              set: function set(power) {
                // set the light's intensity (in candela) from the desired luminous power (in lumens)
                this.intensity = power / (4 * Math.PI);
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.shadow.dispose();
              }
            }, {
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_PointLight.prototype), "copy", this).call(this, source, recursive);
                this.distance = source.distance;
                this.decay = source.decay;
                this.shadow = source.shadow.clone();
                return this;
              }
            }]);
            return _PointLight;
          }(_Light);
          var DirectionalLightShadow = /*#__PURE__*/function (_LightShadow3) {
            _inherits(DirectionalLightShadow, _LightShadow3);
            var _super135 = _createSuper(DirectionalLightShadow);
            function DirectionalLightShadow() {
              var _this111;
              _classCallCheck2(this, DirectionalLightShadow);
              _this111 = _super135.call(this, new _OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
              _this111.isDirectionalLightShadow = true;
              return _this111;
            }
            return _createClass2(DirectionalLightShadow);
          }(LightShadow);
          var _DirectionalLight = /*#__PURE__*/function (_Light5) {
            _inherits(_DirectionalLight, _Light5);
            var _super136 = _createSuper(_DirectionalLight);
            function _DirectionalLight(color, intensity) {
              var _this112;
              _classCallCheck2(this, _DirectionalLight);
              _this112 = _super136.call(this, color, intensity);
              _this112.isDirectionalLight = true;
              _this112.type = 'DirectionalLight';
              _this112.position.copy(_Object3D.DefaultUp);
              _this112.updateMatrix();
              _this112.target = new _Object3D();
              _this112.shadow = new DirectionalLightShadow();
              return _this112;
            }
            _createClass2(_DirectionalLight, [{
              key: "dispose",
              value: function dispose() {
                this.shadow.dispose();
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_DirectionalLight.prototype), "copy", this).call(this, source);
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
              }
            }]);
            return _DirectionalLight;
          }(_Light);
          var _AmbientLight = /*#__PURE__*/function (_Light6) {
            _inherits(_AmbientLight, _Light6);
            var _super137 = _createSuper(_AmbientLight);
            function _AmbientLight(color, intensity) {
              var _this113;
              _classCallCheck2(this, _AmbientLight);
              _this113 = _super137.call(this, color, intensity);
              _this113.isAmbientLight = true;
              _this113.type = 'AmbientLight';
              return _this113;
            }
            return _createClass2(_AmbientLight);
          }(_Light);
          var _RectAreaLight = /*#__PURE__*/function (_Light7) {
            _inherits(_RectAreaLight, _Light7);
            var _super138 = _createSuper(_RectAreaLight);
            function _RectAreaLight(color, intensity) {
              var _this114;
              var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
              var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
              _classCallCheck2(this, _RectAreaLight);
              _this114 = _super138.call(this, color, intensity);
              _this114.isRectAreaLight = true;
              _this114.type = 'RectAreaLight';
              _this114.width = width;
              _this114.height = height;
              return _this114;
            }
            _createClass2(_RectAreaLight, [{
              key: "power",
              get: function get() {
                // compute the light's luminous power (in lumens) from its intensity (in nits)
                return this.intensity * this.width * this.height * Math.PI;
              },
              set: function set(power) {
                // set the light's intensity (in nits) from the desired luminous power (in lumens)
                this.intensity = power / (this.width * this.height * Math.PI);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_RectAreaLight.prototype), "copy", this).call(this, source);
                this.width = source.width;
                this.height = source.height;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_RectAreaLight.prototype), "toJSON", this).call(this, meta);
                data.object.width = this.width;
                data.object.height = this.height;
                return data;
              }
            }]);
            return _RectAreaLight;
          }(_Light);
          /**
          * Primary reference:
          *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
          *
          * Secondary reference:
          *   https://www.ppsloan.org/publications/StupidSH36.pdf
          */
          // 3-band SH defined by 9 coefficients
          var _SphericalHarmonics = /*#__PURE__*/function () {
            function _SphericalHarmonics() {
              _classCallCheck2(this, _SphericalHarmonics);
              this.isSphericalHarmonics3 = true;
              this.coefficients = [];
              for (var i = 0; i < 9; i++) {
                this.coefficients.push(new _Vector2());
              }
            }
            _createClass2(_SphericalHarmonics, [{
              key: "set",
              value: function set(coefficients) {
                for (var i = 0; i < 9; i++) {
                  this.coefficients[i].copy(coefficients[i]);
                }
                return this;
              }
            }, {
              key: "zero",
              value: function zero() {
                for (var i = 0; i < 9; i++) {
                  this.coefficients[i].set(0, 0, 0);
                }
                return this;
              } // get the radiance in the direction of the normal
              // target is a Vector3
            }, {
              key: "getAt",
              value: function getAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x,
                  y = normal.y,
                  z = normal.z;
                var coeff = this.coefficients; // band 0
                target.copy(coeff[0]).multiplyScalar(0.282095); // band 1
                target.addScaledVector(coeff[1], 0.488603 * y);
                target.addScaledVector(coeff[2], 0.488603 * z);
                target.addScaledVector(coeff[3], 0.488603 * x); // band 2
                target.addScaledVector(coeff[4], 1.092548 * (x * y));
                target.addScaledVector(coeff[5], 1.092548 * (y * z));
                target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
                target.addScaledVector(coeff[7], 1.092548 * (x * z));
                target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
                return target;
              } // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
              // target is a Vector3
              // https://graphics.stanford.edu/papers/envmap/envmap.pdf
            }, {
              key: "getIrradianceAt",
              value: function getIrradianceAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x,
                  y = normal.y,
                  z = normal.z;
                var coeff = this.coefficients; // band 0
                target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
                // band 1
                target.addScaledVector(coeff[1], 2.0 * 0.511664 * y); // ( 2 * π / 3 ) * 0.488603
                target.addScaledVector(coeff[2], 2.0 * 0.511664 * z);
                target.addScaledVector(coeff[3], 2.0 * 0.511664 * x); // band 2
                target.addScaledVector(coeff[4], 2.0 * 0.429043 * x * y); // ( π / 4 ) * 1.092548
                target.addScaledVector(coeff[5], 2.0 * 0.429043 * y * z);
                target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
                target.addScaledVector(coeff[7], 2.0 * 0.429043 * x * z);
                target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
                return target;
              }
            }, {
              key: "add",
              value: function add(sh) {
                for (var i = 0; i < 9; i++) {
                  this.coefficients[i].add(sh.coefficients[i]);
                }
                return this;
              }
            }, {
              key: "addScaledSH",
              value: function addScaledSH(sh, s) {
                for (var i = 0; i < 9; i++) {
                  this.coefficients[i].addScaledVector(sh.coefficients[i], s);
                }
                return this;
              }
            }, {
              key: "scale",
              value: function scale(s) {
                for (var i = 0; i < 9; i++) {
                  this.coefficients[i].multiplyScalar(s);
                }
                return this;
              }
            }, {
              key: "lerp",
              value: function lerp(sh, alpha) {
                for (var i = 0; i < 9; i++) {
                  this.coefficients[i].lerp(sh.coefficients[i], alpha);
                }
                return this;
              }
            }, {
              key: "equals",
              value: function equals(sh) {
                for (var i = 0; i < 9; i++) {
                  if (!this.coefficients[i].equals(sh.coefficients[i])) {
                    return false;
                  }
                }
                return true;
              }
            }, {
              key: "copy",
              value: function copy(sh) {
                return this.set(sh.coefficients);
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "fromArray",
              value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for (var i = 0; i < 9; i++) {
                  coefficients[i].fromArray(array, offset + i * 3);
                }
                return this;
              }
            }, {
              key: "toArray",
              value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for (var i = 0; i < 9; i++) {
                  coefficients[i].toArray(array, offset + i * 3);
                }
                return array;
              } // evaluate the basis functions
              // shBasis is an Array[ 9 ]
            }], [{
              key: "getBasisAt",
              value: function getBasisAt(normal, shBasis) {
                // normal is assumed to be unit length
                var x = normal.x,
                  y = normal.y,
                  z = normal.z; // band 0
                shBasis[0] = 0.282095; // band 1
                shBasis[1] = 0.488603 * y;
                shBasis[2] = 0.488603 * z;
                shBasis[3] = 0.488603 * x; // band 2
                shBasis[4] = 1.092548 * x * y;
                shBasis[5] = 1.092548 * y * z;
                shBasis[6] = 0.315392 * (3 * z * z - 1);
                shBasis[7] = 1.092548 * x * z;
                shBasis[8] = 0.546274 * (x * x - y * y);
              }
            }]);
            return _SphericalHarmonics;
          }();
          var _LightProbe = /*#__PURE__*/function (_Light8) {
            _inherits(_LightProbe, _Light8);
            var _super139 = _createSuper(_LightProbe);
            function _LightProbe() {
              var _this115;
              var sh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _SphericalHarmonics();
              var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              _classCallCheck2(this, _LightProbe);
              _this115 = _super139.call(this, undefined, intensity);
              _this115.isLightProbe = true;
              _this115.sh = sh;
              return _this115;
            }
            _createClass2(_LightProbe, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_LightProbe.prototype), "copy", this).call(this, source);
                this.sh.copy(source.sh);
                return this;
              }
            }, {
              key: "fromJSON",
              value: function fromJSON(json) {
                this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
                this.sh.fromArray(json.sh);
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON(meta) {
                var data = _get2(_getPrototypeOf(_LightProbe.prototype), "toJSON", this).call(this, meta);
                data.object.sh = this.sh.toArray();
                return data;
              }
            }]);
            return _LightProbe;
          }(_Light);
          var _MaterialLoader = /*#__PURE__*/function (_Loader9) {
            _inherits(_MaterialLoader, _Loader9);
            var _super140 = _createSuper(_MaterialLoader);
            function _MaterialLoader(manager) {
              var _this116;
              _classCallCheck2(this, _MaterialLoader);
              _this116 = _super140.call(this, manager);
              _this116.textures = {};
              return _this116;
            }
            _createClass2(_MaterialLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new _FileLoader(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function (text) {
                  try {
                    onLoad(scope.parse(JSON.parse(text)));
                  } catch (e) {
                    if (onError) {
                      onError(e);
                    } else {
                      console.error(e);
                    }
                    scope.manager.itemError(url);
                  }
                }, onProgress, onError);
              }
            }, {
              key: "parse",
              value: function parse(json) {
                var textures = this.textures;
                function getTexture(name) {
                  if (textures[name] === undefined) {
                    console.warn('THREE.MaterialLoader: Undefined texture', name);
                  }
                  return textures[name];
                }
                var material = _MaterialLoader.createMaterialFromType(json.type);
                if (json.uuid !== undefined) material.uuid = json.uuid;
                if (json.name !== undefined) material.name = json.name;
                if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
                if (json.roughness !== undefined) material.roughness = json.roughness;
                if (json.metalness !== undefined) material.metalness = json.metalness;
                if (json.sheen !== undefined) material.sheen = json.sheen;
                if (json.sheenColor !== undefined) material.sheenColor = new _Color().setHex(json.sheenColor);
                if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
                if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
                if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
                if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
                if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
                if (json.shininess !== undefined) material.shininess = json.shininess;
                if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
                if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
                if (json.iridescence !== undefined) material.iridescence = json.iridescence;
                if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
                if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
                if (json.transmission !== undefined) material.transmission = json.transmission;
                if (json.thickness !== undefined) material.thickness = json.thickness;
                if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
                if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
                if (json.fog !== undefined) material.fog = json.fog;
                if (json.flatShading !== undefined) material.flatShading = json.flatShading;
                if (json.blending !== undefined) material.blending = json.blending;
                if (json.combine !== undefined) material.combine = json.combine;
                if (json.side !== undefined) material.side = json.side;
                if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
                if (json.opacity !== undefined) material.opacity = json.opacity;
                if (json.transparent !== undefined) material.transparent = json.transparent;
                if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
                if (json.depthTest !== undefined) material.depthTest = json.depthTest;
                if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
                if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
                if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
                if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
                if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
                if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
                if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
                if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
                if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
                if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
                if (json.wireframe !== undefined) material.wireframe = json.wireframe;
                if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
                if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
                if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
                if (json.rotation !== undefined) material.rotation = json.rotation;
                if (json.linewidth !== 1) material.linewidth = json.linewidth;
                if (json.dashSize !== undefined) material.dashSize = json.dashSize;
                if (json.gapSize !== undefined) material.gapSize = json.gapSize;
                if (json.scale !== undefined) material.scale = json.scale;
                if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
                if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
                if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
                if (json.dithering !== undefined) material.dithering = json.dithering;
                if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
                if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
                if (json.visible !== undefined) material.visible = json.visible;
                if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
                if (json.userData !== undefined) material.userData = json.userData;
                if (json.vertexColors !== undefined) {
                  if (typeof json.vertexColors === 'number') {
                    material.vertexColors = json.vertexColors > 0 ? true : false;
                  } else {
                    material.vertexColors = json.vertexColors;
                  }
                } // Shader Material
                if (json.uniforms !== undefined) {
                  for (var name in json.uniforms) {
                    var uniform = json.uniforms[name];
                    material.uniforms[name] = {};
                    switch (uniform.type) {
                      case 't':
                        material.uniforms[name].value = getTexture(uniform.value);
                        break;
                      case 'c':
                        material.uniforms[name].value = new _Color().setHex(uniform.value);
                        break;
                      case 'v2':
                        material.uniforms[name].value = new _Vector().fromArray(uniform.value);
                        break;
                      case 'v3':
                        material.uniforms[name].value = new _Vector2().fromArray(uniform.value);
                        break;
                      case 'v4':
                        material.uniforms[name].value = new _Vector3().fromArray(uniform.value);
                        break;
                      case 'm3':
                        material.uniforms[name].value = new _Matrix().fromArray(uniform.value);
                        break;
                      case 'm4':
                        material.uniforms[name].value = new _Matrix2().fromArray(uniform.value);
                        break;
                      default:
                        material.uniforms[name].value = uniform.value;
                    }
                  }
                }
                if (json.defines !== undefined) material.defines = json.defines;
                if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
                if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
                if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
                if (json.extensions !== undefined) {
                  for (var key in json.extensions) {
                    material.extensions[key] = json.extensions[key];
                  }
                } // for PointsMaterial
                if (json.size !== undefined) material.size = json.size;
                if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation; // maps
                if (json.map !== undefined) material.map = getTexture(json.map);
                if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
                if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
                if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
                if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
                if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
                if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
                if (json.normalScale !== undefined) {
                  var normalScale = json.normalScale;
                  if (Array.isArray(normalScale) === false) {
                    // Blender exporter used to export a scalar. See #7459
                    normalScale = [normalScale, normalScale];
                  }
                  material.normalScale = new _Vector().fromArray(normalScale);
                }
                if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
                if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
                if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
                if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
                if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
                if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
                if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
                if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
                if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
                if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
                if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
                if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
                if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
                if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
                if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
                if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
                if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
                if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
                if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
                if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
                if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
                if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
                if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new _Vector().fromArray(json.clearcoatNormalScale);
                if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
                if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
                if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
                if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
                if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
                if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
                return material;
              }
            }, {
              key: "setTextures",
              value: function setTextures(value) {
                this.textures = value;
                return this;
              }
            }], [{
              key: "createMaterialFromType",
              value: function createMaterialFromType(type) {
                var materialLib = {
                  ShadowMaterial: _ShadowMaterial,
                  SpriteMaterial: _SpriteMaterial,
                  RawShaderMaterial: _RawShaderMaterial,
                  ShaderMaterial: _ShaderMaterial,
                  PointsMaterial: _PointsMaterial,
                  MeshPhysicalMaterial: _MeshPhysicalMaterial,
                  MeshStandardMaterial: _MeshStandardMaterial,
                  MeshPhongMaterial: _MeshPhongMaterial,
                  MeshToonMaterial: _MeshToonMaterial,
                  MeshNormalMaterial: _MeshNormalMaterial,
                  MeshLambertMaterial: _MeshLambertMaterial,
                  MeshDepthMaterial: _MeshDepthMaterial,
                  MeshDistanceMaterial: _MeshDistanceMaterial,
                  MeshBasicMaterial: _MeshBasicMaterial,
                  MeshMatcapMaterial: _MeshMatcapMaterial,
                  LineDashedMaterial: _LineDashedMaterial,
                  LineBasicMaterial: _LineBasicMaterial,
                  Material: _Material
                };
                return new materialLib[type]();
              }
            }]);
            return _MaterialLoader;
          }(_Loader);
          var _LoaderUtils = /*#__PURE__*/function () {
            function _LoaderUtils() {
              _classCallCheck2(this, _LoaderUtils);
            }
            _createClass2(_LoaderUtils, null, [{
              key: "decodeText",
              value: function decodeText(array) {
                if (typeof TextDecoder !== 'undefined') {
                  return new TextDecoder().decode(array);
                } // Avoid the String.fromCharCode.apply(null, array) shortcut, which
                // throws a "maximum call stack size exceeded" error for large arrays.
                var s = '';
                for (var i = 0, il = array.length; i < il; i++) {
                  // Implicitly assumes little-endian.
                  s += String.fromCharCode(array[i]);
                }
                try {
                  // merges multi-byte utf-8 characters.
                  return decodeURIComponent(escape(s));
                } catch (e) {
                  // see #16358
                  return s;
                }
              }
            }, {
              key: "extractUrlBase",
              value: function extractUrlBase(url) {
                var index = url.lastIndexOf('/');
                if (index === -1) return './';
                return url.slice(0, index + 1);
              }
            }, {
              key: "resolveURL",
              value: function resolveURL(url, path) {
                // Invalid URL
                if (typeof url !== 'string' || url === '') return ''; // Host Relative URL
                if (/^https?:\/\//i.test(path) && /^\//.test(url)) {
                  path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
                } // Absolute URL http://,https://,//
                if (/^(https?:)?\/\//i.test(url)) return url; // Data URI
                if (/^data:.*,.*$/i.test(url)) return url; // Blob URL
                if (/^blob:.*$/i.test(url)) return url; // Relative URL
                return path + url;
              }
            }]);
            return _LoaderUtils;
          }();
          var _InstancedBufferGeometry = /*#__PURE__*/function (_BufferGeometry17) {
            _inherits(_InstancedBufferGeometry, _BufferGeometry17);
            var _super141 = _createSuper(_InstancedBufferGeometry);
            function _InstancedBufferGeometry() {
              var _this117;
              _classCallCheck2(this, _InstancedBufferGeometry);
              _this117 = _super141.call(this);
              _this117.isInstancedBufferGeometry = true;
              _this117.type = 'InstancedBufferGeometry';
              _this117.instanceCount = Infinity;
              return _this117;
            }
            _createClass2(_InstancedBufferGeometry, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_InstancedBufferGeometry.prototype), "copy", this).call(this, source);
                this.instanceCount = source.instanceCount;
                return this;
              }
            }, {
              key: "toJSON",
              value: function toJSON() {
                var data = _get2(_getPrototypeOf(_InstancedBufferGeometry.prototype), "toJSON", this).call(this);
                data.instanceCount = this.instanceCount;
                data.isInstancedBufferGeometry = true;
                return data;
              }
            }]);
            return _InstancedBufferGeometry;
          }(_BufferGeometry);
          var _BufferGeometryLoader = /*#__PURE__*/function (_Loader10) {
            _inherits(_BufferGeometryLoader, _Loader10);
            var _super142 = _createSuper(_BufferGeometryLoader);
            function _BufferGeometryLoader(manager) {
              _classCallCheck2(this, _BufferGeometryLoader);
              return _super142.call(this, manager);
            }
            _createClass2(_BufferGeometryLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new _FileLoader(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function (text) {
                  try {
                    onLoad(scope.parse(JSON.parse(text)));
                  } catch (e) {
                    if (onError) {
                      onError(e);
                    } else {
                      console.error(e);
                    }
                    scope.manager.itemError(url);
                  }
                }, onProgress, onError);
              }
            }, {
              key: "parse",
              value: function parse(json) {
                var interleavedBufferMap = {};
                var arrayBufferMap = {};
                function getInterleavedBuffer(json, uuid) {
                  if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
                  var interleavedBuffers = json.interleavedBuffers;
                  var interleavedBuffer = interleavedBuffers[uuid];
                  var buffer = getArrayBuffer(json, interleavedBuffer.buffer);
                  var array = getTypedArray(interleavedBuffer.type, buffer);
                  var ib = new _InterleavedBuffer(array, interleavedBuffer.stride);
                  ib.uuid = interleavedBuffer.uuid;
                  interleavedBufferMap[uuid] = ib;
                  return ib;
                }
                function getArrayBuffer(json, uuid) {
                  if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
                  var arrayBuffers = json.arrayBuffers;
                  var arrayBuffer = arrayBuffers[uuid];
                  var ab = new Uint32Array(arrayBuffer).buffer;
                  arrayBufferMap[uuid] = ab;
                  return ab;
                }
                var geometry = json.isInstancedBufferGeometry ? new _InstancedBufferGeometry() : new _BufferGeometry();
                var index = json.data.index;
                if (index !== undefined) {
                  var typedArray = getTypedArray(index.type, index.array);
                  geometry.setIndex(new _BufferAttribute(typedArray, 1));
                }
                var attributes = json.data.attributes;
                for (var key in attributes) {
                  var attribute = attributes[key];
                  var bufferAttribute = void 0;
                  if (attribute.isInterleavedBufferAttribute) {
                    var interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new _InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                  } else {
                    var _typedArray = getTypedArray(attribute.type, attribute.array);
                    var bufferAttributeConstr = attribute.isInstancedBufferAttribute ? _InstancedBufferAttribute : _BufferAttribute;
                    bufferAttribute = new bufferAttributeConstr(_typedArray, attribute.itemSize, attribute.normalized);
                  }
                  if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                  if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
                  if (attribute.updateRange !== undefined) {
                    bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                    bufferAttribute.updateRange.count = attribute.updateRange.count;
                  }
                  geometry.setAttribute(key, bufferAttribute);
                }
                var morphAttributes = json.data.morphAttributes;
                if (morphAttributes) {
                  for (var _key3 in morphAttributes) {
                    var attributeArray = morphAttributes[_key3];
                    var array = [];
                    for (var i = 0, il = attributeArray.length; i < il; i++) {
                      var _attribute3 = attributeArray[i];
                      var _bufferAttribute = void 0;
                      if (_attribute3.isInterleavedBufferAttribute) {
                        var _interleavedBuffer = getInterleavedBuffer(json.data, _attribute3.data);
                        _bufferAttribute = new _InterleavedBufferAttribute(_interleavedBuffer, _attribute3.itemSize, _attribute3.offset, _attribute3.normalized);
                      } else {
                        var _typedArray2 = getTypedArray(_attribute3.type, _attribute3.array);
                        _bufferAttribute = new _BufferAttribute(_typedArray2, _attribute3.itemSize, _attribute3.normalized);
                      }
                      if (_attribute3.name !== undefined) _bufferAttribute.name = _attribute3.name;
                      array.push(_bufferAttribute);
                    }
                    geometry.morphAttributes[_key3] = array;
                  }
                }
                var morphTargetsRelative = json.data.morphTargetsRelative;
                if (morphTargetsRelative) {
                  geometry.morphTargetsRelative = true;
                }
                var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
                if (groups !== undefined) {
                  for (var _i87 = 0, n = groups.length; _i87 !== n; ++_i87) {
                    var group = groups[_i87];
                    geometry.addGroup(group.start, group.count, group.materialIndex);
                  }
                }
                var boundingSphere = json.data.boundingSphere;
                if (boundingSphere !== undefined) {
                  var center = new _Vector2();
                  if (boundingSphere.center !== undefined) {
                    center.fromArray(boundingSphere.center);
                  }
                  geometry.boundingSphere = new _Sphere(center, boundingSphere.radius);
                }
                if (json.name) geometry.name = json.name;
                if (json.userData) geometry.userData = json.userData;
                return geometry;
              }
            }]);
            return _BufferGeometryLoader;
          }(_Loader);
          var _ObjectLoader = /*#__PURE__*/function (_Loader11) {
            _inherits(_ObjectLoader, _Loader11);
            var _super143 = _createSuper(_ObjectLoader);
            function _ObjectLoader(manager) {
              _classCallCheck2(this, _ObjectLoader);
              return _super143.call(this, manager);
            }
            _createClass2(_ObjectLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var path = this.path === '' ? _LoaderUtils.extractUrlBase(url) : this.path;
                this.resourcePath = this.resourcePath || path;
                var loader = new _FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (text) {
                  var json = null;
                  try {
                    json = JSON.parse(text);
                  } catch (error) {
                    if (onError !== undefined) onError(error);
                    console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                    return;
                  }
                  var metadata = json.metadata;
                  if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                    if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                    console.error('THREE.ObjectLoader: Can\'t load ' + url);
                    return;
                  }
                  scope.parse(json, onLoad);
                }, onProgress, onError);
              }
            }, {
              key: "loadAsync",
              value: function () {
                var _loadAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, onProgress) {
                  var scope, path, loader, text, json, metadata;
                  return _regeneratorRuntime().wrap(function _callee2$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        scope = this;
                        path = this.path === '' ? _LoaderUtils.extractUrlBase(url) : this.path;
                        this.resourcePath = this.resourcePath || path;
                        loader = new _FileLoader(this.manager);
                        loader.setPath(this.path);
                        loader.setRequestHeader(this.requestHeader);
                        loader.setWithCredentials(this.withCredentials);
                        _context9.next = 9;
                        return loader.loadAsync(url, onProgress);
                      case 9:
                        text = _context9.sent;
                        json = JSON.parse(text);
                        metadata = json.metadata;
                        if (!(metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry')) {
                          _context9.next = 14;
                          break;
                        }
                        throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
                      case 14:
                        _context9.next = 16;
                        return scope.parseAsync(json);
                      case 16:
                        return _context9.abrupt("return", _context9.sent);
                      case 17:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee2, this);
                }));
                function loadAsync(_x7, _x8) {
                  return _loadAsync.apply(this, arguments);
                }
                return loadAsync;
              }()
            }, {
              key: "parse",
              value: function parse(json, onLoad) {
                var animations = this.parseAnimations(json.animations);
                var shapes = this.parseShapes(json.shapes);
                var geometries = this.parseGeometries(json.geometries, shapes);
                var images = this.parseImages(json.images, function () {
                  if (onLoad !== undefined) onLoad(object);
                });
                var textures = this.parseTextures(json.textures, images);
                var materials = this.parseMaterials(json.materials, textures);
                var object = this.parseObject(json.object, geometries, materials, textures, animations);
                var skeletons = this.parseSkeletons(json.skeletons, object);
                this.bindSkeletons(object, skeletons); //
                if (onLoad !== undefined) {
                  var hasImages = false;
                  for (var uuid in images) {
                    if (images[uuid].data instanceof HTMLImageElement) {
                      hasImages = true;
                      break;
                    }
                  }
                  if (hasImages === false) onLoad(object);
                }
                return object;
              }
            }, {
              key: "parseAsync",
              value: function () {
                var _parseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(json) {
                  var animations, shapes, geometries, images, textures, materials, object, skeletons;
                  return _regeneratorRuntime().wrap(function _callee3$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        animations = this.parseAnimations(json.animations);
                        shapes = this.parseShapes(json.shapes);
                        geometries = this.parseGeometries(json.geometries, shapes);
                        _context10.next = 5;
                        return this.parseImagesAsync(json.images);
                      case 5:
                        images = _context10.sent;
                        textures = this.parseTextures(json.textures, images);
                        materials = this.parseMaterials(json.materials, textures);
                        object = this.parseObject(json.object, geometries, materials, textures, animations);
                        skeletons = this.parseSkeletons(json.skeletons, object);
                        this.bindSkeletons(object, skeletons);
                        return _context10.abrupt("return", object);
                      case 12:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee3, this);
                }));
                function parseAsync(_x9) {
                  return _parseAsync.apply(this, arguments);
                }
                return parseAsync;
              }()
            }, {
              key: "parseShapes",
              value: function parseShapes(json) {
                var shapes = {};
                if (json !== undefined) {
                  for (var i = 0, l = json.length; i < l; i++) {
                    var shape = new _Shape().fromJSON(json[i]);
                    shapes[shape.uuid] = shape;
                  }
                }
                return shapes;
              }
            }, {
              key: "parseSkeletons",
              value: function parseSkeletons(json, object) {
                var skeletons = {};
                var bones = {}; // generate bone lookup table
                object.traverse(function (child) {
                  if (child.isBone) bones[child.uuid] = child;
                }); // create skeletons
                if (json !== undefined) {
                  for (var i = 0, l = json.length; i < l; i++) {
                    var skeleton = new _Skeleton().fromJSON(json[i], bones);
                    skeletons[skeleton.uuid] = skeleton;
                  }
                }
                return skeletons;
              }
            }, {
              key: "parseGeometries",
              value: function parseGeometries(json, shapes) {
                var geometries = {};
                if (json !== undefined) {
                  var bufferGeometryLoader = new _BufferGeometryLoader();
                  for (var i = 0, l = json.length; i < l; i++) {
                    var geometry = void 0;
                    var data = json[i];
                    switch (data.type) {
                      case 'BufferGeometry':
                      case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                      case 'Geometry':
                        if ('THREE' in window && 'LegacyJSONLoader' in THREE) {
                          var geometryLoader = new THREE.LegacyJSONLoader();
                          geometry = geometryLoader.parse(data, this.resourcePath).geometry;
                        } else {
                          console.error('THREE.ObjectLoader: You have to import LegacyJSONLoader in order load geometry data of type "Geometry".');
                        }
                        break;
                      default:
                        if (data.type in Geometries) {
                          geometry = Geometries[data.type].fromJSON(data, shapes);
                        } else {
                          console.warn("THREE.ObjectLoader: Unsupported geometry type \"".concat(data.type, "\""));
                        }
                    }
                    geometry.uuid = data.uuid;
                    if (data.name !== undefined) geometry.name = data.name;
                    if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                    geometries[data.uuid] = geometry;
                  }
                }
                return geometries;
              }
            }, {
              key: "parseMaterials",
              value: function parseMaterials(json, textures) {
                var cache = {}; // MultiMaterial
                var materials = {};
                if (json !== undefined) {
                  var loader = new _MaterialLoader();
                  loader.setTextures(textures);
                  for (var i = 0, l = json.length; i < l; i++) {
                    var data = json[i];
                    if (cache[data.uuid] === undefined) {
                      cache[data.uuid] = loader.parse(data);
                    }
                    materials[data.uuid] = cache[data.uuid];
                  }
                }
                return materials;
              }
            }, {
              key: "parseAnimations",
              value: function parseAnimations(json) {
                var animations = {};
                if (json !== undefined) {
                  for (var i = 0; i < json.length; i++) {
                    var data = json[i];
                    var clip = _AnimationClip.parse(data);
                    animations[clip.uuid] = clip;
                  }
                }
                return animations;
              }
            }, {
              key: "parseImages",
              value: function parseImages(json, onLoad) {
                var scope = this;
                var images = {};
                var loader;
                function loadImage(url) {
                  scope.manager.itemStart(url);
                  return loader.load(url, function () {
                    scope.manager.itemEnd(url);
                  }, undefined, function () {
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                  });
                }
                function deserializeImage(image) {
                  if (typeof image === 'string') {
                    var url = image;
                    var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                    return loadImage(path);
                  } else {
                    if (image.data) {
                      return {
                        data: getTypedArray(image.type, image.data),
                        width: image.width,
                        height: image.height
                      };
                    } else {
                      return null;
                    }
                  }
                }
                if (json !== undefined && json.length > 0) {
                  var manager = new _LoadingManager(onLoad);
                  loader = new _ImageLoader(manager);
                  loader.setCrossOrigin(this.crossOrigin);
                  for (var i = 0, il = json.length; i < il; i++) {
                    var image = json[i];
                    var url = image.url;
                    if (Array.isArray(url)) {
                      // load array of images e.g CubeTexture
                      var imageArray = [];
                      for (var j = 0, jl = url.length; j < jl; j++) {
                        var currentUrl = url[j];
                        var deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                          if (deserializedImage instanceof HTMLImageElement) {
                            imageArray.push(deserializedImage);
                          } else {
                            // special case: handle array of data textures for cube textures
                            imageArray.push(new _DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                          }
                        }
                      }
                      images[image.uuid] = new _Source(imageArray);
                    } else {
                      // load single image
                      var _deserializedImage = deserializeImage(image.url);
                      images[image.uuid] = new _Source(_deserializedImage);
                    }
                  }
                }
                return images;
              }
            }, {
              key: "parseImagesAsync",
              value: function () {
                var _parseImagesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(json) {
                  var scope, images, loader, deserializeImage, _deserializeImage, i, il, image, url, imageArray, j, jl, currentUrl, deserializedImage, _deserializedImage2;
                  return _regeneratorRuntime().wrap(function _callee5$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        _deserializeImage = function _deserializeImage3() {
                          _deserializeImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(image) {
                            var _url, path;
                            return _regeneratorRuntime().wrap(function _callee4$(_context11) {
                              while (1) switch (_context11.prev = _context11.next) {
                                case 0:
                                  if (!(typeof image === 'string')) {
                                    _context11.next = 8;
                                    break;
                                  }
                                  _url = image;
                                  path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(_url) ? _url : scope.resourcePath + _url;
                                  _context11.next = 5;
                                  return loader.loadAsync(path);
                                case 5:
                                  return _context11.abrupt("return", _context11.sent);
                                case 8:
                                  if (!image.data) {
                                    _context11.next = 12;
                                    break;
                                  }
                                  return _context11.abrupt("return", {
                                    data: getTypedArray(image.type, image.data),
                                    width: image.width,
                                    height: image.height
                                  });
                                case 12:
                                  return _context11.abrupt("return", null);
                                case 13:
                                case "end":
                                  return _context11.stop();
                              }
                            }, _callee4);
                          }));
                          return _deserializeImage.apply(this, arguments);
                        };
                        deserializeImage = function _deserializeImage2(_x11) {
                          return _deserializeImage.apply(this, arguments);
                        };
                        scope = this;
                        images = {};
                        if (!(json !== undefined && json.length > 0)) {
                          _context12.next = 33;
                          break;
                        }
                        loader = new _ImageLoader(this.manager);
                        loader.setCrossOrigin(this.crossOrigin);
                        i = 0, il = json.length;
                      case 8:
                        if (!(i < il)) {
                          _context12.next = 33;
                          break;
                        }
                        image = json[i];
                        url = image.url;
                        if (!Array.isArray(url)) {
                          _context12.next = 26;
                          break;
                        }
                        // load array of images e.g CubeTexture
                        imageArray = [];
                        j = 0, jl = url.length;
                      case 14:
                        if (!(j < jl)) {
                          _context12.next = 23;
                          break;
                        }
                        currentUrl = url[j];
                        _context12.next = 18;
                        return deserializeImage(currentUrl);
                      case 18:
                        deserializedImage = _context12.sent;
                        if (deserializedImage !== null) {
                          if (deserializedImage instanceof HTMLImageElement) {
                            imageArray.push(deserializedImage);
                          } else {
                            // special case: handle array of data textures for cube textures
                            imageArray.push(new _DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                          }
                        }
                      case 20:
                        j++;
                        _context12.next = 14;
                        break;
                      case 23:
                        images[image.uuid] = new _Source(imageArray);
                        _context12.next = 30;
                        break;
                      case 26:
                        _context12.next = 28;
                        return deserializeImage(image.url);
                      case 28:
                        _deserializedImage2 = _context12.sent;
                        images[image.uuid] = new _Source(_deserializedImage2);
                      case 30:
                        i++;
                        _context12.next = 8;
                        break;
                      case 33:
                        return _context12.abrupt("return", images);
                      case 34:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee5, this);
                }));
                function parseImagesAsync(_x10) {
                  return _parseImagesAsync.apply(this, arguments);
                }
                return parseImagesAsync;
              }()
            }, {
              key: "parseTextures",
              value: function parseTextures(json, images) {
                function parseConstant(value, type) {
                  if (typeof value === 'number') return value;
                  console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
                  return type[value];
                }
                var textures = {};
                if (json !== undefined) {
                  for (var i = 0, l = json.length; i < l; i++) {
                    var data = json[i];
                    if (data.image === undefined) {
                      console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
                    }
                    if (images[data.image] === undefined) {
                      console.warn('THREE.ObjectLoader: Undefined image', data.image);
                    }
                    var source = images[data.image];
                    var image = source.data;
                    var texture = void 0;
                    if (Array.isArray(image)) {
                      texture = new _CubeTexture();
                      if (image.length === 6) texture.needsUpdate = true;
                    } else {
                      if (image && image.data) {
                        texture = new _DataTexture();
                      } else {
                        texture = new _Texture();
                      }
                      if (image) texture.needsUpdate = true; // textures can have undefined image data
                    }
                    texture.source = source;
                    texture.uuid = data.uuid;
                    if (data.name !== undefined) texture.name = data.name;
                    if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
                    if (data.offset !== undefined) texture.offset.fromArray(data.offset);
                    if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
                    if (data.center !== undefined) texture.center.fromArray(data.center);
                    if (data.rotation !== undefined) texture.rotation = data.rotation;
                    if (data.wrap !== undefined) {
                      texture.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
                      texture.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
                    }
                    if (data.format !== undefined) texture.format = data.format;
                    if (data.type !== undefined) texture.type = data.type;
                    if (data.encoding !== undefined) texture.encoding = data.encoding;
                    if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
                    if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
                    if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
                    if (data.flipY !== undefined) texture.flipY = data.flipY;
                    if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
                    if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
                    if (data.userData !== undefined) texture.userData = data.userData;
                    textures[data.uuid] = texture;
                  }
                }
                return textures;
              }
            }, {
              key: "parseObject",
              value: function parseObject(data, geometries, materials, textures, animations) {
                var object;
                function getGeometry(name) {
                  if (geometries[name] === undefined) {
                    console.warn('THREE.ObjectLoader: Undefined geometry', name);
                  }
                  return geometries[name];
                }
                function getMaterial(name) {
                  if (name === undefined) return undefined;
                  if (Array.isArray(name)) {
                    var array = [];
                    for (var i = 0, l = name.length; i < l; i++) {
                      var uuid = name[i];
                      if (materials[uuid] === undefined) {
                        console.warn('THREE.ObjectLoader: Undefined material', uuid);
                      }
                      array.push(materials[uuid]);
                    }
                    return array;
                  }
                  if (materials[name] === undefined) {
                    console.warn('THREE.ObjectLoader: Undefined material', name);
                  }
                  return materials[name];
                }
                function getTexture(uuid) {
                  if (textures[uuid] === undefined) {
                    console.warn('THREE.ObjectLoader: Undefined texture', uuid);
                  }
                  return textures[uuid];
                }
                var geometry, material;
                switch (data.type) {
                  case 'Scene':
                    object = new _Scene();
                    if (data.background !== undefined) {
                      if (Number.isInteger(data.background)) {
                        object.background = new _Color(data.background);
                      } else {
                        object.background = getTexture(data.background);
                      }
                    }
                    if (data.environment !== undefined) {
                      object.environment = getTexture(data.environment);
                    }
                    if (data.fog !== undefined) {
                      if (data.fog.type === 'Fog') {
                        object.fog = new _Fog(data.fog.color, data.fog.near, data.fog.far);
                      } else if (data.fog.type === 'FogExp2') {
                        object.fog = new _FogExp(data.fog.color, data.fog.density);
                      }
                    }
                    if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                    break;
                  case 'PerspectiveCamera':
                    object = new _PerspectiveCamera(data.fov, data.aspect, data.near, data.far);
                    if (data.focus !== undefined) object.focus = data.focus;
                    if (data.zoom !== undefined) object.zoom = data.zoom;
                    if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                    if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                    if (data.view !== undefined) object.view = Object.assign({}, data.view);
                    break;
                  case 'OrthographicCamera':
                    object = new _OrthographicCamera(data.left, data.right, data.top, data.bottom, data.near, data.far);
                    if (data.zoom !== undefined) object.zoom = data.zoom;
                    if (data.view !== undefined) object.view = Object.assign({}, data.view);
                    break;
                  case 'AmbientLight':
                    object = new _AmbientLight(data.color, data.intensity);
                    break;
                  case 'DirectionalLight':
                    object = new _DirectionalLight(data.color, data.intensity);
                    break;
                  case 'PointLight':
                    object = new _PointLight(data.color, data.intensity, data.distance, data.decay);
                    break;
                  case 'RectAreaLight':
                    object = new _RectAreaLight(data.color, data.intensity, data.width, data.height);
                    break;
                  case 'SpotLight':
                    object = new _SpotLight(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                    break;
                  case 'HemisphereLight':
                    object = new _HemisphereLight(data.color, data.groundColor, data.intensity);
                    break;
                  case 'LightProbe':
                    object = new _LightProbe().fromJSON(data);
                    break;
                  case 'SkinnedMesh':
                    geometry = getGeometry(data.geometry);
                    material = getMaterial(data.material);
                    object = new _SkinnedMesh(geometry, material);
                    if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                    if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                    if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                    break;
                  case 'Mesh':
                    geometry = getGeometry(data.geometry);
                    material = getMaterial(data.material);
                    object = new _Mesh(geometry, material);
                    break;
                  case 'InstancedMesh':
                    geometry = getGeometry(data.geometry);
                    material = getMaterial(data.material);
                    var count = data.count;
                    var instanceMatrix = data.instanceMatrix;
                    var instanceColor = data.instanceColor;
                    object = new _InstancedMesh(geometry, material, count);
                    object.instanceMatrix = new _InstancedBufferAttribute(new Float32Array(instanceMatrix.array), 16);
                    if (instanceColor !== undefined) object.instanceColor = new _InstancedBufferAttribute(new Float32Array(instanceColor.array), instanceColor.itemSize);
                    break;
                  case 'LOD':
                    object = new _LOD();
                    break;
                  case 'Line':
                    object = new _Line(getGeometry(data.geometry), getMaterial(data.material));
                    break;
                  case 'LineLoop':
                    object = new _LineLoop(getGeometry(data.geometry), getMaterial(data.material));
                    break;
                  case 'LineSegments':
                    object = new _LineSegments(getGeometry(data.geometry), getMaterial(data.material));
                    break;
                  case 'PointCloud':
                  case 'Points':
                    object = new _Points(getGeometry(data.geometry), getMaterial(data.material));
                    break;
                  case 'Sprite':
                    object = new _Sprite(getMaterial(data.material));
                    break;
                  case 'Group':
                    object = new _Group();
                    break;
                  case 'Bone':
                    object = new _Bone();
                    break;
                  default:
                    object = new _Object3D();
                }
                object.uuid = data.uuid;
                if (data.name !== undefined) object.name = data.name;
                if (data.matrix !== undefined) {
                  object.matrix.fromArray(data.matrix);
                  if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
                  if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
                } else {
                  if (data.position !== undefined) object.position.fromArray(data.position);
                  if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
                  if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
                  if (data.scale !== undefined) object.scale.fromArray(data.scale);
                }
                if (data.castShadow !== undefined) object.castShadow = data.castShadow;
                if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
                if (data.shadow) {
                  if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
                  if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
                  if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
                  if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
                  if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
                }
                if (data.visible !== undefined) object.visible = data.visible;
                if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
                if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
                if (data.userData !== undefined) object.userData = data.userData;
                if (data.layers !== undefined) object.layers.mask = data.layers;
                if (data.children !== undefined) {
                  var children = data.children;
                  for (var i = 0; i < children.length; i++) {
                    object.add(this.parseObject(children[i], geometries, materials, textures, animations));
                  }
                }
                if (data.animations !== undefined) {
                  var objectAnimations = data.animations;
                  for (var _i88 = 0; _i88 < objectAnimations.length; _i88++) {
                    var uuid = objectAnimations[_i88];
                    object.animations.push(animations[uuid]);
                  }
                }
                if (data.type === 'LOD') {
                  if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
                  var levels = data.levels;
                  for (var l = 0; l < levels.length; l++) {
                    var level = levels[l];
                    var child = object.getObjectByProperty('uuid', level.object);
                    if (child !== undefined) {
                      object.addLevel(child, level.distance, level.hysteresis);
                    }
                  }
                }
                return object;
              }
            }, {
              key: "bindSkeletons",
              value: function bindSkeletons(object, skeletons) {
                if (Object.keys(skeletons).length === 0) return;
                object.traverse(function (child) {
                  if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                    var skeleton = skeletons[child.skeleton];
                    if (skeleton === undefined) {
                      console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                    } else {
                      child.bind(skeleton, child.bindMatrix);
                    }
                  }
                });
              }
            }]);
            return _ObjectLoader;
          }(_Loader);
          var TEXTURE_MAPPING = {
            UVMapping: _UVMapping,
            CubeReflectionMapping: _CubeReflectionMapping,
            CubeRefractionMapping: _CubeRefractionMapping,
            EquirectangularReflectionMapping: _EquirectangularReflectionMapping,
            EquirectangularRefractionMapping: _EquirectangularRefractionMapping,
            CubeUVReflectionMapping: _CubeUVReflectionMapping
          };
          var TEXTURE_WRAPPING = {
            RepeatWrapping: _RepeatWrapping,
            ClampToEdgeWrapping: _ClampToEdgeWrapping,
            MirroredRepeatWrapping: _MirroredRepeatWrapping
          };
          var TEXTURE_FILTER = {
            NearestFilter: _NearestFilter,
            NearestMipmapNearestFilter: _NearestMipmapNearestFilter,
            NearestMipmapLinearFilter: _NearestMipmapLinearFilter,
            LinearFilter: _LinearFilter,
            LinearMipmapNearestFilter: _LinearMipmapNearestFilter,
            LinearMipmapLinearFilter: _LinearMipmapLinearFilter
          };
          var _ImageBitmapLoader = /*#__PURE__*/function (_Loader12) {
            _inherits(_ImageBitmapLoader, _Loader12);
            var _super144 = _createSuper(_ImageBitmapLoader);
            function _ImageBitmapLoader(manager) {
              var _this118;
              _classCallCheck2(this, _ImageBitmapLoader);
              _this118 = _super144.call(this, manager);
              _this118.isImageBitmapLoader = true;
              if (typeof createImageBitmap === 'undefined') {
                console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
              }
              if (typeof fetch === 'undefined') {
                console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
              }
              _this118.options = {
                premultiplyAlpha: 'none'
              };
              return _this118;
            }
            _createClass2(_ImageBitmapLoader, [{
              key: "setOptions",
              value: function setOptions(options) {
                this.options = options;
                return this;
              }
            }, {
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = _Cache.get(url);
                if (cached !== undefined) {
                  scope.manager.itemStart(url);
                  setTimeout(function () {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                  }, 0);
                  return cached;
                }
                var fetchOptions = {};
                fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
                fetchOptions.headers = this.requestHeader;
                fetch(url, fetchOptions).then(function (res) {
                  return res.blob();
                }).then(function (blob) {
                  return createImageBitmap(blob, Object.assign(scope.options, {
                    colorSpaceConversion: 'none'
                  }));
                }).then(function (imageBitmap) {
                  _Cache.add(url, imageBitmap);
                  if (onLoad) onLoad(imageBitmap);
                  scope.manager.itemEnd(url);
                }).catch(function (e) {
                  if (onError) onError(e);
                  scope.manager.itemError(url);
                  scope.manager.itemEnd(url);
                });
                scope.manager.itemStart(url);
              }
            }]);
            return _ImageBitmapLoader;
          }(_Loader);
          var _context;
          var _AudioContext = /*#__PURE__*/function () {
            function _AudioContext() {
              _classCallCheck2(this, _AudioContext);
            }
            _createClass2(_AudioContext, null, [{
              key: "getContext",
              value: function getContext() {
                if (_context === undefined) {
                  _context = new (window.AudioContext || window.webkitAudioContext)();
                }
                return _context;
              }
            }, {
              key: "setContext",
              value: function setContext(value) {
                _context = value;
              }
            }]);
            return _AudioContext;
          }();
          var _AudioLoader = /*#__PURE__*/function (_Loader13) {
            _inherits(_AudioLoader, _Loader13);
            var _super145 = _createSuper(_AudioLoader);
            function _AudioLoader(manager) {
              _classCallCheck2(this, _AudioLoader);
              return _super145.call(this, manager);
            }
            _createClass2(_AudioLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new _FileLoader(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (buffer) {
                  try {
                    // Create a copy of the buffer. The `decodeAudioData` method
                    // detaches the buffer when complete, preventing reuse.
                    var bufferCopy = buffer.slice(0);
                    var context = _AudioContext.getContext();
                    context.decodeAudioData(bufferCopy, function (audioBuffer) {
                      onLoad(audioBuffer);
                    });
                  } catch (e) {
                    if (onError) {
                      onError(e);
                    } else {
                      console.error(e);
                    }
                    scope.manager.itemError(url);
                  }
                }, onProgress, onError);
              }
            }]);
            return _AudioLoader;
          }(_Loader);
          var _HemisphereLightProbe = /*#__PURE__*/function (_LightProbe2) {
            _inherits(_HemisphereLightProbe, _LightProbe2);
            var _super146 = _createSuper(_HemisphereLightProbe);
            function _HemisphereLightProbe(skyColor, groundColor) {
              var _this119;
              var intensity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              _classCallCheck2(this, _HemisphereLightProbe);
              _this119 = _super146.call(this, undefined, intensity);
              _this119.isHemisphereLightProbe = true;
              var color1 = new _Color().set(skyColor);
              var color2 = new _Color().set(groundColor);
              var sky = new _Vector2(color1.r, color1.g, color1.b);
              var ground = new _Vector2(color2.r, color2.g, color2.b); // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
              var c0 = Math.sqrt(Math.PI);
              var c1 = c0 * Math.sqrt(0.75);
              _this119.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
              _this119.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
              return _this119;
            }
            return _createClass2(_HemisphereLightProbe);
          }(_LightProbe);
          var _AmbientLightProbe = /*#__PURE__*/function (_LightProbe3) {
            _inherits(_AmbientLightProbe, _LightProbe3);
            var _super147 = _createSuper(_AmbientLightProbe);
            function _AmbientLightProbe(color) {
              var _this120;
              var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              _classCallCheck2(this, _AmbientLightProbe);
              _this120 = _super147.call(this, undefined, intensity);
              _this120.isAmbientLightProbe = true;
              var color1 = new _Color().set(color); // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
              _this120.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
              return _this120;
            }
            return _createClass2(_AmbientLightProbe);
          }(_LightProbe);
          var _eyeRight = /*@__PURE__*/new _Matrix2();
          var _eyeLeft = /*@__PURE__*/new _Matrix2();
          var _projectionMatrix = /*@__PURE__*/new _Matrix2();
          var _StereoCamera = /*#__PURE__*/function () {
            function _StereoCamera() {
              _classCallCheck2(this, _StereoCamera);
              this.type = 'StereoCamera';
              this.aspect = 1;
              this.eyeSep = 0.064;
              this.cameraL = new _PerspectiveCamera();
              this.cameraL.layers.enable(1);
              this.cameraL.matrixAutoUpdate = false;
              this.cameraR = new _PerspectiveCamera();
              this.cameraR.layers.enable(2);
              this.cameraR.matrixAutoUpdate = false;
              this._cache = {
                focus: null,
                fov: null,
                aspect: null,
                near: null,
                far: null,
                zoom: null,
                eyeSep: null
              };
            }
            _createClass2(_StereoCamera, [{
              key: "update",
              value: function update(camera) {
                var cache = this._cache;
                var needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
                if (needsUpdate) {
                  cache.focus = camera.focus;
                  cache.fov = camera.fov;
                  cache.aspect = camera.aspect * this.aspect;
                  cache.near = camera.near;
                  cache.far = camera.far;
                  cache.zoom = camera.zoom;
                  cache.eyeSep = this.eyeSep; // Off-axis stereoscopic effect based on
                  // http://paulbourke.net/stereographics/stereorender/
                  _projectionMatrix.copy(camera.projectionMatrix);
                  var eyeSepHalf = cache.eyeSep / 2;
                  var eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
                  var ymax = cache.near * Math.tan(DEG2RAD * cache.fov * 0.5) / cache.zoom;
                  var xmin, xmax; // translate xOffset
                  _eyeLeft.elements[12] = -eyeSepHalf;
                  _eyeRight.elements[12] = eyeSepHalf; // for left eye
                  xmin = -ymax * cache.aspect + eyeSepOnProjection;
                  xmax = ymax * cache.aspect + eyeSepOnProjection;
                  _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                  _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                  this.cameraL.projectionMatrix.copy(_projectionMatrix); // for right eye
                  xmin = -ymax * cache.aspect - eyeSepOnProjection;
                  xmax = ymax * cache.aspect - eyeSepOnProjection;
                  _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                  _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                  this.cameraR.projectionMatrix.copy(_projectionMatrix);
                }
                this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
                this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
              }
            }]);
            return _StereoCamera;
          }();
          var _Clock = /*#__PURE__*/function () {
            function _Clock() {
              var autoStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              _classCallCheck2(this, _Clock);
              this.autoStart = autoStart;
              this.startTime = 0;
              this.oldTime = 0;
              this.elapsedTime = 0;
              this.running = false;
            }
            _createClass2(_Clock, [{
              key: "start",
              value: function start() {
                this.startTime = now();
                this.oldTime = this.startTime;
                this.elapsedTime = 0;
                this.running = true;
              }
            }, {
              key: "stop",
              value: function stop() {
                this.getElapsedTime();
                this.running = false;
                this.autoStart = false;
              }
            }, {
              key: "getElapsedTime",
              value: function getElapsedTime() {
                this.getDelta();
                return this.elapsedTime;
              }
            }, {
              key: "getDelta",
              value: function getDelta() {
                var diff = 0;
                if (this.autoStart && !this.running) {
                  this.start();
                  return 0;
                }
                if (this.running) {
                  var newTime = now();
                  diff = (newTime - this.oldTime) / 1000;
                  this.oldTime = newTime;
                  this.elapsedTime += diff;
                }
                return diff;
              }
            }]);
            return _Clock;
          }();
          function now() {
            return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
          }
          var _position$1 = /*@__PURE__*/new _Vector2();
          var _quaternion$1 = /*@__PURE__*/new _Quaternion();
          var _scale$1 = /*@__PURE__*/new _Vector2();
          var _orientation$1 = /*@__PURE__*/new _Vector2();
          var _AudioListener = /*#__PURE__*/function (_Object3D13) {
            _inherits(_AudioListener, _Object3D13);
            var _super148 = _createSuper(_AudioListener);
            function _AudioListener() {
              var _this121;
              _classCallCheck2(this, _AudioListener);
              _this121 = _super148.call(this);
              _this121.type = 'AudioListener';
              _this121.context = _AudioContext.getContext();
              _this121.gain = _this121.context.createGain();
              _this121.gain.connect(_this121.context.destination);
              _this121.filter = null;
              _this121.timeDelta = 0; // private
              _this121._clock = new _Clock();
              return _this121;
            }
            _createClass2(_AudioListener, [{
              key: "getInput",
              value: function getInput() {
                return this.gain;
              }
            }, {
              key: "removeFilter",
              value: function removeFilter() {
                if (this.filter !== null) {
                  this.gain.disconnect(this.filter);
                  this.filter.disconnect(this.context.destination);
                  this.gain.connect(this.context.destination);
                  this.filter = null;
                }
                return this;
              }
            }, {
              key: "getFilter",
              value: function getFilter() {
                return this.filter;
              }
            }, {
              key: "setFilter",
              value: function setFilter(value) {
                if (this.filter !== null) {
                  this.gain.disconnect(this.filter);
                  this.filter.disconnect(this.context.destination);
                } else {
                  this.gain.disconnect(this.context.destination);
                }
                this.filter = value;
                this.gain.connect(this.filter);
                this.filter.connect(this.context.destination);
                return this;
              }
            }, {
              key: "getMasterVolume",
              value: function getMasterVolume() {
                return this.gain.gain.value;
              }
            }, {
              key: "setMasterVolume",
              value: function setMasterVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
              }
            }, {
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                _get2(_getPrototypeOf(_AudioListener.prototype), "updateMatrixWorld", this).call(this, force);
                var listener = this.context.listener;
                var up = this.up;
                this.timeDelta = this._clock.getDelta();
                this.matrixWorld.decompose(_position$1, _quaternion$1, _scale$1);
                _orientation$1.set(0, 0, -1).applyQuaternion(_quaternion$1);
                if (listener.positionX) {
                  // code path for Chrome (see #14393)
                  var endTime = this.context.currentTime + this.timeDelta;
                  listener.positionX.linearRampToValueAtTime(_position$1.x, endTime);
                  listener.positionY.linearRampToValueAtTime(_position$1.y, endTime);
                  listener.positionZ.linearRampToValueAtTime(_position$1.z, endTime);
                  listener.forwardX.linearRampToValueAtTime(_orientation$1.x, endTime);
                  listener.forwardY.linearRampToValueAtTime(_orientation$1.y, endTime);
                  listener.forwardZ.linearRampToValueAtTime(_orientation$1.z, endTime);
                  listener.upX.linearRampToValueAtTime(up.x, endTime);
                  listener.upY.linearRampToValueAtTime(up.y, endTime);
                  listener.upZ.linearRampToValueAtTime(up.z, endTime);
                } else {
                  listener.setPosition(_position$1.x, _position$1.y, _position$1.z);
                  listener.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z);
                }
              }
            }]);
            return _AudioListener;
          }(_Object3D);
          var _Audio = /*#__PURE__*/function (_Object3D14) {
            _inherits(_Audio, _Object3D14);
            var _super149 = _createSuper(_Audio);
            function _Audio(listener) {
              var _this122;
              _classCallCheck2(this, _Audio);
              _this122 = _super149.call(this);
              _this122.type = 'Audio';
              _this122.listener = listener;
              _this122.context = listener.context;
              _this122.gain = _this122.context.createGain();
              _this122.gain.connect(listener.getInput());
              _this122.autoplay = false;
              _this122.buffer = null;
              _this122.detune = 0;
              _this122.loop = false;
              _this122.loopStart = 0;
              _this122.loopEnd = 0;
              _this122.offset = 0;
              _this122.duration = undefined;
              _this122.playbackRate = 1;
              _this122.isPlaying = false;
              _this122.hasPlaybackControl = true;
              _this122.source = null;
              _this122.sourceType = 'empty';
              _this122._startedAt = 0;
              _this122._progress = 0;
              _this122._connected = false;
              _this122.filters = [];
              return _this122;
            }
            _createClass2(_Audio, [{
              key: "getOutput",
              value: function getOutput() {
                return this.gain;
              }
            }, {
              key: "setNodeSource",
              value: function setNodeSource(audioNode) {
                this.hasPlaybackControl = false;
                this.sourceType = 'audioNode';
                this.source = audioNode;
                this.connect();
                return this;
              }
            }, {
              key: "setMediaElementSource",
              value: function setMediaElementSource(mediaElement) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaNode';
                this.source = this.context.createMediaElementSource(mediaElement);
                this.connect();
                return this;
              }
            }, {
              key: "setMediaStreamSource",
              value: function setMediaStreamSource(mediaStream) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaStreamNode';
                this.source = this.context.createMediaStreamSource(mediaStream);
                this.connect();
                return this;
              }
            }, {
              key: "setBuffer",
              value: function setBuffer(audioBuffer) {
                this.buffer = audioBuffer;
                this.sourceType = 'buffer';
                if (this.autoplay) this.play();
                return this;
              }
            }, {
              key: "play",
              value: function play() {
                var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.isPlaying === true) {
                  console.warn('THREE.Audio: Audio is already playing.');
                  return;
                }
                if (this.hasPlaybackControl === false) {
                  console.warn('THREE.Audio: this Audio has no playback control.');
                  return;
                }
                this._startedAt = this.context.currentTime + delay;
                var source = this.context.createBufferSource();
                source.buffer = this.buffer;
                source.loop = this.loop;
                source.loopStart = this.loopStart;
                source.loopEnd = this.loopEnd;
                source.onended = this.onEnded.bind(this);
                source.start(this._startedAt, this._progress + this.offset, this.duration);
                this.isPlaying = true;
                this.source = source;
                this.setDetune(this.detune);
                this.setPlaybackRate(this.playbackRate);
                return this.connect();
              }
            }, {
              key: "pause",
              value: function pause() {
                if (this.hasPlaybackControl === false) {
                  console.warn('THREE.Audio: this Audio has no playback control.');
                  return;
                }
                if (this.isPlaying === true) {
                  // update current progress
                  this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
                  if (this.loop === true) {
                    // ensure _progress does not exceed duration with looped audios
                    this._progress = this._progress % (this.duration || this.buffer.duration);
                  }
                  this.source.stop();
                  this.source.onended = null;
                  this.isPlaying = false;
                }
                return this;
              }
            }, {
              key: "stop",
              value: function stop() {
                if (this.hasPlaybackControl === false) {
                  console.warn('THREE.Audio: this Audio has no playback control.');
                  return;
                }
                this._progress = 0;
                this.source.stop();
                this.source.onended = null;
                this.isPlaying = false;
                return this;
              }
            }, {
              key: "connect",
              value: function connect() {
                if (this.filters.length > 0) {
                  this.source.connect(this.filters[0]);
                  for (var i = 1, l = this.filters.length; i < l; i++) {
                    this.filters[i - 1].connect(this.filters[i]);
                  }
                  this.filters[this.filters.length - 1].connect(this.getOutput());
                } else {
                  this.source.connect(this.getOutput());
                }
                this._connected = true;
                return this;
              }
            }, {
              key: "disconnect",
              value: function disconnect() {
                if (this.filters.length > 0) {
                  this.source.disconnect(this.filters[0]);
                  for (var i = 1, l = this.filters.length; i < l; i++) {
                    this.filters[i - 1].disconnect(this.filters[i]);
                  }
                  this.filters[this.filters.length - 1].disconnect(this.getOutput());
                } else {
                  this.source.disconnect(this.getOutput());
                }
                this._connected = false;
                return this;
              }
            }, {
              key: "getFilters",
              value: function getFilters() {
                return this.filters;
              }
            }, {
              key: "setFilters",
              value: function setFilters(value) {
                if (!value) value = [];
                if (this._connected === true) {
                  this.disconnect();
                  this.filters = value.slice();
                  this.connect();
                } else {
                  this.filters = value.slice();
                }
                return this;
              }
            }, {
              key: "setDetune",
              value: function setDetune(value) {
                this.detune = value;
                if (this.source.detune === undefined) return; // only set detune when available
                if (this.isPlaying === true) {
                  this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
                }
                return this;
              }
            }, {
              key: "getDetune",
              value: function getDetune() {
                return this.detune;
              }
            }, {
              key: "getFilter",
              value: function getFilter() {
                return this.getFilters()[0];
              }
            }, {
              key: "setFilter",
              value: function setFilter(filter) {
                return this.setFilters(filter ? [filter] : []);
              }
            }, {
              key: "setPlaybackRate",
              value: function setPlaybackRate(value) {
                if (this.hasPlaybackControl === false) {
                  console.warn('THREE.Audio: this Audio has no playback control.');
                  return;
                }
                this.playbackRate = value;
                if (this.isPlaying === true) {
                  this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
                }
                return this;
              }
            }, {
              key: "getPlaybackRate",
              value: function getPlaybackRate() {
                return this.playbackRate;
              }
            }, {
              key: "onEnded",
              value: function onEnded() {
                this.isPlaying = false;
              }
            }, {
              key: "getLoop",
              value: function getLoop() {
                if (this.hasPlaybackControl === false) {
                  console.warn('THREE.Audio: this Audio has no playback control.');
                  return false;
                }
                return this.loop;
              }
            }, {
              key: "setLoop",
              value: function setLoop(value) {
                if (this.hasPlaybackControl === false) {
                  console.warn('THREE.Audio: this Audio has no playback control.');
                  return;
                }
                this.loop = value;
                if (this.isPlaying === true) {
                  this.source.loop = this.loop;
                }
                return this;
              }
            }, {
              key: "setLoopStart",
              value: function setLoopStart(value) {
                this.loopStart = value;
                return this;
              }
            }, {
              key: "setLoopEnd",
              value: function setLoopEnd(value) {
                this.loopEnd = value;
                return this;
              }
            }, {
              key: "getVolume",
              value: function getVolume() {
                return this.gain.gain.value;
              }
            }, {
              key: "setVolume",
              value: function setVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
              }
            }]);
            return _Audio;
          }(_Object3D);
          var _position = /*@__PURE__*/new _Vector2();
          var _quaternion = /*@__PURE__*/new _Quaternion();
          var _scale = /*@__PURE__*/new _Vector2();
          var _orientation = /*@__PURE__*/new _Vector2();
          var _PositionalAudio = /*#__PURE__*/function (_Audio2) {
            _inherits(_PositionalAudio, _Audio2);
            var _super150 = _createSuper(_PositionalAudio);
            function _PositionalAudio(listener) {
              var _this123;
              _classCallCheck2(this, _PositionalAudio);
              _this123 = _super150.call(this, listener);
              _this123.panner = _this123.context.createPanner();
              _this123.panner.panningModel = 'HRTF';
              _this123.panner.connect(_this123.gain);
              return _this123;
            }
            _createClass2(_PositionalAudio, [{
              key: "disconnect",
              value: function disconnect() {
                _get2(_getPrototypeOf(_PositionalAudio.prototype), "disconnect", this).call(this);
                this.panner.disconnect(this.gain);
              }
            }, {
              key: "getOutput",
              value: function getOutput() {
                return this.panner;
              }
            }, {
              key: "getRefDistance",
              value: function getRefDistance() {
                return this.panner.refDistance;
              }
            }, {
              key: "setRefDistance",
              value: function setRefDistance(value) {
                this.panner.refDistance = value;
                return this;
              }
            }, {
              key: "getRolloffFactor",
              value: function getRolloffFactor() {
                return this.panner.rolloffFactor;
              }
            }, {
              key: "setRolloffFactor",
              value: function setRolloffFactor(value) {
                this.panner.rolloffFactor = value;
                return this;
              }
            }, {
              key: "getDistanceModel",
              value: function getDistanceModel() {
                return this.panner.distanceModel;
              }
            }, {
              key: "setDistanceModel",
              value: function setDistanceModel(value) {
                this.panner.distanceModel = value;
                return this;
              }
            }, {
              key: "getMaxDistance",
              value: function getMaxDistance() {
                return this.panner.maxDistance;
              }
            }, {
              key: "setMaxDistance",
              value: function setMaxDistance(value) {
                this.panner.maxDistance = value;
                return this;
              }
            }, {
              key: "setDirectionalCone",
              value: function setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
                this.panner.coneInnerAngle = coneInnerAngle;
                this.panner.coneOuterAngle = coneOuterAngle;
                this.panner.coneOuterGain = coneOuterGain;
                return this;
              }
            }, {
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                _get2(_getPrototypeOf(_PositionalAudio.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.hasPlaybackControl === true && this.isPlaying === false) return;
                this.matrixWorld.decompose(_position, _quaternion, _scale);
                _orientation.set(0, 0, 1).applyQuaternion(_quaternion);
                var panner = this.panner;
                if (panner.positionX) {
                  // code path for Chrome and Firefox (see #14393)
                  var endTime = this.context.currentTime + this.listener.timeDelta;
                  panner.positionX.linearRampToValueAtTime(_position.x, endTime);
                  panner.positionY.linearRampToValueAtTime(_position.y, endTime);
                  panner.positionZ.linearRampToValueAtTime(_position.z, endTime);
                  panner.orientationX.linearRampToValueAtTime(_orientation.x, endTime);
                  panner.orientationY.linearRampToValueAtTime(_orientation.y, endTime);
                  panner.orientationZ.linearRampToValueAtTime(_orientation.z, endTime);
                } else {
                  panner.setPosition(_position.x, _position.y, _position.z);
                  panner.setOrientation(_orientation.x, _orientation.y, _orientation.z);
                }
              }
            }]);
            return _PositionalAudio;
          }(_Audio);
          var _AudioAnalyser = /*#__PURE__*/function () {
            function _AudioAnalyser(audio) {
              var fftSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2048;
              _classCallCheck2(this, _AudioAnalyser);
              this.analyser = audio.context.createAnalyser();
              this.analyser.fftSize = fftSize;
              this.data = new Uint8Array(this.analyser.frequencyBinCount);
              audio.getOutput().connect(this.analyser);
            }
            _createClass2(_AudioAnalyser, [{
              key: "getFrequencyData",
              value: function getFrequencyData() {
                this.analyser.getByteFrequencyData(this.data);
                return this.data;
              }
            }, {
              key: "getAverageFrequency",
              value: function getAverageFrequency() {
                var value = 0;
                var data = this.getFrequencyData();
                for (var i = 0; i < data.length; i++) {
                  value += data[i];
                }
                return value / data.length;
              }
            }]);
            return _AudioAnalyser;
          }();
          var _PropertyMixer = /*#__PURE__*/function () {
            function _PropertyMixer(binding, typeName, valueSize) {
              _classCallCheck2(this, _PropertyMixer);
              this.binding = binding;
              this.valueSize = valueSize;
              var mixFunction, mixFunctionAdditive, setIdentity; // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
              //
              // interpolators can use .buffer as their .result
              // the data then goes to 'incoming'
              //
              // 'accu0' and 'accu1' are used frame-interleaved for
              // the cumulative result and are compared to detect
              // changes
              //
              // 'orig' stores the original state of the property
              //
              // 'add' is used for additive cumulative results
              //
              // 'work' is optional and is only present for quaternion types. It is used
              // to store intermediate quaternion multiplication results
              switch (typeName) {
                case 'quaternion':
                  mixFunction = this._slerp;
                  mixFunctionAdditive = this._slerpAdditive;
                  setIdentity = this._setAdditiveIdentityQuaternion;
                  this.buffer = new Float64Array(valueSize * 6);
                  this._workIndex = 5;
                  break;
                case 'string':
                case 'bool':
                  mixFunction = this._select; // Use the regular mix function and for additive on these types,
                  // additive is not relevant for non-numeric types
                  mixFunctionAdditive = this._select;
                  setIdentity = this._setAdditiveIdentityOther;
                  this.buffer = new Array(valueSize * 5);
                  break;
                default:
                  mixFunction = this._lerp;
                  mixFunctionAdditive = this._lerpAdditive;
                  setIdentity = this._setAdditiveIdentityNumeric;
                  this.buffer = new Float64Array(valueSize * 5);
              }
              this._mixBufferRegion = mixFunction;
              this._mixBufferRegionAdditive = mixFunctionAdditive;
              this._setIdentity = setIdentity;
              this._origIndex = 3;
              this._addIndex = 4;
              this.cumulativeWeight = 0;
              this.cumulativeWeightAdditive = 0;
              this.useCount = 0;
              this.referenceCount = 0;
            } // accumulate data in the 'incoming' region into 'accu<i>'
            _createClass2(_PropertyMixer, [{
              key: "accumulate",
              value: function accumulate(accuIndex, weight) {
                // note: happily accumulating nothing when weight = 0, the caller knows
                // the weight and shouldn't have made the call in the first place
                var buffer = this.buffer,
                  stride = this.valueSize,
                  offset = accuIndex * stride + stride;
                var currentWeight = this.cumulativeWeight;
                if (currentWeight === 0) {
                  // accuN := incoming * weight
                  for (var i = 0; i !== stride; ++i) {
                    buffer[offset + i] = buffer[i];
                  }
                  currentWeight = weight;
                } else {
                  // accuN := accuN + incoming * weight
                  currentWeight += weight;
                  var mix = weight / currentWeight;
                  this._mixBufferRegion(buffer, offset, 0, mix, stride);
                }
                this.cumulativeWeight = currentWeight;
              } // accumulate data in the 'incoming' region into 'add'
            }, {
              key: "accumulateAdditive",
              value: function accumulateAdditive(weight) {
                var buffer = this.buffer,
                  stride = this.valueSize,
                  offset = stride * this._addIndex;
                if (this.cumulativeWeightAdditive === 0) {
                  // add = identity
                  this._setIdentity();
                } // add := add + incoming * weight
                this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
                this.cumulativeWeightAdditive += weight;
              } // apply the state of 'accu<i>' to the binding when accus differ
            }, {
              key: "apply",
              value: function apply(accuIndex) {
                var stride = this.valueSize,
                  buffer = this.buffer,
                  offset = accuIndex * stride + stride,
                  weight = this.cumulativeWeight,
                  weightAdditive = this.cumulativeWeightAdditive,
                  binding = this.binding;
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
                if (weight < 1) {
                  // accuN := accuN + original * ( 1 - cumulativeWeight )
                  var originalValueOffset = stride * this._origIndex;
                  this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
                }
                if (weightAdditive > 0) {
                  // accuN := accuN + additive accuN
                  this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
                }
                for (var i = stride, e = stride + stride; i !== e; ++i) {
                  if (buffer[i] !== buffer[i + stride]) {
                    // value has changed -> update scene graph
                    binding.setValue(buffer, offset);
                    break;
                  }
                }
              } // remember the state of the bound property and copy it to both accus
            }, {
              key: "saveOriginalState",
              value: function saveOriginalState() {
                var binding = this.binding;
                var buffer = this.buffer,
                  stride = this.valueSize,
                  originalValueOffset = stride * this._origIndex;
                binding.getValue(buffer, originalValueOffset); // accu[0..1] := orig -- initially detect changes against the original
                for (var i = stride, e = originalValueOffset; i !== e; ++i) {
                  buffer[i] = buffer[originalValueOffset + i % stride];
                } // Add to identity for additive
                this._setIdentity();
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
              } // apply the state previously taken via 'saveOriginalState' to the binding
            }, {
              key: "restoreOriginalState",
              value: function restoreOriginalState() {
                var originalValueOffset = this.valueSize * 3;
                this.binding.setValue(this.buffer, originalValueOffset);
              }
            }, {
              key: "_setAdditiveIdentityNumeric",
              value: function _setAdditiveIdentityNumeric() {
                var startIndex = this._addIndex * this.valueSize;
                var endIndex = startIndex + this.valueSize;
                for (var i = startIndex; i < endIndex; i++) {
                  this.buffer[i] = 0;
                }
              }
            }, {
              key: "_setAdditiveIdentityQuaternion",
              value: function _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric();
                this.buffer[this._addIndex * this.valueSize + 3] = 1;
              }
            }, {
              key: "_setAdditiveIdentityOther",
              value: function _setAdditiveIdentityOther() {
                var startIndex = this._origIndex * this.valueSize;
                var targetIndex = this._addIndex * this.valueSize;
                for (var i = 0; i < this.valueSize; i++) {
                  this.buffer[targetIndex + i] = this.buffer[startIndex + i];
                }
              } // mix functions
            }, {
              key: "_select",
              value: function _select(buffer, dstOffset, srcOffset, t, stride) {
                if (t >= 0.5) {
                  for (var i = 0; i !== stride; ++i) {
                    buffer[dstOffset + i] = buffer[srcOffset + i];
                  }
                }
              }
            }, {
              key: "_slerp",
              value: function _slerp(buffer, dstOffset, srcOffset, t) {
                _Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
              }
            }, {
              key: "_slerpAdditive",
              value: function _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                var workOffset = this._workIndex * stride; // Store result in intermediate buffer offset
                _Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset); // Slerp to the intermediate result
                _Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
              }
            }, {
              key: "_lerp",
              value: function _lerp(buffer, dstOffset, srcOffset, t, stride) {
                var s = 1 - t;
                for (var i = 0; i !== stride; ++i) {
                  var j = dstOffset + i;
                  buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
                }
              }
            }, {
              key: "_lerpAdditive",
              value: function _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                for (var i = 0; i !== stride; ++i) {
                  var j = dstOffset + i;
                  buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
                }
              }
            }]);
            return _PropertyMixer;
          }(); // Characters [].:/ are reserved for track binding syntax.
          var _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
          var _reservedRe = new RegExp('[' + _RESERVED_CHARS_RE + ']', 'g'); // Attempts to allow node names from any language. ES5's `\w` regexp matches
          // only latin characters, and the unicode \p{L} is not yet supported. So
          // instead, we exclude reserved characters and match everything else.
          var _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
          var _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace('\\.', '') + ']'; // Parent directories, delimited by '/' or ':'. Currently unused, but must
          // be matched to parse the rest of the track name.
          var _directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', _wordChar); // Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
          var _nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', _wordCharOrDot); // Object on target node, and accessor. May not contain reserved
          // characters. Accessor may contain any character except closing bracket.
          var _objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _wordChar); // Property and accessor. May not contain reserved characters. Accessor may
          // contain any non-bracket characters.
          var _propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _wordChar);
          var _trackRe = new RegExp('' + '^' + _directoryRe + _nodeRe + _objectRe + _propertyRe + '$');
          var _supportedObjectNames = ['material', 'materials', 'bones', 'map'];
          var Composite = /*#__PURE__*/function () {
            function Composite(targetGroup, path, optionalParsedPath) {
              _classCallCheck2(this, Composite);
              var parsedPath = optionalParsedPath || _PropertyBinding.parseTrackName(path);
              this._targetGroup = targetGroup;
              this._bindings = targetGroup.subscribe_(path, parsedPath);
            }
            _createClass2(Composite, [{
              key: "getValue",
              value: function getValue(array, offset) {
                this.bind(); // bind all binding
                var firstValidIndex = this._targetGroup.nCachedObjects_,
                  binding = this._bindings[firstValidIndex]; // and only call .getValue on the first
                if (binding !== undefined) binding.getValue(array, offset);
              }
            }, {
              key: "setValue",
              value: function setValue(array, offset) {
                var bindings = this._bindings;
                for (var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
                  bindings[i].setValue(array, offset);
                }
              }
            }, {
              key: "bind",
              value: function bind() {
                var bindings = this._bindings;
                for (var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
                  bindings[i].bind();
                }
              }
            }, {
              key: "unbind",
              value: function unbind() {
                var bindings = this._bindings;
                for (var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
                  bindings[i].unbind();
                }
              }
            }]);
            return Composite;
          }(); // Note: This class uses a State pattern on a per-method basis:
          // 'bind' sets 'this.getValue' / 'setValue' and shadows the
          // prototype version of these methods with one that represents
          // the bound state. When the property is not found, the methods
          // become no-ops.
          var _PropertyBinding = /*#__PURE__*/function () {
            function _PropertyBinding(rootNode, path, parsedPath) {
              _classCallCheck2(this, _PropertyBinding);
              this.path = path;
              this.parsedPath = parsedPath || _PropertyBinding.parseTrackName(path);
              this.node = _PropertyBinding.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
              this.rootNode = rootNode; // initial state of these methods that calls 'bind'
              this.getValue = this._getValue_unbound;
              this.setValue = this._setValue_unbound;
            }
            _createClass2(_PropertyBinding, [{
              key: "_getValue_unavailable",
              value:
              // these are used to "bind" a nonexistent property
              function _getValue_unavailable() {}
            }, {
              key: "_setValue_unavailable",
              value: function _setValue_unavailable() {} // Getters
            }, {
              key: "_getValue_direct",
              value: function _getValue_direct(buffer, offset) {
                buffer[offset] = this.targetObject[this.propertyName];
              }
            }, {
              key: "_getValue_array",
              value: function _getValue_array(buffer, offset) {
                var source = this.resolvedProperty;
                for (var i = 0, n = source.length; i !== n; ++i) {
                  buffer[offset++] = source[i];
                }
              }
            }, {
              key: "_getValue_arrayElement",
              value: function _getValue_arrayElement(buffer, offset) {
                buffer[offset] = this.resolvedProperty[this.propertyIndex];
              }
            }, {
              key: "_getValue_toArray",
              value: function _getValue_toArray(buffer, offset) {
                this.resolvedProperty.toArray(buffer, offset);
              } // Direct
            }, {
              key: "_setValue_direct",
              value: function _setValue_direct(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
              }
            }, {
              key: "_setValue_direct_setNeedsUpdate",
              value: function _setValue_direct_setNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.needsUpdate = true;
              }
            }, {
              key: "_setValue_direct_setMatrixWorldNeedsUpdate",
              value: function _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
              } // EntireArray
            }, {
              key: "_setValue_array",
              value: function _setValue_array(buffer, offset) {
                var dest = this.resolvedProperty;
                for (var i = 0, n = dest.length; i !== n; ++i) {
                  dest[i] = buffer[offset++];
                }
              }
            }, {
              key: "_setValue_array_setNeedsUpdate",
              value: function _setValue_array_setNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for (var i = 0, n = dest.length; i !== n; ++i) {
                  dest[i] = buffer[offset++];
                }
                this.targetObject.needsUpdate = true;
              }
            }, {
              key: "_setValue_array_setMatrixWorldNeedsUpdate",
              value: function _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for (var i = 0, n = dest.length; i !== n; ++i) {
                  dest[i] = buffer[offset++];
                }
                this.targetObject.matrixWorldNeedsUpdate = true;
              } // ArrayElement
            }, {
              key: "_setValue_arrayElement",
              value: function _setValue_arrayElement(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
              }
            }, {
              key: "_setValue_arrayElement_setNeedsUpdate",
              value: function _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.needsUpdate = true;
              }
            }, {
              key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
              value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
              } // HasToFromArray
            }, {
              key: "_setValue_fromArray",
              value: function _setValue_fromArray(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
              }
            }, {
              key: "_setValue_fromArray_setNeedsUpdate",
              value: function _setValue_fromArray_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.needsUpdate = true;
              }
            }, {
              key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
              value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.matrixWorldNeedsUpdate = true;
              }
            }, {
              key: "_getValue_unbound",
              value: function _getValue_unbound(targetArray, offset) {
                this.bind();
                this.getValue(targetArray, offset);
              }
            }, {
              key: "_setValue_unbound",
              value: function _setValue_unbound(sourceArray, offset) {
                this.bind();
                this.setValue(sourceArray, offset);
              } // create getter / setter pair for a property in the scene graph
            }, {
              key: "bind",
              value: function bind() {
                var targetObject = this.node;
                var parsedPath = this.parsedPath;
                var objectName = parsedPath.objectName;
                var propertyName = parsedPath.propertyName;
                var propertyIndex = parsedPath.propertyIndex;
                if (!targetObject) {
                  targetObject = _PropertyBinding.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
                  this.node = targetObject;
                } // set fail state so we can just 'return' on error
                this.getValue = this._getValue_unavailable;
                this.setValue = this._setValue_unavailable; // ensure there is a value node
                if (!targetObject) {
                  console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
                  return;
                }
                if (objectName) {
                  var objectIndex = parsedPath.objectIndex; // special cases were we need to reach deeper into the hierarchy to get the face materials....
                  switch (objectName) {
                    case 'materials':
                      if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                      }
                      if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                      }
                      targetObject = targetObject.material.materials;
                      break;
                    case 'bones':
                      if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                      } // potential future optimization: skip this if propertyIndex is already an integer
                      // and convert the integer string to a true integer.
                      targetObject = targetObject.skeleton.bones; // support resolving morphTarget names into indices.
                      for (var i = 0; i < targetObject.length; i++) {
                        if (targetObject[i].name === objectIndex) {
                          objectIndex = i;
                          break;
                        }
                      }
                      break;
                    case 'map':
                      if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                      }
                      if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                      }
                      if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                      }
                      targetObject = targetObject.material.map;
                      break;
                    default:
                      if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                      }
                      targetObject = targetObject[objectName];
                  }
                  if (objectIndex !== undefined) {
                    if (targetObject[objectIndex] === undefined) {
                      console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                      return;
                    }
                    targetObject = targetObject[objectIndex];
                  }
                } // resolve property
                var nodeProperty = targetObject[propertyName];
                if (nodeProperty === undefined) {
                  var nodeName = parsedPath.nodeName;
                  console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
                  return;
                } // determine versioning scheme
                var versioning = this.Versioning.None;
                this.targetObject = targetObject;
                if (targetObject.needsUpdate !== undefined) {
                  // material
                  versioning = this.Versioning.NeedsUpdate;
                } else if (targetObject.matrixWorldNeedsUpdate !== undefined) {
                  // node transform
                  versioning = this.Versioning.MatrixWorldNeedsUpdate;
                } // determine how the property gets bound
                var bindingType = this.BindingType.Direct;
                if (propertyIndex !== undefined) {
                  // access a sub element of the property array (only primitives are supported right now)
                  if (propertyName === 'morphTargetInfluences') {
                    // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                    // support resolving morphTarget names into indices.
                    if (!targetObject.geometry) {
                      console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                      return;
                    }
                    if (!targetObject.geometry.morphAttributes) {
                      console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                      return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) {
                      propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                    }
                  }
                  bindingType = this.BindingType.ArrayElement;
                  this.resolvedProperty = nodeProperty;
                  this.propertyIndex = propertyIndex;
                } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
                  // must use copy for Object3D.Euler/Quaternion
                  bindingType = this.BindingType.HasFromToArray;
                  this.resolvedProperty = nodeProperty;
                } else if (Array.isArray(nodeProperty)) {
                  bindingType = this.BindingType.EntireArray;
                  this.resolvedProperty = nodeProperty;
                } else {
                  this.propertyName = propertyName;
                } // select getter / setter
                this.getValue = this.GetterByBindingType[bindingType];
                this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
              }
            }, {
              key: "unbind",
              value: function unbind() {
                this.node = null; // back to the prototype version of getValue / setValue
                // note: avoiding to mutate the shape of 'this' via 'delete'
                this.getValue = this._getValue_unbound;
                this.setValue = this._setValue_unbound;
              }
            }], [{
              key: "create",
              value: function create(root, path, parsedPath) {
                if (!(root && root.isAnimationObjectGroup)) {
                  return new _PropertyBinding(root, path, parsedPath);
                } else {
                  return new _PropertyBinding.Composite(root, path, parsedPath);
                }
              } /**
                * Replaces spaces with underscores and removes unsupported characters from
                * node names, to ensure compatibility with parseTrackName().
                *
                * @param {string} name Node name to be sanitized.
                * @return {string}
                */
            }, {
              key: "sanitizeNodeName",
              value: function sanitizeNodeName(name) {
                return name.replace(/\s/g, '_').replace(_reservedRe, '');
              }
            }, {
              key: "parseTrackName",
              value: function parseTrackName(trackName) {
                var matches = _trackRe.exec(trackName);
                if (matches === null) {
                  throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
                }
                var results = {
                  // directoryName: matches[ 1 ], // (tschw) currently unused
                  nodeName: matches[2],
                  objectName: matches[3],
                  objectIndex: matches[4],
                  propertyName: matches[5],
                  // required
                  propertyIndex: matches[6]
                };
                var lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
                if (lastDot !== undefined && lastDot !== -1) {
                  var objectName = results.nodeName.substring(lastDot + 1); // Object names must be checked against an allowlist. Otherwise, there
                  // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
                  // 'bar' could be the objectName, or part of a nodeName (which can
                  // include '.' characters).
                  if (_supportedObjectNames.indexOf(objectName) !== -1) {
                    results.nodeName = results.nodeName.substring(0, lastDot);
                    results.objectName = objectName;
                  }
                }
                if (results.propertyName === null || results.propertyName.length === 0) {
                  throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
                }
                return results;
              }
            }, {
              key: "findNode",
              value: function findNode(root, nodeName) {
                if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {
                  return root;
                } // search into skeleton bones.
                if (root.skeleton) {
                  var bone = root.skeleton.getBoneByName(nodeName);
                  if (bone !== undefined) {
                    return bone;
                  }
                } // search into node subtree.
                if (root.children) {
                  var searchNodeSubtree = function searchNodeSubtree(children) {
                    for (var i = 0; i < children.length; i++) {
                      var childNode = children[i];
                      if (childNode.name === nodeName || childNode.uuid === nodeName) {
                        return childNode;
                      }
                      var result = searchNodeSubtree(childNode.children);
                      if (result) return result;
                    }
                    return null;
                  };
                  var subTreeNode = searchNodeSubtree(root.children);
                  if (subTreeNode) {
                    return subTreeNode;
                  }
                }
                return null;
              }
            }]);
            return _PropertyBinding;
          }();
          _PropertyBinding.Composite = Composite;
          _PropertyBinding.prototype.BindingType = {
            Direct: 0,
            EntireArray: 1,
            ArrayElement: 2,
            HasFromToArray: 3
          };
          _PropertyBinding.prototype.Versioning = {
            None: 0,
            NeedsUpdate: 1,
            MatrixWorldNeedsUpdate: 2
          };
          _PropertyBinding.prototype.GetterByBindingType = [_PropertyBinding.prototype._getValue_direct, _PropertyBinding.prototype._getValue_array, _PropertyBinding.prototype._getValue_arrayElement, _PropertyBinding.prototype._getValue_toArray];
          _PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [[
          // Direct
          _PropertyBinding.prototype._setValue_direct, _PropertyBinding.prototype._setValue_direct_setNeedsUpdate, _PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [
          // EntireArray
          _PropertyBinding.prototype._setValue_array, _PropertyBinding.prototype._setValue_array_setNeedsUpdate, _PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate], [
          // ArrayElement
          _PropertyBinding.prototype._setValue_arrayElement, _PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate, _PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [
          // HasToFromArray
          _PropertyBinding.prototype._setValue_fromArray, _PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate, _PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]]; /**
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * A group of objects that receives a shared animation state.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * Usage:
                                                                                                                                                                                                     *
                                                                                                                                                                                                     *  - Add objects you would otherwise pass as 'root' to the
                                                                                                                                                                                                     *    constructor or the .clipAction method of AnimationMixer.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     *  - Instead pass this object as 'root'.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     *  - You can also add and remove objects later when the mixer
                                                                                                                                                                                                     *    is running.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * Note:
                                                                                                                                                                                                     *
                                                                                                                                                                                                     *    Objects of this class appear as one object to the mixer,
                                                                                                                                                                                                     *    so cache control of the individual objects must be done
                                                                                                                                                                                                     *    on the group.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * Limitation:
                                                                                                                                                                                                     *
                                                                                                                                                                                                     *  - The animated properties must be compatible among the
                                                                                                                                                                                                     *    all objects in the group.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     *  - A single property can either be controlled through a
                                                                                                                                                                                                     *    target group or directly, but not both.
                                                                                                                                                                                                     */
          var _AnimationObjectGroup = /*#__PURE__*/function () {
            function _AnimationObjectGroup() {
              _classCallCheck2(this, _AnimationObjectGroup);
              this.isAnimationObjectGroup = true;
              this.uuid = generateUUID(); // cached objects followed by the active ones
              this._objects = Array.prototype.slice.call(arguments);
              this.nCachedObjects_ = 0; // threshold
              // note: read by PropertyBinding.Composite
              var indices = {};
              this._indicesByUUID = indices; // for bookkeeping
              for (var i = 0, n = arguments.length; i !== n; ++i) {
                indices[arguments[i].uuid] = i;
              }
              this._paths = []; // inside: string
              this._parsedPaths = []; // inside: { we don't care, here }
              this._bindings = []; // inside: Array< PropertyBinding >
              this._bindingsIndicesByPath = {}; // inside: indices in these arrays
              var scope = this;
              this.stats = {
                objects: {
                  get total() {
                    return scope._objects.length;
                  },
                  get inUse() {
                    return this.total - scope.nCachedObjects_;
                  }
                },
                get bindingsPerObject() {
                  return scope._bindings.length;
                }
              };
            }
            _createClass2(_AnimationObjectGroup, [{
              key: "add",
              value: function add() {
                var objects = this._objects,
                  indicesByUUID = this._indicesByUUID,
                  paths = this._paths,
                  parsedPaths = this._parsedPaths,
                  bindings = this._bindings,
                  nBindings = bindings.length;
                var knownObject = undefined,
                  nObjects = objects.length,
                  nCachedObjects = this.nCachedObjects_;
                for (var i = 0, n = arguments.length; i !== n; ++i) {
                  var object = arguments[i],
                    uuid = object.uuid;
                  var index = indicesByUUID[uuid];
                  if (index === undefined) {
                    // unknown object -> add it to the ACTIVE region
                    index = nObjects++;
                    indicesByUUID[uuid] = index;
                    objects.push(object); // accounting is done, now do the same for all bindings
                    for (var j = 0, m = nBindings; j !== m; ++j) {
                      bindings[j].push(new _PropertyBinding(object, paths[j], parsedPaths[j]));
                    }
                  } else if (index < nCachedObjects) {
                    knownObject = objects[index]; // move existing object to the ACTIVE region
                    var firstActiveIndex = --nCachedObjects,
                      lastCachedObject = objects[firstActiveIndex];
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    indicesByUUID[uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = object; // accounting is done, now do the same for all bindings
                    for (var _j16 = 0, _m2 = nBindings; _j16 !== _m2; ++_j16) {
                      var bindingsForPath = bindings[_j16],
                        lastCached = bindingsForPath[firstActiveIndex];
                      var binding = bindingsForPath[index];
                      bindingsForPath[index] = lastCached;
                      if (binding === undefined) {
                        // since we do not bother to create new bindings
                        // for objects that are cached, the binding may
                        // or may not exist
                        binding = new _PropertyBinding(object, paths[_j16], parsedPaths[_j16]);
                      }
                      bindingsForPath[firstActiveIndex] = binding;
                    }
                  } else if (objects[index] !== knownObject) {
                    console.error('THREE.AnimationObjectGroup: Different objects with the same UUID ' + 'detected. Clean the caches or recreate your infrastructure when reloading scenes.');
                  } // else the object is already where we want it to be
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
              }
            }, {
              key: "remove",
              value: function remove() {
                var objects = this._objects,
                  indicesByUUID = this._indicesByUUID,
                  bindings = this._bindings,
                  nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_;
                for (var i = 0, n = arguments.length; i !== n; ++i) {
                  var object = arguments[i],
                    uuid = object.uuid,
                    index = indicesByUUID[uuid];
                  if (index !== undefined && index >= nCachedObjects) {
                    // move existing object into the CACHED region
                    var lastCachedIndex = nCachedObjects++,
                      firstActiveObject = objects[lastCachedIndex];
                    indicesByUUID[firstActiveObject.uuid] = index;
                    objects[index] = firstActiveObject;
                    indicesByUUID[uuid] = lastCachedIndex;
                    objects[lastCachedIndex] = object; // accounting is done, now do the same for all bindings
                    for (var j = 0, m = nBindings; j !== m; ++j) {
                      var bindingsForPath = bindings[j],
                        firstActive = bindingsForPath[lastCachedIndex],
                        binding = bindingsForPath[index];
                      bindingsForPath[index] = firstActive;
                      bindingsForPath[lastCachedIndex] = binding;
                    }
                  }
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
              } // remove & forget
            }, {
              key: "uncache",
              value: function uncache() {
                var objects = this._objects,
                  indicesByUUID = this._indicesByUUID,
                  bindings = this._bindings,
                  nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_,
                  nObjects = objects.length;
                for (var i = 0, n = arguments.length; i !== n; ++i) {
                  var object = arguments[i],
                    uuid = object.uuid,
                    index = indicesByUUID[uuid];
                  if (index !== undefined) {
                    delete indicesByUUID[uuid];
                    if (index < nCachedObjects) {
                      // object is cached, shrink the CACHED region
                      var firstActiveIndex = --nCachedObjects,
                        lastCachedObject = objects[firstActiveIndex],
                        lastIndex = --nObjects,
                        lastObject = objects[lastIndex]; // last cached object takes this object's place
                      indicesByUUID[lastCachedObject.uuid] = index;
                      objects[index] = lastCachedObject; // last object goes to the activated slot and pop
                      indicesByUUID[lastObject.uuid] = firstActiveIndex;
                      objects[firstActiveIndex] = lastObject;
                      objects.pop(); // accounting is done, now do the same for all bindings
                      for (var j = 0, m = nBindings; j !== m; ++j) {
                        var bindingsForPath = bindings[j],
                          lastCached = bindingsForPath[firstActiveIndex],
                          last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                      }
                    } else {
                      // object is active, just swap with the last and pop
                      var _lastIndex = --nObjects,
                        _lastObject = objects[_lastIndex];
                      if (_lastIndex > 0) {
                        indicesByUUID[_lastObject.uuid] = index;
                      }
                      objects[index] = _lastObject;
                      objects.pop(); // accounting is done, now do the same for all bindings
                      for (var _j17 = 0, _m4 = nBindings; _j17 !== _m4; ++_j17) {
                        var _bindingsForPath = bindings[_j17];
                        _bindingsForPath[index] = _bindingsForPath[_lastIndex];
                        _bindingsForPath.pop();
                      }
                    } // cached or active
                  } // if object is known
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
              } // Internal interface used by befriended PropertyBinding.Composite:
            }, {
              key: "subscribe_",
              value: function subscribe_(path, parsedPath) {
                // returns an array of bindings for the given path that is changed
                // according to the contained objects in the group
                var indicesByPath = this._bindingsIndicesByPath;
                var index = indicesByPath[path];
                var bindings = this._bindings;
                if (index !== undefined) return bindings[index];
                var paths = this._paths,
                  parsedPaths = this._parsedPaths,
                  objects = this._objects,
                  nObjects = objects.length,
                  nCachedObjects = this.nCachedObjects_,
                  bindingsForPath = new Array(nObjects);
                index = bindings.length;
                indicesByPath[path] = index;
                paths.push(path);
                parsedPaths.push(parsedPath);
                bindings.push(bindingsForPath);
                for (var i = nCachedObjects, n = objects.length; i !== n; ++i) {
                  var object = objects[i];
                  bindingsForPath[i] = new _PropertyBinding(object, path, parsedPath);
                }
                return bindingsForPath;
              }
            }, {
              key: "unsubscribe_",
              value: function unsubscribe_(path) {
                // tells the group to forget about a property path and no longer
                // update the array previously obtained with 'subscribe_'
                var indicesByPath = this._bindingsIndicesByPath,
                  index = indicesByPath[path];
                if (index !== undefined) {
                  var paths = this._paths,
                    parsedPaths = this._parsedPaths,
                    bindings = this._bindings,
                    lastBindingsIndex = bindings.length - 1,
                    lastBindings = bindings[lastBindingsIndex],
                    lastBindingsPath = path[lastBindingsIndex];
                  indicesByPath[lastBindingsPath] = index;
                  bindings[index] = lastBindings;
                  bindings.pop();
                  parsedPaths[index] = parsedPaths[lastBindingsIndex];
                  parsedPaths.pop();
                  paths[index] = paths[lastBindingsIndex];
                  paths.pop();
                }
              }
            }]);
            return _AnimationObjectGroup;
          }();
          var AnimationAction = /*#__PURE__*/function () {
            function AnimationAction(mixer, clip) {
              var localRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var blendMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : clip.blendMode;
              _classCallCheck2(this, AnimationAction);
              this._mixer = mixer;
              this._clip = clip;
              this._localRoot = localRoot;
              this.blendMode = blendMode;
              var tracks = clip.tracks,
                nTracks = tracks.length,
                interpolants = new Array(nTracks);
              var interpolantSettings = {
                endingStart: _ZeroCurvatureEnding,
                endingEnd: _ZeroCurvatureEnding
              };
              for (var i = 0; i !== nTracks; ++i) {
                var interpolant = tracks[i].createInterpolant(null);
                interpolants[i] = interpolant;
                interpolant.settings = interpolantSettings;
              }
              this._interpolantSettings = interpolantSettings;
              this._interpolants = interpolants; // bound by the mixer
              // inside: PropertyMixer (managed by the mixer)
              this._propertyBindings = new Array(nTracks);
              this._cacheIndex = null; // for the memory manager
              this._byClipCacheIndex = null; // for the memory manager
              this._timeScaleInterpolant = null;
              this._weightInterpolant = null;
              this.loop = _LoopRepeat;
              this._loopCount = -1; // global mixer time when the action is to be started
              // it's set back to 'null' upon start of the action
              this._startTime = null; // scaled local time of the action
              // gets clamped or wrapped to 0..clip.duration according to loop
              this.time = 0;
              this.timeScale = 1;
              this._effectiveTimeScale = 1;
              this.weight = 1;
              this._effectiveWeight = 1;
              this.repetitions = Infinity; // no. of repetitions when looping
              this.paused = false; // true -> zero effective time scale
              this.enabled = true; // false -> zero effective weight
              this.clampWhenFinished = false; // keep feeding the last frame?
              this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
              this.zeroSlopeAtEnd = true; // clips for start, loop and end
            } // State & Scheduling
            _createClass2(AnimationAction, [{
              key: "play",
              value: function play() {
                this._mixer._activateAction(this);
                return this;
              }
            }, {
              key: "stop",
              value: function stop() {
                this._mixer._deactivateAction(this);
                return this.reset();
              }
            }, {
              key: "reset",
              value: function reset() {
                this.paused = false;
                this.enabled = true;
                this.time = 0; // restart clip
                this._loopCount = -1; // forget previous loops
                this._startTime = null; // forget scheduling
                return this.stopFading().stopWarping();
              }
            }, {
              key: "isRunning",
              value: function isRunning() {
                return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
              } // return true when play has been called
            }, {
              key: "isScheduled",
              value: function isScheduled() {
                return this._mixer._isActiveAction(this);
              }
            }, {
              key: "startAt",
              value: function startAt(time) {
                this._startTime = time;
                return this;
              }
            }, {
              key: "setLoop",
              value: function setLoop(mode, repetitions) {
                this.loop = mode;
                this.repetitions = repetitions;
                return this;
              } // Weight
              // set the weight stopping any scheduled fading
              // although .enabled = false yields an effective weight of zero, this
              // method does *not* change .enabled, because it would be confusing
            }, {
              key: "setEffectiveWeight",
              value: function setEffectiveWeight(weight) {
                this.weight = weight; // note: same logic as when updated at runtime
                this._effectiveWeight = this.enabled ? weight : 0;
                return this.stopFading();
              } // return the weight considering fading and .enabled
            }, {
              key: "getEffectiveWeight",
              value: function getEffectiveWeight() {
                return this._effectiveWeight;
              }
            }, {
              key: "fadeIn",
              value: function fadeIn(duration) {
                return this._scheduleFading(duration, 0, 1);
              }
            }, {
              key: "fadeOut",
              value: function fadeOut(duration) {
                return this._scheduleFading(duration, 1, 0);
              }
            }, {
              key: "crossFadeFrom",
              value: function crossFadeFrom(fadeOutAction, duration, warp) {
                fadeOutAction.fadeOut(duration);
                this.fadeIn(duration);
                if (warp) {
                  var fadeInDuration = this._clip.duration,
                    fadeOutDuration = fadeOutAction._clip.duration,
                    startEndRatio = fadeOutDuration / fadeInDuration,
                    endStartRatio = fadeInDuration / fadeOutDuration;
                  fadeOutAction.warp(1.0, startEndRatio, duration);
                  this.warp(endStartRatio, 1.0, duration);
                }
                return this;
              }
            }, {
              key: "crossFadeTo",
              value: function crossFadeTo(fadeInAction, duration, warp) {
                return fadeInAction.crossFadeFrom(this, duration, warp);
              }
            }, {
              key: "stopFading",
              value: function stopFading() {
                var weightInterpolant = this._weightInterpolant;
                if (weightInterpolant !== null) {
                  this._weightInterpolant = null;
                  this._mixer._takeBackControlInterpolant(weightInterpolant);
                }
                return this;
              } // Time Scale Control
              // set the time scale stopping any scheduled warping
              // although .paused = true yields an effective time scale of zero, this
              // method does *not* change .paused, because it would be confusing
            }, {
              key: "setEffectiveTimeScale",
              value: function setEffectiveTimeScale(timeScale) {
                this.timeScale = timeScale;
                this._effectiveTimeScale = this.paused ? 0 : timeScale;
                return this.stopWarping();
              } // return the time scale considering warping and .paused
            }, {
              key: "getEffectiveTimeScale",
              value: function getEffectiveTimeScale() {
                return this._effectiveTimeScale;
              }
            }, {
              key: "setDuration",
              value: function setDuration(duration) {
                this.timeScale = this._clip.duration / duration;
                return this.stopWarping();
              }
            }, {
              key: "syncWith",
              value: function syncWith(action) {
                this.time = action.time;
                this.timeScale = action.timeScale;
                return this.stopWarping();
              }
            }, {
              key: "halt",
              value: function halt(duration) {
                return this.warp(this._effectiveTimeScale, 0, duration);
              }
            }, {
              key: "warp",
              value: function warp(startTimeScale, endTimeScale, duration) {
                var mixer = this._mixer,
                  now = mixer.time,
                  timeScale = this.timeScale;
                var interpolant = this._timeScaleInterpolant;
                if (interpolant === null) {
                  interpolant = mixer._lendControlInterpolant();
                  this._timeScaleInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions,
                  values = interpolant.sampleValues;
                times[0] = now;
                times[1] = now + duration;
                values[0] = startTimeScale / timeScale;
                values[1] = endTimeScale / timeScale;
                return this;
              }
            }, {
              key: "stopWarping",
              value: function stopWarping() {
                var timeScaleInterpolant = this._timeScaleInterpolant;
                if (timeScaleInterpolant !== null) {
                  this._timeScaleInterpolant = null;
                  this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
                }
                return this;
              } // Object Accessors
            }, {
              key: "getMixer",
              value: function getMixer() {
                return this._mixer;
              }
            }, {
              key: "getClip",
              value: function getClip() {
                return this._clip;
              }
            }, {
              key: "getRoot",
              value: function getRoot() {
                return this._localRoot || this._mixer._root;
              } // Interna
            }, {
              key: "_update",
              value: function _update(time, deltaTime, timeDirection, accuIndex) {
                // called by the mixer
                if (!this.enabled) {
                  // call ._updateWeight() to update ._effectiveWeight
                  this._updateWeight(time);
                  return;
                }
                var startTime = this._startTime;
                if (startTime !== null) {
                  // check for scheduled start of action
                  var timeRunning = (time - startTime) * timeDirection;
                  if (timeRunning < 0 || timeDirection === 0) {
                    deltaTime = 0;
                  } else {
                    this._startTime = null; // unschedule
                    deltaTime = timeDirection * timeRunning;
                  }
                } // apply time scale and advance time
                deltaTime *= this._updateTimeScale(time);
                var clipTime = this._updateTime(deltaTime); // note: _updateTime may disable the action resulting in
                // an effective weight of 0
                var weight = this._updateWeight(time);
                if (weight > 0) {
                  var interpolants = this._interpolants;
                  var propertyMixers = this._propertyBindings;
                  switch (this.blendMode) {
                    case _AdditiveAnimationBlendMode:
                      for (var j = 0, m = interpolants.length; j !== m; ++j) {
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                      }
                      break;
                    case _NormalAnimationBlendMode:
                    default:
                      for (var _j18 = 0, _m5 = interpolants.length; _j18 !== _m5; ++_j18) {
                        interpolants[_j18].evaluate(clipTime);
                        propertyMixers[_j18].accumulate(accuIndex, weight);
                      }
                  }
                }
              }
            }, {
              key: "_updateWeight",
              value: function _updateWeight(time) {
                var weight = 0;
                if (this.enabled) {
                  weight = this.weight;
                  var interpolant = this._weightInterpolant;
                  if (interpolant !== null) {
                    var interpolantValue = interpolant.evaluate(time)[0];
                    weight *= interpolantValue;
                    if (time > interpolant.parameterPositions[1]) {
                      this.stopFading();
                      if (interpolantValue === 0) {
                        // faded out, disable
                        this.enabled = false;
                      }
                    }
                  }
                }
                this._effectiveWeight = weight;
                return weight;
              }
            }, {
              key: "_updateTimeScale",
              value: function _updateTimeScale(time) {
                var timeScale = 0;
                if (!this.paused) {
                  timeScale = this.timeScale;
                  var interpolant = this._timeScaleInterpolant;
                  if (interpolant !== null) {
                    var interpolantValue = interpolant.evaluate(time)[0];
                    timeScale *= interpolantValue;
                    if (time > interpolant.parameterPositions[1]) {
                      this.stopWarping();
                      if (timeScale === 0) {
                        // motion has halted, pause
                        this.paused = true;
                      } else {
                        // warp done - apply final time scale
                        this.timeScale = timeScale;
                      }
                    }
                  }
                }
                this._effectiveTimeScale = timeScale;
                return timeScale;
              }
            }, {
              key: "_updateTime",
              value: function _updateTime(deltaTime) {
                var duration = this._clip.duration;
                var loop = this.loop;
                var time = this.time + deltaTime;
                var loopCount = this._loopCount;
                var pingPong = loop === _LoopPingPong;
                if (deltaTime === 0) {
                  if (loopCount === -1) return time;
                  return pingPong && (loopCount & 1) === 1 ? duration - time : time;
                }
                if (loop === _LoopOnce) {
                  if (loopCount === -1) {
                    // just started
                    this._loopCount = 0;
                    this._setEndings(true, true, false);
                  }
                  handle_stop: {
                    if (time >= duration) {
                      time = duration;
                    } else if (time < 0) {
                      time = 0;
                    } else {
                      this.time = time;
                      break handle_stop;
                    }
                    if (this.clampWhenFinished) this.paused = true;else this.enabled = false;
                    this.time = time;
                    this._mixer.dispatchEvent({
                      type: 'finished',
                      action: this,
                      direction: deltaTime < 0 ? -1 : 1
                    });
                  }
                } else {
                  // repetitive Repeat or PingPong
                  if (loopCount === -1) {
                    // just started
                    if (deltaTime >= 0) {
                      loopCount = 0;
                      this._setEndings(true, this.repetitions === 0, pingPong);
                    } else {
                      // when looping in reverse direction, the initial
                      // transition through zero counts as a repetition,
                      // so leave loopCount at -1
                      this._setEndings(this.repetitions === 0, true, pingPong);
                    }
                  }
                  if (time >= duration || time < 0) {
                    // wrap around
                    var loopDelta = Math.floor(time / duration); // signed
                    time -= duration * loopDelta;
                    loopCount += Math.abs(loopDelta);
                    var pending = this.repetitions - loopCount;
                    if (pending <= 0) {
                      // have to stop (switch state, clamp time, fire event)
                      if (this.clampWhenFinished) this.paused = true;else this.enabled = false;
                      time = deltaTime > 0 ? duration : 0;
                      this.time = time;
                      this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                      });
                    } else {
                      // keep running
                      if (pending === 1) {
                        // entering the last round
                        var atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                      } else {
                        this._setEndings(false, false, pingPong);
                      }
                      this._loopCount = loopCount;
                      this.time = time;
                      this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                      });
                    }
                  } else {
                    this.time = time;
                  }
                  if (pingPong && (loopCount & 1) === 1) {
                    // invert time for the "pong round"
                    return duration - time;
                  }
                }
                return time;
              }
            }, {
              key: "_setEndings",
              value: function _setEndings(atStart, atEnd, pingPong) {
                var settings = this._interpolantSettings;
                if (pingPong) {
                  settings.endingStart = _ZeroSlopeEnding;
                  settings.endingEnd = _ZeroSlopeEnding;
                } else {
                  // assuming for LoopOnce atStart == atEnd == true
                  if (atStart) {
                    settings.endingStart = this.zeroSlopeAtStart ? _ZeroSlopeEnding : _ZeroCurvatureEnding;
                  } else {
                    settings.endingStart = _WrapAroundEnding;
                  }
                  if (atEnd) {
                    settings.endingEnd = this.zeroSlopeAtEnd ? _ZeroSlopeEnding : _ZeroCurvatureEnding;
                  } else {
                    settings.endingEnd = _WrapAroundEnding;
                  }
                }
              }
            }, {
              key: "_scheduleFading",
              value: function _scheduleFading(duration, weightNow, weightThen) {
                var mixer = this._mixer,
                  now = mixer.time;
                var interpolant = this._weightInterpolant;
                if (interpolant === null) {
                  interpolant = mixer._lendControlInterpolant();
                  this._weightInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions,
                  values = interpolant.sampleValues;
                times[0] = now;
                values[0] = weightNow;
                times[1] = now + duration;
                values[1] = weightThen;
                return this;
              }
            }]);
            return AnimationAction;
          }();
          var _controlInterpolantsResultBuffer = new Float32Array(1);
          var _AnimationMixer = /*#__PURE__*/function (_EventDispatcher8) {
            _inherits(_AnimationMixer, _EventDispatcher8);
            var _super151 = _createSuper(_AnimationMixer);
            function _AnimationMixer(root) {
              var _this124;
              _classCallCheck2(this, _AnimationMixer);
              _this124 = _super151.call(this);
              _this124._root = root;
              _this124._initMemoryManager();
              _this124._accuIndex = 0;
              _this124.time = 0;
              _this124.timeScale = 1.0;
              return _this124;
            }
            _createClass2(_AnimationMixer, [{
              key: "_bindAction",
              value: function _bindAction(action, prototypeAction) {
                var root = action._localRoot || this._root,
                  tracks = action._clip.tracks,
                  nTracks = tracks.length,
                  bindings = action._propertyBindings,
                  interpolants = action._interpolants,
                  rootUuid = root.uuid,
                  bindingsByRoot = this._bindingsByRootAndName;
                var bindingsByName = bindingsByRoot[rootUuid];
                if (bindingsByName === undefined) {
                  bindingsByName = {};
                  bindingsByRoot[rootUuid] = bindingsByName;
                }
                for (var i = 0; i !== nTracks; ++i) {
                  var track = tracks[i],
                    trackName = track.name;
                  var binding = bindingsByName[trackName];
                  if (binding !== undefined) {
                    ++binding.referenceCount;
                    bindings[i] = binding;
                  } else {
                    binding = bindings[i];
                    if (binding !== undefined) {
                      // existing binding, make sure the cache knows
                      if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                      }
                      continue;
                    }
                    var path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                    binding = new _PropertyMixer(_PropertyBinding.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                    ++binding.referenceCount;
                    this._addInactiveBinding(binding, rootUuid, trackName);
                    bindings[i] = binding;
                  }
                  interpolants[i].resultBuffer = binding.buffer;
                }
              }
            }, {
              key: "_activateAction",
              value: function _activateAction(action) {
                if (!this._isActiveAction(action)) {
                  if (action._cacheIndex === null) {
                    // this action has been forgotten by the cache, but the user
                    // appears to be still using it -> rebind
                    var rootUuid = (action._localRoot || this._root).uuid,
                      clipUuid = action._clip.uuid,
                      actionsForClip = this._actionsByClip[clipUuid];
                    this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                    this._addInactiveAction(action, clipUuid, rootUuid);
                  }
                  var bindings = action._propertyBindings; // increment reference counts / sort out state
                  for (var i = 0, n = bindings.length; i !== n; ++i) {
                    var binding = bindings[i];
                    if (binding.useCount++ === 0) {
                      this._lendBinding(binding);
                      binding.saveOriginalState();
                    }
                  }
                  this._lendAction(action);
                }
              }
            }, {
              key: "_deactivateAction",
              value: function _deactivateAction(action) {
                if (this._isActiveAction(action)) {
                  var bindings = action._propertyBindings; // decrement reference counts / sort out state
                  for (var i = 0, n = bindings.length; i !== n; ++i) {
                    var binding = bindings[i];
                    if (--binding.useCount === 0) {
                      binding.restoreOriginalState();
                      this._takeBackBinding(binding);
                    }
                  }
                  this._takeBackAction(action);
                }
              } // Memory manager
            }, {
              key: "_initMemoryManager",
              value: function _initMemoryManager() {
                this._actions = []; // 'nActiveActions' followed by inactive ones
                this._nActiveActions = 0;
                this._actionsByClip = {}; // inside:
                // {
                // 	knownActions: Array< AnimationAction > - used as prototypes
                // 	actionByRoot: AnimationAction - lookup
                // }
                this._bindings = []; // 'nActiveBindings' followed by inactive ones
                this._nActiveBindings = 0;
                this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
                this._controlInterpolants = []; // same game as above
                this._nActiveControlInterpolants = 0;
                var scope = this;
                this.stats = {
                  actions: {
                    get total() {
                      return scope._actions.length;
                    },
                    get inUse() {
                      return scope._nActiveActions;
                    }
                  },
                  bindings: {
                    get total() {
                      return scope._bindings.length;
                    },
                    get inUse() {
                      return scope._nActiveBindings;
                    }
                  },
                  controlInterpolants: {
                    get total() {
                      return scope._controlInterpolants.length;
                    },
                    get inUse() {
                      return scope._nActiveControlInterpolants;
                    }
                  }
                };
              } // Memory management for AnimationAction objects
            }, {
              key: "_isActiveAction",
              value: function _isActiveAction(action) {
                var index = action._cacheIndex;
                return index !== null && index < this._nActiveActions;
              }
            }, {
              key: "_addInactiveAction",
              value: function _addInactiveAction(action, clipUuid, rootUuid) {
                var actions = this._actions,
                  actionsByClip = this._actionsByClip;
                var actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip === undefined) {
                  actionsForClip = {
                    knownActions: [action],
                    actionByRoot: {}
                  };
                  action._byClipCacheIndex = 0;
                  actionsByClip[clipUuid] = actionsForClip;
                } else {
                  var knownActions = actionsForClip.knownActions;
                  action._byClipCacheIndex = knownActions.length;
                  knownActions.push(action);
                }
                action._cacheIndex = actions.length;
                actions.push(action);
                actionsForClip.actionByRoot[rootUuid] = action;
              }
            }, {
              key: "_removeInactiveAction",
              value: function _removeInactiveAction(action) {
                var actions = this._actions,
                  lastInactiveAction = actions[actions.length - 1],
                  cacheIndex = action._cacheIndex;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                action._cacheIndex = null;
                var clipUuid = action._clip.uuid,
                  actionsByClip = this._actionsByClip,
                  actionsForClip = actionsByClip[clipUuid],
                  knownActionsForClip = actionsForClip.knownActions,
                  lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1],
                  byClipCacheIndex = action._byClipCacheIndex;
                lastKnownAction._byClipCacheIndex = byClipCacheIndex;
                knownActionsForClip[byClipCacheIndex] = lastKnownAction;
                knownActionsForClip.pop();
                action._byClipCacheIndex = null;
                var actionByRoot = actionsForClip.actionByRoot,
                  rootUuid = (action._localRoot || this._root).uuid;
                delete actionByRoot[rootUuid];
                if (knownActionsForClip.length === 0) {
                  delete actionsByClip[clipUuid];
                }
                this._removeInactiveBindingsForAction(action);
              }
            }, {
              key: "_removeInactiveBindingsForAction",
              value: function _removeInactiveBindingsForAction(action) {
                var bindings = action._propertyBindings;
                for (var i = 0, n = bindings.length; i !== n; ++i) {
                  var binding = bindings[i];
                  if (--binding.referenceCount === 0) {
                    this._removeInactiveBinding(binding);
                  }
                }
              }
            }, {
              key: "_lendAction",
              value: function _lendAction(action) {
                // [ active actions |  inactive actions  ]
                // [  active actions >| inactive actions ]
                //                 s        a
                //                  <-swap->
                //                 a        s
                var actions = this._actions,
                  prevIndex = action._cacheIndex,
                  lastActiveIndex = this._nActiveActions++,
                  firstInactiveAction = actions[lastActiveIndex];
                action._cacheIndex = lastActiveIndex;
                actions[lastActiveIndex] = action;
                firstInactiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = firstInactiveAction;
              }
            }, {
              key: "_takeBackAction",
              value: function _takeBackAction(action) {
                // [  active actions  | inactive actions ]
                // [ active actions |< inactive actions  ]
                //        a        s
                //         <-swap->
                //        s        a
                var actions = this._actions,
                  prevIndex = action._cacheIndex,
                  firstInactiveIndex = --this._nActiveActions,
                  lastActiveAction = actions[firstInactiveIndex];
                action._cacheIndex = firstInactiveIndex;
                actions[firstInactiveIndex] = action;
                lastActiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = lastActiveAction;
              } // Memory management for PropertyMixer objects
            }, {
              key: "_addInactiveBinding",
              value: function _addInactiveBinding(binding, rootUuid, trackName) {
                var bindingsByRoot = this._bindingsByRootAndName,
                  bindings = this._bindings;
                var bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName === undefined) {
                  bindingByName = {};
                  bindingsByRoot[rootUuid] = bindingByName;
                }
                bindingByName[trackName] = binding;
                binding._cacheIndex = bindings.length;
                bindings.push(binding);
              }
            }, {
              key: "_removeInactiveBinding",
              value: function _removeInactiveBinding(binding) {
                var bindings = this._bindings,
                  propBinding = binding.binding,
                  rootUuid = propBinding.rootNode.uuid,
                  trackName = propBinding.path,
                  bindingsByRoot = this._bindingsByRootAndName,
                  bindingByName = bindingsByRoot[rootUuid],
                  lastInactiveBinding = bindings[bindings.length - 1],
                  cacheIndex = binding._cacheIndex;
                lastInactiveBinding._cacheIndex = cacheIndex;
                bindings[cacheIndex] = lastInactiveBinding;
                bindings.pop();
                delete bindingByName[trackName];
                if (Object.keys(bindingByName).length === 0) {
                  delete bindingsByRoot[rootUuid];
                }
              }
            }, {
              key: "_lendBinding",
              value: function _lendBinding(binding) {
                var bindings = this._bindings,
                  prevIndex = binding._cacheIndex,
                  lastActiveIndex = this._nActiveBindings++,
                  firstInactiveBinding = bindings[lastActiveIndex];
                binding._cacheIndex = lastActiveIndex;
                bindings[lastActiveIndex] = binding;
                firstInactiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = firstInactiveBinding;
              }
            }, {
              key: "_takeBackBinding",
              value: function _takeBackBinding(binding) {
                var bindings = this._bindings,
                  prevIndex = binding._cacheIndex,
                  firstInactiveIndex = --this._nActiveBindings,
                  lastActiveBinding = bindings[firstInactiveIndex];
                binding._cacheIndex = firstInactiveIndex;
                bindings[firstInactiveIndex] = binding;
                lastActiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = lastActiveBinding;
              } // Memory management of Interpolants for weight and time scale
            }, {
              key: "_lendControlInterpolant",
              value: function _lendControlInterpolant() {
                var interpolants = this._controlInterpolants,
                  lastActiveIndex = this._nActiveControlInterpolants++;
                var interpolant = interpolants[lastActiveIndex];
                if (interpolant === undefined) {
                  interpolant = new _LinearInterpolant(new Float32Array(2), new Float32Array(2), 1, _controlInterpolantsResultBuffer);
                  interpolant.__cacheIndex = lastActiveIndex;
                  interpolants[lastActiveIndex] = interpolant;
                }
                return interpolant;
              }
            }, {
              key: "_takeBackControlInterpolant",
              value: function _takeBackControlInterpolant(interpolant) {
                var interpolants = this._controlInterpolants,
                  prevIndex = interpolant.__cacheIndex,
                  firstInactiveIndex = --this._nActiveControlInterpolants,
                  lastActiveInterpolant = interpolants[firstInactiveIndex];
                interpolant.__cacheIndex = firstInactiveIndex;
                interpolants[firstInactiveIndex] = interpolant;
                lastActiveInterpolant.__cacheIndex = prevIndex;
                interpolants[prevIndex] = lastActiveInterpolant;
              } // return an action for a clip optionally using a custom root target
              // object (this method allocates a lot of dynamic memory in case a
              // previously unknown clip/root combination is specified)
            }, {
              key: "clipAction",
              value: function clipAction(clip, optionalRoot, blendMode) {
                var root = optionalRoot || this._root,
                  rootUuid = root.uuid;
                var clipObject = typeof clip === 'string' ? _AnimationClip.findByName(root, clip) : clip;
                var clipUuid = clipObject !== null ? clipObject.uuid : clip;
                var actionsForClip = this._actionsByClip[clipUuid];
                var prototypeAction = null;
                if (blendMode === undefined) {
                  if (clipObject !== null) {
                    blendMode = clipObject.blendMode;
                  } else {
                    blendMode = _NormalAnimationBlendMode;
                  }
                }
                if (actionsForClip !== undefined) {
                  var existingAction = actionsForClip.actionByRoot[rootUuid];
                  if (existingAction !== undefined && existingAction.blendMode === blendMode) {
                    return existingAction;
                  } // we know the clip, so we don't have to parse all
                  // the bindings again but can just copy
                  prototypeAction = actionsForClip.knownActions[0]; // also, take the clip from the prototype action
                  if (clipObject === null) clipObject = prototypeAction._clip;
                } // clip must be known when specified via string
                if (clipObject === null) return null; // allocate all resources required to run it
                var newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
                this._bindAction(newAction, prototypeAction); // and make the action known to the memory manager
                this._addInactiveAction(newAction, clipUuid, rootUuid);
                return newAction;
              } // get an existing action
            }, {
              key: "existingAction",
              value: function existingAction(clip, optionalRoot) {
                var root = optionalRoot || this._root,
                  rootUuid = root.uuid,
                  clipObject = typeof clip === 'string' ? _AnimationClip.findByName(root, clip) : clip,
                  clipUuid = clipObject ? clipObject.uuid : clip,
                  actionsForClip = this._actionsByClip[clipUuid];
                if (actionsForClip !== undefined) {
                  return actionsForClip.actionByRoot[rootUuid] || null;
                }
                return null;
              } // deactivates all previously scheduled actions
            }, {
              key: "stopAllAction",
              value: function stopAllAction() {
                var actions = this._actions,
                  nActions = this._nActiveActions;
                for (var i = nActions - 1; i >= 0; --i) {
                  actions[i].stop();
                }
                return this;
              } // advance the time and update apply the animation
            }, {
              key: "update",
              value: function update(deltaTime) {
                deltaTime *= this.timeScale;
                var actions = this._actions,
                  nActions = this._nActiveActions,
                  time = this.time += deltaTime,
                  timeDirection = Math.sign(deltaTime),
                  accuIndex = this._accuIndex ^= 1; // run active actions
                for (var i = 0; i !== nActions; ++i) {
                  var action = actions[i];
                  action._update(time, deltaTime, timeDirection, accuIndex);
                } // update scene graph
                var bindings = this._bindings,
                  nBindings = this._nActiveBindings;
                for (var _i89 = 0; _i89 !== nBindings; ++_i89) {
                  bindings[_i89].apply(accuIndex);
                }
                return this;
              } // Allows you to seek to a specific time in an animation.
            }, {
              key: "setTime",
              value: function setTime(timeInSeconds) {
                this.time = 0; // Zero out time attribute for AnimationMixer object;
                for (var i = 0; i < this._actions.length; i++) {
                  this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
                }
                return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
              } // return this mixer's root target object
            }, {
              key: "getRoot",
              value: function getRoot() {
                return this._root;
              } // free all resources specific to a particular clip
            }, {
              key: "uncacheClip",
              value: function uncacheClip(clip) {
                var actions = this._actions,
                  clipUuid = clip.uuid,
                  actionsByClip = this._actionsByClip,
                  actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip !== undefined) {
                  // note: just calling _removeInactiveAction would mess up the
                  // iteration state and also require updating the state we can
                  // just throw away
                  var actionsToRemove = actionsForClip.knownActions;
                  for (var i = 0, n = actionsToRemove.length; i !== n; ++i) {
                    var action = actionsToRemove[i];
                    this._deactivateAction(action);
                    var cacheIndex = action._cacheIndex,
                      lastInactiveAction = actions[actions.length - 1];
                    action._cacheIndex = null;
                    action._byClipCacheIndex = null;
                    lastInactiveAction._cacheIndex = cacheIndex;
                    actions[cacheIndex] = lastInactiveAction;
                    actions.pop();
                    this._removeInactiveBindingsForAction(action);
                  }
                  delete actionsByClip[clipUuid];
                }
              } // free all resources specific to a particular root target object
            }, {
              key: "uncacheRoot",
              value: function uncacheRoot(root) {
                var rootUuid = root.uuid,
                  actionsByClip = this._actionsByClip;
                for (var clipUuid in actionsByClip) {
                  var actionByRoot = actionsByClip[clipUuid].actionByRoot,
                    action = actionByRoot[rootUuid];
                  if (action !== undefined) {
                    this._deactivateAction(action);
                    this._removeInactiveAction(action);
                  }
                }
                var bindingsByRoot = this._bindingsByRootAndName,
                  bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName !== undefined) {
                  for (var trackName in bindingByName) {
                    var binding = bindingByName[trackName];
                    binding.restoreOriginalState();
                    this._removeInactiveBinding(binding);
                  }
                }
              } // remove a targeted clip from the cache
            }, {
              key: "uncacheAction",
              value: function uncacheAction(clip, optionalRoot) {
                var action = this.existingAction(clip, optionalRoot);
                if (action !== null) {
                  this._deactivateAction(action);
                  this._removeInactiveAction(action);
                }
              }
            }]);
            return _AnimationMixer;
          }(_EventDispatcher);
          var _Uniform = /*#__PURE__*/function () {
            function _Uniform(value) {
              _classCallCheck2(this, _Uniform);
              this.value = value;
            }
            _createClass2(_Uniform, [{
              key: "clone",
              value: function clone() {
                return new _Uniform(this.value.clone === undefined ? this.value : this.value.clone());
              }
            }]);
            return _Uniform;
          }();
          var id = 0;
          var _UniformsGroup = /*#__PURE__*/function (_EventDispatcher9) {
            _inherits(_UniformsGroup, _EventDispatcher9);
            var _super152 = _createSuper(_UniformsGroup);
            function _UniformsGroup() {
              var _this125;
              _classCallCheck2(this, _UniformsGroup);
              _this125 = _super152.call(this);
              _this125.isUniformsGroup = true;
              Object.defineProperty(_assertThisInitialized(_this125), 'id', {
                value: id++
              });
              _this125.name = '';
              _this125.usage = _StaticDrawUsage;
              _this125.uniforms = [];
              return _this125;
            }
            _createClass2(_UniformsGroup, [{
              key: "add",
              value: function add(uniform) {
                this.uniforms.push(uniform);
                return this;
              }
            }, {
              key: "remove",
              value: function remove(uniform) {
                var index = this.uniforms.indexOf(uniform);
                if (index !== -1) this.uniforms.splice(index, 1);
                return this;
              }
            }, {
              key: "setName",
              value: function setName(name) {
                this.name = name;
                return this;
              }
            }, {
              key: "setUsage",
              value: function setUsage(value) {
                this.usage = value;
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.dispatchEvent({
                  type: 'dispose'
                });
                return this;
              }
            }, {
              key: "copy",
              value: function copy(source) {
                this.name = source.name;
                this.usage = source.usage;
                var uniformsSource = source.uniforms;
                this.uniforms.length = 0;
                for (var i = 0, l = uniformsSource.length; i < l; i++) {
                  this.uniforms.push(uniformsSource[i].clone());
                }
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _UniformsGroup;
          }(_EventDispatcher);
          var _InstancedInterleavedBuffer = /*#__PURE__*/function (_InterleavedBuffer2) {
            _inherits(_InstancedInterleavedBuffer, _InterleavedBuffer2);
            var _super153 = _createSuper(_InstancedInterleavedBuffer);
            function _InstancedInterleavedBuffer(array, stride) {
              var _this126;
              var meshPerAttribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              _classCallCheck2(this, _InstancedInterleavedBuffer);
              _this126 = _super153.call(this, array, stride);
              _this126.isInstancedInterleavedBuffer = true;
              _this126.meshPerAttribute = meshPerAttribute;
              return _this126;
            }
            _createClass2(_InstancedInterleavedBuffer, [{
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_InstancedInterleavedBuffer.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
              }
            }, {
              key: "clone",
              value: function clone(data) {
                var ib = _get2(_getPrototypeOf(_InstancedInterleavedBuffer.prototype), "clone", this).call(this, data);
                ib.meshPerAttribute = this.meshPerAttribute;
                return ib;
              }
            }, {
              key: "toJSON",
              value: function toJSON(data) {
                var json = _get2(_getPrototypeOf(_InstancedInterleavedBuffer.prototype), "toJSON", this).call(this, data);
                json.isInstancedInterleavedBuffer = true;
                json.meshPerAttribute = this.meshPerAttribute;
                return json;
              }
            }]);
            return _InstancedInterleavedBuffer;
          }(_InterleavedBuffer);
          var _GLBufferAttribute = /*#__PURE__*/function () {
            function _GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
              _classCallCheck2(this, _GLBufferAttribute);
              this.isGLBufferAttribute = true;
              this.buffer = buffer;
              this.type = type;
              this.itemSize = itemSize;
              this.elementSize = elementSize;
              this.count = count;
              this.version = 0;
            }
            _createClass2(_GLBufferAttribute, [{
              key: "needsUpdate",
              set: function set(value) {
                if (value === true) this.version++;
              }
            }, {
              key: "setBuffer",
              value: function setBuffer(buffer) {
                this.buffer = buffer;
                return this;
              }
            }, {
              key: "setType",
              value: function setType(type, elementSize) {
                this.type = type;
                this.elementSize = elementSize;
                return this;
              }
            }, {
              key: "setItemSize",
              value: function setItemSize(itemSize) {
                this.itemSize = itemSize;
                return this;
              }
            }, {
              key: "setCount",
              value: function setCount(count) {
                this.count = count;
                return this;
              }
            }]);
            return _GLBufferAttribute;
          }();
          var _Raycaster = /*#__PURE__*/function () {
            function _Raycaster(origin, direction) {
              var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
              _classCallCheck2(this, _Raycaster);
              this.ray = new _Ray(origin, direction); // direction is assumed to be normalized (for accurate distance calculations)
              this.near = near;
              this.far = far;
              this.camera = null;
              this.layers = new _Layers();
              this.params = {
                Mesh: {},
                Line: {
                  threshold: 1
                },
                LOD: {},
                Points: {
                  threshold: 1
                },
                Sprite: {}
              };
            }
            _createClass2(_Raycaster, [{
              key: "set",
              value: function set(origin, direction) {
                // direction is assumed to be normalized (for accurate distance calculations)
                this.ray.set(origin, direction);
              }
            }, {
              key: "setFromCamera",
              value: function setFromCamera(coords, camera) {
                if (camera.isPerspectiveCamera) {
                  this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
                  this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
                  this.camera = camera;
                } else if (camera.isOrthographicCamera) {
                  this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
                  this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
                  this.camera = camera;
                } else {
                  console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
                }
              }
            }, {
              key: "intersectObject",
              value: function intersectObject(object) {
                var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var intersects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                _intersectObject(object, this, intersects, recursive);
                intersects.sort(ascSort);
                return intersects;
              }
            }, {
              key: "intersectObjects",
              value: function intersectObjects(objects) {
                var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var intersects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                for (var i = 0, l = objects.length; i < l; i++) {
                  _intersectObject(objects[i], this, intersects, recursive);
                }
                intersects.sort(ascSort);
                return intersects;
              }
            }]);
            return _Raycaster;
          }();
          function ascSort(a, b) {
            return a.distance - b.distance;
          }
          function _intersectObject(object, raycaster, intersects, recursive) {
            if (object.layers.test(raycaster.layers)) {
              object.raycast(raycaster, intersects);
            }
            if (recursive === true) {
              var children = object.children;
              for (var i = 0, l = children.length; i < l; i++) {
                _intersectObject(children[i], raycaster, intersects, true);
              }
            }
          } /**
            * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
            *
            * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
            * The azimuthal angle (theta) is measured from the positive z-axis.
            */
          var _Spherical = /*#__PURE__*/function () {
            function _Spherical() {
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var phi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var theta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              _classCallCheck2(this, _Spherical);
              this.radius = radius;
              this.phi = phi; // polar angle
              this.theta = theta; // azimuthal angle
              return this;
            }
            _createClass2(_Spherical, [{
              key: "set",
              value: function set(radius, phi, theta) {
                this.radius = radius;
                this.phi = phi;
                this.theta = theta;
                return this;
              }
            }, {
              key: "copy",
              value: function copy(other) {
                this.radius = other.radius;
                this.phi = other.phi;
                this.theta = other.theta;
                return this;
              } // restrict phi to be between EPS and PI-EPS
            }, {
              key: "makeSafe",
              value: function makeSafe() {
                var EPS = 0.000001;
                this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
                return this;
              }
            }, {
              key: "setFromVector3",
              value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
              }
            }, {
              key: "setFromCartesianCoords",
              value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + y * y + z * z);
                if (this.radius === 0) {
                  this.theta = 0;
                  this.phi = 0;
                } else {
                  this.theta = Math.atan2(x, z);
                  this.phi = Math.acos(clamp(y / this.radius, -1, 1));
                }
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Spherical;
          }();
          /**
          * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
          */
          var _Cylindrical = /*#__PURE__*/function () {
            function _Cylindrical() {
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              var theta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              _classCallCheck2(this, _Cylindrical);
              this.radius = radius; // distance from the origin to a point in the x-z plane
              this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
              this.y = y; // height above the x-z plane
              return this;
            }
            _createClass2(_Cylindrical, [{
              key: "set",
              value: function set(radius, theta, y) {
                this.radius = radius;
                this.theta = theta;
                this.y = y;
                return this;
              }
            }, {
              key: "copy",
              value: function copy(other) {
                this.radius = other.radius;
                this.theta = other.theta;
                this.y = other.y;
                return this;
              }
            }, {
              key: "setFromVector3",
              value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
              }
            }, {
              key: "setFromCartesianCoords",
              value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + z * z);
                this.theta = Math.atan2(x, z);
                this.y = y;
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Cylindrical;
          }();
          var _vector$4 = /*@__PURE__*/new _Vector();
          var _Box = /*#__PURE__*/function () {
            function _Box() {
              var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector(+Infinity, +Infinity);
              var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector(-Infinity, -Infinity);
              _classCallCheck2(this, _Box);
              this.isBox2 = true;
              this.min = min;
              this.max = max;
            }
            _createClass2(_Box, [{
              key: "set",
              value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
              }
            }, {
              key: "setFromPoints",
              value: function setFromPoints(points) {
                this.makeEmpty();
                for (var i = 0, il = points.length; i < il; i++) {
                  this.expandByPoint(points[i]);
                }
                return this;
              }
            }, {
              key: "setFromCenterAndSize",
              value: function setFromCenterAndSize(center, size) {
                var halfSize = _vector$4.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }, {
              key: "copy",
              value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
              }
            }, {
              key: "makeEmpty",
              value: function makeEmpty() {
                this.min.x = this.min.y = +Infinity;
                this.max.x = this.max.y = -Infinity;
                return this;
              }
            }, {
              key: "isEmpty",
              value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y;
              }
            }, {
              key: "getCenter",
              value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
              }
            }, {
              key: "getSize",
              value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
              }
            }, {
              key: "expandByPoint",
              value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
              }
            }, {
              key: "expandByVector",
              value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
              }
            }, {
              key: "expandByScalar",
              value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
              }
            }, {
              key: "containsPoint",
              value: function containsPoint(point) {
                return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
              }
            }, {
              key: "containsBox",
              value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
              }
            }, {
              key: "getParameter",
              value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
              }
            }, {
              key: "intersectsBox",
              value: function intersectsBox(box) {
                // using 4 splitting planes to rule out intersections
                return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
              }
            }, {
              key: "clampPoint",
              value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
              }
            }, {
              key: "distanceToPoint",
              value: function distanceToPoint(point) {
                var clampedPoint = _vector$4.copy(point).clamp(this.min, this.max);
                return clampedPoint.sub(point).length();
              }
            }, {
              key: "intersect",
              value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                return this;
              }
            }, {
              key: "union",
              value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
              }
            }, {
              key: "translate",
              value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
              }
            }, {
              key: "equals",
              value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
              }
            }]);
            return _Box;
          }();
          var _startP = /*@__PURE__*/new _Vector2();
          var _startEnd = /*@__PURE__*/new _Vector2();
          var _Line2 = /*#__PURE__*/function () {
            function _Line2() {
              var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2();
              var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2();
              _classCallCheck2(this, _Line2);
              this.start = start;
              this.end = end;
            }
            _createClass2(_Line2, [{
              key: "set",
              value: function set(start, end) {
                this.start.copy(start);
                this.end.copy(end);
                return this;
              }
            }, {
              key: "copy",
              value: function copy(line) {
                this.start.copy(line.start);
                this.end.copy(line.end);
                return this;
              }
            }, {
              key: "getCenter",
              value: function getCenter(target) {
                return target.addVectors(this.start, this.end).multiplyScalar(0.5);
              }
            }, {
              key: "delta",
              value: function delta(target) {
                return target.subVectors(this.end, this.start);
              }
            }, {
              key: "distanceSq",
              value: function distanceSq() {
                return this.start.distanceToSquared(this.end);
              }
            }, {
              key: "distance",
              value: function distance() {
                return this.start.distanceTo(this.end);
              }
            }, {
              key: "at",
              value: function at(t, target) {
                return this.delta(target).multiplyScalar(t).add(this.start);
              }
            }, {
              key: "closestPointToPointParameter",
              value: function closestPointToPointParameter(point, clampToLine) {
                _startP.subVectors(point, this.start);
                _startEnd.subVectors(this.end, this.start);
                var startEnd2 = _startEnd.dot(_startEnd);
                var startEnd_startP = _startEnd.dot(_startP);
                var t = startEnd_startP / startEnd2;
                if (clampToLine) {
                  t = clamp(t, 0, 1);
                }
                return t;
              }
            }, {
              key: "closestPointToPoint",
              value: function closestPointToPoint(point, clampToLine, target) {
                var t = this.closestPointToPointParameter(point, clampToLine);
                return this.delta(target).multiplyScalar(t).add(this.start);
              }
            }, {
              key: "applyMatrix4",
              value: function applyMatrix4(matrix) {
                this.start.applyMatrix4(matrix);
                this.end.applyMatrix4(matrix);
                return this;
              }
            }, {
              key: "equals",
              value: function equals(line) {
                return line.start.equals(this.start) && line.end.equals(this.end);
              }
            }, {
              key: "clone",
              value: function clone() {
                return new this.constructor().copy(this);
              }
            }]);
            return _Line2;
          }();
          var _vector$3 = /*@__PURE__*/new _Vector2();
          var _SpotLightHelper = /*#__PURE__*/function (_Object3D15) {
            _inherits(_SpotLightHelper, _Object3D15);
            var _super154 = _createSuper(_SpotLightHelper);
            function _SpotLightHelper(light, color) {
              var _this127;
              _classCallCheck2(this, _SpotLightHelper);
              _this127 = _super154.call(this);
              _this127.light = light;
              _this127.matrix = light.matrixWorld;
              _this127.matrixAutoUpdate = false;
              _this127.color = color;
              _this127.type = 'SpotLightHelper';
              var geometry = new _BufferGeometry();
              var positions = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1];
              for (var i = 0, j = 1, l = 32; i < l; i++, j++) {
                var p1 = i / l * Math.PI * 2;
                var p2 = j / l * Math.PI * 2;
                positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
              }
              geometry.setAttribute('position', new _Float32BufferAttribute(positions, 3));
              var material = new _LineBasicMaterial({
                fog: false,
                toneMapped: false
              });
              _this127.cone = new _LineSegments(geometry, material);
              _this127.add(_this127.cone);
              _this127.update();
              return _this127;
            }
            _createClass2(_SpotLightHelper, [{
              key: "dispose",
              value: function dispose() {
                this.cone.geometry.dispose();
                this.cone.material.dispose();
              }
            }, {
              key: "update",
              value: function update() {
                this.light.updateWorldMatrix(true, false);
                this.light.target.updateWorldMatrix(true, false);
                var coneLength = this.light.distance ? this.light.distance : 1000;
                var coneWidth = coneLength * Math.tan(this.light.angle);
                this.cone.scale.set(coneWidth, coneWidth, coneLength);
                _vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
                this.cone.lookAt(_vector$3);
                if (this.color !== undefined) {
                  this.cone.material.color.set(this.color);
                } else {
                  this.cone.material.color.copy(this.light.color);
                }
              }
            }]);
            return _SpotLightHelper;
          }(_Object3D);
          var _vector$2 = /*@__PURE__*/new _Vector2();
          var _boneMatrix = /*@__PURE__*/new _Matrix2();
          var _matrixWorldInv = /*@__PURE__*/new _Matrix2();
          var _SkeletonHelper = /*#__PURE__*/function (_LineSegments2) {
            _inherits(_SkeletonHelper, _LineSegments2);
            var _super155 = _createSuper(_SkeletonHelper);
            function _SkeletonHelper(object) {
              var _this128;
              _classCallCheck2(this, _SkeletonHelper);
              var bones = getBoneList(object);
              var geometry = new _BufferGeometry();
              var vertices = [];
              var colors = [];
              var color1 = new _Color(0, 0, 1);
              var color2 = new _Color(0, 1, 0);
              for (var i = 0; i < bones.length; i++) {
                var bone = bones[i];
                if (bone.parent && bone.parent.isBone) {
                  vertices.push(0, 0, 0);
                  vertices.push(0, 0, 0);
                  colors.push(color1.r, color1.g, color1.b);
                  colors.push(color2.r, color2.g, color2.b);
                }
              }
              geometry.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              geometry.setAttribute('color', new _Float32BufferAttribute(colors, 3));
              var material = new _LineBasicMaterial({
                vertexColors: true,
                depthTest: false,
                depthWrite: false,
                toneMapped: false,
                transparent: true
              });
              _this128 = _super155.call(this, geometry, material);
              _this128.isSkeletonHelper = true;
              _this128.type = 'SkeletonHelper';
              _this128.root = object;
              _this128.bones = bones;
              _this128.matrix = object.matrixWorld;
              _this128.matrixAutoUpdate = false;
              return _this128;
            }
            _createClass2(_SkeletonHelper, [{
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                var bones = this.bones;
                var geometry = this.geometry;
                var position = geometry.getAttribute('position');
                _matrixWorldInv.copy(this.root.matrixWorld).invert();
                for (var i = 0, j = 0; i < bones.length; i++) {
                  var bone = bones[i];
                  if (bone.parent && bone.parent.isBone) {
                    _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
                    _vector$2.setFromMatrixPosition(_boneMatrix);
                    position.setXYZ(j, _vector$2.x, _vector$2.y, _vector$2.z);
                    _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
                    _vector$2.setFromMatrixPosition(_boneMatrix);
                    position.setXYZ(j + 1, _vector$2.x, _vector$2.y, _vector$2.z);
                    j += 2;
                  }
                }
                geometry.getAttribute('position').needsUpdate = true;
                _get2(_getPrototypeOf(_SkeletonHelper.prototype), "updateMatrixWorld", this).call(this, force);
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _SkeletonHelper;
          }(_LineSegments);
          function getBoneList(object) {
            var boneList = [];
            if (object.isBone === true) {
              boneList.push(object);
            }
            for (var i = 0; i < object.children.length; i++) {
              boneList.push.apply(boneList, getBoneList(object.children[i]));
            }
            return boneList;
          }
          var _PointLightHelper = /*#__PURE__*/function (_Mesh4) {
            _inherits(_PointLightHelper, _Mesh4);
            var _super156 = _createSuper(_PointLightHelper);
            function _PointLightHelper(light, sphereSize, color) {
              var _this129;
              _classCallCheck2(this, _PointLightHelper);
              var geometry = new _SphereGeometry(sphereSize, 4, 2);
              var material = new _MeshBasicMaterial({
                wireframe: true,
                fog: false,
                toneMapped: false
              });
              _this129 = _super156.call(this, geometry, material);
              _this129.light = light;
              _this129.color = color;
              _this129.type = 'PointLightHelper';
              _this129.matrix = _this129.light.matrixWorld;
              _this129.matrixAutoUpdate = false;
              _this129.update(); /*
                                 // TODO: delete this comment?
                                 const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
                                 const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );
                                 this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
                                 this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );
                                 const d = light.distance;
                                 if ( d === 0.0 ) {
                                 this.lightDistance.visible = false;
                                 } else {
                                 this.lightDistance.scale.set( d, d, d );
                                 }
                                 this.add( this.lightDistance );
                                 */
              return _this129;
            }
            _createClass2(_PointLightHelper, [{
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }, {
              key: "update",
              value: function update() {
                this.light.updateWorldMatrix(true, false);
                if (this.color !== undefined) {
                  this.material.color.set(this.color);
                } else {
                  this.material.color.copy(this.light.color);
                } /*
                  const d = this.light.distance;
                  if ( d === 0.0 ) {
                  this.lightDistance.visible = false;
                  } else {
                  this.lightDistance.visible = true;
                  this.lightDistance.scale.set( d, d, d );
                  }
                  */
              }
            }]);
            return _PointLightHelper;
          }(_Mesh);
          var _vector$1 = /*@__PURE__*/new _Vector2();
          var _color1 = /*@__PURE__*/new _Color();
          var _color2 = /*@__PURE__*/new _Color();
          var _HemisphereLightHelper = /*#__PURE__*/function (_Object3D16) {
            _inherits(_HemisphereLightHelper, _Object3D16);
            var _super157 = _createSuper(_HemisphereLightHelper);
            function _HemisphereLightHelper(light, size, color) {
              var _this130;
              _classCallCheck2(this, _HemisphereLightHelper);
              _this130 = _super157.call(this);
              _this130.light = light;
              _this130.matrix = light.matrixWorld;
              _this130.matrixAutoUpdate = false;
              _this130.color = color;
              _this130.type = 'HemisphereLightHelper';
              var geometry = new _OctahedronGeometry(size);
              geometry.rotateY(Math.PI * 0.5);
              _this130.material = new _MeshBasicMaterial({
                wireframe: true,
                fog: false,
                toneMapped: false
              });
              if (_this130.color === undefined) _this130.material.vertexColors = true;
              var position = geometry.getAttribute('position');
              var colors = new Float32Array(position.count * 3);
              geometry.setAttribute('color', new _BufferAttribute(colors, 3));
              _this130.add(new _Mesh(geometry, _this130.material));
              _this130.update();
              return _this130;
            }
            _createClass2(_HemisphereLightHelper, [{
              key: "dispose",
              value: function dispose() {
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
              }
            }, {
              key: "update",
              value: function update() {
                var mesh = this.children[0];
                if (this.color !== undefined) {
                  this.material.color.set(this.color);
                } else {
                  var colors = mesh.geometry.getAttribute('color');
                  _color1.copy(this.light.color);
                  _color2.copy(this.light.groundColor);
                  for (var i = 0, l = colors.count; i < l; i++) {
                    var color = i < l / 2 ? _color1 : _color2;
                    colors.setXYZ(i, color.r, color.g, color.b);
                  }
                  colors.needsUpdate = true;
                }
                this.light.updateWorldMatrix(true, false);
                mesh.lookAt(_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
              }
            }]);
            return _HemisphereLightHelper;
          }(_Object3D);
          var _GridHelper = /*#__PURE__*/function (_LineSegments3) {
            _inherits(_GridHelper, _LineSegments3);
            var _super158 = _createSuper(_GridHelper);
            function _GridHelper() {
              var _this131;
              var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
              var divisions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
              var color1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0x444444;
              var color2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0x888888;
              _classCallCheck2(this, _GridHelper);
              color1 = new _Color(color1);
              color2 = new _Color(color2);
              var center = divisions / 2;
              var step = size / divisions;
              var halfSize = size / 2;
              var vertices = [],
                colors = [];
              for (var i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step) {
                vertices.push(-halfSize, 0, k, halfSize, 0, k);
                vertices.push(k, 0, -halfSize, k, 0, halfSize);
                var color = i === center ? color1 : color2;
                color.toArray(colors, j);
                j += 3;
                color.toArray(colors, j);
                j += 3;
                color.toArray(colors, j);
                j += 3;
                color.toArray(colors, j);
                j += 3;
              }
              var geometry = new _BufferGeometry();
              geometry.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              geometry.setAttribute('color', new _Float32BufferAttribute(colors, 3));
              var material = new _LineBasicMaterial({
                vertexColors: true,
                toneMapped: false
              });
              _this131 = _super158.call(this, geometry, material);
              _this131.type = 'GridHelper';
              return _this131;
            }
            _createClass2(_GridHelper, [{
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _GridHelper;
          }(_LineSegments);
          var _PolarGridHelper = /*#__PURE__*/function (_LineSegments4) {
            _inherits(_PolarGridHelper, _LineSegments4);
            var _super159 = _createSuper(_PolarGridHelper);
            function _PolarGridHelper() {
              var _this132;
              var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
              var sectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
              var rings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
              var divisions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 64;
              var color1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0x444444;
              var color2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0x888888;
              _classCallCheck2(this, _PolarGridHelper);
              color1 = new _Color(color1);
              color2 = new _Color(color2);
              var vertices = [];
              var colors = []; // create the sectors
              if (sectors > 1) {
                for (var i = 0; i < sectors; i++) {
                  var v = i / sectors * (Math.PI * 2);
                  var x = Math.sin(v) * radius;
                  var z = Math.cos(v) * radius;
                  vertices.push(0, 0, 0);
                  vertices.push(x, 0, z);
                  var color = i & 1 ? color1 : color2;
                  colors.push(color.r, color.g, color.b);
                  colors.push(color.r, color.g, color.b);
                }
              } // create the rings
              for (var _i90 = 0; _i90 < rings; _i90++) {
                var _color3 = _i90 & 1 ? color1 : color2;
                var r = radius - radius / rings * _i90;
                for (var j = 0; j < divisions; j++) {
                  // first vertex
                  var _v = j / divisions * (Math.PI * 2);
                  var _x12 = Math.sin(_v) * r;
                  var _z3 = Math.cos(_v) * r;
                  vertices.push(_x12, 0, _z3);
                  colors.push(_color3.r, _color3.g, _color3.b); // second vertex
                  _v = (j + 1) / divisions * (Math.PI * 2);
                  _x12 = Math.sin(_v) * r;
                  _z3 = Math.cos(_v) * r;
                  vertices.push(_x12, 0, _z3);
                  colors.push(_color3.r, _color3.g, _color3.b);
                }
              }
              var geometry = new _BufferGeometry();
              geometry.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              geometry.setAttribute('color', new _Float32BufferAttribute(colors, 3));
              var material = new _LineBasicMaterial({
                vertexColors: true,
                toneMapped: false
              });
              _this132 = _super159.call(this, geometry, material);
              _this132.type = 'PolarGridHelper';
              return _this132;
            }
            _createClass2(_PolarGridHelper, [{
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _PolarGridHelper;
          }(_LineSegments);
          var _v1 = /*@__PURE__*/new _Vector2();
          var _v2 = /*@__PURE__*/new _Vector2();
          var _v3 = /*@__PURE__*/new _Vector2();
          var _DirectionalLightHelper = /*#__PURE__*/function (_Object3D17) {
            _inherits(_DirectionalLightHelper, _Object3D17);
            var _super160 = _createSuper(_DirectionalLightHelper);
            function _DirectionalLightHelper(light, size, color) {
              var _this133;
              _classCallCheck2(this, _DirectionalLightHelper);
              _this133 = _super160.call(this);
              _this133.light = light;
              _this133.matrix = light.matrixWorld;
              _this133.matrixAutoUpdate = false;
              _this133.color = color;
              _this133.type = 'DirectionalLightHelper';
              if (size === undefined) size = 1;
              var geometry = new _BufferGeometry();
              geometry.setAttribute('position', new _Float32BufferAttribute([-size, size, 0, size, size, 0, size, -size, 0, -size, -size, 0, -size, size, 0], 3));
              var material = new _LineBasicMaterial({
                fog: false,
                toneMapped: false
              });
              _this133.lightPlane = new _Line(geometry, material);
              _this133.add(_this133.lightPlane);
              geometry = new _BufferGeometry();
              geometry.setAttribute('position', new _Float32BufferAttribute([0, 0, 0, 0, 0, 1], 3));
              _this133.targetLine = new _Line(geometry, material);
              _this133.add(_this133.targetLine);
              _this133.update();
              return _this133;
            }
            _createClass2(_DirectionalLightHelper, [{
              key: "dispose",
              value: function dispose() {
                this.lightPlane.geometry.dispose();
                this.lightPlane.material.dispose();
                this.targetLine.geometry.dispose();
                this.targetLine.material.dispose();
              }
            }, {
              key: "update",
              value: function update() {
                this.light.updateWorldMatrix(true, false);
                this.light.target.updateWorldMatrix(true, false);
                _v1.setFromMatrixPosition(this.light.matrixWorld);
                _v2.setFromMatrixPosition(this.light.target.matrixWorld);
                _v3.subVectors(_v2, _v1);
                this.lightPlane.lookAt(_v2);
                if (this.color !== undefined) {
                  this.lightPlane.material.color.set(this.color);
                  this.targetLine.material.color.set(this.color);
                } else {
                  this.lightPlane.material.color.copy(this.light.color);
                  this.targetLine.material.color.copy(this.light.color);
                }
                this.targetLine.lookAt(_v2);
                this.targetLine.scale.z = _v3.length();
              }
            }]);
            return _DirectionalLightHelper;
          }(_Object3D);
          var _vector = /*@__PURE__*/new _Vector2();
          var _camera = /*@__PURE__*/new _Camera(); /**
                                                    *	- shows frustum, line of sight and up of the camera
                                                    *	- suitable for fast updates
                                                    * 	- based on frustum visualization in lightgl.js shadowmap example
                                                    *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
                                                    */
          var _CameraHelper = /*#__PURE__*/function (_LineSegments5) {
            _inherits(_CameraHelper, _LineSegments5);
            var _super161 = _createSuper(_CameraHelper);
            function _CameraHelper(camera) {
              var _this134;
              _classCallCheck2(this, _CameraHelper);
              var geometry = new _BufferGeometry();
              var material = new _LineBasicMaterial({
                color: 0xffffff,
                vertexColors: true,
                toneMapped: false
              });
              var vertices = [];
              var colors = [];
              var pointMap = {}; // near
              addLine('n1', 'n2');
              addLine('n2', 'n4');
              addLine('n4', 'n3');
              addLine('n3', 'n1'); // far
              addLine('f1', 'f2');
              addLine('f2', 'f4');
              addLine('f4', 'f3');
              addLine('f3', 'f1'); // sides
              addLine('n1', 'f1');
              addLine('n2', 'f2');
              addLine('n3', 'f3');
              addLine('n4', 'f4'); // cone
              addLine('p', 'n1');
              addLine('p', 'n2');
              addLine('p', 'n3');
              addLine('p', 'n4'); // up
              addLine('u1', 'u2');
              addLine('u2', 'u3');
              addLine('u3', 'u1'); // target
              addLine('c', 't');
              addLine('p', 'c'); // cross
              addLine('cn1', 'cn2');
              addLine('cn3', 'cn4');
              addLine('cf1', 'cf2');
              addLine('cf3', 'cf4');
              function addLine(a, b) {
                addPoint(a);
                addPoint(b);
              }
              function addPoint(id) {
                vertices.push(0, 0, 0);
                colors.push(0, 0, 0);
                if (pointMap[id] === undefined) {
                  pointMap[id] = [];
                }
                pointMap[id].push(vertices.length / 3 - 1);
              }
              geometry.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              geometry.setAttribute('color', new _Float32BufferAttribute(colors, 3));
              _this134 = _super161.call(this, geometry, material);
              _this134.type = 'CameraHelper';
              _this134.camera = camera;
              if (_this134.camera.updateProjectionMatrix) _this134.camera.updateProjectionMatrix();
              _this134.matrix = camera.matrixWorld;
              _this134.matrixAutoUpdate = false;
              _this134.pointMap = pointMap;
              _this134.update(); // colors
              var colorFrustum = new _Color(0xffaa00);
              var colorCone = new _Color(0xff0000);
              var colorUp = new _Color(0x00aaff);
              var colorTarget = new _Color(0xffffff);
              var colorCross = new _Color(0x333333);
              _this134.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
              return _this134;
            }
            _createClass2(_CameraHelper, [{
              key: "setColors",
              value: function setColors(frustum, cone, up, target, cross) {
                var geometry = this.geometry;
                var colorAttribute = geometry.getAttribute('color'); // near
                colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
                colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
                colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
                colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
                // far
                colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
                colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
                colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
                colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
                // sides
                colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
                colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
                colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
                colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
                // cone
                colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
                colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
                colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
                colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
                // up
                colorAttribute.setXYZ(32, up.r, up.g, up.b);
                colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
                colorAttribute.setXYZ(34, up.r, up.g, up.b);
                colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
                colorAttribute.setXYZ(36, up.r, up.g, up.b);
                colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
                // target
                colorAttribute.setXYZ(38, target.r, target.g, target.b);
                colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
                colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
                // cross
                colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
                colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
                colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
                colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
                colorAttribute.needsUpdate = true;
              }
            }, {
              key: "update",
              value: function update() {
                var geometry = this.geometry;
                var pointMap = this.pointMap;
                var w = 1,
                  h = 1; // we need just camera projection matrix inverse
                // world matrix must be identity
                _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse); // center / target
                setPoint('c', pointMap, geometry, _camera, 0, 0, -1);
                setPoint('t', pointMap, geometry, _camera, 0, 0, 1); // near
                setPoint('n1', pointMap, geometry, _camera, -w, -h, -1);
                setPoint('n2', pointMap, geometry, _camera, w, -h, -1);
                setPoint('n3', pointMap, geometry, _camera, -w, h, -1);
                setPoint('n4', pointMap, geometry, _camera, w, h, -1); // far
                setPoint('f1', pointMap, geometry, _camera, -w, -h, 1);
                setPoint('f2', pointMap, geometry, _camera, w, -h, 1);
                setPoint('f3', pointMap, geometry, _camera, -w, h, 1);
                setPoint('f4', pointMap, geometry, _camera, w, h, 1); // up
                setPoint('u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, -1);
                setPoint('u2', pointMap, geometry, _camera, -w * 0.7, h * 1.1, -1);
                setPoint('u3', pointMap, geometry, _camera, 0, h * 2, -1); // cross
                setPoint('cf1', pointMap, geometry, _camera, -w, 0, 1);
                setPoint('cf2', pointMap, geometry, _camera, w, 0, 1);
                setPoint('cf3', pointMap, geometry, _camera, 0, -h, 1);
                setPoint('cf4', pointMap, geometry, _camera, 0, h, 1);
                setPoint('cn1', pointMap, geometry, _camera, -w, 0, -1);
                setPoint('cn2', pointMap, geometry, _camera, w, 0, -1);
                setPoint('cn3', pointMap, geometry, _camera, 0, -h, -1);
                setPoint('cn4', pointMap, geometry, _camera, 0, h, -1);
                geometry.getAttribute('position').needsUpdate = true;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _CameraHelper;
          }(_LineSegments);
          function setPoint(point, pointMap, geometry, camera, x, y, z) {
            _vector.set(x, y, z).unproject(camera);
            var points = pointMap[point];
            if (points !== undefined) {
              var position = geometry.getAttribute('position');
              for (var i = 0, l = points.length; i < l; i++) {
                position.setXYZ(points[i], _vector.x, _vector.y, _vector.z);
              }
            }
          }
          var _box = /*@__PURE__*/new _Box2();
          var _BoxHelper = /*#__PURE__*/function (_LineSegments6) {
            _inherits(_BoxHelper, _LineSegments6);
            var _super162 = _createSuper(_BoxHelper);
            function _BoxHelper(object) {
              var _this135;
              var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0xffff00;
              _classCallCheck2(this, _BoxHelper);
              var indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
              var positions = new Float32Array(8 * 3);
              var geometry = new _BufferGeometry();
              geometry.setIndex(new _BufferAttribute(indices, 1));
              geometry.setAttribute('position', new _BufferAttribute(positions, 3));
              _this135 = _super162.call(this, geometry, new _LineBasicMaterial({
                color: color,
                toneMapped: false
              }));
              _this135.object = object;
              _this135.type = 'BoxHelper';
              _this135.matrixAutoUpdate = false;
              _this135.update();
              return _this135;
            }
            _createClass2(_BoxHelper, [{
              key: "update",
              value: function update(object) {
                if (object !== undefined) {
                  console.warn('THREE.BoxHelper: .update() has no longer arguments.');
                }
                if (this.object !== undefined) {
                  _box.setFromObject(this.object);
                }
                if (_box.isEmpty()) return;
                var min = _box.min;
                var max = _box.max; /*
                                    5____4
                                    1/___0/|
                                    | 6__|_7
                                    2/___3/
                                    0: max.x, max.y, max.z
                                    1: min.x, max.y, max.z
                                    2: min.x, min.y, max.z
                                    3: max.x, min.y, max.z
                                    4: max.x, max.y, min.z
                                    5: min.x, max.y, min.z
                                    6: min.x, min.y, min.z
                                    7: max.x, min.y, min.z
                                    */
                var position = this.geometry.attributes.position;
                var array = position.array;
                array[0] = max.x;
                array[1] = max.y;
                array[2] = max.z;
                array[3] = min.x;
                array[4] = max.y;
                array[5] = max.z;
                array[6] = min.x;
                array[7] = min.y;
                array[8] = max.z;
                array[9] = max.x;
                array[10] = min.y;
                array[11] = max.z;
                array[12] = max.x;
                array[13] = max.y;
                array[14] = min.z;
                array[15] = min.x;
                array[16] = max.y;
                array[17] = min.z;
                array[18] = min.x;
                array[19] = min.y;
                array[20] = min.z;
                array[21] = max.x;
                array[22] = min.y;
                array[23] = min.z;
                position.needsUpdate = true;
                this.geometry.computeBoundingSphere();
              }
            }, {
              key: "setFromObject",
              value: function setFromObject(object) {
                this.object = object;
                this.update();
                return this;
              }
            }, {
              key: "copy",
              value: function copy(source, recursive) {
                _get2(_getPrototypeOf(_BoxHelper.prototype), "copy", this).call(this, source, recursive);
                this.object = source.object;
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _BoxHelper;
          }(_LineSegments);
          var _Box3Helper = /*#__PURE__*/function (_LineSegments7) {
            _inherits(_Box3Helper, _LineSegments7);
            var _super163 = _createSuper(_Box3Helper);
            function _Box3Helper(box) {
              var _this136;
              var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0xffff00;
              _classCallCheck2(this, _Box3Helper);
              var indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
              var positions = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1];
              var geometry = new _BufferGeometry();
              geometry.setIndex(new _BufferAttribute(indices, 1));
              geometry.setAttribute('position', new _Float32BufferAttribute(positions, 3));
              _this136 = _super163.call(this, geometry, new _LineBasicMaterial({
                color: color,
                toneMapped: false
              }));
              _this136.box = box;
              _this136.type = 'Box3Helper';
              _this136.geometry.computeBoundingSphere();
              return _this136;
            }
            _createClass2(_Box3Helper, [{
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                var box = this.box;
                if (box.isEmpty()) return;
                box.getCenter(this.position);
                box.getSize(this.scale);
                this.scale.multiplyScalar(0.5);
                _get2(_getPrototypeOf(_Box3Helper.prototype), "updateMatrixWorld", this).call(this, force);
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _Box3Helper;
          }(_LineSegments);
          var _PlaneHelper = /*#__PURE__*/function (_Line5) {
            _inherits(_PlaneHelper, _Line5);
            var _super164 = _createSuper(_PlaneHelper);
            function _PlaneHelper(plane) {
              var _this137;
              var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var hex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0xffff00;
              _classCallCheck2(this, _PlaneHelper);
              var color = hex;
              var positions = [1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0];
              var geometry = new _BufferGeometry();
              geometry.setAttribute('position', new _Float32BufferAttribute(positions, 3));
              geometry.computeBoundingSphere();
              _this137 = _super164.call(this, geometry, new _LineBasicMaterial({
                color: color,
                toneMapped: false
              }));
              _this137.type = 'PlaneHelper';
              _this137.plane = plane;
              _this137.size = size;
              var positions2 = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0];
              var geometry2 = new _BufferGeometry();
              geometry2.setAttribute('position', new _Float32BufferAttribute(positions2, 3));
              geometry2.computeBoundingSphere();
              _this137.add(new _Mesh(geometry2, new _MeshBasicMaterial({
                color: color,
                opacity: 0.2,
                transparent: true,
                depthWrite: false,
                toneMapped: false
              })));
              return _this137;
            }
            _createClass2(_PlaneHelper, [{
              key: "updateMatrixWorld",
              value: function updateMatrixWorld(force) {
                this.position.set(0, 0, 0);
                this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
                this.lookAt(this.plane.normal);
                this.translateZ(-this.plane.constant);
                _get2(_getPrototypeOf(_PlaneHelper.prototype), "updateMatrixWorld", this).call(this, force);
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
              }
            }]);
            return _PlaneHelper;
          }(_Line);
          var _axis = /*@__PURE__*/new _Vector2();
          var _lineGeometry, _coneGeometry;
          var _ArrowHelper = /*#__PURE__*/function (_Object3D18) {
            _inherits(_ArrowHelper, _Object3D18);
            var _super165 = _createSuper(_ArrowHelper);
            // dir is assumed to be normalized
            function _ArrowHelper() {
              var _this138;
              var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Vector2(0, 0, 1);
              var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Vector2(0, 0, 0);
              var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0xffff00;
              var headLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : length * 0.2;
              var headWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : headLength * 0.2;
              _classCallCheck2(this, _ArrowHelper);
              _this138 = _super165.call(this);
              _this138.type = 'ArrowHelper';
              if (_lineGeometry === undefined) {
                _lineGeometry = new _BufferGeometry();
                _lineGeometry.setAttribute('position', new _Float32BufferAttribute([0, 0, 0, 0, 1, 0], 3));
                _coneGeometry = new _CylinderGeometry(0, 0.5, 1, 5, 1);
                _coneGeometry.translate(0, -0.5, 0);
              }
              _this138.position.copy(origin);
              _this138.line = new _Line(_lineGeometry, new _LineBasicMaterial({
                color: color,
                toneMapped: false
              }));
              _this138.line.matrixAutoUpdate = false;
              _this138.add(_this138.line);
              _this138.cone = new _Mesh(_coneGeometry, new _MeshBasicMaterial({
                color: color,
                toneMapped: false
              }));
              _this138.cone.matrixAutoUpdate = false;
              _this138.add(_this138.cone);
              _this138.setDirection(dir);
              _this138.setLength(length, headLength, headWidth);
              return _this138;
            }
            _createClass2(_ArrowHelper, [{
              key: "setDirection",
              value: function setDirection(dir) {
                // dir is assumed to be normalized
                if (dir.y > 0.99999) {
                  this.quaternion.set(0, 0, 0, 1);
                } else if (dir.y < -0.99999) {
                  this.quaternion.set(1, 0, 0, 0);
                } else {
                  _axis.set(dir.z, 0, -dir.x).normalize();
                  var radians = Math.acos(dir.y);
                  this.quaternion.setFromAxisAngle(_axis, radians);
                }
              }
            }, {
              key: "setLength",
              value: function setLength(length) {
                var headLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : length * 0.2;
                var headWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : headLength * 0.2;
                this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
                this.line.updateMatrix();
                this.cone.scale.set(headWidth, headLength, headWidth);
                this.cone.position.y = length;
                this.cone.updateMatrix();
              }
            }, {
              key: "setColor",
              value: function setColor(color) {
                this.line.material.color.set(color);
                this.cone.material.color.set(color);
              }
            }, {
              key: "copy",
              value: function copy(source) {
                _get2(_getPrototypeOf(_ArrowHelper.prototype), "copy", this).call(this, source, false);
                this.line.copy(source.line);
                this.cone.copy(source.cone);
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.line.geometry.dispose();
                this.line.material.dispose();
                this.cone.geometry.dispose();
                this.cone.material.dispose();
              }
            }]);
            return _ArrowHelper;
          }(_Object3D);
          var _AxesHelper = /*#__PURE__*/function (_LineSegments8) {
            _inherits(_AxesHelper, _LineSegments8);
            var _super166 = _createSuper(_AxesHelper);
            function _AxesHelper() {
              var _this139;
              var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              _classCallCheck2(this, _AxesHelper);
              var vertices = [0, 0, 0, size, 0, 0, 0, 0, 0, 0, size, 0, 0, 0, 0, 0, 0, size];
              var colors = [1, 0, 0, 1, 0.6, 0, 0, 1, 0, 0.6, 1, 0, 0, 0, 1, 0, 0.6, 1];
              var geometry = new _BufferGeometry();
              geometry.setAttribute('position', new _Float32BufferAttribute(vertices, 3));
              geometry.setAttribute('color', new _Float32BufferAttribute(colors, 3));
              var material = new _LineBasicMaterial({
                vertexColors: true,
                toneMapped: false
              });
              _this139 = _super166.call(this, geometry, material);
              _this139.type = 'AxesHelper';
              return _this139;
            }
            _createClass2(_AxesHelper, [{
              key: "setColors",
              value: function setColors(xAxisColor, yAxisColor, zAxisColor) {
                var color = new _Color();
                var array = this.geometry.attributes.color.array;
                color.set(xAxisColor);
                color.toArray(array, 0);
                color.toArray(array, 3);
                color.set(yAxisColor);
                color.toArray(array, 6);
                color.toArray(array, 9);
                color.set(zAxisColor);
                color.toArray(array, 12);
                color.toArray(array, 15);
                this.geometry.attributes.color.needsUpdate = true;
                return this;
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
              }
            }]);
            return _AxesHelper;
          }(_LineSegments);
          var _ShapePath = /*#__PURE__*/function () {
            function _ShapePath() {
              _classCallCheck2(this, _ShapePath);
              this.type = 'ShapePath';
              this.color = new _Color();
              this.subPaths = [];
              this.currentPath = null;
            }
            _createClass2(_ShapePath, [{
              key: "moveTo",
              value: function moveTo(x, y) {
                this.currentPath = new _Path();
                this.subPaths.push(this.currentPath);
                this.currentPath.moveTo(x, y);
                return this;
              }
            }, {
              key: "lineTo",
              value: function lineTo(x, y) {
                this.currentPath.lineTo(x, y);
                return this;
              }
            }, {
              key: "quadraticCurveTo",
              value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
                return this;
              }
            }, {
              key: "bezierCurveTo",
              value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
                return this;
              }
            }, {
              key: "splineThru",
              value: function splineThru(pts) {
                this.currentPath.splineThru(pts);
                return this;
              }
            }, {
              key: "toShapes",
              value: function toShapes(isCCW) {
                function toShapesNoHoles(inSubpaths) {
                  var shapes = [];
                  for (var i = 0, l = inSubpaths.length; i < l; i++) {
                    var _tmpPath = inSubpaths[i];
                    var _tmpShape = new _Shape();
                    _tmpShape.curves = _tmpPath.curves;
                    shapes.push(_tmpShape);
                  }
                  return shapes;
                }
                function isPointInsidePolygon(inPt, inPolygon) {
                  var polyLen = inPolygon.length; // inPt on polygon contour => immediate success    or
                  // toggling of inside/outside at every single! intersection point of an edge
                  //  with the horizontal line through inPt, left of inPt
                  //  not counting lowerY endpoints of edges and whole edges on that line
                  var inside = false;
                  for (var p = polyLen - 1, q = 0; q < polyLen; p = q++) {
                    var edgeLowPt = inPolygon[p];
                    var edgeHighPt = inPolygon[q];
                    var edgeDx = edgeHighPt.x - edgeLowPt.x;
                    var edgeDy = edgeHighPt.y - edgeLowPt.y;
                    if (Math.abs(edgeDy) > Number.EPSILON) {
                      // not parallel
                      if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                      }
                      if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                      if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                        // continue;				// no intersection or edgeLowPt => doesn't count !!!
                      } else {
                        var perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                      }
                    } else {
                      // parallel or collinear
                      if (inPt.y !== edgeLowPt.y) continue; // parallel
                      // edge lies on the same horizontal line as inPt
                      if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                      // continue;
                    }
                  }
                  return inside;
                }
                var isClockWise = _ShapeUtils.isClockWise;
                var subPaths = this.subPaths;
                if (subPaths.length === 0) return [];
                var solid, tmpPath, tmpShape;
                var shapes = [];
                if (subPaths.length === 1) {
                  tmpPath = subPaths[0];
                  tmpShape = new _Shape();
                  tmpShape.curves = tmpPath.curves;
                  shapes.push(tmpShape);
                  return shapes;
                }
                var holesFirst = !isClockWise(subPaths[0].getPoints());
                holesFirst = isCCW ? !holesFirst : holesFirst; // console.log("Holes first", holesFirst);
                var betterShapeHoles = [];
                var newShapes = [];
                var newShapeHoles = [];
                var mainIdx = 0;
                var tmpPoints;
                newShapes[mainIdx] = undefined;
                newShapeHoles[mainIdx] = [];
                for (var i = 0, l = subPaths.length; i < l; i++) {
                  tmpPath = subPaths[i];
                  tmpPoints = tmpPath.getPoints();
                  solid = isClockWise(tmpPoints);
                  solid = isCCW ? !solid : solid;
                  if (solid) {
                    if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                    newShapes[mainIdx] = {
                      s: new _Shape(),
                      p: tmpPoints
                    };
                    newShapes[mainIdx].s.curves = tmpPath.curves;
                    if (holesFirst) mainIdx++;
                    newShapeHoles[mainIdx] = []; //console.log('cw', i);
                  } else {
                    newShapeHoles[mainIdx].push({
                      h: tmpPath,
                      p: tmpPoints[0]
                    }); //console.log('ccw', i);
                  }
                } // only Holes? -> probably all Shapes with wrong orientation
                if (!newShapes[0]) return toShapesNoHoles(subPaths);
                if (newShapes.length > 1) {
                  var ambiguous = false;
                  var toChange = 0;
                  for (var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
                    betterShapeHoles[sIdx] = [];
                  }
                  for (var _sIdx = 0, _sLen = newShapes.length; _sIdx < _sLen; _sIdx++) {
                    var sho = newShapeHoles[_sIdx];
                    for (var hIdx = 0; hIdx < sho.length; hIdx++) {
                      var ho = sho[hIdx];
                      var hole_unassigned = true;
                      for (var s2Idx = 0; s2Idx < newShapes.length; s2Idx++) {
                        if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                          if (_sIdx !== s2Idx) toChange++;
                          if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                          } else {
                            ambiguous = true;
                          }
                        }
                      }
                      if (hole_unassigned) {
                        betterShapeHoles[_sIdx].push(ho);
                      }
                    }
                  }
                  if (toChange > 0 && ambiguous === false) {
                    newShapeHoles = betterShapeHoles;
                  }
                }
                var tmpHoles;
                for (var _i91 = 0, il = newShapes.length; _i91 < il; _i91++) {
                  tmpShape = newShapes[_i91].s;
                  shapes.push(tmpShape);
                  tmpHoles = newShapeHoles[_i91];
                  for (var j = 0, jl = tmpHoles.length; j < jl; j++) {
                    tmpShape.holes.push(tmpHoles[j].h);
                  }
                } //console.log("shape", shapes);
                return shapes;
              }
            }]);
            return _ShapePath;
          }(); // Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
          var _tables = /*@__PURE__*/_generateTables();
          function _generateTables() {
            // float32 to float16 helpers
            var buffer = new ArrayBuffer(4);
            var floatView = new Float32Array(buffer);
            var uint32View = new Uint32Array(buffer);
            var baseTable = new Uint32Array(512);
            var shiftTable = new Uint32Array(512);
            for (var i = 0; i < 256; ++i) {
              var e = i - 127; // very small number (0, -0)
              if (e < -27) {
                baseTable[i] = 0x0000;
                baseTable[i | 0x100] = 0x8000;
                shiftTable[i] = 24;
                shiftTable[i | 0x100] = 24; // small number (denorm)
              } else if (e < -14) {
                baseTable[i] = 0x0400 >> -e - 14;
                baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
                shiftTable[i] = -e - 1;
                shiftTable[i | 0x100] = -e - 1; // normal number
              } else if (e <= 15) {
                baseTable[i] = e + 15 << 10;
                baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
                shiftTable[i] = 13;
                shiftTable[i | 0x100] = 13; // large number (Infinity, -Infinity)
              } else if (e < 128) {
                baseTable[i] = 0x7c00;
                baseTable[i | 0x100] = 0xfc00;
                shiftTable[i] = 24;
                shiftTable[i | 0x100] = 24; // stay (NaN, Infinity, -Infinity)
              } else {
                baseTable[i] = 0x7c00;
                baseTable[i | 0x100] = 0xfc00;
                shiftTable[i] = 13;
                shiftTable[i | 0x100] = 13;
              }
            } // float16 to float32 helpers
            var mantissaTable = new Uint32Array(2048);
            var exponentTable = new Uint32Array(64);
            var offsetTable = new Uint32Array(64);
            for (var _i92 = 1; _i92 < 1024; ++_i92) {
              var m = _i92 << 13; // zero pad mantissa bits
              var _e4 = 0; // zero exponent
              // normalized
              while ((m & 0x00800000) === 0) {
                m <<= 1;
                _e4 -= 0x00800000; // decrement exponent
              }
              m &= ~0x00800000; // clear leading 1 bit
              _e4 += 0x38800000; // adjust bias
              mantissaTable[_i92] = m | _e4;
            }
            for (var _i93 = 1024; _i93 < 2048; ++_i93) {
              mantissaTable[_i93] = 0x38000000 + (_i93 - 1024 << 13);
            }
            for (var _i94 = 1; _i94 < 31; ++_i94) {
              exponentTable[_i94] = _i94 << 23;
            }
            exponentTable[31] = 0x47800000;
            exponentTable[32] = 0x80000000;
            for (var _i95 = 33; _i95 < 63; ++_i95) {
              exponentTable[_i95] = 0x80000000 + (_i95 - 32 << 23);
            }
            exponentTable[63] = 0xc7800000;
            for (var _i96 = 1; _i96 < 64; ++_i96) {
              if (_i96 !== 32) {
                offsetTable[_i96] = 1024;
              }
            }
            return {
              floatView: floatView,
              uint32View: uint32View,
              baseTable: baseTable,
              shiftTable: shiftTable,
              mantissaTable: mantissaTable,
              exponentTable: exponentTable,
              offsetTable: offsetTable
            };
          } // float32 to float16
          function toHalfFloat(val) {
            if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
            val = clamp(val, -65504, 65504);
            _tables.floatView[0] = val;
            var f = _tables.uint32View[0];
            var e = f >> 23 & 0x1ff;
            return _tables.baseTable[e] + ((f & 0x007fffff) >> _tables.shiftTable[e]);
          } // float16 to float32
          function fromHalfFloat(val) {
            var m = val >> 10;
            _tables.uint32View[0] = _tables.mantissaTable[_tables.offsetTable[m] + (val & 0x3ff)] + _tables.exponentTable[m];
            return _tables.floatView[0];
          }
          var _DataUtils = /*#__PURE__*/Object.freeze({
            __proto__: null,
            toHalfFloat: toHalfFloat,
            fromHalfFloat: fromHalfFloat
          }); // r134, d65e0af06644fe5a84a6fc0e372f4318f95a04c0
          function _ImmediateRenderObject() {
            console.error('THREE.ImmediateRenderObject has been removed.');
          } // r138, 48b05d3500acc084df50be9b4c90781ad9b8cb17
          var _WebGLMultisampleRenderTarget = /*#__PURE__*/function (_WebGLRenderTarget6) {
            _inherits(_WebGLMultisampleRenderTarget, _WebGLRenderTarget6);
            var _super167 = _createSuper(_WebGLMultisampleRenderTarget);
            function _WebGLMultisampleRenderTarget(width, height, options) {
              var _this140;
              _classCallCheck2(this, _WebGLMultisampleRenderTarget);
              console.error('THREE.WebGLMultisampleRenderTarget has been removed. Use a normal render target and set the "samples" property to greater 0 to enable multisampling.');
              _this140 = _super167.call(this, width, height, options);
              _this140.samples = 4;
              return _this140;
            }
            return _createClass2(_WebGLMultisampleRenderTarget);
          }(_WebGLRenderTarget); // r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
          var _DataTexture2DArray = /*#__PURE__*/function (_DataArrayTexture2) {
            _inherits(_DataTexture2DArray, _DataArrayTexture2);
            var _super168 = _createSuper(_DataTexture2DArray);
            function _DataTexture2DArray(data, width, height, depth) {
              _classCallCheck2(this, _DataTexture2DArray);
              console.warn('THREE.DataTexture2DArray has been renamed to DataArrayTexture.');
              return _super168.call(this, data, width, height, depth);
            }
            return _createClass2(_DataTexture2DArray);
          }(_DataArrayTexture); // r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
          var _DataTexture3D = /*#__PURE__*/function (_Data3DTexture2) {
            _inherits(_DataTexture3D, _Data3DTexture2);
            var _super169 = _createSuper(_DataTexture3D);
            function _DataTexture3D(data, width, height, depth) {
              _classCallCheck2(this, _DataTexture3D);
              console.warn('THREE.DataTexture3D has been renamed to Data3DTexture.');
              return _super169.call(this, data, width, height, depth);
            }
            return _createClass2(_DataTexture3D);
          }(_Data3DTexture); // r144
          var _BoxBufferGeometry = /*#__PURE__*/function (_BoxGeometry2) {
            _inherits(_BoxBufferGeometry, _BoxGeometry2);
            var _super170 = _createSuper(_BoxBufferGeometry);
            function _BoxBufferGeometry(width, height, depth, widthSegments, heightSegments, depthSegments) {
              _classCallCheck2(this, _BoxBufferGeometry);
              console.warn('THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.');
              return _super170.call(this, width, height, depth, widthSegments, heightSegments, depthSegments);
            }
            return _createClass2(_BoxBufferGeometry);
          }(_BoxGeometry); // r144
          var _CapsuleBufferGeometry = /*#__PURE__*/function (_CapsuleGeometry2) {
            _inherits(_CapsuleBufferGeometry, _CapsuleGeometry2);
            var _super171 = _createSuper(_CapsuleBufferGeometry);
            function _CapsuleBufferGeometry(radius, length, capSegments, radialSegments) {
              _classCallCheck2(this, _CapsuleBufferGeometry);
              console.warn('THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.');
              return _super171.call(this, radius, length, capSegments, radialSegments);
            }
            return _createClass2(_CapsuleBufferGeometry);
          }(_CapsuleGeometry); // r144
          var _CircleBufferGeometry = /*#__PURE__*/function (_CircleGeometry2) {
            _inherits(_CircleBufferGeometry, _CircleGeometry2);
            var _super172 = _createSuper(_CircleBufferGeometry);
            function _CircleBufferGeometry(radius, segments, thetaStart, thetaLength) {
              _classCallCheck2(this, _CircleBufferGeometry);
              console.warn('THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.');
              return _super172.call(this, radius, segments, thetaStart, thetaLength);
            }
            return _createClass2(_CircleBufferGeometry);
          }(_CircleGeometry); // r144
          var _ConeBufferGeometry = /*#__PURE__*/function (_ConeGeometry2) {
            _inherits(_ConeBufferGeometry, _ConeGeometry2);
            var _super173 = _createSuper(_ConeBufferGeometry);
            function _ConeBufferGeometry(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength) {
              _classCallCheck2(this, _ConeBufferGeometry);
              console.warn('THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.');
              return _super173.call(this, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
            }
            return _createClass2(_ConeBufferGeometry);
          }(_ConeGeometry); // r144
          var _CylinderBufferGeometry = /*#__PURE__*/function (_CylinderGeometry3) {
            _inherits(_CylinderBufferGeometry, _CylinderGeometry3);
            var _super174 = _createSuper(_CylinderBufferGeometry);
            function _CylinderBufferGeometry(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength) {
              _classCallCheck2(this, _CylinderBufferGeometry);
              console.warn('THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.');
              return _super174.call(this, radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
            }
            return _createClass2(_CylinderBufferGeometry);
          }(_CylinderGeometry); // r144
          var _DodecahedronBufferGeometry = /*#__PURE__*/function (_DodecahedronGeometry2) {
            _inherits(_DodecahedronBufferGeometry, _DodecahedronGeometry2);
            var _super175 = _createSuper(_DodecahedronBufferGeometry);
            function _DodecahedronBufferGeometry(radius, detail) {
              _classCallCheck2(this, _DodecahedronBufferGeometry);
              console.warn('THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.');
              return _super175.call(this, radius, detail);
            }
            return _createClass2(_DodecahedronBufferGeometry);
          }(_DodecahedronGeometry); // r144
          var _ExtrudeBufferGeometry = /*#__PURE__*/function (_ExtrudeGeometry2) {
            _inherits(_ExtrudeBufferGeometry, _ExtrudeGeometry2);
            var _super176 = _createSuper(_ExtrudeBufferGeometry);
            function _ExtrudeBufferGeometry(shapes, options) {
              _classCallCheck2(this, _ExtrudeBufferGeometry);
              console.warn('THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.');
              return _super176.call(this, shapes, options);
            }
            return _createClass2(_ExtrudeBufferGeometry);
          }(_ExtrudeGeometry); // r144
          var _IcosahedronBufferGeometry = /*#__PURE__*/function (_IcosahedronGeometry2) {
            _inherits(_IcosahedronBufferGeometry, _IcosahedronGeometry2);
            var _super177 = _createSuper(_IcosahedronBufferGeometry);
            function _IcosahedronBufferGeometry(radius, detail) {
              _classCallCheck2(this, _IcosahedronBufferGeometry);
              console.warn('THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.');
              return _super177.call(this, radius, detail);
            }
            return _createClass2(_IcosahedronBufferGeometry);
          }(_IcosahedronGeometry); // r144
          var _LatheBufferGeometry = /*#__PURE__*/function (_LatheGeometry3) {
            _inherits(_LatheBufferGeometry, _LatheGeometry3);
            var _super178 = _createSuper(_LatheBufferGeometry);
            function _LatheBufferGeometry(points, segments, phiStart, phiLength) {
              _classCallCheck2(this, _LatheBufferGeometry);
              console.warn('THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.');
              return _super178.call(this, points, segments, phiStart, phiLength);
            }
            return _createClass2(_LatheBufferGeometry);
          }(_LatheGeometry); // r144
          var _OctahedronBufferGeometry = /*#__PURE__*/function (_OctahedronGeometry2) {
            _inherits(_OctahedronBufferGeometry, _OctahedronGeometry2);
            var _super179 = _createSuper(_OctahedronBufferGeometry);
            function _OctahedronBufferGeometry(radius, detail) {
              _classCallCheck2(this, _OctahedronBufferGeometry);
              console.warn('THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.');
              return _super179.call(this, radius, detail);
            }
            return _createClass2(_OctahedronBufferGeometry);
          }(_OctahedronGeometry); // r144
          var _PlaneBufferGeometry = /*#__PURE__*/function (_PlaneGeometry2) {
            _inherits(_PlaneBufferGeometry, _PlaneGeometry2);
            var _super180 = _createSuper(_PlaneBufferGeometry);
            function _PlaneBufferGeometry(width, height, widthSegments, heightSegments) {
              _classCallCheck2(this, _PlaneBufferGeometry);
              console.warn('THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.');
              return _super180.call(this, width, height, widthSegments, heightSegments);
            }
            return _createClass2(_PlaneBufferGeometry);
          }(_PlaneGeometry); // r144
          var _PolyhedronBufferGeometry = /*#__PURE__*/function (_PolyhedronGeometry6) {
            _inherits(_PolyhedronBufferGeometry, _PolyhedronGeometry6);
            var _super181 = _createSuper(_PolyhedronBufferGeometry);
            function _PolyhedronBufferGeometry(vertices, indices, radius, detail) {
              _classCallCheck2(this, _PolyhedronBufferGeometry);
              console.warn('THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.');
              return _super181.call(this, vertices, indices, radius, detail);
            }
            return _createClass2(_PolyhedronBufferGeometry);
          }(_PolyhedronGeometry); // r144
          var _RingBufferGeometry = /*#__PURE__*/function (_RingGeometry2) {
            _inherits(_RingBufferGeometry, _RingGeometry2);
            var _super182 = _createSuper(_RingBufferGeometry);
            function _RingBufferGeometry(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength) {
              _classCallCheck2(this, _RingBufferGeometry);
              console.warn('THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.');
              return _super182.call(this, innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
            }
            return _createClass2(_RingBufferGeometry);
          }(_RingGeometry); // r144
          var _ShapeBufferGeometry = /*#__PURE__*/function (_ShapeGeometry2) {
            _inherits(_ShapeBufferGeometry, _ShapeGeometry2);
            var _super183 = _createSuper(_ShapeBufferGeometry);
            function _ShapeBufferGeometry(shapes, curveSegments) {
              _classCallCheck2(this, _ShapeBufferGeometry);
              console.warn('THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.');
              return _super183.call(this, shapes, curveSegments);
            }
            return _createClass2(_ShapeBufferGeometry);
          }(_ShapeGeometry); // r144
          var _SphereBufferGeometry = /*#__PURE__*/function (_SphereGeometry2) {
            _inherits(_SphereBufferGeometry, _SphereGeometry2);
            var _super184 = _createSuper(_SphereBufferGeometry);
            function _SphereBufferGeometry(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength) {
              _classCallCheck2(this, _SphereBufferGeometry);
              console.warn('THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.');
              return _super184.call(this, radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
            }
            return _createClass2(_SphereBufferGeometry);
          }(_SphereGeometry); // r144
          var _TetrahedronBufferGeometry = /*#__PURE__*/function (_TetrahedronGeometry2) {
            _inherits(_TetrahedronBufferGeometry, _TetrahedronGeometry2);
            var _super185 = _createSuper(_TetrahedronBufferGeometry);
            function _TetrahedronBufferGeometry(radius, detail) {
              _classCallCheck2(this, _TetrahedronBufferGeometry);
              console.warn('THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.');
              return _super185.call(this, radius, detail);
            }
            return _createClass2(_TetrahedronBufferGeometry);
          }(_TetrahedronGeometry); // r144
          var _TorusBufferGeometry = /*#__PURE__*/function (_TorusGeometry2) {
            _inherits(_TorusBufferGeometry, _TorusGeometry2);
            var _super186 = _createSuper(_TorusBufferGeometry);
            function _TorusBufferGeometry(radius, tube, radialSegments, tubularSegments, arc) {
              _classCallCheck2(this, _TorusBufferGeometry);
              console.warn('THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.');
              return _super186.call(this, radius, tube, radialSegments, tubularSegments, arc);
            }
            return _createClass2(_TorusBufferGeometry);
          }(_TorusGeometry); // r144
          var _TorusKnotBufferGeometry = /*#__PURE__*/function (_TorusKnotGeometry2) {
            _inherits(_TorusKnotBufferGeometry, _TorusKnotGeometry2);
            var _super187 = _createSuper(_TorusKnotBufferGeometry);
            function _TorusKnotBufferGeometry(radius, tube, tubularSegments, radialSegments, p, q) {
              _classCallCheck2(this, _TorusKnotBufferGeometry);
              console.warn('THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.');
              return _super187.call(this, radius, tube, tubularSegments, radialSegments, p, q);
            }
            return _createClass2(_TorusKnotBufferGeometry);
          }(_TorusKnotGeometry); // r144
          var _TubeBufferGeometry = /*#__PURE__*/function (_TubeGeometry2) {
            _inherits(_TubeBufferGeometry, _TubeGeometry2);
            var _super188 = _createSuper(_TubeBufferGeometry);
            function _TubeBufferGeometry(path, tubularSegments, radius, radialSegments, closed) {
              _classCallCheck2(this, _TubeBufferGeometry);
              console.warn('THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.');
              return _super188.call(this, path, tubularSegments, radius, radialSegments, closed);
            }
            return _createClass2(_TubeBufferGeometry);
          }(_TubeGeometry);
          if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
            __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
              detail: {
                revision: _REVISION
              }
            }));
          }
          if (typeof window !== 'undefined') {
            if (window.__THREE__) {
              console.warn('WARNING: Multiple instances of Three.js being imported.');
            } else {
              window.__THREE__ = _REVISION;
            }
          }

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/libs/ktx-parse.module.js":
        /*!************************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/libs/ktx-parse.module.js ***!
          \************************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLibsKtxParseModuleJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"KHR_DF_CHANNEL_RGBSDA_ALPHA": function KHR_DF_CHANNEL_RGBSDA_ALPHA() {
              return (/* binding */Q
              );
            },
            /* harmony export */"KHR_DF_CHANNEL_RGBSDA_BLUE": function KHR_DF_CHANNEL_RGBSDA_BLUE() {
              return (/* binding */q
              );
            },
            /* harmony export */"KHR_DF_CHANNEL_RGBSDA_DEPTH": function KHR_DF_CHANNEL_RGBSDA_DEPTH() {
              return (/* binding */J
              );
            },
            /* harmony export */"KHR_DF_CHANNEL_RGBSDA_GREEN": function KHR_DF_CHANNEL_RGBSDA_GREEN() {
              return (/* binding */Y
              );
            },
            /* harmony export */"KHR_DF_CHANNEL_RGBSDA_RED": function KHR_DF_CHANNEL_RGBSDA_RED() {
              return (/* binding */R
              );
            },
            /* harmony export */"KHR_DF_CHANNEL_RGBSDA_STENCIL": function KHR_DF_CHANNEL_RGBSDA_STENCIL() {
              return (/* binding */G
              );
            },
            /* harmony export */"KHR_DF_FLAG_ALPHA_PREMULTIPLIED": function KHR_DF_FLAG_ALPHA_PREMULTIPLIED() {
              return (/* binding */p
              );
            },
            /* harmony export */"KHR_DF_FLAG_ALPHA_STRAIGHT": function KHR_DF_FLAG_ALPHA_STRAIGHT() {
              return (/* binding */_
              );
            },
            /* harmony export */"KHR_DF_KHR_DESCRIPTORTYPE_BASICFORMAT": function KHR_DF_KHR_DESCRIPTORTYPE_BASICFORMAT() {
              return (/* binding */s
              );
            },
            /* harmony export */"KHR_DF_MODEL_ASTC": function KHR_DF_MODEL_ASTC() {
              return (/* binding */c
              );
            },
            /* harmony export */"KHR_DF_MODEL_ETC1": function KHR_DF_MODEL_ETC1() {
              return (/* binding */f
              );
            },
            /* harmony export */"KHR_DF_MODEL_ETC1S": function KHR_DF_MODEL_ETC1S() {
              return (/* binding */h
              );
            },
            /* harmony export */"KHR_DF_MODEL_ETC2": function KHR_DF_MODEL_ETC2() {
              return (/* binding */U
              );
            },
            /* harmony export */"KHR_DF_MODEL_RGBSDA": function KHR_DF_MODEL_RGBSDA() {
              return (/* binding */l
              );
            },
            /* harmony export */"KHR_DF_MODEL_UNSPECIFIED": function KHR_DF_MODEL_UNSPECIFIED() {
              return (/* binding */o
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_ACES": function KHR_DF_PRIMARIES_ACES() {
              return (/* binding */W
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_ACESCC": function KHR_DF_PRIMARIES_ACESCC() {
              return (/* binding */N
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_ADOBERGB": function KHR_DF_PRIMARIES_ADOBERGB() {
              return (/* binding */j
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_BT2020": function KHR_DF_PRIMARIES_BT2020() {
              return (/* binding */z
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_BT601_EBU": function KHR_DF_PRIMARIES_BT601_EBU() {
              return (/* binding */P
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_BT601_SMPTE": function KHR_DF_PRIMARIES_BT601_SMPTE() {
              return (/* binding */C
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_BT709": function KHR_DF_PRIMARIES_BT709() {
              return (/* binding */F
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_CIEXYZ": function KHR_DF_PRIMARIES_CIEXYZ() {
              return (/* binding */M
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_DISPLAYP3": function KHR_DF_PRIMARIES_DISPLAYP3() {
              return (/* binding */X
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_NTSC1953": function KHR_DF_PRIMARIES_NTSC1953() {
              return (/* binding */H
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_PAL525": function KHR_DF_PRIMARIES_PAL525() {
              return (/* binding */K
              );
            },
            /* harmony export */"KHR_DF_PRIMARIES_UNSPECIFIED": function KHR_DF_PRIMARIES_UNSPECIFIED() {
              return (/* binding */E
              );
            },
            /* harmony export */"KHR_DF_SAMPLE_DATATYPE_EXPONENT": function KHR_DF_SAMPLE_DATATYPE_EXPONENT() {
              return (/* binding */tt
              );
            },
            /* harmony export */"KHR_DF_SAMPLE_DATATYPE_FLOAT": function KHR_DF_SAMPLE_DATATYPE_FLOAT() {
              return (/* binding */Z
              );
            },
            /* harmony export */"KHR_DF_SAMPLE_DATATYPE_LINEAR": function KHR_DF_SAMPLE_DATATYPE_LINEAR() {
              return (/* binding */et
              );
            },
            /* harmony export */"KHR_DF_SAMPLE_DATATYPE_SIGNED": function KHR_DF_SAMPLE_DATATYPE_SIGNED() {
              return (/* binding */$
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_ACESCC": function KHR_DF_TRANSFER_ACESCC() {
              return (/* binding */O
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_ACESCCT": function KHR_DF_TRANSFER_ACESCCT() {
              return (/* binding */T
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_ADOBERGB": function KHR_DF_TRANSFER_ADOBERGB() {
              return (/* binding */V
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_BT1886": function KHR_DF_TRANSFER_BT1886() {
              return (/* binding */w
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_DCIP3": function KHR_DF_TRANSFER_DCIP3() {
              return (/* binding */k
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_HLG_EOTF": function KHR_DF_TRANSFER_HLG_EOTF() {
              return (/* binding */B
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_HLG_OETF": function KHR_DF_TRANSFER_HLG_OETF() {
              return (/* binding */D
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_ITU": function KHR_DF_TRANSFER_ITU() {
              return (/* binding */u
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_LINEAR": function KHR_DF_TRANSFER_LINEAR() {
              return (/* binding */y
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_NTSC": function KHR_DF_TRANSFER_NTSC() {
              return (/* binding */b
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_PAL625_EOTF": function KHR_DF_TRANSFER_PAL625_EOTF() {
              return (/* binding */S
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_PAL_OETF": function KHR_DF_TRANSFER_PAL_OETF() {
              return (/* binding */v
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_PQ_EOTF": function KHR_DF_TRANSFER_PQ_EOTF() {
              return (/* binding */L
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_PQ_OETF": function KHR_DF_TRANSFER_PQ_OETF() {
              return (/* binding */A
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_SLOG": function KHR_DF_TRANSFER_SLOG() {
              return (/* binding */d
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_SLOG2": function KHR_DF_TRANSFER_SLOG2() {
              return (/* binding */m
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_SRGB": function KHR_DF_TRANSFER_SRGB() {
              return (/* binding */x
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_ST240": function KHR_DF_TRANSFER_ST240() {
              return (/* binding */I
              );
            },
            /* harmony export */"KHR_DF_TRANSFER_UNSPECIFIED": function KHR_DF_TRANSFER_UNSPECIFIED() {
              return (/* binding */g
              );
            },
            /* harmony export */"KHR_DF_VENDORID_KHRONOS": function KHR_DF_VENDORID_KHRONOS() {
              return (/* binding */a
              );
            },
            /* harmony export */"KHR_DF_VERSION": function KHR_DF_VERSION() {
              return (/* binding */r
              );
            },
            /* harmony export */"KHR_SUPERCOMPRESSION_BASISLZ": function KHR_SUPERCOMPRESSION_BASISLZ() {
              return (/* binding */e
              );
            },
            /* harmony export */"KHR_SUPERCOMPRESSION_NONE": function KHR_SUPERCOMPRESSION_NONE() {
              return (/* binding */t
              );
            },
            /* harmony export */"KHR_SUPERCOMPRESSION_ZLIB": function KHR_SUPERCOMPRESSION_ZLIB() {
              return (/* binding */i
              );
            },
            /* harmony export */"KHR_SUPERCOMPRESSION_ZSTD": function KHR_SUPERCOMPRESSION_ZSTD() {
              return (/* binding */n
              );
            },
            /* harmony export */"KTX2Container": function KTX2Container() {
              return (/* binding */Si
              );
            },
            /* harmony export */"VK_FORMAT_A1R5G5B5_UNORM_PACK16": function VK_FORMAT_A1R5G5B5_UNORM_PACK16() {
              return (/* binding */Ut
              );
            },
            /* harmony export */"VK_FORMAT_A2B10G10R10_SINT_PACK32": function VK_FORMAT_A2B10G10R10_SINT_PACK32() {
              return (/* binding */qt
              );
            },
            /* harmony export */"VK_FORMAT_A2B10G10R10_SNORM_PACK32": function VK_FORMAT_A2B10G10R10_SNORM_PACK32() {
              return (/* binding */Rt
              );
            },
            /* harmony export */"VK_FORMAT_A2B10G10R10_UINT_PACK32": function VK_FORMAT_A2B10G10R10_UINT_PACK32() {
              return (/* binding */Yt
              );
            },
            /* harmony export */"VK_FORMAT_A2B10G10R10_UNORM_PACK32": function VK_FORMAT_A2B10G10R10_UNORM_PACK32() {
              return (/* binding */jt
              );
            },
            /* harmony export */"VK_FORMAT_A2R10G10B10_SINT_PACK32": function VK_FORMAT_A2R10G10B10_SINT_PACK32() {
              return (/* binding */Xt
              );
            },
            /* harmony export */"VK_FORMAT_A2R10G10B10_SNORM_PACK32": function VK_FORMAT_A2R10G10B10_SNORM_PACK32() {
              return (/* binding */Ht
              );
            },
            /* harmony export */"VK_FORMAT_A2R10G10B10_UINT_PACK32": function VK_FORMAT_A2R10G10B10_UINT_PACK32() {
              return (/* binding */Kt
              );
            },
            /* harmony export */"VK_FORMAT_A2R10G10B10_UNORM_PACK32": function VK_FORMAT_A2R10G10B10_UNORM_PACK32() {
              return (/* binding */Nt
              );
            },
            /* harmony export */"VK_FORMAT_A4B4G4R4_UNORM_PACK16_EXT": function VK_FORMAT_A4B4G4R4_UNORM_PACK16_EXT() {
              return (/* binding */vi
              );
            },
            /* harmony export */"VK_FORMAT_A4R4G4B4_UNORM_PACK16_EXT": function VK_FORMAT_A4R4G4B4_UNORM_PACK16_EXT() {
              return (/* binding */ki
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x10_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_10x10_SFLOAT_BLOCK_EXT() {
              return (/* binding */Bi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x10_SRGB_BLOCK": function VK_FORMAT_ASTC_10x10_SRGB_BLOCK() {
              return (/* binding */Xn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x10_UNORM_BLOCK": function VK_FORMAT_ASTC_10x10_UNORM_BLOCK() {
              return (/* binding */Kn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x5_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_10x5_SFLOAT_BLOCK_EXT() {
              return (/* binding */mi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x5_SRGB_BLOCK": function VK_FORMAT_ASTC_10x5_SRGB_BLOCK() {
              return (/* binding */zn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x5_UNORM_BLOCK": function VK_FORMAT_ASTC_10x5_UNORM_BLOCK() {
              return (/* binding */Cn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x6_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_10x6_SFLOAT_BLOCK_EXT() {
              return (/* binding */wi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x6_SRGB_BLOCK": function VK_FORMAT_ASTC_10x6_SRGB_BLOCK() {
              return (/* binding */Wn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x6_UNORM_BLOCK": function VK_FORMAT_ASTC_10x6_UNORM_BLOCK() {
              return (/* binding */Mn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x8_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_10x8_SFLOAT_BLOCK_EXT() {
              return (/* binding */Di
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x8_SRGB_BLOCK": function VK_FORMAT_ASTC_10x8_SRGB_BLOCK() {
              return (/* binding */Hn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_10x8_UNORM_BLOCK": function VK_FORMAT_ASTC_10x8_UNORM_BLOCK() {
              return (/* binding */Nn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_12x10_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_12x10_SFLOAT_BLOCK_EXT() {
              return (/* binding */Li
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_12x10_SRGB_BLOCK": function VK_FORMAT_ASTC_12x10_SRGB_BLOCK() {
              return (/* binding */Rn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_12x10_UNORM_BLOCK": function VK_FORMAT_ASTC_12x10_UNORM_BLOCK() {
              return (/* binding */jn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_12x12_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_12x12_SFLOAT_BLOCK_EXT() {
              return (/* binding */Ai
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_12x12_SRGB_BLOCK": function VK_FORMAT_ASTC_12x12_SRGB_BLOCK() {
              return (/* binding */qn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_12x12_UNORM_BLOCK": function VK_FORMAT_ASTC_12x12_UNORM_BLOCK() {
              return (/* binding */Yn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_4x4_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_4x4_SFLOAT_BLOCK_EXT() {
              return (/* binding */_i
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_4x4_SRGB_BLOCK": function VK_FORMAT_ASTC_4x4_SRGB_BLOCK() {
              return (/* binding */wn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_4x4_UNORM_BLOCK": function VK_FORMAT_ASTC_4x4_UNORM_BLOCK() {
              return (/* binding */mn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_5x4_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_5x4_SFLOAT_BLOCK_EXT() {
              return (/* binding */pi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_5x4_SRGB_BLOCK": function VK_FORMAT_ASTC_5x4_SRGB_BLOCK() {
              return (/* binding */Bn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_5x4_UNORM_BLOCK": function VK_FORMAT_ASTC_5x4_UNORM_BLOCK() {
              return (/* binding */Dn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_5x5_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_5x5_SFLOAT_BLOCK_EXT() {
              return (/* binding */gi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_5x5_SRGB_BLOCK": function VK_FORMAT_ASTC_5x5_SRGB_BLOCK() {
              return (/* binding */An
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_5x5_UNORM_BLOCK": function VK_FORMAT_ASTC_5x5_UNORM_BLOCK() {
              return (/* binding */Ln
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_6x5_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_6x5_SFLOAT_BLOCK_EXT() {
              return (/* binding */yi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_6x5_SRGB_BLOCK": function VK_FORMAT_ASTC_6x5_SRGB_BLOCK() {
              return (/* binding */vn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_6x5_UNORM_BLOCK": function VK_FORMAT_ASTC_6x5_UNORM_BLOCK() {
              return (/* binding */kn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_6x6_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_6x6_SFLOAT_BLOCK_EXT() {
              return (/* binding */xi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_6x6_SRGB_BLOCK": function VK_FORMAT_ASTC_6x6_SRGB_BLOCK() {
              return (/* binding */In
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_6x6_UNORM_BLOCK": function VK_FORMAT_ASTC_6x6_UNORM_BLOCK() {
              return (/* binding */Sn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x5_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_8x5_SFLOAT_BLOCK_EXT() {
              return (/* binding */ui
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x5_SRGB_BLOCK": function VK_FORMAT_ASTC_8x5_SRGB_BLOCK() {
              return (/* binding */Tn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x5_UNORM_BLOCK": function VK_FORMAT_ASTC_8x5_UNORM_BLOCK() {
              return (/* binding */On
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x6_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_8x6_SFLOAT_BLOCK_EXT() {
              return (/* binding */bi
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x6_SRGB_BLOCK": function VK_FORMAT_ASTC_8x6_SRGB_BLOCK() {
              return (/* binding */En
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x6_UNORM_BLOCK": function VK_FORMAT_ASTC_8x6_UNORM_BLOCK() {
              return (/* binding */Vn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x8_SFLOAT_BLOCK_EXT": function VK_FORMAT_ASTC_8x8_SFLOAT_BLOCK_EXT() {
              return (/* binding */di
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x8_SRGB_BLOCK": function VK_FORMAT_ASTC_8x8_SRGB_BLOCK() {
              return (/* binding */Pn
              );
            },
            /* harmony export */"VK_FORMAT_ASTC_8x8_UNORM_BLOCK": function VK_FORMAT_ASTC_8x8_UNORM_BLOCK() {
              return (/* binding */Fn
              );
            },
            /* harmony export */"VK_FORMAT_B10G11R11_UFLOAT_PACK32": function VK_FORMAT_B10G11R11_UFLOAT_PACK32() {
              return (/* binding */Me
              );
            },
            /* harmony export */"VK_FORMAT_B10X6G10X6R10X6G10X6_422_UNORM_4PACK16": function VK_FORMAT_B10X6G10X6R10X6G10X6_422_UNORM_4PACK16() {
              return (/* binding */$n
              );
            },
            /* harmony export */"VK_FORMAT_B12X4G12X4R12X4G12X4_422_UNORM_4PACK16": function VK_FORMAT_B12X4G12X4R12X4G12X4_422_UNORM_4PACK16() {
              return (/* binding */si
              );
            },
            /* harmony export */"VK_FORMAT_B4G4R4A4_UNORM_PACK16": function VK_FORMAT_B4G4R4A4_UNORM_PACK16() {
              return (/* binding */at
              );
            },
            /* harmony export */"VK_FORMAT_B5G5R5A1_UNORM_PACK16": function VK_FORMAT_B5G5R5A1_UNORM_PACK16() {
              return (/* binding */ft
              );
            },
            /* harmony export */"VK_FORMAT_B5G6R5_UNORM_PACK16": function VK_FORMAT_B5G6R5_UNORM_PACK16() {
              return (/* binding */ot
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8A8_SINT": function VK_FORMAT_B8G8R8A8_SINT() {
              return (/* binding */Mt
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8A8_SNORM": function VK_FORMAT_B8G8R8A8_SNORM() {
              return (/* binding */Ct
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8A8_SRGB": function VK_FORMAT_B8G8R8A8_SRGB() {
              return (/* binding */Wt
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8A8_UINT": function VK_FORMAT_B8G8R8A8_UINT() {
              return (/* binding */zt
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8A8_UNORM": function VK_FORMAT_B8G8R8A8_UNORM() {
              return (/* binding */Pt
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8_SINT": function VK_FORMAT_B8G8R8_SINT() {
              return (/* binding */St
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8_SNORM": function VK_FORMAT_B8G8R8_SNORM() {
              return (/* binding */kt
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8_SRGB": function VK_FORMAT_B8G8R8_SRGB() {
              return (/* binding */It
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8_UINT": function VK_FORMAT_B8G8R8_UINT() {
              return (/* binding */vt
              );
            },
            /* harmony export */"VK_FORMAT_B8G8R8_UNORM": function VK_FORMAT_B8G8R8_UNORM() {
              return (/* binding */At
              );
            },
            /* harmony export */"VK_FORMAT_BC1_RGBA_SRGB_BLOCK": function VK_FORMAT_BC1_RGBA_SRGB_BLOCK() {
              return (/* binding */Qe
              );
            },
            /* harmony export */"VK_FORMAT_BC1_RGBA_UNORM_BLOCK": function VK_FORMAT_BC1_RGBA_UNORM_BLOCK() {
              return (/* binding */Je
              );
            },
            /* harmony export */"VK_FORMAT_BC1_RGB_SRGB_BLOCK": function VK_FORMAT_BC1_RGB_SRGB_BLOCK() {
              return (/* binding */Ge
              );
            },
            /* harmony export */"VK_FORMAT_BC1_RGB_UNORM_BLOCK": function VK_FORMAT_BC1_RGB_UNORM_BLOCK() {
              return (/* binding */qe
              );
            },
            /* harmony export */"VK_FORMAT_BC2_SRGB_BLOCK": function VK_FORMAT_BC2_SRGB_BLOCK() {
              return (/* binding */$e
              );
            },
            /* harmony export */"VK_FORMAT_BC2_UNORM_BLOCK": function VK_FORMAT_BC2_UNORM_BLOCK() {
              return (/* binding */Ze
              );
            },
            /* harmony export */"VK_FORMAT_BC3_SRGB_BLOCK": function VK_FORMAT_BC3_SRGB_BLOCK() {
              return (/* binding */en
              );
            },
            /* harmony export */"VK_FORMAT_BC3_UNORM_BLOCK": function VK_FORMAT_BC3_UNORM_BLOCK() {
              return (/* binding */tn
              );
            },
            /* harmony export */"VK_FORMAT_BC4_SNORM_BLOCK": function VK_FORMAT_BC4_SNORM_BLOCK() {
              return (/* binding */sn
              );
            },
            /* harmony export */"VK_FORMAT_BC4_UNORM_BLOCK": function VK_FORMAT_BC4_UNORM_BLOCK() {
              return (/* binding */nn
              );
            },
            /* harmony export */"VK_FORMAT_BC5_SNORM_BLOCK": function VK_FORMAT_BC5_SNORM_BLOCK() {
              return (/* binding */rn
              );
            },
            /* harmony export */"VK_FORMAT_BC5_UNORM_BLOCK": function VK_FORMAT_BC5_UNORM_BLOCK() {
              return (/* binding */an
              );
            },
            /* harmony export */"VK_FORMAT_BC6H_SFLOAT_BLOCK": function VK_FORMAT_BC6H_SFLOAT_BLOCK() {
              return (/* binding */ln
              );
            },
            /* harmony export */"VK_FORMAT_BC6H_UFLOAT_BLOCK": function VK_FORMAT_BC6H_UFLOAT_BLOCK() {
              return (/* binding */on
              );
            },
            /* harmony export */"VK_FORMAT_BC7_SRGB_BLOCK": function VK_FORMAT_BC7_SRGB_BLOCK() {
              return (/* binding */Un
              );
            },
            /* harmony export */"VK_FORMAT_BC7_UNORM_BLOCK": function VK_FORMAT_BC7_UNORM_BLOCK() {
              return (/* binding */fn
              );
            },
            /* harmony export */"VK_FORMAT_D16_UNORM": function VK_FORMAT_D16_UNORM() {
              return (/* binding */Ne
              );
            },
            /* harmony export */"VK_FORMAT_D16_UNORM_S8_UINT": function VK_FORMAT_D16_UNORM_S8_UINT() {
              return (/* binding */je
              );
            },
            /* harmony export */"VK_FORMAT_D24_UNORM_S8_UINT": function VK_FORMAT_D24_UNORM_S8_UINT() {
              return (/* binding */Re
              );
            },
            /* harmony export */"VK_FORMAT_D32_SFLOAT": function VK_FORMAT_D32_SFLOAT() {
              return (/* binding */Ke
              );
            },
            /* harmony export */"VK_FORMAT_D32_SFLOAT_S8_UINT": function VK_FORMAT_D32_SFLOAT_S8_UINT() {
              return (/* binding */Ye
              );
            },
            /* harmony export */"VK_FORMAT_E5B9G9R9_UFLOAT_PACK32": function VK_FORMAT_E5B9G9R9_UFLOAT_PACK32() {
              return (/* binding */We
              );
            },
            /* harmony export */"VK_FORMAT_EAC_R11G11_SNORM_BLOCK": function VK_FORMAT_EAC_R11G11_SNORM_BLOCK() {
              return (/* binding */dn
              );
            },
            /* harmony export */"VK_FORMAT_EAC_R11G11_UNORM_BLOCK": function VK_FORMAT_EAC_R11G11_UNORM_BLOCK() {
              return (/* binding */bn
              );
            },
            /* harmony export */"VK_FORMAT_EAC_R11_SNORM_BLOCK": function VK_FORMAT_EAC_R11_SNORM_BLOCK() {
              return (/* binding */un
              );
            },
            /* harmony export */"VK_FORMAT_EAC_R11_UNORM_BLOCK": function VK_FORMAT_EAC_R11_UNORM_BLOCK() {
              return (/* binding */xn
              );
            },
            /* harmony export */"VK_FORMAT_ETC2_R8G8B8A1_SRGB_BLOCK": function VK_FORMAT_ETC2_R8G8B8A1_SRGB_BLOCK() {
              return (/* binding */pn
              );
            },
            /* harmony export */"VK_FORMAT_ETC2_R8G8B8A1_UNORM_BLOCK": function VK_FORMAT_ETC2_R8G8B8A1_UNORM_BLOCK() {
              return (/* binding */_n
              );
            },
            /* harmony export */"VK_FORMAT_ETC2_R8G8B8A8_SRGB_BLOCK": function VK_FORMAT_ETC2_R8G8B8A8_SRGB_BLOCK() {
              return (/* binding */yn
              );
            },
            /* harmony export */"VK_FORMAT_ETC2_R8G8B8A8_UNORM_BLOCK": function VK_FORMAT_ETC2_R8G8B8A8_UNORM_BLOCK() {
              return (/* binding */gn
              );
            },
            /* harmony export */"VK_FORMAT_ETC2_R8G8B8_SRGB_BLOCK": function VK_FORMAT_ETC2_R8G8B8_SRGB_BLOCK() {
              return (/* binding */hn
              );
            },
            /* harmony export */"VK_FORMAT_ETC2_R8G8B8_UNORM_BLOCK": function VK_FORMAT_ETC2_R8G8B8_UNORM_BLOCK() {
              return (/* binding */cn
              );
            },
            /* harmony export */"VK_FORMAT_G10X6B10X6G10X6R10X6_422_UNORM_4PACK16": function VK_FORMAT_G10X6B10X6G10X6R10X6_422_UNORM_4PACK16() {
              return (/* binding */Zn
              );
            },
            /* harmony export */"VK_FORMAT_G12X4B12X4G12X4R12X4_422_UNORM_4PACK16": function VK_FORMAT_G12X4B12X4G12X4R12X4_422_UNORM_4PACK16() {
              return (/* binding */ii
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC1_2BPP_SRGB_BLOCK_IMG": function VK_FORMAT_PVRTC1_2BPP_SRGB_BLOCK_IMG() {
              return (/* binding */fi
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC1_2BPP_UNORM_BLOCK_IMG": function VK_FORMAT_PVRTC1_2BPP_UNORM_BLOCK_IMG() {
              return (/* binding */ai
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC1_4BPP_SRGB_BLOCK_IMG": function VK_FORMAT_PVRTC1_4BPP_SRGB_BLOCK_IMG() {
              return (/* binding */Ui
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC1_4BPP_UNORM_BLOCK_IMG": function VK_FORMAT_PVRTC1_4BPP_UNORM_BLOCK_IMG() {
              return (/* binding */ri
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC2_2BPP_SRGB_BLOCK_IMG": function VK_FORMAT_PVRTC2_2BPP_SRGB_BLOCK_IMG() {
              return (/* binding */ci
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC2_2BPP_UNORM_BLOCK_IMG": function VK_FORMAT_PVRTC2_2BPP_UNORM_BLOCK_IMG() {
              return (/* binding */oi
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC2_4BPP_SRGB_BLOCK_IMG": function VK_FORMAT_PVRTC2_4BPP_SRGB_BLOCK_IMG() {
              return (/* binding */hi
              );
            },
            /* harmony export */"VK_FORMAT_PVRTC2_4BPP_UNORM_BLOCK_IMG": function VK_FORMAT_PVRTC2_4BPP_UNORM_BLOCK_IMG() {
              return (/* binding */li
              );
            },
            /* harmony export */"VK_FORMAT_R10X6G10X6B10X6A10X6_UNORM_4PACK16": function VK_FORMAT_R10X6G10X6B10X6A10X6_UNORM_4PACK16() {
              return (/* binding */Qn
              );
            },
            /* harmony export */"VK_FORMAT_R10X6G10X6_UNORM_2PACK16": function VK_FORMAT_R10X6G10X6_UNORM_2PACK16() {
              return (/* binding */Jn
              );
            },
            /* harmony export */"VK_FORMAT_R10X6_UNORM_PACK16": function VK_FORMAT_R10X6_UNORM_PACK16() {
              return (/* binding */Gn
              );
            },
            /* harmony export */"VK_FORMAT_R12X4G12X4B12X4A12X4_UNORM_4PACK16": function VK_FORMAT_R12X4G12X4B12X4A12X4_UNORM_4PACK16() {
              return (/* binding */ni
              );
            },
            /* harmony export */"VK_FORMAT_R12X4G12X4_UNORM_2PACK16": function VK_FORMAT_R12X4G12X4_UNORM_2PACK16() {
              return (/* binding */ei
              );
            },
            /* harmony export */"VK_FORMAT_R12X4_UNORM_PACK16": function VK_FORMAT_R12X4_UNORM_PACK16() {
              return (/* binding */ti
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16A16_SFLOAT": function VK_FORMAT_R16G16B16A16_SFLOAT() {
              return (/* binding */pe
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16A16_SINT": function VK_FORMAT_R16G16B16A16_SINT() {
              return (/* binding */_e
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16A16_SNORM": function VK_FORMAT_R16G16B16A16_SNORM() {
              return (/* binding */ce
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16A16_UINT": function VK_FORMAT_R16G16B16A16_UINT() {
              return (/* binding */he
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16A16_UNORM": function VK_FORMAT_R16G16B16A16_UNORM() {
              return (/* binding */Ue
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16_SFLOAT": function VK_FORMAT_R16G16B16_SFLOAT() {
              return (/* binding */fe
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16_SINT": function VK_FORMAT_R16G16B16_SINT() {
              return (/* binding */le
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16_SNORM": function VK_FORMAT_R16G16B16_SNORM() {
              return (/* binding */re
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16_UINT": function VK_FORMAT_R16G16B16_UINT() {
              return (/* binding */oe
              );
            },
            /* harmony export */"VK_FORMAT_R16G16B16_UNORM": function VK_FORMAT_R16G16B16_UNORM() {
              return (/* binding */ae
              );
            },
            /* harmony export */"VK_FORMAT_R16G16_SFLOAT": function VK_FORMAT_R16G16_SFLOAT() {
              return (/* binding */se
              );
            },
            /* harmony export */"VK_FORMAT_R16G16_SINT": function VK_FORMAT_R16G16_SINT() {
              return (/* binding */ie
              );
            },
            /* harmony export */"VK_FORMAT_R16G16_SNORM": function VK_FORMAT_R16G16_SNORM() {
              return (/* binding */ee
              );
            },
            /* harmony export */"VK_FORMAT_R16G16_UINT": function VK_FORMAT_R16G16_UINT() {
              return (/* binding */ne
              );
            },
            /* harmony export */"VK_FORMAT_R16G16_UNORM": function VK_FORMAT_R16G16_UNORM() {
              return (/* binding */te
              );
            },
            /* harmony export */"VK_FORMAT_R16_SFLOAT": function VK_FORMAT_R16_SFLOAT() {
              return (/* binding */$t
              );
            },
            /* harmony export */"VK_FORMAT_R16_SINT": function VK_FORMAT_R16_SINT() {
              return (/* binding */Zt
              );
            },
            /* harmony export */"VK_FORMAT_R16_SNORM": function VK_FORMAT_R16_SNORM() {
              return (/* binding */Jt
              );
            },
            /* harmony export */"VK_FORMAT_R16_UINT": function VK_FORMAT_R16_UINT() {
              return (/* binding */Qt
              );
            },
            /* harmony export */"VK_FORMAT_R16_UNORM": function VK_FORMAT_R16_UNORM() {
              return (/* binding */Gt
              );
            },
            /* harmony export */"VK_FORMAT_R32G32B32A32_SFLOAT": function VK_FORMAT_R32G32B32A32_SFLOAT() {
              return (/* binding */Ae
              );
            },
            /* harmony export */"VK_FORMAT_R32G32B32A32_SINT": function VK_FORMAT_R32G32B32A32_SINT() {
              return (/* binding */Le
              );
            },
            /* harmony export */"VK_FORMAT_R32G32B32A32_UINT": function VK_FORMAT_R32G32B32A32_UINT() {
              return (/* binding */Be
              );
            },
            /* harmony export */"VK_FORMAT_R32G32B32_SFLOAT": function VK_FORMAT_R32G32B32_SFLOAT() {
              return (/* binding */De
              );
            },
            /* harmony export */"VK_FORMAT_R32G32B32_SINT": function VK_FORMAT_R32G32B32_SINT() {
              return (/* binding */we
              );
            },
            /* harmony export */"VK_FORMAT_R32G32B32_UINT": function VK_FORMAT_R32G32B32_UINT() {
              return (/* binding */me
              );
            },
            /* harmony export */"VK_FORMAT_R32G32_SFLOAT": function VK_FORMAT_R32G32_SFLOAT() {
              return (/* binding */de
              );
            },
            /* harmony export */"VK_FORMAT_R32G32_SINT": function VK_FORMAT_R32G32_SINT() {
              return (/* binding */be
              );
            },
            /* harmony export */"VK_FORMAT_R32G32_UINT": function VK_FORMAT_R32G32_UINT() {
              return (/* binding */ue
              );
            },
            /* harmony export */"VK_FORMAT_R32_SFLOAT": function VK_FORMAT_R32_SFLOAT() {
              return (/* binding */xe
              );
            },
            /* harmony export */"VK_FORMAT_R32_SINT": function VK_FORMAT_R32_SINT() {
              return (/* binding */ye
              );
            },
            /* harmony export */"VK_FORMAT_R32_UINT": function VK_FORMAT_R32_UINT() {
              return (/* binding */ge
              );
            },
            /* harmony export */"VK_FORMAT_R4G4B4A4_UNORM_PACK16": function VK_FORMAT_R4G4B4A4_UNORM_PACK16() {
              return (/* binding */st
              );
            },
            /* harmony export */"VK_FORMAT_R4G4_UNORM_PACK8": function VK_FORMAT_R4G4_UNORM_PACK8() {
              return (/* binding */it
              );
            },
            /* harmony export */"VK_FORMAT_R5G5B5A1_UNORM_PACK16": function VK_FORMAT_R5G5B5A1_UNORM_PACK16() {
              return (/* binding */lt
              );
            },
            /* harmony export */"VK_FORMAT_R5G6B5_UNORM_PACK16": function VK_FORMAT_R5G6B5_UNORM_PACK16() {
              return (/* binding */rt
              );
            },
            /* harmony export */"VK_FORMAT_R64G64B64A64_SFLOAT": function VK_FORMAT_R64G64B64A64_SFLOAT() {
              return (/* binding */ze
              );
            },
            /* harmony export */"VK_FORMAT_R64G64B64A64_SINT": function VK_FORMAT_R64G64B64A64_SINT() {
              return (/* binding */Ce
              );
            },
            /* harmony export */"VK_FORMAT_R64G64B64A64_UINT": function VK_FORMAT_R64G64B64A64_UINT() {
              return (/* binding */Pe
              );
            },
            /* harmony export */"VK_FORMAT_R64G64B64_SFLOAT": function VK_FORMAT_R64G64B64_SFLOAT() {
              return (/* binding */Fe
              );
            },
            /* harmony export */"VK_FORMAT_R64G64B64_SINT": function VK_FORMAT_R64G64B64_SINT() {
              return (/* binding */Ee
              );
            },
            /* harmony export */"VK_FORMAT_R64G64B64_UINT": function VK_FORMAT_R64G64B64_UINT() {
              return (/* binding */Ve
              );
            },
            /* harmony export */"VK_FORMAT_R64G64_SFLOAT": function VK_FORMAT_R64G64_SFLOAT() {
              return (/* binding */Te
              );
            },
            /* harmony export */"VK_FORMAT_R64G64_SINT": function VK_FORMAT_R64G64_SINT() {
              return (/* binding */Oe
              );
            },
            /* harmony export */"VK_FORMAT_R64G64_UINT": function VK_FORMAT_R64G64_UINT() {
              return (/* binding */Ie
              );
            },
            /* harmony export */"VK_FORMAT_R64_SFLOAT": function VK_FORMAT_R64_SFLOAT() {
              return (/* binding */Se
              );
            },
            /* harmony export */"VK_FORMAT_R64_SINT": function VK_FORMAT_R64_SINT() {
              return (/* binding */ve
              );
            },
            /* harmony export */"VK_FORMAT_R64_UINT": function VK_FORMAT_R64_UINT() {
              return (/* binding */ke
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8A8_SINT": function VK_FORMAT_R8G8B8A8_SINT() {
              return (/* binding */Et
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8A8_SNORM": function VK_FORMAT_R8G8B8A8_SNORM() {
              return (/* binding */Tt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8A8_SRGB": function VK_FORMAT_R8G8B8A8_SRGB() {
              return (/* binding */Ft
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8A8_UINT": function VK_FORMAT_R8G8B8A8_UINT() {
              return (/* binding */Vt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8A8_UNORM": function VK_FORMAT_R8G8B8A8_UNORM() {
              return (/* binding */Ot
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8_SINT": function VK_FORMAT_R8G8B8_SINT() {
              return (/* binding */Bt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8_SNORM": function VK_FORMAT_R8G8B8_SNORM() {
              return (/* binding */wt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8_SRGB": function VK_FORMAT_R8G8B8_SRGB() {
              return (/* binding */Lt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8_UINT": function VK_FORMAT_R8G8B8_UINT() {
              return (/* binding */Dt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8B8_UNORM": function VK_FORMAT_R8G8B8_UNORM() {
              return (/* binding */mt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8_SINT": function VK_FORMAT_R8G8_SINT() {
              return (/* binding */bt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8_SNORM": function VK_FORMAT_R8G8_SNORM() {
              return (/* binding */xt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8_SRGB": function VK_FORMAT_R8G8_SRGB() {
              return (/* binding */dt
              );
            },
            /* harmony export */"VK_FORMAT_R8G8_UINT": function VK_FORMAT_R8G8_UINT() {
              return (/* binding */ut
              );
            },
            /* harmony export */"VK_FORMAT_R8G8_UNORM": function VK_FORMAT_R8G8_UNORM() {
              return (/* binding */yt
              );
            },
            /* harmony export */"VK_FORMAT_R8_SINT": function VK_FORMAT_R8_SINT() {
              return (/* binding */pt
              );
            },
            /* harmony export */"VK_FORMAT_R8_SNORM": function VK_FORMAT_R8_SNORM() {
              return (/* binding */ht
              );
            },
            /* harmony export */"VK_FORMAT_R8_SRGB": function VK_FORMAT_R8_SRGB() {
              return (/* binding */gt
              );
            },
            /* harmony export */"VK_FORMAT_R8_UINT": function VK_FORMAT_R8_UINT() {
              return (/* binding */_t
              );
            },
            /* harmony export */"VK_FORMAT_R8_UNORM": function VK_FORMAT_R8_UNORM() {
              return (/* binding */ct
              );
            },
            /* harmony export */"VK_FORMAT_S8_UINT": function VK_FORMAT_S8_UINT() {
              return (/* binding */Xe
              );
            },
            /* harmony export */"VK_FORMAT_UNDEFINED": function VK_FORMAT_UNDEFINED() {
              return (/* binding */nt
              );
            },
            /* harmony export */"VK_FORMAT_X8_D24_UNORM_PACK32": function VK_FORMAT_X8_D24_UNORM_PACK32() {
              return (/* binding */He
              );
            },
            /* harmony export */"read": function read() {
              return (/* binding */Pi
              );
            },
            /* harmony export */"write": function write() {
              return (/* binding */Mi
              );
            }
            /* harmony export */
          });
          /* provided dependency */
          var Buffer = __webpack_require__( /*! buffer */"./node_modules/buffer/index.js")["Buffer"];
          var t = 0,
            e = 1,
            n = 2,
            i = 3,
            s = 0,
            a = 0,
            r = 2,
            o = 0,
            l = 1,
            f = 160,
            U = 161,
            c = 162,
            h = 163,
            _ = 0,
            p = 1,
            g = 0,
            y = 1,
            x = 2,
            u = 3,
            b = 4,
            d = 5,
            m = 6,
            w = 7,
            D = 8,
            B = 9,
            L = 10,
            A = 11,
            k = 12,
            v = 13,
            S = 14,
            I = 15,
            O = 16,
            T = 17,
            V = 18,
            E = 0,
            F = 1,
            P = 2,
            C = 3,
            z = 4,
            M = 5,
            W = 6,
            N = 7,
            H = 8,
            K = 9,
            X = 10,
            j = 11,
            R = 0,
            Y = 1,
            q = 2,
            G = 13,
            J = 14,
            Q = 15,
            Z = 128,
            $ = 64,
            tt = 32,
            et = 16,
            nt = 0,
            it = 1,
            st = 2,
            at = 3,
            rt = 4,
            ot = 5,
            lt = 6,
            ft = 7,
            Ut = 8,
            ct = 9,
            ht = 10,
            _t = 13,
            pt = 14,
            gt = 15,
            yt = 16,
            xt = 17,
            ut = 20,
            bt = 21,
            dt = 22,
            mt = 23,
            wt = 24,
            Dt = 27,
            Bt = 28,
            Lt = 29,
            At = 30,
            kt = 31,
            vt = 34,
            St = 35,
            It = 36,
            Ot = 37,
            Tt = 38,
            Vt = 41,
            Et = 42,
            Ft = 43,
            Pt = 44,
            Ct = 45,
            zt = 48,
            Mt = 49,
            Wt = 50,
            Nt = 58,
            Ht = 59,
            Kt = 62,
            Xt = 63,
            jt = 64,
            Rt = 65,
            Yt = 68,
            qt = 69,
            Gt = 70,
            Jt = 71,
            Qt = 74,
            Zt = 75,
            $t = 76,
            te = 77,
            ee = 78,
            ne = 81,
            ie = 82,
            se = 83,
            ae = 84,
            re = 85,
            oe = 88,
            le = 89,
            fe = 90,
            Ue = 91,
            ce = 92,
            he = 95,
            _e = 96,
            pe = 97,
            ge = 98,
            ye = 99,
            xe = 100,
            ue = 101,
            be = 102,
            de = 103,
            me = 104,
            we = 105,
            De = 106,
            Be = 107,
            Le = 108,
            Ae = 109,
            ke = 110,
            ve = 111,
            Se = 112,
            Ie = 113,
            Oe = 114,
            Te = 115,
            Ve = 116,
            Ee = 117,
            Fe = 118,
            Pe = 119,
            Ce = 120,
            ze = 121,
            Me = 122,
            We = 123,
            Ne = 124,
            He = 125,
            Ke = 126,
            Xe = 127,
            je = 128,
            Re = 129,
            Ye = 130,
            qe = 131,
            Ge = 132,
            Je = 133,
            Qe = 134,
            Ze = 135,
            $e = 136,
            tn = 137,
            en = 138,
            nn = 139,
            sn = 140,
            an = 141,
            rn = 142,
            on = 143,
            ln = 144,
            fn = 145,
            Un = 146,
            cn = 147,
            hn = 148,
            _n = 149,
            pn = 150,
            gn = 151,
            yn = 152,
            xn = 153,
            un = 154,
            bn = 155,
            dn = 156,
            mn = 157,
            wn = 158,
            Dn = 159,
            Bn = 160,
            Ln = 161,
            An = 162,
            kn = 163,
            vn = 164,
            Sn = 165,
            In = 166,
            On = 167,
            Tn = 168,
            Vn = 169,
            En = 170,
            Fn = 171,
            Pn = 172,
            Cn = 173,
            zn = 174,
            Mn = 175,
            Wn = 176,
            Nn = 177,
            Hn = 178,
            Kn = 179,
            Xn = 180,
            jn = 181,
            Rn = 182,
            Yn = 183,
            qn = 184,
            Gn = 1000156007,
            Jn = 1000156008,
            Qn = 1000156009,
            Zn = 1000156010,
            $n = 1000156011,
            ti = 1000156017,
            ei = 1000156018,
            ni = 1000156019,
            ii = 1000156020,
            si = 1000156021,
            ai = 1000054e3,
            ri = 1000054001,
            oi = 1000054002,
            li = 1000054003,
            fi = 1000054004,
            Ui = 1000054005,
            ci = 1000054006,
            hi = 1000054007,
            _i = 1000066e3,
            pi = 1000066001,
            gi = 1000066002,
            yi = 1000066003,
            xi = 1000066004,
            ui = 1000066005,
            bi = 1000066006,
            di = 1000066007,
            mi = 1000066008,
            wi = 1000066009,
            Di = 1000066010,
            Bi = 1000066011,
            Li = 1000066012,
            Ai = 1000066013,
            ki = 100034e4,
            vi = 1000340001;
          var Si = /*#__PURE__*/_createClass2(function Si() {
            _classCallCheck2(this, Si);
            this.vkFormat = 0, this.typeSize = 1, this.pixelWidth = 0, this.pixelHeight = 0, this.pixelDepth = 0, this.layerCount = 0, this.faceCount = 1, this.supercompressionScheme = 0, this.levels = [], this.dataFormatDescriptor = [{
              vendorId: 0,
              descriptorType: 0,
              descriptorBlockSize: 0,
              versionNumber: 2,
              colorModel: 0,
              colorPrimaries: 1,
              transferFunction: 2,
              flags: 0,
              texelBlockDimension: [0, 0, 0, 0],
              bytesPlane: [0, 0, 0, 0, 0, 0, 0, 0],
              samples: []
            }], this.keyValue = {}, this.globalData = null;
          });
          var Ii = /*#__PURE__*/function () {
            function Ii(t, e, n, i) {
              _classCallCheck2(this, Ii);
              this._dataView = new DataView(t.buffer, t.byteOffset + e, n), this._littleEndian = i, this._offset = 0;
            }
            _createClass2(Ii, [{
              key: "_nextUint8",
              value: function _nextUint8() {
                var t = this._dataView.getUint8(this._offset);
                return this._offset += 1, t;
              }
            }, {
              key: "_nextUint16",
              value: function _nextUint16() {
                var t = this._dataView.getUint16(this._offset, this._littleEndian);
                return this._offset += 2, t;
              }
            }, {
              key: "_nextUint32",
              value: function _nextUint32() {
                var t = this._dataView.getUint32(this._offset, this._littleEndian);
                return this._offset += 4, t;
              }
            }, {
              key: "_nextUint64",
              value: function _nextUint64() {
                var t = this._dataView.getUint32(this._offset, this._littleEndian) + Math.pow(2, 32) * this._dataView.getUint32(this._offset + 4, this._littleEndian);
                return this._offset += 8, t;
              }
            }, {
              key: "_nextInt32",
              value: function _nextInt32() {
                var t = this._dataView.getInt32(this._offset, this._littleEndian);
                return this._offset += 4, t;
              }
            }, {
              key: "_skip",
              value: function _skip(t) {
                return this._offset += t, this;
              }
            }, {
              key: "_scan",
              value: function _scan(t) {
                var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var n = this._offset;
                var i = 0;
                for (; this._dataView.getUint8(this._offset) !== e && i < t;) i++, this._offset++;
                return i < t && this._offset++, new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + n, i);
              }
            }]);
            return Ii;
          }();
          var Oi = new Uint8Array([0]),
            Ti = [171, 75, 84, 88, 32, 50, 48, 187, 13, 10, 26, 10];
          function Vi(t) {
            return "undefined" != typeof TextEncoder ? new TextEncoder().encode(t) : Buffer.from(t);
          }
          function Ei(t) {
            return "undefined" != typeof TextDecoder ? new TextDecoder().decode(t) : Buffer.from(t).toString("utf8");
          }
          function Fi(t) {
            var e = 0;
            var _iterator11 = _createForOfIteratorHelper2(t),
              _step11;
            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var _n2 = _step11.value;
                e += _n2.byteLength;
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
            var n = new Uint8Array(e);
            var i = 0;
            var _iterator12 = _createForOfIteratorHelper2(t),
              _step12;
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _e5 = _step12.value;
                n.set(new Uint8Array(_e5), i), i += _e5.byteLength;
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
            return n;
          }
          function Pi(t) {
            var e = new Uint8Array(t.buffer, t.byteOffset, Ti.length);
            if (e[0] !== Ti[0] || e[1] !== Ti[1] || e[2] !== Ti[2] || e[3] !== Ti[3] || e[4] !== Ti[4] || e[5] !== Ti[5] || e[6] !== Ti[6] || e[7] !== Ti[7] || e[8] !== Ti[8] || e[9] !== Ti[9] || e[10] !== Ti[10] || e[11] !== Ti[11]) throw new Error("Missing KTX 2.0 identifier.");
            var n = new Si(),
              i = 17 * Uint32Array.BYTES_PER_ELEMENT,
              s = new Ii(t, Ti.length, i, !0);
            n.vkFormat = s._nextUint32(), n.typeSize = s._nextUint32(), n.pixelWidth = s._nextUint32(), n.pixelHeight = s._nextUint32(), n.pixelDepth = s._nextUint32(), n.layerCount = s._nextUint32(), n.faceCount = s._nextUint32();
            var a = s._nextUint32();
            n.supercompressionScheme = s._nextUint32();
            var r = s._nextUint32(),
              o = s._nextUint32(),
              l = s._nextUint32(),
              f = s._nextUint32(),
              U = s._nextUint64(),
              c = s._nextUint64(),
              h = new Ii(t, Ti.length + i, 3 * a * 8, !0);
            for (var _e6 = 0; _e6 < a; _e6++) n.levels.push({
              levelData: new Uint8Array(t.buffer, t.byteOffset + h._nextUint64(), h._nextUint64()),
              uncompressedByteLength: h._nextUint64()
            });
            var _ = new Ii(t, r, o, !0),
              p = {
                vendorId: _._skip(4)._nextUint16(),
                descriptorType: _._nextUint16(),
                versionNumber: _._nextUint16(),
                descriptorBlockSize: _._nextUint16(),
                colorModel: _._nextUint8(),
                colorPrimaries: _._nextUint8(),
                transferFunction: _._nextUint8(),
                flags: _._nextUint8(),
                texelBlockDimension: [_._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8()],
                bytesPlane: [_._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8()],
                samples: []
              },
              g = (p.descriptorBlockSize / 4 - 6) / 4;
            for (var _t3 = 0; _t3 < g; _t3++) {
              var _e7 = {
                bitOffset: _._nextUint16(),
                bitLength: _._nextUint8(),
                channelType: _._nextUint8(),
                samplePosition: [_._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8()],
                sampleLower: -Infinity,
                sampleUpper: Infinity
              };
              64 & _e7.channelType ? (_e7.sampleLower = _._nextInt32(), _e7.sampleUpper = _._nextInt32()) : (_e7.sampleLower = _._nextUint32(), _e7.sampleUpper = _._nextUint32()), p.samples[_t3] = _e7;
            }
            n.dataFormatDescriptor.length = 0, n.dataFormatDescriptor.push(p);
            var y = new Ii(t, l, f, !0);
            for (; y._offset < f;) {
              var _t4 = y._nextUint32(),
                _e8 = y._scan(_t4),
                _i97 = Ei(_e8),
                _s6 = y._scan(_t4 - _e8.byteLength);
              n.keyValue[_i97] = _i97.match(/^ktx/i) ? Ei(_s6) : _s6, y._offset % 4 && y._skip(4 - y._offset % 4);
            }
            if (c <= 0) return n;
            var x = new Ii(t, U, c, !0),
              u = x._nextUint16(),
              b = x._nextUint16(),
              d = x._nextUint32(),
              m = x._nextUint32(),
              w = x._nextUint32(),
              D = x._nextUint32(),
              B = [];
            for (var _t5 = 0; _t5 < a; _t5++) B.push({
              imageFlags: x._nextUint32(),
              rgbSliceByteOffset: x._nextUint32(),
              rgbSliceByteLength: x._nextUint32(),
              alphaSliceByteOffset: x._nextUint32(),
              alphaSliceByteLength: x._nextUint32()
            });
            var L = U + x._offset,
              A = L + d,
              k = A + m,
              v = k + w,
              S = new Uint8Array(t.buffer, t.byteOffset + L, d),
              I = new Uint8Array(t.buffer, t.byteOffset + A, m),
              O = new Uint8Array(t.buffer, t.byteOffset + k, w),
              T = new Uint8Array(t.buffer, t.byteOffset + v, D);
            return n.globalData = {
              endpointCount: u,
              selectorCount: b,
              imageDescs: B,
              endpointsData: S,
              selectorsData: I,
              tablesData: O,
              extendedData: T
            }, n;
          }
          function Ci() {
            return (Ci = Object.assign || function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];
                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
              }
              return t;
            }).apply(this, arguments);
          }
          var zi = {
            keepWriter: !1
          };
          function Mi(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            e = Ci({}, zi, e);
            var n = new ArrayBuffer(0);
            if (t.globalData) {
              var _e9 = new ArrayBuffer(20 + 5 * t.globalData.imageDescs.length * 4),
                _i98 = new DataView(_e9);
              _i98.setUint16(0, t.globalData.endpointCount, !0), _i98.setUint16(2, t.globalData.selectorCount, !0), _i98.setUint32(4, t.globalData.endpointsData.byteLength, !0), _i98.setUint32(8, t.globalData.selectorsData.byteLength, !0), _i98.setUint32(12, t.globalData.tablesData.byteLength, !0), _i98.setUint32(16, t.globalData.extendedData.byteLength, !0);
              for (var _e10 = 0; _e10 < t.globalData.imageDescs.length; _e10++) {
                var _n3 = t.globalData.imageDescs[_e10];
                _i98.setUint32(20 + 5 * _e10 * 4 + 0, _n3.imageFlags, !0), _i98.setUint32(20 + 5 * _e10 * 4 + 4, _n3.rgbSliceByteOffset, !0), _i98.setUint32(20 + 5 * _e10 * 4 + 8, _n3.rgbSliceByteLength, !0), _i98.setUint32(20 + 5 * _e10 * 4 + 12, _n3.alphaSliceByteOffset, !0), _i98.setUint32(20 + 5 * _e10 * 4 + 16, _n3.alphaSliceByteLength, !0);
              }
              n = Fi([_e9, t.globalData.endpointsData, t.globalData.selectorsData, t.globalData.tablesData, t.globalData.extendedData]);
            }
            var i = [];
            var s = t.keyValue;
            e.keepWriter || (s = Ci({}, t.keyValue, {
              KTXwriter: "KTX-Parse v0.3.1"
            }));
            for (var _t6 in s) {
              var _e11 = s[_t6],
                _n4 = Vi(_t6),
                _a5 = "string" == typeof _e11 ? Vi(_e11) : _e11,
                _r = _n4.byteLength + 1 + _a5.byteLength + 1,
                _o = _r % 4 ? 4 - _r % 4 : 0;
              i.push(Fi([new Uint32Array([_r]), _n4, Oi, _a5, Oi, new Uint8Array(_o).fill(0)]));
            }
            var a = Fi(i);
            if (1 !== t.dataFormatDescriptor.length || 0 !== t.dataFormatDescriptor[0].descriptorType) throw new Error("Only BASICFORMAT Data Format Descriptor output supported.");
            var r = t.dataFormatDescriptor[0],
              o = new ArrayBuffer(28 + 16 * r.samples.length),
              l = new DataView(o),
              f = 24 + 16 * r.samples.length;
            if (l.setUint32(0, o.byteLength, !0), l.setUint16(4, r.vendorId, !0), l.setUint16(6, r.descriptorType, !0), l.setUint16(8, r.versionNumber, !0), l.setUint16(10, f, !0), l.setUint8(12, r.colorModel), l.setUint8(13, r.colorPrimaries), l.setUint8(14, r.transferFunction), l.setUint8(15, r.flags), !Array.isArray(r.texelBlockDimension)) throw new Error("texelBlockDimension is now an array. For dimensionality `d`, set `d - 1`.");
            l.setUint8(16, r.texelBlockDimension[0]), l.setUint8(17, r.texelBlockDimension[1]), l.setUint8(18, r.texelBlockDimension[2]), l.setUint8(19, r.texelBlockDimension[3]);
            for (var _t7 = 0; _t7 < 8; _t7++) l.setUint8(20 + _t7, r.bytesPlane[_t7]);
            for (var _t8 = 0; _t8 < r.samples.length; _t8++) {
              var _e12 = r.samples[_t8],
                _n5 = 28 + 16 * _t8;
              if (_e12.channelID) throw new Error("channelID has been renamed to channelType.");
              l.setUint16(_n5 + 0, _e12.bitOffset, !0), l.setUint8(_n5 + 2, _e12.bitLength), l.setUint8(_n5 + 3, _e12.channelType), l.setUint8(_n5 + 4, _e12.samplePosition[0]), l.setUint8(_n5 + 5, _e12.samplePosition[1]), l.setUint8(_n5 + 6, _e12.samplePosition[2]), l.setUint8(_n5 + 7, _e12.samplePosition[3]), 64 & _e12.channelType ? (l.setInt32(_n5 + 8, _e12.sampleLower, !0), l.setInt32(_n5 + 12, _e12.sampleUpper, !0)) : (l.setUint32(_n5 + 8, _e12.sampleLower, !0), l.setUint32(_n5 + 12, _e12.sampleUpper, !0));
            }
            var U = Ti.length + 68 + 3 * t.levels.length * 8,
              c = U + o.byteLength;
            var h = n.byteLength > 0 ? c + a.byteLength : 0;
            h % 8 && (h += 8 - h % 8);
            var _ = [],
              p = new DataView(new ArrayBuffer(3 * t.levels.length * 8));
            var g = (h || c + a.byteLength) + n.byteLength;
            for (var _e13 = 0; _e13 < t.levels.length; _e13++) {
              var _n6 = t.levels[_e13];
              _.push(_n6.levelData), p.setBigUint64(24 * _e13 + 0, BigInt(g), !0), p.setBigUint64(24 * _e13 + 8, BigInt(_n6.levelData.byteLength), !0), p.setBigUint64(24 * _e13 + 16, BigInt(_n6.uncompressedByteLength), !0), g += _n6.levelData.byteLength;
            }
            var y = new ArrayBuffer(68),
              x = new DataView(y);
            return x.setUint32(0, t.vkFormat, !0), x.setUint32(4, t.typeSize, !0), x.setUint32(8, t.pixelWidth, !0), x.setUint32(12, t.pixelHeight, !0), x.setUint32(16, t.pixelDepth, !0), x.setUint32(20, t.layerCount, !0), x.setUint32(24, t.faceCount, !0), x.setUint32(28, t.levels.length, !0), x.setUint32(32, t.supercompressionScheme, !0), x.setUint32(36, U, !0), x.setUint32(40, o.byteLength, !0), x.setUint32(44, c, !0), x.setUint32(48, a.byteLength, !0), x.setBigUint64(52, BigInt(n.byteLength > 0 ? h : 0), !0), x.setBigUint64(60, BigInt(n.byteLength), !0), new Uint8Array(Fi([new Uint8Array(Ti).buffer, y, p.buffer, o, a, h > 0 ? new ArrayBuffer(h - (c + a.byteLength)) : new ArrayBuffer(0), n].concat(_)));
          }

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/libs/zstddec.module.js":
        /*!**********************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/libs/zstddec.module.js ***!
          \**********************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLibsZstddecModuleJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"ZSTDDecoder": function ZSTDDecoder() {
              return (/* binding */Q
              );
            }
            /* harmony export */
          });
          /* provided dependency */
          var Buffer = __webpack_require__( /*! buffer */"./node_modules/buffer/index.js")["Buffer"];
          var A, I, B;
          var g = {
            env: {
              emscripten_notify_memory_growth: function emscripten_notify_memory_growth(A) {
                B = new Uint8Array(I.exports.memory.buffer);
              }
            }
          };
          var Q = /*#__PURE__*/function () {
            function Q() {
              _classCallCheck2(this, Q);
            }
            _createClass2(Q, [{
              key: "init",
              value: function init() {
                return A || (A = "undefined" != typeof fetch ? fetch("data:application/wasm;base64," + C).then(function (A) {
                  return A.arrayBuffer();
                }).then(function (A) {
                  return WebAssembly.instantiate(A, g);
                }).then(this._init) : WebAssembly.instantiate(Buffer.from(C, "base64"), g).then(this._init), A);
              }
            }, {
              key: "_init",
              value: function _init(A) {
                I = A.instance, g.env.emscripten_notify_memory_growth(0);
              }
            }, {
              key: "decode",
              value: function decode(A) {
                var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (!I) throw new Error("ZSTDDecoder: Await .init() before decoding.");
                var _Q = A.byteLength,
                  C = I.exports.malloc(_Q);
                B.set(A, C), g = g || Number(I.exports.ZSTD_findDecompressedSize(C, _Q));
                var E = I.exports.malloc(g),
                  i = I.exports.ZSTD_decompress(E, g, C, _Q),
                  D = B.slice(E, E + i);
                return I.exports.free(C), I.exports.free(E), D;
              }
            }]);
            return Q;
          }();
          var C = "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";

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/lights/LightProbeGenerator.js":
        /*!*****************************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/lights/LightProbeGenerator.js ***!
          \*****************************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLightsLightProbeGeneratorJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"LightProbeGenerator": function LightProbeGenerator() {
              return (/* binding */_LightProbeGenerator
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");
          var _LightProbeGenerator = /*#__PURE__*/function () {
            function _LightProbeGenerator() {
              _classCallCheck2(this, _LightProbeGenerator);
            }
            _createClass2(_LightProbeGenerator, null, [{
              key: "fromCubeTexture",
              value:
              // https://www.ppsloan.org/publications/StupidSH36.pdf
              function fromCubeTexture(cubeTexture) {
                var totalWeight = 0;
                var coord = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
                var dir = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
                var color = new three__WEBPACK_IMPORTED_MODULE_0__.Color();
                var shBasis = [0, 0, 0, 0, 0, 0, 0, 0, 0];
                var sh = new three__WEBPACK_IMPORTED_MODULE_0__.SphericalHarmonics3();
                var shCoefficients = sh.coefficients;
                for (var faceIndex = 0; faceIndex < 6; faceIndex++) {
                  var image = cubeTexture.image[faceIndex];
                  var width = image.width;
                  var height = image.height;
                  var canvas = document.createElement('canvas');
                  canvas.width = width;
                  canvas.height = height;
                  var context = canvas.getContext('2d');
                  context.drawImage(image, 0, 0, width, height);
                  var imageData = context.getImageData(0, 0, width, height);
                  var data = imageData.data;
                  var imageWidth = imageData.width; // assumed to be square

                  var pixelSize = 2 / imageWidth;
                  for (var i = 0, il = data.length; i < il; i += 4) {
                    // RGBA assumed

                    // pixel color
                    color.setRGB(data[i] / 255, data[i + 1] / 255, data[i + 2] / 255);

                    // convert to linear color space
                    convertColorToLinear(color, cubeTexture.encoding);

                    // pixel coordinate on unit cube

                    var pixelIndex = i / 4;
                    var col = -1 + (pixelIndex % imageWidth + 0.5) * pixelSize;
                    var row = 1 - (Math.floor(pixelIndex / imageWidth) + 0.5) * pixelSize;
                    switch (faceIndex) {
                      case 0:
                        coord.set(-1, row, -col);
                        break;
                      case 1:
                        coord.set(1, row, col);
                        break;
                      case 2:
                        coord.set(-col, 1, -row);
                        break;
                      case 3:
                        coord.set(-col, -1, row);
                        break;
                      case 4:
                        coord.set(-col, row, 1);
                        break;
                      case 5:
                        coord.set(col, row, -1);
                        break;
                    }

                    // weight assigned to this pixel

                    var lengthSq = coord.lengthSq();
                    var weight = 4 / (Math.sqrt(lengthSq) * lengthSq);
                    totalWeight += weight;

                    // direction vector to this pixel
                    dir.copy(coord).normalize();

                    // evaluate SH basis functions in direction dir
                    three__WEBPACK_IMPORTED_MODULE_0__.SphericalHarmonics3.getBasisAt(dir, shBasis);

                    // accummuulate
                    for (var j = 0; j < 9; j++) {
                      shCoefficients[j].x += shBasis[j] * color.r * weight;
                      shCoefficients[j].y += shBasis[j] * color.g * weight;
                      shCoefficients[j].z += shBasis[j] * color.b * weight;
                    }
                  }
                }

                // normalize
                var norm = 4 * Math.PI / totalWeight;
                for (var _j19 = 0; _j19 < 9; _j19++) {
                  shCoefficients[_j19].x *= norm;
                  shCoefficients[_j19].y *= norm;
                  shCoefficients[_j19].z *= norm;
                }
                return new three__WEBPACK_IMPORTED_MODULE_0__.LightProbe(sh);
              }
            }, {
              key: "fromCubeRenderTarget",
              value: function fromCubeRenderTarget(renderer, cubeRenderTarget) {
                // The renderTarget must be set to RGBA in order to make readRenderTargetPixels works
                var totalWeight = 0;
                var coord = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
                var dir = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
                var color = new three__WEBPACK_IMPORTED_MODULE_0__.Color();
                var shBasis = [0, 0, 0, 0, 0, 0, 0, 0, 0];
                var sh = new three__WEBPACK_IMPORTED_MODULE_0__.SphericalHarmonics3();
                var shCoefficients = sh.coefficients;
                for (var faceIndex = 0; faceIndex < 6; faceIndex++) {
                  var imageWidth = cubeRenderTarget.width; // assumed to be square
                  var data = new Uint8Array(imageWidth * imageWidth * 4);
                  renderer.readRenderTargetPixels(cubeRenderTarget, 0, 0, imageWidth, imageWidth, data, faceIndex);
                  var pixelSize = 2 / imageWidth;
                  for (var i = 0, il = data.length; i < il; i += 4) {
                    // RGBA assumed

                    // pixel color
                    color.setRGB(data[i] / 255, data[i + 1] / 255, data[i + 2] / 255);

                    // convert to linear color space
                    convertColorToLinear(color, cubeRenderTarget.texture.encoding);

                    // pixel coordinate on unit cube

                    var pixelIndex = i / 4;
                    var col = -1 + (pixelIndex % imageWidth + 0.5) * pixelSize;
                    var row = 1 - (Math.floor(pixelIndex / imageWidth) + 0.5) * pixelSize;
                    switch (faceIndex) {
                      case 0:
                        coord.set(1, row, -col);
                        break;
                      case 1:
                        coord.set(-1, row, col);
                        break;
                      case 2:
                        coord.set(col, 1, -row);
                        break;
                      case 3:
                        coord.set(col, -1, row);
                        break;
                      case 4:
                        coord.set(col, row, 1);
                        break;
                      case 5:
                        coord.set(-col, row, -1);
                        break;
                    }

                    // weight assigned to this pixel

                    var lengthSq = coord.lengthSq();
                    var weight = 4 / (Math.sqrt(lengthSq) * lengthSq);
                    totalWeight += weight;

                    // direction vector to this pixel
                    dir.copy(coord).normalize();

                    // evaluate SH basis functions in direction dir
                    three__WEBPACK_IMPORTED_MODULE_0__.SphericalHarmonics3.getBasisAt(dir, shBasis);

                    // accummuulate
                    for (var j = 0; j < 9; j++) {
                      shCoefficients[j].x += shBasis[j] * color.r * weight;
                      shCoefficients[j].y += shBasis[j] * color.g * weight;
                      shCoefficients[j].z += shBasis[j] * color.b * weight;
                    }
                  }
                }

                // normalize
                var norm = 4 * Math.PI / totalWeight;
                for (var _j20 = 0; _j20 < 9; _j20++) {
                  shCoefficients[_j20].x *= norm;
                  shCoefficients[_j20].y *= norm;
                  shCoefficients[_j20].z *= norm;
                }
                return new three__WEBPACK_IMPORTED_MODULE_0__.LightProbe(sh);
              }
            }]);
            return _LightProbeGenerator;
          }();
          function convertColorToLinear(color, encoding) {
            switch (encoding) {
              case three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding:
                color.convertSRGBToLinear();
                break;
              case three__WEBPACK_IMPORTED_MODULE_0__.LinearEncoding:
                break;
              default:
                console.warn('WARNING: LightProbeGenerator convertColorToLinear() encountered an unsupported encoding.');
                break;
            }
            return color;
          }

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/loaders/DRACOLoader.js":
        /*!**********************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/loaders/DRACOLoader.js ***!
          \**********************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLoadersDRACOLoaderJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"DRACOLoader": function DRACOLoader() {
              return (/* binding */_DRACOLoader
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");
          var _taskCache = new WeakMap();
          var _DRACOLoader = /*#__PURE__*/function (_three__WEBPACK_IMPOR) {
            _inherits(_DRACOLoader, _three__WEBPACK_IMPOR);
            var _super189 = _createSuper(_DRACOLoader);
            function _DRACOLoader(manager) {
              var _this141;
              _classCallCheck2(this, _DRACOLoader);
              _this141 = _super189.call(this, manager);
              _this141.decoderPath = '';
              _this141.decoderConfig = {};
              _this141.decoderBinary = null;
              _this141.decoderPending = null;
              _this141.workerLimit = 4;
              _this141.workerPool = [];
              _this141.workerNextTaskID = 1;
              _this141.workerSourceURL = '';
              _this141.defaultAttributeIDs = {
                position: 'POSITION',
                normal: 'NORMAL',
                color: 'COLOR',
                uv: 'TEX_COORD'
              };
              _this141.defaultAttributeTypes = {
                position: 'Float32Array',
                normal: 'Float32Array',
                color: 'Float32Array',
                uv: 'Float32Array'
              };
              return _this141;
            }
            _createClass2(_DRACOLoader, [{
              key: "setDecoderPath",
              value: function setDecoderPath(path) {
                this.decoderPath = path;
                return this;
              }
            }, {
              key: "setDecoderConfig",
              value: function setDecoderConfig(config) {
                this.decoderConfig = config;
                return this;
              }
            }, {
              key: "setWorkerLimit",
              value: function setWorkerLimit(workerLimit) {
                this.workerLimit = workerLimit;
                return this;
              }
            }, {
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var _this142 = this;
                var loader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (buffer) {
                  _this142.decodeDracoFile(buffer, onLoad).catch(onError);
                }, onProgress, onError);
              }
            }, {
              key: "decodeDracoFile",
              value: function decodeDracoFile(buffer, callback, attributeIDs, attributeTypes) {
                var taskConfig = {
                  attributeIDs: attributeIDs || this.defaultAttributeIDs,
                  attributeTypes: attributeTypes || this.defaultAttributeTypes,
                  useUniqueIDs: !!attributeIDs
                };
                return this.decodeGeometry(buffer, taskConfig).then(callback);
              }
            }, {
              key: "decodeGeometry",
              value: function decodeGeometry(buffer, taskConfig) {
                var _this143 = this;
                var taskKey = JSON.stringify(taskConfig);

                // Check for an existing task using this buffer. A transferred buffer cannot be transferred
                // again from this thread.
                if (_taskCache.has(buffer)) {
                  var cachedTask = _taskCache.get(buffer);
                  if (cachedTask.key === taskKey) {
                    return cachedTask.promise;
                  } else if (buffer.byteLength === 0) {
                    // Technically, it would be possible to wait for the previous task to complete,
                    // transfer the buffer back, and decode again with the second configuration. That
                    // is complex, and I don't know of any reason to decode a Draco buffer twice in
                    // different ways, so this is left unimplemented.
                    throw new Error('THREE.DRACOLoader: Unable to re-decode a buffer with different ' + 'settings. Buffer has already been transferred.');
                  }
                }

                //

                var worker;
                var taskID = this.workerNextTaskID++;
                var taskCost = buffer.byteLength;

                // Obtain a worker and assign a task, and construct a geometry instance
                // when the task completes.
                var geometryPending = this._getWorker(taskID, taskCost).then(function (_worker) {
                  worker = _worker;
                  return new Promise(function (resolve, reject) {
                    worker._callbacks[taskID] = {
                      resolve: resolve,
                      reject: reject
                    };
                    worker.postMessage({
                      type: 'decode',
                      id: taskID,
                      taskConfig: taskConfig,
                      buffer: buffer
                    }, [buffer]);

                    // this.debug();
                  });
                }).then(function (message) {
                  return _this143._createGeometry(message.geometry);
                });

                // Remove task from the task list.
                // Note: replaced '.finally()' with '.catch().then()' block - iOS 11 support (#19416)
                geometryPending.catch(function () {
                  return true;
                }).then(function () {
                  if (worker && taskID) {
                    _this143._releaseTask(worker, taskID);

                    // this.debug();
                  }
                });

                // Cache the task result.
                _taskCache.set(buffer, {
                  key: taskKey,
                  promise: geometryPending
                });
                return geometryPending;
              }
            }, {
              key: "_createGeometry",
              value: function _createGeometry(geometryData) {
                var geometry = new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry();
                if (geometryData.index) {
                  geometry.setIndex(new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(geometryData.index.array, 1));
                }
                for (var i = 0; i < geometryData.attributes.length; i++) {
                  var attribute = geometryData.attributes[i];
                  var name = attribute.name;
                  var array = attribute.array;
                  var itemSize = attribute.itemSize;
                  geometry.setAttribute(name, new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(array, itemSize));
                }
                return geometry;
              }
            }, {
              key: "_loadLibrary",
              value: function _loadLibrary(url, responseType) {
                var loader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                loader.setPath(this.decoderPath);
                loader.setResponseType(responseType);
                loader.setWithCredentials(this.withCredentials);
                return new Promise(function (resolve, reject) {
                  loader.load(url, resolve, undefined, reject);
                });
              }
            }, {
              key: "preload",
              value: function preload() {
                this._initDecoder();
                return this;
              }
            }, {
              key: "_initDecoder",
              value: function _initDecoder() {
                var _this144 = this;
                if (this.decoderPending) return this.decoderPending;
                var useJS = typeof WebAssembly !== 'object' || this.decoderConfig.type === 'js';
                var librariesPending = [];
                if (useJS) {
                  librariesPending.push(this._loadLibrary('draco_decoder.js', 'text'));
                } else {
                  librariesPending.push(this._loadLibrary('draco_wasm_wrapper.js', 'text'));
                  librariesPending.push(this._loadLibrary('draco_decoder.wasm', 'arraybuffer'));
                }
                this.decoderPending = Promise.all(librariesPending).then(function (libraries) {
                  var jsContent = libraries[0];
                  if (!useJS) {
                    _this144.decoderConfig.wasmBinary = libraries[1];
                  }
                  var fn = DRACOWorker.toString();
                  var body = ['/* draco decoder */', jsContent, '', '/* worker */', fn.substring(fn.indexOf('{') + 1, fn.lastIndexOf('}'))].join('\n');
                  _this144.workerSourceURL = URL.createObjectURL(new Blob([body]));
                });
                return this.decoderPending;
              }
            }, {
              key: "_getWorker",
              value: function _getWorker(taskID, taskCost) {
                var _this145 = this;
                return this._initDecoder().then(function () {
                  if (_this145.workerPool.length < _this145.workerLimit) {
                    var _worker2 = new Worker(_this145.workerSourceURL);
                    _worker2._callbacks = {};
                    _worker2._taskCosts = {};
                    _worker2._taskLoad = 0;
                    _worker2.postMessage({
                      type: 'init',
                      decoderConfig: _this145.decoderConfig
                    });
                    _worker2.onmessage = function (e) {
                      var message = e.data;
                      switch (message.type) {
                        case 'decode':
                          _worker2._callbacks[message.id].resolve(message);
                          break;
                        case 'error':
                          _worker2._callbacks[message.id].reject(message);
                          break;
                        default:
                          console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                      }
                    };
                    _this145.workerPool.push(_worker2);
                  } else {
                    _this145.workerPool.sort(function (a, b) {
                      return a._taskLoad > b._taskLoad ? -1 : 1;
                    });
                  }
                  var worker = _this145.workerPool[_this145.workerPool.length - 1];
                  worker._taskCosts[taskID] = taskCost;
                  worker._taskLoad += taskCost;
                  return worker;
                });
              }
            }, {
              key: "_releaseTask",
              value: function _releaseTask(worker, taskID) {
                worker._taskLoad -= worker._taskCosts[taskID];
                delete worker._callbacks[taskID];
                delete worker._taskCosts[taskID];
              }
            }, {
              key: "debug",
              value: function debug() {
                console.log('Task load: ', this.workerPool.map(function (worker) {
                  return worker._taskLoad;
                }));
              }
            }, {
              key: "dispose",
              value: function dispose() {
                for (var i = 0; i < this.workerPool.length; ++i) {
                  this.workerPool[i].terminate();
                }
                this.workerPool.length = 0;
                return this;
              }
            }]);
            return _DRACOLoader;
          }(three__WEBPACK_IMPORTED_MODULE_0__.Loader);
          /* WEB WORKER */
          function DRACOWorker() {
            var decoderConfig;
            var decoderPending;
            onmessage = function onmessage(e) {
              var message = e.data;
              switch (message.type) {
                case 'init':
                  decoderConfig = message.decoderConfig;
                  decoderPending = new Promise(function (resolve /*, reject*/) {
                    decoderConfig.onModuleLoaded = function (draco) {
                      // Module is Promise-like. Wrap before resolving to avoid loop.
                      resolve({
                        draco: draco
                      });
                    };
                    DracoDecoderModule(decoderConfig); // eslint-disable-line no-undef
                  });

                  break;
                case 'decode':
                  var buffer = message.buffer;
                  var taskConfig = message.taskConfig;
                  decoderPending.then(function (module) {
                    var draco = module.draco;
                    var decoder = new draco.Decoder();
                    var decoderBuffer = new draco.DecoderBuffer();
                    decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
                    try {
                      var geometry = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
                      var buffers = geometry.attributes.map(function (attr) {
                        return attr.array.buffer;
                      });
                      if (geometry.index) buffers.push(geometry.index.array.buffer);
                      self.postMessage({
                        type: 'decode',
                        id: message.id,
                        geometry: geometry
                      }, buffers);
                    } catch (error) {
                      console.error(error);
                      self.postMessage({
                        type: 'error',
                        id: message.id,
                        error: error.message
                      });
                    } finally {
                      draco.destroy(decoderBuffer);
                      draco.destroy(decoder);
                    }
                  });
                  break;
              }
            };
            function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
              var attributeIDs = taskConfig.attributeIDs;
              var attributeTypes = taskConfig.attributeTypes;
              var dracoGeometry;
              var decodingStatus;
              var geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
              if (geometryType === draco.TRIANGULAR_MESH) {
                dracoGeometry = new draco.Mesh();
                decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
              } else if (geometryType === draco.POINT_CLOUD) {
                dracoGeometry = new draco.PointCloud();
                decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
              } else {
                throw new Error('THREE.DRACOLoader: Unexpected geometry type.');
              }
              if (!decodingStatus.ok() || dracoGeometry.ptr === 0) {
                throw new Error('THREE.DRACOLoader: Decoding failed: ' + decodingStatus.error_msg());
              }
              var geometry = {
                index: null,
                attributes: []
              };

              // Gather all vertex attributes.
              for (var attributeName in attributeIDs) {
                var attributeType = self[attributeTypes[attributeName]];
                var attribute = void 0;
                var attributeID = void 0;

                // A Draco file may be created with default vertex attributes, whose attribute IDs
                // are mapped 1:1 from their semantic name (POSITION, NORMAL, ...). Alternatively,
                // a Draco file may contain a custom set of attributes, identified by known unique
                // IDs. glTF files always do the latter, and `.drc` files typically do the former.
                if (taskConfig.useUniqueIDs) {
                  attributeID = attributeIDs[attributeName];
                  attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
                } else {
                  attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                  if (attributeID === -1) continue;
                  attribute = decoder.GetAttribute(dracoGeometry, attributeID);
                }
                geometry.attributes.push(decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute));
              }

              // Add index.
              if (geometryType === draco.TRIANGULAR_MESH) {
                geometry.index = decodeIndex(draco, decoder, dracoGeometry);
              }
              draco.destroy(dracoGeometry);
              return geometry;
            }
            function decodeIndex(draco, decoder, dracoGeometry) {
              var numFaces = dracoGeometry.num_faces();
              var numIndices = numFaces * 3;
              var byteLength = numIndices * 4;
              var ptr = draco._malloc(byteLength);
              decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
              var index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
              draco._free(ptr);
              return {
                array: index,
                itemSize: 1
              };
            }
            function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
              var numComponents = attribute.num_components();
              var numPoints = dracoGeometry.num_points();
              var numValues = numPoints * numComponents;
              var byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
              var dataType = getDracoDataType(draco, attributeType);
              var ptr = draco._malloc(byteLength);
              decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
              var array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
              draco._free(ptr);
              return {
                name: attributeName,
                array: array,
                itemSize: numComponents
              };
            }
            function getDracoDataType(draco, attributeType) {
              switch (attributeType) {
                case Float32Array:
                  return draco.DT_FLOAT32;
                case Int8Array:
                  return draco.DT_INT8;
                case Int16Array:
                  return draco.DT_INT16;
                case Int32Array:
                  return draco.DT_INT32;
                case Uint8Array:
                  return draco.DT_UINT8;
                case Uint16Array:
                  return draco.DT_UINT16;
                case Uint32Array:
                  return draco.DT_UINT32;
              }
            }
          }

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/loaders/GLTFLoader.js":
        /*!*********************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/loaders/GLTFLoader.js ***!
          \*********************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLoadersGLTFLoaderJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"GLTFLoader": function GLTFLoader() {
              return (/* binding */_GLTFLoader
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");
          var _GLTFLoader = /*#__PURE__*/function (_three__WEBPACK_IMPOR2) {
            _inherits(_GLTFLoader, _three__WEBPACK_IMPOR2);
            var _super190 = _createSuper(_GLTFLoader);
            function _GLTFLoader(manager) {
              var _this146;
              _classCallCheck2(this, _GLTFLoader);
              _this146 = _super190.call(this, manager);
              _this146.dracoLoader = null;
              _this146.ktx2Loader = null;
              _this146.meshoptDecoder = null;
              _this146.pluginCallbacks = [];
              _this146.register(function (parser) {
                return new GLTFMaterialsClearcoatExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFTextureBasisUExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFTextureWebPExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsSheenExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsTransmissionExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsVolumeExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsIorExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsEmissiveStrengthExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsSpecularExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMaterialsIridescenceExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFLightsExtension(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMeshoptCompression(parser);
              });
              _this146.register(function (parser) {
                return new GLTFMeshGpuInstancing(parser);
              });
              return _this146;
            }
            _createClass2(_GLTFLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var resourcePath;
                if (this.resourcePath !== '') {
                  resourcePath = this.resourcePath;
                } else if (this.path !== '') {
                  resourcePath = this.path;
                } else {
                  resourcePath = three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.extractUrlBase(url);
                }

                // Tells the LoadingManager to track an extra item, which resolves after
                // the model is fully loaded. This means the count of items loaded will
                // be incorrect, but ensures manager.onLoad() does not fire early.
                this.manager.itemStart(url);
                var _onError = function _onError(e) {
                  if (onError) {
                    onError(e);
                  } else {
                    console.error(e);
                  }
                  scope.manager.itemError(url);
                  scope.manager.itemEnd(url);
                };
                var loader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (data) {
                  try {
                    scope.parse(data, resourcePath, function (gltf) {
                      onLoad(gltf);
                      scope.manager.itemEnd(url);
                    }, _onError);
                  } catch (e) {
                    _onError(e);
                  }
                }, onProgress, _onError);
              }
            }, {
              key: "setDRACOLoader",
              value: function setDRACOLoader(dracoLoader) {
                this.dracoLoader = dracoLoader;
                return this;
              }
            }, {
              key: "setDDSLoader",
              value: function setDDSLoader() {
                throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
              }
            }, {
              key: "setKTX2Loader",
              value: function setKTX2Loader(ktx2Loader) {
                this.ktx2Loader = ktx2Loader;
                return this;
              }
            }, {
              key: "setMeshoptDecoder",
              value: function setMeshoptDecoder(meshoptDecoder) {
                this.meshoptDecoder = meshoptDecoder;
                return this;
              }
            }, {
              key: "register",
              value: function register(callback) {
                if (this.pluginCallbacks.indexOf(callback) === -1) {
                  this.pluginCallbacks.push(callback);
                }
                return this;
              }
            }, {
              key: "unregister",
              value: function unregister(callback) {
                if (this.pluginCallbacks.indexOf(callback) !== -1) {
                  this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
                }
                return this;
              }
            }, {
              key: "parse",
              value: function parse(data, path, onLoad, onError) {
                var json;
                var extensions = {};
                var plugins = {};
                if (typeof data === 'string') {
                  json = JSON.parse(data);
                } else if (data instanceof ArrayBuffer) {
                  var magic = three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.decodeText(new Uint8Array(data, 0, 4));
                  if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
                    try {
                      extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
                    } catch (error) {
                      if (onError) onError(error);
                      return;
                    }
                    json = JSON.parse(extensions[EXTENSIONS.KHR_BINARY_GLTF].content);
                  } else {
                    json = JSON.parse(three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.decodeText(new Uint8Array(data)));
                  }
                } else {
                  json = data;
                }
                if (json.asset === undefined || json.asset.version[0] < 2) {
                  if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
                  return;
                }
                var parser = new GLTFParser(json, {
                  path: path || this.resourcePath || '',
                  crossOrigin: this.crossOrigin,
                  requestHeader: this.requestHeader,
                  manager: this.manager,
                  ktx2Loader: this.ktx2Loader,
                  meshoptDecoder: this.meshoptDecoder
                });
                parser.fileLoader.setRequestHeader(this.requestHeader);
                for (var i = 0; i < this.pluginCallbacks.length; i++) {
                  var plugin = this.pluginCallbacks[i](parser);
                  plugins[plugin.name] = plugin;

                  // Workaround to avoid determining as unknown extension
                  // in addUnknownExtensionsToUserData().
                  // Remove this workaround if we move all the existing
                  // extension handlers to plugin system
                  extensions[plugin.name] = true;
                }
                if (json.extensionsUsed) {
                  for (var _i99 = 0; _i99 < json.extensionsUsed.length; ++_i99) {
                    var extensionName = json.extensionsUsed[_i99];
                    var extensionsRequired = json.extensionsRequired || [];
                    switch (extensionName) {
                      case EXTENSIONS.KHR_MATERIALS_UNLIT:
                        extensions[extensionName] = new GLTFMaterialsUnlitExtension();
                        break;
                      case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                        extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                        break;
                      case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                        extensions[extensionName] = new GLTFTextureTransformExtension();
                        break;
                      case EXTENSIONS.KHR_MESH_QUANTIZATION:
                        extensions[extensionName] = new GLTFMeshQuantizationExtension();
                        break;
                      default:
                        if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) {
                          console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
                        }
                    }
                  }
                }
                parser.setExtensions(extensions);
                parser.setPlugins(plugins);
                parser.parse(onLoad, onError);
              }
            }, {
              key: "parseAsync",
              value: function parseAsync(data, path) {
                var scope = this;
                return new Promise(function (resolve, reject) {
                  scope.parse(data, path, resolve, reject);
                });
              }
            }]);
            return _GLTFLoader;
          }(three__WEBPACK_IMPORTED_MODULE_0__.Loader);
          /* GLTFREGISTRY */
          function GLTFRegistry() {
            var objects = {};
            return {
              get: function get(key) {
                return objects[key];
              },
              add: function add(key, object) {
                objects[key] = object;
              },
              remove: function remove(key) {
                delete objects[key];
              },
              removeAll: function removeAll() {
                objects = {};
              }
            };
          }

          /*********************************/
          /********** EXTENSIONS ***********/
          /*********************************/

          var EXTENSIONS = {
            KHR_BINARY_GLTF: 'KHR_binary_glTF',
            KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
            KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
            KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
            KHR_MATERIALS_IOR: 'KHR_materials_ior',
            KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
            KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
            KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
            KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
            KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
            KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
            KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
            KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
            KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
            KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
            EXT_TEXTURE_WEBP: 'EXT_texture_webp',
            EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
            EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
          };

          /**
           * Punctual Lights Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
           */
          var GLTFLightsExtension = /*#__PURE__*/function () {
            function GLTFLightsExtension(parser) {
              _classCallCheck2(this, GLTFLightsExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;

              // Object3D instance caches
              this.cache = {
                refs: {},
                uses: {}
              };
            }
            _createClass2(GLTFLightsExtension, [{
              key: "_markDefs",
              value: function _markDefs() {
                var parser = this.parser;
                var nodeDefs = this.parser.json.nodes || [];
                for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
                  var nodeDef = nodeDefs[nodeIndex];
                  if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) {
                    parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
                  }
                }
              }
            }, {
              key: "_loadLight",
              value: function _loadLight(lightIndex) {
                var parser = this.parser;
                var cacheKey = 'light:' + lightIndex;
                var dependency = parser.cache.get(cacheKey);
                if (dependency) return dependency;
                var json = parser.json;
                var extensions = json.extensions && json.extensions[this.name] || {};
                var lightDefs = extensions.lights || [];
                var lightDef = lightDefs[lightIndex];
                var lightNode;
                var color = new three__WEBPACK_IMPORTED_MODULE_0__.Color(0xffffff);
                if (lightDef.color !== undefined) color.fromArray(lightDef.color);
                var range = lightDef.range !== undefined ? lightDef.range : 0;
                switch (lightDef.type) {
                  case 'directional':
                    lightNode = new three__WEBPACK_IMPORTED_MODULE_0__.DirectionalLight(color);
                    lightNode.target.position.set(0, 0, -1);
                    lightNode.add(lightNode.target);
                    break;
                  case 'point':
                    lightNode = new three__WEBPACK_IMPORTED_MODULE_0__.PointLight(color);
                    lightNode.distance = range;
                    break;
                  case 'spot':
                    lightNode = new three__WEBPACK_IMPORTED_MODULE_0__.SpotLight(color);
                    lightNode.distance = range;
                    // Handle spotlight properties.
                    lightDef.spot = lightDef.spot || {};
                    lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                    lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                    lightNode.angle = lightDef.spot.outerConeAngle;
                    lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                    lightNode.target.position.set(0, 0, -1);
                    lightNode.add(lightNode.target);
                    break;
                  default:
                    throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);
                }

                // Some lights (e.g. spot) default to a position other than the origin. Reset the position
                // here, because node-level parsing will only override position if explicitly specified.
                lightNode.position.set(0, 0, 0);
                lightNode.decay = 2;
                assignExtrasToUserData(lightNode, lightDef);
                if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
                lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);
                dependency = Promise.resolve(lightNode);
                parser.cache.add(cacheKey, dependency);
                return dependency;
              }
            }, {
              key: "getDependency",
              value: function getDependency(type, index) {
                if (type !== 'light') return;
                return this._loadLight(index);
              }
            }, {
              key: "createNodeAttachment",
              value: function createNodeAttachment(nodeIndex) {
                var self = this;
                var parser = this.parser;
                var json = parser.json;
                var nodeDef = json.nodes[nodeIndex];
                var lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
                var lightIndex = lightDef.light;
                if (lightIndex === undefined) return null;
                return this._loadLight(lightIndex).then(function (light) {
                  return parser._getNodeRef(self.cache, lightIndex, light);
                });
              }
            }]);
            return GLTFLightsExtension;
          }();
          /**
           * Unlit Materials Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
           */
          var GLTFMaterialsUnlitExtension = /*#__PURE__*/function () {
            function GLTFMaterialsUnlitExtension() {
              _classCallCheck2(this, GLTFMaterialsUnlitExtension);
              this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
            }
            _createClass2(GLTFMaterialsUnlitExtension, [{
              key: "getMaterialType",
              value: function getMaterialType() {
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial;
              }
            }, {
              key: "extendParams",
              value: function extendParams(materialParams, materialDef, parser) {
                var pending = [];
                materialParams.color = new three__WEBPACK_IMPORTED_MODULE_0__.Color(1.0, 1.0, 1.0);
                materialParams.opacity = 1.0;
                var metallicRoughness = materialDef.pbrMetallicRoughness;
                if (metallicRoughness) {
                  if (Array.isArray(metallicRoughness.baseColorFactor)) {
                    var array = metallicRoughness.baseColorFactor;
                    materialParams.color.fromArray(array);
                    materialParams.opacity = array[3];
                  }
                  if (metallicRoughness.baseColorTexture !== undefined) {
                    pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding));
                  }
                }
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsUnlitExtension;
          }();
          /**
           * Materials Emissive Strength Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
           */
          var GLTFMaterialsEmissiveStrengthExtension = /*#__PURE__*/function () {
            function GLTFMaterialsEmissiveStrengthExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsEmissiveStrengthExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
            }
            _createClass2(GLTFMaterialsEmissiveStrengthExtension, [{
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
                if (emissiveStrength !== undefined) {
                  materialParams.emissiveIntensity = emissiveStrength;
                }
                return Promise.resolve();
              }
            }]);
            return GLTFMaterialsEmissiveStrengthExtension;
          }();
          /**
           * Clearcoat Materials Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
           */
          var GLTFMaterialsClearcoatExtension = /*#__PURE__*/function () {
            function GLTFMaterialsClearcoatExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsClearcoatExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
            }
            _createClass2(GLTFMaterialsClearcoatExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var pending = [];
                var extension = materialDef.extensions[this.name];
                if (extension.clearcoatFactor !== undefined) {
                  materialParams.clearcoat = extension.clearcoatFactor;
                }
                if (extension.clearcoatTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
                }
                if (extension.clearcoatRoughnessFactor !== undefined) {
                  materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
                }
                if (extension.clearcoatRoughnessTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
                }
                if (extension.clearcoatNormalTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));
                  if (extension.clearcoatNormalTexture.scale !== undefined) {
                    var scale = extension.clearcoatNormalTexture.scale;
                    materialParams.clearcoatNormalScale = new three__WEBPACK_IMPORTED_MODULE_0__.Vector2(scale, scale);
                  }
                }
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsClearcoatExtension;
          }();
          /**
           * Iridescence Materials Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
           */
          var GLTFMaterialsIridescenceExtension = /*#__PURE__*/function () {
            function GLTFMaterialsIridescenceExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsIridescenceExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
            }
            _createClass2(GLTFMaterialsIridescenceExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var pending = [];
                var extension = materialDef.extensions[this.name];
                if (extension.iridescenceFactor !== undefined) {
                  materialParams.iridescence = extension.iridescenceFactor;
                }
                if (extension.iridescenceTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
                }
                if (extension.iridescenceIor !== undefined) {
                  materialParams.iridescenceIOR = extension.iridescenceIor;
                }
                if (materialParams.iridescenceThicknessRange === undefined) {
                  materialParams.iridescenceThicknessRange = [100, 400];
                }
                if (extension.iridescenceThicknessMinimum !== undefined) {
                  materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
                }
                if (extension.iridescenceThicknessMaximum !== undefined) {
                  materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
                }
                if (extension.iridescenceThicknessTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
                }
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsIridescenceExtension;
          }();
          /**
           * Sheen Materials Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
           */
          var GLTFMaterialsSheenExtension = /*#__PURE__*/function () {
            function GLTFMaterialsSheenExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsSheenExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
            }
            _createClass2(GLTFMaterialsSheenExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var pending = [];
                materialParams.sheenColor = new three__WEBPACK_IMPORTED_MODULE_0__.Color(0, 0, 0);
                materialParams.sheenRoughness = 0;
                materialParams.sheen = 1;
                var extension = materialDef.extensions[this.name];
                if (extension.sheenColorFactor !== undefined) {
                  materialParams.sheenColor.fromArray(extension.sheenColorFactor);
                }
                if (extension.sheenRoughnessFactor !== undefined) {
                  materialParams.sheenRoughness = extension.sheenRoughnessFactor;
                }
                if (extension.sheenColorTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding));
                }
                if (extension.sheenRoughnessTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
                }
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsSheenExtension;
          }();
          /**
           * Transmission Materials Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
           * Draft: https://github.com/KhronosGroup/glTF/pull/1698
           */
          var GLTFMaterialsTransmissionExtension = /*#__PURE__*/function () {
            function GLTFMaterialsTransmissionExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsTransmissionExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
            }
            _createClass2(GLTFMaterialsTransmissionExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var pending = [];
                var extension = materialDef.extensions[this.name];
                if (extension.transmissionFactor !== undefined) {
                  materialParams.transmission = extension.transmissionFactor;
                }
                if (extension.transmissionTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
                }
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsTransmissionExtension;
          }();
          /**
           * Materials Volume Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
           */
          var GLTFMaterialsVolumeExtension = /*#__PURE__*/function () {
            function GLTFMaterialsVolumeExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsVolumeExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
            }
            _createClass2(GLTFMaterialsVolumeExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var pending = [];
                var extension = materialDef.extensions[this.name];
                materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
                if (extension.thicknessTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
                }
                materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
                var colorArray = extension.attenuationColor || [1, 1, 1];
                materialParams.attenuationColor = new three__WEBPACK_IMPORTED_MODULE_0__.Color(colorArray[0], colorArray[1], colorArray[2]);
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsVolumeExtension;
          }();
          /**
           * Materials ior Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
           */
          var GLTFMaterialsIorExtension = /*#__PURE__*/function () {
            function GLTFMaterialsIorExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsIorExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_IOR;
            }
            _createClass2(GLTFMaterialsIorExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var extension = materialDef.extensions[this.name];
                materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
                return Promise.resolve();
              }
            }]);
            return GLTFMaterialsIorExtension;
          }();
          /**
           * Materials specular Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
           */
          var GLTFMaterialsSpecularExtension = /*#__PURE__*/function () {
            function GLTFMaterialsSpecularExtension(parser) {
              _classCallCheck2(this, GLTFMaterialsSpecularExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
            }
            _createClass2(GLTFMaterialsSpecularExtension, [{
              key: "getMaterialType",
              value: function getMaterialType(materialIndex) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshPhysicalMaterial;
              }
            }, {
              key: "extendMaterialParams",
              value: function extendMaterialParams(materialIndex, materialParams) {
                var parser = this.parser;
                var materialDef = parser.json.materials[materialIndex];
                if (!materialDef.extensions || !materialDef.extensions[this.name]) {
                  return Promise.resolve();
                }
                var pending = [];
                var extension = materialDef.extensions[this.name];
                materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
                if (extension.specularTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
                }
                var colorArray = extension.specularColorFactor || [1, 1, 1];
                materialParams.specularColor = new three__WEBPACK_IMPORTED_MODULE_0__.Color(colorArray[0], colorArray[1], colorArray[2]);
                if (extension.specularColorTexture !== undefined) {
                  pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding));
                }
                return Promise.all(pending);
              }
            }]);
            return GLTFMaterialsSpecularExtension;
          }();
          /**
           * BasisU Texture Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
           */
          var GLTFTextureBasisUExtension = /*#__PURE__*/function () {
            function GLTFTextureBasisUExtension(parser) {
              _classCallCheck2(this, GLTFTextureBasisUExtension);
              this.parser = parser;
              this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
            }
            _createClass2(GLTFTextureBasisUExtension, [{
              key: "loadTexture",
              value: function loadTexture(textureIndex) {
                var parser = this.parser;
                var json = parser.json;
                var textureDef = json.textures[textureIndex];
                if (!textureDef.extensions || !textureDef.extensions[this.name]) {
                  return null;
                }
                var extension = textureDef.extensions[this.name];
                var loader = parser.options.ktx2Loader;
                if (!loader) {
                  if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
                    throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
                  } else {
                    // Assumes that the extension is optional and that a fallback texture is present
                    return null;
                  }
                }
                return parser.loadTextureImage(textureIndex, extension.source, loader);
              }
            }]);
            return GLTFTextureBasisUExtension;
          }();
          /**
           * WebP Texture Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
           */
          var GLTFTextureWebPExtension = /*#__PURE__*/function () {
            function GLTFTextureWebPExtension(parser) {
              _classCallCheck2(this, GLTFTextureWebPExtension);
              this.parser = parser;
              this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
              this.isSupported = null;
            }
            _createClass2(GLTFTextureWebPExtension, [{
              key: "loadTexture",
              value: function loadTexture(textureIndex) {
                var name = this.name;
                var parser = this.parser;
                var json = parser.json;
                var textureDef = json.textures[textureIndex];
                if (!textureDef.extensions || !textureDef.extensions[name]) {
                  return null;
                }
                var extension = textureDef.extensions[name];
                var source = json.images[extension.source];
                var loader = parser.textureLoader;
                if (source.uri) {
                  var handler = parser.options.manager.getHandler(source.uri);
                  if (handler !== null) loader = handler;
                }
                return this.detectSupport().then(function (isSupported) {
                  if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
                  if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
                    throw new Error('THREE.GLTFLoader: WebP required by asset but unsupported.');
                  }

                  // Fall back to PNG or JPEG.
                  return parser.loadTexture(textureIndex);
                });
              }
            }, {
              key: "detectSupport",
              value: function detectSupport() {
                if (!this.isSupported) {
                  this.isSupported = new Promise(function (resolve) {
                    var image = new Image();

                    // Lossy test image. Support for lossy images doesn't guarantee support for all
                    // WebP images, unfortunately.
                    image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
                    image.onload = image.onerror = function () {
                      resolve(image.height === 1);
                    };
                  });
                }
                return this.isSupported;
              }
            }]);
            return GLTFTextureWebPExtension;
          }();
          /**
           * meshopt BufferView Compression Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
           */
          var GLTFMeshoptCompression = /*#__PURE__*/function () {
            function GLTFMeshoptCompression(parser) {
              _classCallCheck2(this, GLTFMeshoptCompression);
              this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
              this.parser = parser;
            }
            _createClass2(GLTFMeshoptCompression, [{
              key: "loadBufferView",
              value: function loadBufferView(index) {
                var json = this.parser.json;
                var bufferView = json.bufferViews[index];
                if (bufferView.extensions && bufferView.extensions[this.name]) {
                  var extensionDef = bufferView.extensions[this.name];
                  var buffer = this.parser.getDependency('buffer', extensionDef.buffer);
                  var decoder = this.parser.options.meshoptDecoder;
                  if (!decoder || !decoder.supported) {
                    if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
                      throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
                    } else {
                      // Assumes that the extension is optional and that fallback buffer data is present
                      return null;
                    }
                  }
                  return buffer.then(function (res) {
                    var byteOffset = extensionDef.byteOffset || 0;
                    var byteLength = extensionDef.byteLength || 0;
                    var count = extensionDef.count;
                    var stride = extensionDef.byteStride;
                    var source = new Uint8Array(res, byteOffset, byteLength);
                    if (decoder.decodeGltfBufferAsync) {
                      return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function (res) {
                        return res.buffer;
                      });
                    } else {
                      // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                      return decoder.ready.then(function () {
                        var result = new ArrayBuffer(count * stride);
                        decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                        return result;
                      });
                    }
                  });
                } else {
                  return null;
                }
              }
            }]);
            return GLTFMeshoptCompression;
          }();
          /**
           * GPU Instancing Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
           *
           */
          var GLTFMeshGpuInstancing = /*#__PURE__*/function () {
            function GLTFMeshGpuInstancing(parser) {
              _classCallCheck2(this, GLTFMeshGpuInstancing);
              this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
              this.parser = parser;
            }
            _createClass2(GLTFMeshGpuInstancing, [{
              key: "createNodeMesh",
              value: function createNodeMesh(nodeIndex) {
                var _this147 = this;
                var json = this.parser.json;
                var nodeDef = json.nodes[nodeIndex];
                if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) {
                  return null;
                }
                var meshDef = json.meshes[nodeDef.mesh];

                // No Points or Lines + Instancing support yet
                var _iterator13 = _createForOfIteratorHelper2(meshDef.primitives),
                  _step13;
                try {
                  for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                    var primitive = _step13.value;
                    if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) {
                      return null;
                    }
                  }
                } catch (err) {
                  _iterator13.e(err);
                } finally {
                  _iterator13.f();
                }
                var extensionDef = nodeDef.extensions[this.name];
                var attributesDef = extensionDef.attributes;

                // @TODO: Can we support InstancedMesh + SkinnedMesh?

                var pending = [];
                var attributes = {};
                var _loop2 = function _loop2(key) {
                  pending.push(_this147.parser.getDependency('accessor', attributesDef[key]).then(function (accessor) {
                    attributes[key] = accessor;
                    return attributes[key];
                  }));
                };
                for (var key in attributesDef) {
                  _loop2(key);
                }
                if (pending.length < 1) {
                  return null;
                }
                pending.push(this.parser.createNodeMesh(nodeIndex));
                return Promise.all(pending).then(function (results) {
                  var nodeObject = results.pop();
                  var meshes = nodeObject.isGroup ? nodeObject.children : [nodeObject];
                  var count = results[0].count; // All attribute counts should be same
                  var instancedMeshes = [];
                  var _iterator14 = _createForOfIteratorHelper2(meshes),
                    _step14;
                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var mesh = _step14.value;
                      // Temporal variables
                      var m = new three__WEBPACK_IMPORTED_MODULE_0__.Matrix4();
                      var p = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
                      var q = new three__WEBPACK_IMPORTED_MODULE_0__.Quaternion();
                      var s = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(1, 1, 1);
                      var instancedMesh = new three__WEBPACK_IMPORTED_MODULE_0__.InstancedMesh(mesh.geometry, mesh.material, count);
                      for (var i = 0; i < count; i++) {
                        if (attributes.TRANSLATION) {
                          p.fromBufferAttribute(attributes.TRANSLATION, i);
                        }
                        if (attributes.ROTATION) {
                          q.fromBufferAttribute(attributes.ROTATION, i);
                        }
                        if (attributes.SCALE) {
                          s.fromBufferAttribute(attributes.SCALE, i);
                        }
                        instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                      }

                      // Add instance attributes to the geometry, excluding TRS.
                      for (var attributeName in attributes) {
                        if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') {
                          mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                        }
                      }

                      // Just in case
                      three__WEBPACK_IMPORTED_MODULE_0__.Object3D.prototype.copy.call(instancedMesh, mesh);

                      // https://github.com/mrdoob/three.js/issues/18334
                      instancedMesh.frustumCulled = false;
                      _this147.parser.assignFinalMaterial(instancedMesh);
                      instancedMeshes.push(instancedMesh);
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                  if (nodeObject.isGroup) {
                    nodeObject.clear();
                    nodeObject.add.apply(nodeObject, instancedMeshes);
                    return nodeObject;
                  }
                  return instancedMeshes[0];
                });
              }
            }]);
            return GLTFMeshGpuInstancing;
          }();
          /* BINARY EXTENSION */
          var BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
          var BINARY_EXTENSION_HEADER_LENGTH = 12;
          var BINARY_EXTENSION_CHUNK_TYPES = {
            JSON: 0x4E4F534A,
            BIN: 0x004E4942
          };
          var GLTFBinaryExtension = /*#__PURE__*/_createClass2(function GLTFBinaryExtension(data) {
            _classCallCheck2(this, GLTFBinaryExtension);
            this.name = EXTENSIONS.KHR_BINARY_GLTF;
            this.content = null;
            this.body = null;
            var headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
            this.header = {
              magic: three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.decodeText(new Uint8Array(data.slice(0, 4))),
              version: headerView.getUint32(4, true),
              length: headerView.getUint32(8, true)
            };
            if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
              throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
            } else if (this.header.version < 2.0) {
              throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
            }
            var chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
            var chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
            var chunkIndex = 0;
            while (chunkIndex < chunkContentsLength) {
              var chunkLength = chunkView.getUint32(chunkIndex, true);
              chunkIndex += 4;
              var chunkType = chunkView.getUint32(chunkIndex, true);
              chunkIndex += 4;
              if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                var contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.decodeText(contentArray);
              } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                var byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
              }

              // Clients must ignore chunks with unknown types.

              chunkIndex += chunkLength;
            }
            if (this.content === null) {
              throw new Error('THREE.GLTFLoader: JSON content not found.');
            }
          });
          /**
           * DRACO Mesh Compression Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
           */
          var GLTFDracoMeshCompressionExtension = /*#__PURE__*/function () {
            function GLTFDracoMeshCompressionExtension(json, dracoLoader) {
              _classCallCheck2(this, GLTFDracoMeshCompressionExtension);
              if (!dracoLoader) {
                throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
              }
              this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
              this.json = json;
              this.dracoLoader = dracoLoader;
              this.dracoLoader.preload();
            }
            _createClass2(GLTFDracoMeshCompressionExtension, [{
              key: "decodePrimitive",
              value: function decodePrimitive(primitive, parser) {
                var json = this.json;
                var dracoLoader = this.dracoLoader;
                var bufferViewIndex = primitive.extensions[this.name].bufferView;
                var gltfAttributeMap = primitive.extensions[this.name].attributes;
                var threeAttributeMap = {};
                var attributeNormalizedMap = {};
                var attributeTypeMap = {};
                for (var attributeName in gltfAttributeMap) {
                  var threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
                  threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
                }
                for (var _attributeName in primitive.attributes) {
                  var _threeAttributeName = ATTRIBUTES[_attributeName] || _attributeName.toLowerCase();
                  if (gltfAttributeMap[_attributeName] !== undefined) {
                    var accessorDef = json.accessors[primitive.attributes[_attributeName]];
                    var componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                    attributeTypeMap[_threeAttributeName] = componentType.name;
                    attributeNormalizedMap[_threeAttributeName] = accessorDef.normalized === true;
                  }
                }
                return parser.getDependency('bufferView', bufferViewIndex).then(function (bufferView) {
                  return new Promise(function (resolve) {
                    dracoLoader.decodeDracoFile(bufferView, function (geometry) {
                      for (var _attributeName2 in geometry.attributes) {
                        var attribute = geometry.attributes[_attributeName2];
                        var normalized = attributeNormalizedMap[_attributeName2];
                        if (normalized !== undefined) attribute.normalized = normalized;
                      }
                      resolve(geometry);
                    }, threeAttributeMap, attributeTypeMap);
                  });
                });
              }
            }]);
            return GLTFDracoMeshCompressionExtension;
          }();
          /**
           * Texture Transform Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
           */
          var GLTFTextureTransformExtension = /*#__PURE__*/function () {
            function GLTFTextureTransformExtension() {
              _classCallCheck2(this, GLTFTextureTransformExtension);
              this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
            }
            _createClass2(GLTFTextureTransformExtension, [{
              key: "extendTexture",
              value: function extendTexture(texture, transform) {
                if (transform.texCoord !== undefined) {
                  console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.');
                }
                if (transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) {
                  // See https://github.com/mrdoob/three.js/issues/21819.
                  return texture;
                }
                texture = texture.clone();
                if (transform.offset !== undefined) {
                  texture.offset.fromArray(transform.offset);
                }
                if (transform.rotation !== undefined) {
                  texture.rotation = transform.rotation;
                }
                if (transform.scale !== undefined) {
                  texture.repeat.fromArray(transform.scale);
                }
                texture.needsUpdate = true;
                return texture;
              }
            }]);
            return GLTFTextureTransformExtension;
          }();
          /**
           * Mesh Quantization Extension
           *
           * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
           */
          var GLTFMeshQuantizationExtension = /*#__PURE__*/_createClass2(function GLTFMeshQuantizationExtension() {
            _classCallCheck2(this, GLTFMeshQuantizationExtension);
            this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
          });
          /*********************************/
          /********** INTERPOLATION ********/
          /*********************************/
          // Spline Interpolation
          // Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
          var GLTFCubicSplineInterpolant = /*#__PURE__*/function (_three__WEBPACK_IMPOR3) {
            _inherits(GLTFCubicSplineInterpolant, _three__WEBPACK_IMPOR3);
            var _super191 = _createSuper(GLTFCubicSplineInterpolant);
            function GLTFCubicSplineInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
              _classCallCheck2(this, GLTFCubicSplineInterpolant);
              return _super191.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
            }
            _createClass2(GLTFCubicSplineInterpolant, [{
              key: "copySampleValue_",
              value: function copySampleValue_(index) {
                // Copies a sample value to the result buffer. See description of glTF
                // CUBICSPLINE values layout in interpolate_() function below.

                var result = this.resultBuffer,
                  values = this.sampleValues,
                  valueSize = this.valueSize,
                  offset = index * valueSize * 3 + valueSize;
                for (var i = 0; i !== valueSize; i++) {
                  result[i] = values[offset + i];
                }
                return result;
              }
            }, {
              key: "interpolate_",
              value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer;
                var values = this.sampleValues;
                var stride = this.valueSize;
                var stride2 = stride * 2;
                var stride3 = stride * 3;
                var td = t1 - t0;
                var p = (t - t0) / td;
                var pp = p * p;
                var ppp = pp * p;
                var offset1 = i1 * stride3;
                var offset0 = offset1 - stride3;
                var s2 = -2 * ppp + 3 * pp;
                var s3 = ppp - pp;
                var s0 = 1 - s2;
                var s1 = s3 - pp + p;

                // Layout of keyframe output values for CUBICSPLINE animations:
                //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
                for (var i = 0; i !== stride; i++) {
                  var p0 = values[offset0 + i + stride]; // splineVertex_k
                  var m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
                  var p1 = values[offset1 + i + stride]; // splineVertex_k+1
                  var m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)

                  result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
                }
                return result;
              }
            }]);
            return GLTFCubicSplineInterpolant;
          }(three__WEBPACK_IMPORTED_MODULE_0__.Interpolant);
          var _q = new three__WEBPACK_IMPORTED_MODULE_0__.Quaternion();
          var GLTFCubicSplineQuaternionInterpolant = /*#__PURE__*/function (_GLTFCubicSplineInter) {
            _inherits(GLTFCubicSplineQuaternionInterpolant, _GLTFCubicSplineInter);
            var _super192 = _createSuper(GLTFCubicSplineQuaternionInterpolant);
            function GLTFCubicSplineQuaternionInterpolant() {
              _classCallCheck2(this, GLTFCubicSplineQuaternionInterpolant);
              return _super192.apply(this, arguments);
            }
            _createClass2(GLTFCubicSplineQuaternionInterpolant, [{
              key: "interpolate_",
              value: function interpolate_(i1, t0, t, t1) {
                var result = _get2(_getPrototypeOf(GLTFCubicSplineQuaternionInterpolant.prototype), "interpolate_", this).call(this, i1, t0, t, t1);
                _q.fromArray(result).normalize().toArray(result);
                return result;
              }
            }]);
            return GLTFCubicSplineQuaternionInterpolant;
          }(GLTFCubicSplineInterpolant);
          /*********************************/
          /********** INTERNALS ************/
          /*********************************/
          /* CONSTANTS */
          var WEBGL_CONSTANTS = {
            FLOAT: 5126,
            //FLOAT_MAT2: 35674,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
          };
          var WEBGL_COMPONENT_TYPES = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
          };
          var WEBGL_FILTERS = {
            9728: three__WEBPACK_IMPORTED_MODULE_0__.NearestFilter,
            9729: three__WEBPACK_IMPORTED_MODULE_0__.LinearFilter,
            9984: three__WEBPACK_IMPORTED_MODULE_0__.NearestMipmapNearestFilter,
            9985: three__WEBPACK_IMPORTED_MODULE_0__.LinearMipmapNearestFilter,
            9986: three__WEBPACK_IMPORTED_MODULE_0__.NearestMipmapLinearFilter,
            9987: three__WEBPACK_IMPORTED_MODULE_0__.LinearMipmapLinearFilter
          };
          var WEBGL_WRAPPINGS = {
            33071: three__WEBPACK_IMPORTED_MODULE_0__.ClampToEdgeWrapping,
            33648: three__WEBPACK_IMPORTED_MODULE_0__.MirroredRepeatWrapping,
            10497: three__WEBPACK_IMPORTED_MODULE_0__.RepeatWrapping
          };
          var WEBGL_TYPE_SIZES = {
            'SCALAR': 1,
            'VEC2': 2,
            'VEC3': 3,
            'VEC4': 4,
            'MAT2': 4,
            'MAT3': 9,
            'MAT4': 16
          };
          var ATTRIBUTES = {
            POSITION: 'position',
            NORMAL: 'normal',
            TANGENT: 'tangent',
            TEXCOORD_0: 'uv',
            TEXCOORD_1: 'uv2',
            COLOR_0: 'color',
            WEIGHTS_0: 'skinWeight',
            JOINTS_0: 'skinIndex'
          };
          var PATH_PROPERTIES = {
            scale: 'scale',
            translation: 'position',
            rotation: 'quaternion',
            weights: 'morphTargetInfluences'
          };
          var INTERPOLATION = {
            CUBICSPLINE: undefined,
            // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
            // keyframe track will be initialized with a default interpolation type, then modified.
            LINEAR: three__WEBPACK_IMPORTED_MODULE_0__.InterpolateLinear,
            STEP: three__WEBPACK_IMPORTED_MODULE_0__.InterpolateDiscrete
          };
          var ALPHA_MODES = {
            OPAQUE: 'OPAQUE',
            MASK: 'MASK',
            BLEND: 'BLEND'
          };

          /**
           * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
           */
          function createDefaultMaterial(cache) {
            if (cache['DefaultMaterial'] === undefined) {
              cache['DefaultMaterial'] = new three__WEBPACK_IMPORTED_MODULE_0__.MeshStandardMaterial({
                color: 0xFFFFFF,
                emissive: 0x000000,
                metalness: 1,
                roughness: 1,
                transparent: false,
                depthTest: true,
                side: three__WEBPACK_IMPORTED_MODULE_0__.FrontSide
              });
            }
            return cache['DefaultMaterial'];
          }
          function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
            // Add unknown glTF extensions to an object's userData.

            for (var name in objectDef.extensions) {
              if (knownExtensions[name] === undefined) {
                object.userData.gltfExtensions = object.userData.gltfExtensions || {};
                object.userData.gltfExtensions[name] = objectDef.extensions[name];
              }
            }
          }

          /**
           * @param {Object3D|Material|BufferGeometry} object
           * @param {GLTF.definition} gltfDef
           */
          function assignExtrasToUserData(object, gltfDef) {
            if (gltfDef.extras !== undefined) {
              if (typeof gltfDef.extras === 'object') {
                Object.assign(object.userData, gltfDef.extras);
              } else {
                console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
              }
            }
          }

          /**
           * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
           *
           * @param {BufferGeometry} geometry
           * @param {Array<GLTF.Target>} targets
           * @param {GLTFParser} parser
           * @return {Promise<BufferGeometry>}
           */
          function addMorphTargets(geometry, targets, parser) {
            var hasMorphPosition = false;
            var hasMorphNormal = false;
            var hasMorphColor = false;
            for (var i = 0, il = targets.length; i < il; i++) {
              var target = targets[i];
              if (target.POSITION !== undefined) hasMorphPosition = true;
              if (target.NORMAL !== undefined) hasMorphNormal = true;
              if (target.COLOR_0 !== undefined) hasMorphColor = true;
              if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
            }
            if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
            var pendingPositionAccessors = [];
            var pendingNormalAccessors = [];
            var pendingColorAccessors = [];
            for (var _i100 = 0, _il19 = targets.length; _i100 < _il19; _i100++) {
              var _target2 = targets[_i100];
              if (hasMorphPosition) {
                var pendingAccessor = _target2.POSITION !== undefined ? parser.getDependency('accessor', _target2.POSITION) : geometry.attributes.position;
                pendingPositionAccessors.push(pendingAccessor);
              }
              if (hasMorphNormal) {
                var _pendingAccessor = _target2.NORMAL !== undefined ? parser.getDependency('accessor', _target2.NORMAL) : geometry.attributes.normal;
                pendingNormalAccessors.push(_pendingAccessor);
              }
              if (hasMorphColor) {
                var _pendingAccessor2 = _target2.COLOR_0 !== undefined ? parser.getDependency('accessor', _target2.COLOR_0) : geometry.attributes.color;
                pendingColorAccessors.push(_pendingAccessor2);
              }
            }
            return Promise.all([Promise.all(pendingPositionAccessors), Promise.all(pendingNormalAccessors), Promise.all(pendingColorAccessors)]).then(function (accessors) {
              var morphPositions = accessors[0];
              var morphNormals = accessors[1];
              var morphColors = accessors[2];
              if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
              if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
              if (hasMorphColor) geometry.morphAttributes.color = morphColors;
              geometry.morphTargetsRelative = true;
              return geometry;
            });
          }

          /**
           * @param {Mesh} mesh
           * @param {GLTF.Mesh} meshDef
           */
          function updateMorphTargets(mesh, meshDef) {
            mesh.updateMorphTargets();
            if (meshDef.weights !== undefined) {
              for (var i = 0, il = meshDef.weights.length; i < il; i++) {
                mesh.morphTargetInfluences[i] = meshDef.weights[i];
              }
            }

            // .extras has user-defined data, so check that .extras.targetNames is an array.
            if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
              var targetNames = meshDef.extras.targetNames;
              if (mesh.morphTargetInfluences.length === targetNames.length) {
                mesh.morphTargetDictionary = {};
                for (var _i101 = 0, _il20 = targetNames.length; _i101 < _il20; _i101++) {
                  mesh.morphTargetDictionary[targetNames[_i101]] = _i101;
                }
              } else {
                console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
              }
            }
          }
          function createPrimitiveKey(primitiveDef) {
            var dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
            var geometryKey;
            if (dracoExtension) {
              geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + createAttributesKey(dracoExtension.attributes);
            } else {
              geometryKey = primitiveDef.indices + ':' + createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
            }
            return geometryKey;
          }
          function createAttributesKey(attributes) {
            var attributesKey = '';
            var keys = Object.keys(attributes).sort();
            for (var i = 0, il = keys.length; i < il; i++) {
              attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
            }
            return attributesKey;
          }
          function getNormalizedComponentScale(constructor) {
            // Reference:
            // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data

            switch (constructor) {
              case Int8Array:
                return 1 / 127;
              case Uint8Array:
                return 1 / 255;
              case Int16Array:
                return 1 / 32767;
              case Uint16Array:
                return 1 / 65535;
              default:
                throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');
            }
          }
          function getImageURIMimeType(uri) {
            if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
            if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';
            return 'image/png';
          }

          /* GLTF PARSER */
          var GLTFParser = /*#__PURE__*/function () {
            function GLTFParser() {
              var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck2(this, GLTFParser);
              this.json = json;
              this.extensions = {};
              this.plugins = {};
              this.options = options;

              // loader object cache
              this.cache = new GLTFRegistry();

              // associations between Three.js objects and glTF elements
              this.associations = new Map();

              // BufferGeometry caching
              this.primitiveCache = {};

              // Object3D instance caches
              this.meshCache = {
                refs: {},
                uses: {}
              };
              this.cameraCache = {
                refs: {},
                uses: {}
              };
              this.lightCache = {
                refs: {},
                uses: {}
              };
              this.sourceCache = {};
              this.textureCache = {};

              // Track node names, to ensure no duplicates
              this.nodeNamesUsed = {};

              // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
              // expensive work of uploading a texture to the GPU off the main thread.

              var isSafari = false;
              var isFirefox = false;
              var firefoxVersion = -1;
              if (typeof navigator !== 'undefined') {
                isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
                isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
                firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
              }
              if (typeof createImageBitmap === 'undefined' || isSafari || isFirefox && firefoxVersion < 98) {
                this.textureLoader = new three__WEBPACK_IMPORTED_MODULE_0__.TextureLoader(this.options.manager);
              } else {
                this.textureLoader = new three__WEBPACK_IMPORTED_MODULE_0__.ImageBitmapLoader(this.options.manager);
              }
              this.textureLoader.setCrossOrigin(this.options.crossOrigin);
              this.textureLoader.setRequestHeader(this.options.requestHeader);
              this.fileLoader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.options.manager);
              this.fileLoader.setResponseType('arraybuffer');
              if (this.options.crossOrigin === 'use-credentials') {
                this.fileLoader.setWithCredentials(true);
              }
            }
            _createClass2(GLTFParser, [{
              key: "setExtensions",
              value: function setExtensions(extensions) {
                this.extensions = extensions;
              }
            }, {
              key: "setPlugins",
              value: function setPlugins(plugins) {
                this.plugins = plugins;
              }
            }, {
              key: "parse",
              value: function parse(onLoad, onError) {
                var parser = this;
                var json = this.json;
                var extensions = this.extensions;

                // Clear the loader cache
                this.cache.removeAll();

                // Mark the special nodes/meshes in json for efficient parse
                this._invokeAll(function (ext) {
                  return ext._markDefs && ext._markDefs();
                });
                Promise.all(this._invokeAll(function (ext) {
                  return ext.beforeRoot && ext.beforeRoot();
                })).then(function () {
                  return Promise.all([parser.getDependencies('scene'), parser.getDependencies('animation'), parser.getDependencies('camera')]);
                }).then(function (dependencies) {
                  var result = {
                    scene: dependencies[0][json.scene || 0],
                    scenes: dependencies[0],
                    animations: dependencies[1],
                    cameras: dependencies[2],
                    asset: json.asset,
                    parser: parser,
                    userData: {}
                  };
                  addUnknownExtensionsToUserData(extensions, result, json);
                  assignExtrasToUserData(result, json);
                  Promise.all(parser._invokeAll(function (ext) {
                    return ext.afterRoot && ext.afterRoot(result);
                  })).then(function () {
                    onLoad(result);
                  });
                }).catch(onError);
              }

              /**
               * Marks the special nodes/meshes in json for efficient parse.
               */
            }, {
              key: "_markDefs",
              value: function _markDefs() {
                var nodeDefs = this.json.nodes || [];
                var skinDefs = this.json.skins || [];
                var meshDefs = this.json.meshes || [];

                // Nothing in the node definition indicates whether it is a Bone or an
                // Object3D. Use the skins' joint references to mark bones.
                for (var skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
                  var joints = skinDefs[skinIndex].joints;
                  for (var i = 0, il = joints.length; i < il; i++) {
                    nodeDefs[joints[i]].isBone = true;
                  }
                }

                // Iterate over all nodes, marking references to shared resources,
                // as well as skeleton joints.
                for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
                  var nodeDef = nodeDefs[nodeIndex];
                  if (nodeDef.mesh !== undefined) {
                    this._addNodeRef(this.meshCache, nodeDef.mesh);

                    // Nothing in the mesh definition indicates whether it is
                    // a SkinnedMesh or Mesh. Use the node's mesh reference
                    // to mark SkinnedMesh if node has skin.
                    if (nodeDef.skin !== undefined) {
                      meshDefs[nodeDef.mesh].isSkinnedMesh = true;
                    }
                  }
                  if (nodeDef.camera !== undefined) {
                    this._addNodeRef(this.cameraCache, nodeDef.camera);
                  }
                }
              }

              /**
               * Counts references to shared node / Object3D resources. These resources
               * can be reused, or "instantiated", at multiple nodes in the scene
               * hierarchy. Mesh, Camera, and Light instances are instantiated and must
               * be marked. Non-scenegraph resources (like Materials, Geometries, and
               * Textures) can be reused directly and are not marked here.
               *
               * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
               */
            }, {
              key: "_addNodeRef",
              value: function _addNodeRef(cache, index) {
                if (index === undefined) return;
                if (cache.refs[index] === undefined) {
                  cache.refs[index] = cache.uses[index] = 0;
                }
                cache.refs[index]++;
              }

              /** Returns a reference to a shared resource, cloning it if necessary. */
            }, {
              key: "_getNodeRef",
              value: function _getNodeRef(cache, index, object) {
                var _this148 = this;
                if (cache.refs[index] <= 1) return object;
                var ref = object.clone();

                // Propagates mappings to the cloned object, prevents mappings on the
                // original object from being lost.
                var updateMappings = function updateMappings(original, clone) {
                  var mappings = _this148.associations.get(original);
                  if (mappings != null) {
                    _this148.associations.set(clone, mappings);
                  }
                  var _iterator15 = _createForOfIteratorHelper2(original.children.entries()),
                    _step15;
                  try {
                    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                      var _step15$value = _slicedToArray(_step15.value, 2),
                        i = _step15$value[0],
                        child = _step15$value[1];
                      updateMappings(child, clone.children[i]);
                    }
                  } catch (err) {
                    _iterator15.e(err);
                  } finally {
                    _iterator15.f();
                  }
                };
                updateMappings(object, ref);
                ref.name += '_instance_' + cache.uses[index]++;
                return ref;
              }
            }, {
              key: "_invokeOne",
              value: function _invokeOne(func) {
                var extensions = Object.values(this.plugins);
                extensions.push(this);
                for (var i = 0; i < extensions.length; i++) {
                  var result = func(extensions[i]);
                  if (result) return result;
                }
                return null;
              }
            }, {
              key: "_invokeAll",
              value: function _invokeAll(func) {
                var extensions = Object.values(this.plugins);
                extensions.unshift(this);
                var pending = [];
                for (var i = 0; i < extensions.length; i++) {
                  var result = func(extensions[i]);
                  if (result) pending.push(result);
                }
                return pending;
              }

              /**
               * Requests the specified dependency asynchronously, with caching.
               * @param {string} type
               * @param {number} index
               * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
               */
            }, {
              key: "getDependency",
              value: function getDependency(type, index) {
                var cacheKey = type + ':' + index;
                var dependency = this.cache.get(cacheKey);
                if (!dependency) {
                  switch (type) {
                    case 'scene':
                      dependency = this.loadScene(index);
                      break;
                    case 'node':
                      dependency = this.loadNode(index);
                      break;
                    case 'mesh':
                      dependency = this._invokeOne(function (ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                      });
                      break;
                    case 'accessor':
                      dependency = this.loadAccessor(index);
                      break;
                    case 'bufferView':
                      dependency = this._invokeOne(function (ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                      });
                      break;
                    case 'buffer':
                      dependency = this.loadBuffer(index);
                      break;
                    case 'material':
                      dependency = this._invokeOne(function (ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                      });
                      break;
                    case 'texture':
                      dependency = this._invokeOne(function (ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                      });
                      break;
                    case 'skin':
                      dependency = this.loadSkin(index);
                      break;
                    case 'animation':
                      dependency = this._invokeOne(function (ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                      });
                      break;
                    case 'camera':
                      dependency = this.loadCamera(index);
                      break;
                    default:
                      dependency = this._invokeOne(function (ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                      });
                      if (!dependency) {
                        throw new Error('Unknown type: ' + type);
                      }
                      break;
                  }
                  this.cache.add(cacheKey, dependency);
                }
                return dependency;
              }

              /**
               * Requests all dependencies of the specified type asynchronously, with caching.
               * @param {string} type
               * @return {Promise<Array<Object>>}
               */
            }, {
              key: "getDependencies",
              value: function getDependencies(type) {
                var dependencies = this.cache.get(type);
                if (!dependencies) {
                  var parser = this;
                  var defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];
                  dependencies = Promise.all(defs.map(function (def, index) {
                    return parser.getDependency(type, index);
                  }));
                  this.cache.add(type, dependencies);
                }
                return dependencies;
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
               * @param {number} bufferIndex
               * @return {Promise<ArrayBuffer>}
               */
            }, {
              key: "loadBuffer",
              value: function loadBuffer(bufferIndex) {
                var bufferDef = this.json.buffers[bufferIndex];
                var loader = this.fileLoader;
                if (bufferDef.type && bufferDef.type !== 'arraybuffer') {
                  throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
                }

                // If present, GLB container is required to be the first buffer.
                if (bufferDef.uri === undefined && bufferIndex === 0) {
                  return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
                }
                var options = this.options;
                return new Promise(function (resolve, reject) {
                  loader.load(three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.resolveURL(bufferDef.uri, options.path), resolve, undefined, function () {
                    reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
                  });
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
               * @param {number} bufferViewIndex
               * @return {Promise<ArrayBuffer>}
               */
            }, {
              key: "loadBufferView",
              value: function loadBufferView(bufferViewIndex) {
                var bufferViewDef = this.json.bufferViews[bufferViewIndex];
                return this.getDependency('buffer', bufferViewDef.buffer).then(function (buffer) {
                  var byteLength = bufferViewDef.byteLength || 0;
                  var byteOffset = bufferViewDef.byteOffset || 0;
                  return buffer.slice(byteOffset, byteOffset + byteLength);
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
               * @param {number} accessorIndex
               * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
               */
            }, {
              key: "loadAccessor",
              value: function loadAccessor(accessorIndex) {
                var parser = this;
                var json = this.json;
                var accessorDef = this.json.accessors[accessorIndex];
                if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
                  var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
                  var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                  var normalized = accessorDef.normalized === true;
                  var array = new TypedArray(accessorDef.count * itemSize);
                  return Promise.resolve(new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(array, itemSize, normalized));
                }
                var pendingBufferViews = [];
                if (accessorDef.bufferView !== undefined) {
                  pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
                } else {
                  pendingBufferViews.push(null);
                }
                if (accessorDef.sparse !== undefined) {
                  pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
                  pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
                }
                return Promise.all(pendingBufferViews).then(function (bufferViews) {
                  var bufferView = bufferViews[0];
                  var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
                  var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];

                  // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
                  var elementBytes = TypedArray.BYTES_PER_ELEMENT;
                  var itemBytes = elementBytes * itemSize;
                  var byteOffset = accessorDef.byteOffset || 0;
                  var byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
                  var normalized = accessorDef.normalized === true;
                  var array, bufferAttribute;

                  // The buffer is not interleaved if the stride is the item size in bytes.
                  if (byteStride && byteStride !== itemBytes) {
                    // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                    // This makes sure that IBA.count reflects accessor.count properly
                    var ibSlice = Math.floor(byteOffset / byteStride);
                    var ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
                    var ib = parser.cache.get(ibCacheKey);
                    if (!ib) {
                      array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);

                      // Integer parameters to IB/IBA are in array elements, not bytes.
                      ib = new three__WEBPACK_IMPORTED_MODULE_0__.InterleavedBuffer(array, byteStride / elementBytes);
                      parser.cache.add(ibCacheKey, ib);
                    }
                    bufferAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.InterleavedBufferAttribute(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
                  } else {
                    if (bufferView === null) {
                      array = new TypedArray(accessorDef.count * itemSize);
                    } else {
                      array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                    }
                    bufferAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(array, itemSize, normalized);
                  }

                  // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
                  if (accessorDef.sparse !== undefined) {
                    var itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
                    var TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                    var byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                    var byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                    var sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                    var sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                    if (bufferView !== null) {
                      // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                      bufferAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                    }
                    for (var i = 0, il = sparseIndices.length; i < il; i++) {
                      var index = sparseIndices[i];
                      bufferAttribute.setX(index, sparseValues[i * itemSize]);
                      if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                      if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                      if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                      if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
                    }
                  }
                  return bufferAttribute;
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
               * @param {number} textureIndex
               * @return {Promise<THREE.Texture|null>}
               */
            }, {
              key: "loadTexture",
              value: function loadTexture(textureIndex) {
                var json = this.json;
                var options = this.options;
                var textureDef = json.textures[textureIndex];
                var sourceIndex = textureDef.source;
                var sourceDef = json.images[sourceIndex];
                var loader = this.textureLoader;
                if (sourceDef.uri) {
                  var handler = options.manager.getHandler(sourceDef.uri);
                  if (handler !== null) loader = handler;
                }
                return this.loadTextureImage(textureIndex, sourceIndex, loader);
              }
            }, {
              key: "loadTextureImage",
              value: function loadTextureImage(textureIndex, sourceIndex, loader) {
                var parser = this;
                var json = this.json;
                var textureDef = json.textures[textureIndex];
                var sourceDef = json.images[sourceIndex];
                var cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;
                if (this.textureCache[cacheKey]) {
                  // See https://github.com/mrdoob/three.js/issues/21559.
                  return this.textureCache[cacheKey];
                }
                var promise = this.loadImageSource(sourceIndex, loader).then(function (texture) {
                  texture.flipY = false;
                  texture.name = textureDef.name || sourceDef.name || '';
                  var samplers = json.samplers || {};
                  var sampler = samplers[textureDef.sampler] || {};
                  texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || three__WEBPACK_IMPORTED_MODULE_0__.LinearFilter;
                  texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || three__WEBPACK_IMPORTED_MODULE_0__.LinearMipmapLinearFilter;
                  texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || three__WEBPACK_IMPORTED_MODULE_0__.RepeatWrapping;
                  texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || three__WEBPACK_IMPORTED_MODULE_0__.RepeatWrapping;
                  parser.associations.set(texture, {
                    textures: textureIndex
                  });
                  return texture;
                }).catch(function () {
                  return null;
                });
                this.textureCache[cacheKey] = promise;
                return promise;
              }
            }, {
              key: "loadImageSource",
              value: function loadImageSource(sourceIndex, loader) {
                var parser = this;
                var json = this.json;
                var options = this.options;
                if (this.sourceCache[sourceIndex] !== undefined) {
                  return this.sourceCache[sourceIndex].then(function (texture) {
                    return texture.clone();
                  });
                }
                var sourceDef = json.images[sourceIndex];
                var URL = self.URL || self.webkitURL;
                var sourceURI = sourceDef.uri || '';
                var isObjectURL = false;
                if (sourceDef.bufferView !== undefined) {
                  // Load binary image data from bufferView, if provided.

                  sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function (bufferView) {
                    isObjectURL = true;
                    var blob = new Blob([bufferView], {
                      type: sourceDef.mimeType
                    });
                    sourceURI = URL.createObjectURL(blob);
                    return sourceURI;
                  });
                } else if (sourceDef.uri === undefined) {
                  throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
                }
                var promise = Promise.resolve(sourceURI).then(function (sourceURI) {
                  return new Promise(function (resolve, reject) {
                    var onLoad = resolve;
                    if (loader.isImageBitmapLoader === true) {
                      onLoad = function onLoad(imageBitmap) {
                        var texture = new three__WEBPACK_IMPORTED_MODULE_0__.Texture(imageBitmap);
                        texture.needsUpdate = true;
                        resolve(texture);
                      };
                    }
                    loader.load(three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.resolveURL(sourceURI, options.path), onLoad, undefined, reject);
                  });
                }).then(function (texture) {
                  // Clean up resources and configure Texture.

                  if (isObjectURL === true) {
                    URL.revokeObjectURL(sourceURI);
                  }
                  texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
                  return texture;
                }).catch(function (error) {
                  console.error('THREE.GLTFLoader: Couldn\'t load texture', sourceURI);
                  throw error;
                });
                this.sourceCache[sourceIndex] = promise;
                return promise;
              }

              /**
               * Asynchronously assigns a texture to the given material parameters.
               * @param {Object} materialParams
               * @param {string} mapName
               * @param {Object} mapDef
               * @return {Promise<Texture>}
               */
            }, {
              key: "assignTexture",
              value: function assignTexture(materialParams, mapName, mapDef, encoding) {
                var parser = this;
                return this.getDependency('texture', mapDef.index).then(function (texture) {
                  if (!texture) return null;

                  // Materials sample aoMap from UV set 1 and other maps from UV set 0 - this can't be configured
                  // However, we will copy UV set 0 to UV set 1 on demand for aoMap
                  if (mapDef.texCoord !== undefined && mapDef.texCoord != 0 && !(mapName === 'aoMap' && mapDef.texCoord == 1)) {
                    console.warn('THREE.GLTFLoader: Custom UV set ' + mapDef.texCoord + ' for texture ' + mapName + ' not yet supported.');
                  }
                  if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                    var transform = mapDef.extensions !== undefined ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                    if (transform) {
                      var gltfReference = parser.associations.get(texture);
                      texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                      parser.associations.set(texture, gltfReference);
                    }
                  }
                  if (encoding !== undefined) {
                    texture.encoding = encoding;
                  }
                  materialParams[mapName] = texture;
                  return texture;
                });
              }

              /**
               * Assigns final material to a Mesh, Line, or Points instance. The instance
               * already has a material (generated from the glTF material options alone)
               * but reuse of the same glTF material may require multiple threejs materials
               * to accommodate different primitive types, defines, etc. New materials will
               * be created if necessary, and reused from a cache.
               * @param  {Object3D} mesh Mesh, Line, or Points instance.
               */
            }, {
              key: "assignFinalMaterial",
              value: function assignFinalMaterial(mesh) {
                var geometry = mesh.geometry;
                var material = mesh.material;
                var useDerivativeTangents = geometry.attributes.tangent === undefined;
                var useVertexColors = geometry.attributes.color !== undefined;
                var useFlatShading = geometry.attributes.normal === undefined;
                if (mesh.isPoints) {
                  var cacheKey = 'PointsMaterial:' + material.uuid;
                  var pointsMaterial = this.cache.get(cacheKey);
                  if (!pointsMaterial) {
                    pointsMaterial = new three__WEBPACK_IMPORTED_MODULE_0__.PointsMaterial();
                    three__WEBPACK_IMPORTED_MODULE_0__.Material.prototype.copy.call(pointsMaterial, material);
                    pointsMaterial.color.copy(material.color);
                    pointsMaterial.map = material.map;
                    pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px

                    this.cache.add(cacheKey, pointsMaterial);
                  }
                  material = pointsMaterial;
                } else if (mesh.isLine) {
                  var _cacheKey = 'LineBasicMaterial:' + material.uuid;
                  var lineMaterial = this.cache.get(_cacheKey);
                  if (!lineMaterial) {
                    lineMaterial = new three__WEBPACK_IMPORTED_MODULE_0__.LineBasicMaterial();
                    three__WEBPACK_IMPORTED_MODULE_0__.Material.prototype.copy.call(lineMaterial, material);
                    lineMaterial.color.copy(material.color);
                    this.cache.add(_cacheKey, lineMaterial);
                  }
                  material = lineMaterial;
                }

                // Clone the material if it will be modified
                if (useDerivativeTangents || useVertexColors || useFlatShading) {
                  var _cacheKey2 = 'ClonedMaterial:' + material.uuid + ':';
                  if (useDerivativeTangents) _cacheKey2 += 'derivative-tangents:';
                  if (useVertexColors) _cacheKey2 += 'vertex-colors:';
                  if (useFlatShading) _cacheKey2 += 'flat-shading:';
                  var cachedMaterial = this.cache.get(_cacheKey2);
                  if (!cachedMaterial) {
                    cachedMaterial = material.clone();
                    if (useVertexColors) cachedMaterial.vertexColors = true;
                    if (useFlatShading) cachedMaterial.flatShading = true;
                    if (useDerivativeTangents) {
                      // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                      if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                      if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                    }
                    this.cache.add(_cacheKey2, cachedMaterial);
                    this.associations.set(cachedMaterial, this.associations.get(material));
                  }
                  material = cachedMaterial;
                }

                // workarounds for mesh and geometry

                if (material.aoMap && geometry.attributes.uv2 === undefined && geometry.attributes.uv !== undefined) {
                  geometry.setAttribute('uv2', geometry.attributes.uv);
                }
                mesh.material = material;
              }
            }, {
              key: "getMaterialType",
              value: function getMaterialType( /* materialIndex */
              ) {
                return three__WEBPACK_IMPORTED_MODULE_0__.MeshStandardMaterial;
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
               * @param {number} materialIndex
               * @return {Promise<Material>}
               */
            }, {
              key: "loadMaterial",
              value: function loadMaterial(materialIndex) {
                var parser = this;
                var json = this.json;
                var extensions = this.extensions;
                var materialDef = json.materials[materialIndex];
                var materialType;
                var materialParams = {};
                var materialExtensions = materialDef.extensions || {};
                var pending = [];
                if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
                  var kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
                  materialType = kmuExtension.getMaterialType();
                  pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
                } else {
                  // Specification:
                  // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material

                  var metallicRoughness = materialDef.pbrMetallicRoughness || {};
                  materialParams.color = new three__WEBPACK_IMPORTED_MODULE_0__.Color(1.0, 1.0, 1.0);
                  materialParams.opacity = 1.0;
                  if (Array.isArray(metallicRoughness.baseColorFactor)) {
                    var array = metallicRoughness.baseColorFactor;
                    materialParams.color.fromArray(array);
                    materialParams.opacity = array[3];
                  }
                  if (metallicRoughness.baseColorTexture !== undefined) {
                    pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding));
                  }
                  materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
                  materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
                  if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                    pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
                    pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
                  }
                  materialType = this._invokeOne(function (ext) {
                    return ext.getMaterialType && ext.getMaterialType(materialIndex);
                  });
                  pending.push(Promise.all(this._invokeAll(function (ext) {
                    return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
                  })));
                }
                if (materialDef.doubleSided === true) {
                  materialParams.side = three__WEBPACK_IMPORTED_MODULE_0__.DoubleSide;
                }
                var alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
                if (alphaMode === ALPHA_MODES.BLEND) {
                  materialParams.transparent = true;

                  // See: https://github.com/mrdoob/three.js/issues/17706
                  materialParams.depthWrite = false;
                } else {
                  materialParams.transparent = false;
                  if (alphaMode === ALPHA_MODES.MASK) {
                    materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
                  }
                }
                if (materialDef.normalTexture !== undefined && materialType !== three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial) {
                  pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));
                  materialParams.normalScale = new three__WEBPACK_IMPORTED_MODULE_0__.Vector2(1, 1);
                  if (materialDef.normalTexture.scale !== undefined) {
                    var scale = materialDef.normalTexture.scale;
                    materialParams.normalScale.set(scale, scale);
                  }
                }
                if (materialDef.occlusionTexture !== undefined && materialType !== three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial) {
                  pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));
                  if (materialDef.occlusionTexture.strength !== undefined) {
                    materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
                  }
                }
                if (materialDef.emissiveFactor !== undefined && materialType !== three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial) {
                  materialParams.emissive = new three__WEBPACK_IMPORTED_MODULE_0__.Color().fromArray(materialDef.emissiveFactor);
                }
                if (materialDef.emissiveTexture !== undefined && materialType !== three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial) {
                  pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding));
                }
                return Promise.all(pending).then(function () {
                  var material = new materialType(materialParams);
                  if (materialDef.name) material.name = materialDef.name;
                  assignExtrasToUserData(material, materialDef);
                  parser.associations.set(material, {
                    materials: materialIndex
                  });
                  if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);
                  return material;
                });
              }

              /** When Object3D instances are targeted by animation, they need unique names. */
            }, {
              key: "createUniqueName",
              value: function createUniqueName(originalName) {
                var sanitizedName = three__WEBPACK_IMPORTED_MODULE_0__.PropertyBinding.sanitizeNodeName(originalName || '');
                var name = sanitizedName;
                for (var i = 1; this.nodeNamesUsed[name]; ++i) {
                  name = sanitizedName + '_' + i;
                }
                this.nodeNamesUsed[name] = true;
                return name;
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
               *
               * Creates BufferGeometries from primitives.
               *
               * @param {Array<GLTF.Primitive>} primitives
               * @return {Promise<Array<BufferGeometry>>}
               */
            }, {
              key: "loadGeometries",
              value: function loadGeometries(primitives) {
                var parser = this;
                var extensions = this.extensions;
                var cache = this.primitiveCache;
                function createDracoPrimitive(primitive) {
                  return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function (geometry) {
                    return addPrimitiveAttributes(geometry, primitive, parser);
                  });
                }
                var pending = [];
                for (var i = 0, il = primitives.length; i < il; i++) {
                  var primitive = primitives[i];
                  var cacheKey = createPrimitiveKey(primitive);

                  // See if we've already created this geometry
                  var cached = cache[cacheKey];
                  if (cached) {
                    // Use the cached geometry if it exists
                    pending.push(cached.promise);
                  } else {
                    var geometryPromise = void 0;
                    if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {
                      // Use DRACO geometry if available
                      geometryPromise = createDracoPrimitive(primitive);
                    } else {
                      // Otherwise create a new geometry
                      geometryPromise = addPrimitiveAttributes(new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry(), primitive, parser);
                    }

                    // Cache this geometry
                    cache[cacheKey] = {
                      primitive: primitive,
                      promise: geometryPromise
                    };
                    pending.push(geometryPromise);
                  }
                }
                return Promise.all(pending);
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
               * @param {number} meshIndex
               * @return {Promise<Group|Mesh|SkinnedMesh>}
               */
            }, {
              key: "loadMesh",
              value: function loadMesh(meshIndex) {
                var parser = this;
                var json = this.json;
                var extensions = this.extensions;
                var meshDef = json.meshes[meshIndex];
                var primitives = meshDef.primitives;
                var pending = [];
                for (var i = 0, il = primitives.length; i < il; i++) {
                  var material = primitives[i].material === undefined ? createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);
                  pending.push(material);
                }
                pending.push(parser.loadGeometries(primitives));
                return Promise.all(pending).then(function (results) {
                  var materials = results.slice(0, results.length - 1);
                  var geometries = results[results.length - 1];
                  var meshes = [];
                  for (var _i102 = 0, _il21 = geometries.length; _i102 < _il21; _i102++) {
                    var geometry = geometries[_i102];
                    var primitive = primitives[_i102];

                    // 1. create Mesh

                    var mesh = void 0;
                    var _material2 = materials[_i102];
                    if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                      // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                      mesh = meshDef.isSkinnedMesh === true ? new three__WEBPACK_IMPORTED_MODULE_0__.SkinnedMesh(geometry, _material2) : new three__WEBPACK_IMPORTED_MODULE_0__.Mesh(geometry, _material2);
                      if (mesh.isSkinnedMesh === true && !mesh.geometry.attributes.skinWeight.normalized) {
                        // we normalize floating point skin weight array to fix malformed assets (see #15319)
                        // it's important to skip this for non-float32 data since normalizeSkinWeights assumes non-normalized inputs
                        mesh.normalizeSkinWeights();
                      }
                      if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
                        mesh.geometry = toTrianglesDrawMode(mesh.geometry, three__WEBPACK_IMPORTED_MODULE_0__.TriangleStripDrawMode);
                      } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
                        mesh.geometry = toTrianglesDrawMode(mesh.geometry, three__WEBPACK_IMPORTED_MODULE_0__.TriangleFanDrawMode);
                      }
                    } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
                      mesh = new three__WEBPACK_IMPORTED_MODULE_0__.LineSegments(geometry, _material2);
                    } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
                      mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Line(geometry, _material2);
                    } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
                      mesh = new three__WEBPACK_IMPORTED_MODULE_0__.LineLoop(geometry, _material2);
                    } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
                      mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Points(geometry, _material2);
                    } else {
                      throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
                    }
                    if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
                      updateMorphTargets(mesh, meshDef);
                    }
                    mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);
                    assignExtrasToUserData(mesh, meshDef);
                    if (primitive.extensions) addUnknownExtensionsToUserData(extensions, mesh, primitive);
                    parser.assignFinalMaterial(mesh);
                    meshes.push(mesh);
                  }
                  for (var _i103 = 0, _il22 = meshes.length; _i103 < _il22; _i103++) {
                    parser.associations.set(meshes[_i103], {
                      meshes: meshIndex,
                      primitives: _i103
                    });
                  }
                  if (meshes.length === 1) {
                    return meshes[0];
                  }
                  var group = new three__WEBPACK_IMPORTED_MODULE_0__.Group();
                  parser.associations.set(group, {
                    meshes: meshIndex
                  });
                  for (var _i104 = 0, _il23 = meshes.length; _i104 < _il23; _i104++) {
                    group.add(meshes[_i104]);
                  }
                  return group;
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
               * @param {number} cameraIndex
               * @return {Promise<THREE.Camera>}
               */
            }, {
              key: "loadCamera",
              value: function loadCamera(cameraIndex) {
                var camera;
                var cameraDef = this.json.cameras[cameraIndex];
                var params = cameraDef[cameraDef.type];
                if (!params) {
                  console.warn('THREE.GLTFLoader: Missing camera parameters.');
                  return;
                }
                if (cameraDef.type === 'perspective') {
                  camera = new three__WEBPACK_IMPORTED_MODULE_0__.PerspectiveCamera(three__WEBPACK_IMPORTED_MODULE_0__.MathUtils.radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
                } else if (cameraDef.type === 'orthographic') {
                  camera = new three__WEBPACK_IMPORTED_MODULE_0__.OrthographicCamera(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
                }
                if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
                assignExtrasToUserData(camera, cameraDef);
                return Promise.resolve(camera);
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
               * @param {number} skinIndex
               * @return {Promise<Skeleton>}
               */
            }, {
              key: "loadSkin",
              value: function loadSkin(skinIndex) {
                var skinDef = this.json.skins[skinIndex];
                var pending = [];
                for (var i = 0, il = skinDef.joints.length; i < il; i++) {
                  pending.push(this.getDependency('node', skinDef.joints[i]));
                }
                if (skinDef.inverseBindMatrices !== undefined) {
                  pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
                } else {
                  pending.push(null);
                }
                return Promise.all(pending).then(function (results) {
                  var inverseBindMatrices = results.pop();
                  var jointNodes = results;
                  var bones = [];
                  var boneInverses = [];
                  for (var _i105 = 0, _il24 = jointNodes.length; _i105 < _il24; _i105++) {
                    var jointNode = jointNodes[_i105];
                    if (jointNode) {
                      bones.push(jointNode);
                      var mat = new three__WEBPACK_IMPORTED_MODULE_0__.Matrix4();
                      if (inverseBindMatrices !== null) {
                        mat.fromArray(inverseBindMatrices.array, _i105 * 16);
                      }
                      boneInverses.push(mat);
                    } else {
                      console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[_i105]);
                    }
                  }
                  return new three__WEBPACK_IMPORTED_MODULE_0__.Skeleton(bones, boneInverses);
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
               * @param {number} animationIndex
               * @return {Promise<AnimationClip>}
               */
            }, {
              key: "loadAnimation",
              value: function loadAnimation(animationIndex) {
                var json = this.json;
                var animationDef = json.animations[animationIndex];
                var pendingNodes = [];
                var pendingInputAccessors = [];
                var pendingOutputAccessors = [];
                var pendingSamplers = [];
                var pendingTargets = [];
                for (var i = 0, il = animationDef.channels.length; i < il; i++) {
                  var channel = animationDef.channels[i];
                  var sampler = animationDef.samplers[channel.sampler];
                  var target = channel.target;
                  var name = target.node;
                  var input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
                  var output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
                  pendingNodes.push(this.getDependency('node', name));
                  pendingInputAccessors.push(this.getDependency('accessor', input));
                  pendingOutputAccessors.push(this.getDependency('accessor', output));
                  pendingSamplers.push(sampler);
                  pendingTargets.push(target);
                }
                return Promise.all([Promise.all(pendingNodes), Promise.all(pendingInputAccessors), Promise.all(pendingOutputAccessors), Promise.all(pendingSamplers), Promise.all(pendingTargets)]).then(function (dependencies) {
                  var nodes = dependencies[0];
                  var inputAccessors = dependencies[1];
                  var outputAccessors = dependencies[2];
                  var samplers = dependencies[3];
                  var targets = dependencies[4];
                  var tracks = [];
                  var _loop3 = function _loop3() {
                    var node = nodes[_i106];
                    var inputAccessor = inputAccessors[_i106];
                    var outputAccessor = outputAccessors[_i106];
                    var sampler = samplers[_i106];
                    var target = targets[_i106];
                    if (node === undefined) return "continue";
                    node.updateMatrix();
                    var TypedKeyframeTrack;
                    switch (PATH_PROPERTIES[target.path]) {
                      case PATH_PROPERTIES.weights:
                        TypedKeyframeTrack = three__WEBPACK_IMPORTED_MODULE_0__.NumberKeyframeTrack;
                        break;
                      case PATH_PROPERTIES.rotation:
                        TypedKeyframeTrack = three__WEBPACK_IMPORTED_MODULE_0__.QuaternionKeyframeTrack;
                        break;
                      case PATH_PROPERTIES.position:
                      case PATH_PROPERTIES.scale:
                      default:
                        TypedKeyframeTrack = three__WEBPACK_IMPORTED_MODULE_0__.VectorKeyframeTrack;
                        break;
                    }
                    var targetName = node.name ? node.name : node.uuid;
                    var interpolation = sampler.interpolation !== undefined ? INTERPOLATION[sampler.interpolation] : three__WEBPACK_IMPORTED_MODULE_0__.InterpolateLinear;
                    var targetNames = [];
                    if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
                      node.traverse(function (object) {
                        if (object.morphTargetInfluences) {
                          targetNames.push(object.name ? object.name : object.uuid);
                        }
                      });
                    } else {
                      targetNames.push(targetName);
                    }
                    var outputArray = outputAccessor.array;
                    if (outputAccessor.normalized) {
                      var scale = getNormalizedComponentScale(outputArray.constructor);
                      var scaled = new Float32Array(outputArray.length);
                      for (var j = 0, jl = outputArray.length; j < jl; j++) {
                        scaled[j] = outputArray[j] * scale;
                      }
                      outputArray = scaled;
                    }
                    for (var _j21 = 0, _jl3 = targetNames.length; _j21 < _jl3; _j21++) {
                      var track = new TypedKeyframeTrack(targetNames[_j21] + '.' + PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);

                      // Override interpolation with custom factory method.
                      if (sampler.interpolation === 'CUBICSPLINE') {
                        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
                          // A CUBICSPLINE keyframe in glTF has three output values for each input value,
                          // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
                          // must be divided by three to get the interpolant's sampleSize argument.

                          var interpolantType = this instanceof three__WEBPACK_IMPORTED_MODULE_0__.QuaternionKeyframeTrack ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
                          return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
                        };

                        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
                        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
                      }
                      tracks.push(track);
                    }
                  };
                  for (var _i106 = 0, _il25 = nodes.length; _i106 < _il25; _i106++) {
                    var _ret2 = _loop3();
                    if (_ret2 === "continue") continue;
                  }
                  var name = animationDef.name ? animationDef.name : 'animation_' + animationIndex;
                  return new three__WEBPACK_IMPORTED_MODULE_0__.AnimationClip(name, undefined, tracks);
                });
              }
            }, {
              key: "createNodeMesh",
              value: function createNodeMesh(nodeIndex) {
                var json = this.json;
                var parser = this;
                var nodeDef = json.nodes[nodeIndex];
                if (nodeDef.mesh === undefined) return null;
                return parser.getDependency('mesh', nodeDef.mesh).then(function (mesh) {
                  var node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);

                  // if weights are provided on the node, override weights on the mesh.
                  if (nodeDef.weights !== undefined) {
                    node.traverse(function (o) {
                      if (!o.isMesh) return;
                      for (var i = 0, il = nodeDef.weights.length; i < il; i++) {
                        o.morphTargetInfluences[i] = nodeDef.weights[i];
                      }
                    });
                  }
                  return node;
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
               * @param {number} nodeIndex
               * @return {Promise<Object3D>}
               */
            }, {
              key: "loadNode",
              value: function loadNode(nodeIndex) {
                var json = this.json;
                var extensions = this.extensions;
                var parser = this;
                var nodeDef = json.nodes[nodeIndex];

                // reserve node's name before its dependencies, so the root has the intended name.
                var nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';
                return function () {
                  var pending = [];
                  var meshPromise = parser._invokeOne(function (ext) {
                    return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
                  });
                  if (meshPromise) {
                    pending.push(meshPromise);
                  }
                  if (nodeDef.camera !== undefined) {
                    pending.push(parser.getDependency('camera', nodeDef.camera).then(function (camera) {
                      return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
                    }));
                  }
                  parser._invokeAll(function (ext) {
                    return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
                  }).forEach(function (promise) {
                    pending.push(promise);
                  });
                  return Promise.all(pending);
                }().then(function (objects) {
                  var node;

                  // .isBone isn't in glTF spec. See ._markDefs
                  if (nodeDef.isBone === true) {
                    node = new three__WEBPACK_IMPORTED_MODULE_0__.Bone();
                  } else if (objects.length > 1) {
                    node = new three__WEBPACK_IMPORTED_MODULE_0__.Group();
                  } else if (objects.length === 1) {
                    node = objects[0];
                  } else {
                    node = new three__WEBPACK_IMPORTED_MODULE_0__.Object3D();
                  }
                  if (node !== objects[0]) {
                    for (var i = 0, il = objects.length; i < il; i++) {
                      node.add(objects[i]);
                    }
                  }
                  if (nodeDef.name) {
                    node.userData.name = nodeDef.name;
                    node.name = nodeName;
                  }
                  assignExtrasToUserData(node, nodeDef);
                  if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);
                  if (nodeDef.matrix !== undefined) {
                    var matrix = new three__WEBPACK_IMPORTED_MODULE_0__.Matrix4();
                    matrix.fromArray(nodeDef.matrix);
                    node.applyMatrix4(matrix);
                  } else {
                    if (nodeDef.translation !== undefined) {
                      node.position.fromArray(nodeDef.translation);
                    }
                    if (nodeDef.rotation !== undefined) {
                      node.quaternion.fromArray(nodeDef.rotation);
                    }
                    if (nodeDef.scale !== undefined) {
                      node.scale.fromArray(nodeDef.scale);
                    }
                  }
                  if (!parser.associations.has(node)) {
                    parser.associations.set(node, {});
                  }
                  parser.associations.get(node).nodes = nodeIndex;
                  return node;
                });
              }

              /**
               * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
               * @param {number} sceneIndex
               * @return {Promise<Group>}
               */
            }, {
              key: "loadScene",
              value: function loadScene(sceneIndex) {
                var json = this.json;
                var extensions = this.extensions;
                var sceneDef = this.json.scenes[sceneIndex];
                var parser = this;

                // Loader returns Group, not Scene.
                // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
                var scene = new three__WEBPACK_IMPORTED_MODULE_0__.Group();
                if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
                assignExtrasToUserData(scene, sceneDef);
                if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);
                var nodeIds = sceneDef.nodes || [];
                var pending = [];
                for (var i = 0, il = nodeIds.length; i < il; i++) {
                  pending.push(buildNodeHierarchy(nodeIds[i], scene, json, parser));
                }
                return Promise.all(pending).then(function () {
                  // Removes dangling associations, associations that reference a node that
                  // didn't make it into the scene.
                  var reduceAssociations = function reduceAssociations(node) {
                    var reducedAssociations = new Map();
                    var _iterator16 = _createForOfIteratorHelper2(parser.associations),
                      _step16;
                    try {
                      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                        var _step16$value = _slicedToArray(_step16.value, 2),
                          key = _step16$value[0],
                          _value9 = _step16$value[1];
                        if (key instanceof three__WEBPACK_IMPORTED_MODULE_0__.Material || key instanceof three__WEBPACK_IMPORTED_MODULE_0__.Texture) {
                          reducedAssociations.set(key, _value9);
                        }
                      }
                    } catch (err) {
                      _iterator16.e(err);
                    } finally {
                      _iterator16.f();
                    }
                    node.traverse(function (node) {
                      var mappings = parser.associations.get(node);
                      if (mappings != null) {
                        reducedAssociations.set(node, mappings);
                      }
                    });
                    return reducedAssociations;
                  };
                  parser.associations = reduceAssociations(scene);
                  return scene;
                });
              }
            }]);
            return GLTFParser;
          }();
          function buildNodeHierarchy(nodeId, parentObject, json, parser) {
            var nodeDef = json.nodes[nodeId];
            return parser.getDependency('node', nodeId).then(function (node) {
              if (nodeDef.skin === undefined) return node;

              // build skeleton here as well

              return parser.getDependency('skin', nodeDef.skin).then(function (skeleton) {
                node.traverse(function (mesh) {
                  if (!mesh.isSkinnedMesh) return;
                  mesh.bind(skeleton, mesh.matrixWorld);
                });
                return node;
              });
            }).then(function (node) {
              // build node hierachy

              parentObject.add(node);
              var pending = [];
              if (nodeDef.children) {
                var children = nodeDef.children;
                for (var i = 0, il = children.length; i < il; i++) {
                  var child = children[i];
                  pending.push(buildNodeHierarchy(child, node, json, parser));
                }
              }
              return Promise.all(pending);
            });
          }

          /**
           * @param {BufferGeometry} geometry
           * @param {GLTF.Primitive} primitiveDef
           * @param {GLTFParser} parser
           */
          function computeBounds(geometry, primitiveDef, parser) {
            var attributes = primitiveDef.attributes;
            var box = new three__WEBPACK_IMPORTED_MODULE_0__.Box3();
            if (attributes.POSITION !== undefined) {
              var accessor = parser.json.accessors[attributes.POSITION];
              var min = accessor.min;
              var max = accessor.max;

              // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

              if (min !== undefined && max !== undefined) {
                box.set(new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(min[0], min[1], min[2]), new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(max[0], max[1], max[2]));
                if (accessor.normalized) {
                  var boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
                  box.min.multiplyScalar(boxScale);
                  box.max.multiplyScalar(boxScale);
                }
              } else {
                console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
                return;
              }
            } else {
              return;
            }
            var targets = primitiveDef.targets;
            if (targets !== undefined) {
              var maxDisplacement = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
              var vector = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
              for (var i = 0, il = targets.length; i < il; i++) {
                var target = targets[i];
                if (target.POSITION !== undefined) {
                  var _accessor = parser.json.accessors[target.POSITION];
                  var _min = _accessor.min;
                  var _max2 = _accessor.max;

                  // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

                  if (_min !== undefined && _max2 !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(_min[0]), Math.abs(_max2[0])));
                    vector.setY(Math.max(Math.abs(_min[1]), Math.abs(_max2[1])));
                    vector.setZ(Math.max(Math.abs(_min[2]), Math.abs(_max2[2])));
                    if (_accessor.normalized) {
                      var _boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[_accessor.componentType]);
                      vector.multiplyScalar(_boxScale);
                    }

                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                  } else {
                    console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
                  }
                }
              }

              // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
              box.expandByVector(maxDisplacement);
            }
            geometry.boundingBox = box;
            var sphere = new three__WEBPACK_IMPORTED_MODULE_0__.Sphere();
            box.getCenter(sphere.center);
            sphere.radius = box.min.distanceTo(box.max) / 2;
            geometry.boundingSphere = sphere;
          }

          /**
           * @param {BufferGeometry} geometry
           * @param {GLTF.Primitive} primitiveDef
           * @param {GLTFParser} parser
           * @return {Promise<BufferGeometry>}
           */
          function addPrimitiveAttributes(geometry, primitiveDef, parser) {
            var attributes = primitiveDef.attributes;
            var pending = [];
            function assignAttributeAccessor(accessorIndex, attributeName) {
              return parser.getDependency('accessor', accessorIndex).then(function (accessor) {
                geometry.setAttribute(attributeName, accessor);
              });
            }
            for (var gltfAttributeName in attributes) {
              var threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();

              // Skip attributes already provided by e.g. Draco extension.
              if (threeAttributeName in geometry.attributes) continue;
              pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
            }
            if (primitiveDef.indices !== undefined && !geometry.index) {
              var accessor = parser.getDependency('accessor', primitiveDef.indices).then(function (accessor) {
                geometry.setIndex(accessor);
              });
              pending.push(accessor);
            }
            assignExtrasToUserData(geometry, primitiveDef);
            computeBounds(geometry, primitiveDef, parser);
            return Promise.all(pending).then(function () {
              return primitiveDef.targets !== undefined ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
            });
          }

          /**
           * @param {BufferGeometry} geometry
           * @param {Number} drawMode
           * @return {BufferGeometry}
           */
          function toTrianglesDrawMode(geometry, drawMode) {
            var index = geometry.getIndex();

            // generate index if not present

            if (index === null) {
              var indices = [];
              var position = geometry.getAttribute('position');
              if (position !== undefined) {
                for (var i = 0; i < position.count; i++) {
                  indices.push(i);
                }
                geometry.setIndex(indices);
                index = geometry.getIndex();
              } else {
                console.error('THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                return geometry;
              }
            }

            //

            var numberOfTriangles = index.count - 2;
            var newIndices = [];
            if (drawMode === three__WEBPACK_IMPORTED_MODULE_0__.TriangleFanDrawMode) {
              // gl.TRIANGLE_FAN

              for (var _i107 = 1; _i107 <= numberOfTriangles; _i107++) {
                newIndices.push(index.getX(0));
                newIndices.push(index.getX(_i107));
                newIndices.push(index.getX(_i107 + 1));
              }
            } else {
              // gl.TRIANGLE_STRIP

              for (var _i108 = 0; _i108 < numberOfTriangles; _i108++) {
                if (_i108 % 2 === 0) {
                  newIndices.push(index.getX(_i108));
                  newIndices.push(index.getX(_i108 + 1));
                  newIndices.push(index.getX(_i108 + 2));
                } else {
                  newIndices.push(index.getX(_i108 + 2));
                  newIndices.push(index.getX(_i108 + 1));
                  newIndices.push(index.getX(_i108));
                }
              }
            }
            if (newIndices.length / 3 !== numberOfTriangles) {
              console.error('THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
            }

            // build final geometry

            var newGeometry = geometry.clone();
            newGeometry.setIndex(newIndices);
            return newGeometry;
          }

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/loaders/KTX2Loader.js":
        /*!*********************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/loaders/KTX2Loader.js ***!
          \*********************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLoadersKTX2LoaderJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          var _FORMAT_MAP, _TYPE_MAP, _ENCODING_MAP;
          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"KTX2Loader": function KTX2Loader() {
              return (/* binding */_KTX2Loader
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");
          /* harmony import */
          var _utils_WorkerPool_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/WorkerPool.js */"./node_modules/super-three/examples/jsm/utils/WorkerPool.js");
          /* harmony import */
          var _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../libs/ktx-parse.module.js */"./node_modules/super-three/examples/jsm/libs/ktx-parse.module.js");
          /* harmony import */
          var _libs_zstddec_module_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../libs/zstddec.module.js */"./node_modules/super-three/examples/jsm/libs/zstddec.module.js");
          /**
           * Loader for KTX 2.0 GPU Texture containers.
           *
           * KTX 2.0 is a container format for various GPU texture formats. The loader
           * supports Basis Universal GPU textures, which can be quickly transcoded to
           * a wide variety of GPU texture compression formats, as well as some
           * uncompressed DataTexture and Data3DTexture formats.
           *
           * References:
           * - KTX: http://github.khronos.org/KTX-Specification/
           * - DFD: https://www.khronos.org/registry/DataFormat/specs/1.3/dataformat.1.3.html#basicdescriptor
           */

          var _taskCache = new WeakMap();
          var _activeLoaders = 0;
          var _zstd;
          var _KTX2Loader = /*#__PURE__*/function (_three__WEBPACK_IMPOR4) {
            _inherits(_KTX2Loader, _three__WEBPACK_IMPOR4);
            var _super193 = _createSuper(_KTX2Loader);
            function _KTX2Loader(manager) {
              var _this149;
              _classCallCheck2(this, _KTX2Loader);
              _this149 = _super193.call(this, manager);
              _this149.transcoderPath = '';
              _this149.transcoderBinary = null;
              _this149.transcoderPending = null;
              _this149.workerPool = new _utils_WorkerPool_js__WEBPACK_IMPORTED_MODULE_1__.WorkerPool();
              _this149.workerSourceURL = '';
              _this149.workerConfig = null;
              if (typeof MSC_TRANSCODER !== 'undefined') {
                console.warn('THREE.KTX2Loader: Please update to latest "basis_transcoder".' + ' "msc_basis_transcoder" is no longer supported in three.js r125+.');
              }
              return _this149;
            }
            _createClass2(_KTX2Loader, [{
              key: "setTranscoderPath",
              value: function setTranscoderPath(path) {
                this.transcoderPath = path;
                return this;
              }
            }, {
              key: "setWorkerLimit",
              value: function setWorkerLimit(num) {
                this.workerPool.setWorkerLimit(num);
                return this;
              }
            }, {
              key: "detectSupport",
              value: function detectSupport(renderer) {
                this.workerConfig = {
                  astcSupported: renderer.extensions.has('WEBGL_compressed_texture_astc'),
                  etc1Supported: renderer.extensions.has('WEBGL_compressed_texture_etc1'),
                  etc2Supported: renderer.extensions.has('WEBGL_compressed_texture_etc'),
                  dxtSupported: renderer.extensions.has('WEBGL_compressed_texture_s3tc'),
                  bptcSupported: renderer.extensions.has('EXT_texture_compression_bptc'),
                  pvrtcSupported: renderer.extensions.has('WEBGL_compressed_texture_pvrtc') || renderer.extensions.has('WEBKIT_WEBGL_compressed_texture_pvrtc')
                };
                if (renderer.capabilities.isWebGL2) {
                  // https://github.com/mrdoob/three.js/pull/22928
                  this.workerConfig.etc1Supported = false;
                }
                return this;
              }
            }, {
              key: "init",
              value: function init() {
                var _this150 = this;
                if (!this.transcoderPending) {
                  // Load transcoder wrapper.
                  var jsLoader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                  jsLoader.setPath(this.transcoderPath);
                  jsLoader.setWithCredentials(this.withCredentials);
                  var jsContent = jsLoader.loadAsync('basis_transcoder.js');

                  // Load transcoder WASM binary.
                  var binaryLoader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                  binaryLoader.setPath(this.transcoderPath);
                  binaryLoader.setResponseType('arraybuffer');
                  binaryLoader.setWithCredentials(this.withCredentials);
                  var binaryContent = binaryLoader.loadAsync('basis_transcoder.wasm');
                  this.transcoderPending = Promise.all([jsContent, binaryContent]).then(function (_ref4) {
                    var _ref5 = _slicedToArray(_ref4, 2),
                      jsContent = _ref5[0],
                      binaryContent = _ref5[1];
                    var fn = _KTX2Loader.BasisWorker.toString();
                    var body = ['/* constants */', 'let _EngineFormat = ' + JSON.stringify(_KTX2Loader.EngineFormat), 'let _TranscoderFormat = ' + JSON.stringify(_KTX2Loader.TranscoderFormat), 'let _BasisFormat = ' + JSON.stringify(_KTX2Loader.BasisFormat), '/* basis_transcoder.js */', jsContent, '/* worker */', fn.substring(fn.indexOf('{') + 1, fn.lastIndexOf('}'))].join('\n');
                    _this150.workerSourceURL = URL.createObjectURL(new Blob([body]));
                    _this150.transcoderBinary = binaryContent;
                    _this150.workerPool.setWorkerCreator(function () {
                      var worker = new Worker(_this150.workerSourceURL);
                      var transcoderBinary = _this150.transcoderBinary.slice(0);
                      worker.postMessage({
                        type: 'init',
                        config: _this150.workerConfig,
                        transcoderBinary: transcoderBinary
                      }, [transcoderBinary]);
                      return worker;
                    });
                  });
                  if (_activeLoaders > 0) {
                    // Each instance loads a transcoder and allocates workers, increasing network and memory cost.

                    console.warn('THREE.KTX2Loader: Multiple active KTX2 loaders may cause performance issues.' + ' Use a single KTX2Loader instance, or call .dispose() on old instances.');
                  }
                  _activeLoaders++;
                }
                return this.transcoderPending;
              }
            }, {
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var _this151 = this;
                if (this.workerConfig === null) {
                  throw new Error('THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.');
                }
                var loader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (buffer) {
                  // Check for an existing task using this buffer. A transferred buffer cannot be transferred
                  // again from this thread.
                  if (_taskCache.has(buffer)) {
                    var cachedTask = _taskCache.get(buffer);
                    return cachedTask.promise.then(onLoad).catch(onError);
                  }
                  _this151._createTexture(buffer).then(function (texture) {
                    return onLoad ? onLoad(texture) : null;
                  }).catch(onError);
                }, onProgress, onError);
              }
            }, {
              key: "_createTextureFrom",
              value: function _createTextureFrom(transcodeResult, container) {
                var mipmaps = transcodeResult.mipmaps,
                  width = transcodeResult.width,
                  height = transcodeResult.height,
                  format = transcodeResult.format,
                  type = transcodeResult.type,
                  error = transcodeResult.error,
                  dfdTransferFn = transcodeResult.dfdTransferFn,
                  dfdFlags = transcodeResult.dfdFlags;
                if (type === 'error') return Promise.reject(error);
                var texture = container.layerCount > 1 ? new three__WEBPACK_IMPORTED_MODULE_0__.CompressedArrayTexture(mipmaps, width, height, container.layerCount, format, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType) : new three__WEBPACK_IMPORTED_MODULE_0__.CompressedTexture(mipmaps, width, height, format, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType);
                texture.minFilter = mipmaps.length === 1 ? three__WEBPACK_IMPORTED_MODULE_0__.LinearFilter : three__WEBPACK_IMPORTED_MODULE_0__.LinearMipmapLinearFilter;
                texture.magFilter = three__WEBPACK_IMPORTED_MODULE_0__.LinearFilter;
                texture.generateMipmaps = false;
                texture.needsUpdate = true;
                texture.encoding = dfdTransferFn === _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.KHR_DF_TRANSFER_SRGB ? three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding : three__WEBPACK_IMPORTED_MODULE_0__.LinearEncoding;
                texture.premultiplyAlpha = !!(dfdFlags & _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.KHR_DF_FLAG_ALPHA_PREMULTIPLIED);
                return texture;
              }

              /**
               * @param {ArrayBuffer} buffer
               * @param {object?} config
               * @return {Promise<CompressedTexture|CompressedArrayTexture|DataTexture|Data3DTexture>}
               */
            }, {
              key: "_createTexture",
              value: function () {
                var _createTexture2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(buffer) {
                  var _this152 = this;
                  var config,
                    container,
                    taskConfig,
                    texturePending,
                    _args12 = arguments;
                  return _regeneratorRuntime().wrap(function _callee6$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        config = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
                        container = (0, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.read)(new Uint8Array(buffer));
                        if (!(container.vkFormat !== _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_UNDEFINED)) {
                          _context13.next = 4;
                          break;
                        }
                        return _context13.abrupt("return", createDataTexture(container));
                      case 4:
                        //
                        taskConfig = config;
                        texturePending = this.init().then(function () {
                          return _this152.workerPool.postMessage({
                            type: 'transcode',
                            buffer: buffer,
                            taskConfig: taskConfig
                          }, [buffer]);
                        }).then(function (e) {
                          return _this152._createTextureFrom(e.data, container);
                        }); // Cache the task result.
                        _taskCache.set(buffer, {
                          promise: texturePending
                        });
                        return _context13.abrupt("return", texturePending);
                      case 8:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee6, this);
                }));
                function _createTexture(_x13) {
                  return _createTexture2.apply(this, arguments);
                }
                return _createTexture;
              }()
            }, {
              key: "dispose",
              value: function dispose() {
                this.workerPool.dispose();
                if (this.workerSourceURL) URL.revokeObjectURL(this.workerSourceURL);
                _activeLoaders--;
                return this;
              }
            }]);
            return _KTX2Loader;
          }(three__WEBPACK_IMPORTED_MODULE_0__.Loader);
          /* CONSTANTS */
          _KTX2Loader.BasisFormat = {
            ETC1S: 0,
            UASTC_4x4: 1
          };
          _KTX2Loader.TranscoderFormat = {
            ETC1: 0,
            ETC2: 1,
            BC1: 2,
            BC3: 3,
            BC4: 4,
            BC5: 5,
            BC7_M6_OPAQUE_ONLY: 6,
            BC7_M5: 7,
            PVRTC1_4_RGB: 8,
            PVRTC1_4_RGBA: 9,
            ASTC_4x4: 10,
            ATC_RGB: 11,
            ATC_RGBA_INTERPOLATED_ALPHA: 12,
            RGBA32: 13,
            RGB565: 14,
            BGR565: 15,
            RGBA4444: 16
          };
          _KTX2Loader.EngineFormat = {
            RGBAFormat: three__WEBPACK_IMPORTED_MODULE_0__.RGBAFormat,
            RGBA_ASTC_4x4_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGBA_ASTC_4x4_Format,
            RGBA_BPTC_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGBA_BPTC_Format,
            RGBA_ETC2_EAC_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGBA_ETC2_EAC_Format,
            RGBA_PVRTC_4BPPV1_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGBA_PVRTC_4BPPV1_Format,
            RGBA_S3TC_DXT5_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGBA_S3TC_DXT5_Format,
            RGB_ETC1_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGB_ETC1_Format,
            RGB_ETC2_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGB_ETC2_Format,
            RGB_PVRTC_4BPPV1_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGB_PVRTC_4BPPV1_Format,
            RGB_S3TC_DXT1_Format: three__WEBPACK_IMPORTED_MODULE_0__.RGB_S3TC_DXT1_Format
          };

          /* WEB WORKER */

          _KTX2Loader.BasisWorker = function () {
            var config;
            var transcoderPending;
            var BasisModule;
            var EngineFormat = _EngineFormat; // eslint-disable-line no-undef
            var TranscoderFormat = _TranscoderFormat; // eslint-disable-line no-undef
            var BasisFormat = _BasisFormat; // eslint-disable-line no-undef

            self.addEventListener('message', function (e) {
              var message = e.data;
              switch (message.type) {
                case 'init':
                  config = message.config;
                  init(message.transcoderBinary);
                  break;
                case 'transcode':
                  transcoderPending.then(function () {
                    try {
                      var _transcode = transcode(message.buffer),
                        width = _transcode.width,
                        height = _transcode.height,
                        hasAlpha = _transcode.hasAlpha,
                        mipmaps = _transcode.mipmaps,
                        format = _transcode.format,
                        dfdTransferFn = _transcode.dfdTransferFn,
                        dfdFlags = _transcode.dfdFlags;
                      var buffers = [];
                      for (var i = 0; i < mipmaps.length; ++i) {
                        buffers.push(mipmaps[i].data.buffer);
                      }
                      self.postMessage({
                        type: 'transcode',
                        id: message.id,
                        width: width,
                        height: height,
                        hasAlpha: hasAlpha,
                        mipmaps: mipmaps,
                        format: format,
                        dfdTransferFn: dfdTransferFn,
                        dfdFlags: dfdFlags
                      }, buffers);
                    } catch (error) {
                      console.error(error);
                      self.postMessage({
                        type: 'error',
                        id: message.id,
                        error: error.message
                      });
                    }
                  });
                  break;
              }
            });
            function init(wasmBinary) {
              transcoderPending = new Promise(function (resolve) {
                BasisModule = {
                  wasmBinary: wasmBinary,
                  onRuntimeInitialized: resolve
                };
                BASIS(BasisModule); // eslint-disable-line no-undef
              }).then(function () {
                BasisModule.initializeBasis();
                if (BasisModule.KTX2File === undefined) {
                  console.warn('THREE.KTX2Loader: Please update Basis Universal transcoder.');
                }
              });
            }
            function transcode(buffer) {
              var ktx2File = new BasisModule.KTX2File(new Uint8Array(buffer));
              function cleanup() {
                ktx2File.close();
                ktx2File.delete();
              }
              if (!ktx2File.isValid()) {
                cleanup();
                throw new Error('THREE.KTX2Loader:	Invalid or unsupported .ktx2 file');
              }
              var basisFormat = ktx2File.isUASTC() ? BasisFormat.UASTC_4x4 : BasisFormat.ETC1S;
              var width = ktx2File.getWidth();
              var height = ktx2File.getHeight();
              var layers = ktx2File.getLayers() || 1;
              var levels = ktx2File.getLevels();
              var hasAlpha = ktx2File.getHasAlpha();
              var dfdTransferFn = ktx2File.getDFDTransferFunc();
              var dfdFlags = ktx2File.getDFDFlags();
              var _getTranscoderFormat = getTranscoderFormat(basisFormat, width, height, hasAlpha),
                transcoderFormat = _getTranscoderFormat.transcoderFormat,
                engineFormat = _getTranscoderFormat.engineFormat;
              if (!width || !height || !levels) {
                cleanup();
                throw new Error('THREE.KTX2Loader:	Invalid texture');
              }
              if (!ktx2File.startTranscoding()) {
                cleanup();
                throw new Error('THREE.KTX2Loader: .startTranscoding failed');
              }
              var mipmaps = [];
              for (var mip = 0; mip < levels; mip++) {
                var layerMips = [];
                var mipWidth = void 0,
                  mipHeight = void 0;
                for (var layer = 0; layer < layers; layer++) {
                  var levelInfo = ktx2File.getImageLevelInfo(mip, layer, 0);
                  mipWidth = levelInfo.origWidth;
                  mipHeight = levelInfo.origHeight;
                  var dst = new Uint8Array(ktx2File.getImageTranscodedSizeInBytes(mip, layer, 0, transcoderFormat));
                  var status = ktx2File.transcodeImage(dst, mip, layer, 0, transcoderFormat, 0, -1, -1);
                  if (!status) {
                    cleanup();
                    throw new Error('THREE.KTX2Loader: .transcodeImage failed.');
                  }
                  layerMips.push(dst);
                }
                mipmaps.push({
                  data: concat(layerMips),
                  width: mipWidth,
                  height: mipHeight
                });
              }
              cleanup();
              return {
                width: width,
                height: height,
                hasAlpha: hasAlpha,
                mipmaps: mipmaps,
                format: engineFormat,
                dfdTransferFn: dfdTransferFn,
                dfdFlags: dfdFlags
              };
            }

            //

            // Optimal choice of a transcoder target format depends on the Basis format (ETC1S or UASTC),
            // device capabilities, and texture dimensions. The list below ranks the formats separately
            // for ETC1S and UASTC.
            //
            // In some cases, transcoding UASTC to RGBA32 might be preferred for higher quality (at
            // significant memory cost) compared to ETC1/2, BC1/3, and PVRTC. The transcoder currently
            // chooses RGBA32 only as a last resort and does not expose that option to the caller.
            var FORMAT_OPTIONS = [{
              if: 'astcSupported',
              basisFormat: [BasisFormat.UASTC_4x4],
              transcoderFormat: [TranscoderFormat.ASTC_4x4, TranscoderFormat.ASTC_4x4],
              engineFormat: [EngineFormat.RGBA_ASTC_4x4_Format, EngineFormat.RGBA_ASTC_4x4_Format],
              priorityETC1S: Infinity,
              priorityUASTC: 1,
              needsPowerOfTwo: false
            }, {
              if: 'bptcSupported',
              basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC_4x4],
              transcoderFormat: [TranscoderFormat.BC7_M5, TranscoderFormat.BC7_M5],
              engineFormat: [EngineFormat.RGBA_BPTC_Format, EngineFormat.RGBA_BPTC_Format],
              priorityETC1S: 3,
              priorityUASTC: 2,
              needsPowerOfTwo: false
            }, {
              if: 'dxtSupported',
              basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC_4x4],
              transcoderFormat: [TranscoderFormat.BC1, TranscoderFormat.BC3],
              engineFormat: [EngineFormat.RGB_S3TC_DXT1_Format, EngineFormat.RGBA_S3TC_DXT5_Format],
              priorityETC1S: 4,
              priorityUASTC: 5,
              needsPowerOfTwo: false
            }, {
              if: 'etc2Supported',
              basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC_4x4],
              transcoderFormat: [TranscoderFormat.ETC1, TranscoderFormat.ETC2],
              engineFormat: [EngineFormat.RGB_ETC2_Format, EngineFormat.RGBA_ETC2_EAC_Format],
              priorityETC1S: 1,
              priorityUASTC: 3,
              needsPowerOfTwo: false
            }, {
              if: 'etc1Supported',
              basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC_4x4],
              transcoderFormat: [TranscoderFormat.ETC1],
              engineFormat: [EngineFormat.RGB_ETC1_Format],
              priorityETC1S: 2,
              priorityUASTC: 4,
              needsPowerOfTwo: false
            }, {
              if: 'pvrtcSupported',
              basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC_4x4],
              transcoderFormat: [TranscoderFormat.PVRTC1_4_RGB, TranscoderFormat.PVRTC1_4_RGBA],
              engineFormat: [EngineFormat.RGB_PVRTC_4BPPV1_Format, EngineFormat.RGBA_PVRTC_4BPPV1_Format],
              priorityETC1S: 5,
              priorityUASTC: 6,
              needsPowerOfTwo: true
            }];
            var ETC1S_OPTIONS = FORMAT_OPTIONS.sort(function (a, b) {
              return a.priorityETC1S - b.priorityETC1S;
            });
            var UASTC_OPTIONS = FORMAT_OPTIONS.sort(function (a, b) {
              return a.priorityUASTC - b.priorityUASTC;
            });
            function getTranscoderFormat(basisFormat, width, height, hasAlpha) {
              var transcoderFormat;
              var engineFormat;
              var options = basisFormat === BasisFormat.ETC1S ? ETC1S_OPTIONS : UASTC_OPTIONS;
              for (var i = 0; i < options.length; i++) {
                var opt = options[i];
                if (!config[opt.if]) continue;
                if (!opt.basisFormat.includes(basisFormat)) continue;
                if (hasAlpha && opt.transcoderFormat.length < 2) continue;
                if (opt.needsPowerOfTwo && !(isPowerOfTwo(width) && isPowerOfTwo(height))) continue;
                transcoderFormat = opt.transcoderFormat[hasAlpha ? 1 : 0];
                engineFormat = opt.engineFormat[hasAlpha ? 1 : 0];
                return {
                  transcoderFormat: transcoderFormat,
                  engineFormat: engineFormat
                };
              }
              console.warn('THREE.KTX2Loader: No suitable compressed texture format found. Decoding to RGBA32.');
              transcoderFormat = TranscoderFormat.RGBA32;
              engineFormat = EngineFormat.RGBAFormat;
              return {
                transcoderFormat: transcoderFormat,
                engineFormat: engineFormat
              };
            }
            function isPowerOfTwo(value) {
              if (value <= 2) return true;
              return (value & value - 1) === 0 && value !== 0;
            }

            /** Concatenates N byte arrays. */
            function concat(arrays) {
              var totalByteLength = 0;
              var _iterator17 = _createForOfIteratorHelper2(arrays),
                _step17;
              try {
                for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                  var array = _step17.value;
                  totalByteLength += array.byteLength;
                }
              } catch (err) {
                _iterator17.e(err);
              } finally {
                _iterator17.f();
              }
              var result = new Uint8Array(totalByteLength);
              var byteOffset = 0;
              var _iterator18 = _createForOfIteratorHelper2(arrays),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var _array2 = _step18.value;
                  result.set(_array2, byteOffset);
                  byteOffset += _array2.byteLength;
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
              return result;
            }
          };

          //
          // DataTexture and Data3DTexture parsing.

          var FORMAT_MAP = (_FORMAT_MAP = {}, _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R32G32B32A32_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.RGBAFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R16G16B16A16_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.RGBAFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8B8A8_UNORM, three__WEBPACK_IMPORTED_MODULE_0__.RGBAFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8B8A8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.RGBAFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R32G32_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.RGFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R16G16_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.RGFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8_UNORM, three__WEBPACK_IMPORTED_MODULE_0__.RGFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.RGFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R32_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.RedFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R16_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.RedFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.RedFormat), _defineProperty(_FORMAT_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8_UNORM, three__WEBPACK_IMPORTED_MODULE_0__.RedFormat), _FORMAT_MAP);
          var TYPE_MAP = (_TYPE_MAP = {}, _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R32G32B32A32_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.FloatType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R16G16B16A16_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.HalfFloatType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8B8A8_UNORM, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8B8A8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R32G32_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.FloatType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R16G16_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.HalfFloatType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8_UNORM, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R32_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.FloatType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R16_SFLOAT, three__WEBPACK_IMPORTED_MODULE_0__.HalfFloatType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType), _defineProperty(_TYPE_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8_UNORM, three__WEBPACK_IMPORTED_MODULE_0__.UnsignedByteType), _TYPE_MAP);
          var ENCODING_MAP = (_ENCODING_MAP = {}, _defineProperty(_ENCODING_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8B8A8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding), _defineProperty(_ENCODING_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8G8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding), _defineProperty(_ENCODING_MAP, _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.VK_FORMAT_R8_SRGB, three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding), _ENCODING_MAP);
          function createDataTexture(_x14) {
            return _createDataTexture.apply(this, arguments);
          }
          /***/
          function _createDataTexture() {
            _createDataTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(container) {
              var vkFormat, pixelWidth, pixelHeight, pixelDepth, level, levelData, view, texture;
              return _regeneratorRuntime().wrap(function _callee8$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    vkFormat = container.vkFormat, pixelWidth = container.pixelWidth, pixelHeight = container.pixelHeight, pixelDepth = container.pixelDepth;
                    if (!(FORMAT_MAP[vkFormat] === undefined)) {
                      _context15.next = 3;
                      break;
                    }
                    throw new Error('THREE.KTX2Loader: Unsupported vkFormat.');
                  case 3:
                    level = container.levels[0];
                    if (!(container.supercompressionScheme === _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.KHR_SUPERCOMPRESSION_NONE)) {
                      _context15.next = 8;
                      break;
                    }
                    levelData = level.levelData;
                    _context15.next = 16;
                    break;
                  case 8:
                    if (!(container.supercompressionScheme === _libs_ktx_parse_module_js__WEBPACK_IMPORTED_MODULE_2__.KHR_SUPERCOMPRESSION_ZSTD)) {
                      _context15.next = 15;
                      break;
                    }
                    if (!_zstd) {
                      _zstd = new Promise( /*#__PURE__*/function () {
                        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resolve) {
                          var zstd;
                          return _regeneratorRuntime().wrap(function _callee7$(_context14) {
                            while (1) switch (_context14.prev = _context14.next) {
                              case 0:
                                zstd = new _libs_zstddec_module_js__WEBPACK_IMPORTED_MODULE_3__.ZSTDDecoder();
                                _context14.next = 3;
                                return zstd.init();
                              case 3:
                                resolve(zstd);
                              case 4:
                              case "end":
                                return _context14.stop();
                            }
                          }, _callee7);
                        }));
                        return function (_x15) {
                          return _ref6.apply(this, arguments);
                        };
                      }());
                    }
                    _context15.next = 12;
                    return _zstd;
                  case 12:
                    levelData = _context15.sent.decode(level.levelData, level.uncompressedByteLength);
                    _context15.next = 16;
                    break;
                  case 15:
                    throw new Error('THREE.KTX2Loader: Unsupported supercompressionScheme.');
                  case 16:
                    if (TYPE_MAP[vkFormat] === three__WEBPACK_IMPORTED_MODULE_0__.FloatType) {
                      view = new Float32Array(levelData.buffer, levelData.byteOffset, levelData.byteLength / Float32Array.BYTES_PER_ELEMENT);
                    } else if (TYPE_MAP[vkFormat] === three__WEBPACK_IMPORTED_MODULE_0__.HalfFloatType) {
                      view = new Uint16Array(levelData.buffer, levelData.byteOffset, levelData.byteLength / Uint16Array.BYTES_PER_ELEMENT);
                    } else {
                      view = levelData;
                    }
                    //
                    texture = pixelDepth === 0 ? new three__WEBPACK_IMPORTED_MODULE_0__.DataTexture(view, pixelWidth, pixelHeight) : new three__WEBPACK_IMPORTED_MODULE_0__.Data3DTexture(view, pixelWidth, pixelHeight, pixelDepth);
                    texture.type = TYPE_MAP[vkFormat];
                    texture.format = FORMAT_MAP[vkFormat];
                    texture.encoding = ENCODING_MAP[vkFormat] || three__WEBPACK_IMPORTED_MODULE_0__.LinearEncoding;
                    texture.needsUpdate = true;

                    //
                    return _context15.abrupt("return", Promise.resolve(texture));
                  case 23:
                  case "end":
                    return _context15.stop();
                }
              }, _callee8);
            }));
            return _createDataTexture.apply(this, arguments);
          }
        },
        /***/"./node_modules/super-three/examples/jsm/loaders/MTLLoader.js":
        /*!********************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/loaders/MTLLoader.js ***!
          \********************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLoadersMTLLoaderJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"MTLLoader": function MTLLoader() {
              return (/* binding */_MTLLoader
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");

          /**
           * Loads a Wavefront .mtl file specifying materials
           */
          var _MTLLoader = /*#__PURE__*/function (_three__WEBPACK_IMPOR5) {
            _inherits(_MTLLoader, _three__WEBPACK_IMPOR5);
            var _super194 = _createSuper(_MTLLoader);
            function _MTLLoader(manager) {
              _classCallCheck2(this, _MTLLoader);
              return _super194.call(this, manager);
            }

            /**
             * Loads and parses a MTL asset from a URL.
             *
             * @param {String} url - URL to the MTL file.
             * @param {Function} [onLoad] - Callback invoked with the loaded object.
             * @param {Function} [onProgress] - Callback for download progress.
             * @param {Function} [onError] - Callback for download errors.
             *
             * @see setPath setResourcePath
             *
             * @note In order for relative texture references to resolve correctly
             * you must call setResourcePath() explicitly prior to load.
             */
            _createClass2(_MTLLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var path = this.path === '' ? three__WEBPACK_IMPORTED_MODULE_0__.LoaderUtils.extractUrlBase(url) : this.path;
                var loader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (text) {
                  try {
                    onLoad(scope.parse(text, path));
                  } catch (e) {
                    if (onError) {
                      onError(e);
                    } else {
                      console.error(e);
                    }
                    scope.manager.itemError(url);
                  }
                }, onProgress, onError);
              }
            }, {
              key: "setMaterialOptions",
              value: function setMaterialOptions(value) {
                this.materialOptions = value;
                return this;
              }

              /**
               * Parses a MTL file.
               *
               * @param {String} text - Content of MTL file
               * @return {MaterialCreator}
               *
               * @see setPath setResourcePath
               *
               * @note In order for relative texture references to resolve correctly
               * you must call setResourcePath() explicitly prior to parse.
               */
            }, {
              key: "parse",
              value: function parse(text, path) {
                var lines = text.split('\n');
                var info = {};
                var delimiter_pattern = /\s+/;
                var materialsInfo = {};
                for (var i = 0; i < lines.length; i++) {
                  var line = lines[i];
                  line = line.trim();
                  if (line.length === 0 || line.charAt(0) === '#') {
                    // Blank line or comment ignore
                    continue;
                  }
                  var pos = line.indexOf(' ');
                  var key = pos >= 0 ? line.substring(0, pos) : line;
                  key = key.toLowerCase();
                  var _value10 = pos >= 0 ? line.substring(pos + 1) : '';
                  _value10 = _value10.trim();
                  if (key === 'newmtl') {
                    // New material

                    info = {
                      name: _value10
                    };
                    materialsInfo[_value10] = info;
                  } else {
                    if (key === 'ka' || key === 'kd' || key === 'ks' || key === 'ke') {
                      var ss = _value10.split(delimiter_pattern, 3);
                      info[key] = [parseFloat(ss[0]), parseFloat(ss[1]), parseFloat(ss[2])];
                    } else {
                      info[key] = _value10;
                    }
                  }
                }
                var materialCreator = new MaterialCreator(this.resourcePath || path, this.materialOptions);
                materialCreator.setCrossOrigin(this.crossOrigin);
                materialCreator.setManager(this.manager);
                materialCreator.setMaterials(materialsInfo);
                return materialCreator;
              }
            }]);
            return _MTLLoader;
          }(three__WEBPACK_IMPORTED_MODULE_0__.Loader);
          /**
           * Create a new MTLLoader.MaterialCreator
           * @param baseUrl - Url relative to which textures are loaded
           * @param options - Set of options on how to construct the materials
           *                  side: Which side to apply the material
           *                        FrontSide (default), THREE.BackSide, THREE.DoubleSide
           *                  wrap: What type of wrapping to apply for textures
           *                        RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
           *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
           *                                Default: false, assumed to be already normalized
           *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
           *                                  Default: false
           * @constructor
           */
          var MaterialCreator = /*#__PURE__*/function () {
            function MaterialCreator() {
              var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck2(this, MaterialCreator);
              this.baseUrl = baseUrl;
              this.options = options;
              this.materialsInfo = {};
              this.materials = {};
              this.materialsArray = [];
              this.nameLookup = {};
              this.crossOrigin = 'anonymous';
              this.side = this.options.side !== undefined ? this.options.side : three__WEBPACK_IMPORTED_MODULE_0__.FrontSide;
              this.wrap = this.options.wrap !== undefined ? this.options.wrap : three__WEBPACK_IMPORTED_MODULE_0__.RepeatWrapping;
            }
            _createClass2(MaterialCreator, [{
              key: "setCrossOrigin",
              value: function setCrossOrigin(value) {
                this.crossOrigin = value;
                return this;
              }
            }, {
              key: "setManager",
              value: function setManager(value) {
                this.manager = value;
              }
            }, {
              key: "setMaterials",
              value: function setMaterials(materialsInfo) {
                this.materialsInfo = this.convert(materialsInfo);
                this.materials = {};
                this.materialsArray = [];
                this.nameLookup = {};
              }
            }, {
              key: "convert",
              value: function convert(materialsInfo) {
                if (!this.options) return materialsInfo;
                var converted = {};
                for (var mn in materialsInfo) {
                  // Convert materials info into normalized form based on options

                  var mat = materialsInfo[mn];
                  var covmat = {};
                  converted[mn] = covmat;
                  for (var prop in mat) {
                    var save = true;
                    var _value11 = mat[prop];
                    var lprop = prop.toLowerCase();
                    switch (lprop) {
                      case 'kd':
                      case 'ka':
                      case 'ks':
                        // Diffuse color (color under white light) using RGB values

                        if (this.options && this.options.normalizeRGB) {
                          _value11 = [_value11[0] / 255, _value11[1] / 255, _value11[2] / 255];
                        }
                        if (this.options && this.options.ignoreZeroRGBs) {
                          if (_value11[0] === 0 && _value11[1] === 0 && _value11[2] === 0) {
                            // ignore

                            save = false;
                          }
                        }
                        break;
                      default:
                        break;
                    }
                    if (save) {
                      covmat[lprop] = _value11;
                    }
                  }
                }
                return converted;
              }
            }, {
              key: "preload",
              value: function preload() {
                for (var mn in this.materialsInfo) {
                  this.create(mn);
                }
              }
            }, {
              key: "getIndex",
              value: function getIndex(materialName) {
                return this.nameLookup[materialName];
              }
            }, {
              key: "getAsArray",
              value: function getAsArray() {
                var index = 0;
                for (var mn in this.materialsInfo) {
                  this.materialsArray[index] = this.create(mn);
                  this.nameLookup[mn] = index;
                  index++;
                }
                return this.materialsArray;
              }
            }, {
              key: "create",
              value: function create(materialName) {
                if (this.materials[materialName] === undefined) {
                  this.createMaterial_(materialName);
                }
                return this.materials[materialName];
              }
            }, {
              key: "createMaterial_",
              value: function createMaterial_(materialName) {
                // Create material

                var scope = this;
                var mat = this.materialsInfo[materialName];
                var params = {
                  name: materialName,
                  side: this.side
                };
                function resolveURL(baseUrl, url) {
                  if (typeof url !== 'string' || url === '') return '';

                  // Absolute URL
                  if (/^https?:\/\//i.test(url)) return url;
                  return baseUrl + url;
                }
                function setMapForType(mapType, value) {
                  if (params[mapType]) return; // Keep the first encountered texture

                  var texParams = scope.getTextureParams(value, params);
                  var map = scope.loadTexture(resolveURL(scope.baseUrl, texParams.url));
                  map.repeat.copy(texParams.scale);
                  map.offset.copy(texParams.offset);
                  map.wrapS = scope.wrap;
                  map.wrapT = scope.wrap;
                  if (mapType === 'map' || mapType === 'emissiveMap') {
                    map.encoding = three__WEBPACK_IMPORTED_MODULE_0__.sRGBEncoding;
                  }
                  params[mapType] = map;
                }
                for (var prop in mat) {
                  var _value12 = mat[prop];
                  var n = void 0;
                  if (_value12 === '') continue;
                  switch (prop.toLowerCase()) {
                    // Ns is material specular exponent

                    case 'kd':
                      // Diffuse color (color under white light) using RGB values

                      params.color = new three__WEBPACK_IMPORTED_MODULE_0__.Color().fromArray(_value12).convertSRGBToLinear();
                      break;
                    case 'ks':
                      // Specular color (color when light is reflected from shiny surface) using RGB values
                      params.specular = new three__WEBPACK_IMPORTED_MODULE_0__.Color().fromArray(_value12).convertSRGBToLinear();
                      break;
                    case 'ke':
                      // Emissive using RGB values
                      params.emissive = new three__WEBPACK_IMPORTED_MODULE_0__.Color().fromArray(_value12).convertSRGBToLinear();
                      break;
                    case 'map_kd':
                      // Diffuse texture map

                      setMapForType('map', _value12);
                      break;
                    case 'map_ks':
                      // Specular map

                      setMapForType('specularMap', _value12);
                      break;
                    case 'map_ke':
                      // Emissive map

                      setMapForType('emissiveMap', _value12);
                      break;
                    case 'norm':
                      setMapForType('normalMap', _value12);
                      break;
                    case 'map_bump':
                    case 'bump':
                      // Bump texture map

                      setMapForType('bumpMap', _value12);
                      break;
                    case 'map_d':
                      // Alpha map

                      setMapForType('alphaMap', _value12);
                      params.transparent = true;
                      break;
                    case 'ns':
                      // The specular exponent (defines the focus of the specular highlight)
                      // A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.

                      params.shininess = parseFloat(_value12);
                      break;
                    case 'd':
                      n = parseFloat(_value12);
                      if (n < 1) {
                        params.opacity = n;
                        params.transparent = true;
                      }
                      break;
                    case 'tr':
                      n = parseFloat(_value12);
                      if (this.options && this.options.invertTrProperty) n = 1 - n;
                      if (n > 0) {
                        params.opacity = 1 - n;
                        params.transparent = true;
                      }
                      break;
                    default:
                      break;
                  }
                }
                this.materials[materialName] = new three__WEBPACK_IMPORTED_MODULE_0__.MeshPhongMaterial(params);
                return this.materials[materialName];
              }
            }, {
              key: "getTextureParams",
              value: function getTextureParams(value, matParams) {
                var texParams = {
                  scale: new three__WEBPACK_IMPORTED_MODULE_0__.Vector2(1, 1),
                  offset: new three__WEBPACK_IMPORTED_MODULE_0__.Vector2(0, 0)
                };
                var items = value.split(/\s+/);
                var pos;
                pos = items.indexOf('-bm');
                if (pos >= 0) {
                  matParams.bumpScale = parseFloat(items[pos + 1]);
                  items.splice(pos, 2);
                }
                pos = items.indexOf('-s');
                if (pos >= 0) {
                  texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
                  items.splice(pos, 4); // we expect 3 parameters here!
                }

                pos = items.indexOf('-o');
                if (pos >= 0) {
                  texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
                  items.splice(pos, 4); // we expect 3 parameters here!
                }

                texParams.url = items.join(' ').trim();
                return texParams;
              }
            }, {
              key: "loadTexture",
              value: function loadTexture(url, mapping, onLoad, onProgress, onError) {
                var manager = this.manager !== undefined ? this.manager : three__WEBPACK_IMPORTED_MODULE_0__.DefaultLoadingManager;
                var loader = manager.getHandler(url);
                if (loader === null) {
                  loader = new three__WEBPACK_IMPORTED_MODULE_0__.TextureLoader(manager);
                }
                if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
                var texture = loader.load(url, onLoad, onProgress, onError);
                if (mapping !== undefined) texture.mapping = mapping;
                return texture;
              }
            }]);
            return MaterialCreator;
          }();
          /***/
        },
        /***/"./node_modules/super-three/examples/jsm/loaders/OBJLoader.js":
        /*!********************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/loaders/OBJLoader.js ***!
          \********************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmLoadersOBJLoaderJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"OBJLoader": function OBJLoader() {
              return (/* binding */_OBJLoader
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");

          // o object_name | g group_name
          var _object_pattern = /^[og]\s*(.+)?/;
          // mtllib file_reference
          var _material_library_pattern = /^mtllib /;
          // usemtl material_name
          var _material_use_pattern = /^usemtl /;
          // usemap map_name
          var _map_use_pattern = /^usemap /;
          var _face_vertex_data_separator_pattern = /\s+/;
          var _vA = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
          var _vB = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
          var _vC = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
          var _ab = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
          var _cb = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
          var _color = new three__WEBPACK_IMPORTED_MODULE_0__.Color();
          function ParserState() {
            var state = {
              objects: [],
              object: {},
              vertices: [],
              normals: [],
              colors: [],
              uvs: [],
              materials: {},
              materialLibraries: [],
              startObject: function startObject(name, fromDeclaration) {
                // If the current object (initial from reset) is not from a g/o declaration in the parsed
                // file. We need to use it for the first parsed g/o to keep things in sync.
                if (this.object && this.object.fromDeclaration === false) {
                  this.object.name = name;
                  this.object.fromDeclaration = fromDeclaration !== false;
                  return;
                }
                var previousMaterial = this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined;
                if (this.object && typeof this.object._finalize === 'function') {
                  this.object._finalize(true);
                }
                this.object = {
                  name: name || '',
                  fromDeclaration: fromDeclaration !== false,
                  geometry: {
                    vertices: [],
                    normals: [],
                    colors: [],
                    uvs: [],
                    hasUVIndices: false
                  },
                  materials: [],
                  smooth: true,
                  startMaterial: function startMaterial(name, libraries) {
                    var previous = this._finalize(false);

                    // New usemtl declaration overwrites an inherited material, except if faces were declared
                    // after the material, then it must be preserved for proper MultiMaterial continuation.
                    if (previous && (previous.inherited || previous.groupCount <= 0)) {
                      this.materials.splice(previous.index, 1);
                    }
                    var material = {
                      index: this.materials.length,
                      name: name || '',
                      mtllib: Array.isArray(libraries) && libraries.length > 0 ? libraries[libraries.length - 1] : '',
                      smooth: previous !== undefined ? previous.smooth : this.smooth,
                      groupStart: previous !== undefined ? previous.groupEnd : 0,
                      groupEnd: -1,
                      groupCount: -1,
                      inherited: false,
                      clone: function clone(index) {
                        var cloned = {
                          index: typeof index === 'number' ? index : this.index,
                          name: this.name,
                          mtllib: this.mtllib,
                          smooth: this.smooth,
                          groupStart: 0,
                          groupEnd: -1,
                          groupCount: -1,
                          inherited: false
                        };
                        cloned.clone = this.clone.bind(cloned);
                        return cloned;
                      }
                    };
                    this.materials.push(material);
                    return material;
                  },
                  currentMaterial: function currentMaterial() {
                    if (this.materials.length > 0) {
                      return this.materials[this.materials.length - 1];
                    }
                    return undefined;
                  },
                  _finalize: function _finalize(end) {
                    var lastMultiMaterial = this.currentMaterial();
                    if (lastMultiMaterial && lastMultiMaterial.groupEnd === -1) {
                      lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
                      lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
                      lastMultiMaterial.inherited = false;
                    }

                    // Ignore objects tail materials if no face declarations followed them before a new o/g started.
                    if (end && this.materials.length > 1) {
                      for (var mi = this.materials.length - 1; mi >= 0; mi--) {
                        if (this.materials[mi].groupCount <= 0) {
                          this.materials.splice(mi, 1);
                        }
                      }
                    }

                    // Guarantee at least one empty material, this makes the creation later more straight forward.
                    if (end && this.materials.length === 0) {
                      this.materials.push({
                        name: '',
                        smooth: this.smooth
                      });
                    }
                    return lastMultiMaterial;
                  }
                };

                // Inherit previous objects material.
                // Spec tells us that a declared material must be set to all objects until a new material is declared.
                // If a usemtl declaration is encountered while this new object is being parsed, it will
                // overwrite the inherited material. Exception being that there was already face declarations
                // to the inherited material, then it will be preserved for proper MultiMaterial continuation.

                if (previousMaterial && previousMaterial.name && typeof previousMaterial.clone === 'function') {
                  var declared = previousMaterial.clone(0);
                  declared.inherited = true;
                  this.object.materials.push(declared);
                }
                this.objects.push(this.object);
              },
              finalize: function finalize() {
                if (this.object && typeof this.object._finalize === 'function') {
                  this.object._finalize(true);
                }
              },
              parseVertexIndex: function parseVertexIndex(value, len) {
                var index = parseInt(value, 10);
                return (index >= 0 ? index - 1 : index + len / 3) * 3;
              },
              parseNormalIndex: function parseNormalIndex(value, len) {
                var index = parseInt(value, 10);
                return (index >= 0 ? index - 1 : index + len / 3) * 3;
              },
              parseUVIndex: function parseUVIndex(value, len) {
                var index = parseInt(value, 10);
                return (index >= 0 ? index - 1 : index + len / 2) * 2;
              },
              addVertex: function addVertex(a, b, c) {
                var src = this.vertices;
                var dst = this.object.geometry.vertices;
                dst.push(src[a + 0], src[a + 1], src[a + 2]);
                dst.push(src[b + 0], src[b + 1], src[b + 2]);
                dst.push(src[c + 0], src[c + 1], src[c + 2]);
              },
              addVertexPoint: function addVertexPoint(a) {
                var src = this.vertices;
                var dst = this.object.geometry.vertices;
                dst.push(src[a + 0], src[a + 1], src[a + 2]);
              },
              addVertexLine: function addVertexLine(a) {
                var src = this.vertices;
                var dst = this.object.geometry.vertices;
                dst.push(src[a + 0], src[a + 1], src[a + 2]);
              },
              addNormal: function addNormal(a, b, c) {
                var src = this.normals;
                var dst = this.object.geometry.normals;
                dst.push(src[a + 0], src[a + 1], src[a + 2]);
                dst.push(src[b + 0], src[b + 1], src[b + 2]);
                dst.push(src[c + 0], src[c + 1], src[c + 2]);
              },
              addFaceNormal: function addFaceNormal(a, b, c) {
                var src = this.vertices;
                var dst = this.object.geometry.normals;
                _vA.fromArray(src, a);
                _vB.fromArray(src, b);
                _vC.fromArray(src, c);
                _cb.subVectors(_vC, _vB);
                _ab.subVectors(_vA, _vB);
                _cb.cross(_ab);
                _cb.normalize();
                dst.push(_cb.x, _cb.y, _cb.z);
                dst.push(_cb.x, _cb.y, _cb.z);
                dst.push(_cb.x, _cb.y, _cb.z);
              },
              addColor: function addColor(a, b, c) {
                var src = this.colors;
                var dst = this.object.geometry.colors;
                if (src[a] !== undefined) dst.push(src[a + 0], src[a + 1], src[a + 2]);
                if (src[b] !== undefined) dst.push(src[b + 0], src[b + 1], src[b + 2]);
                if (src[c] !== undefined) dst.push(src[c + 0], src[c + 1], src[c + 2]);
              },
              addUV: function addUV(a, b, c) {
                var src = this.uvs;
                var dst = this.object.geometry.uvs;
                dst.push(src[a + 0], src[a + 1]);
                dst.push(src[b + 0], src[b + 1]);
                dst.push(src[c + 0], src[c + 1]);
              },
              addDefaultUV: function addDefaultUV() {
                var dst = this.object.geometry.uvs;
                dst.push(0, 0);
                dst.push(0, 0);
                dst.push(0, 0);
              },
              addUVLine: function addUVLine(a) {
                var src = this.uvs;
                var dst = this.object.geometry.uvs;
                dst.push(src[a + 0], src[a + 1]);
              },
              addFace: function addFace(a, b, c, ua, ub, uc, na, nb, nc) {
                var vLen = this.vertices.length;
                var ia = this.parseVertexIndex(a, vLen);
                var ib = this.parseVertexIndex(b, vLen);
                var ic = this.parseVertexIndex(c, vLen);
                this.addVertex(ia, ib, ic);
                this.addColor(ia, ib, ic);

                // normals

                if (na !== undefined && na !== '') {
                  var nLen = this.normals.length;
                  ia = this.parseNormalIndex(na, nLen);
                  ib = this.parseNormalIndex(nb, nLen);
                  ic = this.parseNormalIndex(nc, nLen);
                  this.addNormal(ia, ib, ic);
                } else {
                  this.addFaceNormal(ia, ib, ic);
                }

                // uvs

                if (ua !== undefined && ua !== '') {
                  var uvLen = this.uvs.length;
                  ia = this.parseUVIndex(ua, uvLen);
                  ib = this.parseUVIndex(ub, uvLen);
                  ic = this.parseUVIndex(uc, uvLen);
                  this.addUV(ia, ib, ic);
                  this.object.geometry.hasUVIndices = true;
                } else {
                  // add placeholder values (for inconsistent face definitions)

                  this.addDefaultUV();
                }
              },
              addPointGeometry: function addPointGeometry(vertices) {
                this.object.geometry.type = 'Points';
                var vLen = this.vertices.length;
                for (var vi = 0, l = vertices.length; vi < l; vi++) {
                  var index = this.parseVertexIndex(vertices[vi], vLen);
                  this.addVertexPoint(index);
                  this.addColor(index);
                }
              },
              addLineGeometry: function addLineGeometry(vertices, uvs) {
                this.object.geometry.type = 'Line';
                var vLen = this.vertices.length;
                var uvLen = this.uvs.length;
                for (var vi = 0, l = vertices.length; vi < l; vi++) {
                  this.addVertexLine(this.parseVertexIndex(vertices[vi], vLen));
                }
                for (var uvi = 0, _l12 = uvs.length; uvi < _l12; uvi++) {
                  this.addUVLine(this.parseUVIndex(uvs[uvi], uvLen));
                }
              }
            };
            state.startObject('', false);
            return state;
          }

          //
          var _OBJLoader = /*#__PURE__*/function (_three__WEBPACK_IMPOR6) {
            _inherits(_OBJLoader, _three__WEBPACK_IMPOR6);
            var _super195 = _createSuper(_OBJLoader);
            function _OBJLoader(manager) {
              var _this153;
              _classCallCheck2(this, _OBJLoader);
              _this153 = _super195.call(this, manager);
              _this153.materials = null;
              return _this153;
            }
            _createClass2(_OBJLoader, [{
              key: "load",
              value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new three__WEBPACK_IMPORTED_MODULE_0__.FileLoader(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function (text) {
                  try {
                    onLoad(scope.parse(text));
                  } catch (e) {
                    if (onError) {
                      onError(e);
                    } else {
                      console.error(e);
                    }
                    scope.manager.itemError(url);
                  }
                }, onProgress, onError);
              }
            }, {
              key: "setMaterials",
              value: function setMaterials(materials) {
                this.materials = materials;
                return this;
              }
            }, {
              key: "parse",
              value: function parse(text) {
                var state = new ParserState();
                if (text.indexOf('\r\n') !== -1) {
                  // This is faster than String.split with regex that splits on both
                  text = text.replace(/\r\n/g, '\n');
                }
                if (text.indexOf('\\\n') !== -1) {
                  // join lines separated by a line continuation character (\)
                  text = text.replace(/\\\n/g, '');
                }
                var lines = text.split('\n');
                var result = [];
                for (var i = 0, l = lines.length; i < l; i++) {
                  var line = lines[i].trimStart();
                  if (line.length === 0) continue;
                  var lineFirstChar = line.charAt(0);

                  // @todo invoke passed in handler if any
                  if (lineFirstChar === '#') continue;
                  if (lineFirstChar === 'v') {
                    var data = line.split(_face_vertex_data_separator_pattern);
                    switch (data[0]) {
                      case 'v':
                        state.vertices.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                        if (data.length >= 7) {
                          _color.setRGB(parseFloat(data[4]), parseFloat(data[5]), parseFloat(data[6])).convertSRGBToLinear();
                          state.colors.push(_color.r, _color.g, _color.b);
                        } else {
                          // if no colors are defined, add placeholders so color and vertex indices match

                          state.colors.push(undefined, undefined, undefined);
                        }
                        break;
                      case 'vn':
                        state.normals.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                        break;
                      case 'vt':
                        state.uvs.push(parseFloat(data[1]), parseFloat(data[2]));
                        break;
                    }
                  } else if (lineFirstChar === 'f') {
                    var lineData = line.slice(1).trim();
                    var vertexData = lineData.split(_face_vertex_data_separator_pattern);
                    var faceVertices = [];

                    // Parse the face vertex data into an easy to work with format

                    for (var j = 0, jl = vertexData.length; j < jl; j++) {
                      var vertex = vertexData[j];
                      if (vertex.length > 0) {
                        var vertexParts = vertex.split('/');
                        faceVertices.push(vertexParts);
                      }
                    }

                    // Draw an edge between the first vertex and all subsequent vertices to form an n-gon

                    var v1 = faceVertices[0];
                    for (var _j22 = 1, _jl4 = faceVertices.length - 1; _j22 < _jl4; _j22++) {
                      var v2 = faceVertices[_j22];
                      var v3 = faceVertices[_j22 + 1];
                      state.addFace(v1[0], v2[0], v3[0], v1[1], v2[1], v3[1], v1[2], v2[2], v3[2]);
                    }
                  } else if (lineFirstChar === 'l') {
                    var lineParts = line.substring(1).trim().split(' ');
                    var lineVertices = [];
                    var lineUVs = [];
                    if (line.indexOf('/') === -1) {
                      lineVertices = lineParts;
                    } else {
                      for (var li = 0, llen = lineParts.length; li < llen; li++) {
                        var parts = lineParts[li].split('/');
                        if (parts[0] !== '') lineVertices.push(parts[0]);
                        if (parts[1] !== '') lineUVs.push(parts[1]);
                      }
                    }
                    state.addLineGeometry(lineVertices, lineUVs);
                  } else if (lineFirstChar === 'p') {
                    var _lineData = line.slice(1).trim();
                    var pointData = _lineData.split(' ');
                    state.addPointGeometry(pointData);
                  } else if ((result = _object_pattern.exec(line)) !== null) {
                    // o object_name
                    // or
                    // g group_name

                    // WORKAROUND: https://bugs.chromium.org/p/v8/issues/detail?id=2869
                    // let name = result[ 0 ].slice( 1 ).trim();
                    var name = (' ' + result[0].slice(1).trim()).slice(1);
                    state.startObject(name);
                  } else if (_material_use_pattern.test(line)) {
                    // material

                    state.object.startMaterial(line.substring(7).trim(), state.materialLibraries);
                  } else if (_material_library_pattern.test(line)) {
                    // mtl file

                    state.materialLibraries.push(line.substring(7).trim());
                  } else if (_map_use_pattern.test(line)) {
                    // the line is parsed but ignored since the loader assumes textures are defined MTL files
                    // (according to https://www.okino.com/conv/imp_wave.htm, 'usemap' is the old-style Wavefront texture reference method)

                    console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
                  } else if (lineFirstChar === 's') {
                    result = line.split(' ');

                    // smooth shading

                    // @todo Handle files that have varying smooth values for a set of faces inside one geometry,
                    // but does not define a usemtl for each face set.
                    // This should be detected and a dummy material created (later MultiMaterial and geometry groups).
                    // This requires some care to not create extra material on each smooth value for "normal" obj files.
                    // where explicit usemtl defines geometry groups.
                    // Example asset: examples/models/obj/cerberus/Cerberus.obj

                    /*
                    	 * http://paulbourke.net/dataformats/obj/
                    	 *
                    	 * From chapter "Grouping" Syntax explanation "s group_number":
                    	 * "group_number is the smoothing group number. To turn off smoothing groups, use a value of 0 or off.
                    	 * Polygonal elements use group numbers to put elements in different smoothing groups. For free-form
                    	 * surfaces, smoothing groups are either turned on or off; there is no difference between values greater
                    	 * than 0."
                    	 */
                    if (result.length > 1) {
                      var _value13 = result[1].trim().toLowerCase();
                      state.object.smooth = _value13 !== '0' && _value13 !== 'off';
                    } else {
                      // ZBrush can produce "s" lines #11707
                      state.object.smooth = true;
                    }
                    var material = state.object.currentMaterial();
                    if (material) material.smooth = state.object.smooth;
                  } else {
                    // Handle null terminated files without exception
                    if (line === '\0') continue;
                    console.warn('THREE.OBJLoader: Unexpected line: "' + line + '"');
                  }
                }
                state.finalize();
                var container = new three__WEBPACK_IMPORTED_MODULE_0__.Group();
                container.materialLibraries = [].concat(state.materialLibraries);
                var hasPrimitives = !(state.objects.length === 1 && state.objects[0].geometry.vertices.length === 0);
                if (hasPrimitives === true) {
                  for (var _i109 = 0, _l13 = state.objects.length; _i109 < _l13; _i109++) {
                    var object = state.objects[_i109];
                    var geometry = object.geometry;
                    var materials = object.materials;
                    var isLine = geometry.type === 'Line';
                    var isPoints = geometry.type === 'Points';
                    var hasVertexColors = false;

                    // Skip o/g line declarations that did not follow with any faces
                    if (geometry.vertices.length === 0) continue;
                    var buffergeometry = new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry();
                    buffergeometry.setAttribute('position', new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(geometry.vertices, 3));
                    if (geometry.normals.length > 0) {
                      buffergeometry.setAttribute('normal', new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(geometry.normals, 3));
                    }
                    if (geometry.colors.length > 0) {
                      hasVertexColors = true;
                      buffergeometry.setAttribute('color', new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(geometry.colors, 3));
                    }
                    if (geometry.hasUVIndices === true) {
                      buffergeometry.setAttribute('uv', new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(geometry.uvs, 2));
                    }

                    // Create materials

                    var createdMaterials = [];
                    for (var mi = 0, miLen = materials.length; mi < miLen; mi++) {
                      var sourceMaterial = materials[mi];
                      var materialHash = sourceMaterial.name + '_' + sourceMaterial.smooth + '_' + hasVertexColors;
                      var _material3 = state.materials[materialHash];
                      if (this.materials !== null) {
                        _material3 = this.materials.create(sourceMaterial.name);

                        // mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
                        if (isLine && _material3 && !(_material3 instanceof three__WEBPACK_IMPORTED_MODULE_0__.LineBasicMaterial)) {
                          var materialLine = new three__WEBPACK_IMPORTED_MODULE_0__.LineBasicMaterial();
                          three__WEBPACK_IMPORTED_MODULE_0__.Material.prototype.copy.call(materialLine, _material3);
                          materialLine.color.copy(_material3.color);
                          _material3 = materialLine;
                        } else if (isPoints && _material3 && !(_material3 instanceof three__WEBPACK_IMPORTED_MODULE_0__.PointsMaterial)) {
                          var materialPoints = new three__WEBPACK_IMPORTED_MODULE_0__.PointsMaterial({
                            size: 10,
                            sizeAttenuation: false
                          });
                          three__WEBPACK_IMPORTED_MODULE_0__.Material.prototype.copy.call(materialPoints, _material3);
                          materialPoints.color.copy(_material3.color);
                          materialPoints.map = _material3.map;
                          _material3 = materialPoints;
                        }
                      }
                      if (_material3 === undefined) {
                        if (isLine) {
                          _material3 = new three__WEBPACK_IMPORTED_MODULE_0__.LineBasicMaterial();
                        } else if (isPoints) {
                          _material3 = new three__WEBPACK_IMPORTED_MODULE_0__.PointsMaterial({
                            size: 1,
                            sizeAttenuation: false
                          });
                        } else {
                          _material3 = new three__WEBPACK_IMPORTED_MODULE_0__.MeshPhongMaterial();
                        }
                        _material3.name = sourceMaterial.name;
                        _material3.flatShading = sourceMaterial.smooth ? false : true;
                        _material3.vertexColors = hasVertexColors;
                        state.materials[materialHash] = _material3;
                      }
                      createdMaterials.push(_material3);
                    }

                    // Create mesh

                    var mesh = void 0;
                    if (createdMaterials.length > 1) {
                      for (var _mi = 0, _miLen = materials.length; _mi < _miLen; _mi++) {
                        var _sourceMaterial = materials[_mi];
                        buffergeometry.addGroup(_sourceMaterial.groupStart, _sourceMaterial.groupCount, _mi);
                      }
                      if (isLine) {
                        mesh = new three__WEBPACK_IMPORTED_MODULE_0__.LineSegments(buffergeometry, createdMaterials);
                      } else if (isPoints) {
                        mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Points(buffergeometry, createdMaterials);
                      } else {
                        mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Mesh(buffergeometry, createdMaterials);
                      }
                    } else {
                      if (isLine) {
                        mesh = new three__WEBPACK_IMPORTED_MODULE_0__.LineSegments(buffergeometry, createdMaterials[0]);
                      } else if (isPoints) {
                        mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Points(buffergeometry, createdMaterials[0]);
                      } else {
                        mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Mesh(buffergeometry, createdMaterials[0]);
                      }
                    }
                    mesh.name = object.name;
                    container.add(mesh);
                  }
                } else {
                  // if there is only the default parser state object with no geometry data, interpret data as point cloud

                  if (state.vertices.length > 0) {
                    var _material4 = new three__WEBPACK_IMPORTED_MODULE_0__.PointsMaterial({
                      size: 1,
                      sizeAttenuation: false
                    });
                    var _buffergeometry = new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry();
                    _buffergeometry.setAttribute('position', new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(state.vertices, 3));
                    if (state.colors.length > 0 && state.colors[0] !== undefined) {
                      _buffergeometry.setAttribute('color', new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(state.colors, 3));
                      _material4.vertexColors = true;
                    }
                    var points = new three__WEBPACK_IMPORTED_MODULE_0__.Points(_buffergeometry, _material4);
                    container.add(points);
                  }
                }
                return container;
              }
            }]);
            return _OBJLoader;
          }(three__WEBPACK_IMPORTED_MODULE_0__.Loader);
          /***/
        },
        /***/"./node_modules/super-three/examples/jsm/utils/BufferGeometryUtils.js":
        /*!****************************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/utils/BufferGeometryUtils.js ***!
          \****************************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmUtilsBufferGeometryUtilsJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"computeMikkTSpaceTangents": function computeMikkTSpaceTangents() {
              return (/* binding */_computeMikkTSpaceTangents
              );
            },
            /* harmony export */"computeMorphedAttributes": function computeMorphedAttributes() {
              return (/* binding */_computeMorphedAttributes
              );
            },
            /* harmony export */"computeTangents": function computeTangents() {
              return (/* binding */_computeTangents
              );
            },
            /* harmony export */"deepCloneAttribute": function deepCloneAttribute() {
              return (/* binding */_deepCloneAttribute
              );
            },
            /* harmony export */"deinterleaveAttribute": function deinterleaveAttribute() {
              return (/* binding */_deinterleaveAttribute
              );
            },
            /* harmony export */"deinterleaveGeometry": function deinterleaveGeometry() {
              return (/* binding */_deinterleaveGeometry
              );
            },
            /* harmony export */"estimateBytesUsed": function estimateBytesUsed() {
              return (/* binding */_estimateBytesUsed
              );
            },
            /* harmony export */"interleaveAttributes": function interleaveAttributes() {
              return (/* binding */_interleaveAttributes
              );
            },
            /* harmony export */"mergeBufferAttributes": function mergeBufferAttributes() {
              return (/* binding */_mergeBufferAttributes
              );
            },
            /* harmony export */"mergeBufferGeometries": function mergeBufferGeometries() {
              return (/* binding */_mergeBufferGeometries
              );
            },
            /* harmony export */"mergeGroups": function mergeGroups() {
              return (/* binding */_mergeGroups
              );
            },
            /* harmony export */"mergeVertices": function mergeVertices() {
              return (/* binding */_mergeVertices
              );
            },
            /* harmony export */"toCreasedNormals": function toCreasedNormals() {
              return (/* binding */_toCreasedNormals
              );
            },
            /* harmony export */"toTrianglesDrawMode": function toTrianglesDrawMode() {
              return (/* binding */_toTrianglesDrawMode
              );
            }
            /* harmony export */
          });
          /* harmony import */
          var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! three */"./node_modules/super-three/build/three.module.js");
          function _computeTangents() {
            throw new Error('BufferGeometryUtils: computeTangents renamed to computeMikkTSpaceTangents.');
          }
          function _computeMikkTSpaceTangents(geometry, MikkTSpace) {
            var negateSign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            if (!MikkTSpace || !MikkTSpace.isReady) {
              throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
            }
            if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) {
              throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
            }
            function getAttributeArray(attribute) {
              if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
                var dstArray = new Float32Array(attribute.getCount() * attribute.itemSize);
                for (var i = 0, j = 0; i < attribute.getCount(); i++) {
                  dstArray[j++] = attribute.getX(i);
                  dstArray[j++] = attribute.getY(i);
                  if (attribute.itemSize > 2) {
                    dstArray[j++] = attribute.getZ(i);
                  }
                }
                return dstArray;
              }
              if (attribute.array instanceof Float32Array) {
                return attribute.array;
              }
              return new Float32Array(attribute.array);
            }

            // MikkTSpace algorithm requires non-indexed input.

            var _geometry = geometry.index ? geometry.toNonIndexed() : geometry;

            // Compute vertex tangents.

            var tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));

            // Texture coordinate convention of glTF differs from the apparent
            // default of the MikkTSpace library; .w component must be flipped.

            if (negateSign) {
              for (var i = 3; i < tangents.length; i += 4) {
                tangents[i] *= -1;
              }
            }

            //

            _geometry.setAttribute('tangent', new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(tangents, 4));
            if (geometry !== _geometry) {
              geometry.copy(_geometry);
            }
            return geometry;
          }

          /**
           * @param  {Array<BufferGeometry>} geometries
           * @param  {Boolean} useGroups
           * @return {BufferGeometry}
           */
          function _mergeBufferGeometries(geometries) {
            var useGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var isIndexed = geometries[0].index !== null;
            var attributesUsed = new Set(Object.keys(geometries[0].attributes));
            var morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
            var attributes = {};
            var morphAttributes = {};
            var morphTargetsRelative = geometries[0].morphTargetsRelative;
            var mergedGeometry = new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry();
            var offset = 0;
            for (var i = 0; i < geometries.length; ++i) {
              var geometry = geometries[i];
              var attributesCount = 0;

              // ensure that all geometries are indexed, or none

              if (isIndexed !== (geometry.index !== null)) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
                return null;
              }

              // gather attributes, exit early if they're different

              for (var name in geometry.attributes) {
                if (!attributesUsed.has(name)) {
                  console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                  return null;
                }
                if (attributes[name] === undefined) attributes[name] = [];
                attributes[name].push(geometry.attributes[name]);
                attributesCount++;
              }

              // ensure geometries have the same number of attributes

              if (attributesCount !== attributesUsed.size) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
                return null;
              }

              // gather morph attributes, exit early if they're different

              if (morphTargetsRelative !== geometry.morphTargetsRelative) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
                return null;
              }
              for (var _name5 in geometry.morphAttributes) {
                if (!morphAttributesUsed.has(_name5)) {
                  console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
                  return null;
                }
                if (morphAttributes[_name5] === undefined) morphAttributes[_name5] = [];
                morphAttributes[_name5].push(geometry.morphAttributes[_name5]);
              }
              if (useGroups) {
                var count = void 0;
                if (isIndexed) {
                  count = geometry.index.count;
                } else if (geometry.attributes.position !== undefined) {
                  count = geometry.attributes.position.count;
                } else {
                  console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
                  return null;
                }
                mergedGeometry.addGroup(offset, count, i);
                offset += count;
              }
            }

            // merge indices

            if (isIndexed) {
              var indexOffset = 0;
              var mergedIndex = [];
              for (var _i110 = 0; _i110 < geometries.length; ++_i110) {
                var index = geometries[_i110].index;
                for (var j = 0; j < index.count; ++j) {
                  mergedIndex.push(index.getX(j) + indexOffset);
                }
                indexOffset += geometries[_i110].attributes.position.count;
              }
              mergedGeometry.setIndex(mergedIndex);
            }

            // merge attributes

            for (var _name6 in attributes) {
              var mergedAttribute = _mergeBufferAttributes(attributes[_name6]);
              if (!mergedAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the ' + _name6 + ' attribute.');
                return null;
              }
              mergedGeometry.setAttribute(_name6, mergedAttribute);
            }

            // merge morph attributes

            for (var _name7 in morphAttributes) {
              var numMorphTargets = morphAttributes[_name7][0].length;
              if (numMorphTargets === 0) break;
              mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
              mergedGeometry.morphAttributes[_name7] = [];
              for (var _i111 = 0; _i111 < numMorphTargets; ++_i111) {
                var morphAttributesToMerge = [];
                for (var _j23 = 0; _j23 < morphAttributes[_name7].length; ++_j23) {
                  morphAttributesToMerge.push(morphAttributes[_name7][_j23][_i111]);
                }
                var mergedMorphAttribute = _mergeBufferAttributes(morphAttributesToMerge);
                if (!mergedMorphAttribute) {
                  console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the ' + _name7 + ' morphAttribute.');
                  return null;
                }
                mergedGeometry.morphAttributes[_name7].push(mergedMorphAttribute);
              }
            }
            return mergedGeometry;
          }

          /**
           * @param {Array<BufferAttribute>} attributes
           * @return {BufferAttribute}
           */
          function _mergeBufferAttributes(attributes) {
            var TypedArray;
            var itemSize;
            var normalized;
            var arrayLength = 0;
            for (var i = 0; i < attributes.length; ++i) {
              var attribute = attributes[i];
              if (attribute.isInterleavedBufferAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported.');
                return null;
              }
              if (TypedArray === undefined) TypedArray = attribute.array.constructor;
              if (TypedArray !== attribute.array.constructor) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
                return null;
              }
              if (itemSize === undefined) itemSize = attribute.itemSize;
              if (itemSize !== attribute.itemSize) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
                return null;
              }
              if (normalized === undefined) normalized = attribute.normalized;
              if (normalized !== attribute.normalized) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
                return null;
              }
              arrayLength += attribute.array.length;
            }
            var array = new TypedArray(arrayLength);
            var offset = 0;
            for (var _i112 = 0; _i112 < attributes.length; ++_i112) {
              array.set(attributes[_i112].array, offset);
              offset += attributes[_i112].array.length;
            }
            return new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(array, itemSize, normalized);
          }

          /**
           * @param {BufferAttribute}
           * @return {BufferAttribute}
           */
          function _deepCloneAttribute(attribute) {
            if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) {
              return _deinterleaveAttribute(attribute);
            }
            if (attribute.isInstancedBufferAttribute) {
              return new three__WEBPACK_IMPORTED_MODULE_0__.InstancedBufferAttribute().copy(attribute);
            }
            return new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute().copy(attribute);
          }

          /**
           * @param {Array<BufferAttribute>} attributes
           * @return {Array<InterleavedBufferAttribute>}
           */
          function _interleaveAttributes(attributes) {
            // Interleaves the provided attributes into an InterleavedBuffer and returns
            // a set of InterleavedBufferAttributes for each attribute
            var TypedArray;
            var arrayLength = 0;
            var stride = 0;

            // calculate the length and type of the interleavedBuffer
            for (var i = 0, l = attributes.length; i < l; ++i) {
              var attribute = attributes[i];
              if (TypedArray === undefined) TypedArray = attribute.array.constructor;
              if (TypedArray !== attribute.array.constructor) {
                console.error('AttributeBuffers of different types cannot be interleaved');
                return null;
              }
              arrayLength += attribute.array.length;
              stride += attribute.itemSize;
            }

            // Create the set of buffer attributes
            var interleavedBuffer = new three__WEBPACK_IMPORTED_MODULE_0__.InterleavedBuffer(new TypedArray(arrayLength), stride);
            var offset = 0;
            var res = [];
            var getters = ['getX', 'getY', 'getZ', 'getW'];
            var setters = ['setX', 'setY', 'setZ', 'setW'];
            for (var j = 0, _l14 = attributes.length; j < _l14; j++) {
              var _attribute4 = attributes[j];
              var itemSize = _attribute4.itemSize;
              var count = _attribute4.count;
              var iba = new three__WEBPACK_IMPORTED_MODULE_0__.InterleavedBufferAttribute(interleavedBuffer, itemSize, offset, _attribute4.normalized);
              res.push(iba);
              offset += itemSize;

              // Move the data for each attribute into the new interleavedBuffer
              // at the appropriate offset
              for (var c = 0; c < count; c++) {
                for (var k = 0; k < itemSize; k++) {
                  iba[setters[k]](c, _attribute4[getters[k]](c));
                }
              }
            }
            return res;
          }

          // returns a new, non-interleaved version of the provided attribute
          function _deinterleaveAttribute(attribute) {
            var cons = attribute.data.array.constructor;
            var count = attribute.count;
            var itemSize = attribute.itemSize;
            var normalized = attribute.normalized;
            var array = new cons(count * itemSize);
            var newAttribute;
            if (attribute.isInstancedInterleavedBufferAttribute) {
              newAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.InstancedBufferAttribute(array, itemSize, normalized, attribute.meshPerAttribute);
            } else {
              newAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(array, itemSize, normalized);
            }
            for (var i = 0; i < count; i++) {
              newAttribute.setX(i, attribute.getX(i));
              if (itemSize >= 2) {
                newAttribute.setY(i, attribute.getY(i));
              }
              if (itemSize >= 3) {
                newAttribute.setZ(i, attribute.getZ(i));
              }
              if (itemSize >= 4) {
                newAttribute.setW(i, attribute.getW(i));
              }
            }
            return newAttribute;
          }

          // deinterleaves all attributes on the geometry
          function _deinterleaveGeometry(geometry) {
            var attributes = geometry.attributes;
            var morphTargets = geometry.morphTargets;
            var attrMap = new Map();
            for (var key in attributes) {
              var attr = attributes[key];
              if (attr.isInterleavedBufferAttribute) {
                if (!attrMap.has(attr)) {
                  attrMap.set(attr, _deinterleaveAttribute(attr));
                }
                attributes[key] = attrMap.get(attr);
              }
            }
            for (var _key4 in morphTargets) {
              var _attr = morphTargets[_key4];
              if (_attr.isInterleavedBufferAttribute) {
                if (!attrMap.has(_attr)) {
                  attrMap.set(_attr, _deinterleaveAttribute(_attr));
                }
                morphTargets[_key4] = attrMap.get(_attr);
              }
            }
          }

          /**
           * @param {Array<BufferGeometry>} geometry
           * @return {number}
           */
          function _estimateBytesUsed(geometry) {
            // Return the estimated memory used by this geometry in bytes
            // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
            // for InterleavedBufferAttributes.
            var mem = 0;
            for (var name in geometry.attributes) {
              var attr = geometry.getAttribute(name);
              mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
            }
            var indices = geometry.getIndex();
            mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
            return mem;
          }

          /**
           * @param {BufferGeometry} geometry
           * @param {number} tolerance
           * @return {BufferGeometry}
           */
          function _mergeVertices(geometry) {
            var tolerance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e-4;
            tolerance = Math.max(tolerance, Number.EPSILON);

            // Generate an index buffer if the geometry doesn't have one, or optimize it
            // if it's already available.
            var hashToIndex = {};
            var indices = geometry.getIndex();
            var positions = geometry.getAttribute('position');
            var vertexCount = indices ? indices.count : positions.count;

            // next value for triangle indices
            var nextIndex = 0;

            // attributes and new attribute arrays
            var attributeNames = Object.keys(geometry.attributes);
            var tmpAttributes = {};
            var tmpMorphAttributes = {};
            var newIndices = [];
            var getters = ['getX', 'getY', 'getZ', 'getW'];
            var setters = ['setX', 'setY', 'setZ', 'setW'];

            // Initialize the arrays, allocating space conservatively. Extra
            // space will be trimmed in the last step.
            for (var i = 0, l = attributeNames.length; i < l; i++) {
              var name = attributeNames[i];
              var attr = geometry.attributes[name];
              tmpAttributes[name] = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
              var morphAttr = geometry.morphAttributes[name];
              if (morphAttr) {
                tmpMorphAttributes[name] = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
              }
            }

            // convert the error tolerance to an amount of decimal places to truncate to
            var decimalShift = Math.log10(1 / tolerance);
            var shiftMultiplier = Math.pow(10, decimalShift);
            for (var _i113 = 0; _i113 < vertexCount; _i113++) {
              var index = indices ? indices.getX(_i113) : _i113;

              // Generate a hash for the vertex attributes at the current index 'i'
              var hash = '';
              for (var j = 0, _l15 = attributeNames.length; j < _l15; j++) {
                var _name8 = attributeNames[j];
                var attribute = geometry.getAttribute(_name8);
                var itemSize = attribute.itemSize;
                for (var k = 0; k < itemSize; k++) {
                  // double tilde truncates the decimal value
                  hash += "".concat(~~(attribute[getters[k]](index) * shiftMultiplier), ",");
                }
              }

              // Add another reference to the vertex if it's already
              // used by another index
              if (hash in hashToIndex) {
                newIndices.push(hashToIndex[hash]);
              } else {
                // copy data to the new index in the temporary attributes
                for (var _j24 = 0, _l16 = attributeNames.length; _j24 < _l16; _j24++) {
                  var _name9 = attributeNames[_j24];
                  var _attribute5 = geometry.getAttribute(_name9);
                  var _morphAttr = geometry.morphAttributes[_name9];
                  var _itemSize = _attribute5.itemSize;
                  var newarray = tmpAttributes[_name9];
                  var newMorphArrays = tmpMorphAttributes[_name9];
                  for (var _k4 = 0; _k4 < _itemSize; _k4++) {
                    var getterFunc = getters[_k4];
                    var setterFunc = setters[_k4];
                    newarray[setterFunc](nextIndex, _attribute5[getterFunc](index));
                    if (_morphAttr) {
                      for (var m = 0, ml = _morphAttr.length; m < ml; m++) {
                        newMorphArrays[m][setterFunc](nextIndex, _morphAttr[m][getterFunc](index));
                      }
                    }
                  }
                }
                hashToIndex[hash] = nextIndex;
                newIndices.push(nextIndex);
                nextIndex++;
              }
            }

            // generate result BufferGeometry
            var result = geometry.clone();
            for (var _name10 in geometry.attributes) {
              var tmpAttribute = tmpAttributes[_name10];
              result.setAttribute(_name10, new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
              if (!(_name10 in tmpMorphAttributes)) continue;
              for (var _j25 = 0; _j25 < tmpMorphAttributes[_name10].length; _j25++) {
                var tmpMorphAttribute = tmpMorphAttributes[_name10][_j25];
                result.morphAttributes[_name10][_j25] = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
              }
            }

            // indices

            result.setIndex(newIndices);
            return result;
          }

          /**
           * @param {BufferGeometry} geometry
           * @param {number} drawMode
           * @return {BufferGeometry}
           */
          function _toTrianglesDrawMode(geometry, drawMode) {
            if (drawMode === three__WEBPACK_IMPORTED_MODULE_0__.TrianglesDrawMode) {
              console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
              return geometry;
            }
            if (drawMode === three__WEBPACK_IMPORTED_MODULE_0__.TriangleFanDrawMode || drawMode === three__WEBPACK_IMPORTED_MODULE_0__.TriangleStripDrawMode) {
              var index = geometry.getIndex();

              // generate index if not present

              if (index === null) {
                var indices = [];
                var position = geometry.getAttribute('position');
                if (position !== undefined) {
                  for (var i = 0; i < position.count; i++) {
                    indices.push(i);
                  }
                  geometry.setIndex(indices);
                  index = geometry.getIndex();
                } else {
                  console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                  return geometry;
                }
              }

              //

              var numberOfTriangles = index.count - 2;
              var newIndices = [];
              if (drawMode === three__WEBPACK_IMPORTED_MODULE_0__.TriangleFanDrawMode) {
                // gl.TRIANGLE_FAN

                for (var _i114 = 1; _i114 <= numberOfTriangles; _i114++) {
                  newIndices.push(index.getX(0));
                  newIndices.push(index.getX(_i114));
                  newIndices.push(index.getX(_i114 + 1));
                }
              } else {
                // gl.TRIANGLE_STRIP

                for (var _i115 = 0; _i115 < numberOfTriangles; _i115++) {
                  if (_i115 % 2 === 0) {
                    newIndices.push(index.getX(_i115));
                    newIndices.push(index.getX(_i115 + 1));
                    newIndices.push(index.getX(_i115 + 2));
                  } else {
                    newIndices.push(index.getX(_i115 + 2));
                    newIndices.push(index.getX(_i115 + 1));
                    newIndices.push(index.getX(_i115));
                  }
                }
              }
              if (newIndices.length / 3 !== numberOfTriangles) {
                console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
              }

              // build final geometry

              var newGeometry = geometry.clone();
              newGeometry.setIndex(newIndices);
              newGeometry.clearGroups();
              return newGeometry;
            } else {
              console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
              return geometry;
            }
          }

          /**
           * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
           * Helpful for Raytracing or Decals.
           * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
           * @return {Object} An Object with original position/normal attributes and morphed ones.
           */
          function _computeMorphedAttributes(object) {
            if (object.geometry.isBufferGeometry !== true) {
              console.error('THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.');
              return null;
            }
            var _vA = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _vB = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _vC = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _tempA = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _tempB = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _tempC = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _morphA = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _morphB = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var _morphC = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
              _vA.fromBufferAttribute(attribute, a);
              _vB.fromBufferAttribute(attribute, b);
              _vC.fromBufferAttribute(attribute, c);
              var morphInfluences = object.morphTargetInfluences;
              if (morphAttribute && morphInfluences) {
                _morphA.set(0, 0, 0);
                _morphB.set(0, 0, 0);
                _morphC.set(0, 0, 0);
                for (var _i116 = 0, _il26 = morphAttribute.length; _i116 < _il26; _i116++) {
                  var influence = morphInfluences[_i116];
                  var morph = morphAttribute[_i116];
                  if (influence === 0) continue;
                  _tempA.fromBufferAttribute(morph, a);
                  _tempB.fromBufferAttribute(morph, b);
                  _tempC.fromBufferAttribute(morph, c);
                  if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                  } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                  }
                }
                _vA.add(_morphA);
                _vB.add(_morphB);
                _vC.add(_morphC);
              }
              if (object.isSkinnedMesh) {
                object.boneTransform(a, _vA);
                object.boneTransform(b, _vB);
                object.boneTransform(c, _vC);
              }
              modifiedAttributeArray[a * 3 + 0] = _vA.x;
              modifiedAttributeArray[a * 3 + 1] = _vA.y;
              modifiedAttributeArray[a * 3 + 2] = _vA.z;
              modifiedAttributeArray[b * 3 + 0] = _vB.x;
              modifiedAttributeArray[b * 3 + 1] = _vB.y;
              modifiedAttributeArray[b * 3 + 2] = _vB.z;
              modifiedAttributeArray[c * 3 + 0] = _vC.x;
              modifiedAttributeArray[c * 3 + 1] = _vC.y;
              modifiedAttributeArray[c * 3 + 2] = _vC.z;
            }
            var geometry = object.geometry;
            var material = object.material;
            var a, b, c;
            var index = geometry.index;
            var positionAttribute = geometry.attributes.position;
            var morphPosition = geometry.morphAttributes.position;
            var morphTargetsRelative = geometry.morphTargetsRelative;
            var normalAttribute = geometry.attributes.normal;
            var morphNormal = geometry.morphAttributes.position;
            var groups = geometry.groups;
            var drawRange = geometry.drawRange;
            var i, j, il, jl;
            var group;
            var start, end;
            var modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
            var modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
            if (index !== null) {
              // indexed buffer geometry

              if (Array.isArray(material)) {
                for (i = 0, il = groups.length; i < il; i++) {
                  group = groups[i];
                  start = Math.max(group.start, drawRange.start);
                  end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                  for (j = start, jl = end; j < jl; j += 3) {
                    a = index.getX(j);
                    b = index.getX(j + 1);
                    c = index.getX(j + 2);
                    _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                    _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
                  }
                }
              } else {
                start = Math.max(0, drawRange.start);
                end = Math.min(index.count, drawRange.start + drawRange.count);
                for (i = start, il = end; i < il; i += 3) {
                  a = index.getX(i);
                  b = index.getX(i + 1);
                  c = index.getX(i + 2);
                  _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                  _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
                }
              }
            } else {
              // non-indexed buffer geometry

              if (Array.isArray(material)) {
                for (i = 0, il = groups.length; i < il; i++) {
                  group = groups[i];
                  start = Math.max(group.start, drawRange.start);
                  end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                  for (j = start, jl = end; j < jl; j += 3) {
                    a = j;
                    b = j + 1;
                    c = j + 2;
                    _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                    _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
                  }
                }
              } else {
                start = Math.max(0, drawRange.start);
                end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for (i = start, il = end; i < il; i += 3) {
                  a = i;
                  b = i + 1;
                  c = i + 2;
                  _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                  _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
                }
              }
            }
            var morphedPositionAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(modifiedPosition, 3);
            var morphedNormalAttribute = new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(modifiedNormal, 3);
            return {
              positionAttribute: positionAttribute,
              normalAttribute: normalAttribute,
              morphedPositionAttribute: morphedPositionAttribute,
              morphedNormalAttribute: morphedNormalAttribute
            };
          }
          function _mergeGroups(geometry) {
            if (geometry.groups.length === 0) {
              console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
              return geometry;
            }
            var groups = geometry.groups;

            // sort groups by material index

            groups = groups.sort(function (a, b) {
              if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
              return a.start - b.start;
            });

            // create index for non-indexed geometries

            if (geometry.getIndex() === null) {
              var positionAttribute = geometry.getAttribute('position');
              var indices = [];
              for (var i = 0; i < positionAttribute.count; i += 3) {
                indices.push(i, i + 1, i + 2);
              }
              geometry.setIndex(indices);
            }

            // sort index

            var index = geometry.getIndex();
            var newIndices = [];
            for (var _i117 = 0; _i117 < groups.length; _i117++) {
              var group = groups[_i117];
              var groupStart = group.start;
              var groupLength = groupStart + group.count;
              for (var j = groupStart; j < groupLength; j++) {
                newIndices.push(index.getX(j));
              }
            }
            geometry.dispose(); // Required to force buffer recreation
            geometry.setIndex(newIndices);

            // update groups indices

            var start = 0;
            for (var _i118 = 0; _i118 < groups.length; _i118++) {
              var _group3 = groups[_i118];
              _group3.start = start;
              start += _group3.count;
            }

            // merge groups

            var currentGroup = groups[0];
            geometry.groups = [currentGroup];
            for (var _i119 = 1; _i119 < groups.length; _i119++) {
              var _group4 = groups[_i119];
              if (currentGroup.materialIndex === _group4.materialIndex) {
                currentGroup.count += _group4.count;
              } else {
                currentGroup = _group4;
                geometry.groups.push(currentGroup);
              }
            }
            return geometry;
          }

          // Creates a new, non-indexed geometry with smooth normals everywhere except faces that meet at
          // an angle greater than the crease angle.
          function _toCreasedNormals(geometry) {
            var creaseAngle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.PI / 3;
            var creaseDot = Math.cos(creaseAngle);
            var hashMultiplier = (1 + 1e-10) * 1e2;

            // reusable vertors
            var verts = [new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(), new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(), new three__WEBPACK_IMPORTED_MODULE_0__.Vector3()];
            var tempVec1 = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var tempVec2 = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var tempNorm = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
            var tempNorm2 = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();

            // hashes a vector
            function hashVertex(v) {
              var x = ~~(v.x * hashMultiplier);
              var y = ~~(v.y * hashMultiplier);
              var z = ~~(v.z * hashMultiplier);
              return "".concat(x, ",").concat(y, ",").concat(z);
            }
            var resultGeometry = geometry.toNonIndexed();
            var posAttr = resultGeometry.attributes.position;
            var vertexMap = {};

            // find all the normals shared by commonly located vertices
            for (var i = 0, l = posAttr.count / 3; i < l; i++) {
              var i3 = 3 * i;
              var a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
              var b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
              var c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
              tempVec1.subVectors(c, b);
              tempVec2.subVectors(a, b);

              // add the normal to the map for all vertices
              var normal = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3().crossVectors(tempVec1, tempVec2).normalize();
              for (var n = 0; n < 3; n++) {
                var vert = verts[n];
                var hash = hashVertex(vert);
                if (!(hash in vertexMap)) {
                  vertexMap[hash] = [];
                }
                vertexMap[hash].push(normal);
              }
            }

            // average normals from all vertices that share a common location if they are within the
            // provided crease threshold
            var normalArray = new Float32Array(posAttr.count * 3);
            var normAttr = new three__WEBPACK_IMPORTED_MODULE_0__.BufferAttribute(normalArray, 3, false);
            for (var _i120 = 0, _l17 = posAttr.count / 3; _i120 < _l17; _i120++) {
              // get the face normal for this vertex
              var _i121 = 3 * _i120;
              var _a6 = verts[0].fromBufferAttribute(posAttr, _i121 + 0);
              var _b7 = verts[1].fromBufferAttribute(posAttr, _i121 + 1);
              var _c5 = verts[2].fromBufferAttribute(posAttr, _i121 + 2);
              tempVec1.subVectors(_c5, _b7);
              tempVec2.subVectors(_a6, _b7);
              tempNorm.crossVectors(tempVec1, tempVec2).normalize();

              // average all normals that meet the threshold and set the normal value
              for (var _n7 = 0; _n7 < 3; _n7++) {
                var _vert6 = verts[_n7];
                var _hash = hashVertex(_vert6);
                var otherNormals = vertexMap[_hash];
                tempNorm2.set(0, 0, 0);
                for (var k = 0, lk = otherNormals.length; k < lk; k++) {
                  var otherNorm = otherNormals[k];
                  if (tempNorm.dot(otherNorm) > creaseDot) {
                    tempNorm2.add(otherNorm);
                  }
                }
                tempNorm2.normalize();
                normAttr.setXYZ(_i121 + _n7, tempNorm2.x, tempNorm2.y, tempNorm2.z);
              }
            }
            resultGeometry.setAttribute('normal', normAttr);
            return resultGeometry;
          }

          /***/
        },

        /***/"./node_modules/super-three/examples/jsm/utils/WorkerPool.js":
        /*!*******************************************************************!*\
          !*** ./node_modules/super-three/examples/jsm/utils/WorkerPool.js ***!
          \*******************************************************************/
        /***/
        function node_modulesSuperThreeExamplesJsmUtilsWorkerPoolJs(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
          "use strict";

          __webpack_require__.r(__webpack_exports__);
          /* harmony export */
          __webpack_require__.d(__webpack_exports__, {
            /* harmony export */"WorkerPool": function WorkerPool() {
              return (/* binding */_WorkerPool
              );
            }
            /* harmony export */
          });
          /**
           * @author Deepkolos / https://github.com/deepkolos
           */
          var _WorkerPool = /*#__PURE__*/function () {
            function _WorkerPool() {
              var pool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
              _classCallCheck2(this, _WorkerPool);
              this.pool = pool;
              this.queue = [];
              this.workers = [];
              this.workersResolve = [];
              this.workerStatus = 0;
            }
            _createClass2(_WorkerPool, [{
              key: "_initWorker",
              value: function _initWorker(workerId) {
                if (!this.workers[workerId]) {
                  var worker = this.workerCreator();
                  worker.addEventListener('message', this._onMessage.bind(this, workerId));
                  this.workers[workerId] = worker;
                }
              }
            }, {
              key: "_getIdleWorker",
              value: function _getIdleWorker() {
                for (var i = 0; i < this.pool; i++) if (!(this.workerStatus & 1 << i)) return i;
                return -1;
              }
            }, {
              key: "_onMessage",
              value: function _onMessage(workerId, msg) {
                var resolve = this.workersResolve[workerId];
                resolve && resolve(msg);
                if (this.queue.length) {
                  var _this$queue$shift = this.queue.shift(),
                    _resolve2 = _this$queue$shift.resolve,
                    _msg = _this$queue$shift.msg,
                    transfer = _this$queue$shift.transfer;
                  this.workersResolve[workerId] = _resolve2;
                  this.workers[workerId].postMessage(_msg, transfer);
                } else {
                  this.workerStatus ^= 1 << workerId;
                }
              }
            }, {
              key: "setWorkerCreator",
              value: function setWorkerCreator(workerCreator) {
                this.workerCreator = workerCreator;
              }
            }, {
              key: "setWorkerLimit",
              value: function setWorkerLimit(pool) {
                this.pool = pool;
              }
            }, {
              key: "postMessage",
              value: function postMessage(msg, transfer) {
                var _this154 = this;
                return new Promise(function (resolve) {
                  var workerId = _this154._getIdleWorker();
                  if (workerId !== -1) {
                    _this154._initWorker(workerId);
                    _this154.workerStatus |= 1 << workerId;
                    _this154.workersResolve[workerId] = resolve;
                    _this154.workers[workerId].postMessage(msg, transfer);
                  } else {
                    _this154.queue.push({
                      resolve: resolve,
                      msg: msg,
                      transfer: transfer
                    });
                  }
                });
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.workers.forEach(function (worker) {
                  return worker.terminate();
                });
                this.workersResolve.length = 0;
                this.workers.length = 0;
                this.queue.length = 0;
                this.workerStatus = 0;
              }
            }]);
            return _WorkerPool;
          }();
          /***/
        },
        /***/"./package.json":
        /*!**********************!*\
          !*** ./package.json ***!
          \**********************/
        /***/
        function packageJson(module) {
          "use strict";

          module.exports = JSON.parse('{"name":"aframe","version":"1.4.1","description":"A web framework for building virtual reality experiences.","homepage":"https://aframe.io/","main":"dist/aframe-master.js","scripts":{"dev":"cross-env INSPECTOR_VERSION=dev webpack serve --port 8080","dist":"node scripts/updateVersionLog.js && npm run dist:min && npm run dist:max","dist:max":"webpack --config webpack.config.js","dist:min":"webpack --config webpack.prod.config.js","docs":"markserv --dir docs --port 9001","preghpages":"node ./scripts/preghpages.js","ghpages":"ghpages -p gh-pages/","lint":"semistandard -v | snazzy","lint:fix":"semistandard --fix","precommit":"npm run lint","prepush":"node scripts/testOnlyCheck.js","prerelease":"node scripts/release.js 1.3.0 1.4.0","start":"npm run dev","start:https":"npm run dev -- --server-type https","test":"karma start ./tests/karma.conf.js","test:docs":"node scripts/docsLint.js","test:firefox":"npm test -- --browsers Firefox","test:chrome":"npm test -- --browsers Chrome","test:nobrowser":"NO_BROWSER=true npm test","test:node":"mocha --ui tdd tests/node"},"repository":"aframevr/aframe","license":"MIT","files":["dist/*","docs/**/*","src/**/*","vendor/**/*"],"dependencies":{"buffer":"^6.0.3","custom-event-polyfill":"^1.0.6","debug":"ngokevin/debug#noTimestamp","deep-assign":"^2.0.0","@ungap/custom-elements":"^1.1.0","load-bmfont":"^1.2.3","object-assign":"^4.0.1","present":"0.0.6","promise-polyfill":"^3.1.0","super-animejs":"^3.1.0","super-three":"^0.147.1","three-bmfont-text":"dmarcos/three-bmfont-text#21d017046216e318362c48abd1a48bddfb6e0733","webvr-polyfill":"^0.10.12"},"devDependencies":{"@babel/core":"^7.17.10","babel-loader":"^8.2.5","babel-plugin-istanbul":"^6.1.1","chai":"^4.3.6","chai-shallow-deep-equal":"^1.4.0","chalk":"^1.1.3","cross-env":"^7.0.3","css-loader":"^6.7.1","ghpages":"0.0.8","git-rev":"^0.2.1","glob":"^8.0.3","husky":"^0.11.7","jsdom":"^20.0.0","karma":"^6.4.0","karma-chai-shallow-deep-equal":"0.0.4","karma-chrome-launcher":"^3.1.1","karma-coverage":"^2.2.0","karma-env-preprocessor":"^0.1.1","karma-firefox-launcher":"^2.1.2","karma-mocha":"^2.0.1","karma-mocha-reporter":"^2.2.5","karma-sinon-chai":"^2.0.2","karma-webpack":"^5.0.0","markserv":"github:sukima/markserv#feature/fix-broken-websoketio-link","mocha":"^10.0.0","replace-in-file":"^2.5.3","semistandard":"^9.0.0","shelljs":"^0.7.7","shx":"^0.2.2","sinon":"<12.0.0","sinon-chai":"^3.7.0","snazzy":"^5.0.0","style-loader":"^3.3.1","too-wordy":"ngokevin/too-wordy","webpack":"^5.73.0","webpack-cli":"^4.10.0","webpack-dev-server":"^4.11.0","webpack-merge":"^5.8.0","write-good":"^1.0.8"},"link":true,"semistandard":{"ignore":["build/**","dist/**","examples/**/shaders/*.js","**/vendor/**"]},"keywords":["3d","aframe","cardboard","components","oculus","three","three.js","rift","vive","vr","web-components","webvr"],"engines":{"node":">= 4.6.0","npm":">= 2.15.9"}}');

          /***/
        }

        /******/
      };
      /************************************************************************/
      /******/ // The module cache
      /******/
      var __webpack_module_cache__ = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/var cachedModule = __webpack_module_cache__[moduleId];
        /******/
        if (cachedModule !== undefined) {
          /******/return cachedModule.exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = __webpack_module_cache__[moduleId] = {
          /******/id: moduleId,
          /******/ // no module.loaded needed
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = __webpack_modules__;
      /******/
      /************************************************************************/
      /******/ /* webpack/runtime/compat get default export */
      /******/
      (function () {
        /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/__webpack_require__.n = function (module) {
          /******/var getter = module && module.__esModule ? /******/function () {
            return module['default'];
          } : /******/function () {
            return module;
          };
          /******/
          __webpack_require__.d(getter, {
            a: getter
          });
          /******/
          return getter;
          /******/
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/define property getters */
      /******/
      (function () {
        /******/ // define getter functions for harmony exports
        /******/__webpack_require__.d = function (exports, definition) {
          /******/for (var key in definition) {
            /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
              /******/Object.defineProperty(exports, key, {
                enumerable: true,
                get: definition[key]
              });
              /******/
            }
            /******/
          }
          /******/
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/global */
      /******/
      (function () {
        /******/__webpack_require__.g = function () {
          /******/if (typeof globalThis === 'object') return globalThis;
          /******/
          try {
            /******/return this || new Function('return this')();
            /******/
          } catch (e) {
            /******/if (typeof window === 'object') return window;
            /******/
          }
          /******/
        }();
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/hasOwnProperty shorthand */
      /******/
      (function () {
        /******/__webpack_require__.o = function (obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/make namespace object */
      /******/
      (function () {
        /******/ // define __esModule on exports
        /******/__webpack_require__.r = function (exports) {
          /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/Object.defineProperty(exports, Symbol.toStringTag, {
              value: 'Module'
            });
            /******/
          }
          /******/
          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          /******/
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/jsonp chunk loading */
      /******/
      (function () {
        /******/__webpack_require__.b = document.baseURI || self.location.href;
        /******/
        /******/ // object to store loaded and loading chunks
        /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
        /******/ // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
        /******/
        var installedChunks = {
          /******/"main": 0
          /******/
        };
        /******/
        /******/ // no chunk on demand loading
        /******/
        /******/ // no prefetching
        /******/
        /******/ // no preloaded
        /******/
        /******/ // no HMR
        /******/
        /******/ // no HMR manifest
        /******/
        /******/ // no on chunks loaded
        /******/
        /******/ // no jsonp function
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/nonce */
      /******/
      (function () {
        /******/__webpack_require__.nc = undefined;
        /******/
      })();
      /******/
      /************************************************************************/
      /******/
      /******/ // startup
      /******/ // Load entry module and return exports
      /******/ // This entry module is referenced by other modules so it can't be inlined
      /******/
      var __webpack_exports__ = __webpack_require__("./src/index.js");
      /******/
      /******/
      return __webpack_exports__;
      /******/
    }()
  );
});